import * as React$2 from 'react';
import React__default, { createContext, forwardRef, useContext, createElement, useRef, useCallback, Children, useState, useEffect, PureComponent } from 'react';
import ReactDOM from 'react-dom';

function capitalizeString$1(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var newStyle = {};
    var requiredPrefixes = prefixProperties[property];
    var capitalizedProperty = capitalizeString$1(property);
    var keys = Object.keys(style);
    for (var i = 0; i < keys.length; i++) {
      var styleProperty = keys[i];
      if (styleProperty === property) {
        for (var j = 0; j < requiredPrefixes.length; j++) {
          newStyle[requiredPrefixes[j] + capitalizedProperty] = style[property];
        }
      }
      newStyle[styleProperty] = style[styleProperty];
    }
    return newStyle;
  }
  return style;
}

function prefixValue$1(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}

function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}

function isObject$1(value) {
  return value instanceof Object && !Array.isArray(value);
}

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;

  return function prefix(style) {
    for (var property in style) {
      var value = style[property];

      // handle nested objects
      if (isObject$1(value)) {
        style[property] = prefix(value);
        // handle array values
      } else if (Array.isArray(value)) {
        var combinedValue = [];

        for (var i = 0, len = value.length; i < len; ++i) {
          var processedValue = prefixValue$1(plugins, property, value[i], style, prefixMap);
          addNewValuesOnly(combinedValue, processedValue || value[i]);
        }

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (combinedValue.length > 0) {
          style[property] = combinedValue;
        }
      } else {
        var _processedValue = prefixValue$1(plugins, property, value, style, prefixMap);

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (_processedValue) {
          style[property] = _processedValue;
        }

        style = prefixProperty(prefixMap, property, style);
      }
    }

    return style;
  };
}

var w$1 = ["Webkit"];
var m$1 = ["Moz"];
var ms = ["ms"];
var wm = ["Webkit", "Moz"];
var wms = ["Webkit", "ms"];
var wmms = ["Webkit", "Moz", "ms"];

var data = {
  plugins: [],
  prefixMap: { "appearance": wm, "textEmphasisPosition": w$1, "textEmphasis": w$1, "textEmphasisStyle": w$1, "textEmphasisColor": w$1, "boxDecorationBreak": w$1, "maskImage": w$1, "maskMode": w$1, "maskRepeat": w$1, "maskPosition": w$1, "maskClip": w$1, "maskOrigin": w$1, "maskSize": w$1, "maskComposite": w$1, "mask": w$1, "maskBorderSource": w$1, "maskBorderMode": w$1, "maskBorderSlice": w$1, "maskBorderWidth": w$1, "maskBorderOutset": w$1, "maskBorderRepeat": w$1, "maskBorder": w$1, "maskType": w$1, "textDecorationStyle": w$1, "textDecorationSkip": w$1, "textDecorationLine": w$1, "textDecorationColor": w$1, "userSelect": wmms, "backdropFilter": w$1, "fontKerning": w$1, "scrollSnapType": wms, "scrollSnapPointsX": wms, "scrollSnapPointsY": wms, "scrollSnapDestination": wms, "scrollSnapCoordinate": wms, "clipPath": w$1, "shapeImageThreshold": w$1, "shapeImageMargin": w$1, "shapeImageOutside": w$1, "filter": w$1, "hyphens": wms, "flowInto": wms, "flowFrom": wms, "breakBefore": wms, "breakAfter": wms, "breakInside": wms, "regionFragment": wms, "writingMode": wms, "textOrientation": w$1, "tabSize": m$1, "fontFeatureSettings": w$1, "columnCount": w$1, "columnFill": w$1, "columnGap": w$1, "columnRule": w$1, "columnRuleColor": w$1, "columnRuleStyle": w$1, "columnRuleWidth": w$1, "columns": w$1, "columnSpan": w$1, "columnWidth": w$1, "wrapFlow": ms, "wrapThrough": ms, "wrapMargin": ms, "textSizeAdjust": wms }
};

// https://developer.mozilla.org/en-US/docs/Web/CSS/background-clip#Browser_compatibility
function backgroundClip(property, value) {
  if (typeof value === 'string' && value === 'text') {
    return ['-webkit-text', 'text'];
  }
}

var prefixes$5 = ['-webkit-', '-moz-', ''];

var values$3 = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values$3.hasOwnProperty(value)) {
    return prefixes$5.map(function (prefix) {
      return prefix + value;
    });
  }
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var isPrefixedValue_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];
});

var isPrefixedValue = unwrapExports(isPrefixedValue_1);

// http://caniuse.com/#search=cross-fade
var prefixes$4 = ['-webkit-', ''];

function crossFade(property, value) {
  if (typeof value === 'string' && !isPrefixedValue(value) && value.indexOf('cross-fade(') > -1) {
    return prefixes$4.map(function (prefix) {
      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
    });
  }
}

// http://caniuse.com/#feat=css-filter-function
var prefixes$3 = ['-webkit-', ''];

function filter(property, value) {
  if (typeof value === 'string' && !isPrefixedValue(value) && value.indexOf('filter(') > -1) {
    return prefixes$3.map(function (prefix) {
      return value.replace(/filter\(/g, prefix + 'filter(');
    });
  }
}

var values$2 = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values$2.hasOwnProperty(value)) {
    return values$2[value];
  }
}

var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps$1 = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines',
  flexGrow: 'WebkitBoxFlex'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps$1.hasOwnProperty(property)) {
    style[alternativeProps$1[property]] = alternativeValues[value] || value;
  }
}

var prefixes$2 = ['-webkit-', '-moz-', ''];
var values$1 = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;

function gradient(property, value) {
  if (typeof value === 'string' && !isPrefixedValue(value) && values$1.test(value)) {
    return prefixes$2.map(function (prefix) {
      return value.replace(values$1, function (grad) {
        return prefix + grad;
      });
    });
  }
}

var _slicedToArray$1f = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function isSimplePositionValue(value) {
  return typeof value === 'number' && !isNaN(value);
}

function isComplexSpanValue(value) {
  return typeof value === 'string' && value.includes('/');
}

var alignmentValues = ['center', 'end', 'start', 'stretch'];

var displayValues = {
  'inline-grid': ['-ms-inline-grid', 'inline-grid'],
  grid: ['-ms-grid', 'grid']
};

var propertyConverters = {
  alignSelf: function alignSelf(value, style) {
    if (alignmentValues.indexOf(value) > -1) {
      style.msGridRowAlign = value;
    }
  },

  gridColumn: function gridColumn(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridColumn = value;
    } else if (isComplexSpanValue(value)) {
      var _value$split = value.split('/'),
          _value$split2 = _slicedToArray$1f(_value$split, 2),
          start = _value$split2[0],
          end = _value$split2[1];

      propertyConverters.gridColumnStart(+start, style);

      var _end$split = end.split(/ ?span /),
          _end$split2 = _slicedToArray$1f(_end$split, 2),
          maybeSpan = _end$split2[0],
          maybeNumber = _end$split2[1];

      if (maybeSpan === '') {
        propertyConverters.gridColumnEnd(+start + +maybeNumber, style);
      } else {
        propertyConverters.gridColumnEnd(+end, style);
      }
    } else {
      propertyConverters.gridColumnStart(value, style);
    }
  },

  gridColumnEnd: function gridColumnEnd(value, style) {
    var msGridColumn = style.msGridColumn;

    if (isSimplePositionValue(value) && isSimplePositionValue(msGridColumn)) {
      style.msGridColumnSpan = value - msGridColumn;
    }
  },

  gridColumnStart: function gridColumnStart(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridColumn = value;
    }
  },

  gridRow: function gridRow(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridRow = value;
    } else if (isComplexSpanValue(value)) {
      var _value$split3 = value.split('/'),
          _value$split4 = _slicedToArray$1f(_value$split3, 2),
          start = _value$split4[0],
          end = _value$split4[1];

      propertyConverters.gridRowStart(+start, style);

      var _end$split3 = end.split(/ ?span /),
          _end$split4 = _slicedToArray$1f(_end$split3, 2),
          maybeSpan = _end$split4[0],
          maybeNumber = _end$split4[1];

      if (maybeSpan === '') {
        propertyConverters.gridRowEnd(+start + +maybeNumber, style);
      } else {
        propertyConverters.gridRowEnd(+end, style);
      }
    } else {
      propertyConverters.gridRowStart(value, style);
    }
  },

  gridRowEnd: function gridRowEnd(value, style) {
    var msGridRow = style.msGridRow;

    if (isSimplePositionValue(value) && isSimplePositionValue(msGridRow)) {
      style.msGridRowSpan = value - msGridRow;
    }
  },

  gridRowStart: function gridRowStart(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridRow = value;
    }
  },

  gridTemplateColumns: function gridTemplateColumns(value, style) {
    style.msGridColumns = value;
  },

  gridTemplateRows: function gridTemplateRows(value, style) {
    style.msGridRows = value;
  },

  justifySelf: function justifySelf(value, style) {
    if (alignmentValues.indexOf(value) > -1) {
      style.msGridColumnAlign = value;
    }
  }
};

function grid$2(property, value, style) {
  if (property === 'display' && value in displayValues) {
    return displayValues[value];
  }

  if (property in propertyConverters) {
    var propertyConverter = propertyConverters[property];
    propertyConverter(value, style);
  }
}

// http://caniuse.com/#feat=css-image-set
var prefixes$1 = ['-webkit-', ''];

function imageSet(property, value) {
  if (typeof value === 'string' && !isPrefixedValue(value) && value.indexOf('image-set(') > -1) {
    return prefixes$1.map(function (prefix) {
      return value.replace(/image-set\(/g, prefix + 'image-set(');
    });
  }
}

var alternativeProps = {
  marginBlockStart: ['WebkitMarginBefore'],
  marginBlockEnd: ['WebkitMarginAfter'],
  marginInlineStart: ['WebkitMarginStart', 'MozMarginStart'],
  marginInlineEnd: ['WebkitMarginEnd', 'MozMarginEnd'],
  paddingBlockStart: ['WebkitPaddingBefore'],
  paddingBlockEnd: ['WebkitPaddingAfter'],
  paddingInlineStart: ['WebkitPaddingStart', 'MozPaddingStart'],
  paddingInlineEnd: ['WebkitPaddingEnd', 'MozPaddingEnd'],
  borderBlockStart: ['WebkitBorderBefore'],
  borderBlockStartColor: ['WebkitBorderBeforeColor'],
  borderBlockStartStyle: ['WebkitBorderBeforeStyle'],
  borderBlockStartWidth: ['WebkitBorderBeforeWidth'],
  borderBlockEnd: ['WebkitBorderAfter'],
  borderBlockEndColor: ['WebkitBorderAfterColor'],
  borderBlockEndStyle: ['WebkitBorderAfterStyle'],
  borderBlockEndWidth: ['WebkitBorderAfterWidth'],
  borderInlineStart: ['WebkitBorderStart', 'MozBorderStart'],
  borderInlineStartColor: ['WebkitBorderStartColor', 'MozBorderStartColor'],
  borderInlineStartStyle: ['WebkitBorderStartStyle', 'MozBorderStartStyle'],
  borderInlineStartWidth: ['WebkitBorderStartWidth', 'MozBorderStartWidth'],
  borderInlineEnd: ['WebkitBorderEnd', 'MozBorderEnd'],
  borderInlineEndColor: ['WebkitBorderEndColor', 'MozBorderEndColor'],
  borderInlineEndStyle: ['WebkitBorderEndStyle', 'MozBorderEndStyle'],
  borderInlineEndWidth: ['WebkitBorderEndWidth', 'MozBorderEndWidth']
};

function logical(property, value, style) {
  if (Object.prototype.hasOwnProperty.call(alternativeProps, property)) {
    var alternativePropList = alternativeProps[property];
    for (var i = 0, len = alternativePropList.length; i < len; ++i) {
      style[alternativePropList[i]] = value;
    }
  }
}

function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return ['-webkit-sticky', 'sticky'];
  }
}

var prefixes = ['-webkit-', '-moz-', ''];

var properties$1 = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing$3(property, value) {
  if (properties$1.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}

/* eslint-disable no-var, prefer-template */
var uppercasePattern$1 = /[A-Z]/g;
var msPattern$1 = /^ms-/;
var cache$1 = {};

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName$1(name) {
  if (cache$1.hasOwnProperty(name)) {
    return cache$1[name]
  }

  var hName = name.replace(uppercasePattern$1, toHyphenLower);
  return (cache$1[name] = msPattern$1.test(hName) ? '-' + hName : hName)
}

var hyphenateProperty_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;



var _hyphenateStyleName2 = _interopRequireDefault(hyphenateStyleName$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];
});

var hyphenateProperty = unwrapExports(hyphenateProperty_1);

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};

var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if (isPrefixedValue(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = hyphenateProperty(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + capitalizeString$1(property)] = webkitOutput;
    style['Moz' + capitalizeString$1(property)] = mozOutput;
    return outputValue;
  }
}

var plugins = [backgroundClip, crossFade, cursor, filter, flexboxOld, gradient, grid$2, imageSet, logical, position, sizing$3, transition, flex];

var prefix = createPrefixer({
  prefixMap: data.prefixMap,
  plugins: plugins
});

class SequentialIDGenerator {
  constructor(prefix$$1 = "") {
    // ensure start with "ae" so "ad" is never produced
    this.prefix = prefix$$1;
    this.count = 0;
    this.offset = 374;
    this.msb = 1295;
    this.power = 2;
  }

  next() {
    const id = this.increment().toString(36);
    return this.prefix ? `${this.prefix}${id}` : id;
  }

  increment() {
    const id = this.count + this.offset;

    if (id === this.msb) {
      this.offset += (this.msb + 1) * 9;
      this.msb = Math.pow(36, ++this.power) - 1;
    }

    this.count++;
    return id;
  }

}

// adapted from https://github.com/dutchenkoOleg/sort-css-media-queries
const minMaxWidth = /(!?\(\s*min(-device-)?-width).+\(\s*max(-device)?-width/i;
const minWidth = /\(\s*min(-device)?-width/i;
const maxMinWidth = /(!?\(\s*max(-device)?-width).+\(\s*min(-device)?-width/i;
const maxWidth = /\(\s*max(-device)?-width/i;

const isMinWidth = _testQuery(minMaxWidth, maxMinWidth, minWidth);

const isMaxWidth = _testQuery(maxMinWidth, minMaxWidth, maxWidth);

const minMaxHeight = /(!?\(\s*min(-device)?-height).+\(\s*max(-device)?-height/i;
const minHeight = /\(\s*min(-device)?-height/i;
const maxMinHeight = /(!?\(\s*max(-device)?-height).+\(\s*min(-device)?-height/i;
const maxHeight = /\(\s*max(-device)?-height/i;

const isMinHeight = _testQuery(minMaxHeight, maxMinHeight, minHeight);

const isMaxHeight = _testQuery(maxMinHeight, minMaxHeight, maxHeight);

const isPrint = /print/i;
const isPrintOnly = /^print$/i;
const maxValue = Number.MAX_VALUE;

function _getQueryLength(length) {
  const matches = /(-?\d*\.?\d+)(ch|em|ex|px|rem)/.exec(length);

  if (matches === null) {
    return maxValue;
  }

  let number = matches[1];
  const unit = matches[2];

  switch (unit) {
    case "ch":
      number = parseFloat(number) * 8.8984375;
      break;

    case "em":
    case "rem":
      number = parseFloat(number) * 16;
      break;

    case "ex":
      number = parseFloat(number) * 8.296875;
      break;

    case "px":
      number = parseFloat(number);
      break;
  }

  return +number;
}

function _testQuery(doubleTestTrue, doubleTestFalse, singleTest) {
  return function (query) {
    if (doubleTestTrue.test(query)) {
      return true;
    } else if (doubleTestFalse.test(query)) {
      return false;
    }

    return singleTest.test(query);
  };
}

function _testIsPrint(a, b) {
  const isPrintA = isPrint.test(a);
  const isPrintOnlyA = isPrintOnly.test(a);
  const isPrintB = isPrint.test(b);
  const isPrintOnlyB = isPrintOnly.test(b);

  if (isPrintA && isPrintB) {
    if (!isPrintOnlyA && isPrintOnlyB) {
      return 1;
    }

    if (isPrintOnlyA && !isPrintOnlyB) {
      return -1;
    }

    return a.localeCompare(b);
  }

  if (isPrintA) {
    return 1;
  }

  if (isPrintB) {
    return -1;
  }

  return null;
}

function sortCSSmq(a, b) {
  if (a === "") {
    return -1;
  }

  if (b === "") {
    return 1;
  }

  const testIsPrint = _testIsPrint(a, b);

  if (testIsPrint !== null) {
    return testIsPrint;
  }

  const minA = isMinWidth(a) || isMinHeight(a);
  const maxA = isMaxWidth(a) || isMaxHeight(a);
  const minB = isMinWidth(b) || isMinHeight(b);
  const maxB = isMaxWidth(b) || isMaxHeight(b);

  if (minA && maxB) {
    return -1;
  }

  if (maxA && minB) {
    return 1;
  }

  const lengthA = _getQueryLength(a);

  const lengthB = _getQueryLength(b);

  if (lengthA === maxValue && lengthB === maxValue) {
    return a.localeCompare(b);
  } else if (lengthA === maxValue) {
    return 1;
  } else if (lengthB === maxValue) {
    return -1;
  }

  if (lengthA > lengthB) {
    if (maxA) {
      return -1;
    }

    return 1;
  }

  if (lengthA < lengthB) {
    if (maxA) {
      return 1;
    }

    return -1;
  }

  return a.localeCompare(b);
}

class MultiCache {
  constructor(idGenerator, onNewCache, onNewValue) {
    this.idGenerator = idGenerator;
    this.onNewCache = onNewCache;
    this.onNewValue = onNewValue;
    this.sortedCacheKeys = [];
    this.caches = {};
  }

  getCache(key) {
    if (!this.caches[key]) {
      const cache = new Cache(this.idGenerator, this.onNewValue);
      cache.key = key;
      this.sortedCacheKeys.push(key);
      this.sortedCacheKeys.sort(sortCSSmq);
      const keyIndex = this.sortedCacheKeys.indexOf(key);
      const insertBeforeMedia = keyIndex < this.sortedCacheKeys.length - 1 ? this.sortedCacheKeys[keyIndex + 1] : void 0;
      this.caches[key] = cache;
      this.onNewCache(key, cache, insertBeforeMedia);
    }

    return this.caches[key];
  }

  getSortedCacheKeys() {
    return this.sortedCacheKeys;
  }

}
class Cache {
  constructor(idGenerator, onNewValue) {
    this.cache = {};
    this.idGenerator = idGenerator;
    this.onNewValue = onNewValue;
  }

  addValue(key, value) {
    const cached = this.cache[key];

    if (cached) {
      return cached;
    }

    const id = this.idGenerator.next();
    this.cache[key] = id;
    this.onNewValue(this, id, value);
    return id;
  }

}

const uppercasePattern = /[A-Z]/g;
const msPattern = /^ms-/;
const cache = {};
function hyphenateStyleName(prop) {
  return prop in cache ? cache[prop] : cache[prop] = prop.replace(uppercasePattern, "-$&").toLowerCase().replace(msPattern, "-ms-");
}

/**
 * Adapted from https://github.com/gilmoreorless/css-shorthand-properties
 */
const shorthandMap = {
  // CSS 2.1: https://www.w3.org/TR/CSS2/propidx.html
  "list-style": ["list-style-type", "list-style-position", "list-style-image"],
  margin: ["margin-top", "margin-right", "margin-bottom", "margin-left"],
  outline: ["outline-width", "outline-style", "outline-color"],
  padding: ["padding-top", "padding-right", "padding-bottom", "padding-left"],
  // CSS Backgrounds and Borders Module Level 3: https://www.w3.org/TR/css3-background/
  background: ["background-image", "background-position", "background-size", "background-repeat", "background-origin", "background-clip", "background-attachment", "background-color"],
  border: ["border-top-width", "border-right-width", "border-bottom-width", "border-left-width", "border-width", "border-top-style", "border-right-style", "border-bottom-style", "border-left-style", "border-style", "border-top-color", "border-right-color", "border-bottom-color", "border-left-color", "border-color"],
  "border-color": ["border-top-color", "border-right-color", "border-bottom-color", "border-left-color"],
  "border-style": ["border-top-style", "border-right-style", "border-bottom-style", "border-left-style"],
  "border-width": ["border-top-width", "border-right-width", "border-bottom-width", "border-left-width"],
  "border-top": ["border-top-width", "border-top-style", "border-top-color"],
  "border-right": ["border-right-width", "border-right-style", "border-right-color"],
  "border-bottom": ["border-bottom-width", "border-bottom-style", "border-bottom-color"],
  "border-left": ["border-left-width", "border-left-style", "border-left-color"],
  "border-radius": ["border-top-left-radius", "border-top-right-radius", "border-bottom-right-radius", "border-bottom-left-radius"],
  "border-image": ["border-image-source", "border-image-slice", "border-image-width", "border-image-outset", "border-image-repeat"],
  // CSS Fonts Module Level 3: https://www.w3.org/TR/css3-fonts/
  font: ["font-style", "font-variant-ligatures", "font-variant-alternates", "font-variant-caps", "font-variant-numeric", "font-variant-east-asian", "font-variant", "font-weight", "font-stretch", "font-size", "line-height", "font-family"],
  "font-variant": ["font-variant-ligatures", "font-variant-alternates", "font-variant-caps", "font-variant-numeric", "font-variant-east-asian"],
  // CSS Flexible Box Layout Module Level 1: https://www.w3.org/TR/css3-flexbox-1/
  flex: ["flex-grow", "flex-shrink", "flex-basis"],
  "flex-flow": ["flex-direction", "flex-wrap"],
  // CSS Grid Layout Module Level 1: https://www.w3.org/TR/css-grid-1/
  grid: ["grid-template-rows", "grid-template-columns", "grid-template-areas", "grid-auto-rows", "grid-auto-columns", "grid-auto-flow"],
  "grid-template": ["grid-template-rows", "grid-template-columns", "grid-template-areas"],
  "grid-row": ["grid-row-start", "grid-row-end"],
  "grid-column": ["grid-column-start", "grid-column-end"],
  "grid-area": ["grid-row-start", "grid-column-start", "grid-row-end", "grid-column-end"],
  "grid-gap": ["grid-row-gap", "grid-column-gap"],
  // CSS Masking Module Level 1: https://www.w3.org/TR/css-masking/
  mask: ["mask-image", "mask-mode", "mask-position", "mask-size", "mask-repeat", "mask-origin", "mask-clip"],
  "mask-border": ["mask-border-source", "mask-border-slice", "mask-border-width", "mask-border-outset", "mask-border-repeat", "mask-border-mode"],
  // CSS Multi-column Layout Module: https://www.w3.org/TR/css3-multicol/
  columns: ["column-width", "column-count"],
  "column-rule": ["column-rule-width", "column-rule-style", "column-rule-color"],
  // CSS Scroll Snap Module Level 1: https://www.w3.org/TR/css-scroll-snap-1/
  "scroll-padding": ["scroll-padding-top", "scroll-padding-right", "scroll-padding-bottom", "scroll-padding-left"],
  "scroll-padding-block": ["scroll-padding-block-start", "scroll-padding-block-end"],
  "scroll-padding-inline": ["scroll-padding-inline-start", "scroll-padding-inline-end"],
  "scroll-snap-margin": ["scroll-snap-margin-top", "scroll-snap-margin-right", "scroll-snap-margin-bottom", "scroll-snap-margin-left"],
  "scroll-snap-margin-block": ["scroll-snap-margin-block-start", "scroll-snap-margin-block-end"],
  "scroll-snap-margin-inline": ["scroll-snap-margin-inline-start", "scroll-snap-margin-inline-end"],
  // CSS Speech Module: https://www.w3.org/TR/css3-speech/
  cue: ["cue-before", "cue-after"],
  pause: ["pause-before", "pause-after"],
  rest: ["rest-before", "rest-after"],
  // CSS Text Decoration Module Level 3: https://www.w3.org/TR/css-text-decor-3/
  "text-decoration": ["text-decoration-line", "text-decoration-style", "text-decoration-color"],
  "text-emphasis": ["text-emphasis-style", "text-emphasis-color"],
  // CSS Animations (WD): https://www.w3.org/TR/css3-animations
  animation: ["animation-name", "animation-duration", "animation-timing-function", "animation-delay", "animation-iteration-count", "animation-direction", "animation-fill-mode", "animation-play-state"],
  // CSS Transitions (WD): https://www.w3.org/TR/css3-transitions/
  transition: ["transition-property", "transition-duration", "transition-timing-function", "transition-delay"]
};
function validateNoMixedHand(style) {
  const hyphenatedProperties = Object.keys(style).reduce((acc, property) => {
    acc[hyphenateStyleName(property)] = property;
    return acc;
  }, {});
  const mixed = [];

  for (const property in hyphenatedProperties) {
    if (property in shorthandMap) {
      for (const longhand of shorthandMap[property]) {
        if (longhand in hyphenatedProperties) {
          const long = hyphenatedProperties[longhand];
          const short = hyphenatedProperties[property];
          mixed.push({
            shorthand: {
              property: short,
              value: style[short]
            },
            longhand: {
              property: long,
              value: style[long]
            }
          });
        }
      }
    }
  }

  return mixed;
}

function injectStylePrefixed(styleCache, styles, media, pseudo) {
  const cache = styleCache.getCache(media);
  let classString = "";

  for (const originalKey in styles) {
    const originalVal = styles[originalKey];

    if (originalVal === void 0 || originalVal === null) {
      continue;
    }

    if (typeof originalVal !== "object") {
      // Non-null and non-undefined primitive value
      if (process.env.NODE_ENV !== "production") {
        validateValueType(originalVal, originalKey);
      }

      const propValPair = `${hyphenateStyleName(originalKey)}:${originalVal}`;
      const key = `${pseudo}${propValPair}`;
      const cachedId = cache.cache[key];

      if (cachedId !== void 0) {
        // cache hit
        classString += " " + cachedId;
        continue;
      } else {
        // cache miss
        let block = "";
        const prefixed = prefix({
          [originalKey]: originalVal
        });

        for (const prefixedKey in prefixed) {
          const prefixedVal = prefixed[prefixedKey];
          const prefixedValType = typeof prefixedVal;

          if (prefixedValType === "string" || prefixedValType === "number") {
            const prefixedPair = `${hyphenateStyleName(prefixedKey)}:${prefixedVal}`;

            if (prefixedPair !== propValPair) {
              block += `${prefixedPair};`;
            }
          } else if (Array.isArray(prefixedVal)) {
            const hyphenated = hyphenateStyleName(prefixedKey);

            for (let i = 0; i < prefixedVal.length; i++) {
              const prefixedPair = `${hyphenated}:${prefixedVal[i]}`;

              if (prefixedPair !== propValPair) {
                block += `${prefixedPair};`;
              }
            }
          }
        }

        block += propValPair; // ensure original prop/val is last (for hydration)

        const id = cache.addValue(key, {
          pseudo,
          block
        });
        classString += " " + id;
      }
    } else {
      // Non-null object value
      if (originalKey[0] === ":") {
        classString += " " + injectStylePrefixed(styleCache, originalVal, media, pseudo + originalKey);
      } else if (originalKey.substring(0, 6) === "@media") {
        classString += " " + injectStylePrefixed(styleCache, originalVal, originalKey.substr(7), pseudo);
      }
    }
  }

  if (process.env.NODE_ENV !== "production") {
    const conflicts = validateNoMixedHand(styles);

    if (conflicts.length) {
      conflicts.forEach(({
        shorthand,
        longhand
      }) => {
        const short = JSON.stringify({
          [shorthand.property]: shorthand.value
        });
        const long = JSON.stringify({
          [longhand.property]: longhand.value
        }); // eslint-disable-next-line no-console

        console.warn(`Styles \`${short}\` and \`${long}\` in object yielding class "${classString.slice(1)}" may result in unexpected behavior. Mixing shorthand and longhand properties within the same style object is unsupported with atomic rendering.`);
      });
    }
  } // remove leading space


  return classString.slice(1);
}

function validateValueType(value, key) {
  if (value === null || Array.isArray(value) || typeof value !== "number" && typeof value !== "string") {
    throw new Error(`Unsupported style value: ${JSON.stringify(value)} used in property ${JSON.stringify(key)}`);
  }
}

/* eslint-disable no-console */
const validAnimationState = /^(from|to|\+?(\d*\.)?\d+%)(\s*,\s*(from|to|\+?(\d*\.)?\d+%))*$/;
function validateKeyframesObject(keyframes) {
  let valid = true;

  for (const animationState in keyframes) {
    const value = keyframes[animationState];

    if (!validAnimationState.test(animationState)) {
      valid = false;
      console.warn(`Warning: property "${animationState}" in keyframes object ${JSON.stringify(keyframes)} is not a valid. Must be "from", "to", or a percentage.`);
    }

    if (typeof value !== "object") {
      valid = false;
      console.warn(`Warning: value for "${animationState}" property in keyframes object ${JSON.stringify(keyframes)} must be an object. Instead it was a ${typeof value}.`);
    }

    if (!valid) {
      console.warn(`Warning: object used as value for "animationName" style is invalid:`, keyframes);
    }
  }
}

function atomicSelector(id, pseudo) {
  let selector = `.${id}`;

  if (pseudo) {
    selector += pseudo;
  }

  return selector;
}
function keyframesToBlock(keyframes) {
  if (process.env.NODE_ENV !== "production") {
    validateKeyframesObject(keyframes);
  }

  if (process.env.NODE_ENV !== "production" && typeof Object.getPrototypeOf(keyframes) !== "undefined") {
    if (Object.getPrototypeOf(keyframes) !== Object.getPrototypeOf({})) {
      // eslint-disable-next-line no-console
      console.warn("Only plain objects should be used as animation values. Unexpectedly recieved:", keyframes);
    }
  }

  let result = "";

  for (const animationState in keyframes) {
    result += `${animationState}{${declarationsToBlock(keyframes[animationState])}}`;
  }

  return result;
}
function declarationsToBlock(style) {
  let css = "";

  for (const prop in style) {
    const val = style[prop];

    if (typeof val === "string" || typeof val === "number") {
      css += `${hyphenateStyleName(prop)}:${val};`;
    }
  } // trim trailing semicolon


  return css.slice(0, -1);
}
function keyframesBlockToRule(id, block) {
  return `@keyframes ${id}{${block}}`;
}
function fontFaceBlockToRule(id, block) {
  return `@font-face{font-family:${id};${block}}`;
}
function styleBlockToRule(selector, block) {
  return `${selector}{${block}}`;
}

/* eslint-env browser */

/* eslint-env browser */
const STYLES_HYDRATOR = /\.([^{:]+)(:[^{]+)?{(?:[^}]*;)?([^}]*?)}/g;
const KEYFRAMES_HYRDATOR = /@keyframes ([^{]+){((?:(?:from|to|(?:\d+\.?\d*%))\{(?:[^}])*})*)}/g;
const FONT_FACE_HYDRATOR = /@font-face\{font-family:([^;]+);([^}]*)\}/g;

function hydrateStyles(cache, hydrator, css) {
  let match;

  while (match = hydrator.exec(css)) {
    const [, id, pseudo, key] = match;

    const fullKey = pseudo ? `${pseudo}${key}` : key;
    cache.cache[fullKey] = id; // set cache without triggering side effects

    cache.idGenerator.increment(); // increment id
  }
}

function hydrate(cache, hydrator, css) {
  let match;

  while (match = hydrator.exec(css)) {
    const [, id, key] = match;

    cache.cache[key] = id; // set cache without triggering side effects

    cache.idGenerator.increment(); // increment id
  }
}

class StyletronClient {
  constructor(opts = {}) {
    this.styleElements = {};
    const styleIdGenerator = new SequentialIDGenerator(opts.prefix);

    const onNewStyle = (cache, id, value) => {
      const {
        pseudo,
        block
      } = value;
      const sheet = this.styleElements[cache.key].sheet;
      const selector = atomicSelector(id, pseudo);
      const rule = styleBlockToRule(selector, block);

      try {
        sheet.insertRule(rule, sheet.cssRules.length);

        
      } catch (e) {
        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.warn(`Failed to inject CSS: "${rule}". Perhaps this has invalid or un-prefixed properties?`);
        }
      }
    }; // Setup style cache


    this.styleCache = new MultiCache(styleIdGenerator, (media, _cache, insertBeforeMedia) => {
      const styleElement = document.createElement("style");
      styleElement.media = media;

      if (insertBeforeMedia === void 0) {
        this.container.appendChild(styleElement);
      } else {
        const insertBeforeIndex = findSheetIndexWithMedia(this.container.children, insertBeforeMedia);
        this.container.insertBefore(styleElement, this.container.children[insertBeforeIndex]);
      }

      this.styleElements[media] = styleElement;
    }, onNewStyle);
    this.keyframesCache = new Cache(new SequentialIDGenerator(opts.prefix), (cache, id, value) => {
      this.styleCache.getCache("");
      const sheet = this.styleElements[""].sheet;
      const rule = keyframesBlockToRule(id, keyframesToBlock(value));

      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.warn(`Failed to inject CSS: "${rule}". Perhaps this has invalid or un-prefixed properties?`);
        }
      }
    });
    this.fontFaceCache = new Cache(new SequentialIDGenerator(opts.prefix), (cache, id, value) => {
      this.styleCache.getCache("");
      const sheet = this.styleElements[""].sheet;
      const rule = fontFaceBlockToRule(id, declarationsToBlock(value));

      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.warn(`Failed to inject CSS: "${rule}". Perhaps this has invalid or un-prefixed properties?`);
        }
      }
    });

    if (opts.container) {
      this.container = opts.container;
    } // Hydrate


    if (opts.hydrate && opts.hydrate.length > 0) {
      // infer container from parent element
      if (!this.container) {
        const parentElement = opts.hydrate[0].parentElement;

        if (parentElement !== null && parentElement !== void 0) {
          this.container = parentElement;
        }
      }

      for (let i = 0; i < opts.hydrate.length; i++) {
        const element = opts.hydrate[i];
        const hydrateType = element.getAttribute("data-hydrate");

        if (hydrateType === "font-face") {
          hydrate(this.fontFaceCache, FONT_FACE_HYDRATOR, element.textContent);
          continue;
        }

        if (hydrateType === "keyframes") {
          hydrate(this.keyframesCache, KEYFRAMES_HYRDATOR, element.textContent);
          continue;
        }

        const key = element.media ? element.media : "";
        this.styleElements[key] = element;
        const cache = new Cache(styleIdGenerator, onNewStyle);
        cache.key = key;
        hydrateStyles(cache, STYLES_HYDRATOR, element.textContent);
        this.styleCache.sortedCacheKeys.push(key);
        this.styleCache.caches[key] = cache;
      }
    }

    if (!this.container) {
      if (document.head === null) {
        throw new Error("No container provided and `document.head` was null");
      }

      this.container = document.head;
    }
  }

  renderStyle(style) {
    return injectStylePrefixed(this.styleCache, style, "", "");
  }

  renderFontFace(fontFace) {
    const key = declarationsToBlock(fontFace);
    return this.fontFaceCache.addValue(key, fontFace);
  }

  renderKeyframes(keyframes) {
    const key = keyframesToBlock(keyframes);
    return this.keyframesCache.addValue(key, keyframes);
  }

}

function findSheetIndexWithMedia(children, media) {
  let index = 0;

  for (; index < children.length; index++) {
    const child = children[index];

    if (child.tagName === "STYLE" && child.media === media) {
      return index;
    }
  }

  return -1;
}

function _objectWithoutPropertiesLoose$Z(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

class StyletronServer {
  constructor(opts = {}) {
    this.styleRules = {
      "": ""
    };
    this.styleCache = new MultiCache(new SequentialIDGenerator(opts.prefix), media => {
      this.styleRules[media] = "";
    }, (cache, id, value) => {
      const {
        pseudo,
        block
      } = value;
      this.styleRules[cache.key] += styleBlockToRule(atomicSelector(id, pseudo), block);
    });
    this.fontFaceRules = "";
    this.fontFaceCache = new Cache(new SequentialIDGenerator(opts.prefix), (cache, id, value) => {
      this.fontFaceRules += fontFaceBlockToRule(id, declarationsToBlock(value));
    });
    this.keyframesRules = "";
    this.keyframesCache = new Cache(new SequentialIDGenerator(opts.prefix), (cache, id, value) => {
      this.keyframesRules += keyframesBlockToRule(id, keyframesToBlock(value));
    });
  }

  renderStyle(style) {
    return injectStylePrefixed(this.styleCache, style, "", "");
  }

  renderFontFace(fontFace) {
    const key = JSON.stringify(fontFace);
    return this.fontFaceCache.addValue(key, fontFace);
  }

  renderKeyframes(keyframes) {
    const key = JSON.stringify(keyframes);
    return this.keyframesCache.addValue(key, keyframes);
  }

  getStylesheets() {
    return [...(this.keyframesRules.length ? [{
      css: this.keyframesRules,
      attrs: {
        "data-hydrate": "keyframes"
      }
    }] : []), ...(this.fontFaceRules.length ? [{
      css: this.fontFaceRules,
      attrs: {
        "data-hydrate": "font-face"
      }
    }] : []), ...sheetify(this.styleRules, this.styleCache.getSortedCacheKeys())];
  }

  getStylesheetsHtml(className = "_styletron_hydrate_") {
    return generateHtmlString(this.getStylesheets(), className);
  }

  getCss() {
    return this.keyframesRules + this.fontFaceRules + stringify(this.styleRules, this.styleCache.getSortedCacheKeys());
  }

}

function generateHtmlString(sheets, className) {
  let html = "";

  for (let i = 0; i < sheets.length; i++) {
    const sheet = sheets[i];

    const _sheet$attrs = sheet.attrs,
          {
      class: originalClassName
    } = _sheet$attrs,
          rest = _objectWithoutPropertiesLoose$Z(_sheet$attrs, ["class"]);

    const attrs = Object.assign({
      class: originalClassName ? `${className} ${originalClassName}` : className
    }, rest);
    html += `<style${attrsToString(attrs)}>${sheet.css}</style>`;
  }

  return html;
}

function attrsToString(attrs) {
  let result = "";

  for (const attr in attrs) {
    const value = attrs[attr];

    if (value === true) {
      result += " " + attr;
    } else if (value !== false) {
      result += ` ${attr}="${value}"`;
    }
  }

  return result;
}

function stringify(styleRules, sortedCacheKeys) {
  let result = "";
  sortedCacheKeys.forEach(cacheKey => {
    const rules = styleRules[cacheKey];

    if (cacheKey !== "") {
      result += `@media ${cacheKey}{${rules}}`;
    } else {
      result += rules;
    }
  });
  return result;
}

function sheetify(styleRules, sortedCacheKeys) {
  if (sortedCacheKeys.length === 0) {
    return [{
      css: "",
      attrs: {}
    }];
  }

  const sheets = [];
  sortedCacheKeys.forEach(cacheKey => {
    // omit media (cacheKey) attribute if empty
    const attrs = cacheKey === "" ? {} : {
      media: cacheKey
    };
    sheets.push({
      css: styleRules[cacheKey],
      attrs
    });
  });
  return sheets;
}

// Note: $Shape is needed to make polymorphic withStyle refinements work correctly
// It seems functions satisfy this type without $Shape
// See: https://github.com/facebook/flow/issues/6784
//
//
//
//
//
//
function driver(style, styletron) {
  const tx = renderDeclarativeRules(style, styletron);
  return styletron.renderStyle(tx);
}
function getInitialStyle() {
  return {};
}
function renderDeclarativeRules(style, styletron) {
  for (const key in style) {
    const val = style[key];

    if (key === "animationName" && typeof val !== "string") {
      style.animationName = styletron.renderKeyframes(val);
      continue;
    }

    if (key === "fontFamily" && typeof val !== "string") {
      if (Array.isArray(val)) {
        let result = "";

        for (const font of val) {
          if (typeof font === "object") {
            result += `${styletron.renderFontFace(font)},`;
          } else if (typeof font === "string") {
            result += `${font},`;
          }
        }

        style.fontFamily = result.slice(0, -1);
        continue;
      } else if (val === void 0) {
        continue;
      } else {
        style.fontFamily = styletron.renderFontFace(val);
        continue;
      }
    }

    if (typeof val === "object" && val !== null) {
      renderDeclarativeRules(val, styletron);
    }
  }

  return style;
}

var index_es$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  driver: driver,
  getInitialStyle: getInitialStyle,
  renderDeclarativeRules: renderDeclarativeRules
});

/* eslint-env browser */

/* global module */
 // DEVTOOLS SETUP



class NoopDebugEngine {
  debug() {}

}

const DebugEngine = NoopDebugEngine;

function _extends$1x() { _extends$1x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1x.apply(this, arguments); }

/* eslint-env browser */

/* eslint-disable no-unused-vars, no-redeclare, no-shadow */
const noopEngine = {
  renderStyle: () => "",
  renderKeyframes: () => "",
  renderFontFace: () => ""
};
const StyletronContext = createContext(noopEngine);
const HydrationContext = createContext(false);
const DebugEngineContext = createContext();
createContext();

const Provider$1 = StyletronContext.Provider;

function checkNoopEngine(engine) {
  // if no engine provided, we default to no-op, handy for tests
  // however, print a warning in other envs
  if (process.env.NODE_ENV !== "test") {
    engine === noopEngine && // eslint-disable-next-line no-console
    console.warn(process.env.NODE_ENV !== "production" ? `
Styletron has been switched to a no-op (test) mode.

A Styletron styled component was rendered, but no Styletron engine instance was provided in React context.

Did you forget to provide a Styletron engine instance to React context via using the Styletron provider component?

Note: Providers and Consumers must come from the exact same React.createContext call to work.
If your app has multiple instances of the "styletron-react" package in your node_module tree,
your Provider may be coming from a different React.createContext call, which means the styled components
will not recieve the provided engine instance. This scenario can arise, for example, when using "npm link".
` : `Styletron Provider is not set up. Defaulting to no-op.`);
  }
}

function useStyletron$1() {
  const styletronEngine = useContext(StyletronContext);
  useContext(DebugEngineContext);
  useContext(HydrationContext);
  checkNoopEngine(styletronEngine);
  useRef("");
  useRef([]);
  return [function css(style) {
    const className = driver(style, styletronEngine);

    {
      return className;
    }
  }];
}
function createStyled({
  getInitialStyle: getInitialStyle$$1,
  driver: driver$$1,
  wrapper
}) {
  function styled(base, styleArg) {
    if (process.env.NODE_ENV !== "production") {
      if (base.__STYLETRON__) {
        /* eslint-disable no-console */
        console.warn("It appears you are passing a styled component into `styled`.");
        console.warn("For composition with existing styled components, use `withStyle` or `withTransform` instead.");
        /* eslint-enable no-console */
      }
    }

    const baseStyletron = {
      reducers: [],
      base: base,
      driver: driver$$1,
      getInitialStyle: getInitialStyle$$1,
      wrapper
    };

    return createStyledElementComponent(autoComposeShallow(baseStyletron, styleArg));
  }

  return styled;
}
const styled$1 = createStyled({
  getInitialStyle,
  driver,
  wrapper: Component$$1 => Component$$1
});
function withTransform(component, transformer) {
  const styletron = component.__STYLETRON__;

  return createStyledElementComponent(composeDynamic(styletron, transformer));
}
var withStyle$1 = withStyleDeep;
function withStyleDeep(component, styleArg) {
  const styletron = component.__STYLETRON__;

  if (process.env.NODE_ENV !== "production") {
    if (!styletron) {
      /* eslint-disable no-console */
      console.warn("The first parameter to `withStyle` must be a styled component (without extra wrappers).");
      /* eslint-enable no-console */
    }
  }

  {
    return createStyledElementComponent(autoComposeDeep(styletron, styleArg));
  }
}
function withWrapper$1(component, wrapper) {
  const styletron = component.__STYLETRON__;

  if (process.env.NODE_ENV !== "production") {
    if (!styletron) {
      /* eslint-disable no-console */
      console.warn("The first parameter to `withWrapper` must be a styled component (without extra wrappers).");
      /* eslint-enable no-console */
    }
  }

  const composed = {
    getInitialStyle: styletron.getInitialStyle,
    base: styletron.base,
    driver: styletron.driver,
    wrapper: wrapper,
    reducers: styletron.reducers
  };

  return createStyledElementComponent(composed);
}
function autoComposeShallow(styletron, styleArg) {
  if (typeof styleArg === "function") {
    return dynamicComposeShallow(styletron, styleArg);
  }

  return staticComposeShallow(styletron, styleArg);
}

function autoComposeDeep(styletron, styleArg) {
  if (typeof styleArg === "function") {
    return dynamicComposeDeep(styletron, styleArg);
  }

  return staticComposeDeep(styletron, styleArg);
}
function staticComposeShallow(styletron, style) {
  return composeStatic(styletron, createShallowMergeReducer(style));
}
function staticComposeDeep(styletron, style) {
  return composeStatic(styletron, createDeepMergeReducer(style));
}
function dynamicComposeShallow(styletron, styleFn) {
  return composeDynamic(styletron, (style, props) => shallowMerge(style, styleFn(props)));
}
function dynamicComposeDeep(styletron, styleFn) {
  return composeDynamic(styletron, (style, props) => deepMerge$1(style, styleFn(props)));
}
function createShallowMergeReducer(style) {
  return {
    reducer: inputStyle => shallowMerge(inputStyle, style),
    assignmentCommutative: true,
    factory: createShallowMergeReducer,
    style: style
  };
}
function createDeepMergeReducer(style) {
  return {
    reducer: inputStyle => deepMerge$1(inputStyle, style),
    assignmentCommutative: true,
    factory: createDeepMergeReducer,
    style: style
  };
}
function composeStatic(styletron, reducerContainer) {
  if (styletron.reducers.length === 0) {
    const style = reducerContainer.reducer(styletron.getInitialStyle());
    const result = {
      reducers: styletron.reducers,
      base: styletron.base,
      driver: styletron.driver,
      wrapper: styletron.wrapper,
      getInitialStyle: () => style
    };

    return result;
  } else {
    const last = styletron.reducers[0];

    if (last.assignmentCommutative === true && reducerContainer.assignmentCommutative === true) {
      const composed = reducerContainer.reducer(last.style);
      const result = {
        getInitialStyle: styletron.getInitialStyle,
        base: styletron.base,
        driver: styletron.driver,
        wrapper: styletron.wrapper,
        reducers: [last.factory(composed)].concat(styletron.reducers.slice(1))
      };

      return result;
    }

    return composeDynamic(styletron, reducerContainer.reducer);
  }
}
function composeDynamic(styletron, reducer) {
  const composed = {
    getInitialStyle: styletron.getInitialStyle,
    base: styletron.base,
    driver: styletron.driver,
    wrapper: styletron.wrapper,
    reducers: [{
      assignmentCommutative: false,
      reducer
    }].concat(styletron.reducers)
  };

  return composed;
}
function createStyledElementComponent(styletron) {
  const {
    reducers,
    base,
    driver: driver$$1,
    wrapper,
    getInitialStyle: getInitialStyle$$1,
    ext
  } = styletron;

  const StyledElement = forwardRef((props, ref) => {
    const styletron = useContext(StyletronContext);
    useContext(DebugEngineContext);
    useContext(HydrationContext);
    checkNoopEngine(styletron);
    const elementProps = omitPrefixedKeys(props);
    let style = resolveStyle(getInitialStyle$$1, reducers, props);

    if (props.$style) {
      if (typeof props.$style === "function") {
        style = deepMerge$1(style, props.$style(props));
      } else {
        style = deepMerge$1(style, props.$style);
      }
    }

    const styleClassString = driver$$1(style, styletron);
    const Element = props.$as ? props.$as : base;
    elementProps.className = props.className ? `${props.className} ${styleClassString}` : styleClassString;

    if (props.$ref) {
      // eslint-disable-next-line no-console
      console.warn("The prop `$ref` has been deprecated. Use `ref` instead. Refs are now forwarded with React.forwardRef.");
    }

    return createElement(Element, _extends$1x({}, elementProps, {
      ref: ref || props.$ref
    }));
  });
  const Wrapped = wrapper(StyledElement);
  Wrapped.__STYLETRON__ = {
    base,
    reducers,
    driver: driver$$1,
    wrapper,
    getInitialStyle: getInitialStyle$$1
  };

  if (process.env.NODE_ENV !== "production") {
    let displayName;

    if (typeof base === "string") {
      displayName = base;
    } else if (base.displayName) {
      displayName = base.displayName;
    } else if (base.name) {
      displayName = base.name;
    } else {
      displayName = "Unknown";
    }

    Wrapped.displayName = `Styled(${displayName})`;
  }

  return Wrapped;
} // Utility functions

function resolveStyle(getInitialStyle$$1, reducers, props) {
  let result = getInitialStyle$$1();
  let i = reducers.length;

  while (i--) {
    // Cast to allow passing unused props param in case of static reducer
    const reducer = reducers[i].reducer;
    result = reducer(result, props);
  }

  return result;
}

function isObject(x) {
  return typeof x === "object" && x !== null;
}

function omitPrefixedKeys(source) {
  const result = {};

  for (const key in source) {
    if (key[0] !== "$") {
      result[key] = source[key];
    }
  }

  return result;
}

function deepMerge$1(a, b) {
  const result = assign$1({}, a);

  for (const key in b) {
    const val = b[key];

    if (isObject(val) && isObject(a[key])) {
      result[key] = deepMerge$1(a[key], val);
    } else {
      result[key] = val;
    }
  }

  return result;
}

function shallowMerge(a, b) {
  return assign$1(assign$1({}, a), b);
}

function assign$1(target, source) {
  for (const key in source) {
    target[key] = source[key];
  }

  return target;
}

var index_es = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DebugEngine: DebugEngine,
  Provider: Provider$1,
  useStyletron: useStyletron$1,
  createStyled: createStyled,
  styled: styled$1,
  withTransform: withTransform,
  withStyle: withStyle$1,
  withStyleDeep: withStyleDeep,
  withWrapper: withWrapper$1,
  autoComposeShallow: autoComposeShallow,
  autoComposeDeep: autoComposeDeep,
  staticComposeShallow: staticComposeShallow,
  staticComposeDeep: staticComposeDeep,
  dynamicComposeShallow: dynamicComposeShallow,
  dynamicComposeDeep: dynamicComposeDeep,
  createShallowMergeReducer: createShallowMergeReducer,
  createDeepMergeReducer: createDeepMergeReducer,
  composeStatic: composeStatic,
  composeDynamic: composeDynamic,
  createStyledElementComponent: createStyledElementComponent,
  resolveStyle: resolveStyle
});

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var colors = {
  white: '#FFFFFF',
  gray50: '#F6F6F6',
  gray100: '#EEEEEE',
  gray200: '#E2E2E2',
  gray300: '#CBCBCB',
  gray400: '#AFAFAF',
  gray500: '#6B6B6B',
  gray600: '#545454',
  gray700: '#333333',
  gray800: '#1F1F1F',
  gray900: '#141414',
  black: '#000000',
  platinum50: '#F4FAFB',
  platinum100: '#EBF5F7',
  platinum200: '#CCDFE5',
  platinum300: '#A1BDCA',
  platinum400: '#8EA3AD',
  platinum500: '#6C7C83',
  platinum600: '#556268',
  platinum700: '#394145',
  platinum800: '#142328',
  red50: '#FFEFED',
  red100: '#FED7D2',
  red200: '#F1998E',
  red300: '#E85C4A',
  red400: '#E11900',
  red500: '#AB1300',
  red600: '#870F00',
  red700: '#5A0A00',
  orange50: '#FFF3EF',
  orange100: '#FFE1D6',
  orange200: '#FABDA5',
  orange300: '#FA9269',
  orange400: '#FF6937',
  orange500: '#C14F29',
  orange600: '#9A3F21',
  orange700: '#672A16',
  yellow50: '#FFFAF0',
  yellow100: '#FFF2D9',
  yellow200: '#FFE3AC',
  yellow300: '#FFCF70',
  yellow400: '#FFC043',
  yellow500: '#BC8B2C',
  yellow600: '#996F00',
  yellow700: '#674D1B',
  green50: '#E6F2ED',
  green100: '#ADDEC9',
  green200: '#66D19E',
  green300: '#06C167',
  green400: '#048848',
  green500: '#03703C',
  green600: '#03582F',
  green700: '#10462D',
  blue50: '#EFF3FE',
  blue100: '#D4E2FC',
  blue200: '#A0BFF8',
  blue300: '#5B91F5',
  blue400: '#276EF1',
  blue500: '#1E54B7',
  blue600: '#174291',
  blue700: '#102C60',
  cobalt50: '#EBEDFA',
  cobalt100: '#D2D7F0',
  cobalt200: '#949CE3',
  cobalt300: '#535FCF',
  cobalt400: '#0E1FC1',
  cobalt500: '#0A1899',
  cobalt600: '#081270',
  cobalt700: '#050C4D',
  purple50: '#F3F1F9',
  purple100: '#E3DDF2',
  purple200: '#C1B4E2',
  purple300: '#957FCE',
  purple400: '#7356BF',
  purple500: '#574191',
  purple600: '#453473',
  purple700: '#2E224C',
  brown50: '#F6F0EA',
  brown100: '#EBE0DB',
  brown200: '#D2BBB0',
  brown300: '#B18977',
  brown400: '#99644C',
  brown500: '#744C3A',
  brown600: '#5C3C2E',
  brown700: '#3D281E'
};
var colorTokens$3 = colors;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// color constants
var lightColorTokens = {
  // Primary Palette
  primaryA: colorTokens$3.black,
  primaryB: colorTokens$3.white,
  primary: colorTokens$3.black,
  primary50: colorTokens$3.gray50,
  primary100: colorTokens$3.gray100,
  primary200: colorTokens$3.gray200,
  primary300: colorTokens$3.gray300,
  primary400: colorTokens$3.gray400,
  primary500: colorTokens$3.gray500,
  primary600: colorTokens$3.gray600,
  primary700: colorTokens$3.gray700,
  // Accent Palette
  accent: colorTokens$3.blue400,
  accent50: colorTokens$3.blue50,
  accent100: colorTokens$3.blue100,
  accent200: colorTokens$3.blue200,
  accent300: colorTokens$3.blue300,
  accent400: colorTokens$3.blue400,
  accent500: colorTokens$3.blue500,
  accent600: colorTokens$3.blue600,
  accent700: colorTokens$3.blue700,
  // Negative Palette
  negative: colorTokens$3.red400,
  negative50: colorTokens$3.red50,
  negative100: colorTokens$3.red100,
  negative200: colorTokens$3.red200,
  negative300: colorTokens$3.red300,
  negative400: colorTokens$3.red400,
  negative500: colorTokens$3.red500,
  negative600: colorTokens$3.red600,
  negative700: colorTokens$3.red700,
  // Warning Palette
  warning: colorTokens$3.yellow400,
  warning50: colorTokens$3.yellow50,
  warning100: colorTokens$3.yellow100,
  warning200: colorTokens$3.yellow200,
  warning300: colorTokens$3.yellow300,
  warning400: colorTokens$3.yellow400,
  warning500: colorTokens$3.yellow500,
  warning600: colorTokens$3.yellow600,
  warning700: colorTokens$3.yellow700,
  // Positive Palette
  positive: colorTokens$3.green500,
  positive50: colorTokens$3.green50,
  positive100: colorTokens$3.green100,
  positive200: colorTokens$3.green200,
  positive300: colorTokens$3.green300,
  positive400: colorTokens$3.green400,
  positive500: colorTokens$3.green500,
  positive600: colorTokens$3.green600,
  positive700: colorTokens$3.green700,
  // Monochrome Palette
  white: colorTokens$3.white,
  black: colorTokens$3.black,
  mono100: colorTokens$3.white,
  mono200: colorTokens$3.gray50,
  mono300: colorTokens$3.gray100,
  mono400: colorTokens$3.gray200,
  mono500: colorTokens$3.gray300,
  mono600: colorTokens$3.gray400,
  mono700: colorTokens$3.gray500,
  mono800: colorTokens$3.gray600,
  mono900: colorTokens$3.gray700,
  mono1000: colorTokens$3.black,
  // Rating Palette,
  rating200: colorTokens$3.yellow200,
  rating400: colorTokens$3.yellow400,
  ratingInactiveFill: colorTokens$3.gray100,
  ratingStroke: colorTokens$3.gray300
};
var colorTokens$2 = lightColorTokens;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function hexToRgb() {
  var hex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1';
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? "rgba(".concat(parseInt(result[1], 16), ", ").concat(parseInt(result[2], 16), ", ").concat(parseInt(result[3], 16), ", ").concat(alpha, ")") : null;
}
var ellipsisText$1 = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  wordWrap: 'normal'
};
function expandBorderStyles(borderStyles) {
  return {
    borderTopWidth: borderStyles.borderWidth,
    borderTopStyle: borderStyles.borderStyle,
    borderTopColor: borderStyles.borderColor,
    borderBottomWidth: borderStyles.borderWidth,
    borderBottomStyle: borderStyles.borderStyle,
    borderBottomColor: borderStyles.borderColor,
    borderLeftWidth: borderStyles.borderWidth,
    borderLeftStyle: borderStyles.borderStyle,
    borderLeftColor: borderStyles.borderColor,
    borderRightWidth: borderStyles.borderWidth,
    borderRightStyle: borderStyles.borderStyle,
    borderRightColor: borderStyles.borderColor
  };
}

function ownKeys$1f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1f(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1f(Object(source), true).forEach(function (key) { _defineProperty$1I(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1I(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var getSemanticColorTokens = (function () {
  var foundation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : colorTokens$2;
  var core = {
    // Background
    backgroundPrimary: foundation.primaryB,
    backgroundSecondary: colorTokens$3.gray50,
    backgroundTertiary: colorTokens$3.gray100,
    backgroundInversePrimary: foundation.primaryA,
    backgroundInverseSecondary: colorTokens$3.gray800,
    // Content
    contentPrimary: foundation.primaryA,
    contentSecondary: colorTokens$3.gray600,
    contentTertiary: colorTokens$3.gray500,
    contentInversePrimary: foundation.primaryB,
    contentInverseSecondary: colorTokens$3.gray300,
    contentInverseTertiary: colorTokens$3.gray400,
    // Border
    borderOpaque: colorTokens$3.gray200,
    borderTransparent: hexToRgb(foundation.primaryA, '0.08'),
    borderSelected: foundation.primaryA,
    borderInverseOpaque: colorTokens$3.gray700,
    borderInverseTransparent: hexToRgb(foundation.primaryB, '0.2'),
    borderInverseSelected: foundation.primaryB
  };
  var coreExtensions = {
    // Backgrounds
    backgroundStateDisabled: colorTokens$3.gray50,
    backgroundOverlayDark: hexToRgb(colorTokens$3.black, '0.3'),
    backgroundOverlayLight: hexToRgb(colorTokens$3.black, '0.08'),
    backgroundAccent: foundation.accent,
    backgroundNegative: foundation.negative,
    backgroundWarning: foundation.warning,
    backgroundPositive: colorTokens$3.green400,
    backgroundLightAccent: colorTokens$3.blue50,
    backgroundLightNegative: colorTokens$3.red50,
    backgroundLightWarning: colorTokens$3.yellow50,
    backgroundLightPositive: colorTokens$3.green50,
    backgroundAlwaysDark: colorTokens$3.black,
    backgroundAlwaysLight: colorTokens$3.white,
    // Content
    contentStateDisabled: colorTokens$3.gray400,
    contentAccent: foundation.accent,
    contentOnColor: colorTokens$3.white,
    contentOnColorInverse: colorTokens$3.black,
    contentNegative: foundation.negative,
    contentWarning: colorTokens$3.yellow600,
    contentPositive: colorTokens$3.green400,
    // Border
    borderStateDisabled: colorTokens$3.gray50,
    borderAccent: colorTokens$3.blue400,
    borderAccentLight: colorTokens$3.blue200,
    borderNegative: colorTokens$3.red200,
    borderWarning: colorTokens$3.yellow200,
    borderPositive: colorTokens$3.green200,
    // Programs
    safety: colorTokens$3.blue400,
    eatsGreen400: colorTokens$3.green400,
    freightBlue400: colorTokens$3.cobalt400,
    jumpRed400: colorTokens$3.red400,
    rewardsTier1: colorTokens$3.blue400,
    rewardsTier2: colorTokens$3.yellow400,
    rewardsTier3: colorTokens$3.platinum400,
    rewardsTier4: colorTokens$3.black,
    membership: colorTokens$3.yellow600
  };
  return _objectSpread$1f(_objectSpread$1f({}, core), coreExtensions);
});

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var tagHoverBackground = "rgba(0, 0, 0, 0.08)";
/* ---- Component colors ---- */
// TODO(#2318) Make it a plain object in the next v11 major version
// with values taken from `colorTokens`.
// Due to the legacy `createTheme` type the value need to be
// overrideable through primitives (`foundation` )

var getComponentColorTokens = (function () {
  var themePrimitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : colorTokens$2;
  return {
    // Buttons
    buttonPrimaryFill: themePrimitives.primary,
    buttonPrimaryText: themePrimitives.white,
    buttonPrimaryHover: themePrimitives.primary700,
    buttonPrimaryActive: themePrimitives.primary600,
    buttonPrimarySelectedFill: themePrimitives.primary600,
    buttonPrimarySelectedText: themePrimitives.white,
    buttonPrimarySpinnerForeground: themePrimitives.accent,
    buttonPrimarySpinnerBackground: themePrimitives.primaryB,
    buttonSecondaryFill: themePrimitives.primary100,
    buttonSecondaryText: themePrimitives.primary,
    buttonSecondaryHover: themePrimitives.primary200,
    buttonSecondaryActive: themePrimitives.primary300,
    buttonSecondarySelectedFill: themePrimitives.primary300,
    buttonSecondarySelectedText: themePrimitives.primary,
    buttonSecondarySpinnerForeground: themePrimitives.accent,
    buttonSecondarySpinnerBackground: themePrimitives.primaryB,
    buttonTertiaryFill: 'transparent',
    buttonTertiaryText: themePrimitives.primary,
    buttonTertiaryHover: themePrimitives.primary50,
    buttonTertiaryActive: themePrimitives.primary100,
    buttonTertiarySelectedFill: themePrimitives.primary100,
    buttonTertiarySelectedText: themePrimitives.primary,
    buttonTertiaryDisabledActiveFill: themePrimitives.primary50,
    buttonTertiaryDisabledActiveText: themePrimitives.mono600,
    buttonTertiarySpinnerForeground: themePrimitives.accent,
    buttonTertiarySpinnerBackground: themePrimitives.primary100,
    buttonMinimalFill: 'transparent',
    buttonMinimalText: themePrimitives.primary,
    buttonMinimalHover: themePrimitives.primary50,
    buttonMinimalActive: themePrimitives.primary100,
    buttonMinimalSelectedFill: themePrimitives.primary100,
    buttonMinimalSelectedText: themePrimitives.primary,
    buttonMinimalSpinnerForeground: themePrimitives.accent,
    buttonMinimalSpinnerBackground: themePrimitives.primary100,
    buttonDisabledFill: themePrimitives.mono200,
    buttonDisabledText: themePrimitives.mono600,
    buttonDisabledActiveFill: themePrimitives.mono700,
    buttonDisabledActiveText: themePrimitives.mono100,
    buttonDisabledSpinnerForeground: themePrimitives.mono600,
    buttonDisabledSpinnerBackground: themePrimitives.mono400,
    // Breadcrumbs
    breadcrumbsText: themePrimitives.mono900,
    breadcrumbsSeparatorFill: themePrimitives.mono700,
    // Datepicker
    datepickerBackground: themePrimitives.mono100,
    datepickerDayFont: themePrimitives.mono1000,
    datepickerDayFontDisabled: themePrimitives.mono500,
    datepickerDayPseudoSelected: themePrimitives.primary100,
    datepickerDayPseudoHighlighted: themePrimitives.primary200,
    // Calendar
    calendarBackground: themePrimitives.mono100,
    calendarForeground: themePrimitives.mono1000,
    calendarForegroundDisabled: themePrimitives.mono500,
    calendarHeaderBackground: themePrimitives.white,
    calendarHeaderForeground: themePrimitives.primary,
    calendarHeaderBackgroundActive: themePrimitives.primary700,
    calendarHeaderForegroundDisabled: themePrimitives.primary500,
    calendarDayBackgroundPseudoSelected: themePrimitives.primary100,
    calendarDayForegroundPseudoSelected: themePrimitives.mono1000,
    calendarDayBackgroundPseudoSelectedHighlighted: themePrimitives.primary200,
    calendarDayForegroundPseudoSelectedHighlighted: themePrimitives.mono1000,
    calendarDayBackgroundSelected: themePrimitives.primary,
    calendarDayForegroundSelected: themePrimitives.white,
    calendarDayBackgroundSelectedHighlighted: themePrimitives.primary,
    calendarDayForegroundSelectedHighlighted: themePrimitives.white,
    // Combobox
    comboboxListItemFocus: themePrimitives.mono200,
    comboboxListItemHover: themePrimitives.mono300,
    // FileUploader
    fileUploaderBackgroundColor: themePrimitives.mono200,
    fileUploaderBackgroundColorActive: themePrimitives.primary50,
    fileUploaderBorderColorActive: themePrimitives.primary,
    fileUploaderBorderColorDefault: themePrimitives.mono500,
    fileUploaderMessageColor: themePrimitives.mono800,
    // Links
    linkText: themePrimitives.primary,
    linkVisited: themePrimitives.primary700,
    linkHover: themePrimitives.primary600,
    linkActive: themePrimitives.primary500,
    // List
    listHeaderFill: themePrimitives.white,
    listBodyFill: themePrimitives.white,
    listIconFill: themePrimitives.mono500,
    listBorder: themePrimitives.mono500,
    // ProgressSteps
    progressStepsCompletedText: themePrimitives.white,
    progressStepsCompletedFill: themePrimitives.primary,
    progressStepsActiveText: themePrimitives.white,
    progressStepsActiveFill: themePrimitives.primary,
    progressStepsIconActiveFill: themePrimitives.primary,
    // Toggle
    toggleFill: themePrimitives.white,
    toggleFillChecked: themePrimitives.primary,
    toggleFillDisabled: themePrimitives.mono600,
    toggleTrackFill: themePrimitives.mono400,
    toggleTrackFillDisabled: themePrimitives.mono300,
    // Tick
    tickFill: themePrimitives.mono100,
    tickFillHover: themePrimitives.mono200,
    tickFillActive: themePrimitives.mono300,
    tickFillSelected: themePrimitives.primary,
    tickFillSelectedHover: themePrimitives.primary700,
    tickFillSelectedHoverActive: themePrimitives.primary600,
    tickFillError: themePrimitives.negative50,
    tickFillErrorHover: themePrimitives.negative100,
    tickFillErrorHoverActive: themePrimitives.negative200,
    tickFillErrorSelected: themePrimitives.negative400,
    tickFillErrorSelectedHover: themePrimitives.negative500,
    tickFillErrorSelectedHoverActive: themePrimitives.negative600,
    tickFillDisabled: themePrimitives.mono600,
    tickBorder: themePrimitives.mono700,
    tickBorderError: themePrimitives.negative400,
    tickMarkFill: themePrimitives.white,
    tickMarkFillError: themePrimitives.white,
    tickMarkFillDisabled: themePrimitives.mono100,
    // Slider/Toggle
    sliderTrackFill: 'transparent',
    sliderHandleFill: themePrimitives.primaryA,
    sliderHandleFillDisabled: themePrimitives.primary400,
    sliderHandleInnerFill: themePrimitives.primaryA,
    sliderTrackFillHover: themePrimitives.mono500,
    sliderTrackFillActive: themePrimitives.mono600,
    sliderTrackFillSelected: themePrimitives.primary,
    sliderTrackFillSelectedHover: themePrimitives.primary,
    sliderTrackFillSelectedActive: themePrimitives.primary500,
    sliderTrackFillDisabled: themePrimitives.mono300,
    sliderHandleFillHover: themePrimitives.white,
    sliderHandleFillActive: themePrimitives.white,
    sliderHandleFillSelected: themePrimitives.white,
    sliderHandleFillSelectedHover: themePrimitives.white,
    sliderHandleFillSelectedActive: themePrimitives.white,
    sliderHandleInnerFillDisabled: themePrimitives.mono400,
    sliderHandleInnerFillSelectedHover: themePrimitives.primary,
    sliderHandleInnerFillSelectedActive: themePrimitives.primary500,
    sliderBorder: themePrimitives.mono500,
    sliderBorderHover: themePrimitives.primary,
    sliderBorderDisabled: themePrimitives.mono600,
    // Inputs
    inputBorder: themePrimitives.mono300,
    inputFill: themePrimitives.mono300,
    inputFillError: themePrimitives.negative50,
    inputFillDisabled: themePrimitives.mono200,
    inputFillActive: themePrimitives.mono200,
    inputFillPositive: themePrimitives.positive50,
    inputTextDisabled: themePrimitives.mono600,
    inputBorderError: themePrimitives.negative200,
    inputBorderPositive: themePrimitives.positive200,
    inputEnhancerFill: themePrimitives.mono300,
    inputEnhancerFillDisabled: themePrimitives.mono300,
    inputEnhancerTextDisabled: themePrimitives.mono600,
    inputPlaceholder: themePrimitives.mono700,
    inputPlaceholderDisabled: themePrimitives.mono600,
    // Menu
    menuFill: themePrimitives.mono100,
    menuFillHover: themePrimitives.mono200,
    menuFontDefault: themePrimitives.mono800,
    menuFontDisabled: themePrimitives.mono500,
    menuFontHighlighted: themePrimitives.mono1000,
    menuFontSelected: themePrimitives.mono1000,
    // Modal
    modalCloseColor: themePrimitives.mono1000,
    modalCloseColorHover: themePrimitives.mono800,
    modalCloseColorFocus: themePrimitives.mono800,
    // Pagination
    paginationTriangleDown: themePrimitives.mono800,
    // Header navigation
    headerNavigationFill: 'transparent',
    // Tab
    tabBarFill: themePrimitives.mono200,
    tabColor: themePrimitives.mono800,
    // Notification
    notificationPrimaryBackground: themePrimitives.primary50,
    notificationPrimaryText: themePrimitives.primaryA,
    notificationInfoBackground: themePrimitives.accent50,
    notificationInfoText: themePrimitives.primaryA,
    notificationPositiveBackground: themePrimitives.positive50,
    notificationPositiveText: themePrimitives.primaryA,
    notificationWarningBackground: themePrimitives.warning50,
    notificationWarningText: themePrimitives.primaryA,
    notificationNegativeBackground: themePrimitives.negative50,
    notificationNegativeText: themePrimitives.primaryA,
    // Tag
    // Custom ramps
    tagFontDisabledRampUnit: '100',
    tagOutlinedDisabledRampUnit: '200',
    tagSolidFontRampUnit: '0',
    tagSolidRampUnit: '400',
    tagOutlinedFontRampUnit: '400',
    tagOutlinedRampUnit: '200',
    // Deprecated
    tagSolidHoverRampUnit: '50',
    tagSolidActiveRampUnit: '100',
    tagSolidDisabledRampUnit: '50',
    tagSolidFontHoverRampUnit: '500',
    tagLightRampUnit: '50',
    tagLightHoverRampUnit: '100',
    tagLightActiveRampUnit: '100',
    tagLightDisabledRampUnit: '50',
    tagLightFontRampUnit: '500',
    tagLightFontHoverRampUnit: '500',
    tagOutlinedHoverRampUnit: '50',
    tagOutlinedActiveRampUnit: '0',
    tagOutlinedFontHoverRampUnit: '400',
    // Neutral
    tagNeutralFontDisabled: themePrimitives.mono600,
    tagNeutralOutlinedDisabled: themePrimitives.mono400,
    tagNeutralSolidFont: themePrimitives.white,
    tagNeutralSolidBackground: themePrimitives.black,
    tagNeutralOutlinedBackground: themePrimitives.mono600,
    tagNeutralOutlinedFont: themePrimitives.black,
    // Deprecated
    tagNeutralSolidHover: themePrimitives.mono300,
    tagNeutralSolidActive: themePrimitives.mono400,
    tagNeutralSolidDisabled: themePrimitives.mono200,
    tagNeutralSolidFontHover: themePrimitives.mono900,
    tagNeutralLightBackground: themePrimitives.mono300,
    tagNeutralLightHover: themePrimitives.mono300,
    tagNeutralLightActive: themePrimitives.mono400,
    tagNeutralLightDisabled: themePrimitives.mono200,
    tagNeutralLightFont: themePrimitives.mono900,
    tagNeutralLightFontHover: themePrimitives.mono900,
    tagNeutralOutlinedActive: themePrimitives.mono900,
    tagNeutralOutlinedFontHover: themePrimitives.mono800,
    tagNeutralOutlinedHover: tagHoverBackground,
    // Primary
    tagPrimaryFontDisabled: themePrimitives.primary400,
    tagPrimaryOutlinedDisabled: themePrimitives.primary200,
    tagPrimarySolidFont: themePrimitives.white,
    tagPrimarySolidBackground: themePrimitives.primary,
    tagPrimaryOutlinedFontHover: themePrimitives.primary,
    tagPrimaryOutlinedFont: themePrimitives.primary,
    // Deprecated
    tagPrimarySolidHover: themePrimitives.primary100,
    tagPrimarySolidActive: themePrimitives.primary200,
    tagPrimarySolidDisabled: themePrimitives.primary50,
    tagPrimarySolidFontHover: themePrimitives.primary700,
    tagPrimaryLightBackground: themePrimitives.primary50,
    tagPrimaryLightHover: themePrimitives.primary100,
    tagPrimaryLightActive: themePrimitives.primary100,
    tagPrimaryLightDisabled: themePrimitives.primary50,
    tagPrimaryLightFont: themePrimitives.primary500,
    tagPrimaryLightFontHover: themePrimitives.primary500,
    tagPrimaryOutlinedActive: themePrimitives.primary600,
    tagPrimaryOutlinedHover: tagHoverBackground,
    tagPrimaryOutlinedBackground: themePrimitives.primary400,
    // Accent
    tagAccentFontDisabled: themePrimitives.accent200,
    tagAccentOutlinedDisabled: themePrimitives.accent200,
    tagAccentSolidFont: themePrimitives.white,
    tagAccentSolidBackground: themePrimitives.accent400,
    tagAccentOutlinedBackground: themePrimitives.accent200,
    tagAccentOutlinedFont: themePrimitives.accent400,
    // Deprecated
    tagAccentSolidHover: themePrimitives.accent50,
    tagAccentSolidActive: themePrimitives.accent100,
    tagAccentSolidDisabled: themePrimitives.accent50,
    tagAccentSolidFontHover: themePrimitives.accent500,
    tagAccentLightBackground: themePrimitives.accent50,
    tagAccentLightHover: themePrimitives.accent100,
    tagAccentLightActive: themePrimitives.accent100,
    tagAccentLightDisabled: themePrimitives.accent50,
    tagAccentLightFont: themePrimitives.accent500,
    tagAccentLightFontHover: themePrimitives.accent500,
    tagAccentOutlinedActive: themePrimitives.accent600,
    tagAccentOutlinedFontHover: themePrimitives.accent400,
    tagAccentOutlinedHover: tagHoverBackground,
    // Positive
    tagPositiveFontDisabled: themePrimitives.positive200,
    tagPositiveOutlinedDisabled: themePrimitives.positive200,
    tagPositiveSolidFont: themePrimitives.white,
    tagPositiveSolidBackground: themePrimitives.positive400,
    tagPositiveOutlinedBackground: themePrimitives.positive200,
    tagPositiveOutlinedFont: themePrimitives.positive400,
    // Deprecated
    tagPositiveSolidHover: themePrimitives.positive50,
    tagPositiveSolidActive: themePrimitives.positive100,
    tagPositiveSolidDisabled: themePrimitives.positive50,
    tagPositiveSolidFontHover: themePrimitives.positive500,
    tagPositiveLightBackground: themePrimitives.positive50,
    tagPositiveLightHover: themePrimitives.positive100,
    tagPositiveLightActive: themePrimitives.positive100,
    tagPositiveLightDisabled: themePrimitives.positive50,
    tagPositiveLightFont: themePrimitives.positive500,
    tagPositiveLightFontHover: themePrimitives.positive500,
    tagPositiveOutlinedActive: themePrimitives.positive600,
    tagPositiveOutlinedFontHover: themePrimitives.positive400,
    tagPositiveOutlinedHover: tagHoverBackground,
    // Warning
    tagWarningFontDisabled: themePrimitives.warning300,
    tagWarningOutlinedDisabled: themePrimitives.warning300,
    tagWarningSolidFont: themePrimitives.warning700,
    tagWarningSolidBackground: themePrimitives.warning400,
    tagWarningOutlinedBackground: themePrimitives.warning300,
    tagWarningOutlinedFont: themePrimitives.warning600,
    // Deprecated
    tagWarningSolidHover: themePrimitives.warning50,
    tagWarningSolidActive: themePrimitives.warning100,
    tagWarningSolidDisabled: themePrimitives.warning50,
    tagWarningSolidFontHover: themePrimitives.warning500,
    tagWarningLightBackground: themePrimitives.warning50,
    tagWarningLightHover: themePrimitives.warning100,
    tagWarningLightActive: themePrimitives.warning100,
    tagWarningLightDisabled: themePrimitives.warning50,
    tagWarningLightFont: themePrimitives.warning500,
    tagWarningLightFontHover: themePrimitives.warning500,
    tagWarningOutlinedActive: themePrimitives.warning600,
    tagWarningOutlinedFontHover: themePrimitives.warning600,
    tagWarningOutlinedHover: tagHoverBackground,
    // Negative
    tagNegativeFontDisabled: themePrimitives.negative200,
    tagNegativeOutlinedDisabled: themePrimitives.negative200,
    tagNegativeSolidFont: themePrimitives.white,
    tagNegativeSolidBackground: themePrimitives.negative400,
    tagNegativeOutlinedBackground: themePrimitives.negative200,
    tagNegativeOutlinedFont: themePrimitives.negative400,
    // Deprecated
    tagNegativeSolidHover: themePrimitives.negative50,
    tagNegativeSolidActive: themePrimitives.negative100,
    tagNegativeSolidDisabled: themePrimitives.negative50,
    tagNegativeSolidFontHover: themePrimitives.negative500,
    tagNegativeLightBackground: themePrimitives.negative50,
    tagNegativeLightHover: themePrimitives.negative100,
    tagNegativeLightActive: themePrimitives.negative100,
    tagNegativeLightDisabled: themePrimitives.negative50,
    tagNegativeLightFont: themePrimitives.negative500,
    tagNegativeLightFontHover: themePrimitives.negative500,
    tagNegativeOutlinedActive: themePrimitives.negative600,
    tagNegativeOutlinedFontHover: themePrimitives.negative400,
    tagNegativeOutlinedHover: tagHoverBackground,
    // Table
    tableHeadBackgroundColor: themePrimitives.mono100,
    tableBackground: themePrimitives.mono100,
    tableStripedBackground: themePrimitives.mono200,
    tableFilter: themePrimitives.mono600,
    tableFilterHeading: themePrimitives.mono700,
    tableFilterBackground: themePrimitives.mono100,
    tableFilterFooterBackground: themePrimitives.mono200,
    // Toast
    toastText: themePrimitives.white,
    toastPrimaryBackground: themePrimitives.primary400,
    toastPrimaryText: themePrimitives.white,
    toastInfoBackground: themePrimitives.accent400,
    toastInfoText: themePrimitives.white,
    toastPositiveBackground: themePrimitives.positive400,
    toastPositiveText: themePrimitives.white,
    toastWarningBackground: themePrimitives.warning400,
    toastWarningText: themePrimitives.black,
    toastNegativeBackground: themePrimitives.negative400,
    toastNegativeText: themePrimitives.white,
    // Spinner
    spinnerTrackFill: themePrimitives.mono900,
    // Progress bar
    progressbarTrackFill: themePrimitives.mono900,
    // Tooltip
    tooltipBackground: themePrimitives.mono900,
    tooltipText: themePrimitives.mono100
  };
});

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* ---- DEPRECATED ---- */
var getDeprecatedSemanticColorTokens = (function () {
  var themePrimitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : colorTokens$2;
  return {
    // TODO(#2318) Remove Legacy Semantic Colors values in the next v11 major
    // since it's not used in the component specific tokens
    // and we ship semantic tokens separately

    /* ---- Legacy Semantic Colors ---- */
    // Font Color
    colorPrimary: themePrimitives.black,
    colorSecondary: themePrimitives.mono800,
    // Background
    background: themePrimitives.white,
    backgroundAlt: themePrimitives.white,
    backgroundInv: themePrimitives.primary,
    // Foreground
    foreground: themePrimitives.black,
    foregroundAlt: themePrimitives.mono800,
    foregroundInv: themePrimitives.white,
    // Borders
    border: themePrimitives.mono500,
    borderAlt: themePrimitives.mono600,
    borderFocus: themePrimitives.primary,
    borderError: themePrimitives.negative,
    // Shadow
    shadowFocus: 'rgba(39, 110, 241, 0.32)',
    shadowError: 'rgba(229, 73, 55, 0.32)'
  };
});

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// borderColor is defaulted to the light theme values.
// Dark theme overrides the border colors.
var borders = {
  border100: {
    borderColor: 'hsla(0, 0%, 0%, 0.04)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border200: {
    borderColor: 'hsla(0, 0%, 0%, 0.08)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border300: {
    borderColor: 'hsla(0, 0%, 0%, 0.12)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border400: {
    borderColor: 'hsla(0, 0%, 0%, 0.16)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border500: {
    borderColor: 'hsla(0, 0%, 0%, 0.2)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border600: {
    borderColor: 'hsla(0, 0%, 0%, 0.24)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  radius100: '2px',
  radius200: '4px',
  radius300: '8px',
  radius400: '12px',
  radius500: '16px',

  /** Datepicker (Range), Progress Bar, Slider, Tag */
  useRoundedCorners: true,

  /** Button, ButtonGroup */
  buttonBorderRadius: '0px',

  /** Input, Select, Textarea, Checkbox */
  inputBorderRadius: '0px',

  /** Popover, Menu, Tooltip */
  popoverBorderRadius: '0px',

  /** Card, Datepicker, Modal, Toast, Notification */
  surfaceBorderRadius: '0px',

  /** Tag */
  tagBorderRadius: '24px'
};
var borders$1 = borders;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var lighting = {
  shadow400: '0 1px 4px hsla(0, 0%, 0%, 0.16)',
  shadow500: '0 2px 8px hsla(0, 0%, 0%, 0.16)',
  shadow600: '0 4px 16px hsla(0, 0%, 0%, 0.16)',
  shadow700: '0 8px 24px hsla(0, 0%, 0%, 0.16)',
  overlay0: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0)',
  overlay100: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.04)',
  overlay200: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.08)',
  overlay300: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.12)',
  overlay400: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.16)',
  overlay500: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.2)',
  overlay600: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.24)',
  shallowAbove: '0px -4px 16px rgba(0, 0, 0, 0.12)',
  shallowBelow: '0px 4px 16px rgba(0, 0, 0, 0.12)',
  deepAbove: '0px -16px 48px rgba(0, 0, 0, 0.22)',
  deepBelow: '0px 16px 48px rgba(0, 0, 0, 0.22)'
};
var lighting$1 = lighting;

function ownKeys$1e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1e(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1e(Object(source), true).forEach(function (key) { _defineProperty$1H(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1H(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var defaultFontTokens = {
  primaryFontFamily: 'system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif'
};
var monoFontFamily = '"Lucida Console", Monaco, monospace';
var getTypography = (function () {
  var fontTokens = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultFontTokens;
  var font100 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '12px',
    fontWeight: 'normal',
    lineHeight: '20px'
  };
  var font150 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px'
  };
  var font200 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: '20px'
  };
  var font250 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '16px'
  };
  var font300 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '16px',
    fontWeight: 'normal',
    lineHeight: '24px'
  };
  var font350 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '20px'
  };
  var font400 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '18px',
    fontWeight: 'normal',
    lineHeight: '28px'
  };
  var font450 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '24px'
  };
  var font550 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '28px'
  };
  var font650 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '32px'
  };
  var font750 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '28px',
    fontWeight: 500,
    lineHeight: '36px'
  };
  var font850 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '32px',
    fontWeight: 500,
    lineHeight: '40px'
  };
  var font950 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '36px',
    fontWeight: 500,
    lineHeight: '44px'
  };
  var font1050 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '40px',
    fontWeight: 500,
    lineHeight: '52px'
  };
  var font1150 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '36px',
    fontWeight: 500,
    lineHeight: '44px'
  };
  var font1250 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '44px',
    fontWeight: 500,
    lineHeight: '52px'
  };
  var font1350 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '52px',
    fontWeight: 500,
    lineHeight: '64px'
  };
  var font1450 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '96px',
    fontWeight: 500,
    lineHeight: '112px'
  };
  return {
    font100: font100,
    font150: font150,
    font200: font200,
    font250: font250,
    font300: font300,
    font350: font350,
    font400: font400,
    font450: font450,
    font550: font550,
    font650: font650,
    font750: font750,
    font850: font850,
    font950: font950,
    font1050: font1050,
    font1150: font1150,
    font1250: font1250,
    font1350: font1350,
    font1450: font1450,
    ParagraphXSmall: font100,
    ParagraphSmall: font200,
    ParagraphMedium: font300,
    ParagraphLarge: font400,
    LabelXSmall: font150,
    LabelSmall: font250,
    LabelMedium: font350,
    LabelLarge: font450,
    HeadingXSmall: font550,
    HeadingSmall: font650,
    HeadingMedium: font750,
    HeadingLarge: font850,
    HeadingXLarge: font950,
    HeadingXXLarge: font1050,
    DisplayXSmall: font1150,
    DisplaySmall: font1250,
    DisplayMedium: font1350,
    DisplayLarge: font1450,
    MonoParagraphXSmall: _objectSpread$1e(_objectSpread$1e({}, font100), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphSmall: _objectSpread$1e(_objectSpread$1e({}, font200), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphMedium: _objectSpread$1e(_objectSpread$1e({}, font300), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphLarge: _objectSpread$1e(_objectSpread$1e({}, font400), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelXSmall: _objectSpread$1e(_objectSpread$1e({}, font150), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelSmall: _objectSpread$1e(_objectSpread$1e({}, font250), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelMedium: _objectSpread$1e(_objectSpread$1e({}, font350), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelLarge: _objectSpread$1e(_objectSpread$1e({}, font450), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXSmall: _objectSpread$1e(_objectSpread$1e({}, font550), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingSmall: _objectSpread$1e(_objectSpread$1e({}, font650), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingMedium: _objectSpread$1e(_objectSpread$1e({}, font750), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingLarge: _objectSpread$1e(_objectSpread$1e({}, font850), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXLarge: _objectSpread$1e(_objectSpread$1e({}, font950), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXXLarge: _objectSpread$1e(_objectSpread$1e({}, font1050), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayXSmall: _objectSpread$1e(_objectSpread$1e({}, font1150), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplaySmall: _objectSpread$1e(_objectSpread$1e({}, font1250), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayMedium: _objectSpread$1e(_objectSpread$1e({}, font1350), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayLarge: _objectSpread$1e(_objectSpread$1e({}, font1450), {}, {
      fontFamily: monoFontFamily
    })
  };
});

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var animation = {
  timing100: '100ms',
  timing200: '200ms',
  timing300: '300ms',
  timing400: '400ms',
  timing500: '500ms',
  timing600: '600ms',
  timing700: '700ms',
  timing800: '800ms',
  timing900: '900ms',
  timing1000: '1000ms',
  easeInCurve: 'cubic-bezier(.8, .2, .6, 1)',
  easeOutCurve: 'cubic-bezier(.2, .8, .4, 1)',
  easeInOutCurve: 'cubic-bezier(0.4, 0, 0.2, 1)',
  easeInQuinticCurve: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
  easeOutQuinticCurve: 'cubic-bezier(0.23, 1, 0.32, 1)',
  easeInOutQuinticCurve: 'cubic-bezier(0.86, 0, 0.07, 1)',
  linearCurve: 'cubic-bezier(0, 0, 1, 1)'
};
var animation$1 = animation;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var breakpoints = {
  small: 320,
  medium: 600,
  large: 1136
};
var breakpoints$1 = breakpoints;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var grid = {
  columns: [4, 8, 12],
  gutters: [16, 36, 36],
  margins: [16, 36, 64],
  gaps: 0,
  unit: 'px',
  maxWidth: 1280
};
var grid$1 = grid;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/**
 * Helper function that generates media queries based on breakpoint, e.g.
 * getMediaQuery(720) => '@media screen and (min-width: 720px)'
 */
var getMediaQuery = function getMediaQuery(breakpoint) {
  return "@media screen and (min-width: ".concat(breakpoint, "px)");
};
var getMediaQueries = function getMediaQueries(breakpoints) {
  return Object.keys(breakpoints).map(function (key) {
    return breakpoints[key];
  }).sort(function (a, b) {
    return a - b;
  }).map(getMediaQuery);
};

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var mediaQuery = {
  small: getMediaQuery(breakpoints$1.small),
  medium: getMediaQuery(breakpoints$1.medium),
  large: getMediaQuery(breakpoints$1.large)
};
var mediaQuery$1 = mediaQuery;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var sizing$1 = {
  scale0: '2px',
  scale100: '4px',
  scale200: '6px',
  scale300: '8px',
  scale400: '10px',
  scale500: '12px',
  scale550: '14px',
  scale600: '16px',
  scale650: '18px',
  scale700: '20px',
  scale750: '22px',
  scale800: '24px',
  scale850: '28px',
  scale900: '32px',
  scale950: '36px',
  scale1000: '40px',
  scale1200: '48px',
  scale1400: '56px',
  scale1600: '64px',
  scale2400: '96px',
  scale3200: '128px',
  scale4800: '192px'
};
var sizing$2 = sizing$1;

function ownKeys$1d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1d(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1d(Object(source), true).forEach(function (key) { _defineProperty$1G(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1G(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var LightTheme$1 = {
  name: 'light-theme',
  colors: _objectSpread$1d(_objectSpread$1d(_objectSpread$1d(_objectSpread$1d({}, colorTokens$2), getComponentColorTokens()), getDeprecatedSemanticColorTokens()), getSemanticColorTokens()),
  animation: animation$1,
  breakpoints: breakpoints$1,
  borders: borders$1,
  direction: 'auto',
  grid: grid$1,
  lighting: lighting$1,
  mediaQuery: mediaQuery$1,
  sizing: sizing$2,
  typography: getTypography(),
  // TODO(#2318) Remove it in the next v11 major version.
  // Do not use.
  zIndex: {
    modal: 2000
  }
};

function _typeof$Q(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$Q = function _typeof(obj) { return typeof obj; }; } else { _typeof$Q = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$Q(obj); }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* flowlint unclear-type:off */
function deepMerge(target) {
  target = target || {};
  var len = arguments.length <= 1 ? 0 : arguments.length - 1;
  var obj;
  var value;

  for (var i = 0; i < len; i++) {
    obj = (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) || {};

    for (var key in obj) {
      if (_typeof$Q(obj[key]) !== undefined) {
        value = obj[key];

        if (isCloneable(value)) {
          target[key] = deepMerge(
          /* eslint-disable-next-line no-mixed-operators */
          target[key] || Array.isArray(value) && [] || {}, value);
        } else {
          target[key] = value;
        }
      }
    }
  }

  return target;
}
/* flowlint unclear-type:error */

/* eslint-disable-next-line flowtype/no-weak-types */

function isCloneable(obj) {
  /* eslint-disable-next-line eqeqeq */
  return Array.isArray(obj) || {}.toString.call(obj) == '[object Object]';
}

function ownKeys$1c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1c(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1c(Object(source), true).forEach(function (key) { _defineProperty$1F(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1F(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties$W(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$Y(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$Y(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function createLightTheme() {
  var primitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var // Used to override default theme property values derived from primitives
  overrides = arguments.length > 1 ? arguments[1] : undefined;

  // Extract font tokens and color tokens from primitives
  var primaryFontFamily = primitives.primaryFontFamily,
      customColorTokens = _objectWithoutProperties$W(primitives, ["primaryFontFamily"]); // Assemble color tokens by overriding defaults with custom color tokens


  var colorTokens = _objectSpread$1c(_objectSpread$1c({}, colorTokens$2), customColorTokens);

  var theme = {
    animation: animation$1,
    borders: borders$1,
    breakpoints: breakpoints$1,
    colors: _objectSpread$1c(_objectSpread$1c(_objectSpread$1c(_objectSpread$1c({}, colorTokens), getComponentColorTokens(colorTokens)), getDeprecatedSemanticColorTokens(colorTokens)), getSemanticColorTokens(colorTokens)),
    direction: 'auto',
    grid: grid$1,
    lighting: lighting$1,
    mediaQuery: mediaQuery$1,
    sizing: sizing$2,
    // If primaryFontFamily is not provided, we use our default font tokens
    typography: primaryFontFamily ? getTypography({
      primaryFontFamily: primaryFontFamily
    }) : getTypography(),
    // TODO(#2318) Remove in v11, the next major version.
    // Do not use.
    zIndex: {
      modal: 2000
    }
  };
  return deepMerge(theme, overrides);
}

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var ThemeContext = /*#__PURE__*/React$2.createContext(LightTheme$1);

var ThemeProvider = function ThemeProvider(props) {
  var theme = props.theme,
      children = props.children;
  return /*#__PURE__*/React$2.createElement(ThemeContext.Provider, {
    value: theme
  }, children);
};

var ThemeProvider$1 = ThemeProvider;

function ownKeys$1b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1b(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1b(Object(source), true).forEach(function (key) { _defineProperty$1E(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1E(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$1e(arr, i) { return _arrayWithHoles$1e(arr) || _iterableToArrayLimit$1e(arr, i) || _unsupportedIterableToArray$1g(arr, i) || _nonIterableRest$1e(); }

function _nonIterableRest$1e() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1g(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1g(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1g(o, minLen); }

function _arrayLikeToArray$1g(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1e(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1e(arr) { if (Array.isArray(arr)) return arr; }

function _extends$1w() { _extends$1w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1w.apply(this, arguments); }

var wrapper = function wrapper(StyledComponent) {
  // eslint-disable-next-line react/display-name
  return /*#__PURE__*/React$2.forwardRef(function (props, ref) {
    return /*#__PURE__*/React$2.createElement(ThemeContext.Consumer, null, function (theme) {
      return /*#__PURE__*/React$2.createElement(StyledComponent, _extends$1w({
        ref: ref
      }, props, {
        $theme: theme
      }));
    });
  });
};
/* eslint-disable flowtype/generic-spacing */

/* flowlint unclear-type:off */


/* eslint-enable flowtype/generic-spacing */

/* flowlint unclear-type:error */
function createThemedStyled() {
  return createStyled({
    wrapper: wrapper,
    getInitialStyle: getInitialStyle,
    driver: driver // flowlint-next-line unclear-type:off

  });
}
var styled = createThemedStyled();
function createThemedWithStyle() {
  // flowlint-next-line unclear-type:off
  return withStyle$1;
}
var withStyle = createThemedWithStyle();
function createThemedUseStyletron() {
  return function () {
    // flowlint-next-line unclear-type:off
    var theme = React$2.useContext(ThemeContext);

    var _styletronUseStyletro = useStyletron$1(),
        _styletronUseStyletro2 = _slicedToArray$1e(_styletronUseStyletro, 1),
        css = _styletronUseStyletro2[0];

    return [css, theme];
  };
}
var useStyletron = createThemedUseStyletron();
function withWrapper( // flowlint-next-line unclear-type:off
StyledElement, wrapperFn) {
  // flowlint-next-line unclear-type:off
  return withWrapper$1(StyledElement, function (Styled) {
    // eslint-disable-next-line react/display-name
    return /*#__PURE__*/React$2.forwardRef(function (props, ref) {
      return /*#__PURE__*/React$2.createElement(ThemeContext.Consumer, null, function (theme) {
        return wrapperFn(Styled)(_objectSpread$1b(_objectSpread$1b({
          ref: ref
        }, props), {}, {
          $theme: theme
        }));
      });
    });
  });
}

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var locale$c = {
  collapse: 'Collapse',
  expand: 'Expand'
};
var accordion = locale$c;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var locale$b = {
  ariaLabel: 'Breadcrumbs navigation'
};
var breadcrumbs = locale$b;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var locale$a = {
  ariaLabel: 'Select a date.',
  ariaLabelRange: 'Select a date range.',
  ariaLabelCalendar: 'Calendar.',
  ariaRoleDescriptionCalendarMonth: 'Calendar month',
  previousMonth: 'Previous month.',
  nextMonth: 'Next month.',
  pastWeek: 'Past Week',
  pastMonth: 'Past Month',
  pastThreeMonths: 'Past 3 Months',
  pastSixMonths: 'Past 6 Months',
  pastYear: 'Past Year',
  pastTwoYears: 'Past 2 Years',
  screenReaderMessageInput: 'Press the down arrow key to interact with the calendar and select a date. Press the escape button to close the calendar.',
  selectedDate: 'Selected date is ${date}.',
  selectedDateRange: 'Selected date range is from ${startDate} to ${endDate}.',
  selectSecondDatePrompt: 'Select the second date.',
  quickSelectLabel: 'Choose a date range',
  quickSelectAriaLabel: 'Choose a date range',
  quickSelectPlaceholder: 'None',
  timeSelectEndLabel: 'End time',
  timeSelectStartLabel: 'Start time',
  timePickerAriaLabel12Hour: 'Select a time, 12-hour format.',
  timePickerAriaLabel24Hour: 'Select a time, 24-hour format.',
  timezonePickerAriaLabel: 'Select a timezone.',
  selectedStartDateLabel: 'Selected start date.',
  selectedEndDateLabel: 'Selected end date.',
  dateNotAvailableLabel: 'Not available.',
  dateAvailableLabel: "It's available.",
  selectedLabel: 'Selected.',
  chooseLabel: 'Choose'
};
var datepicker = locale$a;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var locale$9 = {
  emptyState: 'No rows match the filter criteria defined. Please remove one or more filters to view more data.',
  loadingState: 'Loading rows.',
  searchAriaLabel: 'Search by text',
  filterAdd: 'Add Filter',
  filterExclude: 'Exclude',
  filterApply: 'Apply',
  filterExcludeRange: 'Exclude range',
  filterExcludeValue: 'Exclude value',
  filterAppliedTo: 'filter applied to',
  optionsLabel: 'Select column to filter by',
  optionsSearch: 'Search for a column to filter by...',
  optionsEmpty: 'No columns available.',
  categoricalFilterSelectAll: 'Select All',
  categoricalFilterSelectClear: 'Clear',
  categoricalFilterEmpty: 'No categories found',
  datetimeFilterRange: 'Range',
  datetimeFilterRangeDatetime: 'Date, Time',
  datetimeFilterRangeDate: 'Date',
  datetimeFilterRangeTime: 'Time',
  datetimeFilterCategorical: 'Categorical',
  datetimeFilterCategoricalWeekday: 'Weekday',
  datetimeFilterCategoricalMonth: 'Month',
  datetimeFilterCategoricalQuarter: 'Quarter',
  datetimeFilterCategoricalHalf: 'Half',
  datetimeFilterCategoricalFirstHalf: 'H1',
  datetimeFilterCategoricalSecondHalf: 'H2',
  datetimeFilterCategoricalYear: 'Year',
  numericalFilterRange: 'Range',
  numericalFilterSingleValue: 'Single Value',
  booleanFilterTrue: 'true',
  booleanFilterFalse: 'false',
  booleanColumnTrueShort: 'T',
  booleanColumnFalseShort: 'F'
};
var datatable = locale$9;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var locale$8 = {
  ariaLabel: 'button group'
};
var buttongroup = locale$8;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var locale$7 = {
  dropFilesToUpload: 'Drop files here to upload...',
  or: '',
  browseFiles: 'Browse files',
  retry: 'Retry Upload',
  cancel: 'Cancel'
};
var fileuploader = locale$7;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var locale$6 = {
  noResultsMsg: 'No results',
  parentMenuItemAriaLabel: "You are currently at an item that opens a nested listbox. Press right arrow to enter that element and left arrow to return."
};
var menu = locale$6;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var locale$5 = {
  close: 'Close'
};
var modal = locale$5;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var locale$4 = {
  close: 'Close'
};
var drawer = locale$4;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var locale$3 = {
  prev: 'Prev',
  next: 'Next',
  preposition: 'of'
};
var pagination = locale$3;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var locale$2 = {
  // Remove noResultsMsg prop in the next major version
  noResultsMsg: 'No results found',
  placeholder: 'Select...',
  create: 'Create'
};
var select = locale$2;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var locale$1 = {
  close: 'Close'
};
var toast = locale$1;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var en_US = {
  accordion: accordion,
  breadcrumbs: breadcrumbs,
  datepicker: datepicker,
  datatable: datatable,
  buttongroup: buttongroup,
  fileuploader: fileuploader,
  menu: menu,
  modal: modal,
  drawer: drawer,
  pagination: pagination,
  select: select,
  toast: toast
};
var en_US$1 = en_US;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var LocaleContext = /*#__PURE__*/React$2.createContext(en_US$1);

/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */
var generateUID$1 = function () {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */
    var uid = function (item, index) {
        if (typeof item === 'number' ||
            typeof item === 'string') {
            return index ? "idx-" + index : "val-" + item;
        }
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};

var createSource = function (prefix) {
    if (prefix === void 0) { prefix = ''; }
    return ({
        value: 1,
        prefix: prefix,
        uid: generateUID$1()
    });
};
var counter = createSource();
var source = React$2.createContext(createSource());
var getId = function (source) { return source.value++; };
var getPrefix = function (source) { return source ? source.prefix : ''; };

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

// --------------------------------------------
var prefixId = function (id, prefix, name) {
    var uid = (prefix + id);
    return String(name ? name(uid) : uid);
};
/**
 * @deprecated
 * UID in form of renderProps (not SSR friendly)
 * @see https://github.com/thearnica/react-uid#react-components
 * @example
 * // get UID to connect label to input
 * <UID>
 *   {(id)} => <label htmlFor={id}><input id={id}/>}
 * </UID>
 *
 * // get uid to generate uid for a keys in a list
 * <UID>
 *   {(, uid)} => items.map(item => <li key={uid(item) />)}
 * </UID>
 */
var UID = /** @class */ (function (_super) {
    __extends(UID, _super);
    function UID() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            quartz: _this.props.idSource || counter,
            prefix: getPrefix(_this.props.idSource),
            id: getId(_this.props.idSource || counter)
        };
        _this.uid = function (item) { return prefixId(_this.state.id + '-' + _this.state.quartz.uid(item), _this.state.prefix, _this.props.name); };
        return _this;
    }
    UID.prototype.render = function () {
        var _a = this.props, children = _a.children, name = _a.name;
        var _b = this.state, id = _b.id, prefix = _b.prefix;
        return children(prefixId(id, prefix, name), this.uid);
    };
    return UID;
}(React$2.Component));

/**
 * UID isolation component, required for SSR and testing.
 * Wrap your application with it to guarantee UID consistency between SSR and CSR.
 * @param {String} [prefix] - prefix for all generated ids
 * @example
 * <UIDReset>
 *    <App />
 * </UIDReset/>
 * @see https://github.com/thearnica/react-uid#server-side-friendly-uid
 */
var UIDReset = function (_a) {
    var children = _a.children, _b = _a.prefix, prefix = _b === void 0 ? '' : _b;
    return (React$2.createElement(source.Provider, { value: createSource(prefix) }, children));
};
/**
 * UID in form of renderProps. Supports nesting and SSR. Prefer {@link useUID} hook version if possible.
 * @see https://github.com/thearnica/react-uid#server-side-friendly-uid
 * @see https://github.com/thearnica/react-uid#react-components
 * @example
 * // get UID to connect label to input
 * <UIDConsumer>
 *   {(id)} => <label htmlFor={id}><input id={id}/>}
 * </UIDConsumer>
 *
 * // get uid to generate uid for a keys in a list
 * <UIDConsumer>
 *   {(, uid)} => items.map(item => <li key={uid(item) />)}
 * </UIDConsumer>
 *
 * @see {@link useUID} - a hook version of this component
 * @see {@link UID} - not SSR compatible version
 */
var UIDConsumer = function (_a) {
    var name = _a.name, children = _a.children;
    return (React$2.createElement(source.Consumer, null, function (value) { return (React$2.createElement(UID, { name: name, idSource: value, children: children })); }));
};

var generateUID = function (context) {
    var quartz = context || counter;
    var prefix = getPrefix(quartz);
    var id = getId(quartz);
    var uid = prefix + id;
    var gen = function (item) { return uid + quartz.uid(item); };
    return { uid: uid, gen: gen };
};
var useUIDState = function () {
    if (process.env.NODE_ENV !== "production") {
        if (!('useContext' in React$2)) {
            throw new Error('Hooks API requires React 16.8+');
        }
    }
    // @ts-ignore
    return React$2.useState(generateUID(React$2.useContext(source)));
};
/**
 * returns and unique id. SSR friendly
 * returns {String}
 * @see {@link UIDConsumer}
 * @see https://github.com/thearnica/react-uid#hooks-168
 * @example
 * const id = useUID();
 * id == 1; // for example
 */
var useUID = function () {
    var uid = useUIDState()[0].uid;
    return uid;
};
/**
 * returns an uid generator
 * @see {@link UIDConsumer}
 * @see https://github.com/thearnica/react-uid#hooks-168
 * @example
 * const uid = useUIDSeed();
 * return (
 *  <>
 *    <label for={seed('email')}>Email: </label>
 *    <input id={seed('email')} name="email" />
 *    {data.map(item => <div key={seed(item)}>...</div>
 *  </>
 * )
 */
var useUIDSeed = function () {
    var gen = useUIDState()[0].gen;
    return gen;
};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element$1=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element$1,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});
reactIs_development.AsyncMode;
reactIs_development.ConcurrentMode;
reactIs_development.ContextConsumer;
reactIs_development.ContextProvider;
reactIs_development.Element;
reactIs_development.ForwardRef;
reactIs_development.Fragment;
reactIs_development.Lazy;
reactIs_development.Memo;
reactIs_development.Portal;
reactIs_development.Profiler;
reactIs_development.StrictMode;
reactIs_development.Suspense;
reactIs_development.isAsyncMode;
reactIs_development.isConcurrentMode;
reactIs_development.isContextConsumer;
reactIs_development.isContextProvider;
reactIs_development.isElement;
reactIs_development.isForwardRef;
reactIs_development.isFragment;
reactIs_development.isLazy;
reactIs_development.isMemo;
reactIs_development.isPortal;
reactIs_development.isProfiler;
reactIs_development.isStrictMode;
reactIs_development.isSuspense;
reactIs_development.isValidElementType;
reactIs_development.typeOf;

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});
var reactIs_1 = reactIs.isFragment;
var reactIs_2 = reactIs.isValidElementType;

function _extends$1v() { _extends$1v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1v.apply(this, arguments); }

function ownKeys$1a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1a(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1a(Object(source), true).forEach(function (key) { _defineProperty$1D(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1D(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof$P(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$P = function _typeof(obj) { return typeof obj; }; } else { _typeof$P = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$P(obj); }

/**
 * Given an override argument, returns the component implementation override if it exists
 */
// flowlint-next-line unclear-type:off
function getOverride(override) {
  if (reactIs_2(override)) {
    return override;
  } // Check if override is OverrideObjectT


  if (override && _typeof$P(override) === 'object') {
    // Remove this 'any' once this flow issue is fixed:
    // https://github.com/facebook/flow/issues/6666
    // flowlint-next-line unclear-type:off
    return override.component;
  } // null/undefined


  return override;
}
/**
 * Given an override argument, returns the override props that should be passed
 * to the component when rendering it.
 */

function getOverrideProps(override) {
  if (override && _typeof$P(override) === 'object') {
    if (_typeof$P(override.props) === 'object') {
      //$FlowFixMe
      return _objectSpread$1a(_objectSpread$1a({}, override.props), {}, {
        $style: override.style
      });
    } else {
      //$FlowFixMe
      return {
        $style: override.style
      };
    }
  } //$FlowFixMe


  return {};
}
/**
 * Coerces an override argument into an override object
 * (sometimes it is just an override component)
 */

function toObjectOverride(override) {
  if (reactIs_2(override)) {
    return {
      // flowlint-next-line unclear-type:off
      component: override
    };
  } // Flow can't figure out that typeof 'function' above will
  // catch React.StatelessFunctionalComponent
  // (probably related to https://github.com/facebook/flow/issues/6666)
  // flowlint-next-line unclear-type:off


  return override || {};
}
/**
 * Get a convenient override array that will always have [component, props]
 */

/* flowlint unclear-type:off */

function getOverrides(override, defaultComponent) {
  var Component = getOverride(override) || defaultComponent;

  if (override && _typeof$P(override) === 'object' && typeof override.props === 'function') {
    // TODO(v11)
    if (process.env.NODE_ENV !== "production") {
      console.warn('baseui:Overrides Props as a function will be removed in the next major version. Override the whole component instead. ' + 'See https://baseweb.design/guides/understanding-overrides/#override-the-entire-subcomponent');
    }

    var DynamicOverride = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
      var mappedProps = override.props(props);
      var nextProps = getOverrideProps(_objectSpread$1a(_objectSpread$1a({}, override), {}, {
        props: mappedProps
      }));
      return /*#__PURE__*/React$2.createElement(Component, _extends$1v({
        ref: ref
      }, nextProps));
    });
    DynamicOverride.displayName = Component.displayName; //$FlowFixMe

    return [DynamicOverride, {}];
  }

  var props = getOverrideProps(override);
  return [Component, props];
}
/* flowlint unclear-type:error */

/**
 * Merges two overrides objects – this is useful if you want to inject your own
 * overrides into a child component, but also accept further overrides from
 * from upstream. See `mergeOverride` below.
 */

function mergeOverrides() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var merged = Object.assign({}, target, source);
  var allIdentifiers = Object.keys(merged); // const allIdentifiers = Object.keys({...target, ...source});

  return allIdentifiers.reduce(function (acc, name) {
    acc[name] = mergeOverride(toObjectOverride(target[name]), toObjectOverride(source[name]));
    return acc;
  }, {});
}
/**
 * Merges two override objects using the following behavior:
 * - Component implementation from the source (parent) replaces target
 * - Props and styles are both deep merged
 */

function mergeOverride(target, source) {
  // Shallow merge should handle `component`
  var merged = _objectSpread$1a(_objectSpread$1a({}, target), source);

  if (target.props && source.props) {
    merged.props = mergeConfigurationOverrides(target.props, source.props);
  }

  if (target.style && source.style) {
    merged.style = mergeConfigurationOverrides(target.style, source.style);
  }

  return merged;
}
/**
 * Since style or props overrides can be an object *or* a function, we need to handle
 * the case that one of them is a function. We do this by returning a new
 * function that deep merges the result of each style override
 */

function mergeConfigurationOverrides(target, source) {
  // Simple case of both objects
  if (_typeof$P(target) === 'object' && _typeof$P(source) === 'object') {
    return deepMerge({}, target, source);
  } // At least one is a function, return a new composite function


  return function () {
    return deepMerge({}, typeof target === 'function' ? target.apply(void 0, arguments) : target, typeof source === 'function' ? source.apply(void 0, arguments) : source);
  };
} // Lil' hook for memoized unpacking of overrides

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// based on:
// - https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/utils/focusVisible.js
// - https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
var initialized = false;
var hadKeyboardEvent = true;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */

function focusTriggersKeyboardModality(node) {
  var type = node.type,
      tagName = node.tagName;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') ;
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
} //$FlowFixMe

function isFocusVisible(event) {
  try {
    return event.target.matches(':focus-visible');
  } catch (error) {// browsers not implementing :focus-visible will throw a SyntaxError
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
  } // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only


  return hadKeyboardEvent || focusTriggersKeyboardModality(event.target);
}

function initFocusVisible(node) {
  if (!initialized && node != null) {
    initialized = true;
    prepare(node.ownerDocument);
  }
}
var forkFocus = function forkFocus(rootProps, handler) {
  return function (e) {
    if (typeof rootProps.onFocus === 'function') {
      rootProps.onFocus(e);
    }

    handler(e);
  };
};
var forkBlur = function forkBlur(rootProps, handler) {
  return function (e) {
    if (typeof rootProps.onBlur === 'function') {
      rootProps.onBlur(e);
    }

    handler(e);
  };
};

function _typeof$O(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$O = function _typeof(obj) { return typeof obj; }; } else { _typeof$O = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$O(obj); }

function _extends$1u() { _extends$1u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1u.apply(this, arguments); }

function _slicedToArray$1d(arr, i) { return _arrayWithHoles$1d(arr) || _iterableToArrayLimit$1d(arr, i) || _unsupportedIterableToArray$1f(arr, i) || _nonIterableRest$1d(); }

function _nonIterableRest$1d() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit$1d(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1d(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray$c(arr) { return _arrayWithoutHoles$b(arr) || _iterableToArray$b(arr) || _unsupportedIterableToArray$1f(arr) || _nonIterableSpread$b(); }

function _nonIterableSpread$b() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1f(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1f(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1f(o, minLen); }

function _iterableToArray$b(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$b(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$1f(arr); }

function _arrayLikeToArray$1f(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck$N(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$L(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$M(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$L(Constructor.prototype, protoProps); if (staticProps) _defineProperties$L(Constructor, staticProps); return Constructor; }

function _inherits$M(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$N(subClass, superClass); }

function _setPrototypeOf$N(o, p) { _setPrototypeOf$N = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$N(o, p); }

function _createSuper$L(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$M(); return function _createSuperInternal() { var Super = _getPrototypeOf$M(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$M(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$M(this, result); }; }

function _possibleConstructorReturn$M(self, call) { if (call && (_typeof$O(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$O(self); }

function _assertThisInitialized$O(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$M() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$M(o) { _getPrototypeOf$M = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$M(o); }

function _defineProperty$1C(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var StyledAppContainer = styled('div', {});
StyledAppContainer.displayName = "StyledAppContainer";
var StyledLayersContainer = styled('div', {});
StyledLayersContainer.displayName = "StyledLayersContainer";

function defaultEventHandlerFn() {
  if (process.env.NODE_ENV !== "production") {
    console.warn('`LayersManager` was not found. This occurs if you are attempting to use a component requiring `Layer` without using the `BaseProvider` at the root of your app. Please visit https://baseweb.design/components/base-provider/ for more information');
  }
}

var LayersContext = /*#__PURE__*/React$2.createContext({
  addEscapeHandler: defaultEventHandlerFn,
  removeEscapeHandler: defaultEventHandlerFn,
  addDocClickHandler: defaultEventHandlerFn,
  removeDocClickHandler: defaultEventHandlerFn,
  host: undefined,
  zIndex: undefined
});
var Provider = LayersContext.Provider;
var Consumer = LayersContext.Consumer;

var LayersManager = /*#__PURE__*/function (_React$Component) {
  _inherits$M(LayersManager, _React$Component);

  var _super = _createSuper$L(LayersManager);

  function LayersManager(props) {
    var _this;

    _classCallCheck$N(this, LayersManager);

    _this = _super.call(this, props);

    _defineProperty$1C(_assertThisInitialized$O(_this), "host", /*#__PURE__*/React$2.createRef());

    _defineProperty$1C(_assertThisInitialized$O(_this), "containerRef", /*#__PURE__*/React$2.createRef());

    _defineProperty$1C(_assertThisInitialized$O(_this), "onDocumentClick", function (event) {
      var docClickHandler = _this.state.docClickHandlers[_this.state.docClickHandlers.length - 1];

      if (docClickHandler) {
        docClickHandler(event);
      }
    });

    _defineProperty$1C(_assertThisInitialized$O(_this), "onKeyUp", function (event) {
      if (event.key === 'Escape') {
        var escapeKeyHandler = _this.state.escapeKeyHandlers[_this.state.escapeKeyHandlers.length - 1];

        if (escapeKeyHandler) {
          escapeKeyHandler();
        }
      }
    });

    _defineProperty$1C(_assertThisInitialized$O(_this), "onAddEscapeHandler", function (escapeKeyHandler) {
      _this.setState(function (prev) {
        return {
          escapeKeyHandlers: [].concat(_toConsumableArray$c(prev.escapeKeyHandlers), [escapeKeyHandler])
        };
      });
    });

    _defineProperty$1C(_assertThisInitialized$O(_this), "onRemoveEscapeHandler", function (escapeKeyHandler) {
      _this.setState(function (prev) {
        return {
          escapeKeyHandlers: prev.escapeKeyHandlers.filter(function (handler) {
            return handler !== escapeKeyHandler;
          })
        };
      });
    });

    _defineProperty$1C(_assertThisInitialized$O(_this), "onAddDocClickHandler", function (docClickHandler) {
      _this.setState(function (prev) {
        return {
          docClickHandlers: [].concat(_toConsumableArray$c(prev.docClickHandlers), [docClickHandler])
        };
      });
    });

    _defineProperty$1C(_assertThisInitialized$O(_this), "onRemoveDocClickHandler", function (docClickHandler) {
      _this.setState(function (prev) {
        return {
          docClickHandlers: prev.docClickHandlers.filter(function (handler) {
            return handler !== docClickHandler;
          })
        };
      });
    });

    _this.state = {
      escapeKeyHandlers: [],
      docClickHandlers: []
    };
    return _this;
  }

  _createClass$M(LayersManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.forceUpdate();
      initFocusVisible(this.containerRef.current);

      if (typeof document !== 'undefined') {
        document.addEventListener('keyup', this.onKeyUp); // using mousedown event so that callback runs before events on children inside of the layer

        document.addEventListener('mousedown', this.onDocumentClick);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof document !== 'undefined') {
        document.removeEventListener('keyup', this.onKeyUp);
        document.removeEventListener('mousedown', this.onDocumentClick);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props$overrides = this.props.overrides,
          overrides = _this$props$overrides === void 0 ? {} : _this$props$overrides;

      var _getOverrides = getOverrides(overrides.AppContainer, StyledAppContainer),
          _getOverrides2 = _slicedToArray$1d(_getOverrides, 2),
          AppContainer = _getOverrides2[0],
          appContainerProps = _getOverrides2[1];

      var _getOverrides3 = getOverrides(overrides.LayersContainer, StyledLayersContainer),
          _getOverrides4 = _slicedToArray$1d(_getOverrides3, 2),
          LayersContainer = _getOverrides4[0],
          layersContainerProps = _getOverrides4[1];

      return /*#__PURE__*/React$2.createElement(Consumer, null, function (_ref) {
        var host = _ref.host;

        if (process.env.NODE_ENV !== "production") {
          if (host !== undefined) {
            // eslint-disable-next-line no-console
            console.warn('There is a LayersManager already exists in your application. It is not recommended to have more than one LayersManager in an application.');
          }
        }

        return /*#__PURE__*/React$2.createElement(Provider, {
          value: {
            host: host || _this2.host.current,
            zIndex: _this2.props.zIndex,
            addEscapeHandler: _this2.onAddEscapeHandler,
            removeEscapeHandler: _this2.onRemoveEscapeHandler,
            addDocClickHandler: _this2.onAddDocClickHandler,
            removeDocClickHandler: _this2.onRemoveDocClickHandler
          }
        }, /*#__PURE__*/React$2.createElement(AppContainer, _extends$1u({}, appContainerProps, {
          ref: _this2.containerRef
        }), _this2.props.children), /*#__PURE__*/React$2.createElement(LayersContainer, _extends$1u({}, layersContainerProps, {
          ref: _this2.host
        })));
      });
    }
  }]);

  return LayersManager;
}(React$2.Component);

function _typeof$N(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$N = function _typeof(obj) { return typeof obj; }; } else { _typeof$N = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$N(obj); }

function _extends$1t() { _extends$1t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1t.apply(this, arguments); }

function _classCallCheck$M(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$K(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$L(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$K(Constructor.prototype, protoProps); if (staticProps) _defineProperties$K(Constructor, staticProps); return Constructor; }

function _inherits$L(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$M(subClass, superClass); }

function _setPrototypeOf$M(o, p) { _setPrototypeOf$M = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$M(o, p); }

function _createSuper$K(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$L(); return function _createSuperInternal() { var Super = _getPrototypeOf$L(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$L(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$L(this, result); }; }

function _possibleConstructorReturn$L(self, call) { if (call && (_typeof$N(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$N(self); }

function _assertThisInitialized$N(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$L() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$L(o) { _getPrototypeOf$L = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$L(o); }

function _defineProperty$1B(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Container$1 = styled('div', function (_ref) {
  var $zIndex = _ref.$zIndex;
  return {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: $zIndex || null
  };
});
Container$1.displayName = "Container";

var LayerComponent = /*#__PURE__*/function (_React$Component) {
  _inherits$L(LayerComponent, _React$Component);

  var _super = _createSuper$K(LayerComponent);

  function LayerComponent() {
    var _this;

    _classCallCheck$M(this, LayerComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1B(_assertThisInitialized$N(_this), "state", {
      container: null
    });

    _defineProperty$1B(_assertThisInitialized$N(_this), "onEscape", function () {
      if (_this.props.onEscape) {
        _this.props.onEscape();
      }
    });

    _defineProperty$1B(_assertThisInitialized$N(_this), "onDocumentClick", function (event) {
      if (_this.props.onDocumentClick) {
        _this.props.onDocumentClick(event);
      }
    });

    return _this;
  }

  _createClass$L(LayerComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.context.addEscapeHandler(this.onEscape);

      if (!this.props.isHoverLayer) {
        this.context.addDocClickHandler(this.onDocumentClick);
      }

      var _this$props = this.props,
          onMount = _this$props.onMount,
          mountNode = _this$props.mountNode,
          layersManagerHost = _this$props.host;

      if (mountNode) {
        onMount && onMount();
        return;
      } // There was no LayersManager added if this.props.host === undefined.
      // Use document.body is the case no LayersManager is used.


      var hasLayersManager = layersManagerHost !== undefined;

      if (process.env.NODE_ENV !== "production") {
        if (!hasLayersManager) {
          console.warn('`LayersManager` was not found. This occurs if you are attempting to use a component requiring `Layer` without using the `BaseProvider` at the root of your app. Please visit https://baseweb.design/components/base-provider/ for more information');
        }
      }

      var host = hasLayersManager ? layersManagerHost : document.body;

      if (host) {
        this.addContainer(host);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          host = _this$props2.host,
          mountNode = _this$props2.mountNode;

      if (mountNode) {
        return;
      }

      if (host && host !== prevProps.host && prevProps.host === null) {
        this.addContainer(host);
      }

      if (prevProps.isHoverLayer != this.props.isHoverLayer) {
        if (this.props.isHoverLayer) {
          this.context.removeDocClickHandler(this.onDocumentClick);
        } else {
          this.context.addDocClickHandler(this.onDocumentClick);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.context.removeEscapeHandler(this.onEscape);
      this.context.removeDocClickHandler(this.onDocumentClick);

      if (this.props.onUnmount) {
        this.props.onUnmount();
      }

      var host = this.props.host;
      var container = this.state.container;

      if (host && container) {
        if (host.contains(container)) {
          host.removeChild(container);
        }
      }
    }
  }, {
    key: "addContainer",
    value: function addContainer(host) {
      var _this$props3 = this.props,
          index = _this$props3.index,
          mountNode = _this$props3.mountNode,
          onMount = _this$props3.onMount; // Do nothing if mountNode is provided

      if (mountNode) {
        return;
      }

      if (host) {
        var container = host.ownerDocument.createElement('div'); // `host` is an DOM node, but not a React component

        var sibling = typeof index === 'number' ? host.children[index] : null;
        sibling ? host.insertBefore(container, sibling) : host.appendChild(container);
        this.setState({
          container: container
        }, function () {
          onMount && onMount();
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var container = this.state.container;
      var _this$props4 = this.props,
          children = _this$props4.children,
          mountNode = _this$props4.mountNode,
          zIndex = _this$props4.zIndex; // Only adding an additional wrapper when a layer has z-index to be set

      var childrenToRender = zIndex ? /*#__PURE__*/React$2.createElement(Container$1, {
        $zIndex: zIndex
      }, children) : children;

      if (typeof document !== 'undefined') {
        var portalContainer = mountNode || container;

        if (portalContainer) {
          return /*#__PURE__*/ReactDOM.createPortal(childrenToRender, portalContainer);
        }

        return null;
      }

      return null;
    }
  }]);

  return LayerComponent;
}(React$2.Component);

_defineProperty$1B(LayerComponent, "contextType", LayersContext);

function Layer(props) {
  return /*#__PURE__*/React$2.createElement(Consumer, null, function (_ref2) {
    var host = _ref2.host,
        zIndex = _ref2.zIndex;
    return /*#__PURE__*/React$2.createElement(LayerComponent, _extends$1t({}, props, {
      host: host,
      zIndex: zIndex
    }));
  });
}

/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction$2(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends$1s = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends$1s({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed$1(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed$1(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed$1(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends$1s({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex$1(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex$1(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction$2(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends$1s({}, attributes, data.attributes);
  data.styles = _extends$1s({}, styles, data.styles);
  data.arrowStyles = _extends$1s({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends$1s({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends$1s({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends$1s({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends$1s({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends$1s({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends$1s({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends$1s({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction$2(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

var Popper$1 = Popper;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function toPopperPlacement(placement) {
  return placement.replace(/(Top|Left)$/, '-start').replace(/(Right|Bottom)$/, '-end');
}
/**
 * Takes the offset passed from popper.js and normalizes it
 */

function parsePopperOffset(offset) {
  return {
    top: Math.floor(offset.top || 0),
    left: Math.floor(offset.left || 0)
  };
}

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var TETHER_PLACEMENT = {
  auto: 'auto',
  topLeft: 'topLeft',
  top: 'top',
  topRight: 'topRight',
  rightTop: 'rightTop',
  right: 'right',
  rightBottom: 'rightBottom',
  bottomRight: 'bottomRight',
  bottom: 'bottom',
  bottomLeft: 'bottomLeft',
  leftBottom: 'leftBottom',
  left: 'left',
  leftTop: 'leftTop'
};

function _typeof$M(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$M = function _typeof(obj) { return typeof obj; }; } else { _typeof$M = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$M(obj); }

function ownKeys$19(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$19(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$19(Object(source), true).forEach(function (key) { _defineProperty$1A(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$19(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties$V(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$X(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$X(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$L(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$J(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$K(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$J(Constructor.prototype, protoProps); if (staticProps) _defineProperties$J(Constructor, staticProps); return Constructor; }

function _inherits$K(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$L(subClass, superClass); }

function _setPrototypeOf$L(o, p) { _setPrototypeOf$L = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$L(o, p); }

function _createSuper$J(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$K(); return function _createSuperInternal() { var Super = _getPrototypeOf$K(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$K(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$K(this, result); }; }

function _possibleConstructorReturn$K(self, call) { if (call && (_typeof$M(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$M(self); }

function _assertThisInitialized$M(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$K() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$K(o) { _getPrototypeOf$K = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$K(o); }

function _defineProperty$1A(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Tether = /*#__PURE__*/function (_React$Component) {
  _inherits$K(Tether, _React$Component);

  var _super = _createSuper$J(Tether);

  function Tether() {
    var _this;

    _classCallCheck$L(this, Tether);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1A(_assertThisInitialized$M(_this), "popper", void 0);

    _defineProperty$1A(_assertThisInitialized$M(_this), "popperHeight", 0);

    _defineProperty$1A(_assertThisInitialized$M(_this), "popperWidth", 0);

    _defineProperty$1A(_assertThisInitialized$M(_this), "anchorHeight", 0);

    _defineProperty$1A(_assertThisInitialized$M(_this), "anchorWidth", 0);

    _defineProperty$1A(_assertThisInitialized$M(_this), "state", {
      isMounted: false
    });

    _defineProperty$1A(_assertThisInitialized$M(_this), "onPopperUpdate", function (data) {
      var normalizedOffsets = {
        popper: parsePopperOffset(data.offsets.popper),
        arrow: data.offsets.arrow ? parsePopperOffset(data.offsets.arrow) : {
          top: 0,
          left: 0
        }
      };

      _this.props.onPopperUpdate(normalizedOffsets, data);
    });

    return _this;
  }

  _createClass$K(Tether, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        isMounted: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // Handles the case where popover content changes size and creates a gap between the anchor and
      // the popover. Popper.js only schedules updates on resize and scroll events. In the case of
      // the Select component, when options were filtered in the dropdown menu it creates a gap
      // between it and the input element.
      if (this.props.anchorRef) {
        var _this$props$anchorRef = this.props.anchorRef.getBoundingClientRect(),
            height = _this$props$anchorRef.height,
            width = _this$props$anchorRef.width;

        if (this.anchorHeight !== height || this.anchorWidth !== width) {
          this.anchorHeight = height;
          this.anchorWidth = width;
          this.popper && this.popper.scheduleUpdate();
        }
      }

      if (this.props.popperRef) {
        var _this$props$popperRef = this.props.popperRef.getBoundingClientRect(),
            _height = _this$props$popperRef.height,
            _width = _this$props$popperRef.width;

        if (this.popperHeight !== _height || this.popperWidth !== _width) {
          this.popperHeight = _height;
          this.popperWidth = _width;
          this.popper && this.popper.scheduleUpdate();
        }

        if (this.state.isMounted !== prevState.isMounted) {
          if (!this.props.anchorRef) {
            if (process.env.NODE_ENV !== "production") {
              // eslint-disable-next-line no-console
              console.warn("[baseui][TetherBehavior] ref has not been passed to the Popper's anchor element.\n              See how to pass the ref to an anchor element in the Popover example\n              http://baseui.design/components/popover#anchor-ref-handling-example");
            }
          } else {
            this.initializePopper();
          }
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyPopover();
    }
  }, {
    key: "initializePopper",
    value: function initializePopper() {
      var _this$props = this.props,
          placement = _this$props.placement,
          popperOptions = _this$props.popperOptions;

      var modifiers = popperOptions.modifiers,
          restOptions = _objectWithoutProperties$V(popperOptions, ["modifiers"]);

      if (!this.props.anchorRef || !this.props.popperRef) return;
      this.popper = new Popper$1(this.props.anchorRef, this.props.popperRef, _objectSpread$19({
        // Recommended placement (popper may ignore if it causes a viewport overflow, etc)
        placement: toPopperPlacement(placement),
        modifiers: _objectSpread$19({
          // Passing the arrow ref will measure the arrow when calculating styles
          arrow: {
            element: this.props.arrowRef,
            enabled: !!this.props.arrowRef
          },
          computeStyle: {
            // Make popper use top/left instead of transform translate, this is because
            // we use transform for animations and we dont want them to conflict
            gpuAcceleration: false
          },
          applyStyle: {
            // Disable default styling modifier, we'll apply styles on our own
            enabled: false
          },
          applyReactStyle: {
            enabled: true,
            fn: this.onPopperUpdate,
            order: 900
          },
          preventOverflow: {
            enabled: true
          }
        }, modifiers)
      }, restOptions));
    }
  }, {
    key: "destroyPopover",
    value: function destroyPopover() {
      if (this.popper) {
        this.popper.destroy();
        delete this.popper;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return Tether;
}(React$2.Component);

_defineProperty$1A(Tether, "defaultProps", {
  anchorRef: null,
  onPopperUpdate: function onPopperUpdate() {
    return null;
  },
  placement: TETHER_PLACEMENT.auto,
  popperRef: null,
  popperOptions: {}
});

var TetherBehavior = Tether;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

var BaseProvider = function BaseProvider(props) {
  var children = props.children,
      overrides = props.overrides,
      theme = props.theme,
      zIndex = props.zIndex;
  return /*#__PURE__*/React$2.createElement(LayersManager, {
    zIndex: zIndex,
    overrides: overrides
  }, /*#__PURE__*/React$2.createElement(UIDReset, {
    prefix: "bui"
  }, /*#__PURE__*/React$2.createElement(ThemeProvider$1, {
    theme: theme
  }, children)));
};

var BaseProvider$1 = BaseProvider;

var breakpoint = {
	"x-large": "1280px",
	large: "880px"
};
var spacing = {
	"xxxx-small": "2px",
	"xxx-small": "4px",
	"xx-small": "8px",
	"x-small": "12px",
	small: "16px",
	large: "24px",
	"x-large": "32px",
	"xx-large": "48px",
	"xxx-large": "96px"
};
var opacity$1 = {
	disabled: "0.2",
	high: "0.4",
	medium: "0.6",
	low: "0.8"
};
var color = {
	"brand-primary-150": "#B63225",
	"brand-primary-125": "#D14334",
	"brand-primary": "#FF5B4A",
	"brand-primary-75": "#EE7562",
	"brand-primary-50": "#F09286",
	"brand-primary-25": "#F3B0A8",
	"brand-primary-10": "#FADFDE",
	"neutral-100": "#000000",
	"neutral-75": "#4F4F4F",
	"neutral-50": "#767676",
	"neutral-25": "#E0E0E0",
	"neutral-10": "#F9F9F9",
	"neutral-0": "#FFFFFF",
	"status-success-100": "#138810",
	"status-success-25": "#E6F2ED",
	"status-warning-100": "#FFCA62",
	"status-danger-100": "#BB5500",
	"status-danger-25": "#F3DDCB",
	"brand-secondary-1-125": "#2F63D7",
	"brand-secondary-1-100": "#1669FF",
	"brand-secondary-1-75": "#4179F6",
	"brand-secondary-1-50": "#6997F7",
	"brand-secondary-1-25": "#92B4F6",
	"brand-secondary-1-10": "#D5E1FC",
	"brand-secondary-2-125": "#7030EC",
	"brand-secondary-2-100": "#7E3BFF",
	"brand-secondary-2-75": "#8259F6",
	"brand-secondary-2-50": "#9C7CF7",
	"brand-secondary-2-25": "#B9A0F8",
	"brand-secondary-2-10": "#E2D9FB",
	"brand-secondary-3-125": "#E49100",
	"brand-secondary-3-100": "#FFA200",
	"brand-secondary-3-75": "#F2AE43",
	"brand-secondary-3-50": "#F5BF63",
	"brand-secondary-3-25": "#F8D18B",
	"brand-secondary-3-10": "#FCECD0",
	"brand-secondary-4-125": "#028C65",
	"brand-secondary-4-100": "#00A576",
	"brand-secondary-4-75": "#51AB87",
	"brand-secondary-4-50": "#6DBDA1",
	"brand-secondary-4-25": "#93D0BC",
	"brand-secondary-4-10": "#D1EDE4",
	"dataviz-1-100": "#042E8B",
	"dataviz-1-75": "#2B59BF",
	"dataviz-1-50": "#7290CF",
	"dataviz-1-25": "#A4B7DA",
	"dataviz-1-10": "#D0D7E6",
	"neutral-100-opacity-low": "rgba(0, 0, 0, 0.8)"
};
var body = {
	"font-family": "font-family.text",
	"font-size": "font-size.root",
	"font-weight": "font-weight.regular",
	"line-height": "line-height.body",
	color: "color.neutral-75"
};
var h1 = {
	"font-family": "font-family.heading",
	"font-size": "font-size.x-large",
	"font-weight": "font-weight.heavy",
	"line-height": "line-height.h1",
	color: "color.neutral-100"
};
var h2 = {
	"font-family": "font-family.heading",
	"font-size": "font-size.large",
	"font-weight": "font-weight.heavy",
	"line-height": "line-height.h2",
	color: "color.neutral-100"
};
var h3 = {
	"font-family": "font-family.heading",
	"font-size": "font-size.medium",
	"font-weight": "font-weight.heavy",
	"line-height": "line-height.h3",
	color: "color.neutral-100"
};
var h4 = {
	"font-family": "font-family.heading",
	"font-size": "font-size.root",
	"font-weight": "font-weight.heavy",
	"line-height": "line-height.h4",
	color: "color.neutral-100"
};
var hyperlink = {
	"font-family": "font-family.text",
	"font-size": "font-size.root",
	"font-weight": "font-weight.regular",
	"line-height": "line-height.body",
	color: "color.brand-primary-125",
	"text-decoration": "underline"
};
var label = {
	"font-family": "font-family.heading",
	"font-size": "font-size.root",
	"font-weight": "font-weight.regular",
	"line-height": "line-height.label",
	color: "color.neutral-100"
};
var width = {
	"large-main": "100%",
	"x-large-main": "84%",
	"x-large-margin": "8%",
	"main-right-expanded": "67.2%",
	"main-both-expanded": "53%",
	"left-drawer-collapsed": "5.8%",
	"left-drawer-expanded": "20%",
	"right-drawer-expanded": "27%"
};
var tokens$1 = {
	breakpoint: breakpoint,
	"corner-radius": {
	sharp: "0",
	"semi-sharp": "4px",
	"default": "8px",
	smooth: "24px",
	pill: "20rem"
},
	spacing: spacing,
	opacity: opacity$1,
	color: color,
	"box-shadow": {
	card: "0.0px 1.0px 10.0px 0px rgba(79, 79, 79, 0.12),0.0px 4.0px 12.0px 0px rgba(79, 79, 79, 0.12),0.0px 0.0px 2.0px 0px rgba(0, 0, 0, 0.12)",
	"card-light": "0px 0px 46px rgba(79, 79, 79, 0.12);",
	layout: "0px 0px 2px rgba(0, 0, 0, 0.24);",
	overlay: "0px 32px 56px rgba(0, 0, 0, 0.04), 0px 4px 24px rgba(0, 0, 0, 0.1), 0px 11px 32px rgba(0, 0, 0, 0.06)",
	focus: "0px 0px 0px 2px #F09286, 0px 4px 12px rgba(0, 0, 0, 0.16), 0px 20px 36px rgba(243, 176, 168, 0.24)",
	"card-hover": "0px 4px 12px rgba(0, 0, 0, 0.16),0px 20px 36px rgba(232, 230, 230, 0.24),0px 8px 32px rgba(79, 79, 79, 0.12)",
	"map-object": "0px 4px 20px rgba(0, 0, 0, 0.16)",
	"map-object-selected": "0px 4px 20px rgba(74, 74, 74, 0.25), 0px 4px 10px rgba(74, 74, 74, 0.25)",
	"dataviz-hover": "0px 10px 20px rgba(74, 74, 74, 0.25), 0px 5px 10px rgba(74, 74, 74, 0.25)"
},
	"font-family": {
	heading: "proxima-nova, Helvetica, San-Serif",
	text: "P22-mackinac-pro, Georgia, Serif"
},
	"font-weight": {
	heavy: "800",
	bold: "700",
	regular: "500"
},
	"font-size": {
	"xxxx-large": "72px",
	"xxx-large": "48px",
	"xx-large": "36px",
	"x-large": "28px",
	large: "24px",
	medium: "20px",
	root: "16px",
	small: "12px",
	"x-small": "10px"
},
	"line-height": {
	"display-4": "44px",
	h1: "36px",
	h2: "28px",
	h3: "26px",
	h4: "20px",
	"subhead-1": "28px",
	"subhead-2": "24px",
	"subhead-3": "20px",
	"subhead-4": "16px",
	body: "24px",
	"body-small": "20px",
	"label-large": "24px",
	label: "20px",
	"label-small": "16px",
	"label-small-tight": "12px",
	"label-tight": "16px"
},
	body: body,
	"body-bold": {
	"font-family": "font-family.text",
	"font-size": "font-size.root",
	"font-weight": "font-weight.bold",
	"line-height": "line-height.body",
	color: "color.neutral-75"
},
	"body-small-": {
	"font-family": "font-family.text",
	"font-size": "font-size.small",
	"font-weight": "font-weight.regular",
	"line-height": "line-height.body",
	color: "color.neutral-75"
},
	"body-small-bold": {
	"font-family": "font-family.text",
	"font-size": "font-size.small",
	"font-weight": "font-weight.bold",
	"line-height": "line-height.body",
	color: "color.neutral-75"
},
	h1: h1,
	h2: h2,
	h3: h3,
	h4: h4,
	"subhead-1": {
	"font-family": "font-family.heading",
	"font-size": "font-size.large",
	"font-weight": "font-weight.bold",
	"line-height": "line-height.subhead-1",
	color: "color.neutral-100"
},
	"subhead-2": {
	"font-family": "font-family.heading",
	"font-size": "font-size.medium",
	"font-weight": "font-weight.bold",
	"line-height": "line-height.subhead-2",
	color: "color.neutral-100"
},
	"subhead-3": {
	"font-family": "font-family.heading",
	"font-size": "font-size.root",
	"font-weight": "font-weight.bold",
	"line-height": "line-height.subhead-3",
	color: "color.neutral-100"
},
	"subhead-4": {
	"font-family": "font-family.heading",
	"font-size": "font-size.small",
	"font-weight": "font-weight.bold",
	"line-height": "line-height.subhead-4",
	color: "color.neutral-100"
},
	"display-4": {
	"font-family": "font-family.heading",
	"font-size": "font-size.xx-large",
	"font-weight": "font-weight.bold",
	"line-height": "line-height.display-4",
	color: "color.neutral-100"
},
	"button-tertiary": {
	"font-family": "font-family.heading",
	"font-size": "font-size.root",
	"font-weight": "font-weight.regular",
	"line-height": "line-height.label",
	color: "color.brand-primary-125",
	"text-decoration": "underline"
},
	hyperlink: hyperlink,
	"hyperlink-small": {
	"font-family": "font-family.text",
	"font-size": "font-size.small",
	"font-weight": "font-weight.regular",
	"line-height": "line-height.body-small",
	color: "color.brand-primary-125",
	"text-decoration": "underline"
},
	label: label,
	"label-bold": {
	"font-family": "font-family.heading",
	"font-size": "font-size.root",
	"font-weight": "font-weight.bold",
	"line-height": "line-height.label",
	color: "color.neutral-100"
},
	"label-heavy": {
	"font-family": "font-family.heading",
	"font-size": "font-size.root",
	"font-weight": "font-weight.heavy",
	"line-height": "line-height.label",
	color: "color.neutral-100"
},
	"label-small": {
	"font-family": "font-family.heading",
	"font-size": "font-size.small",
	"font-weight": "font-weight.regular",
	"line-height": "line-height.label-small",
	color: "color.neutral-100"
},
	"label-small-bold": {
	"font-family": "font-family.heading",
	"font-size": "font-size.small",
	"font-weight": "font-weight.bold",
	"line-height": "line-height.label-small",
	color: "color.neutral-100"
},
	"label-small-heavy": {
	"font-family": "font-family.heading",
	"font-size": "font-size.small",
	"font-weight": "font-weight.heavy",
	"line-height": "line-height.label-small",
	color: "color.neutral-100"
},
	"label-large": {
	"font-family": "font-family.heading",
	"font-size": "font-size.medium",
	"font-weight": "font-weight.regular",
	"line-height": "line-height.label-large",
	color: "color.neutral-100"
},
	"label-large-bold": {
	"font-family": "font-family.heading",
	"font-size": "font-size.medium",
	"font-weight": "font-weight.bold",
	"line-height": "line-height.label-large",
	color: "color.neutral-100"
},
	"label-large-heavy": {
	"font-family": "font-family.heading",
	"font-size": "font-size.medium",
	"font-weight": "font-weight.heavy",
	"line-height": "line-height.label-large",
	color: "color.neutral-100"
},
	"button-tertiary-mini": {
	"font-family": "font-family.heading",
	"font-size": "font-size.small",
	"font-weight": "font-weight.regular",
	"line-height": "line-height.label-small",
	color: "color.brand-primary-125"
},
	"label-small-tight": {
	"font-family": "font-family.heading",
	"font-size": "font-size.small",
	"font-weight": "font-weight.regular",
	"line-height": "line-height.label-small-tight",
	color: "color.neutral-100"
},
	"label-small-bold-tight": {
	"font-family": "font-family.heading",
	"font-size": "font-size.small",
	"font-weight": "font-weight.bold",
	"line-height": "line-height.label-small-tight",
	color: "color.neutral-100"
},
	"label-bold-tight": {
	"font-family": "font-family.heading",
	"font-size": "font-size.root",
	"font-weight": "font-weight.regular",
	"line-height": "line-height.label-tight",
	color: "color.neutral-100"
},
	"label-tight": {
	"font-family": "font-family.heading",
	"font-size": "font-size.root",
	"font-weight": "font-weight.bold",
	"line-height": "line-height.label-tight",
	color: "color.neutral-100"
},
	"icon-scale": {
	"x-small": "scale(0.575)",
	small: "scale(0.835)",
	regular: "scale(1.0)",
	large: "scale(1.67)",
	"object-selected": "scale(1.5)"
},
	"icon-color": {
	"neutral-100": "color.neutral-100",
	"brand-primary": "color.brand-primary",
	"brand-primary-125": "color.brand-primary-125",
	"neutral-75": "color.neutral-75",
	"neutral-50": "color.neutral-50",
	"status-success": "color.status-success"
},
	width: width
};

var FontWeight;
(function (FontWeight) {
    FontWeight[FontWeight["Regular"] = parseInt(tokens$1['font-weight'].regular, 10)] = "Regular";
    FontWeight[FontWeight["Bold"] = parseInt(tokens$1['font-weight'].bold, 10)] = "Bold";
    FontWeight[FontWeight["Heavy"] = parseInt(tokens$1['font-weight'].heavy, 10)] = "Heavy";
})(FontWeight || (FontWeight = {}));

const numberPattern = /[-]{0,1}[\d]*[.]{0,1}[\d]+/g;

const getBreakpoints = () => {
    const [medium] = String(tokens$1.breakpoint.large)
        .match(numberPattern);
    const [large] = String(tokens$1.breakpoint['x-large'])
        .match(numberPattern);
    return {
        large: Number(large),
        medium: Number(medium),
        small: 600,
    };
};

const primitives = {
    primaryFontFamily: tokens$1['font-family'].heading,
};
const overridesLight = {
    breakpoints: getBreakpoints(),
    colors: {
        /* eslint-disable sort-keys-fix/sort-keys-fix */
        // Grays. Ordered in increasing saturation levels
        mono100: tokens$1.color['neutral-0'],
        mono200: tokens$1.color['neutral-10'],
        mono300: tokens$1.color['neutral-25'],
        mono400: tokens$1.color['neutral-50'],
        mono500: tokens$1.color['neutral-75'],
        mono600: tokens$1.color['neutral-100'],
        // Blues. Ordered in increasing saturation levels
        accent: tokens$1.color['brand-secondary-1-10'],
        accent50: tokens$1.color['brand-secondary-1-25'],
        accent100: tokens$1.color['brand-secondary-1-50'],
        accent200: tokens$1.color['brand-secondary-1-75'],
        accent300: tokens$1.color['brand-secondary-1-100'],
        accent400: tokens$1.color['brand-secondary-1-125'],
        // Main Premise Red
        primary: tokens$1.color['brand-primary'],
        // Premise Reds. Ordered in increasing saturation levels
        primaryA: tokens$1.color['brand-primary-10'],
        primaryB: tokens$1.color['brand-primary-25'],
        primary50: tokens$1.color['brand-primary-50'],
        primary100: tokens$1.color['brand-primary-75'],
        primary200: tokens$1.color['brand-primary-125'],
        primary300: tokens$1.color['brand-primary-150'],
        // Oranges. Ordered in increasing saturation levels
        warning50: tokens$1.color['brand-secondary-3-10'],
        warning100: tokens$1.color['brand-secondary-3-25'],
        warning200: tokens$1.color['brand-secondary-3-50'],
        warning300: tokens$1.color['brand-secondary-3-75'],
        warning400: tokens$1.color['brand-secondary-3-100'],
        warning500: tokens$1.color['brand-secondary-3-125'],
        // Greens. Ordered in increasing saturation levels
        positive100: tokens$1.color['brand-secondary-4-10'],
        positive200: tokens$1.color['brand-secondary-4-25'],
        positive300: tokens$1.color['brand-secondary-4-50'],
        positive400: tokens$1.color['brand-secondary-4-75'],
        positive500: tokens$1.color['brand-secondary-4-100'],
        positive600: tokens$1.color['brand-secondary-4-125'],
        // Primitive statuses
        negative: tokens$1.color['status-danger-25'],
        negative50: tokens$1.color['status-danger-100'],
        positive: tokens$1.color['status-success-25'],
        positive50: tokens$1.color['status-success-100'],
        warning: tokens$1.color['status-warning-100'],
        /* eslint-enable sort-keys-fix/sort-keys-fix */
    },
};
const overridesDark = {
    breakpoints: getBreakpoints(),
    colors: {
        /* eslint-disable sort-keys-fix/sort-keys-fix */
        // Grays. Ordered in increasing saturation levels
        mono100: tokens$1.color['neutral-0'],
        mono200: tokens$1.color['neutral-10'],
        mono300: tokens$1.color['neutral-25'],
        mono400: tokens$1.color['neutral-50'],
        mono500: tokens$1.color['neutral-75'],
        mono600: tokens$1.color['neutral-100'],
        // Blues. Ordered in increasing saturation levels
        accent: tokens$1.color['brand-secondary-1-10'],
        accent50: tokens$1.color['brand-secondary-1-25'],
        accent100: tokens$1.color['brand-secondary-1-50'],
        accent200: tokens$1.color['brand-secondary-1-75'],
        accent300: tokens$1.color['brand-secondary-1-100'],
        accent400: tokens$1.color['brand-secondary-1-125'],
        // Main Premise Red
        primary: tokens$1.color['brand-primary'],
        // Premise Reds. Ordered in increasing saturation levels
        primaryA: tokens$1.color['brand-primary-10'],
        primaryB: tokens$1.color['brand-primary-25'],
        primary50: tokens$1.color['brand-primary-50'],
        primary100: tokens$1.color['brand-primary-75'],
        primary200: tokens$1.color['brand-primary-125'],
        primary300: tokens$1.color['brand-primary-150'],
        // Oranges. Ordered in increasing saturation levels
        warning50: tokens$1.color['brand-secondary-3-10'],
        warning100: tokens$1.color['brand-secondary-3-25'],
        warning200: tokens$1.color['brand-secondary-3-50'],
        warning300: tokens$1.color['brand-secondary-3-75'],
        warning400: tokens$1.color['brand-secondary-3-100'],
        warning500: tokens$1.color['brand-secondary-3-125'],
        // Greens. Ordered in increasing saturation levels
        positive100: tokens$1.color['brand-secondary-4-10'],
        positive200: tokens$1.color['brand-secondary-4-25'],
        positive300: tokens$1.color['brand-secondary-4-50'],
        positive400: tokens$1.color['brand-secondary-4-75'],
        positive500: tokens$1.color['brand-secondary-4-100'],
        positive600: tokens$1.color['brand-secondary-4-125'],
        // Primitive statuses
        negative: tokens$1.color['status-danger-25'],
        negative50: tokens$1.color['status-danger-100'],
        positive: tokens$1.color['status-success-25'],
        positive50: tokens$1.color['status-success-100'],
        warning: tokens$1.color['status-warning-100'],
        /* eslint-enable sort-keys-fix/sort-keys-fix */
    },
};
const LightThemeBase = createLightTheme(primitives, overridesLight);
const DarkThemeBase = createLightTheme(primitives, overridesDark);
const sizing = {
    ...LightThemeBase.sizing,
    ...Object.entries(tokens$1.spacing).reduce((acc, [k, v]) => ({
        ...acc,
        [k]: v,
    }), {}),
};
const cornerRadius = Object.entries(tokens$1['corner-radius'])
    .reduce((acc, [k, v]) => ({
    ...acc,
    [k]: v,
}), {});
const boxShadow = Object.entries(tokens$1['box-shadow'])
    .reduce((acc, [k, v]) => ({
    ...acc,
    [k]: v,
}), {});
const opacity = Object.entries(tokens$1.opacity)
    .reduce((acc, [k, v]) => ({
    ...acc,
    [k]: v,
}), {});
const iconScale = Object.entries(tokens$1['icon-scale'])
    .reduce((acc, [k, v]) => ({
    ...acc,
    [k]: v,
}), {});
const LightTheme = {
    ...LightThemeBase,
    boxShadow,
    colors: {
        ...LightThemeBase.colors,
        ...Object.entries(tokens$1.color).reduce((acc, [k, v]) => ({
            ...acc,
            [k]: v,
        }), {}),
    },
    cornerRadius,
    iconScale,
    opacity,
    sizing,
};
const DarkTheme = {
    ...DarkThemeBase,
    boxShadow,
    colors: {
        ...DarkThemeBase.colors,
        ...Object.entries(tokens$1.color).reduce((acc, [k, v]) => ({
            ...acc,
            [k]: v,
        }), {}),
    },
    cornerRadius,
    iconScale,
    opacity,
    sizing,
};

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function getSvgStyles$1(_ref) {
  var $theme = _ref.$theme,
      $size = _ref.$size,
      $color = _ref.$color;
  var size = $theme.sizing.scale600;

  if ($size) {
    if ($theme.sizing[$size]) {
      size = $theme.sizing[$size];
    } else if (typeof $size === 'number') {
      size = "".concat($size, "px");
    } else {
      size = $size;
    }
  }

  var color = 'currentColor';

  if ($color) {
    if ($theme.colors[$color]) {
      color = $theme.colors[$color];
    } else {
      color = $color;
    }
  }

  return {
    display: 'inline-block',
    fill: color,
    color: color,
    height: size,
    width: size
  };
}
var Svg$1 = styled('svg', getSvgStyles$1);
Svg$1.displayName = "Svg";

function ownKeys$18(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$18(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$18(Object(source), true).forEach(function (key) { _defineProperty$1z(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$18(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1z(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Main component container element
 */
var Root$a = styled('ul', {
  listStyleType: 'none',
  marginBottom: 0,
  marginTop: 0,
  paddingLeft: 0,
  paddingRight: 0,
  width: '100%'
});
Root$a.displayName = "Root";
var PanelContainer = styled('li', function (props) {
  var $expanded = props.$expanded,
      colors = props.$theme.colors;
  return {
    listStyleType: 'none',
    width: '100%',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: $expanded ? colors.mono500 : colors.mono400
  };
});
PanelContainer.displayName = "PanelContainer";
var Header = styled('div', function (props) {
  var $disabled = props.$disabled,
      $isFocusVisible = props.$isFocusVisible,
      _props$$theme = props.$theme,
      colors = _props$$theme.colors,
      sizing = _props$$theme.sizing,
      typography = _props$$theme.typography;
  return _objectSpread$18(_objectSpread$18({}, typography.font350), {}, {
    color: colors.contentPrimary,
    cursor: $disabled ? 'not-allowed' : 'pointer',
    backgroundColor: colors.listHeaderFill,
    paddingTop: sizing.scale600,
    paddingBottom: sizing.scale600,
    paddingLeft: sizing.scale700,
    paddingRight: sizing.scale700,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    display: 'flex',
    alignItems: 'center',
    outline: $isFocusVisible ? "3px solid ".concat(colors.accent) : 'none',
    outlineOffset: '-3px',
    justifyContent: 'space-between',
    ':hover': {
      color: colors.primary
    }
  });
});
Header.displayName = "Header";
var ToggleIcon = styled('svg', function (props) {
  var $theme = props.$theme,
      $disabled = props.$disabled,
      $color = props.$color;
  return _objectSpread$18(_objectSpread$18({}, getSvgStyles$1(props)), {}, {
    flexShrink: 0,
    color: $color || $theme.colors.contentPrimary,
    cursor: $disabled ? 'not-allowed' : 'pointer'
  });
});
ToggleIcon.displayName = "ToggleIcon";
var ToggleIconGroup = styled('g', function (props) {
  var $theme = props.$theme,
      $expanded = props.$expanded;
  return {
    transform: $expanded ? 'rotate(0)' : 'rotate(-90deg)',
    transformOrigin: 'center',
    transitionProperty: 'transform',
    transitionDuration: $theme.animation.timing500,
    transitionTimingFunction: $theme.animation.easeOutQuinticCurve
  };
});
ToggleIconGroup.displayName = "ToggleIconGroup";
var Content = styled('div', function (props) {
  var _props$$theme2 = props.$theme,
      animation = _props$$theme2.animation,
      colors = _props$$theme2.colors,
      sizing = _props$$theme2.sizing,
      typography = _props$$theme2.typography,
      $expanded = props.$expanded;
  return _objectSpread$18(_objectSpread$18({}, typography.font200), {}, {
    backgroundColor: colors.listBodyFill,
    color: colors.contentPrimary,
    paddingTop: sizing.scale800,
    paddingBottom: sizing.scale1000,
    paddingLeft: sizing.scale800,
    paddingRight: sizing.scale800,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    boxSizing: 'border-box',
    overflow: 'hidden',
    opacity: $expanded ? 1 : 0,
    visibility: $expanded ? 'visible' : 'hidden',
    transitionProperty: 'opacity,visibility',
    transitionDuration: animation.timing500,
    transitionDelay: animation.timing200,
    transitionTimingFunction: animation.easeOutQuinticCurve
  });
});
Content.displayName = "Content";
var ContentAnimationContainer = styled('div', function (props) {
  var $height = props.$height,
      animation = props.$theme.animation;
  return {
    height: "".concat($height),
    overflow: 'hidden',
    transitionProperty: 'height',
    transitionDuration: animation.timing500,
    transitionTimingFunction: animation.easeOutQuinticCurve
  };
});
ContentAnimationContainer.displayName = "ContentAnimationContainer";

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var STATE_CHANGE_TYPE$4 = {
  expand: 'expand'
};

function _typeof$L(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$L = function _typeof(obj) { return typeof obj; }; } else { _typeof$L = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$L(obj); }

function _extends$1r() { _extends$1r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1r.apply(this, arguments); }

function _slicedToArray$1c(arr, i) { return _arrayWithHoles$1c(arr) || _iterableToArrayLimit$1c(arr, i) || _unsupportedIterableToArray$1e(arr, i) || _nonIterableRest$1c(); }

function _nonIterableRest$1c() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit$1c(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1c(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray$b(arr) { return _arrayWithoutHoles$a(arr) || _iterableToArray$a(arr) || _unsupportedIterableToArray$1e(arr) || _nonIterableSpread$a(); }

function _nonIterableSpread$a() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1e(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1e(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1e(o, minLen); }

function _iterableToArray$a(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$a(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$1e(arr); }

function _arrayLikeToArray$1e(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys$17(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$17(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$17(Object(source), true).forEach(function (key) { _defineProperty$1y(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$17(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck$K(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$I(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$J(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$I(Constructor.prototype, protoProps); if (staticProps) _defineProperties$I(Constructor, staticProps); return Constructor; }

function _inherits$J(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$K(subClass, superClass); }

function _setPrototypeOf$K(o, p) { _setPrototypeOf$K = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$K(o, p); }

function _createSuper$I(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$J(); return function _createSuperInternal() { var Super = _getPrototypeOf$J(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$J(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$J(this, result); }; }

function _possibleConstructorReturn$J(self, call) { if (call && (_typeof$L(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$L(self); }

function _assertThisInitialized$L(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$J() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$J(o) { _getPrototypeOf$J = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$J(o); }

function _defineProperty$1y(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Accordion$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$J(Accordion, _React$Component);

  var _super = _createSuper$I(Accordion);

  function Accordion() {
    var _this;

    _classCallCheck$K(this, Accordion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1y(_assertThisInitialized$L(_this), "state", _objectSpread$17({
      expanded: []
    }, _this.props.initialState));

    return _this;
  }

  _createClass$J(Accordion, [{
    key: "onPanelChange",
    value: //flowlint-next-line unclear-type:off
    function onPanelChange(key, onChange) {
      var activeKeys = this.state.expanded;
      var accordion = this.props.accordion;

      if (accordion) {
        activeKeys = activeKeys[0] === key ? [] : [key];
      } else {
        activeKeys = _toConsumableArray$b(activeKeys);
        var index = activeKeys.indexOf(key);
        var wasExpanded = index > -1;

        if (wasExpanded) {
          // remove active state
          activeKeys.splice(index, 1);
        } else {
          activeKeys.push(key);
        }
      }

      var newState = {
        expanded: activeKeys
      };
      this.internalSetState(STATE_CHANGE_TYPE$4.expand, newState); // Call individual panel's onChange handler

      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      if (typeof onChange === 'function') onChange.apply(void 0, args);
    }
  }, {
    key: "internalSetState",
    value: function internalSetState(type, changes) {
      var _this$props = this.props,
          stateReducer = _this$props.stateReducer,
          onChange = _this$props.onChange;
      var newState = stateReducer(type, changes, this.state);
      this.setState(newState);
      typeof onChange === 'function' && onChange(newState);
    }
  }, {
    key: "getItems",
    value: function getItems() {
      var _this2 = this;

      var expanded = this.state.expanded;
      var _this$props2 = this.props,
          accordion = _this$props2.accordion,
          disabled = _this$props2.disabled,
          children = _this$props2.children,
          renderPanelContent = _this$props2.renderPanelContent,
          renderAll = _this$props2.renderAll,
          overrides = _this$props2.overrides; // flowlint-next-line unclear-type:off

      return React$2.Children.map(children, function (child, index) {
        if (!child) return; // If there is no key provided use the panel order as a default key

        var key = child.key || String(index);
        var isExpanded = false;

        if (accordion) {
          isExpanded = expanded[0] === key;
        } else {
          isExpanded = expanded.includes(key);
        }

        var props = {
          key: key,
          expanded: isExpanded || child.props.expanded,
          accordion: accordion,
          renderPanelContent: renderPanelContent,
          renderAll: renderAll,
          overrides: child.props.overrides || overrides,
          disabled: child.props.disabled || disabled,
          onChange: function onChange() {
            for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              args[_key3] = arguments[_key3];
            }

            return _this2.onPanelChange.apply(_this2, [key, child.props.onChange].concat(args));
          }
        };
        return /*#__PURE__*/React$2.cloneElement(child, props);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // TODO(v11)
      if (process.env.NODE_ENV !== "production" && this.props.renderPanelContent) {
        console.warn('baseui:Accordion The `renderPanelContent` prop is deprecated. Please update your code to use `renderAll`.');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$overrides = this.props.overrides,
          overrides = _this$props$overrides === void 0 ? {} : _this$props$overrides;
      var RootOverride = overrides.Root;

      var _getOverrides = getOverrides(RootOverride, Root$a),
          _getOverrides2 = _slicedToArray$1c(_getOverrides, 2),
          Root = _getOverrides2[0],
          rootProps = _getOverrides2[1];

      return /*#__PURE__*/React$2.createElement(Root, _extends$1r({
        "data-baseweb": "accordion",
        $disabled: this.props.disabled,
        $isFocusVisible: false
      }, rootProps), this.getItems());
    }
  }]);

  return Accordion;
}(React$2.Component);

_defineProperty$1y(Accordion$1, "defaultProps", {
  accordion: true,
  disabled: false,
  initialState: {
    expanded: []
  },
  onChange: function onChange() {},
  overrides: {},
  renderAll: false,
  renderPanelContent: false,
  stateReducer: function stateReducer(type, newState) {
    return newState;
  }
});

function _extends$1q() { _extends$1q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1q.apply(this, arguments); }

function ownKeys$16(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$16(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$16(Object(source), true).forEach(function (key) { _defineProperty$1x(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$16(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1x(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$1b(arr, i) { return _arrayWithHoles$1b(arr) || _iterableToArrayLimit$1b(arr, i) || _unsupportedIterableToArray$1d(arr, i) || _nonIterableRest$1b(); }

function _nonIterableRest$1b() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1d(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1d(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1d(o, minLen); }

function _arrayLikeToArray$1d(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1b(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1b(arr) { if (Array.isArray(arr)) return arr; }

var Panel$1 = function Panel(_ref) {
  var ariaControls = _ref['aria-controls'],
      children = _ref.children,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$expanded = _ref.expanded,
      expanded = _ref$expanded === void 0 ? false : _ref$expanded,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$onKeyDown = _ref.onKeyDown,
      onKeyDown = _ref$onKeyDown === void 0 ? function () {} : _ref$onKeyDown,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$renderPanelConte = _ref.renderPanelContent,
      renderPanelContent = _ref$renderPanelConte === void 0 ? false : _ref$renderPanelConte,
      _ref$renderAll = _ref.renderAll,
      renderAll = _ref$renderAll === void 0 ? false : _ref$renderAll;

  var _React$useState = React$2.useState({
    expanded: expanded,
    isFocusVisible: false,
    elementHeight: 0,
    animationInProgress: false
  }),
      _React$useState2 = _slicedToArray$1b(_React$useState, 2),
      localState = _React$useState2[0],
      setLocalState = _React$useState2[1];

  var handleFocus = React$2.useCallback(function (event) {
    if (isFocusVisible(event)) {
      setLocalState(_objectSpread$16(_objectSpread$16({}, localState), {}, {
        isFocusVisible: true
      }));
    }
  }, [localState]);
  var handleBlur = React$2.useCallback(function (event) {
    if (localState.isFocusVisible) {
      setLocalState(_objectSpread$16(_objectSpread$16({}, localState), {}, {
        isFocusVisible: false
      }));
    }
  }, [localState]);
  var handleClick = React$2.useCallback(function (e) {
    if (disabled) {
      return;
    }

    typeof onChange === 'function' && onChange({
      expanded: !expanded
    });
    typeof onClick === 'function' && onClick(e);
  }, [expanded, disabled, onChange, onClick]);
  var handleKeyDown = React$2.useCallback(function (e) {
    if (disabled) {
      return;
    }

    var ENTER = 13;
    var SPACE = 32;

    if (e.keyCode === ENTER || e.keyCode === SPACE) {
      typeof onChange === 'function' && onChange({
        expanded: !expanded
      });

      if (e.keyCode === SPACE) {
        e.preventDefault(); // prevent jumping scroll when using Space
      }
    }

    typeof onKeyDown === 'function' && onKeyDown(e);
  }, [expanded, disabled, onChange, onKeyDown]); // flowlint-next-line unclear-type:off

  var _animateRef = React$2.useRef(null);

  React$2.useEffect(function () {
    if (_animateRef.current) {
      var height = _animateRef.current.getBoundingClientRect().height; // After the first render, when everything is in the DOM, update the local
      //state to indicate an animation is in progress.


      if (expanded !== localState.expanded) {
        setLocalState(_objectSpread$16(_objectSpread$16({}, localState), {}, {
          expanded: expanded,
          animationInProgress: true
        }));
      } else if (parseInt(localState.elementHeight) !== height) {
        // After the second render (where child elements were added to the Content)
        //the Content height now reflects the true height. This kicks off the actual
        //animation.
        setLocalState(_objectSpread$16(_objectSpread$16({}, localState), {}, {
          elementHeight: height ? "".concat(height, "px") : 0
        }));
      }
    }
  }, [_animateRef.current, expanded, localState.elementHeight, localState.expanded, setLocalState]);
  var contentHeight = React$2.useMemo(function () {
    // When closing, the first render will re-query the content element for the new
    //height and set the height of the animation container from auto to a px value.
    if (!expanded && localState.expanded) {
      var height = _animateRef.current.getBoundingClientRect().height;

      setLocalState(_objectSpread$16(_objectSpread$16({}, localState), {}, {
        elementHeight: height ? "".concat(height, "px") : 0
      }));
      return localState.elementHeight;
    }

    if (!localState.expanded) {
      return 0;
    } // When no longer animating, set the height to auto to accommodate dynamic nested components.


    return localState.animationInProgress ? localState.elementHeight : 'auto';
  }, [expanded, localState.expanded, localState.animationInProgress, localState.elementHeight]);
  var sharedProps = {
    $disabled: disabled,
    $expanded: expanded,
    $isFocusVisible: localState.isFocusVisible
  };
  var PanelContainerOverride = overrides.PanelContainer,
      HeaderOverride = overrides.Header,
      ContentOverride = overrides.Content,
      ContentAnimationContainerOverride = overrides.ContentAnimationContainer,
      ToggleIconOverride = overrides.ToggleIcon,
      ToggleIconGroupOverride = overrides.ToggleIconGroup;

  var _getOverrides = getOverrides(PanelContainerOverride, PanelContainer),
      _getOverrides2 = _slicedToArray$1b(_getOverrides, 2),
      PanelContainer$1 = _getOverrides2[0],
      panelContainerProps = _getOverrides2[1];

  var _getOverrides3 = getOverrides(HeaderOverride, Header),
      _getOverrides4 = _slicedToArray$1b(_getOverrides3, 2),
      Header$1 = _getOverrides4[0],
      headerProps = _getOverrides4[1];

  var _getOverrides5 = getOverrides(ContentOverride, Content),
      _getOverrides6 = _slicedToArray$1b(_getOverrides5, 2),
      Content$1 = _getOverrides6[0],
      contentProps = _getOverrides6[1];

  var _getOverrides7 = getOverrides(ContentAnimationContainerOverride, ContentAnimationContainer),
      _getOverrides8 = _slicedToArray$1b(_getOverrides7, 2),
      ContentAnimationContainer$1 = _getOverrides8[0],
      contentAnimationProps = _getOverrides8[1];

  var _getOverrides9 = getOverrides(ToggleIconGroupOverride, ToggleIconGroup),
      _getOverrides10 = _slicedToArray$1b(_getOverrides9, 2),
      ToggleIconGroup$1 = _getOverrides10[0],
      toggleIconGroupProps = _getOverrides10[1];

  var _getOverrides11 = getOverrides(ToggleIconOverride, ToggleIcon),
      _getOverrides12 = _slicedToArray$1b(_getOverrides11, 2),
      ToggleIcon$1 = _getOverrides12[0],
      toggleIconProps = _getOverrides12[1];

  return /*#__PURE__*/React$2.createElement(LocaleContext.Consumer, null, function (locale) {
    return /*#__PURE__*/React$2.createElement(PanelContainer$1, _extends$1q({}, sharedProps, panelContainerProps), /*#__PURE__*/React$2.createElement(Header$1, _extends$1q({
      tabIndex: 0,
      role: "button",
      "aria-expanded": expanded,
      "aria-disabled": disabled || null
    }, sharedProps, headerProps, ariaControls ? {
      'aria-controls': ariaControls
    } : {}, {
      onClick: handleClick,
      onKeyDown: handleKeyDown,
      onFocus: forkFocus(headerProps, handleFocus),
      onBlur: forkBlur(headerProps, handleBlur)
    }), title, /*#__PURE__*/React$2.createElement(ToggleIcon$1, _extends$1q({
      viewBox: "0 0 24 24",
      title: localState.expanded ? locale.accordion.collapse : locale.accordion.expand,
      size: 16
    }, toggleIconProps, sharedProps), /*#__PURE__*/React$2.createElement(ToggleIconGroup$1, _extends$1q({}, sharedProps, toggleIconGroupProps), /*#__PURE__*/React$2.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 12C6 11.4477 6.44772 11 7 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H7C6.44772 13 6 12.5523 6 12Z"
    })), /*#__PURE__*/React$2.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 12C6 11.4477 6.44772 11 7 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H7C6.44772 13 6 12.5523 6 12Z"
    }))), /*#__PURE__*/React$2.createElement(ContentAnimationContainer$1, _extends$1q({}, sharedProps, contentAnimationProps, {
      $height: contentHeight,
      onTransitionEnd: function onTransitionEnd() {
        if (localState.animationInProgress) {
          setLocalState(_objectSpread$16(_objectSpread$16({}, localState), {}, {
            animationInProgress: false
          }));
        }
      }
    }), /*#__PURE__*/React$2.createElement(Content$1, _extends$1q({
      ref: _animateRef
    }, sharedProps, contentProps, ariaControls ? {
      id: ariaControls
    } : {}), localState.expanded || renderAll || renderPanelContent || localState.animationInProgress ? children : null)));
  });
};

var BasePanel = Panel$1;

function _typeof$K(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$K = function _typeof(obj) { return typeof obj; }; } else { _typeof$K = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$K(obj); }

function _objectWithoutProperties$U(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$W(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$W(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys$15(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$15(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$15(Object(source), true).forEach(function (key) { _defineProperty$1w(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$15(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck$J(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$H(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$I(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$H(Constructor.prototype, protoProps); if (staticProps) _defineProperties$H(Constructor, staticProps); return Constructor; }

function _inherits$I(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$J(subClass, superClass); }

function _setPrototypeOf$J(o, p) { _setPrototypeOf$J = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$J(o, p); }

function _createSuper$H(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$I(); return function _createSuperInternal() { var Super = _getPrototypeOf$I(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$I(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$I(this, result); }; }

function _possibleConstructorReturn$I(self, call) { if (call && (_typeof$K(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$K(self); }

function _assertThisInitialized$K(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$I() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$I(o) { _getPrototypeOf$I = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$I(o); }

function _defineProperty$1w(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultStateReducer$5 = function defaultStateReducer(type, nextState) {
  return nextState;
};

var StatefulPanelContainer = /*#__PURE__*/function (_React$Component) {
  _inherits$I(StatefulPanelContainer, _React$Component);

  var _super = _createSuper$H(StatefulPanelContainer);

  function StatefulPanelContainer() {
    var _this;

    _classCallCheck$J(this, StatefulPanelContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1w(_assertThisInitialized$K(_this), "state", _objectSpread$15({
      expanded: false
    }, _this.props.initialState));

    _defineProperty$1w(_assertThisInitialized$K(_this), "onChange", function () {
      if (typeof _this.props.onChange === 'function') {
        _this.props.onChange({
          expanded: !_this.state.expanded
        });
      }

      _this.internalSetState(STATE_CHANGE_TYPE$4.expand, {
        expanded: !_this.state.expanded
      });
    });

    return _this;
  }

  _createClass$I(StatefulPanelContainer, [{
    key: "internalSetState",
    value: function internalSetState(type, changes) {
      var stateReducer = this.props.stateReducer;
      this.setState(function (prevState) {
        return stateReducer ? stateReducer(type, changes, prevState) : changes;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props;
          _this$props.children;
          _this$props.initialState;
          _this$props.stateReducer;
          var restProps = _objectWithoutProperties$U(_this$props, ["children", "initialState", "stateReducer"]);

      return this.props.children(_objectSpread$15(_objectSpread$15(_objectSpread$15({}, restProps), this.state), {}, {
        onChange: this.onChange
      }));
    }
  }]);

  return StatefulPanelContainer;
}(React$2.Component);

_defineProperty$1w(StatefulPanelContainer, "defaultProps", {
  initialState: {
    expanded: false
  },
  stateReducer: defaultStateReducer$5,
  onChange: function onChange() {}
});

var StatefulPanelContainer$1 = StatefulPanelContainer;

function _extends$1p() { _extends$1p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1p.apply(this, arguments); }

function _toConsumableArray$a(arr) { return _arrayWithoutHoles$9(arr) || _iterableToArray$9(arr) || _unsupportedIterableToArray$1c(arr) || _nonIterableSpread$9(); }

function _nonIterableSpread$9() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray$9(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$9(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$1c(arr); }

function _slicedToArray$1a(arr, i) { return _arrayWithHoles$1a(arr) || _iterableToArrayLimit$1a(arr, i) || _unsupportedIterableToArray$1c(arr, i) || _nonIterableRest$1a(); }

function _nonIterableRest$1a() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1c(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1c(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1c(o, minLen); }

function _arrayLikeToArray$1c(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1a(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1a(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties$T(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$V(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$V(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function StatelessAccordion$1(_ref) {
  var _ref$accordion = _ref.accordion,
      accordion = _ref$accordion === void 0 ? true : _ref$accordion,
      children = _ref.children,
      disabled = _ref.disabled,
      expanded = _ref.expanded,
      onChange = _ref.onChange,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides,
      renderAll = _ref.renderAll,
      renderPanelContent = _ref.renderPanelContent;

  var RootOverrides = overrides.Root,
      PanelOverrides = _objectWithoutProperties$T(overrides, ["Root"]);

  var _getOverrides = getOverrides(RootOverrides, Root$a),
      _getOverrides2 = _slicedToArray$1a(_getOverrides, 2),
      Root = _getOverrides2[0],
      rootProps = _getOverrides2[1];

  return /*#__PURE__*/React$2.createElement(Root, _extends$1p({
    "data-baseweb": "accordion"
  }, rootProps), React$2.Children.map(children, function (child, index) {
    var key = child.key || String(index);
    return /*#__PURE__*/React$2.cloneElement(child, {
      disabled: child.props.disabled || disabled,
      expanded: expanded.includes(key),
      key: key,
      onChange: // Don't bother constructing the wrapper function if no one is listening
      onChange && typeof onChange === 'function' ? function () {
        var next;

        if (accordion) {
          if (expanded.includes(key)) {
            next = [];
          } else {
            next = [key];
          }
        } else {
          if (expanded.includes(key)) {
            next = expanded.filter(function (k) {
              return k !== key;
            });
          } else {
            next = [].concat(_toConsumableArray$a(expanded), [key]);
          }
        }

        onChange({
          key: key,
          expanded: next
        });
      } : onChange,
      overrides: child.props.overrides || PanelOverrides,
      renderAll: renderAll,
      renderPanelContent: renderPanelContent
    });
  }));
}

const defaultParentContextProps = {
    level: 0,
    size: 'small',
};
const ParentContext = React$2.createContext(defaultParentContextProps);
const ParentProvider = (props) => {
    const { children, value } = props;
    return (React$2.createElement(ParentContext.Provider, { value: value }, children));
};

const StatelessAccordion = (props) => {
    const { children, size, ...restProps } = props;
    const value = React$2.useContext(ParentContext);
    let parentSize = size !== null && size !== void 0 ? size : 'small';
    let level = 0;
    if (value) {
        parentSize = size !== null && size !== void 0 ? size : value.size;
        level = value.level;
    }
    return (React$2.createElement(ParentProvider, { value: { level: level + 1, size: parentSize } },
        React$2.createElement(StatelessAccordion$1, { ...restProps }, children)));
};

const Accordion = (props) => {
    const { children, size, ...restProps } = props;
    const value = React$2.useContext(ParentContext);
    let parentSize = size !== null && size !== void 0 ? size : 'small';
    let level = 0;
    if (value) {
        parentSize = size !== null && size !== void 0 ? size : value.size;
        level = value.level;
    }
    return (React$2.createElement(ParentProvider, { value: { level: level + 1, size: parentSize } },
        React$2.createElement(Accordion$1, { ...restProps }, children)));
};

function _extends$1o() {
  _extends$1o = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1o.apply(this, arguments);
}

function _assertThisInitialized$J(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _setPrototypeOf$I(o, p) {
  _setPrototypeOf$I = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$I(o, p);
}

function _inheritsLoose$3(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$I(subClass, superClass);
}

function _getPrototypeOf$H(o) {
  _getPrototypeOf$H = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$H(o);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _isNativeReflectConstruct$H() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct$H()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf$I(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf$H(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf$I(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function last() {
  var _ref;

  return _ref = arguments.length - 1, _ref < 0 || arguments.length <= _ref ? undefined : arguments[_ref];
}

function negation(a) {
  return -a;
}

function addition(a, b) {
  return a + b;
}

function subtraction(a, b) {
  return a - b;
}

function multiplication(a, b) {
  return a * b;
}

function division(a, b) {
  return a / b;
}

function max() {
  return Math.max.apply(Math, arguments);
}

function min() {
  return Math.min.apply(Math, arguments);
}

function comma() {
  return Array.of.apply(Array, arguments);
}

var defaultSymbols = {
  symbols: {
    '*': {
      infix: {
        symbol: '*',
        f: multiplication,
        notation: 'infix',
        precedence: 4,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: '*',
      regSymbol: '\\*'
    },
    '/': {
      infix: {
        symbol: '/',
        f: division,
        notation: 'infix',
        precedence: 4,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: '/',
      regSymbol: '/'
    },
    '+': {
      infix: {
        symbol: '+',
        f: addition,
        notation: 'infix',
        precedence: 2,
        rightToLeft: 0,
        argCount: 2
      },
      prefix: {
        symbol: '+',
        f: last,
        notation: 'prefix',
        precedence: 3,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '+',
      regSymbol: '\\+'
    },
    '-': {
      infix: {
        symbol: '-',
        f: subtraction,
        notation: 'infix',
        precedence: 2,
        rightToLeft: 0,
        argCount: 2
      },
      prefix: {
        symbol: '-',
        f: negation,
        notation: 'prefix',
        precedence: 3,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '-',
      regSymbol: '-'
    },
    ',': {
      infix: {
        symbol: ',',
        f: comma,
        notation: 'infix',
        precedence: 1,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: ',',
      regSymbol: ','
    },
    '(': {
      prefix: {
        symbol: '(',
        f: last,
        notation: 'prefix',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '(',
      regSymbol: '\\('
    },
    ')': {
      postfix: {
        symbol: ')',
        f: undefined,
        notation: 'postfix',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: ')',
      regSymbol: '\\)'
    },
    min: {
      func: {
        symbol: 'min',
        f: min,
        notation: 'func',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: 'min',
      regSymbol: 'min\\b'
    },
    max: {
      func: {
        symbol: 'max',
        f: max,
        notation: 'func',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: 'max',
      regSymbol: 'max\\b'
    }
  }
};
var defaultSymbolMap = defaultSymbols;

// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js

/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */
var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
  "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
  "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
  "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
  "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
  "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found and no default was provided.\n\n",
  "75": "important requires a valid style object, got a %s instead.\n\n",
  "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
  "77": "remToPx expects a value in \"rem\" but you provided it in \"%s\".\n\n",
  "78": "base must be set in \"px\" or \"%\" but you set it in \"%s\".\n"
};
/**
 * super basic version of sprintf
 * @private
 */

function format$1() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */


var PolishedError = /*#__PURE__*/function (_Error) {
  _inheritsLoose$3(PolishedError, _Error);

  function PolishedError(code) {
    var _this;

    if (process.env.NODE_ENV === 'production') {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      _this = _Error.call(this, format$1.apply(void 0, [ERRORS[code]].concat(args))) || this;
    }

    return _assertThisInitialized$J(_this);
  }

  return PolishedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var unitRegExp = /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g; // Merges additional math functionality into the defaults.

function mergeSymbolMaps(additionalSymbols) {
  var symbolMap = {};
  symbolMap.symbols = additionalSymbols ? _extends$1o({}, defaultSymbolMap.symbols, additionalSymbols.symbols) : _extends$1o({}, defaultSymbolMap.symbols);
  return symbolMap;
}

function exec(operators, values) {
  var _ref;

  var op = operators.pop();
  values.push(op.f.apply(op, (_ref = []).concat.apply(_ref, values.splice(-op.argCount))));
  return op.precedence;
}

function calculate(expression, additionalSymbols) {
  var symbolMap = mergeSymbolMaps(additionalSymbols);
  var match;
  var operators = [symbolMap.symbols['('].prefix];
  var values = [];
  var pattern = new RegExp( // Pattern for numbers
  "\\d+(?:\\.\\d+)?|" + // ...and patterns for individual operators/function names
  Object.keys(symbolMap.symbols).map(function (key) {
    return symbolMap.symbols[key];
  }) // longer symbols should be listed first
  // $FlowFixMe
  .sort(function (a, b) {
    return b.symbol.length - a.symbol.length;
  }) // $FlowFixMe
  .map(function (val) {
    return val.regSymbol;
  }).join('|') + "|(\\S)", 'g');
  pattern.lastIndex = 0; // Reset regular expression object

  var afterValue = false;

  do {
    match = pattern.exec(expression);

    var _ref2 = match || [')', undefined],
        token = _ref2[0],
        bad = _ref2[1];

    var notNumber = symbolMap.symbols[token];
    var notNewValue = notNumber && !notNumber.prefix && !notNumber.func;
    var notAfterValue = !notNumber || !notNumber.postfix && !notNumber.infix; // Check for syntax errors:

    if (bad || (afterValue ? notAfterValue : notNewValue)) {
      throw new PolishedError(37, match ? match.index : expression.length, expression);
    }

    if (afterValue) {
      // We either have an infix or postfix operator (they should be mutually exclusive)
      var curr = notNumber.postfix || notNumber.infix;

      do {
        var prev = operators[operators.length - 1];
        if ((curr.precedence - prev.precedence || prev.rightToLeft) > 0) break; // Apply previous operator, since it has precedence over current one
      } while (exec(operators, values)); // Exit loop after executing an opening parenthesis or function


      afterValue = curr.notation === 'postfix';

      if (curr.symbol !== ')') {
        operators.push(curr); // Postfix always has precedence over any operator that follows after it

        if (afterValue) exec(operators, values);
      }
    } else if (notNumber) {
      // prefix operator or function
      operators.push(notNumber.prefix || notNumber.func);

      if (notNumber.func) {
        // Require an opening parenthesis
        match = pattern.exec(expression);

        if (!match || match[0] !== '(') {
          throw new PolishedError(38, match ? match.index : expression.length, expression);
        }
      }
    } else {
      // number
      values.push(+token);
      afterValue = true;
    }
  } while (match && operators.length);

  if (operators.length) {
    throw new PolishedError(39, match ? match.index : expression.length, expression);
  } else if (match) {
    throw new PolishedError(40, match ? match.index : expression.length, expression);
  } else {
    return values.pop();
  }
}

function reverseString(str) {
  return str.split('').reverse().join('');
}
/**
 * Helper for doing math with CSS Units. Accepts a formula as a string. All values in the formula must have the same unit (or be unitless). Supports complex formulas utliziing addition, subtraction, multiplication, division, square root, powers, factorial, min, max, as well as parentheses for order of operation.
 *
 *In cases where you need to do calculations with mixed units where one unit is a [relative length unit](https://developer.mozilla.org/en-US/docs/Web/CSS/length#Relative_length_units), you will want to use [CSS Calc](https://developer.mozilla.org/en-US/docs/Web/CSS/calc).
 *
 * *warning* While we've done everything possible to ensure math safely evalutes formulas expressed as strings, you should always use extreme caution when passing `math` user provided values.
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: math('12rem + 8rem'),
 *   fontSize: math('(12px + 2px) * 3'),
 *   fontSize: math('3px^2 + sqrt(4)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${math('12rem + 8rem')};
 *   fontSize: ${math('(12px + 2px) * 3')};
 *   fontSize: ${math('3px^2 + sqrt(4)')};
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   fontSize: '20rem',
 *   fontSize: '42px',
 *   fontSize: '11px',
 * }
 */


function math(formula, additionalSymbols) {
  var reversedFormula = reverseString(formula);
  var formulaMatch = reversedFormula.match(unitRegExp); // Check that all units are the same

  if (formulaMatch && !formulaMatch.every(function (unit) {
    return unit === formulaMatch[0];
  })) {
    throw new PolishedError(41);
  }

  var cleanFormula = reverseString(reversedFormula.replace(unitRegExp, ''));
  return "" + calculate(cleanFormula, additionalSymbols) + (formulaMatch ? reverseString(formulaMatch[0]) : '');
}

// @private
function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var positionMap$1 = ['Top', 'Right', 'Bottom', 'Left'];

function generateProperty(property, position) {
  if (!property) return position.toLowerCase();
  var splitProperty = property.split('-');

  if (splitProperty.length > 1) {
    splitProperty.splice(1, 0, position);
    return splitProperty.reduce(function (acc, val) {
      return "" + acc + capitalizeString(val);
    });
  }

  var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
  return property === joinedProperty ? "" + property + position : joinedProperty;
}

function generateStyles(property, valuesWithDefaults) {
  var styles = {};

  for (var i = 0; i < valuesWithDefaults.length; i += 1) {
    if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) {
      styles[generateProperty(property, positionMap$1[i])] = valuesWithDefaults[i];
    }
  }

  return styles;
}
/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */


function directionalProperty(property) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  //  prettier-ignore
  var firstValue = values[0],
      _values$ = values[1],
      secondValue = _values$ === void 0 ? firstValue : _values$,
      _values$2 = values[2],
      thirdValue = _values$2 === void 0 ? firstValue : _values$2,
      _values$3 = values[3],
      fourthValue = _values$3 === void 0 ? secondValue : _values$3;
  var valuesWithDefaults = [firstValue, secondValue, thirdValue, fourthValue];
  return generateStyles(property, valuesWithDefaults);
}

function constructGradientValue(literals) {
  var template = '';

  for (var _len = arguments.length, substitutions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    substitutions[_key - 1] = arguments[_key];
  }

  for (var i = 0; i < literals.length; i += 1) {
    template += literals[i];

    if (i === substitutions.length - 1 && substitutions[i]) {
      var definedValues = substitutions.filter(function (substitute) {
        return !!substitute;
      }); // Adds leading coma if properties preceed color-stops

      if (definedValues.length > 1) {
        template = template.slice(0, -1);
        template += ", " + substitutions[i]; // No trailing space if color-stops is the only param provided
      } else if (definedValues.length === 1) {
        template += "" + substitutions[i];
      }
    } else if (substitutions[i]) {
      template += substitutions[i] + " ";
    }
  }

  return template.trim();
}

var _templateObject$1;

/**
 * CSS for declaring a linear gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#FFF',
 *   'backgroundImage': 'linear-gradient(to top right, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */
function linearGradient(_ref) {
  var colorStops = _ref.colorStops,
      fallback = _ref.fallback,
      _ref$toDirection = _ref.toDirection,
      toDirection = _ref$toDirection === void 0 ? '' : _ref$toDirection;

  if (!colorStops || colorStops.length < 2) {
    throw new PolishedError(56);
  }

  return {
    backgroundColor: fallback || colorStops[0].replace(/,\s+/g, ',').split(' ')[0].replace(/,(?=\S)/g, ', '),
    backgroundImage: constructGradientValue(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["linear-gradient(", "", ")"])), toDirection, colorStops.join(', ').replace(/,(?=\S)/g, ', '))
  };
}

function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  } // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV


  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */

function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}

var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */

function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new PolishedError(3);
  }

  var normalizedColor = nameToHex(color);

  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }

  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }

  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }

  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));

    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }

  var rgbMatched = rgbRegex.exec(normalizedColor);

  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }

  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));

  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
  }

  var hslMatched = hslRegex.exec(normalizedColor);

  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);

    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }

    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }

  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));

  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);

    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;

    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;

    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";

    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);

    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }

    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
    };
  }

  throw new PolishedError(5);
}

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }

  return value;
};

var reduceHexValue$1 = reduceHexValue;

function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue$1("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue$1("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }

  throw new PolishedError(6);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }

  throw new PolishedError(7);
}

var sideMap = ['top', 'right', 'bottom', 'left'];
/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */

function border$1(sideKeyword) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (typeof sideKeyword === 'string' && sideMap.indexOf(sideKeyword) >= 0) {
    var _ref;

    return _ref = {}, _ref["border" + capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
  } else {
    values.unshift(sideKeyword);
    return {
      borderWidth: values[0],
      borderStyle: values[1],
      borderColor: values[2]
    };
  }
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */
function borderColor() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderColor'].concat(values));
}

/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */
function borderRadius(side, radius) {
  var uppercaseSide = capitalizeString(side);

  if (!radius && radius !== 0) {
    throw new PolishedError(62);
  }

  if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
    var _ref;

    return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
  }

  if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
    var _ref2;

    return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
  }

  throw new PolishedError(63);
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */
function borderStyle() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderStyle'].concat(values));
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */
function borderWidth() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderWidth'].concat(values));
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */
function margin() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['margin'].concat(values));
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */
function padding() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['padding'].concat(values));
}

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

// styletron will throw when value is undefined. if so, replace with null
function constrainToNull(value) {
  if (value === undefined) {
    return null;
  }

  return value;
}

function build(breakpoints) {
  var styles = {};
  var mediaQueries = getMediaQueries(breakpoints);
  return {
    apply: function apply(_ref) {
      var property = _ref.property,
          _ref$transform = _ref.transform,
          transform = _ref$transform === void 0 ? function (x) {
        return x;
      } : _ref$transform,
          value = _ref.value;

      if (value === null || value === undefined) {
        return;
      }

      if (Array.isArray(value)) {
        value.forEach(function (v, index) {
          // Do not create a media query for the smallest breakpoint.
          if (index === 0) {
            styles[property] = constrainToNull(transform(v));
            return;
          }

          var mediaQuery = mediaQueries[index - 1];

          if (!styles[mediaQuery]) {
            styles[mediaQuery] = {};
          }

          styles[mediaQuery][property] = constrainToNull(transform(v));
        });
      } else {
        styles[property] = constrainToNull(transform(value));
      }
    },
    value: function value() {
      return styles;
    }
  };
}

function getFontValue(obj, key) {
  if (!obj) return;
  return obj[key];
}

var StyledBlock = styled('div', function (props) {
  var _props$$theme = props.$theme,
      breakpoints = _props$$theme.breakpoints,
      colors = _props$$theme.colors,
      typography = _props$$theme.typography,
      sizing = _props$$theme.sizing;

  var get = function get(obj, key) {
    return obj[key];
  };

  var getScale = function getScale(size) {
    return sizing[size] || size;
  };

  var styles = build(breakpoints);
  styles.apply({
    property: 'color',
    value: get(props, '$color'),
    transform: function transform(color) {
      return colors[color] || color;
    }
  });
  styles.apply({
    property: 'backgroundAttachment',
    value: get(props, '$backgroundAttachment')
  });
  styles.apply({
    property: 'backgroundClip',
    value: get(props, '$backgroundClip')
  });
  styles.apply({
    property: 'backgroundColor',
    value: get(props, '$backgroundColor'),
    transform: function transform(backgroundColor) {
      return colors[backgroundColor] || backgroundColor;
    }
  });
  styles.apply({
    property: 'backgroundImage',
    value: get(props, '$backgroundImage')
  });
  styles.apply({
    property: 'backgroundOrigin',
    value: get(props, '$backgroundOrigin')
  });
  styles.apply({
    property: 'backgroundPosition',
    value: get(props, '$backgroundPosition')
  });
  styles.apply({
    property: 'backgroundRepeat',
    value: get(props, '$backgroundRepeat')
  });
  styles.apply({
    property: 'backgroundSize',
    value: get(props, '$backgroundSize')
  });
  styles.apply({
    property: 'fontFamily',
    value: get(props, '$font'),
    transform: function transform(font) {
      return getFontValue(typography[font], 'fontFamily');
    }
  });
  styles.apply({
    property: 'fontWeight',
    value: get(props, '$font'),
    transform: function transform(font) {
      return getFontValue(typography[font], 'fontWeight');
    }
  });
  styles.apply({
    property: 'fontSize',
    value: get(props, '$font'),
    transform: function transform(font) {
      return getFontValue(typography[font], 'fontSize');
    }
  });
  styles.apply({
    property: 'lineHeight',
    value: get(props, '$font'),
    transform: function transform(font) {
      return getFontValue(typography[font], 'lineHeight');
    }
  });
  styles.apply({
    property: 'alignContent',
    value: get(props, '$alignContent')
  });
  styles.apply({
    property: 'alignItems',
    value: get(props, '$alignItems')
  });
  styles.apply({
    property: 'alignSelf',
    value: get(props, '$alignSelf')
  });
  styles.apply({
    property: 'display',
    value: get(props, '$display')
  });
  styles.apply({
    property: 'flex',
    value: get(props, '$flex')
  });
  styles.apply({
    property: 'flexDirection',
    value: get(props, '$flexDirection')
  });
  styles.apply({
    property: 'grid',
    value: get(props, '$grid')
  });
  styles.apply({
    property: 'gridArea',
    value: get(props, '$gridArea')
  });
  styles.apply({
    property: 'gridAutoColumns',
    value: get(props, '$gridAutoColumns')
  });
  styles.apply({
    property: 'gridAutoFlow',
    value: get(props, '$gridAutoFlow')
  });
  styles.apply({
    property: 'gridAutoRows',
    value: get(props, '$gridAutoRows')
  });
  styles.apply({
    property: 'gridColumn',
    value: get(props, '$gridColumn')
  });
  styles.apply({
    property: 'gridColumnEnd',
    value: get(props, '$gridColumnEnd')
  });
  styles.apply({
    property: 'gridColumnGap',
    value: get(props, '$gridColumnGap'),
    transform: getScale
  });
  styles.apply({
    property: 'gridColumnStart',
    value: get(props, '$gridColumnStart')
  });
  styles.apply({
    property: 'gridGap',
    value: get(props, '$gridGap'),
    transform: getScale
  });
  styles.apply({
    property: 'gridRow',
    value: get(props, '$gridRow')
  });
  styles.apply({
    property: 'gridRowEnd',
    value: get(props, '$gridRowEnd')
  });
  styles.apply({
    property: 'gridRowGap',
    value: get(props, '$gridRowGap'),
    transform: getScale
  });
  styles.apply({
    property: 'gridRowStart',
    value: get(props, '$gridRowStart')
  });
  styles.apply({
    property: 'gridTemplate',
    value: get(props, '$gridTemplate')
  });
  styles.apply({
    property: 'gridTemplateAreas',
    value: get(props, '$gridTemplateAreas')
  });
  styles.apply({
    property: 'gridTemplateColumns',
    value: get(props, '$gridTemplateColumns')
  });
  styles.apply({
    property: 'gridTemplateRows',
    value: get(props, '$gridTemplateRows')
  });
  styles.apply({
    property: 'justifyContent',
    value: get(props, '$justifyContent')
  });
  styles.apply({
    property: 'justifyItems',
    value: get(props, '$justifyItems')
  });
  styles.apply({
    property: 'justifySelf',
    value: get(props, '$justifySelf')
  });
  styles.apply({
    property: 'position',
    value: get(props, '$position')
  });
  styles.apply({
    property: 'width',
    value: get(props, '$width'),
    transform: getScale
  });
  styles.apply({
    property: 'minWidth',
    value: get(props, '$minWidth'),
    transform: getScale
  });
  styles.apply({
    property: 'maxWidth',
    value: get(props, '$maxWidth'),
    transform: getScale
  });
  styles.apply({
    property: 'height',
    value: get(props, '$height'),
    transform: getScale
  });
  styles.apply({
    property: 'minHeight',
    value: get(props, '$minHeight'),
    transform: getScale
  });
  styles.apply({
    property: 'maxHeight',
    value: get(props, '$maxHeight'),
    transform: getScale
  });
  styles.apply({
    property: 'overflowX',
    value: get(props, '$overflow'),
    transform: function transform(overflow) {
      if (overflow === 'scrollX') {
        return 'scroll';
      }

      return null;
    }
  });
  styles.apply({
    property: 'overflowY',
    value: get(props, '$overflow'),
    transform: function transform(overflow) {
      if (overflow === 'scrollY') {
        return 'scroll';
      }

      return null;
    }
  });
  styles.apply({
    property: 'overflow',
    value: get(props, '$overflow'),
    transform: function transform(overflow) {
      if (overflow !== 'scrollX' && overflow !== 'scrollY') {
        return overflow;
      }

      return null;
    }
  });
  styles.apply({
    property: 'margin',
    value: get(props, '$margin'),
    transform: getScale
  });
  styles.apply({
    property: 'marginTop',
    value: get(props, '$marginTop'),
    transform: getScale
  });
  styles.apply({
    property: 'marginRight',
    value: get(props, '$marginRight'),
    transform: getScale
  });
  styles.apply({
    property: 'marginBottom',
    value: get(props, '$marginBottom'),
    transform: getScale
  });
  styles.apply({
    property: 'marginLeft',
    value: get(props, '$marginLeft'),
    transform: getScale
  });
  styles.apply({
    property: 'padding',
    value: get(props, '$padding'),
    transform: getScale
  });
  styles.apply({
    property: 'paddingTop',
    value: get(props, '$paddingTop'),
    transform: getScale
  });
  styles.apply({
    property: 'paddingRight',
    value: get(props, '$paddingRight'),
    transform: getScale
  });
  styles.apply({
    property: 'paddingBottom',
    value: get(props, '$paddingBottom'),
    transform: getScale
  });
  styles.apply({
    property: 'paddingLeft',
    value: get(props, '$paddingLeft'),
    transform: getScale
  });
  styles.apply({
    property: 'placeContent',
    value: get(props, '$placeContent')
  });
  styles.apply({
    property: 'placeItems',
    value: get(props, '$placeItems')
  });
  styles.apply({
    property: 'placeSelf',
    value: get(props, '$placeSelf')
  });
  styles.apply({
    property: 'flexWrap',
    value: get(props, '$flexWrap'),
    transform: function transform() {
      return 'wrap';
    }
  });
  styles.apply({
    property: 'top',
    value: get(props, '$top'),
    transform: getScale
  });
  styles.apply({
    property: 'right',
    value: get(props, '$right'),
    transform: getScale
  });
  styles.apply({
    property: 'left',
    value: get(props, '$left'),
    transform: getScale
  });
  styles.apply({
    property: 'bottom',
    value: get(props, '$bottom'),
    transform: getScale
  });
  styles.apply({
    property: 'textOverflow',
    value: get(props, '$textOverflow')
  });
  styles.apply({
    property: 'whiteSpace',
    value: get(props, '$whiteSpace')
  });
  return styles.value();
});
StyledBlock.displayName = "StyledBlock";

function _extends$1n() { _extends$1n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1n.apply(this, arguments); }

function _slicedToArray$19(arr, i) { return _arrayWithHoles$19(arr) || _iterableToArrayLimit$19(arr, i) || _unsupportedIterableToArray$1b(arr, i) || _nonIterableRest$19(); }

function _nonIterableRest$19() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1b(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1b(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1b(o, minLen); }

function _arrayLikeToArray$1b(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$19(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$19(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties$S(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$U(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$U(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Block$1(_ref) {
  var forwardedRef = _ref.forwardedRef,
      children = _ref.children,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides,
      color = _ref.color,
      backgroundAttachment = _ref.backgroundAttachment,
      backgroundClip = _ref.backgroundClip,
      backgroundColor = _ref.backgroundColor,
      backgroundImage = _ref.backgroundImage,
      backgroundOrigin = _ref.backgroundOrigin,
      backgroundPosition = _ref.backgroundPosition,
      backgroundRepeat = _ref.backgroundRepeat,
      backgroundSize = _ref.backgroundSize,
      font = _ref.font,
      alignContent = _ref.alignContent,
      alignItems = _ref.alignItems,
      alignSelf = _ref.alignSelf,
      flexDirection = _ref.flexDirection,
      display = _ref.display,
      flex = _ref.flex,
      grid = _ref.grid,
      gridArea = _ref.gridArea,
      gridAutoColumns = _ref.gridAutoColumns,
      gridAutoFlow = _ref.gridAutoFlow,
      gridAutoRows = _ref.gridAutoRows,
      gridColumn = _ref.gridColumn,
      gridColumnEnd = _ref.gridColumnEnd,
      gridColumnGap = _ref.gridColumnGap,
      gridColumnStart = _ref.gridColumnStart,
      gridGap = _ref.gridGap,
      gridRow = _ref.gridRow,
      gridRowEnd = _ref.gridRowEnd,
      gridRowGap = _ref.gridRowGap,
      gridRowStart = _ref.gridRowStart,
      gridTemplate = _ref.gridTemplate,
      gridTemplateAreas = _ref.gridTemplateAreas,
      gridTemplateColumns = _ref.gridTemplateColumns,
      gridTemplateRows = _ref.gridTemplateRows,
      justifyContent = _ref.justifyContent,
      justifyItems = _ref.justifyItems,
      justifySelf = _ref.justifySelf,
      position = _ref.position,
      width = _ref.width,
      minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth,
      height = _ref.height,
      minHeight = _ref.minHeight,
      maxHeight = _ref.maxHeight,
      overflow = _ref.overflow,
      margin = _ref.margin,
      marginTop = _ref.marginTop,
      marginRight = _ref.marginRight,
      marginBottom = _ref.marginBottom,
      marginLeft = _ref.marginLeft,
      padding = _ref.padding,
      paddingTop = _ref.paddingTop,
      paddingRight = _ref.paddingRight,
      paddingBottom = _ref.paddingBottom,
      paddingLeft = _ref.paddingLeft,
      placeContent = _ref.placeContent,
      placeItems = _ref.placeItems,
      placeSelf = _ref.placeSelf,
      flexWrap = _ref.flexWrap,
      left = _ref.left,
      top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      textOverflow = _ref.textOverflow,
      whiteSpace = _ref.whiteSpace,
      restProps = _objectWithoutProperties$S(_ref, ["forwardedRef", "children", "as", "overrides", "color", "backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPosition", "backgroundRepeat", "backgroundSize", "font", "alignContent", "alignItems", "alignSelf", "flexDirection", "display", "flex", "grid", "gridArea", "gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridColumn", "gridColumnEnd", "gridColumnGap", "gridColumnStart", "gridGap", "gridRow", "gridRowEnd", "gridRowGap", "gridRowStart", "gridTemplate", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows", "justifyContent", "justifyItems", "justifySelf", "position", "width", "minWidth", "maxWidth", "height", "minHeight", "maxHeight", "overflow", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "placeContent", "placeItems", "placeSelf", "flexWrap", "left", "top", "right", "bottom", "textOverflow", "whiteSpace"]);

  var _getOverrides = getOverrides(overrides.Block, StyledBlock),
      _getOverrides2 = _slicedToArray$19(_getOverrides, 2),
      BaseBlock = _getOverrides2[0],
      baseBlockProps = _getOverrides2[1];

  return /*#__PURE__*/React$2.createElement(BaseBlock // coerced to any because because of how react components are typed.
  // cannot guarantee an html element
  // flowlint-next-line unclear-type:off
  , _extends$1n({
    ref: forwardedRef,
    $as: as,
    $color: color,
    $backgroundAttachment: backgroundAttachment,
    $backgroundClip: backgroundClip,
    $backgroundColor: backgroundColor,
    $backgroundImage: backgroundImage,
    $backgroundOrigin: backgroundOrigin,
    $backgroundPosition: backgroundPosition,
    $backgroundRepeat: backgroundRepeat,
    $backgroundSize: backgroundSize,
    $font: font,
    $alignContent: alignContent,
    $alignItems: alignItems,
    $alignSelf: alignSelf,
    $flexDirection: flexDirection,
    $display: display,
    $flex: flex,
    $grid: grid,
    $gridArea: gridArea,
    $gridAutoColumns: gridAutoColumns,
    $gridAutoFlow: gridAutoFlow,
    $gridAutoRows: gridAutoRows,
    $gridColumn: gridColumn,
    $gridColumnEnd: gridColumnEnd,
    $gridColumnGap: gridColumnGap,
    $gridColumnStart: gridColumnStart,
    $gridGap: gridGap,
    $gridRow: gridRow,
    $gridRowEnd: gridRowEnd,
    $gridRowGap: gridRowGap,
    $gridRowStart: gridRowStart,
    $gridTemplate: gridTemplate,
    $gridTemplateAreas: gridTemplateAreas,
    $gridTemplateColumns: gridTemplateColumns,
    $gridTemplateRows: gridTemplateRows,
    $justifyContent: justifyContent,
    $justifyItems: justifyItems,
    $justifySelf: justifySelf,
    $position: position,
    $width: width,
    $minWidth: minWidth,
    $maxWidth: maxWidth,
    $height: height,
    $minHeight: minHeight,
    $maxHeight: maxHeight,
    $overflow: overflow,
    $margin: margin,
    $marginTop: marginTop,
    $marginRight: marginRight,
    $marginBottom: marginBottom,
    $marginLeft: marginLeft,
    $padding: padding,
    $paddingTop: paddingTop,
    $paddingRight: paddingRight,
    $paddingBottom: paddingBottom,
    $paddingLeft: paddingLeft,
    $placeContent: placeContent,
    $placeItems: placeItems,
    $placeSelf: placeSelf,
    $flexWrap: flexWrap,
    $left: left,
    $top: top,
    $right: right,
    $bottom: bottom,
    $textOverflow: textOverflow,
    $whiteSpace: whiteSpace,
    "data-baseweb": "block"
  }, restProps, baseBlockProps), children);
}

var BlockComponent = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return /*#__PURE__*/React$2.createElement(Block$1, _extends$1n({}, props, {
    forwardedRef: ref
  }));
});
BlockComponent.displayName = 'Block';
var Block$2 = BlockComponent;

function _extends$1m() { _extends$1m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1m.apply(this, arguments); }
var DisplayLarge = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-displaylarge"
    }, props, {
      font: props.font || 'DisplayLarge',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
DisplayLarge.displayName = 'DisplayLarge';
var DisplayMedium = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-displaymedium"
    }, props, {
      font: props.font || 'DisplayMedium',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
DisplayMedium.displayName = 'DisplayMedium';
var DisplaySmall = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-displaysmall"
    }, props, {
      font: props.font || 'DisplaySmall',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
DisplaySmall.displayName = 'DisplaySmall';
var DisplayXSmall = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-displayxsmall"
    }, props, {
      font: props.font || 'DisplayXSmall',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
DisplayXSmall.displayName = 'DisplayXSmall';
var HeadingXXLarge$1 = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-headingxxlarge",
      as: props.as || 'h1'
    }, props, {
      font: props.font || 'HeadingXXLarge',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
HeadingXXLarge$1.displayName = 'HeadingXXLarge';
var HeadingXLarge$1 = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-headingxlarge",
      as: props.as || 'h2'
    }, props, {
      font: props.font || 'HeadingXLarge',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
HeadingXLarge$1.displayName = 'HeadingXLarge';
var HeadingLarge$1 = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-headinglarge",
      as: props.as || 'h3'
    }, props, {
      font: props.font || 'HeadingLarge',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
HeadingLarge$1.displayName = 'HeadingLarge';
var HeadingMedium$1 = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-headingmedium",
      as: props.as || 'h4'
    }, props, {
      font: props.font || 'HeadingMedium',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
HeadingMedium$1.displayName = 'HeadingMedium';
var HeadingSmall = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-headingsmall",
      as: props.as || 'h5'
    }, props, {
      font: props.font || 'HeadingSmall',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
HeadingSmall.displayName = 'HeadingSmall';
var HeadingXSmall = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-headingxsmall",
      as: props.as || 'h6'
    }, props, {
      font: props.font || 'HeadingXSmall',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
HeadingXSmall.displayName = 'HeadingXSmall';
var LabelLarge$1 = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-labellarge"
    }, props, {
      font: props.font || 'LabelLarge',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
LabelLarge$1.displayName = 'LabelLarge';
var LabelMedium$1 = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-labelmedium"
    }, props, {
      font: props.font || 'LabelMedium',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
LabelMedium$1.displayName = 'LabelMedium';
var LabelSmall$1 = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-labelsmall"
    }, props, {
      font: props.font || 'LabelSmall',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
LabelSmall$1.displayName = 'LabelSmall';
var LabelXSmall = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-labelxsmall"
    }, props, {
      font: props.font || 'LabelXSmall',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
LabelXSmall.displayName = 'LabelXSmall';
var ParagraphLarge$1 = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-paragraphlarge",
      as: props.as || 'p'
    }, props, {
      font: props.font || 'ParagraphLarge',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
ParagraphLarge$1.displayName = 'ParagraphLarge';
var ParagraphMedium = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-paragraphmedium",
      as: props.as || 'p'
    }, props, {
      font: props.font || 'ParagraphMedium',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
ParagraphMedium.displayName = 'ParagraphMedium';
var ParagraphSmall$1 = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-paragraphsmall",
      as: props.as || 'p'
    }, props, {
      font: props.font || 'ParagraphSmall',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
ParagraphSmall$1.displayName = 'ParagraphSmall';
var ParagraphXSmall = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-paragraphxsmall",
      as: props.as || 'p'
    }, props, {
      font: props.font || 'ParagraphXSmall',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
ParagraphXSmall.displayName = 'ParagraphXSmall';
var MonoDisplayLarge = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-monodisplaylarge"
    }, props, {
      font: props.font || 'MonoDisplayLarge',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
MonoDisplayLarge.displayName = 'MonoDisplayLarge';
var MonoDisplayMedium = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-monodisplaymedium"
    }, props, {
      font: props.font || 'MonoDisplayMedium',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
MonoDisplayMedium.displayName = 'MonoDisplayMedium';
var MonoDisplaySmall = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-monodisplaysmall"
    }, props, {
      font: props.font || 'MonoDisplaySmall',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
MonoDisplaySmall.displayName = 'MonoDisplaySmall';
var MonoDisplayXSmall = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-monodisplayxsmall"
    }, props, {
      font: props.font || 'MonoDisplayXSmall',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
MonoDisplayXSmall.displayName = 'MonoDisplayXSmall';
var MonoHeadingXXLarge = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-monoheadingxxlarge",
      as: props.as || 'h1'
    }, props, {
      font: props.font || 'MonoHeadingXXLarge',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
MonoHeadingXXLarge.displayName = 'MonoHeadingXXLarge';
var MonoHeadingXLarge = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-monoheadingxlarge",
      as: props.as || 'h2'
    }, props, {
      font: props.font || 'MonoHeadingXLarge',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
MonoHeadingXLarge.displayName = 'MonoHeadingXLarge';
var MonoHeadingLarge$1 = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-monoheadinglarge",
      as: props.as || 'h3'
    }, props, {
      font: props.font || 'MonoHeadingLarge',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
MonoHeadingLarge$1.displayName = 'MonoHeadingLarge';
var MonoHeadingMedium$1 = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-monoheadingmedium",
      as: props.as || 'h4'
    }, props, {
      font: props.font || 'MonoHeadingMedium',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
MonoHeadingMedium$1.displayName = 'MonoHeadingMedium';
var MonoHeadingSmall$1 = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-monoheadingsmall",
      as: props.as || 'h5'
    }, props, {
      font: props.font || 'MonoHeadingSmall',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
MonoHeadingSmall$1.displayName = 'MonoHeadingSmall';
var MonoHeadingXSmall$1 = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-monoheadingxsmall",
      as: props.as || 'h6'
    }, props, {
      font: props.font || 'MonoHeadingXSmall',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
MonoHeadingXSmall$1.displayName = 'MonoHeadingXSmall';
var MonoLabelLarge = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-monolabellarge"
    }, props, {
      font: props.font || 'MonoLabelLarge',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
MonoLabelLarge.displayName = 'MonoLabelLarge';
var MonoLabelMedium = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-monolabelmedium"
    }, props, {
      font: props.font || 'MonoLabelMedium',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
MonoLabelMedium.displayName = 'MonoLabelMedium';
var MonoLabelSmall = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-monolabelsmall"
    }, props, {
      font: props.font || 'MonoLabelSmall',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
MonoLabelSmall.displayName = 'MonoLabelSmall';
var MonoLabelXSmall = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-monolabelxsmall"
    }, props, {
      font: props.font || 'MonoLabelXSmall',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
MonoLabelXSmall.displayName = 'MonoLabelXSmall';
var MonoParagraphLarge = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-monoparagraphlarge",
      as: props.as || 'p'
    }, props, {
      font: props.font || 'MonoParagraphLarge',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
MonoParagraphLarge.displayName = 'MonoParagraphLarge';
var MonoParagraphMedium = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-monoparagraphmedium",
      as: props.as || 'p'
    }, props, {
      font: props.font || 'MonoParagraphMedium',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
MonoParagraphMedium.displayName = 'MonoParagraphMedium';
var MonoParagraphSmall = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-monoparagraphsmall",
      as: props.as || 'p'
    }, props, {
      font: props.font || 'MonoParagraphSmall',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
MonoParagraphSmall.displayName = 'MonoParagraphSmall';
var MonoParagraphXSmall = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Block$2, _extends$1m({
      "data-baseweb": "typo-monoparagraphxsmall",
      as: props.as || 'p'
    }, props, {
      font: props.font || 'MonoParagraphXSmall',
      color: props.color || 'contentPrimary',
      ref: ref
    }))
  );
});
MonoParagraphXSmall.displayName = 'MonoParagraphXSmall'; // TODO(v11): remove
var Paragraph4 = ParagraphXSmall;
var Label4 = LabelXSmall;
var Caption1 = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return /*#__PURE__*/React$2.createElement(Paragraph4, _extends$1m({}, props, {
    color: props.color || 'contentSecondary',
    ref: ref
  }));
});
Caption1.displayName = 'Caption1';
var Caption2 = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return /*#__PURE__*/React$2.createElement(Label4, _extends$1m({}, props, {
    color: props.color || 'contentSecondary'
  }));
});
Caption2.displayName = 'Caption2';

const typography$6 = {
    LabelLarge: {
        fontFamily: tokens$1['font-family'].heading,
        fontSize: tokens$1['font-size'].medium,
        fontWeight: FontWeight.Regular,
        lineHeight: tokens$1['line-height']['label-large'],
    },
    LabelMedium: {
        fontFamily: tokens$1['font-family'].heading,
        fontSize: tokens$1['font-size'].root,
        fontWeight: FontWeight.Regular,
        lineHeight: tokens$1['line-height'].label,
    },
    LabelMediumTight: {
        fontFamily: tokens$1['font-family'].heading,
        fontSize: tokens$1['font-size'].root,
        fontWeight: FontWeight.Regular,
        lineHeight: tokens$1['line-height']['label-tight'],
    },
    LabelSmall: {
        fontFamily: tokens$1['font-family'].heading,
        fontSize: tokens$1['font-size'].small,
        fontWeight: FontWeight.Regular,
        lineHeight: tokens$1['line-height']['label-small'],
    },
    LabelSmallTight: {
        fontFamily: tokens$1['font-family'].heading,
        fontSize: tokens$1['font-size'].small,
        fontWeight: FontWeight.Regular,
        lineHeight: tokens$1['line-height']['label-small-tight'],
    },
};
var LineHeightVariant;
(function (LineHeightVariant) {
    LineHeightVariant[LineHeightVariant["Default"] = 0] = "Default";
    LineHeightVariant[LineHeightVariant["Tight"] = 1] = "Tight";
})(LineHeightVariant || (LineHeightVariant = {}));

const themedUseStyletron = createThemedUseStyletron();
const themedStyled = createThemedStyled();
const themedWithStyle = createThemedWithStyle();

const LabelLarge = (props) => {
    const { fontWeight = FontWeight.Regular, color, ...restProps } = props;
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(LabelLarge$1, { color: color !== null && color !== void 0 ? color : theme.colors['neutral-100'], overrides: {
            Block: {
                style: {
                    ...typography$6.LabelLarge,
                    fontWeight,
                },
            },
        }, ...restProps }));
};
const LabelMedium = (props) => {
    const { fontWeight = FontWeight.Regular, color, lineHeight = LineHeightVariant.Default, ...restProps } = props;
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(LabelMedium$1, { color: color !== null && color !== void 0 ? color : theme.colors['neutral-100'], overrides: {
            Block: {
                style: {
                    ...typography$6.LabelMedium,
                    fontWeight,
                    ...(lineHeight === LineHeightVariant.Tight ? {
                        lineHeight: tokens$1['line-height']['label-tight'],
                    } : {}),
                },
            },
        }, ...restProps }));
};
const LabelSmall = (props) => {
    const { fontWeight = FontWeight.Regular, color, lineHeight = LineHeightVariant.Default, ...restProps } = props;
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(LabelSmall$1, { color: color !== null && color !== void 0 ? color : theme.colors['neutral-100'], overrides: {
            Block: {
                style: {
                    ...typography$6.LabelSmall,
                    fontWeight,
                    ...(lineHeight === LineHeightVariant.Tight ? {
                        lineHeight: tokens$1['line-height']['label-small-tight'],
                    } : {}),
                },
            },
        }, ...restProps }));
};
const LabelSmallTight = (props) => {
    const { fontWeight = FontWeight.Regular, color, ...restProps } = props;
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(LabelSmall$1, { color: color !== null && color !== void 0 ? color : theme.colors['neutral-100'], overrides: {
            Block: {
                style: {
                    ...typography$6.LabelSmallTight,
                    fontWeight,
                },
            },
        }, ...restProps }));
};

const StyledToggleIcon = themedWithStyle(ToggleIcon, {
    display: 'none',
});
const StyledContent$2 = themedWithStyle(Content, {
    ...padding('0px'),
    backgroundColor: 'transparent',
});
const StyledHeader = themedWithStyle(Header, ({ $isFocusVisible, $disabled, $isParent, $size, $theme, $noBorder }) => ({
    ...(($size === 'large' && $isParent) ? {
        ...typography$6.LabelMedium,
        ...padding($theme.sizing['xx-small'], $theme.sizing.small),
    } : {
        ...typography$6.LabelSmall,
        ...padding($theme.sizing['xx-small'], $theme.sizing['xx-small']),
    }),
    ...margin('0px'),
    alignItems: 'center',
    backgroundColor: 'transparent',
    display: 'flex',
    fontWeight: FontWeight.Bold,
    ...($isFocusVisible ? {
        backgroundColor: $theme.colors['neutral-0'],
        boxShadow: $theme.boxShadow.focus,
        outline: 'none',
    } : {}),
    ...borderWidth('0px'),
    ...($disabled ? {
        opacity: $theme.opacity.disabled,
    } : {}),
    ':hover': {
        color: 'currentColor',
    },
    ...(!$noBorder
        ? border$1('top', '1px', 'solid', $theme.colors['neutral-25'])
        : {}),
}));
const StyledPanelContainer = themedWithStyle(PanelContainer, ({
    ...borderWidth('0px'),
    backgroundColor: 'transparent',
}));

const StyledSvg = themedStyled('svg', ({ $clickable, $theme }) => ({
    ...($clickable ? {
        ':focus': {
            boxShadow: $theme === null || $theme === void 0 ? void 0 : $theme.boxShadow.focus,
            outline: 'none',
        },
        cursor: 'pointer',
    } : {}),
}));
const Icon$2 = (props) => {
    const { children, title, size = tokens$1['icon-scale'].regular, color, onClick, ...restProps } = props;
    const [, theme] = themedUseStyletron();
    // Using a size such as scale(1.0), extract the number and set that to
    // width and height
    const [match] = String(size).match(numberPattern);
    const dimension = 24 * Number(match);
    const $clickable = onClick && typeof onClick === 'function';
    const passThroughProps = {
        $clickable,
        $theme: theme,
        fill: color !== null && color !== void 0 ? color : theme.colors['neutral-100'],
        height: dimension,
        onClick,
        ...($clickable ? {
            role: 'button',
            tabIndex: 0,
        } : {}),
        title,
        viewBox: '0 0 24 24',
        width: dimension,
        ...restProps,
    };
    return (React$2.createElement(StyledSvg, { "data-baseweb": "icon", ...passThroughProps },
        title ? React$2.createElement("title", null, title) : null,
        children));
};

/* eslint-disable max-len */
const BgPauseIcon = (props) => {
    const { title = 'Bg Pause Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", fillOpacity: "0.5" }),
        React$2.createElement("rect", { x: "9", y: "7", width: "1.8", height: "10", rx: "0.9", fill: "white" }),
        React$2.createElement("rect", { x: "13.2", y: "7", width: "1.8", height: "10", rx: "0.9", fill: "white" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const BgPlayIcon = (props) => {
    const { title = 'Bg Play Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", fillOpacity: "0.5" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 12.2188C16.5 12.5015 16.3495 12.7628 16.1053 12.9042L10.1842 16.3315C9.93995 16.4728 9.639 16.4728 9.39474 16.3315C9.15047 16.1901 9 15.9288 9 15.646L9 8.79149C9 8.50872 9.15047 8.24743 9.39474 8.10604C9.639 7.96465 9.93995 7.96465 10.1842 8.10604L16.1053 11.5333C16.3495 11.6747 16.5 11.936 16.5 12.2188Z", fill: "white" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const BoundaryL0FillIcon = (props) => {
    const { title = 'Boundary L0 Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("rect", { x: "2", y: "2", width: "20", height: "20", rx: "2.85714" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const BoundaryL1FillIcon = (props) => {
    const { title = 'Boundary L1 Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("rect", { x: "4", y: "4", width: "16", height: "16", rx: "2" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const BoundaryL2FillIcon = (props) => {
    const { title = 'Boundary L2 Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("rect", { x: "6", y: "6", width: "12", height: "12", rx: "2" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const BoundaryPointsFillIcon = (props) => {
    const { title = 'Boundary Points Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("ellipse", { cx: "9.6", cy: "16.7999", rx: "2.4", ry: "2.4" }),
        React$2.createElement("circle", { cx: "7.2", cy: "7.20005", r: "2.4" }),
        React$2.createElement("ellipse", { cx: "16.8", cy: "10.7999", rx: "2.4", ry: "2.4" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CautionFillIcon = (props) => {
    const { title = 'Caution Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.459 15.5L14.5308 3.5C13.3761 1.5 10.4893 1.5 9.3346 3.5L2.4064 15.5C1.2517 17.5 2.69508 20 5.00448 20H18.8609C21.1703 20 22.6137 17.5 21.459 15.5ZM12.9327 8C12.9327 7.44772 12.485 7 11.9327 7C11.3804 7 10.9327 7.44772 10.9327 8V12C10.9327 12.5523 11.3804 13 11.9327 13C12.485 13 12.9327 12.5523 12.9327 12V8ZM12.9327 15C12.9327 15.5523 12.485 16 11.9327 16C11.3804 16 10.9327 15.5523 10.9327 15C10.9327 14.4477 11.3804 14 11.9327 14C12.485 14 12.9327 14.4477 12.9327 15Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CheckmarkFillIcon = (props) => {
    const { title = 'Checkmark Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM8.05162 13.3397C7.62854 12.9847 6.99779 13.0399 6.64279 13.463C6.28779 13.886 6.34297 14.5168 6.76604 14.8718L9.76986 17.3923C9.97303 17.5628 10.2356 17.6456 10.4998 17.6224C10.764 17.5993 11.0082 17.4722 11.1787 17.269L17.6371 9.57224C17.9921 9.14916 17.9369 8.51841 17.5138 8.1634C17.0907 7.8084 16.46 7.86359 16.105 8.28666L10.2894 15.2174L8.05162 13.3397Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CircleCautionFillIcon = (props) => {
    const { title = 'Circle Caution Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V8ZM13 15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CloseCircleFillIcon = (props) => {
    const { title = 'Close Circle Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM15.5355 8.46424C15.145 8.07372 14.5118 8.07372 14.1213 8.46424L12 10.5856L9.87868 8.46424C9.48815 8.07372 8.85499 8.07372 8.46447 8.46424C8.07394 8.85477 8.07394 9.48793 8.46447 9.87846L10.5858 11.9998L8.46447 14.1211C8.07394 14.5116 8.07394 15.1448 8.46447 15.5353C8.85499 15.9258 9.48816 15.9258 9.87868 15.5353L12 13.414L14.1213 15.5353C14.5118 15.9258 15.145 15.9258 15.5355 15.5353C15.9261 15.1448 15.9261 14.5116 15.5355 14.1211L13.4142 11.9998L15.5355 9.87846C15.9261 9.48793 15.9261 8.85477 15.5355 8.46424Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ClosedCaptionFillIcon = (props) => {
    const { title = 'Closed Caption Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 5C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V6C21 5.44772 20.5523 5 20 5H4ZM9.456 15.1441C7.668 15.1441 6.384 13.8841 6.384 12.0961C6.384 10.3201 7.668 9.06006 9.456 9.06006C10.644 9.06006 11.364 9.57606 11.748 10.1161L10.752 11.0401C10.476 10.6441 10.056 10.4161 9.528 10.4161C8.604 10.4161 7.956 11.0881 7.956 12.0961C7.956 13.1041 8.604 13.7881 9.528 13.7881C10.056 13.7881 10.476 13.5481 10.752 13.1641L11.748 14.0881C11.364 14.6281 10.644 15.1441 9.456 15.1441ZM15.4443 15.1441C13.6563 15.1441 12.3723 13.8841 12.3723 12.0961C12.3723 10.3201 13.6563 9.06006 15.4443 9.06006C16.6323 9.06006 17.3523 9.57606 17.7363 10.1161L16.7403 11.0401C16.4643 10.6441 16.0443 10.4161 15.5163 10.4161C14.5923 10.4161 13.9443 11.0881 13.9443 12.0961C13.9443 13.1041 14.5923 13.7881 15.5163 13.7881C16.0443 13.7881 16.4643 13.5481 16.7403 13.1641L17.7363 14.0881C17.3523 14.6281 16.6323 15.1441 15.4443 15.1441Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FastforwardFillIcon = (props) => {
    const { title = 'Fastforward Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 13.8L5.5145 17.0913C4.84797 17.4912 4 17.0111 4 16.2338V7.76619C4 6.9889 4.84797 6.50879 5.5145 6.9087L11 10.2V7.76619C11 6.9889 11.848 6.50879 12.5145 6.9087L19.5708 11.1425C20.2182 11.5309 20.2182 12.4691 19.5708 12.8575L12.5145 17.0913C11.848 17.4912 11 17.0111 11 16.2338V13.8Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const HomeFillIcon = (props) => {
    const { title = 'Home Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M4 9.30402C4 8.99132 4.14628 8.69661 4.39535 8.50753L11.3953 3.1935C11.7528 2.92215 12.2472 2.92215 12.6047 3.1935L19.6047 8.50753C19.8537 8.69661 20 8.99132 20 9.30402V18.9999C20 19.5522 19.5523 19.9999 19 19.9999H5C4.44771 19.9999 4 19.5522 4 18.9999V9.30402ZM14 9.99988H10C8.89543 9.99988 8 10.8953 8 11.9999V15.9999C8 17.1044 8.89543 17.9999 10 17.9999H14C15.1046 17.9999 16 17.1044 16 15.9999V11.9999C16 10.8953 15.1046 9.99988 14 9.99988Z", stroke: color, strokeWidth: "2" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const MapPinFillIcon = (props) => {
    const { title = 'Map Pin Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22C13.5 22 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 10.5 22 12 22ZM13.2722 8.45675C12.9047 8.15385 12.4412 7.99199 11.9651 8.00031C11.489 8.00862 11.0314 8.18655 10.6748 8.50209C10.3181 8.81763 10.0857 9.25008 10.0195 9.72165C9.9532 10.1932 10.0574 10.673 10.3132 11.0746C10.4269 11.253 10.5671 11.4108 10.7278 11.5432C11.154 11.8945 11.2147 12.5248 10.8634 12.9509C10.5121 13.3771 9.88186 13.4378 9.4557 13.0865C9.13427 12.8215 8.85373 12.506 8.62644 12.1492C8.11471 11.3459 7.90639 10.3865 8.03894 9.44331C8.17149 8.50016 8.63621 7.63526 9.34953 7.00418C10.0628 6.37309 10.9779 6.01723 11.9302 6.00061C12.8825 5.98399 13.8094 6.30769 14.5443 6.9135C15.2792 7.51931 15.7739 8.36747 15.9392 9.30541C16.1046 10.2434 15.9299 11.2095 15.4465 12.0302C15.2078 12.4354 14.9016 12.792 14.5443 13.0865C14.1182 13.4378 13.4879 13.3771 13.1366 12.951C12.7853 12.5248 12.846 11.8945 13.2722 11.5432C13.4508 11.396 13.6039 11.2177 13.7233 11.0151C13.965 10.6048 14.0523 10.1217 13.9696 9.6527C13.8869 9.18373 13.6396 8.75966 13.2722 8.45675Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const MarketFillIcon = (props) => {
    const { title = 'Market Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 10.1424C21.6171 9.59795 22 8.83922 22 8V5C22 3.34315 20.5076 2 18.6667 2H5.33333C3.49238 2 2 3.34315 2 5V8C2 8.83922 2.38288 9.59795 3 10.1424V19.9999C3 21.1045 3.89543 21.9999 5 21.9999H19C20.1046 21.9999 21 21.1045 21 19.9999V10.1424ZM10.0265 7.1354C9.62682 6.59433 8.81763 6.59433 8.41791 7.1354L7.3717 8.55155C7.16891 8.82606 6.82876 9 6.44444 9H5.33333C4.71968 9 4.22222 8.55228 4.22222 8V5C4.22222 4.44772 4.71968 4 5.33333 4H18.6667C19.2803 4 19.7778 4.44772 19.7778 5V8C19.7778 8.55228 19.2803 9 18.6667 9H17.5556C17.1712 9 16.8311 8.82606 16.6283 8.55155L15.5821 7.13539C15.1824 6.59432 14.3732 6.59432 13.9735 7.13539L12.9273 8.55155C12.7245 8.82606 12.3843 9 12 9C11.6157 9 11.2755 8.82606 11.0727 8.55155L10.0265 7.1354ZM17.5556 11C17.2071 11 16.8711 10.9519 16.5553 10.8626C15.8206 10.6548 15.1955 10.2243 14.7778 9.65889C14.3601 10.2243 13.735 10.6548 13.0003 10.8626C12.6845 10.9519 12.3485 11 12 11C11.6515 11 11.3155 10.9519 10.9997 10.8626C10.265 10.6548 9.6399 10.2243 9.22222 9.6589C8.80454 10.2243 8.17944 10.6548 7.4447 10.8626C7.12894 10.9519 6.79294 11 6.44444 11H5.33333C5.22083 11 5.10964 10.995 5 10.9852V19.9999L19 19.9999V10.9852C18.8904 10.995 18.7792 11 18.6667 11H17.5556Z" }),
        React$2.createElement("path", { d: "M4 4H20V9H4V4Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 14C8 12.8954 8.89543 12 10 12H14C15.1046 12 16 12.8954 16 14V18C16 18.5523 15.5523 19 15 19C14.4477 19 14 18.5523 14 18V14H10V18C10 18.5523 9.55228 19 9 19C8.44772 19 8 18.5523 8 18V14Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const PaymentsFillIcon = (props) => {
    const { title = 'Payments Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H6ZM19 14.8293V15C19 15.5523 18.5523 16 18 16H6C5.44772 16 5 15.5523 5 15V14.8293C5.31278 14.9398 5.64936 15 6 15H18C18.3506 15 18.6872 14.9398 19 14.8293ZM19 18V17.8293C18.6872 17.9398 18.3506 18 18 18H6C5.64936 18 5.31278 17.9398 5 17.8293V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18ZM14 9C14 10.1046 13.1046 11 12 11C10.8954 11 10 10.1046 10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const PlayFillIcon = (props) => {
    const { title = 'Play Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.0389 14.2229L8.90557 20.0734C7.19445 21.0613 5.05557 19.8264 5.05557 17.8506V6.1496C5.05557 4.17376 7.19447 2.93889 8.90557 3.9268L19.0389 9.77728C20.75 10.7652 20.75 13.235 19.0389 14.2229Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ProfileFillIcon = (props) => {
    const { title = 'Profile Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12ZM6 17C6 14.7909 7.79086 13 10 13H14C16.2091 13 18 14.7909 18 17V19C18 20.1046 17.1046 21 16 21H8C6.89543 21 6 20.1046 6 19V17Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const RewardFillIcon = (props) => {
    const { title = 'Reward Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.66506 3.2499C8.46933 2.55955 6.94036 2.96924 6.25 4.16497C5.715 5.09161 5.84065 6.21839 6.4808 6.9999H6C4.89543 6.9999 4 7.89534 4 8.9999V18.9999C4 20.1045 4.89543 20.9999 6 20.9999H18C19.1046 20.9999 20 20.1045 20 18.9999V8.9999C20 7.89534 19.1046 6.9999 18 6.9999H17.0815C17.7216 6.21839 17.8473 5.09161 17.3123 4.16497C16.6219 2.96924 15.0929 2.55955 13.8972 3.2499L12.1651 4.2499C12.0264 4.33001 11.8982 4.42141 11.7811 4.52228C11.664 4.42141 11.5359 4.33001 11.3971 4.2499L9.66506 3.2499ZM10.3971 5.98196L8.66506 4.98196C8.42592 4.84388 8.12012 4.92582 7.98205 5.16497C7.84398 5.40411 7.92592 5.70991 8.16506 5.84798L9.89711 6.84798C10.1363 6.98605 10.4421 6.90411 10.5801 6.66497C10.7182 6.42582 10.6363 6.12003 10.3971 5.98196ZM13.1651 5.98196L14.8972 4.98196C15.1363 4.84388 15.4421 4.92582 15.5802 5.16497C15.7183 5.40411 15.6363 5.70991 15.3972 5.84798L13.6651 6.84798C13.426 6.98605 13.1202 6.90411 12.9821 6.66497C12.8441 6.42582 12.926 6.12003 13.1651 5.98196ZM17 11.9999C17 12.5522 16.5523 12.9999 16 12.9999H8C7.44771 12.9999 7 12.5522 7 11.9999C7 11.4476 7.44771 10.9999 8 10.9999H16C16.5523 10.9999 17 11.4476 17 11.9999Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const RewindFillIcon = (props) => {
    const { title = 'Rewind Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 13.8L18.4855 17.0913C19.152 17.4912 20 17.0111 20 16.2338V7.76619C20 6.9889 19.152 6.50879 18.4855 6.9087L13 10.2V7.76619C13 6.9889 12.152 6.50879 11.4855 6.9087L4.42916 11.1425C3.78182 11.5309 3.78181 12.4691 4.42915 12.8575L11.4855 17.0913C12.152 17.4912 13 17.0111 13 16.2338V13.8Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const SettingsFillIcon = (props) => {
    const { title = 'Settings Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M9.75759 5.50845L10.3824 5.25554V4.58151V3L14.3824 3V4.58153V5.25556L15.0072 5.50846C15.6042 5.75013 16.1607 6.07206 16.6633 6.46117L17.1941 6.87213L17.7755 6.53648L19.0227 5.81642L21.0574 9.34062L19.8109 10.0603L19.2307 10.3952L19.3198 11.0592C19.361 11.3665 19.3824 11.6805 19.3824 12C19.3824 12.309 19.3624 12.6129 19.3238 12.9105L19.238 13.5717L19.8155 13.9051L21.0735 14.6314L19.0068 18.211L17.7483 17.4845L17.1697 17.1504L16.6395 17.5572C16.1432 17.9381 15.5948 18.2537 15.0072 18.4915L14.3824 18.7444V19.4185V21H10.3824V19.4185V18.7445L9.75759 18.4916C9.16039 18.2498 8.60369 17.9278 8.10096 17.5385L7.57014 17.1275L6.98873 17.4632L5.74194 18.183L3.70724 14.6588L4.95371 13.9391L5.53385 13.6042L5.44484 12.9402C5.40367 12.6332 5.38235 12.3193 5.38235 12C5.38235 11.691 5.40232 11.3871 5.44091 11.0895L5.52668 10.4283L4.94922 10.0949L3.69136 9.36866L5.75805 5.78905L7.01637 6.51554L7.59505 6.84964L8.12516 6.44284C8.62154 6.06193 9.16996 5.74631 9.75759 5.50845ZM12.3824 16C14.5915 16 16.3824 14.2091 16.3824 12C16.3824 9.79086 14.5915 8 12.3824 8C10.1732 8 8.38238 9.79086 8.38238 12C8.38238 14.2091 10.1732 16 12.3824 16Z", stroke: color, strokeWidth: "2" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const StopFillIcon = (props) => {
    const { title = 'Stop Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("rect", { x: "5", y: "5", width: "14", height: "14", rx: "1" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const TaskFillIcon = (props) => {
    const { title = 'Task Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M4 5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V5ZM10.4142 8.79285C9.63317 8.0118 8.36683 8.0118 7.58579 8.79285C6.80474 9.57389 6.80474 10.8402 7.58579 11.6213L9.70711 13.7426C9.80525 13.8407 9.91106 13.9265 10.0226 14H7C5.89543 14 5 14.8955 5 16C5 17.1046 5.89543 18 7 18H17C18.1046 18 19 17.1046 19 16C19 14.8955 18.1046 14 17 14H12.22C12.3316 13.9265 12.4374 13.8407 12.5355 13.7426L16.0711 10.2071C16.8521 9.42601 16.8521 8.15968 16.0711 7.37863C15.29 6.59758 14.0237 6.59758 13.2426 7.37863L11.1213 9.49995L10.4142 8.79285Z", stroke: color, strokeWidth: "2" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilledAlertFillIcon = (props) => {
    const { title = 'Filled Alert Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.93581 11.2354C4.93581 8.13222 6.02061 5.51098 8.85023 4.66884C8.85023 1.24771 14.7219 0.975657 14.7219 4.66884C17.5515 5.51098 18.6363 8.13222 18.6363 11.2354V15.1498C18.6363 15.6707 18.8682 16.0985 19.1063 16.5376C19.3572 17.0004 19.6149 17.4757 19.6149 18.0856C19.6149 18.6261 19.1768 19.0642 18.6363 19.0642H4.93581C4.39535 19.0642 3.95721 19.0642 3.95721 18.0856C3.95721 17.4757 4.2149 17.0004 4.46581 16.5376C4.70386 16.0985 4.93581 15.6707 4.93581 15.1498V11.2354Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.7433 20.0428H9.82884C9.82884 21.1237 10.7051 22 11.786 22C12.867 22 13.7433 21.1237 13.7433 20.0428Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.83636 3.96055C5.83636 4.36453 5.59776 4.72135 5.2864 4.97874C4.60213 5.54439 4.1492 6.44211 3.96814 7.72002C3.89418 8.242 3.46966 8.66064 2.94246 8.66064C2.38829 8.66064 1.93868 8.2002 2.00686 7.65023C2.24876 5.69889 3.02301 4.05547 4.52718 3.10825C5.13442 2.72585 5.83636 3.24293 5.83636 3.96055Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.6577 3.96055C17.6577 4.36453 17.8963 4.72135 18.2076 4.97874C18.8919 5.54439 19.3448 6.44211 19.5259 7.72002C19.5998 8.242 20.0244 8.66064 20.5516 8.66064C21.1057 8.66064 21.5554 8.2002 21.4872 7.65023C21.2453 5.69889 20.471 4.05547 18.9669 3.10825C18.3596 2.72585 17.6577 3.24293 17.6577 3.96055Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilledDarkFillIcon = (props) => {
    const { title = 'Filled Dark Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M8.03964 18.0583C11.7797 19.0371 15.6407 16.8082 16.6635 13.08C17.6863 9.35172 15.4836 5.53592 11.7436 4.55713C10.8413 4.32099 9.93191 4.27155 9.05708 4.38483C8.27536 4.48604 8.11628 5.46899 8.59727 6.08374C9.8038 7.62581 10.2882 9.69953 9.72704 11.7449C9.25328 13.4718 8.12375 14.8522 6.6795 15.6894C5.99664 16.0852 5.76676 17.0536 6.45324 17.4292C6.94294 17.6971 7.47369 17.9102 8.03964 18.0583Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilledDeleteFillIcon = (props) => {
    const { title = 'Filled Delete Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2C8.89543 2 8 2.89543 8 4V5H4C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H16V4C16 2.89543 15.1046 2 14 2H10Z" }),
        React$2.createElement("path", { d: "M17 8H5V10V19C5 20.6569 6.34315 22 8 22H16C17.6569 22 19 20.6569 19 19V10V8H17Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilledDragFillIcon = (props) => {
    const { title = 'Filled Drag Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("circle", { cx: "16", cy: "20", r: "2", transform: "rotate(90 16 20)" }),
        React$2.createElement("circle", { cx: "16", cy: "4", r: "2", transform: "rotate(90 16 4)" }),
        React$2.createElement("circle", { cx: "16", cy: "12", r: "2" }),
        React$2.createElement("circle", { cx: "8", cy: "12", r: "2" }),
        React$2.createElement("circle", { cx: "8", cy: "4", r: "2", transform: "rotate(90 8 4)" }),
        React$2.createElement("circle", { cx: "8", cy: "20", r: "2", transform: "rotate(90 8 20)" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilledExtremelySatisfiedFillIcon = (props) => {
    const { title = 'Filled Extremely Satisfied Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11ZM17 9.5C17 10.3284 16.3284 11 15.5 11C14.6716 11 14 10.3284 14 9.5C14 8.67157 14.6716 8 15.5 8C16.3284 8 17 8.67157 17 9.5ZM6.41114 14.1872C6.17571 13.5861 6.67111 13 7.31669 13C7.79305 13 8.19637 13.3302 8.40599 13.7579C9.05669 15.0858 10.4216 16 12 16C13.5784 16 14.9433 15.0858 15.594 13.7579C15.8036 13.3302 16.2069 13 16.6833 13C17.3289 13 17.8243 13.5861 17.5888 14.1872C16.7146 16.4193 14.5419 18 12 18C9.45807 18 7.28534 16.4193 6.41114 14.1872Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilledExtremelyUnsatisfiedFillIcon = (props) => {
    const { title = 'Filled Extremely Unsatisfied Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("mask", { id: "path-1-inside-1_9877_567805", fill: "white" },
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11ZM17 9.5C17 10.3284 16.3284 11 15.5 11C14.6716 11 14 10.3284 14 9.5C14 8.67157 14.6716 8 15.5 8C16.3284 8 17 8.67157 17 9.5ZM8.66436 16.8462C9.47506 15.6907 10.6867 15 12 15C13.3133 15 14.525 15.6907 15.3357 16.8462C15.6529 17.2983 16.2765 17.4076 16.7286 17.0904C17.1807 16.7732 17.2901 16.1496 16.9729 15.6975C15.8412 14.0845 14.0529 13 12 13C9.94708 13 8.15885 14.0845 7.02715 15.6975C6.70994 16.1496 6.8193 16.7732 7.2714 17.0904C7.7235 17.4076 8.34715 17.2983 8.66436 16.8462Z", fill: "none" })),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11ZM17 9.5C17 10.3284 16.3284 11 15.5 11C14.6716 11 14 10.3284 14 9.5C14 8.67157 14.6716 8 15.5 8C16.3284 8 17 8.67157 17 9.5ZM8.66436 16.8462C9.47506 15.6907 10.6867 15 12 15C13.3133 15 14.525 15.6907 15.3357 16.8462C15.6529 17.2983 16.2765 17.4076 16.7286 17.0904C17.1807 16.7732 17.2901 16.1496 16.9729 15.6975C15.8412 14.0845 14.0529 13 12 13C9.94708 13 8.15885 14.0845 7.02715 15.6975C6.70994 16.1496 6.8193 16.7732 7.2714 17.0904C7.7235 17.4076 8.34715 17.2983 8.66436 16.8462Z" }),
        React$2.createElement("path", { d: "M8.66436 16.8462L10.3016 17.9949H10.3016L8.66436 16.8462ZM15.3357 16.8462L13.6984 17.9949H13.6984L15.3357 16.8462ZM16.9729 15.6975L15.3357 16.8462H15.3357L16.9729 15.6975ZM7.02715 15.6975L8.66436 16.8462L8.66436 16.8462L7.02715 15.6975ZM20 12C20 16.4183 16.4183 20 12 20V24C18.6274 24 24 18.6274 24 12H20ZM12 4C16.4183 4 20 7.58172 20 12H24C24 5.37258 18.6274 0 12 0V4ZM4 12C4 7.58172 7.58172 4 12 4V0C5.37258 0 0 5.37258 0 12H4ZM12 20C7.58172 20 4 16.4183 4 12H0C0 18.6274 5.37258 24 12 24V20ZM8 9.5C8 9.22386 8.22386 9 8.5 9V13C10.433 13 12 11.433 12 9.5H8ZM8.5 10C8.22386 10 8 9.77614 8 9.5H12C12 7.567 10.433 6 8.5 6V10ZM9 9.5C9 9.77614 8.77614 10 8.5 10V6C6.567 6 5 7.567 5 9.5H9ZM8.5 9C8.77614 9 9 9.22386 9 9.5H5C5 11.433 6.567 13 8.5 13V9ZM15.5 13C17.433 13 19 11.433 19 9.5H15C15 9.22386 15.2239 9 15.5 9V13ZM12 9.5C12 11.433 13.567 13 15.5 13V9C15.7761 9 16 9.22386 16 9.5H12ZM15.5 6C13.567 6 12 7.567 12 9.5H16C16 9.77614 15.7761 10 15.5 10V6ZM19 9.5C19 7.567 17.433 6 15.5 6V10C15.2239 10 15 9.77614 15 9.5H19ZM12 13C9.94899 13 8.16008 14.0828 7.02715 15.6975L10.3016 17.9949C10.79 17.2987 11.4244 17 12 17V13ZM16.9729 15.6975C15.8399 14.0828 14.051 13 12 13V17C12.5756 17 13.21 17.2987 13.6984 17.9949L16.9729 15.6975ZM15.5799 15.4532C16.032 15.136 16.6556 15.2454 16.9729 15.6975L13.6984 17.9949C14.6501 19.3512 16.521 19.6793 17.8773 18.7276L15.5799 15.4532ZM15.3357 16.8462C15.0184 16.3941 15.1278 15.7704 15.5799 15.4532L17.8773 18.7276C19.2336 17.776 19.5617 15.905 18.6101 14.5487L15.3357 16.8462ZM12 15C13.312 15 14.5241 15.6896 15.3357 16.8462L18.6101 14.5487C17.1582 12.4795 14.7938 11 12 11V15ZM8.66436 16.8462C9.47589 15.6896 10.688 15 12 15V11C9.20619 11 6.84181 12.4795 5.38995 14.5487L8.66436 16.8462ZM8.42012 15.4532C8.87222 15.7704 8.98157 16.3941 8.66436 16.8462L5.38995 14.5487C4.43832 15.905 4.76637 17.776 6.12268 18.7276L8.42012 15.4532ZM7.02715 15.6975C7.34436 15.2454 7.96802 15.136 8.42012 15.4532L6.12268 18.7276C7.47898 19.6793 9.34994 19.3512 10.3016 17.9949L7.02715 15.6975Z", mask: "url(#path-1-inside-1_9877_567805)" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilledFolderFillIcon = (props) => {
    const { title = 'Filled Folder Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M2 6C2 4.89543 2.89543 4 4 4H9.17157C9.70201 4 10.2107 4.21071 10.5858 4.58579L11.4142 5.41421C11.7893 5.78929 12.298 6 12.8284 6H20C21.1046 6 22 6.89543 22 8V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilledGroupFillIcon = (props) => {
    const { title = 'Filled Group Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.8351 12.1139C13.6076 11.0655 14.0625 9.78016 14.0625 8.3913C14.0625 7.05083 13.6388 5.80673 12.9146 4.77914C13.6506 4.28755 14.5409 4 15.5 4C18.0313 4 20.0833 6.00294 20.0833 8.47368C20.0833 10.9444 18.0313 12.9474 15.5 12.9474C14.5061 12.9474 13.586 12.6386 12.8351 12.1139ZM14.5952 21C14.8541 20.5039 15 19.9424 15 19.3478V17.5217C15 16.1063 14.4488 14.8163 13.5441 13.8441C13.5848 13.8428 13.6256 13.8421 13.6667 13.8421H17.3333C19.3584 13.8421 21 15.4445 21 17.4211V19.2105C21 20.1988 20.1792 21 19.1667 21H14.5952Z" }),
        React$2.createElement("path", { d: "M7.5 12.9474C10.0313 12.9474 12.0833 10.9444 12.0833 8.47368C12.0833 6.00294 10.0313 4 7.5 4C4.96869 4 2.91667 6.00294 2.91667 8.47368C2.91667 10.9444 4.96869 12.9474 7.5 12.9474Z" }),
        React$2.createElement("path", { d: "M2 17.4211C2 15.4445 3.64162 13.8421 5.66667 13.8421H9.33333C11.3584 13.8421 13 15.4445 13 17.4211V19.2105C13 20.1988 12.1792 21 11.1667 21H3.83333C2.82081 21 2 20.1988 2 19.2105V17.4211Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilledInviteFillIcon = (props) => {
    const { title = 'Filled Invite Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6ZM19.7071 7.70701C20.0976 7.31649 20.0976 6.68332 19.7071 6.2928C19.3166 5.90228 18.6834 5.90228 18.2929 6.2928L12 12.5857L5.70711 6.2928C5.31658 5.90228 4.68342 5.90228 4.29289 6.2928C3.90237 6.68332 3.90237 7.31649 4.29289 7.70701L10.5858 13.9999C11.3668 14.781 12.6332 14.781 13.4142 13.9999L19.7071 7.70701Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilledLightFillIcon = (props) => {
    const { title = 'Filled Light Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M12 3V4", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }),
        React$2.createElement("path", { d: "M12 20V21", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }),
        React$2.createElement("path", { d: "M19.7942 7.5L18.9282 8", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }),
        React$2.createElement("path", { d: "M5.07181 16L4.20578 16.5", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }),
        React$2.createElement("path", { d: "M19.7942 16.5L18.9282 16", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }),
        React$2.createElement("path", { d: "M5.07181 8L4.20578 7.5", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }),
        React$2.createElement("circle", { cx: "12", cy: "12", r: "4" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilledMapLayerFillIcon = (props) => {
    const { title = 'Filled Map Layer Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M4.01488 9.78935C3.50013 9.38899 3.50014 8.61101 4.01488 8.21065L11.3861 2.47751C11.7472 2.19665 12.2528 2.19665 12.6139 2.47751L19.9851 8.21065C20.4999 8.61101 20.4999 9.38899 19.9851 9.78935L12.6139 15.5225C12.2528 15.8034 11.7472 15.8034 11.3861 15.5225L4.01488 9.78935Z" }),
        React$2.createElement("path", { d: "M12.6139 21.5225L19.9851 15.7894C20.4999 15.389 20.4999 14.611 19.9851 14.2106L18.4286 13L12.6139 17.5225C12.2528 17.8034 11.7472 17.8034 11.3861 17.5225L5.57143 13L4.01488 14.2106C3.50014 14.611 3.50013 15.389 4.01488 15.7894L11.3861 21.5225C11.7472 21.8034 12.2528 21.8034 12.6139 21.5225Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilledNeutralFillIcon = (props) => {
    const { title = 'Filled Neutral Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM10 9.5C10 10.3284 9.32843 11 8.5 11C7.67157 11 7 10.3284 7 9.5C7 8.67157 7.67157 8 8.5 8C9.32843 8 10 8.67157 10 9.5ZM17 9.5C17 10.3284 16.3284 11 15.5 11C14.6716 11 14 10.3284 14 9.5C14 8.67157 14.6716 8 15.5 8C16.3284 8 17 8.67157 17 9.5ZM8 16C8 15.4477 8.44772 15 9 15H15C15.5523 15 16 15.4477 16 16C16 16.5523 15.5523 17 15 17H9C8.44772 17 8 16.5523 8 16Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilledNotificationFillIcon = (props) => {
    const { title = 'Filled Notification Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 20H10C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 10.9998C5 7.82879 6.10851 5.15024 9 4.28969C9 0.793768 15 0.515762 15 4.28969C17.8915 5.15024 19 7.82879 19 10.9998V14.9998C19 15.532 19.237 15.9692 19.4803 16.4179C19.7367 16.8909 20 17.3766 20 17.9998C20 18.5521 19.5523 18.9998 19 18.9998H5C4.44772 18.9998 4 18.9998 4 17.9998C4 17.3766 4.26332 16.8909 4.51972 16.4179C4.76298 15.9692 5 15.532 5 14.9998V10.9998Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilledOverviewFillIcon = (props) => {
    const { title = 'Filled Overview Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9H11C11.5523 9 12 8.55228 12 8C12 7.44772 11.5523 7 11 7H8ZM7 12C7 11.4477 7.44772 11 8 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H8C7.44772 13 7 12.5523 7 12ZM8 15C7.44772 15 7 15.4477 7 16C7 16.5523 7.44772 17 8 17H16C16.5523 17 17 16.5523 17 16C17 15.4477 16.5523 15 16 15H8Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilledSatisfiedFillIcon = (props) => {
    const { title = 'Filled Satisfied Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM10 9.5C10 10.3284 9.32843 11 8.5 11C7.67157 11 7 10.3284 7 9.5C7 8.67157 7.67157 8 8.5 8C9.32843 8 10 8.67157 10 9.5ZM17 9.5C17 10.3284 16.3284 11 15.5 11C14.6716 11 14 10.3284 14 9.5C14 8.67157 14.6716 8 15.5 8C16.3284 8 17 8.67157 17 9.5ZM12 15.9999C11.0735 15.9999 10.2271 15.6879 9.70708 15.1679C9.31654 14.7774 8.68338 14.7774 8.29287 15.1679C7.90236 15.5585 7.90238 16.1916 8.29292 16.5821C9.2729 17.562 10.6765 17.9999 12 17.9999C13.3235 17.9999 14.7271 17.562 15.7071 16.5821C16.0976 16.1916 16.0976 15.5585 15.7071 15.1679C15.3166 14.7774 14.6835 14.7774 14.2929 15.1679C13.7729 15.6879 12.9265 15.9999 12 15.9999Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilledSaveFillIcon = (props) => {
    const { title = 'Filled Save Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4C2 2.89543 2.89543 2 4 2H17.5858C18.1162 2 18.6249 2.21071 19 2.58579L21.4142 5C21.7893 5.37507 22 5.88378 22 6.41421V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4ZM7 4H17V8C17 8.55228 16.5523 9 16 9H8C7.44772 9 7 8.55228 7 8V4ZM7 14C7 13.4477 7.44772 13 8 13H16C16.5523 13 17 13.4477 17 14V20H7V14Z" }),
        React$2.createElement("rect", { x: "13", y: "5", width: "2", height: "2", rx: "1" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilledShareFillIcon = (props) => {
    const { title = 'Filled Share Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.8242 9.4581C21.0586 9.2545 21.0586 8.7455 20.8242 8.5419L14.5273 3.07166C14.293 2.86806 14 3.12256 14 3.52976V6.00053L14 6.00049C14 6.00049 10.849 5.89585 7.50002 8.5006C3.00004 12.0006 3.50001 19.5004 4.14997 19.5004C4.35421 19.5004 4.53823 19.0675 4.81786 18.4096C5.70208 16.3294 7.54222 12.0003 14 12.0003L14 12.0003V14.4702C14 14.8774 14.293 15.1319 14.5273 14.9283L20.8242 9.4581Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilledSplitScreenFillIcon = (props) => {
    const { title = 'Filled Split Screen Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M4 7C4 5.89543 4.89543 5 6 5H10V19H6C4.89543 19 4 18.1046 4 17V7Z" }),
        React$2.createElement("path", { d: "M14 5H18C19.1046 5 20 5.89543 20 7V17C20 18.1046 19.1046 19 18 19H14V5Z" }),
        React$2.createElement("path", { d: "M10 2V21.5", stroke: color, strokeWidth: "2", fill: "none" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilledSuggestedPlaceToValidateFillIcon = (props) => {
    const { title = 'Filled Suggested Place To Validate Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22C13.5 22 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 10.5 22 12 22ZM11.492 12.622C11.198 12.3 11.03 11.88 11.03 11.39C11.03 10.4479 11.6692 9.98512 12.2203 9.58618C12.2343 9.57609 12.2482 9.56603 12.262 9.556L12.2689 9.55108C12.7 9.24516 13.074 8.97976 13.074 8.562C13.074 8.128 12.752 7.764 11.982 7.764C11.282 7.764 10.694 8.114 10.26 8.632L9.126 7.358C9.868 6.49 10.988 6 12.192 6C13.998 6 15.104 6.91 15.104 8.212C15.104 9.374 14.348 9.934 13.69 10.396C13.6771 10.4056 13.6641 10.4152 13.6513 10.4247C13.1774 10.7764 12.766 11.0817 12.766 11.586C12.766 11.81 12.878 12.048 13.018 12.174L11.492 12.622ZM12.164 15.632C11.548 15.632 11.03 15.114 11.03 14.498C11.03 13.882 11.548 13.364 12.164 13.364C12.78 13.364 13.298 13.882 13.298 14.498C13.298 15.114 12.78 15.632 12.164 15.632Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilledUnsatisfiedFillIcon = (props) => {
    const { title = 'Filled Unsatisfied Fill Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM10 9.5C10 10.3284 9.32843 11 8.5 11C7.67157 11 7 10.3284 7 9.5C7 8.67157 7.67157 8 8.5 8C9.32843 8 10 8.67157 10 9.5ZM17 9.5C17 10.3284 16.3284 11 15.5 11C14.6716 11 14 10.3284 14 9.5C14 8.67157 14.6716 8 15.5 8C16.3284 8 17 8.67157 17 9.5ZM12 15.8751C11.0735 15.8751 10.2271 16.1872 9.70708 16.7071C9.31654 17.0976 8.68338 17.0976 8.29287 16.7071C7.90236 16.3165 7.90238 15.6834 8.29292 15.2929C9.2729 14.313 10.6765 13.8751 12 13.8751C13.3235 13.8751 14.7271 14.313 15.7071 15.2929C16.0976 15.6834 16.0976 16.3165 15.7071 16.7071C15.3166 17.0976 14.6835 17.0976 14.2929 16.7071C13.7729 16.1871 12.9265 15.8751 12 15.8751Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const AddCircleOutlineIcon = (props) => {
    const { title = 'Add Circle Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8V11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H13V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44771 11 8 11H11V8Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const AddOutlineIcon = (props) => {
    const { title = 'Add Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M3.5145 11.0001C2.96221 11.0001 2.5145 11.4478 2.5145 12.0001C2.5145 12.5524 2.96221 13.0001 3.5145 13.0001H11L11 20.4856C11 21.0379 11.4477 21.4856 12 21.4856C12.5523 21.4856 13 21.0379 13 20.4856V13.0001H20.4854C21.0377 13.0001 21.4854 12.5524 21.4854 12.0001C21.4854 11.4478 21.0377 11.0001 20.4854 11.0001L13 11.0001V3.51465C13 2.96236 12.5523 2.51465 12 2.51465C11.4477 2.51465 11 2.96236 11 3.51465L11 11.0001H3.5145Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const AlertOutlineIcon = (props) => {
    const { title = 'Alert Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.8074 6.1284L9.40853 6.54473C7.80941 7.02065 6.89302 8.49175 6.89302 11.2354V15.1498C6.89302 15.9659 6.60988 16.6546 6.38117 17.107H17.1909C16.9622 16.6546 16.6791 15.9659 16.6791 15.1498V11.2354C16.6791 8.49175 15.7627 7.02065 14.1636 6.54473L12.7647 6.1284V4.66884C12.7647 4.32238 12.6543 4.21602 12.5817 4.15798C12.4559 4.05734 12.1969 3.94919 11.8314 3.95766C11.4668 3.96611 11.1702 4.08796 11.0046 4.223C10.882 4.32294 10.8074 4.43676 10.8074 4.66884V6.1284ZM4.93581 11.2354C4.93581 8.13222 6.02061 5.51098 8.85023 4.66884C8.85023 1.24771 14.7219 0.975657 14.7219 4.66884C17.5515 5.51098 18.6363 8.13222 18.6363 11.2354V15.1498C18.6363 15.6707 18.8682 16.0985 19.1063 16.5376C19.3572 17.0004 19.6149 17.4757 19.6149 18.0856C19.6149 18.6261 19.1768 19.0642 18.6363 19.0642H4.93581C4.39535 19.0642 3.95721 19.0642 3.95721 18.0856C3.95721 17.4757 4.2149 17.0004 4.46581 16.5376C4.70386 16.0985 4.93581 15.6707 4.93581 15.1498V11.2354Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.7433 20.0428H9.82884C9.82884 21.1237 10.7051 22 11.786 22C12.867 22 13.7433 21.1237 13.7433 20.0428Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.83636 3.96055C5.83636 4.36453 5.59776 4.72135 5.2864 4.97874C4.60213 5.54439 4.1492 6.44211 3.96814 7.72002C3.89418 8.242 3.46966 8.66064 2.94246 8.66064C2.38829 8.66064 1.93868 8.2002 2.00686 7.65023C2.24876 5.69889 3.02301 4.05547 4.52718 3.10825C5.13442 2.72585 5.83636 3.24294 5.83636 3.96055Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.6577 3.96055C17.6577 4.36453 17.8963 4.72135 18.2076 4.97874C18.8919 5.54439 19.3448 6.44211 19.5259 7.72002C19.5998 8.242 20.0244 8.66064 20.5516 8.66064C21.1057 8.66064 21.5554 8.2002 21.4872 7.65023C21.2453 5.69889 20.471 4.05547 18.9669 3.10825C18.3596 2.72585 17.6577 3.24294 17.6577 3.96055Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ArrowDownOutlineIcon = (props) => {
    const { title = 'Arrow Down Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M18.7019 13.7334C19.0994 13.3369 19.0994 12.6939 18.7019 12.2974C18.3045 11.9009 17.6602 11.9009 17.2628 12.2974L13 16.5508L13 5.07143C13 4.4797 12.5523 4 12 4C11.4477 4 11 4.4797 11 5.07143L11 16.5508L6.73721 12.2974C6.3398 11.9009 5.69547 11.9009 5.29806 12.2974C4.90065 12.6939 4.90065 13.3369 5.29806 13.7334L11.2804 19.7026C11.6778 20.0991 12.3222 20.0991 12.7196 19.7026L18.7019 13.7334Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ArrowLeftOutlineIcon = (props) => {
    const { title = 'Arrow Left Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M10.2666 5.29806C10.6631 4.90065 11.3061 4.90065 11.7026 5.29806C12.0991 5.69547 12.0991 6.3398 11.7026 6.73722L7.44919 11H18.9286C19.5203 11 20 11.4477 20 12C20 12.5523 19.5203 13 18.9286 13H7.44919L11.7026 17.2628C12.0991 17.6602 12.0991 18.3045 11.7026 18.7019C11.3061 19.0994 10.6631 19.0994 10.2666 18.7019L4.2974 12.7196C3.90087 12.3222 3.90087 11.6778 4.2974 11.2804L10.2666 5.29806Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ArrowRightOutlineIcon = (props) => {
    const { title = 'Arrow Right Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M13.7334 5.29806C13.3369 4.90065 12.6939 4.90065 12.2974 5.29806C11.9009 5.69547 11.9009 6.3398 12.2974 6.73722L16.5508 11H5.07143C4.4797 11 4 11.4477 4 12C4 12.5523 4.4797 13 5.07143 13H16.5508L12.2974 17.2628C11.9009 17.6602 11.9009 18.3045 12.2974 18.7019C12.6939 19.0994 13.3369 19.0994 13.7334 18.7019L19.7026 12.7196C20.0991 12.3222 20.0991 11.6778 19.7026 11.2804L13.7334 5.29806Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ArrowUpOutlineIcon = (props) => {
    const { title = 'Arrow Up Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M18.7019 10.2666C19.0994 10.6631 19.0994 11.3061 18.7019 11.7026C18.3045 12.0991 17.6602 12.0991 17.2628 11.7026L13 7.44919L13 18.9286C13 19.5203 12.5523 20 12 20C11.4477 20 11 19.5203 11 18.9286L11 7.44919L6.73721 11.7026C6.3398 12.0991 5.69547 12.0991 5.29806 11.7026C4.90065 11.3061 4.90065 10.6631 5.29806 10.2666L11.2804 4.2974C11.6778 3.90087 12.3222 3.90087 12.7196 4.2974L18.7019 10.2666Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const AscendingOutlineIcon = (props) => {
    const { title = 'Ascending Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M20.2929 9.70711C20.6834 10.0976 21.3166 10.0976 21.7071 9.70711C22.0976 9.31658 22.0976 8.68342 21.7071 8.29289L17.7077 4.29352L17.7006 4.28639C17.6062 4.19374 17.498 4.12357 17.3828 4.07588C17.2657 4.02735 17.1375 4.0004 17.003 4L17 4L16.997 4C16.7421 4.00076 16.4874 4.09839 16.2929 4.29289L12.2929 8.29289C11.9024 8.68342 11.9024 9.31658 12.2929 9.70711C12.6834 10.0976 13.3166 10.0976 13.7071 9.70711L16 7.41421L16 19C16 19.5523 16.4477 20 17 20C17.5523 20 18 19.5523 18 19L18 7.41421L20.2929 9.70711Z" }),
        React$2.createElement("path", { d: "M4 7C3.44772 7 3 7.44772 3 8C3 8.55228 3.44772 9 4 9H8C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7H4Z" }),
        React$2.createElement("path", { d: "M4 11C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H10C10.5523 13 11 12.5523 11 12C11 11.4477 10.5523 11 10 11H4Z" }),
        React$2.createElement("path", { d: "M3 16C3 15.4477 3.44772 15 4 15H12C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17H4C3.44772 17 3 16.5523 3 16Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const AudioOffOutlineIcon = (props) => {
    const { title = 'Audio Off Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.00002 10C9.00002 10.1748 9.01496 10.3461 9.04365 10.5127L7.45958 12.0968C7.1646 11.4591 7.00002 10.7488 7.00002 10V7C7.00002 4.23858 9.23859 2 12 2C13.5223 2 14.8858 2.68033 15.8028 3.75353L14.3813 5.17506C13.8329 4.46059 12.9703 4 12 4C10.3432 4 9.00002 5.34315 9.00002 7V10ZM19.2635 5.12117L17 7.38461V9.99985C17 12.7613 14.7614 14.9998 12 14.9998C11.2355 14.9998 10.5111 14.8283 9.86312 14.5215L9.07729 15.3073C9.93608 15.7421 10.9108 15.9915 11.9464 15.9998H12.0536C14.5377 15.9799 16.6718 14.5724 17.695 12.5488C17.9443 12.056 18.5458 11.8584 19.0387 12.1077C19.5315 12.3569 19.729 12.9585 19.4798 13.4513C18.2549 15.8737 15.8437 17.609 13 17.9419V19.9998H15C15.5523 19.9998 16 20.4476 16 20.9998C16 21.5521 15.5523 21.9998 15 21.9998H9C8.44772 21.9998 8 21.5521 8 20.9998C8 20.4476 8.44772 19.9998 9 19.9998H11L11 17.9419C9.7675 17.7976 8.61626 17.3899 7.60764 16.777L5.12132 19.2633C4.7308 19.6538 4.09763 19.6538 3.70711 19.2633C3.31658 18.8728 3.31658 18.2396 3.70711 17.8491L17.8492 3.70696C18.2398 3.31643 18.8729 3.31643 19.2635 3.70696C19.654 4.09748 19.654 4.73065 19.2635 5.12117ZM11.4374 12.9473L15 9.38477V10C15 11.6569 13.6569 13 12 13C11.8077 13 11.6197 12.9819 11.4374 12.9473ZM4.96135 12.1077C4.46849 12.3569 4.27098 12.9585 4.5202 13.4513C4.68922 13.7856 4.88081 14.1067 5.09302 14.4129L6.53547 12.9637C6.4534 12.8286 6.37649 12.6902 6.305 12.5488C6.05577 12.056 5.4542 11.8584 4.96135 12.1077Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const AudioOnOutlineIcon = (props) => {
    const { title = 'Audio On Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C9.23858 2 7 4.23858 7 7V10C7 12.7614 9.23858 15 12 15C14.7614 15 17 12.7614 17 10V7C17 4.23858 14.7614 2 12 2ZM15 7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7V10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10V7Z" }),
        React$2.createElement("path", { d: "M6.30499 12.549C6.05577 12.0561 5.45419 11.8586 4.96134 12.1078C4.46848 12.357 4.27098 12.9586 4.5202 13.4515C5.74512 15.8739 8.15626 17.6091 11 17.9421L11 20H9.00001C8.44772 20 8.00001 20.4477 8.00001 21C8.00001 21.5523 8.44772 22 9.00001 22H15C15.5523 22 16 21.5523 16 21C16 20.4477 15.5523 20 15 20H13V17.9421C15.8437 17.6091 18.2549 15.8739 19.4798 13.4515C19.729 12.9586 19.5315 12.357 19.0387 12.1078C18.5458 11.8586 17.9442 12.0561 17.695 12.549C16.6718 14.5725 14.5377 15.98 12.0536 16H11.9464C9.46228 15.98 7.32823 14.5725 6.30499 12.549Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const AutoValidateOutlineIcon = (props) => {
    const { title = 'Auto Validate Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("g", { clipPath: "url(#clip0_9918_565175)" },
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.4701 20.837C17.4602 21.3887 17.8995 21.844 18.4512 21.8539C19.0029 21.8637 19.4581 21.4245 19.468 20.8728L19.5251 17.6808C19.5338 17.1986 19.1967 16.7791 18.7239 16.6836L15.5946 16.0518C15.0537 15.9426 14.5267 16.2926 14.4175 16.8334C14.3083 17.3743 14.6583 17.9013 15.1992 18.0105L16.2978 18.2323C13.3596 20.4885 9.13265 20.2715 6.44239 17.5813C4.41849 15.5573 3.79298 12.6628 4.57119 10.0988C4.73145 9.57084 4.43333 9.01289 3.90532 8.85263C3.37731 8.69237 2.81936 8.99049 2.6591 9.5185C1.67528 12.7599 2.46362 16.4284 5.02944 18.9942C8.4295 22.3943 13.7674 22.6755 17.488 19.8379L17.4701 20.837Z" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.50927 3.09998C6.51915 2.54828 6.07991 2.09303 5.52821 2.08315C4.9765 2.07328 4.52125 2.51252 4.51138 3.06422L4.45424 6.25617C4.4456 6.73839 4.78269 7.15795 5.25546 7.2534L8.38477 7.8852C8.92565 7.9944 9.45265 7.64446 9.56185 7.10358C9.67105 6.5627 9.32111 6.03571 8.78023 5.9265L7.77195 5.72294C10.7072 3.51918 14.892 3.75258 17.5626 6.42314C19.5865 8.44705 20.212 11.3416 19.4338 13.9055C19.2735 14.4336 19.5716 14.9915 20.0997 15.1518C20.6277 15.312 21.1856 15.0139 21.3459 14.4859C22.3297 11.2444 21.5414 7.57601 18.9755 5.01019C15.5672 1.60184 10.2116 1.32753 6.48981 4.18726L6.50927 3.09998Z" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.9785 9.12628C16.369 9.5168 16.369 10.15 15.9785 10.5405L11.3823 15.1367C10.9917 15.5272 10.3586 15.5272 9.96804 15.1367L7.84672 13.0154C7.4562 12.6248 7.4562 11.9917 7.84672 11.6012C8.23725 11.2106 8.87041 11.2106 9.26094 11.6012L10.6752 13.0154L14.5642 9.12628C14.9548 8.73575 15.5879 8.73575 15.9785 9.12628Z" })),
        React$2.createElement("defs", null,
            React$2.createElement("clipPath", { id: "clip0_9918_565175" },
                React$2.createElement("rect", { width: "24", height: "24", fill: "white" })))));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const Back10OutlineIcon = (props) => {
    const { title = 'Back10 Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M10.2937 15.5V8.82998H9.05374L6.95374 10.94L7.76374 11.79L8.86374 10.66V15.5H10.2937Z" }),
        React$2.createElement("path", { d: "M11.2951 12.17C11.2951 13.89 12.1451 15.62 14.0551 15.62C15.9551 15.62 16.8151 13.89 16.8151 12.17C16.8151 10.45 15.9551 8.72998 14.0551 8.72998C12.1451 8.72998 11.2951 10.45 11.2951 12.17ZM15.3651 12.17C15.3651 13.4 15.0051 14.36 14.0551 14.36C13.0951 14.36 12.7351 13.4 12.7351 12.17C12.7351 10.94 13.0951 9.98998 14.0551 9.98998C15.0051 9.98998 15.3651 10.94 15.3651 12.17Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.83374 8.15854L6.35897 8.07617L6.38408 8.07224L8.73445 7.70368L8.76945 7.69819L9.35273 7.60673L10.1679 7.47891C10.5528 7.41855 10.7238 6.96062 10.4727 6.6627L9.94095 6.03183L9.56044 5.5804L9.5376 5.5533L9.46865 5.47151C10.2531 5.16712 11.1064 5.0001 12 5.0001C15.866 5.0001 19 8.1341 19 12.0001C19 15.8661 15.866 19.0001 12 19.0001C8.13401 19.0001 5 15.8661 5 12.0001C5 11.4478 4.55228 11.0001 4 11.0001C3.44772 11.0001 3 11.4478 3 12.0001C3 16.9707 7.02944 21.0001 12 21.0001C16.9706 21.0001 21 16.9707 21 12.0001C21 7.02953 16.9706 3.0001 12 3.0001C10.6134 3.0001 9.2982 3.31431 8.12353 3.87567L8.01111 3.7423L7.99551 3.72379L7.65822 3.32363L7.08347 2.64176C6.83721 2.3496 6.36752 2.43044 6.23311 2.78813L5.91943 3.62293L5.73534 4.11283L5.72683 4.13549L4.92211 6.27705L4.91317 6.30083L4.72616 6.79851L4.41538 7.62557C4.28067 7.98408 4.58252 8.35474 4.96089 8.2954L5.83374 8.15854Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const BankOutlineIcon = (props) => {
    const { title = 'Bank Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.9076 7.52826H12H17.0924L12.6584 4.33495C12.2653 4.05188 11.7347 4.05188 11.3417 4.33495L6.9076 7.52826ZM4.125 8.79123H5.1539H18.8461H19.875V9.77355H4.125V8.79123ZM4.9852 7.52826H3.5625C3.25184 7.52826 3 7.77957 3 8.08958V10.3349C3 10.6449 3.25184 10.8962 3.5625 10.8962H4.6875V17.6321H3.5625C3.25184 17.6321 3 17.8834 3 18.1934V20.4387C3 20.7487 3.25184 21 3.5625 21H20.4375C20.7482 21 21 20.7487 21 20.4387V18.1934C21 17.8834 20.7482 17.6321 20.4375 17.6321H19.3125V10.8962H20.4375C20.7482 10.8962 21 10.6449 21 10.3349V8.08958C21 7.77957 20.7482 7.52826 20.4375 7.52826H19.0148L13.3167 3.42462C12.5306 2.85846 11.4694 2.85846 10.6833 3.42462L4.9852 7.52826ZM5.8125 17.6321V10.8962H18.1875V17.6321H15.9375V12.0188H14.8125V17.6321H12.5625V12.0188H11.4375V17.6321H9.1875V12.0188H8.0625V17.6321H5.8125ZM4.125 19.8774V18.7547H19.875V19.8774H4.125Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CalendarOutlineIcon = (props) => {
    const { title = 'Calendar Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11Z" }),
        React$2.createElement("path", { d: "M7 16C7 15.4477 7.44772 15 8 15C8.55228 15 9 15.4477 9 16C9 16.5523 8.55228 17 8 17C7.44772 17 7 16.5523 7 16Z" }),
        React$2.createElement("path", { d: "M12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11Z" }),
        React$2.createElement("path", { d: "M11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16Z" }),
        React$2.createElement("path", { d: "M16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 2C8.55228 2 9 2.44772 9 3H15C15 2.44772 15.4477 2 16 2C16.5523 2 17 2.44772 17 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H7C7 2.44772 7.44772 2 8 2ZM15 5C15 5.55228 15.4477 6 16 6C16.5523 6 17 5.55228 17 5H19V7H5V5H7C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5H15ZM5 9H19V19H5V9Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CameraOutlineIcon = (props) => {
    const { title = 'Camera Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 13C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13C8 10.7909 9.79086 9 12 9C14.2091 9 16 10.7909 16 13ZM14 13C14 14.1046 13.1046 15 12 15C10.8954 15 10 14.1046 10 13C10 11.8954 10.8954 11 12 11C13.1046 11 14 11.8954 14 13Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.63961 4C7.68625 4 6.86542 4.67292 6.67845 5.60777L6.6 6H4C2.89543 6 2 6.89543 2 8V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V8C22 6.89543 21.1046 6 20 6H17.4L17.3216 5.60777C17.1346 4.67292 16.3138 4 15.3604 4H8.63961ZM8.23961 8L8.63961 6L15.3604 6L15.7604 8H20V18H4V8H8.23961Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CaretDownOutlineIcon = (props) => {
    const { title = 'Caret Down Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.29289 7.29289C2.90237 7.68342 2.90237 8.31658 3.29289 8.70711L11.2929 16.7071C11.6834 17.0976 12.3166 17.0976 12.7071 16.7071L20.7071 8.70711C21.0976 8.31658 21.0976 7.68342 20.7071 7.29289C20.3166 6.90237 19.6834 6.90237 19.2929 7.29289L12 14.5858L4.70711 7.29289C4.31658 6.90237 3.68342 6.90237 3.29289 7.29289Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CaretUpOutlineIcon = (props) => {
    const { title = 'Caret Up Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.7071 16.7071C21.0976 16.3166 21.0976 15.6834 20.7071 15.2929L12.7071 7.29289C12.3166 6.90237 11.6834 6.90237 11.2929 7.29289L3.29289 15.2929C2.90237 15.6834 2.90237 16.3166 3.29289 16.7071C3.68342 17.0976 4.31658 17.0976 4.70711 16.7071L12 9.41421L19.2929 16.7071C19.6834 17.0976 20.3166 17.0976 20.7071 16.7071Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CautionOutlineIcon = (props) => {
    const { title = 'Caution Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M12 7C12.5523 7 13 7.44772 13 8V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12V8C11 7.44772 11.4477 7 12 7Z" }),
        React$2.createElement("path", { d: "M12 16C12.5523 16 13 15.5523 13 15C13 14.4477 12.5523 14 12 14C11.4477 14 11 14.4477 11 15C11 15.5523 11.4477 16 12 16Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.5981 3.5L21.5263 15.5C22.681 17.5 21.2376 20 18.9282 20H5.0718C2.7624 20 1.31902 17.5 2.47372 15.5L9.40192 3.5C10.5566 1.5 13.4434 1.5 14.5981 3.5ZM12.866 4.5C12.4811 3.83333 11.5189 3.83333 11.134 4.5L4.20577 16.5C3.82087 17.1667 4.302 18 5.0718 18H18.9282C19.698 18 20.1791 17.1667 19.7942 16.5L12.866 4.5Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ChatOutlineIcon = (props) => {
    const { title = 'Chat Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.99998 17H19V5H5V18.8231C6.33493 18.5651 7.20142 18.0648 7.99998 17ZM5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.90284 21.0237 4.99426 20.8538C7.95538 20.3929 9 19 9 19H19C20.1046 19 21 18.1046 21 17V5C21 3.89543 20.1046 3 19 3H5Z" }),
        React$2.createElement("circle", { cx: "12", cy: "11", r: "1" }),
        React$2.createElement("circle", { cx: "8", cy: "11", r: "1" }),
        React$2.createElement("circle", { cx: "16", cy: "11", r: "1" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CheckboxCheckedOutlineIcon = (props) => {
    const { title = 'Checkbox Checked Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H6Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.29289 12.2929C6.68342 11.9024 7.31658 11.9024 7.70711 12.2929L9.77271 14.3585L16.1702 7.96098C16.5608 7.57045 17.1939 7.57045 17.5844 7.96098C17.975 8.3515 17.975 8.98467 17.5844 9.37519L10.4798 16.4798C10.2923 16.6674 10.0379 16.7727 9.77271 16.7727C9.50749 16.7727 9.25314 16.6674 9.0656 16.4798L6.29289 13.7071C5.90237 13.3166 5.90237 12.6834 6.29289 12.2929Z", fill: "white" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CheckboxDashOutlineIcon = (props) => {
    const { title = 'Checkbox Dash Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H6Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.00003 12C7.00003 11.4477 7.44775 11 8.00003 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H8.00003C7.44775 13 7.00003 12.5523 7.00003 12Z", fill: "white" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CheckboxDefaultOutlineIcon = (props) => {
    const { title = 'Checkbox Default Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6ZM6 5C5.44772 5 5 5.44772 5 6V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V6C19 5.44772 18.5523 5 18 5H6Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CheckmarkOutlineIcon = (props) => {
    const { title = 'Checkmark Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.50139 12.0844C2.89191 11.6939 3.52508 11.6939 3.9156 12.0844L7.61522 15.784L18.1996 5.19963C18.5902 4.80911 19.2233 4.80911 19.6138 5.19963C20.0044 5.59016 20.0044 6.22332 19.6138 6.61384L8.32232 17.9054C8.13479 18.0929 7.88043 18.1983 7.61522 18.1983C7.35 18.1983 7.09565 18.0929 6.90811 17.9054L2.50139 13.4986C2.11087 13.1081 2.11087 12.475 2.50139 12.0844Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ChevronLeftOutlineIcon = (props) => {
    const { title = 'Chevron Left Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.7071 3.29289C15.3166 2.90237 14.6834 2.90237 14.2929 3.29289L6.29289 11.2929C5.90237 11.6834 5.90237 12.3166 6.29289 12.7071L14.2929 20.7071C14.6834 21.0976 15.3166 21.0976 15.7071 20.7071C16.0976 20.3166 16.0976 19.6834 15.7071 19.2929L8.41421 12L15.7071 4.70711C16.0976 4.31658 16.0976 3.68342 15.7071 3.29289Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ChevronRightOutlineIcon = (props) => {
    const { title = 'Chevron Right Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.29289 3.29289C8.68342 2.90237 9.31658 2.90237 9.70711 3.29289L17.7071 11.2929C18.0976 11.6834 18.0976 12.3166 17.7071 12.7071L9.70711 20.7071C9.31658 21.0976 8.68342 21.0976 8.29289 20.7071C7.90237 20.3166 7.90237 19.6834 8.29289 19.2929L15.5858 12L8.29289 4.70711C7.90237 4.31658 7.90237 3.68342 8.29289 3.29289Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CircleCautionOutlineIcon = (props) => {
    const { title = 'Circle Caution Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20ZM13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V8ZM13 15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CloseCircleOutlineIcon = (props) => {
    const { title = 'Close Circle Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z" }),
        React$2.createElement("path", { d: "M14.1213 8.46449C14.5118 8.07396 15.145 8.07396 15.5355 8.46449C15.9261 8.85501 15.9261 9.48818 15.5355 9.8787L13.4142 12L15.5355 14.1213C15.9261 14.5119 15.9261 15.145 15.5355 15.5356C15.145 15.9261 14.5118 15.9261 14.1213 15.5356L12 13.4142L9.87868 15.5356C9.48816 15.9261 8.85499 15.9261 8.46447 15.5356C8.07394 15.145 8.07394 14.5119 8.46447 14.1213L10.5858 12L8.46447 9.8787C8.07394 9.48818 8.07394 8.85501 8.46447 8.46449C8.85499 8.07396 9.48816 8.07396 9.87868 8.46449L12 10.5858L14.1213 8.46449Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CloseOutlineIcon = (props) => {
    const { title = 'Close Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M6.70689 5.29289C6.31637 4.90237 5.6832 4.90237 5.29268 5.29289C4.90216 5.68342 4.90216 6.31658 5.29268 6.70711L10.5857 12.0001L5.29269 17.2931C4.90217 17.6837 4.90217 18.3168 5.29269 18.7074C5.68322 19.0979 6.31638 19.0979 6.70691 18.7074L11.9999 13.4143L17.2929 18.7074C17.6835 19.0979 18.3166 19.0979 18.7072 18.7074C19.0977 18.3168 19.0977 17.6837 18.7072 17.2931L13.4141 12.0001L18.7072 6.70711C19.0977 6.31658 19.0977 5.68342 18.7072 5.29289C18.3166 4.90237 17.6835 4.90237 17.2929 5.29289L11.9999 10.5859L6.70689 5.29289Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CollapseOutlineIcon = (props) => {
    const { title = 'Collapse Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M8.44259 18C7.87648 18.0007 7.41805 17.5422 7.41868 16.9761C7.4193 16.41 7.87873 15.9506 8.44485 15.95L14.5172 15.9433L6.33199 7.75806C5.91006 7.33613 5.88726 6.67485 6.28106 6.28106C6.67485 5.88726 7.33613 5.91006 7.75806 6.33199L15.9433 14.5172L15.95 8.44484C15.9506 7.87873 16.41 7.4193 16.9761 7.41868C17.5422 7.41805 18.0007 7.87648 18 8.44259L17.9906 16.9645C17.99 17.5306 17.5306 17.99 16.9645 17.9906L8.44259 18Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CountOutlineIcon = (props) => {
    const { title = 'Count Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.9071 4.51444C12.05 3.98097 11.7334 3.43264 11.2 3.28969C10.6665 3.14675 10.1182 3.46333 9.97522 3.9968L8.90254 8.00011H7C6.44772 8.00011 6 8.44783 6 9.00011C6 9.5524 6.44772 10.0001 7 10.0001H8.36664L7.29484 14.0001H5C4.44772 14.0001 4 14.4478 4 15.0001C4 15.5524 4.44772 16.0001 5 16.0001H6.75894L6.09293 18.4857C5.94999 19.0192 6.26658 19.5675 6.80004 19.7104C7.33351 19.8534 7.88184 19.5368 8.02479 19.0033L8.82949 16.0001H12.7589L12.0929 18.4857C11.95 19.0192 12.2666 19.5675 12.8 19.7104C13.3335 19.8534 13.8818 19.5368 14.0248 19.0033L14.8295 16.0001H17C17.5523 16.0001 18 15.5524 18 15.0001C18 14.4478 17.5523 14.0001 17 14.0001H15.3654L16.4372 10.0001H19C19.5523 10.0001 20 9.5524 20 9.00011C20 8.44783 19.5523 8.00011 19 8.00011H16.9731L17.9071 4.51444C18.05 3.98097 17.7334 3.43264 17.2 3.28969C16.6665 3.14675 16.1182 3.46333 15.9752 3.9968L14.9025 8.00011H10.9731L11.9071 4.51444ZM14.3666 10.0001H10.4372L9.36539 14.0001H13.2948L14.3666 10.0001Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const DarkOutlineIcon = (props) => {
    const { title = 'Dark Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("mask", { id: "path-1-inside-1_9843_558007", fill: "white" },
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.03964 18.0584C11.7797 19.0371 15.6407 16.8083 16.6635 13.08C17.6863 9.3518 15.4836 5.536 11.7436 4.55721C10.8413 4.32107 9.93191 4.27163 9.05707 4.3849C8.27535 4.48612 8.11627 5.46907 8.59726 6.08382C9.8038 7.62589 10.2881 9.69961 9.72703 11.7449C9.25327 13.4718 8.12374 14.8523 6.67949 15.6894C5.99663 16.0853 5.76675 17.0537 6.45324 17.4293C6.94293 17.6972 7.47368 17.9102 8.03964 18.0584Z", fill: "none" })),
        React$2.createElement("path", { d: "M6.67949 15.6894L5.68238 13.9694L6.67949 15.6894ZM6.45324 17.4293L5.47241 19.1786L6.45324 17.4293ZM14.7287 12.5737C13.9981 15.2367 11.2402 16.8288 8.56877 16.1296L7.5105 19.9871C12.3191 21.2455 17.2833 18.3799 18.5984 13.5864L14.7287 12.5737ZM11.2144 6.48595C13.8859 7.18508 15.4593 9.91065 14.7287 12.5737L18.5984 13.5864C19.9134 8.79295 17.0813 3.88692 12.2727 2.62848L11.2144 6.48595ZM9.29615 6.36226C9.91805 6.28173 10.5664 6.31634 11.2144 6.48595L12.2727 2.62848C11.1161 2.3258 9.94576 2.26153 8.818 2.40755L9.29615 6.36226ZM7.00921 7.31809C7.84794 8.39007 8.18033 9.8238 7.79219 11.2386L11.6619 12.2513C12.396 9.57541 11.7597 6.8617 10.1853 4.84955L7.00921 7.31809ZM7.79219 11.2386C7.46405 12.4347 6.6849 13.3883 5.68238 13.9694L7.67661 17.4095C9.56258 16.3163 11.0425 14.509 11.6619 12.2513L7.79219 11.2386ZM8.56877 16.1296C8.1616 16.0231 7.78242 15.8705 7.43406 15.68L5.47241 19.1786C6.10345 19.5238 6.78577 19.7974 7.5105 19.9871L8.56877 16.1296ZM5.68238 13.9694C4.82947 14.4638 4.23297 15.3169 4.0746 16.2572C3.9027 17.2779 4.26658 18.5189 5.47241 19.1786L7.43406 15.68C7.63788 15.7915 7.83447 15.9892 7.94905 16.256C8.05608 16.5053 8.05596 16.7292 8.03112 16.8767C7.98679 17.1399 7.84666 17.3109 7.67661 17.4095L5.68238 13.9694ZM8.818 2.40755C7.44485 2.58534 6.63141 3.6067 6.39878 4.61479C6.18438 5.54386 6.40886 6.55079 7.00921 7.31809L10.1853 4.84955C10.3047 5.00211 10.3682 5.21018 10.3085 5.46878C10.2751 5.61379 10.1895 5.82102 9.9949 6.01341C9.7865 6.21944 9.52837 6.33219 9.29615 6.36226L8.818 2.40755Z", mask: "url(#path-1-inside-1_9843_558007)" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const DeleteOutlineIcon = (props) => {
    const { title = 'Delete Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2C8.89543 2 8 2.89543 8 4V5H4C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H16V4C16 2.89543 15.1046 2 14 2H10ZM14 5V4H10V5H14Z" }),
        React$2.createElement("path", { d: "M7 19V8H5V19C5 20.6569 6.34315 22 8 22H16C17.6569 22 19 20.6569 19 19V8H17V19C17 19.5523 16.5523 20 16 20H8C7.44772 20 7 19.5523 7 19Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const DescendingOutlineIcon = (props) => {
    const { title = 'Descending Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M17 4C17.5523 4 18 4.41973 18 4.9375L18 16.5858L20.2929 14.2929C20.6834 13.9024 21.3166 13.9024 21.7071 14.2929C22.0976 14.6834 22.0976 15.3166 21.7071 15.7071L17.7071 19.7071C17.3166 20.0976 16.6834 20.0976 16.2929 19.7071L12.2929 15.7071C11.9024 15.3166 11.9024 14.6834 12.2929 14.2929C12.6834 13.9024 13.3166 13.9024 13.7071 14.2929L16 16.5858L16 4.9375C16 4.41973 16.4477 4 17 4Z" }),
        React$2.createElement("path", { d: "M3 8C3 7.44772 3.44772 7 4 7H12C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9H4C3.44772 9 3 8.55228 3 8Z" }),
        React$2.createElement("path", { d: "M3 12C3 11.4477 3.44772 11 4 11H10C10.5523 11 11 11.4477 11 12C11 12.5523 10.5523 13 10 13H4C3.44772 13 3 12.5523 3 12Z" }),
        React$2.createElement("path", { d: "M4 15C3.44772 15 3 15.4477 3 16C3 16.5523 3.44772 17 4 17H8C8.55228 17 9 16.5523 9 16C9 15.4477 8.55228 15 8 15H4Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const DiagonalUpArrowOutlineIcon = (props) => {
    const { title = 'Diagonal Up Arrow Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M18 15.5574C18.0006 16.1235 17.5422 16.5819 16.9761 16.5813C16.41 16.5807 15.9505 16.1213 15.9499 15.5552L15.9432 9.48283L7.75805 17.668C7.33613 18.0899 6.67485 18.1127 6.28106 17.7189C5.88726 17.3251 5.91006 16.6639 6.33199 16.2419L14.5172 8.05676L8.44484 8.05007C7.87873 8.04945 7.4193 7.59002 7.41867 7.02391C7.41805 6.4578 7.87647 5.99938 8.44258 6L16.9644 6.00938C17.5306 6.01001 17.99 6.46944 17.9906 7.03555L18 15.5574Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const DownloadOutlineIcon = (props) => {
    const { title = 'Download Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 13C6.55228 13 7 13.4477 7 14V17H17V14C17 13.4477 17.4477 13 18 13C18.5523 13 19 13.4477 19 14V17C19 18.1046 18.1046 19 17 19H7C5.89543 19 5 18.1046 5 17V14C5 13.4477 5.44772 13 6 13Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.29289 8.29289C6.90237 8.68342 6.90237 9.31658 7.29289 9.70711L11.2929 13.7071C11.4804 13.8946 11.7348 14 12 14C12.2652 14 12.5196 13.8946 12.7071 13.7071L16.7071 9.70711C17.0976 9.31658 17.0976 8.68342 16.7071 8.29289C16.3166 7.90237 15.6834 7.90237 15.2929 8.29289L13 10.5858L13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4L11 10.5858L8.70711 8.29289C8.31658 7.90237 7.68342 7.90237 7.29289 8.29289Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const DraftOutlineIcon = (props) => {
    const { title = 'Draft Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M17 13.0607V19.5858H5V7.58575H11.3798L13.4279 5.58575H5C3.89543 5.58575 3 6.48118 3 7.58575V19.5858C3 20.6903 3.89543 21.5858 5 21.5858H17C18.1046 21.5858 19 20.6903 19 19.5858V11.0406L17 13.0607Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.8492 7.82843C21.6302 7.04738 21.6302 5.78105 20.8492 5L19.435 3.58579C18.6539 2.80474 17.3876 2.80474 16.6065 3.58579L14.4938 5.69852C14.4909 5.70133 14.4881 5.70416 14.4852 5.70701C14.4824 5.70986 14.4795 5.71273 14.4767 5.7156L8.69219 11.5001L7.47981 14.329C6.76862 15.9885 8.44649 17.6663 10.1059 16.9552L12.9348 15.7428L20.8492 7.82843ZM15.1924 7.82838L10.3788 12.642L9.3181 15.1169L11.793 14.0562L16.6066 9.2426L15.1924 7.82838ZM18.0208 7.82838L19.435 6.41421L18.0208 5L16.6066 6.41417L18.0208 7.82838Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const EllipsesHorizontalOutlineIcon = (props) => {
    const { title = 'Ellipses Horizontal Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("circle", { cx: "12", cy: "12", r: "2" }),
        React$2.createElement("circle", { cx: "4", cy: "12", r: "2" }),
        React$2.createElement("circle", { cx: "20", cy: "12", r: "2" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const EllipsesVerticalOutlineIcon = (props) => {
    const { title = 'Ellipses Vertical Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("circle", { cx: "12", cy: "12", r: "2" }),
        React$2.createElement("circle", { cx: "12", cy: "4", r: "2", transform: "rotate(90 12 4)" }),
        React$2.createElement("circle", { cx: "12", cy: "20", r: "2", transform: "rotate(90 12 20)" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ExpandOutlineIcon = (props) => {
    const { title = 'Expand Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 19C21 20.1046 20.1046 21 19 21L5 21C3.89543 21 3 20.1046 3 19V16C3 15.4477 3.44772 15 4 15C4.55228 15 5 15.4477 5 16V19L19 19L19 5L14.2857 5C13.7334 5 13.2857 4.55228 13.2857 4C13.2857 3.44772 13.7334 3 14.2857 3H19C20.1046 3 21 3.89543 21 5L21 19ZM11.5642 11.5642C11.1737 11.9548 10.5406 11.9548 10.15 11.5642L5 6.41421L5 10.6667C5 11.219 4.55228 11.6667 4 11.6667C3.44772 11.6667 3 11.219 3 10.6667L3 4C3 3.44772 3.44772 3 4 3L10.6667 3C11.219 3 11.6667 3.44772 11.6667 4C11.6667 4.55228 11.219 5 10.6667 5H6.41421L11.5642 10.15C11.9548 10.5406 11.9548 11.1737 11.5642 11.5642Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ExtremelySatisfiedOutlineIcon = (props) => {
    const { title = 'Extremely Satisfied Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("circle", { cx: "12", cy: "12", r: "9", stroke: color, strokeWidth: "2" }),
        React$2.createElement("circle", { cx: "8.5", cy: "9.5", r: "1.5" }),
        React$2.createElement("circle", { cx: "15.5", cy: "9.5", r: "1.5" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.31669 13C6.67111 13 6.17571 13.5861 6.41114 14.1872C7.28534 16.4193 9.45807 18 12 18C14.5419 18 16.7146 16.4193 17.5888 14.1872C17.8243 13.5861 17.3289 13 16.6833 13C16.2069 13 15.8036 13.3302 15.594 13.7579C14.9433 15.0858 13.5784 16 12 16C10.4216 16 9.05669 15.0858 8.40599 13.7579C8.19637 13.3302 7.79305 13 7.31669 13Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ExtremelyUnsatisfiedOutlineIcon = (props) => {
    const { title = 'Extremely Unsatisfied Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("circle", { cx: "12", cy: "12", r: "9", stroke: color, strokeWidth: "2" }),
        React$2.createElement("circle", { cx: "8.5", cy: "9.5", r: "1.5" }),
        React$2.createElement("circle", { cx: "15.5", cy: "9.5", r: "1.5" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 15C10.6867 15 9.47506 15.6907 8.66436 16.8462C8.34715 17.2983 7.7235 17.4076 7.2714 17.0904C6.8193 16.7732 6.70994 16.1496 7.02715 15.6975C8.15885 14.0845 9.94708 13 12 13C14.0529 13 15.8412 14.0845 16.9729 15.6975C17.2901 16.1496 17.1807 16.7732 16.7286 17.0904C16.2765 17.4076 15.6529 17.2983 15.3357 16.8462C14.525 15.6907 13.3133 15 12 15Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilterOffOutlineIcon = (props) => {
    const { title = 'Filter Off Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.3224 12.1062V18.1836L12.6777 17.7318V12.106L17.0391 6H6.96087L11.3224 12.1062ZM14.6777 12.7469L19.7961 5.58124C20.2688 4.91938 19.7957 4 18.9823 4H5.01769C4.20432 4 3.7312 4.91936 4.20396 5.58123L9.32237 12.7471V19.571C9.32237 20.2536 9.99107 20.7356 10.6386 20.5197L13.9939 19.4013C14.4022 19.2652 14.6777 18.883 14.6777 18.4526V12.7469Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FilterOnOutlineIcon = (props) => {
    const { title = 'Filter On Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("mask", { id: "path-1-inside-1_2118_62135", fill: "white" },
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.32236 12.8512L4.12956 5.58123C3.6568 4.91936 4.12992 4 4.94329 4H18.9079C19.7213 4 20.1944 4.91938 19.7217 5.58124L14.6777 12.6428V18.4527C14.6777 18.8831 14.4022 19.2653 13.9939 19.4014L10.6386 20.5198C9.99106 20.7357 9.32236 20.2537 9.32236 19.5711V12.8512Z", fill: "none" })),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.32236 12.8512L4.12956 5.58123C3.6568 4.91936 4.12992 4 4.94329 4H18.9079C19.7213 4 20.1944 4.91938 19.7217 5.58124L14.6777 12.6428V18.4527C14.6777 18.8831 14.4022 19.2653 13.9939 19.4014L10.6386 20.5198C9.99106 20.7357 9.32236 20.2537 9.32236 19.5711V12.8512Z" }),
        React$2.createElement("path", { d: "M9.32236 12.8512H11.3224V12.2103L10.9498 11.6888L9.32236 12.8512ZM4.12956 5.58123L5.75703 4.41876L5.75703 4.41876L4.12956 5.58123ZM19.7217 5.58124L18.0942 4.41876V4.41876L19.7217 5.58124ZM14.6777 12.6428L13.0502 11.4803L12.6777 12.0018V12.6428H14.6777ZM13.9939 19.4014L14.6263 21.2988H14.6263L13.9939 19.4014ZM10.6386 20.5198L10.0061 18.6225L10.0061 18.6225L10.6386 20.5198ZM10.9498 11.6888L5.75703 4.41876L2.50208 6.7437L7.69489 14.0137L10.9498 11.6888ZM5.75703 4.41876C6.22979 5.08064 5.75665 6 4.94329 6V2C2.50319 2 1.0838 4.75809 2.50208 6.7437L5.75703 4.41876ZM4.94329 6H18.9079V2H4.94329V6ZM18.9079 6C18.0946 6 17.6214 5.08063 18.0942 4.41876L21.3491 6.74373C22.7674 4.75812 21.348 2 18.9079 2V6ZM18.0942 4.41876L13.0502 11.4803L16.3051 13.8053L21.3491 6.74373L18.0942 4.41876ZM12.6777 12.6428V18.4527H16.6777V12.6428H12.6777ZM12.6777 18.4527C12.6777 18.0223 12.9531 17.6401 13.3614 17.504L14.6263 21.2988C15.8514 20.8904 16.6777 19.744 16.6777 18.4527H12.6777ZM13.3614 17.504L10.0061 18.6225L11.271 22.4172L14.6263 21.2988L13.3614 17.504ZM10.0061 18.6225C10.6537 18.4066 11.3224 18.8886 11.3224 19.5711H7.32236C7.32236 21.6188 9.32845 23.0647 11.271 22.4172L10.0061 18.6225ZM11.3224 19.5711V12.8512H7.32236V19.5711H11.3224Z", mask: "url(#path-1-inside-1_2118_62135)" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FolderOutlineIcon = (props) => {
    const { title = 'Folder Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 18V8H12.8284C11.7676 8 10.7501 7.57857 10 6.82843L9.17157 6H4V18H20ZM4 4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V8C22 6.89543 21.1046 6 20 6H12.8284C12.298 6 11.7893 5.78929 11.4142 5.41421L10.5858 4.58579C10.2107 4.21071 9.70201 4 9.17157 4H4Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FullScreenOutlineIcon = (props) => {
    const { title = 'Full Screen Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M3 6C3 4.34315 4.34315 3 6 3H8C8.55228 3 9 3.44772 9 4C9 4.55228 8.55228 5 8 5H6C5.44772 5 5 5.44772 5 6V8C5 8.55228 4.55228 9 4 9C3.44772 9 3 8.55228 3 8V6Z" }),
        React$2.createElement("path", { d: "M6 21C4.34315 21 3 19.6569 3 18V16C3 15.4477 3.44772 15 4 15C4.55228 15 5 15.4477 5 16V18C5 18.5523 5.44772 19 6 19H8C8.55228 19 9 19.4477 9 20C9 20.5523 8.55228 21 8 21H6Z" }),
        React$2.createElement("path", { d: "M21 6C21 4.34315 19.6569 3 18 3H16C15.4477 3 15 3.44772 15 4C15 4.55228 15.4477 5 16 5H18C18.5523 5 19 5.44772 19 6V8C19 8.55228 19.4477 9 20 9C20.5523 9 21 8.55228 21 8V6Z" }),
        React$2.createElement("path", { d: "M18 21C19.6569 21 21 19.6569 21 18V16C21 15.4477 20.5523 15 20 15C19.4477 15 19 15.4477 19 16V18C19 18.5523 18.5523 19 18 19H16C15.4477 19 15 19.4477 15 20C15 20.5523 15.4477 21 16 21H18Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const GridOutlineIcon = (props) => {
    const { title = 'Grid Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M4 5C4 4.44772 4.44772 4 5 4H7C7.55228 4 8 4.44772 8 5V7C8 7.55228 7.55228 8 7 8H5C4.44772 8 4 7.55228 4 7V5Z" }),
        React$2.createElement("path", { d: "M10 5C10 4.44772 10.4477 4 11 4H13C13.5523 4 14 4.44772 14 5V7C14 7.55228 13.5523 8 13 8H11C10.4477 8 10 7.55228 10 7V5Z" }),
        React$2.createElement("path", { d: "M17 4C16.4477 4 16 4.44772 16 5V7C16 7.55228 16.4477 8 17 8H19C19.5523 8 20 7.55228 20 7V5C20 4.44772 19.5523 4 19 4H17Z" }),
        React$2.createElement("path", { d: "M10 11C10 10.4477 10.4477 10 11 10H13C13.5523 10 14 10.4477 14 11V13C14 13.5523 13.5523 14 13 14H11C10.4477 14 10 13.5523 10 13V11Z" }),
        React$2.createElement("path", { d: "M11 16C10.4477 16 10 16.4477 10 17V19C10 19.5523 10.4477 20 11 20H13C13.5523 20 14 19.5523 14 19V17C14 16.4477 13.5523 16 13 16H11Z" }),
        React$2.createElement("path", { d: "M4 11C4 10.4477 4.44772 10 5 10H7C7.55228 10 8 10.4477 8 11V13C8 13.5523 7.55228 14 7 14H5C4.44772 14 4 13.5523 4 13V11Z" }),
        React$2.createElement("path", { d: "M5 16C4.44772 16 4 16.4477 4 17V19C4 19.5523 4.44772 20 5 20H7C7.55228 20 8 19.5523 8 19V17C8 16.4477 7.55228 16 7 16H5Z" }),
        React$2.createElement("path", { d: "M16 11C16 10.4477 16.4477 10 17 10H19C19.5523 10 20 10.4477 20 11V13C20 13.5523 19.5523 14 19 14H17C16.4477 14 16 13.5523 16 13V11Z" }),
        React$2.createElement("path", { d: "M17 16C16.4477 16 16 16.4477 16 17V19C16 19.5523 16.4477 20 17 20H19C19.5523 20 20 19.5523 20 19V17C20 16.4477 19.5523 16 19 16H17Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const GroupOutlineIcon = (props) => {
    const { title = 'Group Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.8351 12.1139C13.0936 12.2945 13.372 12.4495 13.6667 12.5751C14.2281 12.8145 14.8482 12.9474 15.5 12.9474C16.1518 12.9474 16.7719 12.8145 17.3333 12.5751C17.7182 12.411 18.0755 12.1968 18.3966 11.9409C19.4261 11.1205 20.0833 9.87202 20.0833 8.47368C20.0833 6.00294 18.0313 4 15.5 4C14.5409 4 13.6506 4.28755 12.9147 4.77914C13.3044 5.33218 13.6071 5.94793 13.8036 6.60767C14.251 6.23224 14.839 6 15.5 6C16.9727 6 18.0833 7.15288 18.0833 8.47368C18.0833 9.79449 16.9727 10.9474 15.5 10.9474C14.819 10.9474 14.2154 10.7008 13.7632 10.3051C13.5526 10.9596 13.2368 11.5688 12.8351 12.1139ZM14.5953 21H19.1667C20.1792 21 21 20.1988 21 19.2105V17.4211C21 15.9285 20.0639 14.6493 18.7335 14.1123C18.3021 13.9382 17.8292 13.8421 17.3333 13.8421H15.5H13.6667C13.6257 13.8421 13.5848 13.8428 13.5441 13.8441C14.0743 14.4138 14.4831 15.0928 14.7307 15.8421H17.3333C18.2997 15.8421 19 16.5944 19 17.4211V19H15V19.3478C15 19.9424 14.8541 20.5039 14.5953 21Z" }),
        React$2.createElement("path", { d: "M11.0833 8.47368C11.0833 10.3695 9.50199 11.9474 7.5 11.9474C5.49801 11.9474 3.91667 10.3695 3.91667 8.47368C3.91667 6.57791 5.49801 5 7.5 5C9.50199 5 11.0833 6.57791 11.0833 8.47368ZM3 17.4211C3 16.0194 4.17094 14.8421 5.66667 14.8421H9.33333C10.8291 14.8421 12 16.0194 12 17.4211V19.2105C12 19.6239 11.6499 20 11.1667 20H3.83333C3.35013 20 3 19.6239 3 19.2105V17.4211Z", stroke: color, strokeWidth: "2", fill: "none" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const GuidelinesOutlineIcon = (props) => {
    const { title = 'Guidelines Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 6.37236C17.5249 5.66303 15.1698 6.42525 13.9605 7.22995C12.7942 8.00607 11.2058 8.00606 10.0395 7.22995C8.83019 6.42525 6.47511 5.66303 4 6.37236V16.6143C6.17595 16.3641 9.22648 16.3763 12 17.7153C14.7735 16.3763 17.824 16.3641 20 16.6143V6.37236ZM12.8525 5.56492C12.3574 5.89441 11.6426 5.89441 11.1475 5.56492C9.41274 4.41055 6.03905 3.36957 2.57888 4.74685C2.22082 4.88937 2 5.24535 2 5.63073V17.7224C2 18.372 2.60925 18.8499 3.24963 18.7408C5.35436 18.3825 8.67614 18.1958 11.4503 19.6789C11.7927 19.862 12.2073 19.862 12.5497 19.6789C15.3239 18.1958 18.6456 18.3825 20.7504 18.7408C21.3908 18.8499 22 18.372 22 17.7224V5.63073C22 5.24535 21.7792 4.88937 21.4211 4.74685C17.9609 3.36957 14.5873 4.41056 12.8525 5.56492Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 6C12.5523 6 13 6.44772 13 7V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V7C11 6.44772 11.4477 6 12 6Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const HelpOutlineIcon = (props) => {
    const { title = 'Help Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.4714 9.11808C12.2674 9.00902 12.0318 8.97408 11.8049 9.01922C11.578 9.06435 11.3738 9.18677 11.227 9.36561C11.0802 9.54445 11 9.76865 11 10C11 10.5523 10.5523 11 10 11C9.44772 11 9 10.5523 9 10C9 9.30594 9.24066 8.63334 9.68097 8.09682C10.1213 7.5603 10.734 7.19305 11.4147 7.05765C12.0955 6.92224 12.8021 7.02706 13.4142 7.35424C14.0263 7.68142 14.506 8.21072 14.7716 8.85195C15.0372 9.49319 15.0723 10.2067 14.8708 10.8709C14.6693 11.535 14.2438 12.1088 13.6667 12.4944C13.4589 12.6333 13.236 12.7447 13.0036 12.8272V13.5C13.0036 14.0523 12.5559 14.5 12.0036 14.5C11.4513 14.5 11.0036 14.0523 11.0036 13.5V12C11.0036 11.4484 11.4502 11.001 12.0018 11C12.1982 10.9997 12.391 10.9414 12.5556 10.8315C12.7479 10.7029 12.8898 10.5117 12.9569 10.2903C13.0241 10.0689 13.0124 9.83106 12.9239 9.61732C12.8353 9.40358 12.6754 9.22714 12.4714 9.11808ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const HideOutlineIcon = (props) => {
    const { title = 'Hide Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M19.7071 5.70711C20.0976 5.31658 20.0976 4.68342 19.7071 4.29289C19.3166 3.90237 18.6834 3.90237 18.2929 4.29289L4.29289 18.2929C3.90237 18.6834 3.90237 19.3166 4.29289 19.7071C4.68342 20.0976 5.31658 20.0976 5.70711 19.7071L19.7071 5.70711Z" }),
        React$2.createElement("path", { d: "M12 6C13.0186 6 14.0661 6.1884 15.0819 6.50386L13.4384 8.14737C12.9481 8.05183 12.4649 8 12 8C10.1649 8 8.04314 8.80761 6.33381 9.92434C5.49382 10.4731 4.83488 11.0446 4.4115 11.5313C4.22442 11.7464 4.11953 11.9023 4.06159 12C4.11953 12.0977 4.22442 12.2536 4.4115 12.4687C4.83488 12.9554 5.49382 13.5269 6.33381 14.0757C6.57042 14.2302 6.81493 14.3789 7.06548 14.5203L5.60485 15.9809C3.49738 14.6892 2 13.0624 2 12C2 10 7.30648 6 12 6Z" }),
        React$2.createElement("path", { d: "M18.3952 8.01906L16.9345 9.4797C17.1851 9.62111 17.4296 9.76976 17.6662 9.92434C18.5062 10.4731 19.1651 11.0446 19.5885 11.5313C19.7756 11.7464 19.8805 11.9023 19.9384 12C19.8805 12.0977 19.7756 12.2536 19.5885 12.4687C19.1651 12.9554 18.5062 13.5269 17.6662 14.0757C15.9569 15.1924 13.8351 16 12 16C11.5351 16 11.0519 15.9482 10.5616 15.8526L8.91808 17.4961C9.93392 17.8116 10.9814 18 12 18C16.6935 18 22 14 22 12C22 10.9376 20.5026 9.31082 18.3952 8.01906Z" }),
        React$2.createElement("path", { d: "M12.5377 9.04806C12.3633 9.01649 12.1836 9 12 9C10.3431 9 9 10.3431 9 12C9 12.1836 9.01649 12.3633 9.04806 12.5377L12.5377 9.04806Z" }),
        React$2.createElement("path", { d: "M14.9519 11.4623L11.4623 14.9519C11.6367 14.9835 11.8164 15 12 15C13.6569 15 15 13.6569 15 12C15 11.8164 14.9835 11.6367 14.9519 11.4623Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const HomeOutlineIcon = (props) => {
    const { title = 'Home Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 18.9999V9.30402L12 3.98999L5 9.30402L5 18.9999H19ZM3.79069 7.71104C3.29256 8.0892 3 8.67861 3 9.30402V18.9999C3 20.1045 3.89543 20.9999 5 20.9999H19C20.1046 20.9999 21 20.1045 21 18.9999V9.30402C21 8.67861 20.7074 8.0892 20.2093 7.71104L13.2093 2.39701C12.4944 1.85432 11.5056 1.85432 10.7907 2.39701L3.79069 7.71104Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 11.9999C8 10.8953 8.89543 9.99988 10 9.99988H14C15.1046 9.99988 16 10.8953 16 11.9999V16.9999C16 17.5522 15.5523 17.9999 15 17.9999C14.4477 17.9999 14 17.5522 14 16.9999V11.9999H10V16.9999C10 17.5522 9.55228 17.9999 9 17.9999C8.44772 17.9999 8 17.5522 8 16.9999V11.9999Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ImageOutlineIcon = (props) => {
    const { title = 'Image Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M7 11C7 11.5523 6.55228 12 6 12C5.44772 12 5 11.5523 5 11C5 10.4477 5.44772 10 6 10C6.55228 10 7 10.4477 7 11Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 4C4.89543 4 4 4.89543 4 6V7H3C2.44772 7 2 7.44772 2 8V19C2 19.5523 2.44772 20 3 20H18C18.5523 20 19 19.5523 19 19V18H20C21.1046 18 22 17.1046 22 16V6C22 4.89543 21.1046 4 20 4H6ZM19 16H20V6L6 6V7H18C18.5523 7 19 7.44772 19 8V16ZM4 16.6263V9H17V13.2942L15.3914 11.7223C14.6194 10.9678 13.3879 10.9622 12.609 11.7095L10.1106 14.1065L9.69321 13.7425C8.91797 13.0664 7.75626 13.0886 7.00742 13.7939L4 16.6263ZM5.45852 18H17V16.0906L13.9936 13.1527L11.4952 15.5497C10.7478 16.2668 9.5766 16.2946 8.79601 15.6138L8.37863 15.2498L5.45852 18Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const InfoOutlineIcon = (props) => {
    const { title = 'Info Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8ZM13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V11Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const InviteOutlineIcon = (props) => {
    const { title = 'Invite Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H4ZM4 18V7.41421L10.5858 14C11.3668 14.781 12.6332 14.781 13.4142 14L20 7.41421V18L4 18ZM18.5858 6L5.41421 6L12 12.5858L18.5858 6Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const LanguageOutlineIcon = (props) => {
    const { title = 'Language Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM13.7467 18.1766C12.9482 19.7737 12.2151 20 12 20C11.7849 20 11.0518 19.7737 10.2533 18.1766C9.61429 16.8986 9.14295 15.094 9.02739 13H14.9726C14.8571 15.094 14.3857 16.8986 13.7467 18.1766ZM14.9726 11H9.02739C9.14295 8.90602 9.61429 7.10143 10.2533 5.82336C11.0518 4.22632 11.7849 4 12 4C12.2151 4 12.9482 4.22632 13.7467 5.82336C14.3857 7.10143 14.8571 8.90602 14.9726 11ZM16.9753 13C16.8545 15.4337 16.2974 17.6107 15.4627 19.2138C17.861 18.0605 19.5956 15.7464 19.9381 13H16.9753ZM19.9381 11H16.9753C16.8545 8.5663 16.2974 6.38927 15.4627 4.78617C17.861 5.93948 19.5956 8.25357 19.9381 11ZM7.02469 11C7.1455 8.5663 7.70258 6.38927 8.53731 4.78617C6.13899 5.93948 4.40437 8.25357 4.06189 11H7.02469ZM4.06189 13C4.40437 15.7464 6.13899 18.0605 8.53731 19.2138C7.70259 17.6107 7.1455 15.4337 7.02469 13H4.06189Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const LayerOutlineIcon = (props) => {
    const { title = 'Layer Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M3 10L12 3L21 10L12 17L3 10Z", stroke: color, strokeWidth: "2", strokeLinejoin: "round", fill: "none" }),
        React$2.createElement("path", { d: "M18.4286 12L21 14L12 21L3 14L5.57143 12", stroke: color, strokeWidth: "2", strokeLinejoin: "round", fill: "none" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const LightOutlineIcon = (props) => {
    const { title = 'Light Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M12 3V4", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }),
        React$2.createElement("path", { d: "M12 20V21", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }),
        React$2.createElement("path", { d: "M19.7942 7.5L18.9282 8", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }),
        React$2.createElement("path", { d: "M5.0718 16L4.20577 16.5", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }),
        React$2.createElement("path", { d: "M19.7942 16.5L18.9282 16", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }),
        React$2.createElement("path", { d: "M5.0718 8L4.20577 7.5", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }),
        React$2.createElement("circle", { cx: "12", cy: "12", r: "4", stroke: color, strokeWidth: "2" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const LightbulbOutlineIcon = (props) => {
    const { title = 'Lightbulb Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M21.1683 11.9642C21.6104 11.9993 22 11.6683 22 11.2248C22 10.7813 21.6104 10.4503 21.1683 10.4854L20.6188 10.5291C20.2632 10.5573 20 10.8681 20 11.2248C20 11.5815 20.2632 11.8923 20.6188 11.9205L21.1683 11.9642Z" }),
        React$2.createElement("path", { d: "M19.0193 5.09555C19.3444 4.81137 19.3846 4.31648 19.0833 4.00725C18.7724 3.68828 18.2596 3.73068 17.9739 4.0724L17.5942 4.52647C17.3723 4.79188 17.4048 5.18388 17.6471 5.4308C17.897 5.68551 18.305 5.71989 18.5737 5.48502L19.0193 5.09555Z" }),
        React$2.createElement("path", { d: "M12 1C12.4346 1 12.7587 1.38161 12.7258 1.815L12.6783 2.44059C12.6519 2.78779 12.3482 3.04496 12 3.04496C11.6518 3.04496 11.3481 2.78779 11.3217 2.44059L11.2742 1.815C11.2413 1.38161 11.5654 1 12 1Z" }),
        React$2.createElement("path", { d: "M6.02615 4.0724C5.74044 3.73068 5.22765 3.68828 4.91675 4.00725C4.61536 4.31648 4.65558 4.81137 4.98069 5.09555L5.42627 5.48503C5.69497 5.71989 6.10296 5.68551 6.35292 5.4308C6.59524 5.18388 6.6277 4.79188 6.40579 4.52647L6.02615 4.0724Z" }),
        React$2.createElement("path", { d: "M2 11.2248C2 10.7813 2.38957 10.4503 2.83165 10.4854L3.38116 10.5291C3.73676 10.5573 4 10.8681 4 11.2248C4 11.5815 3.73676 11.8923 3.38116 11.9205L2.83165 11.9642C2.38957 11.9993 2 11.6683 2 11.2248Z" }),
        React$2.createElement("path", { d: "M4.98069 17.3541C4.65558 17.6382 4.61536 18.1331 4.91675 18.4424C5.22765 18.7613 5.74044 18.7189 6.02615 18.3772L6.40579 17.9231C6.6277 17.6577 6.59524 17.2657 6.35292 17.0188C6.10296 16.7641 5.69497 16.7297 5.42627 16.9646L4.98069 17.3541Z" }),
        React$2.createElement("path", { d: "M17.9739 18.3772C18.2596 18.7189 18.7724 18.7613 19.0833 18.4424C19.3846 18.1331 19.3444 17.6382 19.0193 17.3541L18.5737 16.9646C18.305 16.7297 17.897 16.7641 17.6471 17.0188C17.4048 17.2657 17.3723 17.6577 17.5942 17.9231L17.9739 18.3772Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 16.7453V21C8 22.1046 8.89543 23 10 23H14C15.1046 23 16 22.1046 16 21V16.7453C17.8135 15.4804 19 13.3787 19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 13.3787 6.18652 15.4804 8 16.7453ZM14 15.7019L14.8558 15.1049C16.156 14.198 17 12.6974 17 11C17 8.23858 14.7614 6 12 6C9.23858 6 7 8.23858 7 11C7 12.6974 7.84396 14.198 9.1442 15.1049L10 15.7019V18H14V15.7019ZM10 21V20H14V21H10Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const LinkOutlineIcon = (props) => {
    const { title = 'Link Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 10C4.89543 10 4 10.8954 4 12C4 13.1046 4.89543 14 6 14H10.2C10.7523 14 11.2 14.4477 11.2 15C11.2 15.5523 10.7523 16 10.2 16H6C3.79086 16 2 14.2091 2 12C2 9.79086 3.79086 8 6 8H10.2C10.7523 8 11.2 8.44772 11.2 9C11.2 9.55228 10.7523 10 10.2 10H6ZM12.8 9C12.8 8.44772 13.2477 8 13.8 8H18C20.2091 8 22 9.79086 22 12C22 14.2091 20.2091 16 18 16H13.8C13.2477 16 12.8 15.5523 12.8 15C12.8 14.4477 13.2477 14 13.8 14H18C19.1046 14 20 13.1046 20 12C20 10.8954 19.1046 10 18 10H13.8C13.2477 10 12.8 9.55228 12.8 9Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 12C8 11.4477 8.44772 11 9 11H15C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H9C8.44772 13 8 12.5523 8 12Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ListOutlineIcon = (props) => {
    const { title = 'List Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M3 6C2.44772 6 2 6.44772 2 7C2 7.55229 2.44772 8 3 8L4 8C4.55228 8 5 7.55229 5 7C5 6.44772 4.55228 6 4 6H3Z" }),
        React$2.createElement("path", { d: "M8 6C7.44772 6 7 6.44772 7 7C7 7.55229 7.44772 8 8 8L21 8C21.5523 8 22 7.55228 22 7C22 6.44772 21.5523 6 21 6H8Z" }),
        React$2.createElement("path", { d: "M8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13L21 13C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11L8 11Z" }),
        React$2.createElement("path", { d: "M7 17C7 16.4477 7.44772 16 8 16L21 16C21.5523 16 22 16.4477 22 17C22 17.5523 21.5523 18 21 18L8 18C7.44772 18 7 17.5523 7 17Z" }),
        React$2.createElement("path", { d: "M2 12C2 11.4477 2.44772 11 3 11H4C4.55228 11 5 11.4477 5 12C5 12.5523 4.55228 13 4 13H3C2.44772 13 2 12.5523 2 12Z" }),
        React$2.createElement("path", { d: "M3 16C2.44772 16 2 16.4477 2 17C2 17.5523 2.44772 18 3 18H4C4.55228 18 5 17.5523 5 17C5 16.4477 4.55228 16 4 16H3Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const LocateOutlineIcon = (props) => {
    const { title = 'Locate Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C12.5523 2 13 2.44772 13 3V4C13 4.02071 12.9994 4.04127 12.9981 4.06166C16.6184 4.51223 19.4878 7.38165 19.9383 11.0019C19.9587 11.0006 19.9793 11 20 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H20C19.9793 13 19.9587 12.9994 19.9383 12.9981C19.4878 16.6184 16.6184 19.4878 12.9981 19.9383C12.9994 19.9587 13 19.9793 13 20V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V20C11 19.9793 11.0006 19.9587 11.0019 19.9383C7.38165 19.4878 4.51223 16.6184 4.06166 12.9981C4.04127 12.9994 4.02071 13 4 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H4C4.02071 11 4.04127 11.0006 4.06166 11.0019C4.51223 7.38165 7.38164 4.51223 11.0019 4.06166C11.0006 4.04127 11 4.02071 11 4V3C11 2.44772 11.4477 2 12 2ZM18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const LockOutlineIcon = (props) => {
    const { title = 'Lock Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M14 14C14 14.7403 13.5978 15.3866 13 15.7324V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V15.7324C10.4022 15.3866 10 14.7403 10 14C10 12.8954 10.8954 12 12 12C13.1046 12 14 12.8954 14 14Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 7V8H6C4.89543 8 4 8.89543 4 10V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V10C20 8.89543 19.1046 8 18 8H17V7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7ZM15 8V7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7V8H15ZM6 10H18V20H6V10Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const LogoutOutlineIcon = (props) => {
    const { title = 'Logout Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M4 5C4 3.89543 4.89543 3 6 3H14.5C15.0523 3 15.5 3.44772 15.5 4C15.5 4.55228 15.0523 5 14.5 5H6V19H14.5C15.0523 19 15.5 19.4477 15.5 20C15.5 20.5523 15.0523 21 14.5 21H6C4.89543 21 4 20.1046 4 19V5Z" }),
        React$2.createElement("path", { d: "M16.7071 7.29289C16.3166 6.90237 15.6834 6.90237 15.2929 7.29289C14.9024 7.68342 14.9024 8.31658 15.2929 8.70711L17.5858 11H12C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13L17.5858 13L15.2929 15.2929C14.9024 15.6834 14.9024 16.3166 15.2929 16.7071C15.6834 17.0976 16.3166 17.0976 16.7071 16.7071L20.7071 12.7071C20.8946 12.5196 21 12.2652 21 12C21 11.7348 20.8946 11.4804 20.7071 11.2929L16.7071 7.29289Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const MapPinOutlineIcon = (props) => {
    const { title = 'Map Pin Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M11.9651 8.00031C12.4412 7.99199 12.9047 8.15385 13.2722 8.45675C13.6396 8.75966 13.8869 9.18373 13.9696 9.6527C14.0523 10.1217 13.965 10.6048 13.7233 11.0151C13.6039 11.2177 13.4508 11.396 13.2722 11.5432C12.846 11.8945 12.7853 12.5248 13.1366 12.951C13.4879 13.3771 14.1182 13.4378 14.5443 13.0865C14.9016 12.792 15.2078 12.4354 15.4465 12.0302C15.9299 11.2095 16.1046 10.2434 15.9392 9.30541C15.7739 8.36747 15.2792 7.51931 14.5443 6.9135C13.8094 6.30769 12.8825 5.98399 11.9302 6.00061C10.9779 6.01723 10.0628 6.37309 9.34953 7.00418C8.63621 7.63526 8.17149 8.50016 8.03894 9.44331C7.90639 10.3865 8.11471 11.3459 8.62644 12.1492C8.85373 12.506 9.13427 12.8215 9.4557 13.0865C9.88186 13.4378 10.5121 13.3771 10.8634 12.9509C11.2147 12.5248 11.154 11.8945 10.7278 11.5432C10.5671 11.4108 10.4269 11.253 10.3132 11.0746C10.0574 10.673 9.9532 10.1932 10.0195 9.72165C10.0857 9.25008 10.3181 8.81763 10.6748 8.50209C11.0314 8.18655 11.489 8.00862 11.9651 8.00031Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 10C20 14.4183 13.5 22 12 22C10.5 22 4 14.4183 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10ZM18 10C18 10.6707 17.7358 11.6569 17.1544 12.8808C16.5905 14.0679 15.8055 15.3183 14.9552 16.4667C14.1044 17.6156 13.2265 18.6107 12.5048 19.2968C12.3148 19.4775 12.1458 19.6269 12 19.7471C11.8542 19.6269 11.6852 19.4775 11.4952 19.2968C10.7735 18.6107 9.89559 17.6156 9.04481 16.4667C8.19449 15.3183 7.40953 14.0679 6.84559 12.8808C6.2642 11.6569 6 10.6707 6 10C6 6.68629 8.68629 4 12 4C15.3137 4 18 6.68629 18 10Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const MapOutlineIcon = (props) => {
    const { title = 'Map Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 5.25L9 3L2.69399 5.02693C2.28044 5.15986 2 5.54457 2 5.97896V18.6743C2 19.3386 2.63591 19.8183 3.27472 19.6358L9 18L15 20L21.2747 18.2072C21.704 18.0846 22 17.6922 22 17.2457V4.37182C22 3.69378 21.3395 3.2123 20.694 3.41979L15 5.25ZM15.0455 17.907L20 16.4914V5.74363L14.9494 7.36703L8.94942 5.11703L4 6.70792V17.3485L9.04548 15.907L15.0455 17.907Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 4C9.55228 4 10 4.44772 10 5V17C10 17.5523 9.55228 18 9 18C8.44772 18 8 17.5523 8 17V5C8 4.44772 8.44772 4 9 4Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 6C15.5523 6 16 6.44772 16 7V18C16 18.5523 15.5523 19 15 19C14.4477 19 14 18.5523 14 18V7C14 6.44772 14.4477 6 15 6Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const MarketOutlineIcon = (props) => {
    const { title = 'Market Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.41791 7.1354C8.81763 6.59433 9.62682 6.59433 10.0265 7.1354L11.0727 8.55155C11.2755 8.82606 11.6157 9 12 9C12.3843 9 12.7245 8.82606 12.9273 8.55155L13.9735 7.13539C14.3732 6.59432 15.1824 6.59432 15.5821 7.13539L16.6283 8.55155C16.8311 8.82606 17.1712 9 17.5556 9H18.6667C19.2803 9 19.7778 8.55228 19.7778 8V5C19.7778 4.44772 19.2803 4 18.6667 4H5.33333C4.71968 4 4.22222 4.44772 4.22222 5V8C4.22222 8.55228 4.71968 9 5.33333 9H6.44444C6.82876 9 7.16891 8.82606 7.3717 8.55155L8.41791 7.1354ZM16.5553 10.8626C16.8711 10.9519 17.2071 11 17.5556 11H18.6667C18.7792 11 18.8904 10.995 19 10.9852V19.9999L5 19.9999V10.9852C5.10964 10.995 5.22083 11 5.33333 11H6.44444C6.79294 11 7.12894 10.9519 7.4447 10.8626C8.17944 10.6548 8.80454 10.2243 9.22222 9.6589C9.6399 10.2243 10.265 10.6548 10.9997 10.8626C11.3155 10.9519 11.6515 11 12 11C12.3485 11 12.6845 10.9519 13.0003 10.8626C13.735 10.6548 14.3601 10.2243 14.7778 9.65889C15.1955 10.2243 15.8206 10.6548 16.5553 10.8626ZM3 10.1424C2.38288 9.59795 2 8.83922 2 8V5C2 3.34315 3.49238 2 5.33333 2H18.6667C20.5076 2 22 3.34315 22 5V8C22 8.83922 21.6171 9.59795 21 10.1424V19.9999C21 21.1045 20.1046 21.9999 19 21.9999H5C3.89543 21.9999 3 21.1045 3 19.9999V10.1424ZM8 14C8 12.8954 8.89543 12 10 12H14C15.1046 12 16 12.8954 16 14V18C16 18.5523 15.5523 19 15 19C14.4477 19 14 18.5523 14 18V14H10V18C10 18.5523 9.55228 19 9 19C8.44772 19 8 18.5523 8 18V14Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const MinimizeFullScreenOutlineIcon = (props) => {
    const { title = 'Minimize Full Screen Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M9 6C9 7.65686 7.65685 9 6 9L4 9C3.44771 9 3 8.55229 3 8C3 7.44772 3.44771 7 4 7L6 7C6.55228 7 7 6.55229 7 6L7 4C7 3.44772 7.44771 3 8 3C8.55228 3 9 3.44772 9 4L9 6Z" }),
        React$2.createElement("path", { d: "M18 9C16.3431 9 15 7.65686 15 6L15 4C15 3.44772 15.4477 3 16 3C16.5523 3 17 3.44772 17 4L17 6C17 6.55229 17.4477 7 18 7L20 7C20.5523 7 21 7.44772 21 8C21 8.55229 20.5523 9 20 9L18 9Z" }),
        React$2.createElement("path", { d: "M15 18C15 16.3431 16.3431 15 18 15L20 15C20.5523 15 21 15.4477 21 16C21 16.5523 20.5523 17 20 17L18 17C17.4477 17 17 17.4477 17 18L17 20C17 20.5523 16.5523 21 16 21C15.4477 21 15 20.5523 15 20L15 18Z" }),
        React$2.createElement("path", { d: "M6 15C7.65685 15 9 16.3431 9 18L9 20C9 20.5523 8.55228 21 8 21C7.44771 21 7 20.5523 7 20L7 18C7 17.4477 6.55228 17 6 17L4 17C3.44772 17 3 16.5523 3 16C3 15.4477 3.44772 15 4 15L6 15Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const MinusOutlineIcon = (props) => {
    const { title = 'Minus Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M3.51449 11.0002C2.9622 11.0002 2.51449 11.448 2.51449 12.0002C2.51449 12.5525 2.9622 13.0002 3.51449 13.0002H20.4854C21.0377 13.0002 21.4854 12.5525 21.4854 12.0002C21.4854 11.448 21.0377 11.0002 20.4854 11.0002L3.51449 11.0002Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const NeutralOutlineIcon = (props) => {
    const { title = 'Neutral Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" }),
        React$2.createElement("path", { d: "M10 9.5C10 10.3284 9.32843 11 8.5 11C7.67157 11 7 10.3284 7 9.5C7 8.67157 7.67157 8 8.5 8C9.32843 8 10 8.67157 10 9.5Z" }),
        React$2.createElement("path", { d: "M17 9.5C17 10.3284 16.3284 11 15.5 11C14.6716 11 14 10.3284 14 9.5C14 8.67157 14.6716 8 15.5 8C16.3284 8 17 8.67157 17 9.5Z" }),
        React$2.createElement("path", { d: "M9 15C8.44772 15 8 15.4477 8 16C8 16.5523 8.44772 17 9 17V15ZM15 17C15.5523 17 16 16.5523 16 16C16 15.4477 15.5523 15 15 15V17ZM9 17H15V15H9V17Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const NoImageOutlineIcon = (props) => {
    const { title = 'No Image Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.7406 3.1029C19.9475 2.59083 19.7001 2.008 19.188 1.80111C18.676 1.59422 18.0931 1.84162 17.8863 2.35369L10.3941 20.8974C10.1872 21.4094 10.4346 21.9923 10.9467 22.1992C11.4588 22.406 12.0416 22.1586 12.2485 21.6466L12.9137 20.0002H21C21.5523 20.0002 22 19.5525 22 19.0002V13.2981V13.2909V5.00023C22 4.44795 21.5523 4.00023 21 4.00023H19.3781L19.7406 3.1029ZM18.57 6.00023L17.5064 8.63292L20 10.9799V6.00023H18.57ZM15.7236 13.0453L13.7217 18.0002H20V13.7264L17.5 11.3734L15.7236 13.0453ZM3 4.00023H15.2L14.4 6.00023H4V16.6269L9 11.9211L11.2025 13.994L10.4044 15.9893L9 14.6676L5.45904 18.0002H9.6L8.8 20.0002H3C2.44772 20.0002 2 19.5525 2 19.0002V5.00023C2 4.44795 2.44772 4.00023 3 4.00023ZM9 9.00023C9 10.1048 8.10457 11.0002 7 11.0002C5.89543 11.0002 5 10.1048 5 9.00023C5 7.89566 5.89543 7.00023 7 7.00023C8.10457 7.00023 9 7.89566 9 9.00023Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const NoWifiOutlineIcon = (props) => {
    const { title = 'No Wifi Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.8253 5.23951C4.9107 5.62211 4.03014 6.09034 3.19594 6.6401C2.73479 6.94401 2.64789 7.57384 2.98 8.01511L3.00021 8.04197C3.33233 8.48324 3.95753 8.56838 4.42143 8.26868C5.3563 7.66472 6.3563 7.17709 7.39905 6.81326L5.8253 5.23951ZM10.6741 10.0883C9.30873 10.271 7.99429 10.734 6.81442 11.4496C6.3422 11.736 6.25593 12.3678 6.58804 12.8091L6.63986 12.8779C6.97197 13.3192 7.59642 13.4014 8.07603 13.1276C9.26908 12.4463 10.6245 12.0845 12.0098 12.0862C12.242 12.0865 12.4734 12.097 12.7032 12.1175L10.6741 10.0883ZM16.6989 13.2847L13.5323 10.1181C14.8319 10.3196 16.0809 10.7758 17.2066 11.4623C17.6781 11.7498 17.7629 12.3818 17.4297 12.8223L17.3777 12.891C17.2079 13.1155 16.9623 13.2466 16.6989 13.2847ZM9.6474 6.23319L7.93835 4.52414C9.26232 4.17664 10.6336 3.99832 12.0196 4.00001C15.1632 4.00384 18.2284 4.93343 20.8368 6.6616C21.2972 6.96663 21.3826 7.59667 21.0494 8.03714L21.0291 8.06395C20.6959 8.50441 20.0705 8.58802 19.6074 8.2872C17.3537 6.82342 14.7186 6.03692 12.0171 6.03363C11.2189 6.03266 10.4263 6.10008 9.6474 6.23319ZM13.549 16.312C14.0582 16.5259 14.1432 17.167 13.81 17.6074L12.7997 18.943C12.3989 19.4728 11.6026 19.4718 11.2031 18.9411L10.1961 17.603C9.86397 17.1617 9.95051 16.5209 10.4602 16.3083C10.9466 16.1054 11.4714 15.9994 12.005 16C12.5386 16.0007 13.0631 16.108 13.549 16.312Z" }),
        React$2.createElement("path", { d: "M4 4L18 18", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const NotificationOutlineIcon = (props) => {
    const { title = 'Notification Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 20H10C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 5.7814L9.5705 6.20684C7.93642 6.69316 7 8.19642 7 11.0001V15.0001C7 15.834 6.71067 16.5377 6.47696 17.0001H17.523C17.2893 16.5377 17 15.834 17 15.0001V11.0001C17 8.19642 16.0636 6.69316 14.4295 6.20684L13 5.7814V4.28993C13 3.9359 12.8872 3.82721 12.8131 3.7679C12.6845 3.66506 12.4198 3.55455 12.0463 3.5632C11.6738 3.57184 11.3707 3.69635 11.2015 3.83435C11.0762 3.93647 11 4.05278 11 4.28993V5.7814ZM6.00224 18.0632C6.00221 18.0633 6.00203 18.0617 6.00177 18.0585C6.00215 18.0616 6.00228 18.0632 6.00224 18.0632ZM5 11.0001C5 7.82903 6.10851 5.15048 9 4.28993C9 0.794012 15 0.516006 15 4.28993C17.8915 5.15048 19 7.82903 19 11.0001V15.0001C19 15.5323 19.237 15.9695 19.4803 16.4182C19.7367 16.8911 20 17.3768 20 18.0001C20 18.5523 19.5523 19.0001 19 19.0001H5C4.44772 19.0001 4 19.0001 4 18.0001C4 17.3768 4.26332 16.8911 4.51972 16.4182C4.76298 15.9695 5 15.5323 5 15.0001V11.0001Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const OverviewOutlineIcon = (props) => {
    const { title = 'Overview Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5ZM19 5H5V19H19V5Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 8C7 7.44772 7.44772 7 8 7H11C11.5523 7 12 7.44772 12 8C12 8.55228 11.5523 9 11 9H8C7.44772 9 7 8.55228 7 8Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 12C7 11.4477 7.44772 11 8 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H8C7.44772 13 7 12.5523 7 12Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 16C7 15.4477 7.44772 15 8 15H16C16.5523 15 17 15.4477 17 16C17 16.5523 16.5523 17 16 17H8C7.44772 17 7 16.5523 7 16Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const PauseOutlineIcon = (props) => {
    const { title = 'Pause Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("rect", { x: "6.99988", y: "4", width: "3", height: "16", rx: "1.5" }),
        React$2.createElement("rect", { x: "13.9999", y: "4", width: "3", height: "16", rx: "1.5" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const PaymentsOutlineIcon = (props) => {
    const { title = 'Payments Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H6ZM19 14.8293V15C19 15.5523 18.5523 16 18 16H6C5.44772 16 5 15.5523 5 15V14.8293C5.31278 14.9398 5.64936 15 6 15H18C18.3506 15 18.6872 14.9398 19 14.8293ZM5 12C5 12.5523 5.44772 13 6 13H18C18.5523 13 19 12.5523 19 12V6C19 5.44772 18.5523 5 18 5H6C5.44772 5 5 5.44772 5 6V12ZM19 18V17.8293C18.6872 17.9398 18.3506 18 18 18H6C5.64936 18 5.31278 17.9398 5 17.8293V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const PencilOutlineIcon = (props) => {
    const { title = 'Pencil Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.0459 7.9496L10.3999 18.5956C9.85099 19.1445 9.18186 19.558 8.44547 19.8035L5.93535 20.6402C4.37184 21.1614 2.88436 19.6739 3.40553 18.1104L4.24224 15.6003C4.4877 14.8639 4.90125 14.1947 5.45012 13.6459L16.0961 2.99985C16.8772 2.2188 18.1435 2.2188 18.9246 2.99985L21.0459 5.12117C21.8269 5.90222 21.8269 7.16855 21.0459 7.9496ZM18.2174 7.9496L19.6317 6.53538L17.5103 4.41406L16.0961 5.82828L18.2174 7.9496ZM16.8032 9.36381L14.6819 7.24249L7.1693 14.7551L8.1212 15.707C8.51173 16.0975 8.51173 16.7307 8.1212 17.1212C7.73068 17.5117 7.09751 17.5117 6.70699 17.1212L6.05932 16.4735L5.3029 18.7428L7.81302 17.9061C8.25485 17.7588 8.65633 17.5107 8.98565 17.1814L16.8032 9.36381Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const PercentageOutlineIcon = (props) => {
    const { title = 'Percentage Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 6C6.67157 6 6 6.67157 6 7.5C6 8.32843 6.67157 9 7.5 9C8.32843 9 9 8.32843 9 7.5C9 6.67157 8.32843 6 7.5 6ZM4 7.5C4 5.567 5.567 4 7.5 4C9.433 4 11 5.567 11 7.5C11 9.433 9.433 11 7.5 11C5.567 11 4 9.433 4 7.5Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 15C15.6716 15 15 15.6716 15 16.5C15 17.3284 15.6716 18 16.5 18C17.3284 18 18 17.3284 18 16.5C18 15.6716 17.3284 15 16.5 15ZM13 16.5C13 14.567 14.567 13 16.5 13C18.433 13 20 14.567 20 16.5C20 18.433 18.433 20 16.5 20C14.567 20 13 18.433 13 16.5Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.3718 4.1727C17.8242 4.48948 17.9342 5.11302 17.6174 5.56543L7.86659 19.491C7.54981 19.9434 6.92626 20.0534 6.47386 19.7366C6.02145 19.4198 5.9115 18.7963 6.22828 18.3439L15.9791 4.41827C16.2959 3.96587 16.9194 3.85592 17.3718 4.1727Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const PhoneOutlineIcon = (props) => {
    const { title = 'Phone Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.36 4.48655C10.2399 4.27852 9.8375 4.08422 9.37227 4.35282L7.54664 5.40685C7.13967 5.64181 7.06777 6.02047 7.13904 6.21588C8.69488 10.4814 11.5605 15.5304 14.5829 19.1177C14.7156 19.2752 15.0777 19.4014 15.4836 19.1671L17.3149 18.1098C17.7801 17.8412 17.813 17.3956 17.6929 17.1876L16.441 15.0191C16.3209 14.8111 15.9185 14.6168 15.4532 14.8854C14.6517 15.3481 13.6108 15.1283 13.0822 14.339C12.1226 12.9057 11.28 11.4382 10.523 9.88938C10.1087 9.04179 10.437 8.03733 11.2339 7.57726C11.6991 7.30866 11.7321 6.86304 11.612 6.65501L10.36 4.48655ZM8.37227 2.62077C9.61792 1.90159 11.3231 2.15479 12.092 3.48655L13.344 5.65501C14.0754 6.92179 13.538 8.43432 12.4118 9.19786C13.0759 10.5377 13.808 11.8122 14.6322 13.0581C15.8575 12.4604 17.4403 12.7501 18.173 14.0191L19.425 16.1876C20.1939 17.5193 19.5605 19.1227 18.3149 19.8419L16.4836 20.8992C15.3982 21.5258 13.9223 21.4375 13.0534 20.4063C9.87388 16.6325 6.89282 11.3775 5.26013 6.9012C4.79703 5.63156 5.4573 4.30373 6.54664 3.6748L8.37227 2.62077Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const PlayCircleOutlineIcon = (props) => {
    const { title = 'Play Circle Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 12.2188C16.5 12.5015 16.3495 12.7628 16.1053 12.9042L10.1842 16.3315C9.93995 16.4728 9.639 16.4728 9.39474 16.3315C9.15047 16.1901 9 15.9288 9 15.646L9 8.79149C9 8.50872 9.15047 8.24743 9.39474 8.10604C9.639 7.96465 9.93995 7.96465 10.1842 8.10604L16.1053 11.5333C16.3495 11.6747 16.5 11.936 16.5 12.2188Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const PlayOutlineIcon = (props) => {
    const { title = 'Play Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.62777 6.46465C6.54629 6.4176 6.44444 6.47641 6.44444 6.57049V18.2715C6.44444 18.3655 6.54629 18.4244 6.62777 18.3773L16.7611 12.5268C16.8426 12.4798 16.8426 12.3622 16.7611 12.3151L6.62777 6.46465ZM17.9833 14.6438L7.84999 20.4943C6.13887 21.4822 4 20.2473 4 18.2715V6.57049C4 4.59466 6.1389 3.35979 7.85 4.3477L17.9833 10.1982C19.6945 11.1861 19.6944 13.6559 17.9833 14.6438Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const PreferencesOutlineIcon = (props) => {
    const { title = 'Preferences Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.7324 5L20 5C20.5523 5 21 5.44771 21 6C21 6.55228 20.5523 7 20 7L17.7324 7C17.3866 7.5978 16.7403 8 16 8C15.2597 8 14.6134 7.5978 14.2676 7L4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5L14.2676 5C14.6134 4.4022 15.2597 4 16 4C16.7403 4 17.3866 4.4022 17.7324 5Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.7324 17L20 17C20.5523 17 21 17.4477 21 18C21 18.5523 20.5523 19 20 19L17.7324 19C17.3866 19.5978 16.7403 20 16 20C15.2597 20 14.6134 19.5978 14.2676 19L4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17L14.2676 17C14.6134 16.4022 15.2597 16 16 16C16.7403 16 17.3866 16.4022 17.7324 17Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.73244 11L20 11C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13L9.73244 13C9.38663 13.5978 8.74028 14 8 14C7.25972 14 6.61337 13.5978 6.26756 13L4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11L6.26756 11C6.61337 10.4022 7.25972 10 8 10C8.74028 10 9.38663 10.4022 9.73244 11Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const PreviewOutlineIcon = (props) => {
    const { title = 'Preview Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H10.4615C11.0138 21 11.4615 20.5523 11.4615 20C11.4615 19.4477 11.0138 19 10.4615 19H5V5H15V6C15 6.55228 15.4477 7 16 7C16.5523 7 17 6.55228 17 6V5C17 3.89543 16.1046 3 15 3H5Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.075 17.3608C7.90725 15.1931 7.90725 11.6785 10.075 9.51078C12.2427 7.34306 15.7573 7.34306 17.925 9.51078C19.8513 11.4371 20.0658 14.427 18.5685 16.5902L20.8334 18.8551C21.2239 19.2456 21.2239 19.8788 20.8334 20.2693C20.4428 20.6598 19.8097 20.6598 19.4191 20.2693L17.1543 18.0044C14.9911 19.5016 12.0013 19.2871 10.075 17.3608ZM11.4892 10.925C10.1025 12.3117 10.1025 14.5599 11.4892 15.9466C12.8759 17.3333 15.1241 17.3333 16.5108 15.9466C17.8974 14.5599 17.8974 12.3117 16.5108 10.925C15.1241 9.53832 12.8759 9.53832 11.4892 10.925Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ProfileOutlineIcon = (props) => {
    const { title = 'Profile Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7ZM15 7C15 8.65685 13.6569 10 12 10C10.3431 10 9 8.65685 9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 13H10C7.79086 13 6 14.7909 6 17V19C6 20.1046 6.89543 21 8 21H16C17.1046 21 18 20.1046 18 19V17C18 14.7909 16.2091 13 14 13ZM8 17C8 15.8954 8.89543 15 10 15H14C15.1046 15 16 15.8954 16 17V19H8V17Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const RefreshOutlineIcon = (props) => {
    const { title = 'Refresh Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M11.5591 8.84146C11.9573 9.22412 12.5904 9.21148 12.973 8.81324L15.9126 5.75397C16.2952 5.35573 16.2826 4.7227 15.8843 4.34004L12.8251 1.40051C12.4268 1.01785 11.7938 1.03049 11.4111 1.42873C11.0285 1.82697 11.0411 2.46001 11.4394 2.84266L12.6715 4.02658C12.2165 3.98856 11.761 3.98992 11.3101 4.02934C10.0932 4.13328 8.95416 4.5096 7.95405 5.09705C7.02111 5.64265 6.18854 6.38364 5.52395 7.30213C4.91037 8.1465 4.4579 9.1155 4.21168 10.164C4.01287 11.0062 3.95553 11.8648 4.03081 12.7067C4.20218 14.6627 5.07803 16.4177 6.40111 17.7142C6.79558 18.1008 7.42871 18.0944 7.81525 17.6999C8.2018 17.3054 8.19538 16.6723 7.80091 16.2858C7.07175 15.5712 6.52477 14.6736 6.2344 13.667C6.23037 13.6487 6.2258 13.6304 6.2207 13.612C6.12758 13.2781 6.06322 12.9364 6.02868 12.5909C6.0097 12.3965 5.99999 12.1994 5.99999 12C5.99999 11.4366 6.07766 10.8913 6.22287 10.3742C6.35562 9.90407 6.54839 9.44262 6.80393 9C6.91138 8.8139 7.0273 8.63572 7.15093 8.46567C7.64544 7.78837 8.27841 7.21859 9.0082 6.79797C9.71386 6.39293 10.4946 6.13578 11.2993 6.04049C11.5291 6.01375 11.763 6.00001 12 6.00001C12.0159 6.00001 12.0316 5.99964 12.0473 5.99891C12.3135 6.00075 12.5805 6.02033 12.8467 6.05815L11.5309 7.42753C11.1482 7.82577 11.1609 8.45881 11.5591 8.84146Z" }),
        React$2.createElement("path", { d: "M19 11C19.5523 11 20 11.4477 20 12C20 13.4555 19.6104 14.823 18.9291 16.0007C18.6526 16.4788 18.0409 16.6422 17.5628 16.3656C17.0847 16.0891 16.9214 15.4773 17.1979 14.9993C17.7078 14.1178 18 13.0945 18 12C18 11.4477 18.4477 11 19 11Z" }),
        React$2.createElement("path", { d: "M16.3656 17.5628C16.6421 18.0409 16.4788 18.6526 16.0007 18.9291C14.823 19.6104 13.4555 20 12 20C11.4129 20 10.8395 19.9366 10.2867 19.8159C9.74712 19.6981 9.4052 19.1652 9.52301 18.6256C9.64081 18.086 10.1737 17.7441 10.7133 17.8619C11.1269 17.9522 11.5573 18 12 18C13.0945 18 14.1178 17.7078 14.9993 17.1979C15.4773 16.9214 16.0891 17.0847 16.3656 17.5628Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ReplayOutlineIcon = (props) => {
    const { title = 'Replay Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.60698 5.17803C9.39604 5.3388 9.2576 5.57677 9.22212 5.8396C9.18665 6.10244 9.25703 6.3686 9.41779 6.57954L11.9895 9.95389C12.3243 10.3932 12.9518 10.4779 13.391 10.1431C13.8303 9.80831 13.915 9.18083 13.5802 8.74158L12.3951 7.18657C15.5246 7.38999 18 9.9928 18 13.1738C18 16.4875 15.3137 19.1738 12 19.1738C8.68629 19.1738 6 16.4875 6 13.1738C6 12.6215 5.55228 12.1738 5 12.1738C4.44772 12.1738 4 12.6215 4 13.1738C4 17.592 7.58172 21.1738 12 21.1738C16.4183 21.1738 20 17.592 20 13.1738C20 9.04366 16.8703 5.64454 12.8531 5.21871L14.1937 4.19701C14.6329 3.86224 14.7176 3.23476 14.3828 2.79551C14.0481 2.35625 13.4206 2.27155 12.9813 2.60632L9.60698 5.17803Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ResizeOutlineIcon = (props) => {
    const { title = 'Resize Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.22835 17.7599C5.7957 17.3273 5.7957 16.6258 6.22835 16.1932L16.2049 6.2166C16.6376 5.78396 17.339 5.78396 17.7717 6.2166C18.2043 6.64925 18.2043 7.3507 17.7717 7.78334L7.79509 17.7599C7.36244 18.1926 6.66099 18.1926 6.22835 17.7599Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.4065 17.1042C12.9739 16.6715 12.9739 15.9701 13.4065 15.5374L16.0144 12.9295C16.4471 12.4969 17.1485 12.4969 17.5812 12.9295C18.0138 13.3622 18.0138 14.0636 17.5812 14.4963L14.9733 17.1042C14.5406 17.5368 13.8392 17.5368 13.4065 17.1042Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ResultOutlineIcon = (props) => {
    const { title = 'Result Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V16C22 17.1046 21.1046 18 20 18H4C2.89543 18 2 17.1046 2 16V6ZM20 6L4 6V16H20V6Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 14C7.44772 14 7 13.5523 7 13L7 11C7 10.4477 7.44772 10 8 10C8.55228 10 9 10.4477 9 11L9 13C9 13.5523 8.55228 14 8 14Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 14C11.4477 14 11 13.5523 11 13L11 10C11 9.44771 11.4477 9 12 9C12.5523 9 13 9.44771 13 10L13 13C13 13.5523 12.5523 14 12 14Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 14C15.4477 14 15 13.5523 15 13L15 9C15 8.44772 15.4477 8 16 8C16.5523 8 17 8.44772 17 9L17 13C17 13.5523 16.5523 14 16 14Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 20C7 19.4477 7.44772 19 8 19H16C16.5523 19 17 19.4477 17 20C17 20.5523 16.5523 21 16 21H8C7.44772 21 7 20.5523 7 20Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const RewardOutlineIcon = (props) => {
    const { title = 'Reward Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M16 12.9999C16.5523 12.9999 17 12.5522 17 11.9999C17 11.4476 16.5523 10.9999 16 10.9999H8C7.44771 10.9999 7 11.4476 7 11.9999C7 12.5522 7.44771 12.9999 8 12.9999H16Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.25 4.16497C6.94036 2.96924 8.46933 2.55955 9.66506 3.2499L11.3971 4.2499C11.5359 4.33001 11.664 4.42141 11.7811 4.52228C11.8982 4.42141 12.0264 4.33001 12.1651 4.2499L13.8972 3.2499C15.0929 2.55955 16.6219 2.96924 17.3123 4.16497C17.8473 5.09161 17.7216 6.21839 17.0815 6.9999H18C19.1046 6.9999 20 7.89534 20 8.9999V18.9999C20 20.1045 19.1046 20.9999 18 20.9999H6C4.89543 20.9999 4 20.1045 4 18.9999V8.9999C4 7.89534 4.89543 6.9999 6 6.9999H6.4808C5.84065 6.21839 5.715 5.09161 6.25 4.16497ZM8.66506 4.98196L10.3971 5.98196C10.6363 6.12003 10.7182 6.42582 10.5801 6.66497C10.4421 6.90411 10.1363 6.98605 9.89711 6.84798L8.16506 5.84798C7.92592 5.70991 7.84398 5.40411 7.98205 5.16497C8.12012 4.92582 8.42592 4.84388 8.66506 4.98196ZM6 8.9999H18V18.9999H6V8.9999ZM13.1651 5.98196L14.8972 4.98196C15.1363 4.84388 15.4421 4.92582 15.5802 5.16497C15.7183 5.40411 15.6363 5.70991 15.3972 5.84798L13.6651 6.84798C13.426 6.98605 13.1202 6.90411 12.9821 6.66497C12.8441 6.42582 12.926 6.12003 13.1651 5.98196Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const SatisfiedOutlineIcon = (props) => {
    const { title = 'Satisfied Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" }),
        React$2.createElement("path", { d: "M10 9.5C10 10.3284 9.32843 11 8.5 11C7.67157 11 7 10.3284 7 9.5C7 8.67157 7.67157 8 8.5 8C9.32843 8 10 8.67157 10 9.5Z" }),
        React$2.createElement("path", { d: "M17 9.5C17 10.3284 16.3284 11 15.5 11C14.6716 11 14 10.3284 14 9.5C14 8.67157 14.6716 8 15.5 8C16.3284 8 17 8.67157 17 9.5Z" }),
        React$2.createElement("path", { d: "M9.70708 15.1679C9.31654 14.7774 8.68338 14.7774 8.29287 15.1679C7.90236 15.5585 7.90238 16.1916 8.29292 16.5821L9.70708 15.1679ZM15.7071 16.5821C16.0976 16.1916 16.0976 15.5585 15.7071 15.1679C15.3166 14.7774 14.6835 14.7774 14.2929 15.1679L15.7071 16.5821ZM8.29292 16.5821C9.2729 17.562 10.6765 17.9999 12 17.9999C13.3235 17.9999 14.7271 17.562 15.7071 16.5821L14.2929 15.1679C13.7729 15.6879 12.9265 15.9999 12 15.9999C11.0735 15.9999 10.2271 15.6879 9.70708 15.1679L8.29292 16.5821Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const SaveOutlineIcon = (props) => {
    const { title = 'Save Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M3 4C3 3.44772 3.44772 3 4 3H17.5858C17.851 3 18.1054 3.10536 18.2929 3.29289L20.7071 5.70711C20.8946 5.89464 21 6.149 21 6.41421V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4Z", stroke: color, strokeWidth: "2", fill: "none" }),
        React$2.createElement("rect", { x: "7", y: "3", width: "10", height: "6", rx: "1", stroke: color, strokeWidth: "2", fill: "none" }),
        React$2.createElement("rect", { x: "7", y: "13", width: "10", height: "8", rx: "1", stroke: color, strokeWidth: "2", fill: "none" }),
        React$2.createElement("rect", { x: "13", y: "5", width: "2", height: "2", rx: "1" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ScanOutlineIcon = (props) => {
    const { title = 'Scan Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 7C12.5523 7 13 7.44772 13 8V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V8C11 7.44772 11.4477 7 12 7Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 7C16.5523 7 17 7.44772 17 8V16C17 16.5523 16.5523 17 16 17C15.4477 17 15 16.5523 15 16V8C15 7.44772 15.4477 7 16 7Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 7C8.55228 7 9 7.44772 9 8V16C9 16.5523 8.55228 17 8 17C7.44772 17 7 16.5523 7 16V8C7 7.44772 7.44772 7 8 7Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 5C3 3.89543 3.89543 3 5 3H8C8.55228 3 9 3.44772 9 4C9 4.55228 8.55228 5 8 5H5V8C5 8.55228 4.55228 9 4 9C3.44772 9 3 8.55228 3 8V5Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 5C21 3.89543 20.1046 3 19 3H16C15.4477 3 15 3.44772 15 4C15 4.55228 15.4477 5 16 5H19V8C19 8.55228 19.4477 9 20 9C20.5523 9 21 8.55228 21 8V5Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 19C3 20.1046 3.89543 21 5 21H8C8.55228 21 9 20.5523 9 20C9 19.4477 8.55228 19 8 19H5V16C5 15.4477 4.55228 15 4 15C3.44772 15 3 15.4477 3 16V19Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 19C21 20.1046 20.1046 21 19 21H16C15.4477 21 15 20.5523 15 20C15 19.4477 15.4477 19 16 19H19V16C19 15.4477 19.4477 15 20 15C20.5523 15 21 15.4477 21 16V19Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const SearchOutlineIcon = (props) => {
    const { title = 'Search Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("g", { clipPath: "url(#clip0_377_154)" },
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.0911 5.24605C19.0859 8.2408 19.0859 13.0963 16.0911 16.091C13.0963 19.0858 8.24088 19.0858 5.24613 16.091C2.25137 13.0963 2.25137 8.2408 5.24613 5.24604C8.24088 2.25129 13.0963 2.25129 16.0911 5.24605ZM14.6769 6.66026C16.8906 8.87397 16.8906 12.4631 14.6769 14.6768C12.4632 16.8905 8.87405 16.8905 6.66034 14.6768C4.44663 12.4631 4.44663 8.87397 6.66034 6.66026C8.87405 4.44655 12.4632 4.44655 14.6769 6.66026Z" }),
            React$2.createElement("path", { d: "M19.1958 20.6099L16.1129 17.527C16.3745 17.3257 16.6262 17.1052 16.8659 16.8655C17.1055 16.6259 17.3259 16.3744 17.5271 16.1129L20.61 19.1957C20.996 19.5817 20.9922 20.2111 20.6017 20.6017C20.2112 20.9922 19.5817 20.9959 19.1958 20.6099Z" })),
        React$2.createElement("defs", null,
            React$2.createElement("clipPath", { id: "clip0_377_154" },
                React$2.createElement("rect", { width: "24", height: "24", fill: "white" })))));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const SettingsOutlineIcon = (props) => {
    const { title = 'Settings Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.2496 6.4354L13 5.92958V4H11V5.92957L9.75042 6.43539C9.24741 6.639 8.7774 6.90939 8.35157 7.23617L7.29135 8.04977L5.74169 7.15507L4.675 9.00264L6.22175 9.89565L6.05022 11.2182C6.01714 11.4732 5.99997 11.7341 5.99997 12C5.99997 12.2748 6.01831 12.5442 6.05359 12.8074L6.23161 14.1353L4.69088 15.0248L5.72558 16.817L7.26916 15.9258L8.33081 16.7478C8.76211 17.0818 9.23922 17.3577 9.75042 17.5646L11 18.0704V20H13V18.0704L14.2496 17.5646C14.7526 17.361 15.2225 17.0906 15.6484 16.7638L16.7086 15.9502L18.2584 16.845L19.3251 14.9974L17.7782 14.1044L17.9497 12.7818C17.9828 12.5268 18 12.2659 18 12C18 11.7251 17.9816 11.4555 17.9463 11.1922L17.7682 9.86418L19.309 8.97459L18.2743 7.18245L16.7304 8.0738L15.6688 7.2519C15.2376 6.91807 14.7606 6.64227 14.2496 6.4354ZM15 4.58153V3C15 2.44772 14.5523 2 14 2H9.99999C9.44771 2 8.99999 2.44772 8.99999 3V4.58151C8.32774 4.85363 7.7009 5.21447 7.13398 5.64951L5.87567 4.92302C5.39737 4.64688 4.78578 4.81076 4.50964 5.28905L2.44295 8.86866C2.16681 9.34696 2.33068 9.95855 2.80897 10.2347L4.06683 10.9609C4.02272 11.301 3.99997 11.6479 3.99997 12C3.99997 12.3639 4.02427 12.7221 4.07132 13.0731L2.82486 13.7928C2.34656 14.0689 2.18269 14.6805 2.45883 15.1588L4.49353 18.683C4.76967 19.1613 5.38126 19.3252 5.85955 19.049L7.10634 18.3292C7.6805 18.7738 8.3168 19.1419 8.99999 19.4185V21C8.99999 21.5523 9.44771 22 9.99999 22H14C14.5523 22 15 21.5523 15 21V19.4185C15.6722 19.1464 16.299 18.7855 16.866 18.3505L18.1244 19.0771C18.6027 19.3532 19.2143 19.1893 19.4904 18.711L21.5571 15.1314C21.8333 14.6531 21.6694 14.0415 21.1911 13.7654L19.9331 13.0391C19.9772 12.699 20 12.3521 20 12C20 11.6359 19.9756 11.2775 19.9285 10.9263L21.175 10.2066C21.6533 9.9305 21.8172 9.31891 21.541 8.84062L19.5063 5.31642C19.2302 4.83813 18.6186 4.67425 18.1403 4.9504L16.8931 5.67045C16.3191 5.22605 15.683 4.858 15 4.58153Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.4142 10.5858C12.6332 9.80474 11.3668 9.80474 10.5858 10.5858C9.80474 11.3668 9.80474 12.6332 10.5858 13.4142C10.9763 13.8047 10.9763 14.4379 10.5858 14.8284C10.1953 15.219 9.5621 15.219 9.17157 14.8284C7.60948 13.2663 7.60948 10.7337 9.17157 9.17157C10.7337 7.60948 13.2663 7.60948 14.8284 9.17157C16.3905 10.7337 16.3905 13.2663 14.8284 14.8284C14.4379 15.219 13.8047 15.219 13.4142 14.8284C13.0237 14.4379 13.0237 13.8047 13.4142 13.4142C14.1953 12.6332 14.1953 11.3668 13.4142 10.5858Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ShowOutlineIcon = (props) => {
    const { title = 'Show Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12C22 14 16.6935 18 12 18C7.30648 18 2 14 2 12C2 10 7.30648 6 12 6C16.6935 6 22 10 22 12ZM19.5885 11.5313C19.7756 11.7464 19.8805 11.9023 19.9384 12C19.8805 12.0977 19.7756 12.2536 19.5885 12.4687C19.1651 12.9554 18.5062 13.5269 17.6662 14.0757C15.9569 15.1924 13.8351 16 12 16C10.1649 16 8.04314 15.1924 6.33381 14.0757C5.49382 13.5269 4.83488 12.9554 4.4115 12.4687C4.22442 12.2536 4.11953 12.0977 4.06159 12C4.11953 11.9023 4.22442 11.7464 4.4115 11.5313C4.83488 11.0446 5.49382 10.4731 6.33381 9.92434C8.04314 8.80761 10.1649 8 12 8C13.8351 8 15.9569 8.80761 17.6662 9.92434C18.5062 10.4731 19.1651 11.0446 19.5885 11.5313Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const SimilarOutlineIcon = (props) => {
    const { title = 'Similar Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 18.3264C11.0907 18.7583 10.0736 19 9 19C5.13401 19 2 15.866 2 12C2 8.13401 5.13401 5 9 5C10.0736 5 11.0907 5.24169 12 5.67363C12.9093 5.24169 13.9264 5 15 5C18.866 5 22 8.13401 22 12C22 15.866 18.866 19 15 19C13.9264 19 12.9093 18.7583 12 18.3264ZM10.0008 16.8998C9.67745 16.9655 9.34275 17 9 17C6.23858 17 4 14.7614 4 12C4 9.23858 6.23858 7 9 7C9.34275 7 9.67745 7.03449 10.0008 7.10018C8.76315 8.36279 8 10.0923 8 12C8 13.9077 8.76315 15.6372 10.0008 16.8998ZM13.9992 7.10018C14.3225 7.03449 14.6572 7 15 7C17.7614 7 20 9.23858 20 12C20 14.7614 17.7614 17 15 17C14.6572 17 14.3225 16.9655 13.9992 16.8998C15.2369 15.6372 16 13.9077 16 12C16 10.0923 15.2369 8.36279 13.9992 7.10018Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const SingleImageOutlineIcon = (props) => {
    const { title = 'Single Image Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M9 9C9 10.1046 8.10457 11 7 11C5.89543 11 5 10.1046 5 9C5 7.89543 5.89543 7 7 7C8.10457 7 9 7.89543 9 9Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 13.2907V5C22 4.44772 21.5523 4 21 4H3C2.44772 4 2 4.44772 2 5V19C2 19.5523 2.44772 20 3 20H21C21.5523 20 22 19.5523 22 19V13.2978C22 13.2955 22 13.2931 22 13.2907ZM4 16.6267L9 11.9208L11.5 14.2738L17.5 8.62671L20 10.9796V6H4V16.6267ZM20 13.7261L17.5 11.3732L11.5 17.0203L9 14.6673L5.45904 18H20V13.7261Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const Skip10OutlineIcon = (props) => {
    const { title = 'Skip10 Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M10.2937 15.5V8.82998H9.05374L6.95374 10.94L7.76374 11.79L8.86374 10.66V15.5H10.2937Z" }),
        React$2.createElement("path", { d: "M11.2951 12.17C11.2951 13.89 12.1451 15.62 14.0551 15.62C15.9551 15.62 16.8151 13.89 16.8151 12.17C16.8151 10.45 15.9551 8.72998 14.0551 8.72998C12.1451 8.72998 11.2951 10.45 11.2951 12.17ZM15.3651 12.17C15.3651 13.4 15.0051 14.36 14.0551 14.36C13.0951 14.36 12.7351 13.4 12.7351 12.17C12.7351 10.94 13.0951 9.98998 14.0551 9.98998C15.0051 9.98998 15.3651 10.94 15.3651 12.17Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.1119 8.15854L17.5867 8.07617L17.5616 8.07224L15.2112 7.70368L15.1762 7.69819L14.5929 7.60673L13.7778 7.47891C13.3929 7.41855 13.2219 6.96062 13.473 6.6627L14.0047 6.03183L14.3852 5.5804L14.4081 5.5533L14.477 5.47151C13.6926 5.16712 12.8393 5.0001 11.9457 5.0001C8.07969 5.0001 4.94568 8.1341 4.94568 12.0001C4.94568 15.8661 8.07969 19.0001 11.9457 19.0001C15.8117 19.0001 18.9457 15.8661 18.9457 12.0001C18.9457 11.4478 19.3934 11.0001 19.9457 11.0001C20.498 11.0001 20.9457 11.4478 20.9457 12.0001C20.9457 16.9707 16.9162 21.0001 11.9457 21.0001C6.97512 21.0001 2.94568 16.9707 2.94568 12.0001C2.94568 7.02953 6.97512 3.0001 11.9457 3.0001C13.3323 3.0001 14.6475 3.31431 15.8222 3.87567L15.9346 3.7423L15.9502 3.72379L16.2875 3.32363L16.8622 2.64176C17.1085 2.3496 17.5782 2.43044 17.7126 2.78813L18.0262 3.62293L18.2103 4.11283L18.2189 4.13549L19.0236 6.27705L19.0325 6.30083L19.2195 6.79851L19.5303 7.62557C19.665 7.98408 19.3632 8.35474 18.9848 8.2954L18.1119 8.15854Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const SortOutlineIcon = (props) => {
    const { title = 'Sort Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M11.7071 9.70711C12.0976 9.31658 12.0976 8.68342 11.7071 8.29289L7.70711 4.29289C7.61123 4.19702 7.50073 4.12468 7.38278 4.07588C7.26575 4.02735 7.1375 4.0004 7.003 4L7 4L6.997 4C6.72537 4.0008 6.47921 4.1099 6.29945 4.28639L6.29216 4.29362L2.29289 8.29289C1.90237 8.68342 1.90237 9.31658 2.29289 9.70711C2.68342 10.0976 3.31658 10.0976 3.70711 9.70711L6 7.41421V19C6 19.5523 6.44771 20 7 20C7.55228 20 8 19.5523 8 19V7.41421L10.2929 9.70711C10.6834 10.0976 11.3166 10.0976 11.7071 9.70711Z" }),
        React$2.createElement("path", { d: "M16.2922 19.7064L12.2929 15.7071C11.9024 15.3166 11.9024 14.6834 12.2929 14.2929C12.6834 13.9024 13.3166 13.9024 13.7071 14.2929L16 16.5858V5C16 4.44772 16.4477 4 17 4C17.5523 4 18 4.44772 18 5V16.5858L20.2929 14.2929C20.6834 13.9024 21.3166 13.9024 21.7071 14.2929C22.0976 14.6834 22.0976 15.3166 21.7071 15.7071L17.7078 19.7064C17.7054 19.7088 17.703 19.7112 17.7005 19.7136C17.5208 19.8901 17.2746 19.9992 17.003 20L17 20L16.997 20C16.8625 19.9996 16.7343 19.9727 16.6172 19.9241C16.502 19.8764 16.3938 19.8063 16.2995 19.7136C16.297 19.7112 16.2946 19.7088 16.2922 19.7064Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const SplitScreenOutlineIcon = (props) => {
    const { title = 'Split Screen Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M4 7C4 5.89543 4.89543 5 6 5H10V19H6C4.89543 19 4 18.1046 4 17V7Z", stroke: color, strokeWidth: "2", fill: "none" }),
        React$2.createElement("path", { d: "M14 5H18C19.1046 5 20 5.89543 20 7V17C20 18.1046 19.1046 19 18 19H14", stroke: color, strokeWidth: "2", fill: "none" }),
        React$2.createElement("path", { d: "M10 2V21.5", stroke: color, strokeWidth: "2", fill: "none" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const SubArrowOutlineIcon = (props) => {
    const { title = 'Sub Arrow Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M6 4V14L16.5858 14L14.2929 11.7071C13.9024 11.3166 13.9024 10.6834 14.2929 10.2929C14.6834 9.90237 15.3166 9.90237 15.7071 10.2929L19.7071 14.2929C19.8033 14.389 19.8757 14.4999 19.9245 14.6182C19.9728 14.735 19.9996 14.8629 20 14.997L20 15L20 15.003C19.9992 15.2724 19.8919 15.5167 19.718 15.6961C19.714 15.7002 19.71 15.7042 19.7059 15.7083L15.7071 19.7071C15.3166 20.0976 14.6834 20.0976 14.2929 19.7071C13.9024 19.3166 13.9024 18.6834 14.2929 18.2929L16.5858 16L5 16C4.44772 16 4 15.5523 4 15V4C4 3.44772 4.44772 3 5 3C5.55228 3 6 3.44772 6 4Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const SuggestedPlaceToValidateOutlineIcon = (props) => {
    const { title = 'Suggested Place To Validate Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 10C20 14.4183 13.5 22 12 22C10.5 22 4 14.4183 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10ZM18 10C18 10.6707 17.7358 11.6569 17.1544 12.8808C16.5905 14.0679 15.8055 15.3183 14.9552 16.4667C14.1044 17.6156 13.2265 18.6107 12.5048 19.2968C12.3148 19.4775 12.1458 19.6269 12 19.7471C11.8542 19.6269 11.6852 19.4775 11.4952 19.2968C10.7735 18.6107 9.89559 17.6156 9.04481 16.4667C8.19449 15.3183 7.40953 14.0679 6.84559 12.8808C6.2642 11.6569 6 10.6707 6 10C6 6.68629 8.68629 4 12 4C15.3137 4 18 6.68629 18 10Z" }),
        React$2.createElement("path", { d: "M11.03 11.39C11.03 11.88 11.198 12.3 11.492 12.622L13.018 12.174C12.878 12.048 12.766 11.81 12.766 11.586C12.766 11.068 13.2 10.76 13.69 10.396C14.348 9.934 15.104 9.374 15.104 8.212C15.104 6.91 13.998 6 12.192 6C10.988 6 9.86801 6.49 9.12601 7.358L10.26 8.632C10.694 8.114 11.282 7.764 11.982 7.764C12.752 7.764 13.074 8.128 13.074 8.562C13.074 8.982 12.696 9.248 12.262 9.556C11.702 9.962 11.03 10.424 11.03 11.39ZM11.03 14.498C11.03 15.114 11.548 15.632 12.164 15.632C12.78 15.632 13.298 15.114 13.298 14.498C13.298 13.882 12.78 13.364 12.164 13.364C11.548 13.364 11.03 13.882 11.03 14.498Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const TakePicOutlineIcon = (props) => {
    const { title = 'Take Pic Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M3 6C3 4.34315 4.34315 3 6 3H8C8.55228 3 9 3.44772 9 4C9 4.55228 8.55228 5 8 5H6C5.44772 5 5 5.44772 5 6V8C5 8.55228 4.55228 9 4 9C3.44772 9 3 8.55228 3 8V6Z" }),
        React$2.createElement("path", { d: "M13 10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10V11H10C9.44772 11 9 11.4477 9 12C9 12.5523 9.44772 13 10 13H11V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V13H14C14.5523 13 15 12.5523 15 12C15 11.4477 14.5523 11 14 11H13V10Z" }),
        React$2.createElement("path", { d: "M6 21C4.34315 21 3 19.6569 3 18V16C3 15.4477 3.44772 15 4 15C4.55228 15 5 15.4477 5 16V18C5 18.5523 5.44772 19 6 19H8C8.55228 19 9 19.4477 9 20C9 20.5523 8.55228 21 8 21H6Z" }),
        React$2.createElement("path", { d: "M21 6C21 4.34315 19.6569 3 18 3H16C15.4477 3 15 3.44772 15 4C15 4.55228 15.4477 5 16 5H18C18.5523 5 19 5.44772 19 6V8C19 8.55228 19.4477 9 20 9C20.5523 9 21 8.55228 21 8V6Z" }),
        React$2.createElement("path", { d: "M18 21C19.6569 21 21 19.6569 21 18V16C21 15.4477 20.5523 15 20 15C19.4477 15 19 15.4477 19 16V18C19 18.5523 18.5523 19 18 19H16C15.4477 19 15 19.4477 15 20C15 20.5523 15.4477 21 16 21H18Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const TaskOutlineIcon = (props) => {
    const { title = 'Task Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 5H5L5 19H19V5ZM5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM6 16C6 15.4477 6.44772 15 7 15H17C17.5523 15 18 15.4477 18 16C18 16.5523 17.5523 17 17 17H7C6.44772 17 6 16.5523 6 16ZM9.70711 9.49992C9.31658 9.1094 8.68342 9.1094 8.29289 9.49992C7.90237 9.89045 7.90237 10.5236 8.29289 10.9141L10.4142 13.0355C10.8047 13.426 11.4379 13.426 11.8284 13.0355L15.364 9.49992C15.7545 9.1094 15.7545 8.47624 15.364 8.08571C14.9734 7.69519 14.3403 7.69519 13.9497 8.08571L11.1213 10.9141L9.70711 9.49992Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const TimeOutlineIcon = (props) => {
    const { title = 'Time Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 8C12.5523 8 13 8.44772 13 9V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V9C11 8.44772 11.4477 8 12 8Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 13C17 13.5523 16.5523 14 16 14H12C11.4477 14 11 13.5523 11 13C11 12.4477 11.4477 12 12 12H16C16.5523 12 17 12.4477 17 13Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const TrendOutlineIcon = (props) => {
    const { title = 'Trend Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M4 15L9 10L14 15L20 9", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }),
        React$2.createElement("circle", { cx: "4", cy: "15", r: "2" }),
        React$2.createElement("circle", { cx: "9", cy: "10", r: "2" }),
        React$2.createElement("circle", { cx: "14", cy: "15", r: "2" }),
        React$2.createElement("path", { d: "M21.6561 7.00959C21.8591 6.9552 22.0448 7.14094 21.9904 7.34392L20.5291 12.7975C20.4747 13.0005 20.221 13.0685 20.0724 12.9199L16.0801 8.92758C15.9315 8.77899 15.9995 8.52526 16.2025 8.47087L21.6561 7.00959Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const UnlockedOutlineIcon = (props) => {
    const { title = 'Unlocked Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.46447 1.46449L4.75736 2.1716L6.17157 3.58581L6.87868 2.8787C8.05025 1.70713 9.94975 1.70713 11.1213 2.8787C12.2929 4.05028 12.2929 5.94977 11.1213 7.12134L10.8137 7.42896H5H3H2C0.895431 7.42896 0 8.32439 0 9.42896V19.429C0 20.5335 0.895431 21.429 2 21.429H14C15.1046 21.429 16 20.5335 16 19.429V9.42896C16 8.32439 15.1046 7.42896 14 7.42896H13.3719C14.43 5.52659 14.1512 3.08021 12.5355 1.46449C10.5829 -0.488132 7.41709 -0.488132 5.46447 1.46449ZM14 9.42896V19.429H2V9.42896H14ZM10 13.429C10 14.1692 9.5978 14.8156 9 15.1614V16.429C9 16.9812 8.55228 17.429 8 17.429C7.44772 17.429 7 16.9812 7 16.429V15.1614C6.4022 14.8156 6 14.1692 6 13.429C6 12.3244 6.89543 11.429 8 11.429C9.10457 11.429 10 12.3244 10 13.429Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const UnsatisfiedOutlineIcon = (props) => {
    const { title = 'Unsatisfied Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" }),
        React$2.createElement("path", { d: "M10 9.5C10 10.3284 9.32843 11 8.5 11C7.67157 11 7 10.3284 7 9.5C7 8.67157 7.67157 8 8.5 8C9.32843 8 10 8.67157 10 9.5Z" }),
        React$2.createElement("path", { d: "M17 9.5C17 10.3284 16.3284 11 15.5 11C14.6716 11 14 10.3284 14 9.5C14 8.67157 14.6716 8 15.5 8C16.3284 8 17 8.67157 17 9.5Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 15.875C11.0735 15.875 10.2271 16.1871 9.70708 16.7071C9.31654 17.0976 8.68338 17.0975 8.29287 16.707C7.90236 16.3165 7.90238 15.6833 8.29292 15.2928C9.2729 14.3129 10.6765 13.875 12 13.875C13.3235 13.875 14.7271 14.3129 15.7071 15.2928C16.0976 15.6833 16.0976 16.3165 15.7071 16.707C15.3166 17.0975 14.6835 17.0976 14.2929 16.707C13.7729 16.1871 12.9265 15.875 12 15.875Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const UploadOutlineIcon = (props) => {
    const { title = 'Upload Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M13 10.4142L13.7929 11.2071C14.1834 11.5976 14.8166 11.5976 15.2071 11.2071C15.5976 10.8166 15.5976 10.1834 15.2071 9.79289L12.7071 7.29289C12.5196 7.10536 12.2652 7 12 7C11.7348 7 11.4804 7.10536 11.2929 7.29289L8.79289 9.79289C8.40237 10.1834 8.40237 10.8166 8.79289 11.2071C9.18342 11.5976 9.81658 11.5976 10.2071 11.2071L11 10.4143V13.9999C11 14.5522 11.4477 14.9999 12 14.9999C12.5522 14.9999 13 14.5522 13 13.9999V10.4142Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 18.9776C4.19675 18.725 2 16.369 2 13.5C2 11.3008 3.29079 9.40301 5.15611 8.52301C5.83411 5.36631 8.64071 3 12 3C15.866 3 19 6.13401 19 10V10.2561C20.7478 10.8738 22 12.5407 22 14.5C22 16.9853 19.9853 19 17.5 19H7V18.9776ZM17 11.6704V10C17 7.23858 14.7614 5 12 5C9.60294 5 7.59568 6.68879 7.11151 8.943L6.90384 9.90988L6.00945 10.3318C4.81782 10.894 4 12.1035 4 13.5C4 15.3246 5.39773 16.8251 7.1795 16.9857L7.33874 17H17.5C18.8807 17 20 15.8807 20 14.5C20 13.4146 19.3072 12.4859 18.3335 12.1417L17 11.6704Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const VideoOutlineIcon = (props) => {
    const { title = 'Video Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 6C3.89543 6 3 6.89543 3 8V17C3 18.1046 3.89543 19 5 19H14C15.1046 19 16 18.1046 16 17V15.5582L19.139 17.6299C19.9368 18.1565 21 17.5843 21 16.6284V8.37163C21 7.41572 19.9368 6.84354 19.139 7.3701L16 9.44183V8C16 6.89543 15.1046 6 14 6H5ZM16 11.8382V13.1618L19 15.1418V9.85817L16 11.8382ZM14 8L5 8V17H14V8Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const VolumeOffOutlineIcon = (props) => {
    const { title = 'Volume Off Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M19.9077 12.4991L21.7047 10.7117C21.7978 10.6186 21.8716 10.508 21.922 10.3864C21.9724 10.2647 21.9983 10.1343 21.9983 10.0027C21.9983 9.871 21.9724 9.74062 21.922 9.61897C21.8716 9.49732 21.7978 9.38678 21.7047 9.29368C21.6116 9.20057 21.5011 9.12671 21.3795 9.07632C21.2579 9.02593 21.1275 9 20.9959 9C20.8642 9 20.7339 9.02593 20.6123 9.07632C20.4906 9.12671 20.3801 9.20057 20.287 9.29368L18.5 11.0911L16.713 9.29368C16.525 9.10564 16.27 9 16.0041 9C15.7383 9 15.4833 9.10564 15.2953 9.29368C15.1073 9.48171 15.0017 9.73675 15.0017 10.0027C15.0017 10.2686 15.1073 10.5236 15.2953 10.7117L17.0923 12.4991L15.2953 14.2866C15.2017 14.3795 15.1275 14.4899 15.0768 14.6116C15.0261 14.7333 15 14.8638 15 14.9956C15 15.1274 15.0261 15.258 15.0768 15.3797C15.1275 15.5013 15.2017 15.6118 15.2953 15.7046C15.3881 15.7982 15.4985 15.8725 15.6202 15.9232C15.7419 15.9739 15.8723 16 16.0041 16C16.1359 16 16.2664 15.9739 16.3881 15.9232C16.5097 15.8725 16.6202 15.7982 16.713 15.7046L18.5 13.9072L20.287 15.7046C20.3798 15.7982 20.4903 15.8725 20.6119 15.9232C20.7336 15.9739 20.8641 16 20.9959 16C21.1277 16 21.2581 15.9739 21.3798 15.9232C21.5015 15.8725 21.6119 15.7982 21.7047 15.7046C21.7983 15.6118 21.8725 15.5013 21.9232 15.3797C21.9739 15.258 22 15.1274 22 14.9956C22 14.8638 21.9739 14.7333 21.9232 14.6116C21.8725 14.4899 21.7983 14.3795 21.7047 14.2866L19.9077 12.4991Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.71963 4.59873C11.0223 3.51318 13 4.4395 13 6.13517V17.8651C13 19.5608 11.0223 20.4871 9.71963 19.4015L5.63795 16.0001H4C2.89543 16.0001 2 15.1047 2 14.0001V10.0001C2 8.89556 2.89543 8.00013 4 8.00013H5.63795L9.71963 4.59873ZM11 6.13517L6.64018 9.76835L6.36205 10.0001H6H4V14.0001H6H6.36205L6.64018 14.2319L11 17.8651L11 6.13517Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const VolumeOnOutlineIcon = (props) => {
    const { title = 'Volume On Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M19.6816 6.28659C19.4953 6.10309 19.2426 6 18.9791 6C18.7156 6 18.4629 6.10309 18.2766 6.28659C18.0903 6.47009 17.9857 6.71897 17.9857 6.97848C17.9857 7.23799 18.0903 7.48687 18.2766 7.67037C18.8592 8.24331 19.3145 8.92935 19.6134 9.68489C19.9124 10.4404 20.0485 11.249 20.0131 12.0591C19.9778 12.8693 19.7717 13.6633 19.4081 14.3908C19.0444 15.1183 18.531 15.7633 17.9007 16.2849C17.7476 16.4138 17.6381 16.5857 17.5868 16.7776C17.5356 16.9694 17.545 17.1721 17.6138 17.3586C17.6827 17.545 17.8076 17.7063 17.972 17.821C18.1365 17.9356 18.3325 17.998 18.5339 18C18.7651 18.0004 18.9891 17.9211 19.1671 17.7759C20.009 17.0813 20.695 16.2218 21.1814 15.2521C21.6678 14.2823 21.9439 13.2234 21.9923 12.1428C22.0407 11.0622 21.8603 9.98346 21.4624 8.97526C21.0646 7.96706 20.4581 7.05143 19.6816 6.28659ZM16.8816 9.04441C16.7893 8.95355 16.6798 8.88147 16.5593 8.8323C16.4388 8.78312 16.3096 8.75781 16.1791 8.75781C16.0487 8.75781 15.9195 8.78312 15.7989 8.8323C15.6784 8.88147 15.5689 8.95355 15.4767 9.04441C15.3844 9.13527 15.3112 9.24313 15.2613 9.36185C15.2114 9.48056 15.1857 9.6078 15.1857 9.7363C15.1857 9.86479 15.2114 9.99203 15.2613 10.1107C15.3112 10.2295 15.3844 10.3373 15.4767 10.4282C15.8483 10.792 16.0582 11.2862 16.0604 11.8022C16.0606 12.0861 15.9979 12.3667 15.8765 12.6242C15.7552 12.8818 15.5782 13.1101 15.3579 13.2932C15.2577 13.375 15.1749 13.4755 15.1142 13.5889C15.0535 13.7022 15.0161 13.8263 15.0042 13.9539C14.9922 14.0816 15.006 14.2103 15.0446 14.3327C15.0832 14.4551 15.146 14.5688 15.2293 14.6672C15.3131 14.7652 15.4156 14.8459 15.5311 14.9048C15.6465 14.9638 15.7727 14.9997 15.9022 15.0105C16.0318 15.0214 16.1622 15.007 16.2862 14.9681C16.4101 14.9293 16.525 14.8668 16.6243 14.7842C17.0667 14.4188 17.4226 13.9626 17.667 13.4475C17.9114 12.9324 18.0384 12.3708 18.0392 11.8022C18.0336 10.7694 17.6181 9.77961 16.8816 9.04441Z" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.71963 4.59848C11.0223 3.51294 13 4.43926 13 6.13493V17.8648C13 19.5605 11.0223 20.4868 9.71963 19.4013L5.63795 15.9999H4C2.89543 15.9999 2 15.1045 2 13.9999V9.99989C2 8.89532 2.89543 7.99989 4 7.99989H5.63795L9.71963 4.59848ZM11 6.13493L6.36205 9.99989H4V13.9999L6.36205 13.9999L11 17.8648L11 6.13493Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const WifiOutlineIcon = (props) => {
    const { title = 'Wifi Outline Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M21.0494 8.03714C21.3826 7.59667 21.2972 6.96663 20.8368 6.6616C18.2284 4.93343 15.1632 4.00384 12.0196 4.00001C8.87599 3.99618 5.80862 4.91829 3.19594 6.6401C2.73479 6.94401 2.64789 7.57384 2.98 8.01511L3.00022 8.04197C3.33233 8.48324 3.95754 8.56838 4.42144 8.26868C6.67869 6.81041 9.31566 6.03034 12.0171 6.03363C14.7186 6.03692 17.3537 6.82342 19.6074 8.2872C20.0705 8.58802 20.6959 8.50441 21.0291 8.06395L21.0494 8.03714Z" }),
        React$2.createElement("path", { d: "M17.4297 12.8223C17.7629 12.3818 17.6781 11.7498 17.2066 11.4623C15.6474 10.5114 13.8513 10.0022 12.0123 10C10.1733 9.99777 8.37599 10.5025 6.81442 11.4496C6.3422 11.736 6.25593 12.3678 6.58805 12.8091L6.63986 12.8779C6.97197 13.3192 7.59643 13.4014 8.07604 13.1276C9.26909 12.4463 10.6245 12.0845 12.0098 12.0862C13.3951 12.0879 14.7495 12.453 15.9409 13.1371C16.4199 13.4122 17.0445 13.3315 17.3777 12.891L17.4297 12.8223Z" }),
        React$2.createElement("path", { d: "M13.81 17.6074C14.1432 17.167 14.0582 16.5259 13.549 16.312C13.0631 16.108 12.5386 16.0007 12.005 16C11.4714 15.9994 10.9466 16.1054 10.4602 16.3083C9.95052 16.5209 9.86398 17.1617 10.1961 17.603L11.2031 18.9411C11.6026 19.4718 12.3989 19.4728 12.7997 18.943L13.81 17.6074Z" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const PremiseLogoGrayIcon = (props) => {
    const { title = 'Premise Logo Gray Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M0 8.57108H11.4289V20H20V0H0V8.57108ZM0 20H8.56381V11.4362H0V20ZM48.0271 9.48452V6.64244H45.162V17.5056H48.0271V13.3806C48.0271 10.5155 49.0581 9.09564 52.6791 9.37065V6.39167C50.3652 6.39046 48.8073 7.16942 48.0271 9.48452ZM38.7001 2.4944H31.435V17.5044H34.758V12.0734H38.7001C41.9081 12.0734 44.085 9.91944 44.085 7.16942C44.085 4.41941 41.9093 2.4944 38.7001 2.4944ZM38.1731 9.50754H34.781V5.06148H38.1731C39.9612 5.06148 40.7862 6.13847 40.7862 7.16942C40.7862 8.42934 39.9612 9.50754 38.1731 9.50754ZM93.8034 8.42934C95.1093 8.42934 95.6363 8.95633 95.8883 10.0103H98.7534C98.4784 7.4202 96.6685 6.36622 93.8034 6.36622C91.2133 6.36622 89.1514 7.4202 89.1514 9.7353C89.1514 12.0734 90.9395 12.6913 93.2994 13.1044C95.3613 13.4714 95.8895 13.6314 95.8895 14.4103C95.8895 15.1893 95.1336 15.6024 94.0796 15.6024C92.7736 15.6024 92.0395 14.9143 91.7875 13.6314H88.9224C89.1514 16.2215 90.9625 17.7794 94.0784 17.7794C96.9435 17.7794 98.7534 16.4734 98.7534 14.1583C98.7534 11.8202 96.9435 11.2714 94.3304 10.7893C92.7034 10.4912 91.9922 10.2623 91.9922 9.48331C91.9935 8.86547 92.6804 8.42934 93.8034 8.42934ZM84.3164 4.8095H87.6395V1.48646H84.3164V4.8095ZM110.694 12.1425C110.694 8.7734 108.928 6.36744 105.353 6.36744C102.03 6.36744 99.8995 8.70434 99.8995 12.0734C99.8995 15.4655 102.03 17.7794 105.353 17.7794C108.196 17.7794 109.913 16.4734 110.671 13.8833H107.576C107.232 15.1663 106.317 15.4873 105.469 15.4873C103.978 15.4873 103.04 14.3643 102.878 12.7833H110.694V12.1425ZM102.878 10.9504C103.084 9.57538 103.909 8.54443 105.353 8.54443C106.821 8.54443 107.713 9.50754 107.828 10.9504H102.878ZM58.4433 6.36744C55.1202 6.36744 52.9893 8.70434 52.9893 12.0734C52.9893 15.4655 55.1202 17.7794 58.4433 17.7794C61.2854 17.7794 63.0032 16.4734 63.7604 13.8833H60.6663C60.3222 15.1663 59.4064 15.4873 58.5584 15.4873C57.0683 15.4873 56.1294 14.3643 55.9683 12.7833H63.7834V12.1413C63.7834 8.7734 62.0183 6.36744 58.4433 6.36744ZM55.9683 10.9504C56.1742 9.57538 56.9992 8.54443 58.4433 8.54443C59.9103 8.54443 60.8032 9.50754 60.9183 10.9504H55.9683ZM78.7825 6.36744C77.2245 6.36744 75.9404 6.91744 75.1614 8.43055C74.3825 6.91865 73.0765 6.36744 71.5404 6.36744C70.2574 6.36744 68.9503 6.91744 68.1713 8.43055V6.64244H65.3062V17.5056H68.1713V11.5707C68.1713 9.73772 69.2022 8.93573 70.4864 8.93573C71.7924 8.93573 72.5713 9.73772 72.5713 11.2957V17.5056H75.4364V11.5707C75.4364 9.89763 76.2154 8.93573 77.7285 8.93573C79.0345 8.93573 79.8134 9.73772 79.8134 11.2957V17.5056H82.6785V10.7905C82.6773 7.92538 81.1194 6.36744 78.7825 6.36744ZM84.5454 17.5044H87.4105V6.64123H84.5454V17.5044Z", fill: "#4F4F4F" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const PremiseLogoWebIcon = (props) => {
    const { title = 'Premise Logo Web Icon', size, color, onClick, ...restProps } = props;
    return (React$2.createElement(Icon$2, { title: title, size: size, color: color, onClick: onClick, ...restProps },
        React$2.createElement("path", { d: "M0.639999 71.23H95.5V166.09H166.64V0.0899963H0.639999V71.23ZM0.639999 166.09H71.7197V95.0103H0.639999V166.09ZM399.265 78.8115V55.2222H375.485V145.386H399.265V111.149C399.265 87.3685 407.822 75.5839 437.877 77.8664V53.1408C418.672 53.1308 405.741 59.5962 399.265 78.8115ZM321.851 20.7935H261.55V145.376H289.131V100.299H321.851C348.477 100.299 366.546 82.4213 366.546 59.5962C366.546 36.7711 348.487 20.7935 321.851 20.7935ZM317.477 79.0026H289.322V42.1003H317.477C332.318 42.1003 339.166 51.0393 339.166 59.5962C339.166 70.0535 332.318 79.0026 317.477 79.0026ZM779.208 70.0535C790.047 70.0535 794.421 74.4275 796.513 83.1755H820.293C818.011 61.6776 802.988 52.9297 779.208 52.9297C757.71 52.9297 740.596 61.6776 740.596 80.893C740.596 100.299 755.438 105.427 775.025 108.856C792.139 111.903 796.523 113.23 796.523 119.696C796.523 126.161 790.249 129.59 781.501 129.59C770.661 129.59 764.568 123.879 762.476 113.23H738.696C740.596 134.728 755.629 147.659 781.491 147.659C805.271 147.659 820.293 136.82 820.293 117.604C820.293 98.1978 805.271 93.6428 783.582 89.6409C770.078 87.1673 764.176 85.2669 764.176 78.8015C764.186 73.6734 769.887 70.0535 779.208 70.0535ZM700.466 40.0088H728.048V12.4276H700.466V40.0088ZM919.397 100.872C919.397 72.9092 904.746 52.9397 875.074 52.9397C847.492 52.9397 829.805 72.336 829.805 100.299C829.805 128.454 847.492 147.659 875.074 147.659C898.663 147.659 912.921 136.82 919.205 115.322H893.525C890.669 125.97 883.067 128.635 876.029 128.635C863.661 128.635 855.868 119.314 854.531 106.192H919.397V100.872ZM854.531 90.9782C856.24 79.5657 863.088 71.0088 875.074 71.0088C887.25 71.0088 894.661 79.0026 895.616 90.9782H854.531ZM485.719 52.9397C458.138 52.9397 440.451 72.336 440.451 100.299C440.451 128.454 458.138 147.659 485.719 147.659C509.308 147.659 523.567 136.82 529.851 115.322H504.17C501.315 125.97 493.713 128.635 486.674 128.635C474.307 128.635 466.514 119.314 465.177 106.192H530.042V100.862C530.042 72.9092 515.392 52.9397 485.719 52.9397ZM465.177 90.9782C466.886 79.5657 473.733 71.0088 485.719 71.0088C497.896 71.0088 505.307 79.0026 506.262 90.9782H465.177ZM654.535 52.9397C641.604 52.9397 630.945 57.5047 624.48 70.0636C618.014 57.5148 607.175 52.9397 594.425 52.9397C583.777 52.9397 572.927 57.5047 566.462 70.0636V55.2222H542.681V145.386H566.462V96.1265C566.462 80.9131 575.019 74.2566 585.677 74.2566C596.516 74.2566 602.982 80.913 602.982 93.8439V145.386H626.762V96.1265C626.762 82.2403 633.228 74.2566 645.787 74.2566C656.626 74.2566 663.091 80.913 663.091 93.8439V145.386H686.872V89.651C686.862 65.8706 673.931 52.9397 654.535 52.9397ZM702.367 145.376H726.147V55.2122H702.367V145.376Z", fill: "#FF5B4A" })));
};
/* eslint-enable max-len */

const Pictogram = (props) => {
    const { children, title, ...restProps } = props;
    const passThroughProps = {
        fill: 'none',
        height: 64,
        title,
        viewBox: '0 0 64 64',
        width: 64,
        ...restProps,
    };
    return (React$2.createElement("svg", { "data-baseweb": "icon", ...passThroughProps },
        title ? React$2.createElement("title", null, title) : null,
        children));
};

/* eslint-disable max-len */
const AbtTaskPictogram = (props) => {
    const { title = 'Abt Task Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { d: "M35.6868 21.0461C35.6868 23.1879 33.9438 24.9242 31.7937 24.9242C29.6436 24.9242 27.9006 23.1879 27.9006 21.0461C27.9006 18.9043 29.6436 17.168 31.7937 17.168C33.9438 17.168 35.6868 18.9043 35.6868 21.0461Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M41.9988 27.6636C43.2883 25.2016 44.0001 22.9144 44.0001 20.9423C44.0001 14.3576 38.6384 9 32.0001 9C25.3618 9 20.0001 14.3576 20.0001 20.9423C20.0001 22.9144 20.7119 25.2016 22.0014 27.6636C23.2767 30.0986 25.0127 32.5074 26.8076 34.6679C28.5951 36.8194 30.391 38.6652 31.7434 39.975C31.831 40.0598 31.9165 40.1422 32.0001 40.2223C32.0836 40.1422 32.1692 40.0598 32.2567 39.975C33.6092 38.6652 35.4051 36.8194 37.1925 34.6679C38.9875 32.5074 40.7234 30.0986 41.9988 27.6636ZM32.0001 44.2896C32.0001 44.2896 47.0001 31.5264 47.0001 20.9423C47.0001 12.6899 40.2844 6 32.0001 6C23.7158 6 17.0001 12.6899 17.0001 20.9423C17.0001 31.5264 32.0001 44.2896 32.0001 44.2896Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.9189 34H26.0001V37H17.0812L11.0812 55H39.0001V58H6.91895L14.9189 34ZM46.9189 37H38.5001V34H49.0812L57.0812 58H47.0001V55H52.9189L46.9189 37Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 55H39V58H17V55Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28 55H39V58H28V55Z", fill: "#7E3BFF" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const AddAccountPictogram = (props) => {
    const { title = 'Add Account Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M41 13V10C41 6.13401 37.866 3 34 3C30.134 3 27 6.13401 27 10V13C27 16.866 30.134 20 34 20C37.866 20 41 16.866 41 13ZM34 0C28.4772 0 24 4.47715 24 10V13C24 18.5228 28.4772 23 34 23C39.5228 23 44 18.5228 44 13V10C44 4.47715 39.5228 0 34 0Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32.5 28C25.0442 28 19 34.0442 19 41.5V47H52V50H16V41.5C16 32.3873 23.3873 25 32.5 25H35.5C44.6127 25 52 32.3873 52 41.5V43H49V41.5C49 34.0442 42.9558 28 35.5 28H32.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M49 41.4999C49 35.9664 45.6705 31.2072 40.8994 29.1226L42.1005 26.3735C47.9249 28.9183 52 34.7315 52 41.4999V42.9999H49V41.4999Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M49 41.5001C49 39.0387 48.3426 36.7353 47.1948 34.7512L49.7916 33.249C51.1964 35.6775 52 38.4972 52 41.5001V43.0001H49V41.5001Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 33L9 12L12 12L12 33L9 33Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 24L0 24L0 21L21 21V24Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const AdvertisingPictogram = (props) => {
    const { title = 'Advertising Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5 31C5.59644 31 -2.44628e-07 25.4036 -5.46392e-07 18.5C-8.48156e-07 11.5964 5.59644 6 12.5 6L19 6L19 9L12.5 9C7.25329 9 3 13.2533 3 18.5C3 23.7467 7.25329 28 12.5 28L28 28L28 9L24 9L24 6L31 6L31 31L12.5 31Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 9L12.5 9C8.81033 9 5.60931 11.103 4.03498 14.1828L1.36377 12.8172C3.43086 8.7736 7.64021 6 12.5 6L19 6V9Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 9L12.5 9C11.7551 9 11.0321 9.08543 10.3395 9.2464L9.6604 6.32427C10.5741 6.11193 11.5249 6 12.5 6L19 6V9Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.1687 44C31.3138 44 32.9542 42.088 32.628 39.9678L30.9825 29.2719L28.0173 29.7281L29.6629 40.424C29.7095 40.7269 29.4751 41 29.1687 41L25.2157 41C24.969 41 24.7591 40.8199 24.7216 40.576L22.9825 29.2719L20.0173 29.7281L21.7564 41.0322C22.0191 42.7396 23.4882 44 25.2157 44L29.1687 44Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M45 12C48.866 12 52 15.134 52 19C52 22.866 48.866 26 45 26L42 26L42 12L45 12ZM49 19C49 16.7909 47.2091 15 45 15L45 23C47.2091 23 49 21.2091 49 19Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.8856 30.5827C28.3467 30.3407 28 29.805 28 29.2143L28 7.78571C28 7.19498 28.3467 6.65926 28.8856 6.41731L42.8856 0.131591C43.3497 -0.0767943 43.8879 -0.0357139 44.315 0.240714C44.7421 0.517143 45 0.991229 45 1.5L45 35.5C45 36.0088 44.7421 36.4828 44.315 36.7593C43.8879 37.0357 43.3497 37.0768 42.8856 36.8684L28.8856 30.5827ZM31 28.2435L42 33.1823L42 3.81771L31 8.75649L31 28.2435Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const AgriculturePictogram = (props) => {
    const { title = 'Agriculture Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 22H5C10.2467 22 14.5 26.2533 14.5 31.5V35H9.5C4.25329 35 0 30.7467 0 25.5V22ZM3 25V25.5C3 29.0899 5.91015 32 9.5 32H11.5V31.5C11.5 27.9101 8.58985 25 5 25H3Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 12H5C10.2467 12 14.5 16.2533 14.5 21.5V25H9.5C4.25329 25 0 20.7467 0 15.5V12ZM3 15V15.5C3 19.0899 5.91015 22 9.5 22H11.5V21.5C11.5 17.9101 8.58985 15 5 15H3Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 32H5C10.2467 32 14.5 36.2533 14.5 41.5V45H9.5C4.25329 45 0 40.7467 0 35.5V32ZM3 35V35.5C3 39.0899 5.91015 42 9.5 42H11.5V41.5C11.5 37.9101 8.58985 35 5 35H3Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26 22H21C15.7533 22 11.5 26.2533 11.5 31.5V35H16.5C21.7467 35 26 30.7467 26 25.5V22ZM23 25V25.5C23 29.0899 20.0899 32 16.5 32H14.5V31.5C14.5 27.9101 17.4101 25 21 25H23Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26 12H21C15.7533 12 11.5 16.2533 11.5 21.5V25H16.5C21.7467 25 26 20.7467 26 15.5V12ZM23 15V15.5C23 19.0899 20.0899 22 16.5 22H14.5V21.5C14.5 17.9101 17.4101 15 21 15H23Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26 32H21C15.7533 32 11.5 36.2533 11.5 41.5V45H16.5C21.7467 45 26 40.7467 26 35.5V32ZM23 35V35.5C23 39.0899 20.0899 42 16.5 42H14.5V41.5C14.5 37.9101 17.4101 35 21 35H23Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5 52L11.5 44L14.5 44L14.5 52L11.5 52Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5 42.5L11.5 0L14.5 -1.31136e-07L14.5 42.5L11.5 42.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5 15L11.5 0L14.5 -1.31134e-07L14.5 15L11.5 15Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5 8L11.5 0L14.5 -1.31134e-07L14.5 8L11.5 8Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 12.5L3 4L6 4L6 12.5L3 12.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 13L20 4L23 4L23 13L20 13Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const AirplanePictogram = (props) => {
    const { title = 'Airplane Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.5 0C21.8058 0 18 2.97209 18 6.99997V19.0718L5.87768 23.0034C2.37329 24.14 0 27.4047 0 31.0888V35.6245C0 37.3223 1.65622 38.5263 3.27125 38.0025L18 33.2256V38.7762L16.5068 39.9637L16.5011 39.9683C14.9846 41.1865 13.8283 42.3205 13.0714 43.6204C12.2885 44.9649 12.0001 46.3671 12.0001 47.9998V49.4998C12.0001 50.8805 13.1194 51.9998 14.5001 51.9998H36.4999C37.8806 51.9998 38.9999 50.8805 38.9999 49.4998V47.4998C38.9999 45.7656 38.5376 44.3451 37.6845 43.0931C36.8658 41.8916 35.725 40.904 34.4815 39.9544L33 38.7762V32.9013L48.7287 38.0025C50.3438 38.5263 52 37.3223 52 35.6245V31.0888C52 27.4047 49.6267 24.14 46.1223 23.0034L33 18.7475V16.9999H30V40.2234L32.6377 42.3211L32.6496 42.3302C33.8419 43.2399 34.6665 43.9917 35.2053 44.7824C35.7122 45.5263 35.9999 46.3559 35.9999 47.4998V48.9998H15V47.9998C15 46.7544 15.2116 45.9066 15.6638 45.1301C16.1417 44.3095 16.9549 43.4521 18.3773 42.3092L18.3799 42.3071L21 40.2234V6.99997C21 4.95274 23.1191 2.99999 25.5 2.99999C27.8809 2.99999 30 4.95274 30 6.99997V10.9999H33V6.99997C33 2.97209 29.1942 0 25.5 0ZM33 21.9013V29.7474L49 34.9367V31.0888C49 28.7049 47.4643 26.5925 45.1968 25.8571L33 21.9013ZM18 30.0718V22.2257L6.80319 25.8571C4.53564 26.5925 2.99999 28.7049 2.99999 31.0888V34.9367L18 30.0718Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.9999 6.99997C29.9999 4.95274 27.8808 2.99999 25.4999 2.99999V0C29.1941 0 32.9998 2.97209 32.9998 6.99997V10.9999H29.9999V6.99997Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.9999 6.99982C29.9999 6.52432 29.8928 6.06167 29.6925 5.62371L32.4207 4.37596C32.7874 5.17772 32.9999 6.06417 32.9999 6.99982V10.9998H29.9999V6.99982Z", fill: "#7E3BFF" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const AirportPictogram = (props) => {
    const { title = 'Airport Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("g", { clipPath: "url(#clip0_7959_306447)" },
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.3252 12L30.1506 20H47.8489L48.6743 12H29.3252ZM28.2168 9C27.031 9 26.1056 10.0258 26.2273 11.2053L27.2591 21.2053C27.3643 22.2249 28.2234 23 29.2485 23H48.7511C49.7762 23 50.6353 22.2249 50.7405 21.2053L51.7723 11.2053C51.894 10.0258 50.9686 9 49.7828 9H28.2168Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M40.5 0L40.5 11.5L37.5 11.5L37.5 0L40.5 0Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32.5 20.5H45.5V45.5H42.5V23.5H35.5V36H32.5V20.5Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M42.5 46V38H45.5V46H42.5Z", fill: "#7E3BFF" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M42.5 38V30H45.5V38H42.5Z", fill: "#FF5B4A" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.26685 33.5H35.4999V52.5H8.0204L5.26685 33.5ZM8.73296 36.5L10.617 49.5H32.4999V36.5H8.73296Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 33.5C21.8284 33.5 22.5 34.1716 22.5 35V51C22.5 51.8284 21.8284 52.5 21 52.5C20.1716 52.5 19.5 51.8284 19.5 51V35C19.5 34.1716 20.1716 33.5 21 33.5Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M34.5 43C34.5 43.8284 33.8284 44.5 33 44.5H8.5C7.67157 44.5 7 43.8284 7 43C7 42.1716 7.67157 41.5 8.5 41.5H33C33.8284 41.5 34.5 42.1716 34.5 43Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.12973 2.81686L14.2016 7.80291L20.4756 4.1806C21.6546 3.4999 23.1622 3.90385 23.8429 5.08286C24.5236 6.26187 24.1196 7.76947 22.9406 8.45017L17.0114 11.8734L18.8954 19.3989C19.0095 19.8546 18.9105 20.3375 18.6263 20.7116L16.1924 23.9153C16.0455 24.1087 15.7432 24.0654 15.6565 23.8385L12.1561 14.6766L7.88048 17.1451L7.95362 18.632C7.95932 18.748 7.89969 18.8574 7.79915 18.9154L5.06866 20.4919C4.86802 20.6077 4.61589 20.4703 4.60451 20.2389L4.46044 17.31L3.46392 15.584L1.31032 13.8893C1.13815 13.7538 1.15725 13.4873 1.34699 13.3778L3.37646 12.206C3.92479 11.8895 4.61061 11.9386 5.10819 12.3302L5.63802 12.7471L9.33409 10.6131L3.20264 3.99278C3.04562 3.82323 3.12289 3.54765 3.34518 3.48446L6.7237 2.5241C7.21203 2.38528 7.73739 2.49467 8.12973 2.81686Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M-0.5 49.5L52.5 49.5004L52.5 52.5004L-0.500024 52.5L-0.5 49.5Z", fill: "black" })),
        React$2.createElement("defs", null,
            React$2.createElement("clipPath", { id: "clip0_7959_306447" },
                React$2.createElement("rect", { width: "52", height: "52", fill: "white" })))));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const AlertPictogram = (props) => {
    const { title = 'Alert Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.0436 7.12952C29.452 5.83254 30.5719 4.76042 32.3853 4.76042C34.1987 4.76042 35.3186 5.83254 35.727 7.1295C34.6505 6.89418 33.5324 6.77019 32.3853 6.77019C31.2382 6.77019 30.1201 6.89419 29.0436 7.12952ZM25.854 8.20158C25.8901 5.20588 28.0547 1.74578 32.3853 1.74578C36.7159 1.74578 38.8806 5.20585 38.9166 8.20155C44.2563 10.6714 47.961 16.076 47.961 22.3458V30.3849H44.9464V22.3458C44.9464 15.4086 39.3226 9.78483 32.3853 9.78483C25.4481 9.78483 19.8243 15.4086 19.8243 22.3458V35.9117C19.8243 36.2957 19.6778 36.6652 19.4147 36.9448L13.7666 42.9459H51.3224L48.2346 39.1521L50.5726 37.2491L55.6618 43.5017C56.029 43.9529 56.1038 44.5751 55.854 45.1004C55.6042 45.6258 55.0744 45.9605 54.4927 45.9605H10.278C9.67663 45.9605 9.13281 45.6031 8.89429 45.051C8.65578 44.499 8.7682 43.858 9.18035 43.4201L16.8097 35.3139V22.3458C16.8097 16.076 20.5143 10.6714 25.854 8.20158Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.89827 14.0536L13.361 16.7933L14.3999 13.9633L6.93719 11.2236L5.89827 14.0536Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.4432 2.2232L19.7049 8.43072L17.4052 10.38L12.1435 4.17247L14.4432 2.2232Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.33238 23.0322L12.8971 20.65L13.8026 23.5255L6.23789 25.9077L5.33238 23.0322Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M44.9462 22.3458C44.9462 19.6124 44.0749 17.087 42.5946 15.0264L45.043 13.2676C46.8792 15.8237 47.9608 18.9607 47.9608 22.3458V26.8678H44.9462V22.3458Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M44.9463 30.8873V21.8434H47.961V30.8873H44.9463Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { d: "M32.3853 53.9996C35.1602 53.9996 37.4097 51.7501 37.4097 48.9752H27.3609C27.3609 51.7501 29.6104 53.9996 32.3853 53.9996Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ArtPictogram = (props) => {
    const { title = 'Art Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M47.6265 10.2583C43.4698 13.1119 38.1733 17.5891 32.7448 23.0176C27.6339 28.1285 23.3639 33.1248 20.4988 37.1641L18.0402 35.4202C21.0267 31.2098 25.4152 26.0845 30.6134 20.8863C36.1315 15.3682 41.5701 10.7599 45.9206 7.77333C48.0854 6.28716 50.0441 5.15846 51.6456 4.53487C52.4409 4.2252 53.2334 4.00577 53.9667 3.97058C54.695 3.93564 55.5779 4.07822 56.2498 4.75013C56.8109 5.31122 57.0043 6.02666 57.031 6.66185C57.0572 7.28615 56.9309 7.94152 56.7364 8.57782C56.3464 9.85368 55.5799 11.375 54.5585 13.0372C52.5024 16.3833 49.2291 20.5945 45.1761 25.0717L42.9415 23.0489C46.9249 18.6485 50.0667 14.5899 51.9904 11.4592C52.9588 9.88314 53.5734 8.6144 53.8539 7.69672C53.948 7.38879 53.9932 7.15608 54.0108 6.98913C53.7321 7.01845 53.3141 7.11982 52.7393 7.34364C51.4532 7.8444 49.7152 8.82441 47.6265 10.2583ZM54.283 6.9879C54.2828 6.98802 54.2801 6.98752 54.2751 6.98601C54.2806 6.98702 54.2831 6.98777 54.283 6.9879ZM23.111 41.0074C27.2662 38.1535 32.5584 33.6792 37.9823 28.2552L40.1137 30.3865C34.6002 35.9 29.1661 40.5052 24.8175 43.492L23.111 41.0074Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M42.9416 23.0487C47.5468 17.9616 51.0135 13.3458 52.7825 10.0964L55.4298 11.5377C53.4944 15.0927 49.8459 19.9132 45.1762 25.0716L42.9416 23.0487Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M42.9416 23.0487C45.097 20.6677 47.0107 18.3816 48.6197 16.2847L51.011 18.1196C49.3455 20.2901 47.3783 22.639 45.1762 25.0716L42.9416 23.0487Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.8638 39.2602C18.8802 37.1328 15.5475 37.0162 13.4202 38.9999C11.6207 40.6778 11.5342 42.3069 11.4542 44.593L11.4524 44.646C11.3903 46.4252 11.317 48.5239 10.0883 50.7149C11.8007 50.8794 13.5352 50.6736 15.1497 50.222C17.4644 49.5746 19.4144 48.4549 20.5803 47.3677C21.6066 46.4108 22.2087 44.94 22.2637 43.3678C22.3187 41.7957 21.8207 40.2864 20.8638 39.2602ZM11.3646 36.7953C14.7095 33.6764 19.9495 33.8597 23.0684 37.2046C24.6628 38.9145 25.3539 41.2484 25.2761 43.4732C25.1983 45.6979 24.3458 47.9778 22.6359 49.5722C21.0657 51.0364 18.6677 52.3679 15.9616 53.1248C13.244 53.8849 10.0979 54.0979 7.04922 53.1783L4.74823 52.4843L6.37515 50.7153C8.27651 48.6478 8.36262 46.7548 8.44189 44.4877C8.44276 44.4628 8.44363 44.4379 8.4445 44.4129C8.52467 42.1112 8.62072 39.3538 11.3646 36.7953Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.9038 37.2613L23.9033 30.2608L26.0346 28.1295L33.0351 35.1299L30.9038 37.2613Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M34.451 33.3061L27.4505 26.3057L29.5819 24.1743L36.5823 31.1748L34.451 33.3061Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const AudioPictogram = (props) => {
    const { title = 'Audio Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 10.5C6 4.70101 10.701 0 16.5 0H17.125C22.5788 0 27 4.42119 27 9.875H24C24 6.07804 20.922 3 17.125 3H16.5C12.3579 3 9 6.35786 9 10.5V26C9 30.1421 12.3579 33.5 16.5 33.5C20.6421 33.5 24 30.1421 24 26V18.25H27V26C27 31.799 22.299 36.5 16.5 36.5C10.701 36.5 6 31.799 6 26V10.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24 26V18.25H27V26C27 31.799 22.299 36.5 16.5 36.5V33.5C20.6421 33.5 24 30.1421 24 26Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24 26.625V15H27V26.625H24Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 26V25H0V26C0 34.6071 6.59025 41.6749 15 42.4327V49H9.5V52H24.5V49H18V42.4327C26.4097 41.6749 33 34.6071 33 26V25H30V26C30 33.4558 23.9558 39.5 16.5 39.5C9.04416 39.5 3 33.4558 3 26Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const BattlesPictogram = (props) => {
    const { title = 'Battles Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { d: "M47.438 5.89101C47.2532 7.67028 45.6609 8.96282 43.8817 8.77799C42.1024 8.59315 40.8098 7.00093 40.9947 5.22166C41.1795 3.44238 42.7717 2.14984 44.551 2.33467C46.3303 2.51951 47.6228 4.11173 47.438 5.89101Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M43.8817 8.7778C45.6609 8.96264 47.2532 7.67009 47.438 5.89082C47.6228 4.11155 46.3303 2.51932 44.551 2.33449C42.7717 2.14965 41.1795 3.4422 40.9947 5.22147C40.9364 5.78215 41.0249 6.32425 41.229 6.80959L0.0993652 47.9393L2.22069 50.0606L29.5821 22.6992L51.1472 29.3346L43.4059 8.87539L43.5543 8.72701C43.6613 8.74923 43.7705 8.76626 43.8817 8.7778ZM46.1728 24.6652L31.9823 20.2989L41.0788 11.2025L46.1728 24.6652Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.1697 6.88824C10.3086 6.5803 10.4012 6.24521 10.438 5.89082C10.6229 4.11155 9.33032 2.51932 7.55104 2.33449C5.77177 2.14965 4.17955 3.4422 3.99471 5.22147C3.80988 7.00074 5.10242 8.59297 6.8817 8.7778C7.19042 8.80987 7.49351 8.79747 7.78459 8.74576L7.91423 8.87539L0.0800781 29.5799L23.8626 20.5811L10.1697 6.88824ZM18.4576 19.4187L10.2413 11.2025L5.24009 24.4199L18.4576 19.4187ZM49.0994 50.0606L28.0994 29.0606L30.2207 26.9393L51.2207 47.9393L49.0994 50.0606Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.2207 36.0608L2.22069 50.0608L0.0993652 47.9395L14.0994 33.9395L16.2207 36.0608Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.22069 43.0608L2.22069 50.0608L0.0993652 47.9395L7.09937 40.9395L9.22069 43.0608Z", fill: "#FF5B4A" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const BeverageFreshnessPictogram = (props) => {
    const { title = 'Beverage Freshness Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.8789 0H30.8789C33.3635 0 35.3789 2.0129 35.3789 4.4989V11C35.3789 11.5415 35.5787 12.2374 36.0164 13.1639C36.3733 13.9194 36.8266 14.7069 37.3347 15.5897C37.4477 15.786 37.5634 15.9869 37.6813 16.1933C38.9121 18.3472 40.3789 21.0488 40.3789 24V45.5C40.3789 49.0899 37.4688 52 33.8789 52H21.3789V49H33.8789C35.8119 49 37.3789 47.433 37.3789 45.5V24C37.3789 21.9512 36.3457 19.9028 35.0765 17.6817C34.9718 17.4985 34.8651 17.3131 34.7575 17.1263C34.2469 16.24 33.7179 15.3218 33.3039 14.4454C32.8041 13.3876 32.3789 12.2085 32.3789 11V4.4989C32.3789 3.67119 31.7081 3 30.8789 3H27.8789V0Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.8789 0H24.8789C22.3943 0 20.3789 2.0129 20.3789 4.4989V11C20.3789 11.5415 20.1791 12.2374 19.7414 13.1639C19.3845 13.9194 18.9312 14.7069 18.4231 15.5897C18.3101 15.786 18.1945 15.9869 18.0765 16.1933C16.8457 18.3472 15.3789 21.0488 15.3789 24V43H18.3789V24C18.3789 21.9512 19.4121 19.9028 20.6813 17.6817C20.786 17.4985 20.8928 17.3131 21.0004 17.1263C21.5109 16.24 22.0399 15.3218 22.4539 14.4454C22.9537 13.3876 23.3789 12.2085 23.3789 11V4.4989C23.3789 3.67119 24.0498 3 24.8789 3H27.8789V0Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.3789 35V43H18.3789V35H15.3789Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M38.4519 21.9393C38.678 21.9677 38.8715 21.992 39.0282 22.0077L38.7297 24.9928C38.5235 24.9722 38.2925 24.9447 38.0399 24.9147C36.0384 24.6768 32.6789 24.2773 29.55 25.8427C28.894 26.1709 28.3418 26.5526 27.7156 26.9979C27.6734 27.0279 27.6307 27.0583 27.5876 27.0891C27.0079 27.5021 26.3471 27.9729 25.5643 28.3969C23.8124 29.3459 21.5755 30 17.8789 30V27C21.1823 27 22.9068 26.4245 24.1355 25.759C24.7509 25.4256 25.2727 25.0543 25.8764 24.6246C25.9097 24.601 25.9432 24.5771 25.977 24.5531C26.608 24.1043 27.3251 23.6013 28.2078 23.1597C32.2147 21.155 36.5213 21.6965 38.4519 21.9393Z", fill: "black" }),
        React$2.createElement("path", { d: "M11.3068 5.73984C11.4884 5.18763 12.2695 5.18763 12.4511 5.73984C12.8695 7.01185 13.8672 8.00952 15.1392 8.42786C15.6914 8.60947 15.6914 9.39062 15.1392 9.57223C13.8672 9.99057 12.8695 10.9882 12.4511 12.2603C12.2695 12.8125 11.4884 12.8125 11.3068 12.2603C10.8884 10.9882 9.89075 9.99057 8.61874 9.57223C8.06654 9.39062 8.06654 8.60947 8.61874 8.42786C9.89075 8.00952 10.8884 7.01185 11.3068 5.73984Z", fill: "black" }),
        React$2.createElement("path", { d: "M44.1923 11.0878C44.4103 10.4252 45.3477 10.4252 45.5656 11.0878C46.0676 12.6142 47.2648 13.8114 48.7912 14.3134C49.4539 14.5314 49.4539 15.4687 48.7912 15.6867C47.2648 16.1887 46.0676 17.3859 45.5656 18.9123C45.3477 19.575 44.4103 19.575 44.1923 18.9123C43.6903 17.3859 42.4931 16.1887 40.9667 15.6867C40.3041 15.4687 40.3041 14.5314 40.9667 14.3134C42.4931 13.8114 43.6903 12.6142 44.1923 11.0878Z", fill: "black" }),
        React$2.createElement("path", { d: "M4.96349 19.7837C5.25406 18.9002 6.5039 18.9002 6.79448 19.7837C7.46382 21.819 9.0601 23.4152 11.0953 24.0846C11.9788 24.3752 11.9788 25.625 11.0953 25.9156C9.0601 26.5849 7.46382 28.1812 6.79448 30.2164C6.5039 31.0999 5.25406 31.0999 4.96349 30.2164C4.29414 28.1812 2.69786 26.5849 0.662646 25.9156C-0.220882 25.625 -0.220882 24.3752 0.662646 24.0846C2.69786 23.4152 4.29414 21.819 4.96349 19.7837Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.3789 27V35H18.3789V27H15.3789Z", fill: "#FF5B4A" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const BigBoxStorePictogram = (props) => {
    const { title = 'Big Box Store Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M49 31V8H52V31H49Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M49 36V22H52V36H49Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27 36H22V42H27V36ZM19 33V45H30V33H19Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M35 36H30V42H35V36ZM27 33V45H38V33H27Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M43 36H38V42H43V36ZM35 33V45H46V33H35Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 0H34V3H3V37.4698L13 41.316V7H16V42H52V45H14.2215L0 39.5302V0Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.915527 3.38155L2.08445 0.618652L14.8042 6.0001H52V9.0001H14.1957L0.915527 3.38155Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const BillboardPictogram = (props) => {
    const { title = 'Billboard Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("g", { clipPath: "url(#clip0_7959_306435)" },
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 2.5H48.5V24H45.5V5.5H6.5V30H3.5V2.5Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M45.5 17L45.5 9L48.5 9L48.5 17L45.5 17Z", fill: "#FF5B4A" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M45.5 25L45.5 17L48.5 17L48.5 25L45.5 25Z", fill: "#7E3BFF" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.5 28.5H30.5V51.5H21.5V28.5ZM24.5 31.5V48.5H27.5V31.5H24.5Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.5 2.5H51.5V5.5H0.5V2.5Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 8C9.5 7.17157 10.1716 6.5 11 6.5H15C15.8284 6.5 16.5 7.17157 16.5 8C16.5 8.82843 15.8284 9.5 15 9.5H11C10.1716 9.5 9.5 8.82843 9.5 8Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 0.5C13.8284 0.5 14.5 1.17157 14.5 2V7C14.5 7.82843 13.8284 8.5 13 8.5C12.1716 8.5 11.5 7.82843 11.5 7V2C11.5 1.17157 12.1716 0.5 13 0.5Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.5 8C22.5 7.17157 23.1716 6.5 24 6.5H28C28.8284 6.5 29.5 7.17157 29.5 8C29.5 8.82843 28.8284 9.5 28 9.5H24C23.1716 9.5 22.5 8.82843 22.5 8Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26 0.5C26.8284 0.5 27.5 1.17157 27.5 2V7C27.5 7.82843 26.8284 8.5 26 8.5C25.1716 8.5 24.5 7.82843 24.5 7V2C24.5 1.17157 25.1716 0.5 26 0.5Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M35.5 8C35.5 7.17157 36.1716 6.5 37 6.5H41C41.8284 6.5 42.5 7.17157 42.5 8C42.5 8.82843 41.8284 9.5 41 9.5H37C36.1716 9.5 35.5 8.82843 35.5 8Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M39 0.5C39.8284 0.5 40.5 1.17157 40.5 2V7C40.5 7.82843 39.8284 8.5 39 8.5C38.1716 8.5 37.5 7.82843 37.5 7V2C37.5 1.17157 38.1716 0.5 39 0.5Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.5 28.5H51.5V31.5H0.5V28.5Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.5 48.5H36.5V51.5H15.5V48.5Z", fill: "black" })),
        React$2.createElement("defs", null,
            React$2.createElement("clipPath", { id: "clip0_7959_306435" },
                React$2.createElement("rect", { width: "52", height: "52", fill: "white" })))));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const BinocularsPictogram = (props) => {
    const { title = 'Binoculars Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.4992 17C16.9872 17 14.3254 19.3769 13.4198 23.2434L13.4105 23.283L9.95719 35.1009C9.72485 35.896 8.89269 36.352 8.0985 36.1194C7.30432 35.8868 6.84885 35.0536 7.08119 34.2585L10.512 22.5177C11.6786 17.6032 15.3353 14 20.4992 14C25.6149 14 29.8444 17.7987 30.5268 22.7323C31.0272 22.6729 31.5283 22.6356 32 22.6356C32.4717 22.6356 32.9728 22.6729 33.4732 22.7323C34.1557 17.7987 38.3851 14 43.5008 14C48.4574 14 52.2412 17.5559 53.4012 22.0238L56.4129 32.2297L57.0849 34.752C57.2982 35.5524 56.823 36.3744 56.0234 36.5879C55.2239 36.8014 54.4029 36.3257 54.1896 35.5252L53.5279 33.0415L50.5127 22.8238L50.5061 22.7982C49.6401 19.43 46.8915 17 43.5008 17C39.5645 17 36.3735 20.1947 36.3735 24.1356V26.3001L34.5861 25.9482C33.6611 25.7661 32.7287 25.6356 32 25.6356C31.2713 25.6356 30.3389 25.7661 29.4139 25.9482L27.6265 26.3001V24.1356C27.6265 20.1947 24.4355 17 20.4992 17Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.7073 30.5583C12.8965 30.5583 8.99654 34.4628 8.99654 39.2792C8.99654 44.0956 12.8965 48 17.7073 48C22.5182 48 26.4181 44.0956 26.4181 39.2792C26.4181 34.4628 22.5182 30.5583 17.7073 30.5583ZM6 39.2792C6 32.8059 11.2415 27.5583 17.7073 27.5583C24.1731 27.5583 29.4146 32.8059 29.4146 39.2792C29.4146 45.7524 24.1731 51 17.7073 51C11.2415 51 6 45.7524 6 39.2792Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M46.2927 30.5583C51.1035 30.5583 55.0035 34.4628 55.0035 39.2792H58C58 32.8059 52.7584 27.5583 46.2927 27.5583C39.8269 27.5583 34.5854 32.8059 34.5854 39.2792C34.5854 45.7524 39.8269 51 46.2927 51C48.927 51 51.3621 50.1271 53.3191 48.6551L51.5191 46.2566C50.0633 47.3517 48.2558 48 46.2927 48C41.4818 48 37.5819 44.0956 37.5819 39.2792C37.5819 34.4628 41.4818 30.5583 46.2927 30.5583Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.0049 28.2058L28.0037 23.2058L30.9421 23.7942L29.9432 28.7942L27.0049 28.2058Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.9445 28.2571L36.0308 22.6829L33.0738 23.1687L33.9875 28.7429L36.9445 28.2571Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.6763 42.9446C28.8086 42.6678 30.3671 42.3784 31.97 42.3784C33.5719 42.3784 35.1443 42.6675 36.2891 42.9435C36.8678 43.0829 37.3517 43.2226 37.6938 43.3284C37.865 43.3814 38.0015 43.4261 38.0973 43.4583C38.1452 43.4745 38.183 43.4875 38.21 43.4969L38.2422 43.5082L38.2521 43.5118L38.2555 43.513L38.2567 43.5134C38.2567 43.5134 38.2577 43.5138 37.7504 44.9252L38.2577 43.5138C39.0363 43.7943 39.4403 44.6536 39.1601 45.4331C38.8801 46.2122 38.0225 46.6166 37.2443 46.337L37.243 46.3365L37.2241 46.3299C37.2071 46.324 37.1797 46.3145 37.1426 46.302C37.0682 46.277 36.9553 46.2399 36.8093 46.1948C36.5168 46.1043 36.0947 45.9823 35.5877 45.8601C34.5611 45.6127 33.2433 45.3784 31.97 45.3784C30.6977 45.3784 29.396 45.6124 28.3869 45.859C27.8884 45.9808 27.4746 46.1024 27.1886 46.1925C27.0458 46.2375 26.9355 46.2743 26.8632 46.2992C26.8271 46.3116 26.8005 46.3209 26.7841 46.3268L26.7673 46.3328L26.7659 46.3333C26.7659 46.3333 26.7663 46.3331 26.2496 44.9252L25.7328 43.5172C24.9561 43.8029 24.5578 44.6649 24.8432 45.4425C25.1286 46.22 25.9893 46.6187 26.7659 46.3333M26.2496 44.9252C25.7328 43.5172 25.7328 43.5172 25.7328 43.5172L25.7385 43.5151L25.7484 43.5115L25.7804 43.5C25.8071 43.4905 25.8444 43.4774 25.8917 43.4612C25.9862 43.4288 26.1207 43.3839 26.2896 43.3307C26.6268 43.2245 27.1041 43.0844 27.6763 42.9446", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M51.5191 46.2568C50.0633 47.3519 48.2558 48.0002 46.2927 48.0002C44.6629 48.0002 43.1418 47.5535 41.84 46.7766L40.3057 49.3535C42.0586 50.3997 44.1079 51.0002 46.2927 51.0002C48.927 51.0002 51.3621 50.1273 53.3191 48.6553L51.5191 46.2568Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M51.5191 46.2568C50.0633 47.3519 48.2558 48.0002 46.2927 48.0002V51.0002C48.927 51.0002 51.3621 50.1273 53.3191 48.6553L51.5191 46.2568Z", fill: "#7E3BFF" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const BoatPictogram = (props) => {
    const { title = 'Boat Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.54104 42.8273C8.3547 41.6884 6.48108 41.6884 5.29474 42.8273L2.11439 45.8804L0 43.6779L3.18035 40.6248C5.54814 38.3517 9.28765 38.3517 11.6554 40.6248C12.8418 41.7637 14.7154 41.7637 15.9017 40.6248C18.2695 38.3517 22.009 38.3517 24.3768 40.6248C25.5632 41.7637 27.4368 41.7637 28.6231 40.6248C30.9909 38.3517 34.7304 38.3517 37.0982 40.6248C38.2846 41.7637 40.1582 41.7637 41.3445 40.6248C43.7123 38.3517 47.4518 38.3517 49.8196 40.6248L53 43.6779L50.8856 45.8804L47.7052 42.8273C46.5189 41.6884 44.6453 41.6884 43.4589 42.8273C41.0911 45.1004 37.3516 45.1004 34.9838 42.8273C33.7975 41.6884 31.9239 41.6884 30.7375 42.8273C28.3697 45.1004 24.6302 45.1004 22.2624 42.8273C21.0761 41.6884 19.2025 41.6884 18.0161 42.8273C15.6483 45.1004 11.9088 45.1004 9.54104 42.8273Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.2021 3.05313C11.8537 3.05313 9.88585 4.82945 9.64625 7.16557L8.52011 18.1455L26.5 8.97206L44.4799 18.1455L43.3537 7.16557C43.1141 4.82945 41.1463 3.05313 38.7979 3.05313H14.2021ZM6.60905 6.85407L5.28149 19.7978L0.0395059 22.4723V25.8464C0.0395059 30.2025 1.37941 34.4531 3.87745 38.0218L6.37867 36.2709C4.23986 33.2154 3.09264 29.5761 3.09264 25.8464V24.3421L24.9734 13.1785V29.0048H28.0266V13.1785L49.9074 24.3421V25.8464C49.9074 29.5761 48.7601 33.2154 46.6213 36.2709L49.1225 38.0218C51.6206 34.4531 52.9605 30.2025 52.9605 25.8464V22.4723L47.7185 19.7978L46.3909 6.85407C45.9916 2.96053 42.7119 0 38.7979 0H14.2021C10.2881 0 7.00839 2.96053 6.60905 6.85407Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.9734 20.3542H28.0266V28.4959H24.9734V20.3542Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.9734 28.4959H28.0266V36.6376H24.9734V28.4959Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.54104 51.2309C8.3547 50.092 6.48108 50.092 5.29474 51.2309L3.18035 49.0284C5.54814 46.7553 9.28765 46.7553 11.6554 49.0284C12.8418 50.1673 14.7154 50.1673 15.9017 49.0284C18.2695 46.7553 22.009 46.7553 24.3768 49.0284C25.5632 50.1673 27.4368 50.1673 28.6231 49.0284C30.9909 46.7553 34.7304 46.7553 37.0982 49.0284C38.2846 50.1673 40.1582 50.1673 41.3445 49.0284C43.7123 46.7553 47.4518 46.7553 49.8196 49.0284L47.7052 51.2309C46.5189 50.092 44.6453 50.092 43.4589 51.2309C41.0911 53.504 37.3516 53.504 34.9838 51.2309C33.7975 50.092 31.9239 50.092 30.7375 51.2309C28.3697 53.504 24.6302 53.504 22.2624 51.2309C21.0761 50.092 19.2025 50.092 18.0161 51.2309C15.6483 53.504 11.9088 53.504 9.54104 51.2309Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const BoxPictogram = (props) => {
    const { title = 'Box Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32 6L58 17.8354V46.1646L32 58L6 46.1646V17.8354L32 6ZM9 19.8039V44.1961L32 54.6659L55 44.1961V19.8039L32 9.33412L9 19.8039Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.57694 17.416L33.5 27.9446V48.2221H30.5V29.9724L7.4231 20.2236L8.57694 17.416ZM38.4142 24.5169L54.9142 17.4198L56.0858 20.2198L39.5858 27.3169L38.4142 24.5169Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26.0769 24.8086L33.5 27.9444V48.2219H30.5V29.9722L24.9231 27.6162L26.0769 24.8086Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M33.5 37.0693V48.2219H30.5V37.0693H33.5Z", fill: "#7E3BFF" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const BridgesPictogram = (props) => {
    const { title = 'Bridges Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.5148 7.03557H10.0898V0H7.07459V7.03557H3.6494L1.58133 39.6077L0 41.1257L2.08815 43.3009L5.22903 40.2857C6.40065 39.1609 8.25102 39.1609 9.42264 40.2857C11.761 42.5305 15.4541 42.5305 17.7925 40.2857C18.9642 39.1609 20.8145 39.1609 21.9862 40.2857C24.3246 42.5305 28.0177 42.5305 30.3561 40.2857C31.5277 39.1609 33.3781 39.1609 34.5497 40.2857C36.8881 42.5305 40.5812 42.5305 42.9196 40.2857C44.0912 39.1609 45.9416 39.1609 47.1132 40.2857L50.2541 43.3009L52.3422 41.1257L50.7608 39.6075L48.6927 7.03557H45.2677V0H42.2524V7.03557H38.8273L38.2529 16.0813H14.0892L13.8977 13.0661H33.7092V10.0508H13.7063L13.5148 7.03557ZM14.2806 19.0965L14.8255 27.6781C19.1573 25.7364 22.8467 24.6559 26.5189 24.6252C30.139 24.5949 33.6053 25.5845 37.5258 27.5329L38.0615 19.0965H14.2806ZM15.4993 38.2906L15.0301 30.9015C19.671 28.7274 23.1988 27.6683 26.5441 27.6403C29.852 27.6126 33.1453 28.5933 37.3173 30.8174L36.8428 38.2905C36.7725 38.2341 36.7041 38.1741 36.6378 38.1105C34.2994 35.8656 30.6063 35.8656 28.2679 38.1105C27.0963 39.2352 25.2459 39.2352 24.0743 38.1105C21.7359 35.8656 18.0428 35.8656 15.7044 38.1105C15.6381 38.1741 15.5697 38.2341 15.4993 38.2906ZM11.5108 38.1105C9.66358 36.3372 6.97101 35.9647 4.76866 36.993L6.47927 10.0508H10.685L12.507 38.7476C12.1462 38.6071 11.8068 38.3947 11.5108 38.1105ZM45.8628 10.0508L47.5734 36.993C45.3711 35.9647 42.6786 36.3372 40.8314 38.1105C40.5354 38.3947 40.196 38.6071 39.8351 38.7477L41.6571 10.0508H45.8628Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.42264 46.3161C8.25102 45.1914 6.40065 45.1914 5.22903 46.3161L3.14088 44.141C5.47928 41.8961 9.17239 41.8961 11.5108 44.141C12.6824 45.2657 14.5328 45.2657 15.7044 44.141C18.0428 41.8961 21.7359 41.8961 24.0743 44.141C25.2459 45.2657 27.0963 45.2657 28.2679 44.141C30.6063 41.8961 34.2994 41.8961 36.6378 44.141C37.8094 45.2657 39.6598 45.2657 40.8314 44.141C43.1698 41.8961 46.8629 41.8961 49.2013 44.141L47.1132 46.3161C45.9416 45.1914 44.0912 45.1914 42.9196 46.3161C40.5812 48.561 36.8881 48.561 34.5497 46.3161C33.3781 45.1914 31.5277 45.1914 30.3561 46.3161C28.0177 48.561 24.3246 48.561 21.9862 46.3161C20.8145 45.1914 18.9642 45.1914 17.7926 46.3161L16.7485 45.2286L17.7925 46.3161C15.4541 48.561 11.761 48.561 9.42264 46.3161Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M33.7092 13.0661H19.6381V10.0508H33.7092V13.0661Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M33.7092 13.0661H26.6737V10.0508H33.7092V13.0661Z", fill: "#7E3BFF" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const BrushPictogram = (props) => {
    const { title = 'Brush Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24 34H1V31H24V34Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.3136 1.37384C10.3158 0.536855 11.6496 0 13 0C14.3504 0 15.6842 0.536855 16.6864 1.37384C17.6898 2.21189 18.5 3.4772 18.5 5V16H15.5V5C15.5 4.5898 15.2767 4.10512 14.7633 3.67642C14.2488 3.24665 13.5826 3 13 3C12.4174 3 11.7512 3.24665 11.2367 3.67642C10.7233 4.10512 10.5 4.5898 10.5 5V24C10.5 25.933 8.933 27.5 7 27.5H4.5C3.67157 27.5 3 28.1716 3 29V36H24V29C24 28.1716 23.3284 27.5 22.5 27.5H19C17.067 27.5 15.5 25.933 15.5 24V20H18.5V24C18.5 24.2761 18.7239 24.5 19 24.5H22.5C24.9853 24.5 27 26.5147 27 29V39H0V29C0 26.5147 2.01472 24.5 4.5 24.5H7C7.27614 24.5 7.5 24.2761 7.5 24V5C7.5 3.4772 8.31016 2.21189 9.3136 1.37384Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.5 5.0002C15.5 4.84752 15.471 4.69254 15.4108 4.53458L18.214 3.46582C18.3954 3.94157 18.5 4.45791 18.5 5.0002V16.0002H15.5V5.0002Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.5 16.3955V10.3955H18.5V16.3955H15.5Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 52V41H4.5V52H1.5ZM6.5 52V41H9.5V52H6.5ZM11.5 52V41H14.5V52H11.5ZM16.5 52V41H19.5V52H16.5ZM21.5 52V41H24.5V52H21.5Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ChartPictogram = (props) => {
    const { title = 'Chart Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M54.6566 11.1661L37.849 28.084L27.9192 18.0702L13.4336 32.6875L11.3027 30.5758L27.9185 13.809L37.851 23.8254L52.5283 9.05176L54.6566 11.1661Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M54.6567 11.1661L42.0516 23.854L39.9233 21.7396L52.5285 9.05176L54.6567 11.1661Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M54.6567 11.1661L47.9151 17.952L45.7869 15.8376L52.5284 9.05176L54.6567 11.1661Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 6H9V55H58V58H6V6Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 46L18 56L15 56L15 46L18 46Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29 38L29 55.7895L26 55.7895L26 38L29 38Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M39 43L39 55.7895L36 55.7895L36 43L39 43Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M50 31L50 55.7894L47 55.7894L47 31L50 31Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CommunityPictogram = (props) => {
    const { title = 'Community Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.483 13.1124C17.8798 13.1124 14.9808 14.1058 12.5856 16.6444L11.5544 17.7374L9.37329 15.6704L10.4045 14.5775C13.2882 11.5212 16.9468 10.104 19.483 10.104H20.9838V13.1124H19.483Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.979 10.104H21.4799C22.731 10.104 24.3794 10.5699 25.9126 11.2532C27.4698 11.9471 29.1196 12.9588 30.3246 14.2202L30.3297 14.2256L33.5866 17.6692L31.408 19.7388L28.1538 16.298C27.3039 15.4093 26.0255 14.5959 24.693 14.0021C23.3351 13.397 22.1306 13.1124 21.4799 13.1124H19.979V10.104Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26.6073 22.0959L34.6744 14.0108C40.0104 8.66305 48.6619 8.66305 53.998 14.0108C59.334 19.3586 59.334 28.0291 53.998 33.3769L51.4783 35.9021C53.1504 37.9786 52.9134 40.886 51.2046 42.497C50.2157 43.4292 48.8771 43.6598 47.7442 43.5746C47.7114 43.5721 47.6785 43.5694 47.6457 43.5664C47.644 43.594 47.6422 43.6217 47.64 43.6494C47.5464 44.8598 46.9668 45.947 46.0515 46.8098C44.9897 47.8108 43.6183 48.0532 42.4039 47.9191C42.417 49.097 42.0459 50.3716 41.0654 51.3064C39.5065 52.853 37.2797 52.7915 35.8469 52.0735L35.2084 51.7536L33.2862 53.68C31.5301 55.44 28.6829 55.44 26.9268 53.68C26.1132 52.8646 25.6766 51.8145 25.6169 50.7472C24.5517 50.6874 23.5038 50.2498 22.6901 49.4343C21.8763 48.6187 21.4396 47.5683 21.3801 46.5007C20.3149 46.441 19.267 46.0034 18.4533 45.1879C17.6395 44.3724 17.2029 43.322 17.1433 42.2545C16.0781 42.1948 15.0302 41.7571 14.2165 40.9417C13.2071 39.9301 12.7779 38.5572 12.9289 37.2383L10.7174 35.1465L10.7165 35.1455C8.44696 33.0057 6 29.8148 6 26.1597L6 24.6555L9.00178 24.6555L9.00178 26.1597C9.00178 28.5208 10.6558 30.9581 12.7742 32.9552L12.776 32.9569L14.3442 34.4403L16.6272 32.1523C18.3833 30.3923 21.2305 30.3923 22.9866 32.1523C23.8003 32.9678 24.237 34.0181 24.2966 35.0856C25.3617 35.1454 26.4096 35.583 27.2233 36.3985C28.0371 37.2141 28.4738 38.2645 28.5333 39.3321C29.5985 39.3918 30.6465 39.8295 31.4602 40.645C32.2738 41.4603 32.7104 42.5105 32.7701 43.5778C33.8353 43.6376 34.8832 44.0752 35.6969 44.8907C36.8679 46.0642 37.258 47.7239 36.8674 49.2214L37.1893 49.3828C37.7528 49.6651 38.5173 49.6057 38.9589 49.1631L38.9751 49.1469L38.9918 49.1311C39.2528 48.8851 39.4385 48.4356 39.397 47.8185C39.3555 47.2023 39.0938 46.6202 38.7329 46.262L38.6982 46.2284C38.1041 45.6527 38.0862 44.704 38.658 44.1062C39.2298 43.5083 40.1763 43.4861 40.7754 44.0566L40.7947 44.0751C41.3147 44.5122 42.0034 44.8269 42.6483 44.9182C43.3037 45.011 43.7388 44.8599 43.9948 44.6185C44.4488 44.1905 44.6196 43.7735 44.6472 43.4169C44.6751 43.0563 44.5688 42.5943 44.1732 42.0627C43.727 41.463 43.7883 40.6258 44.3171 40.0979C44.8459 39.5699 45.6815 39.5116 46.2782 39.9611C46.7154 40.2904 47.3492 40.5281 47.9687 40.5747C48.6069 40.6227 48.986 40.4583 49.1479 40.3057C49.6775 39.8064 49.8871 38.6256 49.0693 37.705L36.187 24.7944L32.7434 28.2455C31.0489 29.9437 28.3017 29.9437 26.6073 28.2455C24.9128 26.5473 24.9128 23.7941 26.6073 22.0959ZM29.0309 49.4528C29.0371 49.4466 29.0433 49.4405 29.0494 49.4343L31.4602 47.0183C31.4664 47.012 31.4726 47.0058 31.4788 46.9995C32.064 46.4329 32.9967 46.439 33.5743 47.0179C34.1581 47.603 34.1581 48.5517 33.5743 49.1368L31.1636 51.5528C30.5798 52.1379 29.6332 52.1379 29.0494 51.5528C28.4718 50.9739 28.4656 50.0392 29.0309 49.4528ZM29.3561 44.8722C29.9213 44.2857 29.9152 43.351 29.3376 42.7722C28.7538 42.1871 27.8072 42.1871 27.2234 42.7722L24.8127 45.1882C24.2288 45.7733 24.2288 46.722 24.8127 47.3071C25.3903 47.8859 26.3229 47.8921 26.9081 47.3256C26.9143 47.3192 26.9206 47.313 26.9268 47.3067L29.3375 44.8907C29.3437 44.8845 29.3499 44.8783 29.3561 44.8722ZM28.7298 24.2231L36.797 16.1381C40.9608 11.9651 47.7116 11.9651 51.8754 16.1381C56.0392 20.311 56.0392 27.0767 51.8754 31.2497L49.3743 33.7562L36.187 20.5399L30.6208 26.1183C30.0986 26.6416 29.252 26.6416 28.7298 26.1183C28.2076 25.5949 28.2076 24.7465 28.7298 24.2231ZM16.3391 36.6956C15.7552 37.2807 15.7552 38.2293 16.3391 38.8144C16.9229 39.3995 17.8694 39.3995 18.4533 38.8144L20.864 36.3984C21.4478 35.8133 21.4478 34.8647 20.864 34.2795C20.2802 33.6944 19.3336 33.6944 18.7498 34.2795L16.3391 36.6956ZM20.5758 40.9418C19.992 41.5269 19.992 42.4755 20.5758 43.0606C21.1597 43.6457 22.1062 43.6457 22.69 43.0606L25.1008 40.6446C25.6846 40.0595 25.6846 39.1109 25.1008 38.5257C24.5169 37.9406 23.5704 37.9406 22.9866 38.5257L20.5758 40.9418Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CompliancePictogram = (props) => {
    const { title = 'Compliance Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.9998 11.2393C18.544 11.2393 12.4998 17.2835 12.4998 24.7393C12.4998 32.1951 18.544 38.2393 25.9998 38.2393C29.1277 38.2393 32.0034 37.1774 34.2919 35.3934L36.1363 37.7595C33.3395 39.9397 29.8193 41.2393 25.9998 41.2393C16.8871 41.2393 9.49983 33.852 9.49983 24.7393C9.49983 15.6266 16.8871 8.2393 25.9998 8.2393C35.1125 8.2393 42.4998 15.6266 42.4998 24.7393C42.4998 26.8723 42.0943 28.9142 41.3549 30.7895L38.564 29.6891C39.1675 28.1584 39.4998 26.4895 39.4998 24.7393C39.4998 17.2835 33.4557 11.2393 25.9998 11.2393Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.968 2.37897L17.9301 0.0230119L12.8312 6.66817L4.94367 9.48667L4.72448 17.8598L0 24.7762L4.74427 31.679L4.98744 40.0515L12.883 42.8474L18.0009 49.4779L26.032 47.0989L34.0698 49.4549L39.1687 42.8097L47.0563 39.9912L47.2755 31.6181L52 24.7017L47.2557 17.7989L47.0125 9.42642L39.1169 6.63053L33.999 0L25.968 2.37897ZM32.8802 3.46028L25.9724 5.5065L19.0589 3.48007L14.6731 9.19576L7.88885 11.62L7.70032 18.822L3.63666 24.771L7.71734 30.7083L7.9265 37.9097L14.7177 40.3145L19.1198 46.0176L26.0275 43.9714L32.9411 45.9978L37.3268 40.2821L44.1111 37.8579L44.2996 30.6559L48.3633 24.7069L44.2826 18.7696L44.0735 11.5682L37.2822 9.16338L32.8802 3.46028Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M34.9234 19.1272L24.5592 33.2397L16.7678 26.9031L18.6606 24.5756L24.0069 28.9236L32.5054 17.3515L34.9234 19.1272Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M39.4999 24.7391C39.4999 21.2806 38.2013 18.1289 36.0627 15.7395L38.2981 13.7388C40.91 16.6569 42.4999 20.5142 42.4999 24.7391C42.4999 26.8721 42.0944 28.914 41.3549 30.7894L38.5641 29.6889C39.1676 28.1583 39.4999 26.4893 39.4999 24.7391Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M39.5 24.7393C39.5 23.6525 39.3719 22.5976 39.1306 21.588L42.0484 20.8906C42.3439 22.1269 42.5 23.4159 42.5 24.7393C42.5 26.8723 42.0946 28.9142 41.3551 30.7896L38.5642 29.6891C39.1678 28.1585 39.5 26.4895 39.5 24.7393Z", fill: "#7E3BFF" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ConvenienceStorePictogram = (props) => {
    const { title = 'Convenience Store Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M50 54V43H53V54H50Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M50 43V29.5H53V43H50Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.2088 10L6 20.536V24.5C6 28.7112 9.41383 32.125 13.625 32.125C16.1343 32.125 18.3605 30.9129 19.75 29.0423C21.1395 30.9129 23.3657 32.125 25.875 32.125C28.3843 32.125 30.6105 30.9129 32 29.0423C33.3895 30.9129 35.6157 32.125 38.125 32.125C40.6343 32.125 42.8605 30.9129 44.25 29.0423C45.6395 30.9129 47.8657 32.125 50.375 32.125C54.5862 32.125 58 28.7112 58 24.5V20.566L51.3268 10H13.2088ZM45.75 24.5C45.75 27.0543 47.8207 29.125 50.375 29.125C52.9293 29.125 55 27.0543 55 24.5V21.434L49.6732 13H14.7912L9 21.464V24.5C9 27.0543 11.0707 29.125 13.625 29.125C16.1793 29.125 18.25 27.0543 18.25 24.5H21.25C21.25 27.0543 23.3207 29.125 25.875 29.125C28.4293 29.125 30.5 27.0543 30.5 24.5H33.5C33.5 27.0543 35.5707 29.125 38.125 29.125C40.6793 29.125 42.75 27.0543 42.75 24.5H45.75Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 54V30.5H14V54H11Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 35H34V54H31V38H24V54H21V35Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CostOfLivingPictogram = (props) => {
    const { title = 'Cost Of Living Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 9.5C0 4.25329 4.2533 0 9.5 0H29.5C34.7467 0 39 4.25329 39 9.5V22H36V9.5C36 5.91015 33.0899 3 29.5 3H9.5C5.91015 3 3 5.91015 3 9.5V42.5C3 46.0899 5.91015 49 9.5 49H23V52H9.5C4.25329 52 0 47.7467 0 42.5V9.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.0001 9.49958C36.0001 7.85008 35.3876 6.34728 34.3755 5.20053L36.6247 3.21533C38.102 4.88912 39.0001 7.0913 39.0001 9.49958V21.9996H36.0001V9.49958Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36 22V13H39V22H36Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30 9H9L9 12L30 12L30 9ZM9 6C7.34315 6 6 7.34315 6 9V12C6 13.6569 7.34315 15 9 15H30C31.6569 15 33 13.6569 33 12V9C33 7.34315 31.6569 6 30 6H9Z", fill: "black" }),
        React$2.createElement("path", { d: "M26 21.5C26 19.567 27.567 18 29.5 18C31.433 18 33 19.567 33 21.5C33 23.433 31.433 25 29.5 25C27.567 25 26 23.433 26 21.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29 21.5C29 21.7761 29.2239 22 29.5 22C29.7761 22 30 21.7761 30 21.5C30 21.2239 29.7761 21 29.5 21C29.2239 21 29 21.2239 29 21.5ZM29.5 18C27.567 18 26 19.567 26 21.5C26 23.433 27.567 25 29.5 25C31.433 25 33 23.433 33 21.5C33 19.567 31.433 18 29.5 18Z", fill: "black" }),
        React$2.createElement("path", { d: "M16 21.5C16 19.567 17.567 18 19.5 18C21.433 18 23 19.567 23 21.5C23 23.433 21.433 25 19.5 25C17.567 25 16 23.433 16 21.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 21.5C19 21.7761 19.2239 22 19.5 22C19.7761 22 20 21.7761 20 21.5C20 21.2239 19.7761 21 19.5 21C19.2239 21 19 21.2239 19 21.5ZM19.5 18C17.567 18 16 19.567 16 21.5C16 23.433 17.567 25 19.5 25C21.433 25 23 23.433 23 21.5C23 19.567 21.433 18 19.5 18Z", fill: "black" }),
        React$2.createElement("path", { d: "M16 31.5C16 29.567 17.567 28 19.5 28C21.433 28 23 29.567 23 31.5C23 33.433 21.433 35 19.5 35C17.567 35 16 33.433 16 31.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 31.5C19 31.7761 19.2239 32 19.5 32C19.7761 32 20 31.7761 20 31.5C20 31.2239 19.7761 31 19.5 31C19.2239 31 19 31.2239 19 31.5ZM19.5 28C17.567 28 16 29.567 16 31.5C16 33.433 17.567 35 19.5 35C21.433 35 23 33.433 23 31.5C23 29.567 21.433 28 19.5 28Z", fill: "black" }),
        React$2.createElement("path", { d: "M16 42.5C16 40.567 17.567 39 19.5 39C21.433 39 23 40.567 23 42.5C23 44.433 21.433 46 19.5 46C17.567 46 16 44.433 16 42.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 42.5C19 42.7761 19.2239 43 19.5 43C19.7761 43 20 42.7761 20 42.5C20 42.2239 19.7761 42 19.5 42C19.2239 42 19 42.2239 19 42.5ZM19.5 39C17.567 39 16 40.567 16 42.5C16 44.433 17.567 46 19.5 46C21.433 46 23 44.433 23 42.5C23 40.567 21.433 39 19.5 39Z", fill: "black" }),
        React$2.createElement("path", { d: "M6 21.5C6 19.567 7.567 18 9.5 18C11.433 18 13 19.567 13 21.5C13 23.433 11.433 25 9.5 25C7.567 25 6 23.433 6 21.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 21.5C9 21.7761 9.22386 22 9.5 22C9.77614 22 10 21.7761 10 21.5C10 21.2239 9.77614 21 9.5 21C9.22386 21 9 21.2239 9 21.5ZM9.5 18C7.567 18 6 19.567 6 21.5C6 23.433 7.567 25 9.5 25C11.433 25 13 23.433 13 21.5C13 19.567 11.433 18 9.5 18Z", fill: "black" }),
        React$2.createElement("path", { d: "M6 31.5C6 29.567 7.567 28 9.5 28C11.433 28 13 29.567 13 31.5C13 33.433 11.433 35 9.5 35C7.567 35 6 33.433 6 31.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 31.5C9 31.7761 9.22386 32 9.5 32C9.77614 32 10 31.7761 10 31.5C10 31.2239 9.77614 31 9.5 31C9.22386 31 9 31.2239 9 31.5ZM9.5 28C7.567 28 6 29.567 6 31.5C6 33.433 7.567 35 9.5 35C11.433 35 13 33.433 13 31.5C13 29.567 11.433 28 9.5 28Z", fill: "black" }),
        React$2.createElement("path", { d: "M6 42.5C6 40.567 7.567 39 9.5 39C11.433 39 13 40.567 13 42.5C13 44.433 11.433 46 9.5 46C7.567 46 6 44.433 6 42.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 42.5C9 42.7761 9.22386 43 9.5 43C9.77614 43 10 42.7761 10 42.5C10 42.2239 9.77614 42 9.5 42C9.22386 42 9 42.2239 9 42.5ZM9.5 39C7.567 39 6 40.567 6 42.5C6 44.433 7.567 46 9.5 46C11.433 46 13 44.433 13 42.5C13 40.567 11.433 39 9.5 39Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M49 32.5C49 32.5032 48.9998 32.5078 48.9981 32.5163C48.9963 32.5252 48.9917 32.5437 48.9797 32.5729C48.9555 32.6321 48.8975 32.7432 48.7666 32.8979C48.4929 33.2214 47.9794 33.6415 47.1436 34.0594C45.4704 34.896 42.949 35.5 40 35.5C37.051 35.5 34.5296 34.896 32.8564 34.0594C32.0206 33.6415 31.5071 33.2214 31.2334 32.8979C31.1025 32.7432 31.0445 32.6321 31.0203 32.5729C31.0083 32.5437 31.0037 32.5252 31.0019 32.5163C31.0002 32.5078 31 32.5032 31 32.5C31 32.4968 31.0002 32.4922 31.0019 32.4837C31.0037 32.4748 31.0083 32.4563 31.0203 32.4271C31.0445 32.3679 31.1025 32.2568 31.2334 32.1021C31.5071 31.7786 32.0206 31.3585 32.8564 30.9406C34.5296 30.104 37.051 29.5 40 29.5C42.949 29.5 45.4704 30.104 47.1436 30.9406C47.9794 31.3585 48.4929 31.7786 48.7666 32.1021C48.8975 32.2568 48.9555 32.3679 48.9797 32.4271C48.9917 32.4563 48.9963 32.4748 48.9981 32.4837C48.9998 32.4922 49 32.4968 49 32.5ZM31 36.4687V38.5C31 38.9678 31.4509 39.8387 33.2203 40.6812C34.8778 41.4705 37.273 42 40 42C42.727 42 45.1222 41.4705 46.7797 40.6812C48.5491 39.8387 49 38.9678 49 38.5V36.4687C46.8012 37.7144 43.5841 38.5 40 38.5C36.4159 38.5 33.1988 37.7144 31 36.4687ZM31 42.8911C31.3026 43.0733 31.6149 43.2396 31.9305 43.3898C34.0732 44.4102 36.928 45 40 45C43.072 45 45.9268 44.4102 48.0695 43.3898C48.3851 43.2396 48.6974 43.0733 49 42.8911V45.5C49 45.9678 48.5491 46.8387 46.7797 47.6812C45.1222 48.4705 42.727 49 40 49C37.273 49 34.8778 48.4705 33.2203 47.6812C31.4509 46.8387 31 45.9678 31 45.5V42.8911ZM28 45.5V38.5V32.5C28 29.1863 33.3726 26.5 40 26.5C46.6274 26.5 52 29.1863 52 32.5V38.5V45.5C52 47.7936 50.1004 49.4227 48.0695 50.3898C45.9268 51.4102 43.072 52 40 52C36.928 52 34.0732 51.4102 31.9305 50.3898C29.8996 49.4227 28 47.7936 28 45.5Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const CovidPictogram = (props) => {
    const { title = 'Covid Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M50 28L44 28L44 25L50 25L50 28Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26.5 8.5C17.1112 8.5 9.5 16.1112 9.5 25.5C9.5 34.8888 17.1112 42.5 26.5 42.5C28.6046 42.5 30.6166 42.1182 32.4729 41.4215L33.5271 44.2302C31.3389 45.0515 28.9701 45.5 26.5 45.5C15.4543 45.5 6.5 36.5457 6.5 25.5C6.5 14.4543 15.4543 5.5 26.5 5.5C37.5457 5.5 46.5 14.4543 46.5 25.5H43.5C43.5 16.1112 35.8888 8.5 26.5 8.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M41.511 33.4137C42.8001 31.048 43.4999 28.3375 43.4999 25L46.4999 25C46.4999 28.7869 45.6981 31.9994 44.1453 34.8491L41.511 33.4137Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M37.093 38.7979C38.8701 37.4716 40.2477 35.6686 41.6352 33.2529L44.2366 34.7471C42.7522 37.3315 41.1299 39.5285 38.8874 41.2021L37.093 38.7979Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28 2V11H25V2H28Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.5 25L11.5 25L11.5 28L2.5 28L2.5 25Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25 50L25 41L28 41L28 50L25 50Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.47487 40.303L12.3386 36.4392L14.46 38.5605L10.5962 42.4243L8.47487 40.303Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M44.9245 10.5969L41.0608 14.4607L38.9395 12.3394L42.8032 8.47559L44.9245 10.5969Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.59691 9.47487L13.4607 13.3386L11.3394 15.46L7.47559 11.5962L9.59691 9.47487Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 0H31V3H22V0Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M52 22L52 31L49 31L49 22L52 22Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 31L-3.93403e-07 22L3 22L3 31L0 31Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31 52L22 52L22 49L31 49L31 52Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.4395 45.0605L5.93945 40.5605L8.06077 38.4392L12.5608 42.9392L10.4395 45.0605Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M43.0605 5.93945L47.5605 10.4395L45.4392 12.5608L40.9392 8.06077L43.0605 5.93945Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.93945 11.4395L9.43945 6.93945L11.5608 9.06077L7.06077 13.5608L4.93945 11.4395Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 33C22.1046 33 23 32.1046 23 31C23 29.8954 22.1046 29 21 29C19.8954 29 19 29.8954 19 31C19 32.1046 19.8954 33 21 33ZM21 36C23.7614 36 26 33.7614 26 31C26 28.2386 23.7614 26 21 26C18.2386 26 16 28.2386 16 31C16 33.7614 18.2386 36 21 36Z", fill: "black" }),
        React$2.createElement("path", { d: "M21 19C21 20.1046 20.1046 21 19 21C17.8954 21 17 20.1046 17 19C17 17.8954 17.8954 17 19 17C20.1046 17 21 17.8954 21 19Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 18C18.4477 18 18 18.4477 18 19C18 19.5523 18.4477 20 19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18ZM19 21C20.1046 21 21 20.1046 21 19C21 17.8954 20.1046 17 19 17C17.8954 17 17 17.8954 17 19C17 20.1046 17.8954 21 19 21Z", fill: "black" }),
        React$2.createElement("path", { d: "M36 32C36 33.1046 35.1046 34 34 34C32.8954 34 32 33.1046 32 32C32 30.8954 32.8954 30 34 30C35.1046 30 36 30.8954 36 32Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M34 31C33.4477 31 33 31.4477 33 32C33 32.5523 33.4477 33 34 33C34.5523 33 35 32.5523 35 32C35 31.4477 34.5523 31 34 31ZM34 34C35.1046 34 36 33.1046 36 32C36 30.8954 35.1046 30 34 30C32.8954 30 32 30.8954 32 32C32 33.1046 32.8954 34 34 34Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32 22C33.1046 22 34 21.1046 34 20C34 18.8954 33.1046 18 32 18C30.8954 18 30 18.8954 30 20C30 21.1046 30.8954 22 32 22ZM32 25C34.7614 25 37 22.7614 37 20C37 17.2386 34.7614 15 32 15C29.2386 15 27 17.2386 27 20C27 22.7614 29.2386 25 32 25Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const DigitalMediaPictogram = (props) => {
    const { title = 'Digital Media Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 7.5C0 3.35786 3.35786 0 7.5 0H21.5C25.6421 0 29 3.35786 29 7.5V11H27H26H3V41H26V38H29V44.5C29 48.6421 25.6421 52 21.5 52H7.5C3.35786 52 0 48.6421 0 44.5V7.5ZM26 44H3V44.5C3 46.9853 5.01472 49 7.5 49H21.5C23.9853 49 26 46.9853 26 44.5V44ZM26 7.5V8H3V7.5C3 5.01472 5.01472 3 7.5 3H21.5C23.9853 3 26 5.01472 26 7.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26 44.5V38H29V44.5C29 48.6421 25.6421 52 21.5 52V49C23.9853 49 26 46.9853 26 44.5Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26.0001 44.5V38H29.0001V44.5C29.0001 45.1451 28.9183 45.7733 28.7637 46.3739L25.8584 45.6261C25.9506 45.2678 26.0001 44.8908 26.0001 44.5Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M35 32V37.0254L40.3046 32H46C47.6569 32 49 30.6569 49 29V20C49 18.3431 47.6569 17 46 17H25.5C23.8431 17 22.5 18.3431 22.5 20V29C22.5 30.6569 23.8431 32 25.5 32H35ZM33.6877 42.4011C33.0504 43.0049 32 42.5531 32 41.6751V35H25.5C22.1863 35 19.5 32.3137 19.5 29V20C19.5 16.6863 22.1863 14 25.5 14H46C49.3137 14 52 16.6863 52 20V29C52 32.3137 49.3137 35 46 35H41.5L33.6877 42.4011Z", fill: "black" }),
        React$2.createElement("path", { d: "M38.6709 23.6561C39.2894 24.0489 39.2894 24.9516 38.6709 25.3444L34.0362 28.2878C33.3704 28.7106 32.5001 28.2323 32.5001 27.4437L32.5001 21.5568C32.5001 20.7681 33.3704 20.2898 34.0362 20.7126L38.6709 23.6561Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const DiscoveryPictogram = (props) => {
    const { title = 'Discovery Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.6001 3.0419C12.5494 3.76541 3 13.7675 3 26C3 38.7025 13.2975 49 26 49C34.6926 49 42.2611 44.1784 46.1733 37.0566L48.8027 38.501C44.3847 46.5435 35.8307 52 26 52C11.6406 52 0 40.3594 0 26C0 11.6406 11.6406 0 26 0C40.1823 0 51.7121 11.3549 51.9947 25.47L48.9953 25.53C48.7561 13.5801 39.4019 3.8658 27.6001 3.05479L27.6001 5.56152C37.9974 6.3642 46.2208 14.9232 46.493 25.4613L43.494 25.5387C43.2637 16.6234 36.3645 9.36665 27.6001 8.57218L27.6001 13.5H24.6001L24.6001 8.55518C15.5896 9.26834 8.5 16.8062 8.5 26C8.5 35.665 16.335 43.5 26 43.5V46.5C14.6782 46.5 5.5 37.3218 5.5 26C5.5 15.1487 13.9312 6.26654 24.6001 5.54705L24.6001 3.0419Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.8792 48.9244C35.7729 48.2867 42.5455 43.6606 46.1732 37.0566L48.8026 38.501C44.7059 45.9588 37.0533 51.193 28.1207 51.9147L27.8792 48.9244Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M38.2029 45.4997C41.5262 43.4152 44.2792 40.5044 46.1732 37.0566L48.8026 38.501C46.6618 42.3981 43.5519 45.686 39.7969 48.0411L38.2029 45.4997Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { d: "M19.4103 30.4769C21.8197 25.6987 25.6987 21.8197 30.4769 19.4103L36.2486 16.5L33.3382 22.2717C30.9288 27.0499 27.0499 30.9289 22.2717 33.3382L16.5 36.2486L19.4103 30.4769Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const EducationPictogram = (props) => {
    const { title = 'Education Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.811 42.1804C22.0779 43.1091 23.9735 43.9249 26.3348 44.4613C28.1829 44.8812 30.2749 45.1203 32.4984 45.1203C33.4939 45.1203 34.464 45.0723 35.3982 44.9815L35.6885 47.9674C34.6568 48.0677 33.5898 48.1203 32.4984 48.1203C30.065 48.1203 27.7494 47.8591 25.6704 47.3868C23.0487 46.7912 20.7347 45.844 19.0379 44.6001C17.359 43.3694 16.0838 41.6843 16.0838 39.6278H19.0833C19.0833 40.3415 19.5261 41.2385 20.811 42.1804ZM43.7677 42.4679C45.3636 41.4359 45.9135 40.4169 45.9135 39.6278H48.913C48.913 41.9016 47.3626 43.7156 45.3964 44.9872L43.7677 42.4679Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.0833 29.0781V40.094H16.0838V29.0781H19.0833ZM45.9135 40.094V29.5804H48.913V40.094H45.9135Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.3063 10.1701C31.741 9.94329 32.259 9.94329 32.6937 10.1701L57.194 22.955C57.6894 23.2135 58 23.726 58 24.2848C58 24.8437 57.6894 25.3562 57.194 25.6147L32.6937 38.3996C32.259 38.6264 31.741 38.6264 31.3063 38.3996L6.80602 25.6147C6.31063 25.3562 6 24.8437 6 24.2848C6 23.726 6.31063 23.2135 6.80602 22.955L31.3063 10.1701ZM10.742 24.2848L32 35.3778L53.258 24.2848L32 13.1919L10.742 24.2848Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32.5949 20.3116L56.6587 23.0094C57.4176 23.0944 57.9914 23.7363 57.9914 24.5V42.5H54.9919V25.8413L32.2608 23.293L32.5949 20.3116Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M52.9923 41C52.9923 39.6193 54.1114 38.5 55.4919 38.5H57.9914V54H52.9923V41Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.229 42.4678C22.4844 43.2796 24.2278 43.9825 26.3347 44.4611C28.1829 44.881 30.2749 45.1201 32.4984 45.1201C33.4939 45.1201 34.4639 45.0722 35.3982 44.9813L35.6885 47.9672C34.6567 48.0676 33.5898 48.1201 32.4984 48.1201C30.065 48.1201 27.7494 47.8589 25.6703 47.3866C23.3208 46.8528 21.2263 46.0385 19.6003 44.987L21.229 42.4678Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.0988 44.6221C28.7528 44.942 30.5769 45.1206 32.4984 45.1206C33.4939 45.1206 34.464 45.0726 35.3982 44.9817L35.6885 47.9677C34.6567 48.068 33.5898 48.1206 32.4984 48.1206C30.3942 48.1206 28.3791 47.9253 26.5293 47.5675L27.0988 44.6221Z", fill: "#7E3BFF" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ElectricityPictogram = (props) => {
    const { title = 'Electricity Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.3659 0.0454536C17.0326 0.213156 17.5 0.812646 17.5 1.50014V19.0001H28.5C29.0234 19.0001 29.509 19.273 29.7812 19.72C30.0534 20.1671 30.0729 20.7237 29.8326 21.1887L20.1451 39.9387L17.4799 38.5616L26.0366 22.0001H14.5V7.46364L4.00818 27.0001H14.5V52.0001H11.5V30.0001H1.5C0.972336 30.0001 0.483481 29.7229 0.212651 29.27C-0.0581778 28.8172 -0.0711432 28.2553 0.178509 27.7905L14.6785 0.790452C15.0038 0.184772 15.6992 -0.122249 16.3659 0.0454536Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26.9911 26.6886L20.1453 39.9386L17.48 38.5615L24.3258 25.3115L26.9911 26.6886Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.8911 32.6886L20.1453 39.9386L17.48 38.5615L21.2258 31.3115L23.8911 32.6886Z", fill: "#7E3BFF" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ExplosionPictogram = (props) => {
    const { title = 'Explosion Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.6505 0.041461C21.3446 -0.12488 22.0599 0.221038 22.3605 0.868497L27.7761 12.5328L36.2793 0.628308C36.6994 0.0402495 37.479 -0.164708 38.1339 0.14075C38.7889 0.446208 39.1329 1.17523 38.9523 1.87498L35.5144 15.1971L43.7878 14.0152C44.4181 13.9251 45.0366 14.2429 45.3305 14.8077C45.6244 15.3726 45.5297 16.0615 45.0942 16.526L39.0581 22.9645L51.0907 28.1213C51.7364 28.398 52.1036 29.0858 51.9742 29.7763C51.8448 30.4667 51.2536 30.9749 50.5515 30.9991L38.6574 31.4093L48.2698 46.7017L45.7299 48.2982L33.3424 28.5908L43.7343 28.2324L33.9417 24.0356L39.9857 17.5888L31.4855 18.8031L34.0318 8.93621L27.2238 18.4674L22.7638 8.8612L23.0835 17.8107L15.3867 14.5121L20.252 21.2486L8.00909 22.3964L17.0035 25.8558L11.8739 31.9472L23.261 26.8426L19.9805 39.1446L25.5517 33.2252L29.8832 44.6444L31.0174 37.2719L33.9825 37.7281L31.9825 50.728C31.8789 51.4013 31.3346 51.9203 30.6571 51.9917C29.9796 52.063 29.3391 51.6689 29.0975 51.0319L24.4482 38.7748L18.0923 45.528C17.6214 46.0283 16.8709 46.1447 16.2706 45.8106C15.6702 45.4765 15.3736 44.7773 15.5507 44.1135L18.7389 32.1574L7.11364 37.3688C6.47522 37.6549 5.72373 37.4618 5.30246 36.9032C4.88119 36.3446 4.90204 35.569 5.3527 35.0338L11.9965 27.1443L0.961615 22.9001C0.311537 22.65 -0.0809067 21.9854 0.0141115 21.2954C0.10913 20.6054 0.666608 20.0716 1.36007 20.0066L14.748 18.7515L9.78402 11.8783C9.38927 11.3318 9.40771 10.589 9.82908 10.0627C10.2504 9.53633 10.9712 9.35582 11.5909 9.62141L19.9165 13.1895L19.501 1.5537C19.4755 0.840313 19.9563 0.207802 20.6505 0.041461Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M38.77 31.5887L48.2699 46.7023L45.73 48.2988L36.2301 33.1852L38.77 31.5887Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M42.7699 37.952L48.2699 46.7019L45.73 48.2984L40.23 39.5485L42.7699 37.952Z", fill: "#7E3BFF" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const FoodPictogram = (props) => {
    const { title = 'Food Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M50.4307 35H37V32H50.4307C52.5351 32 54.4351 32.6242 55.8282 33.8755C57.2378 35.1415 58 36.9368 58 39C58 40.9324 57.0471 42.4557 56 43.6039V54.5C56 56.4329 54.4333 58 52.5001 58H51V55H52.5001C52.7761 55 53 54.7763 53 54.5V42.3731L53.4461 41.9326C54.4415 40.9498 55 40.008 55 39C55 37.707 54.5416 36.7523 53.8236 36.1074C53.0891 35.4477 51.9544 35 50.4307 35Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.6473 35C26.9252 35 25 36.7635 25 39.0678C25 39.7265 25.102 40.2232 25.2915 40.6208C25.4749 41.0054 25.7813 41.3847 26.3321 41.7519L27 42.1972V54.5C27 54.5122 27.0212 54.6499 27.1857 54.8143C27.3501 54.9788 27.4878 55 27.5 55H30V58H27.5C26.5122 58 25.6499 57.5212 25.0643 56.9357C24.4788 56.3501 24 55.4878 24 54.5V43.743C23.3857 43.2148 22.914 42.6052 22.5835 41.9117C22.148 40.9981 22 40.0287 22 39.0678C22 34.7427 25.6573 32 29.6473 32H38.5598C42.6201 32 46 34.8057 46 39.0678C46 41.0855 45.065 42.5018 44 43.6207V52H41V42.3597L41.4624 41.9168C42.4989 40.9239 43 40.1425 43 39.0678C43 36.7005 41.2117 35 38.5598 35H29.6473Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 8.5C17 7.11929 18.1193 6 19.5 6H31.5C32.8763 6 34 7.11257 34 8.49773V13.5H31V9H20V11.5H17V8.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26 21L35 21V24H26V21Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32.0321 14H17.5V11H32.2933C32.8966 11 33.4646 11.229 33.8994 11.6211L33.9365 11.6547L43.2174 21.2199C43.7283 21.7042 44 22.3763 44 23.057V29H41V23.2427L32.0321 14Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.5 10.4089L28.1191 20.7227C28.6743 21.185 29 21.8716 29 22.6009V29H26V22.8466L17.5 14.591L9 22.8466V49H18.9714V52H8.45238C7.10684 52 6 50.9135 6 49.5535V22.6009C6 21.8716 6.32567 21.185 6.88089 20.7227L17.5 10.4089Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M38.8092 58L30 58L30 55L38.8092 55L38.8092 58Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M47.0526 58L38 58L38 55L47.0526 55L47.0526 58Z", fill: "#7E3BFF" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const GeneralEconomyPictogram = (props) => {
    const { title = 'General Economy Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 3.34355C19.564 3.99428 18.072 5.58919 16.7832 8.29566C15.1901 11.6411 14.1321 16.28 14.0115 21.5H21L21 3.34355ZM24 3.36969C24.4438 3.58813 24.8985 3.909 25.3611 4.34702C26.3702 5.30249 27.3474 6.757 28.2009 8.67286C29.9061 12.501 31 17.9086 31 24H34C34 17.5914 32.8553 11.749 30.9413 7.45214C30.3995 6.23588 29.7866 5.12232 29.1055 4.14722C36.6241 6.85372 42 14.0491 42 22.5C42 22.9691 41.9835 23.4341 41.951 23.8944L44.9435 24.1056C44.981 23.575 45 23.0396 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.4224 9.27295 44.1789 21 44.9508V45H22.5H24L24 3.36969ZM21 41.6564L21 24.5H14.0463C14.2704 29.3115 15.2926 33.5741 16.7832 36.7043C18.072 39.4108 19.564 41.0057 21 41.6564ZM14.0746 7.00586C12.2574 10.822 11.1314 15.9183 11.0108 21.5H3.0252C3.42612 13.5631 8.57262 6.87765 15.6842 4.22431C15.0856 5.07286 14.5479 6.012 14.0746 7.00586ZM15.6842 40.7757C8.87336 38.2346 3.86491 31.9952 3.10131 24.5H11.0433C11.2691 29.6891 12.3666 34.4072 14.0746 37.9941C14.5479 38.988 15.0856 39.9271 15.6842 40.7757Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M41.9999 22.4998C41.9999 16.5486 39.3358 11.2212 35.1299 7.64215L37.0741 5.35742C41.9212 9.48216 44.9999 15.6322 44.9999 22.4998C44.9999 23.0394 44.9809 23.5748 44.9434 24.1054L41.9509 23.8942C41.9833 23.4339 41.9999 22.9689 41.9999 22.4998Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M41.9999 22.4998C41.9999 19.6878 41.4056 17.0185 40.3372 14.6076L43.0799 13.3921C44.3147 16.1784 44.9999 19.2611 44.9999 22.4998C44.9999 23.0394 44.9809 23.5749 44.9434 24.1054L41.9509 23.8942C41.9834 23.4339 41.9999 22.9689 41.9999 22.4998Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M49 32.5C49 32.5032 48.9998 32.5078 48.9981 32.5163C48.9963 32.5252 48.9917 32.5437 48.9797 32.5729C48.9555 32.6321 48.8975 32.7432 48.7666 32.8979C48.4929 33.2214 47.9794 33.6415 47.1436 34.0594C45.4704 34.896 42.949 35.5 40 35.5C37.051 35.5 34.5296 34.896 32.8564 34.0594C32.0206 33.6415 31.5071 33.2214 31.2334 32.8979C31.1025 32.7432 31.0445 32.6321 31.0203 32.5729C31.0083 32.5437 31.0037 32.5252 31.0019 32.5163C31.0002 32.5078 31 32.5032 31 32.5C31 32.4968 31.0002 32.4922 31.0019 32.4837C31.0037 32.4748 31.0083 32.4563 31.0203 32.4271C31.0445 32.3679 31.1025 32.2568 31.2334 32.1021C31.5071 31.7786 32.0206 31.3585 32.8564 30.9406C34.5296 30.104 37.051 29.5 40 29.5C42.949 29.5 45.4704 30.104 47.1436 30.9406C47.9794 31.3585 48.4929 31.7786 48.7666 32.1021C48.8975 32.2568 48.9555 32.3679 48.9797 32.4271C48.9917 32.4563 48.9963 32.4748 48.9981 32.4837C48.9998 32.4922 49 32.4968 49 32.5ZM31 36.4687V38.5C31 38.9678 31.4509 39.8387 33.2203 40.6812C34.8778 41.4705 37.273 42 40 42C42.727 42 45.1222 41.4705 46.7797 40.6812C48.5491 39.8387 49 38.9678 49 38.5V36.4687C46.8012 37.7144 43.5841 38.5 40 38.5C36.4159 38.5 33.1988 37.7144 31 36.4687ZM31 42.8911C31.3026 43.0733 31.6149 43.2396 31.9305 43.3898C34.0732 44.4102 36.928 45 40 45C43.072 45 45.9268 44.4102 48.0695 43.3898C48.3851 43.2396 48.6974 43.0733 49 42.8911V45.5C49 45.9678 48.5491 46.8387 46.7797 47.6812C45.1222 48.4705 42.727 49 40 49C37.273 49 34.8778 48.4705 33.2203 47.6812C31.4509 46.8387 31 45.9678 31 45.5V42.8911ZM28 45.5V38.5V32.5C28 29.1863 33.3726 26.5 40 26.5C46.6274 26.5 52 29.1863 52 32.5V38.5V45.5C52 47.7936 50.1004 49.4227 48.0695 50.3898C45.9268 51.4102 43.072 52 40 52C36.928 52 34.0732 51.4102 31.9305 50.3898C29.8996 49.4227 28 47.7936 28 45.5Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const GlobalPictogram = (props) => {
    const { title = 'Global Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M50 27.5H2V24.5H50V27.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26 3C13.2975 3 3 13.2975 3 26C3 38.7025 13.2975 49 26 49V52C11.6406 52 0 40.3594 0 26C0 11.6406 11.6406 0 26 0C40.3594 0 52 11.6406 52 26C52 30.6241 50.7916 34.9704 48.6722 38.7358C48.0216 39.8915 47.2854 40.9923 46.4721 42.0296L44.0443 40.271L46.0854 37.2152C47.9414 33.8987 49 30.0752 49 26C49 13.2975 38.7025 3 26 3Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M48.9999 26.0001C48.9999 21.5145 47.7173 17.3331 45.4995 13.7972L48.041 12.2031C50.5496 16.2028 51.9999 20.9344 51.9999 26.0001C51.9999 30.6242 50.7914 34.9706 48.672 38.7359C48.0215 39.8917 47.2852 40.9925 46.472 42.0297L44.0442 40.2711L46.0853 37.2153C47.9413 33.8988 48.9999 30.0754 48.9999 26.0001Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.0378 9.43987C14.573 13.6046 13 19.4561 13 26C13 32.5439 14.573 38.3954 17.0378 42.5601C19.5223 46.7581 22.7401 49 26 49C29.2599 49 32.4777 46.7581 34.9622 42.5601C37.427 38.3954 39 32.5439 39 26C39 19.4561 37.427 13.6046 34.9622 9.43987C32.4777 5.24195 29.2599 3 26 3C22.7401 3 19.5223 5.24195 17.0378 9.43987ZM14.4561 7.9119C17.2196 3.24256 21.2518 0 26 0C30.7482 0 34.7804 3.24256 37.5439 7.9119C40.327 12.6144 42 19.013 42 26C42 32.987 40.327 39.3856 37.5439 44.0881C34.7804 48.7574 30.7482 52 26 52C21.2518 52 17.2196 48.7574 14.4561 44.0881C11.673 39.3856 10 32.987 10 26C10 19.013 11.673 12.6144 14.4561 7.9119Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.5 50V1.5H27.5V50H24.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M46.0853 37.2152C47.9413 33.8987 48.9999 30.0752 48.9999 26H51.9999C51.9999 30.6241 50.7914 34.9704 48.672 38.7358C48.0215 39.8915 47.2852 40.9923 46.472 42.0296L44.0442 40.271L46.0853 37.2152Z", fill: "#7E3BFF" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const GovernmentPictogram = (props) => {
    const { title = 'Government Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { d: "M17.5 23C17.5 21.8954 18.3954 21 19.5 21C20.6046 21 21.5 21.8954 21.5 23C21.5 24.1046 20.6046 25 19.5 25C18.3954 25 17.5 24.1046 17.5 23Z", fill: "black" }),
        React$2.createElement("path", { d: "M7 23C7 21.8954 7.89543 21 9 21C10.1046 21 11 21.8954 11 23C11 24.1046 10.1046 25 9 25C7.89543 25 7 24.1046 7 23Z", fill: "black" }),
        React$2.createElement("path", { d: "M7 31C7 29.8954 7.89543 29 9 29C10.1046 29 11 29.8954 11 31C11 32.1046 10.1046 33 9 33C7.89543 33 7 32.1046 7 31Z", fill: "black" }),
        React$2.createElement("path", { d: "M7 39C7 37.8954 7.89543 37 9 37C10.1046 37 11 37.8954 11 39C11 40.1046 10.1046 41 9 41C7.89543 41 7 40.1046 7 39Z", fill: "black" }),
        React$2.createElement("path", { d: "M17.5 31C17.5 29.8954 18.3954 29 19.5 29C20.6046 29 21.5 29.8954 21.5 31C21.5 32.1046 20.6046 33 19.5 33C18.3954 33 17.5 32.1046 17.5 31Z", fill: "black" }),
        React$2.createElement("path", { d: "M28 23C28 21.8954 28.8954 21 30 21C31.1046 21 32 21.8954 32 23C32 24.1046 31.1046 25 30 25C28.8954 25 28 24.1046 28 23Z", fill: "black" }),
        React$2.createElement("path", { d: "M28 31C28 29.8954 28.8954 29 30 29C31.1046 29 32 29.8954 32 31C32 32.1046 31.1046 33 30 33C28.8954 33 28 32.1046 28 31Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 9L21 13H36.5C38.433 13 40 14.567 40 16.5V41H37V16.5C37 16.2239 36.7761 16 36.5 16H3.5C3.22386 16 3 16.2239 3 16.5V49H18.5V44C18.5 40.134 21.634 37 25.5 37C29.366 37 32.5 40.134 32.5 44V52H29.5V44C29.5 41.7909 27.7091 40 25.5 40C23.2909 40 21.5 41.7909 21.5 44V52H20H18.5H0V16.5C0 14.567 1.567 13 3.5 13H18L18 9L18 0H21H28V2H35V11H25V9H21ZM21 6H25V3H21V6ZM32 8H28V5H32V8Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M37 52V44H40V52H37Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M37 44V36H40V44H37Z", fill: "#FF5B4A" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const GroceriesPictogram = (props) => {
    const { title = 'Groceries Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { d: "M1.64622 9.14989C0.737037 5.91484 2.62253 2.55527 5.85758 1.64609C9.09263 0.736911 12.4522 2.6224 13.3614 5.85745L20.2206 30.264C21.1298 33.4991 19.2443 36.8586 16.0092 37.7678C12.7742 38.677 9.41463 36.7915 8.50545 33.5564L1.64622 9.14989Z", fill: "white" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.2918 31.0871L10.4326 6.68056C9.97799 5.06303 8.29821 4.12029 6.68068 4.57488C5.06316 5.02947 4.12041 6.70925 4.57501 8.32678L11.4342 32.7333C11.8888 34.3509 13.5686 35.2936 15.1861 34.839C16.8037 34.3844 17.7464 32.7046 17.2918 31.0871ZM5.85758 1.64609C2.62253 2.55527 0.737037 5.91484 1.64622 9.14989L8.50545 33.5564C9.41463 36.7915 12.7742 38.677 16.0092 37.7678C19.2443 36.8586 21.1298 33.4991 20.2206 30.264L13.3614 5.85745C12.4522 2.6224 9.09263 0.736911 5.85758 1.64609Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.2958 11.912C18.7755 11.912 16.7324 13.9551 16.7324 16.4754H13.6901C13.6901 12.2749 17.0953 8.86977 21.2958 8.86977C25.4963 8.86977 28.9014 12.2749 28.9014 16.4754H25.8592C25.8592 13.9551 23.8161 11.912 21.2958 11.912Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.3659 9.98035C26.8273 11.0911 26.0051 12.0605 24.9242 12.9931L22.9369 10.6897C23.8096 9.93669 24.3231 9.2827 24.6284 8.65304C24.9283 8.03456 25.0729 7.34587 25.0672 6.45075L28.1094 6.43162C28.1173 7.6898 27.9098 8.85845 27.3659 9.98035Z", fill: "black" }),
        React$2.createElement("path", { d: "M0 16.4754H25.3521V53.9965H0V16.4754Z", fill: "white" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.3099 19.5177H3.04225V50.9543H22.3099V19.5177ZM0 16.4754V53.9965H25.3521V16.4754H0Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.3099 16.4754H36V42.7704H32.9577V19.5177H25.3521V50.9543H36V53.9965H22.3099V16.4754Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32.9577 42.7704V22.5599H36V42.7704H32.9577Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32.9577 42.8416V32.7008H36V42.8416H32.9577Z", fill: "#7E3BFF" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const GroceryCartPictogram = (props) => {
    const { title = 'Grocery Cart Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { d: "M33.0187 51C33.0187 53.7614 30.7785 56 28.0152 56C25.2519 56 23.0117 53.7614 23.0117 51C23.0117 48.2386 25.2519 46 28.0152 46C30.7785 46 33.0187 48.2386 33.0187 51Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.3584 11H6V8H16.6548L24.3598 36.3926C24.5372 37.0462 25.1309 37.5 25.8086 37.5H47.7376C48.4145 37.5 49.0077 37.0473 49.1858 36.3947L54.0695 18.5H27.0146V15.5H58L52.0821 37.184C51.5478 39.1418 49.7683 40.5 47.7376 40.5H25.8086C23.7755 40.5 21.9945 39.1387 21.4624 37.1778L14.3584 11Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.0146 15.5H49.0299V18.5H27.0146V15.5Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.0146 15.5H38.0223V18.5H27.0146V15.5Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { d: "M50.0306 51C50.0306 53.7614 47.7905 56 45.0272 56C42.2638 56 40.0237 53.7614 40.0237 51C40.0237 48.2386 42.2638 46 45.0272 46C47.7905 46 50.0306 48.2386 50.0306 51Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const HardhatPictogram = (props) => {
    const { title = 'Hardhat Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5602 12.6892C7.88095 16.7901 5.5 23.028 5.5 31.5H2.5C2.5 22.472 5.04391 15.4599 9.32714 10.6858C13.6192 5.90186 19.5399 3.5 26 3.5C32.4601 3.5 38.3808 5.90186 42.6729 10.6858C46.9561 15.4599 49.5 22.472 49.5 31.5H46.5C46.5 23.028 44.119 16.7901 40.4398 12.6892C36.7694 8.59814 31.6901 6.5 26 6.5C20.3099 6.5 15.2306 8.59814 11.5602 12.6892Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 30.5H52V44H49V33.5H3V41H39.25V44H0V30.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27 41H39.25V44H27V41Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.5 41H27.75V44H15.5V41Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { d: "M21 0H32V24H21V0Z", fill: "white" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29 3H24V21H29V3ZM21 0V24H32V0H21Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const HardwareStorePictogram = (props) => {
    const { title = 'Hardware Store Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26 9.02051L49.9872 20.2798C51.2156 20.8564 52 22.0911 52 23.4481V33.6775H49V23.4481C49 23.2543 48.8879 23.0779 48.7125 22.9955L26 12.3346L3.28755 22.9955C3.11206 23.0779 3 23.2543 3 23.4481V46.6775H0V23.4481C0 22.0911 0.784408 20.8564 2.01283 20.2798L26 9.02051Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M49 38.1772V23.1772H52V38.1772H49Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M49 40.1772V31.1772H52V40.1772H49Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25 30.1772H19V45.1772H25V30.1772ZM16 27.1772V48.1772H28V27.1772H16Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M34 30.1772H28V45.1772H34V30.1772ZM25 27.1772V48.1772H37V27.1772H25Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M52 48.1772H0V45.1772H52V48.1772Z", fill: "black" }),
        React$2.createElement("path", { d: "M23.5 2.17725C20.2757 3.40675 18 6.56134 18 10.1772C18 13.9035 20.1986 17.0024 23.5 18.1772V28.6772L29.5 28.6772V18.1772C32.8014 17.0024 35 13.9035 35 10.1772C35 6.45102 32.8014 3.35209 29.5 2.17725V9.67725H23.5V2.17725Z", fill: "white" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25 0V8.17733H28V0.0513852L30.0029 0.764144C33.9205 2.15826 36.5 5.83627 36.5 10.1773C36.5 14.1384 34.3523 17.5475 31 19.173V30.1773L22 30.1773V19.173C18.6477 17.5475 16.5 14.1384 16.5 10.1773C16.5 5.92585 19.1724 2.22217 22.9656 0.775767L25 0ZM31 4.71694V11.1773H22V4.78644C20.4695 6.08899 19.5 8.03646 19.5 10.1773C19.5 13.2887 21.3177 15.8086 24.0029 16.7641L25 17.119V27.1773L28 27.1773V17.119L28.9971 16.7641C31.6823 15.8086 33.5 13.2887 33.5 10.1773C33.5 7.92359 32.5463 5.98024 31 4.71694Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const HardwarePictogram = (props) => {
    const { title = 'Hardware Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("g", { clipPath: "url(#clip0_5154_193381)" },
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.40212 15.5618L21.3435 28.5031L28.5029 21.3436L15.5976 8.43831L17.5116 7.52401C25.3852 3.76271 35.1038 5.14024 41.6286 11.6651C47.8859 17.9224 49.4094 27.1168 46.2065 34.8046L57.3761 45.9741L55.2547 48.0954L42.6055 35.4462L43.0627 34.489C46.2932 27.7266 45.1052 19.3843 39.5073 13.7864C34.4533 8.73238 27.1622 7.27301 20.8165 9.41454L32.7456 21.3436L21.3435 32.7457L9.45593 20.8582C7.47828 27.2219 8.92353 34.6448 13.7863 39.5075C19.3842 45.1054 27.7265 46.2933 34.4889 43.0629L35.446 42.6057L48.0953 55.2549L45.974 57.3762L34.8044 46.2067C27.1166 49.4096 17.9222 47.8861 11.6649 41.6288C5.3059 35.2698 3.99457 25.3431 7.50977 17.5421L8.40212 15.5618Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.3056 44.7955C28.4327 45.0252 31.6059 44.4503 34.4887 43.0731L35.4459 42.6159L48.0951 55.2651L45.9738 57.3864L34.8043 46.2169C31.7101 47.5061 28.3743 48.029 25.0858 47.7875L25.3056 44.7955Z", fill: "#FF5B4A" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M45.9736 57.387L38.0828 49.4961L40.2041 47.3748L48.0949 55.2656L45.9736 57.387Z", fill: "#7E3BFF" })),
        React$2.createElement("defs", null,
            React$2.createElement("clipPath", { id: "clip0_5154_193381" },
                React$2.createElement("rect", { width: "64", height: "64", fill: "white" })))));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const HealthPictogram = (props) => {
    const { title = 'Health Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.798 15.7321C26.1701 10.7497 18.717 10.7497 14.089 15.7321C9.40115 20.7791 9.40114 29.0053 14.089 34.0523L31.5446 52.8449C31.7412 53.0566 32.0761 53.0581 32.2747 52.8482L36.6522 48.2212L38.8331 50.2781L34.4556 54.9051C33.0657 56.3742 30.7213 56.3634 29.3449 54.8817L11.8894 36.0891C6.13436 29.8932 6.13437 19.8912 11.8894 13.6953C17.4056 7.75661 26.2181 7.45142 32.0731 12.7798C37.9281 7.45142 46.7407 7.75661 52.2569 13.6953C58.0119 19.8912 58.0119 29.8932 52.2569 36.0891L52.2475 36.0991L49.0647 39.4632L46.8839 37.4064L50.0616 34.0475C54.7451 29.0001 54.7436 20.7775 50.0572 15.7321C45.4293 10.7497 37.9762 10.7497 33.3483 15.7321L32.0731 17.105L30.798 15.7321Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.2081 17.3162L30.6944 34.3404L36.529 21.7221L40.5093 31.2195L41.6293 28.4697H58V31.465H43.6479L40.5488 39.0734L36.3941 29.16L30.1944 42.5678L24.7407 25.6449L22.1148 31.465H6V28.4697H20.1758L25.2081 17.3162Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.5234 43.1328L31.5446 52.8451C31.7413 53.0568 32.0762 53.0583 32.2747 52.8484L36.6522 48.2214L38.8331 50.2783L34.4556 54.9053C33.0657 56.3743 30.7213 56.3636 29.345 54.8819L20.3237 45.1696L22.5234 43.1328Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M38.833 50.278L34.4555 54.9051C33.0657 56.3741 30.7212 56.3634 29.3449 54.8817L25.8801 51.1515L28.0798 49.1147L31.5446 52.8449C31.7412 53.0565 32.0761 53.0581 32.2747 52.8482L36.6522 48.2212L38.833 50.278Z", fill: "#7E3BFF" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const HouseholdPictogram = (props) => {
    const { title = 'Household Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.8719 0.54793C24.8325 -0.182644 26.1631 -0.182643 27.1237 0.54793L49.937 17.8981C51.0025 18.7084 51.1559 20.001 50.8676 20.9432C50.5775 21.8915 49.7029 22.9024 48.3111 22.9024H44.1009V28H41.1009V19.9024H47.6167L25.4978 3.08042L3.3789 19.9024H10.044V49H13.9978V52H7.04404V22.9024H2.68445C1.29267 22.9024 0.418068 21.8916 0.127944 20.9432C-0.160287 20.001 -0.00692379 18.7084 1.05854 17.8981L23.8719 0.54793Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.04395 42H10.0439V49H13.9977V52H7.04395V42Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.04395 48H10.0439V49H13.9977V52H7.04395V48Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.9978 29.5C25.2364 29.5 22.9978 31.7386 22.9978 34.5C22.9978 37.2614 25.2364 39.5 27.9978 39.5C30.7592 39.5 32.9978 37.2614 32.9978 34.5C32.9978 31.7386 30.7592 29.5 27.9978 29.5ZM19.9978 34.5C19.9978 30.0817 23.5795 26.5 27.9978 26.5C32.4161 26.5 35.9978 30.0817 35.9978 34.5C35.9978 38.9183 32.4161 42.5 27.9978 42.5C23.5795 42.5 19.9978 38.9183 19.9978 34.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M42.9978 29.5C40.2364 29.5 37.9978 31.7386 37.9978 34.5C37.9978 37.2614 40.2364 39.5 42.9978 39.5C45.7592 39.5 47.9978 37.2614 47.9978 34.5C47.9978 31.7386 45.7592 29.5 42.9978 29.5ZM34.9978 34.5C34.9978 30.0817 38.5795 26.5 42.9978 26.5C47.4161 26.5 50.9978 30.0817 50.9978 34.5C50.9978 38.9183 47.4161 42.5 42.9978 42.5C38.5795 42.5 34.9978 38.9183 34.9978 34.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.4978 42.5C23.1171 42.5 21.9978 43.6193 21.9978 45V52H18.9978V45C18.9978 41.9624 21.4602 39.5 24.4978 39.5H31.4978C34.5354 39.5 36.9978 41.9624 36.9978 45V52H33.9978V45C33.9978 43.6193 32.8785 42.5 31.4978 42.5H24.4978Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M39.4978 42.5C38.1171 42.5 36.9978 43.6193 36.9978 45V51H33.9978V45C33.9978 41.9624 36.4602 39.5 39.4978 39.5H46.4978C49.5354 39.5 51.9978 41.9624 51.9978 45V52H48.9978V45C48.9978 43.6193 47.8785 42.5 46.4978 42.5H39.4978Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const InfrastructureRoadsPictogram = (props) => {
    const { title = 'Infrastructure Roads Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M43.5 43.5L43.5 58L40.5 58L40.5 43.5L43.5 43.5Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M43.5 50L43.5 58L40.5 58L40.5 50L43.5 50Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { d: "M6 20.5H20.5V6H23.5V20.5H31V17H34V20.5H40.5V6H43.5V20.5H58V23.5H6V20.5Z", fill: "black" }),
        React$2.createElement("path", { d: "M20.5 43.5H6V40.5H58V43.5H34V47H31V43.5H23.5V58H20.5V43.5Z", fill: "black" }),
        React$2.createElement("path", { d: "M34 6H31V11H34V6Z", fill: "black" }),
        React$2.createElement("path", { d: "M31 53H34V58H31V53Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 33V30H6V33L11 33ZM23 30V33L17 33V30H23ZM35 33V30H29V33L35 33ZM47 30V33L41 33V30H47ZM58 30V33L53 33V30H58Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const JobPictogram = (props) => {
    const { title = 'Job Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 34V51.5C11 52.8807 12.1193 54 13.5 54H47.1667V57H13.5C10.4624 57 8 54.5376 8 51.5V34H11Z", fill: "black" }),
        React$2.createElement("path", { d: "M9 17H55V29C55 31.7614 52.7614 34 50 34H39V37H50C54.4183 37 58 33.4183 58 29V14H6V29C6 33.4183 9.58172 37 14 37H25V34H14C11.2386 34 9 31.7614 9 29V17Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M38 57V54H49.5V57H38Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M53 51V42H56V51C56 53.042 55.401 54.7077 53.9495 55.7721C52.6097 56.7547 50.8231 57 49 57V54C50.6769 54 51.6403 53.7453 52.1755 53.3529C52.599 53.0423 53 52.458 53 51Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28 34H36L36 37H28V34ZM25 33C25 31.8954 25.8954 31 27 31H37C38.1046 31 39 31.8954 39 33V38C39 39.1046 38.1046 40 37 40H27C25.8954 40 25 39.1046 25 38L25 33Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25 10V15C25 15.8284 24.3284 16.5 23.5 16.5C22.6716 16.5 22 15.8284 22 15V9.5C22 8.11929 23.1193 7 24.5 7H39.5C40.8807 7 42 8.11929 42 9.5V15C42 15.8284 41.3284 16.5 40.5 16.5C39.6716 16.5 39 15.8284 39 15V10H25Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const MeatPictogram = (props) => {
    const { title = 'Meat Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.119 7.15293C23.4145 1.44846 13.8354 1.60614 7.72075 7.72075C1.60614 13.8354 1.44846 23.4145 7.15293 29.119C9.92444 31.8905 13.5902 33.2742 17.341 33.2717C17.4736 33.2716 17.6088 33.2711 17.7462 33.2706C18.6339 33.2675 19.6137 33.2641 20.5858 33.362C21.5784 33.462 22.4188 33.9128 23.0641 34.4292C26.0313 36.804 30.579 36.5647 33.5719 33.5719C36.7764 30.3673 36.8229 25.395 33.8913 22.4634L36.0126 20.3421C38.7157 23.0453 39.5792 26.8575 38.7096 30.372L43.9543 35.6168C46.0106 34.5018 48.6435 34.8669 50.3786 36.602C52.4809 38.7043 52.5721 42.1244 50.4563 44.2401C49.3797 45.3168 47.9652 45.8219 46.5585 45.7814C46.5991 47.1881 46.0939 48.6025 45.0173 49.6792C42.9016 51.7949 39.4815 51.7038 37.3792 49.6015C35.644 47.8663 35.2789 45.2334 36.3939 43.1772L31.5618 38.345C28.0885 39.6259 24.1458 39.1374 21.1896 36.7714C20.8531 36.5021 20.5437 36.3729 20.2851 36.3469C19.4803 36.2658 18.6717 36.2681 17.7732 36.2707C17.6321 36.2711 17.4888 36.2715 17.343 36.2716C12.8497 36.2747 8.40319 34.6118 5.03163 31.2403C-1.93978 24.2689 -1.58902 12.7879 5.59945 5.59945C12.7879 -1.58902 24.2689 -1.93978 31.2403 5.03163C34.466 8.25731 36.1282 12.4679 36.2627 16.7619L33.2642 16.8559C33.1521 13.2756 31.7713 9.80529 29.119 7.15293ZM34.3242 36.8648L40.4834 43.0241L39.4228 44.0847C38.5346 44.9729 38.513 46.4927 39.5005 47.4802C40.4879 48.4677 42.0078 48.4461 42.896 47.5579C43.7842 46.6697 43.8057 45.1499 42.8183 44.1624L44.9396 42.0411C45.927 43.0286 47.4468 43.007 48.335 42.1188C49.2233 41.2306 49.2448 39.7108 48.2573 38.7233C47.2699 37.7359 45.7501 37.7574 44.8619 38.6456L43.8012 39.7063L37.4803 33.3854C36.9959 34.2096 36.3996 34.9867 35.6932 35.6932C35.2613 36.125 34.8032 36.5157 34.3242 36.8648Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.1191 7.15282C28.2637 6.29741 27.3251 5.57591 26.3272 4.98662L27.8526 2.40343C29.0655 3.11964 30.2046 3.9958 31.2404 5.03151C34.466 8.25719 36.1283 12.4678 36.2628 16.7618L33.2643 16.8558C33.1521 13.2755 31.7714 9.80518 29.1191 7.15282Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M33.2642 16.8559C33.1941 14.6208 32.6293 12.4294 31.5725 10.4556L34.2173 9.03964C35.5011 11.4375 36.1788 14.0839 36.2627 16.7619L33.2642 16.8559Z", fill: "#7E3BFF" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const MonumentPictogram = (props) => {
    const { title = 'Monument Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M37 45.0366H3V49.0366H37V45.0366ZM0 42.0366V52.0366H40V42.0366H0Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29 38.0366H11C10.4477 38.0366 10 38.4843 10 39.0366V42.0366H30V39.0366C30 38.4843 29.5523 38.0366 29 38.0366ZM11 35.0366C8.79086 35.0366 7 36.8275 7 39.0366V45.0366H33V39.0366C33 36.8275 31.2091 35.0366 29 35.0366H11Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 0L27 9.54545V30.0365H24V10.5276L20 5.07302L16 10.5276V35.0365H25.5V38.0365H13V9.54545L20 0Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24 30.0366V23.0366H27V30.0366H24Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24 23.0366V16.0366H27V23.0366H24Z", fill: "#FF5B4A" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const MuralPictogram = (props) => {
    const { title = 'Mural Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("g", { clipPath: "url(#clip0_7959_306448)" },
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.3156 15.9384C13.8159 14.0712 15.735 12.9632 17.6022 13.4635L33.057 17.6046C34.9241 18.1049 36.0322 20.0241 35.5319 21.8912L28.2849 48.9371C27.7846 50.8043 25.8655 51.9123 23.9983 51.412L8.54351 47.2709C6.67638 46.7706 5.56834 44.8514 6.06864 42.9843L13.3156 15.9384ZM16.8257 16.3613C16.559 16.2898 16.2848 16.4481 16.2133 16.7148L8.96641 43.7607C8.89494 44.0275 9.05323 44.3016 9.31997 44.3731L24.7748 48.5142C25.0415 48.5857 25.3157 48.4274 25.3872 48.1607L32.6341 21.1147C32.7056 20.848 32.5473 20.5738 32.2805 20.5024L16.8257 16.3613Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.893 24.2639C19.2503 22.9303 20.6212 22.1388 21.9549 22.4962L32.58 25.3432L31.8036 28.241L21.6614 25.5234L18.0379 39.0463L25.2823 40.9875L24.5059 43.8852L16.7785 41.8147C15.4448 41.4573 14.6534 40.0865 15.0107 38.7528L18.893 24.2639Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.0377 39.0462L19.8494 32.2848L16.9517 31.5083L15.0105 38.7527C14.6532 40.0864 15.4446 41.4573 16.7783 41.8146L24.5057 43.8852L25.2821 40.9874L18.0377 39.0462Z", fill: "#FF5B4A" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.1401 38.27L15.0107 38.753C14.6534 40.0866 15.4448 41.4575 16.7785 41.8148L24.5059 43.8854L25.2824 40.9876L15.1401 38.27Z", fill: "#7E3BFF" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.9104 12.3446C18.1254 7.81018 22.7863 5.11923 27.3207 6.33424L28.2866 6.59306C32.8211 7.80806 35.5121 12.4689 34.2971 17.0034L33.3912 20.3841L16.0045 15.7254L16.9104 12.3446ZM26.5443 9.23202C23.6102 8.44584 20.5943 10.187 19.8082 13.1211L19.6788 13.6041L31.2699 16.7099L31.3993 16.2269C32.1855 13.2929 30.4443 10.277 27.5102 9.49084L26.5443 9.23202Z", fill: "black" }),
            React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.3955 4.38624L26.2389 4.57571L25.8716 5.94622L28.7694 6.72268L29.3955 4.38624ZM29.9082 1.35006C31.6115 1.24782 32.9144 2.84437 32.4728 4.49262L30.8907 10.3969L22.1974 8.06754L23.9007 1.71065L29.9082 1.35006Z", fill: "black" }),
            React$2.createElement("path", { d: "M42.5056 6.5232C42.2912 7.3234 41.4687 7.79827 40.6685 7.58386C39.8683 7.36944 39.3935 6.54694 39.6079 5.74674C39.8223 4.94654 40.6448 4.47167 41.445 4.68608C42.2452 4.90049 42.7201 5.723 42.5056 6.5232Z", fill: "black" }),
            React$2.createElement("path", { d: "M50.2329 8.59351C50.0185 9.39371 49.196 9.86858 48.3958 9.65417C47.5956 9.43976 47.1207 8.61725 47.3352 7.81705C47.5496 7.01685 48.3721 6.54198 49.1723 6.75639C49.9725 6.97081 50.4474 7.79331 50.2329 8.59351Z", fill: "black" }),
            React$2.createElement("path", { d: "M51.7859 2.7981C51.5715 3.5983 50.749 4.07317 49.9488 3.85876C49.1486 3.64435 48.6737 2.82184 48.8881 2.02164C49.1026 1.22144 49.9251 0.74657 50.7253 0.960982C51.5255 1.1754 52.0003 1.9979 51.7859 2.7981Z", fill: "black" }),
            React$2.createElement("path", { d: "M47.1272 20.1848C46.9128 20.985 46.0903 21.4599 45.2901 21.2455C44.4899 21.0311 44.015 20.2086 44.2294 19.4084C44.4439 18.6082 45.2664 18.1333 46.0666 18.3477C46.8668 18.5621 47.3416 19.3846 47.1272 20.1848Z", fill: "black" }),
            React$2.createElement("path", { d: "M40.9527 12.3186C40.7383 13.1188 39.9157 13.5937 39.1155 13.3793C38.3153 13.1649 37.8405 12.3423 38.0549 11.5422C38.2693 10.742 39.0918 10.2671 39.892 10.4815C40.6922 10.6959 41.1671 11.5184 40.9527 12.3186Z", fill: "black" }),
            React$2.createElement("path", { d: "M48.6802 14.3889C48.4658 15.1891 47.6433 15.664 46.8431 15.4496C46.0429 15.2352 45.568 14.4127 45.7824 13.6125C45.9968 12.8123 46.8193 12.3374 47.6195 12.5518C48.4197 12.7662 48.8946 13.5887 48.6802 14.3889Z", fill: "black" }),
            React$2.createElement("path", { d: "M47.1458 4.6604C46.9314 5.4606 46.1089 5.93548 45.3087 5.72106C44.5085 5.50665 44.0336 4.68415 44.248 3.88395C44.4624 3.08375 45.2849 2.60887 46.0851 2.82329C46.8853 3.0377 47.3602 3.86021 47.1458 4.6604Z", fill: "black" }),
            React$2.createElement("path", { d: "M44.0401 16.2517C43.8257 17.0519 43.0031 17.5268 42.2029 17.3124C41.4028 17.098 40.9279 16.2755 41.1423 15.4753C41.3567 14.6751 42.1792 14.2002 42.9794 14.4146C43.7796 14.629 44.2545 15.4515 44.0401 16.2517Z", fill: "black" }),
            React$2.createElement("path", { d: "M37.8655 8.3855C37.6511 9.1857 36.8286 9.66057 36.0284 9.44616C35.2282 9.23175 34.7533 8.40924 34.9677 7.60904C35.1821 6.80885 36.0046 6.33397 36.8048 6.54838C37.605 6.7628 38.0799 7.5853 37.8655 8.3855Z", fill: "black" }),
            React$2.createElement("path", { d: "M45.5928 10.4558C45.3784 11.256 44.5559 11.7309 43.7557 11.5165C42.9555 11.3021 42.4806 10.4796 42.695 9.67936C42.9094 8.87916 43.7319 8.40428 44.5321 8.6187C45.3323 8.83311 45.8072 9.65562 45.5928 10.4558Z", fill: "black" })),
        React$2.createElement("defs", null,
            React$2.createElement("clipPath", { id: "clip0_7959_306448" },
                React$2.createElement("rect", { width: "52", height: "52", fill: "white" })))));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const NaturePictogram = (props) => {
    const { title = 'Nature Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M38.9428 9.80264L38 10.9692L37.0571 9.80264L38 9.04057L38.9428 9.80264ZM38 12.939C38.2682 13.1743 38.5848 13.4571 38.9383 13.7819C40.0831 14.8336 41.6051 16.3164 43.1225 18.0456C44.6442 19.7797 46.1333 21.7302 47.2352 23.7162C48.346 25.7181 49 27.6434 49 29.3564C49 32.963 47.3534 35.4412 45.1606 37.0637C42.9155 38.725 40.1093 39.4694 38 39.4694C34.623 39.4694 31.0495 38.2178 28.9511 35.5434L26.5909 37.3953C29.4223 41.0038 34.0054 42.4694 38 42.4694C40.6983 42.4694 44.1421 41.5494 46.9451 39.4753C49.8005 37.3625 52 34.0342 52 29.3564C52 26.9273 51.0916 24.4831 49.8585 22.2607C48.6167 20.0226 46.9808 17.894 45.3775 16.0669C43.7698 14.2348 42.1669 12.6741 40.9679 11.5726C40.3674 11.021 39.8657 10.5822 39.5122 10.2798C39.3354 10.1285 39.1955 10.0111 39.0986 9.93068C39.0501 9.89045 39.0124 9.85942 38.9862 9.83796L38.9556 9.81299L38.947 9.80597L38.9428 9.80264C38.9425 9.80237 38.9428 9.80264 38 10.9692C37.0571 9.80264 37.0572 9.80251 37.0571 9.80264L37.0521 9.8067L37.0412 9.81549L37.0026 9.84711C36.9694 9.87435 36.9215 9.91384 36.86 9.96505C36.7372 10.0674 36.56 10.2168 36.3375 10.4088C35.8927 10.7927 35.2656 11.348 34.5281 12.0408C33.0568 13.4228 31.1292 15.3678 29.3315 17.601L31.6684 19.4822C33.3511 17.3918 35.1735 15.5506 36.5821 14.2274C37.1315 13.7113 37.6154 13.2764 38 12.939Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.0605 2.33825C14.0606 2.33831 14.0607 2.33842 15.0001 1.16897C15.9394 -0.000487449 15.9397 -0.000266279 15.94 8.38021e-06L15.9443 0.00342565L15.9555 0.0124567L15.9965 0.045673C16.0319 0.0744849 16.0834 0.116549 16.15 0.171325C16.283 0.280871 16.4762 0.441312 16.7209 0.648339C17.2102 1.0623 17.9061 1.66307 18.7399 2.41613C20.4054 3.92043 22.631 6.04129 24.8614 8.5016C27.0869 10.9565 29.3474 13.7821 31.0592 16.6967C32.757 19.5876 34.0002 22.7082 34.0002 25.7193C34.0002 31.4874 31.387 35.4862 27.919 37.9947C24.5111 40.4598 20.3151 41.4694 17.0001 41.4694C13.2429 41.4694 9.0251 40.4728 5.70668 37.9784C2.32762 35.4384 0 31.4277 0 25.7193C0 22.3052 1.43844 18.7778 3.32355 15.5874C5.22406 12.371 7.67102 9.34367 9.88805 6.89477L12.1121 8.9082C9.96892 11.2755 7.66586 14.1358 5.90639 17.1135C4.13151 20.1173 3.00001 23.0907 3.00001 25.7193C3.00001 30.5043 4.89969 33.6187 7.50929 35.5803C10.1795 37.5875 13.7117 38.4693 17.0001 38.4693C19.7912 38.4693 23.3452 37.6006 26.1608 35.564C28.9163 33.5708 31.0001 30.4446 31.0001 25.7193C31.0001 23.4836 30.0558 20.9121 28.4723 18.216C26.9029 15.5437 24.7883 12.8876 22.6388 10.5166C20.4942 8.15097 18.3448 6.10177 16.7291 4.64249C15.9222 3.91376 15.2509 3.33436 14.7832 2.9386C14.5493 2.74076 14.3665 2.58895 14.2432 2.48746C14.1816 2.43672 14.1349 2.39857 14.1041 2.37355L14.07 2.34594L14.0605 2.33825Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.90639 17.1133C4.13151 20.1171 3.00001 23.0905 3.00001 25.7191H0C0 22.3049 1.43844 18.7776 3.32355 15.5872C5.22406 12.3707 7.67102 9.34346 9.88805 6.89456L12.1121 8.90799C9.96892 11.2753 7.66586 14.1356 5.90639 17.1133Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.1122 8.90799C10.0893 11.1425 7.92185 13.8184 6.20408 16.6191L3.64675 15.0507C5.49557 12.0362 7.79347 9.20835 9.88817 6.89456L12.1122 8.90799Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.0001 14.9693V51.9695H15.0001V14.9693H18.0001ZM39.5002 25.4694V51.9695H36.5002V25.4694H39.5002Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.5609 29.0301L17.5609 35.0302L15.4395 32.9088L21.4396 26.9088L23.5609 29.0301Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M45.061 31.0302L39.061 37.0302L36.9396 34.9089L42.9397 28.9088L45.061 31.0302Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.93927 22.0301L14.9393 28.0301L17.0606 25.9088L11.0606 19.9088L8.93927 22.0301Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const NetworkPictogram = (props) => {
    const { title = 'Network Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.9543 3C14.8358 3 5.50273 10.6035 2.90854 20.8676L0 20.1324C2.92458 8.56115 13.4368 0 25.9543 0C38.4717 0 48.984 8.56115 51.9085 20.1324L49 20.8676C46.4058 10.6035 37.0727 3 25.9543 3Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M49 20.8677C47.1769 13.6542 42.0224 7.75012 35.2559 4.88113L36.4269 2.11914C44.0433 5.34847 49.8515 11.9936 51.9086 20.1326L49 20.8677Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M49.0001 20.8676C48.0691 17.184 46.2696 13.8416 43.8286 11.0695L46.0801 9.08691C48.828 12.2075 50.8578 15.975 51.9086 20.1325L49.0001 20.8676Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.9542 15C17.9749 15 11.2955 20.9104 9.93203 28.7568L6.97632 28.2432C8.57609 19.0367 16.4394 12 25.9542 12C35.4689 12 43.3323 19.0367 44.932 28.2432L41.9763 28.7568C40.6129 20.9104 33.9334 15 25.9542 15Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.9542 28C21.2264 28 17.4399 31.4164 16.998 35.6555L14.0142 35.3445C14.6259 29.4769 19.7929 25 25.9542 25C32.1156 25 37.2826 29.4769 37.8943 35.3445L34.9105 35.6555C34.4685 31.4164 30.6821 28 25.9542 28Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.9543 40C25.1259 40 24.4543 40.6716 24.4543 41.5C24.4543 42.3284 25.1259 43 25.9543 43C26.7828 43 27.4543 42.3284 27.4543 41.5C27.4543 40.6716 26.7828 40 25.9543 40ZM21.4543 41.5C21.4543 39.0147 23.4691 37 25.9543 37C28.4396 37 30.4543 39.0147 30.4543 41.5C30.4543 43.9853 28.4396 46 25.9543 46C23.4691 46 21.4543 43.9853 21.4543 41.5Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const NewsPictogram = (props) => {
    const { title = 'News Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M35 3H0V0H38V8H47.5C49.9853 8 52 10.0147 52 12.5V35.5C52 40.579 48.0143 44.7271 43 44.9871V45C42.92 45 42.8402 44.9988 42.7607 44.9965C42.6741 44.9988 42.5872 45 42.5 45H9.5C4.25329 45 0 40.7467 0 35.5V13H3V35.5C3 39.0899 5.91015 42 9.5 42H36.7546C35.6567 40.6304 35 38.8919 35 37V3ZM42.7664 41.9946C46.2327 41.8549 49 39.0006 49 35.5V12.5C49 11.6716 48.3284 11 47.5 11H46.5C45.6716 11 45 11.6716 45 12.5V33H38V37C38 39.6831 40.1134 41.8726 42.7664 41.9946ZM42.2561 11H38V30H42V12.5C42 11.974 42.0902 11.4692 42.2561 11Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28 10H10V16H28V10ZM7 7V19H31V7H7Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M35 3H0V0H38V8H47.5C49.9853 8 52 10.0147 52 12.5V35.5C52 40.579 48.0143 44.7271 43 44.9871V45C42.92 45 42.8402 44.9988 42.7607 44.9965C42.6741 44.9988 42.5872 45 42.5 45H9.5C4.25329 45 0 40.7467 0 35.5V13H3V35.5C3 39.0899 5.91015 42 9.5 42H36.7546C35.6567 40.6304 35 38.8919 35 37V3ZM42.7664 41.9946C46.2327 41.8549 49 39.0006 49 35.5V12.5C49 11.6716 48.3284 11 47.5 11H46.5C45.6716 11 45 11.6716 45 12.5V33H38V37C38 39.6831 40.1134 41.8726 42.7664 41.9946ZM42.2561 11H38V30H42V12.5C42 11.974 42.0902 11.4692 42.2561 11Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 13V24H0V13H3Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 24V35H0V24H3Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 25H31V28H7V25ZM7 31H31V34H7V31Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ParkPictogram = (props) => {
    const { title = 'Park Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M46.3679 11.0566C46.3906 11.0713 46.4163 11.0889 46.4452 11.1097C46.67 11.2718 46.9719 11.5528 47.3388 11.9805C48.0687 12.8315 48.9195 14.1023 49.7913 15.6905C51.5314 18.8606 53.2518 23.1056 54.2158 27.3335C55.191 31.6105 55.3346 35.6215 54.2009 38.4779C53.649 39.8683 52.8036 40.9659 51.6008 41.7299C50.3886 42.4999 48.7039 43 46.3679 43C44.7523 43 43.4484 42.7603 42.4 42.3599L41.3297 45.1625C42.7817 45.7171 44.4592 46 46.3679 46C49.1304 46 51.4082 45.4063 53.2093 44.2623C55.02 43.1122 56.2388 41.4754 56.9893 39.5846C58.4603 35.8785 58.1606 31.1395 57.1407 26.6665C56.1096 22.1444 54.2833 17.6394 52.4211 14.247C51.4918 12.5539 50.5277 11.0904 49.6158 10.0273C49.1618 9.49801 48.6861 9.02704 48.2 8.67645C47.7441 8.34768 47.1086 8 46.3679 8C45.653 8 45.0381 8.32403 44.5932 8.63572C44.1215 8.96614 43.6623 9.40932 43.2258 9.90557C42.3494 10.9019 41.4248 12.273 40.529 13.8617C38.7332 17.0469 36.9482 21.2948 35.8452 25.6302C35.6698 26.3196 35.5113 27.0127 35.3726 27.7054L38.3141 28.2946C38.4422 27.6553 38.5891 27.0125 38.7526 26.3699C39.7878 22.301 41.4712 18.2989 43.1423 15.3351C43.98 13.8493 44.7884 12.6713 45.4783 11.887C45.8249 11.4929 46.1072 11.238 46.3144 11.0928C46.3338 11.0792 46.3517 11.0672 46.3679 11.0566Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M48 20.5L47.9999 57L44.9999 57L45 20.5L48 20.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M41.9712 24.4457L47.0939 27.4713L45.5682 30.0544L40.4455 27.0287L41.9712 24.4457Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M52.58 31.4161L47.0839 35.0802L45.4198 32.584L50.9159 28.9199L52.58 31.4161Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 47.5L40 47.5V50.5L6 50.5L6 47.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M35 48V57H32V48H35Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 48V57H11V48H14Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 41.5V50H14V41.5H17Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32 42V50H29V42H32Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M35 33.5H17.6852V30.5H38V44.5H8V34.5H11V41.5H35V33.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24 30.5L33 30.5L33 33.5L24 33.5L24 30.5Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 30.5L24 30.5L24 33.5L16 33.5L16 30.5Z", fill: "#7E3BFF" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const PetStorePictogram = (props) => {
    const { title = 'Pet Store Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32.3125 28.0063C36.3701 28.0063 39.8189 30.187 41.0515 33.8158L41.066 33.8584L41.083 33.9001C41.6271 35.2336 42.5377 36.1561 43.4484 36.8844C43.8992 37.2449 44.3739 37.5761 44.8134 37.8812C44.8362 37.897 44.859 37.9128 44.8817 37.9286C45.3076 38.2242 45.7032 38.4987 46.0854 38.7936C46.8791 39.4059 47.533 40.0462 48.0025 40.8862C48.4665 41.7163 48.8062 42.8422 48.8062 44.5C48.8062 49.4363 44.1356 53 38.5799 53H37.9999V56H38.5799C45.139 56 51.8062 51.6786 51.8062 44.5C51.8062 42.4078 51.3707 40.7634 50.6211 39.4224C49.877 38.0913 48.8787 37.1596 47.918 36.4184C47.4736 36.0754 47.0198 35.7606 46.6074 35.4745C46.5794 35.4551 46.5516 35.4358 46.5241 35.4167C46.0773 35.1066 45.6824 34.8297 45.3221 34.5415C44.6237 33.9829 44.1509 33.455 43.8757 32.803C42.1507 27.7952 37.4231 25.0063 32.3125 25.0063V28.0063Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32.4937 28.0063C28.4361 28.0063 24.9873 30.187 23.7547 33.8158L20.9141 32.851C22.6253 27.813 27.3668 25.0063 32.4937 25.0063V28.0063Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26.008 30.3657C25.0083 31.2728 24.2257 32.4288 23.7546 33.8156L23.7402 33.8582L23.7232 33.8998C22.9321 35.8387 21.3323 36.9502 20.0698 37.8275L20.057 37.8363L20.0157 37.865C18.6777 38.7947 17.5972 39.5454 16.8731 40.7655C16.372 41.6099 16 42.7646 16 44.4998H13C13 42.3052 13.4792 40.6061 14.2932 39.2345L15.5831 40L14.2932 39.2345C15.3573 37.4414 16.9233 36.3573 18.1521 35.5065C18.2175 35.4613 18.2819 35.4167 18.3452 35.3727C19.6756 34.4483 20.513 33.7926 20.9304 32.8028C21.5699 30.9465 22.6335 29.3768 23.992 28.144L26.008 30.3657Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 44.5C13 42.3052 13.4792 40.606 14.2933 39.2344L16.8732 40.7655C16.372 41.6099 16 42.7646 16 44.5C16 49.4362 20.6705 53 26.2263 53H27V56H26.2263C19.6672 56 13 51.6785 13 44.5Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5 30C14.433 30 16 28.433 16 26.5C16 24.567 14.433 23 12.5 23C10.567 23 9 24.567 9 26.5C9 28.433 10.567 30 12.5 30ZM12.5 33C16.0899 33 19 30.0899 19 26.5C19 22.9101 16.0899 20 12.5 20C8.91015 20 6 22.9101 6 26.5C6 30.0899 8.91015 33 12.5 33Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M51.5 30C53.433 30 55 28.433 55 26.5C55 24.567 53.433 23 51.5 23C49.567 23 48 24.567 48 26.5C48 28.433 49.567 30 51.5 30ZM51.5 33C55.0899 33 58 30.0899 58 26.5C58 22.9101 55.0899 20 51.5 20C47.9101 20 45 22.9101 45 26.5C45 30.0899 47.9101 33 51.5 33Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M39.5 19C41.433 19 43 17.433 43 15.5C43 13.567 41.433 12 39.5 12C37.567 12 36 13.567 36 15.5C36 17.433 37.567 19 39.5 19ZM39.5 22C43.0899 22 46 19.0899 46 15.5C46 11.9101 43.0899 9 39.5 9C35.9101 9 33 11.9101 33 15.5C33 19.0899 35.9101 22 39.5 22Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.5 19C25.433 19 27 17.433 27 15.5C27 13.567 25.433 12 23.5 12C21.567 12 20 13.567 20 15.5C20 17.433 21.567 19 23.5 19ZM23.5 22C27.0899 22 30 19.0899 30 15.5C30 11.9101 27.0899 9 23.5 9C19.9101 9 17 11.9101 17 15.5C17 19.0899 19.9101 22 23.5 22Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const PharmacyPictogram = (props) => {
    const { title = 'Pharmacy Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23 6H41V23.5H58V41H38V38H55V26.5H38V9H26V26H9V38H26V55H38V58H23V41H6V23H23V6Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M38 58H24.5V55H38V58Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23 58V46H26V58H23Z", fill: "#FF5B4A" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const PlaceOfWorshipPictogram = (props) => {
    const { title = 'Place Of Worship Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.5 -7.49338e-08L23.5 8.42514L20.5 8.42514L20.5 0L23.5 -7.49338e-08Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 18C10.5 11.6487 15.6487 6.5 22 6.5C28.3513 6.5 33.5 11.6487 33.5 18V26.5H30.5V18C30.5 13.3056 26.6944 9.5 22 9.5C17.3056 9.5 13.5 13.3056 13.5 18V26.5H10.5V18Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.9509 15.0001L31.4999 15.0001L31.4999 18.0001L11.9509 18.0001L11.9509 15.0001Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 49L20.5 49L20.5 52L10 52L10 49Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 49L28 49L28 52L19 52L19 49Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 20.8896L44 29.475V35.9998H41V48.4998C41 50.4328 39.433 51.9998 37.5 51.9998H34V48.9998H37.5C37.7761 48.9998 38 48.776 38 48.4998V32.9998H41V31.5246L22 24.11L3 31.5246V32.9998H6V48.4998C6 48.776 6.22386 48.9998 6.5 48.9998H10V51.9998H6.5C4.567 51.9998 3 50.4328 3 48.4998V35.9998H0V29.475L22 20.8896Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const PotholePictogram = (props) => {
    const { title = 'Pothole Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.0041 55.6409L15.0041 54.1328L9.47451 54.1328V57.149H12.1961C12.8525 59.4699 14.9864 61.1705 17.5175 61.1705H24.5552C27.0863 61.1705 29.2202 59.4699 29.8766 57.149L61.2515 57.149V54.1328L27.0686 54.1328V55.6409C27.0686 57.029 25.9433 58.1543 24.5552 58.1543H17.5175C16.1294 58.1543 15.0041 57.029 15.0041 55.6409Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.6197 57.149L61.2515 57.149L61.2515 54.1328L36.6197 54.1328L36.6197 57.149Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M48.6843 57.149L61.7542 57.149L61.7542 54.1328L48.6843 54.1328L48.6843 57.149Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.4565 19.6408C13.3911 18.4645 14.1515 17.4007 15.2855 17.0817L41.2776 9.77035C42.4116 9.45136 43.615 9.9628 44.1724 11.0006L46.8928 16.0657L50.9994 14.9105L51.8161 17.814L48.3547 18.7877L49.3626 20.6642L52.3803 19.8154C53.7166 19.4395 55.1046 20.218 55.4805 21.5543L59.2053 34.7964C59.5812 36.1327 58.8027 37.5207 57.4664 37.8966L57.4536 37.9002L58.0183 39.9074C58.6197 42.0455 57.374 44.2662 55.2359 44.8676C53.0979 45.4691 50.8771 44.2234 50.2757 42.0853L49.7111 40.0781L24.4378 47.1872L24.9139 48.8797C25.5153 51.0178 24.2697 53.2385 22.1316 53.84C19.9936 54.4414 17.7728 53.1957 17.1714 51.0576L16.6953 49.3651L16.3985 49.4486C15.0622 49.8245 13.6742 49.0459 13.2983 47.7097L9.57344 34.4676C9.19756 33.1313 9.97611 31.7433 11.3124 31.3674L14.0654 30.593L13.9472 28.466L10.2 29.5201L9.38326 26.6166L13.7757 25.3811L13.4565 19.6408ZM17.0397 29.7564L46.3883 21.5009L41.7061 12.783L16.4904 19.876L17.0397 29.7564ZM16.0657 46.409L12.613 34.1348L52.7131 22.8549L56.1658 35.1292L16.0657 46.409Z", fill: "black" }),
        React$2.createElement("path", { d: "M21.7753 36.9479C22.2435 37.9549 21.8067 39.1508 20.7997 39.6189C19.7927 40.0871 18.5968 39.6503 18.1286 38.6433C17.6605 37.6363 18.0972 36.4405 19.1042 35.9723C20.1112 35.5041 21.3071 35.9409 21.7753 36.9479Z", fill: "black" }),
        React$2.createElement("path", { d: "M50.3326 29.2146C50.8008 30.2216 50.364 31.4175 49.357 31.8857C48.35 32.3539 47.1541 31.9171 46.6859 30.9101C46.2178 29.9031 46.6545 28.7072 47.6615 28.239C48.6685 27.7708 49.8644 28.2076 50.3326 29.2146Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const PricePictogram = (props) => {
    const { title = 'Price Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M52 0L52.0001 26.1467L32.4056 45.6028L30.29 43.4722L48.9975 24.8967L48.9975 3.00255L27.4003 3.00278L4.28645 26.0075L28.5235 49.4638L26.4354 51.6213L0 26.0375L26.1608 0.000263892L52 0Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M40.4904 13.011C41.3195 13.011 41.9917 12.3389 41.9917 11.5098C41.9917 10.6806 41.3195 10.0085 40.4904 10.0085C39.6613 10.0085 38.9892 10.6806 38.9892 11.5098C38.9892 12.3389 39.6613 13.011 40.4904 13.011ZM40.4904 16.0135C42.9778 16.0135 44.9942 13.9971 44.9942 11.5098C44.9942 9.02239 42.9778 7.00597 40.4904 7.00597C38.003 7.00597 35.9866 9.02239 35.9866 11.5098C35.9866 13.9971 38.003 16.0135 40.4904 16.0135Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M48.9408 24.9565L51.056 27.0875L32.4056 45.603L30.2901 43.4724L48.9408 24.9565Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.2902 43.4727L39.4328 34.3946L41.5484 36.5253L32.4058 45.6033L30.2902 43.4727Z", fill: "#7E3BFF" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ProtestPictogram = (props) => {
    const { title = 'Protest Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36 17.5V28H33V17.5H36Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36 27.5V38.5H33V27.5H36Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 0H52V17.5H30V22H18V34H15V22H0V8H17V0ZM49 14.5H30V8H20V3H49V14.5ZM3 11V19H27V11H3Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.5 32C26.6046 32 27.5 31.1046 27.5 30C27.5 28.8954 26.6046 28 25.5 28C24.3954 28 23.5 28.8954 23.5 30C23.5 31.1046 24.3954 32 25.5 32ZM25.5 35C28.2614 35 30.5 32.7614 30.5 30C30.5 27.2386 28.2614 25 25.5 25C22.7386 25 20.5 27.2386 20.5 30C20.5 32.7614 22.7386 35 25.5 35Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 31.5C10.5 32.8807 9.38071 34 8 34C6.61929 34 5.5 32.8807 5.5 31.5C5.5 30.1193 6.61929 29 8 29C9.38071 29 10.5 30.1193 10.5 31.5ZM12.0115 35.2627C12.9346 34.279 13.5 32.9555 13.5 31.5C13.5 28.4624 11.0376 26 8 26C4.96243 26 2.5 28.4624 2.5 31.5C2.5 32.9555 3.06538 34.279 3.98851 35.2627C2.1815 36.5285 1 38.6263 1 41V52H4V41C4 38.7909 5.79086 37 8 37C10.2091 37 12 38.7909 12 41V52H15V41C15 38.6263 13.8185 36.5285 12.0115 35.2627Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M47 31.5C47 32.8807 45.8807 34 44.5 34C43.1193 34 42 32.8807 42 31.5C42 30.1193 43.1193 29 44.5 29C45.8807 29 47 30.1193 47 31.5ZM48.57 35.1994C49.4585 34.2225 50 32.9245 50 31.5C50 28.4624 47.5376 26 44.5 26C41.4624 26 39 28.4624 39 31.5C39 32.9245 39.5415 34.2225 40.43 35.1994C38.3659 36.5354 37 38.8582 37 41.5V52H40V41.5C40 39.0147 42.0147 37 44.5 37C46.9853 37 49 39.0147 49 41.5V52H52V41.5C52 38.8582 50.6341 36.5354 48.57 35.1994Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const RiotPictogram = (props) => {
    const { title = 'Riot Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.54911 11.408C3.10123 5.29281 8.24102 0.500977 14.5 0.500977L15 0.500977C20.3588 0.500977 24.8972 4.01356 26.4383 8.86189C27.9042 7.74331 29.7831 7.15972 31.7619 7.36528L45.3589 8.82264C49.4451 9.24713 52.4294 12.8801 52.0522 16.971L50.5618 33.1387L47.5745 32.8633L49.0649 16.6956C49.2912 14.241 47.5006 12.0613 45.0489 11.8066L31.4519 10.3492C28.9799 10.0924 26.7678 11.8882 26.511 14.3602L23.6122 42.2643C23.3554 44.7363 25.1512 46.9484 27.6232 47.2052L41.5834 48.6554C44.0553 48.9122 46.2675 47.1165 46.5243 44.6445L46.939 40.6524L49.9229 40.9624L49.5082 44.9545C49.0802 49.0744 45.3934 52.0674 41.2734 51.6394L27.3132 50.1892C23.1932 49.7612 20.2003 46.0743 20.6283 41.9544L21.9739 29.0009H10.5C6.35786 29.0009 3 25.643 3 21.5009V18.2876C1.54351 17.7728 0.5 16.3837 0.5 14.751C0.5 13.2922 1.33291 12.028 2.54911 11.408ZM5.62444 11.001C6.33856 6.74441 10.0405 3.50098 14.5 3.50098H15C19.4595 3.50098 23.1614 6.74441 23.8756 11.001H5.62444ZM22.2856 26.0009L23.0647 18.501H22.0527L22.0875 18.534L14.994 26.0009H22.2856ZM23.3763 15.501L23.5271 14.0502C23.5288 14.0338 23.5305 14.0174 23.5323 14.001L4.25 14.001C3.83579 14.001 3.5 14.3368 3.5 14.751C3.5 15.1652 3.83579 15.501 4.25 15.501H23.3763ZM15.0626 18.501H17.981L10.9125 25.9415L10.9751 26.0009H10.5C9.78161 26.0009 9.10254 25.8326 8.50008 25.5332L15.0923 18.5289L15.0626 18.501ZM6 18.501L10.9989 18.501L6.40891 23.3778C6.14638 22.8065 6 22.1708 6 21.5009V18.501Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.8489 16.1228C28.9345 15.2988 29.6719 14.7002 30.4959 14.7858L45.4358 16.3378C46.2598 16.4234 46.8584 17.1608 46.7728 17.9848L46.6171 19.4842C46.3032 22.5055 43.5995 24.7003 40.5782 24.3864L33.5954 23.6611C30.5741 23.3472 28.3793 20.6435 28.6931 17.6222L28.8489 16.1228ZM31.6779 17.9247L31.6771 17.9322C31.5344 19.3055 32.5321 20.5344 33.9054 20.6771L40.8882 21.4025C42.2615 21.5452 43.4905 20.5475 43.6331 19.1742L43.6339 19.1668L31.6779 17.9247Z", fill: "black" }),
        React$2.createElement("path", { d: "M30.0769 35.3068C29.9911 36.1322 29.2525 36.7318 28.4271 36.646C27.6018 36.5603 27.0022 35.8217 27.0879 34.9963C27.1736 34.1709 27.9123 33.5713 28.7376 33.657C29.563 33.7428 30.1626 34.4814 30.0769 35.3068Z", fill: "black" }),
        React$2.createElement("path", { d: "M45.0169 36.8585C44.9312 37.6839 44.1926 38.2835 43.3672 38.1978C42.5418 38.112 41.9422 37.3734 42.028 36.548C42.1137 35.7227 42.8523 35.1231 43.6777 35.2088C44.5031 35.2945 45.1027 36.0332 45.0169 36.8585Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M45.0489 11.8066L38 11.0751L38.31 8.09111L45.3589 8.82264C49.4451 9.24713 52.4294 12.8801 52.0522 16.971L50.5618 33.1387L47.5745 32.8633L49.0649 16.6956C49.2912 14.241 47.5006 12.0613 45.0489 11.8066Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.8489 16.1228C28.9345 15.2988 29.6719 14.7002 30.4959 14.7858L45.4358 16.3378C46.2598 16.4234 46.8584 17.1608 46.7728 17.9848L46.6171 19.4842C46.3032 22.5055 43.5995 24.7003 40.5782 24.3864L33.5954 23.6611C30.5741 23.3472 28.3793 20.6435 28.6931 17.6222L28.8489 16.1228ZM31.6779 17.9247L31.6771 17.9322C31.5344 19.3055 32.5321 20.5344 33.9054 20.6771L40.8882 21.4025C42.2615 21.5452 43.4905 20.5475 43.6331 19.1742L43.6339 19.1668L31.6779 17.9247Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { d: "M30.0769 35.3068C29.9911 36.1322 29.2525 36.7318 28.4271 36.646C27.6018 36.5603 27.0022 35.8217 27.0879 34.9963C27.1736 34.1709 27.9123 33.5713 28.7376 33.657C29.563 33.7428 30.1626 34.4814 30.0769 35.3068Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.5305 35.6513C28.8066 35.68 29.0536 35.4795 29.0823 35.2034C29.111 34.9274 28.9104 34.6803 28.6344 34.6517C28.3583 34.623 28.1113 34.8235 28.0826 35.0996C28.0539 35.3756 28.2544 35.6227 28.5305 35.6513ZM28.4271 36.646C29.2525 36.7318 29.9911 36.1322 30.0769 35.3068C30.1626 34.4814 29.563 33.7428 28.7376 33.657C27.9123 33.5713 27.1736 34.1709 27.0879 34.9963C27.0022 35.8217 27.6018 36.5603 28.4271 36.646Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { d: "M45.0169 36.8585C44.9312 37.6839 44.1926 38.2835 43.3672 38.1978C42.5418 38.112 41.9422 37.3734 42.028 36.548C42.1137 35.7227 42.8523 35.1231 43.6777 35.2088C44.5031 35.2945 45.1027 36.0332 45.0169 36.8585Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M43.4706 37.2031C43.7466 37.2318 43.9937 37.0312 44.0223 36.7552C44.051 36.4791 43.8505 36.2321 43.5744 36.2034C43.2984 36.1747 43.0513 36.3753 43.0226 36.6513C42.994 36.9274 43.1945 37.1744 43.4706 37.2031ZM43.3672 38.1978C44.1926 38.2835 44.9312 37.6839 45.0169 36.8585C45.1027 36.0332 44.5031 35.2945 43.6777 35.2088C42.8523 35.1231 42.1137 35.7227 42.028 36.548C41.9422 37.3734 42.5418 38.112 43.3672 38.1978Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M47.5745 32.8633L48.5918 21.8273L51.5792 22.1027L50.5618 33.1387L47.5745 32.8633Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.8489 16.1228C28.9345 15.2988 29.6719 14.7002 30.4959 14.7858L45.4358 16.3378C46.2598 16.4234 46.8584 17.1608 46.7728 17.9848L46.6171 19.4842C46.3032 22.5055 43.5995 24.7003 40.5782 24.3864L33.5954 23.6611C30.5741 23.3472 28.3793 20.6435 28.6931 17.6222L28.8489 16.1228ZM31.6779 17.9247L31.6771 17.9322C31.5344 19.3055 32.5321 20.5344 33.9054 20.6771L40.8882 21.4025C42.2615 21.5452 43.4905 20.5475 43.6331 19.1742L43.6339 19.1668L31.6779 17.9247Z", fill: "black" }),
        React$2.createElement("path", { d: "M30.0769 35.3068C29.9911 36.1322 29.2525 36.7318 28.4271 36.646C27.6018 36.5603 27.0022 35.8217 27.0879 34.9963C27.1736 34.1709 27.9123 33.5713 28.7376 33.657C29.563 33.7428 30.1626 34.4814 30.0769 35.3068Z", fill: "black" }),
        React$2.createElement("path", { d: "M45.0169 36.8585C44.9312 37.6839 44.1926 38.2835 43.3672 38.1978C42.5418 38.112 41.9422 37.3734 42.028 36.548C42.1137 35.7227 42.8523 35.1231 43.6777 35.2088C44.5031 35.2945 45.1027 36.0332 45.0169 36.8585Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const RoadConditionsPictogram = (props) => {
    const { title = 'Road Conditions Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M40.8569 19.2649L43.9144 36.2993L46.8672 35.7693L43.8097 18.7349L40.8569 19.2649Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M42.3856 27.7819L43.9144 36.2992L46.8672 35.7692L45.3385 27.252L42.3856 27.7819Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M39 11C36.7909 11 35 9.20914 35 7C35 4.79086 36.7909 3 39 3C41.2091 3 43 4.79086 43 7C43 9.20914 41.2091 11 39 11ZM32.1611 5.5C32.8478 2.35482 35.6489 0 39 0C42.3511 0 45.1522 2.35482 45.8389 5.5H52V20.5H41.0786H34.7994L38.9171 43H48V46H36.4163L31.7496 20.5H20.2504L15.5837 46H3.18799L5.13413 35.7619L7.87345 20.5H0V5.5H32.1611ZM32.1611 8.5H29.1682L36.1227 17.5H42.9424L40.3496 13.87C39.9129 13.9553 39.4617 14 39 14C35.6489 14 32.8478 11.6452 32.1611 8.5ZM43.154 12.6348L46.6291 17.5H49V8.5H45.8389C45.4709 10.1855 44.4957 11.644 43.154 12.6348ZM32.3314 17.5L25.3769 8.5H18.6682L25.6227 17.5H31.2006H32.3314ZM8.16816 8.5H14.8769L21.8314 17.5H20.7994H15.1227L8.16816 8.5ZM11.3314 17.5L4.37685 8.5H3V17.5H8.41191H11.3314ZM10.9214 20.5H17.2006L13.0829 43H6.81197L8.08422 36.307L10.9214 20.5Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const RoutePictogram = (props) => {
    const { title = 'Route Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 27H23.5C27.0898 27 30 29.9102 30 33.5C30 37.0899 27.0898 40 23.5 40H16.5C12.3579 40 9 43.3579 9 47.5C9 51.6421 12.3579 55 16.5 55H41.6662C40.8071 54.1413 39.831 53.106 38.853 51.9454C37.435 50.2628 35.9875 48.2873 34.8887 46.1804C33.7952 44.0834 33 41.7666 33 39.4268C33 32.5543 38.6059 27 45.5 27C50.2226 27 54.3622 29.5276 56.4892 33.4233C57.4559 35.1938 58 37.2354 58 39.4268C58 41.7996 57.1822 44.1492 56.0638 46.2709C54.9398 48.4032 53.4623 50.3987 52.0251 52.0894L51.0535 53.2323L48.7678 51.2892L49.7394 50.1463C51.0908 48.5566 52.4223 46.7456 53.4099 44.8719C54.4032 42.9876 55 41.1319 55 39.4268C55 37.7386 54.5824 36.1913 53.8561 34.8609C52.2577 31.9335 49.131 30 45.5 30C40.2438 30 36 34.23 36 39.4268C36 41.1075 36.5798 42.935 37.5488 44.7932C38.5125 46.6413 39.815 48.4316 41.147 50.0121C42.4754 51.5884 43.8081 52.9267 44.8103 53.8717C45.3104 54.3433 45.7258 54.7147 46.014 54.9664C46.1581 55.0922 46.2701 55.1879 46.3449 55.2511C46.3823 55.2828 46.4104 55.3062 46.4284 55.3213L46.4479 55.3375L46.4519 55.3407C46.452 55.3408 46.4517 55.3406 46.4519 55.3407C46.9412 55.7428 47.1257 56.4092 46.9122 57.0055C46.6987 57.602 46.1335 58 45.5 58H16.5C10.701 58 6 53.299 6 47.5C6 41.701 10.701 37 16.5 37H23.5C25.433 37 27 35.433 27 33.5C27 31.567 25.433 30 23.5 30H16V27Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M56.6244 33.5591L57.1668 34.9576C57.7054 36.3463 58 37.8541 58 39.4268C58 41.7995 57.1822 44.1492 56.0638 46.2708C54.9398 48.4031 53.4623 50.3987 52.0251 52.0894L51.0535 53.2322L48.7678 51.2891L49.7394 50.1463C51.0908 48.5566 52.4222 46.7455 53.4099 44.8719C54.4032 42.9876 55 41.1319 55 39.4268C55 38.2312 54.7764 37.0909 54.3698 36.0423L53.8274 34.6438L56.6244 33.5591Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M56.5396 45.4169L55.8113 46.7283C54.7244 48.6855 53.3618 50.517 52.0251 52.0895L51.0535 53.2323L48.7678 51.2892L49.7394 50.1464C50.9917 48.6733 52.2257 47.0057 53.1886 45.2718L53.9168 43.9604L56.5396 45.4169Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.8167 18.9913C22.6299 17.5315 23 16.3075 23 15.3659C23 12.07 19.8918 9 16 9C12.1082 9 9 12.07 9 15.3659C9 16.3075 9.37011 17.5315 10.1833 18.9913C10.9794 20.4204 12.0809 21.8633 13.2481 23.1843C14.2161 24.2798 15.1908 25.2482 16 26.0059C16.8092 25.2482 17.7839 24.2798 18.7519 23.1843C19.9191 21.8633 21.0206 20.4204 21.8167 18.9913ZM16 30C16 30 26 22 26 15.3659C26 10.1932 21.3198 6 16 6C10.6802 6 6 10.1932 6 15.3659C6 22 16 30 16 30Z", fill: "black" }),
        React$2.createElement("path", { d: "M18.5 15.5C18.5 16.8807 17.3807 18 16 18C14.6193 18 13.5 16.8807 13.5 15.5C13.5 14.1193 14.6193 13 16 13C17.3807 13 18.5 14.1193 18.5 15.5Z", fill: "black" }),
        React$2.createElement("path", { d: "M49 39.5C49 41.433 47.433 43 45.5 43C43.567 43 42 41.433 42 39.5C42 37.567 43.567 36 45.5 36C47.433 36 49 37.567 49 39.5Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const SalesPictogram = (props) => {
    const { title = 'Sales Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M48.5121 2.13253L29.7326 21.0353L18.5645 9.77285L2.1492 26.3373L0 24.2075L18.5638 5.47496L29.7346 16.7401L46.3655 0L48.5121 2.13253Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M48.512 2.13253L34.3352 16.4023L32.1887 14.2698L46.3654 0L48.512 2.13253Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M48.5121 2.13253L40.93 9.76443L38.7834 7.63189L46.3656 0L48.5121 2.13253Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.34829 47.6441C9.02004 48.4402 11.4359 48.9742 14.1863 48.9742C16.9366 48.9742 19.3525 48.4402 21.0242 47.6441C22.8088 46.7944 23.2636 45.916 23.2636 45.4442H26.2893C26.2893 47.7575 24.3734 49.4006 22.3251 50.376C20.1639 51.4051 17.2847 52 14.1863 52C11.0878 52 8.20857 51.4051 6.04741 50.376C3.99909 49.4006 2.08317 47.7575 2.08317 45.4442H5.10894C5.10894 45.916 5.56372 46.7944 7.34829 47.6441Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.2616 39.4091C23.2634 39.4005 23.2636 39.3958 23.2636 39.3926C23.2636 39.3894 23.2634 39.3847 23.2616 39.3762C23.2598 39.3672 23.2552 39.3486 23.2431 39.3191C23.2187 39.2593 23.1602 39.1474 23.0281 38.9913C22.7521 38.665 22.2342 38.2413 21.3913 37.8199C19.7037 36.9761 17.1605 36.3669 14.1863 36.3669C11.212 36.3669 8.66884 36.9761 6.98125 37.8199C6.1383 38.2413 5.62036 38.665 5.34438 38.9913C5.21232 39.1474 5.15384 39.2593 5.12939 39.3191C5.11733 39.3486 5.1127 39.3672 5.11088 39.3762C5.10914 39.3847 5.10894 39.3894 5.10894 39.3926C5.10894 39.3958 5.10914 39.4005 5.11088 39.4091C5.1127 39.418 5.11733 39.4367 5.12939 39.4662C5.15384 39.5259 5.21232 39.6379 5.34438 39.794C5.62036 40.1202 6.1383 40.5439 6.98125 40.9654C8.66884 41.8092 11.212 42.4184 14.1863 42.4184C17.1605 42.4184 19.7037 41.8092 21.3913 40.9654C22.2342 40.5439 22.7521 40.1202 23.0281 39.794C23.1602 39.6379 23.2187 39.5259 23.2431 39.4662C23.2552 39.4367 23.2598 39.418 23.2616 39.4091ZM14.1863 45.4442C20.8706 45.4442 26.2893 42.7348 26.2893 39.3926C26.2893 36.0505 20.8706 33.3411 14.1863 33.3411C7.5019 33.3411 2.08317 36.0505 2.08317 39.3926C2.08317 42.7348 7.5019 45.4442 14.1863 45.4442Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26.2893 39.3926V45.4442H23.2636V39.3926H26.2893Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.10894 39.3926L5.10894 45.4442H2.08317L2.08317 39.3926H5.10894Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.5287 47.6441C30.2004 48.4402 32.6163 48.9742 35.3666 48.9742C38.117 48.9742 40.5329 48.4402 42.2046 47.6441C43.9892 46.7944 44.4439 45.916 44.4439 45.4442H47.4697C47.4697 47.7575 45.5538 49.4006 43.5055 50.376C41.3443 51.4051 38.4651 52 35.3666 52C32.2682 52 29.389 51.4051 27.2278 50.376C25.1795 49.4006 23.2636 47.7575 23.2636 45.4442H26.2893C26.2893 45.916 26.7441 46.7944 28.5287 47.6441Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.5287 40.584C30.2004 41.3801 32.6163 41.9141 35.3666 41.9141C38.117 41.9141 40.5329 41.3801 42.2046 40.584C43.9892 39.7342 44.4439 38.8559 44.4439 38.384H47.4697C47.4697 40.6973 45.5538 42.3405 43.5055 43.3159C41.3443 44.345 38.4651 44.9399 35.3666 44.9399C32.2682 44.9399 29.389 44.345 27.2278 43.3159C25.1795 42.3405 23.2636 40.6973 23.2636 38.384H26.2893C26.2893 38.8559 26.7441 39.7342 28.5287 40.584Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M44.442 32.349C44.4437 32.3404 44.4439 32.3357 44.4439 32.3325C44.4439 32.3293 44.4437 32.3246 44.442 32.316C44.4402 32.3071 44.4356 32.2884 44.4235 32.259C44.399 32.1992 44.3406 32.0872 44.2085 31.9311C43.9325 31.6049 43.4146 31.1812 42.5716 30.7597C40.8841 29.9159 38.3409 29.3067 35.3666 29.3067C32.3923 29.3067 29.8492 29.9159 28.1616 30.7597C27.3187 31.1812 26.8007 31.6049 26.5248 31.9311C26.3927 32.0872 26.3342 32.1992 26.3098 32.259C26.2977 32.2884 26.2931 32.3071 26.2913 32.316C26.2895 32.3246 26.2893 32.3293 26.2893 32.3325C26.2893 32.3357 26.2895 32.3404 26.2913 32.349C26.2931 32.3579 26.2977 32.3766 26.3098 32.406C26.3342 32.4658 26.3927 32.5778 26.5248 32.7339C26.8007 33.0601 27.3187 33.4838 28.1616 33.9053C29.8492 34.749 32.3923 35.3583 35.3666 35.3583C38.3409 35.3583 40.8841 34.749 42.5716 33.9053C43.4146 33.4838 43.9325 33.0601 44.2085 32.7339C44.3406 32.5778 44.399 32.4658 44.4235 32.406C44.4356 32.3766 44.4402 32.3579 44.442 32.349ZM35.3666 38.384C42.051 38.384 47.4697 35.6747 47.4697 32.3325C47.4697 28.9903 42.051 26.281 35.3666 26.281C28.6823 26.281 23.2636 28.9903 23.2636 32.3325C23.2636 35.6747 28.6823 38.384 35.3666 38.384Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M47.4697 32.3325V45.4442H44.4439V32.3325H47.4697Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26.2893 32.3325V45.4442H23.2636V32.3325H26.2893Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const SecurityPictogram = (props) => {
    const { title = 'Security Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26 0C17.7157 0 11 6.71573 11 15V22.5H7.5C3.35786 22.5 0 25.8579 0 30V44.5C0 48.6421 3.35786 52 7.5 52H44.5C48.6421 52 52 48.6421 52 44.5V44H49V44.5C49 46.9853 46.9853 49 44.5 49H7.5C5.01472 49 3 46.9853 3 44.5V30C3 27.5147 5.01472 25.5 7.5 25.5H44.5C46.9853 25.5 49 27.5147 49 30V38H52V30C52 25.8579 48.6421 22.5 44.5 22.5H41V15C41 6.71573 34.2843 0 26 0ZM38 22.5V15C38 8.37258 32.6274 3 26 3C19.3726 3 14 8.37258 14 15V22.5H38Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M49.0001 29.9999C49.0001 28.8576 48.5764 27.818 47.8755 27.0238L50.1247 25.0386C51.2908 26.3598 52.0001 28.0989 52.0001 29.9999V37.9999H49.0001V29.9999Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M49 38V32H52V38H49Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26 34.5C24.3431 34.5 23 35.8431 23 37.5C23 39.1569 24.3431 40.5 26 40.5C27.6569 40.5 29 39.1569 29 37.5C29 35.8431 27.6569 34.5 26 34.5ZM20 37.5C20 34.1863 22.6863 31.5 26 31.5C29.3137 31.5 32 34.1863 32 37.5C32 40.8137 29.3137 43.5 26 43.5C22.6863 43.5 20 40.8137 20 37.5Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ShieldPictogram = (props) => {
    const { title = 'Shield Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.4206 57.7007L32.0311 56.321L32.7384 57.6532L32.091 58L31.4206 57.7007ZM11.0843 15.1262L9.59577 14.9156L9.72248 14.0118L32.0311 6L54.3231 14.0058L54.4625 14.8899L52.9779 15.1262C54.4625 14.8899 54.4625 14.8899 54.4625 14.8899L54.4639 14.8989L54.4669 14.918L54.477 14.9861C54.4856 15.0447 54.4978 15.1293 54.5126 15.2387C54.5422 15.4575 54.5828 15.7754 54.6279 16.1818C54.7182 16.9945 54.8269 18.1624 54.9035 19.6009C55.0564 22.4746 55.0818 26.4456 54.5683 30.8301L51.5825 30.4773C52.0711 26.306 52.0478 22.5133 51.9014 19.7621C51.8283 18.3882 51.7247 17.2785 51.6401 16.5166C51.6291 16.4177 51.6185 16.3247 51.6083 16.2377L32.0311 9.2069L12.4632 16.2344C12.4163 16.6524 12.3591 17.2039 12.3012 17.863C12.162 19.4484 12.0199 21.6479 12.0073 24.104C11.9817 29.09 12.4957 34.8539 14.4401 38.7559C16.9823 43.8577 21.485 47.9057 25.4556 50.71C27.427 52.1024 29.2354 53.166 30.5485 53.8801C31.1349 54.199 31.6211 54.4475 31.9771 54.6237C32.1373 54.5321 32.3243 54.4241 32.5351 54.3003C33.3088 53.846 34.4015 53.1809 35.6678 52.3426C38.2098 50.6599 41.4101 48.3069 44.1354 45.587L46.2544 47.729C43.3317 50.6459 39.9501 53.1243 37.3221 54.8639C36.0035 55.7368 34.8642 56.4305 34.0523 56.9073C33.6461 57.1458 33.3213 57.3303 33.0963 57.4561C32.9838 57.519 32.8962 57.5673 32.8358 57.6003L32.7658 57.6384L32.7467 57.6487L32.7384 57.6532C32.7384 57.6532 32.7384 57.6532 32.0311 56.321C31.4206 57.7007 31.4206 57.7007 31.4206 57.7007L31.4153 57.6983L31.4051 57.6937L31.3702 57.6779C31.3406 57.6644 31.2984 57.645 31.2442 57.6196C31.1357 57.569 30.9794 57.4948 30.7804 57.3974C30.3826 57.2026 29.8139 56.9145 29.117 56.5355C27.7245 55.7782 25.8128 54.6538 23.7263 53.1801C19.5809 50.2523 14.616 45.8557 11.7517 40.1075C9.46683 35.5222 8.97507 29.1333 9.00096 24.0884C9.0141 21.529 9.16201 19.2435 9.30648 17.5978C9.37878 16.7741 9.4504 16.1086 9.50427 15.6468C9.5312 15.4158 9.55371 15.2356 9.56967 15.1119C9.57302 15.0859 9.57609 15.0624 9.57885 15.0414C9.58265 15.0125 9.58586 14.9884 9.58843 14.9694L9.59362 14.9311L9.59509 14.9205L9.59577 14.9156C9.59577 14.9156 9.59577 14.9156 11.0843 15.1262Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.4206 57.7007L32.0311 56.321L32.7384 57.6532L32.091 58L31.4206 57.7007ZM31.9771 54.6237C31.6826 54.4779 31.2989 54.2827 30.843 54.0389C29.7047 53.4304 28.1216 52.5223 26.3552 51.3309L24.6792 53.8379C26.5465 55.0973 28.2203 56.0575 29.4305 56.7045C30.0361 57.0283 30.5269 57.2744 30.8695 57.4409C31.0408 57.5241 31.1752 57.5876 31.2684 57.6309C31.315 57.6526 31.3513 57.6693 31.3769 57.6809L31.407 57.6946L31.4159 57.6986L31.4206 57.7007C31.4207 57.7008 31.4206 57.7007 32.0311 56.321C32.7384 57.6532 32.7382 57.6533 32.7384 57.6532L32.7467 57.6487L32.7658 57.6384L32.8358 57.6004C32.8962 57.5673 32.9838 57.519 33.0963 57.4561C33.3213 57.3303 33.6461 57.1458 34.0523 56.9073C34.8642 56.4305 36.0035 55.7368 37.3221 54.8639C39.9501 53.1243 43.3317 50.6459 46.2544 47.729L44.1354 45.587C41.4101 48.3069 38.2098 50.6599 35.6678 52.3426C34.4015 53.1809 33.3088 53.846 32.5351 54.3003C32.3243 54.4241 32.1373 54.5321 31.9771 54.6237Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M34.7309 52.9526C37.3794 51.2582 41.0585 48.6579 44.1354 45.5872L46.2544 47.7293C42.9594 51.0177 39.0781 53.7516 36.3459 55.4995L34.7309 52.9526Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.2707 50.5033L32.0308 49.2008L32.8196 50.486L32.0503 50.9623L31.2707 50.5033ZM17.1766 19.714L15.6829 19.5446L15.7897 18.5943L32.0308 13.022L48.2722 18.5944L48.3788 19.5449L46.8851 19.714C48.3788 19.5449 48.3788 19.5449 48.3788 19.5449L48.38 19.5558L48.3828 19.5815L48.3927 19.6755C48.401 19.7568 48.4126 19.8746 48.4264 20.0253C48.454 20.3268 48.4903 20.7605 48.526 21.2977C48.5973 22.3707 48.6666 23.8631 48.6582 25.5426C48.6417 28.8416 48.3279 33.0885 46.9942 36.2584C45.3855 40.0816 41.7396 43.6603 38.685 46.1971C37.1291 47.4892 35.6693 48.557 34.5986 49.302C34.0625 49.675 33.6222 49.9682 33.3139 50.1695C33.1597 50.2701 33.0384 50.3478 32.9546 50.4011C32.9127 50.4277 32.8801 50.4482 32.8574 50.4625L32.8309 50.479L32.8233 50.4837L32.8196 50.486C32.8196 50.486 32.8196 50.486 32.0308 49.2008C31.2707 50.5033 31.2707 50.5033 31.2707 50.5033L31.2668 50.501L31.259 50.4964L31.2323 50.4805C31.2095 50.4669 31.177 50.4474 31.1353 50.4221C31.0519 50.3715 30.9315 50.2977 30.7788 50.2021C30.4733 50.0108 30.0377 49.7315 29.5073 49.374C28.4481 48.66 27.004 47.629 25.463 46.3594C22.4313 43.8618 18.8213 40.2778 17.2077 36.2321C15.8465 32.8189 15.4882 28.6033 15.4449 25.3506C15.4229 23.7033 15.4817 22.2601 15.546 21.2273C15.5782 20.7103 15.6119 20.2946 15.6377 20.0059C15.6507 19.8615 15.6617 19.7488 15.6696 19.6708L15.679 19.5804L15.6817 19.5556L15.6827 19.546C15.6827 19.546 15.6829 19.5446 17.1766 19.714ZM45.4774 20.8265L32.0308 16.213L18.5869 20.8255C18.5738 21.0011 18.56 21.1986 18.5465 21.4157C18.4858 22.3907 18.4302 23.7557 18.4509 25.3102C18.4929 28.4614 18.8479 32.2241 19.9985 35.1092C21.3164 38.4137 24.4202 41.5949 27.3695 44.0247C28.819 45.2188 30.1822 46.1922 31.1826 46.8666C31.5 47.0806 31.7802 47.264 32.0141 47.4142C32.2578 47.2519 32.552 47.0525 32.8867 46.8197C33.9065 46.1101 35.2949 45.0943 36.7694 43.8698C39.7754 41.3734 42.9189 38.1869 44.225 35.0829C45.3117 32.5 45.6357 28.7686 45.6519 25.5275C45.6598 23.9369 45.5941 22.5187 45.5263 21.4987C45.5098 21.2493 45.4931 21.0241 45.4774 20.8265Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M33.5341 15.1422V33.4192H30.5278V15.1422H33.5341Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ShoppingBasketPictogram = (props) => {
    const { title = 'Shopping Basket Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M45.964 46.1082L49.5224 25.767L52.4776 26.283L48.9192 46.6242C48.3755 49.7321 45.6743 51.9999 42.5162 51.9999H21.4637C18.3033 51.9999 15.6008 49.7289 15.0597 46.6181L14.3027 42.2662L17.2584 41.753L18.0154 46.1049C18.3068 47.7799 19.7619 49.0028 21.4637 49.0028H42.5162C44.2167 49.0028 45.6712 47.7817 45.964 46.1082Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.9698 24.0269L21.6 12L24.4 13.0759L20.184 24.0269H43.816L39.6 13.0759L42.4 12L47.0302 24.0269H58V27.024H6V24.0269H16.9698Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.2584 41.7529L18.0155 46.1048C18.3068 47.7799 19.762 49.0028 21.4638 49.0028H27.0001V51.9999H21.4638C18.3033 51.9999 15.6009 49.7288 15.0598 46.618L14.3027 42.2661L17.2584 41.7529Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.4989 31.6387L17.4321 42.752L14.4764 43.2652L12.5432 32.1518L15.4989 31.6387Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26 44.0075V31.02H29V44.0075H26ZM35 44.0075V31.02H38V44.0075H35Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ShoppingPictogram = (props) => {
    const { title = 'Shopping Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.0398 9C21.2715 9 19.0274 11.2386 19.0274 14V29H16.0199V14C16.0199 9.58172 19.6106 6 24.0398 6C28.4691 6 32.0598 9.58172 32.0598 14V21H36.0697V13C36.0697 9.13401 39.2115 6 43.0872 6C46.9628 6 50.1046 9.13401 50.1046 13V21H56L54.7177 40.1002L51.7169 39.8998L52.7844 24H32.0598V29H29.0523V24H21.0324V21H29.0523V14C29.0523 11.2386 26.8081 9 24.0398 9ZM47.0971 21V13C47.0971 10.7909 45.3018 9 43.0872 9C40.8725 9 39.0772 10.7909 39.0772 13V21H47.0971Z", fill: "black" }),
        React$2.createElement("path", { d: "M50.8598 52.667L51.0456 49.8998L54.0463 50.1002L53.8605 52.8675C53.6666 55.7559 51.2613 58 48.3592 58H21.0324V55H48.3592C49.6783 55 50.7717 53.98 50.8598 52.667Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 21L11.623 54.4299C11.8432 56.4608 13.562 58 15.6098 58H39.0772V21H8ZM11.3501 24L14.6131 54.1075C14.6681 54.6152 15.0978 55 15.6098 55H36.0697V24H11.3501Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M51.717 39.8999L52.5898 26.8999L55.5906 27.1004L54.7178 40.1004L51.717 39.8999Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M51.717 39.8999L52.1534 33.3999L55.1542 33.6004L54.7178 40.1004L51.717 39.8999Z", fill: "#7E3BFF" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const SirenPictogram = (props) => {
    const { title = 'Siren Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.8422 46.2409H11C10.4477 46.2409 10 46.6886 10 47.2409V55.2407H48.5119V47.2409C48.5119 46.6886 48.0641 46.2409 47.5119 46.2409H44.6693L41.5152 21.1223C41.5151 21.1212 41.5149 21.12 41.5148 21.1188C41.1548 18.3249 38.7769 16.2407 35.9061 16.2407H22.6054C19.7346 16.2407 17.3567 18.3249 16.9967 21.1188C16.9966 21.12 16.9964 21.1212 16.9962 21.1223L13.8422 46.2409ZM14.0206 20.7408C14.5743 16.4216 18.2509 13.2407 22.6054 13.2407H35.9061C40.2606 13.2407 43.9371 16.4216 44.4909 20.7409L47.3162 43.2409H47.5119C49.721 43.2409 51.5119 45.0317 51.5119 47.2409V58.2407H7V47.2409C7 45.0317 8.79086 43.2409 11 43.2409H11.1953L14.0206 20.7408Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 43.2409L26.3644 43.2408V46.2408L11 46.2409V43.2409Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M41.0001 43.2406L46.8298 43.2409L46.8297 46.2409L40.9999 46.2406L41.0001 43.2406Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 43.2407H27.0465V46.2407H16V43.2407Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25 43.2407H35V46.2407H25V43.2407Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.7795 23.2656H27.0464V20.2656H23.3381C22.0773 20.2656 21.0138 21.2045 20.8574 22.4555L19.5444 32.9595L22.5213 33.3316L23.7795 23.2656Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M56.3538 15.626L48.7311 17.7427L49.5338 20.6333L57.1564 18.5166L56.3538 15.626Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M56.3127 30.1489L48.4566 28.1849L49.1842 25.2745L57.0404 27.2385L56.3127 30.1489Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M51.5999 8.03961L46.8675 14.3558L44.4666 12.557L49.199 6.24076L51.5999 8.03961Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const SnackPictogram = (props) => {
    const { title = 'Snack Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31 45C31 39.4772 26.5228 35 21 35V32C28.1797 32 34 37.8203 34 45C34 52.1797 28.1797 58 21 58C13.8203 58 8 52.1797 8 45C8 41.2092 9.62449 37.7956 12.2108 35.4213L14.2396 37.6313C12.2462 39.4613 11 42.084 11 45C11 50.5228 15.4772 55 21 55C26.5228 55 31 50.5228 31 45Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.5286 40.6815C22.5032 41.0059 22.5 41.0149 22.5 41H19.5C19.5 40.8934 19.5112 40.7504 19.5254 40.5696C19.5775 39.9059 19.6695 38.7331 19.3933 36.984C19.0519 34.8218 18.1379 31.9395 15.811 28.9146L18.1889 27.0854C20.8621 30.5606 21.948 33.9282 22.3566 36.5161C22.5604 37.8066 22.5949 38.8972 22.5778 39.7038C22.5692 40.1073 22.5477 40.4377 22.5286 40.6815Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.2396 37.6314C12.2462 39.4613 11 42.0841 11 45.0001C11 50.5229 15.4772 55.0001 21 55.0001V58.0001C13.8203 58.0001 8 52.1798 8 45.0001C8 41.2092 9.62449 37.7956 12.2108 35.4214L14.2396 37.6314Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.2396 37.6314C12.2462 39.4613 11 42.0841 11 45.0001C11 45.6759 11.0668 46.3346 11.1938 46.9704L8.25183 47.5578C8.08649 46.7296 8 45.8742 8 45.0001C8 41.2092 9.62449 37.7956 12.2108 35.4214L14.2396 37.6314Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M43.5 6H46.5C48.9846 6 51 8.0129 51 10.4989V17C51 17.5415 51.1998 18.2374 51.6375 19.1639C51.9944 19.9194 52.4477 20.7069 52.9558 21.5897C53.0688 21.786 53.1844 21.9869 53.3024 22.1933C54.5332 24.3472 56 27.0488 56 30V51.5C56 55.0899 53.0899 58 49.5 58H37V55H49.5C51.433 55 53 53.433 53 51.5V30C53 27.9512 51.9668 25.9028 50.6976 23.6817C50.5929 23.4985 50.4861 23.3131 50.3786 23.1263C49.868 22.24 49.339 21.3218 48.925 20.4454C48.4252 19.3876 48 18.2085 48 17V10.4989C48 9.67119 47.3291 9 46.5 9H43.5V6Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M43.5 6H40.5C38.0154 6 36 8.0129 36 10.4989V17C36 17.5415 35.8002 18.2374 35.3625 19.1639C35.0056 19.9194 34.5523 20.7069 34.0442 21.5897C33.9312 21.786 33.8156 21.9869 33.6976 22.1933C32.4668 24.3472 31 27.0488 31 30V32H34V30C34 27.9512 35.0332 25.9028 36.3024 23.6817C36.4071 23.4985 36.5139 23.3131 36.6215 23.1263C37.132 22.24 37.661 21.3218 38.075 20.4454C38.5748 19.3876 39 18.2085 39 17V10.4989C39 9.67119 39.6709 9 40.5 9H43.5V6Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M53.4458 28.4068C53.7075 28.45 53.9155 28.4843 54.1493 28.5077L53.8507 31.4928C53.5251 31.4602 53.1567 31.4 52.8357 31.3474C52.7017 31.3255 52.5759 31.3049 52.465 31.2883C52.0381 31.2243 51.6188 31.1791 51.1519 31.1875C50.2428 31.2038 49.0034 31.426 47.1711 32.3427L47.1392 32.3586C45.6322 33.1126 44.3365 33.7608 43.2286 34.2161C42.1233 34.6702 41.0481 35.0014 40 35.0014V32.0014C40.4519 32.0014 41.0881 31.8522 42.0884 31.4412C43.0784 31.0344 44.2722 30.4385 45.8289 29.6597C47.9966 28.5752 49.6738 28.2135 51.0981 28.188C51.7978 28.1755 52.3994 28.2449 52.91 28.3215C53.1182 28.3527 53.2913 28.3813 53.4458 28.4068Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const StrategyPictogram = (props) => {
    const { title = 'Strategy Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M40 6V8.5H47C47.5115 8.5 47.9878 8.76068 48.2635 9.19157C48.5392 9.62246 48.5763 10.1641 48.3619 10.6286L45.8982 15.9667C45.3663 17.1192 44.2565 17.8863 43.006 17.9884C42.9926 19.0268 43.0014 20.0299 43.0314 21H46.5V24H43.1984C43.8958 32.5239 46.3737 38.3487 49.7104 43.5794C51.0772 44.3516 52 45.8181 52 47.5C52 49.9853 49.9853 52 47.5 52H29.5C27.0147 52 25 49.9853 25 47.5C25 45.784 25.9605 44.2924 27.3732 43.5333C30.695 38.3145 33.1604 32.4989 33.8558 24H30.5V21H34.0228C34.0527 20.0311 34.0616 19.0294 34.0482 17.9924C32.7757 17.9083 31.6414 17.1358 31.1018 15.9667L28.6381 10.6286C28.4237 10.1641 28.4608 9.62246 28.7365 9.19157C29.0122 8.76068 29.4885 8.5 30 8.5H37V6H33.5V3H37V0H40V3H43.5V6H40ZM37.0485 18C37.0611 19.0312 37.0526 20.0305 37.024 21H40.0302C40.0016 20.0305 39.9931 19.0312 40.0057 18H37.0485ZM36.865 24C36.2447 31.9935 34.1422 37.8521 31.2 43H45.8542C42.912 37.8521 40.8095 31.9935 40.1892 24H36.865ZM29.5 46C28.6716 46 28 46.6716 28 47.5C28 48.3284 28.6716 49 29.5 49H47.5C48.3284 49 49 48.3284 49 47.5C49 46.6716 48.3284 46 47.5 46H29.5ZM32.3444 11.5L33.8257 14.7095C33.9074 14.8866 34.0846 15 34.2797 15H42.7203C42.9154 15 43.0926 14.8866 43.1743 14.7095L44.6556 11.5H32.3444ZM9 12H23.5V15H9V12ZM24 37H7V40H24V37Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 21H27V24H0V21Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 21H15V24H0V21Z", fill: "#FF5B4A" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const TalkPictogram = (props) => {
    const { title = 'Talk Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.14441e-05 24.499C1.5378e-05 20.3568 3.35803 16.9989 7.50027 16.999L24.0002 16.9996C28.1423 16.9997 31.5 20.3576 31.5 24.4996L31.5 36.4992C31.5 40.6416 28.1417 43.9996 23.9993 43.9992L19.9392 43.9989L11.0918 51.3048C9.46151 52.6511 6.99999 51.4915 6.99999 49.3771L6.99998 43.9824C3.09097 43.7251 -3.81469e-06 40.4729 0 36.4988L1.14441e-05 24.499ZM7.50016 19.999C5.01482 19.9989 3.00001 22.0137 3.00001 24.499L3 36.4988C3 38.9841 5.01472 40.9988 7.5 40.9988H9.99997L9.99999 48.3158L18.8607 40.9988L23.9996 40.9992C26.485 40.9995 28.5 38.9847 28.5 36.4992L28.5 24.4996C28.5 22.0144 26.4854 19.9997 24.0001 19.9996L7.50016 19.999Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M52 7.5C52 3.35786 48.6421 0 44.5 0H14.5C10.3579 0 7 3.35786 7 7.5V18.5H10V7.5C10 5.01472 12.0147 3 14.5 3H44.5C46.9853 3 49 5.01472 49 7.5V19H52V7.5ZM49 25V25.5C49 27.9853 46.9853 30 44.5 30H40.9846V39.8755L31.0613 29.94L28.9387 32.06L39.7158 42.8504C41.2902 44.4268 43.9846 43.3117 43.9846 41.0837V33H44.5C48.6421 33 52 29.6421 52 25.5V25H49Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M49 7.5C49 5.01472 46.9853 3 44.5 3V0C48.6421 0 52 3.35786 52 7.5V19H49V7.5Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M49 10V19H52V10H49Z", fill: "#7E3BFF" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const TasksPictogram = (props) => {
    const { title = 'Tasks Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 22V34H12V22H15Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 13.5C12 11.567 13.567 10 15.5 10H19V13H15.5C15.2239 13 15 13.2239 15 13.5V22H12V13.5Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M48.5 13H40.1875V10H48.5C50.433 10 52 11.567 52 13.5V54.5C52 56.433 50.433 58 48.5 58H15.5C13.567 58 12 56.433 12 54.5V33.6485H15V54.5C15 54.7762 15.2239 55 15.5 55H48.5C48.7761 55 49 54.7762 49 54.5V13.5C49 13.2239 48.7761 13 48.5 13Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 8.5C22 7.11929 23.1193 6 24.5 6H38.5C39.8807 6 41 7.11929 41 8.5V13H38V9H25V14H34V17H24.5C23.1193 17 22 15.8807 22 14.5V8.5Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 25H31V28H18V25Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.4375 23.9978L38.5498 26.1102L43.7156 20.9444L45.8369 23.0657L38.5498 30.3528L34.3162 26.1191L36.4375 23.9978Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 39H31V42H18V39Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.4375 37.2009L38.5498 39.3133L43.7156 34.1475L45.8369 36.2688L38.5498 43.5559L34.3162 39.3223L36.4375 37.2009Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const TransportationPictogram = (props) => {
    const { title = 'Transportation Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M43 9H21C18.2386 9 16 11.2386 16 14V48C16 48.5523 16.4477 49 17 49H47C47.5523 49 48 48.5523 48 48V14C48 11.2386 45.7614 9 43 9ZM21 6C16.5817 6 13 9.58172 13 14V48C13 50.2091 14.7909 52 17 52H47C49.2091 52 51 50.2091 51 48V14C51 9.58172 47.4183 6 43 6H21Z", fill: "black" }),
        React$2.createElement("path", { d: "M23 54.5C23 56.433 21.433 58 19.5 58C17.567 58 16 56.433 16 54.5V50H23V54.5Z", fill: "black" }),
        React$2.createElement("path", { d: "M47 54.5C47 56.433 45.433 58 43.5 58C41.567 58 40 56.433 40 54.5V50H47V54.5Z", fill: "black" }),
        React$2.createElement("path", { d: "M6 22.375C6 21.6156 6.61561 21 7.375 21H11V29.5C11 30.8807 9.88071 32 8.5 32C7.11929 32 6 30.8807 6 29.5V22.375Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5 19C11.2239 19 11 19.2239 11 19.5V23.02H8V19.5C8 17.567 9.567 16 11.5 16H14.3123V19H11.5Z", fill: "black" }),
        React$2.createElement("path", { d: "M58 22.375C58 21.6156 57.4444 21 56.685 21H53.06V29.5C53.06 30.8807 54.1793 32 55.56 32C56.9407 32 58 30.8807 58 29.5V22.375Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M52.56 19C52.8361 19 53.06 19.2239 53.06 19.5V23.02H56.06V19.5C56.06 17.567 54.493 16 52.56 16H49.5V19H52.56Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 16H31.5V19H16V27.5C16 31.0899 18.9101 34 22.5 34H41.5C45.0899 34 48 31.0899 48 27.5V17.5H51V27.5C51 32.7467 46.7467 37 41.5 37H22.5C17.2533 37 13 32.7467 13 27.5V16Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23 16H33V19H23V16Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31 16H40V19H31V16Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { d: "M23 44C23 45.1046 22.1046 46 21 46C19.8954 46 19 45.1046 19 44C19 42.8954 19.8954 42 21 42C22.1046 42 23 42.8954 23 44Z", fill: "black" }),
        React$2.createElement("path", { d: "M45 44C45 45.1046 44.1046 46 43 46C41.8954 46 41 45.1046 41 44C41 42.8954 41.8954 42 43 42C44.1046 42 45 42.8954 45 44Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const ViolencePictogram = (props) => {
    const { title = 'Violence Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M35.4977 0.143555L37.1535 10.63L51.9746 4.10873L43.7107 18.8657L51.6144 21.1239L44.8748 26.7403L51.8554 32.11L44.598 35.4595L51.3031 47.041L39.341 42.8543L38.7831 51.2222L29.5488 43.9666L31.4022 41.6076L36.1678 45.352L36.61 38.72L44.6479 41.5332L40.3529 34.1147L46.0956 31.4642L40.0762 26.834L45.3366 22.4503L39.2403 20.7085L44.9764 10.4655L34.7975 14.9442L33.4533 6.43066L27.2653 12.6187L23.1356 6.65363L20.224 12.061L11.0606 9.44288L12.9307 16.9233L10.0203 17.6509L6.89038 5.13134L18.727 8.51324L22.8154 0.920588L27.6857 7.95555L35.4977 0.143555Z", fill: "black" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.8154 0.92041L26.4588 6.18312L23.9922 7.89075L23.1356 6.65345L20.224 12.0608L11.0606 9.4427L12.9307 16.9231L10.0203 17.6507L6.89038 5.13116L18.727 8.51306L22.8154 0.92041Z", fill: "#7E3BFF" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.89038 5.13135L14.6376 7.34483L13.8134 10.2294L11.0606 9.44288L12.9307 16.9233L10.0203 17.6509L6.89038 5.13135Z", fill: "#FF5B4A" }),
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.8991 14.6997C24.1966 13.0855 21.518 13.1213 19.8592 14.7805L16.1791 18.4612C15.076 18.3909 13.9461 18.6707 12.9667 19.3237L9.05974 21.9283C6.2053 23.8313 4.37064 26.9286 4.07345 30.3463L3.53348 36.5559L-0.012207 39.6584L1.96331 41.9161L5.96331 38.4161C6.25482 38.161 6.43635 37.8031 6.46991 37.4172L7.06217 30.6062C7.28041 28.0964 8.62769 25.8219 10.7238 24.4245L14.6308 21.8198C15.5429 21.2118 16.7635 21.369 17.4917 22.1883L21.2573 26.4245C21.7603 26.9904 21.647 27.8702 21.0171 28.2901C20.5226 28.6198 19.8642 28.5546 19.444 28.1344L17.2944 25.9848C16.6637 25.3541 15.6888 25.2235 14.9143 25.6661L11.7313 27.4849L13.2198 30.0896L14.9297 29.1125C15.0266 29.9554 14.8589 30.7591 14.5365 31.5038C14.0459 32.6373 13.2153 33.5745 12.5386 34.1158L14.4127 36.4584C15.4026 35.6665 16.572 34.3537 17.2897 32.6955C17.554 32.0849 17.759 31.4206 17.8687 30.7171C19.2737 31.7147 21.1744 31.7742 22.6534 30.8046C22.6958 31.7554 23.072 32.6951 23.7855 33.4332C24.5501 34.2241 25.5592 34.6358 26.5783 34.6645C26.6087 35.4424 26.8568 36.2167 27.3304 36.8893L20.9583 43.58C19.9202 44.67 18.4808 45.2869 16.9755 45.2869H14.4755C14.1082 45.2869 13.7536 45.4217 13.479 45.6658L8.979 49.6658L10.9721 51.908L15.0458 48.2869H16.9755C19.3018 48.2869 21.5264 47.3335 23.1307 45.649L29.8747 38.5678C31.0914 38.8236 32.4093 38.5332 33.429 37.6647L36.0287 35.4507C37.7769 33.9617 37.9871 31.3375 36.4982 29.5893C36.012 29.0184 35.4048 28.6115 34.7465 28.3743C35.8768 26.8163 35.7617 24.6255 34.3775 23.1937C33.7519 22.5466 32.9626 22.1533 32.138 22.016C32.3316 20.6941 31.9047 19.2971 30.8531 18.3C29.8416 17.341 28.4804 16.9733 27.2008 17.191C27.062 16.2722 26.6274 15.3902 25.8991 14.6997ZM24.4587 26.2703L28.7721 22.3272C29.3136 21.8322 29.3213 20.9818 28.789 20.4771C28.2919 20.0058 27.5098 20.0162 27.0255 20.5006L23.3094 24.2175L23.4996 24.4315C23.9857 24.9784 24.3028 25.6114 24.4587 26.2703ZM21.0104 21.6311L23.8604 18.7811C24.3892 18.2522 24.3777 17.3914 23.835 16.8768C23.3123 16.3812 22.49 16.3922 21.9807 16.9016L19.2046 19.6782C19.3907 19.8358 19.5678 20.0082 19.734 20.1952L21.0104 21.6311ZM27.417 31.373L32.1957 26.7534C32.6097 26.3531 32.6209 25.6929 32.2206 25.2789C31.8203 24.8648 31.1602 24.8536 30.7461 25.2539L25.9674 29.8735C25.5533 30.2738 25.5422 30.934 25.9425 31.3481C26.3427 31.7621 27.0029 31.7733 27.417 31.373ZM34.0835 33.1667L31.4839 35.3808C30.997 35.7954 30.2662 35.7369 29.8516 35.2501C29.4369 34.7632 29.4954 34.0324 29.9823 33.6177L32.582 31.4037C33.0688 30.989 33.7996 31.0476 34.2143 31.5344C34.6289 32.0213 34.5704 32.7521 34.0835 33.1667Z", fill: "black" })));
};
/* eslint-enable max-len */

/* eslint-disable max-len */
const WaterPictogram = (props) => {
    const { title = 'Water Pictogram', ...restProps } = props;
    return (React$2.createElement(Pictogram, { title: title, ...restProps },
        React$2.createElement("path", { d: "M25.5 9.6318C21.3888 3.99299 17.5 0 17.5 0C17.5 0 0 17.969 0 31.5C0 40.031 7.96902 48 17.5 48C27.031 48 35 40.031 35 31.5C35 27.0478 33.1053 22.115 30.5628 17.5", stroke: "black", strokeWidth: "3" }),
        React$2.createElement("path", { d: "M30.5628 17.5C33.1053 22.115 35 27.0478 35 31.5C35 36.276 32.5023 40.876 28.6311 44", stroke: "#FF5B4A", strokeWidth: "3" }),
        React$2.createElement("path", { d: "M35 31.5C35 27.0478 33.1053 22.115 30.5627 17.5", stroke: "#7E3BFF", strokeWidth: "3" }),
        React$2.createElement("path", { d: "M17.5 41.5C11.5091 41.5 6.5 36.3533 6.5 30.8438", stroke: "black", strokeWidth: "3" })));
};
/* eslint-enable max-len */

var img$a = "data:image/svg+xml,%3csvg width='18' height='19' viewBox='0 0 18 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5 9C4.44772 9 4 9.44772 4 10C4 10.5523 4.44772 11 5 11C5.55228 11 6 10.5523 6 10C6 9.44772 5.55228 9 5 9Z' fill='black'/%3e%3cpath d='M4 14C4 13.4477 4.44772 13 5 13C5.55228 13 6 13.4477 6 14C6 14.5523 5.55228 15 5 15C4.44772 15 4 14.5523 4 14Z' fill='black'/%3e%3cpath d='M9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11C9.55228 11 10 10.5523 10 10C10 9.44772 9.55228 9 9 9Z' fill='black'/%3e%3cpath d='M8 14C8 13.4477 8.44772 13 9 13C9.55228 13 10 13.4477 10 14C10 14.5523 9.55228 15 9 15C8.44772 15 8 14.5523 8 14Z' fill='black'/%3e%3cpath d='M13 9C12.4477 9 12 9.44772 12 10C12 10.5523 12.4477 11 13 11C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9Z' fill='black'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M5 0C5.55228 0 6 0.447715 6 1H12C12 0.447715 12.4477 0 13 0C13.5523 0 14 0.447715 14 1H16C17.1046 1 18 1.89543 18 3V17C18 18.1046 17.1046 19 16 19H2C0.895431 19 0 18.1046 0 17V3C0 1.89543 0.895431 1 2 1H4C4 0.447715 4.44772 0 5 0ZM12 3C12 3.55228 12.4477 4 13 4C13.5523 4 14 3.55228 14 3H16V5H2V3H4C4 3.55228 4.44772 4 5 4C5.55228 4 6 3.55228 6 3H12ZM2 7H16V17H2V7Z' fill='black'/%3e%3c/svg%3e";

const CalendarIcon = () => (React__default.createElement("img", { alt: "CalendarIcon Icon", src: img$a }));

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// flowlint-next-line unclear-type:off
function omitDollarPrefixedKeys(source) {
  var result = {};

  for (var key in source) {
    if (key[0] !== '$') {
      result[key] = source[key];
    }
  }

  return result;
}

function _extends$1l() { _extends$1l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1l.apply(this, arguments); }

function ownKeys$14(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$14(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$14(Object(source), true).forEach(function (key) { _defineProperty$1v(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$14(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1v(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$18(arr, i) { return _arrayWithHoles$18(arr) || _iterableToArrayLimit$18(arr, i) || _unsupportedIterableToArray$1a(arr, i) || _nonIterableRest$18(); }

function _nonIterableRest$18() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1a(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1a(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1a(o, minLen); }

function _arrayLikeToArray$1a(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$18(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$18(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties$R(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$T(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$T(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Icon(props, ref) {
  var children = props.children,
      title = props.title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties$R(props, ["children", "title", "size", "color", "overrides"]);

  var _getOverrides = getOverrides(overrides.Svg, Svg$1),
      _getOverrides2 = _slicedToArray$18(_getOverrides, 2),
      Svg = _getOverrides2[0],
      overrideProps = _getOverrides2[1]; // Determine how/which props are passed based on if the component is a Styletron component.
  // $FlowFixMe: __STYLETRON__ not in React.AbstractcomponentStatics


  var passThroughProps = Svg.__STYLETRON__ ? _objectSpread$14(_objectSpread$14({
    title: title,
    $color: color,
    $size: size
  }, restProps), overrideProps) : _objectSpread$14(_objectSpread$14({
    title: title,
    color: color,
    size: size
  }, omitDollarPrefixedKeys(restProps)), omitDollarPrefixedKeys(overrideProps));
  return /*#__PURE__*/React$2.createElement(Svg, _extends$1l({
    "data-baseweb": "icon",
    ref: ref
  }, passThroughProps), title ? /*#__PURE__*/React$2.createElement("title", null, title) : null, children);
}

var Icon$1 = /*#__PURE__*/React$2.forwardRef(Icon);

function _extends$1k() { _extends$1k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1k.apply(this, arguments); }

function _objectWithoutProperties$Q(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$S(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$S(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$17(arr, i) { return _arrayWithHoles$17(arr) || _iterableToArrayLimit$17(arr, i) || _unsupportedIterableToArray$19(arr, i) || _nonIterableRest$17(); }

function _nonIterableRest$17() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$19(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$19(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$19(o, minLen); }

function _arrayLikeToArray$19(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$17(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$17(arr) { if (Array.isArray(arr)) return arr; }

function ArrowLeft(props, ref) {
  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$17(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _props$title = props.title,
      title = _props$title === void 0 ? 'Arrow Left' : _props$title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties$Q(props, ["title", "size", "color", "overrides"]);

  var SvgOverride = mergeOverride( // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.ArrowLeft ? theme.icons.ArrowLeft : null
  }, overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {});
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Icon$1, _extends$1k({
      viewBox: "0 0 24 24",
      ref: ref,
      title: title,
      size: size,
      color: color,
      overrides: {
        Svg: SvgOverride
      }
    }, restProps), /*#__PURE__*/React$2.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.29289 11.2929C5.90237 11.6834 5.90237 12.3166 6.29289 12.7071L10.2929 16.7071C10.6834 17.0976 11.3166 17.0976 11.7071 16.7071C12.0976 16.3166 12.0976 15.6834 11.7071 15.2929L9.41421 13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11H9.41421L11.7071 8.70711C12.0976 8.31658 12.0976 7.68342 11.7071 7.29289C11.3166 6.90237 10.6834 6.90237 10.2929 7.29289L6.29289 11.2929Z"
    }))
  );
}

var arrowLeft = /*#__PURE__*/React$2.forwardRef(ArrowLeft);

function _extends$1j() { _extends$1j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1j.apply(this, arguments); }

function _objectWithoutProperties$P(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$R(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$R(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$16(arr, i) { return _arrayWithHoles$16(arr) || _iterableToArrayLimit$16(arr, i) || _unsupportedIterableToArray$18(arr, i) || _nonIterableRest$16(); }

function _nonIterableRest$16() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$18(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$18(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$18(o, minLen); }

function _arrayLikeToArray$18(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$16(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$16(arr) { if (Array.isArray(arr)) return arr; }

function ArrowRight(props, ref) {
  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$16(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _props$title = props.title,
      title = _props$title === void 0 ? 'Arrow Right' : _props$title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties$P(props, ["title", "size", "color", "overrides"]);

  var SvgOverride = mergeOverride( // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.ArrowRight ? theme.icons.ArrowRight : null
  }, overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {});
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Icon$1, _extends$1j({
      viewBox: "0 0 24 24",
      ref: ref,
      title: title,
      size: size,
      color: color,
      overrides: {
        Svg: SvgOverride
      }
    }, restProps), /*#__PURE__*/React$2.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 12C6 12.5523 6.44772 13 7 13H14.5858L12.2929 15.2929C11.9024 15.6834 11.9024 16.3166 12.2929 16.7071C12.6834 17.0976 13.3166 17.0976 13.7071 16.7071L17.7071 12.7071C17.8946 12.5196 18 12.2652 18 12C18 11.7348 17.8946 11.4804 17.7071 11.2929L13.7071 7.29289C13.3166 6.90237 12.6834 6.90237 12.2929 7.29289C11.9024 7.68342 11.9024 8.31658 12.2929 8.70711L14.5858 11H7C6.44772 11 6 11.4477 6 12Z"
    }))
  );
}

var arrowRight = /*#__PURE__*/React$2.forwardRef(ArrowRight);

function _extends$1i() { _extends$1i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }

function _objectWithoutProperties$O(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$Q(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$Q(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$15(arr, i) { return _arrayWithHoles$15(arr) || _iterableToArrayLimit$15(arr, i) || _unsupportedIterableToArray$17(arr, i) || _nonIterableRest$15(); }

function _nonIterableRest$15() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$17(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$17(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$17(o, minLen); }

function _arrayLikeToArray$17(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$15(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$15(arr) { if (Array.isArray(arr)) return arr; }

function ChevronDown$1(props, ref) {
  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$15(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _props$title = props.title,
      title = _props$title === void 0 ? 'Down' : _props$title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties$O(props, ["title", "size", "color", "overrides"]);

  var SvgOverride = mergeOverride( // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.ChevronDown ? theme.icons.ChevronDown : null
  }, overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {});
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Icon$1, _extends$1i({
      viewBox: "0 0 24 24",
      ref: ref,
      title: title,
      size: size,
      color: color,
      overrides: {
        Svg: SvgOverride
      }
    }, restProps), /*#__PURE__*/React$2.createElement("path", {
      transform: "rotate(270, 12, 12)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 12C9 12.2652 9.10536 12.5196 9.29289 12.7071L13.2929 16.7071C13.6834 17.0976 14.3166 17.0976 14.7071 16.7071C15.0976 16.3166 15.0976 15.6834 14.7071 15.2929L11.4142 12L14.7071 8.70711C15.0976 8.31658 15.0976 7.68342 14.7071 7.29289C14.3166 6.90237 13.6834 6.90237 13.2929 7.29289L9.29289 11.2929C9.10536 11.4804 9 11.7348 9 12Z"
    }))
  );
}

var ChevronDown$2 = /*#__PURE__*/React$2.forwardRef(ChevronDown$1);

function _extends$1h() { _extends$1h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }

function _objectWithoutProperties$N(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$P(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$P(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$14(arr, i) { return _arrayWithHoles$14(arr) || _iterableToArrayLimit$14(arr, i) || _unsupportedIterableToArray$16(arr, i) || _nonIterableRest$14(); }

function _nonIterableRest$14() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$16(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$16(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$16(o, minLen); }

function _arrayLikeToArray$16(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$14(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$14(arr) { if (Array.isArray(arr)) return arr; }

function ChevronLeft$1(props, ref) {
  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$14(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _props$title = props.title,
      title = _props$title === void 0 ? 'Left' : _props$title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties$N(props, ["title", "size", "color", "overrides"]);

  var SvgOverride = mergeOverride( // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.ChevronLeft ? theme.icons.ChevronLeft : null
  }, overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {});
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Icon$1, _extends$1h({
      viewBox: "0 0 24 24",
      ref: ref,
      title: title,
      size: size,
      color: color,
      overrides: {
        Svg: SvgOverride
      }
    }, restProps), /*#__PURE__*/React$2.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 12C9 12.2652 9.10536 12.5196 9.29289 12.7071L13.2929 16.7071C13.6834 17.0976 14.3166 17.0976 14.7071 16.7071C15.0976 16.3166 15.0976 15.6834 14.7071 15.2929L11.4142 12L14.7071 8.70711C15.0976 8.31658 15.0976 7.68342 14.7071 7.29289C14.3166 6.90237 13.6834 6.90237 13.2929 7.29289L9.29289 11.2929C9.10536 11.4804 9 11.7348 9 12Z"
    }))
  );
}

var ChevronLeft$2 = /*#__PURE__*/React$2.forwardRef(ChevronLeft$1);

function _extends$1g() { _extends$1g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }

function _objectWithoutProperties$M(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$O(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$O(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$13(arr, i) { return _arrayWithHoles$13(arr) || _iterableToArrayLimit$13(arr, i) || _unsupportedIterableToArray$15(arr, i) || _nonIterableRest$13(); }

function _nonIterableRest$13() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$15(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$15(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$15(o, minLen); }

function _arrayLikeToArray$15(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$13(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$13(arr) { if (Array.isArray(arr)) return arr; }

function ChevronRight$1(props, ref) {
  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$13(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _props$title = props.title,
      title = _props$title === void 0 ? 'Right' : _props$title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties$M(props, ["title", "size", "color", "overrides"]);

  var SvgOverride = mergeOverride( // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.ChevronRight ? theme.icons.ChevronRight : null
  }, overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {});
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Icon$1, _extends$1g({
      viewBox: "0 0 24 24",
      ref: ref,
      title: title,
      size: size,
      color: color,
      overrides: {
        Svg: SvgOverride
      }
    }, restProps), /*#__PURE__*/React$2.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.29289 7.29289C8.90237 7.68342 8.90237 8.31658 9.29289 8.70711L12.5858 12L9.29289 15.2929C8.90237 15.6834 8.90237 16.3166 9.29289 16.7071C9.68342 17.0976 10.3166 17.0976 10.7071 16.7071L14.7071 12.7071C14.8946 12.5196 15 12.2652 15 12C15 11.7348 14.8946 11.4804 14.7071 11.2929L10.7071 7.29289C10.3166 6.90237 9.68342 6.90237 9.29289 7.29289Z"
    }))
  );
}

var ChevronRight$2 = /*#__PURE__*/React$2.forwardRef(ChevronRight$1);

function _extends$1f() { _extends$1f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }

function _objectWithoutProperties$L(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$N(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$N(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$12(arr, i) { return _arrayWithHoles$12(arr) || _iterableToArrayLimit$12(arr, i) || _unsupportedIterableToArray$14(arr, i) || _nonIterableRest$12(); }

function _nonIterableRest$12() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$14(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$14(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$14(o, minLen); }

function _arrayLikeToArray$14(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$12(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$12(arr) { if (Array.isArray(arr)) return arr; }

function ChevronUp$1(props, ref) {
  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$12(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _props$title = props.title,
      title = _props$title === void 0 ? 'Up' : _props$title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties$L(props, ["title", "size", "color", "overrides"]);

  var SvgOverride = mergeOverride( // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.ChevronUp ? theme.icons.ChevronUp : null
  }, overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {});
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Icon$1, _extends$1f({
      viewBox: "0 0 24 24",
      ref: ref,
      title: title,
      size: size,
      color: color,
      overrides: {
        Svg: SvgOverride
      }
    }, restProps), /*#__PURE__*/React$2.createElement("path", {
      transform: "rotate(90, 12, 12)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 12C9 12.2652 9.10536 12.5196 9.29289 12.7071L13.2929 16.7071C13.6834 17.0976 14.3166 17.0976 14.7071 16.7071C15.0976 16.3166 15.0976 15.6834 14.7071 15.2929L11.4142 12L14.7071 8.70711C15.0976 8.31658 15.0976 7.68342 14.7071 7.29289C14.3166 6.90237 13.6834 6.90237 13.2929 7.29289L9.29289 11.2929C9.10536 11.4804 9 11.7348 9 12Z"
    }))
  );
}

var BaseChevronUp = /*#__PURE__*/React$2.forwardRef(ChevronUp$1);

function _extends$1e() { _extends$1e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }

function _objectWithoutProperties$K(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$M(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$M(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$11(arr, i) { return _arrayWithHoles$11(arr) || _iterableToArrayLimit$11(arr, i) || _unsupportedIterableToArray$13(arr, i) || _nonIterableRest$11(); }

function _nonIterableRest$11() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$13(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$13(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$13(o, minLen); }

function _arrayLikeToArray$13(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$11(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$11(arr) { if (Array.isArray(arr)) return arr; }

function DeleteAlt(props, ref) {
  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$11(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _props$title = props.title,
      title = _props$title === void 0 ? 'Delete Alt' : _props$title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties$K(props, ["title", "size", "color", "overrides"]);

  var SvgOverride = mergeOverride( // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.DeleteAlt ? theme.icons.DeleteAlt : null
  }, overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {});
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Icon$1, _extends$1e({
      viewBox: "0 0 24 24",
      ref: ref,
      title: title,
      size: size,
      color: color,
      overrides: {
        Svg: SvgOverride
      }
    }, restProps), /*#__PURE__*/React$2.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58173 16.4183 4 12 4C7.58173 4 4 7.58173 4 12C4 16.4183 7.58173 20 12 20ZM10.0303 8.96967C9.73743 8.67679 9.26257 8.67679 8.96967 8.96967C8.67676 9.26257 8.67676 9.73743 8.96967 10.0303L10.9393 12L8.96967 13.9697C8.67676 14.2626 8.67676 14.7374 8.96967 15.0303C9.26257 15.3232 9.73743 15.3232 10.0303 15.0303L12 13.0607L13.9697 15.0303C14.2626 15.3232 14.7374 15.3232 15.0303 15.0303C15.3232 14.7374 15.3232 14.2626 15.0303 13.9697L13.0607 12L15.0303 10.0303C15.3232 9.73743 15.3232 9.26257 15.0303 8.96967C14.7374 8.67679 14.2626 8.67679 13.9697 8.96967L12 10.9393L10.0303 8.96967Z"
    }))
  );
}

var DeleteAlt$1 = /*#__PURE__*/React$2.forwardRef(DeleteAlt);

function _extends$1d() { _extends$1d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }

function _objectWithoutProperties$J(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$L(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$L(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$10(arr, i) { return _arrayWithHoles$10(arr) || _iterableToArrayLimit$10(arr, i) || _unsupportedIterableToArray$12(arr, i) || _nonIterableRest$10(); }

function _nonIterableRest$10() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$12(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$12(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$12(o, minLen); }

function _arrayLikeToArray$12(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$10(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$10(arr) { if (Array.isArray(arr)) return arr; }

function Delete$1(props, ref) {
  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$10(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _props$title = props.title,
      title = _props$title === void 0 ? 'Delete' : _props$title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties$J(props, ["title", "size", "color", "overrides"]);

  var SvgOverride = mergeOverride( // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.Delete ? theme.icons.Delete : null
  }, overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {});
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Icon$1, _extends$1d({
      viewBox: "0 0 24 24",
      ref: ref,
      title: title,
      size: size,
      color: color,
      overrides: {
        Svg: SvgOverride
      }
    }, restProps), /*#__PURE__*/React$2.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.29289 7.29289C7.68342 6.90237 8.31658 6.90237 8.70711 7.29289L12 10.5858L15.2929 7.29289C15.6834 6.90237 16.3166 6.90237 16.7071 7.29289C17.0976 7.68342 17.0976 8.31658 16.7071 8.70711L13.4142 12L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L12 13.4142L8.70711 16.7071C8.31658 17.0976 7.68342 17.0976 7.29289 16.7071C6.90237 16.3166 6.90237 15.6834 7.29289 15.2929L10.5858 12L7.29289 8.70711C6.90237 8.31658 6.90237 7.68342 7.29289 7.29289Z"
    }))
  );
}

var DeleteIcon = /*#__PURE__*/React$2.forwardRef(Delete$1);

function _extends$1c() { _extends$1c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }

function _objectWithoutProperties$I(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$K(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$K(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$$(arr, i) { return _arrayWithHoles$$(arr) || _iterableToArrayLimit$$(arr, i) || _unsupportedIterableToArray$11(arr, i) || _nonIterableRest$$(); }

function _nonIterableRest$$() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$11(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$11(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$11(o, minLen); }

function _arrayLikeToArray$11(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$$(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$$(arr) { if (Array.isArray(arr)) return arr; }

function Grab(props, ref) {
  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$$(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _props$title = props.title,
      title = _props$title === void 0 ? 'Grab' : _props$title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties$I(props, ["title", "size", "color", "overrides"]);

  var SvgOverride = mergeOverride( // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.Grab ? theme.icons.Grab : null
  }, overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {});
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Icon$1, _extends$1c({
      viewBox: "0 0 24 24",
      ref: ref,
      title: title,
      size: size,
      color: color,
      overrides: {
        Svg: SvgOverride
      }
    }, restProps), /*#__PURE__*/React$2.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 8C4.44775 8 4 8.44775 4 9C4 9.55225 4.44775 10 5 10H19C19.5522 10 20 9.55225 20 9C20 8.44775 19.5522 8 19 8H5ZM5 14C4.44775 14 4 14.4478 4 15C4 15.5522 4.44775 16 5 16H19C19.5522 16 20 15.5522 20 15C20 14.4478 19.5522 14 19 14H5Z"
    }))
  );
}

var Grab$1 = /*#__PURE__*/React$2.forwardRef(Grab);

function _extends$1b() { _extends$1b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }

function _objectWithoutProperties$H(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$J(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$J(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$_(arr, i) { return _arrayWithHoles$_(arr) || _iterableToArrayLimit$_(arr, i) || _unsupportedIterableToArray$10(arr, i) || _nonIterableRest$_(); }

function _nonIterableRest$_() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$10(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$10(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$10(o, minLen); }

function _arrayLikeToArray$10(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$_(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$_(arr) { if (Array.isArray(arr)) return arr; }

function Hide(props, ref) {
  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$_(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _props$title = props.title,
      title = _props$title === void 0 ? 'Hide' : _props$title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties$H(props, ["title", "size", "color", "overrides"]);

  var SvgOverride = mergeOverride( // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.Hide ? theme.icons.Hide : null
  }, overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {});
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Icon$1, _extends$1b({
      viewBox: "0 0 20 20",
      ref: ref,
      title: title,
      size: size,
      color: color,
      overrides: {
        Svg: SvgOverride
      }
    }, restProps), /*#__PURE__*/React$2.createElement("path", {
      d: "M12.81 4.36l-1.77 1.78a4 4 0 00-4.9 4.9l-2.76 2.75C2.06 12.79.96 11.49.2 10a11 11 0 0112.6-5.64zm3.8 1.85c1.33 1 2.43 2.3 3.2 3.79a11 11 0 01-12.62 5.64l1.77-1.78a4 4 0 004.9-4.9l2.76-2.75zm-.25-3.99l1.42 1.42L3.64 17.78l-1.42-1.42L16.36 2.22z"
    }))
  );
}

var Hide$1 = /*#__PURE__*/React$2.forwardRef(Hide);

function _extends$1a() { _extends$1a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }

function _objectWithoutProperties$G(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$I(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$I(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$Z(arr, i) { return _arrayWithHoles$Z(arr) || _iterableToArrayLimit$Z(arr, i) || _unsupportedIterableToArray$$(arr, i) || _nonIterableRest$Z(); }

function _nonIterableRest$Z() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$$(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$$(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$$(o, minLen); }

function _arrayLikeToArray$$(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$Z(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$Z(arr) { if (Array.isArray(arr)) return arr; }

function Overflow$1(props, ref) {
  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$Z(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _props$title = props.title,
      title = _props$title === void 0 ? 'Overflow' : _props$title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties$G(props, ["title", "size", "color", "overrides"]);

  var SvgOverride = mergeOverride( // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.Overflow ? theme.icons.Overflow : null
  }, overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {});
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Icon$1, _extends$1a({
      viewBox: "0 0 24 24",
      ref: ref,
      title: title,
      size: size,
      color: color,
      overrides: {
        Svg: SvgOverride
      }
    }, restProps), /*#__PURE__*/React$2.createElement("circle", {
      cx: "6",
      cy: "12",
      r: "2"
    }), /*#__PURE__*/React$2.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "2"
    }), /*#__PURE__*/React$2.createElement("circle", {
      cx: "18",
      cy: "12",
      r: "2"
    }))
  );
}

var BaseOverflow = /*#__PURE__*/React$2.forwardRef(Overflow$1);

function _extends$19() { _extends$19 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }

function _objectWithoutProperties$F(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$H(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$H(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$Y(arr, i) { return _arrayWithHoles$Y(arr) || _iterableToArrayLimit$Y(arr, i) || _unsupportedIterableToArray$_(arr, i) || _nonIterableRest$Y(); }

function _nonIterableRest$Y() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$_(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$_(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$_(o, minLen); }

function _arrayLikeToArray$_(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$Y(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$Y(arr) { if (Array.isArray(arr)) return arr; }

function Plus$1(props, ref) {
  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$Y(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _props$title = props.title,
      title = _props$title === void 0 ? 'Plus' : _props$title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties$F(props, ["title", "size", "color", "overrides"]);

  var SvgOverride = mergeOverride( // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.Plus ? theme.icons.Plus : null
  }, overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {});
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Icon$1, _extends$19({
      viewBox: "0 0 24 24",
      ref: ref,
      title: title,
      size: size,
      color: color,
      overrides: {
        Svg: SvgOverride
      }
    }, restProps), /*#__PURE__*/React$2.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 5C12.5523 5 13 5.44772 13 6V11L18 11C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13L13 13V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V13L6 13C5.44772 13 5 12.5523 5 12C5 11.4477 5.44771 11 6 11L11 11V6C11 5.44772 11.4477 5 12 5Z"
    }))
  );
}

var BasePlus = /*#__PURE__*/React$2.forwardRef(Plus$1);

function _extends$18() { _extends$18 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }

function _objectWithoutProperties$E(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$G(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$G(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$X(arr, i) { return _arrayWithHoles$X(arr) || _iterableToArrayLimit$X(arr, i) || _unsupportedIterableToArray$Z(arr, i) || _nonIterableRest$X(); }

function _nonIterableRest$X() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$Z(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$Z(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$Z(o, minLen); }

function _arrayLikeToArray$Z(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$X(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$X(arr) { if (Array.isArray(arr)) return arr; }

function Search$1(props, ref) {
  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$X(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _props$title = props.title,
      title = _props$title === void 0 ? 'Search' : _props$title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties$E(props, ["title", "size", "color", "overrides"]);

  var SvgOverride = mergeOverride( // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.Search ? theme.icons.Search : null
  }, overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {});
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Icon$1, _extends$18({
      viewBox: "0 0 24 24",
      ref: ref,
      title: title,
      size: size,
      color: color,
      overrides: {
        Svg: SvgOverride
      }
    }, restProps), /*#__PURE__*/React$2.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 6C8.79086 6 7 7.79086 7 10C7 12.2091 8.79086 14 11 14C13.2091 14 15 12.2091 15 10C15 7.79086 13.2091 6 11 6ZM5 10C5 6.68629 7.68629 4 11 4C14.3137 4 17 6.68629 17 10C17 11.2958 16.5892 12.4957 15.8907 13.4765L19.7071 17.2929C20.0976 17.6834 20.0976 18.3166 19.7071 18.7071C19.3166 19.0976 18.6834 19.0976 18.2929 18.7071L14.4765 14.8907C13.4957 15.5892 12.2958 16 11 16C7.68629 16 5 13.3137 5 10Z"
    }))
  );
}

var SearchIconComponent = /*#__PURE__*/React$2.forwardRef(Search$1);

function _extends$17() { _extends$17 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }

function _objectWithoutProperties$D(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$F(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$F(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$W(arr, i) { return _arrayWithHoles$W(arr) || _iterableToArrayLimit$W(arr, i) || _unsupportedIterableToArray$Y(arr, i) || _nonIterableRest$W(); }

function _nonIterableRest$W() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$Y(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$Y(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$Y(o, minLen); }

function _arrayLikeToArray$Y(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$W(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$W(arr) { if (Array.isArray(arr)) return arr; }

function Show$1(props, ref) {
  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$W(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _props$title = props.title,
      title = _props$title === void 0 ? 'Show' : _props$title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties$D(props, ["title", "size", "color", "overrides"]);

  var SvgOverride = mergeOverride( // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.Show ? theme.icons.Show : null
  }, overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {});
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Icon$1, _extends$17({
      viewBox: "0 0 20 20",
      ref: ref,
      title: title,
      size: size,
      color: color,
      overrides: {
        Svg: SvgOverride
      }
    }, restProps), /*#__PURE__*/React$2.createElement("path", {
      d: "M.2 10a11 11 0 0119.6 0A11 11 0 01.2 10zm9.8 4a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 110-4 2 2 0 010 4z"
    }))
  );
}

var Show$2 = /*#__PURE__*/React$2.forwardRef(Show$1);

function _extends$16() { _extends$16 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }

function _objectWithoutProperties$C(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$E(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$E(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$V(arr, i) { return _arrayWithHoles$V(arr) || _iterableToArrayLimit$V(arr, i) || _unsupportedIterableToArray$X(arr, i) || _nonIterableRest$V(); }

function _nonIterableRest$V() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$X(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$X(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$X(o, minLen); }

function _arrayLikeToArray$X(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$V(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$V(arr) { if (Array.isArray(arr)) return arr; }

function TriangleDown(props, ref) {
  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$V(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _props$title = props.title,
      title = _props$title === void 0 ? 'Triangle Down' : _props$title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties$C(props, ["title", "size", "color", "overrides"]);

  var SvgOverride = mergeOverride( // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.TriangleDown ? theme.icons.TriangleDown : null
  }, overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {});
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Icon$1, _extends$16({
      viewBox: "0 0 24 24",
      ref: ref,
      title: title,
      size: size,
      color: color,
      overrides: {
        Svg: SvgOverride
      }
    }, restProps), /*#__PURE__*/React$2.createElement("path", {
      d: "M12.7071 15.2929L17.1464 10.8536C17.4614 10.5386 17.2383 10 16.7929 10L7.20711 10C6.76165 10 6.53857 10.5386 6.85355 10.8536L11.2929 15.2929C11.6834 15.6834 12.3166 15.6834 12.7071 15.2929Z"
    }))
  );
}

var TriangleDown$1 = /*#__PURE__*/React$2.forwardRef(TriangleDown);

function _extends$15() { _extends$15 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }

function _objectWithoutProperties$B(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$D(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$D(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$U(arr, i) { return _arrayWithHoles$U(arr) || _iterableToArrayLimit$U(arr, i) || _unsupportedIterableToArray$W(arr, i) || _nonIterableRest$U(); }

function _nonIterableRest$U() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$W(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$W(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$W(o, minLen); }

function _arrayLikeToArray$W(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$U(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$U(arr) { if (Array.isArray(arr)) return arr; }

function TriangleLeft(props, ref) {
  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$U(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _props$title = props.title,
      title = _props$title === void 0 ? 'Triangle Left' : _props$title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties$B(props, ["title", "size", "color", "overrides"]);

  var SvgOverride = mergeOverride( // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.TriangleLeft ? theme.icons.TriangleLeft : null
  }, overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {});
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Icon$1, _extends$15({
      viewBox: "0 0 24 24",
      ref: ref,
      title: title,
      size: size,
      color: color,
      overrides: {
        Svg: SvgOverride
      }
    }, restProps), /*#__PURE__*/React$2.createElement("path", {
      d: "M8.70711 11.2929L13.1464 6.85355C13.4614 6.53857 14 6.76165 14 7.20711L14 16.7929C14 17.2383 13.4614 17.4614 13.1464 17.1464L8.70711 12.7071C8.31658 12.3166 8.31658 11.6834 8.70711 11.2929Z"
    }))
  );
}

var triangleLeft = /*#__PURE__*/React$2.forwardRef(TriangleLeft);

function _extends$14() { _extends$14 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }

function _objectWithoutProperties$A(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$C(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$C(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$T(arr, i) { return _arrayWithHoles$T(arr) || _iterableToArrayLimit$T(arr, i) || _unsupportedIterableToArray$V(arr, i) || _nonIterableRest$T(); }

function _nonIterableRest$T() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$V(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$V(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$V(o, minLen); }

function _arrayLikeToArray$V(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$T(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$T(arr) { if (Array.isArray(arr)) return arr; }

function TriangleRight(props, ref) {
  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$T(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _props$title = props.title,
      title = _props$title === void 0 ? 'Triangle Right' : _props$title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties$A(props, ["title", "size", "color", "overrides"]);

  var SvgOverride = mergeOverride( // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.TriangleRight ? theme.icons.TriangleRight : null
  }, overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {});
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Icon$1, _extends$14({
      viewBox: "0 0 24 24",
      ref: ref,
      title: title,
      size: size,
      color: color,
      overrides: {
        Svg: SvgOverride
      }
    }, restProps), /*#__PURE__*/React$2.createElement("path", {
      d: "M15.2929 11.2929L10.8536 6.85355C10.5386 6.53857 10 6.76165 10 7.20711L10 16.7929C10 17.2383 10.5386 17.4614 10.8536 17.1464L15.2929 12.7071C15.6834 12.3166 15.6834 11.6834 15.2929 11.2929Z"
    }))
  );
}

var triangleRight = /*#__PURE__*/React$2.forwardRef(TriangleRight);

function _extends$13() { _extends$13 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }

function _objectWithoutProperties$z(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$B(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$B(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$S(arr, i) { return _arrayWithHoles$S(arr) || _iterableToArrayLimit$S(arr, i) || _unsupportedIterableToArray$U(arr, i) || _nonIterableRest$S(); }

function _nonIterableRest$S() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$U(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$U(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$U(o, minLen); }

function _arrayLikeToArray$U(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$S(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$S(arr) { if (Array.isArray(arr)) return arr; }

function TriangleUp(props, ref) {
  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$S(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _props$title = props.title,
      title = _props$title === void 0 ? 'Triangle Up' : _props$title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties$z(props, ["title", "size", "color", "overrides"]);

  var SvgOverride = mergeOverride( // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.TriangleUp ? theme.icons.TriangleUp : null
  }, overrides && overrides.Svg ? toObjectOverride(overrides.Svg) : {});
  return (
    /*#__PURE__*/
    // $FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(Icon$1, _extends$13({
      viewBox: "0 0 24 24",
      ref: ref,
      title: title,
      size: size,
      color: color,
      overrides: {
        Svg: SvgOverride
      }
    }, restProps), /*#__PURE__*/React$2.createElement("path", {
      d: "M12.7071 8.70711L17.1464 13.1464C17.4614 13.4614 17.2383 14 16.7929 14L7.20711 14C6.76165 14 6.53857 13.4614 6.85355 13.1464L11.2929 8.70711C11.6834 8.31658 12.3166 8.31658 12.7071 8.70711Z"
    }))
  );
}

var TriangleUp$1 = /*#__PURE__*/React$2.forwardRef(TriangleUp);

const ChevronDown = (props) => (React$2.createElement(ChevronDown$2, { ...props }));

const ChevronLeft = (props) => (React$2.createElement(ChevronLeft$2, { ...props }));

const ChevronRight = (props) => (React$2.createElement(ChevronRight$2, { ...props }));

const ChevronUp = (props) => (React$2.createElement(BaseChevronUp, { ...props }));

const Close$1 = (props) => {
    const { color } = props;
    return (React$2.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: color, xmlns: "http://www.w3.org/2000/svg", ...props },
        React$2.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z" }),
        React$2.createElement("path", { d: "M14.1213 8.46449C14.5118 8.07396 15.145 8.07396 15.5355 8.46449C15.9261 8.85501 15.9261 9.48818 15.5355 9.8787L13.4142 12L15.5355 14.1213C15.9261 14.5119 15.9261 15.145 15.5355 15.5356C15.145 15.9261 14.5118 15.9261 14.1213 15.5356L12 13.4142L9.87868 15.5356C9.48816 15.9261 8.85499 15.9261 8.46447 15.5356C8.07394 15.145 8.07394 14.5119 8.46447 14.1213L10.5858 12L8.46447 9.8787C8.07394 9.48818 8.07394 8.85501 8.46447 8.46449C8.85499 8.07396 9.48816 8.07396 9.87868 8.46449L12 10.5858L14.1213 8.46449Z" })));
};

var img$9 = "data:image/svg+xml,%3csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M2.31669 9.42519C1.89563 9.42566 1.55468 9.0847 1.55514 8.66364C1.5556 8.24259 1.89731 7.90088 2.31837 7.90042L6.83476 7.89544L0.746898 1.80758C0.433083 1.49377 0.416123 1.00193 0.709016 0.709039C1.00191 0.416146 1.49374 0.433106 1.80756 0.74692L7.89542 6.83478L7.90039 2.31839C7.90086 1.89733 8.24256 1.55563 8.66362 1.55516C9.08467 1.5547 9.42563 1.89565 9.42517 2.31671L9.41819 8.65498C9.41773 9.07604 9.07602 9.41775 8.65496 9.41821L2.31669 9.42519Z' fill='black'/%3e%3c/svg%3e";

const CollapseIcon = (props) => (React__default.createElement("img", { alt: "Collapse Icon", src: img$9, ...props }));

const Delete = (props) => (React$2.createElement(DeleteIcon, { ...props }));

var img$8 = "data:image/svg+xml,%3csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M6.14286 6.14286L1 1M1 1V6M1 1H6M8.71429 1H12.25C12.6642 1 13 1.33579 13 1.75L13 12.25C13 12.6642 12.6642 13 12.25 13L1.75 13C1.33579 13 1 12.6642 1 12.25V10' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e";

const ExpandIcon = () => (React__default.createElement("img", { alt: "Expand Icon", src: img$8 }));

const Filter = (props) => {
    const { color } = props;
    return (React__default.createElement("svg", { stroke: color, width: "15", height: "16", viewBox: "0 0 15 16", fill: color, xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { d: "M14.8756 0.842075C14.7695 0.598213 14.5257 0.428571 14.25 0.428571H0.678571C0.402902 0.428571 0.15904 0.598213 0.0530134 0.842075C-0.0530134 1.09654 0 1.39341 0.201451 1.58426L5.42857 6.81138V11.9643C5.42857 12.1445 5.50279 12.3142 5.63002 12.4414L8.34431 15.1557C8.47154 15.2935 8.64118 15.3571 8.82143 15.3571C8.90625 15.3571 9.00167 15.3359 9.0865 15.3041C9.33036 15.1981 9.5 14.9542 9.5 14.6786V6.81138L14.7271 1.58426C14.9286 1.39341 14.9816 1.09654 14.8756 0.842075Z", fill: color })));
};

const Globe = (props) => {
    const { color } = props;
    /* eslint-disable */
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("svg", { width: "17", height: "17", viewBox: "0 0 17 17", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M8.14286 0.0714278C3.64732 0.0714278 0 3.71875 0 8.21429C0 12.7098 3.64732 16.3571 8.14286 16.3571C12.6384 16.3571 16.2857 12.7098 16.2857 8.21429C16.2857 3.71875 12.6384 0.0714278 8.14286 0.0714278ZM11.048 5.59542C11.1646 5.5212 11.3555 5.42578 11.5039 5.46819C11.6205 5.5 11.716 5.54241 11.5781 5.63783C11.5145 5.68025 11.4191 5.63783 11.3449 5.65904C11.4403 5.68025 11.5781 5.72266 11.5357 5.81808C11.8114 5.97712 11.4509 6.16797 11.2706 6.14676C11.3555 6.15737 11.0904 6.31641 11.0904 6.3058C10.995 6.35882 10.8677 6.35882 10.7935 6.45424C10.7087 6.57087 10.8253 6.77232 10.6663 6.72991C10.6027 6.86775 10.3588 6.79353 10.2528 6.94196C10.3694 7.0692 10.1362 7.24944 10.0195 7.0904C9.91351 7.13281 9.96652 7.24944 9.86049 7.31306C9.9029 7.37667 9.91351 7.44029 9.83929 7.4827C9.86049 7.4721 9.98772 7.57812 10.0195 7.58873C9.99833 7.64174 9.95592 7.68415 9.9029 7.68415C9.95592 7.82199 9.83929 7.97042 9.74386 8.05525C9.63784 8.14007 9.39397 8.22489 9.36217 8.24609C9.17132 8.42634 9.04409 8.69141 9.38337 8.76562C9.39397 8.76562 9.39397 9.11551 9.40458 9.12612C9.42578 9.25335 9.4788 9.62444 9.25614 9.48661C9.15011 9.43359 9.0865 9.13672 9.05469 9.02009C9.02288 8.89286 9.01228 8.89286 8.92746 8.76562C8.78962 8.92466 8.76842 8.80804 8.65179 8.73382C8.53516 8.6702 8.36551 8.69141 8.3019 8.62779C8.14286 8.74442 8.02623 8.71261 7.99442 8.53237C7.95201 8.61719 8.03683 8.74442 8.02623 8.77623C7.97321 8.88225 7.87779 8.86105 7.79297 8.79743C7.65513 8.69141 7.35826 8.87165 7.19922 8.79743C7.20982 8.79743 7.25223 8.83984 7.28404 8.86105C7.25223 8.98828 7.17801 8.91406 7.1144 8.95647C7.04018 9.00949 6.97656 9.11551 6.91295 9.16853C7.05078 9.43359 6.90234 9.68806 6.91295 9.97433C6.91295 10.1864 7.05078 10.5575 7.25223 10.6741C7.34766 10.7271 7.66574 10.7483 7.76116 10.7059C7.9096 10.6423 7.88839 10.5257 7.94141 10.3984C7.99442 10.2606 8.05804 10.197 8.21708 10.1864C8.67299 10.1652 8.3231 10.5363 8.27009 10.7271C8.23828 10.865 8.22768 11.024 8.20647 11.1512C8.25949 11.1724 8.3125 11.1618 8.36551 11.1618C8.36551 11.1194 8.39732 11.0664 8.39732 11.0346C8.46094 11.1406 8.67299 11.1724 8.73661 11.0452C8.81083 11.1724 8.95926 11.2679 8.98047 11.4163C9.00167 11.5647 9.13951 11.7238 8.93806 11.7238C8.78962 11.7238 8.95926 12.0206 8.98047 12.0737C9.0971 12.2857 9.28795 12.3705 9.5 12.2645C9.5 12.3493 9.46819 12.5826 9.35156 12.6038C9.24554 12.625 9.04409 12.4023 9.0865 12.2857C9.07589 12.3281 9.04409 12.3599 9.01228 12.3811C8.90625 12.2539 8.726 12.1903 8.63058 12.0631C8.60938 12.0312 8.3231 11.5965 8.38672 11.5753C8.23828 11.639 7.94141 11.5329 7.80357 11.4587C7.58092 11.3421 7.54911 11.0346 7.27344 11.077C7.08259 11.1088 7.02958 11.183 6.80692 11.0982C6.65848 11.0452 6.53125 10.9392 6.38281 10.865C6.21317 10.7695 5.91629 10.6741 5.85268 10.4621C5.78906 10.2924 5.81027 10.091 5.71484 9.93192C5.65123 9.82589 5.46038 9.61384 5.32254 9.61384C5.44978 9.61384 5.20592 9.29576 5.17411 9.26395C5.05748 9.12612 4.63337 8.75502 4.71819 8.54297C4.7394 8.51116 4.50614 8.42634 4.46373 8.41574C4.50614 8.52176 4.51674 8.63839 4.56975 8.73382C4.62277 8.83984 4.68638 8.93527 4.75 9.04129C4.86663 9.23214 5.02567 9.4654 5.00446 9.69866C4.86663 9.74107 4.90904 9.53962 4.86663 9.4548C4.79241 9.31696 4.59096 9.31696 4.53795 9.16853C4.55915 9.15792 4.56975 9.15792 4.59096 9.14732C4.60156 8.96708 4.3365 8.81864 4.37891 8.69141C4.23047 8.57478 4.23047 8.35212 4.12444 8.20368C4.02902 8.06585 3.86998 8.00223 3.73214 7.90681C3.67913 7.875 3.29743 7.38728 3.43527 7.35547C3.22321 7.40848 3.11719 6.91016 3.149 6.78292C3.149 6.78292 3.12779 6.78292 3.12779 6.77232C3.1702 6.64509 3.09598 5.98772 3.26563 5.97712C3.149 5.98772 3.11719 5.70145 3.149 5.64844C3.1702 5.60603 3.32924 5.76507 3.33984 5.78627C3.40346 5.75446 3.46708 5.66964 3.44587 5.59542C3.41406 5.5106 3.29743 5.43638 3.22321 5.37277C3.19141 5.35156 2.7673 5.07589 2.7567 5.08649C2.79911 5.01228 2.7885 4.93806 2.72489 4.88504C2.52344 5.04408 2.62946 4.73661 2.52344 4.7048C2.48103 4.6942 2.43862 4.66239 2.39621 4.61998C3.01116 3.64453 3.86998 2.82812 4.88784 2.26618C4.95145 2.25558 5.03627 2.25558 5.12109 2.25558C5.31194 2.27679 5.41797 2.43583 5.5558 2.53125C5.57701 2.47824 5.5346 2.39341 5.50279 2.3404C5.5346 2.25558 5.66183 2.23437 5.73605 2.21317C5.83147 2.20257 5.96931 2.18136 6.05413 2.22377C5.99051 2.12835 5.91629 2.04353 5.84208 1.9587C5.83147 1.96931 5.79967 1.99051 5.78906 2.01172C5.67243 1.91629 5.44978 2.04353 5.34375 2.08594C5.25893 2.12835 5.18471 2.18136 5.09989 2.21317C5.04688 2.23437 5.01507 2.23437 4.97266 2.22377C5.29074 2.05413 5.61942 1.90569 5.96931 1.78906C6.03292 1.83147 6.09654 1.90569 6.19196 1.97991C6.12835 1.9269 6.12835 2.17076 6.14955 2.21317C6.26618 2.37221 6.52065 2.26618 6.67969 2.26618C6.66909 2.26618 7.14621 2.3298 7.05078 2.21317C7.125 2.3192 7.125 2.47824 7.22042 2.57366C7.31585 2.47824 7.17801 2.37221 7.24163 2.27679C7.26284 2.23437 7.45368 2.18136 7.5173 2.14955C7.59152 2.09654 7.46429 2.02232 7.43248 2.00112C7.32645 1.9375 6.91295 1.90569 7.1144 1.66183C7.18862 1.57701 7.45368 1.61942 7.5385 1.67243C7.65513 1.73605 7.78237 1.85268 7.62333 1.9587C7.69754 1.96931 8.04743 2.06473 7.99442 2.20257C8.02623 2.13895 8.07924 2.04353 8.16406 2.04353C8.25949 2.05413 8.28069 2.27679 8.3231 2.3298C8.47154 2.59487 8.726 2.06473 8.76842 2.08594C8.57757 2.01172 8.93806 1.91629 9.03348 1.9481C9.1077 1.97991 9.22433 2.23437 9.0865 2.22377C9.20313 2.3298 9.21373 2.56306 9.00167 2.55245C8.85324 2.54185 8.68359 2.3404 8.54576 2.49944C8.45034 2.60547 8.40792 2.76451 8.3125 2.85993C8.16406 3.00837 7.96261 2.99777 7.78237 2.97656C7.85659 2.98716 7.62333 3.23103 7.60212 3.27344C7.5385 3.34766 7.49609 3.43248 7.47489 3.5173C7.45368 3.62333 7.47489 3.73995 7.42188 3.84598C7.60212 3.79297 7.69754 4.12165 7.62333 4.13225C7.84598 4.10045 8.02623 4.10045 8.23828 4.17466C8.38672 4.22768 8.60938 4.29129 8.67299 4.45033C8.7154 4.38672 8.91685 4.41853 8.98047 4.43973C9.1077 4.50335 9.1183 4.64118 9.15011 4.75781C9.19252 4.91685 9.33036 5.18192 9.5106 5.0971C9.54241 5.07589 9.77567 4.96987 9.69085 4.90625C9.60603 4.83203 9.5106 4.64118 9.59542 4.53516C9.68025 4.41853 9.8817 4.38672 9.93471 4.23828C10.0195 3.99442 9.68025 4.02623 9.68025 3.84598C9.68025 3.73995 9.81808 3.70815 9.80748 3.58091C9.80748 3.47489 9.64844 3.26283 9.77567 3.18862C9.8817 3.125 10.3906 3.23103 10.486 3.29464C10.5815 3.35826 10.8783 3.44308 10.8996 3.5385C10.8783 3.5385 10.8677 3.5385 10.8465 3.5385C10.9314 3.61272 11.0056 3.77176 10.8571 3.81417C10.9526 3.79297 11.2282 3.89899 11.0374 3.96261C11.101 3.9308 11.154 3.95201 11.2176 3.9096C11.2919 3.86719 11.3343 3.79297 11.4297 3.84598C11.4509 3.85658 11.5675 3.62333 11.6311 3.63393C11.7266 3.64453 11.7478 3.78237 11.7902 3.84598C11.8326 3.94141 11.9492 3.97321 11.9916 4.06864C12.0658 4.24888 12.034 4.41853 12.2779 4.48214C12.3521 4.50335 12.5536 4.38672 12.543 4.54576C12.5854 4.50335 12.6066 4.47154 12.6066 4.46094C12.6172 4.60938 12.6808 4.77902 12.861 4.75781C12.861 4.75781 12.861 4.95926 12.8398 4.99107C12.7762 5.08649 12.6172 5.06529 12.5218 5.1183C12.49 5.12891 12.2355 5.35156 12.2673 5.38337C12.1295 5.22433 11.9068 5.22433 11.7266 5.26674C11.5357 5.29855 11.3555 5.31975 11.1752 5.39397C11.0904 5.43638 11.0056 5.47879 10.942 5.55301C10.9102 5.59542 10.8571 5.78627 10.8041 5.79687C10.9102 5.77567 10.9632 5.65904 11.048 5.59542ZM9.31975 14.894C9.30915 14.841 9.29855 14.7349 9.29855 14.7243C9.28795 14.5547 9.46819 14.4381 9.45759 14.279C9.34096 14.2472 9.30915 14.1306 9.33036 14.0033C9.35156 13.8231 9.5106 13.6959 9.63784 13.5792C9.76507 13.4626 9.79688 13.2187 9.76507 13.0703C9.71205 12.8158 9.71205 12.5508 9.66964 12.2963C9.68025 12.3599 9.86049 12.3387 9.8923 12.4235C9.93471 12.3493 9.95592 12.2539 10.0089 12.1797C10.0513 12.1161 10.1256 12.0949 10.1892 12.0419C10.2952 11.9782 10.5179 11.7344 10.6451 11.8828C10.7511 12.01 10.486 12.1479 10.6239 12.2645C10.6663 12.1797 10.6239 12.0525 10.7087 11.9676C10.8783 11.7768 10.995 11.9888 11.1646 12.0419C11.3449 12.0949 11.4085 12.1585 11.5463 12.2751C11.5039 12.2327 11.716 12.1585 11.7372 12.1479C11.9386 12.1055 12.0234 12.2221 12.1613 12.3281C12.3097 12.4342 12.543 12.5084 12.5218 12.7204C12.6278 12.7416 12.6914 12.7734 12.7762 12.8052C12.861 12.8477 12.9777 12.8265 13.0413 12.8901C12.0658 13.9185 10.7723 14.6395 9.31975 14.894Z", fill: color }))));
    /* eslint-enable */
};

const Hamburger = (props) => {
    const { color } = props;
    return (React__default.createElement("svg", { width: "16", height: "14", viewBox: "0 0 16 14", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("line", { y1: "1", x2: "16", y2: "1", stroke: color, strokeWidth: "2" }),
        React__default.createElement("line", { y1: "7", x2: "16", y2: "7", stroke: color, strokeWidth: "2" }),
        React__default.createElement("line", { y1: "13", x2: "16", y2: "13", stroke: color, strokeWidth: "2" })));
};

const Lattice = (props) => {
    const { color } = props;
    return (React__default.createElement("svg", { width: "16", height: "15", viewBox: "0 0 16 15", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("rect", { width: "6", height: "6", fill: color }),
        React__default.createElement("rect", { y: "9", width: "6", height: "6", fill: color }),
        React__default.createElement("rect", { x: "10", width: "6", height: "6", fill: color }),
        React__default.createElement("rect", { x: "10", y: "9", width: "6", height: "6", fill: color })));
};

var img$7 = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.50139 12.0844C2.89191 11.6939 3.52508 11.6939 3.9156 12.0844L7.61522 15.784L18.1996 5.19963C18.5902 4.80911 19.2233 4.80911 19.6138 5.19963C20.0044 5.59016 20.0044 6.22332 19.6138 6.61384L8.32232 17.9054C8.13479 18.0929 7.88043 18.1983 7.61522 18.1983C7.35 18.1983 7.09565 18.0929 6.90811 17.9054L2.50139 13.4986C2.11087 13.1081 2.11087 12.475 2.50139 12.0844Z' fill='black'/%3e%3c/svg%3e";

const OutlineCheckmarkIcon = () => (React__default.createElement("img", { alt: "Outline Checkmark Icon", src: img$7 }));

var img$6 = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M14 14C14 14.7403 13.5978 15.3866 13 15.7324V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V15.7324C10.4022 15.3866 10 14.7403 10 14C10 12.8954 10.8954 12 12 12C13.1046 12 14 12.8954 14 14Z' fill='black'/%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M7 7V8H6C4.89543 8 4 8.89543 4 10V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V10C20 8.89543 19.1046 8 18 8H17V7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7ZM15 8V7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7V8H15ZM6 10H18V20H6V10Z' fill='black'/%3e%3c/svg%3e";

const LockIcon = () => (React__default.createElement("img", { alt: "Lock Icon", src: img$6 }));

const Overflow = (props) => (React$2.createElement(BaseOverflow, { ...props }));

var img$5 = "data:image/svg+xml,%3csvg width='64' height='64' viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='64' height='64' fill='white'/%3e%3cpath d='M11.8494 20.366L32 8.73205L52.1506 20.366V43.634L32 55.2679L11.8494 43.634V20.366Z' stroke='black' stroke-width='3'/%3e%3cpath d='M13 21L32 32L51 21' stroke='black' stroke-width='3' stroke-linecap='round'/%3e%3cpath d='M32 32V45' stroke='black' stroke-width='3' stroke-linecap='round'/%3e%3cpath d='M22 26L41.5 14.5' stroke='black' stroke-width='3' stroke-linecap='round'/%3e%3cpath d='M43 41.5L49 38V42L43 45.5V41.5Z' fill='black'/%3e%3c/svg%3e";

const ProductPlaceholderIcon = (props) => (React$2.createElement("img", { alt: "Default product placement", src: img$5, ...props }));

var img$4 = "data:image/svg+xml,%3csvg width='920' height='167' viewBox='0 0 920 167' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M0.639999 71.23H95.5V166.09H166.64V0.0899963H0.639999V71.23ZM0.639999 166.09H71.7197V95.0103H0.639999V166.09ZM399.265 78.8115V55.2222H375.485V145.386H399.265V111.149C399.265 87.3685 407.822 75.5839 437.877 77.8664V53.1408C418.672 53.1308 405.741 59.5962 399.265 78.8115ZM321.851 20.7935H261.55V145.376H289.131V100.299H321.851C348.477 100.299 366.546 82.4213 366.546 59.5962C366.546 36.7711 348.487 20.7935 321.851 20.7935ZM317.477 79.0026H289.322V42.1003H317.477C332.318 42.1003 339.166 51.0393 339.166 59.5962C339.166 70.0535 332.318 79.0026 317.477 79.0026ZM779.208 70.0535C790.047 70.0535 794.421 74.4275 796.513 83.1755H820.293C818.011 61.6776 802.988 52.9297 779.208 52.9297C757.71 52.9297 740.596 61.6776 740.596 80.893C740.596 100.299 755.438 105.427 775.025 108.856C792.139 111.903 796.523 113.23 796.523 119.696C796.523 126.161 790.249 129.59 781.501 129.59C770.661 129.59 764.568 123.879 762.476 113.23H738.696C740.596 134.728 755.629 147.659 781.491 147.659C805.271 147.659 820.293 136.82 820.293 117.604C820.293 98.1978 805.271 93.6428 783.582 89.6409C770.078 87.1673 764.176 85.2669 764.176 78.8015C764.186 73.6734 769.887 70.0535 779.208 70.0535ZM700.466 40.0088H728.048V12.4276H700.466V40.0088ZM919.397 100.872C919.397 72.9092 904.746 52.9397 875.074 52.9397C847.492 52.9397 829.805 72.336 829.805 100.299C829.805 128.454 847.492 147.659 875.074 147.659C898.663 147.659 912.921 136.82 919.205 115.322H893.525C890.669 125.97 883.067 128.635 876.029 128.635C863.661 128.635 855.868 119.314 854.531 106.192H919.397V100.872ZM854.531 90.9782C856.24 79.5657 863.088 71.0088 875.074 71.0088C887.25 71.0088 894.661 79.0026 895.616 90.9782H854.531ZM485.719 52.9397C458.138 52.9397 440.451 72.336 440.451 100.299C440.451 128.454 458.138 147.659 485.719 147.659C509.308 147.659 523.567 136.82 529.851 115.322H504.17C501.315 125.97 493.713 128.635 486.674 128.635C474.307 128.635 466.514 119.314 465.177 106.192H530.042V100.862C530.042 72.9092 515.392 52.9397 485.719 52.9397ZM465.177 90.9782C466.886 79.5657 473.733 71.0088 485.719 71.0088C497.896 71.0088 505.307 79.0026 506.262 90.9782H465.177ZM654.535 52.9397C641.604 52.9397 630.945 57.5047 624.48 70.0636C618.014 57.5148 607.175 52.9397 594.425 52.9397C583.777 52.9397 572.927 57.5047 566.462 70.0636V55.2222H542.681V145.386H566.462V96.1265C566.462 80.9131 575.019 74.2566 585.677 74.2566C596.516 74.2566 602.982 80.913 602.982 93.8439V145.386H626.762V96.1265C626.762 82.2403 633.228 74.2566 645.787 74.2566C656.626 74.2566 663.091 80.913 663.091 93.8439V145.386H686.872V89.651C686.862 65.8706 673.931 52.9397 654.535 52.9397ZM702.367 145.376H726.147V55.2122H702.367V145.376Z' fill='%23FF5B4A'/%3e%3c/svg%3e";

var img$3 = "data:image/svg+xml,%3csvg width='111' height='20' viewBox='0 0 111 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M0 8.57108H11.4289V20H20V0H0V8.57108ZM0 20H8.56381V11.4362H0V20ZM48.0271 9.48452V6.64244H45.162V17.5056H48.0271V13.3806C48.0271 10.5155 49.0581 9.09564 52.6791 9.37065V6.39167C50.3652 6.39046 48.8073 7.16942 48.0271 9.48452ZM38.7001 2.4944H31.435V17.5044H34.758V12.0734H38.7001C41.9081 12.0734 44.085 9.91944 44.085 7.16942C44.085 4.41941 41.9093 2.4944 38.7001 2.4944ZM38.1731 9.50754H34.781V5.06148H38.1731C39.9612 5.06148 40.7862 6.13847 40.7862 7.16942C40.7862 8.42934 39.9612 9.50754 38.1731 9.50754ZM93.8034 8.42934C95.1093 8.42934 95.6363 8.95633 95.8883 10.0103H98.7534C98.4784 7.4202 96.6685 6.36622 93.8034 6.36622C91.2133 6.36622 89.1514 7.4202 89.1514 9.7353C89.1514 12.0734 90.9395 12.6913 93.2994 13.1044C95.3613 13.4714 95.8895 13.6314 95.8895 14.4103C95.8895 15.1893 95.1336 15.6024 94.0796 15.6024C92.7736 15.6024 92.0395 14.9143 91.7875 13.6314H88.9224C89.1514 16.2215 90.9625 17.7794 94.0784 17.7794C96.9435 17.7794 98.7534 16.4734 98.7534 14.1583C98.7534 11.8202 96.9435 11.2714 94.3304 10.7893C92.7034 10.4912 91.9922 10.2623 91.9922 9.48331C91.9935 8.86547 92.6804 8.42934 93.8034 8.42934ZM84.3164 4.8095H87.6395V1.48646H84.3164V4.8095ZM110.694 12.1425C110.694 8.7734 108.928 6.36744 105.353 6.36744C102.03 6.36744 99.8995 8.70434 99.8995 12.0734C99.8995 15.4655 102.03 17.7794 105.353 17.7794C108.196 17.7794 109.913 16.4734 110.671 13.8833H107.576C107.232 15.1663 106.317 15.4873 105.469 15.4873C103.978 15.4873 103.04 14.3643 102.878 12.7833H110.694V12.1425ZM102.878 10.9504C103.084 9.57538 103.909 8.54443 105.353 8.54443C106.821 8.54443 107.713 9.50754 107.828 10.9504H102.878ZM58.4433 6.36744C55.1202 6.36744 52.9893 8.70434 52.9893 12.0734C52.9893 15.4655 55.1202 17.7794 58.4433 17.7794C61.2854 17.7794 63.0032 16.4734 63.7604 13.8833H60.6663C60.3222 15.1663 59.4064 15.4873 58.5584 15.4873C57.0683 15.4873 56.1294 14.3643 55.9683 12.7833H63.7834V12.1413C63.7834 8.7734 62.0183 6.36744 58.4433 6.36744ZM55.9683 10.9504C56.1742 9.57538 56.9992 8.54443 58.4433 8.54443C59.9103 8.54443 60.8032 9.50754 60.9183 10.9504H55.9683ZM78.7825 6.36744C77.2245 6.36744 75.9404 6.91744 75.1614 8.43055C74.3825 6.91865 73.0765 6.36744 71.5404 6.36744C70.2574 6.36744 68.9503 6.91744 68.1713 8.43055V6.64244H65.3062V17.5056H68.1713V11.5707C68.1713 9.73772 69.2022 8.93573 70.4864 8.93573C71.7924 8.93573 72.5713 9.73772 72.5713 11.2957V17.5056H75.4364V11.5707C75.4364 9.89763 76.2154 8.93573 77.7285 8.93573C79.0345 8.93573 79.8134 9.73772 79.8134 11.2957V17.5056H82.6785V10.7905C82.6773 7.92538 81.1194 6.36744 78.7825 6.36744ZM84.5454 17.5044H87.4105V6.64123H84.5454V17.5044Z' fill='%234F4F4F'/%3e%3c/svg%3e";

const PremiseLogo = (props) => {
    const { active } = props;
    return (React__default.createElement("img", { alt: "a full color logo with text representing Premise Data", src: active ? img$4 : img$3, style: {
            height: '20px',
            width: '110.69px',
        } }));
};

const Show = (props) => (React$2.createElement(Show$2, { ...props }));

const ThreeColumns = (props) => {
    const { color } = props;
    return (React__default.createElement("svg", { stroke: color, width: "15", height: "16", viewBox: "0 0 15 16", fill: color, xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("line", { x1: "2", y1: "0", x2: "2", y2: "16", stroke: color, strokeWidth: "2" }),
        React__default.createElement("line", { x1: "8", y1: "0", x2: "8", y2: "16", stroke: color, strokeWidth: "2" }),
        React__default.createElement("line", { x1: "14", y1: "0", x2: "14", y2: "16", stroke: color, strokeWidth: "2" })));
};

const Plus = (props) => (React$2.createElement(BasePlus, { ...props }));

const Search = (props) => (React$2.createElement(SearchIconComponent, { ...props }));

var img$2 = "data:image/svg+xml,%3c%3fxml version='1.0'%3f%3e%3csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M11 1C11 0.447715 11.4477 0 12 0C12.5523 0 13 0.447715 13 1V5C13 5.55228 12.5523 6 12 6C11.4477 6 11 5.55228 11 5V1ZM24 12C24 11.4477 23.5523 11 23 11H19C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13H23C23.5523 13 24 12.5523 24 12ZM6 12C6 11.4477 5.55228 11 5 11H1C0.447716 11 0 11.4477 0 12C0 12.5523 0.447716 13 1 13H5C5.55228 13 6 12.5523 6 12ZM19.0711 3.51472C19.4616 3.12419 20.0948 3.12419 20.4853 3.51472C20.8758 3.90524 20.8758 4.53841 20.4853 4.92893L17.6569 7.75736C17.2663 8.14788 16.6332 8.14788 16.2426 7.75736C15.8521 7.36684 15.8521 6.73367 16.2426 6.34315L19.0711 3.51472ZM6.34315 16.2426C6.73367 15.8521 7.36684 15.8521 7.75736 16.2426C8.14788 16.6332 8.14788 17.2663 7.75736 17.6569L4.92893 20.4853C4.53841 20.8758 3.90524 20.8758 3.51472 20.4853C3.1242 20.0948 3.1242 19.4616 3.51472 19.0711L6.34315 16.2426ZM11 19C11 18.4477 11.4477 18 12 18C12.5523 18 13 18.4477 13 19V23C13 23.5523 12.5523 24 12 24C11.4477 24 11 23.5523 11 23V19ZM20.4853 19.0711C20.8758 19.4616 20.8758 20.0948 20.4853 20.4853C20.0948 20.8758 19.4616 20.8758 19.0711 20.4853L16.2426 17.6569C15.8521 17.2663 15.8521 16.6332 16.2426 16.2426C16.6332 15.8521 17.2663 15.8521 17.6569 16.2426L20.4853 19.0711ZM7.75736 6.34315C8.14788 6.73367 8.14788 7.36684 7.75736 7.75736C7.36684 8.14788 6.73367 8.14788 6.34315 7.75736L3.51472 4.92893C3.1242 4.53841 3.1242 3.90524 3.51472 3.51472C3.90524 3.1242 4.53841 3.1242 4.92893 3.51472L7.75736 6.34315Z' /%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z' /%3e%3c/svg%3e";

const Sun = () => (React__default.createElement("img", { alt: "Sun Icon", src: img$2 }));

var img$1 = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7ZM15 7C15 8.65685 13.6569 10 12 10C10.3431 10 9 8.65685 9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7Z' fill='black'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M14 13H10C7.79086 13 6 14.7909 6 17V19C6 20.1046 6.89543 21 8 21H16C17.1046 21 18 20.1046 18 19V17C18 14.7909 16.2091 13 14 13ZM8 17C8 15.8954 8.89543 15 10 15H14C15.1046 15 16 15.8954 16 17V19H8V17Z' fill='black'/%3e%3c/svg%3e";

var img = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12ZM6 17C6 14.7909 7.79086 13 10 13H14C16.2091 13 18 14.7909 18 17V19C18 20.1046 17.1046 21 16 21H8C6.89543 21 6 20.1046 6 19V17Z' fill='%23FF5B4A'/%3e%3c/svg%3e";

const ProfileIcon = ({ isActive }) => (React__default.createElement("img", { alt: "Profile Icon", src: isActive ? img : img$1, height: "20px", width: "20px" }));

var _curry = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = curry;

// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
} // eslint-disable-next-line no-redeclare


function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

module.exports = exports.default;
});

unwrapExports(_curry);

var _hslToRgb = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = void 0;

function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  } // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV


  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

var _default = hslToRgb;
exports["default"] = _default;
module.exports = exports.default;
});

unwrapExports(_hslToRgb);

var _nameToHex = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = void 0;
var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */

function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}

var _default = nameToHex;
exports["default"] = _default;
module.exports = exports.default;
});

unwrapExports(_nameToHex);

var _errors = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = void 0;

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js

/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */
var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
  "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
  "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
  "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
  "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
  "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found.\n\n",
  "75": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n"
};
/**
 * super basic version of sprintf
 * @private
 */

function format() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */


var PolishedError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(PolishedError, _Error);

  function PolishedError(code) {
    var _this;

    if (process.env.NODE_ENV === 'production') {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      _this = _Error.call(this, format.apply(void 0, [ERRORS[code]].concat(args))) || this;
    }

    return _assertThisInitialized(_this);
  }

  return PolishedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports["default"] = PolishedError;
module.exports = exports.default;
});

unwrapExports(_errors);

var require$$0$7 = _hslToRgb;

var require$$1$9 = _nameToHex;

var require$$2$4 = _errors;

var parseToRgb_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = parseToRgb;

var _hslToRgb = /*#__PURE__*/_interopRequireDefault( require$$0$7);

var _nameToHex = /*#__PURE__*/_interopRequireDefault( require$$1$9);

var _errors = /*#__PURE__*/_interopRequireDefault( require$$2$4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */

function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new _errors["default"](3);
  }

  var normalizedColor = (0, _nameToHex["default"])(color);

  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }

  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }

  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }

  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));

    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }

  var rgbMatched = rgbRegex.exec(normalizedColor);

  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }

  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));

  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4])
    };
  }

  var hslMatched = hslRegex.exec(normalizedColor);

  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + (0, _hslToRgb["default"])(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);

    if (!hslRgbMatched) {
      throw new _errors["default"](4, normalizedColor, rgbColorString);
    }

    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }

  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));

  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);

    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;

    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;

    var _rgbColorString = "rgb(" + (0, _hslToRgb["default"])(_hue, _saturation, _lightness) + ")";

    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);

    if (!_hslRgbMatched) {
      throw new _errors["default"](4, normalizedColor, _rgbColorString);
    }

    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4])
    };
  }

  throw new _errors["default"](5);
}

module.exports = exports.default;
});

unwrapExports(parseToRgb_1);

var _reduceHexValue = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = void 0;

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }

  return value;
};

var _default = reduceHexValue;
exports["default"] = _default;
module.exports = exports.default;
});

unwrapExports(_reduceHexValue);

var _numberToHex = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = void 0;

function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

var _default = numberToHex;
exports["default"] = _default;
module.exports = exports.default;
});

unwrapExports(_numberToHex);

var require$$0$6 = _reduceHexValue;

var require$$1$8 = _numberToHex;

var rgb_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = rgb;

var _reduceHexValue = /*#__PURE__*/_interopRequireDefault( require$$0$6);

var _numberToHex = /*#__PURE__*/_interopRequireDefault( require$$1$8);

var _errors = /*#__PURE__*/_interopRequireDefault( require$$2$4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return (0, _reduceHexValue["default"])("#" + (0, _numberToHex["default"])(value) + (0, _numberToHex["default"])(green) + (0, _numberToHex["default"])(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return (0, _reduceHexValue["default"])("#" + (0, _numberToHex["default"])(value.red) + (0, _numberToHex["default"])(value.green) + (0, _numberToHex["default"])(value.blue));
  }

  throw new _errors["default"](6);
}

module.exports = exports.default;
});

unwrapExports(rgb_1);

var require$$2$3 = parseToRgb_1;

var require$$1$7 = rgb_1;

var rgba_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = rgba;

var _parseToRgb = /*#__PURE__*/_interopRequireDefault( require$$2$3);

var _rgb = /*#__PURE__*/_interopRequireDefault( require$$1$7);

var _errors = /*#__PURE__*/_interopRequireDefault( require$$2$4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = (0, _parseToRgb["default"])(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? (0, _rgb["default"])(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? (0, _rgb["default"])(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }

  throw new _errors["default"](7);
}

module.exports = exports.default;
});

unwrapExports(rgba_1);

var require$$0$5 = _curry;

var require$$1$6 = rgba_1;

var mix_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = void 0;

var _curry = /*#__PURE__*/_interopRequireDefault( require$$0$5);

var _rgba = /*#__PURE__*/_interopRequireDefault( require$$1$6);

var _parseToRgb = /*#__PURE__*/_interopRequireDefault( require$$2$3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */
function mix(weight, color, otherColor) {
  if (color === 'transparent') return otherColor;
  if (otherColor === 'transparent') return color;
  if (weight === 0) return otherColor;
  var parsedColor1 = (0, _parseToRgb["default"])(color);

  var color1 = _extends({}, parsedColor1, {
    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
  });

  var parsedColor2 = (0, _parseToRgb["default"])(otherColor);

  var color2 = _extends({}, parsedColor2, {
    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
  }); // The formula is copied from the original Sass implementation:
  // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method


  var alphaDelta = color1.alpha - color2.alpha;
  var x = parseFloat(weight) * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2.0;
  var weight2 = 1 - weight1;
  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
    alpha: color1.alpha * (parseFloat(weight) / 1.0) + color2.alpha * (1 - parseFloat(weight) / 1.0)
  };
  return (0, _rgba["default"])(mixedColor);
} // prettier-ignore


var curriedMix = /*#__PURE__*/(0, _curry["default"]
/* ::<number | string, string, string, string> */
)(mix);
var _default = curriedMix;
exports["default"] = _default;
module.exports = exports.default;
});

unwrapExports(mix_1);

var require$$1$5 = mix_1;

var tint_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = void 0;

var _curry = /*#__PURE__*/_interopRequireDefault( require$$0$5);

var _mix = /*#__PURE__*/_interopRequireDefault( require$$1$5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */
function tint(percentage, color) {
  if (color === 'transparent') return color;
  return (0, _mix["default"])(parseFloat(percentage), 'rgb(255, 255, 255)', color);
} // prettier-ignore


var curriedTint = /*#__PURE__*/(0, _curry["default"]
/* ::<number | string, string, string> */
)(tint);
var _default = curriedTint;
exports["default"] = _default;
module.exports = exports.default;
});

var tint = unwrapExports(tint_1);

var shade_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = void 0;

var _curry = /*#__PURE__*/_interopRequireDefault( require$$0$5);

var _mix = /*#__PURE__*/_interopRequireDefault( require$$1$5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */
function shade(percentage, color) {
  if (color === 'transparent') return color;
  return (0, _mix["default"])(parseFloat(percentage), 'rgb(0, 0, 0)', color);
} // prettier-ignore


var curriedShade = /*#__PURE__*/(0, _curry["default"]
/* ::<number | string, string, string> */
)(shade);
var _default = curriedShade;
exports["default"] = _default;
module.exports = exports.default;
});

var shade = unwrapExports(shade_1);

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var SIZE$6 = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};
var VARIANT = Object.freeze({
  solid: 'solid',
  light: 'light',
  outlined: 'outlined'
});
var KIND$2 = {
  custom: 'custom',
  // semantic
  neutral: 'neutral',
  primary: 'primary',
  accent: 'accent',
  positive: 'positive',
  warning: 'warning',
  negative: 'negative',
  // primitive
  black: 'black',
  blue: 'blue',
  green: 'green',
  red: 'red',
  yellow: 'yellow',
  orange: 'orange',
  purple: 'purple',
  brown: 'brown'
};

var _neutralColorStates, _primaryColorStates, _accentColorStates, _positiveColorStates, _warningColorStates, _negativeColorStates, _orangeColorStates, _purpleColorStates, _brownColorStates, _customColorStates, _colorMap;

function ownKeys$13(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$13(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$13(Object(source), true).forEach(function (key) { _defineProperty$1u(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$13(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1u(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function customOnRamp(color, unit) {
  switch (unit) {
    case '0':
      return 'white';

    case '50':
      return tint(0.8, color);

    case '100':
      return tint(0.6, color);

    case '200':
      return tint(0.4, color);

    case '300':
      return tint(0.2, color);

    case '400':
      return color;

    case '500':
      return shade(0.2, color);

    case '600':
      return shade(0.4, color);

    case '700':
      return shade(0.6, color);

    case '800':
      return shade(0.8, color);

    case '1000':
      return 'black';

    default:
      return color;
  }
}
var COLOR_STATE = {
  disabled: 'disabled',
  solid: 'solid',
  outline: 'outline'
}; // Probably best to bake this into the theme once we hit our next major.

var pick = function pick(theme, light, dark) {
  return theme.name && theme.name.includes('dark') ? dark : light;
};

var neutralColorStates = (_neutralColorStates = {}, _defineProperty$1u(_neutralColorStates, COLOR_STATE.disabled, function (theme, color) {
  return {
    color: theme.colors.tagNeutralFontDisabled,
    backgroundColor: null,
    borderColor: theme.colors.tagNeutralOutlinedDisabled
  };
}), _defineProperty$1u(_neutralColorStates, COLOR_STATE.solid, function (theme, color) {
  return {
    color: theme.colors.tagNeutralSolidFont,
    backgroundColor: theme.colors.tagNeutralSolidBackground,
    borderColor: null
  };
}), _defineProperty$1u(_neutralColorStates, COLOR_STATE.outline, function (theme, color) {
  return {
    color: theme.colors.tagNeutralOutlinedFont,
    backgroundColor: null,
    borderColor: theme.colors.tagNeutralOutlinedBackground
  };
}), _neutralColorStates);
var primaryColorStates = (_primaryColorStates = {}, _defineProperty$1u(_primaryColorStates, COLOR_STATE.disabled, function (theme, color) {
  return {
    color: theme.colors.tagPrimaryFontDisabled,
    backgroundColor: null,
    borderColor: theme.colors.tagPrimaryOutlinedDisabled
  };
}), _defineProperty$1u(_primaryColorStates, COLOR_STATE.solid, function (theme, color) {
  return {
    color: theme.colors.tagPrimarySolidFont,
    backgroundColor: theme.colors.tagPrimarySolidBackground,
    borderColor: null
  };
}), _defineProperty$1u(_primaryColorStates, COLOR_STATE.outline, function (theme, color) {
  return {
    color: theme.colors.tagPrimaryOutlinedFont,
    backgroundColor: null,
    borderColor: theme.colors.tagPrimaryOutlinedBackground
  };
}), _primaryColorStates);
var accentColorStates = (_accentColorStates = {}, _defineProperty$1u(_accentColorStates, COLOR_STATE.disabled, function (theme, color) {
  return {
    color: theme.colors.tagAccentFontDisabled,
    backgroundColor: null,
    borderColor: theme.colors.tagAccentOutlinedDisabled
  };
}), _defineProperty$1u(_accentColorStates, COLOR_STATE.solid, function (theme, color) {
  return {
    color: theme.colors.tagAccentSolidFont,
    backgroundColor: theme.colors.tagAccentSolidBackground,
    borderColor: null
  };
}), _defineProperty$1u(_accentColorStates, COLOR_STATE.outline, function (theme, color) {
  return {
    color: theme.colors.tagAccentOutlinedFont,
    backgroundColor: null,
    borderColor: theme.colors.tagAccentOutlinedBackground
  };
}), _accentColorStates);
var positiveColorStates = (_positiveColorStates = {}, _defineProperty$1u(_positiveColorStates, COLOR_STATE.disabled, function (theme, color) {
  return {
    color: theme.colors.tagPositiveFontDisabled,
    backgroundColor: null,
    borderColor: theme.colors.tagPositiveOutlinedDisabled
  };
}), _defineProperty$1u(_positiveColorStates, COLOR_STATE.solid, function (theme, color) {
  return {
    color: theme.colors.tagPositiveSolidFont,
    backgroundColor: theme.colors.tagPositiveSolidBackground,
    borderColor: null
  };
}), _defineProperty$1u(_positiveColorStates, COLOR_STATE.outline, function (theme, color) {
  return {
    color: theme.colors.tagPositiveOutlinedFont,
    backgroundColor: null,
    borderColor: theme.colors.tagPositiveOutlinedBackground
  };
}), _positiveColorStates);
var warningColorStates = (_warningColorStates = {}, _defineProperty$1u(_warningColorStates, COLOR_STATE.disabled, function (theme, color) {
  return {
    color: theme.colors.tagWarningFontDisabled,
    backgroundColor: null,
    borderColor: theme.colors.tagWarningOutlinedDisabled
  };
}), _defineProperty$1u(_warningColorStates, COLOR_STATE.solid, function (theme, color) {
  return {
    color: theme.colors.tagWarningSolidFont,
    backgroundColor: theme.colors.tagWarningSolidBackground,
    borderColor: null
  };
}), _defineProperty$1u(_warningColorStates, COLOR_STATE.outline, function (theme, color) {
  return {
    color: theme.colors.tagWarningOutlinedFont,
    backgroundColor: null,
    borderColor: theme.colors.tagWarningOutlinedBackground
  };
}), _warningColorStates);
var negativeColorStates = (_negativeColorStates = {}, _defineProperty$1u(_negativeColorStates, COLOR_STATE.disabled, function (theme, color) {
  return {
    color: theme.colors.tagNegativeFontDisabled,
    backgroundColor: null,
    borderColor: theme.colors.tagNegativeOutlinedDisabled
  };
}), _defineProperty$1u(_negativeColorStates, COLOR_STATE.solid, function (theme, color) {
  return {
    color: theme.colors.tagNegativeSolidFont,
    backgroundColor: theme.colors.tagNegativeSolidBackground,
    borderColor: null
  };
}), _defineProperty$1u(_negativeColorStates, COLOR_STATE.outline, function (theme, color) {
  return {
    color: theme.colors.tagNegativeOutlinedFont,
    backgroundColor: null,
    borderColor: theme.colors.tagNegativeOutlinedBackground
  };
}), _negativeColorStates);
var orangeColorStates = (_orangeColorStates = {}, _defineProperty$1u(_orangeColorStates, COLOR_STATE.disabled, function (theme, color) {
  return {
    color: pick(theme, colorTokens$3.orange200, colorTokens$3.orange600),
    backgroundColor: null,
    borderColor: pick(theme, colorTokens$3.orange200, colorTokens$3.orange700)
  };
}), _defineProperty$1u(_orangeColorStates, COLOR_STATE.solid, function (theme, color) {
  return {
    color: colorTokens$3.white,
    backgroundColor: pick(theme, colorTokens$3.orange400, colorTokens$3.orange500),
    borderColor: null
  };
}), _defineProperty$1u(_orangeColorStates, COLOR_STATE.outline, function (theme, color) {
  return {
    color: pick(theme, colorTokens$3.orange400, colorTokens$3.orange300),
    backgroundColor: null,
    borderColor: pick(theme, colorTokens$3.orange200, colorTokens$3.orange500)
  };
}), _orangeColorStates);
var purpleColorStates = (_purpleColorStates = {}, _defineProperty$1u(_purpleColorStates, COLOR_STATE.disabled, function (theme, color) {
  return {
    color: pick(theme, colorTokens$3.purple200, colorTokens$3.purple600),
    backgroundColor: null,
    borderColor: pick(theme, colorTokens$3.purple200, colorTokens$3.purple700)
  };
}), _defineProperty$1u(_purpleColorStates, COLOR_STATE.solid, function (theme, color) {
  return {
    color: colorTokens$3.white,
    backgroundColor: pick(theme, colorTokens$3.purple400, colorTokens$3.purple500),
    borderColor: null
  };
}), _defineProperty$1u(_purpleColorStates, COLOR_STATE.outline, function (theme, color) {
  return {
    color: pick(theme, colorTokens$3.purple400, colorTokens$3.purple300),
    backgroundColor: null,
    borderColor: pick(theme, colorTokens$3.purple200, colorTokens$3.purple500)
  };
}), _purpleColorStates);
var brownColorStates = (_brownColorStates = {}, _defineProperty$1u(_brownColorStates, COLOR_STATE.disabled, function (theme, color) {
  return {
    color: pick(theme, colorTokens$3.brown200, colorTokens$3.brown600),
    backgroundColor: null,
    borderColor: pick(theme, colorTokens$3.brown200, colorTokens$3.brown700)
  };
}), _defineProperty$1u(_brownColorStates, COLOR_STATE.solid, function (theme, color) {
  return {
    color: colorTokens$3.white,
    backgroundColor: pick(theme, colorTokens$3.brown400, colorTokens$3.brown500),
    borderColor: null
  };
}), _defineProperty$1u(_brownColorStates, COLOR_STATE.outline, function (theme, color) {
  return {
    color: pick(theme, colorTokens$3.brown400, colorTokens$3.brown300),
    backgroundColor: null,
    borderColor: pick(theme, colorTokens$3.brown200, colorTokens$3.brown500)
  };
}), _brownColorStates);
var customColorStates = (_customColorStates = {}, _defineProperty$1u(_customColorStates, COLOR_STATE.disabled, function (theme, color) {
  return {
    color: customOnRamp(color, theme.colors.tagFontDisabledRampUnit),
    backgroundColor: null,
    borderColor: customOnRamp(color, theme.colors.tagOutlinedDisabledRampUnit)
  };
}), _defineProperty$1u(_customColorStates, COLOR_STATE.solid, function (theme, color) {
  return {
    color: customOnRamp(color, theme.colors.tagSolidFontRampUnit),
    backgroundColor: customOnRamp(color, theme.colors.tagSolidRampUnit),
    borderColor: null
  };
}), _defineProperty$1u(_customColorStates, COLOR_STATE.outline, function (theme, color) {
  return {
    color: customOnRamp(color, theme.colors.tagOutlinedFontRampUnit),
    backgroundColor: null,
    borderColor: customOnRamp(color, theme.colors.tagOutlinedRampUnit)
  };
}), _customColorStates);
var colorMap = (_colorMap = {}, _defineProperty$1u(_colorMap, KIND$2.neutral, neutralColorStates), _defineProperty$1u(_colorMap, KIND$2.primary, primaryColorStates), _defineProperty$1u(_colorMap, KIND$2.accent, accentColorStates), _defineProperty$1u(_colorMap, KIND$2.positive, positiveColorStates), _defineProperty$1u(_colorMap, KIND$2.warning, warningColorStates), _defineProperty$1u(_colorMap, KIND$2.negative, negativeColorStates), _defineProperty$1u(_colorMap, KIND$2.black, primaryColorStates), _defineProperty$1u(_colorMap, KIND$2.blue, accentColorStates), _defineProperty$1u(_colorMap, KIND$2.green, positiveColorStates), _defineProperty$1u(_colorMap, KIND$2.red, negativeColorStates), _defineProperty$1u(_colorMap, KIND$2.yellow, warningColorStates), _defineProperty$1u(_colorMap, KIND$2.orange, orangeColorStates), _defineProperty$1u(_colorMap, KIND$2.purple, purpleColorStates), _defineProperty$1u(_colorMap, KIND$2.brown, brownColorStates), _defineProperty$1u(_colorMap, KIND$2.custom, customColorStates), _colorMap);

var getColorStateFromProps = function getColorStateFromProps(props) {
  if (props.$disabled) return COLOR_STATE.disabled;
  if (props.$variant === VARIANT.solid) return COLOR_STATE.solid;
  return COLOR_STATE.outline;
};

var Action$1 = styled('span', function (props) {
  var _SIZE$small$SIZE$medi, _ref;

  var $theme = props.$theme,
      $disabled = props.$disabled,
      _props$$size = props.$size,
      $size = _props$$size === void 0 ? SIZE$6.small : _props$$size;
  var bottomRadiusDir = $theme.direction === 'rtl' ? 'borderBottomLeftRadius' : 'borderBottomRightRadius';
  var topRadiusDir = $theme.direction === 'rtl' ? 'borderTopLeftRadius' : 'borderTopRightRadius';
  var marginDir = $theme.direction === 'rtl' ? 'marginRight' : 'marginLeft';
  return _ref = {
    alignItems: 'center'
  }, _defineProperty$1u(_ref, bottomRadiusDir, $theme.borders.useRoundedCorners ? $theme.borders.radius400 : 0), _defineProperty$1u(_ref, topRadiusDir, $theme.borders.useRoundedCorners ? $theme.borders.radius400 : 0), _defineProperty$1u(_ref, "cursor", $disabled ? 'not-allowed' : 'pointer'), _defineProperty$1u(_ref, "display", 'flex'), _defineProperty$1u(_ref, marginDir, (_SIZE$small$SIZE$medi = {}, _defineProperty$1u(_SIZE$small$SIZE$medi, SIZE$6.small, '8px'), _defineProperty$1u(_SIZE$small$SIZE$medi, SIZE$6.medium, '12px'), _defineProperty$1u(_SIZE$small$SIZE$medi, SIZE$6.large, '16px'), _SIZE$small$SIZE$medi)[$size]), _defineProperty$1u(_ref, "outline", 'none'), _defineProperty$1u(_ref, "transitionProperty", 'all'), _defineProperty$1u(_ref, "transitionDuration", 'background-color'), _defineProperty$1u(_ref, "transitionTimingFunction", $theme.animation.easeOutCurve), _ref;
});
Action$1.displayName = "Action";
var StartEnhancerContainer = styled('div', function (_ref2) {
  var $theme = _ref2.$theme,
      _ref2$$size = _ref2.$size,
      $size = _ref2$$size === void 0 ? SIZE$6.small : _ref2$$size;
  var paddingMagnitude = $theme.sizing.scale300;

  if ($size === SIZE$6.medium) {
    paddingMagnitude = $theme.sizing.scale400;
  } else if ($size === SIZE$6.large) {
    paddingMagnitude = $theme.sizing.scale600;
  }

  var paddingDir = $theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight';
  return _defineProperty$1u({
    alignItems: 'center',
    display: 'flex'
  }, paddingDir, paddingMagnitude);
});
StartEnhancerContainer.displayName = "StartEnhancerContainer";
var Text = styled('span', function (props) {
  var $theme = props.$theme;
  return {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: props.$theme.sizing.scale3200,
    order: $theme.direction === 'rtl' ? 1 : 0
  };
});
Text.displayName = "Text";
var Root$9 = styled('span', function (props) {
  var _SIZE$small$SIZE$medi2, _SIZE$small$SIZE$medi3, _SIZE$small$SIZE$medi4;

  var $theme = props.$theme,
      _props$$kind = props.$kind,
      $kind = _props$$kind === void 0 ? KIND$2.primary : _props$$kind,
      $clickable = props.$clickable,
      $variant = props.$variant,
      $disabled = props.$disabled,
      $closeable = props.$closeable,
      $isFocusVisible = props.$isFocusVisible,
      $color = props.$color,
      _props$$size2 = props.$size,
      $size = _props$$size2 === void 0 ? SIZE$6.small : _props$$size2;
  var borderRadius = $theme.borders.tagBorderRadius;
  var paddingMagnitude = (_SIZE$small$SIZE$medi2 = {}, _defineProperty$1u(_SIZE$small$SIZE$medi2, SIZE$6.small, $theme.sizing.scale300), _defineProperty$1u(_SIZE$small$SIZE$medi2, SIZE$6.medium, $theme.sizing.scale500), _defineProperty$1u(_SIZE$small$SIZE$medi2, SIZE$6.large, $theme.sizing.scale600), _SIZE$small$SIZE$medi2)[$size];
  var borderWidth = !$disabled && $variant === VARIANT.solid ? 0 : '2px';

  var _colorMap$$kind$getCo = colorMap[$kind][getColorStateFromProps(props)]($theme, $color),
      color = _colorMap$$kind$getCo.color,
      backgroundColor = _colorMap$$kind$getCo.backgroundColor,
      borderColor = _colorMap$$kind$getCo.borderColor;

  return _objectSpread$13(_objectSpread$13({}, (_SIZE$small$SIZE$medi3 = {}, _defineProperty$1u(_SIZE$small$SIZE$medi3, SIZE$6.small, $theme.typography.LabelSmall), _defineProperty$1u(_SIZE$small$SIZE$medi3, SIZE$6.medium, $theme.typography.LabelMedium), _defineProperty$1u(_SIZE$small$SIZE$medi3, SIZE$6.large, $theme.typography.LabelLarge), _SIZE$small$SIZE$medi3)[$size]), {}, {
    alignItems: 'center',
    color: color,
    backgroundColor: backgroundColor,
    borderLeftColor: borderColor,
    borderRightColor: borderColor,
    borderTopColor: borderColor,
    borderBottomColor: borderColor,
    borderLeftStyle: 'solid',
    borderRightStyle: 'solid',
    borderTopStyle: 'solid',
    borderBottomStyle: 'solid',
    borderLeftWidth: borderWidth,
    borderRightWidth: borderWidth,
    borderTopWidth: borderWidth,
    borderBottomWidth: borderWidth,
    borderTopLeftRadius: borderRadius,
    borderTopRightRadius: borderRadius,
    borderBottomRightRadius: borderRadius,
    borderBottomLeftRadius: borderRadius,
    boxSizing: 'border-box',
    cursor: $disabled ? 'not-allowed' : $clickable ? 'pointer' : 'default',
    display: 'inline-flex',
    height: (_SIZE$small$SIZE$medi4 = {}, _defineProperty$1u(_SIZE$small$SIZE$medi4, SIZE$6.small, '24px'), _defineProperty$1u(_SIZE$small$SIZE$medi4, SIZE$6.medium, '32px'), _defineProperty$1u(_SIZE$small$SIZE$medi4, SIZE$6.large, '40px'), _SIZE$small$SIZE$medi4)[$size],
    justifyContent: 'space-between',
    marginTop: '5px',
    marginBottom: '5px',
    marginLeft: '5px',
    marginRight: '5px',
    paddingTop: $theme.sizing.scale0,
    paddingBottom: $theme.sizing.scale0,
    paddingLeft: paddingMagnitude,
    paddingRight: paddingMagnitude,
    outline: 'none',
    ':hover': $disabled || !$clickable ? {} : {
      boxShadow: "inset 0px 0px 100px ".concat(pick($theme, "rgba(0, 0, 0, 0.08)", "rgba(255, 255, 255, 0.2)"))
    },
    ':focus': $disabled || !$clickable && !$closeable ? {} : {
      boxShadow: $isFocusVisible ? "0 0 0 3px ".concat($kind === KIND$2.accent ? $theme.colors.primaryA : $theme.colors.accent) : 'none'
    }
  });
});
Root$9.displayName = "Root";

function _typeof$J(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$J = function _typeof(obj) { return typeof obj; }; } else { _typeof$J = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$J(obj); }
var JOINABLE_TYPES = new Set(['string', 'number']); // Checks the children of a React component to ensure every value is a number
// or a string. If they are, they are joined and returned. Useful for collecting
// text from the child of a node to use as an attribute.

function getTextFromChildren(children) {
  var childList = React$2.Children.toArray(children).filter(function (child) {
    return child !== null && child !== undefined;
  });

  if (!childList.length) {
    return null;
  }

  var isJoinable = childList.every(function (child) {
    return JOINABLE_TYPES.has(_typeof$J(child));
  });

  if (!isJoinable) {
    return null;
  } // Join on an empty string to preserve React's whitespace handling:
  // <Tag>foo{'bar'}baz</Tag> => 'foobar'
  // <Tag>foo {'bar'} baz</Tag> => 'foo bar baz'


  return childList.join('');
}

function _defineProperty$1t(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$R(arr, i) { return _arrayWithHoles$R(arr) || _iterableToArrayLimit$R(arr, i) || _unsupportedIterableToArray$T(arr, i) || _nonIterableRest$R(); }

function _nonIterableRest$R() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$T(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$T(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$T(o, minLen); }

function _arrayLikeToArray$T(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$R(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$R(arr) { if (Array.isArray(arr)) return arr; }

function _extends$12() { _extends$12 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }
// Delete requires modifying Delete's viewbox to prevent visual regressions.

var ModifiedViewBoxDeleteIcon = function ModifiedViewBoxDeleteIcon(props) {
  return /*#__PURE__*/React$2.createElement(DeleteIcon, _extends$12({
    viewBox: "5 5 13.186 13.186"
  }, props));
};

var Tag$1 = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  var _SIZE$small$SIZE$medi;

  var children = props.children,
      _props$closeable = props.closeable,
      closeable = _props$closeable === void 0 ? true : _props$closeable,
      color = props.color,
      _props$size = props.size,
      size = _props$size === void 0 ? SIZE$6.small : _props$size,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$isFocused = props.isFocused,
      isFocused = _props$isFocused === void 0 ? false : _props$isFocused,
      _props$isHovered = props.isHovered,
      isHovered = _props$isHovered === void 0 ? false : _props$isHovered,
      _props$kind = props.kind,
      kind = _props$kind === void 0 ? KIND$2.primary : _props$kind,
      _props$onActionClick = props.onActionClick,
      onActionClick = _props$onActionClick === void 0 ? function (event) {} : _props$onActionClick,
      _props$onActionKeyDow = props.onActionKeyDown,
      onActionKeyDown = _props$onActionKeyDow === void 0 ? function (event) {} : _props$onActionKeyDow,
      _props$onClick = props.onClick,
      onClick = _props$onClick === void 0 ? null : _props$onClick,
      _props$onKeyDown = props.onKeyDown,
      onKeyDown = _props$onKeyDown === void 0 ? null : _props$onKeyDown,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      startEnhancer = props.startEnhancer,
      title = props.title,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? VARIANT.light : _props$variant;

  var _React$useState = React$2.useState(false),
      _React$useState2 = _slicedToArray$R(_React$useState, 2),
      focusVisible = _React$useState2[0],
      setFocusVisible = _React$useState2[1];

  function handleFocus(event) {
    if (isFocusVisible(event)) {
      setFocusVisible(true);
    }
  }

  function handleBlur(event) {
    if (focusVisible !== false) {
      setFocusVisible(false);
    }
  }

  function handleKeyDown(event) {
    if (event.currentTarget !== event.target) {
      return;
    }

    var key = event.key;

    if (onClick && key === 'Enter') {
      onClick(event);
    }

    if (closeable && (key === 'Backspace' || key === 'Delete')) {
      onActionClick(event);
      onActionKeyDown(event);
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  }

  var _getOverrides = getOverrides(overrides.Root, Root$9),
      _getOverrides2 = _slicedToArray$R(_getOverrides, 2),
      Root = _getOverrides2[0],
      rootProps = _getOverrides2[1];

  var _getOverrides3 = getOverrides(overrides.Action, Action$1),
      _getOverrides4 = _slicedToArray$R(_getOverrides3, 2),
      Action = _getOverrides4[0],
      actionProps = _getOverrides4[1];

  var _getOverrides5 = getOverrides(overrides.ActionIcon, ModifiedViewBoxDeleteIcon),
      _getOverrides6 = _slicedToArray$R(_getOverrides5, 2),
      ActionIcon = _getOverrides6[0],
      actionIconProps = _getOverrides6[1];

  var _getOverrides7 = getOverrides(overrides.StartEnhancerContainer, StartEnhancerContainer),
      _getOverrides8 = _slicedToArray$R(_getOverrides7, 2),
      StartEnhancerContainer$1 = _getOverrides8[0],
      startEnhancerContainerProps = _getOverrides8[1];

  var _getOverrides9 = getOverrides(overrides.Text, Text),
      _getOverrides10 = _slicedToArray$R(_getOverrides9, 2),
      Text$1 = _getOverrides10[0],
      textProps = _getOverrides10[1];

  var clickable = typeof onClick === 'function';
  var rootHandlers = disabled ? {} : {
    onClick: onClick,
    onKeyDown: handleKeyDown
  };
  var actionHandlers = disabled ? {} : {
    onClick: function onClick(event) {
      // we don't want onClick to be called when the close icon is clicked
      event.stopPropagation();
      onActionClick(event);
    }
  };
  var sharedProps = {
    $clickable: clickable,
    $closeable: closeable,
    $color: color,
    $disabled: disabled,
    $isFocused: isFocused,
    $isHovered: isHovered,
    $kind: kind,
    $variant: variant,
    $isFocusVisible: focusVisible,
    $size: size
  };
  var titleText = title || getTextFromChildren(children);
  var isButton = (clickable || closeable) && !disabled;
  var actionSize = (_SIZE$small$SIZE$medi = {}, _defineProperty$1t(_SIZE$small$SIZE$medi, SIZE$6.small, 12), _defineProperty$1t(_SIZE$small$SIZE$medi, SIZE$6.medium, 16), _defineProperty$1t(_SIZE$small$SIZE$medi, SIZE$6.large, 20), _SIZE$small$SIZE$medi)[size]; // Capitalize for JSX

  var StartEnhancer = startEnhancer;
  return /*#__PURE__*/React$2.createElement(Root // flowlint-next-line unclear-type:off
  , _extends$12({
    ref: ref,
    "data-baseweb": "tag",
    "aria-label": isButton && closeable ? "".concat(typeof children === 'string' ? "".concat(children, ", ") : '', "close by backspace") : null,
    "aria-disabled": disabled ? true : null,
    role: isButton ? 'button' : null,
    tabIndex: isButton ? 0 : null
  }, rootHandlers, sharedProps, rootProps, {
    onFocus: forkFocus(rootProps, handleFocus),
    onBlur: forkBlur(rootProps, handleBlur)
  }), StartEnhancer && StartEnhancer !== 0 && /*#__PURE__*/React$2.createElement(StartEnhancerContainer$1, startEnhancerContainerProps, /*#__PURE__*/React$2.createElement(StartEnhancer, null)), /*#__PURE__*/React$2.createElement(Text$1, _extends$12({
    title: titleText
  }, textProps), children), closeable ? /*#__PURE__*/React$2.createElement(Action, _extends$12({
    "aria-hidden": true,
    role: "presentation"
  }, actionHandlers, sharedProps, actionProps), /*#__PURE__*/React$2.createElement(ActionIcon, _extends$12({
    size: actionSize
  }, actionIconProps))) : null);
});
Tag$1.displayName = 'Tag';
var Tag$2 = Tag$1;

const BADGE_KIND = {
    neutral25: 'neutral25',
    neutral50: 'neutral50',
    neutral75: 'neutral75',
    primary: 'primary',
    success: 'success',
};
const BadgeColors = new Map([
    [BADGE_KIND.success, {
            active: tokens$1.color['status-success-100'],
            primary: tokens$1.color['status-success-100'],
            secondary: tokens$1.color['status-success-25'],
        }],
    [BADGE_KIND.primary, {
            active: tokens$1.color['brand-primary'],
            primary: tokens$1.color['brand-primary-150'],
            secondary: tokens$1.color['brand-primary-10'],
            tertiary: tokens$1.color['brand-primary'],
        }],
    [BADGE_KIND.neutral25, {
            active: tokens$1.color['neutral-25'],
            primary: tokens$1.color['neutral-25'],
            secondary: tokens$1.color['neutral-25'],
            tertiary: tokens$1.color['neutral-75'],
        }],
    [BADGE_KIND.neutral50, {
            active: tokens$1.color['neutral-50'],
            primary: tokens$1.color['neutral-50'],
            secondary: tokens$1.color['neutral-50'],
            tertiary: tokens$1.color['neutral-0'],
        }],
    [BADGE_KIND.neutral75, {
            active: tokens$1.color['neutral-75'],
            primary: tokens$1.color['neutral-75'],
            secondary: tokens$1.color['neutral-75'],
            tertiary: tokens$1.color['neutral-0'],
        }],
]);

const setColors = (badgeKind, variant) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const isOutlined = variant === VARIANT.outlined;
    const transparentColor = 'transparent';
    let colorSettings;
    if (isOutlined) {
        colorSettings = {
            backgroundColor: transparentColor,
            ...borderColor(badgeKind === BADGE_KIND.primary
                ? (_a = BadgeColors.get(badgeKind)) === null || _a === void 0 ? void 0 : _a.tertiary
                : (_b = BadgeColors.get(badgeKind)) === null || _b === void 0 ? void 0 : _b.primary),
            color: badgeKind === BADGE_KIND.primary
                ? (_c = BadgeColors.get(badgeKind)) === null || _c === void 0 ? void 0 : _c.tertiary
                : (_d = BadgeColors.get(badgeKind)) === null || _d === void 0 ? void 0 : _d.primary,
        };
    }
    else {
        colorSettings = {
            backgroundColor: (_e = BadgeColors.get(badgeKind)) === null || _e === void 0 ? void 0 : _e.secondary,
            ...borderColor(transparentColor),
            color: badgeKind === BADGE_KIND.success || badgeKind === BADGE_KIND.primary
                ? (_f = BadgeColors.get(badgeKind)) === null || _f === void 0 ? void 0 : _f.primary
                : (_g = BadgeColors.get(badgeKind)) === null || _g === void 0 ? void 0 : _g.tertiary,
        };
    }
    return colorSettings;
};
const getIconColor = (badgeKind, variant) => {
    var _a, _b, _c, _d;
    const isOutlined = variant === VARIANT.outlined;
    if (isOutlined) {
        return badgeKind === BADGE_KIND.primary
            ? (_a = BadgeColors.get(badgeKind)) === null || _a === void 0 ? void 0 : _a.tertiary
            : (_b = BadgeColors.get(badgeKind)) === null || _b === void 0 ? void 0 : _b.primary;
    }
    return badgeKind === BADGE_KIND.success || badgeKind === BADGE_KIND.primary
        ? (_c = BadgeColors.get(badgeKind)) === null || _c === void 0 ? void 0 : _c.primary
        : (_d = BadgeColors.get(badgeKind)) === null || _d === void 0 ? void 0 : _d.tertiary;
};

const StyledText = themedWithStyle(Text, ({
    alignItems: 'center',
    display: 'flex',
}));
const StyledRoot$k = themedWithStyle(Root$9, ({ $badgeKind, $variant, $hasEndEnhancer, $closeable, $active, $disabled, $theme, }) => {
    var _a;
    return ({
        ...typography$6.LabelSmall,
        fontWeight: FontWeight.Bold,
        ...borderRadius('top', $theme.cornerRadius.pill),
        ...borderRadius('bottom', $theme.cornerRadius.pill),
        ...padding($theme.sizing['xxxx-small'], $theme.sizing['xx-small']),
        ...($hasEndEnhancer || $closeable
            ? { paddingRight: $theme.sizing['xxx-small'] }
            : {}),
        ...borderWidth('1px'),
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        ...margin('0px'),
        ...setColors($badgeKind, $variant),
        ...($closeable ? {
            ':active': {
                boxShadow: 'none',
            },
        } : {}),
        ...($active && $closeable ? {
            backgroundColor: (_a = BadgeColors.get($badgeKind)) === null || _a === void 0 ? void 0 : _a.active,
            boxShadow: 'none',
            color: $theme.colors['neutral-0'],
        } : {}),
        ':focus': {
            boxShadow: $theme.boxShadow.focus,
        },
        ':hover': {
            boxShadow: 'none',
        },
        width: 'fit-content',
        ...($disabled ? {
            cursor: 'not-allowed',
            opacity: $theme.opacity.disabled,
        } : {}),
    });
});
const StyledAction$1 = themedWithStyle(Action$1, ({ $disabled, $theme }) => ({
    ...($disabled ? { cursor: 'not-allowed' } : {}),
    marginLeft: $theme.sizing['xxx-small'],
}));
const EndIconContainer = themedStyled('div', ({ $theme }) => ({
    alignItems: 'center',
    display: 'flex',
    marginLeft: $theme.sizing['xxx-small'],
}));

const Tag = (props) => {
    const { children, closeable = false, endEnhancer: Icon, badgeKind = BADGE_KIND.primary, variant = VARIANT.solid, disabled = false, } = props;
    const [, theme] = themedUseStyletron();
    const [isHovered, setIsHovered] = React$2.useState(false);
    const [isActive, setIsActive] = React$2.useState(false);
    const iconSize = theme.iconScale.small;
    const iconColor = getIconColor(badgeKind, variant);
    const ActionOverride = useCallback((rootProps) => {
        const { children: actionChildren, onClick } = rootProps;
        return (React$2.createElement(StyledAction$1, { ...(!disabled && {
                onMouseDown: () => setIsActive(true),
                onMouseEnter: () => setIsHovered(true),
                onMouseLeave: () => {
                    setIsHovered(false);
                    setIsActive(false);
                },
                onMouseUp: (event) => {
                    setIsActive(false);
                    if (onClick) {
                        onClick(event);
                    }
                },
            }), "$disabled": disabled }, actionChildren));
    }, [disabled]);
    const ActionIconOverride = useCallback(() => {
        const color = isActive ? theme.colors['neutral-0'] : iconColor;
        const iconProps = {
            color,
            size: iconSize,
            ...(disabled ? { style: { cursor: 'not-allowed' } } : {}),
        };
        return isHovered
            ? React$2.createElement(CloseCircleFillIcon, { ...iconProps })
            : React$2.createElement(CloseCircleOutlineIcon, { ...iconProps });
    }, [isActive, iconColor, iconSize, disabled, isHovered]);
    const RootOverride = useCallback((rootProps) => (React$2.createElement(StyledRoot$k, { ...rootProps, "$active": isActive, "$badgeKind": badgeKind, "$hasEndEnhancer": !!Icon })), [isActive, badgeKind, Icon]);
    return (React$2.createElement(Tag$2, { ...props, variant: variant, closeable: closeable, overrides: {
            Action: ActionOverride,
            ActionIcon: ActionIconOverride,
            Root: RootOverride,
            Text: StyledText,
        } },
        children,
        Icon && (React$2.createElement(EndIconContainer, null,
            React$2.createElement(Icon, { size: iconSize, color: iconColor })))));
};

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var SIZE$5 = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};

var _PROGRESS_BAR_ROUNDED;

function _extends$11() { _extends$11 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }

function ownKeys$12(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$12(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$12(Object(source), true).forEach(function (key) { _defineProperty$1s(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$12(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1s(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getBarHeight(size) {
  var _SIZE$small$SIZE$medi;

  return (_SIZE$small$SIZE$medi = {}, _defineProperty$1s(_SIZE$small$SIZE$medi, SIZE$5.small, '2px'), _defineProperty$1s(_SIZE$small$SIZE$medi, SIZE$5.medium, '4px'), _defineProperty$1s(_SIZE$small$SIZE$medi, SIZE$5.large, '8px'), _SIZE$small$SIZE$medi)[size];
}

var StyledRoot$j = styled('div', function (props) {
  return {
    width: '100%'
  };
});
StyledRoot$j.displayName = "StyledRoot";
var StyledBarContainer$1 = styled('div', function (props) {
  var $theme = props.$theme;
  var sizing = $theme.sizing;
  return {
    display: 'flex',
    marginLeft: sizing.scale500,
    marginRight: sizing.scale500,
    marginTop: sizing.scale500,
    marginBottom: sizing.scale500
  };
});
StyledBarContainer$1.displayName = "StyledBarContainer";
var StyledBar$3 = styled('div', function (props) {
  var $theme = props.$theme,
      $size = props.$size,
      $steps = props.$steps;
  var colors = $theme.colors,
      sizing = $theme.sizing,
      borders = $theme.borders;
  var borderRadius = borders.useRoundedCorners ? sizing.scale0 : 0;
  return _objectSpread$12({
    borderTopLeftRadius: borderRadius,
    borderTopRightRadius: borderRadius,
    borderBottomRightRadius: borderRadius,
    borderBottomLeftRadius: borderRadius,
    backgroundColor: hexToRgb(colors.progressbarTrackFill, '0.16'),
    height: getBarHeight($size),
    flex: 1,
    overflow: 'hidden'
  }, $steps < 2 ? {} : {
    marginLeft: sizing.scale300,
    ':first-child': {
      marginLeft: '0'
    }
  });
});
StyledBar$3.displayName = "StyledBar";
var StyledBarProgress$1 = styled('div', function (props) {
  var $theme = props.$theme,
      $value = props.$value,
      $successValue = props.$successValue,
      $steps = props.$steps,
      $index = props.$index,
      $maxValue = props.$maxValue,
      _props$$minValue = props.$minValue,
      $minValue = _props$$minValue === void 0 ? 0 : _props$$minValue; // making sure this doesn't break existing use that use StyledBarProgress directly

  var maxValue = $maxValue ? $maxValue : $successValue;
  var colors = $theme.colors,
      sizing = $theme.sizing,
      borders = $theme.borders;
  var width = "".concat(100 - ($value - $minValue) * 100 / (maxValue - $minValue), "%");
  var stepStates = {
    default: 'default',
    awaits: 'awaits',
    inProgress: 'inProgress',
    completed: 'completed'
  };
  var stepState = stepStates.default;

  if ($steps > 1) {
    var stepValue = (maxValue - $minValue) / $steps;
    var currentValue = ($value - $minValue) / (maxValue - $minValue) * 100;
    var completedSteps = Math.floor(currentValue / stepValue);

    if ($index < completedSteps) {
      stepState = stepStates.completed;
    } else if ($index === completedSteps) {
      stepState = stepStates.inProgress;
    } else {
      stepState = stepStates.awaits;
    }
  }

  var borderRadius = borders.useRoundedCorners ? sizing.scale0 : 0;
  var animationStyles = {
    transform: "translateX(-".concat(width, ")")
  };
  var stepAnimationStyles = stepState === stepStates.inProgress ? {
    animationDuration: '2.1s',
    animationIterationCount: 'infinite',
    animationTimingFunction: $theme.animation.linearCurve,
    animationName: {
      '0%': {
        transform: 'translateX(-102%)',
        opacity: 1
      },
      '50%': {
        transform: 'translateX(0%)',
        opacity: 1
      },
      '100%': {
        transform: 'translateX(0%)',
        opacity: 0
      }
    }
  } : stepState === stepStates.completed ? {
    transform: 'translateX(0%)'
  } : {
    transform: 'translateX(-102%)'
  };
  return _objectSpread$12({
    borderTopLeftRadius: borderRadius,
    borderTopRightRadius: borderRadius,
    borderBottomRightRadius: borderRadius,
    borderBottomLeftRadius: borderRadius,
    backgroundColor: colors.accent,
    height: '100%',
    width: '100%',
    transform: 'translateX(-102%)',
    transition: 'transform 0.5s'
  }, $steps > 1 ? stepAnimationStyles : animationStyles);
});
StyledBarProgress$1.displayName = "StyledBarProgress";
var StyledInfiniteBar$1 = styled('div', function (props) {
  var $theme = props.$theme,
      _props$$isLeft = props.$isLeft,
      $isLeft = _props$$isLeft === void 0 ? false : _props$$isLeft,
      _props$$size = props.$size,
      $size = _props$$size === void 0 ? SIZE$5.medium : _props$$size;
  var colors = $theme.colors,
      sizing = $theme.sizing,
      borders = $theme.borders;
  var borderRadius = borders.useRoundedCorners ? sizing.scale0 : 0;
  var height = getBarHeight($size);
  var animationStyles = {
    display: 'inline-block',
    flex: 1,
    marginLeft: 'auto',
    marginRight: 'auto',
    transitionProperty: 'background-position',
    animationDuration: '1.5s',
    animationIterationCount: 'infinite',
    animationTimingFunction: $theme.animation.linearCurve,
    backgroundSize: '300% auto',
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: $isLeft ? '-50%' : '150%',
    backgroundImage: "linear-gradient(".concat($isLeft ? '90' : '270', "deg, transparent 0%, ").concat(colors.accent, " 25%, ").concat(colors.accent, " 75%, transparent 100%)"),
    animationName: $isLeft ? {
      '0%': {
        backgroundPositionX: '-50%'
      },
      '33%': {
        backgroundPositionX: '50%'
      },
      '66%': {
        backgroundPositionX: '50%'
      },
      '100%': {
        backgroundPositionX: '150%'
      }
    } : {
      '0%': {
        backgroundPositionX: '150%'
      },
      '33%': {
        backgroundPositionX: '50%'
      },
      '66%': {
        backgroundPositionX: '50%'
      },
      '100%': {
        backgroundPositionX: '-50%'
      }
    }
  };
  return _objectSpread$12(_objectSpread$12({}, $isLeft ? {
    borderTopLeftRadius: borderRadius,
    borderBottomLeftRadius: borderRadius
  } : {
    borderTopRightRadius: borderRadius,
    borderBottomRightRadius: borderRadius
  }), {}, {
    height: height
  }, animationStyles);
});
StyledInfiniteBar$1.displayName = "StyledInfiniteBar";
var StyledLabel$4 = styled('div', function (props) {
  return _objectSpread$12(_objectSpread$12({
    textAlign: 'center'
  }, props.$theme.typography.font150), {}, {
    color: props.$theme.colors.contentTertiary
  });
});
StyledLabel$4.displayName = "StyledLabel";
var PROGRESS_BAR_ROUNDED_SIZES = (_PROGRESS_BAR_ROUNDED = {}, _defineProperty$1s(_PROGRESS_BAR_ROUNDED, SIZE$5.large, {
  d: 'M47.5 4H71.5529C82.2933 4 91 12.9543 91 24C91 35.0457 82.2933 44 71.5529 44H23.4471C12.7067 44 4 35.0457 4 24C4 12.9543 12.7067 4 23.4471 4H47.5195',
  width: 95,
  height: 48,
  strokeWidth: 8,
  typography: 'LabelLarge'
}), _defineProperty$1s(_PROGRESS_BAR_ROUNDED, SIZE$5.medium, {
  d: 'M39 2H60.5833C69.0977 2 76 9.16344 76 18C76 26.8366 69.0977 34 60.5833 34H17.4167C8.90228 34 2 26.8366 2 18C2 9.16344 8.90228 2 17.4167 2H39.0195',
  width: 78,
  height: 36,
  strokeWidth: 4,
  typography: 'LabelMedium'
}), _defineProperty$1s(_PROGRESS_BAR_ROUNDED, SIZE$5.small, {
  d: 'M32 1H51.6271C57.9082 1 63 6.37258 63 13C63 19.6274 57.9082 25 51.6271 25H12.3729C6.09181 25 1 19.6274 1 13C1 6.37258 6.09181 1 12.3729 1H32.0195',
  width: 64,
  height: 26,
  strokeWidth: 2,
  typography: 'LabelSmall'
}), _PROGRESS_BAR_ROUNDED);
var StyledProgressBarRoundedRoot = styled('div', function (_ref) {
  var $size = _ref.$size,
      $inline = _ref.$inline;
  return {
    width: PROGRESS_BAR_ROUNDED_SIZES[$size].width + 'px',
    height: PROGRESS_BAR_ROUNDED_SIZES[$size].height + 'px',
    position: 'relative',
    display: $inline ? 'inline-flex' : 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };
});
StyledProgressBarRoundedRoot.displayName = "StyledProgressBarRoundedRoot";

var _StyledProgressBarRoundedSvg = styled('svg', function (_ref2) {
  var $size = _ref2.$size;
  return {
    width: PROGRESS_BAR_ROUNDED_SIZES[$size].width + 'px',
    height: PROGRESS_BAR_ROUNDED_SIZES[$size].height + 'px',
    position: 'absolute',
    fill: 'none'
  };
});

_StyledProgressBarRoundedSvg.displayName = "_StyledProgressBarRoundedSvg";
withWrapper(_StyledProgressBarRoundedSvg, function (Styled) {
  return function StyledProgressBarRoundedSvg(props) {
    return /*#__PURE__*/React__default.createElement(Styled, _extends$11({
      viewBox: "0 0 ".concat(PROGRESS_BAR_ROUNDED_SIZES[props.$size].width, " ").concat(PROGRESS_BAR_ROUNDED_SIZES[props.$size].height),
      xmlns: "http://www.w3.org/2000/svg"
    }, props));
  };
});

var _StyledProgressBarRoundedTrackBackground = styled('path', function (_ref3) {
  var $theme = _ref3.$theme,
      $size = _ref3.$size;
  return {
    stroke: $theme.colors.backgroundTertiary,
    strokeWidth: PROGRESS_BAR_ROUNDED_SIZES[$size].strokeWidth + 'px'
  };
});

_StyledProgressBarRoundedTrackBackground.displayName = "_StyledProgressBarRoundedTrackBackground";
withWrapper(_StyledProgressBarRoundedTrackBackground, function (Styled) {
  return function StyledProgressBarRoundedSvg(props) {
    return /*#__PURE__*/React__default.createElement(Styled, _extends$11({
      d: PROGRESS_BAR_ROUNDED_SIZES[props.$size].d
    }, props));
  };
});

var _StyledProgressBarRoundedTrackForeground = styled('path', function (_ref4) {
  var $theme = _ref4.$theme,
      $size = _ref4.$size,
      $visible = _ref4.$visible,
      $pathLength = _ref4.$pathLength,
      $pathProgress = _ref4.$pathProgress;
  return {
    visibility: $visible ? 'visible' : 'hidden',
    stroke: $theme.colors.borderAccent,
    strokeWidth: PROGRESS_BAR_ROUNDED_SIZES[$size].strokeWidth + 'px',
    strokeDasharray: $pathLength,
    strokeDashoffset: $pathLength * (1 - $pathProgress) + ''
  };
});

_StyledProgressBarRoundedTrackForeground.displayName = "_StyledProgressBarRoundedTrackForeground";
withWrapper(_StyledProgressBarRoundedTrackForeground, function (Styled) {
  return function StyledProgressBarRoundedSvg(props) {
    return /*#__PURE__*/React__default.createElement(Styled, _extends$11({
      d: PROGRESS_BAR_ROUNDED_SIZES[props.$size].d
    }, props));
  };
});
var StyledProgressBarRoundedText = styled('div', function (_ref5) {
  var $theme = _ref5.$theme,
      $size = _ref5.$size;
  return _objectSpread$12({
    color: $theme.colors.contentPrimary
  }, $theme.typography[PROGRESS_BAR_ROUNDED_SIZES[$size].typography]);
});
StyledProgressBarRoundedText.displayName = "StyledProgressBarRoundedText";

function _typeof$I(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$I = function _typeof(obj) { return typeof obj; }; } else { _typeof$I = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$I(obj); }

function _extends$10() { _extends$10 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }

function _slicedToArray$Q(arr, i) { return _arrayWithHoles$Q(arr) || _iterableToArrayLimit$Q(arr, i) || _unsupportedIterableToArray$S(arr, i) || _nonIterableRest$Q(); }

function _nonIterableRest$Q() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$S(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$S(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$S(o, minLen); }

function _arrayLikeToArray$S(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$Q(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$Q(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties$y(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$A(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$A(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$I(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$G(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$H(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$G(Constructor.prototype, protoProps); if (staticProps) _defineProperties$G(Constructor, staticProps); return Constructor; }

function _inherits$H(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$H(subClass, superClass); }

function _setPrototypeOf$H(o, p) { _setPrototypeOf$H = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$H(o, p); }

function _createSuper$G(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$G(); return function _createSuperInternal() { var Super = _getPrototypeOf$G(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$G(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$H(this, result); }; }

function _possibleConstructorReturn$H(self, call) { if (call && (_typeof$I(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$I(self); }

function _assertThisInitialized$I(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$G() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$G(o) { _getPrototypeOf$G = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$G(o); }

function _defineProperty$1r(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ProgressBar$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$H(ProgressBar, _React$Component);

  var _super = _createSuper$G(ProgressBar);

  function ProgressBar() {
    _classCallCheck$I(this, ProgressBar);

    return _super.apply(this, arguments);
  }

  _createClass$H(ProgressBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // TODO(v11): remove warning when switching default Spinner
      if (process.env.NODE_ENV !== "production") {
        if (this.props.errorMessage) {
          console.warn('baseui:ProgressBar The `errorMessage` prop is deprecated in WAI-ARIA v1.2.');
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$overrides = _this$props.overrides,
          overrides = _this$props$overrides === void 0 ? {} : _this$props$overrides,
          getProgressLabel = _this$props.getProgressLabel,
          value = _this$props.value,
          size = _this$props.size,
          steps = _this$props.steps,
          successValue = _this$props.successValue,
          minValue = _this$props.minValue,
          maxValue = _this$props.maxValue,
          showLabel = _this$props.showLabel,
          infinite = _this$props.infinite,
          errorMessage = _this$props.errorMessage,
          forwardedRef = _this$props.forwardedRef,
          restProps = _objectWithoutProperties$y(_this$props, ["overrides", "getProgressLabel", "value", "size", "steps", "successValue", "minValue", "maxValue", "showLabel", "infinite", "errorMessage", "forwardedRef"]);

      var ariaLabel = this.props['aria-label'] || this.props.ariaLabel; // fallback on successValue (and it's default) if maxValue is not set by user

      var maximumValue = maxValue !== 100 ? maxValue : successValue;

      var _getOverrides = getOverrides(overrides.Root, StyledRoot$j),
          _getOverrides2 = _slicedToArray$Q(_getOverrides, 2),
          Root = _getOverrides2[0],
          rootProps = _getOverrides2[1];

      var _getOverrides3 = getOverrides(overrides.BarContainer, StyledBarContainer$1),
          _getOverrides4 = _slicedToArray$Q(_getOverrides3, 2),
          BarContainer = _getOverrides4[0],
          barContainerProps = _getOverrides4[1];

      var _getOverrides5 = getOverrides(overrides.Bar, StyledBar$3),
          _getOverrides6 = _slicedToArray$Q(_getOverrides5, 2),
          Bar = _getOverrides6[0],
          barProps = _getOverrides6[1];

      var _getOverrides7 = getOverrides(overrides.BarProgress, StyledBarProgress$1),
          _getOverrides8 = _slicedToArray$Q(_getOverrides7, 2),
          BarProgress = _getOverrides8[0],
          barProgressProps = _getOverrides8[1];

      var _getOverrides9 = getOverrides(overrides.Label, StyledLabel$4),
          _getOverrides10 = _slicedToArray$Q(_getOverrides9, 2),
          Label = _getOverrides10[0],
          labelProps = _getOverrides10[1];

      var _getOverrides11 = getOverrides(overrides.InfiniteBar, StyledInfiniteBar$1),
          _getOverrides12 = _slicedToArray$Q(_getOverrides11, 2),
          InfiniteBar = _getOverrides12[0],
          infiniteBarProps = _getOverrides12[1];

      var sharedProps = {
        $infinite: infinite,
        $size: size,
        $steps: steps,
        $successValue: maximumValue,
        $minValue: minValue,
        $maxValue: maximumValue,
        $value: value
      };

      function renderProgressBar() {
        var children = [];

        for (var i = 0; i < steps; i++) {
          children.push( /*#__PURE__*/React$2.createElement(Bar, _extends$10({
            key: i
          }, sharedProps, barProps), /*#__PURE__*/React$2.createElement(BarProgress, _extends$10({
            $index: i
          }, sharedProps, barProgressProps))));
        }

        return children;
      }

      return (
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/role-supports-aria-props
        React$2.createElement(Root, _extends$10({
          ref: forwardedRef,
          "data-baseweb": "progress-bar",
          role: "progressbar",
          "aria-label": ariaLabel || getProgressLabel(value, maximumValue, minValue),
          "aria-valuenow": infinite ? null : value,
          "aria-valuemin": infinite ? null : minValue,
          "aria-valuemax": infinite ? null : maximumValue,
          "aria-invalid": errorMessage ? true : null,
          "aria-errormessage": errorMessage
        }, restProps, sharedProps, rootProps), /*#__PURE__*/React$2.createElement(BarContainer, _extends$10({}, sharedProps, barContainerProps), infinite ? /*#__PURE__*/React$2.createElement(React$2.Fragment, null, /*#__PURE__*/React$2.createElement(InfiniteBar, _extends$10({
          $isLeft: true,
          $size: sharedProps.$size
        }, infiniteBarProps)), /*#__PURE__*/React$2.createElement(InfiniteBar, _extends$10({
          $size: sharedProps.$size
        }, infiniteBarProps))) : renderProgressBar()), showLabel && /*#__PURE__*/React$2.createElement(Label, _extends$10({}, sharedProps, labelProps), getProgressLabel(value, maximumValue, minValue)))
      );
    }
  }]);

  return ProgressBar;
}(React$2.Component);

_defineProperty$1r(ProgressBar$1, "defaultProps", {
  getProgressLabel: function getProgressLabel(value, maxValue, minValue) {
    return "".concat(Math.round((value - minValue) / (maxValue - minValue) * 100), "% Loaded");
  },
  infinite: false,
  overrides: {},
  showLabel: false,
  size: SIZE$5.medium,
  steps: 1,
  successValue: 100,
  minValue: 0,
  maxValue: 100,
  value: 0
});

var ForwardedProgressBar = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    //$FlowExpectedError[cannot-spread-inexact]
    React$2.createElement(ProgressBar$1, _extends$10({
      forwardedRef: ref
    }, props))
  );
});
ForwardedProgressBar.displayName = 'ProgressBar';
var ProgressBar$2 = ForwardedProgressBar;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var SIZE$4 = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};

function ownKeys$11(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$11(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$11(Object(source), true).forEach(function (key) { _defineProperty$1q(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$11(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1q(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var spin = {
  from: {
    transform: 'rotate(0deg)'
  },
  to: {
    transform: 'rotate(360deg)'
  }
};
/**
 * Spinner icon overrides
 */

var Svg = styled('svg', function (props) {
  var $theme = props.$theme,
      $color = props.$color;
  return _objectSpread$11(_objectSpread$11({}, getSvgStyles$1(props)), {}, {
    fill: $color || $theme.colors.accent,
    cursor: 'wait',
    animationName: spin,
    animationDuration: $theme.animation.timing1000,
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear'
  });
});
Svg.displayName = "Svg";
var StyledTrackPath = styled('path', function (props) {
  return {
    fill: props.$theme.colors.spinnerTrackFill,
    opacity: 0.16
  };
});
StyledTrackPath.displayName = "StyledTrackPath";
var StyledActivePath = styled('path', function (props) {
  return {
    fill: props.$color || props.$theme.colors.accent
  };
}); // TODO(v11): Replace Spinner with SpinnerNext

StyledActivePath.displayName = "StyledActivePath";
var StyledSpinnerNext$1 = styled('i', function (_ref) {
  var $theme = _ref.$theme,
      _ref$$color = _ref.$color,
      $color = _ref$$color === void 0 ? $theme.colors.contentAccent : _ref$$color,
      $borderWidth = _ref.$borderWidth,
      _ref$$size = _ref.$size,
      $size = _ref$$size === void 0 ? SIZE$4.medium : _ref$$size;
  var borderSize = {
    large: $theme.sizing.scale300,
    medium: $theme.sizing.scale100,
    small: $theme.sizing.scale0
  }[$borderWidth || $size];
  var boxSize = {
    large: $theme.sizing.scale1000,
    medium: $theme.sizing.scale900,
    small: $theme.sizing.scale800
  }[$size];

  if (!borderSize) {
    borderSize = $theme.sizing[$borderWidth];

    if (!borderSize) {
      borderSize = "".concat(parseInt($borderWidth), "px");
    }
  }

  if (!boxSize) {
    boxSize = $theme.sizing[$size];

    if (!boxSize) {
      boxSize = "".concat(parseInt($size), "px");
    }
  }

  return {
    display: 'block',
    animationName: spin,
    animationDuration: $theme.animation.timing1000,
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear',
    borderLeftStyle: 'solid',
    borderRightStyle: 'solid',
    borderTopStyle: 'solid',
    borderBottomStyle: 'solid',
    borderRadius: '50%',
    borderTopColor: $color,
    borderRightColor: $theme.colors.backgroundTertiary,
    borderBottomColor: $theme.colors.backgroundTertiary,
    borderLeftColor: $theme.colors.backgroundTertiary,
    borderLeftWidth: borderSize,
    borderRightWidth: borderSize,
    borderTopWidth: borderSize,
    borderBottomWidth: borderSize,
    width: boxSize,
    height: boxSize,
    cursor: 'wait'
  };
});
StyledSpinnerNext$1.displayName = "StyledSpinnerNext";

function _typeof$H(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$H = function _typeof(obj) { return typeof obj; }; } else { _typeof$H = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$H(obj); }

function _extends$$() { _extends$$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }

function _slicedToArray$P(arr, i) { return _arrayWithHoles$P(arr) || _iterableToArrayLimit$P(arr, i) || _unsupportedIterableToArray$R(arr, i) || _nonIterableRest$P(); }

function _nonIterableRest$P() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$R(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$R(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$R(o, minLen); }

function _arrayLikeToArray$R(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$P(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$P(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$H(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$F(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$G(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$F(Constructor.prototype, protoProps); if (staticProps) _defineProperties$F(Constructor, staticProps); return Constructor; }

function _inherits$G(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$G(subClass, superClass); }

function _setPrototypeOf$G(o, p) { _setPrototypeOf$G = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$G(o, p); }

function _createSuper$F(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$F(); return function _createSuperInternal() { var Super = _getPrototypeOf$F(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$F(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$G(this, result); }; }

function _possibleConstructorReturn$G(self, call) { if (call && (_typeof$H(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$H(self); }

function _assertThisInitialized$H(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$F() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$F(o) { _getPrototypeOf$F = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$F(o); }

function _defineProperty$1p(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Spinner$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$G(Spinner, _React$Component);

  var _super = _createSuper$F(Spinner);

  function Spinner() {
    _classCallCheck$H(this, Spinner);

    return _super.apply(this, arguments);
  }

  _createClass$G(Spinner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // TODO(v11): remove warning when switching default Spinner
      if (process.env.NODE_ENV !== "production") {
        if (!this.props.$silenceV11DeprecationWarning) {
          console.warn("\u2756 [baseui] Please consider using \"StyledSpinnerNext\" instead of \"Spinner\". " + "In v11, \"StyledSpinnerNext\" will become the default \"Spinner\"" + " and the current SVG based implementation will be deprecated.");
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$overrides = this.props.overrides,
          overrides = _this$props$overrides === void 0 ? {} : _this$props$overrides;
      var mergedOverrides = mergeOverrides({
        Svg: Svg
      }, overrides);

      var _getOverrides = getOverrides(overrides.TrackPath, StyledTrackPath),
          _getOverrides2 = _slicedToArray$P(_getOverrides, 2),
          TrackPath = _getOverrides2[0],
          trackPathProps = _getOverrides2[1];

      var _getOverrides3 = getOverrides(overrides.ActivePath, StyledActivePath),
          _getOverrides4 = _slicedToArray$P(_getOverrides3, 2),
          ActivePath = _getOverrides4[0],
          activePathProps = _getOverrides4[1];

      return (
        /*#__PURE__*/
        // $FlowExpectedError[cannot-spread-inexact]
        React$2.createElement(Icon$1, _extends$$({
          "aria-label": 'Loading',
          "data-baseweb": "spinner",
          title: "Spinner",
          viewBox: "3 3 18 18"
        }, this.props, {
          overrides: mergedOverrides
        }), /*#__PURE__*/React$2.createElement(TrackPath, _extends$$({
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z",
          $color: this.props.color
        }, trackPathProps)), /*#__PURE__*/React$2.createElement(ActivePath, _extends$$({
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.9497 7.05015C14.2161 4.31648 9.78392 4.31648 7.05025 7.05015C6.65973 7.44067 6.02656 7.44067 5.63604 7.05015C5.24551 6.65962 5.24551 6.02646 5.63604 5.63593C9.15076 2.12121 14.8492 2.12121 18.364 5.63593C18.7545 6.02646 18.7545 6.65962 18.364 7.05015C17.9734 7.44067 17.3403 7.44067 16.9497 7.05015Z",
          $color: this.props.color
        }, activePathProps)))
      );
    }
  }]);

  return Spinner;
}(React$2.Component);

_defineProperty$1p(Spinner$1, "defaultProps", {
  color: '',
  size: 44,
  title: 'Loading',
  overrides: {}
});

var Spinner$2 = Spinner$1;

const getSpinnerDimensions = ($size) => {
    switch ($size) {
        case SIZE$4.small:
            return {
                height: '16px',
                width: '16px',
            };
        case SIZE$4.large:
            return {
                height: '44px',
                width: '44px',
            };
        default:
            return {};
    }
};

const StyledSpinnerNext = themedWithStyle(StyledSpinnerNext$1, ({ $size, $theme }) => ({
    ...getSpinnerDimensions($size),
    boxSizing: 'border-box',
    ...borderColor($theme.colors['brand-primary-10']),
    borderTopColor: $theme.colors['brand-primary-125'],
}));

const Spinner = (props) => {
    const { size = SIZE$4.large, ...restProps } = props;
    return (React__default.createElement(StyledSpinnerNext, { "$size": size, ...restProps }));
};

const Container = themedStyled('div', ({ $theme }) => ({
    alignItems: 'center',
    columnGap: $theme.sizing['xx-small'],
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
}));
const IconContainer = themedStyled('div', ({ $showLarge }) => ({
    alignItems: 'flex-start',
    columnGap: $showLarge ? tokens$1.spacing['x-small'] : tokens$1.spacing['xxx-small'],
    display: 'flex',
    flexDirection: 'row',
}));
const Panel = (props) => {
    const { children, noBorder = false, icon: Icon, iconProps = {}, badgeText, loading, } = props;
    const [, theme] = themedUseStyletron();
    const { level, size } = React$2.useContext(ParentContext);
    const isParent = level === 1;
    const showLarge = isParent && size === 'large';
    const HeaderOverride = useCallback((headerProps) => {
        const { $expanded, children: headerChildren } = headerProps;
        const caretProps = {
            color: theme.colors['neutral-50'],
            size: showLarge
                ? theme.iconScale.small
                : theme.iconScale['x-small'],
        };
        return (React$2.createElement(StyledHeader, { "$size": size, "$isParent": isParent, "$hasIcon": !!Icon, "$noBorder": noBorder, ...headerProps },
            React$2.createElement(Container, null,
                React$2.createElement(IconContainer, { "$showLarge": showLarge },
                    React$2.createElement("div", null, $expanded
                        ? React$2.createElement(CaretUpOutlineIcon, { ...caretProps })
                        : React$2.createElement(CaretDownOutlineIcon, { ...caretProps })),
                    headerChildren),
                loading
                    ? (React$2.createElement(Spinner, { size: SIZE$4.small }))
                    : (React$2.createElement(React$2.Fragment, null,
                        Icon && (React$2.createElement(Icon, { color: theme.colors['status-success-100'], size: theme.iconScale.regular, ...iconProps })),
                        badgeText && (React$2.createElement(Tag, { badgeKind: BADGE_KIND.neutral25 }, badgeText)))))));
    }, [showLarge, size, isParent, Icon, noBorder, loading, badgeText, iconProps]);
    return (React$2.createElement(BasePanel, { ...props, overrides: {
            Content: StyledContent$2,
            Header: {
                component: HeaderOverride,
            },
            PanelContainer: StyledPanelContainer,
            ToggleIcon: StyledToggleIcon,
        } }, children));
};

const StatefulPanel = (props) => {
    const { children, ...restProps } = props;
    return (React$2.createElement(StatefulPanelContainer$1, { ...restProps }, (componentProps) => React$2.createElement(Panel, { ...componentProps }, children)));
};

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var STYLE_TYPE = Object.freeze({
  default: 'default',
  toggle: 'toggle',
  toggle_round: 'toggle_round'
});
var LABEL_PLACEMENT = Object.freeze({
  top: 'top',
  right: 'right',
  bottom: 'bottom',
  left: 'left'
});
/* eslint-enable import/prefer-default-export */

function ownKeys$10(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$10(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$10(Object(source), true).forEach(function (key) { _defineProperty$1o(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$10(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1o(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getBorderColor(props) {
  var $disabled = props.$disabled,
      $checked = props.$checked,
      $isError = props.$isError,
      $error = props.$error,
      $isIndeterminate = props.$isIndeterminate,
      $theme = props.$theme,
      $isFocusVisible = props.$isFocusVisible;
  var colors = $theme.colors;

  if ($disabled) {
    return colors.tickFillDisabled;
  } else if ($checked || $isIndeterminate) {
    return 'transparent';
  } else if ($error || $isError) {
    return colors.borderError;
  } else if ($isFocusVisible) {
    return colors.borderSelected;
  } else {
    return colors.tickBorder;
  }
}

function getLabelPadding$1(props) {
  var _props$$labelPlacemen = props.$labelPlacement,
      $labelPlacement = _props$$labelPlacemen === void 0 ? '' : _props$$labelPlacemen,
      $theme = props.$theme;
  var sizing = $theme.sizing;
  var scale300 = sizing.scale300;
  var paddingDirection;

  switch ($labelPlacement) {
    case 'top':
      paddingDirection = 'Bottom';
      break;

    case 'bottom':
      paddingDirection = 'Top';
      break;

    case 'left':
      paddingDirection = 'Right';
      break;

    default:
    case 'right':
      paddingDirection = 'Left';
      break;
  }

  if ($theme.direction === 'rtl' && paddingDirection === 'Left') {
    paddingDirection = 'Right';
  } else if ($theme.direction === 'rtl' && paddingDirection === 'Right') {
    paddingDirection = 'Left';
  }

  return _defineProperty$1o({}, "padding".concat(paddingDirection), scale300);
}

function getBackgroundColor$2(props) {
  var $disabled = props.$disabled,
      $checked = props.$checked,
      $isIndeterminate = props.$isIndeterminate,
      $isError = props.$isError,
      $error = props.$error,
      $isHovered = props.$isHovered,
      $isActive = props.$isActive,
      $theme = props.$theme,
      $checkmarkType = props.$checkmarkType;
  var isToggle = $checkmarkType === STYLE_TYPE.toggle;
  var colors = $theme.colors;

  if ($disabled) {
    if (isToggle) {
      return colors.toggleFillDisabled;
    }

    if ($checked || $isIndeterminate) {
      return colors.tickFillDisabled;
    } else {
      return colors.tickFill;
    }
  } else if (($error || $isError) && ($isIndeterminate || $checked)) {
    if ($isActive) {
      return colors.tickFillErrorSelectedHoverActive;
    } else if ($isHovered) {
      return colors.tickFillErrorSelectedHover;
    } else {
      return colors.tickFillErrorSelected;
    }
  } else if ($error || $isError) {
    if ($isActive) {
      return colors.tickFillErrorHoverActive;
    } else if ($isHovered) {
      return colors.tickFillErrorHover;
    } else {
      return colors.tickFillError;
    }
  } else if ($isIndeterminate || $checked) {
    if ($isActive) {
      return colors.tickFillSelectedHoverActive;
    } else if ($isHovered) {
      return colors.tickFillSelectedHover;
    } else {
      return colors.tickFillSelected;
    }
  } else {
    if ($isActive) {
      return isToggle ? colors.sliderTrackFillActive : colors.tickFillActive;
    } else if ($isHovered) {
      return isToggle ? colors.sliderTrackFillHover : colors.tickFillHover;
    } else {
      return isToggle ? colors.toggleTrackFill : colors.tickFill;
    }
  }
}

function getLabelColor$1(props) {
  var $disabled = props.$disabled,
      $theme = props.$theme;
  var colors = $theme.colors;
  return $disabled ? colors.contentSecondary : colors.contentPrimary;
}

var Root$8 = styled('label', function (props) {
  var $disabled = props.$disabled,
      $labelPlacement = props.$labelPlacement;
  return {
    flexDirection: $labelPlacement === 'top' || $labelPlacement === 'bottom' ? 'column' : 'row',
    display: 'flex',
    alignItems: $labelPlacement === 'top' || $labelPlacement === 'bottom' ? 'center' : 'flex-start',
    cursor: $disabled ? 'not-allowed' : 'pointer',
    userSelect: 'none'
  };
});
Root$8.displayName = "Root";
var Checkmark = styled('span', function (props) {
  var $checked = props.$checked,
      $disabled = props.$disabled,
      $isError = props.$isError,
      $error = props.$error,
      $isIndeterminate = props.$isIndeterminate,
      $theme = props.$theme,
      $isFocusVisible = props.$isFocusVisible;
  var sizing = $theme.sizing,
      animation = $theme.animation;
  var tickColor = $disabled ? $theme.colors.tickMarkFillDisabled : $isError || $error ? $theme.colors.tickMarkFillError : $theme.colors.tickMarkFill;
  var indeterminate = encodeURIComponent("\n    <svg width=\"14\" height=\"4\" viewBox=\"0 0 14 4\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M14 0.5H0V3.5H14V0.5Z\" fill=\"".concat(tickColor, "\"/>\n    </svg>\n  "));
  var check = encodeURIComponent("\n    <svg width=\"17\" height=\"13\" viewBox=\"0 0 17 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M6.50002 12.6L0.400024 6.60002L2.60002 4.40002L6.50002 8.40002L13.9 0.900024L16.1 3.10002L6.50002 12.6Z\" fill=\"".concat(tickColor, "\"/>\n    </svg>\n  "));
  var borderRadius = $theme.borders.inputBorderRadius;
  var borderColor = getBorderColor(props);
  return {
    flex: '0 0 auto',
    transitionDuration: animation.timing200,
    transitionTimingFunction: animation.easeOutCurve,
    transitionProperty: 'background-image, border-color, background-color',
    width: sizing.scale700,
    height: sizing.scale700,
    left: '4px',
    top: '4px',
    boxSizing: 'border-box',
    borderLeftStyle: 'solid',
    borderRightStyle: 'solid',
    borderTopStyle: 'solid',
    borderBottomStyle: 'solid',
    borderLeftWidth: '3px',
    borderRightWidth: '3px',
    borderTopWidth: '3px',
    borderBottomWidth: '3px',
    borderLeftColor: borderColor,
    borderRightColor: borderColor,
    borderTopColor: borderColor,
    borderBottomColor: borderColor,
    borderTopLeftRadius: borderRadius,
    borderTopRightRadius: borderRadius,
    borderBottomRightRadius: borderRadius,
    borderBottomLeftRadius: borderRadius,
    outline: $isFocusVisible && $checked ? "3px solid ".concat($theme.colors.accent) : 'none',
    display: 'inline-block',
    verticalAlign: 'middle',
    backgroundImage: $isIndeterminate ? "url('data:image/svg+xml,".concat(indeterminate, "');") : $checked ? "url('data:image/svg+xml,".concat(check, "');") : null,
    backgroundColor: getBackgroundColor$2(props),
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    marginTop: $theme.sizing.scale0,
    marginBottom: $theme.sizing.scale0,
    marginLeft: $theme.sizing.scale0,
    marginRight: $theme.sizing.scale0
  };
});
Checkmark.displayName = "Checkmark";
var Label$3 = styled('div', function (props) {
  var $theme = props.$theme,
      $checkmarkType = props.$checkmarkType;
  var typography = $theme.typography;
  return _objectSpread$10(_objectSpread$10(_objectSpread$10({
    flex: $checkmarkType === STYLE_TYPE.toggle ? 'auto' : null,
    verticalAlign: 'middle'
  }, getLabelPadding$1(props)), {}, {
    color: getLabelColor$1(props)
  }, typography.LabelMedium), {}, {
    lineHeight: '24px'
  });
}); // tricky style for focus event cause display: none doesn't work

Label$3.displayName = "Label";
var Input$4 = styled('input', {
  opacity: 0,
  width: 0,
  height: 0,
  overflow: 'hidden',
  margin: 0,
  padding: 0,
  position: 'absolute'
});
Input$4.displayName = "Input";
var Toggle = styled('div', function (props) {
  if (props.$checkmarkType === STYLE_TYPE.toggle) {
    var borderRadius = props.$theme.borders.useRoundedCorners ? props.$theme.borders.radius200 : null;
    return _objectSpread$10(_objectSpread$10({}, expandBorderStyles(props.$theme.borders.border300)), {}, {
      alignItems: 'center',
      backgroundColor: props.$theme.colors.mono100,
      borderTopLeftRadius: borderRadius,
      borderTopRightRadius: borderRadius,
      borderBottomRightRadius: borderRadius,
      borderBottomLeftRadius: borderRadius,
      boxShadow: props.$isFocusVisible ? "0 0 0 3px ".concat(props.$theme.colors.accent) : props.$theme.lighting.shadow400,
      outline: 'none',
      display: 'flex',
      justifyContent: 'center',
      height: props.$theme.sizing.scale800,
      width: props.$theme.sizing.scale800
    });
  }

  if (props.$checkmarkType === STYLE_TYPE.toggle_round) {
    var backgroundColor = props.$theme.colors.toggleFill;

    if (props.$disabled) {
      backgroundColor = props.$theme.colors.toggleFillDisabled;
    } else if (props.$checked && (props.$error || props.$isError)) {
      backgroundColor = props.$theme.colors.borderError;
    } else if (props.$checked) {
      backgroundColor = props.$theme.colors.toggleFillChecked;
    }

    return {
      backgroundColor: backgroundColor,
      borderTopLeftRadius: '50%',
      borderTopRightRadius: '50%',
      borderBottomRightRadius: '50%',
      borderBottomLeftRadius: '50%',
      boxShadow: props.$isFocusVisible ? "0 0 0 3px ".concat(props.$theme.colors.accent) : props.$isHovered && !props.$disabled ? props.$theme.lighting.shadow500 : props.$theme.lighting.shadow400,
      outline: 'none',
      height: props.$theme.sizing.scale700,
      width: props.$theme.sizing.scale700,
      transform: props.$checked ? "translateX(".concat(props.$theme.direction === 'rtl' ? '-100%' : '100%', ")") : null,
      transition: "transform ".concat(props.$theme.animation.timing200)
    };
  }

  return {};
});
Toggle.displayName = "Toggle";
var ToggleInner = styled('div', function (props) {
  if (props.$checkmarkType === STYLE_TYPE.toggle) {
    // eslint-disable-next-line no-inner-declarations
    var backgroundColor = function backgroundColor() {
      if (props.$disabled) {
        return props.$theme.colors.sliderHandleInnerFillDisabled;
      }

      if (props.$isActive && props.$checked) {
        return props.$theme.colors.sliderHandleInnerFillSelectedActive;
      }

      if (props.$isHovered && props.$checked) {
        return props.$theme.colors.sliderHandleInnerFillSelectedHover;
      }

      return props.$theme.colors.toggleTrackFill;
    };

    return {
      height: props.$theme.sizing.scale300,
      width: props.$theme.sizing.scale0,
      borderTopLeftRadius: props.$theme.borders.radius100,
      borderTopRightRadius: props.$theme.borders.radius100,
      borderBottomRightRadius: props.$theme.borders.radius100,
      borderBottomLeftRadius: props.$theme.borders.radius100,
      backgroundColor: backgroundColor()
    };
  }

  if (props.$checkmarkType === STYLE_TYPE.toggle_round) {
    return {};
  }

  return {};
});
ToggleInner.displayName = "ToggleInner";
var ToggleTrack = styled('div', function (props) {
  if (props.$checkmarkType === STYLE_TYPE.toggle) {
    var borderRadius = props.$theme.borders.useRoundedCorners ? props.$theme.borders.radius200 : null;
    return {
      alignItems: 'center',
      backgroundColor: getBackgroundColor$2(props),
      borderTopLeftRadius: borderRadius,
      borderTopRightRadius: borderRadius,
      borderBottomRightRadius: borderRadius,
      borderBottomLeftRadius: borderRadius,
      display: 'flex',
      height: props.$theme.sizing.scale600,
      justifyContent: props.$checked ? 'flex-end' : 'flex-start',
      marginTop: props.$theme.sizing.scale100,
      marginBottom: props.$theme.sizing.scale100,
      marginLeft: props.$theme.sizing.scale100,
      marginRight: props.$theme.sizing.scale100,
      width: props.$theme.sizing.scale1000
    };
  }

  if (props.$checkmarkType === STYLE_TYPE.toggle_round) {
    var backgroundColor = props.$theme.colors.toggleTrackFill;

    if (props.$disabled) {
      backgroundColor = props.$theme.colors.toggleTrackFillDisabled;
    } else if ((props.$error || props.$isError) && props.$checked) {
      backgroundColor = props.$theme.colors.tickFillError;
    }

    return {
      alignItems: 'center',
      backgroundColor: backgroundColor,
      borderTopLeftRadius: '7px',
      borderTopRightRadius: '7px',
      borderBottomRightRadius: '7px',
      borderBottomLeftRadius: '7px',
      display: 'flex',
      height: props.$theme.sizing.scale550,
      marginTop: props.$theme.sizing.scale200,
      marginBottom: props.$theme.sizing.scale100,
      marginLeft: props.$theme.sizing.scale200,
      marginRight: props.$theme.sizing.scale100,
      width: props.$theme.sizing.scale1000
    };
  }

  return {};
});
ToggleTrack.displayName = "ToggleTrack";

function _typeof$G(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$G = function _typeof(obj) { return typeof obj; }; } else { _typeof$G = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$G(obj); }

function _extends$_() { _extends$_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }

function _classCallCheck$G(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$E(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$F(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$E(Constructor.prototype, protoProps); if (staticProps) _defineProperties$E(Constructor, staticProps); return Constructor; }

function _inherits$F(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$F(subClass, superClass); }

function _setPrototypeOf$F(o, p) { _setPrototypeOf$F = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$F(o, p); }

function _createSuper$E(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$E(); return function _createSuperInternal() { var Super = _getPrototypeOf$E(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$E(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$F(this, result); }; }

function _possibleConstructorReturn$F(self, call) { if (call && (_typeof$G(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$G(self); }

function _assertThisInitialized$G(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$E() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$E(o) { _getPrototypeOf$E = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$E(o); }

function _defineProperty$1n(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var stopPropagation$1 = function stopPropagation(e) {
  return e.stopPropagation();
};

var StatelessCheckbox = /*#__PURE__*/function (_React$Component) {
  _inherits$F(StatelessCheckbox, _React$Component);

  var _super = _createSuper$E(StatelessCheckbox);

  function StatelessCheckbox() {
    var _this;

    _classCallCheck$G(this, StatelessCheckbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1n(_assertThisInitialized$G(_this), "state", {
      isFocused: _this.props.autoFocus || false,
      isFocusVisible: false,
      isHovered: false,
      isActive: false
    });

    _defineProperty$1n(_assertThisInitialized$G(_this), "onMouseEnter", function (e) {
      _this.setState({
        isHovered: true
      });

      _this.props.onMouseEnter(e);
    });

    _defineProperty$1n(_assertThisInitialized$G(_this), "onMouseLeave", function (e) {
      _this.setState({
        isHovered: false,
        isActive: false
      });

      _this.props.onMouseLeave(e);
    });

    _defineProperty$1n(_assertThisInitialized$G(_this), "onMouseDown", function (e) {
      _this.setState({
        isActive: true
      });

      _this.props.onMouseDown(e);
    });

    _defineProperty$1n(_assertThisInitialized$G(_this), "onMouseUp", function (e) {
      _this.setState({
        isActive: false
      });

      _this.props.onMouseUp(e);
    });

    _defineProperty$1n(_assertThisInitialized$G(_this), "onFocus", function (e) {
      _this.setState({
        isFocused: true
      });

      _this.props.onFocus(e);

      if (isFocusVisible(e)) {
        _this.setState({
          isFocusVisible: true
        });
      }
    });

    _defineProperty$1n(_assertThisInitialized$G(_this), "onBlur", function (e) {
      _this.setState({
        isFocused: false
      });

      _this.props.onBlur(e);

      if (_this.state.isFocusVisible !== false) {
        _this.setState({
          isFocusVisible: false
        });
      }
    });

    _defineProperty$1n(_assertThisInitialized$G(_this), "isToggle", function () {
      return _this.props.checkmarkType === STYLE_TYPE.toggle || _this.props.checkmarkType === STYLE_TYPE.toggle_round;
    });

    return _this;
  }

  _createClass$F(StatelessCheckbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          autoFocus = _this$props.autoFocus,
          inputRef = _this$props.inputRef;

      if (autoFocus && inputRef.current) {
        inputRef.current.focus();
      } // TODO(v11)


      if (process.env.NODE_ENV !== "production") {
        if (this.props.checkmarkType === STYLE_TYPE.toggle) {
          console.warn("baseui:Checkbox The STYLE_TYPE.toggle value on the 'checkmarkType' prop does not conform to the current base design specification. " + 'Please update your code to STYLE_TYPE.toggle_round. This will be updated automatically in a future major version.');
        }

        if (this.props.isError) {
          console.warn('baseui:Checkbox Property "isError" will be removed in the next major version. Use "error" property instead.');
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var checkmarkType = this.props.checkmarkType;
      var _this$props2 = this.props,
          _this$props2$override = _this$props2.overrides,
          overrides = _this$props2$override === void 0 ? {} : _this$props2$override,
          onChange = _this$props2.onChange,
          _this$props2$labelPla = _this$props2.labelPlacement,
          labelPlacement = _this$props2$labelPla === void 0 ? this.isToggle() ? 'left' : 'right' : _this$props2$labelPla,
          inputRef = _this$props2.inputRef,
          isIndeterminate = _this$props2.isIndeterminate,
          isError = _this$props2.isError,
          error = _this$props2.error,
          disabled = _this$props2.disabled,
          value = _this$props2.value,
          name = _this$props2.name,
          type = _this$props2.type,
          checked = _this$props2.checked,
          children = _this$props2.children,
          required = _this$props2.required,
          title = _this$props2.title;
      var RootOverride = overrides.Root,
          CheckmarkOverride = overrides.Checkmark,
          LabelOverride = overrides.Label,
          InputOverride = overrides.Input,
          ToggleOverride = overrides.Toggle,
          ToggleInnerOverride = overrides.ToggleInner,
          ToggleTrackOverride = overrides.ToggleTrack;
      var Root = getOverride(RootOverride) || Root$8;
      var Checkmark$1 = getOverride(CheckmarkOverride) || Checkmark;
      var Label = getOverride(LabelOverride) || Label$3;
      var Input = getOverride(InputOverride) || Input$4;
      var Toggle$1 = getOverride(ToggleOverride) || Toggle;
      var ToggleInner$1 = getOverride(ToggleInnerOverride) || ToggleInner;
      var ToggleTrack$1 = getOverride(ToggleTrackOverride) || ToggleTrack;
      var inputEvents = {
        onChange: onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      };
      var mouseEvents = {
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp
      };
      var sharedProps = {
        $isFocused: this.state.isFocused,
        $isFocusVisible: this.state.isFocusVisible,
        $isHovered: this.state.isHovered,
        $isActive: this.state.isActive,
        $isError: isError,
        $error: error,
        $checked: checked,
        $isIndeterminate: isIndeterminate,
        $required: required,
        $disabled: disabled,
        $value: value,
        $checkmarkType: checkmarkType
      }; // TODO(v11) - add check for children (#2172)

      var labelComp = /*#__PURE__*/React$2.createElement(Label, _extends$_({
        $labelPlacement: labelPlacement
      }, sharedProps, getOverrideProps(LabelOverride)), this.props.containsInteractiveElement ?
      /*#__PURE__*/
      // Prevents the event from bubbling up to the label and moving focus to the radio button
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
      React$2.createElement("div", {
        onClick: function onClick(e) {
          return e.preventDefault();
        }
      }, children) : children);
      return /*#__PURE__*/React$2.createElement(Root, _extends$_({
        "data-baseweb": "checkbox",
        title: title || null,
        $labelPlacement: labelPlacement
      }, sharedProps, mouseEvents, getOverrideProps(RootOverride)), (labelPlacement === 'top' || labelPlacement === 'left') && labelComp, this.isToggle() ? /*#__PURE__*/React$2.createElement(ToggleTrack$1, _extends$_({}, sharedProps, getOverrideProps(ToggleTrackOverride)), /*#__PURE__*/React$2.createElement(Toggle$1, _extends$_({}, sharedProps, getOverrideProps(ToggleOverride)), /*#__PURE__*/React$2.createElement(ToggleInner$1, _extends$_({}, sharedProps, getOverrideProps(ToggleInnerOverride))))) : /*#__PURE__*/React$2.createElement(Checkmark$1, _extends$_({}, sharedProps, getOverrideProps(CheckmarkOverride))), /*#__PURE__*/React$2.createElement(Input, _extends$_({
        value: value,
        name: name,
        checked: checked,
        required: required,
        "aria-label": this.props['aria-label'] || this.props.ariaLabel,
        "aria-checked": isIndeterminate ? 'mixed' : checked,
        "aria-describedby": this.props['aria-describedby'],
        "aria-errormessage": this.props['aria-errormessage'],
        "aria-invalid": error || isError || null,
        "aria-required": required || null,
        disabled: disabled,
        type: type,
        ref: inputRef // Prevent a second click event from firing when label is clicked.
        // See https://github.com/uber/baseweb/issues/3847
        ,
        onClick: stopPropagation$1
      }, sharedProps, inputEvents, getOverrideProps(InputOverride))), (labelPlacement === 'bottom' || labelPlacement === 'right') && labelComp);
    }
  }]);

  return StatelessCheckbox;
}(React$2.Component);

_defineProperty$1n(StatelessCheckbox, "defaultProps", {
  overrides: {},
  checked: false,
  containsInteractiveElement: false,
  disabled: false,
  autoFocus: false,
  isIndeterminate: false,
  inputRef: /*#__PURE__*/React$2.createRef(),
  isError: false,
  error: false,
  type: 'checkbox',
  checkmarkType: STYLE_TYPE.default,
  onChange: function onChange() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onMouseDown: function onMouseDown() {},
  onMouseUp: function onMouseUp() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {}
});

var BaseCheckbox = StatelessCheckbox;

var CheckboxSize;
(function (CheckboxSize) {
    CheckboxSize[CheckboxSize["Mini"] = 0] = "Mini";
    CheckboxSize[CheckboxSize["Large"] = 1] = "Large";
})(CheckboxSize || (CheckboxSize = {}));

const StyledRoot$i = themedWithStyle(Root$8, ({ $disabled, $theme, }) => ({
    ...($disabled ? {
        opacity: $theme.opacity.disabled,
    } : {}),
}));
const StyledLabel$3 = themedWithStyle(Label$3, ({ $checked, $size, $theme }) => ({
    ...($size === CheckboxSize.Mini
        ? typography$6.LabelSmall
        : typography$6.LabelMedium),
    fontWeight: $checked ? FontWeight.Bold : FontWeight.Regular,
    marginTop: 0,
    paddingInlineStart: $theme.sizing['xx-small'],
}));
const StyledCheckmark = themedWithStyle(Checkmark, ({ $checked, $isHovered, $isFocused, $isIndeterminate, $size, $theme, }) => {
    const isMini = $size === CheckboxSize.Mini;
    const sizePx = isMini ? '12px' : '16px';
    const borderRadiusPx = isMini ? '1.5px' : '2px';
    const bgY = $checked && isMini ? '25%' : 'center';
    let bgColor;
    let bordColor;
    if ($checked || $isIndeterminate) {
        const fullColor = $isHovered
            ? $theme.colors['brand-primary-125'] : $theme.colors['brand-primary'];
        bgColor = fullColor;
        bordColor = fullColor;
    }
    else if ($isHovered) {
        bgColor = $theme.colors['neutral-25'];
        bordColor = $theme.colors['neutral-50'];
    }
    else {
        bgColor = $theme.colors['neutral-0'];
        bordColor = $theme.colors['neutral-50'];
    }
    return ({
        backgroundColor: bgColor,
        backgroundPositionY: $isIndeterminate && isMini ? '40%' : bgY,
        backgroundSize: $isIndeterminate && isMini ? '90%' : 'contain',
        boxShadow: $isFocused
            ? `0 0 0 3px ${$theme.colors['brand-primary-25']}` : 'none',
        height: sizePx,
        outline: 'none',
        width: sizePx,
        ...borderWidth(isMini ? '1.5px' : '2px'),
        ...borderRadius('top', borderRadiusPx),
        ...borderRadius('bottom', borderRadiusPx),
        ...borderColor(bordColor),
    });
});
const StyledToggle = themedWithStyle(Toggle, ({ $theme, }) => ({
    backgroundColor: $theme.colors['neutral-0'],
}));
const StyledToggleTrack = themedWithStyle(ToggleTrack, ({ $checked, $theme, }) => ({
    backgroundColor: $checked ? $theme.colors.primary : $theme.colors['neutral-50'],
}));

const Checkbox = (props) => {
    const { size = CheckboxSize.Large, ...otherProps } = props;
    const CheckmarkOverride = useCallback((checkmarkProps) => (React$2.createElement(StyledCheckmark, { ...{
            ...checkmarkProps,
            $size: size,
        } })), [size]);
    const LabelOverride = useCallback((checkmarkProps) => (React$2.createElement(StyledLabel$3, { ...{
            ...checkmarkProps,
            $size: size,
        } })), [size]);
    const ToggleOverride = useCallback((checkmarkProps) => (React$2.createElement(StyledToggle, { ...{
            ...checkmarkProps,
        } })), []);
    const ToggleTrackOverride = useCallback((checkmarkProps) => (React$2.createElement(StyledToggleTrack, { ...{
            ...checkmarkProps,
        } })), []);
    return (React$2.createElement(BaseCheckbox, { ...otherProps, overrides: {
            Checkmark: CheckmarkOverride,
            Label: LabelOverride,
            Root: StyledRoot$i,
            Toggle: ToggleOverride,
            ToggleTrack: ToggleTrackOverride,
        } }));
};

const Block = (props) => (React$2.createElement(Block$2, { ...props }));

function ownKeys$$(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$$(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$$(Object(source), true).forEach(function (key) { _defineProperty$1m(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$$(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1m(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var StyledRoot$h = styled('nav', function (_ref) {
  var $theme = _ref.$theme;
  return _objectSpread$$({
    color: $theme.colors.breadcrumbsText
  }, $theme.typography.font350);
});
StyledRoot$h.displayName = "StyledRoot";
var StyledList$2 = styled('ol', function (_ref2) {
  var $theme = _ref2.$theme;
  return _objectSpread$$({
    listStyleType: 'none',
    margin: 0,
    padding: 0
  }, $theme.typography.font350);
});
StyledList$2.displayName = "StyledList";
var StyledListItem$2 = styled('li', function (_ref3) {
  var $theme = _ref3.$theme;
  return _objectSpread$$({
    display: 'inline-block'
  }, $theme.typography.font350);
});
StyledListItem$2.displayName = "StyledListItem";
var StyledSeparator = styled('div', function (_ref4) {
  var $theme = _ref4.$theme;
  return {
    display: 'inline-block',
    color: $theme.colors.breadcrumbsSeparatorFill,
    marginLeft: $theme.sizing.scale300,
    marginRight: $theme.sizing.scale300,
    verticalAlign: 'middle'
  };
});
StyledSeparator.displayName = "StyledSeparator";

function _extends$Z() { _extends$Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }

function _slicedToArray$O(arr, i) { return _arrayWithHoles$O(arr) || _iterableToArrayLimit$O(arr, i) || _unsupportedIterableToArray$Q(arr, i) || _nonIterableRest$O(); }

function _nonIterableRest$O() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$Q(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$Q(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$Q(o, minLen); }

function _arrayLikeToArray$Q(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$O(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$O(arr) { if (Array.isArray(arr)) return arr; }
function Breadcrumbs$1(props) {
  var _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      _props$showTrailingSe = props.showTrailingSeparator,
      showTrailingSeparator = _props$showTrailingSe === void 0 ? false : _props$showTrailingSe;
  var childrenArray = Children.toArray(props.children);
  var childrenWithSeparators = [];

  var _getOverrides = getOverrides(overrides.Root, StyledRoot$h),
      _getOverrides2 = _slicedToArray$O(_getOverrides, 2),
      Root = _getOverrides2[0],
      baseRootProps = _getOverrides2[1];

  var _getOverrides3 = getOverrides(overrides.Icon, ChevronRight$2),
      _getOverrides4 = _slicedToArray$O(_getOverrides3, 2),
      Right = _getOverrides4[0],
      baseIconProps = _getOverrides4[1];

  var _getOverrides5 = getOverrides(overrides.Icon, ChevronLeft$2),
      _getOverrides6 = _slicedToArray$O(_getOverrides5, 1),
      Left = _getOverrides6[0];

  var _getOverrides7 = getOverrides(overrides.List, StyledList$2),
      _getOverrides8 = _slicedToArray$O(_getOverrides7, 2),
      List = _getOverrides8[0],
      baseListProps = _getOverrides8[1];

  var _getOverrides9 = getOverrides(overrides.ListItem, StyledListItem$2),
      _getOverrides10 = _slicedToArray$O(_getOverrides9, 2),
      ListItem = _getOverrides10[0],
      baseListItemProps = _getOverrides10[1];

  var _getOverrides11 = getOverrides(overrides.Separator, StyledSeparator),
      _getOverrides12 = _slicedToArray$O(_getOverrides11, 2),
      Separator = _getOverrides12[0],
      baseSeparatorProps = _getOverrides12[1];

  baseIconProps.overrides = mergeOverrides({
    Svg: {
      style: {
        verticalAlign: 'text-bottom'
      }
    }
  }, baseIconProps && baseIconProps.overrides);
  childrenArray.forEach(function (child, index) {
    childrenWithSeparators.push( /*#__PURE__*/React__default.createElement(ListItem, _extends$Z({
      key: "breadcrumb-item-".concat(index),
      $itemIndex: index
    }, baseListItemProps), child, (showTrailingSeparator || index !== childrenArray.length - 1) && /*#__PURE__*/React__default.createElement(Separator, _extends$Z({}, baseSeparatorProps, {
      key: "separator-".concat(index)
    }), /*#__PURE__*/React__default.createElement(ThemeContext.Consumer, null, function (theme) {
      return theme.direction === 'rtl' ? /*#__PURE__*/React__default.createElement(Left, baseIconProps) : /*#__PURE__*/React__default.createElement(Right, baseIconProps);
    }))));
  });
  return /*#__PURE__*/React__default.createElement(LocaleContext.Consumer, null, function (locale) {
    return /*#__PURE__*/React__default.createElement(Root, _extends$Z({
      "aria-label": props['aria-label'] || props.ariaLabel || locale.breadcrumbs.ariaLabel,
      "data-baseweb": "breadcrumbs"
    }, baseRootProps), /*#__PURE__*/React__default.createElement(List, baseListProps, childrenWithSeparators));
  });
}
Breadcrumbs$1.defaultProps = {
  overrides: {},
  showTrailingSeparator: false
};

const Breadcrumbs = (props) => (React$2.createElement(Breadcrumbs$1, { overrides: {
        List: {
            style: {
                lineHeight: '20px',
            },
        },
        ListItem: {
            style: {
                lineHeight: '20px',
            },
        },
        Root: {
            style: () => ({
                fontSize: '12px',
                lineHeight: '20px',
                padding: '16px',
            }),
        },
        Separator: {
            style: () => ({
                verticalAlign: 'baseline',
            }),
        },
    }, ...props }));

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var KIND$1 = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  minimal: 'minimal'
};
var SHAPE$1 = {
  default: 'default',
  pill: 'pill',
  round: 'round',
  circle: 'circle',
  square: 'square'
};
var SIZE$3 = {
  mini: 'mini',
  default: 'default',
  compact: 'compact',
  large: 'large'
};

function ownKeys$_(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$_(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$_(Object(source), true).forEach(function (key) { _defineProperty$1l(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$_(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1l(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var BaseButton = styled('button', function (_ref) {
  var $theme = _ref.$theme,
      $size = _ref.$size,
      $colors = _ref.$colors,
      $kind = _ref.$kind,
      $shape = _ref.$shape,
      $isLoading = _ref.$isLoading,
      $isSelected = _ref.$isSelected,
      $disabled = _ref.$disabled,
      $isFocusVisible = _ref.$isFocusVisible;
  return _objectSpread$_(_objectSpread$_(_objectSpread$_(_objectSpread$_(_objectSpread$_({
    display: 'inline-flex',
    // need to maintain button width while showing loading spinner
    flexDirection: $isLoading ? 'column' : 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftStyle: 'none',
    borderTopStyle: 'none',
    borderRightStyle: 'none',
    borderBottomStyle: 'none',
    outline: 'none',
    boxShadow: $isFocusVisible ? "inset 0 0 0 3px ".concat($theme.colors.accent) : 'none',
    textDecoration: 'none',
    WebkitAppearance: 'none',
    transitionProperty: 'background',
    transitionDuration: $theme.animation.timing200,
    transitionTimingFunction: $theme.animation.linearCurve,
    cursor: 'pointer',
    ':disabled': _objectSpread$_({
      cursor: 'not-allowed'
    }, getDisabledStyles({
      $theme: $theme,
      $kind: $kind,
      $disabled: $disabled,
      $isSelected: $isSelected
    })),
    marginLeft: 0,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0
  }, getFontStyles({
    $theme: $theme,
    $size: $size
  })), getBorderRadiiStyles({
    $theme: $theme,
    $size: $size,
    $shape: $shape
  })), getPaddingStyles({
    $theme: $theme,
    $size: $size,
    $shape: $shape
  })), getColorStyles({
    $theme: $theme,
    $colors: $colors,
    $kind: $kind,
    $isLoading: $isLoading,
    $isSelected: $isSelected,
    $disabled: $disabled
  })), getShapeStyles({
    $shape: $shape,
    $size: $size
  }));
});
BaseButton.displayName = "BaseButton";
var EndEnhancer = styled('div', function (_ref2) {
  var $theme = _ref2.$theme;
  var marginDirection = $theme.direction === 'rtl' ? 'marginRight' : 'marginLeft';
  return _defineProperty$1l({
    display: 'flex'
  }, marginDirection, $theme.sizing.scale500);
});
EndEnhancer.displayName = "EndEnhancer";
var StartEnhancer = styled('div', function (_ref4) {
  var $theme = _ref4.$theme;
  var marginDirection = $theme.direction === 'rtl' ? 'marginLeft' : 'marginRight';
  return _defineProperty$1l({
    display: 'flex'
  }, marginDirection, $theme.sizing.scale500);
});
StartEnhancer.displayName = "StartEnhancer";
var LoadingSpinnerContainer = styled('div', function (_ref6) {
  var $theme = _ref6.$theme,
      $size = _ref6.$size;
  // we don't have a theming value for this
  var margins = '3px';

  if ($size === SIZE$3.mini || $size === SIZE$3.compact) {
    margins = $theme.sizing.scale0;
  }

  if ($size === SIZE$3.large) {
    margins = $theme.sizing.scale100;
  }

  return {
    lineHeight: 0,
    position: 'static',
    marginBottom: margins,
    marginTop: margins
  };
});
LoadingSpinnerContainer.displayName = "LoadingSpinnerContainer";
var LoadingSpinner = styled('span', function (_ref7) {
  var $theme = _ref7.$theme,
      $kind = _ref7.$kind,
      $disabled = _ref7.$disabled,
      $size = _ref7.$size;

  var _getLoadingSpinnerCol = getLoadingSpinnerColors({
    $theme: $theme,
    $kind: $kind,
    $disabled: $disabled
  }),
      foreground = _getLoadingSpinnerCol.foreground,
      background = _getLoadingSpinnerCol.background;

  var dimension = $theme.sizing.scale550;

  if ($size === SIZE$3.mini || $size === SIZE$3.compact) {
    dimension = $theme.sizing.scale500;
  }

  if ($size === SIZE$3.large) {
    dimension = $theme.sizing.scale600;
  }

  return {
    height: dimension,
    width: dimension,
    borderTopLeftRadius: '50%',
    borderTopRightRadius: '50%',
    borderBottomRightRadius: '50%',
    borderBottomLeftRadius: '50%',
    borderLeftStyle: 'solid',
    borderTopStyle: 'solid',
    borderRightStyle: 'solid',
    borderBottomStyle: 'solid',
    borderLeftWidth: $theme.sizing.scale0,
    borderTopWidth: $theme.sizing.scale0,
    borderRightWidth: $theme.sizing.scale0,
    borderBottomWidth: $theme.sizing.scale0,
    borderTopColor: foreground,
    borderLeftColor: background,
    borderBottomColor: background,
    borderRightColor: background,
    boxSizing: 'border-box',
    display: 'inline-block',
    animationDuration: $theme.animation.timing700,
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
    animationName: {
      to: {
        transform: 'rotate(360deg)'
      },
      from: {
        transform: 'rotate(0deg)'
      }
    }
  };
});
LoadingSpinner.displayName = "LoadingSpinner";

function getLoadingSpinnerColors(_ref8) {
  var $theme = _ref8.$theme,
      $kind = _ref8.$kind,
      $disabled = _ref8.$disabled;

  if ($disabled) {
    return {
      foreground: $theme.colors.buttonDisabledSpinnerForeground,
      background: $theme.colors.buttonDisabledSpinnerBackground
    };
  }

  switch ($kind) {
    case KIND$1.secondary:
      {
        return {
          foreground: $theme.colors.buttonSecondarySpinnerForeground,
          background: $theme.colors.buttonSecondarySpinnerBackground
        };
      }

    case KIND$1.tertiary:
      {
        return {
          foreground: $theme.colors.buttonTertiarySpinnerForeground,
          background: $theme.colors.buttonTertiarySpinnerBackground
        };
      }

    case KIND$1.minimal:
      {
        return {
          foreground: $theme.colors.buttonMinimalSpinnerForeground,
          background: $theme.colors.buttonMinimalSpinnerBackground
        };
      }

    case KIND$1.primary:
    default:
      {
        return {
          foreground: $theme.colors.buttonPrimarySpinnerForeground,
          background: $theme.colors.buttonPrimarySpinnerBackground
        };
      }
  }
}

function getBorderRadiiStyles(_ref9) {
  var $theme = _ref9.$theme,
      $size = _ref9.$size,
      $shape = _ref9.$shape;
  var value = $theme.borders.buttonBorderRadius;

  if ($shape === SHAPE$1.pill) {
    if ($size === SIZE$3.compact) {
      value = '30px';
    } else if ($size === SIZE$3.large) {
      value = '42px';
    } else {
      value = '38px';
    }
  } else if ($shape === SHAPE$1.circle || $shape === SHAPE$1.round) {
    value = '50%';
  }

  return {
    borderTopRightRadius: value,
    borderBottomRightRadius: value,
    borderTopLeftRadius: value,
    borderBottomLeftRadius: value
  };
}

function getFontStyles(_ref10) {
  var $theme = _ref10.$theme,
      $size = _ref10.$size;

  switch ($size) {
    case SIZE$3.mini:
      return $theme.typography.font150;

    case SIZE$3.compact:
      return $theme.typography.font250;

    case SIZE$3.large:
      return $theme.typography.font450;

    default:
      return $theme.typography.font350;
  }
}

function getDisabledStyles(_ref11) {
  var $theme = _ref11.$theme,
      $kind = _ref11.$kind,
      $isSelected = _ref11.$isSelected,
      $disabled = _ref11.$disabled;

  if ($disabled && $isSelected) {
    if ($kind === KIND$1.primary || $kind === KIND$1.secondary) {
      return {
        color: $theme.colors.buttonDisabledActiveText,
        backgroundColor: $theme.colors.buttonDisabledActiveFill
      };
    } else if ($kind === KIND$1.minimal || $kind === KIND$1.tertiary) {
      return {
        backgroundColor: $theme.colors.buttonTertiaryDisabledActiveFill,
        color: $theme.colors.buttonTertiaryDisabledActiveText
      };
    }
  }

  return {
    backgroundColor: $kind === KIND$1.minimal || $kind === KIND$1.tertiary ? 'transparent' : $theme.colors.buttonDisabledFill,
    color: $theme.colors.buttonDisabledText
  };
}

function getPaddingStyles(_ref12) {
  var $theme = _ref12.$theme,
      $size = _ref12.$size,
      $shape = _ref12.$shape;
  var iconShape = $shape === SHAPE$1.square || $shape === SHAPE$1.circle || $shape === SHAPE$1.round;

  switch ($size) {
    case SIZE$3.mini:
      return {
        paddingTop: $theme.sizing.scale200,
        paddingBottom: $theme.sizing.scale200,
        paddingLeft: iconShape ? $theme.sizing.scale200 : $theme.sizing.scale300,
        paddingRight: iconShape ? $theme.sizing.scale200 : $theme.sizing.scale300
      };

    case SIZE$3.compact:
      return {
        paddingTop: $theme.sizing.scale400,
        paddingBottom: $theme.sizing.scale400,
        paddingLeft: iconShape ? $theme.sizing.scale400 : $theme.sizing.scale500,
        paddingRight: iconShape ? $theme.sizing.scale400 : $theme.sizing.scale500
      };

    case SIZE$3.large:
      return {
        paddingTop: $theme.sizing.scale600,
        paddingBottom: $theme.sizing.scale600,
        paddingLeft: iconShape ? $theme.sizing.scale600 : $theme.sizing.scale700,
        paddingRight: iconShape ? $theme.sizing.scale600 : $theme.sizing.scale700
      };

    default:
      return {
        paddingTop: $theme.sizing.scale550,
        paddingBottom: $theme.sizing.scale550,
        paddingLeft: iconShape ? $theme.sizing.scale550 : $theme.sizing.scale600,
        paddingRight: iconShape ? $theme.sizing.scale550 : $theme.sizing.scale600
      };
  }
}

function getColorStyles(_ref13) {
  var $theme = _ref13.$theme,
      $colors = _ref13.$colors,
      $isLoading = _ref13.$isLoading,
      $isSelected = _ref13.$isSelected,
      $kind = _ref13.$kind,
      $disabled = _ref13.$disabled;

  if ($colors) {
    return {
      color: $colors.color,
      backgroundColor: $colors.backgroundColor,
      ':hover': {
        boxShadow: 'inset 999px 999px 0px rgba(0, 0, 0, 0.04)'
      },
      ':active': {
        boxShadow: 'inset 999px 999px 0px rgba(0, 0, 0, 0.08)'
      }
    };
  }

  if ($disabled) {
    return Object.freeze({});
  }

  switch ($kind) {
    case KIND$1.primary:
      if ($isSelected) {
        return {
          color: $theme.colors.buttonPrimarySelectedText,
          backgroundColor: $theme.colors.buttonPrimarySelectedFill
        };
      }

      return {
        color: $theme.colors.buttonPrimaryText,
        backgroundColor: $theme.colors.buttonPrimaryFill,
        ':hover': {
          backgroundColor: $isLoading ? $theme.colors.buttonPrimaryActive : $theme.colors.buttonPrimaryHover
        },
        ':active': {
          backgroundColor: $theme.colors.buttonPrimaryActive
        }
      };

    case KIND$1.secondary:
      if ($isSelected) {
        return {
          color: $theme.colors.buttonPrimaryText,
          backgroundColor: $theme.colors.buttonPrimaryFill
        };
      }

      return {
        color: $theme.colors.buttonSecondaryText,
        backgroundColor: $theme.colors.buttonSecondaryFill,
        ':hover': {
          backgroundColor: $isLoading ? $theme.colors.buttonSecondaryActive : $theme.colors.buttonSecondaryHover
        },
        ':active': {
          backgroundColor: $theme.colors.buttonSecondaryActive
        }
      };

    case KIND$1.tertiary:
      if ($isSelected) {
        return {
          color: $theme.colors.buttonTertiarySelectedText,
          backgroundColor: $theme.colors.buttonTertiarySelectedFill
        };
      }

      return {
        color: $theme.colors.buttonTertiaryText,
        backgroundColor: $theme.colors.buttonTertiaryFill,
        ':hover': {
          backgroundColor: $isLoading ? $theme.colors.buttonTertiaryActive : $theme.colors.buttonTertiaryHover
        },
        ':active': {
          backgroundColor: $theme.colors.buttonTertiaryActive
        }
      };

    case KIND$1.minimal:
      if ($isSelected) {
        return {
          color: $theme.colors.buttonMinimalSelectedText,
          backgroundColor: $theme.colors.buttonMinimalSelectedFill
        };
      }

      return {
        color: $theme.colors.buttonMinimalText,
        backgroundColor: $theme.colors.buttonMinimalFill,
        ':hover': {
          backgroundColor: $isLoading ? $theme.colors.buttonMinimalActive : $theme.colors.buttonMinimalHover
        },
        ':active': {
          backgroundColor: $theme.colors.buttonMinimalActive
        }
      };

    default:
      return Object.freeze({});
  }
}

function getShapeStyles(_ref14) {
  var $shape = _ref14.$shape,
      $size = _ref14.$size;

  if ($shape === SHAPE$1.circle || $shape === SHAPE$1.square) {
    var height, width;

    switch ($size) {
      case SIZE$3.mini:
        height = '28px';
        width = '28px';
        break;

      case SIZE$3.compact:
        height = '36px';
        width = '36px';
        break;

      case SIZE$3.large:
        height = '56px';
        width = '56px';
        break;

      case SIZE$3.default:
      default:
        height = '48px';
        width = '48px';
        break;
    }

    return {
      height: height,
      width: width,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    };
  } else {
    return {};
  }
}

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function getSharedProps$1(_ref) {
  var colors = _ref.colors,
      disabled = _ref.disabled,
      isLoading = _ref.isLoading,
      isSelected = _ref.isSelected,
      kind = _ref.kind,
      shape = _ref.shape,
      size = _ref.size;
  return {
    $colors: colors,
    $disabled: disabled,
    $isLoading: isLoading,
    $isSelected: isSelected,
    $kind: kind,
    $shape: shape,
    $size: size
  };
}

function _extends$Y() { _extends$Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }

function _slicedToArray$N(arr, i) { return _arrayWithHoles$N(arr) || _iterableToArrayLimit$N(arr, i) || _unsupportedIterableToArray$P(arr, i) || _nonIterableRest$N(); }

function _nonIterableRest$N() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$P(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$P(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$P(o, minLen); }

function _arrayLikeToArray$P(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$N(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$N(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties$x(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$z(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$z(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function RenderEnhancer(props) {
  var Enhancer = props.Enhancer,
      restProps = _objectWithoutProperties$x(props, ["Enhancer"]);

  if (typeof Enhancer === 'string') {
    return Enhancer;
  }

  if (reactIs_2(Enhancer)) {
    // $FlowFixMe
    return /*#__PURE__*/React$2.createElement(Enhancer, restProps);
  } // $FlowFixMe


  return Enhancer;
}

function ButtonInternals(props) {
  var children = props.children,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      startEnhancer = props.startEnhancer,
      endEnhancer = props.endEnhancer;

  var _getOverrides = getOverrides(overrides.StartEnhancer, StartEnhancer),
      _getOverrides2 = _slicedToArray$N(_getOverrides, 2),
      StartEnhancer$1 = _getOverrides2[0],
      startEnhancerProps = _getOverrides2[1];

  var _getOverrides3 = getOverrides(overrides.EndEnhancer, EndEnhancer),
      _getOverrides4 = _slicedToArray$N(_getOverrides3, 2),
      EndEnhancer$1 = _getOverrides4[0],
      endEnhancerProps = _getOverrides4[1];

  var sharedProps = getSharedProps$1(props);
  return /*#__PURE__*/React$2.createElement(React$2.Fragment, null, startEnhancer !== null && startEnhancer !== undefined && /*#__PURE__*/React$2.createElement(StartEnhancer$1, _extends$Y({}, sharedProps, startEnhancerProps), /*#__PURE__*/React$2.createElement(RenderEnhancer, {
    Enhancer: startEnhancer
  })), children, endEnhancer !== null && endEnhancer !== undefined && /*#__PURE__*/React$2.createElement(EndEnhancer$1, _extends$Y({}, sharedProps, endEnhancerProps), /*#__PURE__*/React$2.createElement(RenderEnhancer, {
    Enhancer: endEnhancer
  })));
}

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var defaultProps$7 = {
  disabled: false,
  isLoading: false,
  isSelected: false,
  kind: KIND$1.primary,
  overrides: {},
  shape: SHAPE$1.default,
  size: SIZE$3.default
};

function _typeof$F(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$F = function _typeof(obj) { return typeof obj; }; } else { _typeof$F = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$F(obj); }

function _extends$X() { _extends$X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }

function ownKeys$Z(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$Z(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$Z(Object(source), true).forEach(function (key) { _defineProperty$1k(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$Z(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray$M(arr, i) { return _arrayWithHoles$M(arr) || _iterableToArrayLimit$M(arr, i) || _unsupportedIterableToArray$O(arr, i) || _nonIterableRest$M(); }

function _nonIterableRest$M() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$O(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$O(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$O(o, minLen); }

function _arrayLikeToArray$O(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$M(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$M(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties$w(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$y(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$y(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$F(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$D(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$E(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$D(Constructor.prototype, protoProps); if (staticProps) _defineProperties$D(Constructor, staticProps); return Constructor; }

function _inherits$E(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$E(subClass, superClass); }

function _setPrototypeOf$E(o, p) { _setPrototypeOf$E = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$E(o, p); }

function _createSuper$D(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$D(); return function _createSuperInternal() { var Super = _getPrototypeOf$D(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$D(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$E(this, result); }; }

function _possibleConstructorReturn$E(self, call) { if (call && (_typeof$F(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$F(self); }

function _assertThisInitialized$F(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$D() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$D(o) { _getPrototypeOf$D = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$D(o); }

function _defineProperty$1k(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Button$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$E(Button, _React$Component);

  var _super = _createSuper$D(Button);

  function Button() {
    var _this;

    _classCallCheck$F(this, Button);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty$1k(_assertThisInitialized$F(_this), "state", {
      isFocusVisible: false
    });

    _defineProperty$1k(_assertThisInitialized$F(_this), "internalOnClick", function () {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          onClick = _this$props.onClick;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      if (isLoading) {
        args[0].preventDefault();
        return;
      }

      onClick && onClick.apply(void 0, args);
    });

    _defineProperty$1k(_assertThisInitialized$F(_this), "handleFocus", function (event) {
      if (isFocusVisible(event)) {
        _this.setState({
          isFocusVisible: true
        });
      }
    });

    _defineProperty$1k(_assertThisInitialized$F(_this), "handleBlur", function (event) {
      if (_this.state.isFocusVisible !== false) {
        _this.setState({
          isFocusVisible: false
        });
      }
    });

    return _this;
  }

  _createClass$E(Button, [{
    key: "render",
    value: function render() {
      var _ref;

      var _this$props2 = this.props,
          _this$props2$override = _this$props2.overrides,
          overrides = _this$props2$override === void 0 ? {} : _this$props2$override;
          _this$props2.size;
          _this$props2.kind;
          _this$props2.shape;
          var isLoading = _this$props2.isLoading;
          _this$props2.isSelected;
          _this$props2.startEnhancer;
          _this$props2.endEnhancer;
          _this$props2.children;
          var forwardedRef = _this$props2.forwardedRef,
          restProps = _objectWithoutProperties$w(_this$props2, ["overrides", "size", "kind", "shape", "isLoading", "isSelected", "startEnhancer", "endEnhancer", "children", "forwardedRef"]); // Get overrides


      var _getOverrides = getOverrides( // adding both (1) BaseButton and (2) Root
      // (1) because it's a Button under the hood
      // (2) because we want consistency with the rest of the components
      overrides.BaseButton || overrides.Root, BaseButton),
          _getOverrides2 = _slicedToArray$M(_getOverrides, 2),
          BaseButton$1 = _getOverrides2[0],
          baseButtonProps = _getOverrides2[1];

      var _getOverrides3 = getOverrides(overrides.LoadingSpinner, LoadingSpinner),
          _getOverrides4 = _slicedToArray$M(_getOverrides3, 2),
          LoadingSpinner$1 = _getOverrides4[0],
          loadingSpinnerProps = _getOverrides4[1];

      var _getOverrides5 = getOverrides(overrides.LoadingSpinnerContainer, LoadingSpinnerContainer),
          _getOverrides6 = _slicedToArray$M(_getOverrides5, 2),
          LoadingSpinnerContainer$1 = _getOverrides6[0],
          loadingSpinnerContainerProps = _getOverrides6[1];

      var sharedProps = _objectSpread$Z(_objectSpread$Z({}, getSharedProps$1(this.props)), {}, {
        $isFocusVisible: this.state.isFocusVisible
      });

      return /*#__PURE__*/React$2.createElement(BaseButton$1, _extends$X({
        ref: forwardedRef,
        "data-baseweb": "button"
      }, isLoading ? (_ref = {}, _defineProperty$1k(_ref, 'aria-label', "loading ".concat(typeof this.props.children === 'string' ? this.props.children : '')), _defineProperty$1k(_ref, 'aria-busy', 'true'), _ref) : {}, sharedProps, restProps, baseButtonProps, {
        // Applies last to override passed in onClick
        onClick: this.internalOnClick,
        onFocus: forkFocus(_objectSpread$Z(_objectSpread$Z({}, restProps), baseButtonProps), this.handleFocus),
        onBlur: forkBlur(_objectSpread$Z(_objectSpread$Z({}, restProps), baseButtonProps), this.handleBlur)
      }), isLoading ? /*#__PURE__*/React$2.createElement(React$2.Fragment, null, /*#__PURE__*/React$2.createElement("div", {
        style: {
          opacity: 0,
          display: 'flex',
          height: '0px'
        }
      }, /*#__PURE__*/React$2.createElement(ButtonInternals, this.props)), /*#__PURE__*/React$2.createElement(LoadingSpinnerContainer$1, _extends$X({}, sharedProps, loadingSpinnerContainerProps), /*#__PURE__*/React$2.createElement(LoadingSpinner$1, _extends$X({}, sharedProps, loadingSpinnerProps)))) : /*#__PURE__*/React$2.createElement(ButtonInternals, this.props));
    }
  }]);

  return Button;
}(React$2.Component);

_defineProperty$1k(Button$1, "defaultProps", defaultProps$7);

var ForwardedButton = /*#__PURE__*/React$2.forwardRef( //$FlowFixMe
function (props, ref) {
  return /*#__PURE__*/React$2.createElement(Button$1, _extends$X({
    forwardedRef: ref
  }, props));
});
ForwardedButton.displayName = 'Button';
var Button$2 = ForwardedButton;

const typography$5 = {
    ButtonTertiary: {
        fontFamily: tokens$1['font-family'].heading,
        fontSize: tokens$1['font-size'].root,
        fontWeight: FontWeight.Regular,
        lineHeight: tokens$1['line-height'].label,
        textDecoration: 'underline',
        textUnderlinePosition: 'under',
    },
    ButtonTertiaryMini: {
        fontFamily: tokens$1['font-family'].heading,
        fontSize: tokens$1['font-size'].small,
        fontWeight: FontWeight.Regular,
        lineHeight: tokens$1['line-height']['label-small'],
        textDecoration: 'underline',
        textUnderlinePosition: 'under',
    },
};

const getButtonTypography = ($size, $kind, $theme) => {
    switch ($size) {
        case SIZE$3.large:
            return {
                ...typography$6.LabelLarge,
                fontWeight: FontWeight.Bold,
            };
        case SIZE$3.default:
            return $kind === KIND$1.tertiary
                ? {
                    ...typography$5.ButtonTertiary,
                    color: $theme.colors['brand-primary-125'],
                }
                : {
                    ...typography$6.LabelMedium,
                    fontWeight: FontWeight.Bold,
                };
        case SIZE$3.mini:
            return $kind === KIND$1.tertiary
                ? {
                    ...typography$5.ButtonTertiaryMini,
                    color: $theme.colors['brand-primary-125'],
                }
                : {
                    ...typography$6.LabelSmall,
                    fontWeight: FontWeight.Bold,
                };
        default:
            return {
                ...typography$6.LabelMedium,
                fontWeight: FontWeight.Bold,
            };
    }
};
const getButtonBackgroundColor = ($kind, $theme) => {
    switch ($kind) {
        case KIND$1.primary:
            return $theme.colors['brand-primary'];
        case KIND$1.secondary:
            return $theme.colors['neutral-0'];
        case KIND$1.tertiary:
            return 'transparent';
        default:
            return $theme.colors['brand-primary'];
    }
};
const getButtonHoverBackgroundColor = ($kind, $theme) => {
    switch ($kind) {
        case KIND$1.primary:
            return $theme.colors['brand-primary-125'];
        case KIND$1.secondary:
            return $theme.colors['neutral-25'];
        case KIND$1.tertiary:
            return 'transparent';
        default:
            return $theme.colors['brand-primary-125'];
    }
};
const getButtonColor = ($kind, $theme) => {
    switch ($kind) {
        case KIND$1.primary:
            return $theme.colors['neutral-0'];
        case KIND$1.secondary:
            return $theme.colors['neutral-75'];
        case KIND$1.tertiary:
            return $theme.colors['brand-primary-125'];
        default:
            return $theme.colors['neutral-0'];
    }
};
const getButtonActiveColor = ($kind, $theme) => {
    switch ($kind) {
        case KIND$1.primary:
            return $theme.colors['brand-primary-150'];
        case KIND$1.secondary:
            return $theme.colors['neutral-50'];
        case KIND$1.tertiary:
            return 'transparent';
        default:
            return $theme.colors['brand-primary-150'];
    }
};
const getButtonPadding = ($size, $kind, $theme) => {
    const paddingReduction = $kind === KIND$1.secondary
        ? $theme.sizing['xxxx-small']
        : '0px'; // reduce padding to match border width
    switch ($size) {
        case SIZE$3.large:
            return padding(math(`${$theme.sizing.small} - ${paddingReduction}`), math(`${$theme.sizing['x-large']} - ${paddingReduction}`));
        case SIZE$3.default:
            return $kind === KIND$1.tertiary ? padding('1px') : padding(math(`${$theme.sizing['x-small']} - ${paddingReduction}`), math(`${$theme.sizing.large} - ${paddingReduction}`));
        case SIZE$3.mini:
            return $kind === KIND$1.tertiary ? padding('1px') : padding(math(`${$theme.sizing['xxx-small']} - ${paddingReduction}`), math(`${$theme.sizing.small} - ${paddingReduction}`));
        default:
            return padding(math(`${$theme.sizing['x-small']} - ${paddingReduction}`), math(`${$theme.sizing.large} - ${paddingReduction}`));
    }
};
const getBorderRadius = ($kind, $theme) => {
    switch ($kind) {
        case KIND$1.tertiary:
            return {
                ...borderRadius('top', $theme.cornerRadius.default),
                ...borderRadius('bottom', $theme.cornerRadius.default),
            };
        default:
            return {
                ...borderRadius('top', $theme.cornerRadius.pill),
                ...borderRadius('bottom', $theme.cornerRadius.pill),
            };
    }
};
const getIconProps = ($size, $kind, $theme) => {
    let size;
    switch ($size) {
        case SIZE$3.large:
            size = $theme.iconScale.regular;
            break;
        case SIZE$3.default:
            size = $theme.iconScale.small;
            break;
        case SIZE$3.mini:
            size = $theme.iconScale['x-small'];
            break;
        default:
            size = $theme.iconScale.regular;
            break;
    }
    return {
        color: getButtonColor($kind, $theme),
        size,
    };
};
const getLoadingSpinnerContainerMargin = ($size, $theme) => {
    switch ($size) {
        case SIZE$3.large:
            return margin($theme.sizing['xxx-small'], 0);
        case SIZE$3.default:
            return margin($theme.sizing['xxxx-small'], 0);
        case SIZE$3.mini:
            return margin(0);
        default:
            return margin($theme.sizing['xxxx-small'], 0);
    }
};

const StyledBaseButton$1 = themedWithStyle(BaseButton, ({ $disabled, $isFocusVisible, $kind, $theme, $size = SIZE$3.default, }) => {
    const baseFocus = $kind === KIND$1.tertiary ? {
        ...borderWidth('2px'),
        ...borderColor($theme.colors['brand-primary-50']),
        ...borderStyle('solid'),
        boxShadow: 'none',
    } : {
        boxShadow: `0 0 0 3px ${$theme.colors['brand-primary-50']}`,
    };
    return ({
        ...getButtonTypography($size, $kind, $theme),
        ...($disabled
            ? {} : {
            ':hover': {
                backgroundColor: getButtonHoverBackgroundColor($kind, $theme),
                ...($kind === KIND$1.tertiary ? {
                    color: $theme.colors['brand-primary-150'],
                    textDecoration: 'underline',
                } : {}),
                ':active': {
                    backgroundColor: getButtonActiveColor($kind, $theme),
                    ...($kind === KIND$1.tertiary ? {
                        textDecoration: 'underline',
                    } : {}),
                },
            },
        }),
        backgroundColor: getButtonBackgroundColor($kind, $theme),
        color: getButtonColor($kind, $theme),
        ...($disabled ? {
            opacity: $theme.opacity.disabled,
            ...($kind === KIND$1.primary ? {
                ':disabled': {
                    backgroundColor: $theme.colors['brand-primary'],
                    color: getButtonColor($kind, $theme),
                },
            } : {}),
        } : {}),
        ...getBorderRadius($kind, $theme),
        ...($kind === KIND$1.secondary ? {
            ...borderColor($theme.colors['neutral-50']),
            ...borderWidth('2px'),
            ...borderStyle('solid'),
        } : {}),
        ...($isFocusVisible ? baseFocus : {}),
        ...getButtonPadding($size, $kind, $theme),
    });
});
const StyledStartEnhancer$2 = themedWithStyle(StartEnhancer, ({ $theme, }) => ({
    marginRight: $theme.sizing['xx-small'],
}));
const StyledLoadingSpinnerContainer = themedWithStyle(LoadingSpinnerContainer, ({ $size = SIZE$3.default, $theme, }) => ({
    ...getLoadingSpinnerContainerMargin($size, $theme),
}));

const Button = (props) => {
    const { startEnhancer: Icon, ...restProps } = props;
    const [, theme] = themedUseStyletron();
    const { size = SIZE$3.default, kind } = props;
    const LoadingSpinnerOverride = useCallback(() => React$2.createElement(Spinner, { size: SIZE$4.small }), []);
    return (React$2.createElement(Button$2, { startEnhancer: Icon && (React$2.createElement(Icon, { ...getIconProps(size, kind, theme) })), overrides: {
            BaseButton: StyledBaseButton$1,
            LoadingSpinner: LoadingSpinnerOverride,
            LoadingSpinnerContainer: StyledLoadingSpinnerContainer,
            StartEnhancer: StyledStartEnhancer$2,
        }, ...restProps }));
};

var BAR_SIZE;
(function (BAR_SIZE) {
    BAR_SIZE["Default"] = "default";
    BAR_SIZE["Small"] = "small";
})(BAR_SIZE || (BAR_SIZE = {}));

`${tokens$1['font-size'].root} ${tokens$1['font-family'].heading}`;
const SMALL_FONT = `${tokens$1['font-size'].small} ${tokens$1['font-family'].heading}`;
function smallTextWidth(canvasEl, inputText) {
    const context = canvasEl === null || canvasEl === void 0 ? void 0 : canvasEl.getContext('2d');
    if (context) {
        context.font = SMALL_FONT;
        return context.measureText(inputText).width || 0;
    }
    return 0;
}
function ellipsisText(canvasEl, text, textWidth) {
    let textString = text;
    let lastString = [];
    while (smallTextWidth(canvasEl, textString) > textWidth) {
        lastString = textString.split(' ');
        lastString.pop();
        textString = lastString.join(' ');
    }
    return `${textString}...`;
}

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var PLACEMENT$2 = {
  auto: 'auto',
  topLeft: 'topLeft',
  top: 'top',
  topRight: 'topRight',
  rightTop: 'rightTop',
  right: 'right',
  rightBottom: 'rightBottom',
  bottomRight: 'bottomRight',
  bottom: 'bottom',
  bottomLeft: 'bottomLeft',
  leftBottom: 'leftBottom',
  left: 'left',
  leftTop: 'leftTop'
};
var TRIGGER_TYPE = {
  click: 'click',
  hover: 'hover'
};
var STATE_CHANGE_TYPE$3 = {
  open: 'open',
  close: 'close'
};
var ACCESSIBILITY_TYPE = {
  none: 'none',
  menu: 'menu',
  tooltip: 'tooltip'
};
var POPOVER_MARGIN = 8;
var ARROW_SIZE = 6;
var ANIMATE_OUT_TIME = 0;
var ANIMATE_IN_TIME = 20;
/**
 * Since we use a 45-degree rotated div to render the arrow, the
 * width/height of this div is different than the arrow size itself
 *
 * The arrow size is essentially half the diagonal of the rotated div,
 * using pythagorean theorem:
 *   width^2 + height^2 = (arrow_size * 2)^2
 * In this case width = height so:
 *   2 * width^2 = (arrow_size * 2)^2
 * Simplifies to:
 *   width = √((arrow_size * 2)^2 / 2)
 */

var ARROW_WIDTH = Math.ceil(Math.sqrt(Math.pow(ARROW_SIZE * 2, 2) / 2));

function _typeof$E(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$E = function _typeof(obj) { return typeof obj; }; } else { _typeof$E = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$E(obj); }

function ownKeys$Y(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$Y(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$Y(Object(source), true).forEach(function (key) { _defineProperty$1j(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$Y(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck$E(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$C(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$D(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$C(Constructor.prototype, protoProps); if (staticProps) _defineProperties$C(Constructor, staticProps); return Constructor; }

function _inherits$D(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$D(subClass, superClass); }

function _setPrototypeOf$D(o, p) { _setPrototypeOf$D = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$D(o, p); }

function _createSuper$C(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$C(); return function _createSuperInternal() { var Super = _getPrototypeOf$C(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$C(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$D(this, result); }; }

function _possibleConstructorReturn$D(self, call) { if (call && (_typeof$E(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$E(self); }

function _assertThisInitialized$E(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$C() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$C(o) { _getPrototypeOf$C = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$C(o); }

function _defineProperty$1j(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultStateReducer$4 = function defaultStateReducer(type, nextState) {
  return nextState;
};

var StatefulContainer$6 = /*#__PURE__*/function (_React$Component) {
  _inherits$D(StatefulContainer, _React$Component);

  var _super = _createSuper$C(StatefulContainer);

  function StatefulContainer() {
    var _this;

    _classCallCheck$E(this, StatefulContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1j(_assertThisInitialized$E(_this), "state", _objectSpread$Y({
      isOpen: false
    }, _this.props.initialState));

    _defineProperty$1j(_assertThisInitialized$E(_this), "onBlur", function (e) {
      if (_this.props.onBlur) {
        _this.props.onBlur(e);
      }

      if (_this.props.focusLock || _this.props.autoFocus) {
        return;
      }

      _this.close();
    });

    _defineProperty$1j(_assertThisInitialized$E(_this), "onClick", function (e) {
      if (_this.props.onClick) {
        _this.props.onClick(e);
      }

      if (_this.state.isOpen) {
        _this.close();
      } else {
        _this.open();
      }
    });

    _defineProperty$1j(_assertThisInitialized$E(_this), "onClickOutside", function () {
      _this.close();
    });

    _defineProperty$1j(_assertThisInitialized$E(_this), "onEsc", function () {
      _this.close();
    });

    _defineProperty$1j(_assertThisInitialized$E(_this), "onFocus", function (e) {
      if (_this.props.onFocus) {
        _this.props.onFocus(e);
      }

      _this.open();
    });

    _defineProperty$1j(_assertThisInitialized$E(_this), "onMouseEnter", function (e) {
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(e);
      }

      _this.open();
    });

    _defineProperty$1j(_assertThisInitialized$E(_this), "onMouseLeave", function (e) {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(e);
      }

      _this.close();
    });

    _defineProperty$1j(_assertThisInitialized$E(_this), "onContentClose", function () {
      _this.close();
    });

    _defineProperty$1j(_assertThisInitialized$E(_this), "renderContent", function () {
      var content = _this.props.content;

      if (typeof content === 'function') {
        return content({
          close: _this.onContentClose
        });
      }

      return content;
    });

    return _this;
  }

  _createClass$D(StatefulContainer, [{
    key: "open",
    value: function open() {
      this.internalSetState(STATE_CHANGE_TYPE$3.open, {
        isOpen: true
      });

      if (this.props.onOpen) {
        this.props.onOpen();
      }
    }
  }, {
    key: "close",
    value: function close() {
      this.internalSetState(STATE_CHANGE_TYPE$3.close, {
        isOpen: false
      });

      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }, {
    key: "internalSetState",
    value: function internalSetState(type, changes) {
      var stateReducer = this.props.stateReducer;

      if (typeof stateReducer !== 'function') {
        this.setState(changes);
        return;
      }

      this.setState(function (prevState) {
        return stateReducer(type, changes, prevState);
      });
    }
    /**
     * If user passed a content render prop, we want to give them a
     * callback to close the Popover. This is useful in any case where
     * a dev wants to manually close the popover based on some action.
     *
     * One simple example is a Popover with a "Dismiss" button in it:
     * <StatefulPopover content={({close}) => <button onClick={close}>Dismiss</button>}>
     *  Click me
     * </StatefulPopover>
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          accessibilityType = _this$props.accessibilityType,
          autoFocus = _this$props.autoFocus,
          dismissOnClickOutside = _this$props.dismissOnClickOutside,
          dismissOnEsc = _this$props.dismissOnEsc,
          focusLock = _this$props.focusLock,
          ignoreBoundary = _this$props.ignoreBoundary,
          mountNode = _this$props.mountNode,
          onBlur = _this$props.onBlur,
          onClick = _this$props.onClick,
          onFocus = _this$props.onFocus,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseLeave = _this$props.onMouseLeave,
          onMouseEnterDelay = _this$props.onMouseEnterDelay,
          onMouseLeaveDelay = _this$props.onMouseLeaveDelay,
          overrides = _this$props.overrides,
          placement = _this$props.placement,
          popperOptions = _this$props.popperOptions,
          renderAll = _this$props.renderAll,
          returnFocus = _this$props.returnFocus,
          showArrow = _this$props.showArrow,
          triggerType = _this$props.triggerType,
          popoverMargin = _this$props.popoverMargin,
          focusOptions = _this$props.focusOptions;
      var popoverProps = {
        accessibilityType: accessibilityType,
        autoFocus: autoFocus,
        content: this.renderContent,
        focusLock: focusLock,
        ignoreBoundary: ignoreBoundary,
        isOpen: this.state.isOpen,
        mountNode: mountNode,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseEnterDelay: onMouseEnterDelay,
        onMouseLeaveDelay: onMouseLeaveDelay,
        overrides: overrides,
        placement: placement,
        popperOptions: popperOptions,
        renderAll: renderAll,
        returnFocus: returnFocus,
        showArrow: showArrow,
        triggerType: triggerType,
        popoverMargin: popoverMargin,
        focusOptions: focusOptions
      };

      if (dismissOnClickOutside) {
        popoverProps.onClickOutside = this.onClickOutside;
      }

      if (dismissOnEsc) {
        popoverProps.onEsc = this.onEsc;
      }

      if (triggerType === TRIGGER_TYPE.hover) {
        popoverProps.onBlur = this.onBlur;
        popoverProps.onFocus = this.onFocus;
        popoverProps.onMouseEnter = this.onMouseEnter;
        popoverProps.onMouseLeave = this.onMouseLeave;
      } else {
        popoverProps.onClick = this.onClick;
      }

      return this.props.children(popoverProps);
    }
  }]);

  return StatefulContainer;
}(React$2.Component);

_defineProperty$1j(StatefulContainer$6, "defaultProps", {
  accessibilityType: ACCESSIBILITY_TYPE.menu,
  ignoreBoundary: false,
  overrides: {},
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  placement: PLACEMENT$2.auto,
  popperOptions: {},
  showArrow: false,
  triggerType: TRIGGER_TYPE.click,
  dismissOnClickOutside: true,
  dismissOnEsc: true,
  stateReducer: defaultStateReducer$4,
  popoverMargin: POPOVER_MARGIN
});

var StatefulPopoverContainer = StatefulContainer$6;

function _objectWithoutPropertiesLoose$x(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends$W() {
  _extends$W = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$W.apply(this, arguments);
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$2;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;

var has$1 = has$2;

var printWarning$2 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret$1;
  var loggedTypeFailures = {};
  var has = has$1;

  printWarning$2 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$2(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$2(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

var checkPropTypes = checkPropTypes_1;

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret$1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var require$$1$4 = factoryWithTypeCheckers;

var require$$2$2 = factoryWithThrowingShims;

var propTypes$1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require$$1$4(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = require$$2$2();
}
});

var PropTypes = propTypes$1;
var propTypes_1 = propTypes$1.node;
var propTypes_2 = propTypes$1.bool;
var propTypes_3 = propTypes$1.string;
var propTypes_4 = propTypes$1.any;
var propTypes_5 = propTypes$1.arrayOf;
var propTypes_6 = propTypes$1.oneOfType;
var propTypes_7 = propTypes$1.object;
var propTypes_8 = propTypes$1.func;

var FOCUS_GROUP = 'data-focus-lock';
var FOCUS_DISABLED = 'data-focus-lock-disabled';
var FOCUS_ALLOW = 'data-no-focus-lock';
var FOCUS_AUTO = 'data-autofocus-inside';

/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
    return ref;
}

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
    var ref = useState(function () { return ({
        // value
        value: initialValue,
        // last callback
        callback: callback,
        // "memoized" public interface
        facade: {
            get current() {
                return ref.value;
            },
            set current(value) {
                var last = ref.value;
                if (last !== value) {
                    ref.value = value;
                    ref.callback(value, last);
                }
            }
        }
    }); })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
    return useCallbackRef(defaultValue, function (newValue) {
        return refs.forEach(function (ref) { return assignRef(ref, newValue); });
    });
}

var hiddenGuard = {
  width: '1px',
  height: '0px',
  padding: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: '1px',
  left: '1px'
};

process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function () {
            if (assigned) {
                throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            }
            if (buffer.length) {
                return buffer[buffer.length - 1];
            }
            return defaults;
        },
        useMedium: function (data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function () {
                buffer = buffer.filter(function (x) { return x !== item; });
            };
        },
        assignSyncMedium: function (cb) {
            assigned = true;
            while (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function (x) { return cb(x); },
                filter: function () { return buffer; },
            };
        },
        assignMedium: function (cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function () {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function () { return Promise.resolve().then(executeQueue); };
            cycle();
            buffer = {
                push: function (x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function (filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                },
            };
        },
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    return innerCreateMedium(defaults, middleware);
}
function createSidecarMedium(options) {
    if (options === void 0) { options = {}; }
    var medium = innerCreateMedium(null);
    medium.options = __assign({ async: true, ssr: false }, options);
    return medium;
}

var mediumFocus = createMedium({}, function (_ref) {
  var target = _ref.target,
      currentTarget = _ref.currentTarget;
  return {
    target: target,
    currentTarget: currentTarget
  };
});
var mediumBlur = createMedium();
var mediumEffect = createMedium();
var mediumSidecar = createSidecarMedium({
  async: true
});

var emptyArray = [];
var FocusLock$1 = /*#__PURE__*/React$2.forwardRef(function FocusLockUI(props, parentRef) {
  var _extends2;

  var _React$useState = React$2.useState(),
      realObserved = _React$useState[0],
      setObserved = _React$useState[1];

  var observed = React$2.useRef();
  var isActive = React$2.useRef(false);
  var originalFocusedElement = React$2.useRef(null);
  var children = props.children,
      disabled = props.disabled,
      noFocusGuards = props.noFocusGuards,
      persistentFocus = props.persistentFocus,
      crossFrame = props.crossFrame,
      autoFocus = props.autoFocus,
      allowTextSelection = props.allowTextSelection,
      group = props.group,
      className = props.className,
      whiteList = props.whiteList,
      hasPositiveIndices = props.hasPositiveIndices,
      _props$shards = props.shards,
      shards = _props$shards === void 0 ? emptyArray : _props$shards,
      _props$as = props.as,
      Container = _props$as === void 0 ? 'div' : _props$as,
      _props$lockProps = props.lockProps,
      containerProps = _props$lockProps === void 0 ? {} : _props$lockProps,
      SideCar = props.sideCar,
      shouldReturnFocus = props.returnFocus,
      focusOptions = props.focusOptions,
      onActivationCallback = props.onActivation,
      onDeactivationCallback = props.onDeactivation;

  var _React$useState2 = React$2.useState({}),
      id = _React$useState2[0]; // SIDE EFFECT CALLBACKS


  var onActivation = React$2.useCallback(function () {
    originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;

    if (observed.current && onActivationCallback) {
      onActivationCallback(observed.current);
    }

    isActive.current = true;
  }, [onActivationCallback]);
  var onDeactivation = React$2.useCallback(function () {
    isActive.current = false;

    if (onDeactivationCallback) {
      onDeactivationCallback(observed.current);
    }
  }, [onDeactivationCallback]);
  useEffect(function () {
    if (!disabled) {
      // cleanup return focus on trap deactivation
      // sideEffect/returnFocus should happen by this time
      originalFocusedElement.current = null;
    }
  }, []);
  var returnFocus = React$2.useCallback(function (allowDefer) {
    var returnFocusTo = originalFocusedElement.current;

    if (returnFocusTo && returnFocusTo.focus) {
      var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;

      if (howToReturnFocus) {
        var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
        originalFocusedElement.current = null;

        if (allowDefer) {
          // React might return focus after update
          // it's safer to defer the action
          Promise.resolve().then(function () {
            return returnFocusTo.focus(returnFocusOptions);
          });
        } else {
          returnFocusTo.focus(returnFocusOptions);
        }
      }
    }
  }, [shouldReturnFocus]); // MEDIUM CALLBACKS

  var onFocus = React$2.useCallback(function (event) {
    if (isActive.current) {
      mediumFocus.useMedium(event);
    }
  }, []);
  var onBlur = mediumBlur.useMedium; // REF PROPAGATION
  // not using real refs due to race conditions

  var setObserveNode = React$2.useCallback(function (newObserved) {
    if (observed.current !== newObserved) {
      observed.current = newObserved;
      setObserved(newObserved);
    }
  }, []);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof allowTextSelection !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn('React-Focus-Lock: allowTextSelection is deprecated and enabled by default');
    }

    React$2.useEffect(function () {
      if (!observed.current) {
        // eslint-disable-next-line no-console
        console.error('FocusLock: could not obtain ref to internal node');
      }
    }, []);
  }

  var lockProps = _extends$W((_extends2 = {}, _extends2[FOCUS_DISABLED] = disabled && 'disabled', _extends2[FOCUS_GROUP] = group, _extends2), containerProps);

  var hasLeadingGuards = noFocusGuards !== true;
  var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
  var mergedRef = useMergeRefs([parentRef, setObserveNode]);
  return /*#__PURE__*/React$2.createElement(React$2.Fragment, null, hasLeadingGuards && [
  /*#__PURE__*/
  // nearest focus guard
  React$2.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }), // first tabbed element guard
  hasPositiveIndices ? /*#__PURE__*/React$2.createElement("div", {
    key: "guard-nearest",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 1,
    style: hiddenGuard
  }) : null], !disabled && /*#__PURE__*/React$2.createElement(SideCar, {
    id: id,
    sideCar: mediumSidecar,
    observed: realObserved,
    disabled: disabled,
    persistentFocus: persistentFocus,
    crossFrame: crossFrame,
    autoFocus: autoFocus,
    whiteList: whiteList,
    shards: shards,
    onActivation: onActivation,
    onDeactivation: onDeactivation,
    returnFocus: returnFocus,
    focusOptions: focusOptions
  }), /*#__PURE__*/React$2.createElement(Container, _extends$W({
    ref: mergedRef
  }, lockProps, {
    className: className,
    onBlur: onBlur,
    onFocus: onFocus
  }), children), hasTailingGuards && /*#__PURE__*/React$2.createElement("div", {
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }));
});
FocusLock$1.propTypes = process.env.NODE_ENV !== "production" ? {
  children: propTypes_1,
  disabled: propTypes_2,
  returnFocus: propTypes_6([propTypes_2, propTypes_7, propTypes_8]),
  focusOptions: propTypes_7,
  noFocusGuards: propTypes_2,
  hasPositiveIndices: propTypes_2,
  allowTextSelection: propTypes_2,
  autoFocus: propTypes_2,
  persistentFocus: propTypes_2,
  crossFrame: propTypes_2,
  group: propTypes_3,
  className: propTypes_3,
  whiteList: propTypes_8,
  shards: propTypes_5(propTypes_4),
  as: propTypes_6([propTypes_3, propTypes_8, propTypes_7]),
  lockProps: propTypes_7,
  onActivation: propTypes_8,
  onDeactivation: propTypes_8,
  sideCar: propTypes_4.isRequired
} : {};
FocusLock$1.defaultProps = {
  children: undefined,
  disabled: false,
  returnFocus: false,
  focusOptions: undefined,
  noFocusGuards: false,
  autoFocus: true,
  persistentFocus: false,
  crossFrame: true,
  hasPositiveIndices: undefined,
  allowTextSelection: undefined,
  group: undefined,
  className: undefined,
  whiteList: undefined,
  shards: undefined,
  as: 'div',
  lockProps: {},
  onActivation: undefined,
  onDeactivation: undefined
};
var FocusLockUI = FocusLock$1;

function _setPrototypeOf$C(o, p) {
  _setPrototypeOf$C = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$C(o, p);
}

function _inheritsLoose$2(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$C(subClass, superClass);
}

function _defineProperty$1i(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function withSideEffect(reducePropsToState, handleStateChangeOnClient) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof reducePropsToState !== 'function') {
      throw new Error('Expected reducePropsToState to be a function.');
    }

    if (typeof handleStateChangeOnClient !== 'function') {
      throw new Error('Expected handleStateChangeOnClient to be a function.');
    }
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (process.env.NODE_ENV !== "production") {
      if (typeof WrappedComponent !== 'function') {
        throw new Error('Expected WrappedComponent to be a React component.');
      }
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));
      handleStateChangeOnClient(state);
    }

    var SideEffect = /*#__PURE__*/function (_PureComponent) {
      _inheritsLoose$2(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      var _proto = SideEffect.prototype;

      _proto.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return /*#__PURE__*/React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(PureComponent);

    _defineProperty$1i(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    return SideEffect;
  };
}

var toArray = function (a) {
    var ret = Array(a.length);
    for (var i = 0; i < a.length; ++i) {
        ret[i] = a[i];
    }
    return ret;
};
var asArray = function (a) { return (Array.isArray(a) ? a : [a]); };

var filterNested = function (nodes) {
    var contained = new Set();
    var l = nodes.length;
    for (var i = 0; i < l; i += 1) {
        for (var j = i + 1; j < l; j += 1) {
            var position = nodes[i].compareDocumentPosition(nodes[j]);
            if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) {
                contained.add(j);
            }
            if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) {
                contained.add(i);
            }
        }
    }
    return nodes.filter(function (_, index) { return !contained.has(index); });
};
var getTopParent = function (node) {
    return node.parentNode ? getTopParent(node.parentNode) : node;
};
var getAllAffectedNodes = function (node) {
    var nodes = asArray(node);
    return nodes.filter(Boolean).reduce(function (acc, currentNode) {
        var group = currentNode.getAttribute(FOCUS_GROUP);
        acc.push.apply(acc, (group
            ? filterNested(toArray(getTopParent(currentNode).querySelectorAll("[".concat(FOCUS_GROUP, "=\"").concat(group, "\"]:not([").concat(FOCUS_DISABLED, "=\"disabled\"])"))))
            : [currentNode]));
        return acc;
    }, []);
};

var getActiveElement = function () {
    return (document.activeElement
        ? document.activeElement.shadowRoot
            ? document.activeElement.shadowRoot.activeElement
            : document.activeElement
        : undefined);
};

var focusInFrame = function (frame) { return frame === document.activeElement; };
var focusInsideIframe = function (topNode) {
    return Boolean(toArray(topNode.querySelectorAll('iframe')).some(function (node) { return focusInFrame(node); }));
};
var focusInside = function (topNode) {
    var activeElement = document && getActiveElement();
    if (!activeElement || (activeElement.dataset && activeElement.dataset.focusGuard)) {
        return false;
    }
    return getAllAffectedNodes(topNode).reduce(function (result, node) { return result || node.contains(activeElement) || focusInsideIframe(node); }, false);
};

var focusIsHidden = function () {
    var activeElement = document && getActiveElement();
    if (!activeElement) {
        return false;
    }
    return toArray(document.querySelectorAll("[".concat(FOCUS_ALLOW, "]"))).some(function (node) { return node.contains(activeElement); });
};

var isElementHidden = function (node) {
    if (node.nodeType !== Node.ELEMENT_NODE) {
        return false;
    }
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) {
        return false;
    }
    return (computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden');
};
var isVisibleUncached = function (node, checkParent) {
    return !node ||
        node === document ||
        (node && node.nodeType === Node.DOCUMENT_NODE) ||
        (!isElementHidden(node) &&
            checkParent(node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE
                ?
                    node.parentNode.host
                : node.parentNode));
};
var isVisibleCached = function (visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) {
        return cached;
    }
    var result = isVisibleUncached(node, isVisibleCached.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var getDataset = function (node) {
    return node.dataset;
};
var isHTMLButtonElement = function (node) { return node.tagName === 'BUTTON'; };
var isHTMLInputElement = function (node) { return node.tagName === 'INPUT'; };
var isRadioElement = function (node) {
    return isHTMLInputElement(node) && node.type === 'radio';
};
var notHiddenInput = function (node) {
    return !((isHTMLInputElement(node) || isHTMLButtonElement(node)) && (node.type === 'hidden' || node.disabled)) &&
        !node.ariaDisabled;
};
var isGuard = function (node) { var _a; return Boolean(node && ((_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.focusGuard)); };
var isNotAGuard = function (node) { return !isGuard(node); };
var isDefined = function (x) { return Boolean(x); };

var findSelectedRadio = function (node, nodes) {
    return nodes
        .filter(isRadioElement)
        .filter(function (el) { return el.name === node.name; })
        .filter(function (el) { return el.checked; })[0] || node;
};
var correctNode = function (node, nodes) {
    if (isRadioElement(node) && node.name) {
        return findSelectedRadio(node, nodes);
    }
    return node;
};
var correctNodes = function (nodes) {
    var resultSet = new Set();
    nodes.forEach(function (node) { return resultSet.add(correctNode(node, nodes)); });
    return nodes.filter(function (node) { return resultSet.has(node); });
};

var pickFirstFocus = function (nodes) {
    if (nodes[0] && nodes.length > 1) {
        return correctNode(nodes[0], nodes);
    }
    return nodes[0];
};
var pickFocusable = function (nodes, index) {
    if (nodes.length > 1) {
        return nodes.indexOf(correctNode(nodes[index], nodes));
    }
    return index;
};

var NEW_FOCUS = 'NEW_FOCUS';
var newFocus = function (innerNodes, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = isGuard(activeElement);
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) {
        return undefined;
    }
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = correctNodes(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    var returnFirstNode = pickFocusable(innerNodes, 0);
    var returnLastNode = pickFocusable(innerNodes, cnt - 1);
    if (activeIndex === -1 || lastNodeInside === -1) {
        return NEW_FOCUS;
    }
    if (!indexDiff && lastNodeInside >= 0) {
        return lastNodeInside;
    }
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
        return returnLastNode;
    }
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
        return returnFirstNode;
    }
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) {
        return lastNodeInside;
    }
    if (activeIndex <= firstNodeIndex) {
        return returnLastNode;
    }
    if (activeIndex > lastNodeIndex) {
        return returnFirstNode;
    }
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) {
            return lastNodeInside;
        }
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    return undefined;
};

var tabSort = function (a, b) {
    var tabDiff = a.tabIndex - b.tabIndex;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!a.tabIndex) {
            return 1;
        }
        if (!b.tabIndex) {
            return -1;
        }
    }
    return tabDiff || indexDiff;
};
var orderByTabIndex = function (nodes, filterNegative, keepGuards) {
    return toArray(nodes)
        .map(function (node, index) { return ({
        node: node,
        index: index,
        tabIndex: keepGuards && node.tabIndex === -1 ? ((node.dataset || {}).focusGuard ? 0 : -1) : node.tabIndex,
    }); })
        .filter(function (data) { return !filterNegative || data.tabIndex >= 0; })
        .sort(tabSort);
};

var tabbables = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]',
];

var queryTabbables = tabbables.join(',');
var queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]");
var getFocusables = function (parents, withGuards) {
    return parents.reduce(function (acc, parent) {
        return acc.concat(toArray(parent.querySelectorAll(withGuards ? queryGuardTabbables : queryTabbables)), parent.parentNode
            ? toArray(parent.parentNode.querySelectorAll(queryTabbables)).filter(function (node) { return node === parent; })
            : []);
    }, []);
};
var getParentAutofocusables = function (parent) {
    var parentFocus = parent.querySelectorAll("[".concat(FOCUS_AUTO, "]"));
    return toArray(parentFocus)
        .map(function (node) { return getFocusables([node]); })
        .reduce(function (acc, nodes) { return acc.concat(nodes); }, []);
};

var filterFocusable = function (nodes, visibilityCache) {
    return toArray(nodes)
        .filter(function (node) { return isVisibleCached(visibilityCache, node); })
        .filter(function (node) { return notHiddenInput(node); });
};
var getTabbableNodes = function (topNodes, visibilityCache, withGuards) {
    return orderByTabIndex(filterFocusable(getFocusables(topNodes, withGuards), visibilityCache), true, withGuards);
};
var getAllTabbableNodes = function (topNodes, visibilityCache) {
    return orderByTabIndex(filterFocusable(getFocusables(topNodes), visibilityCache), false);
};
var parentAutofocusables = function (topNode, visibilityCache) {
    return filterFocusable(getParentAutofocusables(topNode), visibilityCache);
};

var getParents = function (node, parents) {
    if (parents === void 0) { parents = []; }
    parents.push(node);
    if (node.parentNode) {
        getParents(node.parentNode, parents);
    }
    return parents;
};
var getCommonParent = function (nodeA, nodeB) {
    var parentsA = getParents(nodeA);
    var parentsB = getParents(nodeB);
    for (var i = 0; i < parentsA.length; i += 1) {
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) {
            return currentParent;
        }
    }
    return false;
};
var getTopCommonParent = function (baseActiveElement, leftEntry, rightEntries) {
    var activeElements = asArray(baseActiveElement);
    var leftEntries = asArray(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function (entry) {
        topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function (subEntry) {
            var common = getCommonParent(activeElement, subEntry);
            if (common) {
                if (!topCommon || common.contains(topCommon)) {
                    topCommon = common;
                }
                else {
                    topCommon = getCommonParent(common, topCommon);
                }
            }
        });
    });
    return topCommon;
};
var allParentAutofocusables = function (entries, visibilityCache) {
    return entries.reduce(function (acc, node) { return acc.concat(parentAutofocusables(node, visibilityCache)); }, []);
};

var findAutoFocused = function (autoFocusables) {
    return function (node) { var _a; return node.autofocus || !!((_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.autofocus) || autoFocusables.indexOf(node) >= 0; };
};
var reorderNodes = function (srcNodes, dstNodes) {
    var remap = new Map();
    dstNodes.forEach(function (entity) { return remap.set(entity.node, entity); });
    return srcNodes.map(function (node) { return remap.get(node); }).filter(isDefined);
};
var getFocusMerge = function (topNode, lastNode) {
    var activeElement = document && getActiveElement();
    var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
    var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = getAllTabbableNodes(entries, visibilityCache);
    var innerElements = getTabbableNodes(entries, visibilityCache).filter(function (_a) {
        var node = _a.node;
        return isNotAGuard(node);
    });
    if (!innerElements[0]) {
        innerElements = anyFocusable;
        if (!innerElements[0]) {
            return undefined;
        }
    }
    var outerNodes = getAllTabbableNodes([commonParent], visibilityCache).map(function (_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = reorderNodes(outerNodes, innerElements);
    var innerNodes = orderedInnerElements.map(function (_a) {
        var node = _a.node;
        return node;
    });
    var newId = newFocus(innerNodes, outerNodes, activeElement, lastNode);
    if (newId === NEW_FOCUS) {
        var autoFocusable = anyFocusable
            .map(function (_a) {
            var node = _a.node;
            return node;
        })
            .filter(findAutoFocused(allParentAutofocusables(entries, visibilityCache)));
        return {
            node: autoFocusable && autoFocusable.length ? pickFirstFocus(autoFocusable) : pickFirstFocus(innerNodes),
        };
    }
    if (newId === undefined) {
        return newId;
    }
    return orderedInnerElements[newId];
};

var getFocusabledIn = function (topNode) {
    var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
    var commonParent = getTopCommonParent(topNode, topNode, entries);
    var visibilityCache = new Map();
    var outerNodes = getTabbableNodes([commonParent], visibilityCache, true);
    var innerElements = getTabbableNodes(entries, visibilityCache)
        .filter(function (_a) {
        var node = _a.node;
        return isNotAGuard(node);
    })
        .map(function (_a) {
        var node = _a.node;
        return node;
    });
    return outerNodes.map(function (_a) {
        var node = _a.node, index = _a.index;
        return ({
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: isGuard(node),
        });
    });
};

var focusOn = function (target, focusOptions) {
    if ('focus' in target) {
        target.focus(focusOptions);
    }
    if ('contentWindow' in target && target.contentWindow) {
        target.contentWindow.focus();
    }
};
var guardCount = 0;
var lockDisabled = false;
var setFocus = function (topNode, lastNode, options) {
    if (options === void 0) { options = {}; }
    var focusable = getFocusMerge(topNode, lastNode);
    if (lockDisabled) {
        return;
    }
    if (focusable) {
        if (guardCount > 2) {
            console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' +
                'See https://github.com/theKashey/focus-lock/#focus-fighting');
            lockDisabled = true;
            setTimeout(function () {
                lockDisabled = false;
            }, 1);
            return;
        }
        guardCount++;
        focusOn(focusable.node, options.focusOptions);
        guardCount--;
    }
};

var moveFocusInside = setFocus;

function deferAction(action) {
  // Hidding setImmediate from Webpack to avoid inserting polyfill
  var _window = window,
      setImmediate = _window.setImmediate;

  if (typeof setImmediate !== 'undefined') {
    setImmediate(action);
  } else {
    setTimeout(action, 1);
  }
}
var inlineProp = function inlineProp(name, value) {
  var obj = {};
  obj[name] = value;
  return obj;
};

var focusOnBody = function focusOnBody() {
  return document && document.activeElement === document.body;
};

var isFreeFocus = function isFreeFocus() {
  return focusOnBody() || focusIsHidden();
};

var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;
var focusWasOutsideWindow = false;

var defaultWhitelist = function defaultWhitelist() {
  return true;
};

var focusWhitelisted = function focusWhitelisted(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};

var recordPortal = function recordPortal(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode: observerNode,
    portaledElement: portaledElement
  };
};

var focusIsPortaledPair = function focusIsPortaledPair(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};

function autoGuard(startIndex, end, step, allNodes) {
  var lastGuard = null;
  var i = startIndex;

  do {
    var item = allNodes[i];

    if (item.guard) {
      if (item.node.dataset.focusAutoGuard) {
        lastGuard = item;
      }
    } else if (item.lockItem) {
      if (i !== startIndex) {
        // we will tab to the next element
        return;
      }

      lastGuard = null;
    } else {
      break;
    }
  } while ((i += step) !== end);

  if (lastGuard) {
    lastGuard.node.tabIndex = 0;
  }
}

var extractRef = function extractRef(ref) {
  return ref && 'current' in ref ? ref.current : ref;
};

var focusWasOutside = function focusWasOutside(crossFrameOption) {
  if (crossFrameOption) {
    // with cross frame return true for any value
    return Boolean(focusWasOutsideWindow);
  } // in other case return only of focus went a while aho


  return focusWasOutsideWindow === 'meanwhile';
};

var checkInHost = function checkInHost(check, el, boundary) {
  return el // find host equal to active element and check nested active element
  && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) // dive up
  || el.parentNode && checkInHost(check, el.parentNode, boundary));
};

var withinHost = function withinHost(activeElement, workingArea) {
  return workingArea.some(function (area) {
    return checkInHost(activeElement, area, area);
  });
};

var activateTrap = function activateTrap() {
  var result = false;

  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap,
        observed = _lastActiveTrap.observed,
        persistentFocus = _lastActiveTrap.persistentFocus,
        autoFocus = _lastActiveTrap.autoFocus,
        shards = _lastActiveTrap.shards,
        crossFrame = _lastActiveTrap.crossFrame,
        focusOptions = _lastActiveTrap.focusOptions;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    var activeElement = document && document.activeElement;

    if (workingNode) {
      var workingArea = [workingNode].concat(shards.map(extractRef).filter(Boolean));

      if (!activeElement || focusWhitelisted(activeElement)) {
        if (persistentFocus || focusWasOutside(crossFrame) || !isFreeFocus() || !lastActiveFocus && autoFocus) {
          if (workingNode && !( // active element is "inside" working area
          focusInside(workingArea) || // check for shadow-dom contained elements
          activeElement && withinHost(activeElement, workingArea) || focusIsPortaledPair(activeElement))) {
            if (document && !lastActiveFocus && activeElement && !autoFocus) {
              // Check if blur() exists, which is missing on certain elements on IE
              if (activeElement.blur) {
                activeElement.blur();
              }

              document.body.focus();
            } else {
              result = moveFocusInside(workingArea, lastActiveFocus, {
                focusOptions: focusOptions
              });
              lastPortaledElement = {};
            }
          }

          focusWasOutsideWindow = false;
          lastActiveFocus = document && document.activeElement;
        }
      }

      if (document) {
        var newActiveElement = document && document.activeElement;
        var allNodes = getFocusabledIn(workingArea);
        var focusedIndex = allNodes.map(function (_ref) {
          var node = _ref.node;
          return node;
        }).indexOf(newActiveElement);

        if (focusedIndex > -1) {
          // remove old focus
          allNodes.filter(function (_ref2) {
            var guard = _ref2.guard,
                node = _ref2.node;
            return guard && node.dataset.focusAutoGuard;
          }).forEach(function (_ref3) {
            var node = _ref3.node;
            return node.removeAttribute('tabIndex');
          });
          autoGuard(focusedIndex, allNodes.length, +1, allNodes);
          autoGuard(focusedIndex, -1, -1, allNodes);
        }
      }
    }
  }

  return result;
};

var onTrap = function onTrap(event) {
  if (activateTrap() && event) {
    // prevent scroll jump
    event.stopPropagation();
    event.preventDefault();
  }
};

var onBlur = function onBlur() {
  return deferAction(activateTrap);
};

var onFocus = function onFocus(event) {
  // detect portal
  var source = event.target;
  var currentNode = event.currentTarget;

  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};

var FocusWatcher = function FocusWatcher() {
  return null;
};

process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired
} : {};

var onWindowBlur = function onWindowBlur() {
  focusWasOutsideWindow = 'just'; // using setTimeout to set  this variable after React/sidecar reaction

  setTimeout(function () {
    focusWasOutsideWindow = 'meanwhile';
  }, 0);
};

var attachHandler = function attachHandler() {
  document.addEventListener('focusin', onTrap);
  document.addEventListener('focusout', onBlur);
  window.addEventListener('blur', onWindowBlur);
};

var detachHandler = function detachHandler() {
  document.removeEventListener('focusin', onTrap);
  document.removeEventListener('focusout', onBlur);
  window.removeEventListener('blur', onWindowBlur);
};

function reducePropsToState(propsList) {
  return propsList.filter(function (_ref5) {
    var disabled = _ref5.disabled;
    return !disabled;
  });
}

function handleStateChangeOnClient(traps) {
  var trap = traps.slice(-1)[0];

  if (trap && !lastActiveTrap) {
    attachHandler();
  }

  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
  lastActiveTrap = trap;

  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation(); // return focus only of last trap was removed

    if (!traps.filter(function (_ref6) {
      var id = _ref6.id;
      return id === lastTrap.id;
    }).length) {
      // allow defer is no other trap is awaiting restore
      lastTrap.returnFocus(!trap);
    }
  }

  if (trap) {
    lastActiveFocus = null;

    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation();
    }

    activateTrap();
    deferAction(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
} // bind medium


mediumFocus.assignSyncMedium(onFocus);
mediumBlur.assignMedium(onBlur);
mediumEffect.assignMedium(function (cb) {
  return cb({
    moveFocusInside: moveFocusInside,
    focusInside: focusInside
  });
});
var FocusTrap = withSideEffect(reducePropsToState, handleStateChangeOnClient)(FocusWatcher);

/* that would be a BREAKING CHANGE!
// delaying sidecar execution till the first usage
const RequireSideCar = (props) => {
  // eslint-disable-next-line global-require
  const SideCar = require('./Trap').default;
  return <SideCar {...props} />;
};
*/

var FocusLockCombination = /*#__PURE__*/React$2.forwardRef(function FocusLockUICombination(props, ref) {
  return /*#__PURE__*/React$2.createElement(FocusLockUI, _extends$W({
    sideCar: FocusTrap,
    ref: ref
  }, props));
});

var _ref = FocusLockUI.propTypes || {};
    _ref.sideCar;
    var propTypes = _objectWithoutPropertiesLoose$x(_ref, ["sideCar"]);

FocusLockCombination.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
var FocusLock = FocusLockCombination;

var useFocusInside = function useFocusInside(observedRef) {
  React$2.useEffect(function () {
    var enabled = true;
    mediumEffect.useMedium(function (car) {
      var observed = observedRef && observedRef.current;

      if (enabled && observed) {
        if (!car.focusInside(observed)) {
          car.moveFocusInside(observed, null);
        }
      }
    });
    return function () {
      enabled = false;
    };
  }, [observedRef]);
};

function MoveFocusInside(_ref) {
  var isDisabled = _ref.disabled,
      className = _ref.className,
      children = _ref.children;
  var ref = React$2.useRef(null);
  useFocusInside(isDisabled ? undefined : ref);
  return /*#__PURE__*/React$2.createElement("div", _extends$W({}, inlineProp(FOCUS_AUTO, !isDisabled), {
    ref: ref,
    className: className
  }), children);
}

MoveFocusInside.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string
} : {};
MoveFocusInside.defaultProps = {
  disabled: false,
  className: undefined
};

function ownKeys$X(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$X(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$X(Object(source), true).forEach(function (key) { _defineProperty$1h(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$X(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1h(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$L(arr, i) { return _arrayWithHoles$L(arr) || _iterableToArrayLimit$L(arr, i) || _unsupportedIterableToArray$N(arr, i) || _nonIterableRest$L(); }

function _nonIterableRest$L() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$N(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$N(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$N(o, minLen); }

function _arrayLikeToArray$N(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$L(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$L(arr) { if (Array.isArray(arr)) return arr; }
var OPPOSITE_POSITIONS = {
  top: 'bottom',
  bottom: 'top',
  right: 'left',
  left: 'right'
};
/**
 * Returns the opposite of the specified position. Useful for tooltip
 * positioning logic.
 * Examples:
 * top -> bottom
 * left -> right
 */

function getOppositePosition(position) {
  return OPPOSITE_POSITIONS[position];
}
/**
 * Determines whether or not the specified position is a vertical one (top or bottom)
 */

function isVerticalPosition(position) {
  return position === 'top' || position === 'bottom';
}
/**
 * Simple utility function for capitalizing the first letter of a string
 */

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
/**
 * Opposite of function above, converts from Popper.js placement
 * to our placement prop
 */

function fromPopperPlacement(placement) {
  var popoverPlacement = placement.replace(/(top|bottom)-start$/, '$1Left').replace(/(top|bottom)-end$/, '$1Right').replace(/(left|right)-start$/, '$1Top').replace(/(left|right)-end$/, '$1Bottom');
  return PLACEMENT$2[popoverPlacement] || null;
}
/**
 * Splits something like 'topLeft' to ['top', 'left'] for easier usage
 */

function splitPlacement(placement) {
  var matches = placement.match(/^([a-z]+)([A-Z][a-z]+)?/) || [];
  return matches.slice(1, 3).filter(Boolean).map(function (s) {
    return s.toLowerCase();
  });
}
/**
 * Returns margin styles to add spacing between the popover
 * and its anchor.
 */

function getPopoverMarginStyles(arrowSize, placement, popoverMargin) {
  var _splitPlacement = splitPlacement(placement),
      _splitPlacement2 = _slicedToArray$L(_splitPlacement, 1),
      position = _splitPlacement2[0];

  var opposite = getOppositePosition(position);

  if (!opposite) {
    return null;
  }

  var property = "margin".concat(capitalize(opposite));
  return _defineProperty$1h({}, property, "".concat(arrowSize + popoverMargin, "px"));
}
/**
 * Returns CSS rules for the popover animation start keyframe
 */

function getStartPosition(offset, placement, arrowSize, popoverMargin) {
  offset = _objectSpread$X({}, offset);

  var _splitPlacement3 = splitPlacement(placement),
      _splitPlacement4 = _slicedToArray$L(_splitPlacement3, 1),
      position = _splitPlacement4[0];

  var margin = (arrowSize > 0 ? arrowSize : popoverMargin) * 2;

  if (isVerticalPosition(position)) {
    offset.top += position === 'top' ? margin : -margin;
  } else {
    offset.left += position === 'left' ? margin : -margin;
  }

  return "translate3d(".concat(offset.left, "px, ").concat(offset.top, "px, 0)");
}
/**
 * Returns CSS rules for the popover animation end keyframe
 */

function getEndPosition(offset) {
  return "translate3d(".concat(offset.left, "px, ").concat(offset.top, "px, 0)");
}
/**
 * Returns top/left styles to position the popover arrow
 */

function getArrowPositionStyles(offsets, placement) {
  var _ref2;

  var _splitPlacement5 = splitPlacement(placement),
      _splitPlacement6 = _slicedToArray$L(_splitPlacement5, 1),
      position = _splitPlacement6[0];

  var oppositePosition = getOppositePosition(position);

  if (!oppositePosition) {
    return null;
  }

  var alignmentProperty = isVerticalPosition(position) ? 'left' : 'top';
  return _ref2 = {}, _defineProperty$1h(_ref2, alignmentProperty, "".concat(offsets[alignmentProperty], "px")), _defineProperty$1h(_ref2, oppositePosition, "-".concat(ARROW_SIZE - 2, "px")), _ref2;
}

function ownKeys$W(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$W(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$W(Object(source), true).forEach(function (key) { _defineProperty$1g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$W(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1g(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Main popover container element that gets positioned next to the anchor
 */
function getBodyStyles(props) {
  var $isOpen = props.$isOpen,
      $isAnimating = props.$isAnimating,
      $placement = props.$placement,
      $popoverOffset = props.$popoverOffset,
      $showArrow = props.$showArrow,
      $theme = props.$theme,
      $popoverMargin = props.$popoverMargin,
      $isHoverTrigger = props.$isHoverTrigger;
  return _objectSpread$W(_objectSpread$W({
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: $theme.colors.backgroundTertiary,
    borderTopLeftRadius: $theme.borders.popoverBorderRadius,
    borderTopRightRadius: $theme.borders.popoverBorderRadius,
    borderBottomRightRadius: $theme.borders.popoverBorderRadius,
    borderBottomLeftRadius: $theme.borders.popoverBorderRadius,
    boxShadow: $theme.lighting.shadow600,
    transitionProperty: 'opacity,transform',
    transitionDuration: $isAnimating ? '0.1s' : '0s',
    transitionTimingFunction: $isOpen ? $theme.animation.easeOutCurve : $theme.animation.easeInCurve,
    opacity: $isAnimating && $isOpen ? 1 : 0,
    transform: $isAnimating && $isOpen ? getEndPosition($popoverOffset) : getStartPosition($popoverOffset, $placement, $showArrow ? ARROW_SIZE : 0, $popoverMargin)
  }, getPopoverMarginStyles($showArrow ? ARROW_SIZE : 0, $placement, $popoverMargin)), $isHoverTrigger ? {
    animationDuration: '.1s',
    animationName: {
      '0%': {
        pointerEvents: 'none'
      },
      '99%': {
        pointerEvents: 'none'
      },
      '100%': {
        pointerEvents: 'auto'
      }
    }
  } : {});
}
var Body$3 = styled('div', getBodyStyles);
/**
 * Arrow shown between the popover and the anchor element
 */

Body$3.displayName = "Body";
function getArrowStyles(props) {
  var $arrowOffset = props.$arrowOffset,
      $placement = props.$placement,
      $theme = props.$theme;
  return _objectSpread$W({
    backgroundColor: $theme.colors.backgroundTertiary,
    boxShadow: $theme.lighting.shadow600,
    width: "".concat(ARROW_WIDTH, "px"),
    height: "".concat(ARROW_WIDTH, "px"),
    transform: 'rotate(45deg)',
    position: 'absolute'
  }, getArrowPositionStyles($arrowOffset, $placement));
}
var Arrow$1 = styled('div', getArrowStyles);
/**
 * Extra div that holds the popover content. This extra element
 * is needed for the arrow–the arrow is just a 45deg rotated div,
 * and rendering this extra element on top with a solid background
 * clips the part of the arrow that extends into the popover.
 */

Arrow$1.displayName = "Arrow";
function getInnerStyles(_ref) {
  var $theme = _ref.$theme;
  return {
    backgroundColor: $theme.colors.backgroundTertiary,
    borderTopLeftRadius: $theme.borders.popoverBorderRadius,
    borderTopRightRadius: $theme.borders.popoverBorderRadius,
    borderBottomRightRadius: $theme.borders.popoverBorderRadius,
    borderBottomLeftRadius: $theme.borders.popoverBorderRadius,
    color: $theme.colors.contentPrimary,
    position: 'relative'
  };
}
var Inner$1 = styled('div', getInnerStyles);
/**
 * A drop-in component that provides the recommended padding
 * for popovers. Mostly a convenience for users so they don't
 * have to define this themselves.
 */

Inner$1.displayName = "Inner";
var Padding = styled('div', {
  paddingLeft: '12px',
  paddingTop: '12px',
  paddingRight: '12px',
  paddingBottom: '12px'
});
Padding.displayName = "Padding";
var Hidden$1 = styled('div', {
  display: 'none'
});
Hidden$1.displayName = "Hidden";

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var baseDefaultProps$2 = {
  accessibilityType: ACCESSIBILITY_TYPE.menu,
  focusLock: false,
  autoFocus: true,
  returnFocus: true,
  // Remove the `ignoreBoundary` prop in the next major version
  // and have it replaced with the TetherBehavior props overrides
  ignoreBoundary: false,
  overrides: {},
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  placement: PLACEMENT$2.auto,
  showArrow: false,
  triggerType: TRIGGER_TYPE.click,
  renderAll: false
};
var defaultProps$6 = baseDefaultProps$2;

function ownKeys$V(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$V(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$V(Object(source), true).forEach(function (key) { _defineProperty$1f(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$V(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends$V() { _extends$V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }

function _typeof$D(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$D = function _typeof(obj) { return typeof obj; }; } else { _typeof$D = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$D(obj); }

function _classCallCheck$D(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$B(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$C(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$B(Constructor.prototype, protoProps); if (staticProps) _defineProperties$B(Constructor, staticProps); return Constructor; }

function _inherits$C(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$B(subClass, superClass); }

function _setPrototypeOf$B(o, p) { _setPrototypeOf$B = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$B(o, p); }

function _createSuper$B(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$B(); return function _createSuperInternal() { var Super = _getPrototypeOf$B(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$B(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$C(this, result); }; }

function _possibleConstructorReturn$C(self, call) { if (call && (_typeof$D(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$D(self); }

function _assertThisInitialized$D(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$B() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$B(o) { _getPrototypeOf$B = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$B(o); }

function _defineProperty$1f(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PopoverInner = /*#__PURE__*/function (_React$Component) {
  _inherits$C(PopoverInner, _React$Component);

  var _super = _createSuper$B(PopoverInner);

  function PopoverInner() {
    var _this;

    _classCallCheck$D(this, PopoverInner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1f(_assertThisInitialized$D(_this), "animateInTimer", void 0);

    _defineProperty$1f(_assertThisInitialized$D(_this), "animateOutTimer", void 0);

    _defineProperty$1f(_assertThisInitialized$D(_this), "animateOutCompleteTimer", void 0);

    _defineProperty$1f(_assertThisInitialized$D(_this), "onMouseEnterTimer", void 0);

    _defineProperty$1f(_assertThisInitialized$D(_this), "onMouseLeaveTimer", void 0);

    _defineProperty$1f(_assertThisInitialized$D(_this), "anchorRef", /*#__PURE__*/React$2.createRef());

    _defineProperty$1f(_assertThisInitialized$D(_this), "popperRef", /*#__PURE__*/React$2.createRef());

    _defineProperty$1f(_assertThisInitialized$D(_this), "arrowRef", /*#__PURE__*/React$2.createRef());

    _defineProperty$1f(_assertThisInitialized$D(_this), "state", _this.getDefaultState(_this.props));

    _defineProperty$1f(_assertThisInitialized$D(_this), "animateIn", function () {
      if (_this.props.isOpen) {
        _this.setState({
          isAnimating: true
        });
      }
    });

    _defineProperty$1f(_assertThisInitialized$D(_this), "animateOut", function () {
      if (!_this.props.isOpen) {
        _this.setState({
          isAnimating: true
        }); // Remove the popover from the DOM after animation finishes


        _this.animateOutCompleteTimer = setTimeout(function () {
          _this.setState({
            isAnimating: false,
            // Reset to ideal placement specified in props
            placement: _this.props.placement
          });
        }, _this.props.animateOutTime || ANIMATE_OUT_TIME);
      }
    });

    _defineProperty$1f(_assertThisInitialized$D(_this), "onAnchorClick", function (e) {
      if (_this.props.onClick) {
        _this.props.onClick(e);
      }
    });

    _defineProperty$1f(_assertThisInitialized$D(_this), "onAnchorMouseEnter", function (e) {
      // First clear any existing close timers, this ensures that the user can
      // move their mouse from the popover back to anchor without it hiding
      if (_this.onMouseLeaveTimer) {
        clearTimeout(_this.onMouseLeaveTimer);
      }

      _this.triggerOnMouseEnterWithDelay(e);
    });

    _defineProperty$1f(_assertThisInitialized$D(_this), "onAnchorMouseLeave", function (e) {
      // Clear any existing open timer, otherwise popover could be stuck open
      if (_this.onMouseEnterTimer) {
        clearTimeout(_this.onMouseEnterTimer);
      }

      _this.triggerOnMouseLeaveWithDelay(e);
    });

    _defineProperty$1f(_assertThisInitialized$D(_this), "onPopoverMouseEnter", function () {
      if (_this.onMouseLeaveTimer) {
        clearTimeout(_this.onMouseLeaveTimer);
      }
    });

    _defineProperty$1f(_assertThisInitialized$D(_this), "onPopoverMouseLeave", function (e) {
      _this.triggerOnMouseLeaveWithDelay(e);
    });

    _defineProperty$1f(_assertThisInitialized$D(_this), "onPopperUpdate", function (normalizedOffsets, data) {
      var placement = fromPopperPlacement(data.placement) || PLACEMENT$2.top;

      _this.setState({
        arrowOffset: normalizedOffsets.arrow,
        popoverOffset: normalizedOffsets.popper,
        placement: placement
      }); // Now that element has been positioned, we can animate it in


      _this.animateInTimer = setTimeout(_this.animateIn, ANIMATE_IN_TIME);
      return data;
    });

    _defineProperty$1f(_assertThisInitialized$D(_this), "triggerOnMouseLeave", function (e) {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(e);
      }
    });

    _defineProperty$1f(_assertThisInitialized$D(_this), "triggerOnMouseEnter", function (e) {
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(e);
      }
    });

    _defineProperty$1f(_assertThisInitialized$D(_this), "onDocumentClick", function (evt) {
      //$FlowFixMe
      var target = evt.composedPath ? evt.composedPath()[0] : evt.target;
      var popper = _this.popperRef.current;
      var anchor = _this.anchorRef.current; // Ignore document click if it came from popover or anchor

      if (!popper || popper === target || // eslint-disable-next-line cup/no-undef
      target instanceof Node && popper.contains(target)) {
        return;
      }

      if (!anchor || anchor === target || // eslint-disable-next-line cup/no-undef
      target instanceof Node && popper.contains(target)) {
        return;
      }

      if (_this.props.onClickOutside) {
        _this.props.onClickOutside(evt);
      }
    });

    return _this;
  }

  _createClass$C(PopoverInner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        isMounted: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this.init(prevProps, prevState);

      if (this.props.autoFocus && !this.state.autoFocusAfterPositioning && this.popperRef.current !== null && this.popperRef.current.getBoundingClientRect().top > 0) {
        this.setState({
          autoFocusAfterPositioning: true
        });
      }

      if (process.env.NODE_ENV !== "production") {
        if (!this.anchorRef.current) {
          // eslint-disable-next-line no-console
          console.warn("[baseui][Popover] ref has not been passed to the Popper's anchor element.\n              See how to pass the ref to an anchor element in the Popover example\n              http://baseui.design/components/popover#anchor-ref-handling-example");
        }
      }
    }
  }, {
    key: "init",
    value: function init(prevProps, prevState) {
      if (this.props.isOpen !== prevProps.isOpen || this.state.isMounted !== prevState.isMounted || this.state.isLayerMounted !== prevState.isLayerMounted) {
        // Transition from closed to open.
        if (this.props.isOpen && this.state.isLayerMounted) {
          // Clear any existing timers (like previous animateOutCompleteTimer)
          this.clearTimers();
          return;
        } // Transition from open to closed.


        if (!this.props.isOpen && prevProps.isOpen) {
          this.animateOutTimer = setTimeout(this.animateOut, 20);
          return;
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimers();
    }
  }, {
    key: "getDefaultState",
    value: function getDefaultState(props) {
      return {
        isAnimating: false,
        arrowOffset: {
          left: 0,
          top: 0
        },
        popoverOffset: {
          left: 0,
          top: 0
        },
        placement: props.placement,
        isMounted: false,
        isLayerMounted: false,
        autoFocusAfterPositioning: false
      };
    }
  }, {
    key: "clearTimers",
    value: function clearTimers() {
      [this.animateInTimer, this.animateOutTimer, this.animateOutCompleteTimer, this.onMouseEnterTimer, this.onMouseLeaveTimer].forEach(function (timerId) {
        if (timerId) {
          clearTimeout(timerId);
        }
      });
    }
  }, {
    key: "triggerOnMouseLeaveWithDelay",
    value: function triggerOnMouseLeaveWithDelay(e) {
      var _this2 = this;

      var onMouseLeaveDelay = this.props.onMouseLeaveDelay;

      if (onMouseLeaveDelay) {
        this.onMouseLeaveTimer = setTimeout(function () {
          return _this2.triggerOnMouseLeave(e);
        }, onMouseLeaveDelay);
        return;
      }

      this.triggerOnMouseLeave(e);
    }
  }, {
    key: "triggerOnMouseEnterWithDelay",
    value: function triggerOnMouseEnterWithDelay(e) {
      var _this3 = this;

      var onMouseEnterDelay = this.props.onMouseEnterDelay;

      if (onMouseEnterDelay) {
        this.onMouseEnterTimer = setTimeout(function () {
          return _this3.triggerOnMouseEnter(e);
        }, onMouseEnterDelay);
        return;
      }

      this.triggerOnMouseEnter(e);
    }
  }, {
    key: "isClickTrigger",
    value: function isClickTrigger() {
      return this.props.triggerType === TRIGGER_TYPE.click;
    }
  }, {
    key: "isHoverTrigger",
    value: function isHoverTrigger() {
      return this.props.triggerType === TRIGGER_TYPE.hover;
    }
  }, {
    key: "isAccessibilityTypeMenu",
    value: function isAccessibilityTypeMenu() {
      return this.props.accessibilityType === ACCESSIBILITY_TYPE.menu;
    }
  }, {
    key: "isAccessibilityTypeTooltip",
    value: function isAccessibilityTypeTooltip() {
      return this.props.accessibilityType === ACCESSIBILITY_TYPE.tooltip;
    }
  }, {
    key: "getAnchorIdAttr",
    value: function getAnchorIdAttr() {
      var popoverId = this.getPopoverIdAttr();
      return popoverId ? "".concat(popoverId, "__anchor") : null;
    }
  }, {
    key: "getPopoverIdAttr",
    value: function getPopoverIdAttr() {
      return this.props.id || null;
    }
  }, {
    key: "getAnchorProps",
    value: function getAnchorProps() {
      var isOpen = this.props.isOpen;
      var anchorProps = {
        'aria-haspopup': 'true',
        'aria-expanded': isOpen ? 'true' : 'false',
        key: 'popover-anchor',
        ref: this.anchorRef
      };
      var popoverId = this.getPopoverIdAttr();

      if (this.isAccessibilityTypeMenu()) {
        var relationAttr = this.isClickTrigger() ? 'aria-controls' : 'aria-owns';
        anchorProps[relationAttr] = isOpen ? popoverId : null;
      } else if (this.isAccessibilityTypeTooltip()) {
        anchorProps.id = this.getAnchorIdAttr();
        anchorProps['aria-describedby'] = isOpen ? popoverId : null;
      }

      if (this.isHoverTrigger()) {
        anchorProps.onMouseEnter = this.onAnchorMouseEnter;
        anchorProps.onMouseLeave = this.onAnchorMouseLeave; // Make it focusable too

        anchorProps.onBlur = this.props.onBlur;
        anchorProps.onFocus = this.props.onFocus;
      } else {
        anchorProps.onClick = this.onAnchorClick;
      }

      return anchorProps;
    }
  }, {
    key: "getPopoverBodyProps",
    value: function getPopoverBodyProps() {
      var bodyProps = {};
      var popoverId = this.getPopoverIdAttr();

      if (this.isAccessibilityTypeMenu()) {
        bodyProps.id = popoverId;
      } else if (this.isAccessibilityTypeTooltip()) {
        bodyProps.id = popoverId;
        bodyProps.role = 'tooltip';
      }

      if (this.isHoverTrigger()) {
        bodyProps.onMouseEnter = this.onPopoverMouseEnter;
        bodyProps.onMouseLeave = this.onPopoverMouseLeave;
      }

      return bodyProps;
    }
  }, {
    key: "getSharedProps",
    value: function getSharedProps() {
      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          showArrow = _this$props.showArrow,
          _this$props$popoverMa = _this$props.popoverMargin,
          popoverMargin = _this$props$popoverMa === void 0 ? POPOVER_MARGIN : _this$props$popoverMa;
      var _this$state = this.state,
          isAnimating = _this$state.isAnimating,
          arrowOffset = _this$state.arrowOffset,
          popoverOffset = _this$state.popoverOffset,
          placement = _this$state.placement;
      return {
        $showArrow: !!showArrow,
        $arrowOffset: arrowOffset,
        $popoverOffset: popoverOffset,
        $placement: placement,
        $isAnimating: isAnimating,
        $isOpen: isOpen,
        $popoverMargin: popoverMargin,
        $isHoverTrigger: this.isHoverTrigger()
      };
    }
  }, {
    key: "getAnchorFromChildren",
    value: function getAnchorFromChildren() {
      var children = this.props.children;
      var childArray = React$2.Children.toArray(children);

      if (childArray.length !== 1) {
        // eslint-disable-next-line no-console
        console.error("[baseui] Exactly 1 child must be passed to Popover/Tooltip, found ".concat(childArray.length, " children"));
      }

      return childArray[0];
    }
  }, {
    key: "renderAnchor",
    value: function renderAnchor() {
      var anchor = this.getAnchorFromChildren();

      if (!anchor) {
        return null;
      }

      var isValidElement = /*#__PURE__*/React$2.isValidElement(anchor);
      var anchorProps = this.getAnchorProps();

      if (_typeof$D(anchor) === 'object' && isValidElement) {
        return /*#__PURE__*/React$2.cloneElement(anchor, anchorProps);
      }

      return /*#__PURE__*/React$2.createElement("span", anchorProps, anchor);
    }
  }, {
    key: "renderPopover",
    value: function renderPopover(renderedContent) {
      var _this$props2 = this.props,
          showArrow = _this$props2.showArrow,
          _this$props2$override = _this$props2.overrides,
          overrides = _this$props2$override === void 0 ? {} : _this$props2$override;
      var ArrowOverride = overrides.Arrow,
          BodyOverride = overrides.Body,
          InnerOverride = overrides.Inner;
      var Arrow = getOverride(ArrowOverride) || Arrow$1;
      var Body = getOverride(BodyOverride) || Body$3;
      var Inner = getOverride(InnerOverride) || Inner$1;
      var sharedProps = this.getSharedProps();
      var bodyProps = this.getPopoverBodyProps();
      return /*#__PURE__*/React$2.createElement(Body, _extends$V({
        key: "popover-body",
        ref: this.popperRef,
        "data-baseweb": this.props['data-baseweb'] || 'popover'
      }, bodyProps, sharedProps, getOverrideProps(BodyOverride)), showArrow ? /*#__PURE__*/React$2.createElement(Arrow, _extends$V({
        key: "popover-arrow",
        ref: this.arrowRef
      }, sharedProps, getOverrideProps(ArrowOverride))) : null, /*#__PURE__*/React$2.createElement(Inner, _extends$V({}, sharedProps, getOverrideProps(InnerOverride)), renderedContent));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var content = this.props.content;
      return typeof content === 'function' ? content() : content;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var mountedAndOpen = this.state.isMounted && this.props.isOpen;
      var rendered = [this.renderAnchor()];
      var renderedContent = mountedAndOpen || this.props.renderAll ? this.renderContent() : null;
      var defaultPopperOptions = {
        modifiers: {
          preventOverflow: {
            enabled: !this.props.ignoreBoundary,
            padding: 0
          }
        }
      }; // Only render popover on the browser (portals aren't supported server-side)

      if (renderedContent) {
        if (mountedAndOpen) {
          rendered.push( /*#__PURE__*/React$2.createElement(Layer, {
            key: "new-layer",
            mountNode: this.props.mountNode,
            onEscape: this.props.onEsc,
            onDocumentClick: this.isHoverTrigger() ? undefined : this.onDocumentClick,
            isHoverLayer: this.isHoverTrigger(),
            onMount: function onMount() {
              return _this4.setState({
                isLayerMounted: true
              });
            },
            onUnmount: function onUnmount() {
              return _this4.setState({
                isLayerMounted: false
              });
            }
          }, /*#__PURE__*/React$2.createElement(TetherBehavior, {
            anchorRef: this.anchorRef.current,
            arrowRef: this.arrowRef.current,
            popperRef: this.popperRef.current // Remove the `ignoreBoundary` prop in the next major version
            // and have it replaced with the TetherBehavior props overrides
            ,
            popperOptions: _objectSpread$V(_objectSpread$V({}, defaultPopperOptions), this.props.popperOptions),
            onPopperUpdate: this.onPopperUpdate,
            placement: this.state.placement
          }, this.props.focusLock ? /*#__PURE__*/React$2.createElement(FocusLock, {
            disabled: !this.props.focusLock,
            noFocusGuards: false // see popover-focus-loop.scenario.js for why hover cannot return focus
            ,
            returnFocus: !this.isHoverTrigger() && this.props.returnFocus,
            autoFocus: this.state.autoFocusAfterPositioning // Allow focus to escape when UI is within an iframe
            ,
            crossFrame: false,
            focusOptions: this.props.focusOptions
          }, this.renderPopover(renderedContent)) : /*#__PURE__*/React$2.createElement(MoveFocusInside, {
            disabled: !this.props.autoFocus || !this.state.autoFocusAfterPositioning
          }, this.renderPopover(renderedContent)))));
        } else {
          rendered.push( /*#__PURE__*/React$2.createElement(Hidden$1, {
            key: "hidden-layer"
          }, renderedContent));
        }
      }

      return rendered;
    }
  }]);

  return PopoverInner;
}(React$2.Component); // Remove when Popover is converted to a functional component.


_defineProperty$1f(PopoverInner, "defaultProps", defaultProps$6);

var Popover = function Popover(props) {
  var innerRef = props.innerRef;
  var gID = useUID(); //$FlowExpectedError[cannot-spread-inexact]

  return /*#__PURE__*/React$2.createElement(PopoverInner, _extends$V({
    id: props.id || gID,
    ref: innerRef
  }, props));
};

Popover.defaultProps = defaultProps$6;
var Popover$1 = Popover;
/* eslint-enable react/no-find-dom-node */

function _objectWithoutProperties$v(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$w(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$w(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function StatefulPopover$1(props) {
  var children = props.children,
      restProps = _objectWithoutProperties$v(props, ["children"]);

  return /*#__PURE__*/React$2.createElement(StatefulPopoverContainer, restProps, function (popoverProps) {
    return /*#__PURE__*/React$2.createElement(Popover$1, popoverProps, children);
  });
}

StatefulPopover$1.defaultProps = {
  accessibilityType: ACCESSIBILITY_TYPE.menu,
  ignoreBoundary: false,
  overrides: {},
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  placement: PLACEMENT$2.auto,
  showArrow: false,
  triggerType: TRIGGER_TYPE.click,
  dismissOnClickOutside: true,
  dismissOnEsc: true,
  stateReducer: function stateReducer(_, nextState) {
    return nextState;
  },
  popoverMargin: POPOVER_MARGIN
};

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var baseDefaultProps = {
  accessibilityType: ACCESSIBILITY_TYPE.tooltip,
  focusLock: false,
  autoFocus: false,
  returnFocus: false,
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  overrides: {},
  placement: PLACEMENT$2.auto,
  popoverMargin: 0,
  showArrow: false,
  triggerType: TRIGGER_TYPE.hover,
  renderAll: false
};
var baseDefaultProps$1 = baseDefaultProps;

function _typeof$C(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$C = function _typeof(obj) { return typeof obj; }; } else { _typeof$C = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$C(obj); }

function ownKeys$U(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$U(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$U(Object(source), true).forEach(function (key) { _defineProperty$1e(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$U(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck$C(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$A(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$B(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$A(Constructor.prototype, protoProps); if (staticProps) _defineProperties$A(Constructor, staticProps); return Constructor; }

function _inherits$B(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$A(subClass, superClass); }

function _setPrototypeOf$A(o, p) { _setPrototypeOf$A = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$A(o, p); }

function _createSuper$A(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$A(); return function _createSuperInternal() { var Super = _getPrototypeOf$A(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$A(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$B(this, result); }; }

function _possibleConstructorReturn$B(self, call) { if (call && (_typeof$C(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$C(self); }

function _assertThisInitialized$C(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$A() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$A(o) { _getPrototypeOf$A = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$A(o); }

function _defineProperty$1e(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StatefulContainer$4 = /*#__PURE__*/function (_React$Component) {
  _inherits$B(StatefulContainer, _React$Component);

  var _super = _createSuper$A(StatefulContainer);

  function StatefulContainer() {
    _classCallCheck$C(this, StatefulContainer);

    return _super.apply(this, arguments);
  }

  _createClass$B(StatefulContainer, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React$2.createElement(StatefulPopoverContainer, this.props);
    }
  }]);

  return StatefulContainer;
}(React$2.Component);

_defineProperty$1e(StatefulContainer$4, "defaultProps", _objectSpread$U({}, baseDefaultProps$1));

var StatefulContainer$5 = StatefulContainer$4;

function ownKeys$T(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$T(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$T(Object(source), true).forEach(function (key) { _defineProperty$1d(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$T(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1d(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * We want to reuse the default Popover styles and add our overrides
 * for Tooltip. Normally you could do something like
 * withStyleDeep(StyledPopoverBody, {...}), however this break the
 * ability to use $style properly–the style overrides passed in by
 * the customer will override the base styles but not the styles
 * specified here.
 *
 * We could create our own withStyleDeep that also takes the $style
 * prop into account
 */
var Body$2 = styled('div', function (props) {
  return _objectSpread$T(_objectSpread$T({}, getBodyStyles(props)), {}, {
    backgroundColor: props.$theme.colors.tooltipBackground,
    borderTopLeftRadius: props.$theme.borders.radius300,
    borderTopRightRadius: props.$theme.borders.radius300,
    borderBottomRightRadius: props.$theme.borders.radius300,
    borderBottomLeftRadius: props.$theme.borders.radius300,
    boxShadow: props.$theme.lighting.shadow400,
    color: props.$theme.colors.tooltipText,
    // Reset transition property to opacity only, and static transform
    transitionProperty: 'opacity',
    transform: getEndPosition(props.$popoverOffset)
  });
});
Body$2.displayName = "Body";
var Inner = styled('div', function (props) {
  return _objectSpread$T(_objectSpread$T(_objectSpread$T({}, getInnerStyles(props)), {}, {
    backgroundColor: props.$theme.colors.tooltipBackground,
    borderTopLeftRadius: props.$theme.borders.radius300,
    borderTopRightRadius: props.$theme.borders.radius300,
    borderBottomRightRadius: props.$theme.borders.radius300,
    borderBottomLeftRadius: props.$theme.borders.radius300,
    paddingTop: props.$theme.sizing.scale300,
    paddingBottom: props.$theme.sizing.scale300,
    paddingLeft: props.$theme.sizing.scale600,
    paddingRight: props.$theme.sizing.scale600
  }, props.$theme.typography.font150), {}, {
    color: props.$theme.colors.tooltipText
  });
});
Inner.displayName = "Inner";
var Arrow = styled('div', function (props) {
  return _objectSpread$T(_objectSpread$T({}, getArrowStyles(props)), {}, {
    backgroundColor: props.$theme.colors.tooltipBackground
  });
});
Arrow.displayName = "Arrow";

function _typeof$B(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$B = function _typeof(obj) { return typeof obj; }; } else { _typeof$B = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$B(obj); }

function ownKeys$S(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$S(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$S(Object(source), true).forEach(function (key) { _defineProperty$1c(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$S(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends$U() { _extends$U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }

function _classCallCheck$B(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$z(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$A(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$z(Constructor.prototype, protoProps); if (staticProps) _defineProperties$z(Constructor, staticProps); return Constructor; }

function _inherits$A(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$z(subClass, superClass); }

function _setPrototypeOf$z(o, p) { _setPrototypeOf$z = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$z(o, p); }

function _createSuper$z(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$z(); return function _createSuperInternal() { var Super = _getPrototypeOf$z(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$z(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$A(this, result); }; }

function _possibleConstructorReturn$A(self, call) { if (call && (_typeof$B(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$B(self); }

function _assertThisInitialized$B(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$z() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$z(o) { _getPrototypeOf$z = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$z(o); }

function _defineProperty$1c(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Tooltip$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$A(Tooltip, _React$Component);

  var _super = _createSuper$z(Tooltip);

  function Tooltip() {
    _classCallCheck$B(this, Tooltip);

    return _super.apply(this, arguments);
  }

  _createClass$A(Tooltip, [{
    key: "render",
    value: function render() {
      var overrides = mergeOverrides({
        Arrow: Arrow,
        Body: Body$2,
        Inner: Inner
      }, this.props.overrides);
      return /*#__PURE__*/React$2.createElement(Popover$1, _extends$U({
        autoFocus: false,
        "data-baseweb": "tooltip"
      }, this.props, {
        overrides: overrides
      }));
    }
  }]);

  return Tooltip;
}(React$2.Component);

_defineProperty$1c(Tooltip$1, "defaultProps", _objectSpread$S({}, baseDefaultProps$1));

var Tooltip$2 = Tooltip$1;

function _objectWithoutProperties$u(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$v(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$v(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function StatefulTooltip(props) {
  var children = props.children,
      restProps = _objectWithoutProperties$u(props, ["children"]);

  return /*#__PURE__*/React$2.createElement(StatefulContainer$5, restProps, function (tooltipProps) {
    return /*#__PURE__*/React$2.createElement(Tooltip$2, tooltipProps, children);
  });
}

StatefulTooltip.defaultProps = StatefulContainer$5.defaultProps;

var TooltipSize;
(function (TooltipSize) {
    TooltipSize[TooltipSize["Regular"] = 0] = "Regular";
    TooltipSize[TooltipSize["Small"] = 1] = "Small";
})(TooltipSize || (TooltipSize = {}));

const sharedStyles = {
    ...borderRadius('top', tokens$1['corner-radius'].default),
    ...borderRadius('bottom', tokens$1['corner-radius'].default),
    boxShadow: tokens$1['box-shadow'].overlay,
};
// unable to use our tooltip on the client side in some use cases (i.e. map choropleths)
// so using custom solution on that side but we still want it styled the same
// hence exposing these style objects
const bodyStyles = {
    ...sharedStyles,
    maxWidth: '225px',
    pointerEvents: 'none',
};
const innerStyles = {
    ...sharedStyles,
    backgroundColor: 'white',
    ...padding(tokens$1.spacing['x-small']),
};
const StyledBody$2 = themedWithStyle(Body$2, bodyStyles);
const StyledInner = themedWithStyle(Inner, ({ $size, $theme, }) => ({
    ...sharedStyles,
    backgroundColor: $theme.colors['neutral-0'],
    ...padding($theme.sizing['x-small']),
    ...($size === TooltipSize.Small ? padding($theme.sizing['xx-small']) : {}),
}));

const Tooltip = (props) => {
    const { size = TooltipSize.Regular, children, placement = PLACEMENT$2.auto, ...restProps } = props;
    const InnerOverride = useCallback((tooltipProps) => (React$2.createElement(StyledInner, { ...{
            ...tooltipProps,
            $size: size,
        } })), [size]);
    return (React$2.createElement(StatefulTooltip, { ...restProps, placement: placement, overrides: {
            Body: StyledBody$2,
            Inner: InnerOverride,
        } }, children));
};

const textWidth$1 = 200;
const twoLineTextWidth$1 = 330; // defines width at which to apply ellipsis
const valueWidth$1 = 36;
const BarRow = themedStyled('div', ({ $theme }) => ({
    alignItems: 'center',
    columnGap: $theme.sizing['xx-small'],
    display: 'flex',
}));
const TextContainer$1 = themedStyled('div', {
    textAlign: 'right',
});
const EllipsisContainer = themedStyled('div', {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});
const StyledBar$2 = themedStyled('div', ({ $theme }) => ({
    ':hover': { boxShadow: $theme.boxShadow['dataviz-hover'] },
    background: $theme.colors['brand-secondary-1-100'],
    ...borderRadius('top', $theme.cornerRadius['semi-sharp']),
    ...borderRadius('bottom', $theme.cornerRadius['semi-sharp']),
    cursor: 'pointer',
}));
const Bar$1 = (props) => {
    const { data, type = BAR_SIZE.Default } = props;
    const [, theme] = themedUseStyletron();
    const canvasRef = useRef(null);
    const canvasEl = canvasRef.current;
    if (!data || data.length === 0) {
        return null;
    }
    const maxValue = Math.max(...data.map(d => d.value));
    const renderText = (text) => {
        const isTwoLines = smallTextWidth(canvasEl, text) > textWidth$1;
        const isThreeLines = smallTextWidth(canvasEl, text) > twoLineTextWidth$1;
        if (!isTwoLines) {
            return (React__default.createElement(LabelSmall, null, text));
        }
        return (React__default.createElement(LabelSmallTight, null, isThreeLines ? (React__default.createElement(Tooltip, { content: (React__default.createElement(LabelMedium, null, text)) }, ellipsisText(canvasEl, text, twoLineTextWidth$1))) : text));
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("canvas", { hidden: true, ref: canvasRef }),
        data.map((response) => {
            // scale bar so largest is 100%
            const barWidthPercentage = (response.value / maxValue) * 100;
            const toolTipContent = (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(LabelMedium, null, response.label),
                React__default.createElement(LabelMedium, { fontWeight: FontWeight.Bold }, response.formattedValue.includes('%')
                    ? response.formattedValue
                    : response.value.toLocaleString())));
            return (React__default.createElement(BarRow, { key: `${response.label}-${response.value}`, style: type === BAR_SIZE.Small ? {
                    marginBottom: theme.sizing['xx-small'],
                    maxHeight: tokens$1['line-height']['label-small'],
                    minHeight: tokens$1['line-height']['label-small'],
                } : {
                    marginBottom: theme.sizing.small,
                    maxHeight: tokens$1['line-height'].label,
                    minHeight: tokens$1['line-height'].label,
                } },
                React__default.createElement(TextContainer$1, { style: { flex: `0 0 ${textWidth$1}px` } }, type === BAR_SIZE.Small
                    ? (React__default.createElement(LabelSmall, null,
                        React__default.createElement(EllipsisContainer, { style: { width: `${textWidth$1}px` } }, smallTextWidth(canvasEl, response.label) > textWidth$1
                            ? (React__default.createElement(Tooltip, { content: (React__default.createElement(LabelMedium, null, response.label)) }, response.label)) : response.label))) : renderText(response.label)),
                React__default.createElement(TextContainer$1, { style: { flex: `0 0 ${valueWidth$1}px` } },
                    React__default.createElement(LabelSmall, { fontWeight: FontWeight.Bold }, response.formattedValue)),
                React__default.createElement(Block, { flex: "1" },
                    React__default.createElement(Tooltip, { content: toolTipContent },
                        React__default.createElement(StyledBar$2, { style: {
                                height: type === BAR_SIZE.Small
                                    ? tokens$1['line-height']['label-small-tight']
                                    : tokens$1['line-height'].label,
                                width: `${barWidthPercentage || 0}%`,
                            } })))));
        })));
};

var LIKERT_SIZE;
(function (LIKERT_SIZE) {
    LIKERT_SIZE["Default"] = "default";
    LIKERT_SIZE["Compact"] = "compact";
})(LIKERT_SIZE || (LIKERT_SIZE = {}));
const LikertColors = [
    [],
    [],
    [
        tokens$1.color['brand-secondary-3-100'],
        tokens$1.color['brand-secondary-4-100'],
    ],
    [
        tokens$1.color['brand-secondary-3-100'],
        tokens$1.color['neutral-25'],
        tokens$1.color['brand-secondary-4-100'],
    ],
    [
        tokens$1.color['brand-secondary-3-125'],
        tokens$1.color['brand-secondary-3-75'],
        tokens$1.color['brand-secondary-4-75'],
        tokens$1.color['brand-secondary-4-125'],
    ],
    [
        tokens$1.color['brand-secondary-3-125'],
        tokens$1.color['brand-secondary-3-75'],
        tokens$1.color['neutral-25'],
        tokens$1.color['brand-secondary-4-75'],
        tokens$1.color['brand-secondary-4-125'],
    ],
    [
        tokens$1.color['brand-secondary-3-125'],
        tokens$1.color['brand-secondary-3-75'],
        tokens$1.color['brand-secondary-3-25'],
        tokens$1.color['brand-secondary-4-25'],
        tokens$1.color['brand-secondary-4-75'],
        tokens$1.color['brand-secondary-4-125'],
    ],
    [
        tokens$1.color['brand-secondary-3-125'],
        tokens$1.color['brand-secondary-3-75'],
        tokens$1.color['brand-secondary-3-25'],
        tokens$1.color['neutral-25'],
        tokens$1.color['brand-secondary-4-25'],
        tokens$1.color['brand-secondary-4-75'],
        tokens$1.color['brand-secondary-4-125'],
    ],
];
// lazy deep copy
const LikertReverseColor = JSON.parse(JSON.stringify(LikertColors));
LikertReverseColor[2].reverse();
LikertReverseColor[3].reverse();
LikertReverseColor[4].reverse();
LikertReverseColor[5].reverse();
LikertReverseColor[6].reverse();
LikertReverseColor[7].reverse();

const textWidth = 200;
const twoLineTextWidth = 290; // defines width at which to apply ellipsis
const valueWidth = 36;
const LikertLegendRow = themedStyled('div', ({ $theme }) => ({
    alignItems: 'center',
    columnGap: $theme.sizing['xx-small'],
    display: 'flex',
    marginBottom: $theme.sizing.small,
}));
const TextContainer = themedStyled('div', {
    textAlign: 'right',
});
const StyledBar$1 = themedStyled('div', ({ $theme }) => ({
    ...borderRadius('top', $theme.cornerRadius['semi-sharp']),
    ...borderRadius('bottom', $theme.cornerRadius['semi-sharp']),
    height: $theme.sizing.small,
    width: $theme.sizing.small,
}));
const renderText = (text, canvasEl) => {
    const isThreeLines = smallTextWidth(canvasEl, text) > twoLineTextWidth;
    return (React__default.createElement(LabelSmall, null, isThreeLines ? (React__default.createElement(Tooltip, { content: () => (React__default.createElement(LabelMedium, null, text)) }, ellipsisText(canvasEl, text, twoLineTextWidth))) : text));
};
function renderLeftLegend(data, likertSize, canvasEl) {
    const [, theme] = themedUseStyletron();
    return data.map((response, index) => (React__default.createElement(LikertLegendRow, { key: `${response.label}-${response.value}` },
        React__default.createElement(TextContainer, { style: { flex: `0 0 ${textWidth}px` } }, renderText(response.label, canvasEl)),
        React__default.createElement(TextContainer, { style: { flex: `0 0 ${valueWidth}px` } },
            React__default.createElement(LabelSmall, { fontWeight: FontWeight.Bold }, response.formattedValue)),
        React__default.createElement(TextContainer, { style: { flex: `0 0 ${theme.sizing.small}px` } },
            React__default.createElement(StyledBar$1, { style: { background: LikertReverseColor[likertSize][index] } })))));
}
function renderRightLegend(data, likertSize, canvasEl) {
    const [, theme] = themedUseStyletron();
    return data.map((response, index) => (React__default.createElement(LikertLegendRow, { key: `${response.label}-${response.value}` },
        React__default.createElement(TextContainer, { style: { flex: `0 0 ${theme.sizing.small}px` } },
            React__default.createElement(StyledBar$1, { style: { background: LikertReverseColor[likertSize][index] } })),
        React__default.createElement(TextContainer, { style: { flex: `0 0 ${valueWidth}px` } },
            React__default.createElement(LabelSmall, { fontWeight: FontWeight.Bold }, response.formattedValue)),
        React__default.createElement(TextContainer, { style: { flex: `0 0 ${textWidth}px`, textAlign: 'left' } }, renderText(response.label, canvasEl)))));
}
const LikertLegend = (props) => {
    const { data, likertSize, type } = props;
    const canvasRef = useRef(null);
    const canvasEl = canvasRef.current;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("canvas", { hidden: true, ref: canvasRef }),
        type !== LIKERT_SIZE.Compact
            ? renderLeftLegend(data, likertSize, canvasEl)
            : renderRightLegend(data, likertSize, canvasEl)));
};

const BarContainer = themedStyled('div', ({ $theme }) => ({
    color: $theme.colors['neutral-100'],
    columnGap: $theme.sizing['xxxx-small'],
    display: 'flex',
    paddingLeft: $theme.sizing.small,
    paddingRight: $theme.sizing.small,
}));
const Bar = themedStyled('div', ({ $theme }) => ({
    ':hover': { boxShadow: $theme.boxShadow['dataviz-hover'] },
    cursor: 'pointer',
}));
function renderDataBar(data, likertSize) {
    const [, theme] = themedUseStyletron();
    return data.map((response, index) => {
        const lastItemIndex = data.length - 1;
        const hasBorderLeft = index === 0;
        const hasBorderRight = index === lastItemIndex;
        return (React__default.createElement(Tooltip, { key: `tip-${response.label}-${response.value}`, content: (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(LabelMedium, null, response.label),
                React__default.createElement(LabelMedium, { fontWeight: FontWeight.Bold }, response.formattedValue))) },
            React__default.createElement(Bar, { style: {
                    background: LikertColors[likertSize][index],
                    ...borderRadius('left', hasBorderLeft ? theme.cornerRadius['semi-sharp'] : 'none'),
                    ...borderRadius('right', hasBorderRight ? theme.cornerRadius['semi-sharp'] : 'none'),
                    height: theme.sizing['xx-large'],
                    width: response.formattedValue,
                } })));
    });
}
function renderDataBarLabels(data) {
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(LabelMedium, null, data[0].label),
        React__default.createElement(LabelMedium, null, data[data.length - 1].label)));
}
function renderBarLabelTop(data, likertSize) {
    const [, theme] = themedUseStyletron();
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(BarContainer, { style: { paddingTop: theme.sizing.small } }, renderDataBar(data, likertSize)),
        React__default.createElement(BarContainer, { style: {
                justifyContent: 'space-between',
                paddingTop: theme.sizing.small,
            } }, renderDataBarLabels(data))));
}
function renderBarLabelBottom(data, likertSize) {
    const [, theme] = themedUseStyletron();
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(BarContainer, { style: {
                justifyContent: 'space-between',
                paddingBottom: theme.sizing.small,
            } }, renderDataBarLabels(data)),
        React__default.createElement(BarContainer, null, renderDataBar(data, likertSize))));
}
const LikertBar = (props) => {
    const { data, likertSize, type } = props;
    const reversedData = data.slice().reverse();
    return type !== LIKERT_SIZE.Compact
        ? React__default.createElement(React__default.Fragment, null, renderBarLabelTop(reversedData, likertSize))
        : React__default.createElement(React__default.Fragment, null, renderBarLabelBottom(reversedData, likertSize));
};

const LikertContainerRow = themedStyled('div', {
    display: 'flex',
});
const LikertContainerColumn = themedStyled('div', {
    display: 'flex',
    flexDirection: 'column',
});
const LikertFixedContainer = themedStyled('div', {
    flex: '0 268px',
    margin: 'auto',
});
const LikertFlexibleContainer = themedStyled('div', {
    flex: '1',
});
const LikertCenteringContainer = themedStyled('div', {
    flex: '1',
    margin: 'auto',
});
const SpacingContainer = themedStyled('div', ({ $theme }) => ({
    marginLeft: $theme.sizing.small,
    marginTop: $theme.sizing.large,
}));
function renderDefaultLikert(likertProps) {
    return (React__default.createElement(LikertContainerRow, null,
        React__default.createElement(LikertFixedContainer, null,
            React__default.createElement(LikertLegend, { ...likertProps })),
        React__default.createElement(LikertCenteringContainer, null,
            React__default.createElement(LikertBar, { ...likertProps }))));
}
function renderCompactLikert(likertProps) {
    return (React__default.createElement(LikertContainerColumn, null,
        React__default.createElement(LikertFlexibleContainer, null,
            React__default.createElement(LikertBar, { ...likertProps })),
        React__default.createElement(LikertFlexibleContainer, null,
            React__default.createElement(SpacingContainer, null,
                React__default.createElement(LikertLegend, { ...likertProps })))));
}
const Likert = (props) => {
    const { data, type = LIKERT_SIZE.Default } = props;
    const likertSize = data.length;
    if (!data || data.length === 0) {
        return null;
    }
    return type === LIKERT_SIZE.Compact
        ? React__default.createElement(React__default.Fragment, null, renderCompactLikert({ data, likertSize, type }))
        : React__default.createElement(React__default.Fragment, null, renderDefaultLikert({ data, likertSize, type }));
};

function ownKeys$R(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$R(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$R(Object(source), true).forEach(function (key) { _defineProperty$1b(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$R(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1b(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Action = styled('div', function (_ref) {
  var $theme = _ref.$theme;
  return _objectSpread$R({}, $theme.typography.LabelMedium);
});
Action.displayName = "Action";
var Body$1 = styled('div', function (_ref2) {
  var $theme = _ref2.$theme;
  return _objectSpread$R({
    marginBottom: $theme.sizing.scale600,
    color: $theme.colors.contentPrimary
  }, $theme.typography.ParagraphMedium);
});
Body$1.displayName = "Body";
var Contents = styled('div', function (_ref3) {
  var $theme = _ref3.$theme;
  return {
    marginLeft: $theme.sizing.scale600,
    marginTop: $theme.sizing.scale600,
    marginRight: $theme.sizing.scale600,
    marginBottom: $theme.sizing.scale600
  };
});
Contents.displayName = "Contents";
var HeaderImage = styled('img', function (_ref4) {
  var $theme = _ref4.$theme;
  return {
    borderTopLeftRadius: $theme.borders.surfaceBorderRadius,
    borderTopRightRadius: $theme.borders.surfaceBorderRadius,
    objectFit: 'contain',
    maxWidth: '100%'
  };
}); // by using the section tag, we can keep the h1 for the title
// https://html.spec.whatwg.org/multipage/sections.html#headings-and-sections

HeaderImage.displayName = "HeaderImage";
var Root$7 = styled('section', function (_ref5) {
  var $theme = _ref5.$theme;
  return {
    borderLeftWidth: '2px',
    borderTopWidth: '2px',
    borderRightWidth: '2px',
    borderBottomWidth: '2px',
    borderLeftStyle: 'solid',
    borderTopStyle: 'solid',
    borderRightStyle: 'solid',
    borderBottomStyle: 'solid',
    borderLeftColor: $theme.colors.borderOpaque,
    borderRightColor: $theme.colors.borderOpaque,
    borderTopColor: $theme.colors.borderOpaque,
    borderBottomColor: $theme.colors.borderOpaque,
    borderTopLeftRadius: $theme.borders.radius400,
    borderTopRightRadius: $theme.borders.radius400,
    borderBottomLeftRadius: $theme.borders.radius400,
    borderBottomRightRadius: $theme.borders.radius400,
    backgroundColor: $theme.colors.backgroundPrimary,
    overflow: 'hidden'
  };
});
Root$7.displayName = "Root";
var Thumbnail = styled('img', function (_ref6) {
  var $theme = _ref6.$theme;
  return _objectSpread$R(_objectSpread$R({
    float: 'right',
    height: $theme.sizing.scale2400,
    width: $theme.sizing.scale2400,
    objectFit: 'cover',
    borderTopLeftRadius: $theme.borders.surfaceBorderRadius,
    borderTopRightRadius: $theme.borders.surfaceBorderRadius,
    borderBottomLeftRadius: $theme.borders.surfaceBorderRadius,
    borderBottomRightRadius: $theme.borders.surfaceBorderRadius
  }, expandBorderStyles($theme.borders.border200)), {}, {
    margin: "0 0 ".concat($theme.sizing.scale500, " ").concat($theme.sizing.scale500)
  });
});
Thumbnail.displayName = "Thumbnail";
var Title = styled('h1', function (_ref7) {
  var $theme = _ref7.$theme;
  return _objectSpread$R(_objectSpread$R({}, $theme.typography.HeadingSmall), {}, {
    color: $theme.colors.contentPrimary,
    marginLeft: 0,
    marginTop: 0,
    marginRight: 0,
    marginBottom: $theme.sizing.scale500,
    paddingLeft: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0
  });
});
Title.displayName = "Title";

var CardVariant;
(function (CardVariant) {
    CardVariant[CardVariant["Interactive"] = 0] = "Interactive";
    CardVariant[CardVariant["Overlay"] = 1] = "Overlay";
    CardVariant[CardVariant["Layout"] = 2] = "Layout";
    CardVariant[CardVariant["Content"] = 3] = "Content";
})(CardVariant || (CardVariant = {}));

const getCardBoxShadow = ($variant, $theme) => {
    // Depending on different card types, return different box shadows tokens
    switch ($variant) {
        case CardVariant.Interactive:
            return $theme.boxShadow['card-light'];
        case CardVariant.Overlay:
            return $theme.boxShadow.overlay;
        case CardVariant.Layout:
            return $theme.boxShadow.layout;
        default:
            return 'none';
    }
};

const StyledRoot$g = themedWithStyle(Root$7, ({ $clickable, $selected, $variant, $noPadding, $theme, }) => ({
    ...borderRadius('top', $theme.cornerRadius['semi-sharp']),
    ...borderRadius('bottom', $theme.cornerRadius['semi-sharp']),
    ...borderWidth('0px'),
    ...borderStyle('solid'),
    ...($noPadding ? padding('0px') : padding($theme.sizing.small)),
    ...($clickable ? {
        ':focus': {
            boxShadow: $theme.boxShadow.focus,
            outline: 'none',
        },
        cursor: 'pointer',
    } : {}),
    ...($clickable && !$selected ? {
        ':hover': {
            boxShadow: $theme.boxShadow['card-hover'],
        },
    } : {}),
    ...($selected ? {
        ...borderColor($theme.colors['brand-primary']),
        ...borderWidth($theme.sizing['xxx-small']),
    } : {
        ...borderColor('transparent'),
    }),
    backgroundColor: $variant === CardVariant.Content
        ? 'transparent'
        : $theme.colors['neutral-0'],
    boxShadow: getCardBoxShadow($variant, $theme),
}));

const Card = (props) => {
    const { clickable = false, selected = false, variant = CardVariant.Interactive, onClick = () => null, children, noPadding = false, ...restProps } = props;
    return (React$2.createElement(StyledRoot$g, { ...{
            ...restProps,
            ...(clickable ? {
                role: 'button',
                tabIndex: 0,
            } : {}),
        }, "$clickable": clickable, "$selected": selected, "$variant": variant, "$noPadding": noPadding, onClick: onClick }, children));
};

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var ORIENTATION$1 = Object.freeze({
  horizontal: 'horizontal',
  vertical: 'vertical'
});
Object.freeze({
  change: 'change',
  moveUp: 'moveUp',
  moveDown: 'moveDown',
  moveLeft: 'moveLeft',
  moveRight: 'moveRight',
  mouseOver: 'mouseOver',
  mouseLeave: 'mouseLeave'
});
var WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];
var DEFAULT_MONTHS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
var DENSITY = {
  high: 'high',
  default: 'default'
};

function ownKeys$Q(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$Q(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$Q(Object(source), true).forEach(function (key) { _defineProperty$1a(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$Q(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1a(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Label$2 = styled('label', function (props) {
  var $disabled = props.$disabled,
      _props$$theme = props.$theme,
      colors = _props$$theme.colors,
      typography = _props$$theme.typography;
  return _objectSpread$Q(_objectSpread$Q({}, typography.font250), {}, {
    fontWeight: 500,
    width: '100%',
    color: $disabled ? colors.contentSecondary : colors.contentPrimary,
    display: 'block',
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0
  });
});
Label$2.displayName = "Label";
var LabelContainer = styled('span', function (_ref) {
  var sizing = _ref.$theme.sizing;
  return {
    display: 'flex',
    width: '100%',
    marginTop: sizing.scale300,
    marginRight: 0,
    marginBottom: sizing.scale300,
    marginLeft: 0
  };
});
LabelContainer.displayName = "LabelContainer";
var LabelEndEnhancer = styled('span', function (_ref2) {
  var $disabled = _ref2.$disabled,
      $counterError = _ref2.$counterError,
      _ref2$$theme = _ref2.$theme,
      colors = _ref2$$theme.colors,
      typography = _ref2$$theme.typography;
  return _objectSpread$Q(_objectSpread$Q({}, typography.font100), {}, {
    flex: 0,
    width: '100%',
    color: $counterError ? colors.negative400 : $disabled ? colors.contentSecondary : colors.contentPrimary
  });
});
LabelEndEnhancer.displayName = "LabelEndEnhancer";
var Caption = styled('div', function (props) {
  var $error = props.$error,
      $positive = props.$positive,
      _props$$theme2 = props.$theme,
      colors = _props$$theme2.colors,
      sizing = _props$$theme2.sizing,
      typography = _props$$theme2.typography;
  var fontColor = colors.contentSecondary;

  if ($error) {
    fontColor = colors.negative400;
  } else if ($positive) {
    fontColor = colors.positive400;
  }

  return _objectSpread$Q(_objectSpread$Q({}, typography.font100), {}, {
    color: fontColor,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    marginTop: sizing.scale300,
    marginRight: 0,
    marginBottom: sizing.scale300,
    marginLeft: 0
  });
});
Caption.displayName = "Caption";
var ControlContainer = styled('div', function (props) {
  var sizing = props.$theme.sizing;
  return {
    width: '100%',
    marginBottom: sizing.scale600
  };
});
ControlContainer.displayName = "ControlContainer";

function _extends$T() { _extends$T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }

function _typeof$A(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$A = function _typeof(obj) { return typeof obj; }; } else { _typeof$A = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$A(obj); }

function _classCallCheck$A(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$y(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$z(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$y(Constructor.prototype, protoProps); if (staticProps) _defineProperties$y(Constructor, staticProps); return Constructor; }

function _inherits$z(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$y(subClass, superClass); }

function _setPrototypeOf$y(o, p) { _setPrototypeOf$y = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$y(o, p); }

function _createSuper$y(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$y(); return function _createSuperInternal() { var Super = _getPrototypeOf$y(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$y(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$z(this, result); }; }

function _possibleConstructorReturn$z(self, call) { if (call && (_typeof$A(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$A(self); }

function _assertThisInitialized$A(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$y() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$y(o) { _getPrototypeOf$y = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$y(o); }

function _defineProperty$19(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function chooseRenderedHint(caption, error, positive, sharedProps) {
  if (!!error && typeof error !== 'boolean') {
    return typeof error === 'function' ? error(sharedProps) : error;
  }

  if (!!positive && typeof positive !== 'boolean') {
    return typeof positive === 'function' ? positive(sharedProps) : positive;
  }

  if (caption) {
    return typeof caption === 'function' ? caption(sharedProps) : caption;
  }

  return null;
}

var FormControl$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$z(FormControl, _React$Component);

  var _super = _createSuper$y(FormControl);

  function FormControl() {
    _classCallCheck$A(this, FormControl);

    return _super.apply(this, arguments);
  }

  _createClass$z(FormControl, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$overrides = _this$props.overrides,
          LabelOverride = _this$props$overrides.Label,
          LabelEndEnhancerOverride = _this$props$overrides.LabelEndEnhancer,
          LabelContainerOverride = _this$props$overrides.LabelContainer,
          CaptionOverride = _this$props$overrides.Caption,
          ControlContainerOverride = _this$props$overrides.ControlContainer,
          label = _this$props.label,
          caption = _this$props.caption,
          disabled = _this$props.disabled,
          error = _this$props.error,
          positive = _this$props.positive,
          htmlFor = _this$props.htmlFor,
          children = _this$props.children,
          counter = _this$props.counter;
      var onlyChildProps = React$2.Children.only(children).props;
      var sharedProps = {
        $disabled: !!disabled,
        $error: !!error,
        $positive: !!positive
      };
      var Label = getOverride(LabelOverride) || Label$2;
      var LabelEndEnhancer$1 = getOverride(LabelEndEnhancerOverride) || LabelEndEnhancer;
      var LabelContainer$1 = getOverride(LabelContainerOverride) || LabelContainer;
      var Caption$1 = getOverride(CaptionOverride) || Caption;
      var ControlContainer$1 = getOverride(ControlContainerOverride) || ControlContainer;
      var hint = chooseRenderedHint(caption, error, positive, sharedProps);

      if (process.env.NODE_ENV !== "production") {
        if (error && positive) {
          // eslint-disable-next-line no-console
          console.warn("[FormControl] `error` and `positive` are both set to `true`. `error` will take precedence but this may not be what you want.");
        }
      }

      var labelEndEnhancer = this.props.labelEndEnhancer;

      if (counter) {
        // inferred values are preferred but if the user specifies the value
        // that is then used as the default.
        var maxLength = null;
        var length = null;
        var counterError = null;

        if (_typeof$A(counter) === 'object') {
          length = counter.length;
          maxLength = counter.maxLength;
          counterError = counter.error;
        }

        maxLength = maxLength ? maxLength : onlyChildProps.maxLength;

        if (length == null && typeof onlyChildProps.value === 'string') {
          length = onlyChildProps.value.length;
        }

        if (length == null) {
          length = 0;

          if (process.env.NODE_ENV !== "production") {
            console.warn("[FromControl] `length` must either be explicitly set via `counter` object property, or `value` string property on the child component.");
          }
        }

        sharedProps.$length = length;

        if (maxLength == null) {
          if (!labelEndEnhancer) labelEndEnhancer = "".concat(length);
        } else {
          sharedProps.$maxLength = length;
          if (!labelEndEnhancer) labelEndEnhancer = "".concat(length, "/").concat(maxLength);
          if (length > maxLength && counterError == null) counterError = true;
        }

        if (counterError) {
          sharedProps.$error = true;
          sharedProps.$counterError = true;
        }
      }

      return /*#__PURE__*/React$2.createElement(React$2.Fragment, null, label && /*#__PURE__*/React$2.createElement(LabelContainer$1, _extends$T({}, sharedProps, getOverrideProps(LabelContainerOverride)), /*#__PURE__*/React$2.createElement(Label, _extends$T({
        "data-baseweb": "form-control-label",
        htmlFor: htmlFor || onlyChildProps.id
      }, sharedProps, getOverrideProps(LabelOverride)), typeof label === 'function' ? label(sharedProps) : label), !!labelEndEnhancer && /*#__PURE__*/React$2.createElement(LabelEndEnhancer$1, _extends$T({}, sharedProps, getOverrideProps(LabelEndEnhancerOverride)), typeof labelEndEnhancer === 'function' ? labelEndEnhancer(sharedProps) : labelEndEnhancer)), /*#__PURE__*/React$2.createElement(UIDConsumer, null, function (captionId) {
        return /*#__PURE__*/React$2.createElement(ControlContainer$1, _extends$T({
          "data-baseweb": "form-control-container"
        }, sharedProps, getOverrideProps(ControlContainerOverride)), React$2.Children.map(children, function (child, index) {
          if (!child) return;
          var key = child.key || String(index);
          return /*#__PURE__*/React$2.cloneElement(child, {
            key: key,
            'aria-errormessage': error ? captionId : null,
            'aria-describedby': caption || positive ? captionId : null,
            disabled: onlyChildProps.disabled || disabled,
            error: typeof onlyChildProps.error !== 'undefined' ? onlyChildProps.error : sharedProps.$error,
            positive: typeof onlyChildProps.positive !== 'undefined' ? onlyChildProps.positive : sharedProps.$positive
          });
        }), (!!caption || !!error || positive) && /*#__PURE__*/React$2.createElement(Caption$1, _extends$T({
          "data-baseweb": "form-control-caption",
          id: captionId
        }, sharedProps, getOverrideProps(CaptionOverride)), hint));
      }));
    }
  }]);

  return FormControl;
}(React$2.Component);

_defineProperty$19(FormControl$1, "defaultProps", {
  overrides: {},
  label: null,
  caption: null,
  disabled: false,
  counter: false
});

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var STATE_CHANGE_TYPE$2 = {
  change: 'change'
};
var CUSTOM_INPUT_TYPE = {
  textarea: 'textarea'
};
var ADJOINED = {
  none: 'none',
  left: 'left',
  right: 'right',
  both: 'both'
};
var SIZE$2 = {
  mini: 'mini',
  default: 'default',
  compact: 'compact',
  large: 'large'
};
var ENHANCER_POSITION = {
  start: 'start',
  end: 'end'
};

function _typeof$z(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$z = function _typeof(obj) { return typeof obj; }; } else { _typeof$z = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$z(obj); }

function _objectWithoutProperties$t(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$u(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$u(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys$P(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$P(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$P(Object(source), true).forEach(function (key) { _defineProperty$18(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$P(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck$z(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$x(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$y(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$x(Constructor.prototype, protoProps); if (staticProps) _defineProperties$x(Constructor, staticProps); return Constructor; }

function _inherits$y(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$x(subClass, superClass); }

function _setPrototypeOf$x(o, p) { _setPrototypeOf$x = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$x(o, p); }

function _createSuper$x(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$x(); return function _createSuperInternal() { var Super = _getPrototypeOf$x(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$x(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$y(this, result); }; }

function _possibleConstructorReturn$y(self, call) { if (call && (_typeof$z(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$z(self); }

function _assertThisInitialized$z(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$x() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$x(o) { _getPrototypeOf$x = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$x(o); }

function _defineProperty$18(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultStateReducer$3 = function defaultStateReducer(type, nextState) {
  return nextState;
};

var StatefulContainer$2 = /*#__PURE__*/function (_React$Component) {
  _inherits$y(StatefulContainer, _React$Component);

  var _super = _createSuper$x(StatefulContainer);

  function StatefulContainer() {
    var _this;

    _classCallCheck$z(this, StatefulContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$18(_assertThisInitialized$z(_this), "state", _objectSpread$P({
      value: ''
    }, _this.props.initialState));

    _defineProperty$18(_assertThisInitialized$z(_this), "onChange", function (e) {
      var nextState = {
        value: e.target.value
      };

      _this.internalSetState(STATE_CHANGE_TYPE$2.change, nextState);

      _this.props.onChange(e);
    });

    _defineProperty$18(_assertThisInitialized$z(_this), "internalSetState", function (type, nextState) {
      var newState = _this.props.stateReducer(type, nextState, _this.state);

      _this.setState(newState);
    });

    return _this;
  }

  _createClass$y(StatefulContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children;
          _this$props.initialState;
          _this$props.stateReducer;
          var restProps = _objectWithoutProperties$t(_this$props, ["children", "initialState", "stateReducer"]);

      var onChange = this.onChange;
      return children(_objectSpread$P(_objectSpread$P(_objectSpread$P({}, restProps), this.state), {}, {
        onChange: onChange
      }));
    }
  }]);

  return StatefulContainer;
}(React$2.Component);

_defineProperty$18(StatefulContainer$2, "defaultProps", {
  initialState: {},
  stateReducer: defaultStateReducer$3,
  onChange: function onChange() {},
  onClear: function onClear() {}
});

var StatefulContainer$3 = StatefulContainer$2;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function getSharedProps(props, state) {
  var disabled = props.disabled,
      error = props.error,
      positive = props.positive,
      adjoined = props.adjoined,
      size = props.size,
      required = props.required;
  var isFocused = state.isFocused;
  return {
    $isFocused: isFocused,
    $disabled: disabled,
    $error: error,
    $positive: positive,
    $adjoined: adjoined,
    $size: size,
    $required: required
  };
}

function ownKeys$O(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$O(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$O(Object(source), true).forEach(function (key) { _defineProperty$17(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$O(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$17(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var StyledMaskToggleButton = styled('button', function (_ref) {
  var _SIZE$mini$SIZE$compa;

  var $theme = _ref.$theme,
      $size = _ref.$size,
      $isFocusVisible = _ref.$isFocusVisible;
  var pad = (_SIZE$mini$SIZE$compa = {}, _defineProperty$17(_SIZE$mini$SIZE$compa, SIZE$2.mini, $theme.sizing.scale400), _defineProperty$17(_SIZE$mini$SIZE$compa, SIZE$2.compact, $theme.sizing.scale400), _defineProperty$17(_SIZE$mini$SIZE$compa, SIZE$2.default, $theme.sizing.scale300), _defineProperty$17(_SIZE$mini$SIZE$compa, SIZE$2.large, $theme.sizing.scale200), _SIZE$mini$SIZE$compa)[$size];
  return {
    display: 'flex',
    alignItems: 'center',
    borderTopStyle: 'none',
    borderBottomStyle: 'none',
    borderLeftStyle: 'none',
    borderRightStyle: 'none',
    background: 'none',
    paddingLeft: pad,
    paddingRight: pad,
    outline: $isFocusVisible ? "solid 3px ".concat($theme.colors.accent) : 'none',
    color: $theme.colors.contentPrimary
  };
});
StyledMaskToggleButton.displayName = "StyledMaskToggleButton";
var StyledClearIconContainer = styled('div', function (_ref2) {
  var _SIZE$mini$SIZE$compa2;

  var _ref2$$alignTop = _ref2.$alignTop,
      $alignTop = _ref2$$alignTop === void 0 ? false : _ref2$$alignTop,
      $size = _ref2.$size,
      $theme = _ref2.$theme;
  var pad = (_SIZE$mini$SIZE$compa2 = {}, _defineProperty$17(_SIZE$mini$SIZE$compa2, SIZE$2.mini, $theme.sizing.scale200), _defineProperty$17(_SIZE$mini$SIZE$compa2, SIZE$2.compact, $theme.sizing.scale200), _defineProperty$17(_SIZE$mini$SIZE$compa2, SIZE$2.default, $theme.sizing.scale100), _defineProperty$17(_SIZE$mini$SIZE$compa2, SIZE$2.large, $theme.sizing.scale0), _SIZE$mini$SIZE$compa2)[$size];
  return {
    display: 'flex',
    alignItems: $alignTop ? 'flex-start' : 'center',
    paddingLeft: pad,
    paddingRight: pad,
    paddingTop: $alignTop ? $theme.sizing.scale500 : '0px',
    color: $theme.colors.contentPrimary
  };
});
StyledClearIconContainer.displayName = "StyledClearIconContainer";
var StyledClearIcon$1 = styled(DeleteAlt$1, function (_ref3) {
  var $theme = _ref3.$theme,
      $isFocusVisible = _ref3.$isFocusVisible;
  return {
    cursor: 'pointer',
    outline: $isFocusVisible ? "solid 3px ".concat($theme.colors.accent) : 'none'
  };
});
StyledClearIcon$1.displayName = "StyledClearIcon";

function getInputPadding(size, sizing) {
  var _SIZE$mini$SIZE$compa3;

  return (_SIZE$mini$SIZE$compa3 = {}, _defineProperty$17(_SIZE$mini$SIZE$compa3, SIZE$2.mini, {
    paddingTop: sizing.scale100,
    paddingBottom: sizing.scale100,
    paddingLeft: sizing.scale550,
    paddingRight: sizing.scale550
  }), _defineProperty$17(_SIZE$mini$SIZE$compa3, SIZE$2.compact, {
    paddingTop: sizing.scale200,
    paddingBottom: sizing.scale200,
    paddingLeft: sizing.scale550,
    paddingRight: sizing.scale550
  }), _defineProperty$17(_SIZE$mini$SIZE$compa3, SIZE$2.default, {
    paddingTop: sizing.scale400,
    paddingBottom: sizing.scale400,
    paddingLeft: sizing.scale550,
    paddingRight: sizing.scale550
  }), _defineProperty$17(_SIZE$mini$SIZE$compa3, SIZE$2.large, {
    paddingTop: sizing.scale550,
    paddingBottom: sizing.scale550,
    paddingLeft: sizing.scale550,
    paddingRight: sizing.scale550
  }), _SIZE$mini$SIZE$compa3)[size];
}

function getRootPadding(adjoined, size, sizing, direction, hasIconTrailing) {
  var ifLeftPad = adjoined === ADJOINED.both || adjoined === ADJOINED.left && direction !== 'rtl' || adjoined === ADJOINED.right && direction === 'rtl' || hasIconTrailing && direction === 'rtl';
  var ifRightPad = adjoined === ADJOINED.both || adjoined === ADJOINED.right && direction !== 'rtl' || adjoined === ADJOINED.left && direction === 'rtl' || hasIconTrailing && direction !== 'rtl';
  return {
    paddingLeft: ifLeftPad ? sizing.scale550 : '0px',
    paddingRight: ifRightPad ? sizing.scale550 : '0px'
  };
}

function getFont$1(size, typography) {
  var _SIZE$mini$SIZE$compa4;

  return (_SIZE$mini$SIZE$compa4 = {}, _defineProperty$17(_SIZE$mini$SIZE$compa4, SIZE$2.mini, typography.font100), _defineProperty$17(_SIZE$mini$SIZE$compa4, SIZE$2.compact, typography.font200), _defineProperty$17(_SIZE$mini$SIZE$compa4, SIZE$2.default, typography.font300), _defineProperty$17(_SIZE$mini$SIZE$compa4, SIZE$2.large, typography.font400), _SIZE$mini$SIZE$compa4)[size];
}

function getRootColors($disabled, $isFocused, $error) {
  var $positive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var colors = arguments.length > 4 ? arguments[4] : undefined;

  if ($disabled) {
    return {
      borderLeftColor: colors.inputFillDisabled,
      borderRightColor: colors.inputFillDisabled,
      borderTopColor: colors.inputFillDisabled,
      borderBottomColor: colors.inputFillDisabled,
      backgroundColor: colors.inputFillDisabled
    };
  }

  if ($isFocused) {
    return {
      borderLeftColor: colors.borderFocus,
      borderRightColor: colors.borderFocus,
      borderTopColor: colors.borderFocus,
      borderBottomColor: colors.borderFocus,
      backgroundColor: colors.inputFillActive
    };
  }

  if ($error) {
    return {
      borderLeftColor: colors.inputBorderError,
      borderRightColor: colors.inputBorderError,
      borderTopColor: colors.inputBorderError,
      borderBottomColor: colors.inputBorderError,
      backgroundColor: colors.inputFillError
    };
  }

  if ($positive) {
    return {
      borderLeftColor: colors.inputBorderPositive,
      borderRightColor: colors.inputBorderPositive,
      borderTopColor: colors.inputBorderPositive,
      borderBottomColor: colors.inputBorderPositive,
      backgroundColor: colors.inputFillPositive
    };
  }

  return {
    borderLeftColor: colors.inputBorder,
    borderRightColor: colors.inputBorder,
    borderTopColor: colors.inputBorder,
    borderBottomColor: colors.inputBorder,
    backgroundColor: colors.inputFill
  };
}

function getRootBorderRadius(radius) {
  return {
    borderTopLeftRadius: radius,
    borderBottomLeftRadius: radius,
    borderTopRightRadius: radius,
    borderBottomRightRadius: radius
  };
}

var getRootStyles = function getRootStyles(props) {
  var $isFocused = props.$isFocused,
      $adjoined = props.$adjoined,
      $error = props.$error,
      $disabled = props.$disabled,
      $positive = props.$positive,
      $size = props.$size,
      $theme = props.$theme,
      _props$$theme = props.$theme,
      borders = _props$$theme.borders,
      colors = _props$$theme.colors,
      sizing = _props$$theme.sizing,
      typography = _props$$theme.typography,
      animation = _props$$theme.animation,
      $hasIconTrailing = props.$hasIconTrailing;
  return _objectSpread$O(_objectSpread$O(_objectSpread$O(_objectSpread$O({
    boxSizing: 'border-box',
    display: 'flex',
    overflow: 'hidden',
    width: '100%',
    borderLeftWidth: '2px',
    borderRightWidth: '2px',
    borderTopWidth: '2px',
    borderBottomWidth: '2px',
    borderLeftStyle: 'solid',
    borderRightStyle: 'solid',
    borderTopStyle: 'solid',
    borderBottomStyle: 'solid',
    transitionProperty: 'border',
    transitionDuration: animation.timing200,
    transitionTimingFunction: animation.easeOutCurve
  }, getRootBorderRadius(borders.inputBorderRadius)), getFont$1($size, typography)), getRootColors($disabled, $isFocused, $error, $positive, colors)), getRootPadding($adjoined, $size, sizing, $theme.direction, $hasIconTrailing));
};
var Root$6 = styled('div', getRootStyles); // InputEnhancer

Root$6.displayName = "Root";

function getInputEnhancerPadding($size, sizing) {
  var _SIZE$mini$SIZE$compa5;

  return (_SIZE$mini$SIZE$compa5 = {}, _defineProperty$17(_SIZE$mini$SIZE$compa5, SIZE$2.mini, {
    paddingRight: sizing.scale400,
    paddingLeft: sizing.scale400
  }), _defineProperty$17(_SIZE$mini$SIZE$compa5, SIZE$2.compact, {
    paddingRight: sizing.scale400,
    paddingLeft: sizing.scale400
  }), _defineProperty$17(_SIZE$mini$SIZE$compa5, SIZE$2.default, {
    paddingRight: sizing.scale300,
    paddingLeft: sizing.scale300
  }), _defineProperty$17(_SIZE$mini$SIZE$compa5, SIZE$2.large, {
    paddingRight: sizing.scale200,
    paddingLeft: sizing.scale200
  }), _SIZE$mini$SIZE$compa5)[$size];
}

function getInputEnhancerColors($disabled, $isFocused, $error, $positive, colors) {
  if ($disabled) {
    return {
      color: colors.inputEnhancerTextDisabled,
      backgroundColor: colors.inputFillDisabled
    };
  }

  if ($isFocused) {
    return {
      color: colors.contentPrimary,
      backgroundColor: colors.inputFillActive
    };
  }

  if ($error) {
    return {
      color: colors.contentPrimary,
      backgroundColor: colors.inputFillError
    };
  }

  if ($positive) {
    return {
      color: colors.contentPrimary,
      backgroundColor: colors.inputFillPositive
    };
  }

  return {
    color: colors.contentPrimary,
    backgroundColor: colors.inputFill
  };
}

var InputEnhancer = styled('div', function (props) {
  var $size = props.$size,
      $disabled = props.$disabled,
      $isFocused = props.$isFocused,
      $error = props.$error,
      $positive = props.$positive,
      _props$$theme2 = props.$theme,
      colors = _props$$theme2.colors,
      sizing = _props$$theme2.sizing,
      typography = _props$$theme2.typography,
      animation = _props$$theme2.animation;
  return _objectSpread$O(_objectSpread$O(_objectSpread$O({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transitionProperty: 'color, background-color',
    transitionDuration: animation.timing200,
    transitionTimingFunction: animation.easeOutCurve
  }, getFont$1($size, typography)), getInputEnhancerPadding($size, sizing)), getInputEnhancerColors($disabled, $isFocused, $error, $positive, colors));
}); // InputContainer

InputEnhancer.displayName = "InputEnhancer";

function getInputContainerColors($disabled, $isFocused, $error, $positive, colors) {
  if ($disabled) {
    return {
      color: colors.inputTextDisabled,
      backgroundColor: colors.inputFillDisabled
    };
  }

  if ($isFocused) {
    return {
      color: colors.contentPrimary,
      backgroundColor: colors.inputFillActive
    };
  }

  if ($error) {
    return {
      color: colors.contentPrimary,
      backgroundColor: colors.inputFillError
    };
  }

  if ($positive) {
    return {
      color: colors.contentPrimary,
      backgroundColor: colors.inputFillPositive
    };
  }

  return {
    color: colors.contentPrimary,
    backgroundColor: colors.inputFill
  };
}

var getInputContainerStyles = function getInputContainerStyles(props) {
  var $isFocused = props.$isFocused,
      $error = props.$error,
      $disabled = props.$disabled,
      $positive = props.$positive,
      $size = props.$size,
      _props$$theme3 = props.$theme,
      colors = _props$$theme3.colors,
      typography = _props$$theme3.typography,
      animation = _props$$theme3.animation;
  return _objectSpread$O(_objectSpread$O({
    display: 'flex',
    width: '100%',
    transitionProperty: 'background-color',
    transitionDuration: animation.timing200,
    transitionTimingFunction: animation.easeOutCurve
  }, getFont$1($size, typography)), getInputContainerColors($disabled, $isFocused, $error, $positive, colors));
};
var InputContainer = styled('div', getInputContainerStyles);
InputContainer.displayName = "InputContainer";

function getInputColors($disabled, $isFocused, $error, colors) {
  if ($disabled) {
    return {
      color: colors.inputTextDisabled,
      '-webkit-text-fill-color': colors.inputTextDisabled,
      caretColor: colors.contentPrimary,
      '::placeholder': {
        color: colors.inputPlaceholderDisabled
      }
    };
  }

  return {
    color: colors.contentPrimary,
    caretColor: colors.contentPrimary,
    '::placeholder': {
      color: colors.inputPlaceholder
    }
  };
}

var getInputStyles = function getInputStyles(props) {
  var $disabled = props.$disabled,
      $isFocused = props.$isFocused,
      $error = props.$error,
      $size = props.$size,
      _props$$theme4 = props.$theme,
      colors = _props$$theme4.colors,
      sizing = _props$$theme4.sizing,
      typography = _props$$theme4.typography; //$FlowFixMe

  return _objectSpread$O(_objectSpread$O(_objectSpread$O({
    boxSizing: 'border-box',
    backgroundColor: 'transparent',
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 0,
    borderLeftStyle: 'none',
    borderRightStyle: 'none',
    borderTopStyle: 'none',
    borderBottomStyle: 'none',
    outline: 'none',
    width: '100%',
    // See https://stackoverflow.com/a/33811151
    minWidth: 0,
    maxWidth: '100%',
    cursor: $disabled ? 'not-allowed' : 'text',
    margin: '0',
    paddingTop: '0',
    paddingBottom: '0',
    paddingLeft: '0',
    paddingRight: '0'
  }, getFont$1($size, typography)), getInputPadding($size, sizing)), getInputColors($disabled, $isFocused, $error, colors));
};
var Input$3 = styled('input', getInputStyles);
Input$3.displayName = "Input";

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* global window document */

/** A safe way to create event objects down to IE11 */
function createEvent(eventName) {
  var event;

  if (typeof window.Event === 'function') {
    event = new window.Event(eventName, {
      bubbles: true,
      cancelable: true
    });
  } else {
    event = document.createEvent('Event');
    event.initEvent(eventName, true, true);
  }

  return event;
}

function _typeof$y(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$y = function _typeof(obj) { return typeof obj; }; } else { _typeof$y = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$y(obj); }

function _extends$S() { _extends$S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }

function _slicedToArray$K(arr, i) { return _arrayWithHoles$K(arr) || _iterableToArrayLimit$K(arr, i) || _unsupportedIterableToArray$M(arr, i) || _nonIterableRest$K(); }

function _nonIterableRest$K() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$M(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$M(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$M(o, minLen); }

function _arrayLikeToArray$M(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$K(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$K(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$y(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$w(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$x(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$w(Constructor.prototype, protoProps); if (staticProps) _defineProperties$w(Constructor, staticProps); return Constructor; }

function _inherits$x(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$w(subClass, superClass); }

function _setPrototypeOf$w(o, p) { _setPrototypeOf$w = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$w(o, p); }

function _createSuper$w(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$w(); return function _createSuperInternal() { var Super = _getPrototypeOf$w(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$w(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$x(this, result); }; }

function _possibleConstructorReturn$x(self, call) { if (call && (_typeof$y(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$y(self); }

function _assertThisInitialized$y(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$w() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$w(o) { _getPrototypeOf$w = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$w(o); }

function _defineProperty$16(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NullComponent = function NullComponent() {
  return null;
};

var BaseInput = /*#__PURE__*/function (_React$Component) {
  _inherits$x(BaseInput, _React$Component);

  var _super = _createSuper$w(BaseInput);

  function BaseInput() {
    var _this;

    _classCallCheck$y(this, BaseInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$16(_assertThisInitialized$y(_this), "inputRef", _this.props.inputRef || /*#__PURE__*/React$2.createRef());

    _defineProperty$16(_assertThisInitialized$y(_this), "state", {
      isFocused: _this.props.autoFocus || false,
      isMasked: _this.props.type === 'password',
      initialType: _this.props.type,
      isFocusVisibleForClear: false,
      isFocusVisibleForMaskToggle: false
    });

    _defineProperty$16(_assertThisInitialized$y(_this), "onInputKeyDown", function (e) {
      if (_this.props.clearOnEscape && e.key === 'Escape' && _this.inputRef.current) {
        _this.clearValue(); // prevent event from closing modal or doing something unexpected


        e.stopPropagation();
      }
    });

    _defineProperty$16(_assertThisInitialized$y(_this), "onClearIconClick", function () {
      if (_this.inputRef.current) _this.clearValue(); // return focus to the input after click

      if (_this.inputRef.current) _this.inputRef.current.focus();
    });

    _defineProperty$16(_assertThisInitialized$y(_this), "onFocus", function (e) {
      _this.setState({
        isFocused: true
      });

      _this.props.onFocus(e);
    });

    _defineProperty$16(_assertThisInitialized$y(_this), "onBlur", function (e) {
      _this.setState({
        isFocused: false
      });

      _this.props.onBlur(e);
    });

    _defineProperty$16(_assertThisInitialized$y(_this), "handleFocusForMaskToggle", function (event) {
      if (isFocusVisible(event)) {
        _this.setState({
          isFocusVisibleForMaskToggle: true
        });
      }
    });

    _defineProperty$16(_assertThisInitialized$y(_this), "handleBlurForMaskToggle", function (event) {
      if (_this.state.isFocusVisibleForMaskToggle !== false) {
        _this.setState({
          isFocusVisibleForMaskToggle: false
        });
      }
    });

    _defineProperty$16(_assertThisInitialized$y(_this), "handleFocusForClear", function (event) {
      if (isFocusVisible(event)) {
        _this.setState({
          isFocusVisibleForClear: true
        });
      }
    });

    _defineProperty$16(_assertThisInitialized$y(_this), "handleBlurForClear", function (event) {
      if (_this.state.isFocusVisibleForClear !== false) {
        _this.setState({
          isFocusVisibleForClear: false
        });
      }
    });

    return _this;
  }

  _createClass$x(BaseInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          autoFocus = _this$props.autoFocus,
          clearable = _this$props.clearable;

      if (this.inputRef.current) {
        if (autoFocus) {
          this.inputRef.current.focus();
        }

        if (clearable) {
          this.inputRef.current.addEventListener('keydown', this.onInputKeyDown);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var clearable = this.props.clearable;

      if (clearable && this.inputRef.current) {
        this.inputRef.current.removeEventListener('keydown', this.onInputKeyDown);
      }
    }
  }, {
    key: "clearValue",
    value: function clearValue() {
      // trigger a fake input change event (as if all text was deleted)
      var input = this.inputRef.current;

      if (input) {
        var nativeInputValue = Object.getOwnPropertyDescriptor(this.props.type === CUSTOM_INPUT_TYPE.textarea ? window.HTMLTextAreaElement.prototype : window.HTMLInputElement.prototype, 'value');

        if (nativeInputValue) {
          var nativeInputValueSetter = nativeInputValue.set;

          if (nativeInputValueSetter) {
            nativeInputValueSetter.call(input, '');
            var event = createEvent('input');
            input.dispatchEvent(event);
          }
        }
      }
    }
  }, {
    key: "getInputType",
    value: function getInputType() {
      // If the type prop is equal to "password" we allow the user to toggle between
      // masked and non masked text. Internally, we toggle between type "password"
      // and "text".
      if (this.props.type === 'password') {
        return this.state.isMasked ? 'password' : 'text';
      } else {
        return this.props.type;
      }
    }
  }, {
    key: "renderMaskToggle",
    value: function renderMaskToggle() {
      var _SIZE$mini$SIZE$compa,
          _this2 = this;

      if (this.props.type !== 'password') return null;

      var _getOverrides = getOverrides(this.props.overrides.MaskToggleButton, StyledMaskToggleButton),
          _getOverrides2 = _slicedToArray$K(_getOverrides, 2),
          MaskToggleButton = _getOverrides2[0],
          maskToggleButtonProps = _getOverrides2[1];

      var _getOverrides3 = getOverrides(this.props.overrides.MaskToggleShowIcon, Show$2),
          _getOverrides4 = _slicedToArray$K(_getOverrides3, 2),
          MaskToggleShowIcon = _getOverrides4[0],
          maskToggleIconShowProps = _getOverrides4[1];

      var _getOverrides5 = getOverrides(this.props.overrides.MaskToggleHideIcon, Hide$1),
          _getOverrides6 = _slicedToArray$K(_getOverrides5, 2),
          MaskToggleHideIcon = _getOverrides6[0],
          maskToggleIconHideProps = _getOverrides6[1];

      var label = this.state.isMasked ? 'Show password text' : 'Hide password text';
      var iconSize = (_SIZE$mini$SIZE$compa = {}, _defineProperty$16(_SIZE$mini$SIZE$compa, SIZE$2.mini, '12px'), _defineProperty$16(_SIZE$mini$SIZE$compa, SIZE$2.compact, '16px'), _defineProperty$16(_SIZE$mini$SIZE$compa, SIZE$2.default, '20px'), _defineProperty$16(_SIZE$mini$SIZE$compa, SIZE$2.large, '24px'), _SIZE$mini$SIZE$compa)[this.props.size];
      return /*#__PURE__*/React$2.createElement(MaskToggleButton, _extends$S({
        $size: this.props.size,
        $isFocusVisible: this.state.isFocusVisibleForMaskToggle,
        "aria-label": label,
        onClick: function onClick() {
          return _this2.setState(function (state) {
            return {
              isMasked: !state.isMasked
            };
          });
        },
        title: label,
        type: "button"
      }, maskToggleButtonProps, {
        onFocus: forkFocus(maskToggleButtonProps, this.handleFocusForMaskToggle),
        onBlur: forkBlur(maskToggleButtonProps, this.handleBlurForMaskToggle)
      }), this.state.isMasked ? /*#__PURE__*/React$2.createElement(MaskToggleShowIcon, _extends$S({
        size: iconSize,
        title: label
      }, maskToggleIconShowProps)) : /*#__PURE__*/React$2.createElement(MaskToggleHideIcon, _extends$S({
        size: iconSize,
        title: label
      }, maskToggleIconHideProps)));
    }
  }, {
    key: "renderClear",
    value: function renderClear() {
      var _SIZE$mini$SIZE$compa2,
          _this3 = this;

      var _this$props2 = this.props,
          clearable = _this$props2.clearable,
          value = _this$props2.value,
          disabled = _this$props2.disabled,
          _this$props2$override = _this$props2.overrides,
          overrides = _this$props2$override === void 0 ? {} : _this$props2$override;

      if (disabled || !clearable || value == null || typeof value === 'string' && value.length === 0) {
        return null;
      }

      var _getOverrides7 = getOverrides(overrides.ClearIconContainer, StyledClearIconContainer),
          _getOverrides8 = _slicedToArray$K(_getOverrides7, 2),
          ClearIconContainer = _getOverrides8[0],
          clearIconContainerProps = _getOverrides8[1];

      var _getOverrides9 = getOverrides(overrides.ClearIcon, StyledClearIcon$1),
          _getOverrides10 = _slicedToArray$K(_getOverrides9, 2),
          ClearIcon = _getOverrides10[0],
          clearIconProps = _getOverrides10[1];

      var ariaLabel = 'Clear value';
      var sharedProps = getSharedProps(this.props, this.state);
      var iconSize = (_SIZE$mini$SIZE$compa2 = {}, _defineProperty$16(_SIZE$mini$SIZE$compa2, SIZE$2.mini, '14px'), _defineProperty$16(_SIZE$mini$SIZE$compa2, SIZE$2.compact, '14px'), _defineProperty$16(_SIZE$mini$SIZE$compa2, SIZE$2.default, '16px'), _defineProperty$16(_SIZE$mini$SIZE$compa2, SIZE$2.large, '22px'), _SIZE$mini$SIZE$compa2)[this.props.size];
      return /*#__PURE__*/React$2.createElement(ClearIconContainer, _extends$S({
        $alignTop: this.props.type === CUSTOM_INPUT_TYPE.textarea
      }, sharedProps, clearIconContainerProps), /*#__PURE__*/React$2.createElement(ClearIcon, _extends$S({
        size: iconSize,
        tabIndex: 0,
        title: ariaLabel,
        "aria-label": ariaLabel,
        onClick: this.onClearIconClick,
        onKeyDown: function onKeyDown(event) {
          if (event.key && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();

            _this3.onClearIconClick();
          }
        },
        role: "button",
        $isFocusVisible: this.state.isFocusVisibleForClear
      }, sharedProps, clearIconProps, {
        onFocus: forkFocus(clearIconProps, this.handleFocusForClear),
        onBlur: forkBlur(clearIconProps, this.handleBlurForClear)
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          value = _this$props3.value,
          type = _this$props3.type,
          _this$props3$override = _this$props3.overrides,
          InputContainerOverride = _this$props3$override.InputContainer,
          InputOverride = _this$props3$override.Input,
          BeforeOverride = _this$props3$override.Before,
          AfterOverride = _this$props3$override.After; // more here https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion#Preventing_autofilling_with_autocompletenew-password

      var autoComplete = this.state.initialType === 'password' && this.props.autoComplete === BaseInput.defaultProps.autoComplete ? 'new-password' : this.props.autoComplete;
      var sharedProps = getSharedProps(this.props, this.state);

      var _getOverrides11 = getOverrides(InputContainerOverride, InputContainer),
          _getOverrides12 = _slicedToArray$K(_getOverrides11, 2),
          InputContainer$1 = _getOverrides12[0],
          inputContainerProps = _getOverrides12[1];

      var _getOverrides13 = getOverrides(InputOverride, Input$3),
          _getOverrides14 = _slicedToArray$K(_getOverrides13, 2),
          Input = _getOverrides14[0],
          inputProps = _getOverrides14[1];

      var _getOverrides15 = getOverrides(BeforeOverride, NullComponent),
          _getOverrides16 = _slicedToArray$K(_getOverrides15, 2),
          Before = _getOverrides16[0],
          beforeProps = _getOverrides16[1];

      var _getOverrides17 = getOverrides(AfterOverride, NullComponent),
          _getOverrides18 = _slicedToArray$K(_getOverrides17, 2),
          After = _getOverrides18[0],
          afterProps = _getOverrides18[1];

      return /*#__PURE__*/React$2.createElement(InputContainer$1, _extends$S({
        "data-baseweb": this.props['data-baseweb'] || 'base-input'
      }, sharedProps, inputContainerProps), /*#__PURE__*/React$2.createElement(Before, _extends$S({}, sharedProps, beforeProps)), /*#__PURE__*/React$2.createElement(Input, _extends$S({
        ref: this.inputRef,
        "aria-activedescendant": this.props['aria-activedescendant'],
        "aria-autocomplete": this.props['aria-autocomplete'],
        "aria-controls": this.props['aria-controls'],
        "aria-errormessage": this.props['aria-errormessage'],
        "aria-haspopup": this.props['aria-haspopup'],
        "aria-label": this.props['aria-label'],
        "aria-labelledby": this.props['aria-labelledby'],
        "aria-describedby": this.props['aria-describedby'],
        "aria-invalid": this.props.error,
        "aria-required": this.props.required,
        autoComplete: autoComplete,
        disabled: this.props.disabled,
        id: this.props.id,
        inputMode: this.props.inputMode,
        maxLength: this.props.maxLength,
        name: this.props.name,
        onBlur: this.onBlur,
        onChange: this.props.onChange,
        onFocus: this.onFocus,
        onKeyDown: this.props.onKeyDown,
        onKeyPress: this.props.onKeyPress,
        onKeyUp: this.props.onKeyUp,
        pattern: this.props.pattern,
        placeholder: this.props.placeholder,
        type: this.getInputType(),
        required: this.props.required,
        role: this.props.role,
        value: this.props.value,
        min: this.props.min,
        max: this.props.max,
        step: this.props.step,
        rows: this.props.type === CUSTOM_INPUT_TYPE.textarea ? this.props.rows : null
      }, sharedProps, inputProps), type === CUSTOM_INPUT_TYPE.textarea ? value : null), this.renderClear(), this.renderMaskToggle(), /*#__PURE__*/React$2.createElement(After, _extends$S({}, sharedProps, afterProps)));
    }
  }]);

  return BaseInput;
}(React$2.Component);

_defineProperty$16(BaseInput, "defaultProps", {
  'aria-activedescendant': null,
  'aria-autocomplete': null,
  'aria-controls': null,
  'aria-errormessage': null,
  'aria-haspopup': null,
  'aria-label': null,
  'aria-labelledby': null,
  'aria-describedby': null,
  adjoined: ADJOINED.none,
  autoComplete: 'on',
  autoFocus: false,
  disabled: false,
  error: false,
  positive: false,
  name: '',
  inputMode: 'text',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onKeyDown: function onKeyDown() {},
  onKeyPress: function onKeyPress() {},
  onKeyUp: function onKeyUp() {},
  onFocus: function onFocus() {},
  onClear: function onClear() {},
  clearable: false,
  clearOnEscape: true,
  overrides: {},
  pattern: null,
  placeholder: '',
  required: false,
  role: null,
  size: SIZE$2.default,
  type: 'text'
});

var BaseInput$1 = BaseInput;

function _typeof$x(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$x = function _typeof(obj) { return typeof obj; }; } else { _typeof$x = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$x(obj); }

function _extends$R() { _extends$R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }

function _slicedToArray$J(arr, i) { return _arrayWithHoles$J(arr) || _iterableToArrayLimit$J(arr, i) || _unsupportedIterableToArray$L(arr, i) || _nonIterableRest$J(); }

function _nonIterableRest$J() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$L(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$L(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$L(o, minLen); }

function _arrayLikeToArray$L(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$J(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$J(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties$s(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$t(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$t(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$x(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$v(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$w(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$v(Constructor.prototype, protoProps); if (staticProps) _defineProperties$v(Constructor, staticProps); return Constructor; }

function _inherits$w(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$v(subClass, superClass); }

function _setPrototypeOf$v(o, p) { _setPrototypeOf$v = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$v(o, p); }

function _createSuper$v(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$v(); return function _createSuperInternal() { var Super = _getPrototypeOf$v(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$v(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$w(this, result); }; }

function _possibleConstructorReturn$w(self, call) { if (call && (_typeof$x(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$x(self); }

function _assertThisInitialized$x(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$v() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$v(o) { _getPrototypeOf$v = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$v(o); }

function _defineProperty$15(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Input$2 = /*#__PURE__*/function (_React$Component) {
  _inherits$w(Input, _React$Component);

  var _super = _createSuper$v(Input);

  function Input() {
    var _this;

    _classCallCheck$x(this, Input);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$15(_assertThisInitialized$x(_this), "state", {
      isFocused: _this.props.autoFocus || false
    });

    _defineProperty$15(_assertThisInitialized$x(_this), "onFocus", function (e) {
      _this.setState({
        isFocused: true
      });

      _this.props.onFocus(e);
    });

    _defineProperty$15(_assertThisInitialized$x(_this), "onBlur", function (e) {
      _this.setState({
        isFocused: false
      });

      _this.props.onBlur(e);
    });

    return _this;
  }

  _createClass$w(Input, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          startEnhancer = _this$props.startEnhancer,
          endEnhancer = _this$props.endEnhancer,
          _this$props$overrides = _this$props.overrides,
          RootOverride = _this$props$overrides.Root,
          StartEnhancerOverride = _this$props$overrides.StartEnhancer,
          EndEnhancerOverride = _this$props$overrides.EndEnhancer,
          restOverrides = _objectWithoutProperties$s(_this$props$overrides, ["Root", "StartEnhancer", "EndEnhancer"]),
          restProps = _objectWithoutProperties$s(_this$props, ["startEnhancer", "endEnhancer", "overrides"]);

      var _getOverrides = getOverrides(RootOverride, Root$6),
          _getOverrides2 = _slicedToArray$J(_getOverrides, 2),
          Root = _getOverrides2[0],
          rootProps = _getOverrides2[1];

      var _getOverrides3 = getOverrides(StartEnhancerOverride, InputEnhancer),
          _getOverrides4 = _slicedToArray$J(_getOverrides3, 2),
          StartEnhancer = _getOverrides4[0],
          startEnhancerProps = _getOverrides4[1];

      var _getOverrides5 = getOverrides(EndEnhancerOverride, InputEnhancer),
          _getOverrides6 = _slicedToArray$J(_getOverrides5, 2),
          EndEnhancer = _getOverrides6[0],
          endEnhancerProps = _getOverrides6[1];

      var sharedProps = getSharedProps(this.props, this.state);

      if (process.env.NODE_ENV !== "production") {
        if (this.props.error && this.props.positive) {
          // eslint-disable-next-line no-console
          console.warn("[Input] `error` and `positive` are both set to `true`. `error` will take precedence but this may not be what you want.");
        }
      }

      return /*#__PURE__*/React$2.createElement(Root, _extends$R({
        "data-baseweb": "input"
      }, sharedProps, rootProps, {
        $adjoined: getAdjoinedProp(startEnhancer, endEnhancer),
        $hasIconTrailing: this.props.clearable || this.props.type == 'password'
      }), isEnhancer(startEnhancer) && /*#__PURE__*/React$2.createElement(StartEnhancer, _extends$R({}, sharedProps, startEnhancerProps, {
        $position: ENHANCER_POSITION.start
      }), typeof startEnhancer === 'function' ? startEnhancer(sharedProps) : startEnhancer), /*#__PURE__*/React$2.createElement(BaseInput$1, _extends$R({}, restProps, {
        overrides: restOverrides,
        adjoined: getAdjoinedProp(startEnhancer, endEnhancer),
        onFocus: this.onFocus,
        onBlur: this.onBlur
      })), isEnhancer(endEnhancer) && /*#__PURE__*/React$2.createElement(EndEnhancer, _extends$R({}, sharedProps, endEnhancerProps, {
        $position: ENHANCER_POSITION.end
      }), typeof endEnhancer === 'function' ? endEnhancer(sharedProps) : endEnhancer));
    }
  }]);

  return Input;
}(React$2.Component);

_defineProperty$15(Input$2, "defaultProps", {
  autoComplete: 'on',
  autoFocus: false,
  disabled: false,
  name: '',
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  overrides: {},
  required: false,
  size: SIZE$2.default,
  startEnhancer: null,
  endEnhancer: null,
  clearable: false,
  type: 'text'
});

function getAdjoinedProp(startEnhancer, endEnhancer) {
  if (isEnhancer(startEnhancer) && isEnhancer(endEnhancer)) {
    return ADJOINED.both;
  } else if (isEnhancer(startEnhancer)) {
    return ADJOINED.left;
  } else if (isEnhancer(endEnhancer)) {
    return ADJOINED.right;
  }

  return ADJOINED.none;
}

function isEnhancer(enhancer) {
  return Boolean(enhancer || enhancer === 0);
}

var DefaultInput = Input$2;

function _interopDefault$1(e){return e&&"object"==typeof e&&"default"in e?e["default"]:e}var React$1=_interopDefault$1(React__default);function _defaults2$1(e,t){for(var n=Object.getOwnPropertyNames(t),a=0;a<n.length;a++){var i=n[a],r=Object.getOwnPropertyDescriptor(t,i);r&&r.configurable&&e[i]===undefined&&Object.defineProperty(e,i,r);}return e}function _extends$Q(){return (_extends$Q=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);}return e}).apply(this,arguments)}function _inheritsLoose$1(e,t){e.prototype=Object.create(t.prototype),_defaults2$1(e.prototype.constructor=e,t);}function _objectWithoutPropertiesLoose$s(e,t){if(null==e)return {};var n,a,i={},r=Object.keys(e);for(a=0;a<r.length;a++)n=r[a],0<=t.indexOf(n)||(i[n]=e[n]);return i}function _assertThisInitialized$w(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var invariant$2=function(e,t,n,a,i,r,o,s){if(!e){var l;if(t===undefined)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {var u=[n,a,i,r,o,s],c=0;(l=new Error(t.replace(/%s/g,function(){return u[c++]}))).name="Invariant Violation";}throw l.framesToPop=1,l}},invariant_1$1=invariant$2;function setInputSelection$1(e,t,n){if("selectionStart"in e&&"selectionEnd"in e)e.selectionStart=t,e.selectionEnd=n;else {var a=e.createTextRange();a.collapse(!0),a.moveStart("character",t),a.moveEnd("character",n-t),a.select();}}function getInputSelection$1(e){var t=0,n=0;if("selectionStart"in e&&"selectionEnd"in e)t=e.selectionStart,n=e.selectionEnd;else {var a=document.selection.createRange();a.parentElement()===e&&(t=-a.moveStart("character",-e.value.length),n=-a.moveEnd("character",-e.value.length));}return {start:t,end:n,length:n-t}}var defaultFormatChars$1={9:"[0-9]",a:"[A-Za-z]","*":"[A-Za-z0-9]"},defaultMaskChar$1="_";function parseMask$1(e,t,n){var a="",i="",r=null,o=[];if(t===undefined&&(t=defaultMaskChar$1),null==n&&(n=defaultFormatChars$1),!e||"string"!=typeof e)return {maskChar:t,formatChars:n,mask:null,prefix:null,lastEditablePosition:null,permanents:[]};var s=!1;return e.split("").forEach(function(e){s=!s&&"\\"===e||(s||!n[e]?(o.push(a.length),a.length===o.length-1&&(i+=e)):r=a.length+1,a+=e,!1);}),{maskChar:t,formatChars:n,prefix:i,mask:a,lastEditablePosition:r,permanents:o}}function isPermanentCharacter$1(e,t){return -1!==e.permanents.indexOf(t)}function isAllowedCharacter$1(e,t,n){var a=e.mask,i=e.formatChars;if(!n)return !1;if(isPermanentCharacter$1(e,t))return a[t]===n;var r=i[a[t]];return new RegExp(r).test(n)}function isEmpty$1(n,e){return e.split("").every(function(e,t){return isPermanentCharacter$1(n,t)||!isAllowedCharacter$1(n,t,e)})}function getFilledLength$1(e,t){var n=e.maskChar,a=e.prefix;if(!n){for(;t.length>a.length&&isPermanentCharacter$1(e,t.length-1);)t=t.slice(0,t.length-1);return t.length}for(var i=a.length,r=t.length;r>=a.length;r--){var o=t[r];if(!isPermanentCharacter$1(e,r)&&isAllowedCharacter$1(e,r,o)){i=r+1;break}}return i}function isFilled$1(e,t){return getFilledLength$1(e,t)===e.mask.length}function formatValue$1(e,t){var n=e.maskChar,a=e.mask,i=e.prefix;if(!n){for((t=insertString$1(e,"",t,0)).length<i.length&&(t=i);t.length<a.length&&isPermanentCharacter$1(e,t.length);)t+=a[t.length];return t}if(t)return insertString$1(e,formatValue$1(e,""),t,0);for(var r=0;r<a.length;r++)isPermanentCharacter$1(e,r)?t+=a[r]:t+=n;return t}function clearRange$1(n,e,a,t){var i=a+t,r=n.maskChar,o=n.mask,s=n.prefix,l=e.split("");if(r)return l.map(function(e,t){return t<a||i<=t?e:isPermanentCharacter$1(n,t)?o[t]:r}).join("");for(var u=i;u<l.length;u++)isPermanentCharacter$1(n,u)&&(l[u]="");return a=Math.max(s.length,a),l.splice(a,i-a),e=l.join(""),formatValue$1(n,e)}function insertString$1(r,o,e,s){var l=r.mask,u=r.maskChar,c=r.prefix,t=e.split(""),h=isFilled$1(r,o);return !u&&s>o.length&&(o+=l.slice(o.length,s)),t.every(function(e){for(;i=e,isPermanentCharacter$1(r,a=s)&&i!==l[a];){if(s>=o.length&&(o+=l[s]),t=e,n=s,u&&isPermanentCharacter$1(r,n)&&t===u)return !0;if(++s>=l.length)return !1}var t,n,a,i;return !isAllowedCharacter$1(r,s,e)&&e!==u||(s<o.length?o=u||h||s<c.length?o.slice(0,s)+e+o.slice(s+1):(o=o.slice(0,s)+e+o.slice(s),formatValue$1(r,o)):u||(o+=e),++s<l.length)}),o}function getInsertStringLength$1(a,e,t,i){var r=a.mask,o=a.maskChar,n=t.split(""),s=i;return n.every(function(e){for(;n=e,isPermanentCharacter$1(a,t=i)&&n!==r[t];)if(++i>=r.length)return !1;var t,n;return (isAllowedCharacter$1(a,i,e)||e===o)&&i++,i<r.length}),i-s}function getLeftEditablePosition$1(e,t){for(var n=t;0<=n;--n)if(!isPermanentCharacter$1(e,n))return n;return null}function getRightEditablePosition$1(e,t){for(var n=e.mask,a=t;a<n.length;++a)if(!isPermanentCharacter$1(e,a))return a;return null}function getStringValue$1(e){return e||0===e?e+"":""}function processChange$1(e,t,n,a,i){var r=e.mask,o=e.prefix,s=e.lastEditablePosition,l=t,u="",c=0,h=0,f=Math.min(i.start,n.start);if(n.end>i.start?h=(c=getInsertStringLength$1(e,a,u=l.slice(i.start,n.end),f))?i.length:0:l.length<a.length&&(h=a.length-l.length),l=a,h){if(1===h&&!i.length)f=i.start===n.start?getRightEditablePosition$1(e,n.start):getLeftEditablePosition$1(e,n.start);l=clearRange$1(e,l,f,h);}return l=insertString$1(e,l,u,f),(f+=c)>=r.length?f=r.length:f<o.length&&!c?f=o.length:f>=o.length&&f<s&&c&&(f=getRightEditablePosition$1(e,f)),u||(u=null),{value:l=formatValue$1(e,l),enteredString:u,selection:{start:f,end:f}}}function isWindowsPhoneBrowser$1(){var e=new RegExp("windows","i"),t=new RegExp("phone","i"),n=navigator.userAgent;return e.test(n)&&t.test(n)}function isFunction$1(e){return "function"==typeof e}function getRequestAnimationFrame$1(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame}function getCancelAnimationFrame$1(){return window.cancelAnimationFrame||window.webkitCancelRequestAnimationFrame||window.webkitCancelAnimationFrame||window.mozCancelAnimationFrame}function defer$1(e){return (!!getCancelAnimationFrame$1()?getRequestAnimationFrame$1():function(){return setTimeout(e,1e3/60)})(e)}function cancelDefer$1(e){(getCancelAnimationFrame$1()||clearTimeout)(e);}var InputElement$1=function(c){function e(e){var f=c.call(this,e)||this;f.focused=!1,f.mounted=!1,f.previousSelection=null,f.selectionDeferId=null,f.saveSelectionLoopDeferId=null,f.saveSelectionLoop=function(){f.previousSelection=f.getSelection(),f.saveSelectionLoopDeferId=defer$1(f.saveSelectionLoop);},f.runSaveSelectionLoop=function(){null===f.saveSelectionLoopDeferId&&f.saveSelectionLoop();},f.stopSaveSelectionLoop=function(){null!==f.saveSelectionLoopDeferId&&(cancelDefer$1(f.saveSelectionLoopDeferId),f.saveSelectionLoopDeferId=null,f.previousSelection=null);},f.getInputDOMNode=function(){if(!f.mounted)return null;var e=ReactDOM.findDOMNode(_assertThisInitialized$w(_assertThisInitialized$w(f))),t="undefined"!=typeof window&&e instanceof window.Element;if(e&&!t)return null;if("INPUT"!==e.nodeName&&(e=e.querySelector("input")),!e)throw new Error("react-input-mask: inputComponent doesn't contain input node");return e},f.getInputValue=function(){var e=f.getInputDOMNode();return e?e.value:null},f.setInputValue=function(e){var t=f.getInputDOMNode();t&&(f.value=e,t.value=e);},f.setCursorToEnd=function(){var e=getFilledLength$1(f.maskOptions,f.value),t=getRightEditablePosition$1(f.maskOptions,e);null!==t&&f.setCursorPosition(t);},f.setSelection=function(e,t,n){void 0===n&&(n={});var a=f.getInputDOMNode(),i=f.isFocused();a&&i&&(n.deferred||setInputSelection$1(a,e,t),null!==f.selectionDeferId&&cancelDefer$1(f.selectionDeferId),f.selectionDeferId=defer$1(function(){f.selectionDeferId=null,setInputSelection$1(a,e,t);}),f.previousSelection={start:e,end:t,length:Math.abs(t-e)});},f.getSelection=function(){return getInputSelection$1(f.getInputDOMNode())},f.getCursorPosition=function(){return f.getSelection().start},f.setCursorPosition=function(e){f.setSelection(e,e);},f.isFocused=function(){return f.focused},f.getBeforeMaskedValueChangeConfig=function(){var e=f.maskOptions,t=e.mask,n=e.maskChar,a=e.permanents,i=e.formatChars;return {mask:t,maskChar:n,permanents:a,alwaysShowMask:!!f.props.alwaysShowMask,formatChars:i}},f.isInputAutofilled=function(e,t,n,a){var i=f.getInputDOMNode();try{if(i.matches(":-webkit-autofill"))return !0}catch(r){}return !f.focused||a.end<n.length&&t.end===e.length},f.onChange=function(e){var t=_assertThisInitialized$w(_assertThisInitialized$w(f)).beforePasteState,n=_assertThisInitialized$w(_assertThisInitialized$w(f)).previousSelection,a=f.props.beforeMaskedValueChange,i=f.getInputValue(),r=f.value,o=f.getSelection();f.isInputAutofilled(i,o,r,n)&&(r=formatValue$1(f.maskOptions,""),n={start:0,end:0,length:0}),t&&(n=t.selection,r=t.value,o={start:n.start+i.length,end:n.start+i.length,length:0},i=r.slice(0,n.start)+i+r.slice(n.end),f.beforePasteState=null);var s=processChange$1(f.maskOptions,i,o,r,n),l=s.enteredString,u=s.selection,c=s.value;if(isFunction$1(a)){var h=a({value:c,selection:u},{value:r,selection:n},l,f.getBeforeMaskedValueChangeConfig());c=h.value,u=h.selection;}f.setInputValue(c),isFunction$1(f.props.onChange)&&f.props.onChange(e),f.isWindowsPhoneBrowser?f.setSelection(u.start,u.end,{deferred:!0}):f.setSelection(u.start,u.end);},f.onFocus=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions,a=n.mask,i=n.prefix;if(f.focused=!0,f.mounted=!0,a){if(f.value)getFilledLength$1(f.maskOptions,f.value)<f.maskOptions.mask.length&&f.setCursorToEnd();else {var r=formatValue$1(f.maskOptions,i),o=formatValue$1(f.maskOptions,r),s=getFilledLength$1(f.maskOptions,o),l=getRightEditablePosition$1(f.maskOptions,s),u={start:l,end:l};if(isFunction$1(t)){var c=t({value:o,selection:u},{value:f.value,selection:null},null,f.getBeforeMaskedValueChangeConfig());o=c.value,u=c.selection;}var h=o!==f.getInputValue();h&&f.setInputValue(o),h&&isFunction$1(f.props.onChange)&&f.props.onChange(e),f.setSelection(u.start,u.end);}f.runSaveSelectionLoop();}isFunction$1(f.props.onFocus)&&f.props.onFocus(e);},f.onBlur=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions.mask;if(f.stopSaveSelectionLoop(),f.focused=!1,n&&!f.props.alwaysShowMask&&isEmpty$1(f.maskOptions,f.value)){var a="";if(isFunction$1(t))a=t({value:a,selection:null},{value:f.value,selection:f.previousSelection},null,f.getBeforeMaskedValueChangeConfig()).value;var i=a!==f.getInputValue();i&&f.setInputValue(a),i&&isFunction$1(f.props.onChange)&&f.props.onChange(e);}isFunction$1(f.props.onBlur)&&f.props.onBlur(e);},f.onMouseDown=function(e){if(!f.focused&&document.addEventListener){f.mouseDownX=e.clientX,f.mouseDownY=e.clientY,f.mouseDownTime=(new Date).getTime();var r=function r(e){if(document.removeEventListener("mouseup",r),f.focused){var t=Math.abs(e.clientX-f.mouseDownX),n=Math.abs(e.clientY-f.mouseDownY),a=Math.max(t,n),i=(new Date).getTime()-f.mouseDownTime;(a<=10&&i<=200||a<=5&&i<=300)&&f.setCursorToEnd();}};document.addEventListener("mouseup",r);}isFunction$1(f.props.onMouseDown)&&f.props.onMouseDown(e);},f.onPaste=function(e){isFunction$1(f.props.onPaste)&&f.props.onPaste(e),e.defaultPrevented||(f.beforePasteState={value:f.getInputValue(),selection:f.getSelection()},f.setInputValue(""));},f.handleRef=function(e){null==f.props.children&&isFunction$1(f.props.inputRef)&&f.props.inputRef(e);};var t=e.mask,n=e.maskChar,a=e.formatChars,i=e.alwaysShowMask,r=e.beforeMaskedValueChange,o=e.defaultValue,s=e.value;f.maskOptions=parseMask$1(t,n,a),null==o&&(o=""),null==s&&(s=o);var l=getStringValue$1(s);if(f.maskOptions.mask&&(i||l)&&(l=formatValue$1(f.maskOptions,l),isFunction$1(r))){var u=e.value;null==e.value&&(u=o),l=r({value:l,selection:null},{value:u=getStringValue$1(u),selection:null},null,f.getBeforeMaskedValueChangeConfig()).value;}return f.value=l,f}_inheritsLoose$1(e,c);var t=e.prototype;return t.componentDidMount=function(){this.mounted=!0,this.getInputDOMNode()&&(this.isWindowsPhoneBrowser=isWindowsPhoneBrowser$1(),this.maskOptions.mask&&this.getInputValue()!==this.value&&this.setInputValue(this.value));},t.componentDidUpdate=function(){var e=this.previousSelection,t=this.props,n=t.beforeMaskedValueChange,a=t.alwaysShowMask,i=t.mask,r=t.maskChar,o=t.formatChars,s=this.maskOptions,l=a||this.isFocused(),u=null!=this.props.value,c=u?getStringValue$1(this.props.value):this.value,h=e?e.start:null;if(this.maskOptions=parseMask$1(i,r,o),this.maskOptions.mask){!s.mask&&this.isFocused()&&this.runSaveSelectionLoop();var f=this.maskOptions.mask&&this.maskOptions.mask!==s.mask;if(s.mask||u||(c=this.getInputValue()),(f||this.maskOptions.mask&&(c||l))&&(c=formatValue$1(this.maskOptions,c)),f){var p=getFilledLength$1(this.maskOptions,c);(null===h||p<h)&&(h=isFilled$1(this.maskOptions,c)?p:getRightEditablePosition$1(this.maskOptions,p));}!this.maskOptions.mask||!isEmpty$1(this.maskOptions,c)||l||u&&this.props.value||(c="");var d={start:h,end:h};if(isFunction$1(n)){var m=n({value:c,selection:d},{value:this.value,selection:this.previousSelection},null,this.getBeforeMaskedValueChangeConfig());c=m.value,d=m.selection;}this.value=c;var g=this.getInputValue()!==this.value;g?(this.setInputValue(this.value),this.forceUpdate()):f&&this.forceUpdate();var v=!1;null!=d.start&&null!=d.end&&(v=!e||e.start!==d.start||e.end!==d.end),(v||g)&&this.setSelection(d.start,d.end);}else s.mask&&(this.stopSaveSelectionLoop(),this.forceUpdate());},t.componentWillUnmount=function(){this.mounted=!1,null!==this.selectionDeferId&&cancelDefer$1(this.selectionDeferId),this.stopSaveSelectionLoop();},t.render=function(){var t,e=this.props,n=(e.mask,e.alwaysShowMask,e.maskChar,e.formatChars,e.inputRef,e.beforeMaskedValueChange,e.children),a=_objectWithoutPropertiesLoose$s(e,["mask","alwaysShowMask","maskChar","formatChars","inputRef","beforeMaskedValueChange","children"]);if(n){isFunction$1(n)||invariant_1$1(!1);var i=["onChange","onPaste","onMouseDown","onFocus","onBlur","value","disabled","readOnly"],r=_extends$Q({},a);i.forEach(function(e){return delete r[e]}),t=n(r),i.filter(function(e){return null!=t.props[e]&&t.props[e]!==a[e]}).length&&invariant_1$1(!1);}else t=React$1.createElement("input",_extends$Q({ref:this.handleRef},a));var o={onFocus:this.onFocus,onBlur:this.onBlur};return this.maskOptions.mask&&(a.disabled||a.readOnly||(o.onChange=this.onChange,o.onPaste=this.onPaste,o.onMouseDown=this.onMouseDown),null!=a.value&&(o.value=this.value)),t=React$1.cloneElement(t,o)},e}(React$1.Component);var reactInputMask_production_min=InputElement$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = process.env.NODE_ENV;

var invariant$1 = function(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var invariant_1 = invariant$1;

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning$1 = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning$1 = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning$1;

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(React__default);

var invariant = _interopDefault(invariant_1);
var warning = _interopDefault(warning_1);

function _defaults2(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _extends$P() {
  _extends$P = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$P.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _defaults2(subClass, superClass);
}

function _objectWithoutPropertiesLoose$r(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized$v(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function setInputSelection(input, start, end) {
  if ('selectionStart' in input && 'selectionEnd' in input) {
    input.selectionStart = start;
    input.selectionEnd = end;
  } else {
    var range = input.createTextRange();
    range.collapse(true);
    range.moveStart('character', start);
    range.moveEnd('character', end - start);
    range.select();
  }
}
function getInputSelection(input) {
  var start = 0;
  var end = 0;

  if ('selectionStart' in input && 'selectionEnd' in input) {
    start = input.selectionStart;
    end = input.selectionEnd;
  } else {
    var range = document.selection.createRange();

    if (range.parentElement() === input) {
      start = -range.moveStart('character', -input.value.length);
      end = -range.moveEnd('character', -input.value.length);
    }
  }

  return {
    start: start,
    end: end,
    length: end - start
  };
}

var defaultFormatChars = {
  '9': '[0-9]',
  'a': '[A-Za-z]',
  '*': '[A-Za-z0-9]'
};
var defaultMaskChar = '_';

function parseMask (mask, maskChar, formatChars) {
  var parsedMaskString = '';
  var prefix = '';
  var lastEditablePosition = null;
  var permanents = [];

  if (maskChar === undefined) {
    maskChar = defaultMaskChar;
  }

  if (formatChars == null) {
    formatChars = defaultFormatChars;
  }

  if (!mask || typeof mask !== 'string') {
    return {
      maskChar: maskChar,
      formatChars: formatChars,
      mask: null,
      prefix: null,
      lastEditablePosition: null,
      permanents: []
    };
  }

  var isPermanent = false;
  mask.split('').forEach(function (character) {
    if (!isPermanent && character === '\\') {
      isPermanent = true;
    } else {
      if (isPermanent || !formatChars[character]) {
        permanents.push(parsedMaskString.length);

        if (parsedMaskString.length === permanents.length - 1) {
          prefix += character;
        }
      } else {
        lastEditablePosition = parsedMaskString.length + 1;
      }

      parsedMaskString += character;
      isPermanent = false;
    }
  });
  return {
    maskChar: maskChar,
    formatChars: formatChars,
    prefix: prefix,
    mask: parsedMaskString,
    lastEditablePosition: lastEditablePosition,
    permanents: permanents
  };
}

/* eslint no-use-before-define: ["error", { functions: false }] */
function isPermanentCharacter(maskOptions, pos) {
  return maskOptions.permanents.indexOf(pos) !== -1;
}
function isAllowedCharacter(maskOptions, pos, character) {
  var mask = maskOptions.mask,
      formatChars = maskOptions.formatChars;

  if (!character) {
    return false;
  }

  if (isPermanentCharacter(maskOptions, pos)) {
    return mask[pos] === character;
  }

  var ruleChar = mask[pos];
  var charRule = formatChars[ruleChar];
  return new RegExp(charRule).test(character);
}
function isEmpty(maskOptions, value) {
  return value.split('').every(function (character, i) {
    return isPermanentCharacter(maskOptions, i) || !isAllowedCharacter(maskOptions, i, character);
  });
}
function getFilledLength(maskOptions, value) {
  var maskChar = maskOptions.maskChar,
      prefix = maskOptions.prefix;

  if (!maskChar) {
    while (value.length > prefix.length && isPermanentCharacter(maskOptions, value.length - 1)) {
      value = value.slice(0, value.length - 1);
    }

    return value.length;
  }

  var filledLength = prefix.length;

  for (var i = value.length; i >= prefix.length; i--) {
    var character = value[i];
    var isEnteredCharacter = !isPermanentCharacter(maskOptions, i) && isAllowedCharacter(maskOptions, i, character);

    if (isEnteredCharacter) {
      filledLength = i + 1;
      break;
    }
  }

  return filledLength;
}
function isFilled(maskOptions, value) {
  return getFilledLength(maskOptions, value) === maskOptions.mask.length;
}
function formatValue(maskOptions, value) {
  var maskChar = maskOptions.maskChar,
      mask = maskOptions.mask,
      prefix = maskOptions.prefix;

  if (!maskChar) {
    value = insertString(maskOptions, '', value, 0);

    if (value.length < prefix.length) {
      value = prefix;
    }

    while (value.length < mask.length && isPermanentCharacter(maskOptions, value.length)) {
      value += mask[value.length];
    }

    return value;
  }

  if (value) {
    var emptyValue = formatValue(maskOptions, '');
    return insertString(maskOptions, emptyValue, value, 0);
  }

  for (var i = 0; i < mask.length; i++) {
    if (isPermanentCharacter(maskOptions, i)) {
      value += mask[i];
    } else {
      value += maskChar;
    }
  }

  return value;
}
function clearRange(maskOptions, value, start, len) {
  var end = start + len;
  var maskChar = maskOptions.maskChar,
      mask = maskOptions.mask,
      prefix = maskOptions.prefix;
  var arrayValue = value.split('');

  if (!maskChar) {
    // remove any permanent chars after clear range, they will be added back by formatValue
    for (var i = end; i < arrayValue.length; i++) {
      if (isPermanentCharacter(maskOptions, i)) {
        arrayValue[i] = '';
      }
    }

    start = Math.max(prefix.length, start);
    arrayValue.splice(start, end - start);
    value = arrayValue.join('');
    return formatValue(maskOptions, value);
  }

  return arrayValue.map(function (character, i) {
    if (i < start || i >= end) {
      return character;
    }

    if (isPermanentCharacter(maskOptions, i)) {
      return mask[i];
    }

    return maskChar;
  }).join('');
}
function insertString(maskOptions, value, insertStr, insertPosition) {
  var mask = maskOptions.mask,
      maskChar = maskOptions.maskChar,
      prefix = maskOptions.prefix;
  var arrayInsertStr = insertStr.split('');
  var isInputFilled = isFilled(maskOptions, value);

  var isUsablePosition = function isUsablePosition(pos, character) {
    return !isPermanentCharacter(maskOptions, pos) || character === mask[pos];
  };

  var isUsableCharacter = function isUsableCharacter(character, pos) {
    return !maskChar || !isPermanentCharacter(maskOptions, pos) || character !== maskChar;
  };

  if (!maskChar && insertPosition > value.length) {
    value += mask.slice(value.length, insertPosition);
  }

  arrayInsertStr.every(function (insertCharacter) {
    while (!isUsablePosition(insertPosition, insertCharacter)) {
      if (insertPosition >= value.length) {
        value += mask[insertPosition];
      }

      if (!isUsableCharacter(insertCharacter, insertPosition)) {
        return true;
      }

      insertPosition++; // stop iteration if maximum value length reached

      if (insertPosition >= mask.length) {
        return false;
      }
    }

    var isAllowed = isAllowedCharacter(maskOptions, insertPosition, insertCharacter) || insertCharacter === maskChar;

    if (!isAllowed) {
      return true;
    }

    if (insertPosition < value.length) {
      if (maskChar || isInputFilled || insertPosition < prefix.length) {
        value = value.slice(0, insertPosition) + insertCharacter + value.slice(insertPosition + 1);
      } else {
        value = value.slice(0, insertPosition) + insertCharacter + value.slice(insertPosition);
        value = formatValue(maskOptions, value);
      }
    } else if (!maskChar) {
      value += insertCharacter;
    }

    insertPosition++; // stop iteration if maximum value length reached

    return insertPosition < mask.length;
  });
  return value;
}
function getInsertStringLength(maskOptions, value, insertStr, insertPosition) {
  var mask = maskOptions.mask,
      maskChar = maskOptions.maskChar;
  var arrayInsertStr = insertStr.split('');
  var initialInsertPosition = insertPosition;

  var isUsablePosition = function isUsablePosition(pos, character) {
    return !isPermanentCharacter(maskOptions, pos) || character === mask[pos];
  };

  arrayInsertStr.every(function (insertCharacter) {
    while (!isUsablePosition(insertPosition, insertCharacter)) {
      insertPosition++; // stop iteration if maximum value length reached

      if (insertPosition >= mask.length) {
        return false;
      }
    }

    var isAllowed = isAllowedCharacter(maskOptions, insertPosition, insertCharacter) || insertCharacter === maskChar;

    if (isAllowed) {
      insertPosition++;
    } // stop iteration if maximum value length reached


    return insertPosition < mask.length;
  });
  return insertPosition - initialInsertPosition;
}
function getLeftEditablePosition(maskOptions, pos) {
  for (var i = pos; i >= 0; --i) {
    if (!isPermanentCharacter(maskOptions, i)) {
      return i;
    }
  }

  return null;
}
function getRightEditablePosition(maskOptions, pos) {
  var mask = maskOptions.mask;

  for (var i = pos; i < mask.length; ++i) {
    if (!isPermanentCharacter(maskOptions, i)) {
      return i;
    }
  }

  return null;
}
function getStringValue(value) {
  return !value && value !== 0 ? '' : value + '';
}

function processChange(maskOptions, value, selection, previousValue, previousSelection) {
  var mask = maskOptions.mask,
      prefix = maskOptions.prefix,
      lastEditablePosition = maskOptions.lastEditablePosition;
  var newValue = value;
  var enteredString = '';
  var formattedEnteredStringLength = 0;
  var removedLength = 0;
  var cursorPosition = Math.min(previousSelection.start, selection.start);

  if (selection.end > previousSelection.start) {
    enteredString = newValue.slice(previousSelection.start, selection.end);
    formattedEnteredStringLength = getInsertStringLength(maskOptions, previousValue, enteredString, cursorPosition);

    if (!formattedEnteredStringLength) {
      removedLength = 0;
    } else {
      removedLength = previousSelection.length;
    }
  } else if (newValue.length < previousValue.length) {
    removedLength = previousValue.length - newValue.length;
  }

  newValue = previousValue;

  if (removedLength) {
    if (removedLength === 1 && !previousSelection.length) {
      var deleteFromRight = previousSelection.start === selection.start;
      cursorPosition = deleteFromRight ? getRightEditablePosition(maskOptions, selection.start) : getLeftEditablePosition(maskOptions, selection.start);
    }

    newValue = clearRange(maskOptions, newValue, cursorPosition, removedLength);
  }

  newValue = insertString(maskOptions, newValue, enteredString, cursorPosition);
  cursorPosition = cursorPosition + formattedEnteredStringLength;

  if (cursorPosition >= mask.length) {
    cursorPosition = mask.length;
  } else if (cursorPosition < prefix.length && !formattedEnteredStringLength) {
    cursorPosition = prefix.length;
  } else if (cursorPosition >= prefix.length && cursorPosition < lastEditablePosition && formattedEnteredStringLength) {
    cursorPosition = getRightEditablePosition(maskOptions, cursorPosition);
  }

  newValue = formatValue(maskOptions, newValue);

  if (!enteredString) {
    enteredString = null;
  }

  return {
    value: newValue,
    enteredString: enteredString,
    selection: {
      start: cursorPosition,
      end: cursorPosition
    }
  };
}

function isWindowsPhoneBrowser() {
  var windows = new RegExp('windows', 'i');
  var phone = new RegExp('phone', 'i');
  var ua = navigator.userAgent;
  return windows.test(ua) && phone.test(ua);
}

function isFunction(value) {
  return typeof value === 'function';
}

function getRequestAnimationFrame() {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
}

function getCancelAnimationFrame() {
  return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
}

function defer(fn) {
  var hasCancelAnimationFrame = !!getCancelAnimationFrame();
  var deferFn;

  if (hasCancelAnimationFrame) {
    deferFn = getRequestAnimationFrame();
  } else {
    deferFn = function deferFn() {
      return setTimeout(fn, 1000 / 60);
    };
  }

  return deferFn(fn);
}
function cancelDefer(deferId) {
  var cancelFn = getCancelAnimationFrame() || clearTimeout;
  cancelFn(deferId);
}

var InputElement =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(InputElement, _React$Component);

  function InputElement(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.focused = false;
    _this.mounted = false;
    _this.previousSelection = null;
    _this.selectionDeferId = null;
    _this.saveSelectionLoopDeferId = null;

    _this.saveSelectionLoop = function () {
      _this.previousSelection = _this.getSelection();
      _this.saveSelectionLoopDeferId = defer(_this.saveSelectionLoop);
    };

    _this.runSaveSelectionLoop = function () {
      if (_this.saveSelectionLoopDeferId === null) {
        _this.saveSelectionLoop();
      }
    };

    _this.stopSaveSelectionLoop = function () {
      if (_this.saveSelectionLoopDeferId !== null) {
        cancelDefer(_this.saveSelectionLoopDeferId);
        _this.saveSelectionLoopDeferId = null;
        _this.previousSelection = null;
      }
    };

    _this.getInputDOMNode = function () {
      if (!_this.mounted) {
        return null;
      }

      var input = ReactDOM.findDOMNode(_assertThisInitialized$v(_assertThisInitialized$v(_this)));
      var isDOMNode = typeof window !== 'undefined' && input instanceof window.Element; // workaround for react-test-renderer
      // https://github.com/sanniassin/react-input-mask/issues/147

      if (input && !isDOMNode) {
        return null;
      }

      if (input.nodeName !== 'INPUT') {
        input = input.querySelector('input');
      }

      if (!input) {
        throw new Error('react-input-mask: inputComponent doesn\'t contain input node');
      }

      return input;
    };

    _this.getInputValue = function () {
      var input = _this.getInputDOMNode();

      if (!input) {
        return null;
      }

      return input.value;
    };

    _this.setInputValue = function (value) {
      var input = _this.getInputDOMNode();

      if (!input) {
        return;
      }

      _this.value = value;
      input.value = value;
    };

    _this.setCursorToEnd = function () {
      var filledLength = getFilledLength(_this.maskOptions, _this.value);
      var pos = getRightEditablePosition(_this.maskOptions, filledLength);

      if (pos !== null) {
        _this.setCursorPosition(pos);
      }
    };

    _this.setSelection = function (start, end, options) {
      if (options === void 0) {
        options = {};
      }

      var input = _this.getInputDOMNode();

      var isFocused = _this.isFocused(); // don't change selection on unfocused input
      // because Safari sets focus on selection change (#154)


      if (!input || !isFocused) {
        return;
      }

      var _options = options,
          deferred = _options.deferred;

      if (!deferred) {
        setInputSelection(input, start, end);
      }

      if (_this.selectionDeferId !== null) {
        cancelDefer(_this.selectionDeferId);
      } // deferred selection update is required for pre-Lollipop Android browser,
      // but for consistent behavior we do it for all browsers


      _this.selectionDeferId = defer(function () {
        _this.selectionDeferId = null;
        setInputSelection(input, start, end);
      });
      _this.previousSelection = {
        start: start,
        end: end,
        length: Math.abs(end - start)
      };
    };

    _this.getSelection = function () {
      var input = _this.getInputDOMNode();

      return getInputSelection(input);
    };

    _this.getCursorPosition = function () {
      return _this.getSelection().start;
    };

    _this.setCursorPosition = function (pos) {
      _this.setSelection(pos, pos);
    };

    _this.isFocused = function () {
      return _this.focused;
    };

    _this.getBeforeMaskedValueChangeConfig = function () {
      var _this$maskOptions = _this.maskOptions,
          mask = _this$maskOptions.mask,
          maskChar = _this$maskOptions.maskChar,
          permanents = _this$maskOptions.permanents,
          formatChars = _this$maskOptions.formatChars;
      var alwaysShowMask = _this.props.alwaysShowMask;
      return {
        mask: mask,
        maskChar: maskChar,
        permanents: permanents,
        alwaysShowMask: !!alwaysShowMask,
        formatChars: formatChars
      };
    };

    _this.isInputAutofilled = function (value, selection, previousValue, previousSelection) {
      var input = _this.getInputDOMNode(); // only check for positive match because it will be false negative
      // in case of autofill simulation in tests
      //
      // input.matches throws an exception if selector isn't supported


      try {
        if (input.matches(':-webkit-autofill')) {
          return true;
        }
      } catch (e) {} // if input isn't focused then change event must have been triggered
      // either by autofill or event simulation in tests


      if (!_this.focused) {
        return true;
      } // if cursor has moved to the end while previousSelection forbids it
      // then it must be autofill


      return previousSelection.end < previousValue.length && selection.end === value.length;
    };

    _this.onChange = function (event) {
      var _assertThisInitialize = _assertThisInitialized$v(_assertThisInitialized$v(_this)),
          beforePasteState = _assertThisInitialize.beforePasteState;

      var _assertThisInitialize2 = _assertThisInitialized$v(_assertThisInitialized$v(_this)),
          previousSelection = _assertThisInitialize2.previousSelection;

      var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;

      var value = _this.getInputValue();

      var previousValue = _this.value;

      var selection = _this.getSelection(); // autofill replaces entire value, ignore old one
      // https://github.com/sanniassin/react-input-mask/issues/113


      if (_this.isInputAutofilled(value, selection, previousValue, previousSelection)) {
        previousValue = formatValue(_this.maskOptions, '');
        previousSelection = {
          start: 0,
          end: 0,
          length: 0
        };
      } // set value and selection as if we haven't
      // cleared input in onPaste handler


      if (beforePasteState) {
        previousSelection = beforePasteState.selection;
        previousValue = beforePasteState.value;
        selection = {
          start: previousSelection.start + value.length,
          end: previousSelection.start + value.length,
          length: 0
        };
        value = previousValue.slice(0, previousSelection.start) + value + previousValue.slice(previousSelection.end);
        _this.beforePasteState = null;
      }

      var changedState = processChange(_this.maskOptions, value, selection, previousValue, previousSelection);
      var enteredString = changedState.enteredString;
      var newSelection = changedState.selection;
      var newValue = changedState.value;

      if (isFunction(beforeMaskedValueChange)) {
        var modifiedValue = beforeMaskedValueChange({
          value: newValue,
          selection: newSelection
        }, {
          value: previousValue,
          selection: previousSelection
        }, enteredString, _this.getBeforeMaskedValueChangeConfig());
        newValue = modifiedValue.value;
        newSelection = modifiedValue.selection;
      }

      _this.setInputValue(newValue);

      if (isFunction(_this.props.onChange)) {
        _this.props.onChange(event);
      }

      if (_this.isWindowsPhoneBrowser) {
        _this.setSelection(newSelection.start, newSelection.end, {
          deferred: true
        });
      } else {
        _this.setSelection(newSelection.start, newSelection.end);
      }
    };

    _this.onFocus = function (event) {
      var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;
      var _this$maskOptions2 = _this.maskOptions,
          mask = _this$maskOptions2.mask,
          prefix = _this$maskOptions2.prefix;
      _this.focused = true; // if autoFocus is set, onFocus triggers before componentDidMount

      _this.mounted = true;

      if (mask) {
        if (!_this.value) {
          var emptyValue = formatValue(_this.maskOptions, prefix);
          var newValue = formatValue(_this.maskOptions, emptyValue);
          var filledLength = getFilledLength(_this.maskOptions, newValue);
          var cursorPosition = getRightEditablePosition(_this.maskOptions, filledLength);
          var newSelection = {
            start: cursorPosition,
            end: cursorPosition
          };

          if (isFunction(beforeMaskedValueChange)) {
            var modifiedValue = beforeMaskedValueChange({
              value: newValue,
              selection: newSelection
            }, {
              value: _this.value,
              selection: null
            }, null, _this.getBeforeMaskedValueChangeConfig());
            newValue = modifiedValue.value;
            newSelection = modifiedValue.selection;
          }

          var isInputValueChanged = newValue !== _this.getInputValue();

          if (isInputValueChanged) {
            _this.setInputValue(newValue);
          }

          if (isInputValueChanged && isFunction(_this.props.onChange)) {
            _this.props.onChange(event);
          }

          _this.setSelection(newSelection.start, newSelection.end);
        } else if (getFilledLength(_this.maskOptions, _this.value) < _this.maskOptions.mask.length) {
          _this.setCursorToEnd();
        }

        _this.runSaveSelectionLoop();
      }

      if (isFunction(_this.props.onFocus)) {
        _this.props.onFocus(event);
      }
    };

    _this.onBlur = function (event) {
      var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;
      var mask = _this.maskOptions.mask;

      _this.stopSaveSelectionLoop();

      _this.focused = false;

      if (mask && !_this.props.alwaysShowMask && isEmpty(_this.maskOptions, _this.value)) {
        var newValue = '';

        if (isFunction(beforeMaskedValueChange)) {
          var modifiedValue = beforeMaskedValueChange({
            value: newValue,
            selection: null
          }, {
            value: _this.value,
            selection: _this.previousSelection
          }, null, _this.getBeforeMaskedValueChangeConfig());
          newValue = modifiedValue.value;
        }

        var isInputValueChanged = newValue !== _this.getInputValue();

        if (isInputValueChanged) {
          _this.setInputValue(newValue);
        }

        if (isInputValueChanged && isFunction(_this.props.onChange)) {
          _this.props.onChange(event);
        }
      }

      if (isFunction(_this.props.onBlur)) {
        _this.props.onBlur(event);
      }
    };

    _this.onMouseDown = function (event) {
      // tiny unintentional mouse movements can break cursor
      // position on focus, so we have to restore it in that case
      //
      // https://github.com/sanniassin/react-input-mask/issues/108
      if (!_this.focused && document.addEventListener) {
        _this.mouseDownX = event.clientX;
        _this.mouseDownY = event.clientY;
        _this.mouseDownTime = new Date().getTime();

        var mouseUpHandler = function mouseUpHandler(mouseUpEvent) {
          document.removeEventListener('mouseup', mouseUpHandler);

          if (!_this.focused) {
            return;
          }

          var deltaX = Math.abs(mouseUpEvent.clientX - _this.mouseDownX);
          var deltaY = Math.abs(mouseUpEvent.clientY - _this.mouseDownY);
          var axisDelta = Math.max(deltaX, deltaY);

          var timeDelta = new Date().getTime() - _this.mouseDownTime;

          if (axisDelta <= 10 && timeDelta <= 200 || axisDelta <= 5 && timeDelta <= 300) {
            _this.setCursorToEnd();
          }
        };

        document.addEventListener('mouseup', mouseUpHandler);
      }

      if (isFunction(_this.props.onMouseDown)) {
        _this.props.onMouseDown(event);
      }
    };

    _this.onPaste = function (event) {
      if (isFunction(_this.props.onPaste)) {
        _this.props.onPaste(event);
      } // event.clipboardData might not work in Android browser
      // cleaning input to get raw text inside onChange handler


      if (!event.defaultPrevented) {
        _this.beforePasteState = {
          value: _this.getInputValue(),
          selection: _this.getSelection()
        };

        _this.setInputValue('');
      }
    };

    _this.handleRef = function (ref) {
      if (_this.props.children == null && isFunction(_this.props.inputRef)) {
        _this.props.inputRef(ref);
      }
    };

    var _mask = props.mask,
        _maskChar = props.maskChar,
        _formatChars = props.formatChars,
        _alwaysShowMask = props.alwaysShowMask,
        _beforeMaskedValueChange = props.beforeMaskedValueChange;
    var defaultValue = props.defaultValue,
        _value = props.value;
    _this.maskOptions = parseMask(_mask, _maskChar, _formatChars);

    if (defaultValue == null) {
      defaultValue = '';
    }

    if (_value == null) {
      _value = defaultValue;
    }

    var _newValue = getStringValue(_value);

    if (_this.maskOptions.mask && (_alwaysShowMask || _newValue)) {
      _newValue = formatValue(_this.maskOptions, _newValue);

      if (isFunction(_beforeMaskedValueChange)) {
        var oldValue = props.value;

        if (props.value == null) {
          oldValue = defaultValue;
        }

        oldValue = getStringValue(oldValue);

        var modifiedValue = _beforeMaskedValueChange({
          value: _newValue,
          selection: null
        }, {
          value: oldValue,
          selection: null
        }, null, _this.getBeforeMaskedValueChangeConfig());

        _newValue = modifiedValue.value;
      }
    }

    _this.value = _newValue;
    return _this;
  }

  var _proto = InputElement.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true; // workaround for react-test-renderer
    // https://github.com/sanniassin/react-input-mask/issues/147

    if (!this.getInputDOMNode()) {
      return;
    }

    this.isWindowsPhoneBrowser = isWindowsPhoneBrowser();

    if (this.maskOptions.mask && this.getInputValue() !== this.value) {
      this.setInputValue(this.value);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var previousSelection = this.previousSelection;
    var _this$props = this.props,
        beforeMaskedValueChange = _this$props.beforeMaskedValueChange,
        alwaysShowMask = _this$props.alwaysShowMask,
        mask = _this$props.mask,
        maskChar = _this$props.maskChar,
        formatChars = _this$props.formatChars;
    var previousMaskOptions = this.maskOptions;
    var showEmpty = alwaysShowMask || this.isFocused();
    var hasValue = this.props.value != null;
    var newValue = hasValue ? getStringValue(this.props.value) : this.value;
    var cursorPosition = previousSelection ? previousSelection.start : null;
    this.maskOptions = parseMask(mask, maskChar, formatChars);

    if (!this.maskOptions.mask) {
      if (previousMaskOptions.mask) {
        this.stopSaveSelectionLoop(); // render depends on this.maskOptions and this.value,
        // call forceUpdate to keep it in sync

        this.forceUpdate();
      }

      return;
    } else if (!previousMaskOptions.mask && this.isFocused()) {
      this.runSaveSelectionLoop();
    }

    var isMaskChanged = this.maskOptions.mask && this.maskOptions.mask !== previousMaskOptions.mask;

    if (!previousMaskOptions.mask && !hasValue) {
      newValue = this.getInputValue();
    }

    if (isMaskChanged || this.maskOptions.mask && (newValue || showEmpty)) {
      newValue = formatValue(this.maskOptions, newValue);
    }

    if (isMaskChanged) {
      var filledLength = getFilledLength(this.maskOptions, newValue);

      if (cursorPosition === null || filledLength < cursorPosition) {
        if (isFilled(this.maskOptions, newValue)) {
          cursorPosition = filledLength;
        } else {
          cursorPosition = getRightEditablePosition(this.maskOptions, filledLength);
        }
      }
    }

    if (this.maskOptions.mask && isEmpty(this.maskOptions, newValue) && !showEmpty && (!hasValue || !this.props.value)) {
      newValue = '';
    }

    var newSelection = {
      start: cursorPosition,
      end: cursorPosition
    };

    if (isFunction(beforeMaskedValueChange)) {
      var modifiedValue = beforeMaskedValueChange({
        value: newValue,
        selection: newSelection
      }, {
        value: this.value,
        selection: this.previousSelection
      }, null, this.getBeforeMaskedValueChangeConfig());
      newValue = modifiedValue.value;
      newSelection = modifiedValue.selection;
    }

    this.value = newValue;
    var isValueChanged = this.getInputValue() !== this.value; // render depends on this.maskOptions and this.value,
    // call forceUpdate to keep it in sync

    if (isValueChanged) {
      this.setInputValue(this.value);
      this.forceUpdate();
    } else if (isMaskChanged) {
      this.forceUpdate();
    }

    var isSelectionChanged = false;

    if (newSelection.start != null && newSelection.end != null) {
      isSelectionChanged = !previousSelection || previousSelection.start !== newSelection.start || previousSelection.end !== newSelection.end;
    }

    if (isSelectionChanged || isValueChanged) {
      this.setSelection(newSelection.start, newSelection.end);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;

    if (this.selectionDeferId !== null) {
      cancelDefer(this.selectionDeferId);
    }

    this.stopSaveSelectionLoop();
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        mask = _this$props2.mask;
        _this$props2.alwaysShowMask;
        var maskChar = _this$props2.maskChar,
        formatChars = _this$props2.formatChars,
        inputRef = _this$props2.inputRef;
        _this$props2.beforeMaskedValueChange;
        var children = _this$props2.children,
        restProps = _objectWithoutPropertiesLoose$r(_this$props2, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]);

    var inputElement;
    process.env.NODE_ENV !== "production" ? warning( // parse mask to test against actual mask prop as this.maskOptions
    // will be updated later in componentDidUpdate
    !restProps.maxLength || !parseMask(mask, maskChar, formatChars).mask, 'react-input-mask: maxLength property shouldn\'t be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length.') : void 0;

    if (children) {
      !isFunction(children) ? process.env.NODE_ENV !== "production" ? invariant(false, 'react-input-mask: children must be a function') : invariant(false) : void 0;
      var controlledProps = ['onChange', 'onPaste', 'onMouseDown', 'onFocus', 'onBlur', 'value', 'disabled', 'readOnly'];

      var childrenProps = _extends$P({}, restProps);

      controlledProps.forEach(function (propId) {
        return delete childrenProps[propId];
      });
      inputElement = children(childrenProps);
      var conflictProps = controlledProps.filter(function (propId) {
        return inputElement.props[propId] != null && inputElement.props[propId] !== restProps[propId];
      });
      !!conflictProps.length ? process.env.NODE_ENV !== "production" ? invariant(false, "react-input-mask: the following props should be passed to the react-input-mask's component and should not be altered in children's function: " + conflictProps.join(', ')) : invariant(false) : void 0;
      process.env.NODE_ENV !== "production" ? warning(!inputRef, 'react-input-mask: inputRef is ignored when children is passed, attach ref to the children instead') : void 0;
    } else {
      inputElement = React.createElement("input", _extends$P({
        ref: this.handleRef
      }, restProps));
    }

    var changedProps = {
      onFocus: this.onFocus,
      onBlur: this.onBlur
    };

    if (this.maskOptions.mask) {
      if (!restProps.disabled && !restProps.readOnly) {
        changedProps.onChange = this.onChange;
        changedProps.onPaste = this.onPaste;
        changedProps.onMouseDown = this.onMouseDown;
      }

      if (restProps.value != null) {
        changedProps.value = this.value;
      }
    }

    inputElement = React.cloneElement(inputElement, changedProps);
    return inputElement;
  };

  return InputElement;
}(React.Component);

var reactInputMask_development = InputElement;

var reactInputMask = createCommonjsModule(function (module) {
if (process.env.NODE_ENV === 'production') {
  module.exports = reactInputMask_production_min;
} else {
  module.exports = reactInputMask_development;
}
});

function ownKeys$N(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$N(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$N(Object(source), true).forEach(function (key) { _defineProperty$14(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$N(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$14(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof$w(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$w = function _typeof(obj) { return typeof obj; }; } else { _typeof$w = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$w(obj); }

function _extends$O() { _extends$O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }

function _objectWithoutProperties$r(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$q(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$q(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var MaskOverride = /*#__PURE__*/React$2.forwardRef(function (_ref, ref) {
  _ref.startEnhancer;
      _ref.endEnhancer;
      _ref.error;
      _ref.positive;
      var onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      value = _ref.value,
      disabled = _ref.disabled,
      restProps = _objectWithoutProperties$r(_ref, ["startEnhancer", "endEnhancer", "error", "positive", "onChange", "onFocus", "onBlur", "value", "disabled"]);

  return /*#__PURE__*/React$2.createElement(reactInputMask, _extends$O({
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    value: value,
    disabled: disabled
  }, restProps), function (props) {
    return /*#__PURE__*/React$2.createElement(Input$3, _extends$O({
      ref: ref,
      onChange: onChange,
      onFocus: onFocus,
      onBlur: onBlur,
      value: value,
      disabled: disabled
    }, props));
  });
});
MaskOverride.displayName = 'MaskOverride';
function MaskedInput(_ref2) {
  var mask = _ref2.mask,
      maskChar = _ref2.maskChar,
      _ref2$overrides = _ref2.overrides;
  _ref2$overrides = _ref2$overrides === void 0 ? {} : _ref2$overrides;

  var _ref2$overrides$Input = _ref2$overrides.Input,
      inputOverride = _ref2$overrides$Input === void 0 ? {} : _ref2$overrides$Input,
      restOverrides = _objectWithoutProperties$r(_ref2$overrides, ["Input"]),
      restProps = _objectWithoutProperties$r(_ref2, ["mask", "maskChar", "overrides"]);

  var componentOverride = MaskOverride;
  var propsOverride = {};
  var styleOverride = {};

  if (typeof inputOverride === 'function') {
    componentOverride = inputOverride;
  } else if (_typeof$w(inputOverride) === 'object') {
    componentOverride = inputOverride.component || componentOverride;
    propsOverride = inputOverride.props || {};
    styleOverride = inputOverride.style || {};
  }

  if (_typeof$w(propsOverride) === 'object') {
    propsOverride = _objectSpread$N(_objectSpread$N({}, propsOverride), {}, {
      mask: propsOverride.mask || mask,
      maskChar: propsOverride.maskChar || maskChar
    });
  }

  var nextOverrides = _objectSpread$N({
    Input: {
      component: componentOverride,
      props: propsOverride,
      style: styleOverride
    }
  }, restOverrides);

  return /*#__PURE__*/React$2.createElement(DefaultInput, _extends$O({}, restProps, {
    overrides: nextOverrides
  }));
}
MaskedInput.defaultProps = {
  maskChar: ' '
};

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var TYPE$1 = {
  select: 'select',
  search: 'search'
};
var STATE_CHANGE_TYPE$1 = Object.freeze({
  select: 'select',
  remove: 'remove',
  clear: 'clear'
});

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var STATE_CHANGE_TYPES = {
  click: 'click',
  moveUp: 'moveUp',
  moveDown: 'moveDown',
  mouseEnter: 'mouseEnter',
  mouseLeave: 'mouseLeave',
  focus: 'focus',
  reset: 'reset',
  character: 'character',
  enter: 'enter'
};
var KEY_STRINGS = {
  ArrowUp: 'ArrowUp',
  ArrowDown: 'ArrowDown',
  ArrowLeft: 'ArrowLeft',
  ArrowRight: 'ArrowRight',
  Enter: 'Enter',
  Space: ' ',
  Escape: 'Escape',
  Backspace: 'Backspace',
  Home: 'Home',
  End: 'End'
};
var OPTION_LIST_SIZE = {
  default: 'default',
  compact: 'compact'
};

function _objectWithoutProperties$q(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$p(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$p(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys$M(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$M(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$M(Object(source), true).forEach(function (key) { _defineProperty$13(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$M(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$13(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var StyledList$1 = styled('ul', function (_ref) {
  var $theme = _ref.$theme,
      $isFocusVisible = _ref.$isFocusVisible;
  return {
    backgroundColor: $theme.colors.menuFill,
    position: 'relative',
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    paddingTop: $theme.sizing.scale300,
    paddingBottom: $theme.sizing.scale300,
    paddingLeft: 0,
    paddingRight: 0,
    borderTopLeftRadius: $theme.borders.popoverBorderRadius,
    borderTopRightRadius: $theme.borders.popoverBorderRadius,
    borderBottomRightRadius: $theme.borders.popoverBorderRadius,
    borderBottomLeftRadius: $theme.borders.popoverBorderRadius,
    boxShadow: $theme.lighting.shadow600,
    overflow: 'auto',
    ':focus': {
      outline: $isFocusVisible ? "3px solid ".concat($theme.colors.accent) : 'none'
    }
  };
});
StyledList$1.displayName = "StyledList";

function getFontColor$1(props) {
  if (props.$disabled) {
    return props.$theme.colors.menuFontDisabled;
  }

  if (props.$isHighlighted && props.$isFocused) {
    return props.$theme.colors.menuFontHighlighted;
  }

  if (props.$isHighlighted && !props.$isFocused) {
    return props.$theme.colors.menuFontSelected;
  }

  return props.$theme.colors.menuFontDefault;
}

function getBackgroundColor$1(props) {
  if (props.$disabled) {
    return 'transparent';
  }

  if (props.$isHighlighted) {
    return props.$theme.colors.menuFillHover;
  }

  return 'transparent';
}

var StyledEmptyState = styled('li', function (props) {
  var $theme = props.$theme,
      $size = props.$size;
  return _objectSpread$M(_objectSpread$M({}, $size === OPTION_LIST_SIZE.compact ? $theme.typography.font100 : $theme.typography.font200), {}, {
    position: 'relative',
    display: 'block',
    color: $theme.colors.menuFontDisabled,
    textAlign: 'center',
    cursor: 'not-allowed',
    backgroundColor: 'transparent',
    marginBottom: 0,
    paddingTop: $theme.sizing.scale800,
    paddingBottom: $theme.sizing.scale800,
    paddingRight: $theme.sizing.scale800,
    paddingLeft: $theme.sizing.scale800
  });
});
StyledEmptyState.displayName = "StyledEmptyState";
var StyledOptgroupHeader = styled('li', function (props) {
  var paddingX = props.$theme.sizing.scale300;
  var paddingY = props.$theme.sizing.scale200;
  return _objectSpread$M(_objectSpread$M({}, props.$theme.typography.font250), {}, {
    color: props.$theme.colors.colorPrimary,
    paddingTop: paddingY,
    paddingBottom: paddingY,
    paddingRight: paddingX,
    paddingLeft: paddingX
  });
});
StyledOptgroupHeader.displayName = "StyledOptgroupHeader";
var StyledListItemAnchor = styled('a', function (props) {
  return {
    display: 'block',
    color: getFontColor$1(props)
  };
});
StyledListItemAnchor.displayName = "StyledListItemAnchor";
var StyledListItemElement = styled('li', function (props) {
  var $disabled = props.$disabled,
      $theme = props.$theme,
      $size = props.$size;
  return _objectSpread$M(_objectSpread$M({}, $size === OPTION_LIST_SIZE.compact ? $theme.typography.font100 : $theme.typography.font200), {}, {
    position: 'relative',
    display: 'block',
    color: getFontColor$1(props),
    cursor: $disabled ? 'not-allowed' : 'pointer',
    backgroundColor: getBackgroundColor$1(props),
    transitionProperty: 'color, background-color',
    transitionDuration: $theme.animation.timing200,
    transitionTimingFunction: $theme.animation.easeOutCurve,
    marginBottom: 0,
    paddingTop: $size === OPTION_LIST_SIZE.compact ? $theme.sizing.scale100 : $theme.sizing.scale300,
    paddingBottom: $size === OPTION_LIST_SIZE.compact ? $theme.sizing.scale100 : $theme.sizing.scale300,
    paddingRight: $size === OPTION_LIST_SIZE.compact ? $theme.sizing.scale900 : $theme.sizing.scale600,
    paddingLeft: $size === OPTION_LIST_SIZE.compact ? $theme.sizing.scale900 : $theme.sizing.scale600,
    ':focus': {
      outline: 'none'
    }
  });
});
StyledListItemElement.displayName = "StyledListItemElement";
var StyledListItem$1 = withWrapper(StyledListItemElement, function (Styled) {
  return function StyledListItem(_ref2) {
    _ref2.item;
        var restProps = _objectWithoutProperties$q(_ref2, ["item"]);

    return /*#__PURE__*/React$2.createElement(Styled, restProps);
  };
});
var StyledListItemProfile = styled('li', function (_ref3) {
  var $theme = _ref3.$theme;
  return {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    paddingTop: $theme.sizing.scale300,
    paddingBottom: $theme.sizing.scale300,
    paddingRight: $theme.sizing.scale800,
    paddingLeft: $theme.sizing.scale800,
    transitionProperty: 'color, background-color',
    transitionDuration: $theme.animation.timing200,
    transitionTimingFunction: $theme.animation.easeOutCurve,
    ':hover': {
      backgroundColor: $theme.colors.menuFillHover
    }
  };
});
StyledListItemProfile.displayName = "StyledListItemProfile";
var StyledProfileImgContainer = styled('div', {
  width: '60px',
  height: '60px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});
StyledProfileImgContainer.displayName = "StyledProfileImgContainer";
var StyledProfileImg = styled('img', {
  width: '100%',
  height: '100%',
  borderTopLeftRadius: '50%',
  borderTopRightRadius: '50%',
  borderBottomRightRadius: '50%',
  borderBottomLeftRadius: '50%'
});
StyledProfileImg.displayName = "StyledProfileImg";
var StyledProfileLabelsContainer = styled('div', function (_ref4) {
  var _ref4$$theme = _ref4.$theme,
      direction = _ref4$$theme.direction,
      sizing = _ref4$$theme.sizing;
  return _objectSpread$M({
    alignSelf: direction === 'rtl' ? 'flex-end' : 'flex-start',
    display: 'flex',
    flexDirection: 'column'
  }, direction === 'rtl' ? {
    marginRight: sizing.scale600
  } : {
    marginLeft: sizing.scale600
  });
});
StyledProfileLabelsContainer.displayName = "StyledProfileLabelsContainer";
var StyledProfileTitle = styled('h6', function (_ref5) {
  var $theme = _ref5.$theme;
  return _objectSpread$M(_objectSpread$M({}, $theme.typography.font350), {}, {
    color: $theme.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0
  });
});
StyledProfileTitle.displayName = "StyledProfileTitle";
var StyledProfileSubtitle = styled('p', function (_ref6) {
  var $theme = _ref6.$theme;
  return _objectSpread$M(_objectSpread$M({}, $theme.typography.font200), {}, {
    color: $theme.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0
  });
});
StyledProfileSubtitle.displayName = "StyledProfileSubtitle";
var StyledProfileBody = styled('p', function (_ref7) {
  var $theme = _ref7.$theme;
  return _objectSpread$M(_objectSpread$M({}, $theme.typography.font100), {}, {
    color: $theme.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0
  });
});
StyledProfileBody.displayName = "StyledProfileBody";

var NestedMenuContext = /*#__PURE__*/React$2.createContext({
  addMenuToNesting: function addMenuToNesting() {},
  removeMenuFromNesting: function removeMenuFromNesting() {},
  getParentMenu: function getParentMenu() {},
  getChildMenu: function getChildMenu() {},
  nestedMenuHoverIndex: -1,
  isNestedMenuVisible: function isNestedMenuVisible() {
    return false;
  },
  mountRef: {
    current: null
  }
});

function _extends$N() { _extends$N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }

function _slicedToArray$I(arr, i) { return _arrayWithHoles$I(arr) || _iterableToArrayLimit$I(arr, i) || _unsupportedIterableToArray$K(arr, i) || _nonIterableRest$I(); }

function _nonIterableRest$I() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$K(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$K(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$K(o, minLen); }

function _arrayLikeToArray$K(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$I(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$I(arr) { if (Array.isArray(arr)) return arr; }
function MaybeChildMenu(props) {
  if (!props.getChildMenu) {
    return props.children;
  }

  var ChildMenu = props.getChildMenu(props.item);

  if (!ChildMenu) {
    return props.children;
  }

  var _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides;

  var _getOverrides = getOverrides(overrides.ChildMenuPopover, Popover$1),
      _getOverrides2 = _slicedToArray$I(_getOverrides, 2),
      PopoverOverride = _getOverrides2[0],
      popoverProps = _getOverrides2[1];

  return /*#__PURE__*/React$2.createElement(NestedMenuContext.Consumer, null, function (ctx) {
    return /*#__PURE__*/React$2.createElement(PopoverOverride, _extends$N({
      focusLock: false,
      autoFocus: false,
      isOpen: props.isOpen,
      renderAll: props.renderAll,
      content: ChildMenu,
      ignoreBoundary: true,
      mountNode: ctx.mountRef.current ? ctx.mountRef.current : undefined,
      onClick: props.onClick,
      onMouseEnterDelay: 30,
      onMouseLeaveDelay: 30,
      onEsc: props.resetParentMenu,
      placement: "rightTop"
    }, popoverProps, {
      overrides: mergeOverrides({
        Body: {
          props: {
            // Trap tabbing when focused on a child menu. Popover mounts the element at the end of
            // the html body by default. If a user was to tab to the next element it would navigate
            // to elements not within the immediate area surrounding the menu.
            onKeyDown: function onKeyDown(e) {
              if (e.keyCode === 9) {
                e.preventDefault();
              }
            }
          }
        }
      }, popoverProps.overrides)
    }), props.children);
  });
}

function ownKeys$L(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$L(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$L(Object(source), true).forEach(function (key) { _defineProperty$12(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$L(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$12(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$M() { _extends$M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }

function _slicedToArray$H(arr, i) { return _arrayWithHoles$H(arr) || _iterableToArrayLimit$H(arr, i) || _unsupportedIterableToArray$J(arr, i) || _nonIterableRest$H(); }

function _nonIterableRest$H() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$J(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$J(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$J(o, minLen); }

function _arrayLikeToArray$J(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$H(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$H(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties$p(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$o(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$o(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function OptionList(props, ref) {
  var getChildMenu = props.getChildMenu,
      _props$getItemLabel = props.getItemLabel,
      getItemLabel = _props$getItemLabel === void 0 ? function (item) {
    return item ? item.label : '';
  } : _props$getItemLabel,
      item = props.item,
      _props$onClick = props.onClick,
      onClick = _props$onClick === void 0 ? function () {} : _props$onClick,
      _props$onMouseEnter = props.onMouseEnter,
      onMouseEnter = _props$onMouseEnter === void 0 ? function () {} : _props$onMouseEnter,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      _props$renderHrefAsAn = props.renderHrefAsAnchor,
      renderHrefAsAnchor = _props$renderHrefAsAn === void 0 ? true : _props$renderHrefAsAn,
      _props$resetMenu = props.resetMenu,
      resetMenu = _props$resetMenu === void 0 ? function () {} : _props$resetMenu,
      _props$size = props.size,
      size = _props$size === void 0 ? OPTION_LIST_SIZE.default : _props$size,
      $isHighlighted = props.$isHighlighted,
      renderAll = props.renderAll,
      restProps = _objectWithoutProperties$p(props, ["getChildMenu", "getItemLabel", "item", "onClick", "onMouseEnter", "overrides", "renderHrefAsAnchor", "resetMenu", "size", "$isHighlighted", "renderAll"]);

  var _getOverrides = getOverrides(overrides.ListItem, StyledListItem$1),
      _getOverrides2 = _slicedToArray$H(_getOverrides, 2),
      ListItem = _getOverrides2[0],
      listItemProps = _getOverrides2[1];

  var _getOverrides3 = getOverrides(overrides.ListItemAnchor, StyledListItemAnchor),
      _getOverrides4 = _slicedToArray$H(_getOverrides3, 2),
      ListItemAnchor = _getOverrides4[0],
      listItemAnchorProps = _getOverrides4[1];

  var getItem = function getItem(item) {
    if (item.href && renderHrefAsAnchor) {
      return /*#__PURE__*/React$2.createElement(ListItemAnchor, _extends$M({
        $item: item,
        href: item.href
      }, listItemAnchorProps), getItemLabel(item));
    } else {
      return /*#__PURE__*/React$2.createElement(React$2.Fragment, null, getItemLabel(item));
    }
  };

  return /*#__PURE__*/React$2.createElement(LocaleContext.Consumer, null, function (locale) {
    return /*#__PURE__*/React$2.createElement(MaybeChildMenu, {
      getChildMenu: getChildMenu,
      isOpen: !!$isHighlighted,
      item: item,
      resetParentMenu: resetMenu,
      renderAll: renderAll,
      onClick: onClick,
      overrides: overrides
    }, /*#__PURE__*/React$2.createElement(ListItem, _extends$M({
      ref: ref,
      "aria-label": getChildMenu && getChildMenu(item) ? locale.menu.parentMenuItemAriaLabel : null,
      item: item,
      onClick: onClick,
      onMouseEnter: onMouseEnter,
      $size: size,
      $isHighlighted: $isHighlighted
    }, restProps, listItemProps), getItem(_objectSpread$L({
      isHighlighted: $isHighlighted
    }, item))));
  });
}

function areEqualShallow(a, b) {
  if (!a || !b) return false;

  for (var key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
}

function compare$1(prevProps, nextProps) {
  return prevProps.$isHighlighted === nextProps.$isHighlighted && prevProps.$isFocused === nextProps.$isFocused && areEqualShallow(prevProps.item, nextProps.item) && areEqualShallow(prevProps.overrides, nextProps.overrides) && prevProps.size === nextProps.size && prevProps.getItemLabel === nextProps.getItemLabel && prevProps.getChildMenu === nextProps.getChildMenu && prevProps.resetMenu === nextProps.resetMenu;
}

var forwarded = /*#__PURE__*/React$2.forwardRef(OptionList);
forwarded.displayName = 'OptionList';
var OptionList$1 = /*#__PURE__*/React$2.memo(forwarded, compare$1);

function _objectWithoutProperties$o(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$n(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$n(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends$L() { _extends$L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }

function _slicedToArray$G(arr, i) { return _arrayWithHoles$G(arr) || _iterableToArrayLimit$G(arr, i) || _unsupportedIterableToArray$I(arr, i) || _nonIterableRest$G(); }

function _nonIterableRest$G() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$I(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$I(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$I(o, minLen); }

function _arrayLikeToArray$I(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$G(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$G(arr) { if (Array.isArray(arr)) return arr; }
function Menu(props) {
  var _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      _props$ariaLabel = props['aria-label'],
      ariaLabel = _props$ariaLabel === void 0 ? 'Menu' : _props$ariaLabel,
      _props$rootRef = props.rootRef,
      rootRef = _props$rootRef === void 0 ? /*#__PURE__*/React$2.createRef() : _props$rootRef,
      _props$focusMenu = props.focusMenu,
      focusMenu = _props$focusMenu === void 0 ? function () {} : _props$focusMenu,
      _props$unfocusMenu = props.unfocusMenu,
      unfocusMenu = _props$unfocusMenu === void 0 ? function () {} : _props$unfocusMenu,
      _props$handleMouseLea = props.handleMouseLeave,
      handleMouseLeave = _props$handleMouseLea === void 0 ? function () {} : _props$handleMouseLea,
      _props$handleKeyDown = props.handleKeyDown,
      handleKeyDown = _props$handleKeyDown === void 0 ? function (event) {} : _props$handleKeyDown,
      _props$renderAll = props.renderAll,
      renderAll = _props$renderAll === void 0 ? false : _props$renderAll;

  var _React$useState = React$2.useState(false),
      _React$useState2 = _slicedToArray$G(_React$useState, 2),
      focusVisible = _React$useState2[0],
      setFocusVisible = _React$useState2[1];

  var handleFocus = function handleFocus(event) {
    if (isFocusVisible(event)) {
      setFocusVisible(true);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (focusVisible !== false) {
      setFocusVisible(false);
    }
  };

  var _getOverrides = getOverrides(overrides.List, StyledList$1),
      _getOverrides2 = _slicedToArray$G(_getOverrides, 2),
      List = _getOverrides2[0],
      listProps = _getOverrides2[1];

  var _getOverrides3 = getOverrides(overrides.Option, OptionList$1),
      _getOverrides4 = _slicedToArray$G(_getOverrides3, 2),
      Option = _getOverrides4[0],
      optionProps = _getOverrides4[1];

  var _getOverrides5 = getOverrides(overrides.EmptyState, StyledEmptyState),
      _getOverrides6 = _slicedToArray$G(_getOverrides5, 2),
      EmptyState = _getOverrides6[0],
      emptyStateProps = _getOverrides6[1];

  var _getOverrides7 = getOverrides(overrides.OptgroupHeader, StyledOptgroupHeader),
      _getOverrides8 = _slicedToArray$G(_getOverrides7, 2),
      OptgroupHeader = _getOverrides8[0],
      optgroupHeaderProps = _getOverrides8[1];

  var groupedItems = Array.isArray(props.items) ? {
    __ungrouped: props.items
  } : props.items;
  var optgroups = Object.keys(groupedItems);

  var _optgroups$reduce = optgroups.reduce(function (_ref, optgroup) {
    var _ref2 = _slicedToArray$G(_ref, 2),
        els = _ref2[0],
        itemIndex = _ref2[1];

    if (optgroup !== '__ungrouped') {
      els.push( /*#__PURE__*/React$2.createElement(OptgroupHeader, _extends$L({
        key: optgroup
      }, optgroupHeaderProps), optgroup));
    }

    var groupItems = groupedItems[optgroup].map(function (item, index) {
      itemIndex = itemIndex + 1;
      var _props$getRequiredIte = props.getRequiredItemProps,
          getRequiredItemProps = _props$getRequiredIte === void 0 ? function (item, index) {
        return {};
      } : _props$getRequiredIte;

      var _getRequiredItemProps = getRequiredItemProps(item, itemIndex),
          disabled = _getRequiredItemProps.disabled,
          isFocused = _getRequiredItemProps.isFocused,
          isHighlighted = _getRequiredItemProps.isHighlighted,
          _getRequiredItemProps2 = _getRequiredItemProps.resetMenu,
          resetMenu = _getRequiredItemProps2 === void 0 ? function () {} : _getRequiredItemProps2,
          restProps = _objectWithoutProperties$o(_getRequiredItemProps, ["disabled", "isFocused", "isHighlighted", "resetMenu"]);

      return /*#__PURE__*/React$2.createElement(Option, _extends$L({
        renderAll: renderAll,
        key: itemIndex,
        item: item,
        overrides: props.overrides,
        resetMenu: resetMenu,
        role: "option",
        $disabled: disabled,
        $isFocused: isFocused,
        $isHighlighted: isHighlighted,
        "aria-disabled": disabled,
        "aria-selected": isHighlighted && isFocused
      }, restProps, optionProps));
    });
    return [els.concat(groupItems), itemIndex];
  }, [[], -1]),
      _optgroups$reduce2 = _slicedToArray$G(_optgroups$reduce, 1),
      elements = _optgroups$reduce2[0];

  var isEmpty = optgroups.every(function (optgroup) {
    return !groupedItems[optgroup].length;
  });
  return /*#__PURE__*/React$2.createElement(LocaleContext.Consumer, null, function (locale) {
    return /*#__PURE__*/React$2.createElement(List, _extends$L({
      "aria-activedescendant": props.activedescendantId || null,
      role: "listbox",
      "aria-label": ariaLabel,
      ref: rootRef,
      onMouseEnter: focusMenu,
      onMouseLeave: handleMouseLeave,
      onMouseOver: focusMenu,
      onFocus: forkFocus({
        onFocus: focusMenu
      }, handleFocus),
      onBlur: forkBlur({
        onBlur: unfocusMenu
      }, handleBlur),
      onKeyDown: function onKeyDown(event) {
        if (props.isFocused) {
          handleKeyDown(event);
        }
      },
      tabIndex: 0,
      "data-baseweb": "menu",
      $isFocusVisible: focusVisible
    }, listProps), isEmpty ? /*#__PURE__*/React$2.createElement(EmptyState, _extends$L({
      "aria-live": "polite",
      "aria-atomic": true
    }, emptyStateProps), props.noResultsMsg || locale.menu.noResultsMsg) : elements);
  });
}

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* eslint-disable import/prefer-default-export */
// Helps scroll a list item into view when cycling through list via
// keybindings and highlighted item is not in view.
// Previously, this util had been using `scrollIntoView`. The issue with that method is that
// it will not only scroll the parent scroll but also the window scroll bar - causing a jump.
// problem description https://lists.w3.org/Archives/Public/www-style/2014Jul/0386.html
// CHASE: I've noticed some performance issues when testing this with many items in the list.
// I imagine the browser can debounce the `node.scrollIntoView` calls. Callers of this function
// will likely want to debounce themselves.
function scrollItemIntoView(child, parent, isFirst, isLast) {
  var scrollAlignInView = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'auto';
  if (!child) return;
  var childRect = child.getBoundingClientRect();
  var parentRect = parent.getBoundingClientRect(); // while scrolling down, if element is below view

  if (childRect.bottom > parentRect.bottom) {
    if (isLast) {
      parent.scrollTop = parent.scrollHeight - parentRect.height;
    } else {
      var targetBottom = child.offsetTop + childRect.height;
      parent.scrollTop = targetBottom - (scrollAlignInView === 'center' ? Math.round((parentRect.height + childRect.height) / 2) : parentRect.height);
    } // while scrolling up, if element is above view

  } else if (childRect.top < parentRect.top) {
    if (isFirst) {
      parent.scrollTop = 0;
    } else {
      parent.scrollTop = child.offsetTop - (scrollAlignInView === 'center' ? Math.round((parentRect.height - childRect.height) / 2) : 0);
    }
  }
}

function _typeof$v(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$v = function _typeof(obj) { return typeof obj; }; } else { _typeof$v = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$v(obj); }

function _extends$K() { _extends$K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }

function _objectWithoutProperties$n(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$m(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$m(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys$K(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$K(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$K(Object(source), true).forEach(function (key) { _defineProperty$11(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$K(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck$w(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$u(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$v(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$u(Constructor.prototype, protoProps); if (staticProps) _defineProperties$u(Constructor, staticProps); return Constructor; }

function _inherits$v(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$u(subClass, superClass); }

function _setPrototypeOf$u(o, p) { _setPrototypeOf$u = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$u(o, p); }

function _createSuper$u(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$u(); return function _createSuperInternal() { var Super = _getPrototypeOf$u(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$u(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$v(this, result); }; }

function _possibleConstructorReturn$v(self, call) { if (call && (_typeof$v(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$u(self); }

function _assertThisInitialized$u(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$u() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$u(o) { _getPrototypeOf$u = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$u(o); }

function _defineProperty$11(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var DEFAULT_PROPS = {
  // keeping it in defaultProps to satisfy Flow
  initialState: {
    // We start the index at -1 to indicate that no highlighting exists initially
    highlightedIndex: -1,
    isFocused: false
  },
  typeAhead: true,
  keyboardControlNode: {
    current: null
  },
  stateReducer: function (changeType, changes) {
    return changes;
  },
  onItemSelect: function onItemSelect() {},
  getRequiredItemProps: function getRequiredItemProps() {
    return {};
  },
  children: function children() {
    return null;
  },
  // from nested-menus context
  addMenuToNesting: function addMenuToNesting() {},
  removeMenuFromNesting: function removeMenuFromNesting() {},
  getParentMenu: function getParentMenu() {},
  getChildMenu: function getChildMenu() {},
  nestedMenuHoverIndex: -1,
  isNestedMenuVisible: function isNestedMenuVisible() {
    return false;
  },
  forceHighlight: false
};

var MenuStatefulContainerInner = /*#__PURE__*/function (_React$Component) {
  _inherits$v(MenuStatefulContainerInner, _React$Component);

  var _super = _createSuper$u(MenuStatefulContainerInner);

  function MenuStatefulContainerInner() {
    var _this;

    _classCallCheck$w(this, MenuStatefulContainerInner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$11(_assertThisInitialized$u(_this), "state", _objectSpread$K(_objectSpread$K({}, _this.constructor.defaultProps.initialState), _this.props.initialState));

    _defineProperty$11(_assertThisInitialized$u(_this), "rootRef", /*#__PURE__*/React$2.createRef());

    _defineProperty$11(_assertThisInitialized$u(_this), "keyboardControlNode", _this.props.keyboardControlNode.current);

    _defineProperty$11(_assertThisInitialized$u(_this), "refList", []);

    _defineProperty$11(_assertThisInitialized$u(_this), "optionIds", []);

    _defineProperty$11(_assertThisInitialized$u(_this), "typeAheadChars", '');

    _defineProperty$11(_assertThisInitialized$u(_this), "typeAheadTimeOut", null);

    _defineProperty$11(_assertThisInitialized$u(_this), "onKeyDown", function (event) {
      switch (event.key) {
        case KEY_STRINGS.ArrowUp:
        case KEY_STRINGS.ArrowDown:
        case KEY_STRINGS.ArrowLeft:
        case KEY_STRINGS.ArrowRight:
        case KEY_STRINGS.Home:
        case KEY_STRINGS.End:
          _this.handleArrowKey(event);

          break;

        case KEY_STRINGS.Enter:
          if (event.keyCode === 229) {
            // ref.
            // https://github.com/JedWatson/react-select/blob/e12b42b0e7598ec4a96a1a6480e0b2b4c7dc03e3/packages/react-select/src/Select.js#L1209
            break;
          }

          _this.handleEnterKey(event);

          break;

        default:
          if (_this.props.typeAhead) {
            clearTimeout(_this.typeAheadTimeOut);

            _this.handleAlphaDown(event);
          }

          break;
      }
    });

    _defineProperty$11(_assertThisInitialized$u(_this), "handleAlphaDown", function (event) {
      var rootRef = _this.props.rootRef ? _this.props.rootRef : _this.rootRef;
      var prevIndex = _this.state.highlightedIndex;
      _this.typeAheadChars += event.key;
      _this.typeAheadTimeOut = setTimeout(function () {
        _this.typeAheadChars = '';
      }, 500);
      var nextIndex = prevIndex;
      event.preventDefault();

      var list = _this.getItems();

      if (list.length === 0 || !('label' in list[0])) return;
      var notMatch = true;

      for (var n = 0; n < list.length; n++) {
        var label = list[n].label;

        if (label && label.toUpperCase && label.toUpperCase().indexOf(_this.typeAheadChars.toUpperCase()) === 0) {
          nextIndex = n;
          notMatch = false;
          break;
        }
      }

      if (notMatch) {
        for (var _n = 0; _n < list.length; _n++) {
          var _label = list[_n].label;

          if (_label && _label.toUpperCase && _label.toUpperCase().indexOf(_this.typeAheadChars.toUpperCase()) > 0) {
            nextIndex = _n;
            break;
          }
        }
      }

      _this.internalSetState(STATE_CHANGE_TYPES.character, {
        highlightedIndex: nextIndex
      });

      if (_this.refList[nextIndex]) {
        scrollItemIntoView(_this.refList[nextIndex].current, // $FlowFixMe
        rootRef.current, nextIndex === 0, nextIndex === list.length - 1);
      }
    });

    _defineProperty$11(_assertThisInitialized$u(_this), "handleArrowKey", function (event) {
      var rootRef = _this.props.rootRef ? _this.props.rootRef : _this.rootRef;
      var prevIndex = _this.state.highlightedIndex;
      var nextIndex = prevIndex;

      if (event.key === KEY_STRINGS.ArrowUp) {
        event.preventDefault();
        nextIndex = Math.max(0, prevIndex - 1);

        _this.internalSetState(STATE_CHANGE_TYPES.moveUp, {
          highlightedIndex: nextIndex
        });
      } else if (event.key === KEY_STRINGS.ArrowDown) {
        event.preventDefault();
        nextIndex = Math.min(prevIndex + 1, _this.getItems().length - 1);

        _this.internalSetState(STATE_CHANGE_TYPES.moveDown, {
          highlightedIndex: nextIndex
        });
      } else if (event.key === KEY_STRINGS.Home) {
        event.preventDefault();
        nextIndex = 0;

        _this.internalSetState(STATE_CHANGE_TYPES.moveUp, {
          highlightedIndex: nextIndex
        });
      } else if (event.key === KEY_STRINGS.End) {
        event.preventDefault();
        nextIndex = _this.getItems().length - 1;

        _this.internalSetState(STATE_CHANGE_TYPES.moveDown, {
          highlightedIndex: nextIndex
        });
      } else if (event.key === KEY_STRINGS.ArrowLeft) {
        if (_this.props.getParentMenu) {
          var parent = _this.props.getParentMenu(rootRef);

          if (parent && parent.current) {
            parent.current.focus();
          }
        }
      } else if (event.key === KEY_STRINGS.ArrowRight) {
        if (_this.props.getChildMenu) {
          var child = _this.props.getChildMenu(rootRef);

          if (child && child.current) {
            child.current.focus();
          }
        }
      }

      if (_this.refList[nextIndex]) {
        scrollItemIntoView(_this.refList[nextIndex].current, // $FlowFixMe
        rootRef.current, nextIndex === 0, nextIndex === _this.getItems().length - 1);
      }
    });

    _defineProperty$11(_assertThisInitialized$u(_this), "handleEnterKey", function (event) {
      var onItemSelect = _this.props.onItemSelect;
      var highlightedIndex = _this.state.highlightedIndex;

      var items = _this.getItems();

      if (items[highlightedIndex] && onItemSelect && !items[highlightedIndex].disabled) {
        event.preventDefault();
        onItemSelect({
          item: items[highlightedIndex],
          event: event
        });
      }
    });

    _defineProperty$11(_assertThisInitialized$u(_this), "handleItemClick", function (index, item, event) {
      if (_this.props.onItemSelect && !item.disabled) {
        _this.props.onItemSelect({
          item: item,
          event: event
        });

        _this.internalSetState(STATE_CHANGE_TYPES.click, {
          highlightedIndex: index,
          activedescendantId: _this.optionIds[index]
        });
      }
    });

    _defineProperty$11(_assertThisInitialized$u(_this), "handleMouseEnter", function (index) {
      _this.internalSetState(STATE_CHANGE_TYPES.mouseEnter, {
        highlightedIndex: index,
        activedescendantId: _this.optionIds[index]
      });
    });

    _defineProperty$11(_assertThisInitialized$u(_this), "handleMouseLeave", function (event) {});

    _defineProperty$11(_assertThisInitialized$u(_this), "getRequiredItemProps", function (item, index) {
      var itemRef = _this.refList[index];

      if (!itemRef) {
        itemRef = /*#__PURE__*/React$2.createRef();
        _this.refList[index] = itemRef;
        _this.optionIds[index] = _this.props.uidSeed(index);
      }

      var _this$props$getRequir = _this.props.getRequiredItemProps(item, index),
          disabledVal = _this$props$getRequir.disabled,
          requiredItemProps = _objectWithoutProperties$n(_this$props$getRequir, ["disabled"]);

      var disabled = typeof disabledVal === 'boolean' ? disabledVal : !!item.disabled;
      return _objectSpread$K(_objectSpread$K({
        id: requiredItemProps.id || _this.optionIds[index],
        disabled: disabled,
        ref: itemRef,
        isFocused: _this.state.isFocused,
        isHighlighted: _this.state.highlightedIndex === index,
        resetMenu: _this.resetMenu
      }, disabled ? {} : {
        onClick: _this.handleItemClick.bind(_assertThisInitialized$u(_this), index, item),
        onMouseEnter: _this.handleMouseEnter.bind(_assertThisInitialized$u(_this), index)
      }), requiredItemProps);
    });

    _defineProperty$11(_assertThisInitialized$u(_this), "focusMenu", function (event) {
      var rootRef = _this.props.rootRef ? _this.props.rootRef : _this.rootRef;

      if (!_this.state.isFocused && rootRef.current && // $FlowFixMe
      rootRef.current.contains(event.target)) {
        if (_this.state.highlightedIndex < 0) {
          _this.internalSetState(STATE_CHANGE_TYPES.focus, {
            isFocused: true,
            highlightedIndex: 0
          });
        } else {
          _this.internalSetState(STATE_CHANGE_TYPES.focus, {
            isFocused: true
          });
        }

        rootRef.current.focus();
      }
    });

    _defineProperty$11(_assertThisInitialized$u(_this), "unfocusMenu", function () {
      _this.internalSetState(STATE_CHANGE_TYPES.focus, {
        isFocused: false
      });
    });

    _defineProperty$11(_assertThisInitialized$u(_this), "resetMenu", function () {
      _this.internalSetState(STATE_CHANGE_TYPES.reset, {
        isFocused: false,
        highlightedIndex: -1,
        activedescendantId: null
      });
    });

    return _this;
  }

  _createClass$v(MenuStatefulContainerInner, [{
    key: "getItems",
    value: function getItems() {
      var _this2 = this;

      if (Array.isArray(this.props.items)) {
        return this.props.items;
      }

      var optgroups = Object.keys(this.props.items);
      return optgroups.reduce(function (output, optgroup) {
        // $FlowFixMe already checked above that items is grouped shape
        return output.concat(_this2.props.items[optgroup]);
      }, []);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var rootRef = this.props.rootRef ? this.props.rootRef : this.rootRef;

      if (typeof document !== 'undefined') {
        if (rootRef.current && this.state.highlightedIndex > -1 && this.refList[this.state.highlightedIndex]) {
          scrollItemIntoView(this.refList[this.state.highlightedIndex].current, rootRef.current, this.state.highlightedIndex === 0, this.state.highlightedIndex === this.getItems().length - 1, 'center');
        }

        if (this.state.isFocused) {
          if (this.keyboardControlNode) {
            this.keyboardControlNode.addEventListener('keydown', this.onKeyDown);
          }
        }
      }

      this.props.addMenuToNesting && this.props.addMenuToNesting(rootRef);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var rootRef = this.props.rootRef ? this.props.rootRef : this.rootRef;

      if (typeof document !== 'undefined') {
        if (this.keyboardControlNode) this.keyboardControlNode.removeEventListener('keydown', this.onKeyDown);
      }

      if (this.props.removeMenuFromNesting) {
        this.props.removeMenuFromNesting(rootRef);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (typeof document !== 'undefined') {
        if (!prevState.isFocused && this.state.isFocused) {
          if (this.keyboardControlNode) this.keyboardControlNode.addEventListener('keydown', this.onKeyDown);
        } else if (prevState.isFocused && !this.state.isFocused) {
          if (this.keyboardControlNode) this.keyboardControlNode.removeEventListener('keydown', this.onKeyDown);
        }
      }

      var range = this.getItems().length;

      if (this.props.forceHighlight && this.state.highlightedIndex === -1 && range > 0) {
        this.internalSetState(STATE_CHANGE_TYPES.enter, {
          highlightedIndex: 0
        });
      }

      if (range === 0 && this.state.highlightedIndex !== -1) {
        this.internalSetState(STATE_CHANGE_TYPES.enter, {
          highlightedIndex: -1
        });
      } else if (this.state.highlightedIndex >= range) {
        this.internalSetState(STATE_CHANGE_TYPES.enter, {
          highlightedIndex: 0
        });
      }

      if (this.props.isNestedMenuVisible && this.props.nestedMenuHoverIndex !== prevProps.nestedMenuHoverIndex && !this.props.isNestedMenuVisible(this.rootRef) && !this.props.forceHighlight) {
        this.setState({
          highlightedIndex: -1
        });
      }
    } // One array to hold all list item refs

  }, {
    key: "internalSetState",
    value: // Internal set state function that will also invoke stateReducer
    function internalSetState(changeType, changes) {
      var stateReducer = this.props.stateReducer;

      if (this.props.onActiveDescendantChange && typeof changes.highlightedIndex === 'number' && this.state.highlightedIndex !== changes.highlightedIndex) {
        this.props.onActiveDescendantChange(this.optionIds[changes.highlightedIndex]);
      }

      this.setState(stateReducer(changeType, changes, this.state));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      // omit the stateful-container's props and don't pass it down
      // to the children (stateless menu)
      var _this$props = this.props;
          _this$props.initialState;
          _this$props.stateReducer;
          _this$props.children;
          _this$props.onItemSelect;
          _this$props.addMenuToNesting;
          _this$props.removeMenuFromNesting;
          _this$props.getParentMenu;
          _this$props.getChildMenu;
          _this$props.forceHighlight;
          var restProps = _objectWithoutProperties$n(_this$props, ["initialState", "stateReducer", "children", "onItemSelect", "addMenuToNesting", "removeMenuFromNesting", "getParentMenu", "getChildMenu", "forceHighlight"]);

      return this.props.children(_objectSpread$K(_objectSpread$K({}, restProps), {}, {
        rootRef: this.props.rootRef ? this.props.rootRef : this.rootRef,
        activedescendantId: this.optionIds[this.state.highlightedIndex],
        getRequiredItemProps: function getRequiredItemProps(item, index) {
          return _this3.getRequiredItemProps(item, index);
        },
        handleMouseLeave: this.handleMouseLeave,
        highlightedIndex: this.state.highlightedIndex,
        isFocused: this.state.isFocused,
        handleKeyDown: this.props.keyboardControlNode.current ? function (event) {} : this.onKeyDown,
        focusMenu: this.focusMenu,
        unfocusMenu: this.unfocusMenu
      }));
    }
  }]);

  return MenuStatefulContainerInner;
}(React$2.Component); // Remove when MenuStatefulContainer is converted to a functional component.


_defineProperty$11(MenuStatefulContainerInner, "defaultProps", DEFAULT_PROPS);

var MenuStatefulContainer = function MenuStatefulContainer(props) {
  //$FlowExpectedError[cannot-spread-inexact]
  return /*#__PURE__*/React$2.createElement(MenuStatefulContainerInner, _extends$K({
    uidSeed: useUIDSeed()
  }, props));
};

MenuStatefulContainer.defaultProps = DEFAULT_PROPS;
var StatefulContainer$1 = MenuStatefulContainer;

function _typeof$u(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$u = function _typeof(obj) { return typeof obj; }; } else { _typeof$u = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$u(obj); }

function _extends$J() { _extends$J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }

function _objectWithoutProperties$m(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$l(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$l(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$v(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$t(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$u(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$t(Constructor.prototype, protoProps); if (staticProps) _defineProperties$t(Constructor, staticProps); return Constructor; }

function _inherits$u(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$t(subClass, superClass); }

function _setPrototypeOf$t(o, p) { _setPrototypeOf$t = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$t(o, p); }

function _createSuper$t(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$t(); return function _createSuperInternal() { var Super = _getPrototypeOf$t(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$t(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$u(this, result); }; }

function _possibleConstructorReturn$u(self, call) { if (call && (_typeof$u(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$t(self); }

function _assertThisInitialized$t(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$t() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$t(o) { _getPrototypeOf$t = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$t(o); }

var StatefulMenu$1 = /*#__PURE__*/function (_React$PureComponent) {
  _inherits$u(StatefulMenu, _React$PureComponent);

  var _super = _createSuper$t(StatefulMenu);

  function StatefulMenu() {
    _classCallCheck$v(this, StatefulMenu);

    return _super.apply(this, arguments);
  }

  _createClass$u(StatefulMenu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          overrides = _this$props.overrides,
          props = _objectWithoutProperties$m(_this$props, ["overrides"]);

      return /*#__PURE__*/React$2.createElement(NestedMenuContext.Consumer, null, function (ctx) {
        return (
          /*#__PURE__*/
          //$FlowExpectedError[cannot-spread-inexact]
          React$2.createElement(StatefulContainer$1, _extends$J({}, ctx, props), function (renderProps) {
            return /*#__PURE__*/React$2.createElement(Menu, _extends$J({}, renderProps, {
              overrides: overrides
            }));
          })
        );
      });
    }
  }]);

  return StatefulMenu;
}(React$2.PureComponent);

function ownKeys$J(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$J(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$J(Object(source), true).forEach(function (key) { _defineProperty$10(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$J(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$10(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getFont() {
  var _SIZE$mini$SIZE$compa;

  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SIZE$2.default;
  var typography = arguments.length > 1 ? arguments[1] : undefined;
  return (_SIZE$mini$SIZE$compa = {}, _defineProperty$10(_SIZE$mini$SIZE$compa, SIZE$2.mini, typography.font100), _defineProperty$10(_SIZE$mini$SIZE$compa, SIZE$2.compact, typography.font200), _defineProperty$10(_SIZE$mini$SIZE$compa, SIZE$2.default, typography.font300), _defineProperty$10(_SIZE$mini$SIZE$compa, SIZE$2.large, typography.font400), _SIZE$mini$SIZE$compa)[size];
}

function getControlPadding(props) {
  var _SIZE$mini, _SIZE$compact, _SIZE$default, _SIZE$large, _SIZE$mini$SIZE$compa2;

  var $theme = props.$theme,
      sizing = props.$theme.sizing,
      _props$$size = props.$size,
      $size = _props$$size === void 0 ? SIZE$2.default : _props$$size,
      $type = props.$type,
      $multi = props.$multi,
      $isEmpty = props.$isEmpty;
  var isSearch = $type === TYPE$1.search;
  var paddingLeft = isSearch ? "calc(".concat(sizing.scale1000, " - ").concat(sizing.scale0, ")") : sizing.scale400;
  var paddingStartDir = $theme.direction === 'rtl' ? 'paddingRight' : 'paddingLeft';
  var paddingEndDir = $theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight';
  return (_SIZE$mini$SIZE$compa2 = {}, _defineProperty$10(_SIZE$mini$SIZE$compa2, SIZE$2.mini, (_SIZE$mini = {
    // `sizing.scale0` based on the multi value component (Tag) top and bottom margin
    paddingTop: $multi && !$isEmpty ? 0 : sizing.scale100,
    paddingBottom: $multi && !$isEmpty ? 0 : sizing.scale100
  }, _defineProperty$10(_SIZE$mini, paddingStartDir, $multi && !$isEmpty ? "calc(".concat(paddingLeft, " - ").concat(sizing.scale0, ")") : paddingLeft), _defineProperty$10(_SIZE$mini, paddingEndDir, '0'), _SIZE$mini)), _defineProperty$10(_SIZE$mini$SIZE$compa2, SIZE$2.compact, (_SIZE$compact = {
    // `sizing.scale0` based on the multi value component (Tag) top and bottom margin
    paddingTop: $multi && !$isEmpty ? "calc(".concat(sizing.scale100, " - ").concat(sizing.scale0, ")") : sizing.scale200,
    paddingBottom: $multi && !$isEmpty ? "calc(".concat(sizing.scale100, " - ").concat(sizing.scale0, ")") : sizing.scale200
  }, _defineProperty$10(_SIZE$compact, paddingStartDir, $multi && !$isEmpty ? "calc(".concat(paddingLeft, " - ").concat(sizing.scale0, ")") : paddingLeft), _defineProperty$10(_SIZE$compact, paddingEndDir, '0'), _SIZE$compact)), _defineProperty$10(_SIZE$mini$SIZE$compa2, SIZE$2.default, (_SIZE$default = {
    // `sizing.scale0` based on the multi value component (Tag) top and bottom margin
    paddingTop: $multi && !$isEmpty ? "calc(".concat(sizing.scale400, " - ").concat(sizing.scale0, ")") : sizing.scale400,
    paddingBottom: $multi && !$isEmpty ? "calc(".concat(sizing.scale400, " - ").concat(sizing.scale0, ")") : sizing.scale400
  }, _defineProperty$10(_SIZE$default, paddingStartDir, $multi && !$isEmpty ? "calc(".concat(paddingLeft, " + ").concat(sizing.scale0, ")") : paddingLeft), _defineProperty$10(_SIZE$default, paddingEndDir, 0), _SIZE$default)), _defineProperty$10(_SIZE$mini$SIZE$compa2, SIZE$2.large, (_SIZE$large = {
    // `sizing.scale0` based on the multi value component (Tag) top and bottom margin
    paddingTop: $multi && !$isEmpty ? "calc(".concat(sizing.scale600, " - ").concat(sizing.scale0, ")") : sizing.scale550,
    paddingBottom: $multi && !$isEmpty ? "calc(".concat(sizing.scale600, " - ").concat(sizing.scale0, ")") : sizing.scale550
  }, _defineProperty$10(_SIZE$large, paddingStartDir, $multi && !$isEmpty ? "calc(".concat(paddingLeft, " - ").concat(sizing.scale0, ")") : paddingLeft), _defineProperty$10(_SIZE$large, paddingEndDir, 0), _SIZE$large)), _SIZE$mini$SIZE$compa2)[$size];
}

var StyledDropdownContainer$1 = styled('div', function (props) {
  return {
    width: "".concat(String(props.$width), "px")
  };
});
StyledDropdownContainer$1.displayName = "StyledDropdownContainer";
var StyledDropdown$1 = StyledList$1;
var StyledDropdownListItem$1 = StyledListItem$1;
var StyledOptionContent = styled('div', function (props) {
  var $isHighlighted = props.$isHighlighted,
      $selected = props.$selected,
      $disabled = props.$disabled,
      $theme = props.$theme;
  return {
    cursor: $disabled ? 'not-allowed' : 'pointer',
    color: $selected && !$isHighlighted ? $theme.colors.menuFontSelected : null,
    fontWeight: $selected ? 'bold' : 'normal'
  };
});
StyledOptionContent.displayName = "StyledOptionContent";
var StyledRoot$f = styled('div', function (props) {
  var typography = props.$theme.typography,
      $size = props.$size;
  return _objectSpread$J(_objectSpread$J({}, getFont($size, typography)), {}, {
    boxSizing: 'border-box',
    position: 'relative',
    width: '100%'
  });
});
StyledRoot$f.displayName = "StyledRoot";

function getControlContainerColors($disabled, $isFocused, $isPseudoFocused, $positive, $error, colors) {
  if ($disabled) {
    return {
      color: colors.inputTextDisabled,
      borderLeftColor: colors.inputFillDisabled,
      borderRightColor: colors.inputFillDisabled,
      borderTopColor: colors.inputFillDisabled,
      borderBottomColor: colors.inputFillDisabled,
      backgroundColor: colors.inputFillDisabled
    };
  }

  if ($isFocused || $isPseudoFocused) {
    return {
      color: colors.contentPrimary,
      borderLeftColor: colors.borderFocus,
      borderRightColor: colors.borderFocus,
      borderTopColor: colors.borderFocus,
      borderBottomColor: colors.borderFocus,
      backgroundColor: colors.inputFillActive
    };
  }

  if ($error) {
    return {
      color: colors.contentPrimary,
      borderLeftColor: colors.inputBorderError,
      borderRightColor: colors.inputBorderError,
      borderTopColor: colors.inputBorderError,
      borderBottomColor: colors.inputBorderError,
      backgroundColor: colors.inputFillError
    };
  }

  if ($positive) {
    return {
      color: colors.contentPrimary,
      borderLeftColor: colors.inputBorderPositive,
      borderRightColor: colors.inputBorderPositive,
      borderTopColor: colors.inputBorderPositive,
      borderBottomColor: colors.inputBorderPositive,
      backgroundColor: colors.inputFillPositive
    };
  }

  return {
    color: colors.contentPrimary,
    borderLeftColor: colors.inputBorder,
    borderRightColor: colors.inputBorder,
    borderTopColor: colors.inputBorder,
    borderBottomColor: colors.inputBorder,
    backgroundColor: colors.inputFill
  };
}

var StyledControlContainer$2 = styled('div', function (props) {
  var $disabled = props.$disabled,
      $error = props.$error,
      $positive = props.$positive,
      $isFocused = props.$isFocused,
      $isPseudoFocused = props.$isPseudoFocused,
      $type = props.$type,
      $searchable = props.$searchable,
      _props$$theme = props.$theme,
      borders = _props$$theme.borders,
      colors = _props$$theme.colors,
      animation = _props$$theme.animation;
  return _objectSpread$J({
    borderTopLeftRadius: borders.inputBorderRadius,
    borderTopRightRadius: borders.inputBorderRadius,
    borderBottomRightRadius: borders.inputBorderRadius,
    borderBottomLeftRadius: borders.inputBorderRadius,
    boxSizing: 'border-box',
    overflow: 'hidden',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    cursor: $disabled ? 'not-allowed' : $searchable || $type === TYPE$1.search ? 'text' : 'pointer',
    borderLeftWidth: '2px',
    borderRightWidth: '2px',
    borderTopWidth: '2px',
    borderBottomWidth: '2px',
    borderLeftStyle: 'solid',
    borderRightStyle: 'solid',
    borderTopStyle: 'solid',
    borderBottomStyle: 'solid',
    transitionProperty: 'border, box-shadow, background-color',
    transitionDuration: animation.timing200,
    transitionTimingFunction: animation.easeOutCurve
  }, getControlContainerColors($disabled, $isFocused, $isPseudoFocused, $positive, $error, colors));
});
StyledControlContainer$2.displayName = "StyledControlContainer";
var StyledValueContainer$1 = styled('div', function (props) {
  var padding = getControlPadding(props);
  return _objectSpread$J({
    boxSizing: 'border-box',
    position: 'relative',
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: '0%',
    display: 'flex',
    alignItems: 'center',
    flexWrap: props.$multi ? 'wrap' : 'nowrap',
    overflow: 'hidden'
  }, padding);
});
StyledValueContainer$1.displayName = "StyledValueContainer";
var StyledPlaceholder = styled('div', function (props) {
  var $disabled = props.$disabled,
      colors = props.$theme.colors;
  return {
    color: $disabled ? colors.inputPlaceholderDisabled : colors.inputPlaceholder,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };
});
StyledPlaceholder.displayName = "StyledPlaceholder";
var StyledSingleValue = styled('div', function (props) {
  var _objectSpread2;

  var $searchable = props.$searchable,
      $size = props.$size,
      $theme = props.$theme,
      typography = props.$theme.typography;
  var font = getFont($size, typography);
  var marginDir = $theme.direction === 'rtl' ? 'marginRight' : 'marginLeft';
  return _objectSpread$J((_objectSpread2 = {
    lineHeight: !$searchable ? font.lineHeight : 'inherit',
    boxSizing: 'border-box'
  }, _defineProperty$10(_objectSpread2, marginDir, $theme.sizing.scale0), _defineProperty$10(_objectSpread2, "height", '100%'), _defineProperty$10(_objectSpread2, "maxWidth", '100%'), _objectSpread2), ellipsisText$1);
});
StyledSingleValue.displayName = "StyledSingleValue";
var StyledInputContainer$1 = styled('div', function (props) {
  var $size = props.$size,
      $searchable = props.$searchable,
      _props$$theme2 = props.$theme,
      typography = _props$$theme2.typography,
      sizing = _props$$theme2.sizing,
      $isEmpty = props.$isEmpty;
  var font = getFont($size, typography);
  return {
    position: 'relative',
    display: 'inline-block',
    maxWidth: '100%',
    backgroundColor: 'transparent',
    borderLeftStyle: 'none',
    borderTopStyle: 'none',
    borderRightStyle: 'none',
    borderBottomStyle: 'none',
    boxShadow: 'none',
    boxSizing: 'border-box',
    outline: 'none',
    marginTop: 0,
    marginBottom: 0,
    marginLeft: $isEmpty ? 0 : sizing.scale0,
    marginRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    height: String(!$searchable ? font.lineHeight : 'auto'),
    maxHeight: String(font.lineHeight)
  };
});
StyledInputContainer$1.displayName = "StyledInputContainer";
var StyledInput$2 = styled('input', function (props) {
  var _props$$theme3 = props.$theme,
      colors = _props$$theme3.colors,
      typography = _props$$theme3.typography,
      $size = props.$size,
      $searchable = props.$searchable,
      $width = props.$width;
  return _objectSpread$J(_objectSpread$J({}, getFont($size, typography)), {}, {
    color: colors.contentPrimary,
    boxSizing: 'content-box',
    width: !$searchable ? '1px' : $width || '100%',
    maxWidth: '100%',
    background: 'transparent',
    borderLeftStyle: 'none',
    borderTopStyle: 'none',
    borderRightStyle: 'none',
    borderBottomStyle: 'none',
    boxShadow: 'none',
    display: 'inline-block',
    outline: 'none',
    marginTop: '0',
    marginBottom: '0',
    marginLeft: '0',
    marginRight: '0',
    paddingTop: '0',
    paddingBottom: '0',
    paddingLeft: '0',
    paddingRight: '0'
  });
});
StyledInput$2.displayName = "StyledInput";
var StyledInputSizer = styled('div', function (_ref) {
  var _objectSpread3;

  var $size = _ref.$size,
      $theme = _ref.$theme,
      typography = _ref.$theme.typography;
  var dir = $theme.direction === 'rtl' ? 'right' : 'left';
  return _objectSpread$J(_objectSpread$J({}, getFont($size, typography)), {}, (_objectSpread3 = {
    position: 'absolute',
    top: 0
  }, _defineProperty$10(_objectSpread3, dir, 0), _defineProperty$10(_objectSpread3, "visibility", 'hidden'), _defineProperty$10(_objectSpread3, "height", 0), _defineProperty$10(_objectSpread3, "overflow", 'scroll'), _defineProperty$10(_objectSpread3, "whiteSpace", 'pre'), _objectSpread3));
});
StyledInputSizer.displayName = "StyledInputSizer";
var StyledIconsContainer = styled('div', function (_ref2) {
  var $theme = _ref2.$theme,
      sizing = _ref2.$theme.sizing;
  var paddingDir = $theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight';
  return _defineProperty$10({
    boxSizing: 'border-box',
    position: 'relative',
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    alignSelf: 'stretch'
  }, paddingDir, sizing.scale500);
});
StyledIconsContainer.displayName = "StyledIconsContainer";

function getSvgStyles(_ref4) {
  var $theme = _ref4.$theme;
  return {
    display: 'inline-block',
    fill: 'currentColor',
    color: 'currentColor',
    height: $theme.sizing.scale600,
    width: $theme.sizing.scale600
  };
}

var StyledSelectArrow = styled('svg', function (props) {
  var _sizes;

  var $theme = props.$theme,
      $disabled = props.$disabled,
      $size = props.$size;
  var colors = $theme.colors;
  var sizes = (_sizes = {}, _defineProperty$10(_sizes, SIZE$2.mini, 16), _defineProperty$10(_sizes, SIZE$2.compact, 16), _defineProperty$10(_sizes, SIZE$2.default, 20), _defineProperty$10(_sizes, SIZE$2.large, 24), _sizes);
  var size = sizes[SIZE$2.default];

  if ($size) {
    size = sizes[$size];
  }

  return _objectSpread$J(_objectSpread$J({}, getSvgStyles({
    $theme: $theme
  })), {}, {
    color: $disabled ? colors.inputTextDisabled : colors.contentPrimary,
    cursor: $disabled ? 'not-allowed' : 'pointer',
    height: "".concat(size, "px"),
    width: "".concat(size, "px")
  });
});
StyledSelectArrow.displayName = "StyledSelectArrow";
var StyledClearIcon = styled('svg', function (props) {
  var _sizes2;

  var $theme = props.$theme,
      $size = props.$size;
  var colors = $theme.colors;
  var sizes = (_sizes2 = {}, _defineProperty$10(_sizes2, SIZE$2.mini, 15), _defineProperty$10(_sizes2, SIZE$2.compact, 15), _defineProperty$10(_sizes2, SIZE$2.default, 18), _defineProperty$10(_sizes2, SIZE$2.large, 22), _sizes2);
  var size = sizes[SIZE$2.default];

  if ($size) {
    size = sizes[$size];
  }

  return _objectSpread$J(_objectSpread$J({}, getSvgStyles({
    $theme: $theme
  })), {}, {
    color: colors.contentPrimary,
    cursor: 'pointer',
    height: "".concat(size, "px"),
    width: "".concat(size, "px")
  });
});
StyledClearIcon.displayName = "StyledClearIcon";
var getLoadingIconStyles = function getLoadingIconStyles(props) {
  var $theme = props.$theme;
  var colors = $theme.colors;
  return _objectSpread$J(_objectSpread$J({}, getSvgStyles({
    $theme: $theme
  })), {}, {
    color: colors.contentPrimary
  });
};
var StyledSearchIconContainer = styled('div', function (props) {
  var _objectSpread4;

  var $disabled = props.$disabled,
      $theme = props.$theme;
  var colors = $theme.colors,
      sizing = $theme.sizing;
  var dir = $theme.direction === 'rtl' ? 'right' : 'left';
  return _objectSpread$J(_objectSpread$J({}, getSvgStyles(props)), {}, (_objectSpread4 = {
    color: $disabled ? colors.inputTextDisabled : colors.contentPrimary,
    cursor: $disabled ? 'not-allowed' : 'pointer',
    position: 'absolute',
    top: 0
  }, _defineProperty$10(_objectSpread4, dir, sizing.scale500), _defineProperty$10(_objectSpread4, "display", 'flex'), _defineProperty$10(_objectSpread4, "alignItems", 'center'), _defineProperty$10(_objectSpread4, "height", '100%'), _objectSpread4));
});
StyledSearchIconContainer.displayName = "StyledSearchIconContainer";

function _typeof$t(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$t = function _typeof(obj) { return typeof obj; }; } else { _typeof$t = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$t(obj); }

function _extends$I() { _extends$I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }

function ownKeys$I(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$I(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$I(Object(source), true).forEach(function (key) { _defineProperty$$(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$I(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray$F(arr, i) { return _arrayWithHoles$F(arr) || _iterableToArrayLimit$F(arr, i) || _unsupportedIterableToArray$H(arr, i) || _nonIterableRest$F(); }

function _nonIterableRest$F() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$H(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$H(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$H(o, minLen); }

function _arrayLikeToArray$H(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$F(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$F(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties$l(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$k(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$k(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$u(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$s(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$t(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$s(Constructor.prototype, protoProps); if (staticProps) _defineProperties$s(Constructor, staticProps); return Constructor; }

function _inherits$t(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$s(subClass, superClass); }

function _setPrototypeOf$s(o, p) { _setPrototypeOf$s = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$s(o, p); }

function _createSuper$s(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$s(); return function _createSuperInternal() { var Super = _getPrototypeOf$s(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$s(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$t(this, result); }; }

function _possibleConstructorReturn$t(self, call) { if (call && (_typeof$t(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$s(self); }

function _assertThisInitialized$s(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$s() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$s(o) { _getPrototypeOf$s = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$s(o); }

function _defineProperty$$(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AutosizeInput = /*#__PURE__*/function (_React$Component) {
  _inherits$t(AutosizeInput, _React$Component);

  var _super = _createSuper$s(AutosizeInput);

  function AutosizeInput() {
    var _this;

    _classCallCheck$u(this, AutosizeInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$$(_assertThisInitialized$s(_this), "mounted", void 0);

    _defineProperty$$(_assertThisInitialized$s(_this), "sizer", void 0);

    _defineProperty$$(_assertThisInitialized$s(_this), "state", {
      inputWidth: 5
    });

    _defineProperty$$(_assertThisInitialized$s(_this), "sizerRef", function (el) {
      _this.sizer = el;
    });

    return _this;
  }

  _createClass$t(AutosizeInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.updateInputWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this.updateInputWidth();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "updateInputWidth",
    value: function updateInputWidth() {
      if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
        return;
      }

      var newInputWidth = this.sizer.scrollWidth + 2;

      if (newInputWidth !== this.state.inputWidth && this.sizer.scrollWidth !== this.state.inputWidth) {
        this.setState({
          inputWidth: newInputWidth
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$overrides = _this$props.overrides,
          overrides = _this$props$overrides === void 0 ? {} : _this$props$overrides,
          inputRef = _this$props.inputRef,
          restProps = _objectWithoutProperties$l(_this$props, ["overrides", "inputRef"]);

      var _getOverrides = getOverrides(overrides.Input, StyledInput$2),
          _getOverrides2 = _slicedToArray$F(_getOverrides, 2),
          Input = _getOverrides2[0],
          inputProps = _getOverrides2[1];

      var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
        if (previousValue !== null && previousValue !== undefined) {
          return previousValue;
        }

        return currentValue;
      });

      var componentInputProps = _objectSpread$I(_objectSpread$I({}, restProps), {}, {
        $width: "".concat(this.state.inputWidth, "px")
      });

      return /*#__PURE__*/React$2.createElement(React$2.Fragment, null, /*#__PURE__*/React$2.createElement(Input, _extends$I({}, componentInputProps, {
        ref: inputRef
      }, inputProps)), /*#__PURE__*/React$2.createElement(StyledInputSizer, {
        $size: this.props.$size,
        ref: this.sizerRef,
        $style: inputProps.$style ? inputProps.$style : null
      }, sizerValue));
    }
  }]);

  return AutosizeInput;
}(React$2.Component);

_defineProperty$$(AutosizeInput, "defaultProps", {
  inputRef: /*#__PURE__*/React$2.createRef(),
  value: '',
  overrides: {}
});

function ownKeys$H(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$H(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$H(Object(source), true).forEach(function (key) { _defineProperty$_(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$H(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$_(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var escapeRegExp = function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

var isValid$1 = function isValid(value) {
  return typeof value !== 'undefined' && value !== null && value !== '';
};

var defaultProps$5 = {
  filterOption: null,
  ignoreCase: true,
  labelKey: 'label',
  matchPos: 'any',
  matchProp: 'any',
  trimFilter: true,
  valueKey: 'value'
};

var filterOptions = function filterOptions(options, filterValue, excludeOptions, newProps) {
  var props = _objectSpread$H(_objectSpread$H({}, defaultProps$5), newProps);

  if (props.ignoreCase) {
    filterValue = filterValue.toLowerCase();
  }

  if (props.trimFilter) {
    filterValue = filterValue.trim();
  }

  var excludeValues = (excludeOptions || []).reduce(function (acc, option) {
    acc.add(option[props.valueKey]);
    return acc;
  }, new Set());
  var re = new RegExp("".concat(props.matchPos === 'start' ? '$' : '').concat(escapeRegExp(filterValue)), props.ignoreCase ? 'i' : ''); // $FlowFixMe

  return options.filter(function (option) {
    if (excludeValues.has(option[props.valueKey])) return false;
    if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
    if (!filterValue) return true;
    var value = option[props.valueKey];
    var label = option[props.labelKey];
    var hasValue = isValid$1(value);
    var hasLabel = isValid$1(label);

    if (!hasValue && !hasLabel) {
      return false;
    }

    var valueTest = hasValue ? String(value) : null;
    var labelTest = hasLabel ? String(label) : null;
    return valueTest && props.matchProp !== 'label' && re.test(valueTest) || labelTest && props.matchProp !== 'value' && re.test(labelTest);
  });
};

var filterOptions$1 = filterOptions;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var defaultProps$3 = {
  'aria-label': null,
  'aria-describedby': null,
  'aria-errormessage': null,
  'aria-labelledby': null,
  autoFocus: false,
  backspaceRemoves: true,
  clearable: true,
  closeOnSelect: true,
  creatable: false,
  deleteRemoves: true,
  disabled: false,
  error: false,
  positive: false,
  escapeClearsValue: true,
  filterOptions: filterOptions$1,
  filterOutSelected: true,
  getOptionLabel: null,
  getValueLabel: null,
  ignoreCase: true,
  isLoading: false,
  labelKey: 'label',
  maxDropdownHeight: '900px',
  multi: false,
  onBlur: function onBlur() {},
  onBlurResetsInput: true,
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onInputChange: function onInputChange() {},
  onCloseResetsInput: true,
  onSelectResetsInput: true,
  onOpen: null,
  onClose: null,
  openOnClick: true,
  startOpen: false,
  options: [],
  overrides: {},
  required: false,
  searchable: true,
  size: SIZE$2.default,
  type: TYPE$1.select,
  value: [],
  valueKey: 'id'
};
var defaultProps$4 = defaultProps$3;

function _typeof$s(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$s = function _typeof(obj) { return typeof obj; }; } else { _typeof$s = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$s(obj); }

function ownKeys$G(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$G(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$G(Object(source), true).forEach(function (key) { _defineProperty$Z(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$G(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties$k(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$j(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$j(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends$H() { _extends$H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

function _slicedToArray$E(arr, i) { return _arrayWithHoles$E(arr) || _iterableToArrayLimit$E(arr, i) || _unsupportedIterableToArray$G(arr, i) || _nonIterableRest$E(); }

function _nonIterableRest$E() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$G(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$G(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$G(o, minLen); }

function _arrayLikeToArray$G(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$E(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$E(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$t(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$r(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$s(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$r(Constructor.prototype, protoProps); if (staticProps) _defineProperties$r(Constructor, staticProps); return Constructor; }

function _inherits$s(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$r(subClass, superClass); }

function _setPrototypeOf$r(o, p) { _setPrototypeOf$r = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$r(o, p); }

function _createSuper$r(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$r(); return function _createSuperInternal() { var Super = _getPrototypeOf$r(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$r(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$s(this, result); }; }

function _possibleConstructorReturn$s(self, call) { if (call && (_typeof$s(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$r(self); }

function _assertThisInitialized$r(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$r() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$r(o) { _getPrototypeOf$r = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$r(o); }

function _defineProperty$Z(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function groupOptions(options) {
  return options.reduce(function (groups, option) {
    if (option.__optgroup) {
      if (!groups[option.__optgroup]) {
        groups[option.__optgroup] = [];
      }

      groups[option.__optgroup].push(option);
    } else {
      groups.__ungrouped.push(option);
    }

    return groups;
  }, {
    __ungrouped: []
  });
}

var SelectDropdown = /*#__PURE__*/function (_React$Component) {
  _inherits$s(SelectDropdown, _React$Component);

  var _super = _createSuper$r(SelectDropdown);

  function SelectDropdown() {
    var _this;

    _classCallCheck$t(this, SelectDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$Z(_assertThisInitialized$r(_this), "getItemLabel", function (option) {
      var _this$props = _this.props,
          getOptionLabel = _this$props.getOptionLabel,
          _this$props$overrides = _this$props.overrides,
          overrides = _this$props$overrides === void 0 ? {} : _this$props$overrides,
          value = _this$props.value,
          valueKey = _this$props.valueKey;

      var _getOverrides = getOverrides(overrides.OptionContent, StyledOptionContent),
          _getOverrides2 = _slicedToArray$E(_getOverrides, 2),
          OptionContent = _getOverrides2[0],
          optionContentProps = _getOverrides2[1];

      var $selected;

      if (Array.isArray(value)) {
        $selected = !!value.find(function (selected) {
          return selected && selected[valueKey] === option[valueKey];
        });
      } else {
        $selected = value[valueKey] === option[valueKey];
      }

      var optionSharedProps = {
        $selected: $selected,
        $disabled: option.disabled,
        $isHighlighted: option.isHighlighted
      };
      return /*#__PURE__*/React$2.createElement(OptionContent, _extends$H({
        "aria-readonly": option.disabled,
        "aria-selected": $selected,
        key: option[valueKey]
      }, _this.getSharedProps(), optionSharedProps, optionContentProps), getOptionLabel({
        option: option,
        optionState: optionSharedProps
      }));
    });

    _defineProperty$Z(_assertThisInitialized$r(_this), "onMouseDown", function (e) {
      e.nativeEvent.stopImmediatePropagation();
    });

    _defineProperty$Z(_assertThisInitialized$r(_this), "getHighlightedIndex", function () {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          options = _this$props2.options,
          valueKey = _this$props2.valueKey; // Highlight only first value as menu supports only a single highlight index

      var firstValue = {};

      if (Array.isArray(value) && value.length > 0) {
        firstValue = value[0];
      } else if (!(value instanceof Array)) {
        firstValue = value;
      }

      if (Object.keys(firstValue).length > 0) {
        var a = options.findIndex(function (option) {
          return option && option[valueKey] === firstValue[valueKey];
        });
        return a === -1 ? 0 : a;
      }

      return 0;
    });

    return _this;
  }

  _createClass$s(SelectDropdown, [{
    key: "getSharedProps",
    value: function getSharedProps() {
      var _this$props3 = this.props,
          error = _this$props3.error,
          isLoading = _this$props3.isLoading,
          multi = _this$props3.multi,
          required = _this$props3.required,
          size = _this$props3.size,
          searchable = _this$props3.searchable,
          type = _this$props3.type,
          width = _this$props3.width;
      return {
        $error: error,
        $isLoading: isLoading,
        $multi: multi,
        $required: required,
        $searchable: searchable,
        $size: size,
        $type: type,
        $width: width
      };
    } // flowlint-next-line unclear-type:off

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // TODO(#185) Add no-results and loading states to menu
      var _this$props4 = this.props,
          maxDropdownHeight = _this$props4.maxDropdownHeight,
          multi = _this$props4.multi,
          noResultsMsg = _this$props4.noResultsMsg,
          onItemSelect = _this$props4.onItemSelect,
          _this$props4$options = _this$props4.options,
          options = _this$props4$options === void 0 ? [] : _this$props4$options,
          _this$props4$override = _this$props4.overrides,
          overrides = _this$props4$override === void 0 ? {} : _this$props4$override,
          size = _this$props4.size;

      var _getOverrides3 = getOverrides(overrides.DropdownContainer, StyledDropdownContainer$1),
          _getOverrides4 = _slicedToArray$E(_getOverrides3, 2),
          DropdownContainer = _getOverrides4[0],
          dropdownContainerProps = _getOverrides4[1];

      var _getOverrides5 = getOverrides(overrides.DropdownListItem, StyledDropdownListItem$1),
          _getOverrides6 = _slicedToArray$E(_getOverrides5, 2),
          ListItem = _getOverrides6[0],
          listItemProps = _getOverrides6[1];

      var _getOverrides7 = getOverrides(overrides.StatefulMenu, StatefulMenu$1),
          _getOverrides8 = _slicedToArray$E(_getOverrides7, 2),
          OverriddenStatefulMenu = _getOverrides8[0],
          _getOverrides8$ = _getOverrides8[1],
          _getOverrides8$$overr = _getOverrides8$.overrides,
          statefulMenuOverrides = _getOverrides8$$overr === void 0 ? {} : _getOverrides8$$overr,
          restStatefulMenuProps = _objectWithoutProperties$k(_getOverrides8$, ["overrides"]);

      var highlightedIndex = this.getHighlightedIndex();
      var groupedOptions = groupOptions(options);
      return /*#__PURE__*/React$2.createElement(DropdownContainer, _extends$H({
        "data-no-focus-lock": true,
        ref: this.props.innerRef
      }, this.getSharedProps(), dropdownContainerProps), /*#__PURE__*/React$2.createElement(OverriddenStatefulMenu, _extends$H({
        noResultsMsg: noResultsMsg,
        onActiveDescendantChange: function onActiveDescendantChange(id) {
          if (_this2.props.onActiveDescendantChange) {
            _this2.props.onActiveDescendantChange(id);
          }
        },
        onItemSelect: onItemSelect,
        items: groupedOptions,
        size: size,
        initialState: {
          isFocused: true,
          highlightedIndex: highlightedIndex
        },
        typeAhead: false,
        keyboardControlNode: this.props.keyboardControlNode,
        forceHighlight: true,
        overrides: mergeOverrides({
          List: {
            component: StyledDropdown$1,
            style: function style(p) {
              return {
                maxHeight: p.$maxHeight || null
              };
            },
            props: {
              id: this.props.id ? this.props.id : null,
              $maxHeight: maxDropdownHeight,
              'aria-multiselectable': multi
            }
          },
          Option: {
            props: {
              getItemLabel: this.getItemLabel,
              // figure out why the onClick handler is not
              // triggered without this temporary fix
              onMouseDown: this.onMouseDown,
              overrides: {
                ListItem: {
                  component: ListItem,
                  props: _objectSpread$G(_objectSpread$G({}, listItemProps), {}, {
                    role: 'option'
                  }),
                  // slightly hacky way to handle the list item style overrides
                  // since the menu component doesn't provide a top level overrides for it
                  style: listItemProps.$style
                }
              },
              renderHrefAsAnchor: false
            }
          }
        }, _objectSpread$G({
          List: overrides.Dropdown || {},
          Option: overrides.DropdownOption || {}
        }, statefulMenuOverrides))
      }, restStatefulMenuProps)));
    }
  }]);

  return SelectDropdown;
}(React$2.Component);

function ownKeys$F(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$F(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$F(Object(source), true).forEach(function (key) { _defineProperty$Y(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$F(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$Y(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function groupedOptionsToArray(groupedOptions) {
  return Object.keys(groupedOptions).reduce(function (arr, optgroup) {
    var optgroupOptions = groupedOptions[optgroup];
    return arr.concat(optgroupOptions.map(function (option) {
      return _objectSpread$F(_objectSpread$F({}, option), {}, {
        __optgroup: optgroup
      });
    }));
  }, []);
}

function normalizeOptions(options) {
  if (options) {
    if (Array.isArray(options)) {
      return options;
    } else {
      return groupedOptionsToArray(options);
    }
  }

  return [];
}
var expandValue = function expandValue(value, props) {
  if (!props.options) return value;
  var normalizedOptions = normalizeOptions(props.options);

  for (var i = 0; i < normalizedOptions.length; i++) {
    if (String(normalizedOptions[i][props.valueKey]) === String(value[props.valueKey])) {
      return normalizedOptions[i];
    }
  }

  return value;
};

function _typeof$r(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$r = function _typeof(obj) { return typeof obj; }; } else { _typeof$r = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$r(obj); }

function _extends$G() { _extends$G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }

function _slicedToArray$D(arr, i) { return _arrayWithHoles$D(arr) || _iterableToArrayLimit$D(arr, i) || _unsupportedIterableToArray$F(arr, i) || _nonIterableRest$D(); }

function _nonIterableRest$D() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit$D(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$D(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray$9(arr) { return _arrayWithoutHoles$8(arr) || _iterableToArray$8(arr) || _unsupportedIterableToArray$F(arr) || _nonIterableSpread$8(); }

function _nonIterableSpread$8() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$F(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$F(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$F(o, minLen); }

function _iterableToArray$8(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$8(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$F(arr); }

function _arrayLikeToArray$F(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck$s(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$q(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$r(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$q(Constructor.prototype, protoProps); if (staticProps) _defineProperties$q(Constructor, staticProps); return Constructor; }

function _inherits$r(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$q(subClass, superClass); }

function _setPrototypeOf$q(o, p) { _setPrototypeOf$q = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$q(o, p); }

function _createSuper$q(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$q(); return function _createSuperInternal() { var Super = _getPrototypeOf$q(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$q(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$r(this, result); }; }

function _possibleConstructorReturn$r(self, call) { if (call && (_typeof$r(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$q(self); }

function _assertThisInitialized$q(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$q() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$q(o) { _getPrototypeOf$q = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$q(o); }

function _defineProperty$X(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Noop() {
  return null;
}

var isClick = function isClick(event) {
  return event.type === 'click';
};

var isLeftClick = function isLeftClick(event) {
  return event.button !== null && event.button !== undefined && event.button === 0;
};

var containsNode = function containsNode(parent, child) {
  if (typeof document !== 'undefined') {
    // flowlint-next-line unclear-type:off
    return child && parent && parent.contains(child);
  }
};

function isInteractive(rootTarget, rootElement) {
  if (rootTarget instanceof Element) {
    var target = rootTarget;

    while (target && target !== rootElement) {
      var role = target.getAttribute('role');

      if (role === 'button' || role === 'link') {
        return true;
      }

      if (target.tagName) target = target.parentElement;
    }
  }

  return false;
}

var Select$2 = /*#__PURE__*/function (_React$Component) {
  _inherits$r(Select, _React$Component);

  var _super = _createSuper$q(Select);

  // anchor is a ref that refers to the outermost element rendered when the dropdown menu is not
  // open. This is required so that we can check if clicks are on/off the anchor element.
  // dropdown is a ref that refers to the popover element. This is required so that we can check if
  // clicks are on/off the dropdown element.
  // dragging is a flag to track whether a mobile device is currently scrolling versus clicking.
  // focusAfterClear is a flag to indicate that the dropdowm menu should open after a selected
  // option has been cleared.
  // openAfterFocus is a flag to indicate that the dropdown menu should open when the component is
  // focused. Developers have the option to disable initial clicks opening the dropdown menu. If not
  // disabled, clicks will set this flag to true. Upon focusing, look to this to see if the menu should
  // be opened, or only focus.
  // When an item is selected, it also triggers handleClickOutside and since the selected item is
  // already out of the menu (DOM), it will not recognize it as a subnode and triggers handleBlur
  // that sets isOpen to false. That's a faulty logic causing visible problems when
  // closeOnSelect is false. This flag helps to detect that selection was just made.
  // the select components can accept an array of options or an object where properties are optgroups
  // and values are arrays of options. this class property is constructed and updated in a normalized
  // shape where optgroup titles are stored on the option in the __optgroup field.
  function Select(props) {
    var _this;

    _classCallCheck$s(this, Select);

    _this = _super.call(this, props);

    _defineProperty$X(_assertThisInitialized$q(_this), "anchor", /*#__PURE__*/React$2.createRef());

    _defineProperty$X(_assertThisInitialized$q(_this), "dropdown", /*#__PURE__*/React$2.createRef());

    _defineProperty$X(_assertThisInitialized$q(_this), "input", void 0);

    _defineProperty$X(_assertThisInitialized$q(_this), "dragging", void 0);

    _defineProperty$X(_assertThisInitialized$q(_this), "focusAfterClear", void 0);

    _defineProperty$X(_assertThisInitialized$q(_this), "openAfterFocus", void 0);

    _defineProperty$X(_assertThisInitialized$q(_this), "justSelected", void 0);

    _defineProperty$X(_assertThisInitialized$q(_this), "options", []);

    _defineProperty$X(_assertThisInitialized$q(_this), "state", {
      activeDescendant: null,
      inputValue: '',
      isFocused: false,
      isOpen: _this.props.startOpen,
      isPseudoFocused: false
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "isItMounted", false);

    _defineProperty$X(_assertThisInitialized$q(_this), "handleTouchOutside", function (event) {
      if (containsNode(_this.dropdown.current, event.target)) return;

      if (!containsNode(_this.anchor.current, event.target)) {
        _this.closeMenu();
      }
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "handleTouchMove", function () {
      return _this.dragging = true;
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "handleTouchStart", function () {
      return _this.dragging = false;
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "handleTouchEnd", function (event) {
      if (_this.dragging) return;

      _this.handleClick(event);
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "handleClick", function (event) {
      if (_this.props.disabled || !isClick(event) && !isLeftClick(event)) {
        return;
      } // Case comes up when text has been typed into the input field. If no text provided,
      // the 'input' element will have essentially 0 width therefore will not be clickable.
      // When click outside does not reset input, text provided will stay rendered after clicks away
      // from the select component. Upon subsequent clicks on the provided text, open the dropdown
      // menu, in addition to text edit operations.


      if (event.target === _this.input) {
        // CHASE: not sure why this condition is here. I cannot replicate a situation where clicks
        // on provided text break into here.
        if (!_this.state.isFocused) {
          _this.openAfterFocus = _this.props.openOnClick;

          _this.focus();
        }

        if (!_this.state.isOpen) {
          _this.setState({
            isOpen: true,
            isFocused: true,
            isPseudoFocused: false
          });
        }

        return;
      } // Ensures that interactive elements within the Select component do not trigger the outer click
      // handler. For example, after an option is selected clicks on the 'clear' icon call here. We
      // should ignore those events. This comes after case where click is on input element, so that
      // those are handled on their own.


      if (_this.input && isInteractive(event.target, _this.input)) {
        return;
      } // For the simple case where clicking on the Select does not allow for providing
      // text input to filter the dropdown options.


      if (!_this.props.searchable) {
        _this.focus();

        if (_this.state.isOpen) {
          _this.setState({
            isOpen: false,
            isFocused: false
          });
        } else {
          _this.setState({
            isOpen: true,
            isFocused: true
          });
        }

        return;
      } // Cases below only apply to searchable Select component.


      if (_this.state.isFocused) {
        // iOS ignores programmatic calls to input.focus() that were not triggered by a click event.
        // This component can get into a state where isFocused is true, but the DOM node is not
        // focused. Call focus here again to ensure.
        _this.focus(); // Case comes up when click outside does not reset input - once text has been provided to
        // the input, and the user closes the dropdown menu the provided text is maintained. After
        // this, if the user focuses back into the select component then clicks on the component,
        // the provided text highlights rather than position's the cursor at the end of the input.


        if (_this.input) _this.input.value = '';

        _this.setState(function (prev) {
          return {
            isOpen: !_this.focusAfterClear && !prev.isOpen,
            isPseudoFocused: false
          };
        });

        _this.focusAfterClear = false;
      } else {
        // When clear button is clicked, need to click twice to open control container - https://github.com/uber/baseweb/issues/4285
        // Setting focusAfterClear to false, resolves the issue
        _this.focusAfterClear = false;
        _this.openAfterFocus = _this.props.openOnClick;

        _this.focus();
      }
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "handleInputFocus", function (event) {
      if (_this.props.disabled) return;
      if (_this.props.onFocus) _this.props.onFocus(event);
      var toOpen = _this.state.isOpen || _this.openAfterFocus; // if focus happens after clear values, don't open dropdown yet.

      toOpen = !_this.focusAfterClear && toOpen;

      _this.setState({
        isFocused: true,
        isOpen: !!toOpen
      });

      _this.focusAfterClear = false;
      _this.openAfterFocus = false;
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "handleBlur", function (event) {
      if (event.relatedTarget) {
        if (containsNode(_this.anchor.current, event.relatedTarget) || containsNode(_this.dropdown.current, event.relatedTarget)) {
          return;
        }
      } else if (containsNode(_this.anchor.current, event.target)) {
        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      if (_this.isItMounted) {
        _this.setState({
          isFocused: false,
          isOpen: false,
          isPseudoFocused: false,
          inputValue: _this.props.onBlurResetsInput ? '' : _this.state.inputValue
        });
      }
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "handleClickOutside", function (event) {
      if (_this.justSelected) {
        _this.justSelected = false;
        return;
      }

      if (containsNode(_this.dropdown.current, event.target)) return;
      var isFocused = _this.state.isFocused || _this.state.isPseudoFocused;

      if (isFocused && !containsNode(_this.anchor.current, event.target)) {
        _this.handleBlur(event);
      }
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "handleInputChange", function (event) {
      var newInputValue = event.target.value;

      _this.setState({
        inputValue: newInputValue,
        isOpen: true,
        isPseudoFocused: false
      });

      if (_this.props.onInputChange) {
        _this.props.onInputChange(event);
      }
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "handleKeyDown", function (event) {
      if (_this.props.disabled) return;

      switch (event.keyCode) {
        case 8:
          // backspace
          if (!_this.state.inputValue && _this.props.backspaceRemoves) {
            event.preventDefault();

            _this.backspaceValue();
          }

          break;

        case 9:
          // tab
          _this.setState(function (prevState) {
            return {
              isPseudoFocused: false,
              isFocused: false,
              isOpen: false,
              inputValue: !_this.props.onCloseResetsInput || !_this.props.onBlurResetsInput ? prevState.inputValue : ''
            };
          });

          break;

        case 27:
          // escape
          if (!_this.state.isOpen && _this.props.clearable && _this.props.escapeClearsValue) {
            _this.clearValue(event);

            _this.setState({
              isFocused: false,
              isPseudoFocused: false
            });
          }

          break;

        case 32:
          // space
          if (_this.props.searchable) {
            break;
          }

          event.preventDefault();

          if (!_this.state.isOpen) {
            _this.setState({
              isOpen: true
            });
          }

          break;

        case 38:
          // up
          event.preventDefault();

          if (!_this.state.isOpen) {
            _this.setState({
              isOpen: true
            });
          }

          break;

        case 40:
          // down
          event.preventDefault();

          if (!_this.state.isOpen) {
            _this.setState({
              isOpen: true
            });
          }

          break;

        case 33:
          // page up
          event.preventDefault();

          if (!_this.state.isOpen) {
            _this.setState({
              isOpen: true
            });
          }

          break;

        case 34:
          // page down
          event.preventDefault();

          if (!_this.state.isOpen) {
            _this.setState({
              isOpen: true
            });
          }

          break;

        case 35:
          // end key
          if (event.shiftKey) {
            break;
          }

          event.preventDefault();

          if (!_this.state.isOpen) {
            _this.setState({
              isOpen: true
            });
          }

          break;

        case 36:
          // home key
          if (event.shiftKey) {
            break;
          }

          event.preventDefault();

          if (!_this.state.isOpen) {
            _this.setState({
              isOpen: true
            });
          }

          break;

        case 46:
          // delete
          if (!_this.state.inputValue && _this.props.deleteRemoves) {
            event.preventDefault();

            _this.popValue();
          }

          break;
      }
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "getOptionLabel", function (locale, _ref) {
      var option = _ref.option;
      return option.isCreatable ? "".concat(locale.select.create, " \u201C").concat(option[_this.props.labelKey], "\u201D") : option[_this.props.labelKey];
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "getValueLabel", function (_ref2) {
      var option = _ref2.option;
      return option[_this.props.labelKey];
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "handleActiveDescendantChange", function (id) {
      if (id) {
        _this.setState({
          activeDescendant: id
        });
      } else {
        _this.setState({
          activeDescendant: null
        });
      }
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "handleInputRef", function (input) {
      _this.input = input;

      if (_this.props.controlRef && typeof _this.props.controlRef === 'function') {
        _this.props.controlRef(input);
      }
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "selectValue", function (_ref3) {
      var item = _ref3.item;

      if (item.disabled) {
        return;
      }

      _this.justSelected = true; // NOTE: we add/set the value in a callback to make sure the
      // input value is empty to avoid styling issues in Chrome

      var updatedValue = _this.props.onSelectResetsInput ? '' : _this.state.inputValue;

      if (_this.props.multi) {
        _this.setState({
          inputValue: updatedValue,
          isOpen: !_this.props.closeOnSelect
        }, function () {
          var valueArray = _this.props.value;

          if (valueArray.some(function (i) {
            return i[_this.props.valueKey] === item[_this.props.valueKey];
          })) {
            _this.removeValue(item);
          } else {
            _this.addValue(item);
          }
        });
      } else {
        _this.focus();

        _this.setState({
          inputValue: updatedValue,
          isOpen: !_this.props.closeOnSelect,
          isFocused: true,
          isPseudoFocused: false
        }, function () {
          _this.setValue([item], item, STATE_CHANGE_TYPE$1.select);
        });
      }
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "addValue", function (item) {
      var valueArray = _toConsumableArray$9(_this.props.value);

      _this.setValue(valueArray.concat(item), item, STATE_CHANGE_TYPE$1.select);
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "backspaceValue", function () {
      var item = _this.popValue();

      if (!item) {
        return;
      }

      var valueLength = _this.props.value.length;
      var renderLabel = _this.props.getValueLabel || _this.getValueLabel;
      var labelForInput = renderLabel({
        option: item,
        index: valueLength - 1
      }); // label might not be a string, it might be a Node of another kind.

      if (!_this.props.backspaceClearsInputValue && typeof labelForInput === 'string') {
        var remainingInput = labelForInput.slice(0, -1);

        _this.setState({
          inputValue: remainingInput,
          isOpen: true
        });
      }
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "popValue", function () {
      var valueArray = _toConsumableArray$9(_this.props.value);

      var valueLength = valueArray.length;
      if (!valueLength) return;
      if (valueArray[valueLength - 1].clearableValue === false) return;
      var item = valueArray.pop();

      _this.setValue(valueArray, item, STATE_CHANGE_TYPE$1.remove);

      return item;
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "removeValue", function (item) {
      var valueArray = _toConsumableArray$9(_this.props.value);

      _this.setValue(valueArray.filter(function (i) {
        return i[_this.props.valueKey] !== item[_this.props.valueKey];
      }), item, STATE_CHANGE_TYPE$1.remove);

      _this.focus();
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "clearValue", function (event) {
      if (isClick(event) && !isLeftClick(event)) return;

      if (_this.props.value) {
        var resetValue = _this.props.value.filter(function (item) {
          return item.clearableValue === false;
        });

        _this.setValue(resetValue, null, STATE_CHANGE_TYPE$1.clear);
      }

      _this.setState({
        inputValue: '',
        isOpen: false
      });

      _this.focus();

      _this.focusAfterClear = true;
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "shouldShowPlaceholder", function () {
      return !(_this.state.inputValue || _this.props.value && _this.props.value.length);
    });

    _defineProperty$X(_assertThisInitialized$q(_this), "shouldShowValue", function () {
      return !_this.state.inputValue;
    });

    _this.options = normalizeOptions(props.options);
    return _this;
  }

  _createClass$r(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocus) {
        this.focus();
      }

      this.isItMounted = true;
      var controlRef = this.props.controlRef;

      if (controlRef && typeof controlRef !== 'function') {
        controlRef.current = {
          setDropdownOpen: this.handleDropdownOpen.bind(this),
          setInputValue: this.handleSetInputValue.bind(this),
          setInputFocus: this.handleSetInputFocus.bind(this),
          setInputBlur: this.handleSetInputBlur.bind(this),
          // `focus` & `blur` below are for backwards compatibility and may be removed. Use setInputFocus and setInputBlur instead.
          focus: this.handleSetInputFocus.bind(this),
          blur: this.handleSetInputBlur.bind(this)
        };
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (typeof document !== 'undefined') {
        if (prevState.isOpen !== this.state.isOpen) {
          if (this.state.isOpen) {
            this.props.onOpen && this.props.onOpen();
            document.addEventListener('touchstart', this.handleTouchOutside);
          } else {
            this.props.onClose && this.props.onClose();
            document.removeEventListener('touchstart', this.handleTouchOutside);
          }
        }

        if (!prevState.isFocused && this.state.isFocused) {
          document.addEventListener('click', this.handleClickOutside);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof document !== 'undefined') {
        document.removeEventListener('touchstart', this.handleTouchOutside);
        document.removeEventListener('click', this.handleClickOutside);
      }

      this.isItMounted = false;
    }
  }, {
    key: "focus",
    value: function focus() {
      if (!this.input) return;
      this.input.focus();
    }
  }, {
    key: "handleDropdownOpen",
    value: function handleDropdownOpen(nextOpenState) {
      this.setState({
        isOpen: nextOpenState
      });
    }
  }, {
    key: "handleSetInputValue",
    value: function handleSetInputValue(newInputValue) {
      this.setState({
        inputValue: newInputValue
      });
    }
  }, {
    key: "handleSetInputFocus",
    value: function handleSetInputFocus() {
      this.input.focus();
    }
  }, {
    key: "handleSetInputBlur",
    value: function handleSetInputBlur() {
      this.input.blur();
    } // Handle touch outside on mobile to dismiss menu, ensures that the
    // touch target is not within the anchor DOM node.

  }, {
    key: "closeMenu",
    value: function closeMenu() {
      if (this.props.onCloseResetsInput) {
        this.setState({
          inputValue: '',
          isOpen: false,
          isPseudoFocused: this.state.isFocused && !this.props.multi
        });
      } else {
        this.setState({
          isOpen: false,
          isPseudoFocused: this.state.isFocused && !this.props.multi
        });
      }
    }
  }, {
    key: "getValueArray",
    value:
    /**
     * Extends the value into an array from the given options
     */
    function getValueArray(value) {
      var _this2 = this;

      if (!Array.isArray(value)) {
        if (value === null || value === undefined) return [];
        value = [value];
      }

      return value.map(function (value) {
        return expandValue(value, _this2.props);
      });
    }
  }, {
    key: "setValue",
    value: function setValue(value, option, type) {
      if (this.props.onChange) {
        this.props.onChange({
          value: value,
          option: option,
          type: type
        });
      }
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      if (!this.props.isLoading) return;
      var sharedProps = this.getSharedProps();
      var _this$props$overrides = this.props.overrides,
          overrides = _this$props$overrides === void 0 ? {} : _this$props$overrides;

      var _getOverrides = getOverrides(overrides.LoadingIndicator, Spinner$2),
          _getOverrides2 = _slicedToArray$D(_getOverrides, 2),
          LoadingIndicator = _getOverrides2[0],
          loadingIndicatorProps = _getOverrides2[1];

      return /*#__PURE__*/React$2.createElement(LoadingIndicator, _extends$G({
        size: 16,
        overrides: {
          Svg: {
            style: getLoadingIconStyles
          }
        },
        $silenceV11DeprecationWarning: true
      }, sharedProps, loadingIndicatorProps));
    }
  }, {
    key: "renderValue",
    value: function renderValue(valueArray, isOpen, locale) {
      var _this3 = this;

      var _this$props$overrides2 = this.props.overrides,
          overrides = _this$props$overrides2 === void 0 ? {} : _this$props$overrides2;
      var sharedProps = this.getSharedProps();
      var renderLabel = this.props.getValueLabel || this.getValueLabel;
      var Value = this.props.valueComponent || Noop;

      if (!valueArray.length) {
        return null;
      }

      if (this.props.multi) {
        return valueArray.map(function (value, i) {
          var disabled = sharedProps.$disabled || value.clearableValue === false;
          return /*#__PURE__*/React$2.createElement(Value, _extends$G({
            value: value,
            key: "value-".concat(i, "-").concat(value[_this3.props.valueKey]),
            removeValue: function removeValue() {
              return _this3.removeValue(value);
            },
            disabled: disabled,
            overrides: {
              Tag: overrides.Tag,
              MultiValue: overrides.MultiValue
            }
          }, sharedProps, {
            $disabled: disabled
          }), renderLabel({
            option: value,
            index: i
          }));
        });
      } else if (this.shouldShowValue()) {
        return /*#__PURE__*/React$2.createElement(Value, _extends$G({
          value: valueArray[0][this.props.valueKey],
          disabled: this.props.disabled,
          overrides: {
            SingleValue: overrides.SingleValue
          }
        }, sharedProps), renderLabel({
          option: valueArray[0]
        }));
      }
    }
  }, {
    key: "renderInput",
    value: function renderInput(listboxId) {
      var _this4 = this;

      var _this$props$overrides3 = this.props.overrides,
          overrides = _this$props$overrides3 === void 0 ? {} : _this$props$overrides3;

      var _getOverrides3 = getOverrides(overrides.InputContainer, StyledInputContainer$1),
          _getOverrides4 = _slicedToArray$D(_getOverrides3, 2),
          InputContainer = _getOverrides4[0],
          inputContainerProps = _getOverrides4[1];

      var sharedProps = this.getSharedProps();
      var isOpen = this.state.isOpen;
      var selected = this.getValueArray(this.props.value).map(function (v) {
        return v[_this4.props.labelKey];
      }).join(', ');
      var selectedLabel = selected.length ? "Selected ".concat(selected, ". ") : '';
      var label = "".concat(selectedLabel).concat(this.props['aria-label'] || '');

      if (!this.props.searchable) {
        return /*#__PURE__*/React$2.createElement(InputContainer, _extends$G({
          role: "listbox",
          "aria-activedescendant": this.state.activeDescendant,
          "aria-expanded": isOpen,
          "aria-describedby": this.props['aria-describedby'],
          "aria-errormessage": this.props['aria-errormessage'],
          "aria-disabled": this.props.disabled,
          "aria-label": label,
          "aria-labelledby": this.props['aria-labelledby'],
          "aria-owns": this.state.isOpen ? listboxId : null,
          "aria-required": this.props.required || null,
          onFocus: this.handleInputFocus,
          tabIndex: 0
        }, sharedProps, inputContainerProps), /*#__PURE__*/React$2.createElement("input", _extends$G({
          "aria-hidden": true,
          id: this.props.id || null,
          ref: this.handleInputRef,
          style: {
            opacity: 0,
            width: 0,
            overflow: 'hidden',
            border: 'none',
            padding: 0
          },
          tabIndex: -1
        }, overrides.Input ? overrides.Input.props ? // $FlowExpectedError[not-an-object]
        overrides.Input.props : {} : {})));
      }

      return /*#__PURE__*/React$2.createElement(InputContainer, _extends$G({}, sharedProps, inputContainerProps), /*#__PURE__*/React$2.createElement(AutosizeInput, _extends$G({
        "aria-activedescendant": this.state.activeDescendant,
        "aria-autocomplete": "list",
        "aria-controls": this.state.isOpen ? listboxId : null,
        "aria-describedby": this.props['aria-describedby'],
        "aria-errormessage": this.props['aria-errormessage'],
        "aria-disabled": this.props.disabled || null,
        "aria-expanded": isOpen,
        "aria-haspopup": "listbox",
        "aria-label": label,
        "aria-labelledby": this.props['aria-labelledby'],
        "aria-required": this.props.required || null,
        disabled: this.props.disabled || null,
        id: this.props.id || null,
        inputRef: this.handleInputRef,
        onChange: this.handleInputChange,
        onFocus: this.handleInputFocus,
        overrides: {
          Input: overrides.Input
        },
        required: this.props.required && !this.props.value.length || null,
        role: "combobox",
        value: this.state.inputValue,
        tabIndex: 0
      }, sharedProps)));
    }
  }, {
    key: "renderClear",
    value: function renderClear() {
      var isValueEntered = Boolean(this.props.value && this.props.value.length || this.state.inputValue);

      if (!this.props.clearable || this.props.disabled || this.props.isLoading || !isValueEntered) {
        return;
      }

      var sharedProps = this.getSharedProps();
      var _this$props$overrides4 = this.props.overrides,
          overrides = _this$props$overrides4 === void 0 ? {} : _this$props$overrides4;

      var _getOverrides5 = getOverrides(overrides.ClearIcon, DeleteAlt$1),
          _getOverrides6 = _slicedToArray$D(_getOverrides5, 2),
          ClearIcon = _getOverrides6[0],
          clearIconProps = _getOverrides6[1];

      var ariaLabel = this.props.multi ? 'Clear all' : 'Clear value';
      return /*#__PURE__*/React$2.createElement(ClearIcon, _extends$G({
        title: ariaLabel,
        "aria-label": ariaLabel,
        onClick: this.clearValue,
        role: "button",
        overrides: {
          Svg: {
            component: StyledClearIcon,
            props: overrides.ClearIcon && overrides.ClearIcon.props ? overrides.ClearIcon.props : {},
            style: overrides.ClearIcon && overrides.ClearIcon.style ? overrides.ClearIcon.style : {}
          }
        }
      }, sharedProps, clearIconProps));
    }
  }, {
    key: "renderArrow",
    value: function renderArrow() {
      if (this.props.type !== TYPE$1.select) {
        return null;
      }

      var _this$props$overrides5 = this.props.overrides,
          overrides = _this$props$overrides5 === void 0 ? {} : _this$props$overrides5;

      var _getOverrides7 = getOverrides(overrides.SelectArrow, TriangleDown$1),
          _getOverrides8 = _slicedToArray$D(_getOverrides7, 2),
          SelectArrow = _getOverrides8[0],
          selectArrowProps = _getOverrides8[1];

      var sharedProps = this.getSharedProps();
      return /*#__PURE__*/React$2.createElement(SelectArrow, _extends$G({
        size: 16,
        title: 'open',
        overrides: {
          Svg: {
            component: StyledSelectArrow,
            props: overrides.SelectArrow && overrides.SelectArrow.props ? overrides.SelectArrow.props : {},
            style: overrides.SelectArrow && overrides.SelectArrow.style ? overrides.SelectArrow.style : {}
          }
        }
      }, sharedProps, selectArrowProps));
    }
  }, {
    key: "renderSearch",
    value: function renderSearch() {
      if (this.props.type !== TYPE$1.search) {
        return null;
      }

      var _this$props$overrides6 = this.props.overrides,
          overrides = _this$props$overrides6 === void 0 ? {} : _this$props$overrides6;

      var _getOverrides9 = getOverrides(overrides.SearchIconContainer, StyledSearchIconContainer),
          _getOverrides10 = _slicedToArray$D(_getOverrides9, 2),
          SearchIconContainer = _getOverrides10[0],
          searchIconContainerProps = _getOverrides10[1];

      var _getOverrides11 = getOverrides(overrides.SearchIcon, SearchIconComponent),
          _getOverrides12 = _slicedToArray$D(_getOverrides11, 2),
          SearchIcon = _getOverrides12[0],
          searchIconProps = _getOverrides12[1];

      var sharedProps = this.getSharedProps();
      return (
        /*#__PURE__*/
        // TODO(v11): remove searchIconProps from SearchIconContainer
        React$2.createElement(SearchIconContainer, _extends$G({}, sharedProps, searchIconProps, searchIconContainerProps), /*#__PURE__*/React$2.createElement(SearchIcon, _extends$G({
          size: 16,
          title: 'search'
        }, searchIconProps)))
      );
    }
  }, {
    key: "filterOptions",
    value: function filterOptions(excludeOptions) {
      var _this5 = this;

      var filterValue = this.state.inputValue.trim(); // apply filter function

      if (this.props.filterOptions) {
        this.options = this.props.filterOptions(this.options, filterValue, excludeOptions, {
          valueKey: this.props.valueKey,
          labelKey: this.props.labelKey
        });
      } // can user create a new option + there's no exact match already


      var filterDoesNotMatchOption = this.props.ignoreCase ? function (opt) {
        return opt[_this5.props.labelKey].toLowerCase() !== filterValue.toLowerCase().trim();
      } : function (opt) {
        return opt[_this5.props.labelKey] !== filterValue.trim();
      };

      if (filterValue && this.props.creatable && this.options.concat(this.props.value).every(filterDoesNotMatchOption)) {
        var _this$options$push;

        // $FlowFixMe - this.options is typed as a read-only array
        this.options.push((_this$options$push = {
          id: filterValue
        }, _defineProperty$X(_this$options$push, this.props.labelKey, filterValue), _defineProperty$X(_this$options$push, this.props.valueKey, filterValue), _defineProperty$X(_this$options$push, "isCreatable", true), _this$options$push));
      }

      return this.options;
    }
  }, {
    key: "getSharedProps",
    value: function getSharedProps() {
      var _this$props = this.props,
          clearable = _this$props.clearable,
          creatable = _this$props.creatable,
          disabled = _this$props.disabled,
          error = _this$props.error,
          positive = _this$props.positive,
          isLoading = _this$props.isLoading,
          multi = _this$props.multi,
          required = _this$props.required,
          size = _this$props.size,
          searchable = _this$props.searchable,
          type = _this$props.type,
          value = _this$props.value;
      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          isFocused = _this$state.isFocused,
          isPseudoFocused = _this$state.isPseudoFocused;
      return {
        $clearable: clearable,
        $creatable: creatable,
        $disabled: disabled,
        $error: error,
        $positive: positive,
        $isFocused: isFocused,
        $isLoading: isLoading,
        $isOpen: isOpen,
        $isPseudoFocused: isPseudoFocused,
        $multi: multi,
        $required: required,
        $searchable: searchable,
        $size: size,
        $type: type,
        $isEmpty: !this.getValueArray(value).length
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      this.options = normalizeOptions(this.props.options);
      var _this$props2 = this.props,
          _this$props2$override = _this$props2.overrides,
          overrides = _this$props2$override === void 0 ? {} : _this$props2$override,
          type = _this$props2.type,
          multi = _this$props2.multi,
          noResultsMsg = _this$props2.noResultsMsg,
          value = _this$props2.value,
          filterOutSelected = _this$props2.filterOutSelected;

      if (process.env.NODE_ENV !== "production") {
        // value may be nullish, only warn if value is defined
        if (value && !Array.isArray(value)) {
          console.warn('The Select component expects an array as the value prop. For more information, please visit the docs at https://baseweb.design/components/select/');
        }
      }

      var _getOverrides13 = getOverrides(overrides.Root, StyledRoot$f),
          _getOverrides14 = _slicedToArray$D(_getOverrides13, 2),
          Root = _getOverrides14[0],
          rootProps = _getOverrides14[1];

      var _getOverrides15 = getOverrides(overrides.ControlContainer, StyledControlContainer$2),
          _getOverrides16 = _slicedToArray$D(_getOverrides15, 2),
          ControlContainer = _getOverrides16[0],
          controlContainerProps = _getOverrides16[1];

      var _getOverrides17 = getOverrides(overrides.ValueContainer, StyledValueContainer$1),
          _getOverrides18 = _slicedToArray$D(_getOverrides17, 2),
          ValueContainer = _getOverrides18[0],
          valueContainerProps = _getOverrides18[1];

      var _getOverrides19 = getOverrides(overrides.IconsContainer, StyledIconsContainer),
          _getOverrides20 = _slicedToArray$D(_getOverrides19, 2),
          IconsContainer = _getOverrides20[0],
          iconsContainerProps = _getOverrides20[1];

      var _getOverrides21 = getOverrides(overrides.Popover, Popover$1),
          _getOverrides22 = _slicedToArray$D(_getOverrides21, 2),
          PopoverOverride = _getOverrides22[0],
          popoverProps = _getOverrides22[1];

      var _getOverrides23 = getOverrides(overrides.Placeholder, StyledPlaceholder),
          _getOverrides24 = _slicedToArray$D(_getOverrides23, 2),
          Placeholder = _getOverrides24[0],
          placeholderProps = _getOverrides24[1];

      var sharedProps = this.getSharedProps();
      var valueArray = this.getValueArray(value);
      var options = this.filterOptions(multi && filterOutSelected ? valueArray : null);
      var isOpen = this.state.isOpen;
      sharedProps.$isOpen = isOpen;

      if (process.env.NODE_ENV !== "production") {
        if (this.props.error && this.props.positive) {
          // eslint-disable-next-line no-console
          console.warn("[Select] `error` and `positive` are both set to `true`. `error` will take precedence but this may not be what you want.");
        }
      }

      return /*#__PURE__*/React$2.createElement(UIDConsumer, null, function (listboxId) {
        return /*#__PURE__*/React$2.createElement(LocaleContext.Consumer, null, function (locale) {
          return /*#__PURE__*/React$2.createElement(PopoverOverride // Popover does not provide ability to forward refs through, and if we were to simply
          // apply the ref to the Root component below it would be overwritten before the popover
          // renders it. Using this strategy, we will get a ref to the popover, then reuse its
          // anchorRef so we can check if clicks are on the select component or not.
          // flowlint-next-line unclear-type:off
          , _extends$G({
            innerRef: function innerRef(ref) {
              if (!ref) return;
              _this6.anchor = ref.anchorRef;
            },
            autoFocus: false,
            focusLock: false,
            mountNode: _this6.props.mountNode,
            onEsc: function onEsc() {
              return _this6.closeMenu();
            },
            isOpen: isOpen,
            popoverMargin: 0,
            content: function content() {
              var dropdownProps = {
                error: _this6.props.error,
                positive: _this6.props.positive,
                getOptionLabel: _this6.props.getOptionLabel || _this6.getOptionLabel.bind(_this6, locale),
                id: listboxId,
                isLoading: _this6.props.isLoading,
                labelKey: _this6.props.labelKey,
                maxDropdownHeight: _this6.props.maxDropdownHeight,
                multi: multi,
                noResultsMsg: noResultsMsg,
                onActiveDescendantChange: _this6.handleActiveDescendantChange,
                onItemSelect: _this6.selectValue,
                options: options,
                overrides: overrides,
                required: _this6.props.required,
                searchable: _this6.props.searchable,
                size: _this6.props.size,
                type: type,
                value: valueArray,
                valueKey: _this6.props.valueKey,
                width: _this6.anchor.current ? _this6.anchor.current.clientWidth : null,
                keyboardControlNode: _this6.anchor
              };
              return /*#__PURE__*/React$2.createElement(SelectDropdown, _extends$G({
                innerRef: _this6.dropdown
              }, dropdownProps));
            },
            placement: PLACEMENT$2.bottom
          }, popoverProps), /*#__PURE__*/React$2.createElement(Root, _extends$G({
            onBlur: _this6.handleBlur,
            "data-baseweb": "select"
          }, sharedProps, rootProps), /*#__PURE__*/React$2.createElement(ControlContainer, _extends$G({
            onKeyDown: _this6.handleKeyDown,
            onClick: _this6.handleClick,
            onTouchEnd: _this6.handleTouchEnd,
            onTouchMove: _this6.handleTouchMove,
            onTouchStart: _this6.handleTouchStart
          }, sharedProps, controlContainerProps), type === TYPE$1.search ? _this6.renderSearch() : null, /*#__PURE__*/React$2.createElement(ValueContainer, _extends$G({}, sharedProps, valueContainerProps), _this6.renderValue(valueArray, isOpen, locale), _this6.renderInput(listboxId), _this6.shouldShowPlaceholder() ? /*#__PURE__*/React$2.createElement(Placeholder, _extends$G({}, sharedProps, placeholderProps), typeof _this6.props.placeholder !== 'undefined' ? _this6.props.placeholder : locale.select.placeholder) : null), /*#__PURE__*/React$2.createElement(IconsContainer, _extends$G({}, sharedProps, iconsContainerProps), _this6.renderLoading(), _this6.renderClear(), type === TYPE$1.select ? _this6.renderArrow() : null))));
        });
      });
    }
  }]);

  return Select;
}(React$2.Component);

_defineProperty$X(Select$2, "defaultProps", defaultProps$4);

var SelectComponent = Select$2;

function _extends$F() { _extends$F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

function _slicedToArray$C(arr, i) { return _arrayWithHoles$C(arr) || _iterableToArrayLimit$C(arr, i) || _unsupportedIterableToArray$E(arr, i) || _nonIterableRest$C(); }

function _nonIterableRest$C() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$E(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$E(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$E(o, minLen); }

function _arrayLikeToArray$E(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$C(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$C(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties$j(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$i(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$i(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function MultiValue(props) {
  var _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      removeValue = props.removeValue,
      restProps = _objectWithoutProperties$j(props, ["overrides", "removeValue"]); // todo(v11): remove the MultiValue override in favor of Tag


  var _getOverrides = getOverrides(overrides.Tag || overrides.MultiValue, Tag$2),
      _getOverrides2 = _slicedToArray$C(_getOverrides, 2),
      MultiValue = _getOverrides2[0],
      tagProps = _getOverrides2[1];

  return /*#__PURE__*/React$2.createElement(MultiValue, _extends$F({
    variant: VARIANT.solid,
    overrides: {
      Root: {
        style: function style(_ref) {
          var sizing = _ref.$theme.sizing;
          return {
            marginRight: sizing.scale0,
            marginBottom: sizing.scale0,
            marginLeft: sizing.scale0,
            marginTop: sizing.scale0
          };
        }
      }
    },
    onActionClick: removeValue
  }, restProps, tagProps), props.children);
}

function _extends$E() { _extends$E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }

function _slicedToArray$B(arr, i) { return _arrayWithHoles$B(arr) || _iterableToArrayLimit$B(arr, i) || _unsupportedIterableToArray$D(arr, i) || _nonIterableRest$B(); }

function _nonIterableRest$B() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$D(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$D(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$D(o, minLen); }

function _arrayLikeToArray$D(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$B(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$B(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties$i(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$h(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$h(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Value(props) {
  var _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties$i(props, ["overrides"]);

  var _getOverrides = getOverrides(overrides.SingleValue, StyledSingleValue),
      _getOverrides2 = _slicedToArray$B(_getOverrides, 2),
      SingleValue = _getOverrides2[0],
      singleValueProps = _getOverrides2[1];

  return /*#__PURE__*/React$2.createElement(SingleValue, _extends$E({
    "aria-selected": "true"
  }, restProps, singleValueProps), props.children);
}

function _extends$D() { _extends$D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

function Select$1(props) {
  return /*#__PURE__*/React$2.createElement(SelectComponent, _extends$D({}, props, {
    valueComponent: props.multi ? MultiValue : Value
  }));
}

function _extends$C() { _extends$C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

function MultiSelect(props) {
  return /*#__PURE__*/React$2.createElement(SelectComponent, _extends$C({}, props, {
    multi: false,
    valueComponent: Value
  }));
}

function _typeof$q(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$q = function _typeof(obj) { return typeof obj; }; } else { _typeof$q = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$q(obj); }

function _objectWithoutProperties$h(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$g(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$g(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys$E(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$E(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$E(Object(source), true).forEach(function (key) { _defineProperty$W(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$E(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck$r(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$p(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$q(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$p(Constructor.prototype, protoProps); if (staticProps) _defineProperties$p(Constructor, staticProps); return Constructor; }

function _inherits$q(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$p(subClass, superClass); }

function _setPrototypeOf$p(o, p) { _setPrototypeOf$p = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$p(o, p); }

function _createSuper$p(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$p(); return function _createSuperInternal() { var Super = _getPrototypeOf$p(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$p(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$q(this, result); }; }

function _possibleConstructorReturn$q(self, call) { if (call && (_typeof$q(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$p(self); }

function _assertThisInitialized$p(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$p() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$p(o) { _getPrototypeOf$p = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$p(o); }

function _defineProperty$W(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultStateReducer$2 = function defaultStateReducer(type, nextState) {
  return nextState;
};

var StatefulSelectContainer = /*#__PURE__*/function (_React$Component) {
  _inherits$q(StatefulSelectContainer, _React$Component);

  var _super = _createSuper$p(StatefulSelectContainer);

  function StatefulSelectContainer() {
    var _this;

    _classCallCheck$r(this, StatefulSelectContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$W(_assertThisInitialized$p(_this), "state", _objectSpread$E({}, _this.props.initialState));

    _defineProperty$W(_assertThisInitialized$p(_this), "onChange", function (params) {
      _this.internalSetState(params);

      _this.props.onChange(params);
    });

    _defineProperty$W(_assertThisInitialized$p(_this), "internalSetState", function (params) {
      var stateReducer = _this.props.stateReducer;
      var nextState = {
        value: params.value
      };

      _this.setState(stateReducer(params.type, nextState, _this.state));
    });

    return _this;
  }

  _createClass$q(StatefulSelectContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children;
          _this$props.initialState;
          _this$props.stateReducer;
          var restProps = _objectWithoutProperties$h(_this$props, ["children", "initialState", "stateReducer"]); // $FlowFixMe


      return children(_objectSpread$E(_objectSpread$E(_objectSpread$E({}, restProps), this.state), {}, {
        onChange: this.onChange
      }));
    }
  }]);

  return StatefulSelectContainer;
}(React$2.Component);

_defineProperty$W(StatefulSelectContainer, "defaultProps", {
  initialState: {
    value: []
  },
  onChange: function onChange() {},
  overrides: {},
  stateReducer: defaultStateReducer$2
});

var StatefulSelectContainer$1 = StatefulSelectContainer;

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the seconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */

function addSeconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * 1000);
}

var MILLISECONDS_IN_MINUTE$1 = 60000;
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */

function addMinutes(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE$1);
}

var MILLISECONDS_IN_HOUR$1 = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */

function addHours(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR$1);
}

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */

function addWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var days = amount * 7;
  return addDays(dirtyDate, days);
}

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}

/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */

function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}

/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */

function compareAsc(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */

function differenceInYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight)); // Set both dates to a valid leap year for accurate comparison when dealing
  // with leap days

  dateLeft.setFullYear(1584);
  dateRight.setFullYear(1584); // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value

  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign;
  var result = sign * (difference - Number(isLastYearNotFull)); // Prevent negative zero

  return result === 0 ? 0 : result;
}

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */

function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */

function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */

function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */

function isLastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return endOfDay(date).getTime() === endOfMonth(date).getTime();
}

/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */

function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
  var result; // Check for the difference of less than month

  if (difference < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      // This will check if the date is end of Feb and assign a higher end of month date
      // to compare it with Jan
      dateLeft.setDate(30);
    }

    dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
    // If so, result must be decreased by 1 in absolute value

    var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign; // Check for cases of one full calendar month

    if (isLastDayOfMonth(toDate(dirtyDateLeft)) && difference === 1 && compareAsc(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }

    result = sign * (difference - Number(isLastMonthNotFull));
  } // Prevent negative zero


  return result === 0 ? 0 : result;
}

var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function (value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  } // Math.trunc is not supported by IE

};
var defaultRoundingMethod = 'trunc';
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}

/**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of full quarters
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */

function differenceInQuarters(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMonths(dateLeft, dateRight) / 3;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

var MILLISECONDS_IN_DAY$1 = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */

function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY$1);
}

// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.

function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full days according to the local timezone
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
//=> 92
 */


function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value

  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastDayNotFull); // Prevent negative zero

  return result === 0 ? 0 : result;
}

/**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of full weeks
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */

function differenceInWeeks(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInDays(dateLeft, dateRight) / 7;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInMinute = 60000;
/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInHour = 3600000;

/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */

function differenceInMilliseconds(dateLeft, dateRight) {
  requiredArgs(2, arguments);
  return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}

/**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of hours
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */

function differenceInHours(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInHour;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of minutes
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */

function differenceInMinutes(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInMinute;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of seconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */

function differenceInSeconds(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / 1000;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `eachDay` to `eachDayOfInterval`.
 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
 *
 *   ```
 *   2.1.3
 *   time interval
 *   part of the time axis limited by two instants
 *   ```
 *
 *   Also, this function now accepts an object with `start` and `end` properties
 *   instead of two arguments as an interval.
 *   This function now throws `RangeError` if the start of the interval is after its end
 *   or if any date in the interval is `Invalid Date`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   eachDay(new Date(2014, 0, 10), new Date(2014, 0, 20))
 *
 *   // v2.0.0 onward
 *
 *   eachDayOfInterval(
 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) }
 *   )
 *   ```
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.step` must be a number greater than 1
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */

function eachDayOfInterval(dirtyInterval, options) {
  requiredArgs(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = toDate(interval.start);
  var endDate = toDate(interval.end);
  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  var dates = [];
  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  var step = options && 'step' in options ? Number(options.step) : 1;
  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');

  while (currentDate.getTime() <= endTime) {
    dates.push(toDate(currentDate));
    currentDate.setDate(currentDate.getDate() + step);
    currentDate.setHours(0, 0, 0, 0);
  }

  return dates;
}

/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */

function endOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);

  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

var formatDistance$1 = formatDistance;

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

var formatRelative$1 = formatRelative;

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$1 = match;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = locale;

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters$2 = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var lightFormatters = formatters$2;

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return lightFormatters.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

var formatters$1 = formatters;

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters$1 = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$2 = longFormatters$1;

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || defaultLocale;
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp$1).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$2[firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp$1).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString$1(substring);
    }

    var formatter = formatters$1[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString$1(input) {
  return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'");
}

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */

function getHours(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var hours = date.getHours();
  return hours;
}

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */

function getSeconds(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */

function getYear(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getFullYear();
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */

function isEqual$1(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyLeftDate);
  var dateRight = toDate(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 * 
 * @example
 * // Are 4 September and 4 October in the same day?
 * var result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 * 
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */

function isSameYear(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */

function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an hour
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */

function startOfHour(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setMinutes(0, 0, 0);
  return date;
}

/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same hour (and same day)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 * 
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */

function isSameHour(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft);
  var dateRightStartOfHour = startOfHour(dirtyDateRight);
  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}

function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
  requiredArgs(2, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_SECOND = 1000;
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function parseNumericPattern(pattern, string, valueCallback) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  }

  var value = parseInt(matchResult[0], 10);
  return {
    value: valueCallback ? valueCallback(value) : value,
    rest: string.slice(matchResult[0].length)
  };
}

function parseTimezonePattern(pattern, string) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: string.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
    rest: string.slice(matchResult[0].length)
  };
}

function parseAnyDigitsSigned(string, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
}

function parseNDigits(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
  }
}

function parseNDigitsSigned(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
  }
}

function dayPeriodEnumToHours(enumValue) {
  switch (enumValue) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation

function isLeapYearIndex$1(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */


var parsers = {
  // Era
  G: {
    priority: 140,
    parse: function (string, token, match, _options) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
        // A, B

        case 'GGGGG':
          return match.era(string, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return match.era(string, {
            width: 'wide'
          }) || match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
      }
    },
    set: function (date, flags, value, _options) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['R', 'u', 't', 'T']
  },
  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return parseNDigits(4, string, valueCallback);

        case 'yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, _options) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return parseNDigits(4, string, valueCallback);

        case 'Yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, options) {
      var currentYear = getUTCWeekYear(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'R') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (_date, _flags, value, _options) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    },
    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Extended year
  u: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'u') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Quarter
  Q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Month
  M: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'MM':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'MMM':
          return match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone month
  L: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'LL':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'LLL':
          return match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Local week of year
  w: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, string);

        case 'wo':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week of year
  I: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, string);

        case 'Io':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Day of the month
  d: {
    priority: 90,
    subPriority: 1,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, string);

        case 'do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      var month = date.getUTCMonth();

      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Day of year
  D: {
    priority: 90,
    subPriority: 1,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, string);

        case 'Do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);

      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
  },
  // Day of week
  E: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
  },
  // Local day of week
  e: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'eo':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'eee':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
  },
  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'co':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'ccc':
          return match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
  },
  // ISO day of week
  i: {
    priority: 90,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        if (value === 0) {
          return 7;
        }

        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, string);
        // 2nd

        case 'io':
          return match.ordinalNumber(string, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // T

        case 'iiiii':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tu

        case 'iiiiii':
          return match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tuesday

        case 'iiii':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 7;
    },
    set: function (date, _flags, value, options) {
      date = setUTCISODay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
  },
  // AM or PM
  a: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaaa':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['b', 'B', 'H', 'k', 't', 'T']
  },
  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbbb':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'B', 'H', 'k', 't', 'T']
  },
  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBBB':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 't', 'T']
  },
  // Hour [1-12]
  h: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, string);

        case 'ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 12;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
  },
  // Hour [0-23]
  H: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, string);

        case 'Ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 23;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
  },
  // Hour [0-11]
  K: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, string);

        case 'Ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['h', 'H', 'k', 't', 'T']
  },
  // Hour [1-24]
  k: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, string);

        case 'ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 24;
    },
    set: function (date, _flags, value, _options) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
  },
  // Minute
  m: {
    priority: 60,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, string);

        case 'mo':
          return match.ordinalNumber(string, {
            unit: 'minute'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Second
  s: {
    priority: 50,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, string);

        case 'so':
          return match.ordinalNumber(string, {
            unit: 'second'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCSeconds(value, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Fraction of second
  S: {
    priority: 30,
    parse: function (string, token, _match, _options) {
      var valueCallback = function (value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };

      return parseNDigits(token.length, string, valueCallback);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMilliseconds(value);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'x']
  },
  // Timezone (ISO-8601)
  x: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'X']
  },
  // Seconds timestamp
  t: {
    priority: 40,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  },
  // Milliseconds timestamp
  T: {
    priority: 20,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  }
};
var parsers$1 = parsers;

var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Old `parse` was renamed to `toDate`.
 *   Now `parse` is a new function which parses a string using a provided format.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward (toDate no longer accepts a string)
 *   toDate(1392098430000) // Unix to timestamp
 *   toDate(new Date(2014, 1, 11, 11, 30, 30)) // Cloning the date
 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
 *   ```
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = dirtyOptions || {};
  var locale = options.locale || defaultLocale;

  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }

  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return toDate(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  }; // If timezone isn't specified, it will be set to the system timezone

  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    subPriority: -1,
    set: dateToSystemTimezone,
    index: 0
  }];
  var i;
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$2[firstCharacter];
      return longFormatter(substring, locale.formatLong, subFnOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];

  for (i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(token)) {
      throwProtectedError(token, formatString, dirtyDateString);
    }

    if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(token)) {
      throwProtectedError(token, formatString, dirtyDateString);
    }

    var firstCharacter = token[0];
    var parser = parsers$1[firstCharacter];

    if (parser) {
      var incompatibleTokens = parser.incompatibleTokens;

      if (Array.isArray(incompatibleTokens)) {
        var incompatibleToken = void 0;

        for (var _i = 0; _i < usedTokens.length; _i++) {
          var usedToken = usedTokens[_i].token;

          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
            incompatibleToken = usedTokens[_i];
            break;
          }
        }

        if (incompatibleToken) {
          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
        }
      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
      }

      usedTokens.push({
        token: firstCharacter,
        fullToken: token
      });
      var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);

      if (!parseResult) {
        return new Date(NaN);
      }

      setters.push({
        priority: parser.priority,
        subPriority: parser.subPriority || 0,
        set: parser.set,
        validate: parser.validate,
        value: parseResult.value,
        index: setters.length
      });
      dateString = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
      } // Replace two single quote characters with one single quote character


      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString(token);
      } // Cut token from string, or, if string doesn't match the token, return Invalid Date


      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return new Date(NaN);
      }
    }
  } // Check if the remaining input contains something other than whitespace


  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = toDate(dirtyReferenceDate);

  if (isNaN(date)) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37


  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};

  for (i = 0; i < uniquePrioritySetters.length; i++) {
    var setter = uniquePrioritySetters[i];

    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
      return new Date(NaN);
    }

    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)

    if (result[0]) {
      utcDate = result[0];
      assign(flags, result[1]); // Result is date
    } else {
      utcDate = result;
    }
  }

  return utcDate;
}

function dateToSystemTimezone(date, flags) {
  if (flags.timestampIsSet) {
    return date;
  }

  var convertedDate = new Date(0);
  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
  return convertedDate;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */

function setHours(dirtyDate, dirtyHours) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var hours = toInteger(dirtyHours);
  date.setHours(hours);
  return date;
}

/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */

function setMinutes(dirtyDate, dirtyMinutes) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var minutes = toInteger(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */

function getDaysInMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */

function setMonth(dirtyDate, dirtyMonth) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var month = toInteger(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */

function getDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var day = date.getDay();
  return day;
}

/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */

function setSeconds(dirtyDate, dirtySeconds) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var seconds = toInteger(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */

function setYear(dirtyDate, dirtyYear) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var year = toInteger(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  date.setFullYear(year);
  return date;
}

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */

function startOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var cleanDate = toDate(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The previous `parse` implementation was renamed to `parseISO`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   parseISO('2016-01-01')
 *   ```
 *
 * - `parseISO` now validates separate date and time values in ISO-8601 strings
 *   and returns `Invalid Date` if the date is invalid.
 *
 *   ```javascript
 *   parseISO('2018-13-32')
 *   //=> Invalid Date
 *   ```
 *
 * - `parseISO` now doesn't fall back to `new Date` constructor
 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? 2 : toInteger(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time)) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }

  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both

  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

/**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time with local time zone, or both.
 * @returns {String} the formatted date string (in local time zone)
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
 * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */

function formatISO(date, options) {
  requiredArgs(1, arguments);
  var originalDate = toDate(date);

  if (isNaN(originalDate.getTime())) {
    throw new RangeError('Invalid time value');
  }

  var format = !(options !== null && options !== void 0 && options.format) ? 'extended' : String(options.format);
  var representation = !(options !== null && options !== void 0 && options.representation) ? 'complete' : String(options.representation);

  if (format !== 'extended' && format !== 'basic') {
    throw new RangeError("format must be 'extended' or 'basic'");
  }

  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  }

  var result = '';
  var tzOffset = '';
  var dateDelimiter = format === 'extended' ? '-' : '';
  var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'

  if (representation !== 'time') {
    var day = addLeadingZeros(originalDate.getDate(), 2);
    var month = addLeadingZeros(originalDate.getMonth() + 1, 2);
    var year = addLeadingZeros(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.

    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
  } // Representation is either 'time' or 'complete'


  if (representation !== 'date') {
    // Add the timezone.
    var offset = originalDate.getTimezoneOffset();

    if (offset !== 0) {
      var absoluteOffset = Math.abs(offset);
      var hourOffset = addLeadingZeros(Math.floor(absoluteOffset / 60), 2);
      var minuteOffset = addLeadingZeros(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.

      var sign = offset < 0 ? '+' : '-';
      tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
    } else {
      tzOffset = 'Z';
    }

    var hour = addLeadingZeros(originalDate.getHours(), 2);
    var minute = addLeadingZeros(originalDate.getMinutes(), 2);
    var second = addLeadingZeros(originalDate.getSeconds(), 2); // If there's also date, separate it with time with 'T'

    var separator = result === '' ? '' : 'T'; // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.

    var time = [hour, minute, second].join(timeDelimiter); // HHmmss or HH:mm:ss.

    result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
  }

  return result;
}

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `isWithinRange` to `isWithinInterval`.
 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
 *
 *   ```
 *   2.1.3
 *   time interval
 *   part of the time axis limited by two instants
 *   ```
 *
 *   Also, this function now accepts an object with `start` and `end` properties
 *   instead of two arguments as an interval.
 *   This function now throws `RangeError` if the start of the interval is after its end
 *   or if any date in the interval is `Invalid Date`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   isWithinRange(
 *     new Date(2014, 0, 3),
 *     new Date(2014, 0, 1), new Date(2014, 0, 7)
 *   )
 *
 *   // v2.0.0 onward
 *
 *   isWithinInterval(
 *     new Date(2014, 0, 3),
 *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
 *   )
 *   ```
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */
function isWithinInterval(dirtyDate, interval) {
  requiredArgs(2, arguments);
  var time = toDate(dirtyDate).getTime();
  var startTime = toDate(interval.start).getTime();
  var endTime = toDate(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  return time >= startTime && time <= endTime;
}

var longFormatters_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var _default = longFormatters;
exports.default = _default;
module.exports = exports.default;
});

var longFormatters = unwrapExports(longFormatters_1);

var defaultFormats = {
    dayOfMonth: "d",
    fullDate: "PP",
    fullDateWithWeekday: "PPPP",
    fullDateTime: "PP p",
    fullDateTime12h: "PP hh:mm aaa",
    fullDateTime24h: "PP HH:mm",
    fullTime: "p",
    fullTime12h: "hh:mm aaa",
    fullTime24h: "HH:mm",
    hours12h: "hh",
    hours24h: "HH",
    keyboardDate: "P",
    keyboardDateTime: "P p",
    keyboardDateTime12h: "P hh:mm aaa",
    keyboardDateTime24h: "P HH:mm",
    minutes: "mm",
    month: "LLLL",
    monthAndDate: "MMMM d",
    monthAndYear: "LLLL yyyy",
    monthShort: "MMM",
    weekday: "EEEE",
    weekdayShort: "EEE",
    normalDate: "d MMMM",
    normalDateWithWeekday: "EEE, MMM d",
    seconds: "ss",
    shortDate: "MMM d",
    year: "yyyy",
};
var DateFnsUtils = /** @class */ (function () {
    function DateFnsUtils(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, locale = _b.locale, formats = _b.formats;
        this.lib = "date-fns";
        // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
        // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
        this.is12HourCycleInCurrentLocale = function () {
            if (_this.locale) {
                return /a/.test(_this.locale.formatLong.time());
            }
            // By default date-fns is using en-US locale with am/pm enabled
            return true;
        };
        this.getFormatHelperText = function (format) {
            // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
            var longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
            var locale = _this.locale || defaultLocale;
            return format
                .match(longFormatRegexp)
                .map(function (token) {
                var firstCharacter = token[0];
                if (firstCharacter === "p" || firstCharacter === "P") {
                    var longFormatter = longFormatters[firstCharacter];
                    return longFormatter(token, locale.formatLong, {});
                }
                return token;
            })
                .join("")
                .replace(/(aaa|aa|a)/g, "(a|p)m")
                .toLocaleLowerCase();
        };
        this.parseISO = function (isoString) {
            return parseISO(isoString);
        };
        this.toISO = function (value) {
            return formatISO(value, { format: "extended" });
        };
        this.getCurrentLocaleCode = function () {
            var _a;
            return ((_a = _this.locale) === null || _a === void 0 ? void 0 : _a.code) || "en-US";
        };
        this.addSeconds = function (value, count) {
            return addSeconds(value, count);
        };
        this.addMinutes = function (value, count) {
            return addMinutes(value, count);
        };
        this.addHours = function (value, count) {
            return addHours(value, count);
        };
        this.addDays = function (value, count) {
            return addDays(value, count);
        };
        this.addWeeks = function (value, count) {
            return addWeeks(value, count);
        };
        this.addMonths = function (value, count) {
            return addMonths(value, count);
        };
        this.isValid = function (value) {
            return isValid(_this.date(value));
        };
        this.getDiff = function (value, comparing, unit) {
            switch (unit) {
                case "years":
                    return differenceInYears(value, _this.date(comparing));
                case "quarters":
                    return differenceInQuarters(value, _this.date(comparing));
                case "months":
                    return differenceInMonths(value, _this.date(comparing));
                case "weeks":
                    return differenceInWeeks(value, _this.date(comparing));
                case "days":
                    return differenceInDays(value, _this.date(comparing));
                case "hours":
                    return differenceInHours(value, _this.date(comparing));
                case "minutes":
                    return differenceInMinutes(value, _this.date(comparing));
                case "seconds":
                    return differenceInSeconds(value, _this.date(comparing));
                default: {
                    return differenceInMilliseconds(value, _this.date(comparing));
                }
            }
        };
        this.isAfter = function (value, comparing) {
            return isAfter(value, comparing);
        };
        this.isBefore = function (value, comparing) {
            return isBefore(value, comparing);
        };
        this.startOfDay = function (value) {
            return startOfDay(value);
        };
        this.endOfDay = function (value) {
            return endOfDay(value);
        };
        this.getHours = function (value) {
            return getHours(value);
        };
        this.setHours = function (value, count) {
            return setHours(value, count);
        };
        this.setMinutes = function (value, count) {
            return setMinutes(value, count);
        };
        this.getSeconds = function (value) {
            return getSeconds(value);
        };
        this.setSeconds = function (value, count) {
            return setSeconds(value, count);
        };
        this.isSameDay = function (value, comparing) {
            return isSameDay(value, comparing);
        };
        this.isSameMonth = function (value, comparing) {
            return isSameMonth(value, comparing);
        };
        this.isSameYear = function (value, comparing) {
            return isSameYear(value, comparing);
        };
        this.isSameHour = function (value, comparing) {
            return isSameHour(value, comparing);
        };
        this.startOfMonth = function (value) {
            return startOfMonth(value);
        };
        this.endOfMonth = function (value) {
            return endOfMonth(value);
        };
        this.startOfWeek = function (value) {
            return startOfWeek(value, { locale: _this.locale });
        };
        this.endOfWeek = function (value) {
            return endOfWeek(value, { locale: _this.locale });
        };
        this.getYear = function (value) {
            return getYear(value);
        };
        this.setYear = function (value, count) {
            return setYear(value, count);
        };
        this.date = function (value) {
            if (typeof value === "undefined") {
                return new Date();
            }
            if (value === null) {
                return null;
            }
            return new Date(value);
        };
        this.toJsDate = function (value) {
            return value;
        };
        this.parse = function (value, formatString) {
            if (value === "") {
                return null;
            }
            return parse(value, formatString, new Date(), { locale: _this.locale });
        };
        this.format = function (date, formatKey) {
            return _this.formatByString(date, _this.formats[formatKey]);
        };
        this.formatByString = function (date, formatString) {
            return format(date, formatString, { locale: _this.locale });
        };
        this.isEqual = function (date, comparing) {
            if (date === null && comparing === null) {
                return true;
            }
            return isEqual$1(date, comparing);
        };
        this.isNull = function (date) {
            return date === null;
        };
        this.isAfterDay = function (date, value) {
            return isAfter(date, endOfDay(value));
        };
        this.isBeforeDay = function (date, value) {
            return isBefore(date, startOfDay(value));
        };
        this.isBeforeYear = function (date, value) {
            return isBefore(date, startOfYear(value));
        };
        this.isAfterYear = function (date, value) {
            return isAfter(date, endOfYear(value));
        };
        this.isWithinRange = function (date, _a) {
            var start = _a[0], end = _a[1];
            return isWithinInterval(date, { start: start, end: end });
        };
        this.formatNumber = function (numberToFormat) {
            return numberToFormat;
        };
        this.getMinutes = function (date) {
            return date.getMinutes();
        };
        this.getMonth = function (date) {
            return date.getMonth();
        };
        this.getDaysInMonth = function (date) {
            return getDaysInMonth(date);
        };
        this.setMonth = function (date, count) {
            return setMonth(date, count);
        };
        this.getMeridiemText = function (ampm) {
            return ampm === "am" ? "AM" : "PM";
        };
        this.getNextMonth = function (date) {
            return addMonths(date, 1);
        };
        this.getPreviousMonth = function (date) {
            return addMonths(date, -1);
        };
        this.getMonthArray = function (date) {
            var firstMonth = startOfYear(date);
            var monthArray = [firstMonth];
            while (monthArray.length < 12) {
                var prevMonth = monthArray[monthArray.length - 1];
                monthArray.push(_this.getNextMonth(prevMonth));
            }
            return monthArray;
        };
        this.mergeDateAndTime = function (date, time) {
            return _this.setSeconds(_this.setMinutes(_this.setHours(date, _this.getHours(time)), _this.getMinutes(time)), _this.getSeconds(time));
        };
        this.getWeekdays = function () {
            var now = new Date();
            return eachDayOfInterval({
                start: startOfWeek(now, { locale: _this.locale }),
                end: endOfWeek(now, { locale: _this.locale }),
            }).map(function (day) { return _this.formatByString(day, "EEEEEE"); });
        };
        this.getWeekArray = function (date) {
            var start = startOfWeek(startOfMonth(date), { locale: _this.locale });
            var end = endOfWeek(endOfMonth(date), { locale: _this.locale });
            var count = 0;
            var current = start;
            var nestedWeeks = [];
            var lastDay = null;
            while (isBefore(current, end)) {
                var weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                var day = getDay(current);
                if (lastDay !== day) {
                    lastDay = day;
                    nestedWeeks[weekNumber].push(current);
                    count += 1;
                }
                current = addDays(current, 1);
            }
            return nestedWeeks;
        };
        this.getYearRange = function (start, end) {
            var startDate = startOfYear(start);
            var endDate = endOfYear(end);
            var years = [];
            var current = startDate;
            while (isBefore(current, endDate)) {
                years.push(current);
                current = addYears(current, 1);
            }
            return years;
        };
        this.locale = locale;
        this.formats = Object.assign({}, defaultFormats, formats);
    }
    return DateFnsUtils;
}());

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var adapter = new DateFnsUtils({});
var defaultAdapter = adapter;

function ownKeys$D(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$D(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$D(Object(source), true).forEach(function (key) { _defineProperty$V(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$D(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck$q(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty$V(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var MINUTE$1 = 60;
var HOUR$1 = MINUTE$1 * 60;

var DateHelpers = function DateHelpers(_adapter) {
  var _this = this;

  _classCallCheck$q(this, DateHelpers);

  _defineProperty$V(this, "adapter", void 0);

  _defineProperty$V(this, "cloneAdapter", function (adapter, updateOptionsBase) {
    var adapterMap = {
      // all utils classes set the arguments passed into their constructor as public members in some way
      // it just varies by class, most just set formats and locale, but this handles the exceptions
      MomentUtils: {
        formats: {
          monthNumber: 'M',
          dayOfMonthNumber: 'D',
          fullOrdinalWeek: 'dddd, MMMM Do YYYY',
          slashDate: 'YYYY/MM/DD',
          weekday: 'dddd',
          // moment does not have a similar 'single character' weekday format like the other libraries
          // the format below will only supply two character abbreviations.
          weekdaymin: 'dd',
          quarter: '[Q]Q'
        }
      },
      DateFnsUtils: {
        formats: {
          monthNumber: 'M',
          dayOfMonthNumber: 'd',
          weekday: 'EEEE',
          weekdaymin: 'EEEEEE',
          slashDate: 'yyyy/MM/dd',
          fullOrdinalWeek: 'EEEE, MMMM do yyyy',
          quarter: 'QQQ'
        }
      },
      LuxonUtils: {
        formats: {
          monthNumber: 'M',
          dayOfMonthNumber: 'd',
          weekday: 'EEEE',
          weekdaymin: 'EEEEE',
          slashDate: 'yyyy/MM/dd',
          fullOrdinalWeek: 'EEEE, MMMM dd yyyy',
          quarter: 'Qq'
        }
      }
    };

    var defaultGetOptions = function defaultGetOptions(instance) {
      return {
        formats: instance.formats,
        locale: instance.locale
      };
    };

    var updateOptions = updateOptionsBase || defaultGetOptions;
    var UtilsClass = adapter.constructor;
    var className = adapter.constructor.name; // This ensures that if the adapter class isn't
    // supported it just falls back the default formats
    // NOTE: in e2e tests puppeteer seems to add
    // a JSHandle wrapping class to all objects
    // so className always resolves to JSHandle:e
    // and if falls back to the default
    // if we want to test other adapter implementation
    // in e2e tests down the road, we're going to have
    // to figure that out

    var _ref = adapterMap[className] || adapterMap.DateFnsUtils,
        _ref$getOptions = _ref.getOptions,
        getOptions = _ref$getOptions === void 0 ? defaultGetOptions : _ref$getOptions,
        formats = _ref.formats;

    var options = getOptions(adapter);
    return new UtilsClass(Object.assign({}, updateOptions(Object.assign({}, options, {
      formats: Object.assign({}, options.formats, formats)
    }))));
  });

  _defineProperty$V(this, "format", function (date, format, locale) {
    var adapter = locale ? _this.getAdapterWithNewLocale(locale) : _this.adapter;
    return adapter.format(date, format);
  });

  _defineProperty$V(this, "getAdapterWithNewLocale", function (locale) {
    return _this.cloneAdapter(_this.adapter, function (options) {
      return _objectSpread$D(_objectSpread$D({}, options), {}, {
        locale: locale
      });
    });
  });

  _defineProperty$V(this, "date", function (date) {
    return _this.adapter.date(date);
  });

  _defineProperty$V(this, "dateToSeconds", function (date) {
    var seconds = _this.adapter.getSeconds(date);

    var minutes = _this.adapter.getMinutes(date) * MINUTE$1;
    var hours = _this.adapter.getHours(date) * HOUR$1;
    return seconds + minutes + hours;
  });

  _defineProperty$V(this, "secondsToHourMinute", function (seconds) {
    var d = _this.adapter.toJsDate(_this.adapter.date(seconds * 1000));

    return [d.getUTCHours(), d.getUTCMinutes()];
  });

  _defineProperty$V(this, "differenceInCalendarMonths", function (fromDate, toDate) {
    var yearDiff = _this.adapter.getYear(fromDate) - _this.adapter.getYear(toDate);

    var monthDiff = _this.adapter.getMonth(fromDate) - _this.adapter.getMonth(toDate);

    return yearDiff * 12 + monthDiff;
  });

  _defineProperty$V(this, "getStartOfWeek", function (date, locale) {
    var adapter = locale ? _this.getAdapterWithNewLocale(locale) : _this.adapter; // rewrapping this date here ensures that the locale will be taken into account in all adapters

    return adapter.startOfWeek(adapter.date(date));
  });

  _defineProperty$V(this, "formatDate", function (date, formatString, locale) {
    var adapter = locale ? _this.getAdapterWithNewLocale(locale) : _this.adapter;
    return adapter.formatByString(date, formatString);
  });

  _defineProperty$V(this, "getWeekdayMinInLocale", function (date, locale) {
    return _this.getAdapterWithNewLocale(locale).format(date, 'weekdaymin');
  });

  _defineProperty$V(this, "getMonthInLocale", function (monthNumber, locale) {
    var localeAdapter = _this.getAdapterWithNewLocale(locale);

    return localeAdapter.format(localeAdapter.setMonth(localeAdapter.date(), monthNumber), 'month');
  });

  _defineProperty$V(this, "getWeekdayInLocale", function (date, locale) {
    return _this.getAdapterWithNewLocale(locale).format(date, 'weekday');
  });

  _defineProperty$V(this, "getQuarterInLocale", function (quarterNumber, locale) {
    var localeAdapter = _this.getAdapterWithNewLocale(locale);

    return localeAdapter.format(localeAdapter.setMonth(localeAdapter.date(), quarterNumber * 3), 'quarter');
  });

  _defineProperty$V(this, "getEndOfWeek", function (date) {
    return _this.adapter.endOfWeek(date);
  });

  _defineProperty$V(this, "getDay", function (date) {
    return Number(_this.adapter.formatByString(date, 'e')) - 1;
  });

  _defineProperty$V(this, "addWeeks", function (date, weekNumber) {
    return _this.adapter.addDays(date, weekNumber * 7);
  });

  _defineProperty$V(this, "subWeeks", function (date, weekNumber) {
    return _this.addWeeks(date, weekNumber * -1);
  });

  _defineProperty$V(this, "addYears", function (date, yearNumber) {
    return _this.adapter.addMonths(date, yearNumber * 12);
  });

  _defineProperty$V(this, "subYears", function (date, yearNumber) {
    return _this.addYears(date, yearNumber * -1);
  });

  _defineProperty$V(this, "isSameYear", function (fromDate, toDate) {
    if (fromDate && toDate) {
      return _this.adapter.isSameYear(fromDate, toDate);
    }

    return false;
  });

  _defineProperty$V(this, "isStartOfMonth", function (date) {
    return _this.adapter.isSameDay(date, _this.adapter.startOfMonth(date));
  });

  _defineProperty$V(this, "isEndOfMonth", function (date) {
    return _this.adapter.isSameDay(date, _this.adapter.endOfMonth(date));
  });

  _defineProperty$V(this, "isDayInRange", function (date, startDate, endDate) {
    return _this.adapter.isWithinRange(date, [startDate, endDate]);
  });

  _defineProperty$V(this, "isSameDay", function (fromDate, toDate) {
    if (fromDate && toDate) {
      return _this.adapter.isSameDay(fromDate, toDate);
    }

    return false;
  });

  _defineProperty$V(this, "isSameMonth", function (fromDate, toDate) {
    if (fromDate && toDate) {
      return _this.adapter.isSameMonth(fromDate, toDate);
    }

    return false;
  });

  _defineProperty$V(this, "subDays", function (date, days) {
    return _this.adapter.addDays(date, days * -1);
  });

  _defineProperty$V(this, "subMonths", function (date, months) {
    return _this.adapter.addMonths(date, months * -1);
  });

  _defineProperty$V(this, "min", function (dates) {
    return dates.reduce(function (minDate, date) {
      return _this.adapter.isBefore(date, minDate) ? date : minDate;
    });
  });

  _defineProperty$V(this, "max", function (dates) {
    return dates.reduce(function (maxDate, date) {
      return _this.adapter.isAfter(date, maxDate) ? date : maxDate;
    });
  });

  _defineProperty$V(this, "getEffectiveMinDate", function (_ref2) {
    var minDate = _ref2.minDate,
        includeDates = _ref2.includeDates;

    if (includeDates && minDate) {
      var minDates = includeDates.filter(function (includeDate) {
        return _this.isOnOrAfterDay(includeDate, minDate);
      });
      return _this.min(minDates);
    } else if (includeDates && includeDates.length) {
      return _this.min(includeDates);
    } else if (!(includeDates && includeDates.length) && minDate) {
      return minDate;
    } // this condition can't ever be reached
    // but flow isn't smart enough to see that all of the conditions are covered


    return _this.adapter.date();
  });

  _defineProperty$V(this, "getEffectiveMaxDate", function (_ref3) {
    var maxDate = _ref3.maxDate,
        includeDates = _ref3.includeDates;

    if (includeDates && maxDate) {
      var maxDates = includeDates.filter(function (includeDate) {
        return _this.isOnOrBeforeDay(includeDate, maxDate);
      });
      return _this.max(maxDates);
    } else if (includeDates) {
      return _this.max(includeDates);
    } else if (!includeDates && maxDate) {
      return maxDate;
    } // this condition can't ever be reached
    // but flow isn't smart enough to see that all of the conditions are covered


    return _this.adapter.date();
  });

  _defineProperty$V(this, "monthDisabledBefore", function (day) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        minDate = _ref4.minDate,
        includeDates = _ref4.includeDates;

    var previousMonth = _this.subMonths(day, 1);

    return !!minDate && _this.differenceInCalendarMonths(minDate, previousMonth) > 0 || !!includeDates && includeDates.every(function (includeDate) {
      return _this.differenceInCalendarMonths(includeDate, previousMonth) > 0;
    }) || false;
  });

  _defineProperty$V(this, "monthDisabledAfter", function (day) {
    var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        maxDate = _ref5.maxDate,
        includeDates = _ref5.includeDates;

    var nextMonth = _this.adapter.addMonths(day, 1);

    return !!maxDate && _this.differenceInCalendarMonths(nextMonth, maxDate) > 0 || !!includeDates && includeDates.every(function (includeDate) {
      return _this.differenceInCalendarMonths(nextMonth, includeDate) > 0;
    }) || false;
  });

  _defineProperty$V(this, "setDate", function (date, dayNumber) {
    var startOfMonthNoTime = _this.adapter.startOfMonth(date);

    var startOfMonthHoursAndMinutes = _this.adapter.mergeDateAndTime(startOfMonthNoTime, date);

    var startOfMonth = _this.adapter.setSeconds(startOfMonthHoursAndMinutes, _this.adapter.getSeconds(date));

    return _this.adapter.addDays(startOfMonth, dayNumber - 1);
  });

  _defineProperty$V(this, "getDate", function (date) {
    return Number(_this.adapter.format(date, 'dayOfMonthNumber'));
  });

  _defineProperty$V(this, "applyDateToTime", function (time, date) {
    if (!time) return date;

    var yearNumber = _this.adapter.getYear(date);

    var monthNumber = _this.adapter.getMonth(date);

    var dayNumber = _this.getDate(date);

    var yearDate = _this.adapter.setYear(time, yearNumber);

    var monthDate = _this.adapter.setMonth(yearDate, monthNumber);

    return _this.setDate(monthDate, dayNumber);
  });

  _defineProperty$V(this, "applyTimeToDate", function (date, time) {
    if (!date) return time;
    return _this.adapter.setSeconds(_this.adapter.mergeDateAndTime(date, time), 0);
  });

  _defineProperty$V(this, "isDayDisabled", function (day) {
    var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        minDate = _ref6.minDate,
        maxDate = _ref6.maxDate,
        excludeDates = _ref6.excludeDates,
        includeDates = _ref6.includeDates,
        filterDate = _ref6.filterDate;

    return _this.isOutOfBounds(day, {
      minDate: minDate,
      maxDate: maxDate
    }) || excludeDates && excludeDates.some(function (excludeDate) {
      return _this.adapter.isSameDay(day, excludeDate);
    }) || includeDates && !includeDates.some(function (includeDate) {
      return _this.adapter.isSameDay(day, includeDate);
    }) || filterDate && !filterDate(day) || false;
  });

  _defineProperty$V(this, "isOnOrAfterDay", function (fromDate, toDate) {
    if (_this.adapter.isSameDay(fromDate, toDate)) {
      return true;
    }

    return _this.adapter.isAfter(fromDate, toDate);
  });

  _defineProperty$V(this, "isOnOrBeforeDay", function (fromDate, toDate) {
    if (_this.adapter.isSameDay(fromDate, toDate)) {
      return true;
    }

    return _this.adapter.isBefore(fromDate, toDate);
  });

  _defineProperty$V(this, "isOutOfBounds", function (day) {
    var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        minDate = _ref7.minDate,
        maxDate = _ref7.maxDate;

    return !!minDate && !_this.isOnOrAfterDay(day, minDate) || !!maxDate && !_this.isOnOrBeforeDay(day, maxDate);
  });

  _defineProperty$V(this, "parseString", function (string, formatString, locale) {
    var adapter = locale ? _this.getAdapterWithNewLocale(locale) : _this.adapter;
    return adapter.parse(string, formatString);
  });

  _defineProperty$V(this, "parse", function (string, format, locale) {
    var adapter = locale ? _this.getAdapterWithNewLocale(locale) : _this.adapter;
    return adapter.parse(string, adapter.formats[format]);
  });

  _defineProperty$V(this, "setMilliseconds", function (date, milliseconds) {
    return _this.adapter.date(_this.adapter.getSeconds(_this.adapter.startOfDay(date)) * 1000 + milliseconds);
  });

  _defineProperty$V(this, "set", function (date, values) {
    var updatedDate = date;

    if (values.year != null) {
      updatedDate = _this.setYear(updatedDate, values.year);
    }

    if (values.month != null) {
      updatedDate = _this.setMonth(updatedDate, values.month);
    }

    if (values.date != null) {
      updatedDate = _this.setDate(updatedDate, Number(values.date));
    }

    if (values.hours != null) {
      updatedDate = _this.setHours(updatedDate, Number(values.hours));
    }

    if (values.minutes != null) {
      updatedDate = _this.setMinutes(updatedDate, Number(values.minutes));
    }

    if (values.seconds != null) {
      updatedDate = _this.setSeconds(updatedDate, Number(values.seconds));
    }

    return updatedDate;
  });

  _defineProperty$V(this, "getQuarter", function (date) {
    return Math.floor(_this.getMonth(date) / 3) + 1;
  });

  _defineProperty$V(this, "setSeconds", function (date, seconds) {
    return _this.adapter.setSeconds(date, seconds);
  });

  _defineProperty$V(this, "setMinutes", function (date, minutes) {
    return _this.adapter.setMinutes(date, minutes);
  });

  _defineProperty$V(this, "setHours", function (date, hours) {
    return _this.adapter.setHours(date, hours);
  });

  _defineProperty$V(this, "setMonth", function (date, monthNumber) {
    return _this.adapter.setMonth(date, monthNumber);
  });

  _defineProperty$V(this, "setYear", function (date, yearNumber) {
    return _this.adapter.setYear(date, yearNumber);
  });

  _defineProperty$V(this, "getMinutes", function (date) {
    return _this.adapter.getMinutes(date);
  });

  _defineProperty$V(this, "getHours", function (date) {
    return _this.adapter.getHours(date);
  });

  _defineProperty$V(this, "getMonth", function (date) {
    return _this.adapter.getMonth(date);
  });

  _defineProperty$V(this, "getYear", function (date) {
    return _this.adapter.getYear(date);
  });

  _defineProperty$V(this, "getStartOfMonth", function (date) {
    return _this.adapter.startOfMonth(date);
  });

  _defineProperty$V(this, "getEndOfMonth", function (date) {
    return _this.adapter.endOfMonth(date);
  });

  _defineProperty$V(this, "addDays", function (date, days) {
    return _this.adapter.addDays(date, days);
  });

  _defineProperty$V(this, "addMonths", function (date, months) {
    return _this.adapter.addMonths(date, months);
  });

  _defineProperty$V(this, "isBefore", function (fromDate, toDate) {
    return _this.adapter.isBefore(fromDate, toDate);
  });

  _defineProperty$V(this, "isAfter", function (fromDate, toDate) {
    return _this.adapter.isAfter(fromDate, toDate);
  });

  _defineProperty$V(this, "isEqual", function (fromDate, toDate) {
    return _this.adapter.isEqual(fromDate, toDate);
  });

  _defineProperty$V(this, "isValid", function (possibleDate) {
    return _this.adapter.isValid(possibleDate);
  });

  this.adapter = this.cloneAdapter(_adapter);
};

var DateHelpers$1 = DateHelpers;

function ownKeys$C(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$C(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$C(Object(source), true).forEach(function (key) { _defineProperty$U(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$C(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$U(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getDefaultMonthItems = function getDefaultMonthItems(formatMonthLabel) {
  return DEFAULT_MONTHS.map(function (month) {
    return {
      id: month.toString(),
      label: formatMonthLabel(month)
    };
  });
};

var filterMonthItems = function filterMonthItems(monthItems, filterList) {
  return monthItems.map(function (month) {
    if (!filterList.includes(Number(month.id))) {
      return _objectSpread$C(_objectSpread$C({}, month), {}, {
        disabled: true
      });
    }

    return month;
  });
};
var getFilteredMonthItems = function getFilteredMonthItems(_ref) {
  var filterMonthsList = _ref.filterMonthsList,
      formatMonthLabel = _ref.formatMonthLabel;
  var monthItems = getDefaultMonthItems(formatMonthLabel);

  if (filterMonthsList) {
    monthItems = filterMonthItems(monthItems, filterMonthsList);
  }

  return monthItems;
};

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/**
  r == range - date range can be selected
  d == disabled - disabled date
  h == highlighted - currently highlighted date, the highlight is triggered on hover or focus
  mO == hovered (mouse-over) - currently hovered date
  s == selected - selected date, in a range both start and end date are marked as `selected`
  rS == range-selected - when start and end dates of a range are set
  sD == start-date - selected start date of the range
  eD == end-date - selected end date of the range
  pS == pseudo-selected - any date between two selected dates in a range
  rH == range-highlighed - when only a single date of a range selected and the second date is highlighted but not yet selected
  pH == pseudo-highlighted -  any date between a selected date in a range and the currently highlighted date (case when only one date selected in a range case)
  rR == range-on-right - the range-highlighed case with the highlighed date is after the selected one
  rL == range-on-left - the range-highlighed case with the highlighed date is before the selected one
  sM == start-of-month - the first day of the month
  eM == end-of-month - the last day of the month
  oM == outside-month - date outside of currently displayed month (when peekNextMonth is set to true)
 */
//  r  d  h  s  rS sD eD pS rH pH rR rL sM eM oM
//  1  1  1  1  1  1  1  1  1  1  1  1  1  1  1
function getDayStateCode(props) {
  var _props$$range = props.$range,
      $range = _props$$range === void 0 ? false : _props$$range,
      _props$$disabled = props.$disabled,
      $disabled = _props$$disabled === void 0 ? false : _props$$disabled,
      _props$$isHighlighted = props.$isHighlighted,
      $isHighlighted = _props$$isHighlighted === void 0 ? false : _props$$isHighlighted,
      _props$$isHovered = props.$isHovered,
      $isHovered = _props$$isHovered === void 0 ? false : _props$$isHovered,
      _props$$selected = props.$selected,
      $selected = _props$$selected === void 0 ? false : _props$$selected,
      _props$$hasRangeSelec = props.$hasRangeSelected,
      $hasRangeSelected = _props$$hasRangeSelec === void 0 ? false : _props$$hasRangeSelec,
      _props$$startDate = props.$startDate,
      $startDate = _props$$startDate === void 0 ? false : _props$$startDate,
      _props$$endDate = props.$endDate,
      $endDate = _props$$endDate === void 0 ? false : _props$$endDate,
      _props$$pseudoSelecte = props.$pseudoSelected,
      $pseudoSelected = _props$$pseudoSelecte === void 0 ? false : _props$$pseudoSelecte,
      _props$$hasRangeHighl = props.$hasRangeHighlighted,
      $hasRangeHighlighted = _props$$hasRangeHighl === void 0 ? false : _props$$hasRangeHighl,
      _props$$pseudoHighlig = props.$pseudoHighlighted,
      $pseudoHighlighted = _props$$pseudoHighlig === void 0 ? false : _props$$pseudoHighlig,
      _props$$hasRangeOnRig = props.$hasRangeOnRight,
      $hasRangeOnRight = _props$$hasRangeOnRig === void 0 ? false : _props$$hasRangeOnRig,
      _props$$startOfMonth = props.$startOfMonth,
      $startOfMonth = _props$$startOfMonth === void 0 ? false : _props$$startOfMonth,
      _props$$endOfMonth = props.$endOfMonth,
      $endOfMonth = _props$$endOfMonth === void 0 ? false : _props$$endOfMonth,
      _props$$outsideMonth = props.$outsideMonth,
      $outsideMonth = _props$$outsideMonth === void 0 ? false : _props$$outsideMonth;
  return "".concat(+$range).concat(+$disabled).concat(+($isHighlighted || $isHovered)).concat(+$selected).concat(+$hasRangeSelected).concat(+$startDate).concat(+$endDate).concat(+$pseudoSelected).concat(+$hasRangeHighlighted).concat(+$pseudoHighlighted).concat(+($hasRangeHighlighted && !$pseudoHighlighted && $hasRangeOnRight)).concat(+($hasRangeHighlighted && !$pseudoHighlighted && !$hasRangeOnRight)).concat(+$startOfMonth).concat(+$endOfMonth).concat(+$outsideMonth);
}

function ownKeys$B(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$B(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$B(Object(source), true).forEach(function (key) { _defineProperty$T(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$B(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$T(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/**
 * Main component container element
 */

var StyledInputWrapper = styled('div', function (props) {
  var $separateRangeInputs = props.$separateRangeInputs;
  return _objectSpread$B({
    width: '100%'
  }, $separateRangeInputs ? {
    display: 'flex',
    justifyContent: 'center'
  } : {});
});
StyledInputWrapper.displayName = "StyledInputWrapper";
var StyledInputLabel = styled('div', function (_ref) {
  var $theme = _ref.$theme;
  return _objectSpread$B(_objectSpread$B({}, $theme.typography.LabelMedium), {}, {
    marginBottom: $theme.sizing.scale300
  });
});
StyledInputLabel.displayName = "StyledInputLabel";
var StyledStartDate = styled('div', function (_ref2) {
  var $theme = _ref2.$theme;
  return {
    width: '100%',
    marginRight: $theme.sizing.scale300
  };
});
StyledStartDate.displayName = "StyledStartDate";
var StyledEndDate = styled('div', function (_ref3) {
  _ref3.$theme;
  return {
    width: '100%'
  };
});
/**
 * Main component container element
 */

StyledEndDate.displayName = "StyledEndDate";
var StyledRoot$e = styled('div', function (props) {
  var _props$$theme = props.$theme,
      typography = _props$$theme.typography,
      colors = _props$$theme.colors,
      borders = _props$$theme.borders;
  return _objectSpread$B(_objectSpread$B({}, typography.font200), {}, {
    color: colors.calendarForeground,
    backgroundColor: colors.calendarBackground,
    textAlign: 'center',
    borderTopLeftRadius: borders.surfaceBorderRadius,
    borderTopRightRadius: borders.surfaceBorderRadius,
    borderBottomRightRadius: borders.surfaceBorderRadius,
    borderBottomLeftRadius: borders.surfaceBorderRadius,
    display: 'inline-block'
  });
});
StyledRoot$e.displayName = "StyledRoot";
var StyledMonthContainer = styled('div', function (props) {
  var $orientation = props.$orientation;
  return {
    display: 'flex',
    flexDirection: $orientation === ORIENTATION$1.vertical ? 'column' : 'row'
  };
});
StyledMonthContainer.displayName = "StyledMonthContainer";
var StyledCalendarContainer = styled('div', function (props) {
  var sizing = props.$theme.sizing,
      $density = props.$density;
  return {
    paddingTop: sizing.scale300,
    paddingBottom: $density === DENSITY.high ? sizing.scale400 : sizing.scale300,
    paddingLeft: sizing.scale500,
    paddingRight: sizing.scale500
  };
});
StyledCalendarContainer.displayName = "StyledCalendarContainer";
var StyledSelectorContainer = styled('div', function (_ref4) {
  var $theme = _ref4.$theme;
  var textAlign = $theme.direction === 'rtl' ? 'right' : 'left';
  return {
    marginBottom: $theme.sizing.scale600,
    paddingLeft: $theme.sizing.scale600,
    paddingRight: $theme.sizing.scale600,
    textAlign: textAlign
  };
});
StyledSelectorContainer.displayName = "StyledSelectorContainer";
var StyledCalendarHeader = styled('div', function (props) {
  var _props$$theme2 = props.$theme,
      typography = _props$$theme2.typography,
      borders = _props$$theme2.borders,
      colors = _props$$theme2.colors,
      sizing = _props$$theme2.sizing,
      $density = props.$density;
  return _objectSpread$B(_objectSpread$B({}, $density === DENSITY.high ? typography.LabelMedium : typography.LabelLarge), {}, {
    color: colors.calendarHeaderForeground,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: sizing.scale600,
    paddingBottom: sizing.scale300,
    paddingLeft: sizing.scale600,
    paddingRight: sizing.scale600,
    backgroundColor: colors.calendarHeaderBackground,
    borderTopLeftRadius: borders.surfaceBorderRadius,
    borderTopRightRadius: borders.surfaceBorderRadius,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    // account for the left/right arrow heights
    minHeight: $density === DENSITY.high ? "calc(".concat(sizing.scale800, " + ").concat(sizing.scale0, ")") : sizing.scale950
  });
});
StyledCalendarHeader.displayName = "StyledCalendarHeader";
var StyledMonthHeader = styled('div', function (props) {
  return {
    color: props.$theme.colors.calendarHeaderForeground,
    backgroundColor: props.$theme.colors.calendarHeaderBackground,
    whiteSpace: 'nowrap'
  };
});
StyledMonthHeader.displayName = "StyledMonthHeader";
var StyledMonthYearSelectButton = styled('button', function (props) {
  var _props$$theme3 = props.$theme,
      typography = _props$$theme3.typography,
      colors = _props$$theme3.colors,
      $isFocusVisible = props.$isFocusVisible,
      $density = props.$density;
  return _objectSpread$B(_objectSpread$B({}, $density === DENSITY.high ? typography.LabelMedium : typography.LabelLarge), {}, {
    alignItems: 'center',
    backgroundColor: 'transparent',
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 0,
    color: colors.calendarHeaderForeground,
    cursor: 'pointer',
    display: 'flex',
    outline: 'none',
    ':focus': {
      boxShadow: $isFocusVisible ? "0 0 0 3px ".concat(colors.accent) : 'none'
    }
  });
});
StyledMonthYearSelectButton.displayName = "StyledMonthYearSelectButton";
var StyledMonthYearSelectIconContainer = styled('span', function (props) {
  var marginDirection = props.$theme.direction === 'rtl' ? 'marginRight' : 'marginLeft';
  return _defineProperty$T({
    alignItems: 'center',
    display: 'flex'
  }, marginDirection, props.$theme.sizing.scale500);
});
StyledMonthYearSelectIconContainer.displayName = "StyledMonthYearSelectIconContainer";

function getArrowBtnStyle(_ref6) {
  var $theme = _ref6.$theme,
      $disabled = _ref6.$disabled,
      $isFocusVisible = _ref6.$isFocusVisible;
  return {
    boxSizing: 'border-box',
    display: 'flex',
    color: $disabled ? $theme.colors.calendarHeaderForegroundDisabled : $theme.colors.calendarHeaderForeground,
    cursor: $disabled ? 'default' : 'pointer',
    backgroundColor: 'transparent',
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 0,
    paddingTop: '0',
    paddingBottom: '0',
    paddingLeft: '0',
    paddingRight: '0',
    marginBottom: 0,
    marginTop: 0,
    outline: 'none',
    ':focus': $disabled ? {} : {
      boxShadow: $isFocusVisible ? "0 0 0 3px ".concat($theme.colors.accent) : 'none'
    }
  };
}

var StyledPrevButton = styled('button', getArrowBtnStyle);
StyledPrevButton.displayName = "StyledPrevButton";
var StyledNextButton = styled('button', getArrowBtnStyle);
StyledNextButton.displayName = "StyledNextButton";
var StyledMonth = styled('div', function (props) {
  return {
    display: 'inline-block'
  };
});
StyledMonth.displayName = "StyledMonth";
var StyledWeek = styled('div', function (props) {
  var sizing = props.$theme.sizing;
  return {
    whiteSpace: 'nowrap',
    display: 'flex',
    marginBottom: sizing.scale0
  };
});
StyledWeek.displayName = "StyledWeek";

function generateDayStyles(defaultCode, defaultStyle) {
  var _ref7;

  var codeForSM = defaultCode.substr(0, 12) + '1' + defaultCode.substr(12 + 1);
  var codeForEM = defaultCode.substr(0, 13) + '1' + defaultCode.substr(13 + 1);
  return _ref7 = {}, _defineProperty$T(_ref7, defaultCode, defaultStyle), _defineProperty$T(_ref7, codeForSM, defaultStyle), _defineProperty$T(_ref7, codeForEM, defaultStyle), _ref7;
} // flowlint-next-line unclear-type:off


function getDayStyles(code, _ref8) {
  var colors = _ref8.colors;
  var undefinedDayStyle = {
    ':before': {
      content: null
    },
    ':after': {
      content: null
    }
  };
  var defaultDayStyle = undefinedDayStyle;
  var disabledDateStyle = {
    color: colors.calendarForegroundDisabled,
    ':before': {
      content: null
    },
    ':after': {
      content: null
    }
  };
  var outsideMonthDateStyle = {
    color: colors.calendarForegroundDisabled,
    ':before': {
      borderTopStyle: 'none',
      borderBottomStyle: 'none',
      borderLeftStyle: 'none',
      borderRightStyle: 'none',
      backgroundColor: 'transparent'
    },
    ':after': {
      borderTopLeftRadius: '0%',
      borderTopRightRadius: '0%',
      borderBottomLeftRadius: '0%',
      borderBottomRightRadius: '0%',
      borderTopColor: 'transparent',
      borderBottomColor: 'transparent',
      borderRightColor: 'transparent',
      borderLeftColor: 'transparent'
    }
  };
  var highlightedStyle = {
    ':before': {
      content: null
    }
  };
  var CODE_DISABLED_INDEX = 1;

  if (code && code[CODE_DISABLED_INDEX] === '1') {
    defaultDayStyle = disabledDateStyle;
  } // See the ./utils/day-state.js file for the description of all available states
  // rdhsrSsDeDpSrHpHrRrLsMeMoM
  // '000000000000000'


  var dayStateStyle = Object.assign({}, // highlighted date
  generateDayStyles('001000000000000', {
    color: colors.calendarDayForegroundPseudoSelected
  }), // selected date
  generateDayStyles('000100000000000', {
    color: colors.calendarDayForegroundSelected
  }), // selected highlighted date
  generateDayStyles('001100000000000', {
    color: colors.calendarDayForegroundSelectedHighlighted
  }), // disabled date
  {
    '010000000000000': {
      color: colors.calendarForegroundDisabled,
      ':after': {
        content: null
      }
    }
  }, // disabled highlighted date
  {
    '011000000000000': {
      color: colors.calendarForegroundDisabled,
      ':after': {
        content: null
      }
    }
  }, // date outside of the currently displayed month (when peekNextMonth is true)
  generateDayStyles('000000000000001', outsideMonthDateStyle), // Range Datepicker
  // range: highlighted date outside of a selected range
  generateDayStyles('101000000000000', highlightedStyle), generateDayStyles('101010000000000', highlightedStyle), // range: selected date
  generateDayStyles('100100000000000', {
    color: colors.calendarDayForegroundSelected
  }), // range: selected highlighted date
  // when single date selected in a range
  generateDayStyles('101100000000000', {
    color: colors.calendarDayForegroundSelectedHighlighted,
    ':before': {
      content: null
    }
  }), // range: selected start and end dates are the same
  generateDayStyles('100111100000000', {
    color: colors.calendarDayForegroundSelected,
    ':before': {
      content: null
    }
  }), generateDayStyles('101111100000000', {
    color: colors.calendarDayForegroundSelectedHighlighted,
    ':before': {
      content: null
    }
  }), // range: selected start date
  generateDayStyles('100111000000000', {
    color: colors.calendarDayForegroundSelected
  }), // range: selected end date
  generateDayStyles('100110100000000', {
    color: colors.calendarDayForegroundSelected,
    ':before': {
      left: null,
      right: '50%'
    }
  }), // range: first selected date while a range is highlighted but no second date selected yet
  // highlighted range on the right from the selected
  generateDayStyles('100100001010000', {
    color: colors.calendarDayForegroundSelected
  }), // highlighted range on the left from the selected
  generateDayStyles('100100001001000', {
    color: colors.calendarDayForegroundSelected,
    ':before': {
      left: null,
      right: '50%'
    }
  }), // range: second date in a range that is highlighted but not selected
  generateDayStyles('101000001010000', {
    ':before': {
      left: null,
      right: '50%'
    }
  }), {
    '101000001001000': {}
  }, {
    '101000001001100': {}
  }, {
    '101000001001010': {}
  }, // range: pseudo-selected date
  generateDayStyles('100010010000000', {
    color: colors.calendarDayForegroundPseudoSelected,
    ':before': {
      left: '0',
      width: '100%'
    },
    ':after': {
      content: null
    }
  }), // range: pseudo-highlighted date (in a range where only one date is
  // selected and second date is highlighted)
  {
    '101000001100000': {
      color: colors.calendarDayForegroundPseudoSelected,
      ':before': {
        left: '0',
        width: '100%'
      },
      ':after': {
        content: null
      }
    }
  }, generateDayStyles('100000001100000', {
    color: colors.calendarDayForegroundPseudoSelected,
    ':before': {
      left: '0',
      width: '100%'
    },
    ':after': {
      content: null
    }
  }), // highlighted start date in a range
  generateDayStyles('101111000000000', {
    color: colors.calendarDayForegroundSelectedHighlighted
  }), // highlighted end date in a range
  generateDayStyles('101110100000000', {
    color: colors.calendarDayForegroundSelectedHighlighted,
    ':before': {
      left: null,
      right: '50%'
    }
  }), // range: pseudo-selected date
  generateDayStyles('101010010000000', {
    color: colors.calendarDayForegroundPseudoSelectedHighlighted,
    ':before': {
      left: '0',
      width: '100%'
    }
  }), // Range is true Date outside current month (when peekNextMonth is true)
  generateDayStyles('100000000000001', outsideMonthDateStyle), // peekNextMonth is true, date is outside month, start date is selected and range is highlighted is on right
  generateDayStyles('100000001010001', outsideMonthDateStyle), // peekNextMonth is true, date is outside month, start date is selected and range is highlighted is on left
  generateDayStyles('100000001001001', outsideMonthDateStyle), // peekNextMonth is true, date is outside month, range is selected
  generateDayStyles('100010000000001', outsideMonthDateStyle));
  return dayStateStyle[code] || defaultDayStyle;
}

var StyledDay = styled('div', function (props) {
  var $disabled = props.$disabled,
      $isFocusVisible = props.$isFocusVisible,
      $isHighlighted = props.$isHighlighted,
      $peekNextMonth = props.$peekNextMonth,
      $pseudoSelected = props.$pseudoSelected,
      $range = props.$range,
      $selected = props.$selected,
      $outsideMonth = props.$outsideMonth,
      $outsideMonthWithinRange = props.$outsideMonthWithinRange,
      $hasDateLabel = props.$hasDateLabel,
      $density = props.$density,
      _props$$theme4 = props.$theme,
      colors = _props$$theme4.colors,
      typography = _props$$theme4.typography,
      sizing = _props$$theme4.sizing;
  var code = getDayStateCode(props);
  var height;

  if ($hasDateLabel) {
    if ($density === DENSITY.high) {
      height = '60px';
    } else {
      height = '70px';
    }
  } else {
    if ($density === DENSITY.high) {
      height = '40px';
    } else {
      height = '48px';
    }
  }

  return _objectSpread$B(_objectSpread$B(_objectSpread$B({}, $density === DENSITY.high ? typography.ParagraphSmall : typography.ParagraphMedium), {}, {
    boxSizing: 'border-box',
    position: 'relative',
    cursor: $disabled || !$peekNextMonth && $outsideMonth ? 'default' : 'pointer',
    color: colors.calendarForeground,
    display: 'inline-block',
    width: $density === DENSITY.high ? '42px' : '50px',
    height: height,
    // setting lineHeight equal to the contents height to vertically center the text
    lineHeight: $density === DENSITY.high ? sizing.scale700 : sizing.scale900,
    textAlign: 'center',
    paddingTop: sizing.scale300,
    paddingBottom: sizing.scale300,
    paddingLeft: sizing.scale300,
    paddingRight: sizing.scale300,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    outline: 'none',
    backgroundColor: 'transparent',
    // `transform` creates a stacking context so
    // a z-index used on its' children doesn't
    // interfere with anything outside the component
    transform: 'scale(1)'
  }, getDayStyles(code, props.$theme)), {}, {
    // :after pseudo element defines the selected
    // or highlighted day's circle styles
    ':after': _objectSpread$B(_objectSpread$B({
      zIndex: -1,
      content: '""',
      boxSizing: 'border-box',
      display: 'inline-block',
      boxShadow: $isFocusVisible && (!$outsideMonth || $peekNextMonth) ? "0 0 0 3px ".concat(colors.accent) : 'none',
      backgroundColor: $selected ? colors.calendarDayBackgroundSelectedHighlighted : $pseudoSelected && $isHighlighted ? colors.calendarDayBackgroundPseudoSelectedHighlighted : colors.calendarBackground,
      height: $hasDateLabel ? '100%' : $density === DENSITY.high ? '42px' : '50px',
      width: '100%',
      position: 'absolute',
      top: $hasDateLabel ? 0 : '-1px',
      left: 0,
      paddingTop: sizing.scale200,
      paddingBottom: sizing.scale200,
      borderLeftWidth: '2px',
      borderRightWidth: '2px',
      borderTopWidth: '2px',
      borderBottomWidth: '2px',
      borderLeftStyle: 'solid',
      borderRightStyle: 'solid',
      borderTopStyle: 'solid',
      borderBottomStyle: 'solid',
      borderTopColor: colors.borderSelected,
      borderBottomColor: colors.borderSelected,
      borderRightColor: colors.borderSelected,
      borderLeftColor: colors.borderSelected,
      borderTopLeftRadius: $hasDateLabel ? sizing.scale800 : '100%',
      borderTopRightRadius: $hasDateLabel ? sizing.scale800 : '100%',
      borderBottomLeftRadius: $hasDateLabel ? sizing.scale800 : '100%',
      borderBottomRightRadius: $hasDateLabel ? sizing.scale800 : '100%'
    }, getDayStyles(code, props.$theme)[':after'] || {}), $outsideMonthWithinRange ? {
      content: null
    } : {})
  }, $range ? {
    // :before pseudo element defines a grey background style that extends
    // the selected/highlighted day's circle and spans through a range
    ':before': _objectSpread$B(_objectSpread$B({
      zIndex: -1,
      content: '""',
      boxSizing: 'border-box',
      display: 'inline-block',
      backgroundColor: colors.mono300,
      position: 'absolute',
      height: '100%',
      width: '50%',
      top: 0,
      left: '50%',
      borderTopWidth: '2px',
      borderBottomWidth: '2px',
      borderLeftWidth: '0',
      borderRightWidth: '0',
      borderTopStyle: 'solid',
      borderBottomStyle: 'solid',
      borderLeftStyle: 'solid',
      borderRightStyle: 'solid',
      borderTopColor: 'transparent',
      borderBottomColor: 'transparent',
      borderLeftColor: 'transparent',
      borderRightColor: 'transparent'
    }, getDayStyles(code, props.$theme)[':before'] || {}), $outsideMonthWithinRange ? {
      backgroundColor: colors.mono300,
      left: '0',
      width: '100%',
      content: '""'
    } : {})
  } : // a hack to make flow happy, otherwise it complains about complexity
  // flowlint-next-line unclear-type:off
  {});
});
StyledDay.displayName = "StyledDay";
var StyledDayLabel = styled('div', function (props) {
  var _props$$theme5 = props.$theme,
      typography = _props$$theme5.typography,
      colors = _props$$theme5.colors,
      $selected = props.$selected;
  return _objectSpread$B(_objectSpread$B({}, typography.ParagraphXSmall), {}, {
    color: $selected ? colors.contentInverseTertiary : colors.contentTertiary
  });
});
StyledDayLabel.displayName = "StyledDayLabel";
var StyledWeekdayHeader = styled('div', function (props) {
  var _props$$theme6 = props.$theme,
      typography = _props$$theme6.typography,
      colors = _props$$theme6.colors,
      sizing = _props$$theme6.sizing,
      $density = props.$density;
  return _objectSpread$B(_objectSpread$B({}, typography.LabelMedium), {}, {
    color: colors.contentTertiary,
    boxSizing: 'border-box',
    position: 'relative',
    cursor: 'default',
    display: 'inline-block',
    width: $density === DENSITY.high ? '42px' : '50px',
    height: $density === DENSITY.high ? '40px' : '48px',
    textAlign: 'center',
    // setting lineHeight equal to the contents height to vertically center the text
    lineHeight: sizing.scale900,
    paddingTop: sizing.scale300,
    paddingBottom: sizing.scale300,
    paddingLeft: sizing.scale200,
    paddingRight: sizing.scale200,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    backgroundColor: 'transparent'
  });
});
StyledWeekdayHeader.displayName = "StyledWeekdayHeader";

function _typeof$p(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$p = function _typeof(obj) { return typeof obj; }; } else { _typeof$p = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$p(obj); }

function _extends$B() { _extends$B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

function _slicedToArray$A(arr, i) { return _arrayWithHoles$A(arr) || _iterableToArrayLimit$A(arr, i) || _unsupportedIterableToArray$C(arr, i) || _nonIterableRest$A(); }

function _nonIterableRest$A() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$C(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$C(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$C(o, minLen); }

function _arrayLikeToArray$C(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$A(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$A(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys$A(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$A(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$A(Object(source), true).forEach(function (key) { _defineProperty$S(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$A(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck$p(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$o(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$p(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$o(Constructor.prototype, protoProps); if (staticProps) _defineProperties$o(Constructor, staticProps); return Constructor; }

function _inherits$p(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$o(subClass, superClass); }

function _setPrototypeOf$o(o, p) { _setPrototypeOf$o = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$o(o, p); }

function _createSuper$o(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$o(); return function _createSuperInternal() { var Super = _getPrototypeOf$o(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$o(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$p(this, result); }; }

function _possibleConstructorReturn$p(self, call) { if (call && (_typeof$p(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$o(self); }

function _assertThisInitialized$o(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$o() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$o(o) { _getPrototypeOf$o = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$o(o); }

function _defineProperty$S(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var navBtnStyle = function navBtnStyle(_ref) {
  _ref.$theme;
  return {
    cursor: 'pointer'
  };
};

var MIN_YEAR = 2000;
var MAX_YEAR = 2030;
var MIN_MONTH = 0;
var MAX_MONTH = 11;
var DIRECTION = {
  NEXT: 'next',
  PREVIOUS: 'previous'
};

function idToYearMonth(id) {
  return id.split('-').map(Number);
}

var CalendarHeader = /*#__PURE__*/function (_React$Component) {
  _inherits$p(CalendarHeader, _React$Component);

  var _super = _createSuper$o(CalendarHeader);

  function CalendarHeader(props) {
    var _this;

    _classCallCheck$p(this, CalendarHeader);

    _this = _super.call(this, props); //$FlowFixMe

    _defineProperty$S(_assertThisInitialized$o(_this), "dateHelpers", void 0);

    _defineProperty$S(_assertThisInitialized$o(_this), "monthItems", void 0);

    _defineProperty$S(_assertThisInitialized$o(_this), "yearItems", void 0);

    _defineProperty$S(_assertThisInitialized$o(_this), "state", {
      isMonthDropdownOpen: false,
      isYearDropdownOpen: false,
      isFocusVisible: false
    });

    _defineProperty$S(_assertThisInitialized$o(_this), "getDateProp", function () {
      return _this.props.date || _this.dateHelpers.date();
    });

    _defineProperty$S(_assertThisInitialized$o(_this), "getYearItems", function () {
      var date = _this.getDateProp();

      var maxDate = _this.props.maxDate;
      var minDate = _this.props.minDate;
      var maxYear = maxDate ? _this.dateHelpers.getYear(maxDate) : MAX_YEAR;
      var minYear = minDate ? _this.dateHelpers.getYear(minDate) : MIN_YEAR;

      var selectedMonth = _this.dateHelpers.getMonth(date); // TODO: this logic can be optimized to only run when minDate / maxDate change


      _this.yearItems = Array.from({
        length: maxYear - minYear + 1
      }, function (_, i) {
        return minYear + i;
      }).map(function (year) {
        return {
          id: year.toString(),
          label: year.toString()
        };
      });
      var monthOfMaxDate = maxDate ? _this.dateHelpers.getMonth(maxDate) : MAX_MONTH;
      var monthOfMinDate = minDate ? _this.dateHelpers.getMonth(minDate) : MIN_MONTH; // Generates array like [0,1,.... monthOfMaxDate]

      var maxYearMonths = Array.from({
        length: monthOfMaxDate + 1
      }, function (x, i) {
        return i;
      }); // Generates array like [monthOfMinDate, ...., 10, 11]

      var minYearMonths = Array.from({
        length: 12 - monthOfMinDate
      }, function (x, i) {
        return i + monthOfMinDate;
      });

      if (selectedMonth > maxYearMonths[maxYearMonths.length - 1]) {
        var lastIdx = _this.yearItems.length - 1;
        _this.yearItems[lastIdx] = _objectSpread$A(_objectSpread$A({}, _this.yearItems[lastIdx]), {}, {
          disabled: true
        });
      }

      if (selectedMonth < minYearMonths[0]) {
        _this.yearItems[0] = _objectSpread$A(_objectSpread$A({}, _this.yearItems[0]), {}, {
          disabled: true
        });
      }
    });

    _defineProperty$S(_assertThisInitialized$o(_this), "getMonthItems", function () {
      var date = _this.getDateProp();

      var year = _this.dateHelpers.getYear(date);

      var maxDate = _this.props.maxDate;
      var minDate = _this.props.minDate;
      var maxYear = maxDate ? _this.dateHelpers.getYear(maxDate) : MAX_YEAR;
      var minYear = minDate ? _this.dateHelpers.getYear(minDate) : MIN_YEAR;
      var monthOfMaxDate = maxDate ? _this.dateHelpers.getMonth(maxDate) : MAX_MONTH; // Generates array like [0,1,.... monthOfMaxDate]

      var maxYearMonths = Array.from({
        length: monthOfMaxDate + 1
      }, function (x, i) {
        return i;
      });
      var monthOfMinDate = minDate ? _this.dateHelpers.getMonth(minDate) : MIN_MONTH; // Generates array like [monthOfMinDate, ...., 10, 11]

      var minYearMonths = Array.from({
        length: 12 - monthOfMinDate
      }, function (x, i) {
        return i + monthOfMinDate;
      });
      var maxMinYearMonthsIntersection = maxYearMonths.filter(function (year) {
        return minYearMonths.includes(year);
      });
      var filterMonthsList = year === maxYear && year === minYear ? maxMinYearMonthsIntersection : year === maxYear ? maxYearMonths : year === minYear ? minYearMonths : null;

      var formatMonthLabel = function formatMonthLabel(month) {
        return _this.dateHelpers.getMonthInLocale(month, _this.props.locale);
      };

      _this.monthItems = getFilteredMonthItems({
        filterMonthsList: filterMonthsList,
        formatMonthLabel: formatMonthLabel
      });
    });

    _defineProperty$S(_assertThisInitialized$o(_this), "increaseMonth", function () {
      if (_this.props.onMonthChange) {
        // $FlowFixMe
        _this.props.onMonthChange({
          date: _this.dateHelpers.addMonths(_this.getDateProp(), // in a multi-month context, `order` is the number months ahead of
          // the root Calendar month that this CalendarHeader displays. We account
          // for this by incrementing the month by 1, less the value of `order`.
          1 - _this.props.order)
        });
      }
    });

    _defineProperty$S(_assertThisInitialized$o(_this), "decreaseMonth", function () {
      if (_this.props.onMonthChange) {
        // $FlowFixMe
        _this.props.onMonthChange({
          date: _this.dateHelpers.subMonths(_this.getDateProp(), 1)
        });
      }
    });

    _defineProperty$S(_assertThisInitialized$o(_this), "isMultiMonthHorizontal", function () {
      var _this$props = _this.props,
          monthsShown = _this$props.monthsShown,
          orientation = _this$props.orientation;

      if (!monthsShown) {
        return false;
      }

      return orientation === ORIENTATION$1.horizontal && monthsShown > 1;
    });

    _defineProperty$S(_assertThisInitialized$o(_this), "isHiddenPaginationButton", function (direction) {
      var _this$props2 = _this.props,
          monthsShown = _this$props2.monthsShown,
          order = _this$props2.order;

      if (!!monthsShown && _this.isMultiMonthHorizontal()) {
        if (direction === DIRECTION.NEXT) {
          var isLastMonth = order === monthsShown - 1;
          return !isLastMonth;
        } else {
          var isFirstMonth = order === 0;
          return !isFirstMonth;
        }
      }

      return false;
    });

    _defineProperty$S(_assertThisInitialized$o(_this), "handleFocus", function (event) {
      if (isFocusVisible(event)) {
        _this.setState({
          isFocusVisible: true
        });
      }
    });

    _defineProperty$S(_assertThisInitialized$o(_this), "handleBlur", function (event) {
      if (_this.state.isFocusVisible !== false) {
        _this.setState({
          isFocusVisible: false
        });
      }
    });

    _defineProperty$S(_assertThisInitialized$o(_this), "renderPreviousMonthButton", function (_ref2) {
      var locale = _ref2.locale,
          theme = _ref2.theme;

      var date = _this.getDateProp();

      var _this$props3 = _this.props,
          _this$props3$override = _this$props3.overrides,
          overrides = _this$props3$override === void 0 ? {} : _this$props3$override,
          density = _this$props3.density;

      var allPrevDaysDisabled = _this.dateHelpers.monthDisabledBefore(date, _this.props);

      var isDisabled = false;

      if (allPrevDaysDisabled) {
        isDisabled = true;
      }

      var nextMonth = _this.dateHelpers.subMonths(date, 1);

      var minYear = _this.props.minDate ? _this.dateHelpers.getYear(_this.props.minDate) : MIN_YEAR;

      if (_this.dateHelpers.getYear(nextMonth) < minYear) {
        isDisabled = true;
      }

      var isHidden = _this.isHiddenPaginationButton(DIRECTION.PREVIOUS);

      if (isHidden) {
        isDisabled = true;
      }

      var _getOverrides = getOverrides(overrides.PrevButton, StyledPrevButton),
          _getOverrides2 = _slicedToArray$A(_getOverrides, 2),
          PrevButton = _getOverrides2[0],
          prevButtonProps = _getOverrides2[1];

      var _getOverrides3 = getOverrides(overrides.PrevButtonIcon, theme.direction === 'rtl' ? ChevronRight$2 : ChevronLeft$2),
          _getOverrides4 = _slicedToArray$A(_getOverrides3, 2),
          PrevButtonIcon = _getOverrides4[0],
          prevButtonIconProps = _getOverrides4[1];

      var clickHandler = _this.decreaseMonth;

      if (allPrevDaysDisabled) {
        clickHandler = null;
      }

      return /*#__PURE__*/React$2.createElement(PrevButton, _extends$B({
        "aria-label": locale.datepicker.previousMonth,
        tabIndex: 0,
        onClick: clickHandler,
        disabled: isDisabled,
        $isFocusVisible: _this.state.isFocusVisible,
        type: "button",
        $disabled: isDisabled,
        $order: _this.props.order
      }, prevButtonProps), isHidden ? null : /*#__PURE__*/React$2.createElement(PrevButtonIcon, _extends$B({
        size: density === DENSITY.high ? 24 : 36,
        overrides: {
          Svg: {
            style: navBtnStyle
          }
        }
      }, prevButtonIconProps)));
    });

    _defineProperty$S(_assertThisInitialized$o(_this), "renderNextMonthButton", function (_ref3) {
      var locale = _ref3.locale,
          theme = _ref3.theme;

      var date = _this.getDateProp();

      var _this$props4 = _this.props,
          _this$props4$override = _this$props4.overrides,
          overrides = _this$props4$override === void 0 ? {} : _this$props4$override,
          density = _this$props4.density;

      var allNextDaysDisabled = _this.dateHelpers.monthDisabledAfter(date, _this.props);

      var isDisabled = false;

      if (allNextDaysDisabled) {
        isDisabled = true;
      }

      var nextMonth = _this.dateHelpers.addMonths(date, 1);

      var maxYear = _this.props.maxDate ? _this.dateHelpers.getYear(_this.props.maxDate) : MAX_YEAR;

      if (_this.dateHelpers.getYear(nextMonth) > maxYear) {
        isDisabled = true;
      }

      var isHidden = _this.isHiddenPaginationButton(DIRECTION.NEXT);

      if (isHidden) {
        isDisabled = true;
      }

      var _getOverrides5 = getOverrides(overrides.NextButton, StyledNextButton),
          _getOverrides6 = _slicedToArray$A(_getOverrides5, 2),
          NextButton = _getOverrides6[0],
          nextButtonProps = _getOverrides6[1];

      var _getOverrides7 = getOverrides(overrides.NextButtonIcon, theme.direction === 'rtl' ? ChevronLeft$2 : ChevronRight$2),
          _getOverrides8 = _slicedToArray$A(_getOverrides7, 2),
          NextButtonIcon = _getOverrides8[0],
          nextButtonIconProps = _getOverrides8[1];

      var clickHandler = _this.increaseMonth; // The other option is to always provide a click handler and let customers
      // override its functionality based on the `$allPrevDaysDisabled` prop
      // in a custom NextButton component override
      // Their options would be to render `null` or not apply the components handler
      // on click or do nothing

      if (allNextDaysDisabled) {
        clickHandler = null;
      }

      return /*#__PURE__*/React$2.createElement(NextButton, _extends$B({
        "aria-label": locale.datepicker.nextMonth,
        tabIndex: 0,
        onClick: clickHandler,
        disabled: isDisabled,
        type: "button",
        $disabled: isDisabled,
        $isFocusVisible: _this.state.isFocusVisible,
        $order: _this.props.order
      }, nextButtonProps), isHidden ? null : /*#__PURE__*/React$2.createElement(NextButtonIcon, _extends$B({
        size: density === DENSITY.high ? 24 : 36,
        overrides: {
          Svg: {
            style: navBtnStyle
          }
        }
      }, nextButtonIconProps)));
    });

    _defineProperty$S(_assertThisInitialized$o(_this), "canArrowsOpenDropdown", function (event) {
      if (!_this.state.isMonthDropdownOpen && !_this.state.isYearDropdownOpen) {
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
          return true;
        }
      }

      return false;
    });

    _defineProperty$S(_assertThisInitialized$o(_this), "renderMonthYearDropdown", function () {
      var date = _this.getDateProp();

      var month = _this.dateHelpers.getMonth(date);

      var year = _this.dateHelpers.getYear(date);

      var _this$props5 = _this.props,
          locale = _this$props5.locale,
          _this$props5$override = _this$props5.overrides,
          overrides = _this$props5$override === void 0 ? {} : _this$props5$override,
          density = _this$props5.density;

      var _getOverrides9 = getOverrides(overrides.MonthYearSelectButton, StyledMonthYearSelectButton),
          _getOverrides10 = _slicedToArray$A(_getOverrides9, 2),
          MonthYearSelectButton = _getOverrides10[0],
          monthYearSelectButtonProps = _getOverrides10[1];

      var _getOverrides11 = getOverrides(overrides.MonthYearSelectIconContainer, StyledMonthYearSelectIconContainer),
          _getOverrides12 = _slicedToArray$A(_getOverrides11, 2),
          MonthYearSelectIconContainer = _getOverrides12[0],
          monthYearSelectIconContainerProps = _getOverrides12[1];

      var _getOverrides13 = getOverrides(overrides.MonthYearSelectPopover, Popover$1),
          _getOverrides14 = _slicedToArray$A(_getOverrides13, 2),
          OverriddenPopover = _getOverrides14[0],
          popoverProps = _getOverrides14[1];

      var _getOverrides15 = getOverrides(overrides.MonthYearSelectStatefulMenu, StatefulMenu$1),
          _getOverrides16 = _slicedToArray$A(_getOverrides15, 2),
          OverriddenStatefulMenu = _getOverrides16[0],
          menuProps = _getOverrides16[1];

      menuProps.overrides = mergeOverrides({
        List: {
          style: {
            height: 'auto',
            maxHeight: '257px'
          }
        }
      }, menuProps && menuProps.overrides);

      var initialMonthIndex = _this.monthItems.findIndex(function (month) {
        return month.id === _this.dateHelpers.getMonth(date).toString();
      });

      var initialYearIndex = _this.yearItems.findIndex(function (year) {
        return year.id === _this.dateHelpers.getYear(date).toString();
      });

      var monthTitle = "".concat(_this.dateHelpers.getMonthInLocale(_this.dateHelpers.getMonth(date), locale));
      var yearTitle = "".concat(_this.dateHelpers.getYear(date));
      return _this.isMultiMonthHorizontal() ? /*#__PURE__*/React$2.createElement("div", null, "".concat(monthTitle, " ").concat(yearTitle)) : /*#__PURE__*/React$2.createElement(React$2.Fragment, null, /*#__PURE__*/React$2.createElement(OverriddenPopover, _extends$B({
        placement: "bottom",
        autoFocus: true,
        focusLock: true,
        isOpen: _this.state.isMonthDropdownOpen,
        onClick: function onClick() {
          _this.setState(function (prev) {
            return {
              isMonthDropdownOpen: !prev.isMonthDropdownOpen
            };
          });
        },
        onClickOutside: function onClickOutside() {
          return _this.setState({
            isMonthDropdownOpen: false
          });
        },
        onEsc: function onEsc() {
          return _this.setState({
            isMonthDropdownOpen: false
          });
        },
        content: function content() {
          return /*#__PURE__*/React$2.createElement(OverriddenStatefulMenu, _extends$B({
            initialState: {
              highlightedIndex: initialMonthIndex,
              isFocused: true
            },
            items: _this.monthItems,
            onItemSelect: function onItemSelect(_ref4) {
              var item = _ref4.item,
                  event = _ref4.event;
              event.preventDefault();
              var month = idToYearMonth(item.id);

              var updatedDate = _this.dateHelpers.set(date, {
                year: year,
                month: month
              });

              _this.props.onMonthChange && _this.props.onMonthChange({
                date: updatedDate
              });

              _this.setState({
                isMonthDropdownOpen: false
              });
            }
          }, menuProps));
        }
      }, popoverProps), /*#__PURE__*/React$2.createElement(MonthYearSelectButton, _extends$B({
        "aria-live": "polite",
        type: "button",
        $isFocusVisible: _this.state.isFocusVisible,
        $density: density,
        onKeyUp: function onKeyUp(event) {
          if (_this.canArrowsOpenDropdown(event)) {
            _this.setState({
              isMonthDropdownOpen: true
            });
          }
        },
        onKeyDown: function onKeyDown(event) {
          if (_this.canArrowsOpenDropdown(event)) {
            // disables page scroll
            event.preventDefault();
          }

          if (event.key === 'Tab') {
            _this.setState({
              isMonthDropdownOpen: false
            });
          }
        }
      }, monthYearSelectButtonProps), monthTitle, /*#__PURE__*/React$2.createElement(MonthYearSelectIconContainer, monthYearSelectIconContainerProps, /*#__PURE__*/React$2.createElement(ChevronDown$2, {
        title: "",
        overrides: {
          Svg: {
            props: {
              role: 'presentation'
            }
          }
        },
        size: density === DENSITY.high ? 16 : 24
      })))), /*#__PURE__*/React$2.createElement(OverriddenPopover, _extends$B({
        placement: "bottom",
        focusLock: true,
        isOpen: _this.state.isYearDropdownOpen,
        onClick: function onClick() {
          _this.setState(function (prev) {
            return {
              isYearDropdownOpen: !prev.isYearDropdownOpen
            };
          });
        },
        onClickOutside: function onClickOutside() {
          return _this.setState({
            isYearDropdownOpen: false
          });
        },
        onEsc: function onEsc() {
          return _this.setState({
            isYearDropdownOpen: false
          });
        },
        content: function content() {
          return /*#__PURE__*/React$2.createElement(OverriddenStatefulMenu, _extends$B({
            initialState: {
              highlightedIndex: initialYearIndex,
              isFocused: true
            },
            items: _this.yearItems,
            onItemSelect: function onItemSelect(_ref5) {
              var item = _ref5.item,
                  event = _ref5.event;
              event.preventDefault();
              var year = idToYearMonth(item.id);

              var updatedDate = _this.dateHelpers.set(date, {
                year: year,
                month: month
              });

              _this.props.onYearChange && _this.props.onYearChange({
                date: updatedDate
              });

              _this.setState({
                isYearDropdownOpen: false
              });
            }
          }, menuProps));
        }
      }, popoverProps), /*#__PURE__*/React$2.createElement(MonthYearSelectButton, _extends$B({
        "aria-live": "polite",
        type: "button",
        $isFocusVisible: _this.state.isFocusVisible,
        $density: density,
        onKeyUp: function onKeyUp(event) {
          if (_this.canArrowsOpenDropdown(event)) {
            _this.setState({
              isYearDropdownOpen: true
            });
          }
        },
        onKeyDown: function onKeyDown(event) {
          if (_this.canArrowsOpenDropdown(event)) {
            // disables page scroll
            event.preventDefault();
          }

          if (event.key === 'Tab') {
            _this.setState({
              isYearDropdownOpen: false
            });
          }
        }
      }, monthYearSelectButtonProps), yearTitle, /*#__PURE__*/React$2.createElement(MonthYearSelectIconContainer, monthYearSelectIconContainerProps, /*#__PURE__*/React$2.createElement(ChevronDown$2, {
        title: "",
        overrides: {
          Svg: {
            props: {
              role: 'presentation'
            }
          }
        },
        size: density === DENSITY.high ? 16 : 24
      })))));
    });

    _this.dateHelpers = new DateHelpers$1(props.adapter);
    _this.monthItems = [];
    _this.yearItems = [];
    return _this;
  }

  _createClass$p(CalendarHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getYearItems();
      this.getMonthItems();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var selectedMonthDidChange = this.dateHelpers.getMonth(this.props.date) !== this.dateHelpers.getMonth(prevProps.date);
      var selectedYearDidChange = this.dateHelpers.getYear(this.props.date) !== this.dateHelpers.getYear(prevProps.date);

      if (selectedMonthDidChange) {
        // re-calculate yearItems
        this.getYearItems();
      }

      if (selectedYearDidChange) {
        // re-calculate monthItems
        this.getMonthItems();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props6 = this.props,
          _this$props6$override = _this$props6.overrides,
          overrides = _this$props6$override === void 0 ? {} : _this$props6$override,
          density = _this$props6.density;

      var _getOverrides17 = getOverrides(overrides.CalendarHeader, StyledCalendarHeader),
          _getOverrides18 = _slicedToArray$A(_getOverrides17, 2),
          _CalendarHeader = _getOverrides18[0],
          calendarHeaderProps = _getOverrides18[1];

      var _getOverrides19 = getOverrides(overrides.MonthHeader, StyledMonthHeader),
          _getOverrides20 = _slicedToArray$A(_getOverrides19, 2),
          MonthHeader = _getOverrides20[0],
          monthHeaderProps = _getOverrides20[1];

      var _getOverrides21 = getOverrides(overrides.WeekdayHeader, StyledWeekdayHeader),
          _getOverrides22 = _slicedToArray$A(_getOverrides21, 2),
          WeekdayHeader = _getOverrides22[0],
          weekdayHeaderProps = _getOverrides22[1];

      var startOfWeek = this.dateHelpers.getStartOfWeek(this.getDateProp(), this.props.locale);
      return /*#__PURE__*/React$2.createElement(ThemeContext.Consumer, null, function (theme) {
        return /*#__PURE__*/React$2.createElement(LocaleContext.Consumer, null, function (locale) {
          return /*#__PURE__*/React$2.createElement(React$2.Fragment, null, /*#__PURE__*/React$2.createElement(_CalendarHeader, _extends$B({}, calendarHeaderProps, {
            $density: _this2.props.density,
            onFocus: forkFocus(calendarHeaderProps, _this2.handleFocus),
            onBlur: forkBlur(calendarHeaderProps, _this2.handleBlur)
          }), _this2.renderPreviousMonthButton({
            locale: locale,
            theme: theme
          }), _this2.renderMonthYearDropdown(), _this2.renderNextMonthButton({
            locale: locale,
            theme: theme
          })), /*#__PURE__*/React$2.createElement(MonthHeader, _extends$B({
            role: "presentation"
          }, monthHeaderProps), WEEKDAYS.map(function (offset) {
            var day = _this2.dateHelpers.addDays(startOfWeek, offset);

            return /*#__PURE__*/React$2.createElement(WeekdayHeader, _extends$B({
              key: offset,
              alt: _this2.dateHelpers.getWeekdayInLocale(day, _this2.props.locale)
            }, weekdayHeaderProps, {
              $density: density
            }), _this2.dateHelpers.getWeekdayMinInLocale(day, _this2.props.locale));
          })));
        });
      });
    }
  }]);

  return CalendarHeader;
}(React$2.Component);

_defineProperty$S(CalendarHeader, "defaultProps", {
  adapter: defaultAdapter,
  locale: null,
  maxDate: null,
  minDate: null,
  onYearChange: function onYearChange() {},
  overrides: {}
});

function _typeof$o(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$o = function _typeof(obj) { return typeof obj; }; } else { _typeof$o = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$o(obj); }

function _extends$A() { _extends$A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

function _slicedToArray$z(arr, i) { return _arrayWithHoles$z(arr) || _iterableToArrayLimit$z(arr, i) || _unsupportedIterableToArray$B(arr, i) || _nonIterableRest$z(); }

function _nonIterableRest$z() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$B(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$B(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$B(o, minLen); }

function _arrayLikeToArray$B(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$z(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$z(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$o(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$n(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$o(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$n(Constructor.prototype, protoProps); if (staticProps) _defineProperties$n(Constructor, staticProps); return Constructor; }

function _inherits$o(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$n(subClass, superClass); }

function _setPrototypeOf$n(o, p) { _setPrototypeOf$n = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$n(o, p); }

function _createSuper$n(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$n(); return function _createSuperInternal() { var Super = _getPrototypeOf$n(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$n(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$o(this, result); }; }

function _possibleConstructorReturn$o(self, call) { if (call && (_typeof$o(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$n(self); }

function _assertThisInitialized$n(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$n() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$n(o) { _getPrototypeOf$n = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$n(o); }

function _defineProperty$R(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Day = /*#__PURE__*/function (_React$Component) {
  _inherits$o(Day, _React$Component);

  var _super = _createSuper$n(Day);

  function Day(props) {
    var _this;

    _classCallCheck$o(this, Day);

    _this = _super.call(this, props);

    _defineProperty$R(_assertThisInitialized$n(_this), "dayElm", void 0);

    _defineProperty$R(_assertThisInitialized$n(_this), "state", {
      isHovered: false,
      isFocusVisible: false
    });

    _defineProperty$R(_assertThisInitialized$n(_this), "dateHelpers", void 0);

    _defineProperty$R(_assertThisInitialized$n(_this), "getDateProp", function () {
      return _this.props.date === undefined ? _this.dateHelpers.date() : _this.props.date;
    });

    _defineProperty$R(_assertThisInitialized$n(_this), "getMonthProp", function () {
      return _this.props.month === undefined || _this.props.month === null ? _this.dateHelpers.getMonth(_this.getDateProp()) : _this.props.month;
    });

    _defineProperty$R(_assertThisInitialized$n(_this), "onSelect", function (selectedDate) {
      var _this$props = _this.props,
          range = _this$props.range,
          value = _this$props.value;
      var date;

      if (Array.isArray(value) && range) {
        if (!value.length || value.length > 1) {
          date = [selectedDate];
        } else if (_this.dateHelpers.isAfter(selectedDate, value[0])) {
          date = [value[0], selectedDate];
        } else {
          date = [selectedDate, value[0]];
        }
      } else {
        date = selectedDate;
      }

      _this.props.onSelect({
        date: date
      });
    });

    _defineProperty$R(_assertThisInitialized$n(_this), "onKeyDown", function (event) {
      var date = _this.getDateProp();

      var _this$props2 = _this.props,
          highlighted = _this$props2.highlighted,
          disabled = _this$props2.disabled;

      if (event.key === 'Enter' && highlighted && !disabled) {
        event.preventDefault();

        _this.onSelect(date);
      }
    });

    _defineProperty$R(_assertThisInitialized$n(_this), "onClick", function (event) {
      var date = _this.getDateProp();

      var disabled = _this.props.disabled;

      if (!disabled) {
        _this.props.onClick({
          event: event,
          date: date
        });

        _this.onSelect(date);
      }
    });

    _defineProperty$R(_assertThisInitialized$n(_this), "onFocus", function (event) {
      if (isFocusVisible(event)) {
        _this.setState({
          isFocusVisible: true
        });
      }

      _this.props.onFocus({
        event: event,
        date: _this.getDateProp()
      });
    });

    _defineProperty$R(_assertThisInitialized$n(_this), "onBlur", function (event) {
      if (_this.state.isFocusVisible !== false) {
        _this.setState({
          isFocusVisible: false
        });
      }

      _this.props.onBlur({
        event: event,
        date: _this.getDateProp()
      });
    });

    _defineProperty$R(_assertThisInitialized$n(_this), "onMouseOver", function (event) {
      _this.setState({
        isHovered: true
      });

      _this.props.onMouseOver({
        event: event,
        date: _this.getDateProp()
      });
    });

    _defineProperty$R(_assertThisInitialized$n(_this), "onMouseLeave", function (event) {
      _this.setState({
        isHovered: false
      });

      _this.props.onMouseLeave({
        event: event,
        date: _this.getDateProp()
      });
    });

    _defineProperty$R(_assertThisInitialized$n(_this), "isOutsideMonth", function () {
      var month = _this.getMonthProp();

      return month !== undefined && month !== _this.dateHelpers.getMonth(_this.getDateProp());
    });

    _defineProperty$R(_assertThisInitialized$n(_this), "getOrderedDates", function () {
      var _this$props3 = _this.props,
          highlightedDate = _this$props3.highlightedDate,
          value = _this$props3.value;

      if (!value || !Array.isArray(value) || !value[0] || !value[1] && !highlightedDate) {
        return [];
      }

      var firstValue = value[0];
      var secondValue = value.length > 1 && value[1] ? value[1] : highlightedDate;

      if (!firstValue || !secondValue) {
        return [];
      }

      var firstDate = _this.clampToDayStart(firstValue);

      var secondDate = _this.clampToDayStart(secondValue);

      return _this.dateHelpers.isAfter(firstDate, secondDate) ? [secondDate, firstDate] : [firstDate, secondDate];
    });

    _defineProperty$R(_assertThisInitialized$n(_this), "isOutsideOfMonthButWithinRange", function () {
      var date = _this.clampToDayStart(_this.getDateProp());

      var dates = _this.getOrderedDates();

      if (dates.length < 2 || _this.dateHelpers.isSameDay(dates[0], dates[1])) {
        return false;
      }

      var day = _this.dateHelpers.getDate(date);
      /**
       * Empty days (no number label) at the beginning/end of the month should be included
       * within the range if the last day of a month and the first day of the next month are
       * within the range.
       */


      if (day > 15) {
        var firstDayOfNextMonth = _this.clampToDayStart(_this.dateHelpers.addDays(_this.dateHelpers.getEndOfMonth(date), 1));

        return _this.dateHelpers.isOnOrBeforeDay(dates[0], _this.dateHelpers.getEndOfMonth(date)) && _this.dateHelpers.isOnOrAfterDay(dates[1], firstDayOfNextMonth);
      } else {
        var lastDayOfPreviousMonth = _this.clampToDayStart(_this.dateHelpers.subDays(_this.dateHelpers.getStartOfMonth(date), 1));

        return _this.dateHelpers.isOnOrAfterDay(dates[1], _this.dateHelpers.getStartOfMonth(date)) && _this.dateHelpers.isOnOrBeforeDay(dates[0], lastDayOfPreviousMonth);
      }
    });

    _defineProperty$R(_assertThisInitialized$n(_this), "clampToDayStart", function (dt) {
      var _this$dateHelpers = _this.dateHelpers,
          setSeconds = _this$dateHelpers.setSeconds,
          setMinutes = _this$dateHelpers.setMinutes,
          setHours = _this$dateHelpers.setHours;
      return setSeconds(setMinutes(setHours(dt, 0), 0), 0);
    });

    _this.dateHelpers = new DateHelpers$1(props.adapter);
    return _this;
  }

  _createClass$o(Day, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.dayElm && this.props.focusedCalendar) {
        if (this.props.highlighted || !this.props.highlightedDate && this.isSelected()) {
          this.dayElm.focus();
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.dayElm && this.props.focusedCalendar) {
        if (this.props.highlighted || !this.props.highlightedDate && this.isSelected()) {
          this.dayElm.focus();
        }
      }
    }
  }, {
    key: "isSelected",
    value: function isSelected() {
      var date = this.getDateProp();
      var value = this.props.value;

      if (Array.isArray(value)) {
        return this.dateHelpers.isSameDay(date, value[0]) || this.dateHelpers.isSameDay(date, value[1]);
      } else {
        return this.dateHelpers.isSameDay(date, value);
      }
    }
  }, {
    key: "isPseudoSelected",
    value: // calculated for range case only
    function isPseudoSelected() {
      var date = this.getDateProp();
      var value = this.props.value;

      if (Array.isArray(value) && !value[0] && !value[1]) {
        return false;
      } // fix flow by passing a specific arg type and remove 'Array.isArray(value)'


      if (Array.isArray(value) && value.length > 1) {
        return this.dateHelpers.isDayInRange(this.clampToDayStart(date), this.clampToDayStart(value[0]), this.clampToDayStart(value[1]));
      }
    } // calculated for range case only

  }, {
    key: "isPseudoHighlighted",
    value: function isPseudoHighlighted() {
      var date = this.getDateProp();
      var _this$props4 = this.props,
          value = _this$props4.value,
          highlightedDate = _this$props4.highlightedDate;

      if (Array.isArray(value) && !value[0] && !value[1]) {
        return false;
      } // fix flow by passing a specific arg type and remove 'Array.isArray(value)'


      if (Array.isArray(value) && highlightedDate && value[0] && !value[1]) {
        if (this.dateHelpers.isAfter(highlightedDate, value[0])) {
          return this.dateHelpers.isDayInRange(this.clampToDayStart(date), this.clampToDayStart(value[0]), this.clampToDayStart(highlightedDate));
        } else {
          return this.dateHelpers.isDayInRange(this.clampToDayStart(date), this.clampToDayStart(highlightedDate), this.clampToDayStart(value[0]));
        }
      }
    }
  }, {
    key: "getSharedProps",
    value: function getSharedProps() {
      var date = this.getDateProp();
      var _this$props5 = this.props,
          value = _this$props5.value,
          highlightedDate = _this$props5.highlightedDate,
          range = _this$props5.range,
          highlighted = _this$props5.highlighted;
      var $isHighlighted = highlighted;
      var $selected = this.isSelected();
      var $hasRangeHighlighted = !!(Array.isArray(value) && range && value.length === 1 && highlightedDate && !this.dateHelpers.isSameDay(value[0], highlightedDate));
      var $outsideMonth = !this.props.peekNextMonth && this.isOutsideMonth();
      var $outsideMonthWithinRange = !!(Array.isArray(value) && range && $outsideMonth && !this.props.peekNextMonth && this.isOutsideOfMonthButWithinRange());
      return {
        $date: date,
        $density: this.props.density,
        $disabled: this.props.disabled,
        $endDate: Array.isArray(value) && this.props.range && $selected && this.dateHelpers.isSameDay(date, value[1]) || false,
        $hasDateLabel: !!this.props.dateLabel,
        $hasRangeHighlighted: $hasRangeHighlighted,
        $hasRangeOnRight: Array.isArray(value) && $hasRangeHighlighted && highlightedDate && value[0] && this.dateHelpers.isAfter(highlightedDate, value[0]),
        $hasRangeSelected: Array.isArray(value) ? value.length === 2 : false,
        $highlightedDate: highlightedDate,
        $isHighlighted: $isHighlighted,
        $isHovered: this.state.isHovered,
        $isFocusVisible: this.state.isFocusVisible,
        $startOfMonth: this.dateHelpers.isStartOfMonth(date),
        $endOfMonth: this.dateHelpers.isEndOfMonth(date),
        $month: this.getMonthProp(),
        $outsideMonth: $outsideMonth,
        $outsideMonthWithinRange: $outsideMonthWithinRange,
        $peekNextMonth: this.props.peekNextMonth,
        $pseudoHighlighted: this.props.range && !$isHighlighted && !$selected ? this.isPseudoHighlighted() : false,
        $pseudoSelected: this.props.range && !$selected ? this.isPseudoSelected() : false,
        $range: this.props.range,
        $selected: $selected,
        $startDate: Array.isArray(this.props.value) && this.props.value.length > 1 && this.props.range && $selected ? this.dateHelpers.isSameDay(date, this.props.value[0]) : false
      };
    }
  }, {
    key: "getAriaLabel",
    value: function getAriaLabel(sharedProps, localeContext) {
      var date = this.getDateProp();
      return "".concat(sharedProps.$selected ? sharedProps.$range ? sharedProps.$endDate ? localeContext.datepicker.selectedEndDateLabel : localeContext.datepicker.selectedStartDateLabel : localeContext.datepicker.selectedLabel : sharedProps.$disabled ? localeContext.datepicker.dateNotAvailableLabel : localeContext.datepicker.chooseLabel, " ").concat(this.dateHelpers.format(date, 'fullOrdinalWeek', this.props.locale), ". ").concat(!sharedProps.$disabled ? localeContext.datepicker.dateAvailableLabel : '');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var date = this.getDateProp();
      var _this$props6 = this.props,
          peekNextMonth = _this$props6.peekNextMonth,
          _this$props6$override = _this$props6.overrides,
          overrides = _this$props6$override === void 0 ? {} : _this$props6$override;
      var sharedProps = this.getSharedProps();

      var _getOverrides = getOverrides(overrides.Day, StyledDay),
          _getOverrides2 = _slicedToArray$z(_getOverrides, 2),
          _Day = _getOverrides2[0],
          dayProps = _getOverrides2[1];

      var _getOverrides3 = getOverrides(overrides.DayLabel, StyledDayLabel),
          _getOverrides4 = _slicedToArray$z(_getOverrides3, 2),
          DayLabel = _getOverrides4[0],
          dayLabelProps = _getOverrides4[1];

      var dateLabel = this.props.dateLabel && this.props.dateLabel(date);
      return !peekNextMonth && sharedProps.$outsideMonth ? /*#__PURE__*/React$2.createElement(_Day, _extends$A({
        role: "gridcell"
      }, sharedProps, dayProps, {
        onFocus: this.onFocus,
        onBlur: this.onBlur
      })) :
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
      React$2.createElement(LocaleContext.Consumer, null, function (locale) {
        return /*#__PURE__*/React$2.createElement(_Day, _extends$A({
          "aria-label": _this2.getAriaLabel(sharedProps, locale),
          ref: function ref(dayElm) {
            _this2.dayElm = dayElm;
          },
          role: "gridcell",
          "aria-roledescription": "button",
          tabIndex: _this2.props.highlighted || !_this2.props.highlightedDate && _this2.isSelected() ? 0 : -1
        }, sharedProps, dayProps, {
          // Adding event handlers after customers overrides in order to
          // make sure the components functions as expected
          // We can extract the handlers from props overrides
          // and call it along with internal handlers by creating an inline handler
          onFocus: _this2.onFocus,
          onBlur: _this2.onBlur,
          onClick: _this2.onClick,
          onKeyDown: _this2.onKeyDown,
          onMouseOver: _this2.onMouseOver,
          onMouseLeave: _this2.onMouseLeave
        }), /*#__PURE__*/React$2.createElement("div", null, _this2.dateHelpers.getDate(date)), dateLabel ? /*#__PURE__*/React$2.createElement(DayLabel, _extends$A({}, sharedProps, dayLabelProps), dateLabel) : null);
      });
    }
  }]);

  return Day;
}(React$2.Component);

_defineProperty$R(Day, "defaultProps", {
  disabled: false,
  highlighted: false,
  range: false,
  adapter: defaultAdapter,
  onClick: function onClick() {},
  onSelect: function onSelect() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onMouseOver: function onMouseOver() {},
  onMouseLeave: function onMouseLeave() {},
  overrides: {},
  peekNextMonth: true,
  value: null
});

function _typeof$n(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$n = function _typeof(obj) { return typeof obj; }; } else { _typeof$n = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$n(obj); }

function _extends$z() { _extends$z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

function _slicedToArray$y(arr, i) { return _arrayWithHoles$y(arr) || _iterableToArrayLimit$y(arr, i) || _unsupportedIterableToArray$A(arr, i) || _nonIterableRest$y(); }

function _nonIterableRest$y() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$A(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$A(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$A(o, minLen); }

function _arrayLikeToArray$A(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$y(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$y(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$n(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$m(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$n(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$m(Constructor.prototype, protoProps); if (staticProps) _defineProperties$m(Constructor, staticProps); return Constructor; }

function _inherits$n(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$m(subClass, superClass); }

function _setPrototypeOf$m(o, p) { _setPrototypeOf$m = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$m(o, p); }

function _createSuper$m(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$m(); return function _createSuperInternal() { var Super = _getPrototypeOf$m(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$m(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$n(this, result); }; }

function _possibleConstructorReturn$n(self, call) { if (call && (_typeof$n(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$m(self); }

function _assertThisInitialized$m(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$m() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$m(o) { _getPrototypeOf$m = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$m(o); }

function _defineProperty$Q(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Week = /*#__PURE__*/function (_React$Component) {
  _inherits$n(Week, _React$Component);

  var _super = _createSuper$m(Week);

  function Week(props) {
    var _this;

    _classCallCheck$n(this, Week);

    _this = _super.call(this, props);

    _defineProperty$Q(_assertThisInitialized$m(_this), "dateHelpers", void 0);

    _defineProperty$Q(_assertThisInitialized$m(_this), "renderDays", function () {
      var startOfWeek = _this.dateHelpers.getStartOfWeek(_this.props.date || _this.dateHelpers.date(), _this.props.locale);

      var days = []; // $FlowFixMe

      return days.concat(WEEKDAYS.map(function (offset) {
        var day = _this.dateHelpers.addDays(startOfWeek, offset);

        return (
          /*#__PURE__*/
          // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
          React$2.createElement(Day, {
            adapter: _this.props.adapter,
            date: day,
            dateLabel: _this.props.dateLabel,
            density: _this.props.density,
            disabled: _this.dateHelpers.isDayDisabled(day, _this.props),
            excludeDates: _this.props.excludeDates,
            filterDate: _this.props.filterDate,
            highlightedDate: _this.props.highlightedDate,
            highlighted: _this.dateHelpers.isSameDay(day, _this.props.highlightedDate),
            includeDates: _this.props.includeDates,
            focusedCalendar: _this.props.focusedCalendar,
            range: _this.props.range,
            key: offset,
            locale: _this.props.locale,
            minDate: _this.props.minDate,
            maxDate: _this.props.maxDate,
            month: _this.props.month,
            onSelect: _this.props.onChange,
            onBlur: _this.props.onDayBlur,
            onFocus: _this.props.onDayFocus,
            onClick: _this.props.onDayClick,
            onMouseOver: _this.props.onDayMouseOver,
            onMouseLeave: _this.props.onDayMouseLeave,
            overrides: _this.props.overrides,
            peekNextMonth: _this.props.peekNextMonth,
            value: _this.props.value
          })
        );
      }));
    });

    _this.dateHelpers = new DateHelpers$1(props.adapter);
    return _this;
  }

  _createClass$n(Week, [{
    key: "render",
    value: function render() {
      var _this$props$overrides = this.props.overrides,
          overrides = _this$props$overrides === void 0 ? {} : _this$props$overrides;

      var _getOverrides = getOverrides(overrides.Week, StyledWeek),
          _getOverrides2 = _slicedToArray$y(_getOverrides, 2),
          _Week = _getOverrides2[0],
          weekProps = _getOverrides2[1];

      return /*#__PURE__*/React$2.createElement(_Week, _extends$z({
        role: "row"
      }, weekProps), this.renderDays());
    }
  }]);

  return Week;
}(React$2.Component);

_defineProperty$Q(Week, "defaultProps", {
  adapter: defaultAdapter,
  highlightedDate: null,
  onDayClick: function onDayClick() {},
  onDayFocus: function onDayFocus() {},
  onDayBlur: function onDayBlur() {},
  onDayMouseOver: function onDayMouseOver() {},
  onDayMouseLeave: function onDayMouseLeave() {},
  onChange: function onChange() {},
  overrides: {},
  peekNextMonth: false
});

function _typeof$m(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$m = function _typeof(obj) { return typeof obj; }; } else { _typeof$m = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$m(obj); }

function _slicedToArray$x(arr, i) { return _arrayWithHoles$x(arr) || _iterableToArrayLimit$x(arr, i) || _unsupportedIterableToArray$z(arr, i) || _nonIterableRest$x(); }

function _nonIterableRest$x() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$z(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$z(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$z(o, minLen); }

function _arrayLikeToArray$z(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$x(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$x(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$m(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$l(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$m(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$l(Constructor.prototype, protoProps); if (staticProps) _defineProperties$l(Constructor, staticProps); return Constructor; }

function _inherits$m(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$l(subClass, superClass); }

function _setPrototypeOf$l(o, p) { _setPrototypeOf$l = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$l(o, p); }

function _createSuper$l(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$l(); return function _createSuperInternal() { var Super = _getPrototypeOf$l(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$l(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$m(this, result); }; }

function _possibleConstructorReturn$m(self, call) { if (call && (_typeof$m(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$l(self); }

function _assertThisInitialized$l(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$l() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$l(o) { _getPrototypeOf$l = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$l(o); }

function _defineProperty$P(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var defaultProps$2 = {
  dateLabel: null,
  density: DENSITY.high,
  excludeDates: null,
  filterDate: null,
  highlightDates: null,
  includeDates: null,
  locale: null,
  maxDate: null,
  minDate: null,
  month: null,
  adapter: defaultAdapter,
  onDayClick: function onDayClick() {},
  onDayFocus: function onDayFocus() {},
  onDayBlur: function onDayBlur() {},
  onDayMouseOver: function onDayMouseOver() {},
  onDayMouseLeave: function onDayMouseLeave() {},
  overrides: {},
  peekNextMonth: false,
  value: null
};
var CALENDAR_MAX_ROWS = 6;

var CalendarMonth = /*#__PURE__*/function (_React$Component) {
  _inherits$m(CalendarMonth, _React$Component);

  var _super = _createSuper$l(CalendarMonth);

  function CalendarMonth(props) {
    var _this;

    _classCallCheck$m(this, CalendarMonth);

    _this = _super.call(this, props);

    _defineProperty$P(_assertThisInitialized$l(_this), "dateHelpers", void 0);

    _defineProperty$P(_assertThisInitialized$l(_this), "getDateProp", function () {
      return _this.props.date || _this.dateHelpers.date();
    });

    _defineProperty$P(_assertThisInitialized$l(_this), "isWeekInMonth", function (startOfWeek) {
      var date = _this.getDateProp();

      var endOfWeek = _this.dateHelpers.addDays(startOfWeek, 6);

      return _this.dateHelpers.isSameMonth(startOfWeek, date) || _this.dateHelpers.isSameMonth(endOfWeek, date);
    });

    _defineProperty$P(_assertThisInitialized$l(_this), "renderWeeks", function () {
      var weeks = [];

      var currentWeekStart = _this.dateHelpers.getStartOfWeek(_this.dateHelpers.getStartOfMonth(_this.getDateProp()), _this.props.locale);

      var i = 0;
      var isWithinMonth = true;

      while (isWithinMonth || _this.props.fixedHeight && _this.props.peekNextMonth && i < CALENDAR_MAX_ROWS) {
        weeks.push( /*#__PURE__*/React$2.createElement(Week, {
          adapter: _this.props.adapter,
          date: currentWeekStart,
          dateLabel: _this.props.dateLabel,
          density: _this.props.density,
          excludeDates: _this.props.excludeDates,
          filterDate: _this.props.filterDate,
          highlightedDate: _this.props.highlightedDate,
          includeDates: _this.props.includeDates,
          focusedCalendar: _this.props.focusedCalendar,
          range: _this.props.range,
          key: i,
          locale: _this.props.locale,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          month: _this.dateHelpers.getMonth(_this.getDateProp()),
          onDayBlur: _this.props.onDayBlur,
          onDayFocus: _this.props.onDayFocus,
          onDayClick: _this.props.onDayClick,
          onDayMouseOver: _this.props.onDayMouseOver,
          onDayMouseLeave: _this.props.onDayMouseLeave,
          onChange: _this.props.onChange,
          overrides: _this.props.overrides,
          peekNextMonth: _this.props.peekNextMonth,
          value: _this.props.value
        }));
        i++;
        currentWeekStart = _this.dateHelpers.addWeeks(currentWeekStart, 1); // It will break on the next week if the week is out of the month

        isWithinMonth = _this.isWeekInMonth(currentWeekStart);
      }

      return weeks;
    });

    _this.dateHelpers = new DateHelpers$1(props.adapter);
    return _this;
  }

  _createClass$m(CalendarMonth, [{
    key: "render",
    value: function render() {
      var _this$props$overrides = this.props.overrides,
          overrides = _this$props$overrides === void 0 ? {} : _this$props$overrides;

      var _getOverrides = getOverrides(overrides.Month, StyledMonth),
          _getOverrides2 = _slicedToArray$x(_getOverrides, 2),
          Month = _getOverrides2[0],
          monthProps = _getOverrides2[1];

      return /*#__PURE__*/React$2.createElement(Month, monthProps, this.renderWeeks());
    }
  }]);

  return CalendarMonth;
}(React$2.Component);

_defineProperty$P(CalendarMonth, "defaultProps", defaultProps$2);

function _typeof$l(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$l = function _typeof(obj) { return typeof obj; }; } else { _typeof$l = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$l(obj); }

function _extends$y() { _extends$y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

function _slicedToArray$w(arr, i) { return _arrayWithHoles$w(arr) || _iterableToArrayLimit$w(arr, i) || _unsupportedIterableToArray$y(arr, i) || _nonIterableRest$w(); }

function _nonIterableRest$w() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$y(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$y(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$y(o, minLen); }

function _arrayLikeToArray$y(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$w(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$w(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$l(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$k(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$l(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$k(Constructor.prototype, protoProps); if (staticProps) _defineProperties$k(Constructor, staticProps); return Constructor; }

function _inherits$l(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$k(subClass, superClass); }

function _setPrototypeOf$k(o, p) { _setPrototypeOf$k = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$k(o, p); }

function _createSuper$k(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$k(); return function _createSuperInternal() { var Super = _getPrototypeOf$k(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$k(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$l(this, result); }; }

function _possibleConstructorReturn$l(self, call) { if (call && (_typeof$l(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$k(self); }

function _assertThisInitialized$k(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$k() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$k(o) { _getPrototypeOf$k = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$k(o); }

function _defineProperty$O(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var MINUTE = 60;
var HOUR = MINUTE * 60;
var DAY = HOUR * 24;
var NOON = DAY / 2;

var TimePicker = /*#__PURE__*/function (_React$Component) {
  _inherits$l(TimePicker, _React$Component);

  var _super = _createSuper$k(TimePicker);

  function TimePicker(props) {
    var _this;

    _classCallCheck$l(this, TimePicker);

    _this = _super.call(this, props);

    _defineProperty$O(_assertThisInitialized$k(_this), "dateHelpers", void 0);

    _defineProperty$O(_assertThisInitialized$k(_this), "state", {
      steps: [],
      value: null
    });

    _defineProperty$O(_assertThisInitialized$k(_this), "onChange", function (params) {
      _this.setState({
        value: params.value[0]
      });

      if (params.value.length === 0) {
        if (_this.props.nullable) {
          _this.props.onChange && _this.props.onChange(null);
        }

        return;
      }

      var seconds = typeof params.value[0].id === 'string' ? parseInt(params.value[0].id, 10) : params.value[0].id || 0;

      _this.handleChange(seconds);
    });

    _defineProperty$O(_assertThisInitialized$k(_this), "secondsToLabel", function (seconds, format) {
      var _this$dateHelpers$sec = _this.dateHelpers.secondsToHourMinute(seconds),
          _this$dateHelpers$sec2 = _slicedToArray$w(_this$dateHelpers$sec, 2),
          hours = _this$dateHelpers$sec2[0],
          minutes = _this$dateHelpers$sec2[1];

      var zeroPrefix = function zeroPrefix(n) {
        return n < 10 ? "0".concat(n) : n;
      };

      if (format === '12') {
        var isAfterNoon = seconds >= NOON;

        if (isAfterNoon) {
          hours -= 12;
        }

        if (hours === 0) {
          hours = 12;
        }

        return "".concat(hours, ":").concat(zeroPrefix(minutes), " ").concat(isAfterNoon ? 'PM' : 'AM');
      }

      return "".concat(zeroPrefix(hours), ":").concat(zeroPrefix(minutes));
    });

    _defineProperty$O(_assertThisInitialized$k(_this), "stringToOptions", function (str) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '12';
      // leading zero is optional, AM/PM is optional
      var twelveHourRegex = /^(1[0-2]|0?[1-9]):([0-5][0-9]) ?([AaPp][Mm]?)?$/; // leading zero is optional

      var twentyFourHourRegex = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/;
      var regex = format === '12' ? twelveHourRegex : twentyFourHourRegex;
      var match = str.match(regex);

      if (!match) {
        return [];
      }

      var hours = Number(match[1]);
      var minutes = Number(match[2]);
      var hoursMinutes = [];

      switch (format) {
        case '24':
          {
            hoursMinutes = [{
              hours: hours,
              minutes: minutes
            }];
            break;
          }

        case '12':
        default:
          {
            var twelveHours = hours % 12;
            var meridiem = match[3]; // if there's no AM/PM, add both AM and PM options

            if (!meridiem) {
              hoursMinutes = [{
                hours: twelveHours,
                minutes: minutes
              }, {
                hours: twelveHours + 12,
                minutes: minutes
              }];
            } else {
              var twentyFourHours = meridiem.toLowerCase()[0] === 'a' ? twelveHours : twelveHours + 12;
              hoursMinutes = [{
                hours: twentyFourHours,
                minutes: minutes
              }];
            }

            break;
          }
      }

      return hoursMinutes.map(function (_ref) {
        var hours = _ref.hours,
            minutes = _ref.minutes;
        var secs = hours * 3600 + minutes * 60;
        return {
          id: secs,
          label: _this.secondsToLabel(secs, format)
        };
      });
    });

    _defineProperty$O(_assertThisInitialized$k(_this), "handleChange", function (seconds) {
      var _this$dateHelpers$sec3 = _this.dateHelpers.secondsToHourMinute(seconds),
          _this$dateHelpers$sec4 = _slicedToArray$w(_this$dateHelpers$sec3, 2),
          hours = _this$dateHelpers$sec4[0],
          minutes = _this$dateHelpers$sec4[1];

      var updatedDate = _this.setTime(_this.props.value, hours, minutes, 0);

      _this.props.onChange && _this.props.onChange(updatedDate);
    });

    _defineProperty$O(_assertThisInitialized$k(_this), "setTime", function (val, hours, minutes, seconds) {
      var _this$dateHelpers = _this.dateHelpers,
          setSeconds = _this$dateHelpers.setSeconds,
          setMinutes = _this$dateHelpers.setMinutes,
          setHours = _this$dateHelpers.setHours;

      var date = _this.props.adapter.startOfDay(_this.props.adapter.date(val || undefined));

      return setSeconds(setMinutes(setHours(date, hours), minutes), seconds);
    });

    _defineProperty$O(_assertThisInitialized$k(_this), "getTimeWindowInSeconds", function (step) {
      var _this$props = _this.props,
          min = _this$props.minTime,
          max = _this$props.maxTime,
          ignoreMinMaxDateComponent = _this$props.ignoreMinMaxDateComponent;

      var dayStart = _this.setTime(_this.props.value, 0, 0, 0);

      var dayEnd = _this.setTime(_this.props.value, 24, 0, 0);

      if (!min || _this.props.adapter.isBefore(min, dayStart) && !ignoreMinMaxDateComponent) {
        min = dayStart;
      } else {
        min = _this.setTime(_this.props.value, _this.props.adapter.getHours(min), _this.props.adapter.getMinutes(min), _this.props.adapter.getSeconds(min));
      }

      if (!max || _this.props.adapter.isAfter(max, dayEnd) && !ignoreMinMaxDateComponent) {
        max = dayEnd;
      } else {
        max = _this.setTime(_this.props.value, _this.props.adapter.getHours(max), _this.props.adapter.getMinutes(max), // maxTime (if provided) should be inclusive, so add an extra second here
        _this.props.adapter.getSeconds(max) + 1);
      }

      var minDate = _this.props.adapter.toJsDate(min);

      var maxDate = _this.props.adapter.toJsDate(max);

      var midnightDate = _this.props.adapter.toJsDate(dayStart);

      return {
        start: (minDate - midnightDate) / 1000,
        end: (maxDate - midnightDate) / 1000
      };
    });

    _defineProperty$O(_assertThisInitialized$k(_this), "buildSteps", function () {
      var _this$props$step = _this.props.step,
          step = _this$props$step === void 0 ? 900 : _this$props$step;

      var timeWindow = _this.getTimeWindowInSeconds(step);

      var stepCount = (timeWindow.end - timeWindow.start) / step;

      if (process.env.NODE_ENV !== "production" && stepCount > 500) {
        // eslint-disable-next-line no-console
        console.warn("Provided step value (".concat(step, ") results in ").concat(stepCount, " steps. Performance may suffer when more than 500 elements are rendered."));
      }

      if (!Number.isInteger(stepCount)) {
        var previousStepCount = stepCount;
        stepCount = Math.round(stepCount);

        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.warn("Provided step value (".concat(step, ") does not spread evenly across a day. Rounding from ").concat(previousStepCount, " total steps to ").concat(stepCount, "."));
        }
      }

      var options = [];

      for (var i = timeWindow.start; i < timeWindow.end; i += step) {
        options.push(i);
      }

      return options;
    });

    _defineProperty$O(_assertThisInitialized$k(_this), "creatableFilterOptions", function (options, filterValue, excludeOptions, newProps) {
      var result = _this.stringToOptions(filterValue, _this.props.format);

      if (result.length) {
        return result;
      }

      return filterOptions$1(options, filterValue, excludeOptions, newProps);
    });

    _defineProperty$O(_assertThisInitialized$k(_this), "buildSelectedOption", function (value) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '12';

      var secs = _this.dateHelpers.dateToSeconds(value);

      return {
        id: secs,
        label: _this.secondsToLabel(secs, format || '12')
      };
    });

    _this.dateHelpers = new DateHelpers$1(props.adapter);
    return _this;
  }

  _createClass$l(TimePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var steps = this.buildSteps();

      if (this.props.value && this.props.adapter.isValid(this.props.value)) {
        this.setState({
          steps: steps,
          value: this.buildSelectedOption(this.props.value, this.props.format)
        });
      } else {
        var seconds = this.dateHelpers.dateToSeconds(this.props.adapter.date());
        var closestStep = NOON;
        steps.forEach(function (step) {
          if (Math.abs(step - seconds) < Math.abs(closestStep - seconds)) {
            closestStep = step;
          }
        });
        this.setState({
          steps: steps,
          value: this.props.nullable ? undefined : {
            id: closestStep,
            label: this.secondsToLabel(closestStep, this.props.format)
          }
        });

        if (this.props.value || !this.props.nullable && !this.props.value) {
          this.handleChange(closestStep);
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var formatChanged = prevProps.format !== this.props.format;
      var stepChanged = prevProps.step !== this.props.step;
      var adapterChanged = prevProps.adapter !== this.props.adapter;
      var minTimeChange = prevProps.minTime !== this.props.minTime;
      var maxTimeChange = prevProps.maxTime !== this.props.maxTime;

      if (adapterChanged) {
        this.dateHelpers = new DateHelpers$1(this.props.adapter);
      }

      if (formatChanged || stepChanged || minTimeChange || maxTimeChange) {
        var steps = this.buildSteps();
        this.setState({
          steps: steps
        });
      }

      if (prevProps.value && !this.props.value) {
        this.setState({
          value: null
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          format = _this$props2.format,
          _this$props2$override = _this$props2.overrides,
          overrides = _this$props2$override === void 0 ? {} : _this$props2$override,
          adapter = _this$props2.adapter;

      var _getOverrides = getOverrides(overrides.Select, Select$1),
          _getOverrides2 = _slicedToArray$w(_getOverrides, 2),
          OverriddenSelect = _getOverrides2[0],
          selectProps = _getOverrides2[1];

      selectProps.overrides = mergeOverrides({
        Dropdown: {
          style: {
            maxHeight: '126px'
          }
        }
      }, selectProps.overrides);
      var value = this.props.value && adapter.isValid(this.props.value) ? this.buildSelectedOption(this.props.value, this.props.format) : this.state.value;
      return /*#__PURE__*/React$2.createElement(LocaleContext.Consumer, null, function (locale) {
        var ariaLabel;

        if (locale.datepicker.timePickerAriaLabel) {
          ariaLabel = locale.datepicker.timePickerAriaLabel;
        } else {
          ariaLabel = format === '12' ? locale.datepicker.timePickerAriaLabel12Hour : locale.datepicker.timePickerAriaLabel24Hour;
        }

        return /*#__PURE__*/React$2.createElement(OverriddenSelect, _extends$y({
          "aria-label": ariaLabel,
          disabled: _this2.props.disabled,
          error: _this2.props.error,
          positive: _this2.props.positive,
          size: _this2.props.size,
          placeholder: _this2.props.placeholder || 'HH:mm',
          options: _this2.state.steps.map(function (n) {
            return {
              id: n,
              label: _this2.secondsToLabel(n, _this2.props.format)
            };
          }),
          filterOptions: _this2.props.creatable ? _this2.creatableFilterOptions : undefined,
          onChange: _this2.onChange // if value is defined, it should be an array type
          ,
          value: value ? [value] : value,
          clearable: false,
          backspaceRemoves: false,
          valueKey: "label"
        }, selectProps));
      });
    }
  }]);

  return TimePicker;
}(React$2.Component);

_defineProperty$O(TimePicker, "defaultProps", {
  format: '12',
  step: 900,
  creatable: false,
  adapter: defaultAdapter,
  ignoreMinMaxDateComponent: false
});

var TimePicker$1 = TimePicker;

function _typeof$k(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$k = function _typeof(obj) { return typeof obj; }; } else { _typeof$k = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$k(obj); }

function _objectWithoutProperties$g(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$f(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$f(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$v(arr, i) { return _arrayWithHoles$v(arr) || _iterableToArrayLimit$v(arr, i) || _unsupportedIterableToArray$x(arr, i) || _nonIterableRest$v(); }

function _nonIterableRest$v() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit$v(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$v(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray$8(arr) { return _arrayWithoutHoles$7(arr) || _iterableToArray$7(arr) || _unsupportedIterableToArray$x(arr) || _nonIterableSpread$7(); }

function _nonIterableSpread$7() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$x(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$x(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$x(o, minLen); }

function _iterableToArray$7(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$7(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$x(arr); }

function _arrayLikeToArray$x(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends$x() { _extends$x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

function _classCallCheck$k(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$j(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$k(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$j(Constructor.prototype, protoProps); if (staticProps) _defineProperties$j(Constructor, staticProps); return Constructor; }

function _inherits$k(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$j(subClass, superClass); }

function _setPrototypeOf$j(o, p) { _setPrototypeOf$j = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$j(o, p); }

function _createSuper$j(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$j(); return function _createSuperInternal() { var Super = _getPrototypeOf$j(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$j(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$k(this, result); }; }

function _possibleConstructorReturn$k(self, call) { if (call && (_typeof$k(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$j(self); }

function _assertThisInitialized$j(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$j() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$j(o) { _getPrototypeOf$j = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$j(o); }

function _defineProperty$N(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Calendar = /*#__PURE__*/function (_React$Component) {
  _inherits$k(Calendar, _React$Component);

  var _super = _createSuper$j(Calendar);

  function Calendar(props) {
    var _this;

    _classCallCheck$k(this, Calendar);

    _this = _super.call(this, props);

    _defineProperty$N(_assertThisInitialized$j(_this), "dateHelpers", void 0);

    _defineProperty$N(_assertThisInitialized$j(_this), "calendar", void 0);

    _defineProperty$N(_assertThisInitialized$j(_this), "getDateInView", function () {
      var _this$props = _this.props,
          highlightedDate = _this$props.highlightedDate,
          value = _this$props.value;

      var minDate = _this.dateHelpers.getEffectiveMinDate(_this.props);

      var maxDate = _this.dateHelpers.getEffectiveMaxDate(_this.props);

      var current = _this.dateHelpers.date();

      var initialDate = _this.getSingleDate(value) || highlightedDate;

      if (initialDate) {
        return initialDate;
      } else {
        if (minDate && _this.dateHelpers.isBefore(current, minDate)) {
          return minDate;
        } else if (maxDate && _this.dateHelpers.isAfter(current, maxDate)) {
          return maxDate;
        }
      }

      return current;
    });

    _defineProperty$N(_assertThisInitialized$j(_this), "handleMonthChange", function (date) {
      _this.setHighlightedDate(_this.dateHelpers.getStartOfMonth(date));

      if (_this.props.onMonthChange) {
        _this.props.onMonthChange({
          date: date
        });
      }
    });

    _defineProperty$N(_assertThisInitialized$j(_this), "handleYearChange", function (date) {
      _this.setHighlightedDate(date);

      if (_this.props.onYearChange) {
        _this.props.onYearChange({
          date: date
        });
      }
    });

    _defineProperty$N(_assertThisInitialized$j(_this), "changeMonth", function (_ref) {
      var date = _ref.date;

      _this.setState({
        date: date
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    });

    _defineProperty$N(_assertThisInitialized$j(_this), "changeYear", function (_ref2) {
      var date = _ref2.date;

      _this.setState({
        date: date
      }, function () {
        return _this.handleYearChange(_this.state.date);
      });
    });

    _defineProperty$N(_assertThisInitialized$j(_this), "renderCalendarHeader", function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
      var order = arguments.length > 1 ? arguments[1] : undefined;
      return /*#__PURE__*/React$2.createElement(CalendarHeader, _extends$x({}, _this.props, {
        key: "month-header-".concat(order),
        date: date,
        order: order,
        onMonthChange: _this.changeMonth,
        onYearChange: _this.changeYear
      }));
    });

    _defineProperty$N(_assertThisInitialized$j(_this), "onKeyDown", function (event) {
      switch (event.key) {
        case 'ArrowUp':
        case 'ArrowDown':
        case 'ArrowLeft':
        case 'ArrowRight':
        case 'Home':
        case 'End':
        case 'PageUp':
        case 'PageDown':
          _this.handleArrowKey(event.key);

          event.preventDefault();
          event.stopPropagation();
          break;
      }
    });

    _defineProperty$N(_assertThisInitialized$j(_this), "handleArrowKey", function (key) {
      var oldDate = _this.state.highlightedDate;
      var highlightedDate = oldDate;

      var currentDate = _this.dateHelpers.date();

      switch (key) {
        case 'ArrowLeft':
          // adding `new Date()` as the last option to satisfy Flow
          highlightedDate = _this.dateHelpers.subDays(highlightedDate ? highlightedDate : currentDate, 1);
          break;

        case 'ArrowRight':
          highlightedDate = _this.dateHelpers.addDays( // adding `new Date()` as the last option to satisfy Flow
          highlightedDate ? highlightedDate : currentDate, 1);
          break;

        case 'ArrowUp':
          highlightedDate = _this.dateHelpers.subWeeks( // adding `new Date()` as the last option to satisfy Flow
          highlightedDate ? highlightedDate : currentDate, 1);
          break;

        case 'ArrowDown':
          highlightedDate = _this.dateHelpers.addWeeks( // adding `new Date()` as the last option to satisfy Flow
          highlightedDate ? highlightedDate : currentDate, 1);
          break;

        case 'Home':
          highlightedDate = _this.dateHelpers.getStartOfWeek( // adding `new Date()` as the last option to satisfy Flow
          highlightedDate ? highlightedDate : currentDate);
          break;

        case 'End':
          highlightedDate = _this.dateHelpers.getEndOfWeek( // adding `new Date()` as the last option to satisfy Flow
          highlightedDate ? highlightedDate : currentDate);
          break;

        case 'PageUp':
          highlightedDate = _this.dateHelpers.subMonths( // adding `new Date()` as the last option to satisfy Flow
          highlightedDate ? highlightedDate : currentDate, 1);
          break;

        case 'PageDown':
          highlightedDate = _this.dateHelpers.addMonths( // adding `new Date()` as the last option to satisfy Flow
          highlightedDate ? highlightedDate : currentDate, 1);
          break;
      }

      _this.setState({
        highlightedDate: highlightedDate,
        date: highlightedDate
      });
    });

    _defineProperty$N(_assertThisInitialized$j(_this), "focusCalendar", function () {
      if (!_this.state.focused) {
        _this.setState({
          focused: true
        });
      }
    });

    _defineProperty$N(_assertThisInitialized$j(_this), "blurCalendar", function () {
      if (typeof document !== 'undefined') {
        var activeElm = document.activeElement;

        if (_this.calendar && !_this.calendar.contains(activeElm)) {
          _this.setState({
            focused: false
          });
        }
      }
    });

    _defineProperty$N(_assertThisInitialized$j(_this), "handleTabbing", function (event) {
      if (typeof document !== 'undefined') {
        if (event.keyCode === 9) {
          var activeElm = document.activeElement; // need to look for any tabindex >= 0 and ideally for not disabled
          // focusable by default elements like input, button, etc.

          var focusable = _this.state.rootElement ? _this.state.rootElement.querySelectorAll('[tabindex="0"]') : null;
          var length = focusable ? focusable.length : 0;

          if (event.shiftKey) {
            if (focusable && activeElm === focusable[0]) {
              event.preventDefault();
              focusable[length - 1].focus();
            }
          } else {
            if (focusable && activeElm === focusable[length - 1]) {
              event.preventDefault();
              focusable[0].focus();
            }
          }
        }
      }
    });

    _defineProperty$N(_assertThisInitialized$j(_this), "onDayFocus", function (data) {
      var date = data.date;

      _this.setState({
        highlightedDate: date
      });

      _this.focusCalendar();

      _this.props.onDayFocus && _this.props.onDayFocus(data);
    });

    _defineProperty$N(_assertThisInitialized$j(_this), "onDayMouseOver", function (data) {
      var date = data.date;

      _this.setState({
        highlightedDate: date
      });

      _this.props.onDayMouseOver && _this.props.onDayMouseOver(data);
    });

    _defineProperty$N(_assertThisInitialized$j(_this), "onDayMouseLeave", function (data) {
      var date = data.date;
      var value = _this.props.value;

      var selected = _this.getSingleDate(value);

      _this.setState({
        highlightedDate: selected || date
      });

      _this.props.onDayMouseLeave && _this.props.onDayMouseLeave(data);
    });

    _defineProperty$N(_assertThisInitialized$j(_this), "handleDateChange", function (data) {
      var _this$props$onChange = _this.props.onChange,
          onChange = _this$props$onChange === void 0 ? function (params) {} : _this$props$onChange;
      var updatedDate = data.date; // We'll need to update the date in time values of internal state

      var newTimeState = _toConsumableArray$8(_this.state.time); // Apply the currently selected time values (saved in state) to the updated date


      if (Array.isArray(data.date)) {
        updatedDate = data.date.map(function (date, index) {
          newTimeState[index] = _this.dateHelpers.applyDateToTime(newTimeState[index], date);
          return newTimeState[index];
        });
      } else if (!Array.isArray(_this.props.value) && data.date) {
        newTimeState[0] = _this.dateHelpers.applyDateToTime(newTimeState[0], data.date);
        updatedDate = newTimeState[0];
      } // Update the date in time values of internal state


      _this.setState({
        time: newTimeState
      });

      onChange({
        date: updatedDate
      });
    });

    _defineProperty$N(_assertThisInitialized$j(_this), "handleTimeChange", function (time, index) {
      var _this$props$onChange2 = _this.props.onChange,
          onChange = _this$props$onChange2 === void 0 ? function (params) {} : _this$props$onChange2; // Save/update the time value in internal state

      var newTimeState = _toConsumableArray$8(_this.state.time);

      newTimeState[index] = _this.dateHelpers.applyTimeToDate(newTimeState[index], time);

      _this.setState({
        time: newTimeState
      }); // Time change calls calendar's onChange handler
      // with the date value set to the date with updated time


      if (Array.isArray(_this.props.value)) {
        var dates = _this.props.value.map(function (date, i) {
          if (index === i) {
            return _this.dateHelpers.applyTimeToDate(date, time);
          }

          return date;
        });

        onChange({
          date: dates
        });
      } else {
        var date = _this.dateHelpers.applyTimeToDate(_this.props.value, time);

        onChange({
          date: date
        });
      }
    });

    _defineProperty$N(_assertThisInitialized$j(_this), "renderMonths", function (translations) {
      var _this$props2 = _this.props,
          _this$props2$override = _this$props2.overrides,
          overrides = _this$props2$override === void 0 ? {} : _this$props2$override,
          orientation = _this$props2.orientation;
      var monthList = [];

      var _getOverrides = getOverrides(overrides.CalendarContainer, StyledCalendarContainer),
          _getOverrides2 = _slicedToArray$v(_getOverrides, 2),
          CalendarContainer = _getOverrides2[0],
          calendarContainerProps = _getOverrides2[1];

      var _getOverrides3 = getOverrides(overrides.MonthContainer, StyledMonthContainer),
          _getOverrides4 = _slicedToArray$v(_getOverrides3, 2),
          MonthContainer = _getOverrides4[0],
          monthContainerProps = _getOverrides4[1];

      for (var i = 0; i < (_this.props.monthsShown || 1); ++i) {
        var monthSubComponents = [];

        var monthDate = _this.dateHelpers.addMonths(_this.state.date, i);

        var monthKey = "month-".concat(i);
        monthSubComponents.push(_this.renderCalendarHeader(monthDate, i));
        monthSubComponents.push( /*#__PURE__*/React$2.createElement(CalendarContainer, _extends$x({
          key: monthKey,
          ref: function ref(calendar) {
            _this.calendar = calendar;
          },
          role: "grid",
          "aria-roledescription": translations.ariaRoleDescCalMonth,
          "aria-multiselectable": _this.props.range || null,
          onKeyDown: _this.onKeyDown
        }, calendarContainerProps, {
          $density: _this.props.density
        }), /*#__PURE__*/React$2.createElement(CalendarMonth, {
          adapter: _this.props.adapter,
          date: monthDate,
          dateLabel: _this.props.dateLabel,
          density: _this.props.density,
          excludeDates: _this.props.excludeDates,
          filterDate: _this.props.filterDate,
          highlightedDate: _this.state.highlightedDate,
          includeDates: _this.props.includeDates,
          focusedCalendar: _this.state.focused,
          range: _this.props.range,
          locale: _this.props.locale,
          maxDate: _this.props.maxDate,
          minDate: _this.props.minDate,
          month: _this.dateHelpers.getMonth(_this.state.date),
          onDayBlur: _this.blurCalendar,
          onDayFocus: _this.onDayFocus,
          onDayClick: _this.props.onDayClick,
          onDayMouseOver: _this.onDayMouseOver,
          onDayMouseLeave: _this.onDayMouseLeave,
          onChange: _this.handleDateChange,
          overrides: overrides,
          value: _this.props.value,
          peekNextMonth: _this.props.peekNextMonth,
          fixedHeight: _this.props.fixedHeight
        })));
        monthList.push( /*#__PURE__*/React$2.createElement("div", {
          key: "month-component-".concat(i)
        }, monthSubComponents));
      }

      return /*#__PURE__*/React$2.createElement(MonthContainer, _extends$x({
        $orientation: orientation
      }, monthContainerProps), monthList);
    });

    _defineProperty$N(_assertThisInitialized$j(_this), "renderTimeSelect", function (value, onChange, label) {
      var _this$props$overrides = _this.props.overrides,
          overrides = _this$props$overrides === void 0 ? {} : _this$props$overrides;

      var _getOverrides5 = getOverrides(overrides.TimeSelectContainer, StyledSelectorContainer),
          _getOverrides6 = _slicedToArray$v(_getOverrides5, 2),
          TimeSelectContainer = _getOverrides6[0],
          timeSelectContainerProps = _getOverrides6[1];

      var _getOverrides7 = getOverrides(overrides.TimeSelectFormControl, FormControl$1),
          _getOverrides8 = _slicedToArray$v(_getOverrides7, 2),
          TimeSelectFormControl = _getOverrides8[0],
          timeSelectFormControlProps = _getOverrides8[1];

      var _getOverrides9 = getOverrides(overrides.TimeSelect, TimePicker$1),
          _getOverrides10 = _slicedToArray$v(_getOverrides9, 2),
          TimeSelect = _getOverrides10[0],
          timeSelectProps = _getOverrides10[1];

      return /*#__PURE__*/React$2.createElement(TimeSelectContainer, timeSelectContainerProps, /*#__PURE__*/React$2.createElement(TimeSelectFormControl, _extends$x({
        label: label
      }, timeSelectFormControlProps), /*#__PURE__*/React$2.createElement(TimeSelect, _extends$x({
        value: value ? _this.dateHelpers.date(value) : value,
        onChange: onChange,
        nullable: true
      }, timeSelectProps))));
    });

    _defineProperty$N(_assertThisInitialized$j(_this), "renderQuickSelect", function () {
      var _this$props$overrides2 = _this.props.overrides,
          overrides = _this$props$overrides2 === void 0 ? {} : _this$props$overrides2;

      var _getOverrides11 = getOverrides(overrides.QuickSelectContainer, StyledSelectorContainer),
          _getOverrides12 = _slicedToArray$v(_getOverrides11, 2),
          QuickSelectContainer = _getOverrides12[0],
          quickSelectContainerProps = _getOverrides12[1];

      var _getOverrides13 = getOverrides(overrides.QuickSelectFormControl, FormControl$1),
          _getOverrides14 = _slicedToArray$v(_getOverrides13, 2),
          QuickSelectFormControl = _getOverrides14[0],
          quickSelectFormControlProps = _getOverrides14[1];

      var _getOverrides15 = getOverrides( //
      overrides.QuickSelect, Select$1),
          _getOverrides16 = _slicedToArray$v(_getOverrides15, 2),
          QuickSelect = _getOverrides16[0],
          _getOverrides16$ = _getOverrides16[1],
          quickSelectOverrides = _getOverrides16$.overrides,
          restQuickSelectProps = _objectWithoutProperties$g(_getOverrides16$, ["overrides"]);

      if (!_this.props.quickSelect) {
        return null;
      }

      var NOW = _this.dateHelpers.set(_this.dateHelpers.date(), {
        hours: 12,
        minutes: 0,
        seconds: 0
      });

      return /*#__PURE__*/React$2.createElement(LocaleContext.Consumer, null, function (locale) {
        return /*#__PURE__*/React$2.createElement(QuickSelectContainer, quickSelectContainerProps, /*#__PURE__*/React$2.createElement(QuickSelectFormControl, _extends$x({
          label: locale.datepicker.quickSelectLabel
        }, quickSelectFormControlProps), /*#__PURE__*/React$2.createElement(QuickSelect, _extends$x({
          "aria-label": locale.datepicker.quickSelectAriaLabel,
          labelKey: "id",
          onChange: function onChange(params) {
            if (!params.option) {
              _this.setState({
                quickSelectId: null
              });

              _this.props.onChange && _this.props.onChange({
                date: []
              });
            } else {
              _this.setState({
                quickSelectId: params.option.id
              });

              if (_this.props.onChange) {
                if (_this.props.range) {
                  _this.props.onChange({
                    date: [params.option.beginDate, params.option.endDate || NOW]
                  });
                } else {
                  _this.props.onChange({
                    date: params.option.beginDate
                  });
                }
              }
            }

            if (_this.props.onQuickSelectChange) {
              _this.props.onQuickSelectChange(params.option);
            }
          },
          options: _this.props.quickSelectOptions || [{
            id: locale.datepicker.pastWeek,
            beginDate: _this.dateHelpers.subWeeks(NOW, 1)
          }, {
            id: locale.datepicker.pastMonth,
            beginDate: _this.dateHelpers.subMonths(NOW, 1)
          }, {
            id: locale.datepicker.pastThreeMonths,
            beginDate: _this.dateHelpers.subMonths(NOW, 3)
          }, {
            id: locale.datepicker.pastSixMonths,
            beginDate: _this.dateHelpers.subMonths(NOW, 6)
          }, {
            id: locale.datepicker.pastYear,
            beginDate: _this.dateHelpers.subYears(NOW, 1)
          }, {
            id: locale.datepicker.pastTwoYears,
            beginDate: _this.dateHelpers.subYears(NOW, 2)
          }],
          placeholder: locale.datepicker.quickSelectPlaceholder,
          value: _this.state.quickSelectId && [{
            id: _this.state.quickSelectId
          }],
          overrides: mergeOverrides({
            Dropdown: {
              style: {
                textAlign: 'start'
              }
            }
          }, quickSelectOverrides)
        }, restQuickSelectProps))));
      });
    });

    var _this$props3 = _this.props,
        _highlightedDate = _this$props3.highlightedDate,
        _value = _this$props3.value,
        adapter = _this$props3.adapter; //$FlowFixMe

    _this.dateHelpers = new DateHelpers$1(adapter);

    var dateInView = _this.getDateInView();

    var _time = [];

    if (Array.isArray(_value)) {
      _time = _toConsumableArray$8(_value);
    } else if (_value) {
      _time = [_value];
    }

    _this.state = {
      highlightedDate: _this.getSingleDate(_value) || (_highlightedDate && _this.dateHelpers.isSameMonth(dateInView, _highlightedDate) ? _highlightedDate : _this.dateHelpers.date()),
      focused: false,
      date: dateInView,
      quickSelectId: null,
      rootElement: null,
      time: _time
    };
    return _this;
  }

  _createClass$k(Calendar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocusCalendar) {
        this.focusCalendar();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.highlightedDate && !this.dateHelpers.isSameDay(this.props.highlightedDate, prevProps.highlightedDate)) {
        this.setState({
          date: this.props.highlightedDate
        });
      }

      if (this.props.autoFocusCalendar && this.props.autoFocusCalendar !== prevProps.autoFocusCalendar) {
        this.focusCalendar();
      }

      if (prevProps.value !== this.props.value) {
        var nextDate = this.getDateInView();

        if (!this.isInView(nextDate)) {
          this.setState({
            date: nextDate
          });
        }
      }
    }
  }, {
    key: "isInView",
    value: function isInView(date) {
      // we calculate the month delta between the date arg and the date in the state.
      var currentDate = this.state.date; // First we get the year delta

      var yearDelta = this.dateHelpers.getYear(date) - this.dateHelpers.getYear(currentDate); // then we convert it to months. Then we simply add the date-without-year month delta back in.

      var monthDelta = yearDelta * 12 + this.dateHelpers.getMonth(date) - this.dateHelpers.getMonth(currentDate); // we just check that the delta is between the range given by "this month" (i.e. 0) and "the last month" (i.e. monthsShown)

      return monthDelta >= 0 && monthDelta < (this.props.monthsShown || 1);
    }
  }, {
    key: "getSingleDate",
    value: function getSingleDate(value) {
      // need to check this.props.range but flow would complain
      // at the return value in the else clause
      if (Array.isArray(value)) {
        return value[0] || null;
      }

      return value;
    }
  }, {
    key: "setHighlightedDate",
    value: function setHighlightedDate(date) {
      var value = this.props.value;
      var selected = this.getSingleDate(value);
      var nextState;

      if (selected && this.dateHelpers.isSameMonth(selected, date) && this.dateHelpers.isSameYear(selected, date)) {
        nextState = {
          highlightedDate: selected
        };
      } else {
        nextState = {
          highlightedDate: date
        };
      }

      this.setState(nextState);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props$overrides3 = this.props.overrides,
          overrides = _this$props$overrides3 === void 0 ? {} : _this$props$overrides3;

      var _getOverrides17 = getOverrides(overrides.Root, StyledRoot$e),
          _getOverrides18 = _slicedToArray$v(_getOverrides17, 2),
          Root = _getOverrides18[0],
          rootProps = _getOverrides18[1];

      var _concat = [].concat(this.props.value),
          _concat2 = _slicedToArray$v(_concat, 2),
          startDate = _concat2[0],
          endDate = _concat2[1];

      return /*#__PURE__*/React$2.createElement(LocaleContext.Consumer, null, function (locale) {
        return /*#__PURE__*/React$2.createElement(Root, _extends$x({
          $density: _this2.props.density,
          "data-baseweb": "calendar",
          role: "application",
          "aria-roledescription": "datepicker",
          ref: function ref(root) {
            if (root && root instanceof HTMLElement && !_this2.state.rootElement) {
              _this2.setState({
                rootElement: root
              });
            }
          },
          "aria-label": locale.datepicker.ariaLabelCalendar,
          onKeyDown: _this2.props.trapTabbing ? _this2.handleTabbing : null
        }, rootProps), _this2.renderMonths({
          ariaRoleDescCalMonth: locale.datepicker.ariaRoleDescriptionCalendarMonth
        }), _this2.props.timeSelectStart && _this2.renderTimeSelect(startDate, function (time) {
          return _this2.handleTimeChange(time, 0);
        }, locale.datepicker.timeSelectStartLabel), _this2.props.timeSelectEnd && _this2.props.range && _this2.renderTimeSelect(endDate, function (time) {
          return _this2.handleTimeChange(time, 1);
        }, locale.datepicker.timeSelectEndLabel), _this2.renderQuickSelect());
      });
    }
  }]);

  return Calendar;
}(React$2.Component);

_defineProperty$N(Calendar, "defaultProps", {
  autoFocusCalendar: false,
  dateLabel: null,
  density: DENSITY.default,
  excludeDates: null,
  filterDate: null,
  highlightedDate: null,
  includeDates: null,
  range: false,
  locale: null,
  maxDate: null,
  minDate: null,
  onDayClick: function onDayClick() {},
  onDayFocus: function onDayFocus() {},
  onDayMouseOver: function onDayMouseOver() {},
  onDayMouseLeave: function onDayMouseLeave() {},
  onMonthChange: function onMonthChange() {},
  onYearChange: function onYearChange() {},
  onChange: function onChange() {},
  orientation: ORIENTATION$1.horizontal,
  overrides: {},
  peekNextMonth: false,
  adapter: defaultAdapter,
  value: null,
  trapTabbing: false
});

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// Example:
// getInterpolatedString('Selected date is ${date}', 'Jan 1, 2020') => 'Selected date is Jan 1, 2020'
function getInterpolatedString(translation) {
  var interpolations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return translation.replace(/\${(.*?)}/g, function (_, k) {
    return interpolations[k] === undefined ? '${' + k + '}' : interpolations[k];
  });
}

function _typeof$j(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$j = function _typeof(obj) { return typeof obj; }; } else { _typeof$j = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$j(obj); }

function _extends$w() { _extends$w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

function _toConsumableArray$7(arr) { return _arrayWithoutHoles$6(arr) || _iterableToArray$6(arr) || _unsupportedIterableToArray$w(arr) || _nonIterableSpread$6(); }

function _nonIterableSpread$6() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray$6(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$6(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$w(arr); }

function ownKeys$z(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$z(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$z(Object(source), true).forEach(function (key) { _defineProperty$M(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$z(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck$j(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$i(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$j(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$i(Constructor.prototype, protoProps); if (staticProps) _defineProperties$i(Constructor, staticProps); return Constructor; }

function _inherits$j(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$i(subClass, superClass); }

function _setPrototypeOf$i(o, p) { _setPrototypeOf$i = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$i(o, p); }

function _createSuper$i(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$i(); return function _createSuperInternal() { var Super = _getPrototypeOf$i(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$i(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$j(this, result); }; }

function _possibleConstructorReturn$j(self, call) { if (call && (_typeof$j(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$i(self); }

function _assertThisInitialized$i(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$i() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$i(o) { _getPrototypeOf$i = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$i(o); }

function _defineProperty$M(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$u(arr, i) { return _arrayWithHoles$u(arr) || _iterableToArrayLimit$u(arr, i) || _unsupportedIterableToArray$w(arr, i) || _nonIterableRest$u(); }

function _nonIterableRest$u() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$w(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$w(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$w(o, minLen); }

function _arrayLikeToArray$w(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$u(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$u(arr) { if (Array.isArray(arr)) return arr; }
var DEFAULT_DATE_FORMAT = 'yyyy/MM/dd';
var INPUT_DELIMITER = ' – ';

var combineSeparatedInputs = function combineSeparatedInputs(newInputValue) {
  var prevCombinedInputValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var separatedInput = arguments.length > 2 ? arguments[2] : undefined;
  var inputValue = newInputValue;

  var _prevCombinedInputVal = prevCombinedInputValue.split(INPUT_DELIMITER),
      _prevCombinedInputVal2 = _slicedToArray$u(_prevCombinedInputVal, 2),
      _prevCombinedInputVal3 = _prevCombinedInputVal2[0],
      prevStartDate = _prevCombinedInputVal3 === void 0 ? '' : _prevCombinedInputVal3,
      _prevCombinedInputVal4 = _prevCombinedInputVal2[1],
      prevEndDate = _prevCombinedInputVal4 === void 0 ? '' : _prevCombinedInputVal4;

  if (separatedInput === 'startDate' && prevEndDate) {
    inputValue = "".concat(inputValue, " \u2013 ").concat(prevEndDate);
  }

  if (separatedInput === 'endDate') {
    inputValue = "".concat(prevStartDate, " \u2013 ").concat(inputValue);
  }

  return inputValue;
};

var Datepicker = /*#__PURE__*/function (_React$Component) {
  _inherits$j(Datepicker, _React$Component);

  var _super = _createSuper$i(Datepicker);

  function Datepicker(props) {
    var _this;

    _classCallCheck$j(this, Datepicker);

    _this = _super.call(this, props); //$FlowFixMe

    _defineProperty$M(_assertThisInitialized$i(_this), "calendar", void 0);

    _defineProperty$M(_assertThisInitialized$i(_this), "dateHelpers", void 0);

    _defineProperty$M(_assertThisInitialized$i(_this), "onChange", function (data) {
      var isOpen = false;
      var isPseudoFocused = false;
      var calendarFocused = false;
      var nextDate = data.date;

      if (Array.isArray(nextDate) && _this.props.range) {
        if (nextDate.length < 2) {
          isOpen = true;
          isPseudoFocused = true;
          calendarFocused = null;
        } else if (nextDate.length === 2) {
          var _nextDate = nextDate,
              _nextDate2 = _slicedToArray$u(_nextDate, 2),
              start = _nextDate2[0],
              end = _nextDate2[1];

          if (_this.dateHelpers.isAfter(start, end)) {
            nextDate = [start, start];
          }

          if (_this.state.lastActiveElm) {
            _this.state.lastActiveElm.focus();
          }
        }
      } else if (_this.state.lastActiveElm) {
        _this.state.lastActiveElm.focus();
      } // Time selectors previously caused the calendar popover to close.
      // The check below refrains from closing the popover if only times changed.


      var onlyTimeChanged = function onlyTimeChanged(prev, next) {
        if (!prev || !next) return false;

        var p = _this.dateHelpers.format(prev, 'keyboardDate');

        var n = _this.dateHelpers.format(next, 'keyboardDate');

        if (p === n) {
          return _this.dateHelpers.getHours(prev) !== _this.dateHelpers.getHours(next) || _this.dateHelpers.getMinutes(prev) !== _this.dateHelpers.getMinutes(next);
        }

        return false;
      };

      var prevValue = _this.props.value;

      if (Array.isArray(nextDate) && Array.isArray(prevValue)) {
        if (nextDate.some(function (d, i) {
          return onlyTimeChanged(prevValue[i], d);
        })) {
          isOpen = true;
        }
      } else if (!Array.isArray(nextDate) && !Array.isArray(prevValue)) {
        if (onlyTimeChanged(prevValue, nextDate)) {
          isOpen = true;
        }
      }

      _this.setState(_objectSpread$z(_objectSpread$z({
        isOpen: isOpen,
        isPseudoFocused: isPseudoFocused
      }, calendarFocused === null ? {} : {
        calendarFocused: calendarFocused
      }), {}, {
        inputValue: _this.formatDisplayValue(nextDate)
      }));

      _this.props.onChange && _this.props.onChange({
        date: nextDate
      });
    });

    _defineProperty$M(_assertThisInitialized$i(_this), "formatDisplayValue", function (date) {
      var _this$props = _this.props,
          displayValueAtRangeIndex = _this$props.displayValueAtRangeIndex,
          formatDisplayValue = _this$props.formatDisplayValue,
          range = _this$props.range;

      var formatString = _this.normalizeDashes(_this.props.formatString);

      if (typeof displayValueAtRangeIndex === 'number') {
        if (process.env.NODE_ENV !== "production") {
          if (!range) {
            console.error('displayValueAtRangeIndex only applies if range');
          }

          if (range && displayValueAtRangeIndex > 1) {
            console.error('displayValueAtRangeIndex value must be 0 or 1');
          }
        }

        if (date && Array.isArray(date)) {
          var value = date[displayValueAtRangeIndex];

          if (formatDisplayValue) {
            return formatDisplayValue(value, formatString);
          }

          return _this.formatDate(value, formatString);
        }
      }

      if (formatDisplayValue) {
        return formatDisplayValue(date, formatString);
      }

      return _this.formatDate(date, formatString);
    });

    _defineProperty$M(_assertThisInitialized$i(_this), "open", function () {
      _this.setState({
        isOpen: true,
        isPseudoFocused: true,
        calendarFocused: false
      }, _this.props.onOpen);
    });

    _defineProperty$M(_assertThisInitialized$i(_this), "close", function () {
      var isPseudoFocused = false;

      _this.setState({
        isOpen: false,
        isPseudoFocused: isPseudoFocused,
        calendarFocused: false
      }, _this.props.onClose);
    });

    _defineProperty$M(_assertThisInitialized$i(_this), "handleEsc", function () {
      if (_this.state.lastActiveElm) {
        _this.state.lastActiveElm.focus();
      }

      _this.close();
    });

    _defineProperty$M(_assertThisInitialized$i(_this), "handleInputBlur", function () {
      if (!_this.state.isPseudoFocused) {
        _this.close();
      }
    });

    _defineProperty$M(_assertThisInitialized$i(_this), "getMask", function () {
      var _this$props2 = _this.props,
          formatString = _this$props2.formatString,
          mask = _this$props2.mask,
          range = _this$props2.range,
          separateRangeInputs = _this$props2.separateRangeInputs;

      if (mask === null || mask === undefined && formatString !== DEFAULT_DATE_FORMAT) {
        return null;
      }

      if (mask) {
        return _this.normalizeDashes(mask);
      }

      if (range && !separateRangeInputs) {
        return '9999/99/99 – 9999/99/99';
      }

      return '9999/99/99';
    });

    _defineProperty$M(_assertThisInitialized$i(_this), "handleInputChange", function (event, separatedInput) {
      var inputValue = _this.props.range && _this.props.separateRangeInputs ? combineSeparatedInputs(event.currentTarget.value, _this.state.inputValue, separatedInput) : event.currentTarget.value;

      var mask = _this.getMask();

      var formatString = _this.normalizeDashes(_this.props.formatString);

      if (typeof mask === 'string' && inputValue === mask.replace(/9/g, ' ') || inputValue.length === 0) {
        if (_this.props.onChange) {
          if (_this.props.range) {
            _this.props.onChange({
              date: []
            });
          } else {
            _this.props.onChange({
              date: null
            });
          }
        }
      }

      _this.setState({
        inputValue: inputValue
      });

      var parseDateString = function parseDateString(dateString) {
        if (formatString === DEFAULT_DATE_FORMAT) {
          return _this.dateHelpers.parse(dateString, 'slashDate', _this.props.locale);
        }

        return _this.dateHelpers.parseString(dateString, formatString, _this.props.locale);
      };

      if (_this.props.range && typeof _this.props.displayValueAtRangeIndex !== 'number') {
        var _this$normalizeDashes = _this.normalizeDashes(inputValue).split(INPUT_DELIMITER),
            _this$normalizeDashes2 = _slicedToArray$u(_this$normalizeDashes, 2),
            left = _this$normalizeDashes2[0],
            right = _this$normalizeDashes2[1];

        var startDate = _this.dateHelpers.date(left);

        var endDate = _this.dateHelpers.date(right);

        if (formatString) {
          startDate = parseDateString(left);
          endDate = parseDateString(right);
        }

        var onChange = _this.props.onChange;

        if (onChange) {
          var datesValid = _this.dateHelpers.isValid(startDate) && _this.dateHelpers.isValid(endDate); // added equal case so that times within the same day can be expressed


          var rangeValid = _this.dateHelpers.isAfter(endDate, startDate) || _this.dateHelpers.isEqual(startDate, endDate);

          if (datesValid && rangeValid) {
            onChange({
              date: [startDate, endDate]
            });
          }
        }
      } else {
        var dateString = _this.normalizeDashes(inputValue);

        var date = _this.dateHelpers.date(dateString);

        var _formatString = _this.props.formatString; // Prevent early parsing of value.
        // Eg 25.12.2 will be transformed to 25.12.0002 formatted from date to string

        if (dateString.replace(/(\s)*/g, '').length < _formatString.replace(/(\s)*/g, '').length) {
          date = null;
        } else {
          date = parseDateString(dateString);
        }

        var _this$props3 = _this.props,
            displayValueAtRangeIndex = _this$props3.displayValueAtRangeIndex,
            _onChange = _this$props3.onChange,
            range = _this$props3.range,
            value = _this$props3.value;

        if (date && _this.dateHelpers.isValid(date) && _onChange) {
          if (range && Array.isArray(value) && typeof displayValueAtRangeIndex === 'number') {
            var _value = _slicedToArray$u(value, 2),
                _left = _value[0],
                _right = _value[1];

            if (displayValueAtRangeIndex === 0) {
              _left = date;

              if (!_right) {
                _onChange({
                  date: [_left]
                });
              } else {
                if (_this.dateHelpers.isAfter(_right, _left) || _this.dateHelpers.isEqual(_left, _right)) {
                  _onChange({
                    date: [_left, _right]
                  });
                } else {
                  // Is resetting back to previous value appropriate? Invalid range is not
                  // communicated to the user, but if it was not reset the text value would
                  // show one value and date value another. This seems a bit better but clearly
                  // has a downside.
                  _onChange({
                    date: _toConsumableArray$7(value)
                  });
                }
              }
            } else if (displayValueAtRangeIndex === 1) {
              _right = date;

              if (!_left) {
                // If start value is not defined, set start/end to the same day.
                _onChange({
                  date: [_right, _right]
                });
              } else {
                if (_this.dateHelpers.isAfter(_right, _left) || _this.dateHelpers.isEqual(_left, _right)) {
                  _onChange({
                    date: [_left, _right]
                  });
                } else {
                  // See comment above about resetting dates on invalid range
                  _onChange({
                    date: _toConsumableArray$7(value)
                  });
                }
              }
            }
          } else {
            _onChange({
              date: date
            });
          }
        }
      }
    });

    _defineProperty$M(_assertThisInitialized$i(_this), "handleKeyDown", function (event) {
      if (!_this.state.isOpen && event.keyCode === 40) {
        _this.open();
      } else if (_this.state.isOpen && event.key === 'ArrowDown') {
        // next line prevents the page jump on the initial arrowDown
        event.preventDefault();

        _this.focusCalendar();
      } else if (_this.state.isOpen && event.keyCode === 9) {
        _this.close();
      }
    });

    _defineProperty$M(_assertThisInitialized$i(_this), "focusCalendar", function () {
      if (typeof document !== 'undefined') {
        var lastActiveElm = document.activeElement;

        _this.setState({
          calendarFocused: true,
          lastActiveElm: lastActiveElm
        });
      }
    });

    _defineProperty$M(_assertThisInitialized$i(_this), "normalizeDashes", function (inputValue) {
      // replacing both hyphens and em-dashes with en-dashes
      return inputValue.replace(/-/g, '–').replace(/—/g, '–');
    });

    _this.dateHelpers = new DateHelpers$1(props.adapter);
    _this.state = {
      calendarFocused: false,
      isOpen: false,
      isPseudoFocused: false,
      lastActiveElm: null,
      inputValue: _this.formatDisplayValue(props.value) || ''
    };
    return _this;
  }

  _createClass$j(Datepicker, [{
    key: "formatDate",
    value: function formatDate(date, formatString) {
      var _this2 = this;

      var format = function format(date) {
        if (formatString === DEFAULT_DATE_FORMAT) {
          return _this2.dateHelpers.format(date, 'slashDate', _this2.props.locale);
        }

        return _this2.dateHelpers.formatDate(date, formatString, _this2.props.locale);
      };

      if (!date) {
        return '';
      } else if (Array.isArray(date) && !date[0] && !date[1]) {
        return '';
      } else if (Array.isArray(date)) {
        return date.map(function (day) {
          return format(day);
        }).join(INPUT_DELIMITER);
      } else {
        return format(date);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        this.setState({
          inputValue: this.formatDisplayValue(this.props.value)
        });
      }
    }
  }, {
    key: "renderInputComponent",
    value: function renderInputComponent(locale, separatedInput) {
      var _this3 = this;

      var _this$props$overrides = this.props.overrides,
          overrides = _this$props$overrides === void 0 ? {} : _this$props$overrides;

      var _getOverrides = getOverrides(overrides.Input, MaskedInput),
          _getOverrides2 = _slicedToArray$u(_getOverrides, 2),
          InputComponent = _getOverrides2[0],
          inputProps = _getOverrides2[1];

      var placeholder = this.props.placeholder || this.props.placeholder === '' ? this.props.placeholder : this.props.range && !this.props.separateRangeInputs ? 'YYYY/MM/DD – YYYY/MM/DD' : 'YYYY/MM/DD';

      var _split = (this.state.inputValue || '').split(INPUT_DELIMITER),
          _split2 = _slicedToArray$u(_split, 2),
          _split2$ = _split2[0],
          startDate = _split2$ === void 0 ? '' : _split2$,
          _split2$2 = _split2[1],
          endDate = _split2$2 === void 0 ? '' : _split2$2;

      var value = separatedInput === 'startDate' ? startDate : separatedInput === 'endDate' ? endDate : this.state.inputValue;

      var onChange = function onChange(event) {
        return _this3.handleInputChange(event, separatedInput);
      };

      return /*#__PURE__*/React$2.createElement(InputComponent, _extends$w({
        "aria-disabled": this.props.disabled,
        "aria-label": this.props['aria-label'] || (this.props.range ? locale.datepicker.ariaLabelRange : locale.datepicker.ariaLabel),
        error: this.props.error,
        positive: this.props.positive,
        "aria-describedby": this.props['aria-describedby'],
        "aria-labelledby": this.props['aria-labelledby'],
        "aria-required": this.props.required || null,
        disabled: this.props.disabled,
        size: this.props.size,
        value: value,
        onFocus: this.open,
        onBlur: this.handleInputBlur,
        onKeyDown: this.handleKeyDown,
        onChange: onChange,
        placeholder: placeholder,
        mask: this.getMask(),
        required: this.props.required,
        clearable: this.props.clearable
      }, inputProps));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props4 = this.props,
          _this$props4$override = _this$props4.overrides,
          overrides = _this$props4$override === void 0 ? {} : _this$props4$override,
          _this$props4$startDat = _this$props4.startDateLabel,
          startDateLabel = _this$props4$startDat === void 0 ? 'Start Date' : _this$props4$startDat,
          _this$props4$endDateL = _this$props4.endDateLabel,
          endDateLabel = _this$props4$endDateL === void 0 ? 'End Date' : _this$props4$endDateL;

      var _getOverrides3 = getOverrides(overrides.Popover, Popover$1),
          _getOverrides4 = _slicedToArray$u(_getOverrides3, 2),
          PopoverComponent = _getOverrides4[0],
          popoverProps = _getOverrides4[1];

      var _getOverrides5 = getOverrides(overrides.InputWrapper, StyledInputWrapper),
          _getOverrides6 = _slicedToArray$u(_getOverrides5, 2),
          InputWrapper = _getOverrides6[0],
          inputWrapperProps = _getOverrides6[1];

      var _getOverrides7 = getOverrides(overrides.StartDate, StyledStartDate),
          _getOverrides8 = _slicedToArray$u(_getOverrides7, 2),
          StartDate = _getOverrides8[0],
          startDateProps = _getOverrides8[1];

      var _getOverrides9 = getOverrides(overrides.EndDate, StyledEndDate),
          _getOverrides10 = _slicedToArray$u(_getOverrides9, 2),
          EndDate = _getOverrides10[0],
          endDateProps = _getOverrides10[1];

      var _getOverrides11 = getOverrides(overrides.InputLabel, StyledInputLabel),
          _getOverrides12 = _slicedToArray$u(_getOverrides11, 2),
          InputLabel = _getOverrides12[0],
          inputLabelProps = _getOverrides12[1];

      return /*#__PURE__*/React$2.createElement(LocaleContext.Consumer, null, function (locale) {
        return /*#__PURE__*/React$2.createElement(React$2.Fragment, null, /*#__PURE__*/React$2.createElement(PopoverComponent, _extends$w({
          focusLock: false,
          autoFocus: false,
          mountNode: _this4.props.mountNode,
          placement: PLACEMENT$2.bottom,
          isOpen: _this4.state.isOpen,
          onClickOutside: _this4.close,
          onEsc: _this4.handleEsc,
          content: /*#__PURE__*/React$2.createElement(Calendar, _extends$w({
            adapter: _this4.props.adapter,
            autoFocusCalendar: _this4.state.calendarFocused,
            trapTabbing: true,
            value: _this4.props.value
          }, _this4.props, {
            onChange: _this4.onChange
          }))
        }, popoverProps), /*#__PURE__*/React$2.createElement(InputWrapper, _extends$w({}, inputWrapperProps, {
          $separateRangeInputs: _this4.props.range && _this4.props.separateRangeInputs
        }), _this4.props.range && _this4.props.separateRangeInputs ? /*#__PURE__*/React$2.createElement(React$2.Fragment, null, /*#__PURE__*/React$2.createElement(StartDate, startDateProps, /*#__PURE__*/React$2.createElement(InputLabel, inputLabelProps, startDateLabel), _this4.renderInputComponent(locale, 'startDate')), /*#__PURE__*/React$2.createElement(EndDate, endDateProps, /*#__PURE__*/React$2.createElement(InputLabel, inputLabelProps, endDateLabel), _this4.renderInputComponent(locale, 'endDate'))) : /*#__PURE__*/React$2.createElement(React$2.Fragment, null, _this4.renderInputComponent(locale)))), /*#__PURE__*/React$2.createElement("p", {
          id: _this4.props['aria-describedby'],
          style: {
            position: 'fixed',
            width: '0px',
            height: '0px',
            borderLeftWidth: 0,
            borderRightWidth: 0,
            borderTopWidth: 0,
            borderBottomWidth: 0,
            padding: 0,
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            clipPath: 'inset(100%)'
          }
        }, locale.datepicker.screenReaderMessageInput), /*#__PURE__*/React$2.createElement("p", {
          "aria-live": "assertive",
          style: {
            position: 'fixed',
            width: '0px',
            height: '0px',
            borderLeftWidth: 0,
            borderRightWidth: 0,
            borderTopWidth: 0,
            borderBottomWidth: 0,
            padding: 0,
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            clipPath: 'inset(100%)'
          }
        }, // No date selected
        !_this4.props.value || Array.isArray(_this4.props.value) && !_this4.props.value.length ? '' : // Date selected in a non-range picker
        !Array.isArray(_this4.props.value) ? getInterpolatedString(locale.datepicker.selectedDate, {
          date: _this4.state.inputValue || ''
        }) : // Start and end dates are selected in a range picker
        _this4.props.value.length > 1 ? getInterpolatedString(locale.datepicker.selectedDateRange, {
          startDate: _this4.formatDisplayValue(_this4.props.value[0]),
          endDate: _this4.formatDisplayValue( // $FlowFixMe
          _this4.props.value[1])
        }) : // A single date selected in a range picker
        "".concat(getInterpolatedString(locale.datepicker.selectedDate, {
          date: _this4.formatDisplayValue(_this4.props.value[0])
        }), " ").concat(locale.datepicker.selectSecondDatePrompt)));
      });
    }
  }]);

  return Datepicker;
}(React$2.Component);

_defineProperty$M(Datepicker, "defaultProps", {
  'aria-describedby': 'datepicker--screenreader--message--input',
  value: null,
  formatString: DEFAULT_DATE_FORMAT,
  adapter: defaultAdapter
});

var lodash_merge = createCommonjsModule(function (module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeMax = Math.max,
    nativeNow = Date.now;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = merge;
});

const DatePicker = (props) => {
    const { overrides, ...otherProps } = props;
    return (React__default.createElement(Datepicker, { range: true, quickSelect: true, mask: null, size: "compact", overrides: lodash_merge({
            InputWrapper: {
                props: {
                    className: 'date__range__picker-input__wrapper',
                },
            },
            Popover: {
                props: {
                    overrides: {
                        Body: {
                            props: {
                                className: 'date__range__picker-pop__up',
                            },
                        },
                    },
                },
            },
        }, overrides), placeholder: "DD MMM YY \u2013 DD MMM YY", ...otherProps }));
};

const typography$4 = {
    DisplayLarge: {
        fontFamily: tokens$1['font-family'].heading,
        fontSize: tokens$1['font-size']['xx-large'],
        fontWeight: FontWeight.Heavy,
        lineHeight: tokens$1['line-height']['display-4'],
    },
};

const Display4 = (props) => {
    const { color, ...restProps } = props;
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(DisplayLarge, { color: color !== null && color !== void 0 ? color : theme.colors['neutral-100'], overrides: {
            Block: {
                style: typography$4.DisplayLarge,
            },
        }, ...restProps }));
};

var utils$2 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIfInteractive = exports.schd = exports.binarySearch = exports.setItemTransition = exports.isItemTransformed = exports.transformItem = exports.isTouchEvent = exports.getTranslateOffset = exports.arrayRemove = exports.arrayMove = void 0;
function arrayMove(array, from, to) {
    array = array.slice();
    array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
    return array;
}
exports.arrayMove = arrayMove;
function arrayRemove(array, index) {
    array = array.slice();
    array.splice(index, 1);
    return array;
}
exports.arrayRemove = arrayRemove;
function getTranslateOffset(element) {
    var style = window.getComputedStyle(element);
    return (Math.max(parseInt(style['margin-top'], 10), parseInt(style['margin-bottom'], 10)) + element.getBoundingClientRect().height);
}
exports.getTranslateOffset = getTranslateOffset;
function isTouchEvent(event) {
    return ((event.touches && event.touches.length) ||
        (event.changedTouches && event.changedTouches.length));
}
exports.isTouchEvent = isTouchEvent;
function transformItem(element, offsetY, offsetX) {
    if (offsetY === void 0) { offsetY = 0; }
    if (offsetX === void 0) { offsetX = 0; }
    if (!element)
        return;
    if (offsetY === null || offsetX === null) {
        element.style.removeProperty('transform');
        return;
    }
    element.style.transform = "translate(" + offsetX + "px, " + offsetY + "px)";
}
exports.transformItem = transformItem;
function isItemTransformed(element) {
    return !!element.style.transform;
}
exports.isItemTransformed = isItemTransformed;
function setItemTransition(element, duration, timing) {
    if (element) {
        element.style['transition'] = "transform " + duration + "ms" + (timing ? " " + timing : '');
    }
}
exports.setItemTransition = setItemTransition;
// returns the "slot" for the targetValue, aka where it should go
// in an ordered "array", it starts with -1 index
function binarySearch(array, targetValue) {
    var min = 0;
    var max = array.length - 1;
    var guess;
    while (min <= max) {
        guess = Math.floor((max + min) / 2);
        if (!array[guess + 1] ||
            (array[guess] <= targetValue && array[guess + 1] >= targetValue)) {
            return guess;
        }
        else if (array[guess] < targetValue && array[guess + 1] < targetValue) {
            min = guess + 1;
        }
        else {
            max = guess - 1;
        }
    }
    return -1;
}
exports.binarySearch = binarySearch;
// adapted from https://github.com/alexreardon/raf-schd
var schd = function (fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        lastArgs = args;
        if (frameId) {
            return;
        }
        frameId = requestAnimationFrame(function () {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    return wrapperFn;
};
exports.schd = schd;
function checkIfInteractive(target, rootElement) {
    var DISABLED_ELEMENTS = [
        'input',
        'textarea',
        'select',
        'option',
        'optgroup',
        'video',
        'audio',
        'button',
        'a'
    ];
    var DISABLED_ROLES = ['button', 'link', 'checkbox', 'tab'];
    while (target !== rootElement) {
        if (target.getAttribute('data-movable-handle')) {
            return false;
        }
        if (DISABLED_ELEMENTS.includes(target.tagName.toLowerCase())) {
            return true;
        }
        var role = target.getAttribute('role');
        if (role && DISABLED_ROLES.includes(role.toLowerCase())) {
            return true;
        }
        if (target.tagName.toLowerCase() === 'label' &&
            target.hasAttribute('for')) {
            return true;
        }
        if (target.tagName)
            target = target.parentElement;
    }
    return false;
}
exports.checkIfInteractive = checkIfInteractive;
});

unwrapExports(utils$2);
utils$2.checkIfInteractive;
utils$2.schd;
utils$2.binarySearch;
utils$2.setItemTransition;
utils$2.isItemTransformed;
utils$2.transformItem;
utils$2.isTouchEvent;
utils$2.getTranslateOffset;
utils$2.arrayRemove;
utils$2.arrayMove;

var List_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(React__default);
var ReactDOM$1 = __importStar(ReactDOM);

var AUTOSCROLL_ACTIVE_OFFSET = 200;
var AUTOSCROLL_SPEED_RATIO = 10;
var List = /** @class */ (function (_super) {
    __extends(List, _super);
    function List(props) {
        var _this = _super.call(this, props) || this;
        _this.listRef = React.createRef();
        _this.ghostRef = React.createRef();
        _this.topOffsets = [];
        _this.itemTranslateOffsets = [];
        _this.initialYOffset = 0;
        _this.lastScroll = 0;
        _this.lastYOffset = 0;
        _this.lastListYOffset = 0;
        _this.needle = -1;
        _this.afterIndex = -2;
        _this.state = {
            itemDragged: -1,
            itemDraggedOutOfBounds: -1,
            selectedItem: -1,
            initialX: 0,
            initialY: 0,
            targetX: 0,
            targetY: 0,
            targetHeight: 0,
            targetWidth: 0,
            liveText: '',
            scrollingSpeed: 0,
            scrollWindow: false
        };
        _this.doScrolling = function () {
            var _a = _this.state, scrollingSpeed = _a.scrollingSpeed, scrollWindow = _a.scrollWindow;
            var listEl = _this.listRef.current;
            window.requestAnimationFrame(function () {
                if (scrollWindow) {
                    window.scrollTo(window.pageXOffset, window.pageYOffset + scrollingSpeed * 1.5);
                }
                else {
                    listEl.scrollTop += scrollingSpeed;
                }
                if (scrollingSpeed !== 0) {
                    _this.doScrolling();
                }
            });
        };
        _this.getChildren = function () {
            if (_this.listRef && _this.listRef.current) {
                return Array.from(_this.listRef.current.children);
            }
            console.warn('No items found in the List container. Did you forget to pass & spread the `props` param in renderList?');
            return [];
        };
        _this.calculateOffsets = function () {
            _this.topOffsets = _this.getChildren().map(function (item) { return item.getBoundingClientRect().top; });
            _this.itemTranslateOffsets = _this.getChildren().map(function (item) {
                return utils$2.getTranslateOffset(item);
            });
        };
        _this.getTargetIndex = function (e) {
            return _this.getChildren().findIndex(function (child) { return child === e.target || child.contains(e.target); });
        };
        _this.onMouseOrTouchStart = function (e) {
            if (_this.dropTimeout && _this.state.itemDragged > -1) {
                window.clearTimeout(_this.dropTimeout);
                _this.finishDrop();
            }
            var isTouch = utils$2.isTouchEvent(e);
            if (!isTouch && e.button !== 0)
                return;
            var index = _this.getTargetIndex(e);
            if (index === -1 ||
                // @ts-ignore
                (_this.props.values[index] && _this.props.values[index].disabled)) {
                if (_this.state.selectedItem !== -1) {
                    _this.setState({ selectedItem: -1 });
                    _this.finishDrop();
                }
                return;
            }
            var listItemTouched = _this.getChildren()[index];
            var handle = listItemTouched.querySelector('[data-movable-handle]');
            if (handle && !handle.contains(e.target)) {
                return;
            }
            if (utils$2.checkIfInteractive(e.target, listItemTouched)) {
                return;
            }
            e.preventDefault();
            _this.props.beforeDrag &&
                _this.props.beforeDrag({
                    elements: _this.getChildren(),
                    index: index
                });
            if (isTouch) {
                var opts = { passive: false };
                listItemTouched.style.touchAction = 'none';
                document.addEventListener('touchend', _this.schdOnEnd, opts);
                document.addEventListener('touchmove', _this.schdOnTouchMove, opts);
                document.addEventListener('touchcancel', _this.schdOnEnd, opts);
            }
            else {
                document.addEventListener('mousemove', _this.schdOnMouseMove);
                document.addEventListener('mouseup', _this.schdOnEnd);
                var listItemDragged = _this.getChildren()[_this.state.itemDragged];
                if (listItemDragged && listItemDragged.style) {
                    listItemDragged.style.touchAction = '';
                }
            }
            _this.onStart(listItemTouched, isTouch ? e.touches[0].clientX : e.clientX, isTouch ? e.touches[0].clientY : e.clientY, index);
        };
        _this.getYOffset = function () {
            var listScroll = _this.listRef.current
                ? _this.listRef.current.scrollTop
                : 0;
            return window.pageYOffset + listScroll;
        };
        _this.onStart = function (target, clientX, clientY, index) {
            if (_this.state.selectedItem > -1) {
                _this.setState({ selectedItem: -1 });
                _this.needle = -1;
            }
            var targetRect = target.getBoundingClientRect();
            var targetStyles = window.getComputedStyle(target);
            _this.calculateOffsets();
            _this.initialYOffset = _this.getYOffset();
            _this.lastYOffset = window.pageYOffset;
            _this.lastListYOffset = _this.listRef.current.scrollTop;
            _this.setState({
                itemDragged: index,
                targetX: targetRect.left - parseInt(targetStyles['margin-left'], 10),
                targetY: targetRect.top - parseInt(targetStyles['margin-top'], 10),
                targetHeight: targetRect.height,
                targetWidth: targetRect.width,
                initialX: clientX,
                initialY: clientY
            });
        };
        _this.onMouseMove = function (e) {
            e.cancelable && e.preventDefault();
            _this.onMove(e.clientX, e.clientY);
        };
        _this.onTouchMove = function (e) {
            e.cancelable && e.preventDefault();
            _this.onMove(e.touches[0].clientX, e.touches[0].clientY);
        };
        _this.onWheel = function (e) {
            if (_this.state.itemDragged < 0)
                return;
            _this.lastScroll = _this.listRef.current.scrollTop += e.deltaY;
            _this.moveOtherItems();
        };
        _this.onMove = function (clientX, clientY) {
            if (_this.state.itemDragged === -1)
                return null;
            utils$2.transformItem(_this.ghostRef.current, clientY - _this.state.initialY, _this.props.lockVertically ? 0 : clientX - _this.state.initialX);
            _this.autoScrolling(clientY);
            _this.moveOtherItems();
        };
        _this.moveOtherItems = function () {
            var targetRect = _this.ghostRef.current.getBoundingClientRect();
            var itemVerticalCenter = targetRect.top + targetRect.height / 2;
            var offset = utils$2.getTranslateOffset(_this.getChildren()[_this.state.itemDragged]);
            var currentYOffset = _this.getYOffset();
            // adjust offsets if scrolling happens during the item movement
            if (_this.initialYOffset !== currentYOffset) {
                _this.topOffsets = _this.topOffsets.map(function (offset) { return offset - (currentYOffset - _this.initialYOffset); });
                _this.initialYOffset = currentYOffset;
            }
            if (_this.isDraggedItemOutOfBounds() && _this.props.removableByMove) {
                _this.afterIndex = _this.topOffsets.length + 1;
            }
            else {
                _this.afterIndex = utils$2.binarySearch(_this.topOffsets, itemVerticalCenter);
            }
            _this.animateItems(_this.afterIndex === -1 ? 0 : _this.afterIndex, _this.state.itemDragged, offset);
        };
        _this.autoScrolling = function (clientY) {
            var _a = _this.listRef.current.getBoundingClientRect(), top = _a.top, bottom = _a.bottom, height = _a.height;
            var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            // autoscrolling for the window (down)
            if (bottom > viewportHeight &&
                viewportHeight - clientY < AUTOSCROLL_ACTIVE_OFFSET) {
                _this.setState({
                    scrollingSpeed: Math.round((AUTOSCROLL_ACTIVE_OFFSET - (viewportHeight - clientY)) /
                        AUTOSCROLL_SPEED_RATIO),
                    scrollWindow: true
                });
                // autoscrolling for the window (up)
            }
            else if (top < 0 && clientY < AUTOSCROLL_ACTIVE_OFFSET) {
                _this.setState({
                    scrollingSpeed: Math.round((AUTOSCROLL_ACTIVE_OFFSET - clientY) / -AUTOSCROLL_SPEED_RATIO),
                    scrollWindow: true
                });
            }
            else {
                if (_this.state.scrollWindow && _this.state.scrollingSpeed !== 0) {
                    _this.setState({ scrollingSpeed: 0, scrollWindow: false });
                }
                // autoscrolling for containers with overflow
                if (height + 20 < _this.listRef.current.scrollHeight) {
                    var scrollingSpeed = 0;
                    if (clientY - top < AUTOSCROLL_ACTIVE_OFFSET) {
                        scrollingSpeed = Math.round((AUTOSCROLL_ACTIVE_OFFSET - (clientY - top)) /
                            -AUTOSCROLL_SPEED_RATIO);
                    }
                    else if (bottom - clientY < AUTOSCROLL_ACTIVE_OFFSET) {
                        scrollingSpeed = Math.round((AUTOSCROLL_ACTIVE_OFFSET - (bottom - clientY)) /
                            AUTOSCROLL_SPEED_RATIO);
                    }
                    if (_this.state.scrollingSpeed !== scrollingSpeed) {
                        _this.setState({ scrollingSpeed: scrollingSpeed });
                    }
                }
            }
        };
        _this.animateItems = function (needle, movedItem, offset, animateMovedItem) {
            if (animateMovedItem === void 0) { animateMovedItem = false; }
            _this.getChildren().forEach(function (item, i) {
                utils$2.setItemTransition(item, _this.props.transitionDuration);
                if (movedItem === i && animateMovedItem) {
                    if (movedItem === needle) {
                        return utils$2.transformItem(item, null);
                    }
                    utils$2.transformItem(item, movedItem < needle
                        ? _this.itemTranslateOffsets
                            .slice(movedItem + 1, needle + 1)
                            .reduce(function (a, b) { return a + b; }, 0)
                        : _this.itemTranslateOffsets
                            .slice(needle, movedItem)
                            .reduce(function (a, b) { return a + b; }, 0) * -1);
                }
                else if (movedItem < needle && i > movedItem && i <= needle) {
                    utils$2.transformItem(item, -offset);
                }
                else if (i < movedItem && movedItem > needle && i >= needle) {
                    utils$2.transformItem(item, offset);
                }
                else {
                    utils$2.transformItem(item, null);
                }
            });
        };
        _this.isDraggedItemOutOfBounds = function () {
            var initialRect = _this.getChildren()[_this.state.itemDragged].getBoundingClientRect();
            var targetRect = _this.ghostRef.current.getBoundingClientRect();
            if (Math.abs(initialRect.left - targetRect.left) > targetRect.width) {
                if (_this.state.itemDraggedOutOfBounds === -1) {
                    _this.setState({ itemDraggedOutOfBounds: _this.state.itemDragged });
                }
                return true;
            }
            if (_this.state.itemDraggedOutOfBounds > -1) {
                _this.setState({ itemDraggedOutOfBounds: -1 });
            }
            return false;
        };
        _this.onEnd = function (e) {
            e.cancelable && e.preventDefault();
            document.removeEventListener('mousemove', _this.schdOnMouseMove);
            document.removeEventListener('touchmove', _this.schdOnTouchMove);
            document.removeEventListener('mouseup', _this.schdOnEnd);
            document.removeEventListener('touchup', _this.schdOnEnd);
            document.removeEventListener('touchcancel', _this.schdOnEnd);
            var removeItem = _this.props.removableByMove && _this.isDraggedItemOutOfBounds();
            if (!removeItem &&
                _this.props.transitionDuration > 0 &&
                _this.afterIndex !== -2) {
                // animate drop
                utils$2.schd(function () {
                    utils$2.setItemTransition(_this.ghostRef.current, _this.props.transitionDuration, 'cubic-bezier(.2,1,.1,1)');
                    if (_this.afterIndex < 1 && _this.state.itemDragged === 0) {
                        utils$2.transformItem(_this.ghostRef.current, 0, 0);
                    }
                    else {
                        utils$2.transformItem(_this.ghostRef.current, 
                        // compensate window scroll
                        -(window.pageYOffset - _this.lastYOffset) +
                            // compensate container scroll
                            -(_this.listRef.current.scrollTop - _this.lastListYOffset) +
                            (_this.state.itemDragged < _this.afterIndex
                                ? _this.itemTranslateOffsets
                                    .slice(_this.state.itemDragged + 1, _this.afterIndex + 1)
                                    .reduce(function (a, b) { return a + b; }, 0)
                                : _this.itemTranslateOffsets
                                    .slice(_this.afterIndex < 0 ? 0 : _this.afterIndex, _this.state.itemDragged)
                                    .reduce(function (a, b) { return a + b; }, 0) * -1), 0);
                    }
                })();
            }
            _this.dropTimeout = window.setTimeout(_this.finishDrop, removeItem || _this.afterIndex === -2 ? 0 : _this.props.transitionDuration);
        };
        _this.finishDrop = function () {
            var removeItem = _this.props.removableByMove && _this.isDraggedItemOutOfBounds();
            if (removeItem ||
                (_this.afterIndex > -2 && _this.state.itemDragged !== _this.afterIndex)) {
                _this.props.onChange({
                    oldIndex: _this.state.itemDragged,
                    newIndex: removeItem ? -1 : Math.max(_this.afterIndex, 0),
                    targetRect: _this.ghostRef.current.getBoundingClientRect()
                });
            }
            _this.getChildren().forEach(function (item) {
                utils$2.setItemTransition(item, 0);
                utils$2.transformItem(item, null);
                item.style.touchAction = '';
            });
            _this.setState({ itemDragged: -1, scrollingSpeed: 0 });
            _this.afterIndex = -2;
            // sometimes the scroll gets messed up after the drop, fix:
            if (_this.lastScroll > 0) {
                _this.listRef.current.scrollTop = _this.lastScroll;
                _this.lastScroll = 0;
            }
        };
        _this.onKeyDown = function (e) {
            var selectedItem = _this.state.selectedItem;
            var index = _this.getTargetIndex(e);
            if (utils$2.checkIfInteractive(e.target, e.currentTarget)) {
                return;
            }
            if (index === -1)
                return;
            if (e.key === ' ') {
                e.preventDefault();
                if (selectedItem === index) {
                    if (selectedItem !== _this.needle) {
                        _this.getChildren().forEach(function (item) {
                            utils$2.setItemTransition(item, 0);
                            utils$2.transformItem(item, null);
                        });
                        _this.props.onChange({
                            oldIndex: selectedItem,
                            newIndex: _this.needle,
                            targetRect: _this.getChildren()[_this.needle].getBoundingClientRect()
                        });
                        _this.getChildren()[_this.needle].focus();
                    }
                    _this.setState({
                        selectedItem: -1,
                        liveText: _this.props.voiceover.dropped(selectedItem + 1, _this.needle + 1)
                    });
                    _this.needle = -1;
                }
                else {
                    _this.setState({
                        selectedItem: index,
                        liveText: _this.props.voiceover.lifted(index + 1)
                    });
                    _this.needle = index;
                    _this.calculateOffsets();
                }
            }
            if ((e.key === 'ArrowDown' || e.key === 'j') &&
                selectedItem > -1 &&
                _this.needle < _this.props.values.length - 1) {
                e.preventDefault();
                var offset = utils$2.getTranslateOffset(_this.getChildren()[selectedItem]);
                _this.needle++;
                _this.animateItems(_this.needle, selectedItem, offset, true);
                _this.setState({
                    liveText: _this.props.voiceover.moved(_this.needle + 1, false)
                });
            }
            if ((e.key === 'ArrowUp' || e.key === 'k') &&
                selectedItem > -1 &&
                _this.needle > 0) {
                e.preventDefault();
                var offset = utils$2.getTranslateOffset(_this.getChildren()[selectedItem]);
                _this.needle--;
                _this.animateItems(_this.needle, selectedItem, offset, true);
                _this.setState({
                    liveText: _this.props.voiceover.moved(_this.needle + 1, true)
                });
            }
            if (e.key === 'Escape' && selectedItem > -1) {
                _this.getChildren().forEach(function (item) {
                    utils$2.setItemTransition(item, 0);
                    utils$2.transformItem(item, null);
                });
                _this.setState({
                    selectedItem: -1,
                    liveText: _this.props.voiceover.canceled(selectedItem + 1)
                });
                _this.needle = -1;
            }
            if ((e.key === 'Tab' || e.key === 'Enter') && selectedItem > -1) {
                e.preventDefault();
            }
        };
        _this.schdOnMouseMove = utils$2.schd(_this.onMouseMove);
        _this.schdOnTouchMove = utils$2.schd(_this.onTouchMove);
        _this.schdOnEnd = utils$2.schd(_this.onEnd);
        return _this;
    }
    List.prototype.componentDidMount = function () {
        this.calculateOffsets();
        document.addEventListener('touchstart', this.onMouseOrTouchStart, {
            passive: false,
            capture: false
        });
        document.addEventListener('mousedown', this.onMouseOrTouchStart);
    };
    List.prototype.componentDidUpdate = function (_prevProps, prevState) {
        if (prevState.scrollingSpeed !== this.state.scrollingSpeed &&
            prevState.scrollingSpeed === 0) {
            this.doScrolling();
        }
    };
    List.prototype.componentWillUnmount = function () {
        document.removeEventListener('touchstart', this.onMouseOrTouchStart);
        document.removeEventListener('mousedown', this.onMouseOrTouchStart);
    };
    List.prototype.render = function () {
        var _this = this;
        var baseStyle = {
            userSelect: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
            boxSizing: 'border-box',
            position: 'relative'
        };
        var ghostStyle = __assign(__assign({}, baseStyle), { top: this.state.targetY, left: this.state.targetX, width: this.state.targetWidth, height: this.state.targetHeight, position: 'fixed', marginTop: 0 });
        return (React.createElement(React.Fragment, null,
            this.props.renderList({
                children: this.props.values.map(function (value, index) {
                    var isHidden = index === _this.state.itemDragged;
                    var isSelected = index === _this.state.selectedItem;
                    var isDisabled = 
                    // @ts-ignore
                    _this.props.values[index] && _this.props.values[index].disabled;
                    var props = {
                        key: index,
                        tabIndex: isDisabled ? -1 : 0,
                        'aria-roledescription': _this.props.voiceover.item(index + 1),
                        onKeyDown: _this.onKeyDown,
                        style: __assign(__assign({}, baseStyle), { visibility: isHidden ? 'hidden' : undefined, zIndex: isSelected ? 5000 : 0 })
                    };
                    return _this.props.renderItem({
                        value: value,
                        props: props,
                        index: index,
                        isDragged: false,
                        isSelected: isSelected,
                        isOutOfBounds: false
                    });
                }),
                isDragged: this.state.itemDragged > -1,
                props: {
                    ref: this.listRef
                }
            }),
            this.state.itemDragged > -1 &&
                ReactDOM$1.createPortal(this.props.renderItem({
                    value: this.props.values[this.state.itemDragged],
                    props: {
                        ref: this.ghostRef,
                        style: ghostStyle,
                        onWheel: this.onWheel
                    },
                    index: this.state.itemDragged,
                    isDragged: true,
                    isSelected: false,
                    isOutOfBounds: this.state.itemDraggedOutOfBounds > -1
                }), this.props.container || document.body),
            React.createElement("div", { "aria-live": "assertive", role: "log", "aria-atomic": "true", style: {
                    position: 'absolute',
                    width: '1px',
                    height: '1px',
                    margin: '-1px',
                    border: '0px',
                    padding: '0px',
                    overflow: 'hidden',
                    clip: 'rect(0px, 0px, 0px, 0px)',
                    clipPath: 'inset(100%)'
                } }, this.state.liveText)));
    };
    List.defaultProps = {
        transitionDuration: 300,
        lockVertically: false,
        removableByMove: false,
        voiceover: {
            item: function (position) {
                return "You are currently at a draggable item at position " + position + ". Press space bar to lift.";
            },
            lifted: function (position) {
                return "You have lifted item at position " + position + ". Press j to move down, k to move up, space bar to drop and escape to cancel.";
            },
            moved: function (position, up) {
                return "You have moved the lifted item " + (up ? 'up' : 'down') + " to position " + position + ". Press j to move down, k to move up, space bar to drop and escape to cancel.";
            },
            dropped: function (from, to) {
                return "You have dropped the item. It has moved from position " + from + " to " + to + ".";
            },
            canceled: function (position) {
                return "You have cancelled the movement. The item has returned to its starting position of " + position + ".";
            }
        }
    };
    return List;
}(React.Component));
exports.default = List;
});

unwrapExports(List_1);

var lib$1 = createCommonjsModule(function (module, exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayRemove = exports.arrayMove = exports.List = void 0;
var List_1$1 = __importDefault(List_1);
exports.List = List_1$1.default;

Object.defineProperty(exports, "arrayMove", { enumerable: true, get: function () { return utils$2.arrayMove; } });
Object.defineProperty(exports, "arrayRemove", { enumerable: true, get: function () { return utils$2.arrayRemove; } });
});

unwrapExports(lib$1);
var lib_1 = lib$1.arrayRemove;
var lib_2 = lib$1.arrayMove;
var lib_3 = lib$1.List;

function ownKeys$y(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$y(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$y(Object(source), true).forEach(function (key) { _defineProperty$L(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$y(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$L(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Main component container element
 */
var Root$5 = styled('div', function (_ref) {
  _ref.$theme;
  return {
    width: '100%'
  };
});
Root$5.displayName = "Root";
Root$5.displayName = 'StyledRoot';
var List$1 = styled('ul', function (_ref2) {
  var $isDragged = _ref2.$isDragged;
  return {
    paddingLeft: 0,
    cursor: $isDragged ? 'grabbing' : null,
    pointerEvents: $isDragged ? 'none' : 'auto'
  };
});
List$1.displayName = "List";
List$1.displayName = 'StyledList';
var Item = styled('li', function (_ref3) {
  var $isDragged = _ref3.$isDragged,
      $isSelected = _ref3.$isSelected,
      $theme = _ref3.$theme,
      $isFocusVisible = _ref3.$isFocusVisible;
  return {
    ':hover': !$isDragged && !$isSelected ? {
      borderTopWidth: '2px',
      borderBottomWidth: '2px',
      borderLeftWidth: '2px',
      borderRightWidth: '2px',
      borderTopStyle: 'solid',
      borderBottomStyle: 'solid',
      borderLeftStyle: 'solid',
      borderRightStyle: 'solid',
      borderTopColor: $theme.colors.primary,
      borderBottomColor: $theme.colors.primary,
      borderLeftColor: $theme.colors.primary,
      borderRightColor: $theme.colors.primary
    } : {},
    ':focus': {
      outline: $isFocusVisible && !$isDragged && !$isSelected ? "3px solid ".concat($theme.colors.accent) : 'none',
      outlineOffset: '-3px'
    },
    paddingTop: $theme.sizing.scale600,
    paddingBottom: $theme.sizing.scale600,
    paddingLeft: $theme.sizing.scale600,
    paddingRight: $theme.sizing.scale600,
    color: $theme.colors.contentPrimary,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    listStyle: 'none',
    cursor: $isDragged ? 'grabbing' : 'grab',
    backgroundColor: $theme.colors.backgroundPrimary,
    boxShadow: $isDragged ? '0 2px 6px rgba(0, 0, 0, 0.32)' : null,
    borderTopWidth: '2px',
    borderBottomWidth: '2px',
    borderLeftWidth: '2px',
    borderRightWidth: '2px',
    borderTopStyle: 'solid',
    borderBottomStyle: 'solid',
    borderLeftStyle: 'solid',
    borderRightStyle: 'solid',
    borderTopColor: $isDragged || $isSelected ? $theme.colors.primary : 'transparent',
    borderBottomColor: $isDragged || $isSelected ? $theme.colors.primary : 'transparent',
    borderLeftColor: $isDragged || $isSelected ? $theme.colors.primary : 'transparent',
    borderRightColor: $isDragged || $isSelected ? $theme.colors.primary : 'transparent'
  };
});
Item.displayName = "Item";
List$1.displayName = 'StyledItem';
var DragHandle = styled('div', function (_ref4) {
  var _ref5;

  var $theme = _ref4.$theme;
  var marginDir = $theme.direction === 'rtl' ? 'marginLeft' : 'marginRight';
  return _ref5 = {}, _defineProperty$L(_ref5, marginDir, $theme.sizing.scale600), _defineProperty$L(_ref5, "width", $theme.sizing.scale800), _defineProperty$L(_ref5, "color", '#CCC'), _defineProperty$L(_ref5, "display", 'flex'), _defineProperty$L(_ref5, "alignItems", 'center'), _ref5;
});
DragHandle.displayName = "DragHandle";
DragHandle.displayName = 'StyledDragHandle';
var CloseHandle = styled('button', function (_ref6) {
  var _ref7;

  var $theme = _ref6.$theme,
      $isFocusVisible = _ref6.$isFocusVisible;
  var marginDir = $theme.direction === 'rtl' ? 'marginRight' : 'marginLeft';
  return _ref7 = {
    borderLeftStyle: 'none',
    borderTopStyle: 'none',
    borderRightStyle: 'none',
    borderBottomStyle: 'none',
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    overflow: 'visible',
    cursor: 'pointer',
    backgroundColor: 'transparent'
  }, _defineProperty$L(_ref7, marginDir, $theme.sizing.scale600), _defineProperty$L(_ref7, "width", $theme.sizing.scale800), _defineProperty$L(_ref7, "display", 'flex'), _defineProperty$L(_ref7, "alignItems", 'center'), _defineProperty$L(_ref7, ':focus', {
    outline: $isFocusVisible ? "3px solid ".concat($theme.colors.accent) : 'none'
  }), _ref7;
});
CloseHandle.displayName = "CloseHandle";
CloseHandle.displayName = 'StyledCloseHandle';
var Label$1 = styled('div', function (_ref8) {
  var $theme = _ref8.$theme;
  return _objectSpread$y({
    flexGrow: 1
  }, $theme.typography.font300);
});
Label$1.displayName = "Label";
Label$1.displayName = 'StyledLabel';

function _typeof$i(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$i = function _typeof(obj) { return typeof obj; }; } else { _typeof$i = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$i(obj); }

function ownKeys$x(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$x(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$x(Object(source), true).forEach(function (key) { _defineProperty$K(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$x(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends$v() { _extends$v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

function _slicedToArray$t(arr, i) { return _arrayWithHoles$t(arr) || _iterableToArrayLimit$t(arr, i) || _unsupportedIterableToArray$v(arr, i) || _nonIterableRest$t(); }

function _nonIterableRest$t() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$v(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$v(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$v(o, minLen); }

function _arrayLikeToArray$v(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$t(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$t(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$i(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$h(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$i(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$h(Constructor.prototype, protoProps); if (staticProps) _defineProperties$h(Constructor, staticProps); return Constructor; }

function _inherits$i(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$h(subClass, superClass); }

function _setPrototypeOf$h(o, p) { _setPrototypeOf$h = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$h(o, p); }

function _createSuper$h(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$h(); return function _createSuperInternal() { var Super = _getPrototypeOf$h(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$h(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$i(this, result); }; }

function _possibleConstructorReturn$i(self, call) { if (call && (_typeof$i(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$h(self); }

function _assertThisInitialized$h(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$h() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$h(o) { _getPrototypeOf$h = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$h(o); }

function _defineProperty$K(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ItemLayer = function ItemLayer(_ref) {
  var children = _ref.children,
      dragged = _ref.dragged;

  if (!dragged) {
    return children;
  }

  return /*#__PURE__*/React$2.createElement(Layer, null, children);
};

var StatelessList = /*#__PURE__*/function (_React$Component) {
  _inherits$i(StatelessList, _React$Component);

  var _super = _createSuper$h(StatelessList);

  function StatelessList() {
    var _this;

    _classCallCheck$i(this, StatelessList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$K(_assertThisInitialized$h(_this), "state", {
      isFocusVisible: false
    });

    _defineProperty$K(_assertThisInitialized$h(_this), "handleFocus", function (event) {
      if (isFocusVisible(event)) {
        _this.setState({
          isFocusVisible: true
        });
      }
    });

    _defineProperty$K(_assertThisInitialized$h(_this), "handleBlur", function (event) {
      if (_this.state.isFocusVisible !== false) {
        _this.setState({
          isFocusVisible: false
        });
      }
    });

    return _this;
  }

  _createClass$i(StatelessList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$overrides = _this$props.overrides,
          overrides = _this$props$overrides === void 0 ? {} : _this$props$overrides,
          items = _this$props.items,
          onChange = _this$props.onChange,
          removable = _this$props.removable;
      var RootOverride = overrides.Root,
          ListOverride = overrides.List,
          ItemOverride = overrides.Item,
          DragHandleOverride = overrides.DragHandle,
          CloseHandleOverride = overrides.CloseHandle,
          LabelOverride = overrides.Label;

      var _getOverrides = getOverrides(RootOverride, Root$5),
          _getOverrides2 = _slicedToArray$t(_getOverrides, 2),
          Root = _getOverrides2[0],
          rootProps = _getOverrides2[1];

      var _getOverrides3 = getOverrides(ListOverride, List$1),
          _getOverrides4 = _slicedToArray$t(_getOverrides3, 2),
          List = _getOverrides4[0],
          listProps = _getOverrides4[1];

      var _getOverrides5 = getOverrides(ItemOverride, Item),
          _getOverrides6 = _slicedToArray$t(_getOverrides5, 2),
          Item$1 = _getOverrides6[0],
          itemProps = _getOverrides6[1];

      var _getOverrides7 = getOverrides(DragHandleOverride, DragHandle),
          _getOverrides8 = _slicedToArray$t(_getOverrides7, 2),
          DragHandle$1 = _getOverrides8[0],
          dragHandleProps = _getOverrides8[1];

      var _getOverrides9 = getOverrides(CloseHandleOverride, CloseHandle),
          _getOverrides10 = _slicedToArray$t(_getOverrides9, 2),
          CloseHandle$1 = _getOverrides10[0],
          closeHandleProps = _getOverrides10[1];

      var _getOverrides11 = getOverrides(LabelOverride, Label$1),
          _getOverrides12 = _slicedToArray$t(_getOverrides11, 2),
          Label = _getOverrides12[0],
          labelProps = _getOverrides12[1];

      var isRemovable = this.props.removable || false;
      var isRemovableByMove = this.props.removableByMove || false;
      return /*#__PURE__*/React$2.createElement(Root, _extends$v({
        $isRemovable: isRemovable,
        "data-baseweb": "dnd-list"
      }, rootProps, {
        onFocus: forkFocus(rootProps, this.handleFocus),
        onBlur: forkBlur(rootProps, this.handleBlur)
      }), /*#__PURE__*/React$2.createElement(lib_3, {
        removableByMove: isRemovableByMove,
        values: items,
        onChange: onChange,
        renderList: function renderList(_ref2) {
          var children = _ref2.children,
              props = _ref2.props,
              isDragged = _ref2.isDragged;
          return /*#__PURE__*/React$2.createElement(List, _extends$v({
            $isRemovable: isRemovable,
            $isDragged: isDragged,
            ref: props.ref
          }, listProps), children);
        },
        renderItem: function renderItem(_ref3) {
          var value = _ref3.value,
              props = _ref3.props,
              isDragged = _ref3.isDragged,
              isSelected = _ref3.isSelected,
              isOutOfBounds = _ref3.isOutOfBounds,
              index = _ref3.index;
          var sharedProps = {
            $isRemovable: isRemovable,
            $isRemovableByMove: isRemovableByMove,
            $isDragged: isDragged,
            $isSelected: isSelected,
            $isFocusVisible: _this2.state.isFocusVisible,
            $isOutOfBounds: isOutOfBounds,
            $value: value,
            $index: index
          };
          return /*#__PURE__*/React$2.createElement(ItemLayer, {
            dragged: isDragged,
            key: props.key
          }, /*#__PURE__*/React$2.createElement(Item$1, _extends$v({}, sharedProps, {
            ref: props.ref,
            tabIndex: props.tabIndex,
            "aria-roledescription": props['aria-roledescription'],
            onKeyDown: props.onKeyDown,
            onWheel: props.onWheel
          }, itemProps, {
            style: _objectSpread$x(_objectSpread$x({}, props.style), {}, {
              display: 'flex'
            })
          }), /*#__PURE__*/React$2.createElement(DragHandle$1, _extends$v({}, sharedProps, dragHandleProps), /*#__PURE__*/React$2.createElement(Grab$1, {
            size: 24
          })), /*#__PURE__*/React$2.createElement(Label, _extends$v({}, sharedProps, labelProps), value), removable && /*#__PURE__*/React$2.createElement(CloseHandle$1, _extends$v({}, sharedProps, {
            onClick: function onClick(evt) {
              evt.preventDefault();
              onChange && onChange({
                oldIndex: typeof index !== 'undefined' ? index : 0,
                newIndex: -1
              });
            }
          }, closeHandleProps), /*#__PURE__*/React$2.createElement(DeleteIcon, {
            size: 24,
            color: "#CCC"
          }))));
        }
      }));
    }
  }]);

  return StatelessList;
}(React$2.Component);

_defineProperty$K(StatelessList, "defaultProps", {
  items: [],
  onChange: function onChange() {}
});

var List = StatelessList;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var SIZE$1 = {
  default: 'default',
  full: 'full',
  auto: 'auto'
};
var SIZE_DIMENSION = {
  default: '500px',
  full: '100%',
  auto: 'auto'
};
var CLOSE_SOURCE$1 = {
  closeButton: 'closeButton',
  backdrop: 'backdrop',
  escape: 'escape'
};
var ANCHOR = {
  left: 'left',
  right: 'right',
  top: 'top',
  bottom: 'bottom'
};

function ownKeys$w(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$w(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$w(Object(source), true).forEach(function (key) { _defineProperty$J(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$w(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$J(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getSizeStyles$1($size, $anchor) {
  var styles = {
    maxWidth: '100%',
    maxHeight: '100%',
    width: SIZE_DIMENSION.default,
    height: SIZE_DIMENSION.full
  };

  if ($anchor === ANCHOR.left || $anchor === ANCHOR.right) {
    // If the anchor is horizontal, set the width
    styles.height = SIZE_DIMENSION.full;

    if (SIZE$1[$size]) {
      styles.width = SIZE_DIMENSION[$size];
    } else if (typeof $size === 'string') {
      styles.width = $size;
    }
  } else {
    // If the anchor is vertical, set the height
    styles.width = SIZE_DIMENSION.full;

    if (SIZE$1[$size]) {
      styles.height = SIZE_DIMENSION[$size];
    } else if (typeof $size === 'string') {
      styles.height = $size;
    }
  }

  return styles;
}

function getAnchorStyles(props) {
  var $anchor = props.$anchor,
      $isVisible = props.$isVisible,
      $size = props.$size;
  var sizeStyles = getSizeStyles$1($size, $anchor);
  var left = ANCHOR.left,
      right = ANCHOR.right,
      top = ANCHOR.top,
      bottom = ANCHOR.bottom;

  switch ($anchor) {
    case right:
      {
        return _objectSpread$w({
          transform: $isVisible ? 'translateX(0)' : "translateX(".concat(sizeStyles.width, ")"),
          right: $isVisible ? 0 : "-".concat(sizeStyles.width),
          top: 0
        }, sizeStyles);
      }

    case left:
      {
        return _objectSpread$w({
          transform: $isVisible ? 'translateX(0)' : "translateX(-".concat(sizeStyles.width, ")"),
          left: $isVisible ? 0 : "-".concat(sizeStyles.width),
          top: 0
        }, sizeStyles);
      }

    case bottom:
      {
        return _objectSpread$w({
          transform: $isVisible ? 'translateY(0)' : "translateY(".concat(sizeStyles.height, ")"),
          left: 0,
          bottom: $isVisible ? '0' : "-".concat(sizeStyles.height)
        }, sizeStyles);
      }

    case top:
      {
        return _objectSpread$w({
          transform: $isVisible ? 'translateY(0)' : "translateY(-".concat(sizeStyles.height, ")"),
          left: 0,
          top: $isVisible ? '0' : "-".concat(sizeStyles.height)
        }, sizeStyles);
      }

    default:
      {
        return {};
      }
  }
}

var StyledRoot$d = styled('div', function (props) {
  return {
    position: 'fixed',
    overflow: 'auto',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0
  };
});
StyledRoot$d.displayName = "StyledRoot";
var StyledBackdrop = styled('div', function (props) {
  var $animating = props.$animating,
      $isOpen = props.$isOpen,
      $isVisible = props.$isVisible,
      $showBackdrop = props.$showBackdrop,
      $theme = props.$theme;
  return _objectSpread$w({
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    // Disable scroll capabilities.
    touchAction: 'none',
    opacity: $isVisible && $isOpen && $showBackdrop ? 1 : 0
  }, $animating ? {
    transitionProperty: 'opacity',
    transitionDuration: $theme.animation.timing400,
    transitionTimingFunction: $theme.animation.easeOutCurve
  } : null);
});
StyledBackdrop.displayName = "StyledBackdrop";
var StyledDrawerContainer = styled('div', function (props) {
  var $animating = props.$animating,
      $isOpen = props.$isOpen,
      $isVisible = props.$isVisible,
      $theme = props.$theme;
  return _objectSpread$w(_objectSpread$w({
    backgroundColor: $theme.colors.backgroundPrimary,
    borderTopLeftRadius: $theme.borders.surfaceBorderRadius,
    borderTopRightRadius: $theme.borders.surfaceBorderRadius,
    borderBottomRightRadius: $theme.borders.surfaceBorderRadius,
    borderBottomLeftRadius: $theme.borders.surfaceBorderRadius
  }, getAnchorStyles(props)), {}, {
    // Animation
    opacity: $isVisible && $isOpen ? 1 : 0,
    transitionProperty: $animating ? 'opacity, transform' : null,
    transitionDuration: $animating ? $theme.animation.timing400 : null,
    transitionTimingFunction: $animating ? $theme.animation.easeOutCurve : null,
    display: 'flex',
    position: 'fixed'
  });
});
StyledDrawerContainer.displayName = "StyledDrawerContainer";
var StyledDrawerBody = styled('div', function (props) {
  var $theme = props.$theme;
  return _objectSpread$w(_objectSpread$w({}, $theme.typography.font200), {}, {
    color: $theme.colors.contentPrimary,
    marginTop: $theme.sizing.scale900,
    marginBottom: $theme.sizing.scale900,
    marginLeft: $theme.sizing.scale900,
    marginRight: $theme.sizing.scale900,
    overflow: 'auto',
    width: '100%'
  });
});
StyledDrawerBody.displayName = "StyledDrawerBody";
var StyledClose$1 = styled('button', function (props) {
  var _ref;

  var $theme = props.$theme,
      $isFocusVisible = props.$isFocusVisible;
  var dir = $theme.direction === 'rtl' ? 'left' : 'right';
  return _ref = {
    // Reset button styles
    background: 'transparent',
    outline: 0,
    paddingLeft: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    // colors
    fill: $theme.colors.primary,
    transitionProperty: 'fill, border-color',
    transitionDuration: $theme.animation.timing200,
    borderLeftWidth: '1px',
    borderRightWidth: '1px',
    borderTopWidth: '1px',
    borderBottomWidth: '1px',
    borderLeftStyle: 'solid',
    borderRightStyle: 'solid',
    borderTopStyle: 'solid',
    borderBottomStyle: 'solid',
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderTopColor: 'transparent',
    borderBottomColor: 'transparent',
    ':hover': {
      fill: $theme.colors.primary600
    },
    ':focus': {
      outline: $isFocusVisible ? "3px solid ".concat($theme.colors.accent) : 'none'
    },
    // Positioning
    position: 'absolute',
    top: $theme.sizing.scale500
  }, _defineProperty$J(_ref, dir, $theme.sizing.scale500), _defineProperty$J(_ref, "width", $theme.sizing.scale800), _defineProperty$J(_ref, "height", $theme.sizing.scale800), _defineProperty$J(_ref, "display", 'flex'), _defineProperty$J(_ref, "justifyContent", 'center'), _defineProperty$J(_ref, "alignItems", 'center'), _defineProperty$J(_ref, "cursor", 'pointer'), _ref;
});
StyledClose$1.displayName = "StyledClose";
var Hidden = styled('div', {
  display: 'none'
});
Hidden.displayName = "Hidden";

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function CloseIcon$1(props) {
  return /*#__PURE__*/React$2.createElement(DeleteIcon, {
    size: "inherit",
    color: "inherit",
    title: props.title
  });
}

function _typeof$h(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$h = function _typeof(obj) { return typeof obj; }; } else { _typeof$h = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$h(obj); }

function _extends$u() { _extends$u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

function _slicedToArray$s(arr, i) { return _arrayWithHoles$s(arr) || _iterableToArrayLimit$s(arr, i) || _unsupportedIterableToArray$u(arr, i) || _nonIterableRest$s(); }

function _nonIterableRest$s() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$u(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$u(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$u(o, minLen); }

function _arrayLikeToArray$u(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$s(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$s(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$h(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$g(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$h(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$g(Constructor.prototype, protoProps); if (staticProps) _defineProperties$g(Constructor, staticProps); return Constructor; }

function _inherits$h(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$g(subClass, superClass); }

function _setPrototypeOf$g(o, p) { _setPrototypeOf$g = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$g(o, p); }

function _createSuper$g(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$g(); return function _createSuperInternal() { var Super = _getPrototypeOf$g(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$g(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$h(this, result); }; }

function _possibleConstructorReturn$h(self, call) { if (call && (_typeof$h(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$g(self); }

function _assertThisInitialized$g(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$g() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$g(o) { _getPrototypeOf$g = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$g(o); }

function _defineProperty$I(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Drawer$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$h(Drawer, _React$Component);

  var _super = _createSuper$g(Drawer);

  function Drawer() {
    var _this;

    _classCallCheck$h(this, Drawer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$I(_assertThisInitialized$g(_this), "animateOutTimer", void 0);

    _defineProperty$I(_assertThisInitialized$g(_this), "animateStartTimer", void 0);

    _defineProperty$I(_assertThisInitialized$g(_this), "lastFocus", null);

    _defineProperty$I(_assertThisInitialized$g(_this), "lastMountNodeOverflowStyle", null);

    _defineProperty$I(_assertThisInitialized$g(_this), "_refs", {});

    _defineProperty$I(_assertThisInitialized$g(_this), "state", {
      isVisible: false,
      mounted: false,
      isFocusVisible: false
    });

    _defineProperty$I(_assertThisInitialized$g(_this), "handleFocus", function (event) {
      if (isFocusVisible(event)) {
        _this.setState({
          isFocusVisible: true
        });
      }
    });

    _defineProperty$I(_assertThisInitialized$g(_this), "handleBlur", function (event) {
      if (_this.state.isFocusVisible !== false) {
        _this.setState({
          isFocusVisible: false
        });
      }
    });

    _defineProperty$I(_assertThisInitialized$g(_this), "onEscape", function () {
      if (!_this.props.closeable) {
        return;
      }

      _this.triggerClose(CLOSE_SOURCE$1.escape);
    });

    _defineProperty$I(_assertThisInitialized$g(_this), "onBackdropClick", function (event) {
      if (_this.props.onBackdropClick) {
        _this.props.onBackdropClick(event);
      }

      if (!_this.props.closeable) {
        return;
      }

      _this.triggerClose(CLOSE_SOURCE$1.backdrop);
    });

    _defineProperty$I(_assertThisInitialized$g(_this), "onCloseClick", function () {
      _this.triggerClose(CLOSE_SOURCE$1.closeButton);
    });

    _defineProperty$I(_assertThisInitialized$g(_this), "animateOutComplete", function () {
      _this.setState({
        isVisible: false
      });
    });

    return _this;
  }

  _createClass$h(Drawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        mounted: true
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.resetMountNodeScroll();
      this.clearTimers();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var isOpen = this.props.isOpen;

      if ( // If isOpen is changing *or* we just mounted and drawer should be open
      isOpen !== prevProps.isOpen || isOpen && this.state.mounted && !prevState.mounted) {
        if (isOpen) {
          this.didOpen();
        } else {
          this.didClose();
        }
      }
    }
  }, {
    key: "disableMountNodeScroll",
    value: function disableMountNodeScroll() {
      if (this.props.showBackdrop) {
        var mountNode = this.getMountNode();
        this.lastMountNodeOverflowStyle = mountNode.style.overflow || '';
        mountNode.style.overflow = 'hidden';
      }
    }
  }, {
    key: "resetMountNodeScroll",
    value: function resetMountNodeScroll() {
      if (this.props.showBackdrop) {
        var mountNode = this.getMountNode();
        var lastStyle = this.lastMountNodeOverflowStyle;

        if (mountNode && lastStyle !== null) {
          mountNode.style.overflow = lastStyle || '';
          this.lastMountNodeOverflowStyle = null;
        }
      }
    }
  }, {
    key: "getMountNode",
    value: function getMountNode() {
      var mountNode = this.props.mountNode;

      if (mountNode) {
        return mountNode;
      } // Flow thinks body could be null (cast through any)
      // flowlint-next-line unclear-type:off


      return document.body;
    }
  }, {
    key: "clearTimers",
    value: function clearTimers() {
      if (this.animateOutTimer) {
        clearTimeout(this.animateOutTimer);
      }

      if (this.animateStartTimer) {
        // eslint-disable-next-line cup/no-undef
        cancelAnimationFrame(this.animateStartTimer);
      }
    }
  }, {
    key: "didOpen",
    value: function didOpen() {
      var _this2 = this;

      // Sometimes scroll starts past zero, possibly due to animation
      // Reset scroll to 0 (other libraries do this as well)
      var rootRef = this.getRef('Root').current;

      if (rootRef) {
        rootRef.scrollTop = 0;
      } // Clear any existing timers (like previous animateOutTimer)


      this.clearTimers();
      this.disableMountNodeScroll(); // eslint-disable-next-line cup/no-undef

      this.animateStartTimer = requestAnimationFrame(function () {
        _this2.setState({
          isVisible: true
        });
      });
    }
  }, {
    key: "didClose",
    value: function didClose() {
      this.resetMountNodeScroll();
      this.animateOutTimer = setTimeout(this.animateOutComplete, 500);
    }
  }, {
    key: "triggerClose",
    value: function triggerClose(source) {
      // If there's no source, it just means the isOpen prop changed. No need to call onClose.
      if (this.props.onClose && source) {
        this.props.onClose({
          closeSource: source
        });
      }
    }
  }, {
    key: "getSharedProps",
    value: function getSharedProps() {
      var _this$props = this.props,
          animate = _this$props.animate,
          isOpen = _this$props.isOpen,
          size = _this$props.size,
          closeable = _this$props.closeable,
          anchor = _this$props.anchor,
          showBackdrop = _this$props.showBackdrop;
      return {
        $animating: animate,
        $isVisible: this.state.isVisible,
        $isOpen: !!isOpen,
        $size: size,
        $closeable: !!closeable,
        $anchor: anchor,
        $isFocusVisible: this.state.isFocusVisible,
        $showBackdrop: showBackdrop
      };
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var children = this.props.children;
      return typeof children === 'function' ? children() : children;
    }
  }, {
    key: "getRef",
    value: function getRef(component) {
      if (!this._refs[component]) {
        this._refs[component] = /*#__PURE__*/React$2.createRef();
      }

      return this._refs[component];
    }
  }, {
    key: "renderDrawer",
    value: function renderDrawer(renderedContent) {
      var _this3 = this;

      var _this$props2 = this.props,
          _this$props2$override = _this$props2.overrides,
          overrides = _this$props2$override === void 0 ? {} : _this$props2$override,
          closeable = _this$props2.closeable,
          autoFocus = _this$props2.autoFocus;
      var RootOverride = overrides.Root,
          DrawerContainerOverride = overrides.DrawerContainer,
          DrawerBodyOverride = overrides.DrawerBody,
          BackdropOverride = overrides.Backdrop,
          CloseOverride = overrides.Close;

      var _getOverrides = getOverrides(RootOverride, StyledRoot$d),
          _getOverrides2 = _slicedToArray$s(_getOverrides, 2),
          Root = _getOverrides2[0],
          rootProps = _getOverrides2[1];

      var _getOverrides3 = getOverrides(BackdropOverride, StyledBackdrop),
          _getOverrides4 = _slicedToArray$s(_getOverrides3, 2),
          Backdrop = _getOverrides4[0],
          backdropProps = _getOverrides4[1];

      var _getOverrides5 = getOverrides(DrawerContainerOverride, StyledDrawerContainer),
          _getOverrides6 = _slicedToArray$s(_getOverrides5, 2),
          DrawerContainer = _getOverrides6[0],
          drawerContainerProps = _getOverrides6[1];

      var _getOverrides7 = getOverrides(DrawerBodyOverride, StyledDrawerBody),
          _getOverrides8 = _slicedToArray$s(_getOverrides7, 2),
          DrawerBody = _getOverrides8[0],
          drawerBodyProps = _getOverrides8[1];

      var _getOverrides9 = getOverrides(CloseOverride, StyledClose$1),
          _getOverrides10 = _slicedToArray$s(_getOverrides9, 2),
          Close = _getOverrides10[0],
          closeProps = _getOverrides10[1];

      var sharedProps = this.getSharedProps();
      return /*#__PURE__*/React$2.createElement(LocaleContext.Consumer, null, function (locale) {
        return /*#__PURE__*/React$2.createElement(FocusLock // Allow focus to escape when UI is within an iframe
        , {
          crossFrame: false,
          returnFocus: true,
          autoFocus: autoFocus,
          noFocusGuards: true
        }, /*#__PURE__*/React$2.createElement(Root, _extends$u({
          "data-baseweb": "drawer",
          ref: _this3.getRef('Root')
        }, sharedProps, rootProps), /*#__PURE__*/React$2.createElement(Backdrop, _extends$u({
          onClick: _this3.onBackdropClick
        }, sharedProps, backdropProps)), /*#__PURE__*/React$2.createElement(DrawerContainer, _extends$u({}, sharedProps, drawerContainerProps), /*#__PURE__*/React$2.createElement(DrawerBody, _extends$u({}, sharedProps, drawerBodyProps), renderedContent), closeable ? /*#__PURE__*/React$2.createElement(Close, _extends$u({
          "aria-label": locale.drawer.close,
          onClick: _this3.onCloseClick
        }, sharedProps, closeProps, {
          onFocus: forkFocus(closeProps, _this3.handleFocus),
          onBlur: forkBlur(closeProps, _this3.handleBlur)
        }), /*#__PURE__*/React$2.createElement(CloseIcon$1, {
          title: locale.drawer.close
        })) : null)));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var mountedAndOpen = this.state.mounted && (this.props.isOpen || this.state.isVisible);
      var renderedContent = mountedAndOpen || this.props.renderAll ? this.getChildren() : null;

      if (renderedContent) {
        if (mountedAndOpen) {
          return /*#__PURE__*/React$2.createElement(Layer, {
            onEscape: this.onEscape,
            mountNode: this.props.mountNode
          }, this.renderDrawer(renderedContent));
        } else {
          return /*#__PURE__*/React$2.createElement(Hidden, null, renderedContent);
        }
      }

      return null;
    }
  }]);

  return Drawer;
}(React$2.Component);

_defineProperty$I(Drawer$1, "defaultProps", {
  animate: true,
  closeable: true,
  isOpen: false,
  overrides: {},
  size: SIZE$1.default,
  anchor: ANCHOR.right,
  showBackdrop: true,
  autoFocus: true,
  renderAll: false
});

var BaseDrawer = Drawer$1;

const Drawer = (props) => (React$2.createElement(BaseDrawer, { ...props }));

function _toConsumableArray$6(arr) { return _arrayWithoutHoles$5(arr) || _iterableToArray$5(arr) || _unsupportedIterableToArray$t(arr) || _nonIterableSpread$5(); }

function _nonIterableSpread$5() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$t(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$t(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$t(o, minLen); }

function _iterableToArray$5(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$5(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$t(arr); }

function _arrayLikeToArray$t(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var flattenFragments = function flattenFragments(children, ChildWrapper) {
  var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return React$2.Children.toArray(children).reduce(function (acc, child, i) {
    if (reactIs_1(child)) {
      acc.push.apply(acc, _toConsumableArray$6(flattenFragments(child.props.children, ChildWrapper, depth + 1)));
    } else if ( /*#__PURE__*/React$2.isValidElement(child)) {
      if (ChildWrapper) {
        acc.push( /*#__PURE__*/React$2.createElement(ChildWrapper, {
          key: "".concat(depth, ".").concat(i)
        }, child));
      } else {
        acc.push(child);
      }
    }

    return acc;
  }, []);
};

function _slicedToArray$r(arr, i) { return _arrayWithHoles$r(arr) || _iterableToArrayLimit$r(arr, i) || _unsupportedIterableToArray$s(arr, i) || _nonIterableRest$r(); }

function _nonIterableRest$r() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$s(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$s(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$s(o, minLen); }

function _arrayLikeToArray$s(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$r(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$r(arr) { if (Array.isArray(arr)) return arr; }

function _extends$t() { _extends$t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

function _objectWithoutProperties$f(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$e(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$e(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var BaseFlexGrid = /*#__PURE__*/React$2.forwardRef(function (_ref, ref) {
  var display = _ref.display,
      flexWrap = _ref.flexWrap,
      restProps = _objectWithoutProperties$f(_ref, ["display", "flexWrap"]);

  return (
    /*#__PURE__*/
    //$FlowFixMe
    React$2.createElement(Block$2, _extends$t({
      display: display || 'flex',
      flexWrap: flexWrap || flexWrap === false ? flexWrap : true,
      "data-baseweb": "flex-grid"
    }, restProps, {
      ref: ref
    }))
  );
});
BaseFlexGrid.displayName = 'BaseFlexGrid';

var FlexGrid$1 = function FlexGrid(_ref2) {
  var forwardedRef = _ref2.forwardedRef,
      children = _ref2.children,
      as = _ref2.as,
      overrides = _ref2.overrides,
      flexGridColumnCount = _ref2.flexGridColumnCount,
      flexGridColumnGap = _ref2.flexGridColumnGap,
      flexGridRowGap = _ref2.flexGridRowGap,
      restProps = _objectWithoutProperties$f(_ref2, ["forwardedRef", "children", "as", "overrides", "flexGridColumnCount", "flexGridColumnGap", "flexGridRowGap"]);

  var _getOverrides = getOverrides(overrides && overrides.Block, BaseFlexGrid),
      _getOverrides2 = _slicedToArray$r(_getOverrides, 2),
      FlexGrid = _getOverrides2[0],
      flexGridProps = _getOverrides2[1];

  return /*#__PURE__*/React$2.createElement(FlexGrid // coerced to any because of how react components are typed.
  // cannot guarantee an html element
  // flowlint-next-line unclear-type:off
  , _extends$t({
    ref: forwardedRef,
    as: as
  }, restProps, flexGridProps), // flatten fragments so FlexGrid correctly iterates over fragments’ children
  flattenFragments(children).map(function (child, flexGridItemIndex, _ref3) {
    var flexGridItemCount = _ref3.length;
    // $FlowFixMe https://github.com/facebook/flow/issues/4864
    return /*#__PURE__*/React$2.cloneElement(child, {
      flexGridColumnCount: flexGridColumnCount,
      flexGridColumnGap: flexGridColumnGap,
      flexGridRowGap: flexGridRowGap,
      flexGridItemIndex: flexGridItemIndex,
      flexGridItemCount: flexGridItemCount
    });
  }));
};

var FlexGridComponent = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return /*#__PURE__*/React$2.createElement(FlexGrid$1, _extends$t({}, props, {
    forwardedRef: ref
  }));
});
FlexGridComponent.displayName = 'FlexGrid';
var BaseFlexGrid$1 = FlexGridComponent;

function _extends$s() { _extends$s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

function _objectWithoutProperties$e(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$d(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$d(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$q(arr, i) { return _arrayWithHoles$q(arr) || _iterableToArrayLimit$q(arr, i) || _unsupportedIterableToArray$r(arr, i) || _nonIterableRest$q(); }

function _nonIterableRest$q() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit$q(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$q(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray$5(arr) { return _arrayWithoutHoles$4(arr) || _iterableToArray$4(arr) || _unsupportedIterableToArray$r(arr) || _nonIterableSpread$4(); }

function _nonIterableSpread$4() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$r(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$r(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$r(o, minLen); }

function _iterableToArray$4(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$4(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$r(arr); }

function _arrayLikeToArray$r(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys$v(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$v(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$v(Object(source), true).forEach(function (key) { _defineProperty$H(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$v(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$H(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var flexGridItemMediaQueryStyle = function flexGridItemMediaQueryStyle(_ref) {
  var _objectSpread2;

  var $theme = _ref.$theme,
      colCount = _ref.flexGridColumnCount,
      flexGridColumnGap = _ref.flexGridColumnGap,
      flexGridRowGap = _ref.flexGridRowGap,
      itemIndex = _ref.flexGridItemIndex,
      itemCount = _ref.flexGridItemCount;
  // 0px needed for calc() to behave properly
  var colGap = $theme.sizing[flexGridColumnGap] || flexGridColumnGap || '0px';
  var colGapQuantity = parseFloat(colGap);
  var colGapUnit = colGap.match(/[a-zA-Z]+/)[0];
  var rowGap = $theme.sizing[flexGridRowGap] || flexGridRowGap || '0px';
  var rowGapQuantity = parseFloat(rowGap);
  var widthCalc = "(100% - ".concat((colCount - 1) * colGapQuantity).concat(colGapUnit, ") / ").concat(colCount);
  var marginDirection = $theme.direction === 'rtl' ? 'marginLeft' : 'marginRight';
  return Object.freeze(_objectSpread$v((_objectSpread2 = {
    // Subtract .5px to avoid rounding issues on IE/Edge
    // See https://github.com/uber/baseweb/pull/1748
    width: "calc(".concat(widthCalc, " - .5px)")
  }, _defineProperty$H(_objectSpread2, marginDirection, colGapQuantity && ( //flowlint-line sketchy-number-and:off
  (itemIndex + 1) % colCount !== 0 ? colGap : 0)), _defineProperty$H(_objectSpread2, "marginBottom", rowGapQuantity && ( //flowlint-line sketchy-number-and:off
  ~~(itemIndex / colCount) !== ~~((itemCount - 1) / colCount) ? rowGap : 0)), _objectSpread2), itemIndex === itemCount - 1 && (itemIndex + 1) % colCount !== 0 ? _defineProperty$H({}, marginDirection, "calc(".concat(colCount - itemIndex % colCount - 1, " * (").concat(colGap, " + ").concat(widthCalc, "))")) : {}));
};
var getResponsiveValue$1 = function getResponsiveValue(responsive, i) {
  if (!responsive) {
    return null;
  }

  if (!Array.isArray(responsive)) {
    return responsive;
  }

  return responsive[i] || responsive[responsive.length - 1];
};
var flexGridItemStyle = function flexGridItemStyle(_ref3) {
  var $flexGridColumnCount = _ref3.$flexGridColumnCount,
      $flexGridColumnGap = _ref3.$flexGridColumnGap,
      $flexGridRowGap = _ref3.$flexGridRowGap,
      $flexGridItemIndex = _ref3.$flexGridItemIndex,
      $flexGridItemCount = _ref3.$flexGridItemCount,
      $theme = _ref3.$theme;
  var baseFlexGridItemStyle = {
    flexGrow: 1
  };
  var mediaQueries = getMediaQueries($theme.breakpoints); // Get the length of the longest responsive array

  var maxResponsiveLength = Math.max.apply(Math, _toConsumableArray$5([$flexGridColumnCount, $flexGridColumnGap, $flexGridRowGap].map(function (r) {
    return Array.isArray(r) ? r.length : 0;
  }))); // No media queries for non-responsive FlexGrids

  if (maxResponsiveLength < 2) {
    return _objectSpread$v(_objectSpread$v({}, baseFlexGridItemStyle), flexGridItemMediaQueryStyle({
      $theme: $theme,
      flexGridColumnCount: getResponsiveValue$1($flexGridColumnCount, 0) || 1,
      flexGridColumnGap: getResponsiveValue$1($flexGridColumnGap, 0) || 0,
      flexGridRowGap: getResponsiveValue$1($flexGridRowGap, 0) || 0,
      flexGridItemIndex: $flexGridItemIndex || 0,
      flexGridItemCount: $flexGridItemCount || 1
    }));
  } // Generate style by iterating up to maxResponsiveLength for each responsive
  // breakpoint. Will end up with styles for one of the following media queries
  // depending on maxResponsiveLength:
  // - {mobile, small}
  // - {mobile, small, medium}
  // - {mobile, small, medium, large}


  return _toConsumableArray$5(Array(maxResponsiveLength).keys()).reduce(function (acc, i) {
    var _map = [$flexGridColumnCount, $flexGridColumnGap, $flexGridRowGap].map(function (r) {
      return getResponsiveValue$1(r, i);
    }),
        _map2 = _slicedToArray$q(_map, 3),
        flexGridColumnCountValue = _map2[0],
        flexGridColumnGapValue = _map2[1],
        flexGridRowGapValue = _map2[2];

    var mediaQuery = i === 0 ? // Custom media query needed so :nth-child styles don't conflict
    getMediaQuery(0) : mediaQueries[i - 1];

    if (mediaQuery) {
      acc[mediaQuery] = flexGridItemMediaQueryStyle({
        $theme: $theme,
        flexGridColumnCount: flexGridColumnCountValue || 1,
        flexGridColumnGap: flexGridColumnGapValue || 0,
        flexGridRowGap: flexGridRowGapValue || 0,
        flexGridItemIndex: $flexGridItemIndex || 0,
        flexGridItemCount: $flexGridItemCount || 1
      });
    }

    return acc;
  }, baseFlexGridItemStyle);
};

var FlexGridItem = function FlexGridItem(_ref4) {
  var forwardedRef = _ref4.forwardedRef,
      children = _ref4.children,
      as = _ref4.as,
      overrides = _ref4.overrides,
      flexGridColumnCount = _ref4.flexGridColumnCount,
      flexGridColumnGap = _ref4.flexGridColumnGap,
      flexGridRowGap = _ref4.flexGridRowGap,
      flexGridItemIndex = _ref4.flexGridItemIndex,
      flexGridItemCount = _ref4.flexGridItemCount,
      restProps = _objectWithoutProperties$e(_ref4, ["forwardedRef", "children", "as", "overrides", "flexGridColumnCount", "flexGridColumnGap", "flexGridRowGap", "flexGridItemIndex", "flexGridItemCount"]);

  var flexGridItemOverrides = {
    Block: {
      style: flexGridItemStyle
    }
  };
  var blockOverrides = overrides ? mergeOverrides(flexGridItemOverrides, overrides) : flexGridItemOverrides;
  return /*#__PURE__*/React$2.createElement(Block$2 // coerced to any because of how react components are typed.
  // cannot guarantee an html element
  // flowlint-next-line unclear-type:off
  , _extends$s({
    ref: forwardedRef,
    as: as,
    overrides: blockOverrides,
    $flexGridColumnCount: flexGridColumnCount,
    $flexGridColumnGap: flexGridColumnGap,
    $flexGridRowGap: flexGridRowGap,
    $flexGridItemIndex: flexGridItemIndex,
    $flexGridItemCount: flexGridItemCount,
    "data-baseweb": "flex-grid-item"
  }, restProps), children);
};

var FlexGridItemComponent = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
  return /*#__PURE__*/React$2.createElement(FlexGridItem, _extends$s({}, props, {
    forwardedRef: ref
  }));
});
FlexGridItemComponent.displayName = 'FlexGridItem';
var FlexGridItemComponent$1 = FlexGridItemComponent;

const FlexGrid = (props) => (React$2.createElement(BaseFlexGrid$1, { ...props }));

const StyledLabel$2 = themedWithStyle(Label$2, ({ $theme, $disabled, }) => ({
    ...typography$6.LabelSmall,
    fontWeight: FontWeight.Bold,
    ...margin('0px'),
    opacity: ($disabled ? $theme.opacity.disabled : 1),
}));
const StyledCaption = themedWithStyle(Caption, ({ $disabled, $error, $theme, }) => ({
    opacity: ($disabled ? $theme.opacity.disabled : 1),
    ...typography$6.LabelSmall,
    color: $theme.colors[$error ? 'status-danger-100' : 'neutral-75'],
    fontWeight: FontWeight.Bold,
    ...margin($theme.sizing['xxx-small'], '0px', '0px'),
}));
const StyledControlContainer$1 = themedWithStyle(ControlContainer, {
    ...margin('0px'),
});

const FormControl = (props) => {
    const { children } = props;
    return (React__default.createElement(FormControl$1, { overrides: {
            Caption: StyledCaption,
            ControlContainer: StyledControlContainer$1,
            Label: StyledLabel$2,
        }, ...props }, children));
};

const typography$3 = {
    HeadingLarge: {
        fontFamily: tokens$1['font-family'].heading,
        fontSize: tokens$1['font-size'].medium,
        fontWeight: FontWeight.Heavy,
        lineHeight: tokens$1['line-height'].h3,
    },
    HeadingMedium: {
        fontFamily: tokens$1['font-family'].heading,
        fontSize: tokens$1['font-size'].root,
        fontWeight: FontWeight.Heavy,
        lineHeight: tokens$1['line-height'].h4,
    },
    HeadingXLarge: {
        fontFamily: tokens$1['font-family'].heading,
        fontSize: tokens$1['font-size'].large,
        fontWeight: FontWeight.Heavy,
        lineHeight: tokens$1['line-height'].h2,
    },
    HeadingXXLarge: {
        fontFamily: tokens$1['font-family'].heading,
        fontSize: tokens$1['font-size']['x-large'],
        fontWeight: FontWeight.Heavy,
        lineHeight: tokens$1['line-height'].h1,
    },
};

const HeadingXXLarge = (props) => {
    const { color, ...restProps } = props;
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(HeadingXXLarge$1, { color: color !== null && color !== void 0 ? color : theme.colors['neutral-100'], marginTop: "0px", marginBottom: "0px", overrides: {
            Block: {
                style: typography$3.HeadingXXLarge,
            },
        }, ...restProps }));
};
const HeadingXLarge = (props) => {
    const { color, ...restProps } = props;
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(HeadingXLarge$1, { color: color !== null && color !== void 0 ? color : theme.colors['neutral-100'], marginTop: "0px", marginBottom: "0px", overrides: {
            Block: {
                style: typography$3.HeadingXLarge,
            },
        }, ...restProps }));
};
const HeadingLarge = (props) => {
    const { color, ...restProps } = props;
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(HeadingLarge$1, { color: color !== null && color !== void 0 ? color : theme.colors['neutral-100'], marginTop: "0px", marginBottom: "0px", overrides: {
            Block: {
                style: typography$3.HeadingLarge,
            },
        }, ...restProps }));
};
const HeadingMedium = (props) => {
    const { color, ...restProps } = props;
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(HeadingMedium$1, { color: color !== null && color !== void 0 ? color : theme.colors['neutral-100'], marginTop: "0px", marginBottom: "0px", overrides: {
            Block: {
                style: typography$3.HeadingMedium,
            },
        }, ...restProps }));
};

const StyledBaseButton = themedWithStyle(BaseButton, ({ $disabled, $isShadow, $size, $isFocusVisible, $isSelected, $theme, }) => {
    const isMini = $size === SIZE$3.mini;
    const nonShadowFocus = $isFocusVisible ? $theme.boxShadow.focus : 'none';
    const borderRadiusValue = isMini
        ? $theme.cornerRadius['semi-sharp']
        : $theme.cornerRadius.default;
    return ({
        ...$disabled ? {} : {
            ':active': {
                backgroundColor: $theme.colors['brand-primary'],
                color: $theme.colors['neutral-0'],
            },
            ':hover': {
                backgroundColor: $theme.colors[$isSelected ? 'brand-primary-125' : 'neutral-25'],
            },
        },
        ':disabled': {
            backgroundColor: $theme.colors['neutral-0'],
            opacity: $theme.opacity.disabled,
        },
        ...$isSelected ? {
            backgroundColor: $theme.colors['brand-primary'],
            color: $theme.colors['neutral-0'],
        } : {
            backgroundColor: $theme.colors['neutral-0'],
            color: $theme.colors['neutral-75'],
        },
        ...borderRadius('top', borderRadiusValue),
        ...borderRadius('bottom', borderRadiusValue),
        boxShadow: $isShadow ? $theme.boxShadow.card : nonShadowFocus,
        height: isMini ? '28px' : '48px',
        width: isMini ? '28px' : '48px',
        ...padding(isMini
            ? $theme.sizing['xxx-small']
            : $theme.sizing['x-small']),
    });
});
const StyledStartEnhancer$1 = themedWithStyle(StartEnhancer, () => ({
    marginLeft: 0,
    marginRight: 0,
}));

const IconButton = (props) => {
    const { icon: Icon, iconProps = {}, isSelected, isShadow, size, ...otherProps } = props;
    const [, theme] = themedUseStyletron();
    const BaseButtonOverride = useCallback((btnProps) => (React$2.createElement(StyledBaseButton, { ...{
            ...btnProps,
            $isSelected: isSelected,
            $isShadow: isShadow,
        } })), [isSelected, isShadow]);
    return (React$2.createElement(Button$2, { ...otherProps, size: size, startEnhancer: (React$2.createElement(Icon, { color: "currentColor", size: size === SIZE$3.mini
                ? theme.iconScale.small
                : theme.iconScale.regular, ...iconProps })), overrides: {
            BaseButton: BaseButtonOverride,
            StartEnhancer: StyledStartEnhancer$1,
        } }));
};

const StyledRoot$c = themedWithStyle(Root$6, ({ $disabled, $positive, $error, $isFocused, $size, $theme, }) => {
    let backgroundColor = $theme.colors['neutral-10'];
    let borderColor = $theme.colors['neutral-100'];
    let opacity = '1';
    if ($disabled) {
        borderColor = $theme.colors['neutral-25'];
        opacity = $theme.opacity.disabled;
    }
    else if ($positive) {
        backgroundColor = $theme.colors['status-success-25'];
        borderColor = $theme.colors['status-success-100'];
    }
    else if ($error) {
        backgroundColor = $theme.colors['status-danger-25'];
        borderColor = $theme.colors['status-danger-100'];
    }
    return {
        backgroundColor,
        color: $theme.colors['neutral-100'],
        opacity,
        ...borderWidth('0px'),
        ...border$1('bottom', $isFocused ? '2px' : '1px', 'solid', borderColor),
        ...padding($size === SIZE$2.compact || $size === SIZE$2.mini
            ? $theme.sizing['xxx-small']
            : $theme.sizing['xx-small']),
    };
});
const StyledStartEnhancer = themedWithStyle(InputEnhancer, ({ $theme }) => ({
    backgroundColor: 'transparent',
    ...padding('0px', $theme.sizing['xx-small'], '0px', '0px'),
}));
const StyledEndEnhancer = themedWithStyle(InputEnhancer, ({ $theme }) => ({
    backgroundColor: 'transparent',
    ...padding('0px', $theme.sizing['xx-small'], '0px', '0px'),
}));
const StyledInput$1 = themedWithStyle(Input$3, ({ $size, $theme, }) => {
    const typo = ($size === SIZE$2.compact || $size === SIZE$2.mini)
        ? typography$6.LabelSmall
        : typography$6.LabelMedium;
    return {
        ...typo,
        backgroundColor: 'transparent',
        color: $theme.colors['neutral-100'],
        ...padding('0px'),
        '::placeholder': {
            color: $theme.colors['neutral-50'],
        },
        ['::-webkit-outer-spin-button,'
            + '::-webkit-inner-spin-button,'
            + '::-webkit-search-decoration,'
            + '::-webkit-search-cancel-button,'
            + '::-webkit-search-results-button,'
            + '::-webkit-search-results-decoration']: {
            '-webkit-appearance': 'none',
            display: 'none',
            margin: 0,
        },
    };
});
const StyledInputContainer = themedWithStyle(InputContainer, () => ({
    backgroundColor: 'transparent',
}));

var INPUT_TYPE;
(function (INPUT_TYPE) {
    INPUT_TYPE["Search"] = "search";
    INPUT_TYPE["Number"] = "number";
    INPUT_TYPE["Text"] = "text";
    INPUT_TYPE["Email"] = "email";
    INPUT_TYPE["Password"] = "password";
})(INPUT_TYPE || (INPUT_TYPE = {}));

const Input$1 = (props) => {
    const { fsExclude, size = SIZE$2.default, type: inputType = INPUT_TYPE.Text, startEnhancer: Icon, testProps, ...restProps } = props;
    const [, theme] = themedUseStyletron();
    const iconScale = (size === SIZE$2.compact || size === SIZE$2.mini)
        ? theme.iconScale['x-small']
        : theme.iconScale.small;
    const ShowIcon = useCallback(() => {
        if (inputType === INPUT_TYPE.Search) {
            return (React$2.createElement(SearchOutlineIcon, { color: theme.colors['neutral-75'], size: iconScale }));
        }
        if (Icon) {
            return (React$2.createElement(Icon, { size: iconScale }));
        }
        return null;
    }, [inputType, iconScale, Icon]);
    const ClearIconOverride = useCallback((clearIconProps) => (React$2.createElement(CloseCircleOutlineIcon, { ...clearIconProps, color: theme.colors['neutral-75'], size: iconScale })), [iconScale]);
    return (React$2.createElement(DefaultInput, { startEnhancer: (Icon || inputType === INPUT_TYPE.Search) && ShowIcon, overrides: {
            ClearIcon: {
                component: ClearIconOverride,
            },
            ClearIconContainer: {
                style: {
                    paddingLeft: theme.sizing['x-small'],
                },
            },
            EndEnhancer: StyledEndEnhancer,
            Input: {
                component: StyledInput$1,
                props: testProps,
            },
            InputContainer: StyledInputContainer,
            Root: {
                component: StyledRoot$c,
                props: {
                    className: fsExclude ? 'fs-exclude' : null,
                },
            },
            StartEnhancer: StyledStartEnhancer,
        }, type: inputType, size: size, ...restProps }));
};

const StatefulInput = (props) => (React$2.createElement(StatefulContainer$3, { ...props }, (childrenProps) => React$2.createElement(Input$1, { ...childrenProps })));

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var ARTWORK_SIZES = {
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE'
};
var SHAPE = {
  DEFAULT: 'DEFAULT',
  ROUND: 'ROUND'
};

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function artworkSizeToValue(artworkSize, isSublist) {
  if (isSublist) {
    switch (artworkSize) {
      case ARTWORK_SIZES.LARGE:
        return 24;

      case ARTWORK_SIZES.SMALL:
      default:
        return 16;
    }
  }

  switch (artworkSize) {
    case ARTWORK_SIZES.SMALL:
      return 16;

    case ARTWORK_SIZES.LARGE:
      return 36;

    case ARTWORK_SIZES.MEDIUM:
    default:
      return 24;
  }
}

function ownKeys$u(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$u(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$u(Object(source), true).forEach(function (key) { _defineProperty$G(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$u(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$G(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var StyledRoot$b = styled('li', function (_ref) {
  var $theme = _ref.$theme,
      $shape = _ref.$shape;
  return {
    alignItems: 'center',
    backgroundColor: $theme.colors.backgroundPrimary,
    display: 'flex',
    listStyleType: 'none',
    width: '100%',
    borderTopLeftRadius: $shape === SHAPE.ROUND ? $theme.borders.radius400 : 0,
    borderTopRightRadius: $shape === SHAPE.ROUND ? $theme.borders.radius400 : 0,
    borderBottomLeftRadius: $shape === SHAPE.ROUND ? $theme.borders.radius400 : 0,
    borderBottomRightRadius: $shape === SHAPE.ROUND ? $theme.borders.radius400 : 0,
    overflow: 'hidden'
  };
});
StyledRoot$b.displayName = "StyledRoot";
var StyledContent$1 = styled('div', function (_ref2) {
  var $mLeft = _ref2.$mLeft,
      $sublist = _ref2.$sublist,
      $theme = _ref2.$theme;
  return _objectSpread$u(_objectSpread$u({}, expandBorderStyles($theme.borders.border100)), {}, {
    alignItems: 'center',
    borderTopStyle: 'none',
    borderRightStyle: 'none',
    borderLeftStyle: 'none',
    display: 'flex',
    flexGrow: 1,
    minHeight: $sublist ? 'initial' : $theme.sizing.scale1600,
    justifyContent: 'space-between'
  }, $theme.direction === 'rtl' ? {
    paddingLeft: $theme.sizing.scale600,
    marginRight: $mLeft ? $theme.sizing.scale600 : null
  } : {
    paddingRight: $theme.sizing.scale600,
    marginLeft: $mLeft ? $theme.sizing.scale600 : null
  });
});
StyledContent$1.displayName = "StyledContent";
var StyledEndEnhancerContainer = styled('div', {
  alignItems: 'center',
  display: 'flex'
});
StyledEndEnhancerContainer.displayName = "StyledEndEnhancerContainer";
var StyledArtworkContainer$2 = styled('div', function (_ref3) {
  var $artworkSize = _ref3.$artworkSize,
      $sublist = _ref3.$sublist,
      $theme = _ref3.$theme;
  var sizeValue = typeof $artworkSize === 'number' ? $artworkSize : artworkSizeToValue($artworkSize, Boolean($sublist));

  if (sizeValue > 36) {
    return {
      alignItems: 'center',
      display: 'flex',
      paddingLeft: $theme.sizing.scale600,
      paddingRight: $theme.sizing.scale600
    };
  }

  return {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    width: $theme.sizing.scale1600
  };
});
StyledArtworkContainer$2.displayName = "StyledArtworkContainer";
var StyledLabelContent$1 = styled('p', function (_ref4) {
  var $theme = _ref4.$theme;
  return _objectSpread$u(_objectSpread$u({}, $theme.typography.LabelMedium), {}, {
    color: $theme.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0
  });
});
StyledLabelContent$1.displayName = "StyledLabelContent";
var StyledLabelDescription = styled('p', function (_ref5) {
  var $theme = _ref5.$theme;
  return _objectSpread$u(_objectSpread$u({}, $theme.typography.ParagraphSmall), {}, {
    color: $theme.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0
  });
});
StyledLabelDescription.displayName = "StyledLabelDescription";
var StyledLabelSublistContent = styled('p', function (_ref6) {
  var $theme = _ref6.$theme;
  return _objectSpread$u(_objectSpread$u({}, $theme.typography.LabelMedium), {}, {
    color: $theme.colors.contentPrimary,
    marginTop: $theme.sizing.scale500,
    marginBottom: $theme.sizing.scale500
  });
});
StyledLabelSublistContent.displayName = "StyledLabelSublistContent";
var StyledHeadingRoot = styled('div', function (_ref7) {
  var $theme = _ref7.$theme;
  return {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    backgroundColor: $theme.colors.backgroundPrimary,
    overflow: 'hidden',
    minHeight: $theme.sizing.scale1600
  };
});
StyledHeadingRoot.displayName = "StyledHeadingRoot";
var StyledHeadingContent = styled('div', function (_ref8) {
  var $theme = _ref8.$theme;
  return _objectSpread$u({
    flexGrow: 1,
    width: '100%',
    minWidth: 0,
    paddingTop: $theme.sizing.scale600,
    paddingBottom: $theme.sizing.scale300
  }, $theme.direction === 'rtl' ? {
    paddingLeft: $theme.sizing.scale600,
    marginRight: $theme.sizing.scale600
  } : {
    paddingRight: $theme.sizing.scale600,
    marginLeft: $theme.sizing.scale600
  });
});
StyledHeadingContent.displayName = "StyledHeadingContent";
var StyledHeadingContentRow = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%'
});
StyledHeadingContentRow.displayName = "StyledHeadingContentRow";
var StyledHeadingMainHeading = styled('p', // $FlowFixMe - suppressing due to webkit properties
function (_ref9) {
  var _ref9$$maxLines = _ref9.$maxLines,
      $maxLines = _ref9$$maxLines === void 0 ? 1 : _ref9$$maxLines,
      $theme = _ref9.$theme;
  return _objectSpread$u(_objectSpread$u({}, $theme.typography.HeadingSmall), {}, {
    color: $theme.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0,
    marginRight: $theme.sizing.scale600,
    display: '-webkit-box',
    '-webkit-line-clamp': $maxLines,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden'
  });
});
StyledHeadingMainHeading.displayName = "StyledHeadingMainHeading";
var StyledHeadingSubHeading = styled('p', // $FlowFixMe - suppressing due to webkit properties
function (_ref10) {
  var _ref10$$maxLines = _ref10.$maxLines,
      $maxLines = _ref10$$maxLines === void 0 ? 1 : _ref10$$maxLines,
      $theme = _ref10.$theme;
  return _objectSpread$u(_objectSpread$u({}, $theme.typography.ParagraphLarge), {}, {
    color: $theme.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0,
    marginRight: $theme.sizing.scale600,
    display: '-webkit-box',
    '-webkit-line-clamp': $maxLines,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden'
  });
});
StyledHeadingSubHeading.displayName = "StyledHeadingSubHeading";
var StyledHeadingEndEnhancerContainer = styled('div', function (_ref11) {
  var $isText = _ref11.$isText,
      $theme = _ref11.$theme;
  return _objectSpread$u(_objectSpread$u({}, $theme.typography.LabelMedium), {}, {
    display: 'flex',
    alignItems: $isText ? 'flex-end' : 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  });
});
StyledHeadingEndEnhancerContainer.displayName = "StyledHeadingEndEnhancerContainer";
var StyledHeadingEndEnhancerDescriptionContainer = styled('p', function (_ref12) {
  var $theme = _ref12.$theme;
  return _objectSpread$u(_objectSpread$u({}, $theme.typography.ParagraphMedium), {}, {
    marginTop: 0,
    marginBottom: 0,
    display: 'flex',
    alignItems: 'flex-start',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  });
});
StyledHeadingEndEnhancerDescriptionContainer.displayName = "StyledHeadingEndEnhancerDescriptionContainer";

function _extends$r() { _extends$r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

function _slicedToArray$p(arr, i) { return _arrayWithHoles$p(arr) || _iterableToArrayLimit$p(arr, i) || _unsupportedIterableToArray$q(arr, i) || _nonIterableRest$p(); }

function _nonIterableRest$p() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$q(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$q(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$q(o, minLen); }

function _arrayLikeToArray$q(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$p(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$p(arr) { if (Array.isArray(arr)) return arr; }
var ListItem$1 = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides;
  var Artwork = props.artwork;
  var EndEnhancer = props.endEnhancer;

  var _getOverrides = getOverrides(overrides.Root, StyledRoot$b),
      _getOverrides2 = _slicedToArray$p(_getOverrides, 2),
      Root = _getOverrides2[0],
      rootProps = _getOverrides2[1];

  var _getOverrides3 = getOverrides(overrides.ArtworkContainer, StyledArtworkContainer$2),
      _getOverrides4 = _slicedToArray$p(_getOverrides3, 2),
      ArtworkContainer = _getOverrides4[0],
      artworkContainerProps = _getOverrides4[1];

  var _getOverrides5 = getOverrides(overrides.Content, StyledContent$1),
      _getOverrides6 = _slicedToArray$p(_getOverrides5, 2),
      Content = _getOverrides6[0],
      contentProps = _getOverrides6[1];

  var _getOverrides7 = getOverrides(overrides.EndEnhancerContainer, StyledEndEnhancerContainer),
      _getOverrides8 = _slicedToArray$p(_getOverrides7, 2),
      EndEnhancerContainer = _getOverrides8[0],
      endEnhancerContainerProps = _getOverrides8[1];

  var artworkSize = React__default.useMemo(function () {
    if (props.sublist) {
      var size = props.artworkSize || ARTWORK_SIZES.SMALL;

      if (props.artworkSize === ARTWORK_SIZES.MEDIUM) {
        size = ARTWORK_SIZES.SMALL;

        if (process.env.NODE_ENV !== "production") {
          console.warn('When ListItem sublist prop is true, artworkSize MEDIUM is aliased to SMALL');
        }
      }

      return size;
    } else {
      return props.artworkSize || ARTWORK_SIZES.MEDIUM;
    }
  }, [props.artworkSize, props.sublist]);
  return /*#__PURE__*/React__default.createElement(Root // flowlint-next-line unclear-type:off
  , _extends$r({
    ref: ref,
    $shape: props.shape || SHAPE.DEFAULT
  }, rootProps), Artwork && /*#__PURE__*/React__default.createElement(ArtworkContainer, _extends$r({
    $artworkSize: artworkSize,
    $sublist: Boolean(props.sublist)
  }, artworkContainerProps), /*#__PURE__*/React__default.createElement(Artwork, {
    size: typeof artworkSize === 'number' ? artworkSize : artworkSizeToValue(artworkSize, Boolean(props.sublist))
  })), /*#__PURE__*/React__default.createElement(Content, _extends$r({
    $mLeft: !Artwork,
    $sublist: !!props.sublist
  }, contentProps), props.children, EndEnhancer && EndEnhancer !== 0 && /*#__PURE__*/React__default.createElement(EndEnhancerContainer, endEnhancerContainerProps, /*#__PURE__*/React__default.createElement(EndEnhancer, null))));
});
ListItem$1.displayName = 'ListItem';
var BaseListItem = ListItem$1;

function _slicedToArray$o(arr, i) { return _arrayWithHoles$o(arr) || _iterableToArrayLimit$o(arr, i) || _unsupportedIterableToArray$p(arr, i) || _nonIterableRest$o(); }

function _nonIterableRest$o() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$p(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$p(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$p(o, minLen); }

function _arrayLikeToArray$p(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$o(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$o(arr) { if (Array.isArray(arr)) return arr; }

function ListItemLabel$1(props) {
  var _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides;

  var _getOverrides = getOverrides(overrides.LabelSublistContent, StyledLabelSublistContent),
      _getOverrides2 = _slicedToArray$o(_getOverrides, 2),
      LabelSublistContent = _getOverrides2[0],
      labelSublistContentProps = _getOverrides2[1];

  var _getOverrides3 = getOverrides(overrides.LabelContent, StyledLabelContent$1),
      _getOverrides4 = _slicedToArray$o(_getOverrides3, 2),
      LabelContent = _getOverrides4[0],
      labelContentProps = _getOverrides4[1];

  var _getOverrides5 = getOverrides(overrides.LabelDescription, StyledLabelDescription),
      _getOverrides6 = _slicedToArray$o(_getOverrides5, 2),
      LabelDescription = _getOverrides6[0],
      labelDescriptionProps = _getOverrides6[1];

  if (props.sublist) {
    return /*#__PURE__*/React__default.createElement(LabelSublistContent, labelSublistContentProps, props.children);
  }

  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(LabelContent, labelContentProps, props.children), props.description && /*#__PURE__*/React__default.createElement(LabelDescription, labelDescriptionProps, props.description));
}

var colors_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var colors = {
  white: '#FFFFFF',
  gray50: '#F6F6F6',
  gray100: '#EEEEEE',
  gray200: '#E2E2E2',
  gray300: '#CBCBCB',
  gray400: '#AFAFAF',
  gray500: '#6B6B6B',
  gray600: '#545454',
  gray700: '#333333',
  gray800: '#1F1F1F',
  gray900: '#141414',
  black: '#000000',
  platinum50: '#F4FAFB',
  platinum100: '#EBF5F7',
  platinum200: '#CCDFE5',
  platinum300: '#A1BDCA',
  platinum400: '#8EA3AD',
  platinum500: '#6C7C83',
  platinum600: '#556268',
  platinum700: '#394145',
  platinum800: '#142328',
  red50: '#FFEFED',
  red100: '#FED7D2',
  red200: '#F1998E',
  red300: '#E85C4A',
  red400: '#E11900',
  red500: '#AB1300',
  red600: '#870F00',
  red700: '#5A0A00',
  orange50: '#FFF3EF',
  orange100: '#FFE1D6',
  orange200: '#FABDA5',
  orange300: '#FA9269',
  orange400: '#FF6937',
  orange500: '#C14F29',
  orange600: '#9A3F21',
  orange700: '#672A16',
  yellow50: '#FFFAF0',
  yellow100: '#FFF2D9',
  yellow200: '#FFE3AC',
  yellow300: '#FFCF70',
  yellow400: '#FFC043',
  yellow500: '#BC8B2C',
  yellow600: '#996F00',
  yellow700: '#674D1B',
  green50: '#E6F2ED',
  green100: '#ADDEC9',
  green200: '#66D19E',
  green300: '#06C167',
  green400: '#048848',
  green500: '#03703C',
  green600: '#03582F',
  green700: '#10462D',
  blue50: '#EFF3FE',
  blue100: '#D4E2FC',
  blue200: '#A0BFF8',
  blue300: '#5B91F5',
  blue400: '#276EF1',
  blue500: '#1E54B7',
  blue600: '#174291',
  blue700: '#102C60',
  cobalt50: '#EBEDFA',
  cobalt100: '#D2D7F0',
  cobalt200: '#949CE3',
  cobalt300: '#535FCF',
  cobalt400: '#0E1FC1',
  cobalt500: '#0A1899',
  cobalt600: '#081270',
  cobalt700: '#050C4D',
  purple50: '#F3F1F9',
  purple100: '#E3DDF2',
  purple200: '#C1B4E2',
  purple300: '#957FCE',
  purple400: '#7356BF',
  purple500: '#574191',
  purple600: '#453473',
  purple700: '#2E224C',
  brown50: '#F6F0EA',
  brown100: '#EBE0DB',
  brown200: '#D2BBB0',
  brown300: '#B18977',
  brown400: '#99644C',
  brown500: '#744C3A',
  brown600: '#5C3C2E',
  brown700: '#3D281E'
};
var _default = colors;
exports.default = _default;
});

unwrapExports(colors_1);

var require$$1$3 = colors_1;

var tokens = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "colors", {
  enumerable: true,
  get: function get() {
    return _colors.default;
  }
});

var _colors = _interopRequireDefault(require$$1$3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
});

unwrapExports(tokens);

var _index$2 = tokens;

var colorTokens$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;



/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// color constants
var lightColorTokens = {
  // Primary Palette
  primaryA: _index$2.colors.black,
  primaryB: _index$2.colors.white,
  primary: _index$2.colors.black,
  primary50: _index$2.colors.gray50,
  primary100: _index$2.colors.gray100,
  primary200: _index$2.colors.gray200,
  primary300: _index$2.colors.gray300,
  primary400: _index$2.colors.gray400,
  primary500: _index$2.colors.gray500,
  primary600: _index$2.colors.gray600,
  primary700: _index$2.colors.gray700,
  // Accent Palette
  accent: _index$2.colors.blue400,
  accent50: _index$2.colors.blue50,
  accent100: _index$2.colors.blue100,
  accent200: _index$2.colors.blue200,
  accent300: _index$2.colors.blue300,
  accent400: _index$2.colors.blue400,
  accent500: _index$2.colors.blue500,
  accent600: _index$2.colors.blue600,
  accent700: _index$2.colors.blue700,
  // Negative Palette
  negative: _index$2.colors.red400,
  negative50: _index$2.colors.red50,
  negative100: _index$2.colors.red100,
  negative200: _index$2.colors.red200,
  negative300: _index$2.colors.red300,
  negative400: _index$2.colors.red400,
  negative500: _index$2.colors.red500,
  negative600: _index$2.colors.red600,
  negative700: _index$2.colors.red700,
  // Warning Palette
  warning: _index$2.colors.yellow400,
  warning50: _index$2.colors.yellow50,
  warning100: _index$2.colors.yellow100,
  warning200: _index$2.colors.yellow200,
  warning300: _index$2.colors.yellow300,
  warning400: _index$2.colors.yellow400,
  warning500: _index$2.colors.yellow500,
  warning600: _index$2.colors.yellow600,
  warning700: _index$2.colors.yellow700,
  // Positive Palette
  positive: _index$2.colors.green500,
  positive50: _index$2.colors.green50,
  positive100: _index$2.colors.green100,
  positive200: _index$2.colors.green200,
  positive300: _index$2.colors.green300,
  positive400: _index$2.colors.green400,
  positive500: _index$2.colors.green500,
  positive600: _index$2.colors.green600,
  positive700: _index$2.colors.green700,
  // Monochrome Palette
  white: _index$2.colors.white,
  black: _index$2.colors.black,
  mono100: _index$2.colors.white,
  mono200: _index$2.colors.gray50,
  mono300: _index$2.colors.gray100,
  mono400: _index$2.colors.gray200,
  mono500: _index$2.colors.gray300,
  mono600: _index$2.colors.gray400,
  mono700: _index$2.colors.gray500,
  mono800: _index$2.colors.gray600,
  mono900: _index$2.colors.gray700,
  mono1000: _index$2.colors.black,
  // Rating Palette,
  rating200: _index$2.colors.yellow200,
  rating400: _index$2.colors.yellow400,
  ratingInactiveFill: _index$2.colors.gray100,
  ratingStroke: _index$2.colors.gray300
};
var _default = lightColorTokens;
exports.default = _default;
});

unwrapExports(colorTokens$1);

var util = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hexToRgb = hexToRgb;
exports.expandBorderStyles = expandBorderStyles;
exports.ellipsisText = void 0;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function hexToRgb() {
  var hex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1';
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? "rgba(".concat(parseInt(result[1], 16), ", ").concat(parseInt(result[2], 16), ", ").concat(parseInt(result[3], 16), ", ").concat(alpha, ")") : null;
}

var ellipsisText = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  wordWrap: 'normal'
};
exports.ellipsisText = ellipsisText;

function expandBorderStyles(borderStyles) {
  return {
    borderTopWidth: borderStyles.borderWidth,
    borderTopStyle: borderStyles.borderStyle,
    borderTopColor: borderStyles.borderColor,
    borderBottomWidth: borderStyles.borderWidth,
    borderBottomStyle: borderStyles.borderStyle,
    borderBottomColor: borderStyles.borderColor,
    borderLeftWidth: borderStyles.borderWidth,
    borderLeftStyle: borderStyles.borderStyle,
    borderLeftColor: borderStyles.borderColor,
    borderRightWidth: borderStyles.borderWidth,
    borderRightStyle: borderStyles.borderStyle,
    borderRightColor: borderStyles.borderColor
  };
}
});

unwrapExports(util);
util.hexToRgb;
util.expandBorderStyles;
util.ellipsisText;

var require$$0$4 = colorTokens$1;

var _util = util;

var colorSemanticTokens$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colorTokens = _interopRequireDefault(require$$0$4);



var _colors = _interopRequireDefault(require$$1$3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default() {
  var foundation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _colorTokens.default;
  var core = {
    // Background
    backgroundPrimary: foundation.primaryB,
    backgroundSecondary: _colors.default.gray50,
    backgroundTertiary: _colors.default.gray100,
    backgroundInversePrimary: foundation.primaryA,
    backgroundInverseSecondary: _colors.default.gray800,
    // Content
    contentPrimary: foundation.primaryA,
    contentSecondary: _colors.default.gray600,
    contentTertiary: _colors.default.gray500,
    contentInversePrimary: foundation.primaryB,
    contentInverseSecondary: _colors.default.gray300,
    contentInverseTertiary: _colors.default.gray400,
    // Border
    borderOpaque: _colors.default.gray200,
    borderTransparent: (0, _util.hexToRgb)(foundation.primaryA, '0.08'),
    borderSelected: foundation.primaryA,
    borderInverseOpaque: _colors.default.gray700,
    borderInverseTransparent: (0, _util.hexToRgb)(foundation.primaryB, '0.2'),
    borderInverseSelected: foundation.primaryB
  };
  var coreExtensions = {
    // Backgrounds
    backgroundStateDisabled: _colors.default.gray50,
    backgroundOverlayDark: (0, _util.hexToRgb)(_colors.default.black, '0.3'),
    backgroundOverlayLight: (0, _util.hexToRgb)(_colors.default.black, '0.08'),
    backgroundAccent: foundation.accent,
    backgroundNegative: foundation.negative,
    backgroundWarning: foundation.warning,
    backgroundPositive: _colors.default.green400,
    backgroundLightAccent: _colors.default.blue50,
    backgroundLightNegative: _colors.default.red50,
    backgroundLightWarning: _colors.default.yellow50,
    backgroundLightPositive: _colors.default.green50,
    backgroundAlwaysDark: _colors.default.black,
    backgroundAlwaysLight: _colors.default.white,
    // Content
    contentStateDisabled: _colors.default.gray400,
    contentAccent: foundation.accent,
    contentOnColor: _colors.default.white,
    contentOnColorInverse: _colors.default.black,
    contentNegative: foundation.negative,
    contentWarning: _colors.default.yellow600,
    contentPositive: _colors.default.green400,
    // Border
    borderStateDisabled: _colors.default.gray50,
    borderAccent: _colors.default.blue400,
    borderAccentLight: _colors.default.blue200,
    borderNegative: _colors.default.red200,
    borderWarning: _colors.default.yellow200,
    borderPositive: _colors.default.green200,
    // Programs
    safety: _colors.default.blue400,
    eatsGreen400: _colors.default.green400,
    freightBlue400: _colors.default.cobalt400,
    jumpRed400: _colors.default.red400,
    rewardsTier1: _colors.default.blue400,
    rewardsTier2: _colors.default.yellow400,
    rewardsTier3: _colors.default.platinum400,
    rewardsTier4: _colors.default.black,
    membership: _colors.default.yellow600
  };
  return _objectSpread(_objectSpread({}, core), coreExtensions);
};

exports.default = _default;
});

unwrapExports(colorSemanticTokens$1);

var colorComponentTokens$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colorTokens = _interopRequireDefault(require$$0$4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var tagHoverBackground = "rgba(0, 0, 0, 0.08)";
/* ---- Component colors ---- */
// TODO(#2318) Make it a plain object in the next v11 major version
// with values taken from `colorTokens`.
// Due to the legacy `createTheme` type the value need to be
// overrideable through primitives (`foundation` )

var _default = function _default() {
  var themePrimitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _colorTokens.default;
  return {
    // Buttons
    buttonPrimaryFill: themePrimitives.primary,
    buttonPrimaryText: themePrimitives.white,
    buttonPrimaryHover: themePrimitives.primary700,
    buttonPrimaryActive: themePrimitives.primary600,
    buttonPrimarySelectedFill: themePrimitives.primary600,
    buttonPrimarySelectedText: themePrimitives.white,
    buttonPrimarySpinnerForeground: themePrimitives.accent,
    buttonPrimarySpinnerBackground: themePrimitives.primaryB,
    buttonSecondaryFill: themePrimitives.primary100,
    buttonSecondaryText: themePrimitives.primary,
    buttonSecondaryHover: themePrimitives.primary200,
    buttonSecondaryActive: themePrimitives.primary300,
    buttonSecondarySelectedFill: themePrimitives.primary300,
    buttonSecondarySelectedText: themePrimitives.primary,
    buttonSecondarySpinnerForeground: themePrimitives.accent,
    buttonSecondarySpinnerBackground: themePrimitives.primaryB,
    buttonTertiaryFill: 'transparent',
    buttonTertiaryText: themePrimitives.primary,
    buttonTertiaryHover: themePrimitives.primary50,
    buttonTertiaryActive: themePrimitives.primary100,
    buttonTertiarySelectedFill: themePrimitives.primary100,
    buttonTertiarySelectedText: themePrimitives.primary,
    buttonTertiaryDisabledActiveFill: themePrimitives.primary50,
    buttonTertiaryDisabledActiveText: themePrimitives.mono600,
    buttonTertiarySpinnerForeground: themePrimitives.accent,
    buttonTertiarySpinnerBackground: themePrimitives.primary100,
    buttonMinimalFill: 'transparent',
    buttonMinimalText: themePrimitives.primary,
    buttonMinimalHover: themePrimitives.primary50,
    buttonMinimalActive: themePrimitives.primary100,
    buttonMinimalSelectedFill: themePrimitives.primary100,
    buttonMinimalSelectedText: themePrimitives.primary,
    buttonMinimalSpinnerForeground: themePrimitives.accent,
    buttonMinimalSpinnerBackground: themePrimitives.primary100,
    buttonDisabledFill: themePrimitives.mono200,
    buttonDisabledText: themePrimitives.mono600,
    buttonDisabledActiveFill: themePrimitives.mono700,
    buttonDisabledActiveText: themePrimitives.mono100,
    buttonDisabledSpinnerForeground: themePrimitives.mono600,
    buttonDisabledSpinnerBackground: themePrimitives.mono400,
    // Breadcrumbs
    breadcrumbsText: themePrimitives.mono900,
    breadcrumbsSeparatorFill: themePrimitives.mono700,
    // Datepicker
    datepickerBackground: themePrimitives.mono100,
    datepickerDayFont: themePrimitives.mono1000,
    datepickerDayFontDisabled: themePrimitives.mono500,
    datepickerDayPseudoSelected: themePrimitives.primary100,
    datepickerDayPseudoHighlighted: themePrimitives.primary200,
    // Calendar
    calendarBackground: themePrimitives.mono100,
    calendarForeground: themePrimitives.mono1000,
    calendarForegroundDisabled: themePrimitives.mono500,
    calendarHeaderBackground: themePrimitives.white,
    calendarHeaderForeground: themePrimitives.primary,
    calendarHeaderBackgroundActive: themePrimitives.primary700,
    calendarHeaderForegroundDisabled: themePrimitives.primary500,
    calendarDayBackgroundPseudoSelected: themePrimitives.primary100,
    calendarDayForegroundPseudoSelected: themePrimitives.mono1000,
    calendarDayBackgroundPseudoSelectedHighlighted: themePrimitives.primary200,
    calendarDayForegroundPseudoSelectedHighlighted: themePrimitives.mono1000,
    calendarDayBackgroundSelected: themePrimitives.primary,
    calendarDayForegroundSelected: themePrimitives.white,
    calendarDayBackgroundSelectedHighlighted: themePrimitives.primary,
    calendarDayForegroundSelectedHighlighted: themePrimitives.white,
    // Combobox
    comboboxListItemFocus: themePrimitives.mono200,
    comboboxListItemHover: themePrimitives.mono300,
    // FileUploader
    fileUploaderBackgroundColor: themePrimitives.mono200,
    fileUploaderBackgroundColorActive: themePrimitives.primary50,
    fileUploaderBorderColorActive: themePrimitives.primary,
    fileUploaderBorderColorDefault: themePrimitives.mono500,
    fileUploaderMessageColor: themePrimitives.mono800,
    // Links
    linkText: themePrimitives.primary,
    linkVisited: themePrimitives.primary700,
    linkHover: themePrimitives.primary600,
    linkActive: themePrimitives.primary500,
    // List
    listHeaderFill: themePrimitives.white,
    listBodyFill: themePrimitives.white,
    listIconFill: themePrimitives.mono500,
    listBorder: themePrimitives.mono500,
    // ProgressSteps
    progressStepsCompletedText: themePrimitives.white,
    progressStepsCompletedFill: themePrimitives.primary,
    progressStepsActiveText: themePrimitives.white,
    progressStepsActiveFill: themePrimitives.primary,
    progressStepsIconActiveFill: themePrimitives.primary,
    // Toggle
    toggleFill: themePrimitives.white,
    toggleFillChecked: themePrimitives.primary,
    toggleFillDisabled: themePrimitives.mono600,
    toggleTrackFill: themePrimitives.mono400,
    toggleTrackFillDisabled: themePrimitives.mono300,
    // Tick
    tickFill: themePrimitives.mono100,
    tickFillHover: themePrimitives.mono200,
    tickFillActive: themePrimitives.mono300,
    tickFillSelected: themePrimitives.primary,
    tickFillSelectedHover: themePrimitives.primary700,
    tickFillSelectedHoverActive: themePrimitives.primary600,
    tickFillError: themePrimitives.negative50,
    tickFillErrorHover: themePrimitives.negative100,
    tickFillErrorHoverActive: themePrimitives.negative200,
    tickFillErrorSelected: themePrimitives.negative400,
    tickFillErrorSelectedHover: themePrimitives.negative500,
    tickFillErrorSelectedHoverActive: themePrimitives.negative600,
    tickFillDisabled: themePrimitives.mono600,
    tickBorder: themePrimitives.mono700,
    tickBorderError: themePrimitives.negative400,
    tickMarkFill: themePrimitives.white,
    tickMarkFillError: themePrimitives.white,
    tickMarkFillDisabled: themePrimitives.mono100,
    // Slider/Toggle
    sliderTrackFill: 'transparent',
    sliderHandleFill: themePrimitives.primaryA,
    sliderHandleFillDisabled: themePrimitives.primary400,
    sliderHandleInnerFill: themePrimitives.primaryA,
    sliderTrackFillHover: themePrimitives.mono500,
    sliderTrackFillActive: themePrimitives.mono600,
    sliderTrackFillSelected: themePrimitives.primary,
    sliderTrackFillSelectedHover: themePrimitives.primary,
    sliderTrackFillSelectedActive: themePrimitives.primary500,
    sliderTrackFillDisabled: themePrimitives.mono300,
    sliderHandleFillHover: themePrimitives.white,
    sliderHandleFillActive: themePrimitives.white,
    sliderHandleFillSelected: themePrimitives.white,
    sliderHandleFillSelectedHover: themePrimitives.white,
    sliderHandleFillSelectedActive: themePrimitives.white,
    sliderHandleInnerFillDisabled: themePrimitives.mono400,
    sliderHandleInnerFillSelectedHover: themePrimitives.primary,
    sliderHandleInnerFillSelectedActive: themePrimitives.primary500,
    sliderBorder: themePrimitives.mono500,
    sliderBorderHover: themePrimitives.primary,
    sliderBorderDisabled: themePrimitives.mono600,
    // Inputs
    inputBorder: themePrimitives.mono300,
    inputFill: themePrimitives.mono300,
    inputFillError: themePrimitives.negative50,
    inputFillDisabled: themePrimitives.mono200,
    inputFillActive: themePrimitives.mono200,
    inputFillPositive: themePrimitives.positive50,
    inputTextDisabled: themePrimitives.mono600,
    inputBorderError: themePrimitives.negative200,
    inputBorderPositive: themePrimitives.positive200,
    inputEnhancerFill: themePrimitives.mono300,
    inputEnhancerFillDisabled: themePrimitives.mono300,
    inputEnhancerTextDisabled: themePrimitives.mono600,
    inputPlaceholder: themePrimitives.mono700,
    inputPlaceholderDisabled: themePrimitives.mono600,
    // Menu
    menuFill: themePrimitives.mono100,
    menuFillHover: themePrimitives.mono200,
    menuFontDefault: themePrimitives.mono800,
    menuFontDisabled: themePrimitives.mono500,
    menuFontHighlighted: themePrimitives.mono1000,
    menuFontSelected: themePrimitives.mono1000,
    // Modal
    modalCloseColor: themePrimitives.mono1000,
    modalCloseColorHover: themePrimitives.mono800,
    modalCloseColorFocus: themePrimitives.mono800,
    // Pagination
    paginationTriangleDown: themePrimitives.mono800,
    // Header navigation
    headerNavigationFill: 'transparent',
    // Tab
    tabBarFill: themePrimitives.mono200,
    tabColor: themePrimitives.mono800,
    // Notification
    notificationPrimaryBackground: themePrimitives.primary50,
    notificationPrimaryText: themePrimitives.primaryA,
    notificationInfoBackground: themePrimitives.accent50,
    notificationInfoText: themePrimitives.primaryA,
    notificationPositiveBackground: themePrimitives.positive50,
    notificationPositiveText: themePrimitives.primaryA,
    notificationWarningBackground: themePrimitives.warning50,
    notificationWarningText: themePrimitives.primaryA,
    notificationNegativeBackground: themePrimitives.negative50,
    notificationNegativeText: themePrimitives.primaryA,
    // Tag
    // Custom ramps
    tagFontDisabledRampUnit: '100',
    tagOutlinedDisabledRampUnit: '200',
    tagSolidFontRampUnit: '0',
    tagSolidRampUnit: '400',
    tagOutlinedFontRampUnit: '400',
    tagOutlinedRampUnit: '200',
    // Deprecated
    tagSolidHoverRampUnit: '50',
    tagSolidActiveRampUnit: '100',
    tagSolidDisabledRampUnit: '50',
    tagSolidFontHoverRampUnit: '500',
    tagLightRampUnit: '50',
    tagLightHoverRampUnit: '100',
    tagLightActiveRampUnit: '100',
    tagLightDisabledRampUnit: '50',
    tagLightFontRampUnit: '500',
    tagLightFontHoverRampUnit: '500',
    tagOutlinedHoverRampUnit: '50',
    tagOutlinedActiveRampUnit: '0',
    tagOutlinedFontHoverRampUnit: '400',
    // Neutral
    tagNeutralFontDisabled: themePrimitives.mono600,
    tagNeutralOutlinedDisabled: themePrimitives.mono400,
    tagNeutralSolidFont: themePrimitives.white,
    tagNeutralSolidBackground: themePrimitives.black,
    tagNeutralOutlinedBackground: themePrimitives.mono600,
    tagNeutralOutlinedFont: themePrimitives.black,
    // Deprecated
    tagNeutralSolidHover: themePrimitives.mono300,
    tagNeutralSolidActive: themePrimitives.mono400,
    tagNeutralSolidDisabled: themePrimitives.mono200,
    tagNeutralSolidFontHover: themePrimitives.mono900,
    tagNeutralLightBackground: themePrimitives.mono300,
    tagNeutralLightHover: themePrimitives.mono300,
    tagNeutralLightActive: themePrimitives.mono400,
    tagNeutralLightDisabled: themePrimitives.mono200,
    tagNeutralLightFont: themePrimitives.mono900,
    tagNeutralLightFontHover: themePrimitives.mono900,
    tagNeutralOutlinedActive: themePrimitives.mono900,
    tagNeutralOutlinedFontHover: themePrimitives.mono800,
    tagNeutralOutlinedHover: tagHoverBackground,
    // Primary
    tagPrimaryFontDisabled: themePrimitives.primary400,
    tagPrimaryOutlinedDisabled: themePrimitives.primary200,
    tagPrimarySolidFont: themePrimitives.white,
    tagPrimarySolidBackground: themePrimitives.primary,
    tagPrimaryOutlinedFontHover: themePrimitives.primary,
    tagPrimaryOutlinedFont: themePrimitives.primary,
    // Deprecated
    tagPrimarySolidHover: themePrimitives.primary100,
    tagPrimarySolidActive: themePrimitives.primary200,
    tagPrimarySolidDisabled: themePrimitives.primary50,
    tagPrimarySolidFontHover: themePrimitives.primary700,
    tagPrimaryLightBackground: themePrimitives.primary50,
    tagPrimaryLightHover: themePrimitives.primary100,
    tagPrimaryLightActive: themePrimitives.primary100,
    tagPrimaryLightDisabled: themePrimitives.primary50,
    tagPrimaryLightFont: themePrimitives.primary500,
    tagPrimaryLightFontHover: themePrimitives.primary500,
    tagPrimaryOutlinedActive: themePrimitives.primary600,
    tagPrimaryOutlinedHover: tagHoverBackground,
    tagPrimaryOutlinedBackground: themePrimitives.primary400,
    // Accent
    tagAccentFontDisabled: themePrimitives.accent200,
    tagAccentOutlinedDisabled: themePrimitives.accent200,
    tagAccentSolidFont: themePrimitives.white,
    tagAccentSolidBackground: themePrimitives.accent400,
    tagAccentOutlinedBackground: themePrimitives.accent200,
    tagAccentOutlinedFont: themePrimitives.accent400,
    // Deprecated
    tagAccentSolidHover: themePrimitives.accent50,
    tagAccentSolidActive: themePrimitives.accent100,
    tagAccentSolidDisabled: themePrimitives.accent50,
    tagAccentSolidFontHover: themePrimitives.accent500,
    tagAccentLightBackground: themePrimitives.accent50,
    tagAccentLightHover: themePrimitives.accent100,
    tagAccentLightActive: themePrimitives.accent100,
    tagAccentLightDisabled: themePrimitives.accent50,
    tagAccentLightFont: themePrimitives.accent500,
    tagAccentLightFontHover: themePrimitives.accent500,
    tagAccentOutlinedActive: themePrimitives.accent600,
    tagAccentOutlinedFontHover: themePrimitives.accent400,
    tagAccentOutlinedHover: tagHoverBackground,
    // Positive
    tagPositiveFontDisabled: themePrimitives.positive200,
    tagPositiveOutlinedDisabled: themePrimitives.positive200,
    tagPositiveSolidFont: themePrimitives.white,
    tagPositiveSolidBackground: themePrimitives.positive400,
    tagPositiveOutlinedBackground: themePrimitives.positive200,
    tagPositiveOutlinedFont: themePrimitives.positive400,
    // Deprecated
    tagPositiveSolidHover: themePrimitives.positive50,
    tagPositiveSolidActive: themePrimitives.positive100,
    tagPositiveSolidDisabled: themePrimitives.positive50,
    tagPositiveSolidFontHover: themePrimitives.positive500,
    tagPositiveLightBackground: themePrimitives.positive50,
    tagPositiveLightHover: themePrimitives.positive100,
    tagPositiveLightActive: themePrimitives.positive100,
    tagPositiveLightDisabled: themePrimitives.positive50,
    tagPositiveLightFont: themePrimitives.positive500,
    tagPositiveLightFontHover: themePrimitives.positive500,
    tagPositiveOutlinedActive: themePrimitives.positive600,
    tagPositiveOutlinedFontHover: themePrimitives.positive400,
    tagPositiveOutlinedHover: tagHoverBackground,
    // Warning
    tagWarningFontDisabled: themePrimitives.warning300,
    tagWarningOutlinedDisabled: themePrimitives.warning300,
    tagWarningSolidFont: themePrimitives.warning700,
    tagWarningSolidBackground: themePrimitives.warning400,
    tagWarningOutlinedBackground: themePrimitives.warning300,
    tagWarningOutlinedFont: themePrimitives.warning600,
    // Deprecated
    tagWarningSolidHover: themePrimitives.warning50,
    tagWarningSolidActive: themePrimitives.warning100,
    tagWarningSolidDisabled: themePrimitives.warning50,
    tagWarningSolidFontHover: themePrimitives.warning500,
    tagWarningLightBackground: themePrimitives.warning50,
    tagWarningLightHover: themePrimitives.warning100,
    tagWarningLightActive: themePrimitives.warning100,
    tagWarningLightDisabled: themePrimitives.warning50,
    tagWarningLightFont: themePrimitives.warning500,
    tagWarningLightFontHover: themePrimitives.warning500,
    tagWarningOutlinedActive: themePrimitives.warning600,
    tagWarningOutlinedFontHover: themePrimitives.warning600,
    tagWarningOutlinedHover: tagHoverBackground,
    // Negative
    tagNegativeFontDisabled: themePrimitives.negative200,
    tagNegativeOutlinedDisabled: themePrimitives.negative200,
    tagNegativeSolidFont: themePrimitives.white,
    tagNegativeSolidBackground: themePrimitives.negative400,
    tagNegativeOutlinedBackground: themePrimitives.negative200,
    tagNegativeOutlinedFont: themePrimitives.negative400,
    // Deprecated
    tagNegativeSolidHover: themePrimitives.negative50,
    tagNegativeSolidActive: themePrimitives.negative100,
    tagNegativeSolidDisabled: themePrimitives.negative50,
    tagNegativeSolidFontHover: themePrimitives.negative500,
    tagNegativeLightBackground: themePrimitives.negative50,
    tagNegativeLightHover: themePrimitives.negative100,
    tagNegativeLightActive: themePrimitives.negative100,
    tagNegativeLightDisabled: themePrimitives.negative50,
    tagNegativeLightFont: themePrimitives.negative500,
    tagNegativeLightFontHover: themePrimitives.negative500,
    tagNegativeOutlinedActive: themePrimitives.negative600,
    tagNegativeOutlinedFontHover: themePrimitives.negative400,
    tagNegativeOutlinedHover: tagHoverBackground,
    // Table
    tableHeadBackgroundColor: themePrimitives.mono100,
    tableBackground: themePrimitives.mono100,
    tableStripedBackground: themePrimitives.mono200,
    tableFilter: themePrimitives.mono600,
    tableFilterHeading: themePrimitives.mono700,
    tableFilterBackground: themePrimitives.mono100,
    tableFilterFooterBackground: themePrimitives.mono200,
    // Toast
    toastText: themePrimitives.white,
    toastPrimaryBackground: themePrimitives.primary400,
    toastPrimaryText: themePrimitives.white,
    toastInfoBackground: themePrimitives.accent400,
    toastInfoText: themePrimitives.white,
    toastPositiveBackground: themePrimitives.positive400,
    toastPositiveText: themePrimitives.white,
    toastWarningBackground: themePrimitives.warning400,
    toastWarningText: themePrimitives.black,
    toastNegativeBackground: themePrimitives.negative400,
    toastNegativeText: themePrimitives.white,
    // Spinner
    spinnerTrackFill: themePrimitives.mono900,
    // Progress bar
    progressbarTrackFill: themePrimitives.mono900,
    // Tooltip
    tooltipBackground: themePrimitives.mono900,
    tooltipText: themePrimitives.mono100
  };
};

exports.default = _default;
});

unwrapExports(colorComponentTokens$1);

var colorDeprecatedSemanticTokens$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colorTokens = _interopRequireDefault(require$$0$4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* ---- DEPRECATED ---- */
var _default = function _default() {
  var themePrimitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _colorTokens.default;
  return {
    // TODO(#2318) Remove Legacy Semantic Colors values in the next v11 major
    // since it's not used in the component specific tokens
    // and we ship semantic tokens separately

    /* ---- Legacy Semantic Colors ---- */
    // Font Color
    colorPrimary: themePrimitives.black,
    colorSecondary: themePrimitives.mono800,
    // Background
    background: themePrimitives.white,
    backgroundAlt: themePrimitives.white,
    backgroundInv: themePrimitives.primary,
    // Foreground
    foreground: themePrimitives.black,
    foregroundAlt: themePrimitives.mono800,
    foregroundInv: themePrimitives.white,
    // Borders
    border: themePrimitives.mono500,
    borderAlt: themePrimitives.mono600,
    borderFocus: themePrimitives.primary,
    borderError: themePrimitives.negative,
    // Shadow
    shadowFocus: 'rgba(39, 110, 241, 0.32)',
    shadowError: 'rgba(229, 73, 55, 0.32)'
  };
};

exports.default = _default;
});

unwrapExports(colorDeprecatedSemanticTokens$1);

var borders_1$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// borderColor is defaulted to the light theme values.
// Dark theme overrides the border colors.
var borders = {
  border100: {
    borderColor: 'hsla(0, 0%, 0%, 0.04)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border200: {
    borderColor: 'hsla(0, 0%, 0%, 0.08)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border300: {
    borderColor: 'hsla(0, 0%, 0%, 0.12)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border400: {
    borderColor: 'hsla(0, 0%, 0%, 0.16)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border500: {
    borderColor: 'hsla(0, 0%, 0%, 0.2)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border600: {
    borderColor: 'hsla(0, 0%, 0%, 0.24)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  radius100: '2px',
  radius200: '4px',
  radius300: '8px',
  radius400: '12px',
  radius500: '16px',

  /** Datepicker (Range), Progress Bar, Slider, Tag */
  useRoundedCorners: true,

  /** Button, ButtonGroup */
  buttonBorderRadius: '0px',

  /** Input, Select, Textarea, Checkbox */
  inputBorderRadius: '0px',

  /** Popover, Menu, Tooltip */
  popoverBorderRadius: '0px',

  /** Card, Datepicker, Modal, Toast, Notification */
  surfaceBorderRadius: '0px',

  /** Tag */
  tagBorderRadius: '24px'
};
var _default = borders;
exports.default = _default;
});

unwrapExports(borders_1$1);

var lighting_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var lighting = {
  shadow400: '0 1px 4px hsla(0, 0%, 0%, 0.16)',
  shadow500: '0 2px 8px hsla(0, 0%, 0%, 0.16)',
  shadow600: '0 4px 16px hsla(0, 0%, 0%, 0.16)',
  shadow700: '0 8px 24px hsla(0, 0%, 0%, 0.16)',
  overlay0: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0)',
  overlay100: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.04)',
  overlay200: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.08)',
  overlay300: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.12)',
  overlay400: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.16)',
  overlay500: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.2)',
  overlay600: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.24)',
  shallowAbove: '0px -4px 16px rgba(0, 0, 0, 0.12)',
  shallowBelow: '0px 4px 16px rgba(0, 0, 0, 0.12)',
  deepAbove: '0px -16px 48px rgba(0, 0, 0, 0.22)',
  deepBelow: '0px 16px 48px rgba(0, 0, 0, 0.22)'
};
var _default = lighting;
exports.default = _default;
});

unwrapExports(lighting_1);

var typography$2 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.defaultFontTokens = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var defaultFontTokens = {
  primaryFontFamily: 'system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif'
};
exports.defaultFontTokens = defaultFontTokens;
var monoFontFamily = '"Lucida Console", Monaco, monospace';

var _default = function _default() {
  var fontTokens = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultFontTokens;
  var font100 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '12px',
    fontWeight: 'normal',
    lineHeight: '20px'
  };
  var font150 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px'
  };
  var font200 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: '20px'
  };
  var font250 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '16px'
  };
  var font300 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '16px',
    fontWeight: 'normal',
    lineHeight: '24px'
  };
  var font350 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '20px'
  };
  var font400 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '18px',
    fontWeight: 'normal',
    lineHeight: '28px'
  };
  var font450 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '24px'
  };
  var font550 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '28px'
  };
  var font650 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '32px'
  };
  var font750 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '28px',
    fontWeight: 500,
    lineHeight: '36px'
  };
  var font850 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '32px',
    fontWeight: 500,
    lineHeight: '40px'
  };
  var font950 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '36px',
    fontWeight: 500,
    lineHeight: '44px'
  };
  var font1050 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '40px',
    fontWeight: 500,
    lineHeight: '52px'
  };
  var font1150 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '36px',
    fontWeight: 500,
    lineHeight: '44px'
  };
  var font1250 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '44px',
    fontWeight: 500,
    lineHeight: '52px'
  };
  var font1350 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '52px',
    fontWeight: 500,
    lineHeight: '64px'
  };
  var font1450 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '96px',
    fontWeight: 500,
    lineHeight: '112px'
  };
  return {
    font100: font100,
    font150: font150,
    font200: font200,
    font250: font250,
    font300: font300,
    font350: font350,
    font400: font400,
    font450: font450,
    font550: font550,
    font650: font650,
    font750: font750,
    font850: font850,
    font950: font950,
    font1050: font1050,
    font1150: font1150,
    font1250: font1250,
    font1350: font1350,
    font1450: font1450,
    ParagraphXSmall: font100,
    ParagraphSmall: font200,
    ParagraphMedium: font300,
    ParagraphLarge: font400,
    LabelXSmall: font150,
    LabelSmall: font250,
    LabelMedium: font350,
    LabelLarge: font450,
    HeadingXSmall: font550,
    HeadingSmall: font650,
    HeadingMedium: font750,
    HeadingLarge: font850,
    HeadingXLarge: font950,
    HeadingXXLarge: font1050,
    DisplayXSmall: font1150,
    DisplaySmall: font1250,
    DisplayMedium: font1350,
    DisplayLarge: font1450,
    MonoParagraphXSmall: _objectSpread(_objectSpread({}, font100), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphSmall: _objectSpread(_objectSpread({}, font200), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphMedium: _objectSpread(_objectSpread({}, font300), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphLarge: _objectSpread(_objectSpread({}, font400), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelXSmall: _objectSpread(_objectSpread({}, font150), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelSmall: _objectSpread(_objectSpread({}, font250), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelMedium: _objectSpread(_objectSpread({}, font350), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelLarge: _objectSpread(_objectSpread({}, font450), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXSmall: _objectSpread(_objectSpread({}, font550), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingSmall: _objectSpread(_objectSpread({}, font650), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingMedium: _objectSpread(_objectSpread({}, font750), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingLarge: _objectSpread(_objectSpread({}, font850), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXLarge: _objectSpread(_objectSpread({}, font950), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXXLarge: _objectSpread(_objectSpread({}, font1050), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayXSmall: _objectSpread(_objectSpread({}, font1150), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplaySmall: _objectSpread(_objectSpread({}, font1250), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayMedium: _objectSpread(_objectSpread({}, font1350), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayLarge: _objectSpread(_objectSpread({}, font1450), {}, {
      fontFamily: monoFontFamily
    })
  };
};

exports.default = _default;
});

unwrapExports(typography$2);
typography$2.defaultFontTokens;

var animation_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var animation = {
  timing100: '100ms',
  timing200: '200ms',
  timing300: '300ms',
  timing400: '400ms',
  timing500: '500ms',
  timing600: '600ms',
  timing700: '700ms',
  timing800: '800ms',
  timing900: '900ms',
  timing1000: '1000ms',
  easeInCurve: 'cubic-bezier(.8, .2, .6, 1)',
  easeOutCurve: 'cubic-bezier(.2, .8, .4, 1)',
  easeInOutCurve: 'cubic-bezier(0.4, 0, 0.2, 1)',
  easeInQuinticCurve: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
  easeOutQuinticCurve: 'cubic-bezier(0.23, 1, 0.32, 1)',
  easeInOutQuinticCurve: 'cubic-bezier(0.86, 0, 0.07, 1)',
  linearCurve: 'cubic-bezier(0, 0, 1, 1)'
};
var _default = animation;
exports.default = _default;
});

unwrapExports(animation_1);

var breakpoints_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var breakpoints = {
  small: 320,
  medium: 600,
  large: 1136
};
var _default = breakpoints;
exports.default = _default;
});

unwrapExports(breakpoints_1);

var grid_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var grid = {
  columns: [4, 8, 12],
  gutters: [16, 36, 36],
  margins: [16, 36, 64],
  gaps: 0,
  unit: 'px',
  maxWidth: 1280
};
var _default = grid;
exports.default = _default;
});

unwrapExports(grid_1);

var responsiveHelpers = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMediaQueries = exports.getMediaQuery = void 0;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/**
 * Helper function that generates media queries based on breakpoint, e.g.
 * getMediaQuery(720) => '@media screen and (min-width: 720px)'
 */
var getMediaQuery = function getMediaQuery(breakpoint) {
  return "@media screen and (min-width: ".concat(breakpoint, "px)");
};

exports.getMediaQuery = getMediaQuery;

var getMediaQueries = function getMediaQueries(breakpoints) {
  return Object.keys(breakpoints).map(function (key) {
    return breakpoints[key];
  }).sort(function (a, b) {
    return a - b;
  }).map(getMediaQuery);
};

exports.getMediaQueries = getMediaQueries;
});

unwrapExports(responsiveHelpers);
responsiveHelpers.getMediaQueries;
responsiveHelpers.getMediaQuery;

var _responsiveHelpers = responsiveHelpers;

var require$$2$1 = breakpoints_1;

var mediaQuery_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;



var _breakpoints = _interopRequireDefault(require$$2$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var mediaQuery = {
  small: (0, _responsiveHelpers.getMediaQuery)(_breakpoints.default.small),
  medium: (0, _responsiveHelpers.getMediaQuery)(_breakpoints.default.medium),
  large: (0, _responsiveHelpers.getMediaQuery)(_breakpoints.default.large)
};
var _default = mediaQuery;
exports.default = _default;
});

unwrapExports(mediaQuery_1);

var sizing_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var sizing = {
  scale0: '2px',
  scale100: '4px',
  scale200: '6px',
  scale300: '8px',
  scale400: '10px',
  scale500: '12px',
  scale550: '14px',
  scale600: '16px',
  scale650: '18px',
  scale700: '20px',
  scale750: '22px',
  scale800: '24px',
  scale850: '28px',
  scale900: '32px',
  scale950: '36px',
  scale1000: '40px',
  scale1200: '48px',
  scale1400: '56px',
  scale1600: '64px',
  scale2400: '96px',
  scale3200: '128px',
  scale4800: '192px'
};
var _default = sizing;
exports.default = _default;
});

unwrapExports(sizing_1);

var require$$7$1 = colorSemanticTokens$1;

var require$$5$1 = colorComponentTokens$1;

var require$$6$1 = colorDeprecatedSemanticTokens$1;

var require$$1$2 = borders_1$1;

var require$$10 = lighting_1;

var _typography$1 = typography$2;

var require$$0$3 = animation_1;

var require$$9 = grid_1;

var require$$11 = mediaQuery_1;

var require$$12 = sizing_1;

var lightTheme = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LightTheme = void 0;

var _colorTokens = _interopRequireDefault(require$$0$4);

var _colorSemanticTokens = _interopRequireDefault(require$$7$1);

var _colorComponentTokens = _interopRequireDefault(require$$5$1);

var _colorDeprecatedSemanticTokens = _interopRequireDefault(require$$6$1);

var _borders = _interopRequireDefault(require$$1$2);

var _lighting = _interopRequireDefault(require$$10);

var _typography = _interopRequireDefault(_typography$1);

var _animation = _interopRequireDefault(require$$0$3);

var _breakpoints = _interopRequireDefault(require$$2$1);

var _grid = _interopRequireDefault(require$$9);

var _mediaQuery = _interopRequireDefault(require$$11);

var _sizing = _interopRequireDefault(require$$12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LightTheme = {
  name: 'light-theme',
  colors: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _colorTokens.default), (0, _colorComponentTokens.default)()), (0, _colorDeprecatedSemanticTokens.default)()), (0, _colorSemanticTokens.default)()),
  animation: _animation.default,
  breakpoints: _breakpoints.default,
  borders: _borders.default,
  direction: 'auto',
  grid: _grid.default,
  lighting: _lighting.default,
  mediaQuery: _mediaQuery.default,
  sizing: _sizing.default,
  typography: (0, _typography.default)(),
  // TODO(#2318) Remove it in the next v11 major version.
  // Do not use.
  zIndex: {
    modal: 2000
  }
};
exports.LightTheme = LightTheme;
});

unwrapExports(lightTheme);
lightTheme.LightTheme;

var deepMerge_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deepMerge;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* flowlint unclear-type:off */
function deepMerge(target) {
  target = target || {};
  var len = arguments.length <= 1 ? 0 : arguments.length - 1;
  var obj;
  var value;

  for (var i = 0; i < len; i++) {
    obj = (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) || {};

    for (var key in obj) {
      if (_typeof(obj[key]) !== undefined) {
        value = obj[key];

        if (isCloneable(value)) {
          target[key] = deepMerge(
          /* eslint-disable-next-line no-mixed-operators */
          target[key] || Array.isArray(value) && [] || {}, value);
        } else {
          target[key] = value;
        }
      }
    }
  }

  return target;
}
/* flowlint unclear-type:error */

/* eslint-disable-next-line flowtype/no-weak-types */


function isCloneable(obj) {
  /* eslint-disable-next-line eqeqeq */
  return Array.isArray(obj) || {}.toString.call(obj) == '[object Object]';
}
});

unwrapExports(deepMerge_1);

var typography_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typography = exports.fontTokens = void 0;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var fontTokens = {
  primaryFontFamily: 'UberMoveText, system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif'
};
exports.fontTokens = fontTokens;
var secondaryFontFamily = 'UberMove, UberMoveText, system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif';
var monoFontFamily = 'UberMoveMono, "Lucida Console", Monaco, monospace';
var typography = {
  font1450: {
    fontFamily: secondaryFontFamily
  },
  font1350: {
    fontFamily: secondaryFontFamily
  },
  font1250: {
    fontFamily: secondaryFontFamily
  },
  font1150: {
    fontFamily: secondaryFontFamily
  },
  DisplayLarge: {
    fontFamily: secondaryFontFamily
  },
  DisplayMedium: {
    fontFamily: secondaryFontFamily
  },
  DisplaySmall: {
    fontFamily: secondaryFontFamily
  },
  DisplayXSmall: {
    fontFamily: secondaryFontFamily
  },
  MonoParagraphXSmall: {
    fontFamily: monoFontFamily
  },
  MonoParagraphSmall: {
    fontFamily: monoFontFamily
  },
  MonoParagraphMedium: {
    fontFamily: monoFontFamily
  },
  MonoParagraphLarge: {
    fontFamily: monoFontFamily
  },
  MonoLabelXSmall: {
    fontFamily: monoFontFamily
  },
  MonoLabelSmall: {
    fontFamily: monoFontFamily
  },
  MonoLabelMedium: {
    fontFamily: monoFontFamily
  },
  MonoLabelLarge: {
    fontFamily: monoFontFamily
  },
  MonoHeadingXSmall: {
    fontFamily: monoFontFamily
  },
  MonoHeadingSmall: {
    fontFamily: monoFontFamily
  },
  MonoHeadingMedium: {
    fontFamily: monoFontFamily
  },
  MonoHeadingLarge: {
    fontFamily: monoFontFamily
  },
  MonoHeadingXLarge: {
    fontFamily: monoFontFamily
  },
  MonoHeadingXXLarge: {
    fontFamily: monoFontFamily
  },
  MonoDisplayXSmall: {
    fontFamily: monoFontFamily
  },
  MonoDisplaySmall: {
    fontFamily: monoFontFamily
  },
  MonoDisplayMedium: {
    fontFamily: monoFontFamily
  },
  MonoDisplayLarge: {
    fontFamily: monoFontFamily
  }
};
exports.typography = typography;
});

unwrapExports(typography_1);
typography_1.typography;
typography_1.fontTokens;

var require$$3$1 = deepMerge_1;

var _lightTheme = lightTheme;

var _typography = typography_1;

var lightThemeWithMove = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LightThemeMove = void 0;

var _deepMerge = _interopRequireDefault(require$$3$1);





var _typography2 = _interopRequireDefault(_typography$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var LightThemeMove = (0, _deepMerge.default)({}, _lightTheme.LightTheme, {
  name: 'light-theme-with-move',
  // For the move theme we need to override typography values
  // in the default lightTheme with a font values that reference
  // our custom font family. In addition to it we want to replace some
  // of the fonts with an additional secondary font that specified
  // in `moveTypography`. For it we'll get the typography value built
  // with a custom font using `getTypography` helper and extend the result
  // value with the customized set of fonts that reference a secondary font
  typography: (0, _deepMerge.default)((0, _typography2.default)(_typography.fontTokens), _typography.typography)
});
exports.LightThemeMove = LightThemeMove;
});

unwrapExports(lightThemeWithMove);
lightThemeWithMove.LightThemeMove;

var colorTokens = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.darkColorTokens = void 0;



/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// color constants
var darkColorTokens = {
  // Primary Palette
  primaryA: _index$2.colors.gray200,
  primaryB: _index$2.colors.gray900,
  primary: _index$2.colors.white,
  primary50: _index$2.colors.gray50,
  primary100: _index$2.colors.gray100,
  primary200: _index$2.colors.gray200,
  primary300: _index$2.colors.gray300,
  primary400: _index$2.colors.gray400,
  primary500: _index$2.colors.gray500,
  primary600: _index$2.colors.gray600,
  primary700: _index$2.colors.gray700,
  // Accent Palette
  accent: _index$2.colors.blue400,
  accent50: _index$2.colors.blue50,
  accent100: _index$2.colors.blue100,
  accent200: _index$2.colors.blue200,
  accent300: _index$2.colors.blue300,
  accent400: _index$2.colors.blue400,
  accent500: _index$2.colors.blue500,
  accent600: _index$2.colors.blue600,
  accent700: _index$2.colors.blue700,
  // Negative Palette
  negative: _index$2.colors.red500,
  negative50: _index$2.colors.red50,
  negative100: _index$2.colors.red100,
  negative200: _index$2.colors.red200,
  negative300: _index$2.colors.red300,
  negative400: _index$2.colors.red400,
  negative500: _index$2.colors.red500,
  negative600: _index$2.colors.red600,
  negative700: _index$2.colors.red700,
  // Warning Palette
  warning: _index$2.colors.yellow500,
  warning50: _index$2.colors.yellow50,
  warning100: _index$2.colors.yellow100,
  warning200: _index$2.colors.yellow200,
  warning300: _index$2.colors.yellow300,
  warning400: _index$2.colors.yellow400,
  warning500: _index$2.colors.yellow500,
  warning600: _index$2.colors.yellow600,
  warning700: _index$2.colors.yellow700,
  // Positive Palette
  positive: _index$2.colors.green400,
  positive50: _index$2.colors.green50,
  positive100: _index$2.colors.green100,
  positive200: _index$2.colors.green200,
  positive300: _index$2.colors.green300,
  positive400: _index$2.colors.green400,
  positive500: _index$2.colors.green500,
  positive600: _index$2.colors.green600,
  positive700: _index$2.colors.green700,
  // Monochrome Palette
  white: _index$2.colors.white,
  black: _index$2.colors.black,
  mono100: _index$2.colors.gray300,
  mono200: _index$2.colors.gray400,
  mono300: _index$2.colors.gray500,
  mono400: _index$2.colors.gray600,
  mono500: _index$2.colors.gray700,
  // mono600 and mono900 are not in official brand tokens atm
  mono600: '#292929',
  mono700: '#1F1F1F',
  mono800: '#141414',
  mono900: '#111111',
  mono1000: _index$2.colors.black,
  // Rating Palette,
  rating200: _index$2.colors.yellow200,
  rating400: _index$2.colors.yellow400,
  ratingInactiveFill: _index$2.colors.gray500,
  ratingStroke: _index$2.colors.gray700
};
exports.darkColorTokens = darkColorTokens;
var _default = darkColorTokens;
exports.default = _default;
});

unwrapExports(colorTokens);
colorTokens.darkColorTokens;

var require$$0$2 = colorTokens;

var colorSemanticTokens = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colorTokens = _interopRequireDefault(require$$0$2);



var _colors = _interopRequireDefault(require$$1$3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default() {
  var foundation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _colorTokens.default;
  var core = {
    // Background
    backgroundPrimary: foundation.primaryB,
    backgroundSecondary: _colors.default.gray800,
    backgroundTertiary: _colors.default.gray700,
    backgroundInversePrimary: foundation.primaryA,
    backgroundInverseSecondary: _colors.default.gray300,
    // Content
    contentPrimary: _colors.default.white,
    contentSecondary: _colors.default.gray300,
    contentTertiary: _colors.default.gray400,
    contentInversePrimary: _colors.default.black,
    contentInverseSecondary: _colors.default.gray700,
    contentInverseTertiary: _colors.default.gray600,
    // Border
    borderOpaque: _colors.default.gray700,
    borderTransparent: (0, _util.hexToRgb)(foundation.primaryA, '0.08'),
    borderSelected: foundation.primaryA,
    borderInverseOpaque: _colors.default.gray400,
    borderInverseTransparent: (0, _util.hexToRgb)(foundation.primaryB, '0.2'),
    borderInverseSelected: foundation.primaryB
  };
  var coreExtensions = {
    // Backgrounds
    backgroundStateDisabled: _colors.default.gray800,
    backgroundOverlayDark: (0, _util.hexToRgb)(_colors.default.black, '0.3'),
    backgroundOverlayLight: (0, _util.hexToRgb)(_colors.default.black, '0.08'),
    backgroundAccent: foundation.accent,
    backgroundNegative: foundation.negative,
    backgroundWarning: foundation.warning,
    backgroundPositive: _colors.default.green500,
    backgroundLightAccent: _colors.default.blue700,
    backgroundLightPositive: _colors.default.green700,
    backgroundLightNegative: _colors.default.red700,
    backgroundLightWarning: _colors.default.yellow700,
    backgroundAlwaysDark: _colors.default.gray900,
    backgroundAlwaysLight: _colors.default.gray100,
    // Content
    contentStateDisabled: _colors.default.gray600,
    contentAccent: _colors.default.blue300,
    contentOnColor: _colors.default.white,
    contentOnColorInverse: _colors.default.black,
    contentNegative: _colors.default.red300,
    contentWarning: _colors.default.yellow300,
    contentPositive: _colors.default.green300,
    // Border
    borderStateDisabled: _colors.default.gray800,
    borderAccent: _colors.default.blue400,
    borderAccentLight: _colors.default.blue500,
    borderNegative: _colors.default.red500,
    borderWarning: _colors.default.yellow500,
    borderPositive: _colors.default.green500,
    // Programs
    safety: _colors.default.blue400,
    eatsGreen400: _colors.default.green400,
    freightBlue400: _colors.default.cobalt400,
    jumpRed400: _colors.default.red400,
    rewardsTier1: _colors.default.blue400,
    rewardsTier2: _colors.default.yellow400,
    rewardsTier3: _colors.default.platinum400,
    rewardsTier4: _colors.default.gray200,
    membership: _colors.default.yellow600
  };
  return _objectSpread(_objectSpread({}, core), coreExtensions);
};

exports.default = _default;
});

unwrapExports(colorSemanticTokens);

var colorComponentTokens = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colorTokens = _interopRequireDefault(require$$0$2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var tagHoverBackground = "rgba(255, 255, 255, 0.2)";
/* ---- Component colors ---- */
// TODO(#2318) Make it a plain object in the next v11 major version
// with values taken from `colorTokens`.
// Due to the legacy `createTheme` type the values
// need to be overrideable through primitives

var _default = function _default() {
  var themePrimitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _colorTokens.default;
  return {
    // Buttons
    buttonPrimaryFill: themePrimitives.primary,
    buttonPrimaryText: themePrimitives.black,
    buttonPrimaryHover: themePrimitives.primary100,
    buttonPrimaryActive: themePrimitives.primary200,
    buttonPrimarySelectedText: themePrimitives.black,
    buttonPrimarySelectedFill: themePrimitives.primary200,
    buttonPrimarySpinnerForeground: themePrimitives.primary700,
    buttonPrimarySpinnerBackground: themePrimitives.primary300,
    buttonSecondaryFill: themePrimitives.primary700,
    buttonSecondaryText: themePrimitives.primary,
    buttonSecondaryHover: themePrimitives.primary600,
    buttonSecondaryActive: themePrimitives.primary500,
    buttonSecondarySelectedText: themePrimitives.primary,
    buttonSecondarySelectedFill: themePrimitives.primary500,
    buttonSecondarySpinnerForeground: themePrimitives.white,
    buttonSecondarySpinnerBackground: themePrimitives.primary400,
    buttonTertiaryFill: 'transparent',
    buttonTertiaryText: themePrimitives.primary,
    buttonTertiaryHover: themePrimitives.primary700,
    buttonTertiaryActive: themePrimitives.primary600,
    buttonTertiarySelectedText: themePrimitives.primary,
    buttonTertiarySelectedFill: themePrimitives.primary600,
    buttonTertiaryDisabledActiveFill: themePrimitives.primary700,
    buttonTertiaryDisabledActiveText: themePrimitives.mono300,
    buttonTertiarySpinnerForeground: themePrimitives.primary50,
    buttonTertiarySpinnerBackground: themePrimitives.primary500,
    buttonMinimalFill: 'transparent',
    buttonMinimalText: themePrimitives.primary,
    buttonMinimalHover: themePrimitives.primary700,
    buttonMinimalActive: themePrimitives.primary600,
    buttonMinimalSelectedText: themePrimitives.primary,
    buttonMinimalSelectedFill: themePrimitives.primary600,
    buttonMinimalSpinnerForeground: themePrimitives.primary50,
    buttonMinimalSpinnerBackground: themePrimitives.primary500,
    buttonDisabledFill: themePrimitives.mono600,
    buttonDisabledText: themePrimitives.mono300,
    buttonDisabledActiveFill: themePrimitives.mono200,
    buttonDisabledActiveText: themePrimitives.primary500,
    buttonDisabledSpinnerForeground: themePrimitives.mono200,
    buttonDisabledSpinnerBackground: themePrimitives.mono400,
    // Breadcrumbs
    breadcrumbsText: themePrimitives.mono100,
    breadcrumbsSeparatorFill: themePrimitives.mono200,
    // Datepicker
    datepickerBackground: themePrimitives.mono600,
    datepickerDayFont: themePrimitives.white,
    datepickerDayFontDisabled: themePrimitives.mono100,
    datepickerDayPseudoSelected: themePrimitives.mono500,
    datepickerDayPseudoHighlighted: themePrimitives.mono600,
    // Calendar
    calendarBackground: themePrimitives.mono800,
    calendarForeground: themePrimitives.white,
    calendarForegroundDisabled: themePrimitives.mono300,
    calendarHeaderBackground: themePrimitives.primary700,
    calendarHeaderForeground: themePrimitives.primary,
    calendarHeaderBackgroundActive: themePrimitives.primary600,
    calendarHeaderForegroundDisabled: themePrimitives.primary500,
    calendarDayBackgroundPseudoSelected: themePrimitives.primary700,
    calendarDayForegroundPseudoSelected: themePrimitives.primary,
    calendarDayBackgroundPseudoSelectedHighlighted: themePrimitives.primary600,
    calendarDayForegroundPseudoSelectedHighlighted: themePrimitives.primary,
    calendarDayBackgroundSelected: themePrimitives.primary,
    calendarDayForegroundSelected: themePrimitives.black,
    calendarDayBackgroundSelectedHighlighted: themePrimitives.primary100,
    calendarDayForegroundSelectedHighlighted: themePrimitives.black,
    // Combobox
    comboboxListItemFocus: themePrimitives.mono600,
    comboboxListItemHover: themePrimitives.mono500,
    // FileUploader
    fileUploaderBackgroundColor: themePrimitives.mono700,
    fileUploaderBackgroundColorActive: themePrimitives.mono600,
    fileUploaderBorderColorActive: themePrimitives.primary,
    fileUploaderBorderColorDefault: themePrimitives.mono500,
    fileUploaderMessageColor: themePrimitives.mono100,
    // Links
    linkText: themePrimitives.primary,
    linkVisited: themePrimitives.primary100,
    linkHover: themePrimitives.primary200,
    linkActive: themePrimitives.primary300,
    // List
    listHeaderFill: themePrimitives.mono600,
    listBodyFill: themePrimitives.mono800,
    listIconFill: themePrimitives.mono100,
    listBorder: themePrimitives.mono500,
    // ProgressSteps
    progressStepsCompletedText: themePrimitives.black,
    progressStepsCompletedFill: themePrimitives.primary,
    progressStepsActiveText: themePrimitives.black,
    progressStepsActiveFill: themePrimitives.primary,
    progressStepsIconActiveFill: themePrimitives.primary,
    // Modal
    modalCloseColor: themePrimitives.mono300,
    modalCloseColorHover: themePrimitives.mono400,
    modalCloseColorFocus: themePrimitives.mono400,
    // Notification
    notificationPrimaryBackground: themePrimitives.primary700,
    notificationPrimaryText: themePrimitives.primaryA,
    notificationInfoBackground: themePrimitives.accent700,
    notificationInfoText: themePrimitives.primaryA,
    notificationPositiveBackground: themePrimitives.positive700,
    notificationPositiveText: themePrimitives.primaryA,
    notificationWarningBackground: themePrimitives.warning700,
    notificationWarningText: themePrimitives.primaryA,
    notificationNegativeBackground: themePrimitives.negative700,
    notificationNegativeText: themePrimitives.primaryA,
    // Tag
    // Custom ramps
    tagFontDisabledRampUnit: '600',
    tagOutlinedDisabledRampUnit: '700',
    tagSolidFontRampUnit: '0',
    tagSolidRampUnit: '500',
    tagOutlinedFontRampUnit: '500',
    tagOutlinedRampUnit: '500',
    // Deprecated
    tagSolidHoverRampUnit: '500',
    tagSolidActiveRampUnit: '400',
    tagSolidDisabledRampUnit: '700',
    tagSolidFontHoverRampUnit: '100',
    tagLightRampUnit: '700',
    tagLightHoverRampUnit: '700',
    tagLightActiveRampUnit: '600',
    tagLightDisabledRampUnit: '700',
    tagLightFontRampUnit: '100',
    tagLightFontHoverRampUnit: '100',
    tagOutlinedActiveRampUnit: '300',
    tagOutlinedHoverRampUnit: '800',
    tagOutlinedFontHoverRampUnit: '100',
    // Neutral
    tagNeutralOutlinedFont: themePrimitives.mono100,
    tagNeutralOutlinedBackground: themePrimitives.mono200,
    tagNeutralSolidFont: themePrimitives.black,
    tagNeutralSolidBackground: themePrimitives.primary200,
    // not much we can do to get the correct gray here
    tagNeutralFontDisabled: themePrimitives.mono400,
    tagNeutralOutlinedDisabled: themePrimitives.mono500,
    // Deprecated
    tagNeutralSolidHover: themePrimitives.mono600,
    tagNeutralSolidActive: themePrimitives.mono500,
    tagNeutralSolidDisabled: themePrimitives.mono700,
    tagNeutralSolidFontHover: themePrimitives.mono200,
    tagNeutralLightBackground: themePrimitives.mono800,
    tagNeutralLightHover: themePrimitives.mono800,
    tagNeutralLightActive: themePrimitives.mono700,
    tagNeutralLightDisabled: themePrimitives.mono700,
    tagNeutralLightFont: themePrimitives.mono200,
    tagNeutralLightFontHover: themePrimitives.mono200,
    tagNeutralOutlinedActive: themePrimitives.mono400,
    tagNeutralOutlinedFontHover: themePrimitives.mono100,
    tagNeutralOutlinedHover: tagHoverBackground,
    // Primary
    tagPrimaryOutlinedFont: themePrimitives.primary200,
    tagPrimaryOutlinedBackground: themePrimitives.primary400,
    tagPrimarySolidFont: themePrimitives.black,
    tagPrimarySolidBackground: themePrimitives.primary200,
    tagPrimaryFontDisabled: themePrimitives.primary600,
    tagPrimaryOutlinedDisabled: themePrimitives.primary700,
    // Deprecated
    tagPrimarySolidHover: themePrimitives.primary700,
    tagPrimarySolidActive: themePrimitives.primary400,
    tagPrimarySolidDisabled: themePrimitives.primary700,
    tagPrimarySolidFontHover: themePrimitives.primary100,
    tagPrimaryLightBackground: themePrimitives.primary700,
    tagPrimaryLightHover: themePrimitives.primary700,
    tagPrimaryLightActive: themePrimitives.primary600,
    tagPrimaryLightDisabled: themePrimitives.primary700,
    tagPrimaryLightFont: themePrimitives.primary100,
    tagPrimaryLightFontHover: themePrimitives.primary100,
    tagPrimaryOutlinedActive: themePrimitives.primary600,
    tagPrimaryOutlinedFontHover: themePrimitives.primary200,
    tagPrimaryOutlinedHover: tagHoverBackground,
    // Accent
    tagAccentOutlinedFont: themePrimitives.accent200,
    tagAccentOutlinedBackground: themePrimitives.accent500,
    tagAccentSolidFont: themePrimitives.white,
    tagAccentSolidBackground: themePrimitives.accent500,
    tagAccentFontDisabled: themePrimitives.accent600,
    tagAccentOutlinedDisabled: themePrimitives.accent700,
    // Deprecated
    tagAccentSolidHover: themePrimitives.accent500,
    tagAccentSolidActive: themePrimitives.accent400,
    tagAccentSolidDisabled: themePrimitives.accent700,
    tagAccentSolidFontHover: themePrimitives.accent100,
    tagAccentLightBackground: themePrimitives.accent700,
    tagAccentLightHover: themePrimitives.accent700,
    tagAccentLightActive: themePrimitives.accent600,
    tagAccentLightDisabled: themePrimitives.accent700,
    tagAccentLightFont: themePrimitives.accent100,
    tagAccentLightFontHover: themePrimitives.accent100,
    tagAccentOutlinedActive: themePrimitives.accent300,
    tagAccentOutlinedFontHover: themePrimitives.accent200,
    tagAccentOutlinedHover: tagHoverBackground,
    // Positive
    tagPositiveOutlinedFont: themePrimitives.positive300,
    tagPositiveOutlinedBackground: themePrimitives.positive500,
    tagPositiveSolidFont: themePrimitives.white,
    tagPositiveSolidBackground: themePrimitives.positive500,
    tagPositiveFontDisabled: themePrimitives.positive600,
    tagPositiveOutlinedDisabled: themePrimitives.positive700,
    // Deprecated
    tagPositiveSolidHover: themePrimitives.positive500,
    tagPositiveSolidActive: themePrimitives.positive400,
    tagPositiveSolidDisabled: themePrimitives.positive700,
    tagPositiveSolidFontHover: themePrimitives.positive100,
    tagPositiveLightBackground: themePrimitives.positive700,
    tagPositiveLightHover: themePrimitives.positive700,
    tagPositiveLightActive: themePrimitives.positive600,
    tagPositiveLightDisabled: themePrimitives.positive700,
    tagPositiveLightFont: themePrimitives.positive100,
    tagPositiveLightFontHover: themePrimitives.positive100,
    tagPositiveOutlinedActive: themePrimitives.positive300,
    tagPositiveOutlinedFontHover: themePrimitives.positive300,
    tagPositiveOutlinedHover: tagHoverBackground,
    // Warning
    tagWarningOutlinedFont: themePrimitives.warning300,
    tagWarningOutlinedBackground: themePrimitives.warning500,
    tagWarningSolidFont: themePrimitives.black,
    tagWarningSolidBackground: themePrimitives.warning500,
    tagWarningFontDisabled: themePrimitives.warning600,
    tagWarningOutlinedDisabled: themePrimitives.warning700,
    // Deprecated
    tagWarningSolidHover: themePrimitives.warning500,
    tagWarningSolidActive: themePrimitives.warning400,
    tagWarningSolidDisabled: themePrimitives.warning700,
    tagWarningSolidFontHover: themePrimitives.warning100,
    tagWarningLightBackground: themePrimitives.warning700,
    tagWarningLightHover: themePrimitives.warning700,
    tagWarningLightActive: themePrimitives.warning600,
    tagWarningLightDisabled: themePrimitives.warning700,
    tagWarningLightFont: themePrimitives.warning100,
    tagWarningLightFontHover: themePrimitives.warning100,
    tagWarningOutlinedActive: themePrimitives.warning300,
    tagWarningOutlinedFontHover: themePrimitives.warning300,
    tagWarningOutlinedHover: tagHoverBackground,
    // Negative
    tagNegativeOutlinedFont: themePrimitives.negative300,
    tagNegativeOutlinedBackground: themePrimitives.negative500,
    tagNegativeSolidFont: themePrimitives.white,
    tagNegativeSolidBackground: themePrimitives.negative500,
    tagNegativeFontDisabled: themePrimitives.negative600,
    tagNegativeOutlinedDisabled: themePrimitives.negative700,
    // Deprecated
    tagNegativeSolidHover: themePrimitives.negative500,
    tagNegativeSolidActive: themePrimitives.negative400,
    tagNegativeSolidDisabled: themePrimitives.negative700,
    tagNegativeSolidFontHover: themePrimitives.negative100,
    tagNegativeLightBackground: themePrimitives.negative700,
    tagNegativeLightHover: themePrimitives.negative700,
    tagNegativeLightActive: themePrimitives.negative600,
    tagNegativeLightDisabled: themePrimitives.negative700,
    tagNegativeLightFont: themePrimitives.negative100,
    tagNegativeLightFontHover: themePrimitives.negative100,
    tagNegativeOutlinedActive: themePrimitives.negative300,
    tagNegativeOutlinedFontHover: themePrimitives.negative300,
    tagNegativeOutlinedHover: tagHoverBackground,
    // Table
    tableHeadBackgroundColor: themePrimitives.mono700,
    tableBackground: themePrimitives.mono800,
    tableStripedBackground: themePrimitives.mono700,
    tableFilter: themePrimitives.mono400,
    tableFilterHeading: themePrimitives.mono300,
    tableFilterBackground: themePrimitives.mono700,
    tableFilterFooterBackground: themePrimitives.mono800,
    // Toast
    toastText: themePrimitives.white,
    toastPrimaryBackground: themePrimitives.primary400,
    toastPrimaryText: themePrimitives.white,
    toastInfoBackground: themePrimitives.accent400,
    toastInfoText: themePrimitives.white,
    toastPositiveBackground: themePrimitives.positive400,
    toastPositiveText: themePrimitives.white,
    toastWarningBackground: themePrimitives.warning400,
    toastWarningText: themePrimitives.black,
    toastNegativeBackground: themePrimitives.negative400,
    toastNegativeText: themePrimitives.white,
    // Toggle
    toggleFill: themePrimitives.mono300,
    toggleFillChecked: themePrimitives.primary,
    toggleFillDisabled: themePrimitives.mono600,
    toggleTrackFill: themePrimitives.mono400,
    toggleTrackFillDisabled: themePrimitives.mono700,
    // Tick
    tickFill: themePrimitives.mono1000,
    tickFillHover: themePrimitives.mono700,
    tickFillActive: themePrimitives.mono600,
    tickFillSelected: themePrimitives.primary,
    tickFillSelectedHover: themePrimitives.primary50,
    tickFillSelectedHoverActive: themePrimitives.primary100,
    tickFillError: themePrimitives.negative700,
    tickFillErrorHover: themePrimitives.negative600,
    tickFillErrorHoverActive: themePrimitives.negative500,
    tickFillErrorSelected: themePrimitives.negative500,
    tickFillErrorSelectedHover: themePrimitives.negative600,
    tickFillErrorSelectedHoverActive: themePrimitives.negative700,
    tickFillDisabled: themePrimitives.mono500,
    tickBorder: themePrimitives.mono300,
    tickBorderError: themePrimitives.negative400,
    tickMarkFill: themePrimitives.black,
    tickMarkFillError: themePrimitives.white,
    tickMarkFillDisabled: themePrimitives.mono800,
    // Slider/Toggle
    sliderTrackFill: 'transparent',
    sliderHandleFill: themePrimitives.primaryA,
    sliderHandleFillDisabled: themePrimitives.primary500,
    sliderHandleInnerFill: themePrimitives.primaryA,
    sliderHandleFillHover: themePrimitives.mono300,
    sliderHandleFillActive: themePrimitives.mono300,
    sliderHandleFillSelected: themePrimitives.primary500,
    sliderHandleFillSelectedHover: themePrimitives.primary600,
    sliderHandleFillSelectedActive: themePrimitives.primary700,
    sliderTrackFillHover: themePrimitives.mono500,
    sliderTrackFillActive: themePrimitives.mono400,
    sliderTrackFillSelected: themePrimitives.primary500,
    sliderTrackFillSelectedActive: themePrimitives.primary600,
    sliderTrackFillSelectedHover: themePrimitives.primary700,
    sliderTrackFillDisabled: themePrimitives.mono700,
    sliderHandleInnerFillDisabled: themePrimitives.mono500,
    sliderHandleInnerFillSelectedHover: themePrimitives.primary600,
    sliderHandleInnerFillSelectedActive: themePrimitives.primary700,
    sliderBorder: themePrimitives.white,
    sliderBorderHover: themePrimitives.white,
    sliderBorderDisabled: themePrimitives.mono400,
    // Input
    inputBorder: themePrimitives.mono600,
    inputFill: themePrimitives.mono600,
    inputFillActive: themePrimitives.mono500,
    inputFillError: themePrimitives.negative700,
    inputFillDisabled: themePrimitives.mono800,
    inputFillPositive: themePrimitives.positive700,
    inputTextDisabled: themePrimitives.mono500,
    inputBorderError: themePrimitives.negative400,
    inputBorderPositive: themePrimitives.positive400,
    inputEnhancerFill: themePrimitives.mono500,
    inputEnhancerFillDisabled: themePrimitives.mono700,
    inputEnhancerTextDisabled: themePrimitives.mono500,
    inputPlaceholder: themePrimitives.mono300,
    inputPlaceholderDisabled: themePrimitives.mono500,
    // Menu
    menuFill: themePrimitives.mono600,
    menuFillHover: themePrimitives.mono700,
    menuFontDefault: themePrimitives.mono300,
    menuFontDisabled: themePrimitives.mono400,
    menuFontHighlighted: themePrimitives.white,
    menuFontSelected: themePrimitives.white,
    // Pagination
    paginationTriangleDown: themePrimitives.mono100,
    // Header navigation
    headerNavigationFill: themePrimitives.mono700,
    // Tab
    tabBarFill: themePrimitives.mono1000,
    tabColor: themePrimitives.mono300,
    // Spinner
    spinnerTrackFill: themePrimitives.mono100,
    // Progress bar
    progressbarTrackFill: themePrimitives.mono100,
    // Tooltip
    tooltipBackground: themePrimitives.mono200,
    tooltipText: themePrimitives.mono1000
  };
};

exports.default = _default;
});

unwrapExports(colorComponentTokens);

var colorDeprecatedSemanticTokens = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colorTokens = _interopRequireDefault(require$$0$2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* ---- DEPRECATED ---- */
var _default = function _default() {
  var themePrimitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _colorTokens.default;
  return {
    // TODO(#2318) Remove Legacy Semantic Colors values in the next v11 major
    // since it's not used in the component specific tokens
    // and we ship semantic tokens separately

    /* ---- Legacy Semantic Colors ---- */
    // Font Color
    colorPrimary: themePrimitives.mono100,
    colorSecondary: themePrimitives.mono200,
    // Background
    background: themePrimitives.mono1000,
    backgroundAlt: themePrimitives.mono700,
    backgroundInv: themePrimitives.mono100,
    // Foreground
    foreground: themePrimitives.mono100,
    foregroundAlt: themePrimitives.mono300,
    foregroundInv: themePrimitives.mono1000,
    // Borders
    border: themePrimitives.mono600,
    borderAlt: themePrimitives.mono700,
    borderFocus: themePrimitives.primary,
    borderError: themePrimitives.negative,
    // Shadow
    shadowFocus: 'rgba(39, 110, 241, 0.32)',
    shadowError: 'rgba(229, 73, 55, 0.32)'
  };
};

exports.default = _default;
});

unwrapExports(colorDeprecatedSemanticTokens);

var borders_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _borders = _interopRequireDefault(require$$1$2);

var _deepMerge = _interopRequireDefault(require$$3$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// Override border colors for the dark theme
var borders = (0, _deepMerge.default)({}, _borders.default, {
  border100: {
    borderColor: 'hsla(0, 0%, 100%, 0.04)'
  },
  border200: {
    borderColor: 'hsla(0, 0%, 100%, 0.08)'
  },
  border300: {
    borderColor: 'hsla(0, 0%, 100%, 0.12)'
  },
  border400: {
    borderColor: 'hsla(0, 0%, 100%, 0.16)'
  },
  border500: {
    borderColor: 'hsla(0, 0%, 100%, 0.2)'
  },
  border600: {
    borderColor: 'hsla(0, 0%, 100%, 0.24)'
  }
});
var _default = borders;
exports.default = _default;
});

unwrapExports(borders_1);

var require$$7 = colorSemanticTokens;

var require$$5 = colorComponentTokens;

var require$$6 = colorDeprecatedSemanticTokens;

var require$$1$1 = borders_1;

var darkTheme = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DarkTheme = void 0;

var _colorTokens = _interopRequireDefault(require$$0$2);

var _colorSemanticTokens = _interopRequireDefault(require$$7);

var _colorComponentTokens = _interopRequireDefault(require$$5);

var _colorDeprecatedSemanticTokens = _interopRequireDefault(require$$6);

var _borders = _interopRequireDefault(require$$1$1);

var _lighting = _interopRequireDefault(require$$10);

var _typography = _interopRequireDefault(_typography$1);

var _animation = _interopRequireDefault(require$$0$3);

var _breakpoints = _interopRequireDefault(require$$2$1);

var _grid = _interopRequireDefault(require$$9);

var _mediaQuery = _interopRequireDefault(require$$11);

var _sizing = _interopRequireDefault(require$$12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DarkTheme = {
  name: 'dark-theme',
  colors: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _colorTokens.default), (0, _colorComponentTokens.default)()), (0, _colorDeprecatedSemanticTokens.default)()), (0, _colorSemanticTokens.default)()),
  animation: _animation.default,
  breakpoints: _breakpoints.default,
  borders: _borders.default,
  direction: 'auto',
  grid: _grid.default,
  lighting: _lighting.default,
  mediaQuery: _mediaQuery.default,
  sizing: _sizing.default,
  typography: (0, _typography.default)(),
  // TODO(#2318) Remove it in the next v11 major version.
  // Do not use.
  zIndex: {
    modal: 2000
  }
};
exports.DarkTheme = DarkTheme;
});

unwrapExports(darkTheme);
darkTheme.DarkTheme;

var _darkTheme = darkTheme;

var darkThemeWithMove = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DarkThemeMove = void 0;

var _deepMerge = _interopRequireDefault(require$$3$1);





var _typography2 = _interopRequireDefault(_typography$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var DarkThemeMove = (0, _deepMerge.default)({}, _darkTheme.DarkTheme, {
  name: 'dark-theme-with-move',
  // For the move theme we need to override typography values
  // in the default darkTheme with a font values that reference
  // our custom font family. In addition to it we want to replace some
  // of the fonts with an additional secondary font that specified
  // in `moveTypography`. For it we'll get the typography value built
  // with a custom font using `getTypography` helper and extend the result
  // value with the customized set of fonts that reference a secondary font
  typography: (0, _deepMerge.default)((0, _typography2.default)(_typography.fontTokens), _typography.typography)
});
exports.DarkThemeMove = DarkThemeMove;
});

unwrapExports(darkThemeWithMove);
darkThemeWithMove.DarkThemeMove;

var createDarkTheme_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createDarkTheme;

var _animation = _interopRequireDefault(require$$0$3);

var _borders = _interopRequireDefault(require$$1$1);

var _breakpoints = _interopRequireDefault(require$$2$1);

var _deepMerge = _interopRequireDefault(require$$3$1);

var _colorTokens = _interopRequireDefault(require$$0$2);

var _colorComponentTokens = _interopRequireDefault(require$$5);

var _colorDeprecatedSemanticTokens = _interopRequireDefault(require$$6);

var _colorSemanticTokens = _interopRequireDefault(require$$7);

var _typography = _interopRequireDefault(_typography$1);

var _grid = _interopRequireDefault(require$$9);

var _lighting = _interopRequireDefault(require$$10);

var _mediaQuery = _interopRequireDefault(require$$11);

var _sizing = _interopRequireDefault(require$$12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function createDarkTheme() {
  var primitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var // Used to override default theme property values derived from primitives
  overrides = arguments.length > 1 ? arguments[1] : undefined;

  // Extract font tokens and color tokens from primitives
  var primaryFontFamily = primitives.primaryFontFamily,
      customColorTokens = _objectWithoutProperties(primitives, ["primaryFontFamily"]); // Assemble color tokens by overriding defaults with custom color tokens


  var colorTokens = _objectSpread(_objectSpread({}, _colorTokens.default), customColorTokens);

  var theme = {
    animation: _animation.default,
    borders: _borders.default,
    breakpoints: _breakpoints.default,
    colors: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, colorTokens), (0, _colorComponentTokens.default)(colorTokens)), (0, _colorDeprecatedSemanticTokens.default)(colorTokens)), (0, _colorSemanticTokens.default)(colorTokens)),
    direction: 'auto',
    grid: _grid.default,
    lighting: _lighting.default,
    mediaQuery: _mediaQuery.default,
    sizing: _sizing.default,
    // If primaryFontFamily is not provided, we use our default font tokens
    typography: primaryFontFamily ? (0, _typography.default)({
      primaryFontFamily: primaryFontFamily
    }) : (0, _typography.default)(),
    // TODO(#2318) Remove in v11, the next major version.
    // Do not use.
    zIndex: {
      modal: 2000
    }
  };
  return (0, _deepMerge.default)(theme, overrides);
}
});

unwrapExports(createDarkTheme_1);

var createLightTheme_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createLightTheme;

var _animation = _interopRequireDefault(require$$0$3);

var _borders = _interopRequireDefault(require$$1$2);

var _breakpoints = _interopRequireDefault(require$$2$1);

var _deepMerge = _interopRequireDefault(require$$3$1);

var _colorTokens = _interopRequireDefault(require$$0$4);

var _colorComponentTokens = _interopRequireDefault(require$$5$1);

var _colorDeprecatedSemanticTokens = _interopRequireDefault(require$$6$1);

var _colorSemanticTokens = _interopRequireDefault(require$$7$1);

var _typography = _interopRequireDefault(_typography$1);

var _grid = _interopRequireDefault(require$$9);

var _lighting = _interopRequireDefault(require$$10);

var _mediaQuery = _interopRequireDefault(require$$11);

var _sizing = _interopRequireDefault(require$$12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function createLightTheme() {
  var primitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var // Used to override default theme property values derived from primitives
  overrides = arguments.length > 1 ? arguments[1] : undefined;

  // Extract font tokens and color tokens from primitives
  var primaryFontFamily = primitives.primaryFontFamily,
      customColorTokens = _objectWithoutProperties(primitives, ["primaryFontFamily"]); // Assemble color tokens by overriding defaults with custom color tokens


  var colorTokens = _objectSpread(_objectSpread({}, _colorTokens.default), customColorTokens);

  var theme = {
    animation: _animation.default,
    borders: _borders.default,
    breakpoints: _breakpoints.default,
    colors: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, colorTokens), (0, _colorComponentTokens.default)(colorTokens)), (0, _colorDeprecatedSemanticTokens.default)(colorTokens)), (0, _colorSemanticTokens.default)(colorTokens)),
    direction: 'auto',
    grid: _grid.default,
    lighting: _lighting.default,
    mediaQuery: _mediaQuery.default,
    sizing: _sizing.default,
    // If primaryFontFamily is not provided, we use our default font tokens
    typography: primaryFontFamily ? (0, _typography.default)({
      primaryFontFamily: primaryFontFamily
    }) : (0, _typography.default)(),
    // TODO(#2318) Remove in v11, the next major version.
    // Do not use.
    zIndex: {
      modal: 2000
    }
  };
  return (0, _deepMerge.default)(theme, overrides);
}
});

unwrapExports(createLightTheme_1);

var primitives_1$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colorTokens = _interopRequireDefault(require$$0$2);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// We don't use this ourselves. We provide it for backward compatibility.
// People may have used it to create their own custom theme.
var primitives = _objectSpread(_objectSpread({}, _colorTokens.default), _typography$1.defaultFontTokens);

var _default = primitives;
exports.default = _default;
});

unwrapExports(primitives_1$1);

var primitives_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colorTokens = _interopRequireDefault(require$$0$4);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// We don't use this ourselves. We provide it for backward compatibility.
// People may have used it to create their own custom theme.
var primitives = _objectSpread(_objectSpread({}, _colorTokens.default), _typography$1.defaultFontTokens);

var _default = primitives;
exports.default = _default;
});

unwrapExports(primitives_1);

var _lightThemeWithMove = lightThemeWithMove;

var _darkThemeWithMove = darkThemeWithMove;

var require$$0$1 = createDarkTheme_1;

var require$$1 = createLightTheme_1;

var require$$2 = primitives_1$1;

var require$$3 = primitives_1;

var themes = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LightTheme", {
  enumerable: true,
  get: function get() {
    return _lightTheme.LightTheme;
  }
});
Object.defineProperty(exports, "LightThemeMove", {
  enumerable: true,
  get: function get() {
    return _lightThemeWithMove.LightThemeMove;
  }
});
Object.defineProperty(exports, "DarkTheme", {
  enumerable: true,
  get: function get() {
    return _darkTheme.DarkTheme;
  }
});
Object.defineProperty(exports, "darkThemeOverrides", {
  enumerable: true,
  get: function get() {
    return _darkTheme.DarkTheme;
  }
});
Object.defineProperty(exports, "DarkThemeMove", {
  enumerable: true,
  get: function get() {
    return _darkThemeWithMove.DarkThemeMove;
  }
});
Object.defineProperty(exports, "createDarkTheme", {
  enumerable: true,
  get: function get() {
    return _createDarkTheme.default;
  }
});
Object.defineProperty(exports, "createLightTheme", {
  enumerable: true,
  get: function get() {
    return _createLightTheme.default;
  }
});
Object.defineProperty(exports, "createTheme", {
  enumerable: true,
  get: function get() {
    return _createLightTheme.default;
  }
});
Object.defineProperty(exports, "darkThemePrimitives", {
  enumerable: true,
  get: function get() {
    return _primitives.default;
  }
});
Object.defineProperty(exports, "lightThemePrimitives", {
  enumerable: true,
  get: function get() {
    return _primitives2.default;
  }
});









var _createDarkTheme = _interopRequireDefault(require$$0$1);

var _createLightTheme = _interopRequireDefault(require$$1);

var _primitives = _interopRequireDefault(require$$2);

var _primitives2 = _interopRequireDefault(require$$3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
});

unwrapExports(themes);

var _index$1 = themes;

var themeProvider = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ThemeContext = void 0;

var React = _interopRequireWildcard(React__default);



function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var ThemeContext = /*#__PURE__*/React.createContext(_index$1.LightTheme);
exports.ThemeContext = ThemeContext;

var ThemeProvider = function ThemeProvider(props) {
  var theme = props.theme,
      children = props.children;
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: theme
  }, children);
};

var _default = ThemeProvider;
exports.default = _default;
});

unwrapExports(themeProvider);
themeProvider.ThemeContext;

var require$$0 = themeProvider;

var styled_1 = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createThemedStyled = createThemedStyled;
exports.createThemedWithStyle = createThemedWithStyle;
exports.createThemedUseStyletron = createThemedUseStyletron;
exports.withWrapper = withWrapper;
exports.useStyletron = exports.withStyle = exports.styled = void 0;

var React = _interopRequireWildcard(React__default);







function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var wrapper = function wrapper(StyledComponent) {
  // eslint-disable-next-line react/display-name
  return /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(require$$0.ThemeContext.Consumer, null, function (theme) {
      return /*#__PURE__*/React.createElement(StyledComponent, _extends({
        ref: ref
      }, props, {
        $theme: theme
      }));
    });
  });
};
/* eslint-disable flowtype/generic-spacing */

/* flowlint unclear-type:off */


/* eslint-enable flowtype/generic-spacing */

/* flowlint unclear-type:error */
function createThemedStyled() {
  return (0, index_es.createStyled)({
    wrapper: wrapper,
    getInitialStyle: index_es$1.getInitialStyle,
    driver: index_es$1.driver // flowlint-next-line unclear-type:off

  });
}

var styled = createThemedStyled();
exports.styled = styled;

function createThemedWithStyle() {
  // flowlint-next-line unclear-type:off
  return index_es.withStyle;
}

var withStyle = createThemedWithStyle();
exports.withStyle = withStyle;

function createThemedUseStyletron() {
  return function () {
    // flowlint-next-line unclear-type:off
    var theme = React.useContext(require$$0.ThemeContext);

    var _styletronUseStyletro = (0, index_es.useStyletron)(),
        _styletronUseStyletro2 = _slicedToArray(_styletronUseStyletro, 1),
        css = _styletronUseStyletro2[0];

    return [css, theme];
  };
}

var useStyletron = createThemedUseStyletron();
exports.useStyletron = useStyletron;

function withWrapper( // flowlint-next-line unclear-type:off
StyledElement, wrapperFn) {
  // flowlint-next-line unclear-type:off
  return (0, index_es.withWrapper)(StyledElement, function (Styled) {
    // eslint-disable-next-line react/display-name
    return /*#__PURE__*/React.forwardRef(function (props, ref) {
      return /*#__PURE__*/React.createElement(require$$0.ThemeContext.Consumer, null, function (theme) {
        return wrapperFn(Styled)(_objectSpread(_objectSpread({
          ref: ref
        }, props), {}, {
          $theme: theme
        }));
      });
    });
  });
}
});

unwrapExports(styled_1);
styled_1.createThemedStyled;
styled_1.createThemedWithStyle;
styled_1.createThemedUseStyletron;
styled_1.withWrapper;
styled_1.useStyletron;
styled_1.withStyle;
styled_1.styled;

var _styled = styled_1;

var styles = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ThemeProvider", {
  enumerable: true,
  get: function get() {
    return _themeProvider.default;
  }
});
Object.defineProperty(exports, "createThemedStyled", {
  enumerable: true,
  get: function get() {
    return _styled.createThemedStyled;
  }
});
Object.defineProperty(exports, "createThemedWithStyle", {
  enumerable: true,
  get: function get() {
    return _styled.createThemedWithStyle;
  }
});
Object.defineProperty(exports, "createThemedUseStyletron", {
  enumerable: true,
  get: function get() {
    return _styled.createThemedUseStyletron;
  }
});
Object.defineProperty(exports, "styled", {
  enumerable: true,
  get: function get() {
    return _styled.styled;
  }
});
Object.defineProperty(exports, "withStyle", {
  enumerable: true,
  get: function get() {
    return _styled.withStyle;
  }
});
Object.defineProperty(exports, "useStyletron", {
  enumerable: true,
  get: function get() {
    return _styled.useStyletron;
  }
});
Object.defineProperty(exports, "withWrapper", {
  enumerable: true,
  get: function get() {
    return _styled.withWrapper;
  }
});
Object.defineProperty(exports, "hexToRgb", {
  enumerable: true,
  get: function get() {
    return _util.hexToRgb;
  }
});
Object.defineProperty(exports, "expandBorderStyles", {
  enumerable: true,
  get: function get() {
    return _util.expandBorderStyles;
  }
});
exports.ThemeConsumer = void 0;

var _themeProvider = _interopRequireWildcard(require$$0);





function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var ThemeConsumer = _themeProvider.ThemeContext.Consumer;
exports.ThemeConsumer = ThemeConsumer;
});

unwrapExports(styles);
styles.ThemeConsumer;

var constants = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHAPE = exports.ARTWORK_SIZES = void 0;

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var ARTWORK_SIZES = {
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE'
};
exports.ARTWORK_SIZES = ARTWORK_SIZES;
var SHAPE = {
  DEFAULT: 'DEFAULT',
  ROUND: 'ROUND'
};
exports.SHAPE = SHAPE;
});

unwrapExports(constants);
constants.SHAPE;
constants.ARTWORK_SIZES;

var _constants = constants;

var utils$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.artworkSizeToValue = artworkSizeToValue;



/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function artworkSizeToValue(artworkSize, isSublist) {
  if (isSublist) {
    switch (artworkSize) {
      case _constants.ARTWORK_SIZES.LARGE:
        return 24;

      case _constants.ARTWORK_SIZES.SMALL:
      default:
        return 16;
    }
  }

  switch (artworkSize) {
    case _constants.ARTWORK_SIZES.SMALL:
      return 16;

    case _constants.ARTWORK_SIZES.LARGE:
      return 36;

    case _constants.ARTWORK_SIZES.MEDIUM:
    default:
      return 24;
  }
}
});

unwrapExports(utils$1);
utils$1.artworkSizeToValue;

var _index = styles;

var _utils = utils$1;

var styledComponents = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledHeadingEndEnhancerDescriptionContainer = exports.StyledHeadingEndEnhancerContainer = exports.StyledHeadingSubHeading = exports.StyledHeadingMainHeading = exports.StyledHeadingContentRow = exports.StyledHeadingContent = exports.StyledHeadingRoot = exports.StyledLabelSublistContent = exports.StyledLabelDescription = exports.StyledLabelContent = exports.StyledArtworkContainer = exports.StyledEndEnhancerContainer = exports.StyledContent = exports.StyledRoot = void 0;







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StyledRoot = (0, _index.styled)('li', function (_ref) {
  var $theme = _ref.$theme,
      $shape = _ref.$shape;
  return {
    alignItems: 'center',
    backgroundColor: $theme.colors.backgroundPrimary,
    display: 'flex',
    listStyleType: 'none',
    width: '100%',
    borderTopLeftRadius: $shape === _constants.SHAPE.ROUND ? $theme.borders.radius400 : 0,
    borderTopRightRadius: $shape === _constants.SHAPE.ROUND ? $theme.borders.radius400 : 0,
    borderBottomLeftRadius: $shape === _constants.SHAPE.ROUND ? $theme.borders.radius400 : 0,
    borderBottomRightRadius: $shape === _constants.SHAPE.ROUND ? $theme.borders.radius400 : 0,
    overflow: 'hidden'
  };
});
exports.StyledRoot = StyledRoot;
StyledRoot.displayName = "StyledRoot";
var StyledContent = (0, _index.styled)('div', function (_ref2) {
  var $mLeft = _ref2.$mLeft,
      $sublist = _ref2.$sublist,
      $theme = _ref2.$theme;
  return _objectSpread(_objectSpread({}, (0, _index.expandBorderStyles)($theme.borders.border100)), {}, {
    alignItems: 'center',
    borderTopStyle: 'none',
    borderRightStyle: 'none',
    borderLeftStyle: 'none',
    display: 'flex',
    flexGrow: 1,
    minHeight: $sublist ? 'initial' : $theme.sizing.scale1600,
    justifyContent: 'space-between'
  }, $theme.direction === 'rtl' ? {
    paddingLeft: $theme.sizing.scale600,
    marginRight: $mLeft ? $theme.sizing.scale600 : null
  } : {
    paddingRight: $theme.sizing.scale600,
    marginLeft: $mLeft ? $theme.sizing.scale600 : null
  });
});
exports.StyledContent = StyledContent;
StyledContent.displayName = "StyledContent";
var StyledEndEnhancerContainer = (0, _index.styled)('div', {
  alignItems: 'center',
  display: 'flex'
});
exports.StyledEndEnhancerContainer = StyledEndEnhancerContainer;
StyledEndEnhancerContainer.displayName = "StyledEndEnhancerContainer";
var StyledArtworkContainer = (0, _index.styled)('div', function (_ref3) {
  var $artworkSize = _ref3.$artworkSize,
      $sublist = _ref3.$sublist,
      $theme = _ref3.$theme;
  var sizeValue = typeof $artworkSize === 'number' ? $artworkSize : (0, _utils.artworkSizeToValue)($artworkSize, Boolean($sublist));

  if (sizeValue > 36) {
    return {
      alignItems: 'center',
      display: 'flex',
      paddingLeft: $theme.sizing.scale600,
      paddingRight: $theme.sizing.scale600
    };
  }

  return {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    width: $theme.sizing.scale1600
  };
});
exports.StyledArtworkContainer = StyledArtworkContainer;
StyledArtworkContainer.displayName = "StyledArtworkContainer";
var StyledLabelContent = (0, _index.styled)('p', function (_ref4) {
  var $theme = _ref4.$theme;
  return _objectSpread(_objectSpread({}, $theme.typography.LabelMedium), {}, {
    color: $theme.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0
  });
});
exports.StyledLabelContent = StyledLabelContent;
StyledLabelContent.displayName = "StyledLabelContent";
var StyledLabelDescription = (0, _index.styled)('p', function (_ref5) {
  var $theme = _ref5.$theme;
  return _objectSpread(_objectSpread({}, $theme.typography.ParagraphSmall), {}, {
    color: $theme.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0
  });
});
exports.StyledLabelDescription = StyledLabelDescription;
StyledLabelDescription.displayName = "StyledLabelDescription";
var StyledLabelSublistContent = (0, _index.styled)('p', function (_ref6) {
  var $theme = _ref6.$theme;
  return _objectSpread(_objectSpread({}, $theme.typography.LabelMedium), {}, {
    color: $theme.colors.contentPrimary,
    marginTop: $theme.sizing.scale500,
    marginBottom: $theme.sizing.scale500
  });
});
exports.StyledLabelSublistContent = StyledLabelSublistContent;
StyledLabelSublistContent.displayName = "StyledLabelSublistContent";
var StyledHeadingRoot = (0, _index.styled)('div', function (_ref7) {
  var $theme = _ref7.$theme;
  return {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    backgroundColor: $theme.colors.backgroundPrimary,
    overflow: 'hidden',
    minHeight: $theme.sizing.scale1600
  };
});
exports.StyledHeadingRoot = StyledHeadingRoot;
StyledHeadingRoot.displayName = "StyledHeadingRoot";
var StyledHeadingContent = (0, _index.styled)('div', function (_ref8) {
  var $theme = _ref8.$theme;
  return _objectSpread({
    flexGrow: 1,
    width: '100%',
    minWidth: 0,
    paddingTop: $theme.sizing.scale600,
    paddingBottom: $theme.sizing.scale300
  }, $theme.direction === 'rtl' ? {
    paddingLeft: $theme.sizing.scale600,
    marginRight: $theme.sizing.scale600
  } : {
    paddingRight: $theme.sizing.scale600,
    marginLeft: $theme.sizing.scale600
  });
});
exports.StyledHeadingContent = StyledHeadingContent;
StyledHeadingContent.displayName = "StyledHeadingContent";
var StyledHeadingContentRow = (0, _index.styled)('div', {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%'
});
exports.StyledHeadingContentRow = StyledHeadingContentRow;
StyledHeadingContentRow.displayName = "StyledHeadingContentRow";
var StyledHeadingMainHeading = (0, _index.styled)('p', // $FlowFixMe - suppressing due to webkit properties
function (_ref9) {
  var _ref9$$maxLines = _ref9.$maxLines,
      $maxLines = _ref9$$maxLines === void 0 ? 1 : _ref9$$maxLines,
      $theme = _ref9.$theme;
  return _objectSpread(_objectSpread({}, $theme.typography.HeadingSmall), {}, {
    color: $theme.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0,
    marginRight: $theme.sizing.scale600,
    display: '-webkit-box',
    '-webkit-line-clamp': $maxLines,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden'
  });
});
exports.StyledHeadingMainHeading = StyledHeadingMainHeading;
StyledHeadingMainHeading.displayName = "StyledHeadingMainHeading";
var StyledHeadingSubHeading = (0, _index.styled)('p', // $FlowFixMe - suppressing due to webkit properties
function (_ref10) {
  var _ref10$$maxLines = _ref10.$maxLines,
      $maxLines = _ref10$$maxLines === void 0 ? 1 : _ref10$$maxLines,
      $theme = _ref10.$theme;
  return _objectSpread(_objectSpread({}, $theme.typography.ParagraphLarge), {}, {
    color: $theme.colors.contentPrimary,
    marginTop: 0,
    marginBottom: 0,
    marginRight: $theme.sizing.scale600,
    display: '-webkit-box',
    '-webkit-line-clamp': $maxLines,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden'
  });
});
exports.StyledHeadingSubHeading = StyledHeadingSubHeading;
StyledHeadingSubHeading.displayName = "StyledHeadingSubHeading";
var StyledHeadingEndEnhancerContainer = (0, _index.styled)('div', function (_ref11) {
  var $isText = _ref11.$isText,
      $theme = _ref11.$theme;
  return _objectSpread(_objectSpread({}, $theme.typography.LabelMedium), {}, {
    display: 'flex',
    alignItems: $isText ? 'flex-end' : 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  });
});
exports.StyledHeadingEndEnhancerContainer = StyledHeadingEndEnhancerContainer;
StyledHeadingEndEnhancerContainer.displayName = "StyledHeadingEndEnhancerContainer";
var StyledHeadingEndEnhancerDescriptionContainer = (0, _index.styled)('p', function (_ref12) {
  var $theme = _ref12.$theme;
  return _objectSpread(_objectSpread({}, $theme.typography.ParagraphMedium), {}, {
    marginTop: 0,
    marginBottom: 0,
    display: 'flex',
    alignItems: 'flex-start',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  });
});
exports.StyledHeadingEndEnhancerDescriptionContainer = StyledHeadingEndEnhancerDescriptionContainer;
StyledHeadingEndEnhancerDescriptionContainer.displayName = "StyledHeadingEndEnhancerDescriptionContainer";
});

unwrapExports(styledComponents);
styledComponents.StyledHeadingEndEnhancerDescriptionContainer;
styledComponents.StyledHeadingEndEnhancerContainer;
styledComponents.StyledHeadingSubHeading;
styledComponents.StyledHeadingMainHeading;
styledComponents.StyledHeadingContentRow;
styledComponents.StyledHeadingContent;
styledComponents.StyledHeadingRoot;
styledComponents.StyledLabelSublistContent;
styledComponents.StyledLabelDescription;
var styledComponents_10 = styledComponents.StyledLabelContent;
styledComponents.StyledArtworkContainer;
styledComponents.StyledEndEnhancerContainer;
styledComponents.StyledContent;
styledComponents.StyledRoot;

// For some reason, StyledLabelContent is not exported from baseui, so taking
// the styles from the BaseWeb repo and re-working them
const StyledLabelContent = withStyle(styledComponents_10, {
    ...typography$6.LabelMedium,
    marginBottom: 0,
    marginTop: 0,
});

const ListItem = (props) => {
    const { children, ...restProps } = props;
    return (React$2.createElement(BaseListItem, { ...restProps }, children));
};
const ListItemLabel = (props) => {
    const { children, ...restProps } = props;
    return (React$2.createElement(ListItemLabel$1, { overrides: {
            LabelContent: StyledLabelContent,
        }, ...restProps }, children));
};

var _Object$freeze;

function _defineProperty$F(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var BEHAVIOR = Object.freeze({
  fluid: 'fluid',
  fixed: 'fixed'
});
Object.freeze({
  start: 'flex-start',
  center: 'center',
  end: 'flex-end'
});
var STYLE = Object.freeze({
  default: 'default',
  compact: 'compact'
});
var STYLE_VALUES = Object.freeze((_Object$freeze = {}, _defineProperty$F(_Object$freeze, STYLE.default, null), _defineProperty$F(_Object$freeze, STYLE.compact, {
  columns: [4, 8, 12],
  gutters: [16, 16, 16],
  margins: [16, 24, 24],
  gaps: 0,
  unit: 'px',
  maxWidth: 1280
}), _Object$freeze));

function ownKeys$t(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$t(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$t(Object(source), true).forEach(function (key) { _defineProperty$E(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$t(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$E(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var StyledGridWrapper = styled('div', function (_ref) {
  var $theme = _ref.$theme,
      _ref$$behavior = _ref.$behavior,
      $behavior = _ref$$behavior === void 0 ? BEHAVIOR.fixed : _ref$$behavior,
      _ref$$gridMargins = _ref.$gridMargins,
      $gridMargins = _ref$$gridMargins === void 0 ? $theme.grid.margins : _ref$$gridMargins,
      _ref$$gridMaxWidth = _ref.$gridMaxWidth,
      $gridMaxWidth = _ref$$gridMaxWidth === void 0 ? $theme.grid.maxWidth : _ref$$gridMaxWidth,
      _ref$$gridUnit = _ref.$gridUnit,
      $gridUnit = _ref$$gridUnit === void 0 ? $theme.grid.unit : _ref$$gridUnit;
  return {
    margin: 'auto',
    maxWidth: $behavior === BEHAVIOR.fixed ? "".concat($gridMaxWidth + 2 * getResponsiveNumber($gridMargins, Infinity) - 1).concat($gridUnit) : null
  };
});
StyledGridWrapper.displayName = "StyledGridWrapper";
var StyledGrid = styled('div', function (_ref2) {
  var $theme = _ref2.$theme,
      _ref2$$align = _ref2.$align,
      $align = _ref2$$align === void 0 ? null : _ref2$$align,
      _ref2$$behavior = _ref2.$behavior,
      $behavior = _ref2$$behavior === void 0 ? BEHAVIOR.fixed : _ref2$$behavior,
      _ref2$$gridGutters = _ref2.$gridGutters,
      $gridGutters = _ref2$$gridGutters === void 0 ? $theme.grid.gutters : _ref2$$gridGutters,
      _ref2$$gridMargins = _ref2.$gridMargins,
      $gridMargins = _ref2$$gridMargins === void 0 ? $theme.grid.margins : _ref2$$gridMargins,
      _ref2$$gridMaxWidth = _ref2.$gridMaxWidth,
      $gridMaxWidth = _ref2$$gridMaxWidth === void 0 ? $theme.grid.maxWidth : _ref2$$gridMaxWidth,
      _ref2$$gridUnit = _ref2.$gridUnit,
      $gridUnit = _ref2$$gridUnit === void 0 ? $theme.grid.unit : _ref2$$gridUnit;
  var mediaQueries = getMediaQueries($theme.breakpoints);
  var gridStyles = mediaQueries.reduce(function (acc, cur, idx) {
    return _objectSpread$t(_objectSpread$t({}, acc), {}, _defineProperty$E({}, cur, {
      paddingLeft: "".concat(getResponsiveNumber($gridMargins, idx)).concat($gridUnit),
      paddingRight: "".concat(getResponsiveNumber($gridMargins, idx)).concat($gridUnit),
      marginLeft: "-".concat(getResponsiveNumber($gridGutters, idx) / 2).concat($gridUnit),
      marginRight: "-".concat(getResponsiveNumber($gridGutters, idx) / 2).concat($gridUnit),
      alignItems: getResponsiveValue($align, idx)
    }));
  }, {
    paddingLeft: "".concat(getResponsiveNumber($gridMargins, 0)).concat($gridUnit),
    paddingRight: "".concat(getResponsiveNumber($gridMargins, 0)).concat($gridUnit),
    marginLeft: "-".concat(getResponsiveNumber($gridGutters, 0) / 2).concat($gridUnit),
    marginRight: "-".concat(getResponsiveNumber($gridGutters, 0) / 2).concat($gridUnit),
    alignItems: getResponsiveValue($align, 0)
  });
  return _objectSpread$t({
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: $behavior === BEHAVIOR.fixed ? "".concat($gridMaxWidth + 2 * getResponsiveNumber($gridMargins, Infinity) - 1).concat($gridUnit) : null
  }, gridStyles);
});
StyledGrid.displayName = "StyledGrid";
var StyledCell$1 = styled('div', function (_ref3) {
  var $theme = _ref3.$theme,
      _ref3$$align = _ref3.$align,
      $align = _ref3$$align === void 0 ? null : _ref3$$align,
      _ref3$$order = _ref3.$order,
      $order = _ref3$$order === void 0 ? null : _ref3$$order,
      _ref3$$gridColumns = _ref3.$gridColumns,
      $gridColumns = _ref3$$gridColumns === void 0 ? $theme.grid.columns : _ref3$$gridColumns,
      _ref3$$gridGaps = _ref3.$gridGaps,
      $gridGaps = _ref3$$gridGaps === void 0 ? $theme.grid.gaps : _ref3$$gridGaps,
      _ref3$$gridGutters = _ref3.$gridGutters,
      $gridGutters = _ref3$$gridGutters === void 0 ? $theme.grid.gutters : _ref3$$gridGutters,
      _ref3$$gridUnit = _ref3.$gridUnit,
      $gridUnit = _ref3$$gridUnit === void 0 ? $theme.grid.unit : _ref3$$gridUnit,
      _ref3$$skip = _ref3.$skip,
      $skip = _ref3$$skip === void 0 ? [0, 0, 0] : _ref3$$skip,
      _ref3$$span = _ref3.$span,
      $span = _ref3$$span === void 0 ? [1, 1, 1] : _ref3$$span;
  var mediaQueries = getMediaQueries($theme.breakpoints);
  var cellStyles = mediaQueries.reduce(function (acc, cur, idx) {
    if (getResponsiveNumber($span, idx) === 0) {
      return _objectSpread$t(_objectSpread$t({}, acc), {}, _defineProperty$E({}, cur, {
        width: '0',
        paddingLeft: '0',
        paddingRight: '0',
        marginLeft: '0',
        marginRight: '0',
        display: 'none'
      }));
    }

    return _objectSpread$t(_objectSpread$t({}, acc), {}, _defineProperty$E({}, cur, {
      display: 'block',
      width: "calc(".concat(100 / getResponsiveNumber($gridColumns, idx) * Math.min(getResponsiveNumber($span, idx), getResponsiveNumber($gridColumns, idx)), "% - ").concat(getResponsiveNumber($gridGutters, idx)).concat($gridUnit, ")"),
      marginLeft: "calc(".concat(100 / getResponsiveNumber($gridColumns, idx) * Math.min(getResponsiveNumber($skip, idx), getResponsiveNumber($gridColumns, idx) - 1), "% + ").concat(getResponsiveNumber($gridGutters, idx) / 2).concat($gridUnit, ")"),
      marginRight: "".concat(getResponsiveNumber($gridGutters, idx) / 2).concat($gridUnit),
      marginBottom: "".concat(getResponsiveNumber($gridGaps, idx)).concat($gridUnit),
      alignSelf: getResponsiveValue($align, idx),
      order: getResponsiveNumber($order, idx)
    }));
  }, {
    width: '100%',
    marginLeft: "".concat(getResponsiveNumber($gridGutters, 0) / 2).concat($gridUnit),
    marginRight: "".concat(getResponsiveNumber($gridGutters, 0) / 2).concat($gridUnit),
    marginBottom: "".concat(getResponsiveNumber($gridGaps, 0)).concat($gridUnit),
    alignSelf: getResponsiveValue($align, 0),
    order: getResponsiveNumber($order, 0)
  });
  return _objectSpread$t({
    boxSizing: 'border-box'
  }, cellStyles);
});
StyledCell$1.displayName = "StyledCell";

function getResponsiveNumber(responsive, i) {
  var res = getResponsiveValue(responsive, i);
  return typeof res === 'number' ? res : 0;
}

function getResponsiveValue(responsive, i) {
  if (!responsive) {
    return null;
  }

  if (!Array.isArray(responsive)) {
    return responsive;
  }

  if (typeof responsive[i] === 'undefined') {
    return responsive[responsive.length - 1];
  }

  return responsive[i];
}

function _extends$q() { _extends$q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

function ownKeys$s(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$s(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$s(Object(source), true).forEach(function (key) { _defineProperty$D(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$s(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$D(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$n(arr, i) { return _arrayWithHoles$n(arr) || _iterableToArrayLimit$n(arr, i) || _unsupportedIterableToArray$o(arr, i) || _nonIterableRest$n(); }

function _nonIterableRest$n() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$o(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$o(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$o(o, minLen); }

function _arrayLikeToArray$o(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$n(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$n(arr) { if (Array.isArray(arr)) return arr; }
var GridContext = /*#__PURE__*/React$2.createContext({});
function Grid(_ref) {
  var align = _ref.align,
      behavior = _ref.behavior,
      children = _ref.children,
      gridColumns = _ref.gridColumns,
      gridGaps = _ref.gridGaps,
      gridGutters = _ref.gridGutters,
      gridMargins = _ref.gridMargins,
      gridMaxWidth = _ref.gridMaxWidth,
      _ref$gridStyle = _ref.gridStyle,
      gridStyle = _ref$gridStyle === void 0 ? STYLE.default : _ref$gridStyle,
      gridUnit = _ref.gridUnit,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides;

  var _getOverrides = getOverrides(overrides.Grid, StyledGrid),
      _getOverrides2 = _slicedToArray$n(_getOverrides, 2),
      StyledGrid$1 = _getOverrides2[0],
      overrideProps = _getOverrides2[1];

  var _getOverrides3 = getOverrides(overrides.GridWrapper, StyledGridWrapper),
      _getOverrides4 = _slicedToArray$n(_getOverrides3, 2),
      StyledGridWrapper$1 = _getOverrides4[0],
      wrapperProps = _getOverrides4[1];

  var presetStyleValues = STYLE_VALUES[gridStyle];
  var gridStyleValues = presetStyleValues ? {
    $gridGutters: presetStyleValues.gutters,
    $gridMargins: presetStyleValues.margins,
    $gridMaxWidth: presetStyleValues.maxWidth,
    $gridUnit: presetStyleValues.unit
  } : {};
  var gridContextStyleValues = presetStyleValues && {
    gridColumns: presetStyleValues.columns,
    gridGaps: presetStyleValues.gaps,
    gridGutters: presetStyleValues.gutters,
    gridUnit: presetStyleValues.unit
  };
  return /*#__PURE__*/React$2.createElement(StyledGridWrapper$1, _extends$q({
    $behavior: behavior,
    $gridMargins: gridMargins != null ? gridMargins : gridStyleValues.$gridMargins,
    $gridMaxWidth: gridMaxWidth != null ? gridMaxWidth : gridStyleValues.$gridMaxWidth,
    $gridUnit: gridUnit != null ? gridUnit : gridStyleValues.$gridUnit
  }, wrapperProps), /*#__PURE__*/React$2.createElement(StyledGrid$1, _extends$q({
    $align: align,
    $behavior: behavior,
    $gridGutters: gridGutters != null ? gridGutters : gridStyleValues.$gridGutters,
    $gridMargins: gridMargins != null ? gridMargins : gridStyleValues.$gridMargins,
    $gridMaxWidth: gridMaxWidth != null ? gridMaxWidth : gridStyleValues.$gridMaxWidth,
    $gridUnit: gridUnit != null ? gridUnit : gridStyleValues.$gridUnit
  }, overrideProps), /*#__PURE__*/React$2.createElement(GridContext.Provider, {
    value: _objectSpread$s({
      gridColumns: gridColumns,
      gridGaps: gridGaps,
      gridGutters: gridGutters,
      gridUnit: gridUnit
    }, gridContextStyleValues)
  }, children)));
}

function _extends$p() { _extends$p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

function _slicedToArray$m(arr, i) { return _arrayWithHoles$m(arr) || _iterableToArrayLimit$m(arr, i) || _unsupportedIterableToArray$n(arr, i) || _nonIterableRest$m(); }

function _nonIterableRest$m() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$n(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$n(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$n(o, minLen); }

function _arrayLikeToArray$n(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$m(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$m(arr) { if (Array.isArray(arr)) return arr; }
function Cell(_ref) {
  var align = _ref.align,
      children = _ref.children,
      gridColumns = _ref.gridColumns,
      gridGaps = _ref.gridGaps,
      gridGutters = _ref.gridGutters,
      gridUnit = _ref.gridUnit,
      order = _ref.order,
      skip = _ref.skip,
      span = _ref.span,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides;

  var _getOverrides = getOverrides(overrides.Cell, StyledCell$1),
      _getOverrides2 = _slicedToArray$m(_getOverrides, 2),
      StyledCell = _getOverrides2[0],
      overrideProps = _getOverrides2[1];

  var gridContext = React__default.useContext(GridContext);
  return /*#__PURE__*/React__default.createElement(StyledCell, _extends$p({
    $align: align // TODO(v11): Remove the four grid props, get them solely from GridContext
    ,
    $gridColumns: gridColumns || gridContext.gridColumns,
    $gridGaps: gridGaps || gridContext.gridGaps,
    $gridGutters: gridGutters || gridContext.gridGutters,
    $gridUnit: gridUnit || gridContext.gridUnit,
    $order: order,
    $skip: skip,
    $span: span
  }, overrideProps), children);
}

const FluidGrid = (props) => (React$2.createElement(Grid, { behavior: BEHAVIOR.fluid, ...props }));

const StyledList = themedWithStyle(StyledList$1, ({ $theme }) => ({
    boxShadow: $theme.boxShadow.card,
    ...borderRadius('top', $theme.cornerRadius['semi-sharp']),
    ...borderRadius('bottom', $theme.cornerRadius['semi-sharp']),
    ...padding(0),
    ':focus': {
        // boxShadow: $theme.boxShadow.focus,
        outline: 'none',
    },
}));
const StyledListItem = themedWithStyle(StyledListItem$1, (props) => {
    const { $disabled, $theme } = props;
    return {
        ...typography$6.LabelMedium,
        ...padding($theme.sizing['xxx-small'], $theme.sizing['xx-small']),
        backgroundColor: $theme.colors['neutral-0'],
        ...(!$disabled ? {
            '::selection': {
                backgroundColor: $theme.colors['neutral-25'],
            },
            ':hover': {
                backgroundColor: $theme.colors['neutral-25'],
                color: $theme.colors['neutral-100'],
            },
            color: $theme.colors['neutral-100'],
        } : {}),
    };
});

const StatefulMenu = (props) => (React$2.createElement(StatefulMenu$1, { overrides: {
        List: StyledList,
        Option: {
            props: {
                getItemLabel: (item) => item.label,
                overrides: {
                    ListItem: StyledListItem,
                },
            },
        },
    }, ...props }));

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var SIZE = {
  default: 'default',
  full: 'full',
  auto: 'auto'
};
var SIZE_WIDTHS = {
  default: '500px',
  full: '100%',
  auto: 'auto'
};
var ROLE = {
  dialog: 'dialog',
  alertdialog: 'alertdialog'
};
var CLOSE_SOURCE = {
  closeButton: 'closeButton',
  backdrop: 'backdrop',
  escape: 'escape'
};

function ownKeys$r(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$r(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$r(Object(source), true).forEach(function (key) { _defineProperty$C(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$r(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$C(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getSizeStyles($size) {
  var styles = {
    maxWidth: '100%',
    width: null
  };

  if (typeof $size === 'number') {
    styles.width = "".concat($size, "px");
  } else if (SIZE[$size]) {
    styles.width = SIZE_WIDTHS[$size];
  } else if (typeof $size === 'string') {
    styles.width = $size;
  }

  if ($size === SIZE.full) {
    styles.alignSelf = 'stretch';
  }

  return styles;
}

var Root$4 = styled('div', function (props) {
  var $isOpen = props.$isOpen;
  return {
    position: 'fixed',
    overflow: 'auto',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    pointerEvents: $isOpen ? 'auto' : 'none'
  };
});
Root$4.displayName = "Root";
var Backdrop = styled('div', function (props) {
  var $animate = props.$animate,
      $isOpen = props.$isOpen,
      $isVisible = props.$isVisible,
      $theme = props.$theme,
      $unstable_ModalBackdropScroll = props.$unstable_ModalBackdropScroll;

  if ($unstable_ModalBackdropScroll) {
    return {};
  }

  return _objectSpread$r({
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    // Disable scroll capabilities.
    touchAction: 'none',
    opacity: $isVisible && $isOpen ? 1 : 0
  }, $animate ? {
    transitionProperty: 'opacity',
    transitionDuration: $theme.animation.timing400,
    transitionTimingFunction: $theme.animation.easeOutCurve
  } : null);
});
Backdrop.displayName = "Backdrop";
var DialogContainer = styled('div', function (props) {
  var $animate = props.$animate,
      $isOpen = props.$isOpen,
      $isVisible = props.$isVisible,
      $theme = props.$theme,
      $unstable_ModalBackdropScroll = props.$unstable_ModalBackdropScroll;
  return _objectSpread$r({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    minHeight: '100%',
    pointerEvents: 'none',
    userSelect: 'none'
  }, $unstable_ModalBackdropScroll ? _objectSpread$r({
    pointerEvents: 'auto',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    opacity: $isVisible && $isOpen ? 1 : 0
  }, $animate ? {
    transitionProperty: 'opacity',
    transitionDuration: $theme.animation.timing400,
    transitionTimingFunction: $theme.animation.easeOutCurve
  } : null) : {});
});
DialogContainer.displayName = "DialogContainer";
var Dialog = styled('div', function (props) {
  var $animate = props.$animate,
      $isOpen = props.$isOpen,
      $isVisible = props.$isVisible,
      $size = props.$size,
      $theme = props.$theme;
  return _objectSpread$r(_objectSpread$r(_objectSpread$r({
    position: 'relative',
    backgroundColor: $theme.colors.backgroundPrimary,
    borderTopLeftRadius: $theme.borders.radius500,
    borderTopRightRadius: $theme.borders.radius500,
    borderBottomRightRadius: $theme.borders.radius500,
    borderBottomLeftRadius: $theme.borders.radius500,
    marginLeft: $theme.sizing.scale600,
    marginTop: $theme.sizing.scale600,
    marginRight: $theme.sizing.scale600,
    marginBottom: $theme.sizing.scale600
  }, getSizeStyles($size)), {}, {
    // Animation
    opacity: $isVisible && $isOpen ? 1 : 0,
    transform: $isVisible ? 'translateY(0)' : 'translateY(20px)'
  }, $animate ? {
    transitionProperty: 'opacity, transform',
    transitionDuration: $theme.animation.timing400,
    transitionTimingFunction: $theme.animation.easeOutCurve
  } : null), {}, {
    // Reset interactivity properties set by container
    userSelect: 'text',
    pointerEvents: $isOpen ? 'all' : 'none',
    // We move focus to the modal, but we don't want the blue outline style
    ':focus': {
      outline: 'none'
    }
  });
});
Dialog.displayName = "Dialog";
var Close = styled('button', function (props) {
  var _ref;

  var $theme = props.$theme,
      $isFocusVisible = props.$isFocusVisible;
  var dir = $theme.direction === 'rtl' ? 'left' : 'right';
  return _ref = {
    // Reset button styles
    background: 'transparent',
    outline: 0,
    paddingLeft: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    // colors
    color: $theme.colors.modalCloseColor,
    transitionProperty: 'color, border-color',
    transitionDuration: $theme.animation.timing200,
    borderLeftWidth: '1px',
    borderRightWidth: '1px',
    borderTopWidth: '1px',
    borderBottomWidth: '1px',
    borderLeftStyle: 'solid',
    borderRightStyle: 'solid',
    borderTopStyle: 'solid',
    borderBottomStyle: 'solid',
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderTopColor: 'transparent',
    borderBottomColor: 'transparent',
    ':hover': {
      color: $theme.colors.modalCloseColorHover
    },
    ':focus': {
      outline: $isFocusVisible ? "3px solid ".concat($theme.colors.accent) : 'none'
    },
    // Positioning
    position: 'absolute',
    top: $theme.sizing.scale500
  }, _defineProperty$C(_ref, dir, $theme.sizing.scale500), _defineProperty$C(_ref, "width", $theme.sizing.scale800), _defineProperty$C(_ref, "height", $theme.sizing.scale800), _defineProperty$C(_ref, "display", 'flex'), _defineProperty$C(_ref, "justifyContent", 'center'), _defineProperty$C(_ref, "alignItems", 'center'), _defineProperty$C(_ref, "cursor", 'pointer'), _ref;
});
Close.displayName = "Close";
var ModalHeader = styled('div', function (_ref2) {
  var _objectSpread2;

  var $theme = _ref2.$theme;
  var marginStartDir = $theme.direction === 'rtl' ? 'marginRight' : 'marginLeft';
  var marginEndDir = $theme.direction === 'rtl' ? 'marginLeft' : 'marginRight';
  return _objectSpread$r(_objectSpread$r({}, $theme.typography.font550), {}, (_objectSpread2 = {
    color: $theme.colors.contentPrimary,
    marginTop: $theme.sizing.scale900,
    marginBottom: $theme.sizing.scale600
  }, _defineProperty$C(_objectSpread2, marginStartDir, $theme.sizing.scale800), _defineProperty$C(_objectSpread2, marginEndDir, $theme.sizing.scale900), _objectSpread2));
});
ModalHeader.displayName = "ModalHeader";
var ModalBody = styled('div', function (_ref3) {
  var $theme = _ref3.$theme;
  return _objectSpread$r(_objectSpread$r({}, $theme.typography.font200), {}, {
    color: $theme.colors.contentSecondary,
    marginTop: $theme.sizing.scale600,
    marginLeft: $theme.sizing.scale800,
    marginRight: $theme.sizing.scale800,
    marginBottom: $theme.sizing.scale700
  });
});
ModalBody.displayName = "ModalBody";
var ModalFooter = styled('div', function (_ref4) {
  var $theme = _ref4.$theme;
  return _objectSpread$r(_objectSpread$r({}, $theme.typography.font200), {}, {
    marginTop: $theme.sizing.scale700,
    marginLeft: $theme.sizing.scale800,
    marginRight: $theme.sizing.scale800,
    paddingTop: $theme.sizing.scale500,
    paddingBottom: $theme.sizing.scale500,
    textAlign: $theme.direction === 'rtl' ? 'left' : 'right'
  });
});
ModalFooter.displayName = "ModalFooter";

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

function CloseIcon() {
  return /*#__PURE__*/React$2.createElement("svg", {
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    style: {
      stroke: 'currentColor'
    },
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React$2.createElement("path", {
    d: "M9 1L5 5M1 9L5 5M5 5L1 1M5 5L9 9",
    strokeWidth: "2",
    strokeLinecap: "round"
  }));
}

function _typeof$g(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$g = function _typeof(obj) { return typeof obj; }; } else { _typeof$g = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$g(obj); }

function _extends$o() { _extends$o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

function _slicedToArray$l(arr, i) { return _arrayWithHoles$l(arr) || _iterableToArrayLimit$l(arr, i) || _unsupportedIterableToArray$m(arr, i) || _nonIterableRest$l(); }

function _nonIterableRest$l() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$m(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$m(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$m(o, minLen); }

function _arrayLikeToArray$m(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$l(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$l(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$g(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$f(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$g(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$f(Constructor.prototype, protoProps); if (staticProps) _defineProperties$f(Constructor, staticProps); return Constructor; }

function _inherits$g(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$f(subClass, superClass); }

function _setPrototypeOf$f(o, p) { _setPrototypeOf$f = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$f(o, p); }

function _createSuper$f(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$f(); return function _createSuperInternal() { var Super = _getPrototypeOf$f(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$f(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$g(this, result); }; }

function _possibleConstructorReturn$g(self, call) { if (call && (_typeof$g(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$f(self); }

function _assertThisInitialized$f(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$f() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$f(o) { _getPrototypeOf$f = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$f(o); }

function _defineProperty$B(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Modal$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$g(Modal, _React$Component);

  var _super = _createSuper$f(Modal);

  function Modal() {
    var _this;

    _classCallCheck$g(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$B(_assertThisInitialized$f(_this), "animateOutTimer", void 0);

    _defineProperty$B(_assertThisInitialized$f(_this), "animateStartTimer", void 0);

    _defineProperty$B(_assertThisInitialized$f(_this), "lastFocus", null);

    _defineProperty$B(_assertThisInitialized$f(_this), "lastMountNodeOverflowStyle", null);

    _defineProperty$B(_assertThisInitialized$f(_this), "_refs", {});

    _defineProperty$B(_assertThisInitialized$f(_this), "state", {
      isVisible: false,
      mounted: false,
      isFocusVisible: false
    });

    _defineProperty$B(_assertThisInitialized$f(_this), "handleFocus", function (event) {
      if (isFocusVisible(event)) {
        _this.setState({
          isFocusVisible: true
        });
      }
    });

    _defineProperty$B(_assertThisInitialized$f(_this), "handleBlur", function (event) {
      if (_this.state.isFocusVisible !== false) {
        _this.setState({
          isFocusVisible: false
        });
      }
    });

    _defineProperty$B(_assertThisInitialized$f(_this), "onEscape", function () {
      if (!_this.props.closeable) {
        return;
      }

      _this.triggerClose(CLOSE_SOURCE.escape);
    });

    _defineProperty$B(_assertThisInitialized$f(_this), "onDocumentClick", function (e) {
      if (e.target && e.target instanceof HTMLElement && ( // Handles modal closure when unstable_ModalBackdropScroll is set to true
      e.target.contains(_this.getRef('DialogContainer').current) || // Handles modal closure when unstable_ModalBackdropScroll is set to false
      // $FlowFixMe
      e.target.contains(_this.getRef('DeprecatedBackdrop').current))) {
        _this.onBackdropClick();
      }
    });

    _defineProperty$B(_assertThisInitialized$f(_this), "onBackdropClick", function () {
      if (!_this.props.closeable) {
        return;
      }

      _this.triggerClose(CLOSE_SOURCE.backdrop);
    });

    _defineProperty$B(_assertThisInitialized$f(_this), "onCloseClick", function () {
      _this.triggerClose(CLOSE_SOURCE.closeButton);
    });

    _defineProperty$B(_assertThisInitialized$f(_this), "animateOutComplete", function () {
      _this.setState({
        isVisible: false
      });
    });

    return _this;
  }

  _createClass$g(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        mounted: true
      }); // TODO(v11)

      if (process.env.NODE_ENV !== "production") {
        if (!this.props.unstable_ModalBackdropScroll) {
          console.warn("Consider setting 'unstable_ModalBackdropScroll' prop to true\n        to prepare for the next major version upgrade. 'unstable_ModalBackdropScroll'\n        prop will be removed in the next major version but implemented as the default behavior.");
        }

        if (this.props.overrides && this.props.overrides.Backdrop) {
          console.warn("Backdrop element will be removed in the next major version in favor of\n        DialogContainer element that will have the backdrop styles and backdrop click handle.\n        Consider setting 'unstable_ModalBackdropScroll' prop to true that will apply backdrop\n        styles to DialogContainer enable modal scrolling while cursor in over the backdrop.\n        Then pass backdrop overrides to DialogContainer instead. Tha will help you with\n        the next major version upgrade.");
        } // $FlowFixMe: flow complains that this prop doesn't exist


        if (this.props.closable) {
          console.warn('The property `closable` is not supported on the Modal. Did you mean `closeable`?');
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.resetMountNodeScroll();
      this.clearTimers();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var isOpen = this.props.isOpen;

      if ( // If isOpen is changing *or* we just mounted and modal should be open
      isOpen !== prevProps.isOpen || isOpen && this.state.mounted && !prevState.mounted) {
        if (isOpen) {
          this.didOpen();
        } else {
          this.didClose();
        }
      }
    }
  }, {
    key: "disableMountNodeScroll",
    value: function disableMountNodeScroll() {
      var mountNode = this.getMountNode();
      this.lastMountNodeOverflowStyle = mountNode.style.overflow || '';
      mountNode.style.overflow = 'hidden';
    }
  }, {
    key: "resetMountNodeScroll",
    value: function resetMountNodeScroll() {
      var mountNode = this.getMountNode();
      var lastStyle = this.lastMountNodeOverflowStyle;

      if (mountNode && lastStyle !== null) {
        // If overflow is not 'hidden', something else has changed the
        // overflow style and we shouldn't try to reset it.
        if (mountNode.style.overflow === 'hidden') {
          mountNode.style.overflow = lastStyle || '';
        }

        this.lastMountNodeOverflowStyle = null;
      }
    }
  }, {
    key: "clearTimers",
    value: function clearTimers() {
      if (this.animateOutTimer) {
        clearTimeout(this.animateOutTimer);
      }

      if (this.animateStartTimer) {
        // eslint-disable-next-line cup/no-undef
        cancelAnimationFrame(this.animateStartTimer);
      }
    }
  }, {
    key: "didOpen",
    value: function didOpen() {
      var _this2 = this;

      // Sometimes scroll starts past zero, possibly due to animation
      // Reset scroll to 0 (other libraries do this as well)
      var rootRef = this.getRef('Root').current;

      if (rootRef) {
        rootRef.scrollTop = 0;
      } // Clear any existing timers (like previous animateOutTimer)


      this.clearTimers();
      this.disableMountNodeScroll(); // eslint-disable-next-line cup/no-undef

      this.animateStartTimer = requestAnimationFrame(function () {
        _this2.setState({
          isVisible: true
        });
      });
    }
  }, {
    key: "didClose",
    value: function didClose() {
      this.resetMountNodeScroll();
      this.animateOutTimer = setTimeout(this.animateOutComplete, 500);
    }
  }, {
    key: "triggerClose",
    value: function triggerClose(source) {
      // If there's no source, it just means the isOpen prop changed. No need to call onClose.
      if (this.props.onClose && source) {
        this.props.onClose({
          closeSource: source
        });
      }
    }
  }, {
    key: "getSharedProps",
    value: function getSharedProps() {
      var _this$props = this.props,
          animate = _this$props.animate,
          isOpen = _this$props.isOpen,
          size = _this$props.size,
          role = _this$props.role,
          closeable = _this$props.closeable,
          unstable_ModalBackdropScroll = _this$props.unstable_ModalBackdropScroll;
      return {
        $animate: animate,
        $isVisible: this.state.isVisible,
        $isOpen: !!isOpen,
        $size: size,
        $role: role,
        $closeable: !!closeable,
        $unstable_ModalBackdropScroll: unstable_ModalBackdropScroll,
        $isFocusVisible: this.state.isFocusVisible
      };
    }
  }, {
    key: "getMountNode",
    value: function getMountNode() {
      var mountNode = this.props.mountNode;

      if (mountNode) {
        return mountNode;
      } // Flow thinks body could be null (cast through any)
      // flowlint-next-line unclear-type:off


      return document.body;
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var children = this.props.children;
      return typeof children === 'function' ? children() : children;
    }
  }, {
    key: "getRef",
    value: function getRef(component) {
      if (!this._refs[component]) {
        this._refs[component] = /*#__PURE__*/React$2.createRef();
      }

      return this._refs[component];
    }
  }, {
    key: "renderModal",
    value: function renderModal() {
      var _this3 = this;

      var _this$props2 = this.props,
          _this$props2$override = _this$props2.overrides,
          overrides = _this$props2$override === void 0 ? {} : _this$props2$override,
          closeable = _this$props2.closeable,
          role = _this$props2.role,
          unstable_ModalBackdropScroll = _this$props2.unstable_ModalBackdropScroll,
          autofocus = _this$props2.autofocus,
          autoFocus = _this$props2.autoFocus,
          focusLock = _this$props2.focusLock,
          returnFocus = _this$props2.returnFocus;
      var RootOverride = overrides.Root,
          DialogOverride = overrides.Dialog,
          DialogContainerOverride = overrides.DialogContainer,
          BackdropOverride = overrides.Backdrop,
          CloseOverride = overrides.Close;

      var _getOverrides = getOverrides(RootOverride, Root$4),
          _getOverrides2 = _slicedToArray$l(_getOverrides, 2),
          Root = _getOverrides2[0],
          rootProps = _getOverrides2[1];

      var _getOverrides3 = getOverrides(BackdropOverride, Backdrop),
          _getOverrides4 = _slicedToArray$l(_getOverrides3, 2),
          Backdrop$1 = _getOverrides4[0],
          backdropProps = _getOverrides4[1];

      var _getOverrides5 = getOverrides(DialogContainerOverride, DialogContainer),
          _getOverrides6 = _slicedToArray$l(_getOverrides5, 2),
          DialogContainer$1 = _getOverrides6[0],
          dialogContainerProps = _getOverrides6[1];

      var _getOverrides7 = getOverrides(DialogOverride, Dialog),
          _getOverrides8 = _slicedToArray$l(_getOverrides7, 2),
          Dialog$1 = _getOverrides8[0],
          dialogProps = _getOverrides8[1];

      var _getOverrides9 = getOverrides(CloseOverride, Close),
          _getOverrides10 = _slicedToArray$l(_getOverrides9, 2),
          Close$1 = _getOverrides10[0],
          closeProps = _getOverrides10[1];

      var sharedProps = this.getSharedProps();
      var children = this.getChildren();

      if (autofocus === false && process.env.NODE_ENV !== "production") {
        console.warn("The prop \"autofocus\" is deprecated in favor of \"autoFocus\" to be consistent across the project.\n        The property \"autofocus\" will be removed in a future major version.");
      } // Handles backdrop click when `unstable_ModalBackdropScroll` is set to true


      if (dialogContainerProps.ref) {
        this._refs.DialogContainer = dialogContainerProps.ref;
      }

      var dialogContainerConditionalProps = unstable_ModalBackdropScroll ? {
        ref: this.getRef('DialogContainer')
      } : {};
      return /*#__PURE__*/React$2.createElement(LocaleContext.Consumer, null, function (locale) {
        return /*#__PURE__*/React$2.createElement(FocusLock, {
          disabled: !focusLock // Allow focus to escape when UI is within an iframe
          ,
          crossFrame: false,
          returnFocus: returnFocus,
          autoFocus: autofocus !== null ? autofocus : autoFocus
        }, /*#__PURE__*/React$2.createElement(Root, _extends$o({
          "data-baseweb": "modal",
          ref: _this3.getRef('Root')
        }, sharedProps, rootProps), /*#__PURE__*/React$2.createElement(Backdrop$1, _extends$o({}, unstable_ModalBackdropScroll ? {} : {
          ref: _this3.getRef('DeprecatedBackdrop')
        }, sharedProps, backdropProps)), /*#__PURE__*/React$2.createElement(DialogContainer$1, _extends$o({}, dialogContainerConditionalProps, sharedProps, dialogContainerProps), /*#__PURE__*/React$2.createElement(Dialog$1, _extends$o({
          tabIndex: -1,
          "aria-modal": true,
          "aria-label": "dialog",
          role: role,
          ref: _this3.getRef('Dialog')
        }, sharedProps, dialogProps), children, closeable ? /*#__PURE__*/React$2.createElement(Close$1, _extends$o({
          "aria-label": locale.modal.close,
          onClick: _this3.onCloseClick
        }, sharedProps, closeProps, {
          onFocus: forkFocus(closeProps, _this3.handleFocus),
          onBlur: forkBlur(closeProps, _this3.handleBlur)
        }), /*#__PURE__*/React$2.createElement(CloseIcon, null)) : null))));
      });
    }
  }, {
    key: "render",
    value: function render() {
      // Only render modal on the browser (portals aren't supported server-side)
      if (!this.state.mounted) {
        return null;
      } // Only render the modal if its isOpen is passed, or isVisible is true (still animating)


      if (!this.props.isOpen && !this.state.isVisible) {
        return null;
      }

      return /*#__PURE__*/React$2.createElement(Layer, {
        onEscape: this.onEscape,
        onDocumentClick: this.onDocumentClick,
        mountNode: this.props.mountNode
      }, this.renderModal());
    }
  }]);

  return Modal;
}(React$2.Component);

_defineProperty$B(Modal$1, "defaultProps", {
  animate: true,
  // TODO(v11): remove
  autofocus: null,
  autoFocus: true,
  focusLock: true,
  returnFocus: true,
  closeable: true,
  name: 'dialog',
  isOpen: false,
  overrides: {},
  role: ROLE.dialog,
  size: SIZE.default,
  unstable_ModalBackdropScroll: false
});

var BaseModal = Modal$1;

const getDialogStyles = (noPadding, size) => {
    const [, theme] = themedUseStyletron();
    return ({
        ...borderRadius('top', theme.cornerRadius['semi-sharp']),
        ...borderRadius('bottom', theme.cornerRadius['semi-sharp']),
        ...(noPadding ? padding('0px') : padding(theme.sizing.small)),
        ...(size === SIZE.full
            ? {
                ...margin(theme.sizing.small),
            }
            : {
                ...margin(0),
            }),
        backgroundColor: theme.colors['neutral-0'],
        boxShadow: theme.boxShadow.layout,
    });
};
const StyledClose = themedWithStyle(Close, {
    display: 'none',
});
const StyledDialogContainer = themedWithStyle(DialogContainer, ({ $theme }) => ({
    backgroundColor: rgba({
        ...parseToRgb($theme.colors['neutral-100']),
        alpha: parseFloat($theme.opacity.medium),
    }),
    maxHeight: '100%',
}));

const Modal = (props) => {
    const { children, noPadding = false, size, ...otherProps } = props;
    return (React$2.createElement(BaseModal, { unstable_ModalBackdropScroll: true, overrides: {
            Close: StyledClose,
            Dialog: {
                style: getDialogStyles(noPadding, size || SIZE.default),
            },
            DialogContainer: StyledDialogContainer,
        }, size: size, ...otherProps }, children));
};

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var KIND = Object.freeze({
  info: 'info',
  positive: 'positive',
  warning: 'warning',
  negative: 'negative'
});
var TYPE = Object.freeze({
  inline: 'inline',
  toast: 'toast'
});
var PLACEMENT$1 = Object.freeze({
  topLeft: 'topLeft',
  top: 'top',
  topRight: 'topRight',
  bottomRight: 'bottomRight',
  bottom: 'bottom',
  bottomLeft: 'bottomLeft'
});

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function ownKeys$q(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$q(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$q(Object(source), true).forEach(function (key) { _defineProperty$A(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$q(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$A(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getBackgroundColor(kind, type, theme) {
  var _KIND$info$KIND$posit;

  var isInline = type === TYPE.inline;
  return (_KIND$info$KIND$posit = {}, _defineProperty$A(_KIND$info$KIND$posit, KIND.info, isInline ? theme.colors.notificationInfoBackground : theme.colors.toastInfoBackground), _defineProperty$A(_KIND$info$KIND$posit, KIND.positive, isInline ? theme.colors.notificationPositiveBackground : theme.colors.toastPositiveBackground), _defineProperty$A(_KIND$info$KIND$posit, KIND.warning, isInline ? theme.colors.notificationWarningBackground : theme.colors.toastWarningBackground), _defineProperty$A(_KIND$info$KIND$posit, KIND.negative, isInline ? theme.colors.notificationNegativeBackground : theme.colors.toastNegativeBackground), _KIND$info$KIND$posit)[kind];
}

function getFontColor(kind, type, theme) {
  var _KIND$info$KIND$posit3;

  var isInline = type === TYPE.inline;

  if (isInline) {
    var _KIND$info$KIND$posit2;

    return (_KIND$info$KIND$posit2 = {}, _defineProperty$A(_KIND$info$KIND$posit2, KIND.info, theme.colors.notificationInfoText), _defineProperty$A(_KIND$info$KIND$posit2, KIND.positive, theme.colors.notificationPositiveText), _defineProperty$A(_KIND$info$KIND$posit2, KIND.warning, theme.colors.notificationWarningText), _defineProperty$A(_KIND$info$KIND$posit2, KIND.negative, theme.colors.notificationNegativeText), _KIND$info$KIND$posit2)[kind];
  }

  return (_KIND$info$KIND$posit3 = {}, _defineProperty$A(_KIND$info$KIND$posit3, KIND.info, theme.colors.toastInfoText), _defineProperty$A(_KIND$info$KIND$posit3, KIND.positive, theme.colors.toastPositiveText), _defineProperty$A(_KIND$info$KIND$posit3, KIND.warning, theme.colors.toastWarningText), _defineProperty$A(_KIND$info$KIND$posit3, KIND.negative, theme.colors.toastNegativeText), _KIND$info$KIND$posit3)[kind];
}

function getPlacement(placement) {
  var _PLACEMENT$topLeft$PL;

  return (_PLACEMENT$topLeft$PL = {}, _defineProperty$A(_PLACEMENT$topLeft$PL, PLACEMENT$1.topLeft, {
    top: 0,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column'
  }), _defineProperty$A(_PLACEMENT$topLeft$PL, PLACEMENT$1.top, {
    top: 0,
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'column'
  }), _defineProperty$A(_PLACEMENT$topLeft$PL, PLACEMENT$1.topRight, {
    top: 0,
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    flexDirection: 'column'
  }), _defineProperty$A(_PLACEMENT$topLeft$PL, PLACEMENT$1.bottomRight, {
    bottom: 0,
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    flexDirection: 'column-reverse'
  }), _defineProperty$A(_PLACEMENT$topLeft$PL, PLACEMENT$1.bottom, {
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexDirection: 'column-reverse'
  }), _defineProperty$A(_PLACEMENT$topLeft$PL, PLACEMENT$1.bottomLeft, {
    bottom: 0,
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    flexDirection: 'column-reverse'
  }), _PLACEMENT$topLeft$PL)[placement];
}
var Root$3 = styled('div', function (_ref) {
  var $placement = _ref.$placement,
      $theme = _ref.$theme;
  return _objectSpread$q({
    pointerEvents: 'none',
    position: 'fixed',
    right: 0,
    left: 0,
    display: 'flex',
    marginTop: $theme.sizing.scale300,
    marginBottom: $theme.sizing.scale300,
    marginLeft: $theme.sizing.scale600,
    marginRight: $theme.sizing.scale600
  }, getPlacement($placement));
});
Root$3.displayName = "Root";
var InnerContainer = styled('div', // eslint-disable-next-line no-empty-pattern
function (_ref2) {
  _objectDestructuringEmpty(_ref2);

  return {};
});
InnerContainer.displayName = "InnerContainer";
var Body = styled('div', function (_ref3) {
  var $isVisible = _ref3.$isVisible,
      $kind = _ref3.$kind,
      $type = _ref3.$type,
      $theme = _ref3.$theme;
  var isInline = $type === TYPE.inline;
  return _objectSpread$q(_objectSpread$q({}, $theme.typography.font300), {}, {
    pointerEvents: 'auto',
    color: getFontColor($kind, $type, $theme),
    height: 'auto',
    width: '288px',
    paddingTop: $theme.sizing.scale600,
    paddingRight: $theme.sizing.scale600,
    paddingBottom: $theme.sizing.scale600,
    paddingLeft: $theme.sizing.scale600,
    marginTop: $theme.sizing.scale300,
    marginBottom: $theme.sizing.scale300,
    backgroundColor: getBackgroundColor($kind, $type, $theme) || $theme.colors.accent,
    borderTopLeftRadius: $theme.borders.radius400,
    borderTopRightRadius: $theme.borders.radius400,
    borderBottomRightRadius: $theme.borders.radius400,
    borderBottomLeftRadius: $theme.borders.radius400,
    boxShadow: isInline ? 'none' : $theme.lighting.shadow600,
    opacity: $isVisible ? 1 : 0,
    transitionProperty: 'all',
    transitionDuration: $theme.animation.timing200,
    transitionTimingFunction: $theme.animation.easeInOutCurve,
    display: 'flex',
    justifyContent: 'space-between'
  });
});
Body.displayName = "Body";
var CloseIconSvg = styled('svg', function (_ref4) {
  var $theme = _ref4.$theme,
      $size = _ref4.$size,
      $color = _ref4.$color,
      $isFocusVisible = _ref4.$isFocusVisible;
  return _objectSpread$q(_objectSpread$q({}, getSvgStyles$1({
    $theme: $theme,
    $size: $size,
    $color: $color
  })), {}, {
    cursor: 'pointer',
    width: $size || '16px',
    flexShrink: 0,
    outline: $isFocusVisible ? "3px solid ".concat($theme.colors.accent) : 'none'
  });
});
CloseIconSvg.displayName = "CloseIconSvg";

function _typeof$f(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$f = function _typeof(obj) { return typeof obj; }; } else { _typeof$f = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$f(obj); }

function _extends$n() { _extends$n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

function _slicedToArray$k(arr, i) { return _arrayWithHoles$k(arr) || _iterableToArrayLimit$k(arr, i) || _unsupportedIterableToArray$l(arr, i) || _nonIterableRest$k(); }

function _nonIterableRest$k() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$l(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$l(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$l(o, minLen); }

function _arrayLikeToArray$l(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$k(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$k(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$f(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$e(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$f(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$e(Constructor.prototype, protoProps); if (staticProps) _defineProperties$e(Constructor, staticProps); return Constructor; }

function _inherits$f(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$e(subClass, superClass); }

function _setPrototypeOf$e(o, p) { _setPrototypeOf$e = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$e(o, p); }

function _createSuper$e(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$e(); return function _createSuperInternal() { var Super = _getPrototypeOf$e(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$e(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$f(this, result); }; }

function _possibleConstructorReturn$f(self, call) { if (call && (_typeof$f(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$e(self); }

function _assertThisInitialized$e(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$e() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$e(o) { _getPrototypeOf$e = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$e(o); }

function _defineProperty$z(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Toast$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$f(Toast, _React$Component);

  var _super = _createSuper$e(Toast);

  function Toast(props) {
    var _this;

    _classCallCheck$f(this, Toast);

    _this = _super.call(this, props);

    _defineProperty$z(_assertThisInitialized$e(_this), "autoHideTimeout", void 0);

    _defineProperty$z(_assertThisInitialized$e(_this), "animateInTimer", void 0);

    _defineProperty$z(_assertThisInitialized$e(_this), "animateOutCompleteTimer", void 0);

    _defineProperty$z(_assertThisInitialized$e(_this), "closeRef", void 0);

    _defineProperty$z(_assertThisInitialized$e(_this), "previouslyFocusedElement", void 0);

    _defineProperty$z(_assertThisInitialized$e(_this), "state", {
      isVisible: false,
      isRendered: true,
      isFocusVisible: false
    });

    _defineProperty$z(_assertThisInitialized$e(_this), "handleFocus", function (event) {
      if (isFocusVisible(event)) {
        _this.setState({
          isFocusVisible: true
        });
      }
    });

    _defineProperty$z(_assertThisInitialized$e(_this), "handleBlur", function (event) {
      if (_this.state.isFocusVisible !== false) {
        _this.setState({
          isFocusVisible: false
        });
      }
    });

    _defineProperty$z(_assertThisInitialized$e(_this), "animateIn", function () {
      // Defer to next event loop
      _this.animateInTimer = setTimeout(function () {
        _this.setState({
          isVisible: true
        });
      }, 0);
    });

    _defineProperty$z(_assertThisInitialized$e(_this), "animateOut", function () {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

      _this.setState({
        isVisible: false
      }); // Remove the toast from the DOM after animation finishes


      _this.animateOutCompleteTimer = setTimeout(function () {
        _this.setState({
          isRendered: false
        });

        callback();
      }, 600);
    });

    _defineProperty$z(_assertThisInitialized$e(_this), "dismiss", function () {
      _this.animateOut(_this.props.onClose);

      if (_this.props.autoFocus && _this.previouslyFocusedElement) {
        _this.previouslyFocusedElement.focus();
      }
    });

    _defineProperty$z(_assertThisInitialized$e(_this), "onFocus", function (e) {
      if (!_this.state.isVisible) return;
      clearTimeout(_this.autoHideTimeout);
      clearTimeout(_this.animateOutCompleteTimer);
      typeof _this.props.onFocus === 'function' && _this.props.onFocus(e);
    });

    _defineProperty$z(_assertThisInitialized$e(_this), "onMouseEnter", function (e) {
      if (!_this.state.isVisible) return;
      clearTimeout(_this.autoHideTimeout);
      clearTimeout(_this.animateOutCompleteTimer);
      typeof _this.props.onMouseEnter === 'function' && _this.props.onMouseEnter(e);
    });

    _defineProperty$z(_assertThisInitialized$e(_this), "onBlur", function (e) {
      _this.startTimeout();

      typeof _this.props.onBlur === 'function' && _this.props.onBlur(e);
    });

    _defineProperty$z(_assertThisInitialized$e(_this), "onMouseLeave", function (e) {
      _this.startTimeout();

      typeof _this.props.onMouseLeave === 'function' && _this.props.onMouseLeave(e);
    });

    _this.closeRef = /*#__PURE__*/React$2.createRef();
    _this.previouslyFocusedElement = null;
    return _this;
  }

  _createClass$f(Toast, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.animateIn();
      this.startTimeout();

      if (typeof document !== 'undefined' && this.props.autoFocus && this.closeRef && this.closeRef.current && this.closeRef.current.focus && typeof this.closeRef.current.focus === 'function') {
        this.previouslyFocusedElement = document.activeElement; // $FlowFixMe: CloseIcon is `mixed` type so doesn't like `focus` call.

        this.closeRef.current.focus();
        this.setState({
          isFocusVisible: true
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.autoHideDuration !== prevProps.autoHideDuration || this.props.__updated !== prevProps.__updated) {
        this.startTimeout();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimeout();
    }
  }, {
    key: "startTimeout",
    value: function startTimeout() {
      if (this.props.autoHideDuration) {
        if (this.autoHideTimeout) {
          clearTimeout(this.autoHideTimeout);
        }

        this.autoHideTimeout = setTimeout(this.dismiss, this.props.autoHideDuration);
      }
    }
  }, {
    key: "clearTimeout",
    value: function (_clearTimeout) {
      function clearTimeout() {
        return _clearTimeout.apply(this, arguments);
      }

      clearTimeout.toString = function () {
        return _clearTimeout.toString();
      };

      return clearTimeout;
    }(function () {
      [this.autoHideTimeout, this.animateInTimer, this.animateOutCompleteTimer].forEach(function (timerId) {
        if (timerId) {
          clearTimeout(timerId);
        }
      });
    })
  }, {
    key: "getSharedProps",
    value: function getSharedProps() {
      var _this$props = this.props,
          kind = _this$props.kind,
          notificationType = _this$props.notificationType,
          closeable = _this$props.closeable;
      var _this$state = this.state,
          isRendered = _this$state.isRendered,
          isVisible = _this$state.isVisible;
      return {
        $kind: kind,
        $type: notificationType,
        $closeable: closeable,
        $isRendered: isRendered,
        $isVisible: isVisible
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          closeable = _this$props2.closeable;
      var isRendered = this.state.isRendered;
      var _this$props$overrides = this.props.overrides,
          BodyOverride = _this$props$overrides.Body,
          CloseIconOverride = _this$props$overrides.CloseIcon,
          InnerContainerOverride = _this$props$overrides.InnerContainer;

      var _getOverrides = getOverrides(BodyOverride, Body),
          _getOverrides2 = _slicedToArray$k(_getOverrides, 2),
          Body$1 = _getOverrides2[0],
          bodyProps = _getOverrides2[1];

      var _getOverrides3 = getOverrides(InnerContainerOverride, InnerContainer),
          _getOverrides4 = _slicedToArray$k(_getOverrides3, 2),
          InnerContainer$1 = _getOverrides4[0],
          innerContainerProps = _getOverrides4[1];

      var _getOverrides5 = getOverrides(CloseIconOverride, CloseIconSvg),
          _getOverrides6 = _slicedToArray$k(_getOverrides5, 2),
          CloseIcon = _getOverrides6[0],
          closeIconProps = _getOverrides6[1];

      var closeIconOverrides = mergeOverrides({
        Svg: {
          component: CloseIcon
        }
      }, // $FlowFixMe
      {
        Svg: CloseIconOverride
      });
      var sharedProps = this.getSharedProps();

      if (!isRendered) {
        return null;
      }

      return /*#__PURE__*/React$2.createElement(LocaleContext.Consumer, null, function (locale) {
        return /*#__PURE__*/React$2.createElement(Body$1, _extends$n({
          role: "alert",
          "data-baseweb": _this2.props['data-baseweb'] || 'toast'
        }, sharedProps, bodyProps, {
          // the properties below have to go after overrides
          onBlur: _this2.onBlur,
          onFocus: _this2.onFocus,
          onMouseEnter: _this2.onMouseEnter,
          onMouseLeave: _this2.onMouseLeave
        }), /*#__PURE__*/React$2.createElement(InnerContainer$1, _extends$n({}, sharedProps, innerContainerProps), typeof children === 'function' ? children({
          dismiss: _this2.dismiss
        }) : children), closeable ? /*#__PURE__*/React$2.createElement(DeleteIcon, _extends$n({
          ref: _this2.closeRef,
          role: "button",
          tabIndex: 0,
          $isFocusVisible: _this2.state.isFocusVisible,
          onClick: _this2.dismiss,
          onKeyPress: function onKeyPress(event) {
            if (event.key === 'Enter') {
              _this2.dismiss();
            }
          },
          title: locale.toast.close
        }, sharedProps, closeIconProps, {
          onFocus: forkFocus(closeIconProps, _this2.handleFocus),
          onBlur: forkBlur(closeIconProps, _this2.handleBlur),
          overrides: closeIconOverrides
        })) : null);
      });
    }
  }]);

  return Toast;
}(React$2.Component);

_defineProperty$z(Toast$1, "defaultProps", {
  autoFocus: false,
  autoHideDuration: 0,
  closeable: true,
  kind: KIND.info,
  notificationType: TYPE.toast,
  // Do we need a separate handler for
  // when a notification dismisses automatically
  onClose: function onClose() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  overrides: {}
});

var BaseToast = Toast$1;

function _typeof$e(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$e = function _typeof(obj) { return typeof obj; }; } else { _typeof$e = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$e(obj); }

function _slicedToArray$j(arr, i) { return _arrayWithHoles$j(arr) || _iterableToArrayLimit$j(arr, i) || _unsupportedIterableToArray$k(arr, i) || _nonIterableRest$j(); }

function _nonIterableRest$j() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit$j(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$j(arr) { if (Array.isArray(arr)) return arr; }

function _extends$m() { _extends$m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

function _objectWithoutProperties$d(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$c(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$c(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray$4(arr) { return _arrayWithoutHoles$3(arr) || _iterableToArray$3(arr) || _unsupportedIterableToArray$k(arr) || _nonIterableSpread$3(); }

function _nonIterableSpread$3() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$k(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$k(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$k(o, minLen); }

function _iterableToArray$3(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$3(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$k(arr); }

function _arrayLikeToArray$k(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys$p(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$p(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$p(Object(source), true).forEach(function (key) { _defineProperty$y(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$p(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck$e(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$d(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$e(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$d(Constructor.prototype, protoProps); if (staticProps) _defineProperties$d(Constructor, staticProps); return Constructor; }

function _inherits$e(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$d(subClass, superClass); }

function _setPrototypeOf$d(o, p) { _setPrototypeOf$d = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$d(o, p); }

function _createSuper$d(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$d(); return function _createSuperInternal() { var Super = _getPrototypeOf$d(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$d(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$e(this, result); }; }

function _possibleConstructorReturn$e(self, call) { if (call && (_typeof$e(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$d(self); }

function _assertThisInitialized$d(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$d() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$d(o) { _getPrototypeOf$d = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$d(o); }

function _defineProperty$y(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var toasterRef = null;
var ToasterContainer = /*#__PURE__*/function (_React$Component) {
  _inherits$e(ToasterContainer, _React$Component);

  var _super = _createSuper$d(ToasterContainer);

  function ToasterContainer(_props) {
    var _this;

    _classCallCheck$e(this, ToasterContainer);

    _this = _super.call(this, _props);

    _defineProperty$y(_assertThisInitialized$d(_this), "state", {
      isMounted: false,
      toasts: []
    });

    _defineProperty$y(_assertThisInitialized$d(_this), "dismissHandlers", {});

    _defineProperty$y(_assertThisInitialized$d(_this), "toastId", 0);

    _defineProperty$y(_assertThisInitialized$d(_this), "getToastProps", function (props) {
      var _this$props = _this.props,
          autoFocus = _this$props.autoFocus,
          autoHideDuration = _this$props.autoHideDuration,
          closeable = _this$props.closeable;
      var key = props.key || "toast-".concat(_this.toastId++);
      return _objectSpread$p(_objectSpread$p({
        autoFocus: autoFocus,
        autoHideDuration: autoHideDuration,
        closeable: closeable
      }, props), {}, {
        key: key
      });
    });

    _defineProperty$y(_assertThisInitialized$d(_this), "show", function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (_this.state.toasts.map(function (t) {
        return t.key;
      }).includes(props.key)) {
        _this.update(props.key, props);

        return props.key;
      }

      var toastProps = _this.getToastProps(props);

      _this.setState(function (_ref) {
        var toasts = _ref.toasts;
        return {
          toasts: [].concat(_toConsumableArray$4(toasts), [toastProps])
        };
      });

      return toastProps.key;
    });

    _defineProperty$y(_assertThisInitialized$d(_this), "update", function (key, props) {
      _this.setState(function (_ref2) {
        var toasts = _ref2.toasts;
        var updatedToasts = toasts.map(function (toast) {
          if (toast.key === key) {
            var updatedToastProps = _objectSpread$p(_objectSpread$p(_objectSpread$p({}, toast), _this.getToastProps(_objectSpread$p({
              autoHideDuration: toast.autoHideDuration
            }, props))), {}, {
              key: key
            }, _this.props.resetAutoHideTimerOnUpdate ? {
              __updated: (parseInt(toast.__updated) || 0) + 1
            } : {});

            return updatedToastProps;
          }

          return toast;
        });
        return {
          toasts: updatedToasts
        };
      });
    });

    _defineProperty$y(_assertThisInitialized$d(_this), "dismiss", function (key) {
      if (_this.dismissHandlers[key]) {
        _this.dismissHandlers[key]();
      }
    });

    _defineProperty$y(_assertThisInitialized$d(_this), "clearAll", function () {
      Object.keys(_this.dismissHandlers).forEach(function (key) {
        _this.dismissHandlers[key]();
      });
    });

    _defineProperty$y(_assertThisInitialized$d(_this), "clear", function (key) {
      key === undefined ? _this.clearAll() : _this.dismiss(key);
    });

    _defineProperty$y(_assertThisInitialized$d(_this), "internalOnClose", function (key) {
      delete _this.dismissHandlers[key];

      _this.setState(function (_ref3) {
        var toasts = _ref3.toasts;
        return {
          toasts: toasts.filter(function (t) {
            return !(t.key === key);
          })
        };
      });
    });

    _defineProperty$y(_assertThisInitialized$d(_this), "getOnCloseHandler", function (key, onClose) {
      return function () {
        _this.internalOnClose(key);

        typeof onClose === 'function' && onClose();
      };
    });

    _defineProperty$y(_assertThisInitialized$d(_this), "renderToast", function (toastProps) {
      var onClose = toastProps.onClose,
          children = toastProps.children,
          key = toastProps.key,
          restProps = _objectWithoutProperties$d(toastProps, ["onClose", "children", "key"]);

      var _this$props$overrides = _this.props.overrides,
          BodyOverride = _this$props$overrides.ToastBody,
          CloseIconOverride = _this$props$overrides.ToastCloseIcon,
          InnerContainerOverride = _this$props$overrides.ToastInnerContainer;
      var globalToastOverrides = mergeOverrides({
        Body: Body,
        CloseIcon: CloseIconSvg,
        InnerContainer: InnerContainer
      }, {
        Body: BodyOverride || {},
        CloseIcon: CloseIconOverride || {},
        InnerContainer: InnerContainerOverride || {}
      });
      var toastOverrides = mergeOverrides(globalToastOverrides, toastProps.overrides);
      return /*#__PURE__*/React$2.createElement(BaseToast, _extends$m({}, restProps, {
        overrides: toastOverrides,
        key: key,
        onClose: _this.getOnCloseHandler(key, onClose)
      }), function (_ref4) {
        var dismiss = _ref4.dismiss;
        _this.dismissHandlers[key] = dismiss; // $FlowFixMe

        return children;
      });
    });

    _defineProperty$y(_assertThisInitialized$d(_this), "getSharedProps", function () {
      var placement = _this.props.placement;
      return {
        $placement: placement
      };
    });

    toasterRef = _assertThisInitialized$d(_this);
    return _this;
  }

  _createClass$e(ToasterContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        isMounted: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var sharedProps = this.getSharedProps();
      var RootOverride = this.props.overrides.Root;

      var _getOverrides = getOverrides(RootOverride, Root$3),
          _getOverrides2 = _slicedToArray$j(_getOverrides, 2),
          Root = _getOverrides2[0],
          rootProps = _getOverrides2[1];

      var toastsLength = this.state.toasts.length;
      var toastsToRender = []; // render the toasts from the newest at the start
      // to the oldest at the end
      // eslint-disable-next-line for-direction

      for (var i = toastsLength - 1; i >= 0; i--) {
        toastsToRender.push(this.renderToast(this.state.toasts[i]));
      }

      var root = /*#__PURE__*/React$2.createElement(Root, _extends$m({
        "data-baseweb": "toaster"
      }, sharedProps, rootProps), toastsToRender); //Only render the portal in the browser, otherwise render the toasts and children

      if (this.state.isMounted) {
        return /*#__PURE__*/React$2.createElement(React$2.Fragment, null, this.props.usePortal && typeof document !== 'undefined' && document.body ? /*#__PURE__*/ReactDOM.createPortal(root, document.body) : root, this.props.children);
      } else {
        return /*#__PURE__*/React$2.createElement(React$2.Fragment, null, this.props.children);
      }
    }
  }]);

  return ToasterContainer;
}(React$2.Component);

_defineProperty$y(ToasterContainer, "defaultProps", {
  autoFocus: false,
  autoHideDuration: 0,
  children: null,
  closeable: true,
  overrides: {},
  placement: PLACEMENT$1.top,
  resetAutoHideTimerOnUpdate: true,
  usePortal: true
});

var toaster = {
  getRef: function getRef() {
    return toasterRef;
  },
  show: function show(children) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // toasts can not be added until Toaster is mounted
    // no SSR for the `toaster.show()`
    var toasterInstance = this.getRef();

    if (toasterInstance) {
      return toasterInstance.show(_objectSpread$p(_objectSpread$p({}, props), {}, {
        children: children
      }));
    } else if (process.env.NODE_ENV !== "production") {
      throw new Error('Please make sure to add the ToasterContainer to your application, and it is mounted, before adding toasts! You can find more information here: https://baseweb.design/components/toast');
    }
  },
  info: function info(children) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this.show(children, _objectSpread$p(_objectSpread$p({}, props), {}, {
      kind: KIND.info
    }));
  },
  positive: function positive(children) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this.show(children, _objectSpread$p(_objectSpread$p({}, props), {}, {
      kind: KIND.positive
    }));
  },
  warning: function warning(children) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this.show(children, _objectSpread$p(_objectSpread$p({}, props), {}, {
      kind: KIND.warning
    }));
  },
  negative: function negative(children) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this.show(children, _objectSpread$p(_objectSpread$p({}, props), {}, {
      kind: KIND.negative
    }));
  },
  update: function update(key, props) {
    var toasterInstance = this.getRef();

    if (toasterInstance) {
      toasterInstance.update(key, props);
    } else if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.error('No ToasterContainer is mounted yet.');
    }
  },
  clear: function clear(key) {
    var toasterInstance = this.getRef();

    if (toasterInstance) {
      toasterInstance.clear(key);
    } else if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.error('No ToasterContainer is mounted yet.');
    }
  }
};
var toaster$1 = toaster;

function _typeof$d(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$d = function _typeof(obj) { return typeof obj; }; } else { _typeof$d = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$d(obj); }

function _extends$l() { _extends$l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

function _classCallCheck$d(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$c(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$d(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$c(Constructor.prototype, protoProps); if (staticProps) _defineProperties$c(Constructor, staticProps); return Constructor; }

function _inherits$d(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$c(subClass, superClass); }

function _setPrototypeOf$c(o, p) { _setPrototypeOf$c = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$c(o, p); }

function _createSuper$c(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$c(); return function _createSuperInternal() { var Super = _getPrototypeOf$c(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$c(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$d(this, result); }; }

function _possibleConstructorReturn$d(self, call) { if (call && (_typeof$d(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$c(self); }

function _assertThisInitialized$c(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$c() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$c(o) { _getPrototypeOf$c = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$c(o); }

function _defineProperty$x(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Notification$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$d(Notification, _React$Component);

  var _super = _createSuper$c(Notification);

  function Notification() {
    _classCallCheck$d(this, Notification);

    return _super.apply(this, arguments);
  }

  _createClass$d(Notification, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React$2.createElement(BaseToast, _extends$l({
        "data-baseweb": "notification"
      }, this.props));
    }
  }]);

  return Notification;
}(React$2.Component);

_defineProperty$x(Notification$1, "defaultProps", {
  notificationType: TYPE.inline,
  closeable: false
});

const Notification = (props) => (React$2.createElement(Notification$1, { overrides: {
        Body: {
            style: {
                alignItems: 'center',
                marginBottom: '0px',
                marginTop: '0px',
                width: 'auto',
            },
        },
        CloseIcon: {
            style: {
                height: '32px',
                width: '32px',
            },
        },
    }, ...props }));

var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

function ownKeys$o(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$o(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$o(Object(source), true).forEach(function (key) { _defineProperty$w(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$o(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$w(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var StyledRoot$a = styled('div', function (_ref) {
  var $theme = _ref.$theme;
  return _objectSpread$o({
    display: 'flex',
    alignItems: 'center',
    color: $theme.colors.backgroundInversePrimary
  }, $theme.typography.font350);
});
StyledRoot$a.displayName = "StyledRoot";
var StyledMaxLabel = styled('span', function (_ref2) {
  var _ref3;

  var $theme = _ref2.$theme;
  var marginStartDir = $theme.direction === 'rtl' ? 'marginRight' : 'marginLeft';
  var marginEndDir = $theme.direction === 'rtl' ? 'marginLeft' : 'marginRight';
  return _ref3 = {}, _defineProperty$w(_ref3, marginStartDir, $theme.sizing.scale300), _defineProperty$w(_ref3, marginEndDir, $theme.sizing.scale600), _ref3;
});
StyledMaxLabel.displayName = "StyledMaxLabel";
var StyledDropdownContainer = styled('div', function (_ref4) {
  var _ref5;

  var $theme = _ref4.$theme,
      $isFocusVisible = _ref4.$isFocusVisible;
  var marginStartDir = $theme.direction === 'rtl' ? 'marginRight' : 'marginLeft';
  var marginEndDir = $theme.direction === 'rtl' ? 'marginLeft' : 'marginRight';
  return _ref5 = {
    position: 'relative',
    outline: $isFocusVisible ? "3px solid ".concat($theme.colors.accent) : 'none'
  }, _defineProperty$w(_ref5, marginStartDir, $theme.sizing.scale600), _defineProperty$w(_ref5, marginEndDir, $theme.sizing.scale300), _ref5;
});
StyledDropdownContainer.displayName = "StyledDropdownContainer";

function _typeof$c(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$c = function _typeof(obj) { return typeof obj; }; } else { _typeof$c = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$c(obj); }

function _extends$k() { _extends$k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

function ownKeys$n(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$n(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$n(Object(source), true).forEach(function (key) { _defineProperty$v(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$n(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray$i(arr, i) { return _arrayWithHoles$i(arr) || _iterableToArrayLimit$i(arr, i) || _unsupportedIterableToArray$j(arr, i) || _nonIterableRest$i(); }

function _nonIterableRest$i() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$j(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$j(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$j(o, minLen); }

function _arrayLikeToArray$j(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$i(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$i(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$c(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$b(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$c(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$b(Constructor.prototype, protoProps); if (staticProps) _defineProperties$b(Constructor, staticProps); return Constructor; }

function _inherits$c(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$b(subClass, superClass); }

function _setPrototypeOf$b(o, p) { _setPrototypeOf$b = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$b(o, p); }

function _createSuper$b(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$b(); return function _createSuperInternal() { var Super = _getPrototypeOf$b(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$b(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$c(this, result); }; }

function _possibleConstructorReturn$c(self, call) { if (call && (_typeof$c(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$b(self); }

function _assertThisInitialized$b(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$b() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$b(o) { _getPrototypeOf$b = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$b(o); }

function _defineProperty$v(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Pagination = /*#__PURE__*/function (_React$PureComponent) {
  _inherits$c(Pagination, _React$PureComponent);

  var _super = _createSuper$b(Pagination);

  function Pagination() {
    var _this;

    _classCallCheck$c(this, Pagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$v(_assertThisInitialized$b(_this), "state", {
      isFocusVisible: false
    });

    _defineProperty$v(_assertThisInitialized$b(_this), "handleFocus", function (event) {
      if (isFocusVisible(event)) {
        _this.setState({
          isFocusVisible: true
        });
      }
    });

    _defineProperty$v(_assertThisInitialized$b(_this), "handleBlur", function (event) {
      if (_this.state.isFocusVisible !== false) {
        _this.setState({
          isFocusVisible: false
        });
      }
    });

    _defineProperty$v(_assertThisInitialized$b(_this), "getMenuOptions", memoizeOne(function (numPages) {
      var menuOptions = [];

      for (var i = 1; i <= numPages; i++) {
        menuOptions.push({
          label: i
        });
      }

      return menuOptions;
    }));

    _defineProperty$v(_assertThisInitialized$b(_this), "onMenuItemSelect", function (data) {
      var item = data.value[0];
      var _this$props = _this.props,
          onPageChange = _this$props.onPageChange,
          currentPage = _this$props.currentPage;
      var page = item.label;

      if (page !== currentPage) {
        onPageChange && onPageChange({
          nextPage: page,
          prevPage: currentPage
        });
      }
    });

    _defineProperty$v(_assertThisInitialized$b(_this), "onPrevClick", function (event) {
      var _this$props2 = _this.props,
          currentPage = _this$props2.currentPage,
          onPageChange = _this$props2.onPageChange,
          onPrevClick = _this$props2.onPrevClick;

      if (currentPage > 1) {
        onPageChange && onPageChange({
          nextPage: currentPage - 1,
          prevPage: currentPage
        });
        onPrevClick && onPrevClick({
          event: event
        });
      }
    });

    _defineProperty$v(_assertThisInitialized$b(_this), "onNextClick", function (event) {
      var _this$props3 = _this.props,
          currentPage = _this$props3.currentPage,
          numPages = _this$props3.numPages,
          onPageChange = _this$props3.onPageChange,
          onNextClick = _this$props3.onNextClick;

      if (currentPage < numPages) {
        onPageChange && onPageChange({
          nextPage: currentPage + 1,
          prevPage: currentPage
        });
        onNextClick && onNextClick({
          event: event
        });
      }
    });

    _defineProperty$v(_assertThisInitialized$b(_this), "constructAriaWayfinderLabel", function (locale, prefix) {
      var _this$props4 = _this.props,
          currentPage = _this$props4.currentPage,
          numPages = _this$props4.numPages,
          labels = _this$props4.labels;
      return prefix + ' ' + currentPage + ' ' + "".concat(labels && labels.preposition ? labels.preposition : locale.pagination.preposition) + ' ' + numPages;
    });

    return _this;
  }

  _createClass$c(Pagination, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          _this$props5$override = _this$props5.overrides,
          overrides = _this$props5$override === void 0 ? {} : _this$props5$override,
          currentPage = _this$props5.currentPage,
          labels = _this$props5.labels,
          numPages = _this$props5.numPages,
          size = _this$props5.size;

      var _getOverrides = getOverrides(overrides.Root, StyledRoot$a),
          _getOverrides2 = _slicedToArray$i(_getOverrides, 2),
          Root = _getOverrides2[0],
          rootProps = _getOverrides2[1];

      var _getOverrides3 = getOverrides(overrides.MaxLabel, StyledMaxLabel),
          _getOverrides4 = _slicedToArray$i(_getOverrides3, 2),
          MaxLabel = _getOverrides4[0],
          maxLabelProps = _getOverrides4[1];

      var _getOverrides5 = getOverrides(overrides.DropdownContainer, StyledDropdownContainer),
          _getOverrides6 = _slicedToArray$i(_getOverrides5, 2),
          DropdownContainer = _getOverrides6[0],
          dropdownContainerProps = _getOverrides6[1];

      var _getOverrides7 = getOverrides(overrides.Select, Select$1),
          _getOverrides8 = _slicedToArray$i(_getOverrides7, 2),
          Select = _getOverrides8[0],
          selectProps = _getOverrides8[1];

      var options = this.getMenuOptions(numPages);
      return /*#__PURE__*/React$2.createElement(ThemeContext.Consumer, null, function (theme) {
        return /*#__PURE__*/React$2.createElement(LocaleContext.Consumer, null, function (locale) {
          return /*#__PURE__*/React$2.createElement(Root, _extends$k({
            "data-baseweb": "pagination"
          }, rootProps), /*#__PURE__*/React$2.createElement(Button$2, {
            "aria-label": _this2.constructAriaWayfinderLabel(locale, 'previous page. current page'),
            disabled: currentPage <= 1,
            onClick: _this2.onPrevClick,
            startEnhancer: function startEnhancer() {
              return theme.direction === 'rtl' ? /*#__PURE__*/React$2.createElement(ChevronRight$2, {
                title: '',
                size: 24
              }) : /*#__PURE__*/React$2.createElement(ChevronLeft$2, {
                title: '',
                size: 24
              });
            },
            kind: KIND$1.tertiary,
            overrides: {
              BaseButton: overrides.PrevButton
            },
            size: size
          }, labels && labels.prevButton ? labels.prevButton : locale.pagination.prev), /*#__PURE__*/React$2.createElement(DropdownContainer, _extends$k({
            $isFocusVisible: _this2.state.isFocusVisible
          }, dropdownContainerProps, {
            onFocus: forkFocus(dropdownContainerProps, _this2.handleFocus),
            onBlur: forkBlur(dropdownContainerProps, _this2.handleBlur)
          }), /*#__PURE__*/React$2.createElement(Select, _extends$k({
            "aria-label": _this2.constructAriaWayfinderLabel(locale, 'page'),
            options: options,
            labelKey: "label",
            valueKey: "label",
            onChange: _this2.onMenuItemSelect,
            searchable: false,
            clearable: false,
            value: [{
              label: currentPage
            }],
            maxDropdownHeight: "200px",
            size: size,
            overrides: {
              ControlContainer: {
                style: function style(_ref) {
                  var $theme = _ref.$theme,
                      $disabled = _ref.$disabled,
                      $isOpen = _ref.$isOpen,
                      $error = _ref.$error;
                  return {
                    borderLeftColor: 'transparent',
                    borderRightColor: 'transparent',
                    borderTopColor: 'transparent',
                    borderBottomColor: 'transparent',
                    boxShadow: 'none',
                    backgroundColor: $disabled ? $theme.colors.buttonDisabledFill : $isOpen ? $theme.colors.buttonTertiaryHover : $error ? $theme.colors.negative50 : $theme.colors.buttonTertiaryFill,
                    ':hover': {
                      backgroundColor: $theme.colors.buttonTertiaryHover
                    }
                  };
                }
              },
              InputContainer: {
                style: {
                  marginLeft: 0
                }
              },
              ValueContainer: {
                style: {
                  flexBasis: 'auto'
                }
              },
              SingleValue: {
                style: function style(_ref2) {
                  var $theme = _ref2.$theme;
                  return _objectSpread$n(_objectSpread$n({
                    position: 'relative',
                    paddingTop: '0',
                    paddingBottom: '0',
                    paddingLeft: $theme.sizing.scale200,
                    paddingRight: $theme.sizing.scale500,
                    color: $theme.colors.buttonTertiaryText
                  }, $theme.typography.font350), {}, {
                    lineHeight: 'unset'
                  });
                }
              },
              SelectArrow: {
                style: function style(_ref3) {
                  var $theme = _ref3.$theme;
                  return {
                    width: '24px',
                    height: '24px',
                    color: $theme.colors.buttonTertiaryText
                  };
                }
              }
            }
          }, selectProps))), /*#__PURE__*/React$2.createElement(MaxLabel, _extends$k({}, maxLabelProps, {
            "aria-hidden": true
          }), "".concat(labels && labels.preposition ? labels.preposition : locale.pagination.preposition || '', " ").concat(numPages)), /*#__PURE__*/React$2.createElement(Button$2, {
            "aria-label": _this2.constructAriaWayfinderLabel(locale, 'next page. current page'),
            disabled: currentPage >= numPages,
            onClick: _this2.onNextClick,
            endEnhancer: function endEnhancer() {
              return theme.direction === 'rtl' ? /*#__PURE__*/React$2.createElement(ChevronLeft$2, {
                title: '',
                size: 24
              }) : /*#__PURE__*/React$2.createElement(ChevronRight$2, {
                title: '',
                size: 24
              });
            },
            kind: KIND$1.tertiary,
            overrides: {
              BaseButton: overrides.NextButton
            },
            size: size
          }, labels && labels.nextButton ? labels.nextButton : locale.pagination.next));
        });
      });
    }
  }]);

  return Pagination;
}(React$2.PureComponent);

_defineProperty$v(Pagination, "defaultProps", {
  labels: {},
  overrides: {}
});

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var DEFAULT_MAX_DROPDOWN_WIDTH = '400px';
var DEFAULT_MAX_DROPDOWN_HEIGHT = '400px';
var STATE_CHANGE_TYPE = {
  textChange: 'textChange',
  countryChange: 'countryChange'
};

var COUNTRIES = {
  AF: {
    label: 'Afghanistan (‫افغانستان‬‎)',
    id: 'AF',
    dialCode: '+93'
  },
  AL: {
    label: 'Albania (Shqipëri)',
    id: 'AL',
    dialCode: '+355'
  },
  DZ: {
    label: 'Algeria (‫الجزائر‬‎)',
    id: 'DZ',
    dialCode: '+213'
  },
  AS: {
    label: 'American Samoa',
    id: 'AS',
    dialCode: '+1684'
  },
  AD: {
    label: 'Andorra',
    id: 'AD',
    dialCode: '+376'
  },
  AO: {
    label: 'Angola',
    id: 'AO',
    dialCode: '+244'
  },
  AI: {
    label: 'Anguilla',
    id: 'AI',
    dialCode: '+1264'
  },
  AG: {
    label: 'Antigua and Barbuda',
    id: 'AG',
    dialCode: '+1268'
  },
  AR: {
    label: 'Argentina',
    id: 'AR',
    dialCode: '+54'
  },
  AM: {
    label: 'Armenia (Հայաստան)',
    id: 'AM',
    dialCode: '+374'
  },
  AW: {
    label: 'Aruba',
    id: 'AW',
    dialCode: '+297'
  },
  AU: {
    label: 'Australia',
    id: 'AU',
    dialCode: '+61'
  },
  AT: {
    label: 'Austria (Österreich)',
    id: 'AT',
    dialCode: '+43'
  },
  AZ: {
    label: 'Azerbaijan (Azərbaycan)',
    id: 'AZ',
    dialCode: '+994'
  },
  BS: {
    label: 'Bahamas',
    id: 'BS',
    dialCode: '+1242'
  },
  BH: {
    label: 'Bahrain (‫البحرين‬‎)',
    id: 'BH',
    dialCode: '+973'
  },
  BD: {
    label: 'Bangladesh (বাংলাদেশ)',
    id: 'BD',
    dialCode: '+880'
  },
  BB: {
    label: 'Barbados',
    id: 'BB',
    dialCode: '+1246'
  },
  BY: {
    label: 'Belarus (Беларусь)',
    id: 'BY',
    dialCode: '+375'
  },
  BE: {
    label: 'Belgium (België)',
    id: 'BE',
    dialCode: '+32'
  },
  BZ: {
    label: 'Belize',
    id: 'BZ',
    dialCode: '+501'
  },
  BJ: {
    label: 'Benin (Bénin)',
    id: 'BJ',
    dialCode: '+229'
  },
  BM: {
    label: 'Bermuda',
    id: 'BM',
    dialCode: '+1441'
  },
  BT: {
    label: 'Bhutan (འབྲུག)',
    id: 'BT',
    dialCode: '+975'
  },
  BO: {
    label: 'Bolivia',
    id: 'BO',
    dialCode: '+591'
  },
  BA: {
    label: 'Bosnia and Herzegovina (Босна и Херцеговина)',
    id: 'BA',
    dialCode: '+387'
  },
  BW: {
    label: 'Botswana',
    id: 'BW',
    dialCode: '+267'
  },
  BR: {
    label: 'Brazil (Brasil)',
    id: 'BR',
    dialCode: '+55'
  },
  IO: {
    label: 'British Indian Ocean Territory',
    id: 'IO',
    dialCode: '+246'
  },
  VG: {
    label: 'British Virgin Islands',
    id: 'VG',
    dialCode: '+1284'
  },
  BN: {
    label: 'Brunei',
    id: 'BN',
    dialCode: '+673'
  },
  BG: {
    label: 'Bulgaria (България)',
    id: 'BG',
    dialCode: '+359'
  },
  BF: {
    label: 'Burkina Faso',
    id: 'BF',
    dialCode: '+226'
  },
  BI: {
    label: 'Burundi (Uburundi)',
    id: 'BI',
    dialCode: '+257'
  },
  KH: {
    label: 'Cambodia (កម្ពុជា)',
    id: 'KH',
    dialCode: '+855'
  },
  CM: {
    label: 'Cameroon (Cameroun)',
    id: 'CM',
    dialCode: '+237'
  },
  CA: {
    label: 'Canada',
    id: 'CA',
    dialCode: '+1'
  },
  CV: {
    label: 'Cape Verde (Kabu Verdi)',
    id: 'CV',
    dialCode: '+238'
  },
  KY: {
    label: 'Cayman Islands',
    id: 'KY',
    dialCode: '+1345'
  },
  CF: {
    label: 'Central African Republic (République centrafricaine)',
    id: 'CF',
    dialCode: '+236'
  },
  TD: {
    label: 'Chad (Tchad)',
    id: 'TD',
    dialCode: '+235'
  },
  CL: {
    label: 'Chile',
    id: 'CL',
    dialCode: '+56'
  },
  CN: {
    label: 'China (中国)',
    id: 'CN',
    dialCode: '+86'
  },
  CX: {
    label: 'Christmas Island',
    id: 'CX',
    dialCode: '+61'
  },
  CC: {
    label: 'Cocos (Keeling) Islands',
    id: 'CC',
    dialCode: '+61'
  },
  CO: {
    label: 'Colombia',
    id: 'CO',
    dialCode: '+57'
  },
  KM: {
    label: 'Comoros (‫جزر القمر‬‎)',
    id: 'KM',
    dialCode: '+269'
  },
  CD: {
    label: 'Congo (DRC) (Jamhuri ya Kisoemokrasia ya Kongo)',
    id: 'CD',
    dialCode: '+243'
  },
  CG: {
    label: 'Congo (Republic) (Congo-Brazzaville)',
    id: 'CG',
    dialCode: '+242'
  },
  CK: {
    label: 'Cook Islands',
    id: 'CK',
    dialCode: '+682'
  },
  CR: {
    label: 'Costa Rica',
    id: 'CR',
    dialCode: '+506'
  },
  CI: {
    label: 'Côte d’Ivoire',
    id: 'CI',
    dialCode: '+225'
  },
  HR: {
    label: 'Croatia (Hrvatska)',
    id: 'HR',
    dialCode: '+385'
  },
  CU: {
    label: 'Cuba',
    id: 'CU',
    dialCode: '+53'
  },
  CW: {
    label: 'Curaçao',
    id: 'CW',
    dialCode: '+599'
  },
  CY: {
    label: 'Cyprus (Κύπρος)',
    id: 'CY',
    dialCode: '+357'
  },
  CZ: {
    label: 'Czech Republic (Česká republika)',
    id: 'CZ',
    dialCode: '+420'
  },
  DK: {
    label: 'Denmark (Danmark)',
    id: 'DK',
    dialCode: '+45'
  },
  DJ: {
    label: 'Djibouti',
    id: 'DJ',
    dialCode: '+253'
  },
  DM: {
    label: 'Dominica',
    id: 'DM',
    dialCode: '+1767'
  },
  DO: {
    label: 'Dominican Republic (República Dominicana)',
    id: 'DO',
    dialCode: '+1'
  },
  EC: {
    label: 'Ecuador',
    id: 'EC',
    dialCode: '+593'
  },
  EG: {
    label: 'Egypt (‫مصر‬‎)',
    id: 'EG',
    dialCode: '+20'
  },
  SV: {
    label: 'El Salvador',
    id: 'SV',
    dialCode: '+503'
  },
  GQ: {
    label: 'Equatorial Guinea (Guinea Ecuatorial)',
    id: 'GQ',
    dialCode: '+240'
  },
  ER: {
    label: 'Eritrea',
    id: 'ER',
    dialCode: '+291'
  },
  EE: {
    label: 'Estonia (Eesti)',
    id: 'EE',
    dialCode: '+372'
  },
  ET: {
    label: 'Ethiopia',
    id: 'ET',
    dialCode: '+251'
  },
  FK: {
    label: 'Falkland Islands (Islas Malvinas)',
    id: 'FK',
    dialCode: '+500'
  },
  FO: {
    label: 'Faroe Islands (Føroyar)',
    id: 'FO',
    dialCode: '+298'
  },
  FJ: {
    label: 'Fiji',
    id: 'FJ',
    dialCode: '+679'
  },
  FI: {
    label: 'Finland (Suomi)',
    id: 'FI',
    dialCode: '+358'
  },
  FR: {
    label: 'France',
    id: 'FR',
    dialCode: '+33'
  },
  GF: {
    label: 'French Guiana (Guyane française)',
    id: 'GF',
    dialCode: '+594'
  },
  PF: {
    label: 'French Polynesia (Polynésie française)',
    id: 'PF',
    dialCode: '+689'
  },
  GA: {
    label: 'Gabon',
    id: 'GA',
    dialCode: '+241'
  },
  GM: {
    label: 'Gambia',
    id: 'GM',
    dialCode: '+220'
  },
  GE: {
    label: 'Georgia (საქართველო)',
    id: 'GE',
    dialCode: '+995'
  },
  DE: {
    label: 'Germany (Deutschland)',
    id: 'DE',
    dialCode: '+49'
  },
  GH: {
    label: 'Ghana (Gaana)',
    id: 'GH',
    dialCode: '+233'
  },
  GI: {
    label: 'Gibraltar',
    id: 'GI',
    dialCode: '+350'
  },
  GR: {
    label: 'Greece (Ελλάδα)',
    id: 'GR',
    dialCode: '+30'
  },
  GL: {
    label: 'Greenland (Kalaallit Nunaat)',
    id: 'GL',
    dialCode: '+299'
  },
  GD: {
    label: 'Grenada',
    id: 'GD',
    dialCode: '+1473'
  },
  GP: {
    label: 'Guadeloupe',
    id: 'GP',
    dialCode: '+590'
  },
  GU: {
    label: 'Guam',
    id: 'GU',
    dialCode: '+1671'
  },
  GT: {
    label: 'Guatemala',
    id: 'GT',
    dialCode: '+502'
  },
  GG: {
    label: 'Guernsey',
    id: 'GG',
    dialCode: '+44'
  },
  GN: {
    label: 'Guinea (Guinée)',
    id: 'GN',
    dialCode: '+224'
  },
  GW: {
    label: 'Guinea-Bissau (Guiné Bissau)',
    id: 'GW',
    dialCode: '+245'
  },
  GY: {
    label: 'Guyana',
    id: 'GY',
    dialCode: '+592'
  },
  HT: {
    label: 'Haiti',
    id: 'HT',
    dialCode: '+509'
  },
  HN: {
    label: 'Honduras',
    id: 'HN',
    dialCode: '+504'
  },
  HK: {
    label: 'Hong Kong (香港)',
    id: 'HK',
    dialCode: '+852'
  },
  HU: {
    label: 'Hungary (Magyarország)',
    id: 'HU',
    dialCode: '+36'
  },
  IS: {
    label: 'Iceland (Ísland)',
    id: 'IS',
    dialCode: '+354'
  },
  IN: {
    label: 'India (भारत)',
    id: 'IN',
    dialCode: '+91'
  },
  ID: {
    label: 'Indonesia',
    id: 'ID',
    dialCode: '+62'
  },
  IR: {
    label: 'Iran (‫ایران‬‎)',
    id: 'IR',
    dialCode: '+98'
  },
  IQ: {
    label: 'Iraq (‫العراق‬‎)',
    id: 'IQ',
    dialCode: '+964'
  },
  IE: {
    label: 'Ireland',
    id: 'IE',
    dialCode: '+353'
  },
  IM: {
    label: 'Isle of Man',
    id: 'IM',
    dialCode: '+44'
  },
  IL: {
    label: 'Israel (‫ישראל‬‎)',
    id: 'IL',
    dialCode: '+972'
  },
  IT: {
    label: 'Italy (Italia)',
    id: 'IT',
    dialCode: '+39'
  },
  JM: {
    label: 'Jamaica',
    id: 'JM',
    dialCode: '+1'
  },
  JP: {
    label: 'Japan (日本)',
    id: 'JP',
    dialCode: '+81'
  },
  JE: {
    label: 'Jersey',
    id: 'JE',
    dialCode: '+44'
  },
  JO: {
    label: 'Jordan (‫الأردن‬‎)',
    id: 'JO',
    dialCode: '+962'
  },
  KZ: {
    label: 'Kazakhstan (Казахстан)',
    id: 'KZ',
    dialCode: '+7'
  },
  KE: {
    label: 'Kenya',
    id: 'KE',
    dialCode: '+254'
  },
  KI: {
    label: 'Kiribati',
    id: 'KI',
    dialCode: '+686'
  },
  XK: {
    label: 'Kosovo',
    id: 'XK',
    dialCode: '+383'
  },
  KW: {
    label: 'Kuwait (‫الكويت‬‎)',
    id: 'KW',
    dialCode: '+965'
  },
  KG: {
    label: 'Kyrgyzstan (Кыргызстан)',
    id: 'KG',
    dialCode: '+996'
  },
  LA: {
    label: 'Laos (ລາວ)',
    id: 'LA',
    dialCode: '+856'
  },
  LV: {
    label: 'Latvia (Latvija)',
    id: 'LV',
    dialCode: '+371'
  },
  LB: {
    label: 'Lebanon (‫لبنان‬‎)',
    id: 'LB',
    dialCode: '+961'
  },
  LS: {
    label: 'Lesotho',
    id: 'LS',
    dialCode: '+266'
  },
  LR: {
    label: 'Liberia',
    id: 'LR',
    dialCode: '+231'
  },
  LY: {
    label: 'Libya (‫ليبيا‬‎)',
    id: 'LY',
    dialCode: '+218'
  },
  LI: {
    label: 'Liechtenstein',
    id: 'LI',
    dialCode: '+423'
  },
  LT: {
    label: 'Lithuania (Lietuva)',
    id: 'LT',
    dialCode: '+370'
  },
  LU: {
    label: 'Luxembourg',
    id: 'LU',
    dialCode: '+352'
  },
  MO: {
    label: 'Macau (澳門)',
    id: 'MO',
    dialCode: '+853'
  },
  MK: {
    label: 'North Macedonia (FYROM) (Македонија)',
    id: 'MK',
    dialCode: '+389'
  },
  MG: {
    label: 'Madagascar (Madagasikara)',
    id: 'MG',
    dialCode: '+261'
  },
  MW: {
    label: 'Malawi',
    id: 'MW',
    dialCode: '+265'
  },
  MY: {
    label: 'Malaysia',
    id: 'MY',
    dialCode: '+60'
  },
  MV: {
    label: 'Maldives',
    id: 'MV',
    dialCode: '+960'
  },
  ML: {
    label: 'Mali',
    id: 'ML',
    dialCode: '+223'
  },
  MT: {
    label: 'Malta',
    id: 'MT',
    dialCode: '+356'
  },
  MH: {
    label: 'Marshall Islands',
    id: 'MH',
    dialCode: '+692'
  },
  MQ: {
    label: 'Martinique',
    id: 'MQ',
    dialCode: '+596'
  },
  MR: {
    label: 'Mauritania (‫موريتانيا‬‎)',
    id: 'MR',
    dialCode: '+222'
  },
  MU: {
    label: 'Mauritius (Moris)',
    id: 'MU',
    dialCode: '+230'
  },
  YT: {
    label: 'Mayotte',
    id: 'YT',
    dialCode: '+262'
  },
  MX: {
    label: 'Mexico (México)',
    id: 'MX',
    dialCode: '+52'
  },
  FM: {
    label: 'Micronesia',
    id: 'FM',
    dialCode: '+691'
  },
  MD: {
    label: 'Moldova (Republica Moldova)',
    id: 'MD',
    dialCode: '+373'
  },
  MC: {
    label: 'Monaco',
    id: 'MC',
    dialCode: '+377'
  },
  MN: {
    label: 'Mongolia (Монгол)',
    id: 'MN',
    dialCode: '+976'
  },
  ME: {
    label: 'Montenegro (Crna Gora)',
    id: 'ME',
    dialCode: '+382'
  },
  MS: {
    label: 'Montserrat',
    id: 'MS',
    dialCode: '+1664'
  },
  MA: {
    label: 'Morocco (‫المغرب‬‎)',
    id: 'MA',
    dialCode: '+212'
  },
  MZ: {
    label: 'Mozambique (Moçambique)',
    id: 'MZ',
    dialCode: '+258'
  },
  MM: {
    label: 'Myanmar (Burma) (မြန်မာ)',
    id: 'MM',
    dialCode: '+95'
  },
  NA: {
    label: 'Namibia (Namibië)',
    id: 'NA',
    dialCode: '+264'
  },
  NR: {
    label: 'Nauru',
    id: 'NR',
    dialCode: '+674'
  },
  NP: {
    label: 'Nepal (नेपाल)',
    id: 'NP',
    dialCode: '+977'
  },
  NL: {
    label: 'Netherlands (Nederland)',
    id: 'NL',
    dialCode: '+31'
  },
  NC: {
    label: 'New Caledonia (Nouvelle-Calédonie)',
    id: 'NC',
    dialCode: '+687'
  },
  NZ: {
    label: 'New Zealand',
    id: 'NZ',
    dialCode: '+64'
  },
  NI: {
    label: 'Nicaragua',
    id: 'NI',
    dialCode: '+505'
  },
  NE: {
    label: 'Niger (Nijar)',
    id: 'NE',
    dialCode: '+227'
  },
  NG: {
    label: 'Nigeria',
    id: 'NG',
    dialCode: '+234'
  },
  NU: {
    label: 'Niue',
    id: 'NU',
    dialCode: '+683'
  },
  NF: {
    label: 'Norfolk Island',
    id: 'NF',
    dialCode: '+672'
  },
  KP: {
    label: 'North Korea (조선 민주주의 인민 공화국)',
    id: 'KP',
    dialCode: '+850'
  },
  MP: {
    label: 'Northern Mariana Islands',
    id: 'MP',
    dialCode: '+1670'
  },
  NO: {
    label: 'Norway (Norge)',
    id: 'NO',
    dialCode: '+47'
  },
  OM: {
    label: 'Oman (‫عُمان‬‎)',
    id: 'OM',
    dialCode: '+968'
  },
  PK: {
    label: 'Pakistan (‫پاکستان‬‎)',
    id: 'PK',
    dialCode: '+92'
  },
  PW: {
    label: 'Palau',
    id: 'PW',
    dialCode: '+680'
  },
  PS: {
    label: 'Palestine (‫فلسطين‬‎)',
    id: 'PS',
    dialCode: '+970'
  },
  PA: {
    label: 'Panama (Panamá)',
    id: 'PA',
    dialCode: '+507'
  },
  PG: {
    label: 'Papua New Guinea',
    id: 'PG',
    dialCode: '+675'
  },
  PY: {
    label: 'Paraguay',
    id: 'PY',
    dialCode: '+595'
  },
  PE: {
    label: 'Peru (Perú)',
    id: 'PE',
    dialCode: '+51'
  },
  PH: {
    label: 'Philippines',
    id: 'PH',
    dialCode: '+63'
  },
  PL: {
    label: 'Poland (Polska)',
    id: 'PL',
    dialCode: '+48'
  },
  PT: {
    label: 'Portugal',
    id: 'PT',
    dialCode: '+351'
  },
  PR: {
    label: 'Puerto Rico',
    id: 'PR',
    dialCode: '+1'
  },
  QA: {
    label: 'Qatar (‫قطر‬‎)',
    id: 'QA',
    dialCode: '+974'
  },
  RE: {
    label: 'Réunion (La Réunion)',
    id: 'RE',
    dialCode: '+262'
  },
  RO: {
    label: 'Romania (România)',
    id: 'RO',
    dialCode: '+40'
  },
  RU: {
    label: 'Russia (Россия)',
    id: 'RU',
    dialCode: '+7'
  },
  RW: {
    label: 'Rwanda',
    id: 'RW',
    dialCode: '+250'
  },
  BL: {
    label: 'Saint Barthélemy',
    id: 'BL',
    dialCode: '+590'
  },
  SH: {
    label: 'Saint Helena',
    id: 'SH',
    dialCode: '+290'
  },
  KN: {
    label: 'Saint Kitts and Nevis',
    id: 'KN',
    dialCode: '+1869'
  },
  LC: {
    label: 'Saint Lucia',
    id: 'LC',
    dialCode: '+1758'
  },
  MF: {
    label: 'Saint Martin (Saint-Martin (partie française))',
    id: 'MF',
    dialCode: '+590'
  },
  PM: {
    label: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
    id: 'PM',
    dialCode: '+508'
  },
  VC: {
    label: 'Saint Vincent and the Grenadines',
    id: 'VC',
    dialCode: '+1784'
  },
  WS: {
    label: 'Samoa',
    id: 'WS',
    dialCode: '+685'
  },
  SM: {
    label: 'San Marino',
    id: 'SM',
    dialCode: '+378'
  },
  ST: {
    label: 'São Tomé and Príncipe (São Tomé e Príncipe)',
    id: 'ST',
    dialCode: '+239'
  },
  SA: {
    label: 'Saudi Arabia (‫المملكة العربية السعودية‬‎)',
    id: 'SA',
    dialCode: '+966'
  },
  SN: {
    label: 'Senegal (Sénégal)',
    id: 'SN',
    dialCode: '+221'
  },
  RS: {
    label: 'Serbia (Србија)',
    id: 'RS',
    dialCode: '+381'
  },
  SC: {
    label: 'Seychelles',
    id: 'SC',
    dialCode: '+248'
  },
  SL: {
    label: 'Sierra Leone',
    id: 'SL',
    dialCode: '+232'
  },
  SG: {
    label: 'Singapore',
    id: 'SG',
    dialCode: '+65'
  },
  SX: {
    label: 'Sint Maarten',
    id: 'SX',
    dialCode: '+1721'
  },
  SK: {
    label: 'Slovakia (Slovensko)',
    id: 'SK',
    dialCode: '+421'
  },
  SI: {
    label: 'Slovenia (Slovenija)',
    id: 'SI',
    dialCode: '+386'
  },
  SB: {
    label: 'Solomon Islands',
    id: 'SB',
    dialCode: '+677'
  },
  SO: {
    label: 'Somalia (Soomaaliya)',
    id: 'SO',
    dialCode: '+252'
  },
  ZA: {
    label: 'South Africa',
    id: 'ZA',
    dialCode: '+27'
  },
  KR: {
    label: 'South Korea (대한민국)',
    id: 'KR',
    dialCode: '+82'
  },
  SS: {
    label: 'South Sudan (‫جنوب السودان‬‎)',
    id: 'SS',
    dialCode: '+211'
  },
  ES: {
    label: 'Spain (España)',
    id: 'ES',
    dialCode: '+34'
  },
  LK: {
    label: 'Sri Lanka (ශ්‍රී ලංකාව)',
    id: 'LK',
    dialCode: '+94'
  },
  SD: {
    label: 'Sudan (‫السودان‬‎)',
    id: 'SD',
    dialCode: '+249'
  },
  SR: {
    label: 'Suriname',
    id: 'SR',
    dialCode: '+597'
  },
  SJ: {
    label: 'Svalbard and Jan Mayen',
    id: 'SJ',
    dialCode: '+47'
  },
  SZ: {
    label: 'Swaziland',
    id: 'SZ',
    dialCode: '+268'
  },
  SE: {
    label: 'Sweden (Sverige)',
    id: 'SE',
    dialCode: '+46'
  },
  CH: {
    label: 'Switzerland (Schweiz)',
    id: 'CH',
    dialCode: '+41'
  },
  SY: {
    label: 'Syria (‫سوريا‬‎)',
    id: 'SY',
    dialCode: '+963'
  },
  TW: {
    label: 'Taiwan (台灣)',
    id: 'TW',
    dialCode: '+886'
  },
  TJ: {
    label: 'Tajikistan',
    id: 'TJ',
    dialCode: '+992'
  },
  TZ: {
    label: 'Tanzania',
    id: 'TZ',
    dialCode: '+255'
  },
  TH: {
    label: 'Thailand (ไทย)',
    id: 'TH',
    dialCode: '+66'
  },
  TL: {
    label: 'Timor-Leste',
    id: 'TL',
    dialCode: '+670'
  },
  TG: {
    label: 'Togo',
    id: 'TG',
    dialCode: '+228'
  },
  TK: {
    label: 'Tokelau',
    id: 'TK',
    dialCode: '+690'
  },
  TO: {
    label: 'Tonga',
    id: 'TO',
    dialCode: '+676'
  },
  TT: {
    label: 'Trinisoad and Tobago',
    id: 'TT',
    dialCode: '+1868'
  },
  TN: {
    label: 'Tunisia (‫تونس‬‎)',
    id: 'TN',
    dialCode: '+216'
  },
  TR: {
    label: 'Turkey (Türkiye)',
    id: 'TR',
    dialCode: '+90'
  },
  TM: {
    label: 'Turkmenistan',
    id: 'TM',
    dialCode: '+993'
  },
  TC: {
    label: 'Turks and Caicos Islands',
    id: 'TC',
    dialCode: '+1649'
  },
  TV: {
    label: 'Tuvalu',
    id: 'TV',
    dialCode: '+688'
  },
  VI: {
    label: 'U.S. Virgin Islands',
    id: 'VI',
    dialCode: '+1340'
  },
  UG: {
    label: 'Uganda',
    id: 'UG',
    dialCode: '+256'
  },
  UA: {
    label: 'Ukraine (Україна)',
    id: 'UA',
    dialCode: '+380'
  },
  AE: {
    label: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)',
    id: 'AE',
    dialCode: '+971'
  },
  GB: {
    label: 'United Kingdom',
    id: 'GB',
    dialCode: '+44'
  },
  US: {
    label: 'United States',
    id: 'US',
    dialCode: '+1'
  },
  UY: {
    label: 'Uruguay',
    id: 'UY',
    dialCode: '+598'
  },
  UZ: {
    label: 'Uzbekistan (Oʻzbekiston)',
    id: 'UZ',
    dialCode: '+998'
  },
  VU: {
    label: 'Vanuatu',
    id: 'VU',
    dialCode: '+678'
  },
  VA: {
    label: 'Vatican City (Città del Vaticano)',
    id: 'VA',
    dialCode: '+39'
  },
  VE: {
    label: 'Venezuela',
    id: 'VE',
    dialCode: '+58'
  },
  VN: {
    label: 'Vietnam (Việt Nam)',
    id: 'VN',
    dialCode: '+84'
  },
  WF: {
    label: 'Wallis and Futuna (Wallis-et-Futuna)',
    id: 'WF',
    dialCode: '+681'
  },
  YE: {
    label: 'Yemen (‫اليمن‬‎)',
    id: 'YE',
    dialCode: '+967'
  },
  ZM: {
    label: 'Zambia',
    id: 'ZM',
    dialCode: '+260'
  },
  ZW: {
    label: 'Zimbabwe',
    id: 'ZW',
    dialCode: '+263'
  },
  AX: {
    label: 'Åland Islands',
    id: 'AX',
    dialCode: '+358'
  }
};

function _objectWithoutProperties$c(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$b(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$b(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty$u(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// The root element of the PhoneInputNext
var StyledPhoneInputRoot = styled('div', {
  display: 'flex'
});
StyledPhoneInputRoot.displayName = "StyledPhoneInputRoot";
var StyledFlagContainer = styled('span', function (_ref) {
  var _sizeToFont;

  var _ref$$size = _ref.$size,
      $size = _ref$$size === void 0 ? SIZE$2.default : _ref$$size,
      sizing = _ref.$theme.sizing;
  var sizeToFont = (_sizeToFont = {}, _defineProperty$u(_sizeToFont, SIZE$2.mini, sizing.scale700), _defineProperty$u(_sizeToFont, SIZE$2.compact, sizing.scale800), _defineProperty$u(_sizeToFont, SIZE$2.default, sizing.scale900), _defineProperty$u(_sizeToFont, SIZE$2.large, sizing.scale1000), _sizeToFont);
  return {
    fontSize: sizeToFont[$size]
  };
}); // An override component for the Select's Root styled element

StyledFlagContainer.displayName = "StyledFlagContainer";
var StyledRoot$9 = withStyle(StyledRoot$f, function (props) {
  var _sizeToWidth;

  // hard coded widths for the flag dropdown anchor
  var sizeToWidth = (_sizeToWidth = {}, _defineProperty$u(_sizeToWidth, SIZE$2.mini, '50px'), _defineProperty$u(_sizeToWidth, SIZE$2.compact, '60px'), _defineProperty$u(_sizeToWidth, SIZE$2.default, '70px'), _defineProperty$u(_sizeToWidth, SIZE$2.large, '80px'), _sizeToWidth);
  return {
    width: sizeToWidth[props.$size || SIZE$2.default],
    display: 'inline-block'
  };
});
StyledRoot$9.displayName = "StyledRoot";
var StyledDialCode = styled('div', function (_ref2) {
  var _ref3;

  var _ref2$$theme = _ref2.$theme,
      direction = _ref2$$theme.direction,
      sizing = _ref2$$theme.sizing;
  var marginDir = direction === 'rtl' ? 'marginRight' : 'marginLeft';
  return _ref3 = {}, _defineProperty$u(_ref3, marginDir, sizing.scale100), _defineProperty$u(_ref3, "display", 'flex'), _defineProperty$u(_ref3, "alignItems", 'center'), _ref3;
});
StyledDialCode.displayName = "StyledDialCode";
var StyledCountrySelectContainer = styled('div', {
  display: 'flex',
  alignItems: 'center'
});
StyledCountrySelectContainer.displayName = "StyledCountrySelectContainer";
var StyledCountrySelectDropdownContainer = withStyle(StyledList$1, function (props) {
  var _props$$height = props.$height,
      $height = _props$$height === void 0 ? defaultProps$4.maxDropdownHeight : _props$$height;
  return {
    height: $height,
    paddingTop: 0,
    paddingBottom: 0
  };
});
StyledCountrySelectDropdownContainer.displayName = "StyledCountrySelectDropdownContainer";
var StyledCountrySelectDropdownListItemElement = withStyle(StyledDropdownListItem$1, {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  display: 'flex',
  alignItems: 'center',
  height: '42px'
});
StyledCountrySelectDropdownListItemElement.displayName = "StyledCountrySelectDropdownListItemElement";
var StyledCountrySelectDropdownListItem = withWrapper(StyledCountrySelectDropdownListItemElement, function (Styled) {
  return function StyledCountrySelectDropdownListItem(_ref4) {
    _ref4.item;
        var restProps = _objectWithoutProperties$c(_ref4, ["item"]);

    return /*#__PURE__*/React$2.createElement(Styled, restProps);
  };
});
var StyledCountrySelectDropdownFlagColumn = styled('div', function (_ref5) {
  var _ref6;

  var _ref5$$theme = _ref5.$theme,
      direction = _ref5$$theme.direction,
      sizing = _ref5$$theme.sizing;
  var paddingDir = direction === 'rtl' ? 'paddingRight' : 'paddingLeft';
  return _ref6 = {}, _defineProperty$u(_ref6, paddingDir, sizing.scale600), _defineProperty$u(_ref6, "display", 'flex'), _defineProperty$u(_ref6, "alignItems", 'center'), _ref6;
});
StyledCountrySelectDropdownFlagColumn.displayName = "StyledCountrySelectDropdownFlagColumn";
var StyledCountrySelectDropdownNameColumn = styled('div', function (_ref7) {
  var _ref7$$theme = _ref7.$theme,
      direction = _ref7$$theme.direction,
      sizing = _ref7$$theme.sizing;
  var paddingDir = direction === 'rtl' ? 'paddingRight' : 'paddingLeft';
  return _defineProperty$u({}, paddingDir, sizing.scale600);
});
StyledCountrySelectDropdownNameColumn.displayName = "StyledCountrySelectDropdownNameColumn";
var StyledCountrySelectDropdownDialcodeColumn = styled('div', function (_ref9) {
  var _ref10;

  var _ref9$$theme = _ref9.$theme,
      direction = _ref9$$theme.direction,
      sizing = _ref9$$theme.sizing;
  var paddingDir = direction === 'rtl' ? 'paddingLeft' : 'paddingRight';
  var marginDir = direction === 'rtl' ? 'marginRight' : 'marginLeft';
  return _ref10 = {}, _defineProperty$u(_ref10, paddingDir, sizing.scale600), _defineProperty$u(_ref10, marginDir, 'auto'), _ref10;
});
StyledCountrySelectDropdownDialcodeColumn.displayName = "StyledCountrySelectDropdownDialcodeColumn";

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var defaultProps = {
  'aria-label': 'Please enter a phone number without the country dial code.',
  'aria-describedby': null,
  'aria-labelledby': null,
  clearable: false,
  focusLock: false,
  country: {
    label: 'United States',
    id: 'US',
    dialCode: '+1'
  },
  disabled: false,
  error: false,
  id: null,
  maxDropdownHeight: DEFAULT_MAX_DROPDOWN_HEIGHT,
  maxDropdownWidth: DEFAULT_MAX_DROPDOWN_WIDTH,
  name: null,
  onCountryChange: function onCountryChange() {},
  onTextChange: function onTextChange() {},
  overrides: {},
  positive: false,
  required: false,
  size: SIZE$2.default,
  text: ''
};
var defaultProps$1 = defaultProps;

function _toConsumableArray$3(arr) { return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _unsupportedIterableToArray$i(arr) || _nonIterableSpread$2(); }

function _nonIterableSpread$2() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$i(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$i(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$i(o, minLen); }

function _iterableToArray$2(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$2(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$i(arr); }

function _arrayLikeToArray$i(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof$b(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$b = function _typeof(obj) { return typeof obj; }; } else { _typeof$b = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$b(obj); }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// country code regex
var ISO_REGEX = /^[a-z]{2}$/i; // offset between uppercase ascii and regional indicator symbols

var OFFSET = 127397; // convert country code to corresponding emoji flag

function iso2FlagEmoji(iso) {
  if (!ISO_REGEX.test(iso)) {
    var type = _typeof$b(iso);

    if (process.env.NODE_ENV !== "production") {
      console.warn("iso argument must be an ISO 3166-1 alpha-2 string, but got '".concat(type === 'string' ? iso : type, "' instead."));
    }

    return;
  }

  var chars = Array.from(iso.toUpperCase()).map(function (char) {
    return char.charCodeAt(0) + OFFSET;
  });
  return String.fromCodePoint.apply(String, _toConsumableArray$3(chars));
}

function ownKeys$m(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$m(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$m(Object(source), true).forEach(function (key) { _defineProperty$t(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$m(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$t(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$h(arr, i) { return _arrayWithHoles$h(arr) || _iterableToArrayLimit$h(arr, i) || _unsupportedIterableToArray$h(arr, i) || _nonIterableRest$h(); }

function _nonIterableRest$h() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$h(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$h(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$h(o, minLen); }

function _arrayLikeToArray$h(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$h(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$h(arr) { if (Array.isArray(arr)) return arr; }

function _extends$j() { _extends$j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

function _objectWithoutProperties$b(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$a(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$a(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
CountryPicker$1.defaultProps = {
  disabled: defaultProps$1.disabled,
  inputRef: {
    current: null
  },
  maxDropdownHeight: defaultProps$1.maxDropdownHeight,
  maxDropdownWidth: defaultProps$1.maxDropdownWidth,
  overrides: {},
  size: defaultProps$1.size,
  error: defaultProps$1.error,
  positive: defaultProps$1.positive,
  required: defaultProps$1.required
};
var DropdownListItem = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  props.children;
      var rest = _objectWithoutProperties$b(props, ["children"]);

  return /*#__PURE__*/React__default.createElement(StyledCountrySelectDropdownListItem, _extends$j({
    ref: ref
  }, rest), props.children);
});
DropdownListItem.displayName = 'DropdownListItem';

function DropdownOptionContent(props) {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, props.children);
}

function CountryPicker$1(props) {
  var country = props.country,
      disabled = props.disabled,
      error = props.error,
      inputRef = props.inputRef,
      maxDropdownHeight = props.maxDropdownHeight,
      maxDropdownWidth = props.maxDropdownWidth,
      mapIsoToLabel = props.mapIsoToLabel,
      onCountryChange = props.onCountryChange,
      overrides = props.overrides,
      positive = props.positive,
      required = props.required,
      size = props.size;

  var _useState = useState(false),
      _useState2 = _slicedToArray$h(_useState, 2),
      resetScrollIndex = _useState2[0],
      setResetScrollIndex = _useState2[1];

  var sharedProps = {
    $disabled: disabled,
    $error: error,
    $positive: positive,
    $required: required,
    $size: size
  };
  var options = Object.values(props.countries); // $FlowFixMe

  var scrollIndex = options.findIndex(function (opt) {
    return opt.id === country.id;
  });
  var baseSelectOverrides = {
    Root: {
      component: StyledRoot$9
    },
    Input: {
      style: {
        width: 0
      },
      props: {
        // https://github.com/uber/baseweb/issues/3846
        autoComplete: 'chrome-off',
        'aria-label': 'Select country'
      }
    },
    IconsContainer: {
      style: {
        paddingRight: '0'
      }
    },
    SingleValue: {
      style: {
        display: 'flex',
        alignItems: 'center'
      }
    },
    StatefulMenu: {
      props: {
        stateReducer: function stateReducer(type, nextState) {
          var next = _objectSpread$m(_objectSpread$m({}, nextState), {}, {
            highlightedIndex: resetScrollIndex ? 0 : nextState.highlightedIndex
          });

          setResetScrollIndex(false);
          return next;
        },
        initialState: {
          isFocused: true,
          highlightedIndex: scrollIndex
        }
      }
    },
    DropdownContainer: {
      style: {
        width: maxDropdownWidth,
        maxWidth: 'calc(100vw - 10px)'
      }
    },
    Dropdown: {
      props: {
        $country: country,
        $maxDropdownHeight: maxDropdownHeight,
        $mapIsoToLabel: mapIsoToLabel,
        $overrides: {
          CountrySelectDropdown: overrides.CountrySelectDropdown,
          CountrySelectDropdownListItem: overrides.CountrySelectDropdownListItem,
          CountrySelectDropdownFlagColumn: overrides.CountrySelectDropdownFlagColumn,
          CountrySelectDropdownNameColumn: overrides.CountrySelectDropdownNameColumn,
          CountrySelectDropdownDialcodeColumn: overrides.CountrySelectDropdownDialcodeColumn,
          FlagContainer: overrides.FlagContainer
        }
      }
    },
    DropdownListItem: {
      component: DropdownListItem
    },
    OptionContent: {
      component: DropdownOptionContent
    },
    Popover: {
      props: {
        focusLock: false,
        placement: PLACEMENT$2.bottomLeft
      }
    }
  };

  var _getOverrides = getOverrides(overrides.CountrySelect, MultiSelect),
      _getOverrides2 = _slicedToArray$h(_getOverrides, 2),
      Select = _getOverrides2[0],
      selectProps = _getOverrides2[1];

  var selectOverrides = mergeOverrides(baseSelectOverrides, {
    Dropdown: overrides.CountrySelectDropdown || {},
    DropdownListItem: overrides.CountrySelectDropdownListItem || {}
  });
  selectProps.overrides = mergeOverrides(selectOverrides, selectProps.overrides);

  var _getOverrides3 = getOverrides(overrides.CountrySelectDropdownFlagColumn, StyledCountrySelectDropdownFlagColumn),
      _getOverrides4 = _slicedToArray$h(_getOverrides3, 2),
      FlagColumn = _getOverrides4[0],
      flagColumnProps = _getOverrides4[1];

  var _getOverrides5 = getOverrides(overrides.FlagContainer, StyledFlagContainer),
      _getOverrides6 = _slicedToArray$h(_getOverrides5, 2),
      FlagContainer = _getOverrides6[0],
      flagContainerProps = _getOverrides6[1];

  var _getOverrides7 = getOverrides(overrides.CountrySelectDropdownNameColumn, StyledCountrySelectDropdownNameColumn),
      _getOverrides8 = _slicedToArray$h(_getOverrides7, 2),
      NameColumn = _getOverrides8[0],
      nameColumnProps = _getOverrides8[1];

  var _getOverrides9 = getOverrides(overrides.CountrySelectDropdownDialcodeColumn, StyledCountrySelectDropdownDialcodeColumn),
      _getOverrides10 = _slicedToArray$h(_getOverrides9, 2),
      Dialcode = _getOverrides10[0],
      dialcodeProps = _getOverrides10[1];

  return /*#__PURE__*/React__default.createElement(Select, _extends$j({
    clearable: false,
    disabled: disabled,
    getOptionLabel: function getOptionLabel(_ref) {
      var option = _ref.option;
          _ref.optionState;
      var iso = option.id;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FlagColumn, flagColumnProps, /*#__PURE__*/React__default.createElement(FlagContainer, _extends$j({
        $iso: iso,
        "data-iso": iso
      }, flagContainerProps), iso2FlagEmoji(iso))), /*#__PURE__*/React__default.createElement(NameColumn, nameColumnProps, mapIsoToLabel ? mapIsoToLabel(iso) : option.label), /*#__PURE__*/React__default.createElement(Dialcode, dialcodeProps, option.dialCode));
    },
    getValueLabel: function getValueLabel(value) {
      var iso = value.option.id;
      return /*#__PURE__*/React__default.createElement(FlagContainer, _extends$j({
        $iso: iso,
        "data-iso": iso
      }, sharedProps, flagContainerProps), iso2FlagEmoji(iso));
    },
    error: error,
    maxDropdownHeight: maxDropdownHeight,
    onChange: function onChange(event) {
      if (typeof onCountryChange === 'function') {
        onCountryChange(event);
      } else if (process.env.NODE_ENV !== "production") {
        console.warn('CountryPicker component is controlled (or stateless) ' + 'and requires an `onCountryChange` handler to be passed in ' + 'that handles the `country` prop value update.');
      } // After choosing a country, shift focus to the text input


      if (inputRef && inputRef.current) {
        inputRef.current.focus();
      }
    },
    options: options,
    positive: positive,
    required: required,
    size: size,
    value: [country],
    onInputChange: function onInputChange() {
      setResetScrollIndex(true);
    }
  }, selectProps));
}

function _extends$i() { _extends$i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

function _slicedToArray$g(arr, i) { return _arrayWithHoles$g(arr) || _iterableToArrayLimit$g(arr, i) || _unsupportedIterableToArray$g(arr, i) || _nonIterableRest$g(); }

function _nonIterableRest$g() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$g(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$g(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$g(o, minLen); }

function _arrayLikeToArray$g(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$g(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$g(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys$l(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$l(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$l(Object(source), true).forEach(function (key) { _defineProperty$s(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$l(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties$a(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$9(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$9(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty$s(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
CountryPicker.defaultProps = {
  disabled: defaultProps$1.disabled,
  inputRef: {
    current: null
  },
  maxDropdownHeight: defaultProps$1.maxDropdownHeight,
  maxDropdownWidth: defaultProps$1.maxDropdownWidth,
  overrides: {},
  size: defaultProps$1.size,
  error: defaultProps$1.error,
  positive: defaultProps$1.positive,
  required: defaultProps$1.required
};
function CountryPicker(props) {
  var overrides = props.overrides;
  var baseSelectOverrides = {
    Root: {
      style: function style(_ref) {
        var _ref2;

        var _ref$$theme = _ref.$theme,
            direction = _ref$$theme.direction,
            sizing = _ref$$theme.sizing;
        var marginDir = direction === 'rtl' ? 'marginLeft' : 'marginRight';
        return _ref2 = {}, _defineProperty$s(_ref2, marginDir, sizing.scale300), _defineProperty$s(_ref2, "width", 'auto'), _ref2;
      }
    },
    ControlContainer: {
      style: function style(_ref3) {
        var _sizeToLeftPadding, _sizeToRightPadding, _styleOverride;

        var _ref3$$theme = _ref3.$theme,
            direction = _ref3$$theme.direction,
            sizing = _ref3$$theme.sizing,
            props = _objectWithoutProperties$a(_ref3, ["$theme"]);

        var sizeToLeftPadding = (_sizeToLeftPadding = {}, _defineProperty$s(_sizeToLeftPadding, SIZE$2.mini, '0'), _defineProperty$s(_sizeToLeftPadding, SIZE$2.compact, sizing.scale0), _defineProperty$s(_sizeToLeftPadding, SIZE$2.default, sizing.scale200), _defineProperty$s(_sizeToLeftPadding, SIZE$2.large, sizing.scale400), _sizeToLeftPadding);
        var sizeToRightPadding = (_sizeToRightPadding = {}, _defineProperty$s(_sizeToRightPadding, SIZE$2.mini, sizing.scale400), _defineProperty$s(_sizeToRightPadding, SIZE$2.compact, sizing.scale500), _defineProperty$s(_sizeToRightPadding, SIZE$2.default, sizing.scale600), _defineProperty$s(_sizeToRightPadding, SIZE$2.large, sizing.scale700), _sizeToRightPadding);
        var padStartDir = direction === 'rtl' ? 'paddingRight' : 'paddingLeft';
        var padEndDir = direction === 'rtl' ? 'paddingLeft' : 'paddingRight';
        var styleOverride = (_styleOverride = {}, _defineProperty$s(_styleOverride, padStartDir, sizeToLeftPadding[props.$size || SIZE$2.default]), _defineProperty$s(_styleOverride, padEndDir, sizeToRightPadding[props.$size || SIZE$2.default]), _styleOverride); // do not add positive and error color borders when not focused

        if (!props.$isFocused && !props.$isPseudoFocused) {
          return _objectSpread$l(_objectSpread$l({}, styleOverride), {}, {
            borderLeftColor: 'transparent',
            borderRightColor: 'transparent',
            borderTopColor: 'transparent',
            borderBottomColor: 'transparent'
          });
        }

        return styleOverride;
      }
    }
  };

  var _getOverrides = getOverrides(overrides.CountrySelect, MultiSelect),
      _getOverrides2 = _slicedToArray$g(_getOverrides, 2),
      Select = _getOverrides2[0],
      selectProps = _getOverrides2[1];

  var selectOverrides = mergeOverrides(baseSelectOverrides, {
    Dropdown: overrides.CountrySelectDropdown || {},
    DropdownListItem: overrides.CountrySelectDropdownListItem || {}
  });
  selectProps.overrides = mergeOverrides(selectOverrides, selectProps.overrides);
  var baseOverrides = {
    FlagContainer: {
      style: function style(_ref4) {
        var _sizeToMargin;

        var _ref4$$theme = _ref4.$theme,
            direction = _ref4$$theme.direction,
            sizing = _ref4$$theme.sizing,
            props = _objectWithoutProperties$a(_ref4, ["$theme"]);

        var sizeToMargin = (_sizeToMargin = {}, _defineProperty$s(_sizeToMargin, SIZE$2.mini, sizing.scale200), _defineProperty$s(_sizeToMargin, SIZE$2.compact, sizing.scale300), _defineProperty$s(_sizeToMargin, SIZE$2.default, sizing.scale400), _defineProperty$s(_sizeToMargin, SIZE$2.large, sizing.scale500), _sizeToMargin);
        var marginDir = direction === 'rtl' ? 'marginLeft' : 'marginRight';
        return _defineProperty$s({}, marginDir, sizeToMargin[props.$size || SIZE$2.default]);
      }
    },
    DialCode: {
      style: function style(_ref6) {
        var _ref6$$theme = _ref6.$theme,
            direction = _ref6$$theme.direction,
            sizing = _ref6$$theme.sizing;
        var marginDir = direction === 'rtl' ? 'marginRight' : 'marginLeft';
        return _defineProperty$s({}, marginDir, sizing.scale600);
      }
    }
  };
  var mergedOverrides = mergeOverrides(baseOverrides, overrides);
  return /*#__PURE__*/React__default.createElement(CountryPicker$1, _extends$i({}, props, {
    overrides: _objectSpread$l(_objectSpread$l({}, mergedOverrides), {}, {
      CountrySelect: {
        component: Select,
        props: selectProps
      }
    })
  }));
}

function _extends$h() { _extends$h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

function _slicedToArray$f(arr, i) { return _arrayWithHoles$f(arr) || _iterableToArrayLimit$f(arr, i) || _unsupportedIterableToArray$f(arr, i) || _nonIterableRest$f(); }

function _nonIterableRest$f() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$f(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$f(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$f(o, minLen); }

function _arrayLikeToArray$f(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$f(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$f(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties$9(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$8(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$8(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys$k(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$k(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$k(Object(source), true).forEach(function (key) { _defineProperty$r(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$k(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$r(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
PhoneInputNext.defaultProps = _objectSpread$k(_objectSpread$k({}, defaultProps$1), {}, {
  countries: COUNTRIES,
  clearable: true
});
function PhoneInputNext(props) {
  var ariaLabel = props['aria-label'],
      ariaLabelledBy = props['aria-labelledby'],
      ariaDescribedBy = props['aria-describedby'],
      clearable = props.clearable,
      countries = props.countries,
      country = props.country,
      disabled = props.disabled,
      error = props.error,
      id = props.id,
      mapIsoToLabel = props.mapIsoToLabel,
      maxDropdownHeight = props.maxDropdownHeight,
      maxDropdownWidth = props.maxDropdownWidth,
      name = props.name,
      onTextChange = props.onTextChange,
      onCountryChange = props.onCountryChange,
      overrides = props.overrides,
      placeholder = props.placeholder,
      positive = props.positive,
      required = props.required,
      size = props.size,
      text = props.text,
      restProps = _objectWithoutProperties$9(props, ["aria-label", "aria-labelledby", "aria-describedby", "clearable", "countries", "country", "disabled", "error", "id", "mapIsoToLabel", "maxDropdownHeight", "maxDropdownWidth", "name", "onTextChange", "onCountryChange", "overrides", "placeholder", "positive", "required", "size", "text"]);

  var inputRef = useRef(null);
  var baseDialCodeOverride = {
    component: StyledDialCode,
    style: function style(_ref) {
      var _ref$$theme = _ref.$theme,
          direction = _ref$$theme.direction,
          sizing = _ref$$theme.sizing;
      var marginDir = direction === 'rtl' ? 'marginRight' : 'marginLeft';
      return _defineProperty$r({}, marginDir, sizing.scale600);
    },
    props: {
      children: country.dialCode
    }
  };
  var mergedDialCodeOverride = mergeOverrides({
    DialCode: baseDialCodeOverride
  }, {
    DialCode: overrides.DialCode || {}
  });
  var baseOverrides = {
    Input: {
      style: function style(_ref3) {
        var _ref3$$theme = _ref3.$theme,
            direction = _ref3$$theme.direction,
            sizing = _ref3$$theme.sizing;
        var paddingDir = direction === 'rtl' ? 'paddingRight' : 'paddingLeft';
        return _defineProperty$r({}, paddingDir, sizing.scale100);
      }
    },
    Before: mergedDialCodeOverride.DialCode
  };

  var _getOverrides = getOverrides(overrides.Root, StyledPhoneInputRoot),
      _getOverrides2 = _slicedToArray$f(_getOverrides, 2),
      Root = _getOverrides2[0],
      rootProps = _getOverrides2[1];

  var _getOverrides3 = getOverrides(overrides.Input, DefaultInput),
      _getOverrides4 = _slicedToArray$f(_getOverrides3, 2),
      Input = _getOverrides4[0],
      inputProps = _getOverrides4[1];

  inputProps.overrides = mergeOverrides(baseOverrides, inputProps.overrides);
  return /*#__PURE__*/React__default.createElement(Root, _extends$h({}, rootProps, {
    "data-baseweb": "phone-input-next"
  }), /*#__PURE__*/React__default.createElement(CountryPicker, {
    country: country,
    countries: countries,
    disabled: disabled,
    error: error,
    mapIsoToLabel: mapIsoToLabel,
    maxDropdownHeight: maxDropdownHeight,
    maxDropdownWidth: maxDropdownWidth,
    onCountryChange: onCountryChange,
    overrides: overrides,
    positive: positive,
    required: required,
    size: size
  }), /*#__PURE__*/React__default.createElement(Input, _extends$h({
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    "aria-describedby": ariaDescribedBy,
    autoComplete: "tel-national",
    "data-baseweb": "phone-input",
    disabled: disabled,
    error: error,
    id: id,
    inputMode: "tel",
    inputRef: inputRef,
    name: name,
    onChange: onTextChange,
    positive: positive,
    placeholder: placeholder,
    size: size,
    type: "text",
    value: text,
    clearable: clearable
  }, restProps, inputProps)));
}

function _typeof$a(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$a = function _typeof(obj) { return typeof obj; }; } else { _typeof$a = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$a(obj); }

function ownKeys$j(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$j(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$j(Object(source), true).forEach(function (key) { _defineProperty$q(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$j(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck$b(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$a(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$b(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$a(Constructor.prototype, protoProps); if (staticProps) _defineProperties$a(Constructor, staticProps); return Constructor; }

function _inherits$b(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$a(subClass, superClass); }

function _setPrototypeOf$a(o, p) { _setPrototypeOf$a = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$a(o, p); }

function _createSuper$a(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$a(); return function _createSuperInternal() { var Super = _getPrototypeOf$a(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$a(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$b(this, result); }; }

function _possibleConstructorReturn$b(self, call) { if (call && (_typeof$a(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$a(self); }

function _assertThisInitialized$a(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$a(o) { _getPrototypeOf$a = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$a(o); }

function _defineProperty$q(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultStateReducer$1 = function defaultStateReducer(type, nextState) {
  return nextState;
};

var StatefulPhoneInputContainer = /*#__PURE__*/function (_React$Component) {
  _inherits$b(StatefulPhoneInputContainer, _React$Component);

  var _super = _createSuper$a(StatefulPhoneInputContainer);

  function StatefulPhoneInputContainer() {
    var _this;

    _classCallCheck$b(this, StatefulPhoneInputContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$q(_assertThisInitialized$a(_this), "state", _objectSpread$j({
      text: '',
      country: COUNTRIES.US
    }, _this.props.initialState));

    _defineProperty$q(_assertThisInitialized$a(_this), "internalSetState", function (type, nextState) {
      _this.setState(_this.props.stateReducer(type, nextState, _this.state));
    });

    _defineProperty$q(_assertThisInitialized$a(_this), "onTextChange", function (event) {
      _this.props.onTextChange(event);

      _this.internalSetState(STATE_CHANGE_TYPE.textChange, {
        text: event.target.value
      });
    });

    _defineProperty$q(_assertThisInitialized$a(_this), "onCountryChange", function (event) {
      _this.props.onCountryChange(event);

      if (event.option && event.option.id) {
        _this.internalSetState(STATE_CHANGE_TYPE.countryChange, {
          country: COUNTRIES[event.option.id]
        });
      }
    });

    return _this;
  }

  _createClass$b(StatefulPhoneInputContainer, [{
    key: "render",
    value: function render() {
      return this.props.children(_objectSpread$j(_objectSpread$j({}, defaultProps$1), {}, {
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby'],
        'aria-describedby': this.props['aria-describedby'],
        disabled: this.props.disabled,
        error: this.props.error,
        id: this.props.id,
        maxDropdownHeight: this.props.maxDropdownHeight,
        maxDropdownWidth: this.props.maxDropdownWidth,
        mapIsoToLabel: this.props.mapIsoToLabel,
        name: this.props.name,
        overrides: this.props.overrides,
        placeholder: this.props.placeholder,
        positive: this.props.positive,
        required: this.props.required,
        size: this.props.size,
        clearable: this.props.clearable,
        country: this.state.country,
        text: this.state.text,
        onTextChange: this.onTextChange,
        onCountryChange: this.onCountryChange
      }));
    }
  }]);

  return StatefulPhoneInputContainer;
}(React__default.Component);

_defineProperty$q(StatefulPhoneInputContainer, "defaultProps", {
  initialState: {
    text: defaultProps$1.text,
    country: defaultProps$1.country
  },
  onTextChange: defaultProps$1.onTextChange,
  onCountryChange: defaultProps$1.onTextChange,
  stateReducer: defaultStateReducer$1,
  overrides: {}
});

const PhoneInput = (props) => (React$2.createElement(PhoneInputNext, { ...props }));

const StatefulPhoneInput = (props) => (React$2.createElement(StatefulPhoneInputContainer, { ...props }, (childrenProps) => React$2.createElement(PhoneInput, { ...childrenProps })));

const MAX_WIDTH = '600px';
const typography$1 = {
    ParagraphLarge: {
        fontFamily: tokens$1['font-family'].text,
        fontSize: tokens$1['font-size'].root,
        fontWeight: FontWeight.Regular,
        lineHeight: tokens$1['line-height'].body,
    },
    ParagraphSmall: {
        fontFamily: tokens$1['font-family'].text,
        fontSize: tokens$1['font-size'].small,
        fontWeight: FontWeight.Regular,
        lineHeight: tokens$1['line-height']['body-small'],
    },
};

const ParagraphLarge = (props) => {
    const { fontWeight = FontWeight.Regular, color, ...restProps } = props;
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(ParagraphLarge$1, { color: color !== null && color !== void 0 ? color : theme.colors['neutral-75'], maxWidth: MAX_WIDTH, overrides: {
            Block: {
                style: {
                    ...typography$1.ParagraphLarge,
                    fontWeight,
                },
            },
        }, ...restProps }));
};
const ParagraphSmall = (props) => {
    const { fontWeight = FontWeight.Regular, color, ...restProps } = props;
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(ParagraphSmall$1, { color: color !== null && color !== void 0 ? color : theme.colors['neutral-75'], maxWidth: MAX_WIDTH, overrides: {
            Block: {
                style: {
                    ...typography$1.ParagraphSmall,
                    fontWeight,
                },
            },
        }, ...restProps }));
};

const StyledBody$1 = themedWithStyle(Body$3, {
    marginTop: 0,
});

const PopoverMenu = ({ children, items, menuIsOpen, onClose, onItemSelect, onOpen, placement, }) => {
    const Menu = useCallback(({ close }) => (React$2.createElement(StatefulMenu, { items: items, onItemSelect: ({ item }) => {
            close();
            onItemSelect(item);
        } })), [items, onItemSelect]);
    return (React$2.createElement(StatefulPopover, { initialState: {
            isOpen: menuIsOpen || false,
        }, onOpen: onOpen, onClose: onClose, placement: placement, content: Menu },
        React$2.createElement("span", null, children)));
};

const StatefulPopover = (props) => {
    const { children, ...otherProps } = props;
    return (React$2.createElement(StatefulPopover$1, { overrides: {
            Body: StyledBody$1,
        }, placement: PLACEMENT$2.bottomRight || otherProps.placement, ...otherProps },
        React$2.createElement("div", null, children)));
};

const StyledBarContainer = themedWithStyle(StyledBarContainer$1, {
    ...margin('0px'),
    ...padding('0px', '0px', tokens$1.spacing['xx-small'], '0px'),
});
const StyledBar = themedWithStyle(StyledBar$3, ({ $theme }) => ({
    backgroundColor: $theme.colors['neutral-25'],
    ...borderRadius('top', $theme.cornerRadius.pill),
    ...borderRadius('bottom', $theme.cornerRadius.pill),
}));
const StyledBarProgress = themedWithStyle(StyledBarProgress$1, ({ $theme }) => ({
    backgroundColor: $theme.colors['brand-secondary-1-100'],
    ...borderRadius('top', $theme.cornerRadius.pill),
    ...borderRadius('bottom', $theme.cornerRadius.pill),
}));
const StyledLabel$1 = themedWithStyle(StyledLabel$4, ({ $theme }) => ({
    ...typography$6.LabelLarge,
    color: $theme.colors['neutral-100'],
    fontWeight: FontWeight.Heavy,
    textAlign: 'center',
}));
const StyledInfiniteBar = themedWithStyle(StyledInfiniteBar$1, ({ $theme, $isLeft = false, }) => ({
    ...($isLeft
        ? borderRadius('left', $theme.cornerRadius.pill)
        : borderRadius('right', $theme.cornerRadius.pill)),
    backgroundImage: `linear-gradient(${$isLeft ? '90' : '270'}deg, transparent 0%, ${$theme.colors['brand-primary']} 25%, ${$theme.colors['brand-primary-10']} 75%, transparent 100%)`,
    height: '4px',
}));

const ProgressBar = (props) => (React$2.createElement(ProgressBar$2, { ...props, overrides: {
        Bar: StyledBar,
        BarContainer: StyledBarContainer,
        BarProgress: StyledBarProgress,
        InfiniteBar: StyledInfiniteBar,
        Label: StyledLabel$1,
    } }));

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* eslint-disable import/prefer-default-export */
var STATE_TYPE = {
  change: 'CHANGE'
};
var ALIGN$1 = {
  vertical: 'vertical',
  horizontal: 'horizontal'
};
/* eslint-enable import/prefer-default-export */

function _typeof$9(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$9 = function _typeof(obj) { return typeof obj; }; } else { _typeof$9 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$9(obj); }

function _objectWithoutProperties$8(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$7(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$7(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys$i(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$i(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$i(Object(source), true).forEach(function (key) { _defineProperty$p(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$i(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck$a(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$9(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$a(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$9(Constructor.prototype, protoProps); if (staticProps) _defineProperties$9(Constructor, staticProps); return Constructor; }

function _inherits$a(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$9(subClass, superClass); }

function _setPrototypeOf$9(o, p) { _setPrototypeOf$9 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$9(o, p); }

function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = _getPrototypeOf$9(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$9(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$a(this, result); }; }

function _possibleConstructorReturn$a(self, call) { if (call && (_typeof$9(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$9(self); }

function _assertThisInitialized$9(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$9(o) { _getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$9(o); }

function _defineProperty$p(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultStateReducer = function defaultStateReducer(type, nextState) {
  return nextState;
};

var StatefulRadioGroupContainer = /*#__PURE__*/function (_React$Component) {
  _inherits$a(StatefulRadioGroupContainer, _React$Component);

  var _super = _createSuper$9(StatefulRadioGroupContainer);

  function StatefulRadioGroupContainer(props) {
    var _this;

    _classCallCheck$a(this, StatefulRadioGroupContainer);

    _this = _super.call(this, props);

    _defineProperty$p(_assertThisInitialized$9(_this), "onChange", function (e) {
      _this.stateReducer(STATE_TYPE.change, e);

      var onChange = _this.props.onChange;
      onChange && onChange(e);
    });

    _defineProperty$p(_assertThisInitialized$9(_this), "stateReducer", function (type, e) {
      var nextState = {};
      var stateReducer = _this.props.stateReducer;

      if (type === STATE_TYPE.change) {
        nextState = {
          value: e.target.value
        };
      }

      var newState = stateReducer(type, nextState, _this.state, e);

      _this.setState(newState);
    });

    var initialState = _this.props.initialState;
    _this.state = _objectSpread$i({}, initialState);
    return _this;
  }

  _createClass$a(StatefulRadioGroupContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$children = _this$props.children,
          children = _this$props$children === void 0 ? function (childProps) {
        return null;
      } : _this$props$children;
          _this$props.initialState;
          _this$props.stateReducer;
          var restProps = _objectWithoutProperties$8(_this$props, ["children", "initialState", "stateReducer"]);

      var onChange = this.onChange;
      return children(_objectSpread$i(_objectSpread$i({}, restProps), {}, {
        value: this.state.value,
        onChange: onChange
      }));
    }
  }]);

  return StatefulRadioGroupContainer;
}(React$2.Component);

_defineProperty$p(StatefulRadioGroupContainer, "defaultProps", {
  initialState: {
    value: ''
  },
  stateReducer: defaultStateReducer,
  onChange: function onChange() {}
});

var StatefulContainer = StatefulRadioGroupContainer;

function ownKeys$h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$h(Object(source), true).forEach(function (key) { _defineProperty$o(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$o(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var DEFAULT = 0;
var HOVERED = 1;
var ACTIVE = 2;

function getState(props) {
  if (props.$isActive) return ACTIVE;
  if (props.$isHovered) return HOVERED;
  return DEFAULT;
}

function getOuterColor(props) {
  var colors = props.$theme.colors,
      $disabled = props.$disabled,
      $checked = props.$checked,
      $isFocusVisible = props.$isFocusVisible,
      $error = props.$error,
      $isError = props.$isError;
  if ($disabled) return colors.tickFillDisabled;

  if (!$checked) {
    if ($isFocusVisible) return colors.borderSelected;
    if ($error || $isError) return colors.tickBorderError;
    return colors.tickBorder;
  } else {
    if ($error || $isError) {
      switch (getState(props)) {
        case DEFAULT:
          return colors.tickFillErrorSelected;

        case HOVERED:
          return colors.tickFillErrorSelectedHover;

        case ACTIVE:
          return colors.tickFillErrorSelectedHoverActive;
      }
    } else {
      switch (getState(props)) {
        case DEFAULT:
          return colors.tickFillSelected;

        case HOVERED:
          return colors.tickFillSelectedHover;

        case ACTIVE:
          return colors.tickFillSelectedHoverActive;
      }
    }
  }

  return null;
}

function getInnerColor(props) {
  var colors = props.$theme.colors;

  if (props.$disabled) {
    return colors.tickMarkFillDisabled;
  }

  if (!props.$checked) {
    if (props.$error || props.$isError) {
      switch (getState(props)) {
        case DEFAULT:
          return colors.tickFillError;

        case HOVERED:
          return colors.tickFillErrorHover;

        case ACTIVE:
          return colors.tickFillErrorHoverActive;
      }
    } else {
      switch (getState(props)) {
        case DEFAULT:
          return colors.tickFill;

        case HOVERED:
          return colors.tickFillHover;

        case ACTIVE:
          return colors.tickFillActive;
      }
    }
  } else {
    return colors.tickMarkFill;
  }
}

function getLabelPadding(props) {
  var _props$$labelPlacemen = props.$labelPlacement,
      $labelPlacement = _props$$labelPlacemen === void 0 ? '' : _props$$labelPlacemen,
      $theme = props.$theme;
  var paddingDirection;

  switch ($labelPlacement) {
    case 'top':
      paddingDirection = 'Bottom';
      break;

    case 'bottom':
      paddingDirection = 'Top';
      break;

    case 'left':
      paddingDirection = $theme.direction === 'rtl' ? 'Left' : 'Right';
      break;

    default:
    case 'right':
      paddingDirection = $theme.direction === 'rtl' ? 'Right' : 'Left';
      break;
  }

  var sizing = $theme.sizing;
  var scale300 = sizing.scale300;
  return _defineProperty$o({}, "padding".concat(paddingDirection), scale300);
}

function getLabelColor(props) {
  var $disabled = props.$disabled,
      $theme = props.$theme;
  var colors = $theme.colors;
  return $disabled ? colors.contentSecondary : colors.contentPrimary;
}

var RadioGroupRoot = styled('div', // $FlowFixMe - suppressing due to webkit property
function (props) {
  var $disabled = props.$disabled,
      $align = props.$align;
  return {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: $align === 'horizontal' ? 'row' : 'column',
    alignItems: $align === 'horizontal' ? 'center' : 'flex-start',
    cursor: $disabled ? 'not-allowed' : 'pointer',
    '-webkit-tap-highlight-color': 'transparent'
  };
});
RadioGroupRoot.displayName = "RadioGroupRoot";
var Root$2 = styled('label', function (props) {
  var _ref2;

  var $disabled = props.$disabled,
      $hasDescription = props.$hasDescription,
      $labelPlacement = props.$labelPlacement,
      $theme = props.$theme,
      $align = props.$align;
  var sizing = $theme.sizing;
  var isHorizontal = $align === 'horizontal';
  var marginAfter = $theme.direction === 'rtl' ? 'Left' : 'Right';
  return _ref2 = {
    flexDirection: $labelPlacement === 'top' || $labelPlacement === 'bottom' ? 'column' : 'row',
    display: 'flex',
    alignItems: 'center',
    cursor: $disabled ? 'not-allowed' : 'pointer',
    marginTop: sizing.scale200
  }, _defineProperty$o(_ref2, "margin".concat(marginAfter), isHorizontal ? sizing.scale200 : null), _defineProperty$o(_ref2, "marginBottom", $hasDescription && !isHorizontal ? null : sizing.scale200), _ref2;
});
Root$2.displayName = "Root";
var RadioMarkInner = styled('div', function (props) {
  var _props$$theme = props.$theme,
      animation = _props$$theme.animation,
      sizing = _props$$theme.sizing;
  return {
    backgroundColor: getInnerColor(props),
    borderTopLeftRadius: '50%',
    borderTopRightRadius: '50%',
    borderBottomRightRadius: '50%',
    borderBottomLeftRadius: '50%',
    height: props.$checked ? sizing.scale200 : sizing.scale550,
    transitionDuration: animation.timing200,
    transitionTimingFunction: animation.easeOutCurve,
    width: props.$checked ? sizing.scale200 : sizing.scale550
  };
});
RadioMarkInner.displayName = "RadioMarkInner";
var RadioMarkOuter = styled('div', function (props) {
  var _props$$theme2 = props.$theme,
      animation = _props$$theme2.animation,
      sizing = _props$$theme2.sizing;
  return {
    alignItems: 'center',
    backgroundColor: getOuterColor(props),
    borderTopLeftRadius: '50%',
    borderTopRightRadius: '50%',
    borderBottomRightRadius: '50%',
    borderBottomLeftRadius: '50%',
    boxShadow: props.$isFocusVisible && props.$checked ? "0 0 0 3px ".concat(props.$theme.colors.accent) : 'none',
    display: 'flex',
    height: sizing.scale700,
    justifyContent: 'center',
    marginTop: sizing.scale0,
    marginRight: sizing.scale0,
    marginBottom: sizing.scale0,
    marginLeft: sizing.scale0,
    outline: 'none',
    verticalAlign: 'middle',
    width: sizing.scale700,
    flexShrink: 0,
    transitionDuration: animation.timing200,
    transitionTimingFunction: animation.easeOutCurve
  };
});
RadioMarkOuter.displayName = "RadioMarkOuter";
var Label = styled('div', function (props) {
  var typography = props.$theme.typography;
  return _objectSpread$h(_objectSpread$h({
    verticalAlign: 'middle'
  }, getLabelPadding(props)), {}, {
    color: getLabelColor(props)
  }, typography.LabelMedium);
}); // tricky style for focus event cause display: none doesn't work

Label.displayName = "Label";
var Input = styled('input', {
  width: 0,
  height: 0,
  marginTop: 0,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  paddingTop: 0,
  paddingRight: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  clip: 'rect(0 0 0 0)',
  position: 'absolute'
});
Input.displayName = "Input";
var Description = styled('div', function (props) {
  var _objectSpread2;

  var $theme = props.$theme,
      $align = props.$align;
  var isHorizontal = $align === 'horizontal';
  var marginBefore = $theme.direction === 'rtl' ? 'Right' : 'Left';
  var marginAfter = $theme.direction === 'rtl' ? 'Left' : 'Right';
  return _objectSpread$h(_objectSpread$h({}, $theme.typography.ParagraphSmall), {}, (_objectSpread2 = {
    color: $theme.colors.contentSecondary,
    cursor: 'auto'
  }, _defineProperty$o(_objectSpread2, "margin".concat(marginBefore), $align === 'horizontal' ? null : $theme.sizing.scale900), _defineProperty$o(_objectSpread2, "margin".concat(marginAfter), isHorizontal ? $theme.sizing.scale200 : null), _defineProperty$o(_objectSpread2, "maxWidth", '240px'), _objectSpread2));
});
Description.displayName = "Description";

function _typeof$8(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$8 = function _typeof(obj) { return typeof obj; }; } else { _typeof$8 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$8(obj); }

function _extends$g() { _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

function ownKeys$g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$g(Object(source), true).forEach(function (key) { _defineProperty$n(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray$e(arr, i) { return _arrayWithHoles$e(arr) || _iterableToArrayLimit$e(arr, i) || _unsupportedIterableToArray$e(arr, i) || _nonIterableRest$e(); }

function _nonIterableRest$e() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$e(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$e(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$e(o, minLen); }

function _arrayLikeToArray$e(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$e(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$e(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$9(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$8(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$9(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$8(Constructor.prototype, protoProps); if (staticProps) _defineProperties$8(Constructor, staticProps); return Constructor; }

function _inherits$9(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$8(subClass, superClass); }

function _setPrototypeOf$8(o, p) { _setPrototypeOf$8 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$8(o, p); }

function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf$8(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$8(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$9(this, result); }; }

function _possibleConstructorReturn$9(self, call) { if (call && (_typeof$8(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$8(self); }

function _assertThisInitialized$8(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$8(o) { _getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$8(o); }

function _defineProperty$n(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var StatelessRadioGroup = /*#__PURE__*/function (_React$Component) {
  _inherits$9(StatelessRadioGroup, _React$Component);

  var _super = _createSuper$8(StatelessRadioGroup);

  function StatelessRadioGroup() {
    var _this;

    _classCallCheck$9(this, StatelessRadioGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$n(_assertThisInitialized$8(_this), "state", {
      isFocusVisible: false,
      focusedRadioIndex: -1
    });

    _defineProperty$n(_assertThisInitialized$8(_this), "handleFocus", function (event, index) {
      if (isFocusVisible(event)) {
        _this.setState({
          isFocusVisible: true
        });
      }

      _this.setState({
        focusedRadioIndex: index
      });

      _this.props.onFocus && _this.props.onFocus(event);
    });

    _defineProperty$n(_assertThisInitialized$8(_this), "handleBlur", function (event, index) {
      if (_this.state.isFocusVisible !== false) {
        _this.setState({
          isFocusVisible: false
        });
      }

      _this.setState({
        focusedRadioIndex: -1
      });

      _this.props.onBlur && _this.props.onBlur(event);
    });

    return _this;
  }

  _createClass$9(StatelessRadioGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (process.env.NODE_ENV !== "production" && this.props.isError) {
        console.warn('baseui:Radio Property "isError" will be removed in the next major version. Use "error" property instead.');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props$overrides = this.props.overrides,
          overrides = _this$props$overrides === void 0 ? {} : _this$props$overrides;

      var _getOverrides = getOverrides(overrides.RadioGroupRoot, RadioGroupRoot),
          _getOverrides2 = _slicedToArray$e(_getOverrides, 2),
          RadioGroupRoot$1 = _getOverrides2[0],
          radioGroupRootProps = _getOverrides2[1];

      if (process.env.NODE_ENV !== "production") {
        var overrideKeys = Object.keys(overrides); // TODO(v11)

        if (Boolean(overrideKeys.length) && !overrideKeys.includes('RadioGroupRoot')) {
          // eslint-disable-next-line no-console
          console.warn("All overrides beside 'RadioGroupRoot' will be deprecated in the next major version update.\n          Pass other overrides to the 'Radio' children instead.\n        ");
        }
      }

      return /*#__PURE__*/React$2.createElement(RadioGroupRoot$1, _extends$g({
        id: this.props.id,
        role: "radiogroup",
        "aria-describedby": this.props['aria-describedby'],
        "aria-errormessage": this.props['aria-errormessage'],
        "aria-invalid": this.props.error || this.props.isError || null,
        "aria-label": this.props['aria-label'],
        "aria-labelledby": this.props['aria-labelledby'],
        $align: this.props.align,
        $disabled: this.props.disabled,
        $isError: this.props.error || this.props.isError,
        $error: this.props.error || this.props.isError,
        $required: this.props.required
      }, radioGroupRootProps), React$2.Children.map(this.props.children, function (child, index) {
        if (! /*#__PURE__*/React$2.isValidElement(child)) {
          return null;
        }

        var checked = _this2.props.value === child.props.value;
        return /*#__PURE__*/React$2.cloneElement(child, {
          align: _this2.props.align,
          autoFocus: _this2.props.autoFocus,
          checked: checked,
          disabled: _this2.props.disabled || child.props.disabled,
          isError: _this2.props.isError,
          error: _this2.props.error,
          isFocused: _this2.state.focusedRadioIndex === index,
          isFocusVisible: _this2.state.isFocusVisible,
          tabIndex: index === 0 && !_this2.props.value || checked ? '0' : '-1',
          labelPlacement: _this2.props.labelPlacement,
          name: _this2.props.name,
          onBlur: function onBlur(e) {
            return _this2.handleBlur(e, index);
          },
          onFocus: function onFocus(e) {
            return _this2.handleFocus(e, index);
          },
          onChange: _this2.props.onChange,
          onMouseEnter: _this2.props.onMouseEnter,
          onMouseLeave: _this2.props.onMouseLeave,
          // will need to remove overrides pass-through on next major version
          overrides: _objectSpread$g(_objectSpread$g({}, _this2.props.overrides), child.props.overrides)
        });
      }));
    }
  }]);

  return StatelessRadioGroup;
}(React$2.Component);

_defineProperty$n(StatelessRadioGroup, "defaultProps", {
  name: '',
  value: '',
  disabled: false,
  autoFocus: false,
  labelPlacement: 'right',
  align: 'vertical',
  isError: false,
  error: false,
  required: false,
  onChange: function onChange() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  overrides: {}
});

var BaseRadioGroup = StatelessRadioGroup;

function _typeof$7(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$7 = function _typeof(obj) { return typeof obj; }; } else { _typeof$7 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$7(obj); }

function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

function _slicedToArray$d(arr, i) { return _arrayWithHoles$d(arr) || _iterableToArrayLimit$d(arr, i) || _unsupportedIterableToArray$d(arr, i) || _nonIterableRest$d(); }

function _nonIterableRest$d() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$d(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$d(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$d(o, minLen); }

function _arrayLikeToArray$d(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$d(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$d(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$8(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$7(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$8(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$7(Constructor.prototype, protoProps); if (staticProps) _defineProperties$7(Constructor, staticProps); return Constructor; }

function _inherits$8(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$7(subClass, superClass); }

function _setPrototypeOf$7(o, p) { _setPrototypeOf$7 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$7(o, p); }

function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf$7(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$7(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$8(this, result); }; }

function _possibleConstructorReturn$8(self, call) { if (call && (_typeof$7(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$7(self); }

function _assertThisInitialized$7(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$7(o) { _getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$7(o); }

function _defineProperty$m(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function isLabelTopLeft(labelPlacement) {
  return labelPlacement === 'top' || labelPlacement === 'left';
}

function isLabelBottomRight(labelPlacement) {
  return labelPlacement === 'bottom' || labelPlacement === 'right';
}

var stopPropagation = function stopPropagation(e) {
  return e.stopPropagation();
};

var Radio$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$8(Radio, _React$Component);

  var _super = _createSuper$7(Radio);

  function Radio() {
    var _this;

    _classCallCheck$8(this, Radio);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$m(_assertThisInitialized$7(_this), "state", {
      isActive: false,
      isHovered: false
    });

    _defineProperty$m(_assertThisInitialized$7(_this), "onMouseEnter", function (e) {
      _this.setState({
        isHovered: true
      });

      _this.props.onMouseEnter && _this.props.onMouseEnter(e);
    });

    _defineProperty$m(_assertThisInitialized$7(_this), "onMouseLeave", function (e) {
      _this.setState({
        isHovered: false
      });

      _this.props.onMouseLeave && _this.props.onMouseLeave(e);
    });

    _defineProperty$m(_assertThisInitialized$7(_this), "onMouseDown", function (e) {
      _this.setState({
        isActive: true
      });

      _this.props.onMouseDown && _this.props.onMouseDown(e);
    });

    _defineProperty$m(_assertThisInitialized$7(_this), "onMouseUp", function (e) {
      _this.setState({
        isActive: false
      });

      _this.props.onMouseUp && _this.props.onMouseUp(e);
    });

    return _this;
  }

  _createClass$8(Radio, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props$inputRef;

      if (this.props.autoFocus && (_this$props$inputRef = this.props.inputRef) !== null && _this$props$inputRef !== void 0 && _this$props$inputRef.current) {
        this.props.inputRef.current.focus();
      }

      if (process.env.NODE_ENV !== "production" && this.props.isError) {
        console.warn('baseui:Radio Property "isError" will be removed in the next major version. Use "error" property instead.');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$overrides = this.props.overrides,
          overrides = _this$props$overrides === void 0 ? {} : _this$props$overrides;

      var _getOverrides = getOverrides(overrides.Root, Root$2),
          _getOverrides2 = _slicedToArray$d(_getOverrides, 2),
          Root = _getOverrides2[0],
          rootProps = _getOverrides2[1];

      var _getOverrides3 = getOverrides(overrides.Label, Label),
          _getOverrides4 = _slicedToArray$d(_getOverrides3, 2),
          Label$1 = _getOverrides4[0],
          labelProps = _getOverrides4[1];

      var _getOverrides5 = getOverrides(overrides.Input, Input),
          _getOverrides6 = _slicedToArray$d(_getOverrides5, 2),
          Input$1 = _getOverrides6[0],
          inputProps = _getOverrides6[1];

      var _getOverrides7 = getOverrides(overrides.Description, Description),
          _getOverrides8 = _slicedToArray$d(_getOverrides7, 2),
          Description$1 = _getOverrides8[0],
          descriptionProps = _getOverrides8[1];

      var _getOverrides9 = getOverrides(overrides.RadioMarkInner, RadioMarkInner),
          _getOverrides10 = _slicedToArray$d(_getOverrides9, 2),
          RadioMarkInner$1 = _getOverrides10[0],
          radioMarkInnerProps = _getOverrides10[1];

      var _getOverrides11 = getOverrides(overrides.RadioMarkOuter, RadioMarkOuter),
          _getOverrides12 = _slicedToArray$d(_getOverrides11, 2),
          RadioMarkOuter$1 = _getOverrides12[0],
          radioMarkOuterProps = _getOverrides12[1];

      var sharedProps = {
        $align: this.props.align,
        $checked: this.props.checked,
        $disabled: this.props.disabled,
        $hasDescription: !!this.props.description,
        $isActive: this.state.isActive,
        $isError: this.props.isError,
        $error: this.props.error,
        $isFocused: this.props.isFocused,
        $isFocusVisible: this.props.isFocused && this.props.isFocusVisible,
        $isHovered: this.state.isHovered,
        $labelPlacement: this.props.labelPlacement,
        $required: this.props.required,
        $value: this.props.value
      };
      var label = /*#__PURE__*/React$2.createElement(Label$1, _extends$f({}, sharedProps, labelProps), this.props.containsInteractiveElement ?
      /*#__PURE__*/
      // Prevents the event from bubbling up to the label and moving focus to the radio button
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
      React$2.createElement("div", {
        onClick: function onClick(e) {
          return e.preventDefault();
        }
      }, this.props.children) : this.props.children);
      return /*#__PURE__*/React$2.createElement(React$2.Fragment, null, /*#__PURE__*/React$2.createElement(Root, _extends$f({
        "data-baseweb": "radio",
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp
      }, sharedProps, rootProps), isLabelTopLeft(this.props.labelPlacement) && label, /*#__PURE__*/React$2.createElement(RadioMarkOuter$1, _extends$f({}, sharedProps, radioMarkOuterProps), /*#__PURE__*/React$2.createElement(RadioMarkInner$1, _extends$f({}, sharedProps, radioMarkInnerProps))), /*#__PURE__*/React$2.createElement(Input$1, _extends$f({
        "aria-invalid": this.props.error || this.props.isError || null,
        checked: this.props.checked,
        disabled: this.props.disabled,
        name: this.props.name,
        onBlur: this.props.onBlur,
        onFocus: this.props.onFocus // Prevent a second click event from firing when label is clicked.
        // See https://github.com/uber/baseweb/issues/3847 & https://github.com/uber/baseweb/issues/4033
        ,
        onClick: stopPropagation,
        onChange: this.props.onChange,
        ref: this.props.inputRef,
        required: this.props.required,
        tabIndex: this.props.tabIndex,
        type: "radio",
        value: this.props.value
      }, sharedProps, inputProps)), isLabelBottomRight(this.props.labelPlacement) && label), !!this.props.description && /*#__PURE__*/React$2.createElement(Description$1, _extends$f({}, sharedProps, descriptionProps), this.props.description));
    }
  }]);

  return Radio;
}(React$2.Component);

_defineProperty$m(Radio$1, "defaultProps", {
  overrides: {},
  containsInteractiveElement: false,
  checked: false,
  disabled: false,
  autoFocus: false,
  inputRef: /*#__PURE__*/React$2.createRef(),
  align: 'vertical',
  isError: false,
  error: false,
  onChange: function onChange() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onMouseDown: function onMouseDown() {},
  onMouseUp: function onMouseUp() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {}
});

var BaseRadio = Radio$1;

const StyledRoot$8 = themedWithStyle(Root$2, ({ $disabled, $theme }) => ({
    ...($disabled ? {
        opacity: tokens$1.opacity.disabled,
    } : {}),
    alignItems: 'flex-start',
    ...margin($theme.sizing['xxx-small'], '0px'),
}));
const StyledRadioGroupRoot = themedWithStyle(RadioGroupRoot, ({ $align, $theme }) => ({
    ...($align === ALIGN$1.horizontal
        ? {
            columnGap: $theme.sizing.small,
        }
        : {}),
    alignItems: 'flex-start',
}));
const StyledLabel = themedWithStyle(Label, ({ $checked, $theme, }) => ({
    ...typography$6.LabelMedium,
    ...($checked ? {
        color: $theme.colors['neutral-100'],
        fontWeight: FontWeight.Bold, // styles/label-bold
    } : {
        color: $theme.colors['neutral-75'],
    }),
    paddingInlineStart: $theme.sizing['xx-small'],
}));
const StyledRadioMarkInner = themedWithStyle(RadioMarkInner, ({ $checked, $isHovered, $theme, }) => ({
    height: '8px',
    width: '8px',
    ...($checked ? {
        backgroundColor: $theme.colors['brand-primary'],
    } : {}),
    ...($isHovered ? {
        backgroundColor: $checked ? $theme.colors['brand-primary-125'] : $theme.colors['neutral-25'],
    } : {}),
}));
const StyledRadioMarkOuter = themedWithStyle(RadioMarkOuter, ({ $checked, $isHovered, $isFocused, $theme, }) => ({
    ...($isHovered && !$checked ? {
        backgroundColor: $theme.colors['neutral-25'],
    } : {
        backgroundColor: $theme.colors['neutral-0'],
    }),
    ':active': {
        backgroundColor: $theme.colors['neutral-0'],
    },
    height: '16px',
    width: '16px',
    ...borderStyle('solid'),
    ...borderWidth('2px'),
    ...borderColor($theme.colors['neutral-50']),
    ...($checked ? {
        ...borderColor($theme.colors['brand-primary']),
    } : {
        ...borderColor($theme.colors['neutral-50']),
    }),
    ...($checked && $isHovered ? {
        ...borderColor($theme.colors['brand-primary-125']),
    } : {}),
    ...($isFocused ? {
        boxShadow: `0 0 0 3px ${$theme.colors['brand-primary-50']}`,
    } : {}),
    ...margin('0px'),
}));

const Radio = (props) => (React$2.createElement(BaseRadio, { ...props, overrides: {
        Label: StyledLabel,
        RadioMarkInner: StyledRadioMarkInner,
        RadioMarkOuter: StyledRadioMarkOuter,
        Root: StyledRoot$8,
    } }));

const RadioGroup = (props) => (React$2.createElement(BaseRadioGroup, { ...props, overrides: {
        RadioGroupRoot: StyledRadioGroupRoot,
    } }));

const StatefulRadioGroup = (props) => {
    const { children, ...restProps } = props;
    return (React$2.createElement(StatefulContainer, { ...restProps }, (childrenProps) => (React$2.createElement(RadioGroup, { overrides: {
            RadioGroupRoot: StyledRadioGroupRoot,
        }, ...childrenProps }, children))));
};

const OptionContent = (optionProps) => {
    const { children, kind, $selected } = optionProps;
    const [, theme] = themedUseStyletron();
    const StyledOptionContent$1 = themedWithStyle(StyledOptionContent, ({ $theme, }) => {
        let backgroundColor = $theme.colors['neutral-0'];
        let color = $theme.colors['neutral-100'];
        let hoverBackgroundColor = $theme.colors['neutral-25'];
        let hoverColor = $theme.colors['neutral-100'];
        switch (kind) {
            case 'checkmark':
                break;
            default:
                if ($selected) {
                    backgroundColor = $theme.colors['brand-primary'];
                    color = $theme.colors['neutral-0'];
                    hoverBackgroundColor = $theme.colors['brand-primary-125'];
                    hoverColor = $theme.colors['neutral-0'];
                }
        }
        return {
            alignItems: 'center',
            backgroundColor,
            color,
            display: 'flex',
            ...typography$6.LabelMedium,
            fontWeight: $selected ? FontWeight.Bold : FontWeight.Regular,
            overflow: 'hidden',
            width: '100%',
            ...padding($theme.sizing['xxx-small'], $theme.sizing['xx-small']),
            ':hover': {
                backgroundColor: hoverBackgroundColor,
                color: hoverColor,
            },
        };
    });
    return (React__default.createElement(StyledOptionContent$1, { ...optionProps },
        kind === 'checkmark' && (React__default.createElement("div", { style: {
                display: 'inline-block',
                width: theme.sizing['x-large'],
            } }, $selected && (React__default.createElement(CheckmarkOutlineIcon, { color: theme.colors['brand-primary'], size: theme.iconScale.small })))),
        children));
};

const SelectArrow = (selectArrowProps) => {
    const { $isOpen } = selectArrowProps;
    const [, theme] = themedUseStyletron();
    return (React__default.createElement("div", { style: { height: '24px', pointerEvents: 'none' } }, $isOpen
        ? (React__default.createElement(CaretUpOutlineIcon, { size: theme.iconScale.small, color: theme.colors['neutral-75'] }))
        : (React__default.createElement(CaretDownOutlineIcon, { size: theme.iconScale.small, color: theme.colors['neutral-75'] }))));
};

const StyledInput = themedWithStyle(StyledInput$2, ({ $theme, }) => ({
    ...typography$6.LabelMedium,
    background: 'transparent',
    color: $theme.colors['neutral-100'],
    ...padding('0px'),
    '::placeholder': {
        color: $theme.colors['neutral-50'],
    },
    ['::-webkit-outer-spin-button,'
        + '::-webkit-inner-spin-button,'
        + '::-webkit-search-decoration,'
        + '::-webkit-search-cancel-button,'
        + '::-webkit-search-results-button,'
        + '::-webkit-search-results-decoration']: {
        '-webkit-appearance': 'none',
        display: 'none',
        margin: 0,
    },
}));
const StyledControlContainer = themedWithStyle(StyledControlContainer$2, ({ $isFocused, $theme }) => ({
    backgroundColor: $theme.colors['neutral-10'],
    ...borderWidth('0px'),
    ...border$1('bottom', $isFocused ? '2px' : '1px', 'solid', $isFocused ? $theme.colors['neutral-100'] : $theme.colors['neutral-75']),
}));
const StyledDropdown = themedWithStyle(StyledDropdown$1, ({ $theme }) => ({
    backgroundColor: $theme.colors['neutral-0'],
    ...padding('0px'),
    ...borderRadius('bottom', $theme.cornerRadius['semi-sharp']),
}));
const StyledDropdownListItem = themedWithStyle(StyledDropdownListItem$1, {
    ...padding('0px'),
    overflow: 'hidden',
});
const StyledValueContainer = themedWithStyle(StyledValueContainer$1, ({ $theme }) => ({
    ...padding($theme.sizing['xx-small']),
    columnGap: $theme.sizing['xxx-small'],
    rowGap: $theme.sizing['xxx-small'],
    ...typography$6.LabelMedium,
}));
const StyledValueContainerWithSearch = themedWithStyle(StyledValueContainer, { paddingLeft: '38px' });
const StyledPopoverBody = themedWithStyle(Body$3, ({ $theme }) => ({
    boxShadow: $theme.boxShadow.card,
}));

const Select = (props) => {
    const { kind = 'default', clearable = false, overrides, disabled = false, size = SIZE$2.default, ...additionalProps } = props;
    const { type } = additionalProps;
    const [, theme] = themedUseStyletron();
    const iconScale = (size === SIZE$2.compact || size === SIZE$2.mini)
        ? theme.iconScale['x-small']
        : theme.iconScale.small;
    const ClearIconOverride = useCallback((clearIconProps) => (React__default.createElement(CloseCircleOutlineIcon, { ...clearIconProps, color: theme.colors['neutral-75'], size: iconScale })), [iconScale]);
    const OptionContentOverride = useCallback((optionProps) => React__default.createElement(OptionContent, { ...optionProps, kind: kind }), [kind]);
    const SearchIconOverride = useCallback(() => (React__default.createElement(SearchOutlineIcon, { color: theme.colors['neutral-75'], size: theme.iconScale['x-small'] })), []);
    const TagOverride = useCallback((optionProps) => {
        const { children, onActionClick } = optionProps;
        return (React__default.createElement(Tag, { disabled: disabled, badgeKind: BADGE_KIND.neutral50, onActionClick: onActionClick, variant: VARIANT.outlined, closeable: true }, children));
    }, [disabled]);
    return (React__default.createElement(Select$1, { disabled: disabled, clearable: clearable, size: size, overrides: {
            ClearIcon: {
                component: ClearIconOverride,
            },
            ControlContainer: StyledControlContainer,
            Dropdown: StyledDropdown,
            DropdownListItem: StyledDropdownListItem,
            Input: StyledInput,
            OptionContent: OptionContentOverride,
            Popover: {
                props: {
                    overrides: {
                        Body: StyledPopoverBody,
                    },
                },
            },
            SearchIcon: {
                component: SearchIconOverride,
            },
            SelectArrow,
            Tag: TagOverride,
            ValueContainer: type === TYPE$1.search
                ? StyledValueContainerWithSearch
                : StyledValueContainer,
            ...overrides,
        }, ...additionalProps }));
};

const StatefulSelect = (props) => (React$2.createElement(StatefulSelectContainer$1, { ...props }, (childrenProps) => (React$2.createElement(Select, { ...childrenProps, ...props }))));

function _objectWithoutProperties$7(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$6(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$6(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$f(Object(source), true).forEach(function (key) { _defineProperty$l(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$l(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var StyledRoot$7 = styled('nav', function (props) {
  var _props$$theme = props.$theme,
      colors = _props$$theme.colors,
      typography = _props$$theme.typography;
  return _objectSpread$f(_objectSpread$f({}, typography.font300), {}, {
    color: colors.contentPrimary,
    listStyleType: 'none',
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0
  });
});
StyledRoot$7.displayName = "StyledRoot";
var StyledNavItemContainer = styled('li', {});
StyledNavItemContainer.displayName = "StyledNavItemContainer";
var StyledNavLink = styled('a', function (_ref) {
  var $theme = _ref.$theme,
      $isFocusVisible = _ref.$isFocusVisible;
  return {
    color: 'inherit',
    outline: 'none',
    textDecoration: 'none',
    ':focus > div': $isFocusVisible ? {
      outline: "3px solid ".concat($theme.colors.accent),
      outlineOffset: '-3px',
      borderLeftColor: 'transparent',
      borderTopColor: 'transparent',
      borderRightColor: 'transparent',
      borderBottomColor: 'transparent'
    } : {
      outline: 'none'
    }
  };
});
StyledNavLink.displayName = "StyledNavLink";
var StyledNavItemElement = styled('div', function (props) {
  var _ref2;

  var $active = props.$active,
      $selectable = props.$selectable,
      $level = props.$level,
      $disabled = props.$disabled,
      $theme = props.$theme,
      _props$$theme2 = props.$theme,
      colors = _props$$theme2.colors,
      sizing = _props$$theme2.sizing;
  var bgImgGradient = hexToRgb(colors.backgroundPrimary, '0.92') || '';
  var borderWidthDir = $theme.direction === 'rtl' ? 'borderRightWidth' : 'borderLeftWidth';
  var borderStyleDir = $theme.direction === 'rtl' ? 'borderRightStyle' : 'borderLeftStyle';
  var borderColorDir = $theme.direction === 'rtl' ? 'borderRightColor' : 'borderLeftColor';
  var paddingPrefixDir = $theme.direction === 'rtl' ? 'paddingRight' : 'paddingLeft';
  var paddingSuffixDir = $theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight';
  var cursor = $selectable ? 'pointer' : 'default';
  var color = $active ? colors.primary : null;
  var hoverColor = $selectable ? colors.primary : null;

  if ($disabled) {
    cursor = 'not-allowed';
    color = colors.contentSecondary;
    hoverColor = null;
  }

  return _ref2 = {
    backgroundColor: $active ? colors.backgroundInversePrimary : 'transparent',
    backgroundImage: $active ? "linear-gradient(0deg, ".concat(bgImgGradient, ", ").concat(bgImgGradient, ")") : null,
    boxSizing: 'border-box'
  }, _defineProperty$l(_ref2, borderWidthDir, '4px'), _defineProperty$l(_ref2, borderStyleDir, 'solid'), _defineProperty$l(_ref2, borderColorDir, $active ? colors.primary : 'transparent'), _defineProperty$l(_ref2, "color", color), _defineProperty$l(_ref2, "cursor", cursor), _defineProperty$l(_ref2, "paddingTop", sizing.scale500), _defineProperty$l(_ref2, "paddingBottom", sizing.scale500), _defineProperty$l(_ref2, paddingPrefixDir, "calc(".concat(sizing.scale800, " * ").concat($level, ")")), _defineProperty$l(_ref2, paddingSuffixDir, sizing.scale500), _defineProperty$l(_ref2, ':hover', {
    color: hoverColor
  }), _defineProperty$l(_ref2, ':focus', {
    color: $selectable ? colors.primary : null
  }), _ref2;
});
StyledNavItemElement.displayName = "StyledNavItemElement";
var StyledNavItem$1 = withWrapper(StyledNavItemElement, function (Styled) {
  return function StyledNav(_ref3) {
    _ref3.item;
        var restProps = _objectWithoutProperties$7(_ref3, ["item"]);

    return /*#__PURE__*/React$2.createElement(Styled, restProps);
  };
});
var StyledSubNavContainer = styled('ul', {
  listStyleType: 'none',
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
});
StyledSubNavContainer.displayName = "StyledSubNavContainer";

function _typeof$6(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$6 = function _typeof(obj) { return typeof obj; }; } else { _typeof$6 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$6(obj); }

function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

function _slicedToArray$c(arr, i) { return _arrayWithHoles$c(arr) || _iterableToArrayLimit$c(arr, i) || _unsupportedIterableToArray$c(arr, i) || _nonIterableRest$c(); }

function _nonIterableRest$c() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$c(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$c(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$c(o, minLen); }

function _arrayLikeToArray$c(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$c(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$c(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties$6(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$5(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$5(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$6(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$7(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$6(Constructor.prototype, protoProps); if (staticProps) _defineProperties$6(Constructor, staticProps); return Constructor; }

function _inherits$7(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$6(subClass, superClass); }

function _setPrototypeOf$6(o, p) { _setPrototypeOf$6 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$6(o, p); }

function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf$6(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$6(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$7(this, result); }; }

function _possibleConstructorReturn$7(self, call) { if (call && (_typeof$6(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$6(self); }

function _assertThisInitialized$6(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$6(o) { _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$6(o); }

function _defineProperty$k(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NavItem = /*#__PURE__*/function (_React$Component) {
  _inherits$7(NavItem, _React$Component);

  var _super = _createSuper$6(NavItem);

  function NavItem() {
    var _this;

    _classCallCheck$7(this, NavItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$k(_assertThisInitialized$6(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          item = _this$props.item,
          onSelect = _this$props.onSelect;

      if (typeof onSelect === 'function') {
        onSelect({
          item: item,
          event: event
        });
      }
    });

    _defineProperty$k(_assertThisInitialized$6(_this), "handleKeyDown", function (event) {
      var _this$props2 = _this.props,
          item = _this$props2.item,
          onSelect = _this$props2.onSelect;

      if (event.key === 'Enter') {
        if (typeof onSelect === 'function') {
          onSelect({
            item: item,
            event: event
          });
        }
      }
    });

    return _this;
  }

  _createClass$7(NavItem, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          item = _this$props3.item,
          overrides = _this$props3.overrides;
          _this$props3.itemMemoizationComparator;
          var sharedProps = _objectWithoutProperties$6(_this$props3, ["item", "overrides", "itemMemoizationComparator"]);

      var _getOverrides = getOverrides(overrides.NavItem, StyledNavItem$1),
          _getOverrides2 = _slicedToArray$c(_getOverrides, 2),
          _NavItem = _getOverrides2[0],
          itemProps = _getOverrides2[1];

      var _getOverrides3 = getOverrides(overrides.NavLink, StyledNavLink),
          _getOverrides4 = _slicedToArray$c(_getOverrides3, 2),
          NavLink = _getOverrides4[0],
          linkProps = _getOverrides4[1];

      var tabIndex = {
        tabIndex: item.disabled ? -1 : undefined
      };
      return /*#__PURE__*/React$2.createElement(NavLink, _extends$e({
        $as: item.disabled ? 'span' : 'a',
        href: item.disabled ? null : item.itemId
      }, tabIndex, sharedProps, linkProps, item.itemId && !item.disabled ? {
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown
      } : {}), /*#__PURE__*/React$2.createElement(_NavItem, _extends$e({
        item: item
      }, sharedProps, itemProps), item.title));
    }
  }]);

  return NavItem;
}(React$2.Component);

_defineProperty$k(NavItem, "defaultProps", {
  overrides: {},
  onSelect: function onSelect() {}
});

function compare(prevProps, nextProps) {
  if (nextProps.itemMemoizationComparator) {
    return nextProps.itemMemoizationComparator(prevProps, nextProps);
  }

  return false;
}

var NavItem$1 = /*#__PURE__*/React$2.memo(NavItem, compare);

function _typeof$5(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$5 = function _typeof(obj) { return typeof obj; }; } else { _typeof$5 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$5(obj); }

function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$e(Object(source), true).forEach(function (key) { _defineProperty$j(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray$b(arr, i) { return _arrayWithHoles$b(arr) || _iterableToArrayLimit$b(arr, i) || _unsupportedIterableToArray$b(arr, i) || _nonIterableRest$b(); }

function _nonIterableRest$b() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$b(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$b(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$b(o, minLen); }

function _arrayLikeToArray$b(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$b(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$b(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$5(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$6(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$5(Constructor.prototype, protoProps); if (staticProps) _defineProperties$5(Constructor, staticProps); return Constructor; }

function _inherits$6(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$5(subClass, superClass); }

function _setPrototypeOf$5(o, p) { _setPrototypeOf$5 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$5(o, p); }

function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf$5(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$5(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$6(this, result); }; }

function _possibleConstructorReturn$6(self, call) { if (call && (_typeof$5(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$5(self); }

function _assertThisInitialized$5(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$5(o) { _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$5(o); }

function _defineProperty$j(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SideNav = /*#__PURE__*/function (_React$Component) {
  _inherits$6(SideNav, _React$Component);

  var _super = _createSuper$5(SideNav);

  function SideNav() {
    var _this;

    _classCallCheck$6(this, SideNav);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$j(_assertThisInitialized$5(_this), "state", {
      isFocusVisible: false
    });

    _defineProperty$j(_assertThisInitialized$5(_this), "handleFocus", function (event) {
      if (isFocusVisible(event)) {
        _this.setState({
          isFocusVisible: true
        });
      }
    });

    _defineProperty$j(_assertThisInitialized$5(_this), "handleBlur", function (event) {
      if (_this.state.isFocusVisible !== false) {
        _this.setState({
          isFocusVisible: false
        });
      }
    });

    _defineProperty$j(_assertThisInitialized$5(_this), "activePredicate", function (item) {
      return item.itemId === _this.props.activeItemId;
    });

    return _this;
  }

  _createClass$6(SideNav, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          activeItemId = _this$props.activeItemId,
          activePredicate = _this$props.activePredicate,
          items = _this$props.items,
          onChange = _this$props.onChange,
          overrides = _this$props.overrides,
          mapItem = _this$props.mapItem;
      var navLevel = 1;

      var _getOverrides = getOverrides(overrides.Root, StyledRoot$7),
          _getOverrides2 = _slicedToArray$b(_getOverrides, 2),
          Root = _getOverrides2[0],
          rootProps = _getOverrides2[1];

      var _getOverrides3 = getOverrides(overrides.NavItemContainer, StyledNavItemContainer),
          _getOverrides4 = _slicedToArray$b(_getOverrides3, 2),
          NavItemContainer = _getOverrides4[0],
          itemContainerProps = _getOverrides4[1];

      var _getOverrides5 = getOverrides(overrides.SubNavContainer, StyledSubNavContainer),
          _getOverrides6 = _slicedToArray$b(_getOverrides5, 2),
          SubNavContainer = _getOverrides6[0],
          subNavContainerProps = _getOverrides6[1];

      var renderNavItem = function renderNavItem(item, level, index, mapItem) {
        if (typeof mapItem === 'function') {
          var recMapItem = function recMapItem(item) {
            var subNav = [];

            if (item.subNav) {
              subNav = item.subNav.map(recMapItem);
            }

            return mapItem(_objectSpread$e(_objectSpread$e({}, item), {}, {
              subNav: subNav
            }));
          };

          item = recMapItem(item);
        }

        var sharedProps = {
          $active: activePredicate ? activePredicate(item, activeItemId) : _this2.activePredicate(item),
          $level: level,
          $selectable: !!item.itemId,
          $disabled: item.disabled || false
        };
        return /*#__PURE__*/React$2.createElement(NavItemContainer, _extends$d({
          key: "".concat(index, "-level").concat(level, "-").concat(typeof item.title === 'string' ? item.title : item.itemId || '')
        }, sharedProps, itemContainerProps, {
          onFocus: forkFocus(itemContainerProps, _this2.handleFocus),
          onBlur: forkBlur(itemContainerProps, _this2.handleBlur)
        }), /*#__PURE__*/React$2.createElement(React$2.Fragment, null, /*#__PURE__*/React$2.createElement(NavItem$1, _extends$d({
          $isFocusVisible: _this2.state.isFocusVisible,
          item: item,
          itemMemoizationComparator: _this2.props.itemMemoizationComparator,
          onSelect: onChange,
          overrides: overrides
        }, sharedProps)), item.subNav ? /*#__PURE__*/React$2.createElement(SubNavContainer, _extends$d({
          role: "list"
        }, sharedProps, subNavContainerProps), item.subNav.map(function (subitem, idx) {
          return renderNavItem(subitem, level + 1, index);
        })) : null));
      };

      return /*#__PURE__*/React$2.createElement(Root, _extends$d({
        role: "navigation",
        "data-baseweb": "side-navigation"
      }, rootProps), /*#__PURE__*/React$2.createElement(SubNavContainer, {
        role: "list"
      }, items.map(function (item, index) {
        return renderNavItem(item, navLevel, index, mapItem);
      })));
    }
  }]);

  return SideNav;
}(React$2.Component);

_defineProperty$j(SideNav, "defaultProps", {
  activeItemId: '/',
  activePredicate: null,
  items: [],
  overrides: {},
  mapItem: null
});

const StyledRoot$6 = themedWithStyle(StyledRoot$7, {
    ...typography$6.LabelSmall,
    display: 'block',
    ...margin('0px'),
    overflowY: 'scroll',
    width: '250px',
    ...padding('0px'),
});
const StyledNavItem = themedWithStyle(StyledNavItem$1, ({ $active, $theme }) => ({
    ...($active ? {
        backgroundColor: $theme.colors['brand-secondary-1-10'],
        backgroundImage: $theme.colors['brand-secondary-1-10'],
        borderLeftColor: $theme.colors['brand-primary'],
    } : {}),
}));

const SideNavigation = (props) => (React$2.createElement(SideNav, { overrides: {
        NavItem: StyledNavItem,
        Root: StyledRoot$6,
    }, ...props }));

var types = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.Direction = void 0;
(function (Direction) {
    Direction["Right"] = "to right";
    Direction["Left"] = "to left";
    Direction["Down"] = "to bottom";
    Direction["Up"] = "to top";
})(exports.Direction || (exports.Direction = {}));
});

unwrapExports(types);
types.Direction;

var utils = createCommonjsModule(function (module, exports) {
var __spreadArrays = (commonjsGlobal && commonjsGlobal.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useThumbOverlap = exports.assertUnreachable = exports.voidFn = exports.getTrackBackground = exports.replaceAt = exports.schd = exports.translate = exports.getClosestThumbIndex = exports.translateThumbs = exports.getPaddingAndBorder = exports.getMargin = exports.checkInitialOverlap = exports.checkValuesAgainstBoundaries = exports.checkBoundaries = exports.isVertical = exports.relativeValue = exports.normalizeValue = exports.isStepDivisible = exports.isTouchEvent = exports.getStepDecimals = void 0;


var getStepDecimals = function (step) {
    var decimals = step.toString().split('.')[1];
    return decimals ? decimals.length : 0;
};
exports.getStepDecimals = getStepDecimals;
function isTouchEvent(event) {
    return ((event.touches && event.touches.length) ||
        (event.changedTouches && event.changedTouches.length));
}
exports.isTouchEvent = isTouchEvent;
function isStepDivisible(min, max, step) {
    var res = (max - min) / step;
    var precision = 8;
    var roundedRes = Number(res.toFixed(precision));
    return parseInt(roundedRes.toString(), 10) === roundedRes;
}
exports.isStepDivisible = isStepDivisible;
function normalizeValue(value, index, min, max, step, allowOverlap, values) {
    var BIG_NUM = 10e10;
    value = Math.round(value * BIG_NUM) / BIG_NUM;
    if (!allowOverlap) {
        var prev = values[index - 1];
        var next = values[index + 1];
        if (prev && prev > value)
            return prev;
        if (next && next < value)
            return next;
    }
    if (value > max)
        return max;
    if (value < min)
        return min;
    // `remainder` is a difference between the given value and a full step value
    // that is closest lower to the given value and is in the range between the min value
    // and the given value
    var remainder = Math.floor(value * BIG_NUM - min * BIG_NUM) %
        Math.floor(step * BIG_NUM);
    var closestLowerNum = Math.floor(value * BIG_NUM - Math.abs(remainder));
    var rounded = remainder === 0 ? value : closestLowerNum / BIG_NUM;
    // Values with a remainder `< step/2` are rounded to the closest lower value
    // while values with a remainder `= > step/2` are rounded to the closest bigger value
    var res = Math.abs(remainder / BIG_NUM) < step / 2
        ? rounded
        : rounded + step;
    var decimalPlaces = exports.getStepDecimals(step);
    return parseFloat(res.toFixed(decimalPlaces));
}
exports.normalizeValue = normalizeValue;
function relativeValue(value, min, max) {
    return (value - min) / (max - min);
}
exports.relativeValue = relativeValue;
function isVertical(direction) {
    return direction === types.Direction.Up || direction === types.Direction.Down;
}
exports.isVertical = isVertical;
function checkBoundaries(value, min, max) {
    if (min >= max) {
        throw new RangeError("min (" + min + ") is equal/bigger than max (" + max + ")");
    }
    if (value < min) {
        throw new RangeError("value (" + value + ") is smaller than min (" + min + ")");
    }
    if (value > max) {
        throw new RangeError("value (" + value + ") is bigger than max (" + max + ")");
    }
}
exports.checkBoundaries = checkBoundaries;
function checkValuesAgainstBoundaries(value, min, max) {
    if (value < min) {
        // set selectedValue to min
        return min;
    }
    if (value > max) {
        // set selectedValue to max
        return max;
    }
    else {
        return value;
    }
}
exports.checkValuesAgainstBoundaries = checkValuesAgainstBoundaries;
function checkInitialOverlap(values) {
    if (values.length < 2)
        return;
    if (!values.slice(1).every(function (item, i) { return values[i] <= item; })) {
        throw new RangeError("values={[" + values + "]} needs to be sorted when allowOverlap={false}");
    }
}
exports.checkInitialOverlap = checkInitialOverlap;
function getMargin(element) {
    var style = window.getComputedStyle(element);
    return {
        top: parseInt(style['margin-top'], 10),
        bottom: parseInt(style['margin-bottom'], 10),
        left: parseInt(style['margin-left'], 10),
        right: parseInt(style['margin-right'], 10)
    };
}
exports.getMargin = getMargin;
function getPaddingAndBorder(element) {
    var style = window.getComputedStyle(element);
    return {
        top: parseInt(style['padding-top'], 10) + parseInt(style['border-top-width'], 10),
        bottom: parseInt(style['padding-bottom'], 10) + parseInt(style['border-bottom-width'], 10),
        left: parseInt(style['padding-left'], 10) + parseInt(style['border-left-width'], 10),
        right: parseInt(style['padding-right'], 10) + parseInt(style['border-right-width'], 10),
    };
}
exports.getPaddingAndBorder = getPaddingAndBorder;
function translateThumbs(elements, offsets, rtl) {
    var inverter = rtl ? -1 : 1;
    elements.forEach(function (element, index) {
        return translate(element, inverter * offsets[index].x, offsets[index].y);
    });
}
exports.translateThumbs = translateThumbs;
/**
 * Util function for calculating the index of the thumb that is closes to a given position
 * @param thumbs - array of Thumb element to calculate the distance from
 * @param clientX - target x position (mouse/touch)
 * @param clientY - target y position (mouse/touch)
 * @param direction - the direction of the track
 */
function getClosestThumbIndex(thumbs, clientX, clientY, direction) {
    var thumbIndex = 0;
    var minThumbDistance = getThumbDistance(thumbs[0], clientX, clientY, direction);
    for (var i = 1; i < thumbs.length; i++) {
        var thumbDistance = getThumbDistance(thumbs[i], clientX, clientY, direction);
        if (thumbDistance < minThumbDistance) {
            minThumbDistance = thumbDistance;
            thumbIndex = i;
        }
    }
    return thumbIndex;
}
exports.getClosestThumbIndex = getClosestThumbIndex;
function translate(element, x, y) {
    element.style.transform = "translate(" + x + "px, " + y + "px)";
}
exports.translate = translate;
// adapted from https://github.com/alexreardon/raf-schd
var schd = function (fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        lastArgs = args;
        if (frameId) {
            return;
        }
        frameId = requestAnimationFrame(function () {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    return wrapperFn;
};
exports.schd = schd;
function replaceAt(values, index, value) {
    var ret = values.slice(0);
    ret[index] = value;
    return ret;
}
exports.replaceAt = replaceAt;
function getTrackBackground(_a) {
    var values = _a.values, colors = _a.colors, min = _a.min, max = _a.max, _b = _a.direction, direction = _b === void 0 ? types.Direction.Right : _b, _c = _a.rtl, rtl = _c === void 0 ? false : _c;
    if (rtl && direction === types.Direction.Right) {
        direction = types.Direction.Left;
    }
    else if (rtl && types.Direction.Left) {
        direction = types.Direction.Right;
    }
    // sort values ascending
    var progress = values.slice(0).sort(function (a, b) { return a - b; }).map(function (value) { return ((value - min) / (max - min)) * 100; });
    var middle = progress.reduce(function (acc, point, index) {
        return acc + ", " + colors[index] + " " + point + "%, " + colors[index + 1] + " " + point + "%";
    }, '');
    return "linear-gradient(" + direction + ", " + colors[0] + " 0%" + middle + ", " + colors[colors.length - 1] + " 100%)";
}
exports.getTrackBackground = getTrackBackground;
function voidFn() { }
exports.voidFn = voidFn;
function assertUnreachable(x) {
    throw new Error("Didn't expect to get here");
}
exports.assertUnreachable = assertUnreachable;
/**
 * Util function for grabbing the true largest width of a thumb
 * including the label
 * @param thumbEl - Thumb element to grab the largest width from
 * @param value - Thumb value, not label value
 * @param separator - Label separator value
 */
var getThumbWidth = function (thumbEl, value, separator, decimalPlaces, valueToLabel) {
    if (valueToLabel === void 0) { valueToLabel = function (value) { return value; }; }
    var width = Math.ceil(__spreadArrays([thumbEl], Array.from(thumbEl.children)).reduce(function (width, el) {
        var elWidth = Math.ceil(el.getBoundingClientRect().width);
        /**
         * If a label contains a merged label value, it won't return the true
         * label width for that Thumb. Clone the label and change the value
         * to that individual Thumb value in order to grab the true width.
         */
        if (el.innerText &&
            el.innerText.includes(separator) &&
            el.childElementCount === 0) {
            var elClone = el.cloneNode(true);
            elClone.innerHTML = valueToLabel(value.toFixed(decimalPlaces));
            elClone.style.visibility = 'hidden';
            document.body.appendChild(elClone);
            elWidth = Math.ceil(elClone.getBoundingClientRect().width);
            document.body.removeChild(elClone);
        }
        return elWidth > width ? elWidth : width;
    }, thumbEl.getBoundingClientRect().width));
    return width;
};
/**
 * Bulk of logic for thumb overlaps
 * Consider a scenario with 5 thumbs;
 * Thumb 1 overlaps with thumb 0 and thumb 2
 * Thumb 2 overlaps with thumb 3
 * We need an array that contains [0, 1, 2, 3]
 * The function needs to return the directly overlapping thumbs
 * and all thumbs overlapping linked to those and so on
 * @param index - Thumb index calculating overlaps for
 * @param offsets - Current Array of Thumb offsets for Range
 * @param thumbs - Array of Thumb elements
 * @param values - Array of Thumb values
 * @param separator - String separator for merged label values
 * @returns overlaps - Array of all overlapping thumbs from the index
 */
var getOverlaps = function (index, offsets, thumbs, values, separator, decimalPlaces, valueToLabel) {
    if (valueToLabel === void 0) { valueToLabel = function (value) { return value; }; }
    var overlaps = [];
    /**
     * Recursive function for building the overlaps Array
     * If an overlap is found, find the overlaps for that overlap
     * @param thumbIndex current Thumb index to find overlaps from
     */
    var buildOverlaps = function (thumbIndex) {
        var thumbXWidth = getThumbWidth(thumbs[thumbIndex], values[thumbIndex], separator, decimalPlaces, valueToLabel);
        var thumbX = offsets[thumbIndex].x;
        /**
         * Iterate through the Thumb offsets, if there is a match
         * add the thumbIndex and siblingIndex to the overlaps Array
         *
         * Then build overlaps from the overlapping siblingIndex
         */
        offsets.forEach(function (_a, siblingIndex) {
            var siblingX = _a.x;
            var siblingWidth = getThumbWidth(thumbs[siblingIndex], values[siblingIndex], separator, decimalPlaces, valueToLabel);
            if (thumbIndex !== siblingIndex &&
                ((thumbX >= siblingX && thumbX <= siblingX + siblingWidth) ||
                    (thumbX + thumbXWidth >= siblingX &&
                        thumbX + thumbXWidth <= siblingX + siblingWidth))) {
                if (!overlaps.includes(siblingIndex)) {
                    overlaps.push(thumbIndex);
                    overlaps.push(siblingIndex);
                    overlaps = __spreadArrays(overlaps, [thumbIndex, siblingIndex]);
                    buildOverlaps(siblingIndex);
                }
            }
        });
    };
    buildOverlaps(index);
    // Sort and remove duplicates from the built overlaps
    return Array.from(new Set(overlaps.sort()));
};
/**
 * A custom React Hook for calculating whether a thumb overlaps
 * another and whether labels could/should merge.
 * @param rangeRef - React ref value of Range component
 * @param values - current Range values Array
 * @param index - thumb index
 * @param step - step value, used to calculate the number of decimal places
 * @param separator - string to separate thumb values
 * @returns label value + styling for thumb label
 */
var useThumbOverlap = function (rangeRef, values, index, step, separator, valueToLabel) {
    if (step === void 0) { step = 0.1; }
    if (separator === void 0) { separator = ' - '; }
    if (valueToLabel === void 0) { valueToLabel = function (value) { return value; }; }
    var decimalPlaces = exports.getStepDecimals(step);
    // Create initial label style and value. Label value defaults to thumb value
    var _a = React__default.useState({}), labelStyle = _a[0], setLabelStyle = _a[1];
    var _b = React__default.useState(valueToLabel(values[index].toFixed(decimalPlaces))), labelValue = _b[0], setLabelValue = _b[1];
    // When the rangeRef or values change, update the Thumb label values and styling
    React__default.useEffect(function () {
        if (rangeRef) {
            var thumbs = rangeRef.getThumbs();
            if (thumbs.length < 1)
                return;
            var newStyle = {};
            var offsets_1 = rangeRef.getOffsets();
            /**
             * Get any overlaps for the given Thumb index. This must return all linked
             * Thumbs. So if there are 4 Thumbs and Thumbs 2, 3 and 4 overlap. If we are
             * getting the overlaps for Thumb 1 and it overlaps only Thumb 2, we must get
             * 2, 3 and 4 also.
             */
            var overlaps = getOverlaps(index, offsets_1, thumbs, values, separator, decimalPlaces, valueToLabel);
            // Set a default label value of the Thumb value
            var labelValue_1 = valueToLabel(values[index].toFixed(decimalPlaces));
            /**
             * If there are overlaps for the Thumb, we need to calculate the correct
             * Label value along with the relevant styling. We only want to show a Label
             * for the left most Thumb in an overlapping set.
             * All other Thumbs will be set to display: none.
             */
            if (overlaps.length) {
                /**
                 * Get an Array of the offsets for the overlapping Thumbs
                 * This is so we can determine if the Thumb we are looking at
                 * is the left most thumb in an overlapping set
                 */
                var offsetsX = overlaps.reduce(function (a, c, i, s) {
                    return a.length ? __spreadArrays(a, [offsets_1[s[i]].x]) : [offsets_1[s[i]].x];
                }, []);
                /**
                 * If our Thumb is the left most Thumb, we can build a Label value
                 * and set the style for that Label
                 */
                if (Math.min.apply(Math, offsetsX) === offsets_1[index].x) {
                    /**
                     * First calculate the Label value. To do this,
                     * grab all the values for the Thumbs in our overlaps.
                     * Then convert that to a Set and sort it whilst removing duplicates.
                     */
                    var labelValues_1 = [];
                    overlaps.forEach(function (thumb) {
                        labelValues_1.push(values[thumb].toFixed(decimalPlaces));
                    });
                    /**
                     *  Update the labelValue with the resulting Array
                     *  joined by our defined separator
                     */
                    labelValue_1 = Array.from(new Set(labelValues_1.sort(function (a, b) { return parseFloat(a) - parseFloat(b); })))
                        .map(valueToLabel)
                        .join(separator);
                    /**
                     * Lastly, build the label styling. The label styling will
                     * position the label and apply a transform so that it's centered.
                     * We want the center point between the left edge of the left most Thumb
                     * and the right edge of the right most Thumb.
                     */
                    var first = Math.min.apply(Math, offsetsX);
                    var last = Math.max.apply(Math, offsetsX);
                    var lastWidth = thumbs[overlaps[offsetsX.indexOf(last)]].getBoundingClientRect().width;
                    newStyle.left = Math.abs(first - (last + lastWidth)) / 2 + "px";
                    newStyle.transform = 'translate(-50%, 0)';
                }
                else {
                    // If the Thumb isn't the left most Thumb, hide the Label!
                    newStyle.visibility = 'hidden';
                }
            }
            // Update the label value and style
            setLabelValue(labelValue_1);
            setLabelStyle(newStyle);
        }
    }, [rangeRef, values]);
    return [labelValue, labelStyle];
};
exports.useThumbOverlap = useThumbOverlap;
/**
 * Util function for calculating the distance of the center of a thumb
 * form a given mouse/touch target's position
 * @param thumbEl - Thumb element to calculate the distance from
 * @param clientX - target x position (mouse/touch)
 * @param clientY - target y position (mouse/touch)
 * @param direction - the direction of the track
 */
function getThumbDistance(thumbEl, clientX, clientY, direction) {
    var _a = thumbEl.getBoundingClientRect(), left = _a.left, top = _a.top, width = _a.width, height = _a.height;
    return isVertical(direction) ? Math.abs(clientY - (top + height / 2)) : Math.abs(clientX - (left + width / 2));
}
});

unwrapExports(utils);
utils.useThumbOverlap;
utils.assertUnreachable;
utils.voidFn;
utils.getTrackBackground;
utils.replaceAt;
utils.schd;
utils.translate;
utils.getClosestThumbIndex;
utils.translateThumbs;
utils.getPaddingAndBorder;
utils.getMargin;
utils.checkInitialOverlap;
utils.checkValuesAgainstBoundaries;
utils.checkBoundaries;
utils.isVertical;
utils.relativeValue;
utils.normalizeValue;
utils.isStepDivisible;
utils.isTouchEvent;
utils.getStepDecimals;

var Range_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (commonjsGlobal && commonjsGlobal.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(React__default);


var INCREASE_KEYS = ['ArrowRight', 'ArrowUp', 'k', 'PageUp'];
var DECREASE_KEYS = ['ArrowLeft', 'ArrowDown', 'j', 'PageDown'];
var Range = /** @class */ (function (_super) {
    __extends(Range, _super);
    function Range(props) {
        var _this = _super.call(this, props) || this;
        _this.trackRef = React.createRef();
        _this.thumbRefs = [];
        _this.markRefs = [];
        _this.state = {
            draggedTrackPos: [-1, -1],
            draggedThumbIndex: -1,
            thumbZIndexes: new Array(_this.props.values.length).fill(0).map(function (t, i) { return i; }),
            isChanged: false,
            markOffsets: []
        };
        _this.getOffsets = function () {
            var _a = _this.props, direction = _a.direction, values = _a.values, min = _a.min, max = _a.max;
            var trackElement = _this.trackRef.current;
            var trackRect = trackElement.getBoundingClientRect();
            var trackPadding = utils.getPaddingAndBorder(trackElement);
            return _this.getThumbs().map(function (thumb, index) {
                var thumbOffsets = { x: 0, y: 0 };
                var thumbRect = thumb.getBoundingClientRect();
                var thumbMargins = utils.getMargin(thumb);
                switch (direction) {
                    case types.Direction.Right:
                        thumbOffsets.x = (thumbMargins.left + trackPadding.left) * -1;
                        thumbOffsets.y =
                            ((thumbRect.height - trackRect.height) / 2 + trackPadding.top) * -1;
                        thumbOffsets.x +=
                            trackRect.width * utils.relativeValue(values[index], min, max) -
                                thumbRect.width / 2;
                        return thumbOffsets;
                    case types.Direction.Left:
                        thumbOffsets.x = (thumbMargins.right + trackPadding.right) * -1;
                        thumbOffsets.y =
                            ((thumbRect.height - trackRect.height) / 2 + trackPadding.top) * -1;
                        thumbOffsets.x +=
                            trackRect.width -
                                trackRect.width * utils.relativeValue(values[index], min, max) -
                                thumbRect.width / 2;
                        return thumbOffsets;
                    case types.Direction.Up:
                        thumbOffsets.x =
                            ((thumbRect.width - trackRect.width) / 2 +
                                thumbMargins.left +
                                trackPadding.left) *
                                -1;
                        thumbOffsets.y = -trackPadding.left;
                        thumbOffsets.y +=
                            trackRect.height -
                                trackRect.height * utils.relativeValue(values[index], min, max) -
                                thumbRect.height / 2;
                        return thumbOffsets;
                    case types.Direction.Down:
                        thumbOffsets.x =
                            ((thumbRect.width - trackRect.width) / 2 +
                                thumbMargins.left +
                                trackPadding.left) *
                                -1;
                        thumbOffsets.y = -trackPadding.left;
                        thumbOffsets.y +=
                            trackRect.height * utils.relativeValue(values[index], min, max) -
                                thumbRect.height / 2;
                        return thumbOffsets;
                    default:
                        return utils.assertUnreachable(direction);
                }
            });
        };
        _this.getThumbs = function () {
            if (_this.trackRef && _this.trackRef.current) {
                return Array.from(_this.trackRef.current.children).filter(function (el) {
                    return el.hasAttribute('aria-valuenow');
                });
            }
            console.warn('No thumbs found in the track container. Did you forget to pass & spread the `props` param in renderTrack?');
            return [];
        };
        _this.getTargetIndex = function (e) {
            return _this.getThumbs().findIndex(function (child) { return child === e.target || child.contains(e.target); });
        };
        _this.addTouchEvents = function (e) {
            document.addEventListener('touchmove', _this.schdOnTouchMove, {
                passive: false
            });
            document.addEventListener('touchend', _this.schdOnEnd, {
                passive: false
            });
            document.addEventListener('touchcancel', _this.schdOnEnd, {
                passive: false
            });
        };
        _this.addMouseEvents = function (e) {
            document.addEventListener('mousemove', _this.schdOnMouseMove);
            document.addEventListener('mouseup', _this.schdOnEnd);
        };
        _this.onMouseDownTrack = function (e) {
            var _a;
            if (e.button !== 0)
                return;
            e.persist();
            e.preventDefault();
            _this.addMouseEvents(e.nativeEvent);
            if (_this.props.values.length > 1 && _this.props.draggableTrack) {
                if (_this.thumbRefs.some(function (thumbRef) { var _a; return (_a = thumbRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target); }))
                    return;
                // handle dragging the whole track
                _this.setState({
                    draggedTrackPos: [e.clientX, e.clientY]
                }, function () { return _this.onMove(e.clientX, e.clientY); });
            }
            else {
                // get the index of the thumb that is closest to the place where the track is clicked
                var draggedThumbIndex = utils.getClosestThumbIndex(_this.thumbRefs.map(function (t) { return t.current; }), e.clientX, e.clientY, _this.props.direction);
                // move the thumb which is closest to the place where the track is clicked
                (_a = _this.thumbRefs[draggedThumbIndex].current) === null || _a === void 0 ? void 0 : _a.focus();
                _this.setState({
                    draggedThumbIndex: draggedThumbIndex
                }, function () { return _this.onMove(e.clientX, e.clientY); });
            }
        };
        _this.onResize = function () {
            utils.translateThumbs(_this.getThumbs(), _this.getOffsets(), _this.props.rtl);
            _this.calculateMarkOffsets();
        };
        _this.onTouchStartTrack = function (e) {
            var _a;
            e.persist();
            _this.addTouchEvents(e.nativeEvent);
            if (_this.props.values.length > 1 && _this.props.draggableTrack) {
                if (_this.thumbRefs.some(function (thumbRef) { var _a; return (_a = thumbRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target); }))
                    return;
                // handle dragging the whole track
                _this.setState({
                    draggedTrackPos: [e.touches[0].clientX, e.touches[0].clientY]
                }, function () { return _this.onMove(e.touches[0].clientX, e.touches[0].clientY); });
            }
            else {
                // get the index of the thumb that is closest to the place where the track is clicked
                var draggedThumbIndex = utils.getClosestThumbIndex(_this.thumbRefs.map(function (t) { return t.current; }), e.touches[0].clientX, e.touches[0].clientY, _this.props.direction);
                // move the thumb which is closest to the place where the track is clicked
                (_a = _this.thumbRefs[draggedThumbIndex].current) === null || _a === void 0 ? void 0 : _a.focus();
                _this.setState({
                    draggedThumbIndex: draggedThumbIndex
                }, function () { return _this.onMove(e.touches[0].clientX, e.touches[0].clientY); });
            }
        };
        _this.onMouseOrTouchStart = function (e) {
            if (_this.props.disabled)
                return;
            var isTouch = utils.isTouchEvent(e);
            if (!isTouch && e.button !== 0)
                return;
            var index = _this.getTargetIndex(e);
            if (index === -1)
                return;
            if (isTouch) {
                _this.addTouchEvents(e);
            }
            else {
                _this.addMouseEvents(e);
            }
            _this.setState({
                draggedThumbIndex: index,
                thumbZIndexes: _this.state.thumbZIndexes.map(function (t, i) {
                    if (i === index) {
                        return Math.max.apply(Math, _this.state.thumbZIndexes);
                    }
                    return t <= _this.state.thumbZIndexes[index] ? t : t - 1;
                })
            });
        };
        _this.onMouseMove = function (e) {
            e.preventDefault();
            _this.onMove(e.clientX, e.clientY);
        };
        _this.onTouchMove = function (e) {
            e.preventDefault();
            _this.onMove(e.touches[0].clientX, e.touches[0].clientY);
        };
        _this.onKeyDown = function (e) {
            var _a = _this.props, values = _a.values, onChange = _a.onChange, step = _a.step, rtl = _a.rtl, direction = _a.direction;
            var isChanged = _this.state.isChanged;
            var index = _this.getTargetIndex(e.nativeEvent);
            var inverter = rtl || direction === types.Direction.Left || direction === types.Direction.Down
                ? -1
                : 1;
            if (index === -1)
                return;
            if (INCREASE_KEYS.includes(e.key)) {
                e.preventDefault();
                _this.setState({
                    draggedThumbIndex: index,
                    isChanged: true
                });
                onChange(utils.replaceAt(values, index, _this.normalizeValue(values[index] + inverter * (e.key === 'PageUp' ? step * 10 : step), index)));
            }
            else if (DECREASE_KEYS.includes(e.key)) {
                e.preventDefault();
                _this.setState({
                    draggedThumbIndex: index,
                    isChanged: true
                });
                onChange(utils.replaceAt(values, index, _this.normalizeValue(values[index] -
                    inverter * (e.key === 'PageDown' ? step * 10 : step), index)));
            }
            else if (e.key === 'Tab') {
                _this.setState({ draggedThumbIndex: -1 }, function () {
                    // If key pressed when thumb was moving, fire onFinalChange
                    if (isChanged) {
                        _this.fireOnFinalChange();
                    }
                });
            }
            else {
                if (isChanged) {
                    _this.fireOnFinalChange();
                }
            }
        };
        _this.onKeyUp = function (e) {
            var isChanged = _this.state.isChanged;
            _this.setState({
                draggedThumbIndex: -1
            }, function () {
                if (isChanged) {
                    _this.fireOnFinalChange();
                }
            });
        };
        _this.onMove = function (clientX, clientY) {
            var _a = _this.state, draggedThumbIndex = _a.draggedThumbIndex, draggedTrackPos = _a.draggedTrackPos;
            var _b = _this.props, direction = _b.direction, min = _b.min, max = _b.max, onChange = _b.onChange, values = _b.values, step = _b.step, rtl = _b.rtl;
            if (draggedThumbIndex === -1 &&
                draggedTrackPos[0] === -1 &&
                draggedTrackPos[1] === -1)
                return null;
            var trackElement = _this.trackRef.current;
            // If component was closed down prematurely, A last onMove could be triggered based on requestAnimationFrame()
            if (!trackElement)
                return null;
            var trackRect = trackElement.getBoundingClientRect();
            var trackLength = utils.isVertical(direction)
                ? trackRect.height
                : trackRect.width;
            if (draggedTrackPos[0] !== -1 && draggedTrackPos[1] !== -1) {
                // calculate how much it moved since the last update
                var dX = clientX - draggedTrackPos[0];
                var dY = clientY - draggedTrackPos[1];
                // calculate the delta of the value
                var deltaValue = 0;
                switch (direction) {
                    case types.Direction.Right:
                    case types.Direction.Left:
                        deltaValue = (dX / trackLength) * (max - min);
                        break;
                    case types.Direction.Down:
                    case types.Direction.Up:
                        deltaValue = (dY / trackLength) * (max - min);
                        break;
                    default:
                        utils.assertUnreachable(direction);
                }
                // invert for RTL
                if (rtl) {
                    deltaValue *= -1;
                }
                if (Math.abs(deltaValue) >= step / 2) {
                    // adjust delta so it fits into the range
                    for (var i = 0; i < _this.thumbRefs.length; i++) {
                        if ((values[i] === max && Math.sign(deltaValue) === 1) ||
                            (values[i] === min && Math.sign(deltaValue) === -1))
                            return;
                        var thumbValue = values[i] + deltaValue;
                        if (thumbValue > max)
                            deltaValue = max - values[i];
                        else if (thumbValue < min)
                            deltaValue = min - values[i];
                    }
                    // add the delta to each thumb
                    var newValues = values.slice(0);
                    for (var i = 0; i < _this.thumbRefs.length; i++) {
                        newValues = utils.replaceAt(newValues, i, _this.normalizeValue(values[i] + deltaValue, i));
                    }
                    _this.setState({
                        draggedTrackPos: [clientX, clientY]
                    });
                    onChange(newValues);
                }
            }
            else {
                var newValue = 0;
                switch (direction) {
                    case types.Direction.Right:
                        newValue =
                            ((clientX - trackRect.left) / trackLength) * (max - min) + min;
                        break;
                    case types.Direction.Left:
                        newValue =
                            ((trackLength - (clientX - trackRect.left)) / trackLength) *
                                (max - min) +
                                min;
                        break;
                    case types.Direction.Down:
                        newValue =
                            ((clientY - trackRect.top) / trackLength) * (max - min) + min;
                        break;
                    case types.Direction.Up:
                        newValue =
                            ((trackLength - (clientY - trackRect.top)) / trackLength) *
                                (max - min) +
                                min;
                        break;
                    default:
                        utils.assertUnreachable(direction);
                }
                // invert for RTL
                if (rtl) {
                    newValue = max + min - newValue;
                }
                if (Math.abs(values[draggedThumbIndex] - newValue) >= step / 2) {
                    onChange(utils.replaceAt(values, draggedThumbIndex, _this.normalizeValue(newValue, draggedThumbIndex)));
                }
            }
        };
        _this.normalizeValue = function (value, index) {
            var _a = _this.props, min = _a.min, max = _a.max, step = _a.step, allowOverlap = _a.allowOverlap, values = _a.values;
            return utils.normalizeValue(value, index, min, max, step, allowOverlap, values);
        };
        _this.onEnd = function (e) {
            e.preventDefault();
            document.removeEventListener('mousemove', _this.schdOnMouseMove);
            document.removeEventListener('touchmove', _this.schdOnTouchMove);
            document.removeEventListener('mouseup', _this.schdOnEnd);
            document.removeEventListener('touchend', _this.schdOnEnd);
            document.removeEventListener('touchcancel', _this.schdOnEnd);
            if (_this.state.draggedThumbIndex === -1 &&
                _this.state.draggedTrackPos[0] === -1 &&
                _this.state.draggedTrackPos[1] === -1)
                return null;
            _this.setState({ draggedThumbIndex: -1, draggedTrackPos: [-1, -1] }, function () {
                _this.fireOnFinalChange();
            });
        };
        _this.fireOnFinalChange = function () {
            _this.setState({ isChanged: false });
            var _a = _this.props, onFinalChange = _a.onFinalChange, values = _a.values;
            if (onFinalChange) {
                onFinalChange(values);
            }
        };
        _this.calculateMarkOffsets = function () {
            if (!_this.props.renderMark ||
                !_this.trackRef ||
                _this.trackRef.current === null)
                return;
            var elStyles = window.getComputedStyle(_this.trackRef.current);
            var trackWidth = parseInt(elStyles.width, 10);
            var trackHeight = parseInt(elStyles.height, 10);
            var paddingLeft = parseInt(elStyles.paddingLeft, 10);
            var paddingTop = parseInt(elStyles.paddingTop, 10);
            var res = [];
            for (var i = 0; i < _this.numOfMarks + 1; i++) {
                var markHeight = 9999;
                var markWidth = 9999;
                if (_this.markRefs[i].current) {
                    var markRect = _this.markRefs[i].current.getBoundingClientRect();
                    markHeight = markRect.height;
                    markWidth = markRect.width;
                }
                if (_this.props.direction === types.Direction.Left ||
                    _this.props.direction === types.Direction.Right) {
                    res.push([
                        Math.round((trackWidth / _this.numOfMarks) * i + paddingLeft - markWidth / 2),
                        -Math.round((markHeight - trackHeight) / 2)
                    ]);
                }
                else {
                    res.push([
                        Math.round((trackHeight / _this.numOfMarks) * i + paddingTop - markHeight / 2),
                        -Math.round((markWidth - trackWidth) / 2)
                    ]);
                }
            }
            _this.setState({ markOffsets: res });
        };
        if (props.step === 0) {
            throw new Error('"step" property should be a positive number');
        }
        _this.numOfMarks = (props.max - props.min) / _this.props.step;
        _this.schdOnMouseMove = utils.schd(_this.onMouseMove);
        _this.schdOnTouchMove = utils.schd(_this.onTouchMove);
        _this.schdOnEnd = utils.schd(_this.onEnd);
        _this.thumbRefs = props.values.map(function () { return React.createRef(); });
        for (var i = 0; i < _this.numOfMarks + 1; i++) {
            _this.markRefs[i] = React.createRef();
        }
        return _this;
    }
    Range.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, values = _a.values, min = _a.min, step = _a.step;
        this.resizeObserver = window.ResizeObserver
            ? new window.ResizeObserver(this.onResize)
            : {
                observe: function () { return window.addEventListener('resize', _this.onResize); },
                unobserve: function () { return window.removeEventListener('resize', _this.onResize); }
            };
        document.addEventListener('touchstart', this.onMouseOrTouchStart, {
            passive: false
        });
        document.addEventListener('mousedown', this.onMouseOrTouchStart, {
            passive: false
        });
        !this.props.allowOverlap && utils.checkInitialOverlap(this.props.values);
        this.props.values.forEach(function (value) {
            return utils.checkBoundaries(value, _this.props.min, _this.props.max);
        });
        this.resizeObserver.observe(this.trackRef.current);
        utils.translateThumbs(this.getThumbs(), this.getOffsets(), this.props.rtl);
        this.calculateMarkOffsets();
        values.forEach(function (value) {
            if (!utils.isStepDivisible(min, value, step)) {
                console.warn('The `values` property is in conflict with the current `step`, `min`, and `max` properties. Please provide values that are accessible using the min, max, and step values.');
            }
        });
    };
    Range.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this.props, max = _a.max, min = _a.min, step = _a.step, values = _a.values, rtl = _a.rtl;
        if (prevProps.max !== max ||
            prevProps.min !== min ||
            prevProps.step !== step) {
            this.markRefs = [];
            this.numOfMarks = (max - min) / step;
            for (var i = 0; i < this.numOfMarks + 1; i++) {
                this.markRefs[i] = React.createRef();
            }
        }
        utils.translateThumbs(this.getThumbs(), this.getOffsets(), rtl);
        // ensure offsets are calculated when the refs for the marks have been created
        // and those refs have been mounted to the dom
        // on the state update in calculateOffsets with new markOffsets are calculated
        if (prevProps.max !== max ||
            prevProps.min !== min ||
            prevProps.step !== step ||
            prevState.markOffsets.length !== this.state.markOffsets.length) {
            this.calculateMarkOffsets();
            values.forEach(function (value) {
                if (!utils.isStepDivisible(min, value, step)) {
                    console.warn('The `values` property is in conflict with the current `step`, `min`, and `max` properties. Please provide values that are accessible using the min, max, and step values.');
                }
            });
        }
    };
    Range.prototype.componentWillUnmount = function () {
        var options = {
            passive: false
        };
        document.removeEventListener('mousedown', this.onMouseOrTouchStart, options);
        // These need to be removed!!
        document.removeEventListener('mousemove', this.schdOnMouseMove);
        document.removeEventListener('touchmove', this.schdOnTouchMove);
        document.removeEventListener('touchstart', this.onMouseOrTouchStart);
        document.removeEventListener('mouseup', this.schdOnEnd);
        document.removeEventListener('touchend', this.schdOnEnd);
        this.resizeObserver.unobserve(this.trackRef.current);
    };
    Range.prototype.render = function () {
        var _this = this;
        var _a = this.props, renderTrack = _a.renderTrack, renderThumb = _a.renderThumb, _b = _a.renderMark, renderMark = _b === void 0 ? function () { return null; } : _b, values = _a.values, min = _a.min, max = _a.max, allowOverlap = _a.allowOverlap, disabled = _a.disabled;
        var _c = this.state, draggedThumbIndex = _c.draggedThumbIndex, thumbZIndexes = _c.thumbZIndexes, markOffsets = _c.markOffsets;
        return renderTrack({
            props: {
                style: {
                    // creates stacking context that prevents z-index applied to thumbs
                    // interfere with other elements
                    transform: 'scale(1)',
                    cursor: draggedThumbIndex > -1
                        ? 'grabbing'
                        : this.props.draggableTrack
                            ? utils.isVertical(this.props.direction)
                                ? 'ns-resize'
                                : 'ew-resize'
                            : values.length === 1 && !disabled
                                ? 'pointer'
                                : 'inherit'
                },
                onMouseDown: disabled ? utils.voidFn : this.onMouseDownTrack,
                onTouchStart: disabled ? utils.voidFn : this.onTouchStartTrack,
                ref: this.trackRef
            },
            isDragged: this.state.draggedThumbIndex > -1,
            disabled: disabled,
            children: __spreadArrays(markOffsets.map(function (offset, index, arr) {
                return renderMark({
                    props: {
                        style: _this.props.direction === types.Direction.Left ||
                            _this.props.direction === types.Direction.Right
                            ? {
                                position: 'absolute',
                                left: offset[0] + "px",
                                marginTop: offset[1] + "px"
                            }
                            : {
                                position: 'absolute',
                                top: offset[0] + "px",
                                marginLeft: offset[1] + "px"
                            },
                        key: "mark" + index,
                        ref: _this.markRefs[index]
                    },
                    index: index
                });
            }), values.map(function (value, index) {
                var isDragged = _this.state.draggedThumbIndex === index;
                return renderThumb({
                    index: index,
                    value: value,
                    isDragged: isDragged,
                    props: {
                        style: {
                            position: 'absolute',
                            zIndex: thumbZIndexes[index],
                            cursor: disabled ? 'inherit' : isDragged ? 'grabbing' : 'grab',
                            userSelect: 'none',
                            touchAction: 'none',
                            WebkitUserSelect: 'none',
                            MozUserSelect: 'none',
                            msUserSelect: 'none'
                        },
                        key: index,
                        tabIndex: disabled ? undefined : 0,
                        'aria-valuemax': allowOverlap ? max : values[index + 1] || max,
                        'aria-valuemin': allowOverlap ? min : values[index - 1] || min,
                        'aria-valuenow': value,
                        draggable: false,
                        ref: _this.thumbRefs[index],
                        role: 'slider',
                        onKeyDown: disabled ? utils.voidFn : _this.onKeyDown,
                        onKeyUp: disabled ? utils.voidFn : _this.onKeyUp
                    }
                });
            }))
        });
    };
    Range.defaultProps = {
        step: 1,
        direction: types.Direction.Right,
        rtl: false,
        disabled: false,
        allowOverlap: false,
        draggableTrack: false,
        min: 0,
        max: 100
    };
    return Range;
}(React.Component));
exports.default = Range;
});

unwrapExports(Range_1);

var lib = createCommonjsModule(function (module, exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkValuesAgainstBoundaries = exports.relativeValue = exports.useThumbOverlap = exports.Direction = exports.getTrackBackground = exports.Range = void 0;
var Range_1$1 = __importDefault(Range_1);
exports.Range = Range_1$1.default;

Object.defineProperty(exports, "getTrackBackground", { enumerable: true, get: function () { return utils.getTrackBackground; } });
Object.defineProperty(exports, "useThumbOverlap", { enumerable: true, get: function () { return utils.useThumbOverlap; } });
Object.defineProperty(exports, "relativeValue", { enumerable: true, get: function () { return utils.relativeValue; } });
Object.defineProperty(exports, "checkValuesAgainstBoundaries", { enumerable: true, get: function () { return utils.checkValuesAgainstBoundaries; } });

Object.defineProperty(exports, "Direction", { enumerable: true, get: function () { return types.Direction; } });
});

unwrapExports(lib);
lib.checkValuesAgainstBoundaries;
lib.relativeValue;
lib.useThumbOverlap;
lib.Direction;
var lib_5 = lib.getTrackBackground;
var lib_6 = lib.Range;

function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$d(Object(source), true).forEach(function (key) { _defineProperty$i(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$i(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Root$1 = styled('div', {
  position: 'relative',
  width: '100%'
});
Root$1.displayName = "Root";
Root$1.displayName = 'StyledRoot';
var Track = styled('div', function (props) {
  var $theme = props.$theme,
      _props$$value = props.$value,
      $value = _props$$value === void 0 ? [] : _props$$value,
      $disabled = props.$disabled,
      $isDragged = props.$isDragged;
  var sizing = $theme.sizing;
  var cursor = 'inherit';

  if ($disabled) {
    cursor = 'not-allowed';
  } else if ($isDragged) {
    cursor = 'grabbing';
  } else if ($value.length === 1) {
    cursor = 'pointer';
  }

  return {
    paddingTop: sizing.scale600,
    paddingBottom: sizing.scale600,
    paddingRight: sizing.scale600,
    paddingLeft: sizing.scale600,
    display: 'flex',
    cursor: cursor,
    backgroundColor: $theme.colors.sliderTrackFill
  };
});
Track.displayName = "Track";
Track.displayName = 'StyledTrack';
var InnerTrack = styled('div', function (props) {
  var $theme = props.$theme,
      _props$$value2 = props.$value,
      $value = _props$$value2 === void 0 ? [] : _props$$value2,
      $min = props.$min,
      $max = props.$max,
      $disabled = props.$disabled;
  var colors = $theme.colors,
      borders = $theme.borders,
      direction = $theme.direction;
  var borderRadius = $theme.borders.useRoundedCorners ? borders.radius100 : 0;
  return {
    borderTopLeftRadius: borderRadius,
    borderTopRightRadius: borderRadius,
    borderBottomRightRadius: borderRadius,
    borderBottomLeftRadius: borderRadius,
    background: lib_5({
      values: $value,
      colors: $value.length === 1 ? [$disabled ? colors.borderOpaque : colors.primary, $disabled ? colors.backgroundSecondary : colors.borderOpaque] : [$disabled ? colors.backgroundSecondary : colors.borderOpaque, $disabled ? colors.borderOpaque : colors.primary, $disabled ? colors.backgroundSecondary : colors.borderOpaque],
      min: $min || 0,
      max: $max || 0,
      rtl: direction === 'rtl'
    }),
    height: '2px',
    width: '100%',
    alignSelf: 'center',
    cursor: $disabled ? 'not-allowed' : 'inherit'
  };
});
InnerTrack.displayName = "InnerTrack";
InnerTrack.displayName = 'StyledInnerTrack';
var Mark = styled('div', function (props) {
  return {
    width: '4px',
    height: '2px',
    backgroundColor: props.$theme.colors.backgroundPrimary,
    marginLeft: '16px'
  };
});
Mark.displayName = "Mark";
Mark.displayName = 'StyledMark';
var Tick = styled('div', function (props) {
  return _objectSpread$d(_objectSpread$d({}, props.$theme.typography.font200), {}, {
    color: props.$theme.colors.contentPrimary
  });
});
Tick.displayName = "Tick";
Tick.displayName = 'StyledTick';
var TickBar = styled('div', function (props) {
  var $theme = props.$theme;
  var sizing = $theme.sizing;
  return {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: sizing.scale600,
    paddingLeft: sizing.scale600,
    paddingBottom: sizing.scale400
  };
});
TickBar.displayName = "TickBar";
TickBar.displayName = 'StyledTickBar';
var Thumb = styled('div', function (props) {
  var $theme = props.$theme,
      _props$$value3 = props.$value,
      $value = _props$$value3 === void 0 ? [] : _props$$value3,
      $thumbIndex = props.$thumbIndex,
      $disabled = props.$disabled;
  var isLeft = $value.length === 2 && $thumbIndex === 0;
  var isRight = $value.length === 2 && $thumbIndex === 1;

  if ($theme.direction === 'rtl' && (isRight || isLeft)) {
    isLeft = !isLeft;
    isRight = !isRight;
  }

  return {
    height: '24px',
    width: '24px',
    borderTopLeftRadius: '24px',
    borderTopRightRadius: '24px',
    borderBottomLeftRadius: '24px',
    borderBottomRightRadius: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: $disabled ? $theme.colors.sliderHandleFillDisabled : $theme.colors.sliderHandleFill,
    outline: 'none',
    boxShadow: props.$isFocusVisible ? "0 0 0 3px ".concat($theme.colors.accent) : '0 1px 4px rgba(0, 0, 0, 0.12)',
    cursor: $disabled ? 'not-allowed' : 'inherit'
  };
});
Thumb.displayName = "Thumb";
Thumb.displayName = 'StyledThumb';
var InnerThumb = styled('div', function (props) {
  var $disabled = props.$disabled,
      $theme = props.$theme;
  return {
    position: 'absolute',
    top: '-16px',
    width: '4px',
    height: '20px',
    backgroundColor: $disabled ? $theme.colors.sliderHandleFillDisabled : $theme.colors.sliderHandleInnerFill
  };
});
InnerThumb.displayName = "InnerThumb";
InnerThumb.displayName = 'StyledInnerThumb';
var ThumbValue = styled('div', function (props) {
  var $disabled = props.$disabled,
      $theme = props.$theme;
  return _objectSpread$d(_objectSpread$d({
    position: 'absolute',
    top: "-".concat($theme.sizing.scale1400)
  }, $theme.typography.font200), {}, {
    backgroundColor: $disabled ? $theme.colors.sliderHandleFillDisabled : $theme.colors.sliderHandleInnerFill,
    color: $theme.colors.contentInversePrimary,
    paddingLeft: $theme.sizing.scale600,
    paddingRight: $theme.sizing.scale600,
    paddingTop: $theme.sizing.scale500,
    paddingBottom: $theme.sizing.scale500,
    borderBottomLeftRadius: '48px',
    borderBottomRightRadius: '48px',
    borderTopLeftRadius: '48px',
    borderTopRightRadius: '48px',
    whiteSpace: 'nowrap'
  });
});
ThumbValue.displayName = "ThumbValue";
ThumbValue.displayName = 'StyledThumbValue';

function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$c(Object(source), true).forEach(function (key) { _defineProperty$h(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$h(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

function _slicedToArray$a(arr, i) { return _arrayWithHoles$a(arr) || _iterableToArrayLimit$a(arr, i) || _unsupportedIterableToArray$a(arr, i) || _nonIterableRest$a(); }

function _nonIterableRest$a() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$a(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$a(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$a(o, minLen); }

function _arrayLikeToArray$a(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$a(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$a(arr) { if (Array.isArray(arr)) return arr; }
// because our design doesn't support more than
// two thumbs

var limitValue = function limitValue(value) {
  if (value.length > 2 || value.length === 0) {
    throw new Error('the value prop represents positions of thumbs, so its length can be only one or two');
  }

  return value;
};

function Slider$1(_ref) {
  var _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$marks = _ref.marks,
      marks = _ref$marks === void 0 ? false : _ref$marks,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$onFinalChange = _ref.onFinalChange,
      _onFinalChange = _ref$onFinalChange === void 0 ? function () {} : _ref$onFinalChange,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 100 : _ref$max,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      _ref$persistentThumb = _ref.persistentThumb,
      persistentThumb = _ref$persistentThumb === void 0 ? false : _ref$persistentThumb,
      _ref$valueToLabel = _ref.valueToLabel,
      valueToLabel = _ref$valueToLabel === void 0 ? function (label) {
    return label;
  } : _ref$valueToLabel,
      providedValue = _ref.value;

  var theme = React$2.useContext(ThemeContext);

  var _React$useState = React$2.useState(false),
      _React$useState2 = _slicedToArray$a(_React$useState, 2),
      isHovered0 = _React$useState2[0],
      setIsHovered0 = _React$useState2[1];

  var _React$useState3 = React$2.useState(false),
      _React$useState4 = _slicedToArray$a(_React$useState3, 2),
      isHovered1 = _React$useState4[0],
      setIsHovered1 = _React$useState4[1];

  var _React$useState5 = React$2.useState(false),
      _React$useState6 = _slicedToArray$a(_React$useState5, 2),
      isFocusVisible$1 = _React$useState6[0],
      setIsFocusVisible = _React$useState6[1];

  var _React$useState7 = React$2.useState(-1),
      _React$useState8 = _slicedToArray$a(_React$useState7, 2),
      focusedThumbIndex = _React$useState8[0],
      setFocusedThumbIndex = _React$useState8[1];

  var handleFocus = React$2.useCallback(function (event) {
    if (isFocusVisible(event)) {
      setIsFocusVisible(true);
    }

    var index = // flowlint-next-line unclear-type:off
    event.target.parentNode.firstChild === event.target ? 0 : 1;
    setFocusedThumbIndex(index);
  }, []);
  var handleBlur = React$2.useCallback(function (event) {
    if (isFocusVisible$1 !== false) {
      setIsFocusVisible(false);
    }

    setFocusedThumbIndex(-1);
  }, []);
  var value = limitValue(providedValue);
  var sharedProps = {
    $disabled: disabled,
    $step: step,
    $min: min,
    $max: max,
    $marks: marks,
    $value: value,
    $isFocusVisible: isFocusVisible$1
  };

  var _getOverrides = getOverrides(overrides.Root, Root$1),
      _getOverrides2 = _slicedToArray$a(_getOverrides, 2),
      Root = _getOverrides2[0],
      rootProps = _getOverrides2[1];

  var _getOverrides3 = getOverrides(overrides.Track, Track),
      _getOverrides4 = _slicedToArray$a(_getOverrides3, 2),
      Track$1 = _getOverrides4[0],
      trackProps = _getOverrides4[1];

  var _getOverrides5 = getOverrides(overrides.InnerTrack, InnerTrack),
      _getOverrides6 = _slicedToArray$a(_getOverrides5, 2),
      InnerTrack$1 = _getOverrides6[0],
      innerTrackProps = _getOverrides6[1];

  var _getOverrides7 = getOverrides(overrides.Thumb, Thumb),
      _getOverrides8 = _slicedToArray$a(_getOverrides7, 2),
      Thumb$1 = _getOverrides8[0],
      thumbProps = _getOverrides8[1];

  var _getOverrides9 = getOverrides(overrides.InnerThumb, InnerThumb),
      _getOverrides10 = _slicedToArray$a(_getOverrides9, 2),
      InnerThumb$1 = _getOverrides10[0],
      innerThumbProps = _getOverrides10[1];

  var _getOverrides11 = getOverrides(overrides.ThumbValue, ThumbValue),
      _getOverrides12 = _slicedToArray$a(_getOverrides11, 2),
      ThumbValue$1 = _getOverrides12[0],
      thumbValueProps = _getOverrides12[1];

  var _getOverrides13 = getOverrides(overrides.Tick, Tick),
      _getOverrides14 = _slicedToArray$a(_getOverrides13, 2),
      Tick$1 = _getOverrides14[0],
      tickProps = _getOverrides14[1];

  var _getOverrides15 = getOverrides(overrides.TickBar, TickBar),
      _getOverrides16 = _slicedToArray$a(_getOverrides15, 2),
      TickBar$1 = _getOverrides16[0],
      tickBarProps = _getOverrides16[1];

  var _getOverrides17 = getOverrides(overrides.Mark, Mark),
      _getOverrides18 = _slicedToArray$a(_getOverrides17, 2),
      Mark$1 = _getOverrides18[0],
      markProps = _getOverrides18[1];

  return /*#__PURE__*/React$2.createElement(Root, _extends$c({
    "data-baseweb": "slider"
  }, sharedProps, rootProps, {
    onFocus: forkFocus(rootProps, handleFocus),
    onBlur: forkBlur(rootProps, handleBlur)
  }), /*#__PURE__*/React$2.createElement(lib_6, _extends$c({
    step: step,
    min: min,
    max: max,
    values: value,
    disabled: disabled,
    onChange: function onChange(value) {
      return _onChange({
        value: value
      });
    },
    onFinalChange: function onFinalChange(value) {
      return _onFinalChange({
        value: value
      });
    },
    rtl: theme.direction === 'rtl',
    renderTrack: function renderTrack(_ref2) {
      var props = _ref2.props,
          children = _ref2.children,
          isDragged = _ref2.isDragged;
      return /*#__PURE__*/React$2.createElement(Track$1, _extends$c({
        onMouseDown: props.onMouseDown,
        onTouchStart: props.onTouchStart,
        $isDragged: isDragged
      }, sharedProps, trackProps), /*#__PURE__*/React$2.createElement(InnerTrack$1, _extends$c({
        $isDragged: isDragged,
        ref: props.ref
      }, sharedProps, innerTrackProps), children));
    },
    renderThumb: function renderThumb(_ref3) {
      var props = _ref3.props,
          index = _ref3.index,
          isDragged = _ref3.isDragged;
      var displayLabel = persistentThumb ? persistentThumb : (!!index && isHovered1 || !index && isHovered0 || isDragged) && !disabled;
      return /*#__PURE__*/React$2.createElement(Thumb$1, _extends$c({}, props, {
        onMouseEnter: function onMouseEnter() {
          if (index === 0) {
            setIsHovered0(true);
          } else {
            setIsHovered1(true);
          }
        },
        onMouseLeave: function onMouseLeave() {
          if (index === 0) {
            setIsHovered0(false);
          } else {
            setIsHovered1(false);
          }
        },
        $thumbIndex: index,
        $isDragged: isDragged,
        style: _objectSpread$c({}, props.style)
      }, sharedProps, thumbProps, {
        $isFocusVisible: isFocusVisible$1 && focusedThumbIndex === index
      }), displayLabel && /*#__PURE__*/React$2.createElement(ThumbValue$1, _extends$c({
        $thumbIndex: index,
        $isDragged: isDragged
      }, sharedProps, thumbValueProps), valueToLabel(value[index])), displayLabel && /*#__PURE__*/React$2.createElement(InnerThumb$1, _extends$c({
        $thumbIndex: index,
        $isDragged: isDragged
      }, sharedProps, innerThumbProps)));
    }
  }, marks ? {
    // eslint-disable-next-line react/display-name
    renderMark: function renderMark(_ref4) {
      var props = _ref4.props,
          index = _ref4.index;
      return /*#__PURE__*/React$2.createElement(Mark$1, _extends$c({
        $markIndex: index
      }, props, sharedProps, markProps));
    }
  } : {})), /*#__PURE__*/React$2.createElement(TickBar$1, _extends$c({}, sharedProps, tickBarProps), /*#__PURE__*/React$2.createElement(Tick$1, _extends$c({}, sharedProps, tickProps), valueToLabel(min)), /*#__PURE__*/React$2.createElement(Tick$1, _extends$c({}, sharedProps, tickProps), valueToLabel(max))));
}

const StyledInnerTrack = themedWithStyle(InnerThumb, ({ $max, $min, $value, $theme, }) => {
    const range = $max - $min;
    const rangePosition = $value[0] - $min;
    const valueAsPercent = (rangePosition / range) * 100;
    return {
        ...linearGradient({
            colorStops: [
                `${$theme.colors['brand-primary-125']} 0%`,
                `${$theme.colors['brand-primary-125']} ${valueAsPercent}%`,
                `${$theme.colors['neutral-25']} ${valueAsPercent}%`,
                `${$theme.colors['neutral-25']} 100%`,
            ],
            fallback: 'none',
            toDirection: 'to right',
        }),
        ...borderRadius('top', $theme.cornerRadius['semi-sharp']),
        ...borderRadius('bottom', $theme.cornerRadius['semi-sharp']),
        height: '4px',
        width: '100%',
    };
});
const StyledThumb = themedWithStyle(Thumb, ({ $isFocusVisible, $theme, }) => ({
    ':hover': {
        boxShadow: `0 0 0 2px ${$theme.colors['brand-primary-50']}`,
    },
    backgroundColor: $theme.colors['brand-primary'],
    boxShadow: $isFocusVisible ? `0 0 0 2px ${$theme.colors['brand-primary-50']}` : 'none',
}));
const StyledInnerThumb = themedWithStyle(InnerThumb, ({ $theme }) => ({
    backgroundColor: $theme.colors['brand-primary'],
}));

const Slider = (props) => {
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(Slider$1, { overrides: {
            InnerThumb: StyledInnerThumb,
            InnerTrack: StyledInnerTrack,
            Thumb: StyledThumb,
            ThumbValue: {
                style: {
                    ...typography$6.LabelMedium,
                    backgroundColor: theme.colors['brand-primary'],
                    color: theme.colors['neutral-0'],
                    fontWeight: FontWeight.Bold,
                },
            },
            TickBar: () => null,
        }, ...props }));
};

function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$b(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$g(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getAnimationColor(props) {
  var $theme = props.$theme;
  return "linear-gradient(135deg,\n    ".concat($theme.colors.backgroundTertiary, ",\n    ").concat($theme.colors.backgroundTertiary, ",\n    ").concat($theme.colors.backgroundTertiary, ",\n    ").concat($theme.colors.backgroundTertiary, ",\n    ").concat($theme.colors.backgroundTertiary, ",\n    ").concat($theme.colors.backgroundTertiary, ",\n    ").concat($theme.colors.backgroundSecondary, ",\n    ").concat($theme.colors.backgroundTertiary, ",\n    ").concat($theme.colors.backgroundTertiary, ",\n    ").concat($theme.colors.backgroundTertiary, ",\n    ").concat($theme.colors.backgroundTertiary, ",\n    ").concat($theme.colors.backgroundTertiary, ",\n    ").concat($theme.colors.backgroundTertiary, ")");
}

var animationStyle = {
  animationTimingFunction: 'ease-out',
  animationDuration: '1.5s',
  animationIterationCount: 'infinite',
  backgroundSize: '400% 100%',
  animationName: {
    '0%': {
      backgroundPosition: '100% 50%'
    },
    '100%': {
      backgroundPosition: '0% 50%'
    }
  }
};
var StyledRoot$5 = styled('div', function (props) {
  if (typeof props.$rows === 'number' && props.$rows !== 0) {
    return {
      display: 'flex',
      flexDirection: 'column',
      height: props.$height,
      width: props.$width
    };
  }

  return _objectSpread$b(_objectSpread$b({}, props.$animation ? _objectSpread$b(_objectSpread$b({}, animationStyle), {}, {
    backgroundImage: getAnimationColor(props)
  }) : {
    backgroundColor: props.$theme.colors.backgroundTertiary
  }), {}, {
    height: props.$height,
    width: props.$width
  });
});
StyledRoot$5.displayName = "StyledRoot";
var StyledRow$1 = styled('div', function (props) {
  return _objectSpread$b(_objectSpread$b({}, props.$animation ? _objectSpread$b(_objectSpread$b({}, animationStyle), {}, {
    backgroundImage: getAnimationColor(props)
  }) : {
    backgroundColor: props.$theme.colors.backgroundTertiary
  }), {}, {
    width: '100%',
    height: '15px',
    marginBottom: props.$isLastRow ? '0px' : '10px'
  });
});
StyledRow$1.displayName = "StyledRow";

function _typeof$4(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$4 = function _typeof(obj) { return typeof obj; }; } else { _typeof$4 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$4(obj); }

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

function _slicedToArray$9(arr, i) { return _arrayWithHoles$9(arr) || _iterableToArrayLimit$9(arr, i) || _unsupportedIterableToArray$9(arr, i) || _nonIterableRest$9(); }

function _nonIterableRest$9() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$9(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$9(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$9(o, minLen); }

function _arrayLikeToArray$9(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$9(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$9(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$4(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$5(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$4(Constructor.prototype, protoProps); if (staticProps) _defineProperties$4(Constructor, staticProps); return Constructor; }

function _inherits$5(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$4(subClass, superClass); }

function _setPrototypeOf$4(o, p) { _setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$4(o, p); }

function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf$4(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$4(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$5(this, result); }; }

function _possibleConstructorReturn$5(self, call) { if (call && (_typeof$4(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$4(self); }

function _assertThisInitialized$4(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$4(o) { _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$4(o); }

function _defineProperty$f(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Skeleton$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$5(Skeleton, _React$Component);

  var _super = _createSuper$4(Skeleton);

  function Skeleton() {
    _classCallCheck$5(this, Skeleton);

    return _super.apply(this, arguments);
  }

  _createClass$5(Skeleton, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props$overrides = this.props.overrides,
          overrides = _this$props$overrides === void 0 ? {} : _this$props$overrides;

      var _getOverrides = getOverrides(overrides.Root, StyledRoot$5),
          _getOverrides2 = _slicedToArray$9(_getOverrides, 2),
          Root = _getOverrides2[0],
          rootProps = _getOverrides2[1];

      var _getOverrides3 = getOverrides(overrides.Row, StyledRow$1),
          _getOverrides4 = _slicedToArray$9(_getOverrides3, 2),
          Row = _getOverrides4[0],
          rowProps = _getOverrides4[1];

      if (typeof this.props.rows === 'number') {
        return /*#__PURE__*/React$2.createElement(Root, _extends$b({
          $height: this.props.height,
          $width: this.props.width,
          $animation: this.props.animation,
          $rows: this.props.rows,
          testid: 'loader'
        }, rootProps), Array(this.props.rows).fill().map(function (item, index) {
          return /*#__PURE__*/React$2.createElement(Row, _extends$b({
            $animation: _this.props.animation,
            key: index,
            $isLastRow: index === _this.props.rows - 1
          }, rowProps));
        }));
      }

      return /*#__PURE__*/React$2.createElement(Root, _extends$b({
        $height: this.props.height,
        $width: this.props.width,
        $animation: this.props.animation,
        testid: 'loader'
      }, rootProps));
    }
  }]);

  return Skeleton;
}(React$2.Component);

_defineProperty$f(Skeleton$1, "defaultProps", {
  rows: 0,
  animation: false
});

var BaseSkeleton = Skeleton$1;

const Skeleton = (props) => {
    const { ...otherProps } = props;
    return (React__default.createElement(BaseSkeleton, { ...otherProps }));
};

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var DURATION = {
  infinite: 0,
  short: 3000,
  medium: 5000,
  long: 7000
};
var PLACEMENT = {
  topLeft: 'topLeft',
  top: 'top',
  topRight: 'topRight',
  bottomRight: 'bottomRight',
  bottom: 'bottom',
  bottomLeft: 'bottomLeft'
};

function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$a(Object(source), true).forEach(function (key) { _defineProperty$e(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$e(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var StyledRoot$4 = styled('div', function (_ref) {
  var $theme = _ref.$theme;
  return {
    backgroundColor: $theme.colors.backgroundInverseSecondary,
    borderTopLeftRadius: $theme.borders.radius400,
    borderTopRightRadius: $theme.borders.radius400,
    borderBottomRightRadius: $theme.borders.radius400,
    borderBottomLeftRadius: $theme.borders.radius400,
    boxShadow: '0px 16px 48px rgba(0, 0, 0, 0.22)',
    color: $theme.colors.contentInversePrimary,
    display: 'inline-block',
    maxWidth: '540px',
    minWidth: '320px'
  };
});
StyledRoot$4.displayName = "StyledRoot";
var StyledContent = styled('div', {
  alignItems: 'center',
  display: 'inline-flex',
  width: '100%'
});
StyledContent.displayName = "StyledContent";
var StyledStartEnhancerContainer = styled('span', function (_ref2) {
  var $theme = _ref2.$theme;
  var paddingDir = $theme.direction === 'rtl' ? 'paddingRight' : 'paddingLeft';
  return _defineProperty$e({
    alignItems: 'center',
    display: 'flex'
  }, paddingDir, $theme.sizing.scale600);
});
StyledStartEnhancerContainer.displayName = "StyledStartEnhancerContainer";
var StyledSpinner = withStyle(StyledSpinnerNext$1, function (_ref4) {
  var $height = _ref4.$height,
      $width = _ref4.$width;
  return {
    boxSizing: 'border-box',
    height: "".concat($height, "px"),
    width: "".concat($width, "px")
  };
});
StyledSpinner.displayName = "StyledSpinner";
var StyledMessage = styled('p', //$FlowExpectedError[incompatible-shape]
function (_ref5) {
  var _objectSpread2;

  var $theme = _ref5.$theme,
      $hasSuffix = _ref5.$hasSuffix;
  var prefixPadding = $theme.direction === 'rtl' ? 'paddingRight' : 'paddingLeft';
  var suffixPadding = $theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight';
  return _objectSpread$a(_objectSpread$a({}, $theme.typography.ParagraphMedium), {}, (_objectSpread2 = {
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 3,
    display: '-webkit-box',
    marginTop: $theme.sizing.scale600,
    marginBottom: $theme.sizing.scale600,
    overflow: 'hidden'
  }, _defineProperty$e(_objectSpread2, prefixPadding, $theme.sizing.scale600), _defineProperty$e(_objectSpread2, suffixPadding, $hasSuffix ? $theme.sizing.scale300 : $theme.sizing.scale600), _objectSpread2));
});
StyledMessage.displayName = "StyledMessage";
var StyledWrapActionButtonContainer = styled('div', {
  display: 'flex',
  justifyContent: 'flex-end'
});
StyledWrapActionButtonContainer.displayName = "StyledWrapActionButtonContainer";
var StyledActionButtonContainer = styled('div', function (_ref6) {
  var $theme = _ref6.$theme;
  var marginDir = $theme.direction === 'rtl' ? 'marginRight' : 'marginLeft';
  return _defineProperty$e({}, marginDir, 'auto');
});
StyledActionButtonContainer.displayName = "StyledActionButtonContainer";

function placementRules(placement) {
  switch (placement) {
    case PLACEMENT.topLeft:
      return {
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        top: 0
      };

    case PLACEMENT.topRight:
      return {
        alignItems: 'flex-end',
        justifyContent: 'flex-start',
        top: 0
      };

    case PLACEMENT.bottom:
      return {
        alignItems: 'center',
        justifyContent: 'flex-end',
        bottom: 0
      };

    case PLACEMENT.bottomLeft:
      return {
        alignItems: 'flex-start',
        justifyContent: 'flex-end',
        bottom: 0
      };

    case PLACEMENT.bottomRight:
      return {
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        bottom: 0
      };

    case PLACEMENT.top:
    default:
      return {
        alignItems: 'center',
        justifyContent: 'flex-start',
        top: 0
      };
  }
}

var StyledPlacementContainer = styled('div', function (_ref8) {
  var $animating = _ref8.$animating,
      $placement = _ref8.$placement,
      $translateHeight = _ref8.$translateHeight,
      $theme = _ref8.$theme;
  return _objectSpread$a(_objectSpread$a({}, placementRules($placement)), {}, _defineProperty$e({
    display: 'flex',
    flexDirection: 'column',
    pointerEvents: 'none',
    position: 'fixed',
    transform: $animating ? "translateY(".concat($translateHeight, "px)") : null,
    transitionProperty: 'all',
    transitionTimingFunction: $theme.animation.easeOutQuinticCurve,
    transitionDuration: $theme.animation.timing1000,
    right: 0,
    left: 0,
    marginTop: $theme.sizing.scale300,
    marginRight: $theme.sizing.scale300,
    marginBottom: $theme.sizing.scale300,
    marginLeft: $theme.sizing.scale300
  }, $theme.mediaQuery.medium, {
    marginTop: $theme.sizing.scale600,
    marginRight: $theme.sizing.scale600,
    marginBottom: $theme.sizing.scale600,
    marginLeft: $theme.sizing.scale600
  }));
});
StyledPlacementContainer.displayName = "StyledPlacementContainer";

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

function _slicedToArray$8(arr, i) { return _arrayWithHoles$8(arr) || _iterableToArrayLimit$8(arr, i) || _unsupportedIterableToArray$8(arr, i) || _nonIterableRest$8(); }

function _nonIterableRest$8() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$8(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$8(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$8(o, minLen); }

function _arrayLikeToArray$8(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$8(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$8(arr) { if (Array.isArray(arr)) return arr; }
var ActionButton = /*#__PURE__*/React$2.forwardRef( // flowlint-next-line unclear-type:off
function (_ref, ref) {
  var onClick = _ref.onClick,
      message = _ref.message,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides;

  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$8(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _getOverrides = getOverrides(overrides.ActionButtonContainer, StyledActionButtonContainer),
      _getOverrides2 = _slicedToArray$8(_getOverrides, 2),
      ActionButtonContainer = _getOverrides2[0],
      actionButtonContainerProps = _getOverrides2[1];

  return /*#__PURE__*/React$2.createElement(ActionButtonContainer, actionButtonContainerProps, /*#__PURE__*/React$2.createElement(Button$2, {
    ref: ref,
    overrides: {
      BaseButton: {
        style: {
          color: theme.colors.contentInversePrimary,
          marginRight: theme.direction === 'rtl' ? null : theme.sizing.scale100,
          marginLeft: theme.direction === 'rtl' ? theme.sizing.scale100 : null,
          width: '100%',
          whiteSpace: 'nowrap',
          ':hover': {
            backgroundColor: theme.colors.borderInverseTransparent
          },
          ':active': {
            backgroundColor: theme.colors.backgroundInverseSecondary
          }
        }
      }
    },
    kind: KIND$1.tertiary,
    onClick: onClick,
    shape: SHAPE$1.pill
  }, message));
});
ActionButton.displayName = 'ActionButton';
function SnackbarElement(_ref2) {
  var actionMessage = _ref2.actionMessage,
      actionOnClick = _ref2.actionOnClick,
      _ref2$focus = _ref2.focus,
      focus = _ref2$focus === void 0 ? true : _ref2$focus,
      message = _ref2.message,
      _ref2$overrides = _ref2.overrides,
      overrides = _ref2$overrides === void 0 ? {} : _ref2$overrides,
      progress = _ref2.progress,
      StartEnhancer = _ref2.startEnhancer;

  var _useStyletron3 = useStyletron(),
      _useStyletron4 = _slicedToArray$8(_useStyletron3, 1),
      css = _useStyletron4[0];

  var rootRef = React$2.useRef(null);

  var _React$useState = React$2.useState(0),
      _React$useState2 = _slicedToArray$8(_React$useState, 2),
      rootWidth = _React$useState2[0],
      setRootWidth = _React$useState2[1];

  React$2.useEffect(function () {
    if (typeof document !== 'undefined') {
      if (window.ResizeObserver) {
        var observer = new window.ResizeObserver(function (_ref3) {
          var _ref4 = _slicedToArray$8(_ref3, 1),
              entry = _ref4[0];

          return setRootWidth(entry.contentRect.width);
        });

        if (rootRef.current) {
          observer.observe(rootRef.current);
        }

        return function () {
          return observer.disconnect();
        };
      }
    }
  }, []);
  var actionMeasureRef = React$2.useRef(null);

  var _React$useState3 = React$2.useState(0),
      _React$useState4 = _slicedToArray$8(_React$useState3, 2),
      actionMeasureWidth = _React$useState4[0],
      setActionMeasureWidth = _React$useState4[1];

  React$2.useEffect(function () {
    if (typeof document !== 'undefined') {
      if (window.ResizeObserver) {
        var observer = new window.ResizeObserver(function (_ref5) {
          var _ref6 = _slicedToArray$8(_ref5, 1),
              entry = _ref6[0];

          return setActionMeasureWidth(entry.contentRect.width);
        });

        if (actionMeasureRef.current) {
          observer.observe(actionMeasureRef.current);
        }

        return function () {
          return observer.disconnect();
        };
      }
    }
  }, [actionMeasureRef.current]);
  var wrapActionButton = actionMeasureWidth > rootWidth / 2;

  var _getOverrides3 = getOverrides(overrides.Root, StyledRoot$4),
      _getOverrides4 = _slicedToArray$8(_getOverrides3, 2),
      Root = _getOverrides4[0],
      rootProps = _getOverrides4[1];

  var _getOverrides5 = getOverrides(overrides.Content, StyledContent),
      _getOverrides6 = _slicedToArray$8(_getOverrides5, 2),
      Content = _getOverrides6[0],
      contentProps = _getOverrides6[1];

  var _getOverrides7 = getOverrides(overrides.StartEnhancerContainer, StyledStartEnhancerContainer),
      _getOverrides8 = _slicedToArray$8(_getOverrides7, 2),
      StartEnhancerContainer = _getOverrides8[0],
      startEnhancerContainerProps = _getOverrides8[1];

  var _getOverrides9 = getOverrides(overrides.Spinner, StyledSpinner),
      _getOverrides10 = _slicedToArray$8(_getOverrides9, 2),
      Spinner = _getOverrides10[0],
      spinnerProps = _getOverrides10[1];

  var _getOverrides11 = getOverrides(overrides.Message, StyledMessage),
      _getOverrides12 = _slicedToArray$8(_getOverrides11, 2),
      Message = _getOverrides12[0],
      messageProps = _getOverrides12[1];

  var _getOverrides13 = getOverrides(overrides.WrapActionButtonContainer, StyledWrapActionButtonContainer),
      _getOverrides14 = _slicedToArray$8(_getOverrides13, 2),
      WrapActionButtonContainer = _getOverrides14[0],
      wrapActionButtonContainerProps = _getOverrides14[1];

  var prevFocusRef = React$2.useRef(null);
  var actionButtonRef = React$2.useRef(null);
  React$2.useEffect(function () {
    if (typeof document !== 'undefined') {
      if (focus && actionButtonRef.current) {
        prevFocusRef.current = document.activeElement;
        actionButtonRef.current.focus();
      }

      return function () {
        if (prevFocusRef.current) {
          prevFocusRef.current.focus();
        }
      };
    }
  }, [focus]);
  return /*#__PURE__*/React$2.createElement(React$2.Fragment, null, actionMessage && /*#__PURE__*/React$2.createElement("div", {
    className: css({
      position: 'absolute',
      left: '-10000px',
      top: '-10000px'
    })
  }, /*#__PURE__*/React$2.createElement(ActionButton, {
    ref: actionMeasureRef,
    message: actionMessage,
    onClick: actionOnClick,
    overrides: overrides
  })), /*#__PURE__*/React$2.createElement(Root, _extends$a({
    ref: rootRef
  }, rootProps), /*#__PURE__*/React$2.createElement(Content, contentProps, (Boolean(StartEnhancer) || progress) && /*#__PURE__*/React$2.createElement(StartEnhancerContainer, startEnhancerContainerProps, StartEnhancer !== null && StartEnhancer !== undefined ? /*#__PURE__*/React$2.createElement(StartEnhancer, {
    size: 24
  }) : /*#__PURE__*/React$2.createElement(Spinner, _extends$a({
    $height: 24,
    $width: 24
  }, spinnerProps))), /*#__PURE__*/React$2.createElement(Message, _extends$a({
    $hasSuffix: Boolean(actionMessage)
  }, messageProps), message), actionMessage && !wrapActionButton && /*#__PURE__*/React$2.createElement(ActionButton, {
    ref: actionButtonRef,
    message: actionMessage,
    onClick: actionOnClick,
    overrides: overrides
  })), actionMessage && wrapActionButton && /*#__PURE__*/React$2.createElement(WrapActionButtonContainer, wrapActionButtonContainerProps, /*#__PURE__*/React$2.createElement(ActionButton, {
    ref: actionButtonRef,
    message: actionMessage,
    onClick: actionOnClick,
    overrides: overrides
  }))));
}

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$9(Object(source), true).forEach(function (key) { _defineProperty$d(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$d(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties$5(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$4(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$4(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray$2(arr) { return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$7(arr) || _nonIterableSpread$1(); }

function _nonIterableSpread$1() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray$1(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$1(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$7(arr); }

function _slicedToArray$7(arr, i) { return _arrayWithHoles$7(arr) || _iterableToArrayLimit$7(arr, i) || _unsupportedIterableToArray$7(arr, i) || _nonIterableRest$7(); }

function _nonIterableRest$7() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$7(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$7(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen); }

function _arrayLikeToArray$7(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$7(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$7(arr) { if (Array.isArray(arr)) return arr; }

function fallbackHandler() {
  if (process.env.NODE_ENV !== "production") {
    console.warn('Snackbar context not found.');
  }
}

var SnackbarContext = /*#__PURE__*/React$2.createContext({
  enqueue: fallbackHandler,
  dequeue: fallbackHandler
});
function useSnackbar() {
  var context = React$2.useContext(SnackbarContext);
  return {
    enqueue: context.enqueue,
    dequeue: context.dequeue
  };
}

function usePrevious(value) {
  var ref = React$2.useRef();
  React$2.useEffect(function () {
    ref.current = value;
  });
  return ref.current;
}

function SnackbarProvider(_ref) {
  var children = _ref.children,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides,
      placement = _ref.placement,
      _ref$defaultDuration = _ref.defaultDuration,
      defaultDuration = _ref$defaultDuration === void 0 ? DURATION.short : _ref$defaultDuration;

  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$7(_useStyletron, 1),
      css = _useStyletron2[0];

  var _React$useState = React$2.useState([]),
      _React$useState2 = _slicedToArray$7(_React$useState, 2),
      snackbars = _React$useState2[0],
      setSnackbars = _React$useState2[1];

  var _React$useState3 = React$2.useState(false),
      _React$useState4 = _slicedToArray$7(_React$useState3, 2),
      animating = _React$useState4[0],
      setAnimating = _React$useState4[1];

  var timeoutRef = React$2.useRef(null);

  var _React$useState5 = React$2.useState(0),
      _React$useState6 = _slicedToArray$7(_React$useState5, 2),
      containerHeight = _React$useState6[0],
      setContainerHeight = _React$useState6[1];

  var containerRef = React$2.useRef(null);

  function enqueue(elementProps) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultDuration;
    setSnackbars(function (prev) {
      return [].concat(_toConsumableArray$2(prev), [{
        elementProps: elementProps,
        duration: duration
      }]);
    });
  }

  var prevSnackbars = usePrevious(snackbars) || [];
  React$2.useEffect(function () {
    if (prevSnackbars.length === 0 && snackbars.length >= 1) {
      enter(snackbars[0].duration);
    }
  }, [snackbars, prevSnackbars]);

  function dequeue() {
    setContainerHeight(0);
    setSnackbars(function (prev) {
      var next = prev.slice(1);

      if (next.length > 0) {
        enter(next[0].duration);
      }

      return next;
    });
  }

  function enter(duration) {
    setAnimating(true);
    setTimeout(function () {
      setAnimating(false);
      display(duration);
    }, 1000);
  }

  function exit() {
    setAnimating(true);
    setTimeout(function () {
      setAnimating(false);
      dequeue();
    }, 1000);
  }

  function display(duration) {
    if (duration === DURATION.infinite) {
      return;
    }

    timeoutRef.current = setTimeout(function () {
      exit();
    }, duration);
  }

  function handleMouseEnter() {
    clearTimeout(timeoutRef.current);
  }

  function handleMouseLeave(duration) {
    display(duration);
  }

  function handleActionClick() {
    clearTimeout(timeoutRef.current);
    exit();
  }

  React$2.useEffect(function () {
    if (typeof document !== 'undefined') {
      if (window.ResizeObserver) {
        var observer = new window.ResizeObserver(function (_ref2) {
          var _ref3 = _slicedToArray$7(_ref2, 1),
              entry = _ref3[0];

          return setContainerHeight(entry.contentRect.height);
        });

        if (containerRef.current) {
          observer.observe(containerRef.current);
        }

        return function () {
          return observer.disconnect();
        };
      }
    }
  }, [snackbars.length, animating]);
  var translateHeight = React$2.useMemo(function () {
    var value = containerHeight * 2 + 24;

    if (!placement || placement === PLACEMENT.top || placement === PLACEMENT.topLeft || placement === PLACEMENT.topRight) {
      return -1 * value;
    }

    return value;
  }, [placement, containerHeight]);

  var PlacementContainerOverrides = overrides.PlacementContainer,
      snackbarOverrides = _objectWithoutProperties$5(overrides, ["PlacementContainer"]);

  var _getOverrides = getOverrides(PlacementContainerOverrides, StyledPlacementContainer),
      _getOverrides2 = _slicedToArray$7(_getOverrides, 2),
      PlacementContainer = _getOverrides2[0],
      placementContainerProps = _getOverrides2[1];

  return /*#__PURE__*/React$2.createElement(SnackbarContext.Provider, {
    value: {
      enqueue: enqueue,
      dequeue: exit
    }
  }, /*#__PURE__*/React$2.createElement("div", {
    className: css({
      boxSizing: 'border-box',
      position: 'absolute',
      top: '-10000px',
      left: '-10000px'
    }),
    ref: containerRef
  }, snackbars[0] && /*#__PURE__*/React$2.createElement(SnackbarElement, _extends$9({}, snackbars[0].elementProps, {
    overrides: _objectSpread$9(_objectSpread$9({}, snackbarOverrides), snackbars[0].elementProps.overrides),
    focus: false
  }))), snackbars.length > 0 && containerHeight !== 0 && /*#__PURE__*/React$2.createElement(Layer, null, /*#__PURE__*/React$2.createElement(PlacementContainer, _extends$9({
    $animating: animating,
    $placement: placement,
    $translateHeight: translateHeight
  }, placementContainerProps), /*#__PURE__*/React$2.createElement("div", {
    role: "alert",
    onMouseEnter: handleMouseEnter,
    onMouseLeave: function onMouseLeave() {
      return handleMouseLeave(snackbars[0].duration);
    },
    className: css({
      display: 'inline',
      pointerEvents: 'all'
    })
  }, /*#__PURE__*/React$2.createElement(SnackbarElement, _extends$9({}, snackbars[0].elementProps, {
    actionOnClick: function actionOnClick(event) {
      if (snackbars[0].elementProps.actionOnClick) {
        snackbars[0].elementProps.actionOnClick(event);
      }

      handleActionClick();
    },
    overrides: _objectSpread$9(_objectSpread$9({}, snackbarOverrides), snackbars[0].elementProps.overrides)
  }))))), children);
}

function border(styles) {
    const { color, style = 'solid', width = '1px', } = styles;
    return {
        ...borderColor(color),
        ...borderWidth(width),
        ...borderStyle(style),
    };
}
function noBorder() {
    return {
        borderBottomStyle: 'none',
        borderLeftStyle: 'none',
        borderRightStyle: 'none',
        borderTopStyle: 'none',
    };
}

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$8(Object(source), true).forEach(function (key) { _defineProperty$c(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$c(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Link = styled('a', function (_ref) {
  var $theme = _ref.$theme,
      $isAnimateUnderline = _ref.$isAnimateUnderline,
      $isFocusVisible = _ref.$isFocusVisible;
  var colors = $theme.colors,
      typography = $theme.typography,
      animation = $theme.animation,
      direction = $theme.direction;
  var underlineLTR = "linear-gradient(transparent calc(100% - 1px), ".concat(colors.linkHover, " 1px), linear-gradient(transparent calc(100% - 1px), ").concat(colors.linkText, " 1px)");
  var underlineRTL = "linear-gradient(transparent calc(100% - 1px), ".concat(colors.linkText, " 1px), linear-gradient(transparent calc(100% - 1px), ").concat(colors.linkHover, " 1px)");
  return _objectSpread$8(_objectSpread$8({
    color: colors.linkText
  }, typography.font350), {}, {
    fontSize: 'inherit',
    lineHeight: 'inherit',
    transitionProperty: !$isAnimateUnderline ? 'backgroundSize' : '',
    transitionDuration: animation.timing500,
    transitionTimingFunction: animation.easeOutQuinticCurve,
    position: $isAnimateUnderline ? 'relative' : null,
    textDecoration: $isAnimateUnderline ? 'none' : 'underline',
    textUnderlinePosition: 'under',
    willChange: 'background-size',
    backgroundSize: direction === 'rtl' ? '100% 100%, 100% 100%' : '0% 100%, 100% 100%',
    backgroundRepeat: 'no-repeat',
    backgroundImage: $isAnimateUnderline ? direction === 'rtl' ? underlineRTL : underlineLTR : 'none',
    ':hover': {
      color: colors.linkHover,
      backgroundSize: direction === 'rtl' ? '0% 100%, 100% 100%' : '100% 100%, 100% 100%'
    },
    ':focus': {
      outline: $isFocusVisible ? "3px solid ".concat(colors.accent) : 'none',
      outlineOffset: '1px',
      textDecoration: 'none'
    },
    ':visited': {
      color: colors.linkVisited
    },
    ':active': {
      color: colors.linkActive
    }
  });
});
Link.displayName = "Link";

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

function _objectWithoutProperties$4(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$3(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$3(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray$6(arr, i) { return _arrayWithHoles$6(arr) || _iterableToArrayLimit$6(arr, i) || _unsupportedIterableToArray$6(arr, i) || _nonIterableRest$6(); }

function _nonIterableRest$6() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$6(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$6(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen); }

function _arrayLikeToArray$6(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$6(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$6(arr) { if (Array.isArray(arr)) return arr; }

function LinkFocus(props) {
  var _React$useState = React$2.useState(false),
      _React$useState2 = _slicedToArray$6(_React$useState, 2),
      focusVisible = _React$useState2[0],
      setFocusVisible = _React$useState2[1];

  var handleFocus = function handleFocus(event) {
    if (isFocusVisible(event)) {
      setFocusVisible(true);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (focusVisible !== false) {
      setFocusVisible(false);
    }
  };

  return props.children({
    focusVisible: focusVisible,
    handleFocus: handleFocus,
    handleBlur: handleBlur
  });
}

var StyledLink$1 = withWrapper(Link, function (Styled) {
  return function StyledLink(_ref) {
    var animateUnderline = _ref.animateUnderline,
        restProps = _objectWithoutProperties$4(_ref, ["animateUnderline"]);

    return /*#__PURE__*/React$2.createElement(LinkFocus, null, function (focusProps) {
      return /*#__PURE__*/React$2.createElement(Styled, _extends$8({
        "data-baseweb": "link",
        $isAnimateUnderline: animateUnderline,
        $isFocusVisible: focusProps.focusVisible,
        onFocus: forkFocus(restProps, focusProps.handleFocus),
        onBlur: forkBlur(restProps, focusProps.handleBlur)
      }, restProps));
    });
  };
});

const getPseudoLinkStyles = ($theme) => ({
    ':active': {
        color: $theme.colors['neutral-50'],
    },
    ':focus': {
        boxShadow: `0 0 0 3px ${$theme.colors['brand-primary-50']}`,
        outline: 'none',
        textDecoration: 'underline',
    },
    ':hover': {
        color: $theme.colors['brand-primary-150'],
    },
    ':visited': {
        color: $theme.colors['brand-primary-125'],
    },
});

const Hyperlink = themedWithStyle(StyledLink$1, ({ $theme }) => ({
    ...typography$5.ButtonTertiary,
    ...getPseudoLinkStyles($theme),
    borderRadius: $theme.cornerRadius['semi-sharp'],
    ...padding('0px', '1px'),
    color: $theme.colors['brand-primary-125'],
    fontFamily: tokens$1['font-family'].text,
    lineHeight: tokens$1['line-height'].body,
    width: 'fit-content',
}));
const HyperlinkSmall = themedWithStyle(StyledLink$1, ({ $theme }) => ({
    ...typography$5.ButtonTertiaryMini,
    ...getPseudoLinkStyles($theme),
    borderRadius: $theme.cornerRadius['semi-sharp'],
    ...padding('0px', '1px'),
    color: $theme.colors['brand-primary-125'],
    fontFamily: tokens$1['font-family'].text,
    lineHeight: tokens$1['line-height']['body-small'],
    width: 'fit-content',
}));
const StyledLink = (props) => {
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(Hyperlink, { "$theme": theme, ...props }));
};
const StyledLinkSmall = (props) => {
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(HyperlinkSmall, { "$theme": theme, ...props }));
};

const HyperLinkStyles = ({ $theme }) => ({
    ...typography$5.ButtonTertiary,
    ...getPseudoLinkStyles($theme),
    borderRadius: $theme.cornerRadius['semi-sharp'],
    ...padding('0px', '1px'),
    color: $theme.colors['brand-primary-125'],
    width: 'fit-content',
});
const HyperLinkStylesSmall = ({ $theme }) => ({
    ...typography$5.ButtonTertiaryMini,
    ...getPseudoLinkStyles($theme),
    borderRadius: $theme.cornerRadius['semi-sharp'],
    ...padding('0px', '1px'),
    color: $theme.colors['brand-primary-125'],
    width: 'fit-content',
});
const HyperlinkLabel = themedWithStyle(StyledLink$1, HyperLinkStyles);
const HyperlinkLabelSmall = themedWithStyle(StyledLink$1, HyperLinkStylesSmall);
const StyledLinkLabel = (props) => {
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(HyperlinkLabel, { "$theme": theme, ...props }));
};
const StyledLinkLabelSmall = (props) => {
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(HyperlinkLabelSmall, { "$theme": theme, ...props }));
};

const typography = {
    MonoHeadingLarge: {
        fontFamily: tokens$1['font-family'].heading,
        fontSize: tokens$1['font-size'].large,
        fontWeight: FontWeight.Bold,
        lineHeight: tokens$1['line-height']['subhead-1'],
    },
    MonoHeadingMedium: {
        fontFamily: tokens$1['font-family'].heading,
        fontSize: tokens$1['font-size'].medium,
        fontWeight: FontWeight.Bold,
        lineHeight: tokens$1['line-height']['subhead-2'],
    },
    MonoHeadingSmall: {
        fontFamily: tokens$1['font-family'].heading,
        fontSize: tokens$1['font-size'].root,
        fontWeight: FontWeight.Bold,
        lineHeight: tokens$1['line-height']['subhead-3'],
    },
    MonoHeadingXSmall: {
        fontFamily: tokens$1['font-family'].heading,
        fontSize: tokens$1['font-size'].small,
        fontWeight: FontWeight.Bold,
        lineHeight: tokens$1['line-height']['subhead-4'],
    },
};

const MonoHeadingLarge = (props) => {
    const { color, ...restProps } = props;
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(MonoHeadingLarge$1, { color: color !== null && color !== void 0 ? color : theme.colors['neutral-100'], overrides: {
            Block: {
                style: typography.MonoHeadingLarge,
            },
        }, ...restProps }));
};
const MonoHeadingMedium = (props) => {
    const { color, ...restProps } = props;
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(MonoHeadingMedium$1, { color: color !== null && color !== void 0 ? color : theme.colors['neutral-100'], overrides: {
            Block: {
                style: typography.MonoHeadingMedium,
            },
        }, ...restProps }));
};
const MonoHeadingSmall = (props) => {
    const { color, ...restProps } = props;
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(MonoHeadingSmall$1, { color: color !== null && color !== void 0 ? color : theme.colors['neutral-100'], overrides: {
            Block: {
                style: typography.MonoHeadingSmall,
            },
        }, ...restProps }));
};
const MonoHeadingXSmall = (props) => {
    const { color, ...restProps } = props;
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(MonoHeadingXSmall$1, { color: color !== null && color !== void 0 ? color : theme.colors['neutral-100'], overrides: {
            Block: {
                style: typography.MonoHeadingXSmall,
            },
        }, ...restProps }));
};

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var SORT_DIRECTION = Object.freeze({
  ASC: 'ASC',
  DESC: 'DESC'
});

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(Object(source), true).forEach(function (key) { _defineProperty$b(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$b(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var StyledTableElement = styled('div', function (_ref) {
  var $theme = _ref.$theme;
  return _objectSpread$7(_objectSpread$7({}, expandBorderStyles($theme.borders.border300)), {}, {
    backgroundColor: $theme.colors.tableBackground,
    borderTopLeftRadius: $theme.borders.radius200,
    borderTopRightRadius: $theme.borders.radius200,
    borderBottomRightRadius: $theme.borders.radius200,
    borderBottomLeftRadius: $theme.borders.radius200,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflowX: 'auto'
  });
});
StyledTableElement.displayName = "StyledTableElement";
var StyledTable = withWrapper(StyledTableElement, function (StyledComponent) {
  return function StyledTable(props) {
    return /*#__PURE__*/React$2.createElement(StyledComponent, _extends$7({
      "data-baseweb": "table-custom",
      role: "grid"
    }, props));
  };
});
var StyledHeadElement = styled('div', function (_ref2) {
  var $theme = _ref2.$theme,
      $width = _ref2.$width;
  return {
    backgroundColor: $theme.colors.tableHeadBackgroundColor,
    boxShadow: $theme.lighting.shadow400,
    display: 'flex',
    flexGrow: 0,
    width: $width ? $width : '100%'
  };
});
StyledHeadElement.displayName = "StyledHeadElement";
var StyledHead = withWrapper(StyledHeadElement, function (StyledComponent) {
  return function StyledHead(props) {
    return /*#__PURE__*/React$2.createElement(StyledComponent, _extends$7({
      role: "row"
    }, props));
  };
});
var StyledHeadCellElement = styled('div', function (_ref3) {
  var $theme = _ref3.$theme,
      $cursor = _ref3.$cursor;
  var borderDir = $theme.direction === 'rtl' ? 'borderLeft' : 'borderRight';
  return _objectSpread$7(_objectSpread$7(_objectSpread$7({}, $theme.typography.font350), expandBorderStyles($theme.borders.border300)), {}, {
    borderTopStyle: 'none',
    borderBottomStyle: 'none',
    borderLeftStyle: 'none',
    color: $theme.colors.contentPrimary,
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: $theme.sizing.scale500,
    paddingRight: $theme.sizing.scale600,
    paddingBottom: $theme.sizing.scale500,
    paddingLeft: $theme.sizing.scale600,
    cursor: $cursor ? $cursor : 'inherit',
    width: '100%',
    ':last-of-type': _defineProperty$b({}, borderDir, 'none')
  });
});
StyledHeadCellElement.displayName = "StyledHeadCellElement";
var StyledHeadCell = withWrapper(StyledHeadCellElement, function (StyledComponent) {
  return function StyledHeadCell(props) {
    return /*#__PURE__*/React$2.createElement(StyledComponent, _extends$7({
      role: "columnheader"
    }, props));
  };
});
var StyledSortableLabel = styled('button', function (_ref4) {
  var $theme = _ref4.$theme;
  return _objectSpread$7(_objectSpread$7({}, $theme.typography.font250), {}, {
    alignItems: 'center',
    backgroundColor: 'transparent',
    borderLeftStyle: 'none',
    borderTopStyle: 'none',
    borderRightStyle: 'none',
    borderBottomStyle: 'none',
    color: $theme.colors.contentPrimary,
    display: 'flex',
    padding: 0,
    ':hover:enabled': {
      cursor: 'pointer'
    },
    ':disabled': {
      color: $theme.colors.mono500
    }
  });
});
StyledSortableLabel.displayName = "StyledSortableLabel";
var StyledBodyElement = styled('div', function (_ref5) {
  var $width = _ref5.$width;
  return {
    width: $width ? $width : '100%',
    overflowX: 'hidden',
    overflowY: 'overlay',
    flex: 1
  };
});
StyledBodyElement.displayName = "StyledBodyElement";
var StyledBody = withWrapper(StyledBodyElement, function (StyledComponent) {
  return function StyledBody(props) {
    return /*#__PURE__*/React$2.createElement(StyledComponent, _extends$7({
      role: "rowgroup"
    }, props));
  };
});
var StyledRowElement = styled('div', {
  display: 'flex',
  alignItems: 'center'
});
StyledRowElement.displayName = "StyledRowElement";
var StyledRow = withWrapper(StyledRowElement, function (StyledComponent) {
  return function StyledRow(props) {
    return /*#__PURE__*/React$2.createElement(StyledComponent, _extends$7({
      role: "row"
    }, props));
  };
});
var StyledCellElement = styled('div', function (_ref6) {
  var $theme = _ref6.$theme,
      $striped = _ref6.$striped;
  return _objectSpread$7(_objectSpread$7({}, $theme.typography.font200), {}, {
    backgroundColor: $striped ? $theme.colors.tableStripedBackground : null,
    color: $theme.colors.contentPrimary,
    display: 'flex',
    flex: 1,
    paddingTop: $theme.sizing.scale300,
    paddingRight: $theme.sizing.scale600,
    paddingBottom: $theme.sizing.scale300,
    paddingLeft: $theme.sizing.scale600
  });
});
StyledCellElement.displayName = "StyledCellElement";
var StyledCell = withWrapper(StyledCellElement, function (StyledComponent) {
  return function StyledCell(props) {
    return /*#__PURE__*/React$2.createElement(StyledComponent, _extends$7({
      role: "gridcell"
    }, props));
  };
});
var StyledFilterButton = styled('button', function (props) {
  function getIconColor() {
    if (props.$disabled) {
      return props.$theme.colors.mono500;
    }

    if (props.$active) {
      return props.$theme.colors.contentPrimary;
    }

    return props.$theme.colors.tableFilter;
  }

  function getIconHoverColor() {
    if (props.$disabled || props.$active) {
      return null;
    }

    return props.$theme.colors.contentPrimary;
  }

  return {
    backgroundColor: 'transparent',
    borderLeftStyle: 'none',
    borderTopStyle: 'none',
    borderRightStyle: 'none',
    borderBottomStyle: 'none',
    color: getIconColor(),
    cursor: props.$disabled ? null : 'pointer',
    paddingTop: 'none',
    paddingRight: 'none',
    paddingBottom: 'none',
    paddingLeft: 'none',
    ':hover': {
      color: getIconHoverColor()
    }
  };
});
StyledFilterButton.displayName = "StyledFilterButton";
var StyledFilterContent = styled('div', function (_ref7) {
  var $theme = _ref7.$theme;
  return _objectSpread$7(_objectSpread$7({}, expandBorderStyles($theme.borders.border300)), {}, {
    backgroundColor: $theme.colors.tableFilterBackground,
    borderRightStyle: 'none',
    borderLeftStyle: 'none',
    maxHeight: '196px',
    paddingRight: $theme.sizing.scale600,
    paddingLeft: $theme.sizing.scale600,
    overflow: 'auto'
  });
});
StyledFilterContent.displayName = "StyledFilterContent";
var StyledFilterHeading = styled('div', function (_ref8) {
  var $theme = _ref8.$theme;
  return _objectSpread$7(_objectSpread$7({}, $theme.typography.font250), {}, {
    color: $theme.colors.tableFilterHeading,
    paddingTop: $theme.sizing.scale500,
    paddingRight: $theme.sizing.scale600,
    paddingBottom: $theme.sizing.scale500,
    paddingLeft: $theme.sizing.scale600
  });
});
StyledFilterHeading.displayName = "StyledFilterHeading";
var StyledFilterFooter = styled('div', function (_ref9) {
  var $theme = _ref9.$theme;
  return {
    backgroundColor: $theme.colors.tableFilterFooterBackground,
    paddingTop: $theme.sizing.scale300,
    paddingRight: $theme.sizing.scale100,
    paddingBottom: $theme.sizing.scale300,
    paddingLeft: $theme.sizing.scale100,
    display: 'flex',
    justifyContent: 'space-between',
    minWidth: '216px'
  };
});
StyledFilterFooter.displayName = "StyledFilterFooter";
var StyledAction = styled('button', function (_ref10) {
  var $theme = _ref10.$theme;
  return {
    backgroundColor: 'transparent',
    borderLeftStyle: 'none',
    borderTopStyle: 'none',
    borderRightStyle: 'none',
    borderBottomStyle: 'none',
    color: $theme.colors.primary,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    marginRight: $theme.sizing.scale100,
    marginLeft: $theme.sizing.scale100,
    ':hover:enabled': {
      cursor: 'pointer'
    }
  };
});
StyledAction.displayName = "StyledAction";

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

function _slicedToArray$5(arr, i) { return _arrayWithHoles$5(arr) || _iterableToArrayLimit$5(arr, i) || _unsupportedIterableToArray$5(arr, i) || _nonIterableRest$5(); }

function _nonIterableRest$5() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$5(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$5(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen); }

function _arrayLikeToArray$5(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$5(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$5(arr) { if (Array.isArray(arr)) return arr; }

function SortDirectionIcon(_ref) {
  var direction = _ref.direction;

  switch (direction) {
    case SORT_DIRECTION.ASC:
      return /*#__PURE__*/React$2.createElement(TriangleUp$1, {
        title: "Sort ascending"
      });

    case SORT_DIRECTION.DESC:
      return /*#__PURE__*/React$2.createElement(TriangleDown$1, {
        title: "Sort descending"
      });

    default:
      return null;
  }
}

var SortableHeadCellFactory = function SortableHeadCellFactory() {
  var CustomHeadCell = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StyledHeadCell;
  return function SortableHeadCell(props) {
    var _props$overrides = props.overrides,
        overrides = _props$overrides === void 0 ? {} : _props$overrides,
        fillClickTarget = props.fillClickTarget,
        disabled = props.disabled;

    var _getOverrides = getOverrides(overrides.HeadCell, CustomHeadCell),
        _getOverrides2 = _slicedToArray$5(_getOverrides, 2),
        HeadCell = _getOverrides2[0],
        headCellProps = _getOverrides2[1];

    var _getOverrides3 = getOverrides(overrides.SortableLabel, StyledSortableLabel),
        _getOverrides4 = _slicedToArray$5(_getOverrides3, 2),
        SortableLabel = _getOverrides4[0],
        sortableLabelProps = _getOverrides4[1];

    var onClick = function onClick() {
      props.onSort && props.onSort();
    };

    var enableHeadClick = fillClickTarget && !disabled;
    var ariaLabel = props['aria-label'] || props.ariaLabel;

    if (!ariaLabel) {
      if (typeof props.title === 'string') {
        ariaLabel = "sorts table by ".concat(props.title, " column");
      } else {
        ariaLabel = 'sort table by column';
      }
    }

    return /*#__PURE__*/React$2.createElement(HeadCell, _extends$6({
      role: "columnheader"
    }, headCellProps, {
      $cursor: enableHeadClick ? 'pointer' : undefined,
      onClick: enableHeadClick ? onClick : undefined
    }), /*#__PURE__*/React$2.createElement(SortableLabel, _extends$6({
      "aria-label": ariaLabel,
      disabled: disabled,
      onClick: !fillClickTarget ? onClick : undefined
    }, sortableLabelProps), /*#__PURE__*/React$2.createElement(SortDirectionIcon, {
      direction: props.direction
    }), props.title), props.children);
  };
};
var sortableHeadCell = SortableHeadCellFactory();

function _typeof$3(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$4(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$3(Constructor.prototype, protoProps); if (staticProps) _defineProperties$3(Constructor, staticProps); return Constructor; }

function _inherits$4(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$3(subClass, superClass); }

function _setPrototypeOf$3(o, p) { _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$3(o, p); }

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf$3(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$3(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$4(this, result); }; }

function _possibleConstructorReturn$4(self, call) { if (call && (_typeof$3(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$3(self); }

function _assertThisInitialized$3(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$3(o) { _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$3(o); }

function _defineProperty$a(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Table = /*#__PURE__*/function (_React$Component) {
  _inherits$4(Table, _React$Component);

  var _super = _createSuper$3(Table);

  function Table() {
    _classCallCheck$4(this, Table);

    return _super.apply(this, arguments);
  }

  _createClass$4(Table, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React$2.createElement(StyledTable, {
        "data-baseweb": "table",
        "aria-colcount": this.props.columns.length,
        "aria-rowcount": this.props.data.length
      }, this.props.isLoading && /*#__PURE__*/React$2.createElement(ProgressBar$2, {
        infinite: true,
        overrides: {
          Bar: {
            style: {
              marginBottom: 0,
              marginLeft: 0,
              marginRight: 0,
              marginTop: 0
            }
          }
        }
      }), /*#__PURE__*/React$2.createElement(StyledHead, {
        $width: this.props.horizontalScrollWidth
      }, this.props.columns.map(function (column, index) {
        return /*#__PURE__*/React$2.createElement(StyledHeadCell, {
          key: index
        }, column);
      })), /*#__PURE__*/React$2.createElement(StyledBody, {
        $width: this.props.horizontalScrollWidth
      }, this.props.data.map(function (row, index) {
        return /*#__PURE__*/React$2.createElement(StyledRow, {
          key: index
        }, row.map(function (cell, cellIndex) {
          return /*#__PURE__*/React$2.createElement(StyledCell, {
            key: cellIndex
          }, cell);
        }));
      })));
    }
  }]);

  return Table;
}(React$2.Component);

_defineProperty$a(Table, "defaultProps", {
  columns: [],
  data: [[]],
  isLoading: false
});

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var ORIENTATION = {
  vertical: 'vertical',
  horizontal: 'horizontal'
};
var FILL = {
  fixed: 'fixed',
  intrinsic: 'intrinsic'
};

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var getTabId = function getTabId(uid, key) {
  return "tabs-".concat(uid, "-tab-").concat(key);
};
var getTabPanelId = function getTabPanelId(uid, key) {
  return "tabs-".concat(uid, "-tabpanel-").concat(key);
};
var isHorizontal = function isHorizontal(orientation) {
  return orientation === ORIENTATION.horizontal;
};
var isVertical = function isVertical(orientation) {
  return orientation === ORIENTATION.vertical;
};
var isRTL = function isRTL(direction) {
  return direction === 'rtl';
};
var isIntrinsic = function isIntrinsic(fill) {
  return fill === FILL.intrinsic;
};
var isFixed = function isFixed(fill) {
  return fill === FILL.fixed;
};

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty$9(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$9(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var StyledRoot$3 = styled('div', function (_ref) {
  _ref.$theme;
      var _ref$$orientation = _ref.$orientation,
      $orientation = _ref$$orientation === void 0 ? ORIENTATION.horizontal : _ref$$orientation;
  var style = {
    // Creates a stacking context so we can use z-index on the TabHighlight
    // without affecting anything outside of this element.
    transform: 'scale(1)'
  };

  if (isVertical($orientation)) {
    style.display = 'flex';
  }

  return style;
});
StyledRoot$3.displayName = "StyledRoot";
var StyledTabList$1 = styled('div', function (_ref2) {
  var $theme = _ref2.$theme,
      _ref2$$fill = _ref2.$fill,
      $fill = _ref2$$fill === void 0 ? FILL.intrinsic : _ref2$$fill,
      _ref2$$orientation = _ref2.$orientation,
      $orientation = _ref2$$orientation === void 0 ? ORIENTATION.horizontal : _ref2$$orientation;
  var style = {
    position: 'relative',
    display: 'flex',
    flexWrap: 'nowrap'
  };

  if (isHorizontal($orientation)) {
    style.flexDirection = 'row';
    style.paddingBottom = '5px';
    style.marginBottom = '-5px';
  } else {
    style.flexDirection = 'column';

    if (isRTL($theme.direction)) {
      style.paddingLeft = '5px';
      style.marginLeft = '-5px';
    } else {
      style.paddingRight = '5px';
      style.marginRight = '-5px';
    }
  }

  if (isIntrinsic($fill)) {
    style['::-webkit-scrollbar'] = {
      display: 'none'
    }; // $FlowFixMe: property missing in StyleObject

    style['-ms-overflow-style'] = 'none';
    style.scrollbarWidth = 'none';

    if (isHorizontal($orientation)) {
      style.overflowX = 'scroll';
    } else {
      style.overflowY = 'scroll';
    }
  }

  return style;
});
StyledTabList$1.displayName = "StyledTabList";
var StyledTab$1 = styled('button', function (_ref3) {
  var $theme = _ref3.$theme,
      _ref3$$orientation = _ref3.$orientation,
      $orientation = _ref3$$orientation === void 0 ? ORIENTATION.horizontal : _ref3$$orientation,
      _ref3$$fill = _ref3.$fill,
      $fill = _ref3$$fill === void 0 ? FILL.intrinsic : _ref3$$fill,
      _ref3$$focusVisible = _ref3.$focusVisible,
      $focusVisible = _ref3$$focusVisible === void 0 ? false : _ref3$$focusVisible;
      _ref3.$isActive;

  var style = _objectSpread$6({
    cursor: 'pointer',
    WebkitAppearance: 'none',
    marginLeft: '0',
    marginRight: '0',
    marginTop: '0',
    marginBottom: '0',
    boxSizing: 'border-box',
    display: 'inline-flex',
    alignItems: 'center',
    paddingLeft: $theme.sizing.scale600,
    paddingTop: $theme.sizing.scale600,
    paddingRight: $theme.sizing.scale600,
    paddingBottom: $theme.sizing.scale600,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftStyle: 'none',
    borderTopStyle: 'none',
    borderRightStyle: 'none',
    borderBottomStyle: 'none',
    color: $theme.colors.contentPrimary,
    background: $theme.colors.backgroundPrimary,
    transitionProperty: 'background',
    transitionDuration: $theme.animation.timing200,
    transitionTimingFunction: $theme.animation.linearCurve,
    outline: 'none',
    outlineOffset: '-3px',
    ':disabled': {
      cursor: 'not-allowed',
      color: $theme.colors.contentStateDisabled
    },
    ':hover': {
      background: $theme.colors.backgroundSecondary
    },
    ':disabled:hover': {
      background: 'none'
    }
  }, $theme.typography.LabelSmall);

  if ($focusVisible) {
    style.outline = "3px solid ".concat($theme.colors.accent);
  }

  if (isFixed($fill)) {
    style.flexGrow = 1;
    style.flexBasis = 0;
  }

  if (isHorizontal($orientation)) {
    style.justifyContent = 'center';
  } else {
    style.justifyContent = 'flex-end';
  }

  return style;
});
StyledTab$1.displayName = "StyledTab";
var StyledArtworkContainer$1 = styled('div', function (_ref4) {
  var $theme = _ref4.$theme,
      _ref4$$orientation = _ref4.$orientation;
      _ref4$$orientation === void 0 ? ORIENTATION.horizontal : _ref4$$orientation;
  var style = {
    display: 'flex'
  };

  if (isRTL($theme.direction)) {
    style.marginLeft = $theme.sizing.scale300;
  } else {
    style.marginRight = $theme.sizing.scale300;
  }

  return style;
});
StyledArtworkContainer$1.displayName = "StyledArtworkContainer";
var StyledTabBorder$1 = styled('div', function (_ref5) {
  var $theme = _ref5.$theme,
      _ref5$$orientation = _ref5.$orientation,
      $orientation = _ref5$$orientation === void 0 ? ORIENTATION.horizontal : _ref5$$orientation;
  var style = {
    backgroundColor: $theme.colors.borderOpaque,
    position: 'relative'
  };

  if (isHorizontal($orientation)) {
    style.height = '5px';
  } else {
    style.width = '5px';
  }

  return style;
});
StyledTabBorder$1.displayName = "StyledTabBorder";
var StyledTabHighlight$1 = styled('div', function (_ref6) {
  var $theme = _ref6.$theme,
      _ref6$$orientation = _ref6.$orientation,
      $orientation = _ref6$$orientation === void 0 ? ORIENTATION.horizontal : _ref6$$orientation,
      _ref6$$length = _ref6.$length,
      $length = _ref6$$length === void 0 ? 0 : _ref6$$length,
      _ref6$$distance = _ref6.$distance,
      $distance = _ref6$$distance === void 0 ? 0 : _ref6$$distance,
      _ref6$$animate = _ref6.$animate,
      $animate = _ref6$$animate === void 0 ? false : _ref6$$animate;
  var style = {
    backgroundColor: $theme.colors.borderSelected,
    position: 'absolute',
    zIndex: 1
  };

  if (isHorizontal($orientation)) {
    style.bottom = '0px';
    style.left = '0px';
    style.height = '5px';
    style.width = "".concat($length, "px");
    style.transform = "translateX(".concat($distance, "px)");
  } else {
    style.transform = "translateY(".concat($distance, "px)");
    style.width = '5px';
    style.height = "".concat($length, "px");

    if (isRTL($theme.direction)) {
      style.left = '0px';
    } else {
      style.right = '0px';
    }
  }

  if ($animate) {
    style.transitionProperty = 'all';
    style.transitionDuration = $theme.animation.timing400;
    style.transitionTimingFunction = $theme.animation.easeInOutQuinticCurve;
  }

  return style;
});
StyledTabHighlight$1.displayName = "StyledTabHighlight";
var StyledTabPanel$1 = styled('div', function (_ref7) {
  var $theme = _ref7.$theme,
      _ref7$$pad = _ref7.$pad,
      $pad = _ref7$$pad === void 0 ? true : _ref7$$pad;
  var style = {
    flexGrow: 1,
    // only used in vertical orientation
    outline: 'none'
  };

  if ($pad) {
    style.paddingTop = $theme.sizing.scale600;
    style.paddingRight = $theme.sizing.scale600;
    style.paddingBottom = $theme.sizing.scale600;
    style.paddingLeft = $theme.sizing.scale600;
  }

  return style;
});
StyledTabPanel$1.displayName = "StyledTabPanel";

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty$8(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray$1(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$4(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$4(arr); }

function _objectWithoutProperties$3(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$2(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

function _slicedToArray$4(arr, i) { return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i) || _unsupportedIterableToArray$4(arr, i) || _nonIterableRest$4(); }

function _nonIterableRest$4() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }

function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$4(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$4(arr) { if (Array.isArray(arr)) return arr; }
var KEYBOARD_ACTION = {
  next: 'next',
  previous: 'previous'
};

var getLayoutParams = function getLayoutParams(el, orientation) {
  if (!el) {
    return {
      length: 0,
      distance: 0
    };
  } // Note, we are using clientHeight/Width here, which excludes borders.
  // This means borders won't be taken into account if someone adds borders
  // through overrides. In that case you would use getBoundingClientRect
  // which includes borders, but because it returns a fractional value the
  // highlight is slightly misaligned every so often.


  if (isVertical(orientation)) {
    return {
      length: el.clientHeight,
      distance: el.offsetTop
    };
  } else {
    return {
      length: el.clientWidth,
      distance: el.offsetLeft
    };
  }
};

var scrollParentToCentreTarget = function scrollParentToCentreTarget(targetNode) {
  var _targetNode$parentNod = targetNode.parentNode.getBoundingClientRect(),
      parentX = _targetNode$parentNod.x,
      parentY = _targetNode$parentNod.y,
      parentWidth = _targetNode$parentNod.width,
      parentHeight = _targetNode$parentNod.height;

  var _targetNode$getBoundi = targetNode.getBoundingClientRect(),
      childX = _targetNode$getBoundi.x,
      childY = _targetNode$getBoundi.y,
      childWidth = _targetNode$getBoundi.width,
      childHeight = _targetNode$getBoundi.height; // get the position of the child centre, relative to parent


  var childCentre = {
    x: childX - parentX + childWidth / 2,
    y: childY - parentY + childHeight / 2
  }; // aim for the centre of the child to be the centre of the parent

  var _targetNode$parentNod2 = targetNode.parentNode,
      scrollLeft = _targetNode$parentNod2.scrollLeft,
      scrollTop = _targetNode$parentNod2.scrollTop;
  var target = {
    x: scrollLeft + childCentre.x - parentWidth / 2,
    y: scrollTop + childCentre.y - parentHeight / 2
  }; // ignore out of bounds, the browser will manage this for us

  targetNode.parentNode.scroll(target.x, target.y);
};

function Tabs$1(_ref) {
  var _ref$activeKey = _ref.activeKey,
      activeKey = _ref$activeKey === void 0 ? '0' : _ref$activeKey,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      children = _ref.children,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? FILL.intrinsic : _ref$fill,
      _ref$activateOnFocus = _ref.activateOnFocus,
      activateOnFocus = _ref$activateOnFocus === void 0 ? true : _ref$activateOnFocus,
      onChange = _ref.onChange,
      _ref$orientation = _ref.orientation,
      orientation = _ref$orientation === void 0 ? ORIENTATION.horizontal : _ref$orientation,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides,
      _ref$renderAll = _ref.renderAll,
      renderAll = _ref$renderAll === void 0 ? false : _ref$renderAll,
      _ref$uid = _ref.uid,
      customUid = _ref$uid === void 0 ? null : _ref$uid;
  // Create unique id prefix for this tabs component
  var generatedUid = useUID();
  var uid = customUid || generatedUid; // Unpack overrides

  var RootOverrides = overrides.Root,
      TabListOverrides = overrides.TabList,
      TabHighlightOverrides = overrides.TabHighlight,
      TabBorderOverrides = overrides.TabBorder;

  var _getOverrides = getOverrides(RootOverrides, StyledRoot$3),
      _getOverrides2 = _slicedToArray$4(_getOverrides, 2),
      Root = _getOverrides2[0],
      RootProps = _getOverrides2[1];

  var _getOverrides3 = getOverrides(TabListOverrides, StyledTabList$1),
      _getOverrides4 = _slicedToArray$4(_getOverrides3, 2),
      TabList = _getOverrides4[0],
      TabListProps = _getOverrides4[1];

  var _getOverrides5 = getOverrides(TabHighlightOverrides, StyledTabHighlight$1),
      _getOverrides6 = _slicedToArray$4(_getOverrides5, 2),
      TabHighlight = _getOverrides6[0],
      TabHighlightProps = _getOverrides6[1];

  var _getOverrides7 = getOverrides(TabBorderOverrides, StyledTabBorder$1),
      _getOverrides8 = _slicedToArray$4(_getOverrides7, 2),
      TabBorder = _getOverrides8[0],
      TabBorderProps = _getOverrides8[1]; // Count key updates
  // We disable a few things until after first mount:
  // - the highlight animation, avoiding an initial slide-in
  // - smooth scrolling active tab into view


  var _React$useState = React$2.useState(0),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      keyUpdated = _React$useState2[0],
      setKeyUpdated = _React$useState2[1];

  React$2.useEffect(function () {
    setKeyUpdated(keyUpdated + 1);
  }, [activeKey]); // Positioning the highlight.

  var activeTabRef = React$2.useRef();

  var _React$useState3 = React$2.useState({
    length: 0,
    distance: 0
  }),
      _React$useState4 = _slicedToArray$4(_React$useState3, 2),
      highlightLayout = _React$useState4[0],
      setHighlightLayout = _React$useState4[1]; // Create a shared, memoized callback for tabs to call on resize.


  var updateHighlight = React$2.useCallback(function () {
    if (activeTabRef.current) {
      setHighlightLayout(getLayoutParams(activeTabRef.current, orientation));
    }
  }, [activeTabRef.current, orientation]); // Update highlight on key and orientation changes.

  React$2.useEffect(updateHighlight, [activeTabRef.current, orientation]); // Scroll active tab into view when the parent has scrollbar on mount and
  // on key change (smooth scroll). Note, if the active key changes while
  // the tab is not in view, the page will scroll it into view.
  // TODO: replace with custom scrolling logic.

  React$2.useEffect(function () {
    // Flow needs this condition pulled out.
    if (activeTabRef.current) {
      if (isHorizontal(orientation) ? activeTabRef.current.parentNode.scrollWidth > activeTabRef.current.parentNode.clientWidth : activeTabRef.current.parentNode.scrollHeight > activeTabRef.current.parentNode.clientHeight) {
        if (keyUpdated > 1) {
          activeTabRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        } else {
          scrollParentToCentreTarget(activeTabRef.current);
        }
      }
    }
  }, [activeTabRef.current]); // Collect shared styling props

  var sharedStylingProps = {
    $orientation: orientation,
    $fill: fill
  }; // Helper for parsing directional keys
  // TODO(WPT-6473): move to universal keycode aliases

  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray$4(_useStyletron, 2),
      theme = _useStyletron2[1];

  var parseKeyDown = React$2.useCallback(function (event) {
    if (isHorizontal(orientation)) {
      if (isRTL(theme.direction)) {
        switch (event.keyCode) {
          case 39:
            return KEYBOARD_ACTION.previous;

          case 37:
            return KEYBOARD_ACTION.next;

          default:
            return null;
        }
      } else {
        switch (event.keyCode) {
          case 37:
            return KEYBOARD_ACTION.previous;

          case 39:
            return KEYBOARD_ACTION.next;

          default:
            return null;
        }
      }
    } else {
      switch (event.keyCode) {
        case 38:
          return KEYBOARD_ACTION.previous;

        case 40:
          return KEYBOARD_ACTION.next;

        default:
          return null;
      }
    }
  }, [orientation, theme.direction]);
  return /*#__PURE__*/React$2.createElement(Root, _extends$5({}, sharedStylingProps, RootProps), /*#__PURE__*/React$2.createElement(TabList, _extends$5({
    "data-baseweb": "tab-list",
    role: "tablist",
    "aria-orientation": orientation
  }, sharedStylingProps, TabListProps), React$2.Children.map(children, function (child, index) {
    if (!child) return;
    return /*#__PURE__*/React$2.createElement(InternalTab, _extends$5({
      childKey: child.key,
      childIndex: index,
      activeKey: activeKey,
      orientation: orientation,
      activeTabRef: activeTabRef,
      updateHighlight: updateHighlight,
      parseKeyDown: parseKeyDown,
      activateOnFocus: activateOnFocus,
      uid: uid,
      disabled: disabled,
      sharedStylingProps: sharedStylingProps,
      onChange: onChange
    }, child.props));
  }), /*#__PURE__*/React$2.createElement(TabHighlight, _extends$5({
    "data-baseweb": "tab-highlight",
    $length: highlightLayout.length,
    $distance: highlightLayout.distance // This avoids the tab sliding in from the side on mount
    ,
    $animate: keyUpdated > 1,
    "aria-hidden": "true",
    role: "presentation"
  }, sharedStylingProps, TabHighlightProps))), /*#__PURE__*/React$2.createElement(TabBorder, _extends$5({
    "data-baseweb": "tab-border",
    "aria-hidden": "true",
    role: "presentation"
  }, sharedStylingProps, TabBorderProps)), React$2.Children.map(children, function (child, index) {
    if (!child) return;
    return /*#__PURE__*/React$2.createElement(InternalTabPanel, _extends$5({
      childKey: child.key,
      childIndex: index,
      activeKey: activeKey,
      uid: uid,
      sharedStylingProps: sharedStylingProps,
      renderAll: renderAll
    }, child.props));
  }));
}

function InternalTab(_ref2) {
  var childKey = _ref2.childKey,
      childIndex = _ref2.childIndex,
      activeKey = _ref2.activeKey,
      orientation = _ref2.orientation,
      activeTabRef = _ref2.activeTabRef,
      updateHighlight = _ref2.updateHighlight,
      parseKeyDown = _ref2.parseKeyDown,
      activateOnFocus = _ref2.activateOnFocus,
      uid = _ref2.uid,
      disabled = _ref2.disabled,
      sharedStylingProps = _ref2.sharedStylingProps,
      onChange = _ref2.onChange,
      props = _objectWithoutProperties$3(_ref2, ["childKey", "childIndex", "activeKey", "orientation", "activeTabRef", "updateHighlight", "parseKeyDown", "activateOnFocus", "uid", "disabled", "sharedStylingProps", "onChange"]);

  var key = childKey || String(childIndex);
  var isActive = key == activeKey;

  var Artwork = props.artwork,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      tabRef = props.tabRef,
      _onClick = props.onClick,
      title = props.title,
      restProps = _objectWithoutProperties$3(props, ["artwork", "overrides", "tabRef", "onClick", "title"]); // A way to share our internal activeTabRef via the "tabRef" prop.


  var ref = React$2.useRef();
  React$2.useImperativeHandle(tabRef, function () {
    return isActive ? activeTabRef.current : ref.current;
  }); // Track tab dimensions in a ref after each render
  // This is used to compare params when the resize observer fires

  var tabLayoutParams = React$2.useRef({
    length: 0,
    distance: 0
  });
  React$2.useEffect(function () {
    tabLayoutParams.current = getLayoutParams(isActive ? activeTabRef.current : ref.current, orientation);
  }); // We need to potentially update the active tab highlight when the width or
  // placement changes for a tab so we listen for resize updates in each tab.

  React$2.useEffect(function () {
    if (window.ResizeObserver) {
      var observer = new window.ResizeObserver(function (entries) {
        if (entries[0] && entries[0].target) {
          var tabLayoutParamsAfterResize = getLayoutParams(entries[0].target, orientation);

          if (tabLayoutParamsAfterResize.length !== tabLayoutParams.current.length || tabLayoutParamsAfterResize.distance !== tabLayoutParams.current.distance) {
            updateHighlight();
          }
        }
      });
      observer.observe(isActive ? activeTabRef.current : ref.current);
      return function () {
        observer.disconnect();
      };
    }
  }, [activeKey, orientation]);
  React$2.useEffect(updateHighlight, [title]); // Collect overrides

  var TabOverrides = overrides.Tab,
      ArtworkContainerOverrides = overrides.ArtworkContainer;

  var _getOverrides9 = getOverrides(TabOverrides, StyledTab$1),
      _getOverrides10 = _slicedToArray$4(_getOverrides9, 2),
      Tab = _getOverrides10[0],
      TabProps = _getOverrides10[1];

  var _getOverrides11 = getOverrides(ArtworkContainerOverrides, StyledArtworkContainer$1),
      _getOverrides12 = _slicedToArray$4(_getOverrides11, 2),
      ArtworkContainer = _getOverrides12[0],
      ArtworkContainerProps = _getOverrides12[1]; // Keyboard focus styling


  var _React$useState5 = React$2.useState(false),
      _React$useState6 = _slicedToArray$4(_React$useState5, 2),
      focusVisible = _React$useState6[0],
      setFocusVisible = _React$useState6[1];

  var handleFocus = React$2.useCallback(function (event) {
    if (isFocusVisible(event)) {
      setFocusVisible(true);
    }
  }, []);
  var handleBlur = React$2.useCallback(function (event) {
    if (focusVisible !== false) {
      setFocusVisible(false);
    }
  }, [focusVisible]); // Keyboard focus management

  var handleKeyDown = React$2.useCallback(function (event) {
    // WAI-ARIA 1.1
    // https://www.w3.org/TR/wai-aria-practices-1.1/#tabpanel
    // We use directional keys to iterate focus through Tabs.
    // Find all tabs eligible for focus
    var availableTabs = _toConsumableArray$1(event.target.parentNode.childNodes).filter(function (node) {
      return !node.disabled && node.getAttribute('role') === 'tab';
    }); // Exit early if there are no other tabs available


    if (availableTabs.length === 1) return; // Find tab to focus, looping to start/end of list if necessary

    var currentTabIndex = availableTabs.indexOf(event.target);
    var action = parseKeyDown(event);

    if (action) {
      var nextTab;

      if (action === KEYBOARD_ACTION.previous) {
        if (availableTabs[currentTabIndex - 1]) {
          nextTab = availableTabs[currentTabIndex - 1];
        } else {
          nextTab = availableTabs[availableTabs.length - 1];
        }
      } else if (action === KEYBOARD_ACTION.next) {
        if (availableTabs[currentTabIndex + 1]) {
          nextTab = availableTabs[currentTabIndex + 1];
        } else {
          nextTab = availableTabs[0];
        }
      }

      if (nextTab) {
        // Focus the tab
        nextTab.focus(); // Optionally activate the tab

        if (activateOnFocus) {
          nextTab.click();
        }
      } // Prevent default page scroll when in vertical orientation


      if (isVertical(orientation)) {
        event.preventDefault();
      }
    }
  });
  return /*#__PURE__*/React$2.createElement(Tab, _extends$5({
    "data-baseweb": "tab",
    key: key,
    id: getTabId(uid, key),
    role: "tab",
    onKeyDown: handleKeyDown,
    "aria-selected": isActive,
    "aria-controls": getTabPanelId(uid, key),
    tabIndex: isActive ? '0' : '-1',
    ref: isActive ? activeTabRef : ref,
    disabled: !isActive && disabled,
    type: "button" // so it doesn't trigger a submit when used inside forms
    ,
    $focusVisible: focusVisible,
    $isActive: isActive
  }, sharedStylingProps, restProps, TabProps, {
    onClick: function onClick(event) {
      if (typeof onChange === 'function') onChange({
        activeKey: key
      });
      if (typeof _onClick === 'function') _onClick(event);
    },
    onFocus: forkFocus(_objectSpread$5(_objectSpread$5({}, restProps), TabProps), handleFocus),
    onBlur: forkBlur(_objectSpread$5(_objectSpread$5({}, restProps), TabProps), handleBlur)
  }), Artwork ? /*#__PURE__*/React$2.createElement(ArtworkContainer, _extends$5({
    "data-baseweb": "artwork-container"
  }, sharedStylingProps, ArtworkContainerProps), /*#__PURE__*/React$2.createElement(Artwork, {
    size: 20,
    color: "contentPrimary"
  })) : null, title ? title : key);
}

function InternalTabPanel(_ref3) {
  var childKey = _ref3.childKey,
      childIndex = _ref3.childIndex,
      activeKey = _ref3.activeKey,
      uid = _ref3.uid,
      sharedStylingProps = _ref3.sharedStylingProps,
      renderAll = _ref3.renderAll,
      props = _objectWithoutProperties$3(_ref3, ["childKey", "childIndex", "activeKey", "uid", "sharedStylingProps", "renderAll"]);

  var key = childKey || String(childIndex);
  var isActive = key == activeKey;
  var _props$overrides2 = props.overrides,
      overrides = _props$overrides2 === void 0 ? {} : _props$overrides2,
      children = props.children;
  var TabPanelOverrides = overrides.TabPanel;

  var _getOverrides13 = getOverrides(TabPanelOverrides, StyledTabPanel$1),
      _getOverrides14 = _slicedToArray$4(_getOverrides13, 2),
      TabPanel = _getOverrides14[0],
      TabPanelProps = _getOverrides14[1];

  return /*#__PURE__*/React$2.createElement(TabPanel, _extends$5({
    "data-baseweb": "tab-panel",
    key: key,
    role: "tabpanel",
    id: getTabPanelId(uid, key),
    "aria-labelledby": getTabId(uid, key),
    hidden: !isActive
  }, sharedStylingProps, TabPanelProps), isActive || renderAll ? children : null);
}

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function Tab$1(props) {
  return null;
}

var TabSize;
(function (TabSize) {
    TabSize[TabSize["Default"] = 0] = "Default";
    TabSize[TabSize["Mini"] = 1] = "Mini";
})(TabSize || (TabSize = {}));

/* ***** Start Tabs Element Style Overrides. ***** */
const StyledRoot$2 = themedWithStyle(StyledRoot$3, {
    backgroundColor: 'transparent',
    flexGrow: 1,
});
const StyledTabList = themedWithStyle(StyledTabList$1, {
    height: 'auto',
    outline: 'none',
    ...padding('0px'),
    ...margin('0px'),
    backgroundColor: 'transparent',
});
const StyledTabBorder = themedWithStyle(StyledTabBorder$1, {
    backgroundColor: 'none',
    height: '0px',
    outline: 'none',
});
const StyledTabHighlight = themedWithStyle(StyledTabHighlight$1, ({ $theme }) => ({
    backgroundColor: $theme.colors['brand-primary-125'],
    height: '2px',
    outline: 'none',
}));
/* ***** Start Individual Tab Element Style Overrides ***** */
const StyledTab = themedWithStyle(StyledTab$1, ({ $isActive, $focusVisible, $size, $theme }) => ({
    ...($size === TabSize.Default
        ? typography$6.LabelMedium
        : typography$6.LabelSmall),
    fontWeight: $isActive ? FontWeight.Heavy : FontWeight.Regular,
    ...($size === TabSize.Default
        ? padding($theme.sizing.small, $theme.sizing['xx-small'])
        : padding($theme.sizing['xx-small'])),
    ...($focusVisible ? {
        outline: $theme.colors['brand-primary-50'],
    } : {}),
    ':hover': {
        background: $theme.colors['brand-primary-10'],
    },
    background: 'transparent',
    color: $isActive
        ? $theme.colors['brand-primary-125']
        : $theme.colors['neutral-75'],
    display: 'flex',
    textAlign: 'center',
    whiteSpace: 'nowrap',
}));
const StyledArtworkContainer = themedWithStyle(StyledArtworkContainer$1, ({ $theme }) => ({
    marginRight: $theme.sizing['xxx-small'],
}));
const StyledTabPanel = themedWithStyle(StyledTabPanel$1, {
    flexDirection: 'column',
    flexGrow: 1,
    ...padding('0px'),
});

const Tab = (props) => (React$2.createElement(Tab$1, { ...props }));
const CustomTabs = (props) => {
    const { children, size = TabSize.Default, ...restProps } = props;
    const [, theme] = themedUseStyletron();
    return (React$2.createElement(Tabs$1, { ...restProps }, React$2.Children.map(children, child => {
        if (!React$2.isValidElement(child)) {
            return child;
        }
        const { artwork: Artwork, isSpacer, ...childProps } = child.props;
        if (isSpacer) {
            return (React$2.createElement(Tab, { overrides: { Tab: { style: { flex: 1, visibility: 'hidden' } } }, key: "", title: "\u00A0" }));
        }
        const ArtworkComponent = useCallback(() => (React$2.createElement(Artwork, { size: theme.iconScale.small, color: child.key === restProps.activeKey
                ? theme.colors['brand-primary-125']
                : theme.colors['neutral-75'] })), [restProps]);
        return (React$2.createElement(Tab, { artwork: Artwork ? ArtworkComponent : null, overrides: {
                ArtworkContainer: StyledArtworkContainer,
                // eslint-disable-next-line react/display-name
                Tab: React$2.forwardRef((tabProps, ref) => (React$2.createElement(StyledTab, { ref: ref, ...{
                        ...tabProps,
                        $size: size,
                    } }))),
                TabPanel: StyledTabPanel,
            }, childKey: child.key, ...childProps }));
    })));
};
const Tabs = (props) => {
    const { children, ...otherProps } = props;
    return (React$2.createElement(CustomTabs, { overrides: {
            Root: StyledRoot$2,
            TabBorder: StyledTabBorder,
            TabHighlight: StyledTabHighlight,
            TabList: StyledTabList,
        }, ...otherProps }, children));
};

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty$7(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var StyledTextAreaRoot = styled('div', function (props) {
  return getRootStyles(_objectSpread$4(_objectSpread$4({
    $positive: false
  }, props), {}, {
    $hasIconTrailing: false
  }));
});
StyledTextAreaRoot.displayName = "StyledTextAreaRoot";
var StyledTextareaContainer$1 = styled('div', function (props) {
  return _objectSpread$4({}, getInputContainerStyles(_objectSpread$4({
    $positive: false
  }, props)));
});
StyledTextareaContainer$1.displayName = "StyledTextareaContainer";
var StyledTextarea$1 = styled('textarea', function (props) {
  return _objectSpread$4(_objectSpread$4({}, getInputStyles(props)), {}, {
    resize: 'none'
  });
});
StyledTextarea$1.displayName = "StyledTextarea";

function _typeof$2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

function _slicedToArray$3(arr, i) { return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _unsupportedIterableToArray$3(arr, i) || _nonIterableRest$3(); }

function _nonIterableRest$3() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }

function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$3(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$3(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$3(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); if (staticProps) _defineProperties$2(Constructor, staticProps); return Constructor; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$2(subClass, superClass); }

function _setPrototypeOf$2(o, p) { _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$2(o, p); }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf$2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$3(this, result); }; }

function _possibleConstructorReturn$3(self, call) { if (call && (_typeof$2(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$2(self); }

function _assertThisInitialized$2(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$2(o) { _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$2(o); }

function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Textarea$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$3(Textarea, _React$Component);

  var _super = _createSuper$2(Textarea);

  function Textarea() {
    var _this;

    _classCallCheck$3(this, Textarea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$6(_assertThisInitialized$2(_this), "state", {
      isFocused: _this.props.autoFocus || false
    });

    _defineProperty$6(_assertThisInitialized$2(_this), "onFocus", function (e) {
      _this.setState({
        isFocused: true
      });

      _this.props.onFocus(e);
    });

    _defineProperty$6(_assertThisInitialized$2(_this), "onBlur", function (e) {
      _this.setState({
        isFocused: false
      });

      _this.props.onBlur(e);
    });

    return _this;
  }

  _createClass$3(Textarea, [{
    key: "render",
    value: function render() {
      var _this$props$overrides = this.props.overrides,
          overrides = _this$props$overrides === void 0 ? {} : _this$props$overrides;

      var _getOverrides = getOverrides(overrides.Root, StyledTextAreaRoot),
          _getOverrides2 = _slicedToArray$3(_getOverrides, 2),
          Root = _getOverrides2[0],
          rootProps = _getOverrides2[1];

      var inputOverrides = mergeOverrides({
        Input: {
          component: StyledTextarea$1
        },
        InputContainer: {
          component: StyledTextareaContainer$1
        }
      }, overrides);
      return /*#__PURE__*/React$2.createElement(Root, _extends$4({
        "data-baseweb": "textarea",
        $isFocused: this.state.isFocused,
        $disabled: this.props.disabled,
        $error: this.props.error,
        $positive: this.props.positive,
        $required: this.props.required
      }, rootProps), /*#__PURE__*/React$2.createElement(BaseInput$1, _extends$4({}, this.props, {
        type: CUSTOM_INPUT_TYPE.textarea // $FlowFixMe[incompatible-indexer]
        ,
        overrides: inputOverrides,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      })));
    }
  }]);

  return Textarea;
}(React$2.Component);

_defineProperty$6(Textarea$1, "defaultProps", {
  autoFocus: false,
  disabled: false,
  error: false,
  name: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onKeyDown: function onKeyDown() {},
  onKeyPress: function onKeyPress() {},
  onKeyUp: function onKeyUp() {},
  onFocus: function onFocus() {},
  overrides: {},
  placeholder: '',
  required: false,
  rows: 3,
  size: SIZE$2.default
});

var BaseTextarea = Textarea$1;

const StyledTextarea = themedWithStyle(StyledTextarea$1, ({ $disabled, $theme }) => {
    let color = $theme.colors['neutral-100'];
    if ($disabled) {
        color = $theme.colors['neutral-50'];
    }
    return {
        '::placeholder': {
            color: $theme.colors['neutral-50'],
        },
        color,
        fontFamily: tokens$1['font-family'].heading,
        fontSize: tokens$1['font-size'].root,
        ...padding('0px'),
    };
});
const StyledTextareaContainer = themedWithStyle(StyledTextareaContainer$1, ({ $disabled, $isFocused, $error, $positive, $theme }) => {
    let backgroundColor = $theme.colors['neutral-10'];
    let inputContainerBorderWidth = '1px';
    let borderColor = $theme.colors['neutral-100'];
    let paddingBottom = '1px';
    if ($disabled) {
        borderColor = $theme.colors['neutral-25'];
        backgroundColor = $theme.colors['neutral-0'];
    }
    else if ($positive) {
        backgroundColor = $theme.colors['status-success-25'];
        inputContainerBorderWidth = '2px';
        borderColor = $theme.colors['status-success-100'];
        paddingBottom = '0px';
    }
    else if ($error) {
        backgroundColor = $theme.colors['status-danger-25'];
        inputContainerBorderWidth = '2px';
        borderColor = $theme.colors['status-danger-100'];
        paddingBottom = '0px';
    }
    else if ($isFocused) {
        inputContainerBorderWidth = '2px';
        paddingBottom = '0px';
    }
    else {
        borderColor = $theme.colors['neutral-75'];
    }
    return {
        backgroundColor,
        ...border$1('bottom', inputContainerBorderWidth, 'solid', borderColor),
        ...padding(tokens$1.spacing['xx-small'], tokens$1.spacing['xx-small'], math(`${paddingBottom} + ${tokens$1.spacing['xx-small']}`)),
    };
});

const Textarea = (props) => {
    const [, theme] = themedUseStyletron();
    const renderClearIcon = ({ onClick }) => (React$2.createElement("button", { type: "button", onClick: onClick, style: {
            background: 'transparent',
            ...borderWidth('0px'),
            cursor: 'pointer',
        } },
        React$2.createElement(Close$1, { color: theme.colors['neutral-75'] })));
    return (React$2.createElement(FormControl, { ...props },
        React$2.createElement(BaseTextarea, { overrides: {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                // because textarea thinks it doesn't have these components
                ClearIcon: {
                    component: renderClearIcon,
                },
                ClearIconContainer: {
                    style: {
                        paddingRight: '0px',
                        paddingTop: '0px',
                    },
                },
                Input: StyledTextarea,
                InputContainer: StyledTextareaContainer,
                Root: {
                    style: {
                        ...borderWidth('0px'),
                    },
                },
            }, ...props })));
};

const StatefulTextarea = (props) => (React$2.createElement(StatefulContainer$3, { ...props }, (childrenProps) => React$2.createElement(Textarea, { ...childrenProps })));

const Toast = (props) => (React$2.createElement(BaseToast, { ...props }));

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var MODE = Object.freeze({
  radio: 'radio',
  checkbox: 'checkbox'
});
Object.freeze({
  change: 'change'
});

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var StyledRoot$1 = styled('div', function (_ref) {
  var $shape = _ref.$shape,
      $length = _ref.$length,
      $theme = _ref.$theme;
  var margin = $length === 1 ? undefined : $shape !== SHAPE$1.default ? "-".concat($theme.sizing.scale100) : '-0.5px';
  return {
    display: 'flex',
    marginLeft: margin,
    marginRight: margin
  };
});
StyledRoot$1.displayName = "StyledRoot";

function _typeof$1(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty$5(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray$2(arr, i) { return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$2(); }

function _nonIterableRest$2() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$2(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$2(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); return Constructor; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$1(subClass, superClass); }

function _setPrototypeOf$1(o, p) { _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$1(o, p); }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }

function _possibleConstructorReturn$2(self, call) { if (call && (_typeof$1(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$1(self); }

function _assertThisInitialized$1(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$1(o) { _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$1(o); }

function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function isIndexSelected(selected, index) {
  if (!Array.isArray(selected) && typeof selected !== 'number') {
    return false;
  }

  if (Array.isArray(selected)) {
    return selected.includes(index);
  }

  return selected === index;
}

var ButtonGroup = /*#__PURE__*/function (_React$Component) {
  _inherits$2(ButtonGroup, _React$Component);

  var _super = _createSuper$1(ButtonGroup);

  function ButtonGroup() {
    var _this;

    _classCallCheck$2(this, ButtonGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$5(_assertThisInitialized$1(_this), "childRefs", {});

    return _this;
  }

  _createClass$2(ButtonGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$overrides = _this$props.overrides,
          overrides = _this$props$overrides === void 0 ? {} : _this$props$overrides,
          _this$props$mode = _this$props.mode,
          mode = _this$props$mode === void 0 ? MODE.checkbox : _this$props$mode,
          children = _this$props.children,
          selected = _this$props.selected,
          disabled = _this$props.disabled,
          _onClick = _this$props.onClick,
          kind = _this$props.kind,
          shape = _this$props.shape,
          size = _this$props.size;

      var _getOverrides = getOverrides(overrides.Root, StyledRoot$1),
          _getOverrides2 = _slicedToArray$2(_getOverrides, 2),
          Root = _getOverrides2[0],
          rootProps = _getOverrides2[1];

      var ariaLabel = this.props['aria-label'] || this.props.ariaLabel;
      var isRadio = mode === MODE.radio;
      var numItems = React$2.Children.count(children);
      return /*#__PURE__*/React$2.createElement(LocaleContext.Consumer, null, function (locale) {
        return /*#__PURE__*/React$2.createElement(Root, _extends$3({
          "aria-label": ariaLabel || locale.buttongroup.ariaLabel,
          "data-baseweb": "button-group",
          role: isRadio ? 'radiogroup' : 'group',
          $shape: shape,
          $length: children.length
        }, rootProps), React$2.Children.map(children, function (child, index) {
          if (! /*#__PURE__*/React$2.isValidElement(child)) {
            return null;
          }

          var isSelected = child.props.isSelected ? child.props.isSelected : isIndexSelected(selected, index);

          if (isRadio) {
            _this2.childRefs[index] = /*#__PURE__*/React$2.createRef();
          }

          return /*#__PURE__*/React$2.cloneElement(child, {
            disabled: disabled || child.props.disabled,
            isSelected: isSelected,
            ref: isRadio ? _this2.childRefs[index] : undefined,
            tabIndex: !isRadio || isSelected || isRadio && (!selected || selected === -1) && index === 0 ? 0 : -1,
            onKeyDown: function onKeyDown(e) {
              if (!isRadio) return;
              var value = Number(selected) ? Number(selected) : 0;

              if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
                e.preventDefault && e.preventDefault();
                var prevIndex = value - 1 < 0 ? numItems - 1 : value - 1;
                _onClick && _onClick(e, prevIndex);
                _this2.childRefs[prevIndex].current && _this2.childRefs[prevIndex].current.focus();
              }

              if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
                e.preventDefault && e.preventDefault();
                var nextIndex = value + 1 > numItems - 1 ? 0 : value + 1;
                _onClick && _onClick(e, nextIndex);
                _this2.childRefs[nextIndex].current && _this2.childRefs[nextIndex].current.focus();
              }
            },
            kind: kind,
            onClick: function onClick(event) {
              if (disabled) {
                return;
              }

              if (child.props.onClick) {
                child.props.onClick(event);
              }

              if (_onClick) {
                _onClick(event, index);
              }
            },
            shape: shape,
            size: size,
            overrides: _objectSpread$3({
              BaseButton: {
                style: function style(_ref) {
                  var $theme = _ref.$theme;

                  // Even though baseui's buttons have square corners, some applications override to
                  // rounded. Maintaining corner radius in this circumstance is ideal to avoid further
                  // customization.
                  if (children.length === 1) {
                    return {};
                  }

                  if (shape !== SHAPE$1.default) {
                    return {
                      marginLeft: $theme.sizing.scale100,
                      marginRight: $theme.sizing.scale100
                    };
                  }

                  return {
                    marginLeft: '0.5px',
                    marginRight: '0.5px'
                  };
                },
                props: {
                  'aria-checked': isSelected,
                  role: isRadio ? 'radio' : 'checkbox'
                }
              }
            }, child.props.overrides)
          });
        }));
      });
    }
  }]);

  return ButtonGroup;
}(React$2.Component);

_defineProperty$5(ButtonGroup, "defaultProps", {
  disabled: false,
  onClick: function onClick() {},
  shape: SHAPE$1.default,
  size: SIZE$3.default,
  kind: KIND$1.secondary
});

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var ALIGN = {
  right: 'flex-end',
  left: 'flex-start',
  center: 'center'
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty$4(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Root = styled('nav', function (props) {
  var $theme = props.$theme;
  var scale500 = $theme.sizing.scale500,
      font300 = $theme.typography.font300,
      border = $theme.colors.border;
  return _objectSpread$2(_objectSpread$2({}, font300), {}, {
    display: 'flex',
    paddingBottom: scale500,
    paddingTop: scale500,
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: "".concat(border),
    backgroundColor: $theme.colors.headerNavigationFill
  });
});
Root.displayName = "Root";
var NavigationItem = styled('li', function (props) {
  var $theme = props.$theme;
  var scale800 = $theme.sizing.scale800;
  return {
    alignSelf: 'center',
    paddingLeft: scale800
  };
});
NavigationItem.displayName = "NavigationItem";
var NavigationList = styled('ul', function (props) {
  var $align = props.$align,
      $theme = props.$theme;
  var aligned = $align === ALIGN.right || $align === ALIGN.left;
  var scale800 = $theme.sizing.scale800;
  return {
    display: 'flex',
    ':first-child': {
      padding: 0
    },
    ':last-child': {
      padding: 0
    },
    flexGrow: aligned ? 0 : 1,
    flexShrink: aligned ? 0 : 1,
    flexBasis: aligned ? 'auto' : '0%',
    paddingLeft: scale800,
    paddingRight: scale800,
    justifySelf: $align,
    justifyContent: $align,
    listStyle: 'none',
    marginBottom: 0,
    marginTop: 0,
    marginLeft: 0,
    marginRight: 0
  };
});
NavigationList.displayName = "NavigationList";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties$2(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _possibleConstructorReturn$1(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HeaderNavigation = /*#__PURE__*/function (_React$Component) {
  _inherits$1(HeaderNavigation, _React$Component);

  var _super = _createSuper(HeaderNavigation);

  function HeaderNavigation() {
    _classCallCheck$1(this, HeaderNavigation);

    return _super.apply(this, arguments);
  }

  _createClass$1(HeaderNavigation, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          overrides = _this$props.overrides,
          restProps = _objectWithoutProperties$2(_this$props, ["overrides"]);

      var _getOverrides = getOverrides(overrides.Root, Root),
          _getOverrides2 = _slicedToArray$1(_getOverrides, 2),
          Root$1 = _getOverrides2[0],
          rootProps = _getOverrides2[1];

      return /*#__PURE__*/React$2.createElement(Root$1, _extends$2({
        "data-baseweb": "header-navigation",
        role: "navigation"
      }, restProps, rootProps));
    }
  }]);

  return HeaderNavigation;
}(React$2.Component);

_defineProperty$3(HeaderNavigation, "defaultProps", {
  overrides: {}
});

var HeaderNavigation$1 = HeaderNavigation;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var COMMON_MIME_TYPES = new Map([
    ['avi', 'video/avi'],
    ['gif', 'image/gif'],
    ['ico', 'image/x-icon'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['mp4', 'video/mp4'],
    ['pdf', 'application/pdf'],
    ['png', 'image/png'],
    ['zip', 'application/zip'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}

var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, isDragEvt(evt) && evt.dataTransfer
                    ? getDataTransferFiles(evt.dataTransfer, evt.type)
                    : getInputFiles(evt)];
        });
    });
}
function isDragEvt(value) {
    return !!value.dataTransfer;
}
function getInputFiles(evt) {
    var files = isInput(evt.target)
        ? evt.target.files
            ? fromList(evt.target.files)
            : []
        : [];
    return files.map(function (file) { return toFileWithPath(file); });
}
function isInput(value) {
    return value !== null;
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spread(acc, (Array.isArray(files) ? flatten(files) : [files])); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject(item + " is not a File");
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}

var dist = createCommonjsModule(function (module) {
module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={i:e,l:!1,exports:{}};return t[e].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var r={};return n.m=t,n.c=r,n.d=function(t,r,e){n.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:e});},n.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(r,"a",r),r},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=13)}([function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r);},function(t,n){t.exports=function(t){return "object"==typeof t?null!==t:"function"==typeof t};},function(t,n){var r=t.exports={version:"2.5.0"};"number"==typeof __e&&(__e=r);},function(t,n,r){t.exports=!r(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a});},function(t,n){t.exports=function(t){try{return !!t()}catch(t){return !0}};},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)};},function(t,n,r){var e=r(32)("wks"),o=r(9),i=r(0).Symbol,u="function"==typeof i;(t.exports=function(t){return e[t]||(e[t]=u&&i[t]||(u?i:o)("Symbol."+t))}).store=e;},function(t,n,r){var e=r(0),o=r(2),i=r(8),u=r(22),c=r(10),f=function(t,n,r){var a,s,p,l,v=t&f.F,y=t&f.G,h=t&f.S,d=t&f.P,x=t&f.B,g=y?e:h?e[n]||(e[n]={}):(e[n]||{}).prototype,m=y?o:o[n]||(o[n]={}),b=m.prototype||(m.prototype={});y&&(r=n);for(a in r)s=!v&&g&&void 0!==g[a],p=(s?g:r)[a],l=x&&s?c(p,e):d&&"function"==typeof p?c(Function.call,p):p,g&&u(g,a,p,t&f.U),m[a]!=p&&i(m,a,l),d&&b[a]!=p&&(b[a]=p);};e.core=o,f.F=1,f.G=2,f.S=4,f.P=8,f.B=16,f.W=32,f.U=64,f.R=128,t.exports=f;},function(t,n,r){var e=r(16),o=r(21);t.exports=r(3)?function(t,n,r){return e.f(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t};},function(t,n){var r=0,e=Math.random();t.exports=function(t){return "Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))};},function(t,n,r){var e=r(24);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}};},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t};},function(t,n,r){var e=r(28),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0};},function(t,n,r){n.__esModule=!0,n.default=function(t,n){if(t&&n){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return r.some(function(t){var n=t.trim();return "."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):n.endsWith("/*")?i===n.replace(/\/.*$/,""):o===n})}return !0},r(14),r(34);},function(t,n,r){r(15),t.exports=r(2).Array.some;},function(t,n,r){var e=r(7),o=r(25)(3);e(e.P+e.F*!r(33)([].some,!0),"Array",{some:function(t){return o(this,t,arguments[1])}});},function(t,n,r){var e=r(17),o=r(18),i=r(20),u=Object.defineProperty;n.f=r(3)?Object.defineProperty:function(t,n,r){if(e(t),n=i(n,!0),e(r),o)try{return u(t,n,r)}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return "value"in r&&(t[n]=r.value),t};},function(t,n,r){var e=r(1);t.exports=function(t){if(!e(t))throw TypeError(t+" is not an object!");return t};},function(t,n,r){t.exports=!r(3)&&!r(4)(function(){return 7!=Object.defineProperty(r(19)("div"),"a",{get:function(){return 7}}).a});},function(t,n,r){var e=r(1),o=r(0).document,i=e(o)&&e(o.createElement);t.exports=function(t){return i?o.createElement(t):{}};},function(t,n,r){var e=r(1);t.exports=function(t,n){if(!e(t))return t;var r,o;if(n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;if("function"==typeof(r=t.valueOf)&&!e(o=r.call(t)))return o;if(!n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;throw TypeError("Can't convert object to primitive value")};},function(t,n){t.exports=function(t,n){return {enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}};},function(t,n,r){var e=r(0),o=r(8),i=r(23),u=r(9)("src"),c=Function.toString,f=(""+c).split("toString");r(2).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,c){var a="function"==typeof r;a&&(i(r,"name")||o(r,"name",n)),t[n]!==r&&(a&&(i(r,u)||o(r,u,t[n]?""+t[n]:f.join(String(n)))),t===e?t[n]=r:c?t[n]?t[n]=r:o(t,n,r):(delete t[n],o(t,n,r)));})(Function.prototype,"toString",function(){return "function"==typeof this&&this[u]||c.call(this)});},function(t,n){var r={}.hasOwnProperty;t.exports=function(t,n){return r.call(t,n)};},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t};},function(t,n,r){var e=r(10),o=r(26),i=r(27),u=r(12),c=r(29);t.exports=function(t,n){var r=1==t,f=2==t,a=3==t,s=4==t,p=6==t,l=5==t||p,v=n||c;return function(n,c,y){for(var h,d,x=i(n),g=o(x),m=e(c,y,3),b=u(g.length),_=0,w=r?v(n,b):f?v(n,0):void 0;b>_;_++)if((l||_ in g)&&(h=g[_],d=m(h,_,x),t))if(r)w[_]=d;else if(d)switch(t){case 3:return !0;case 5:return h;case 6:return _;case 2:w.push(h);}else if(s)return !1;return p?-1:a||s?s:w}};},function(t,n,r){var e=r(5);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return "String"==e(t)?t.split(""):Object(t)};},function(t,n,r){var e=r(11);t.exports=function(t){return Object(e(t))};},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)};},function(t,n,r){var e=r(30);t.exports=function(t,n){return new(e(t))(n)};},function(t,n,r){var e=r(1),o=r(31),i=r(6)("species");t.exports=function(t){var n;return o(t)&&(n=t.constructor,"function"!=typeof n||n!==Array&&!o(n.prototype)||(n=void 0),e(n)&&null===(n=n[i])&&(n=void 0)),void 0===n?Array:n};},function(t,n,r){var e=r(5);t.exports=Array.isArray||function(t){return "Array"==e(t)};},function(t,n,r){var e=r(0),o=e["__core-js_shared__"]||(e["__core-js_shared__"]={});t.exports=function(t){return o[t]||(o[t]={})};},function(t,n,r){var e=r(4);t.exports=function(t,n){return !!t&&e(function(){n?t.call(null,function(){},1):t.call(null);})};},function(t,n,r){r(35),t.exports=r(2).String.endsWith;},function(t,n,r){var e=r(7),o=r(12),i=r(36),u="".endsWith;e(e.P+e.F*r(38)("endsWith"),"String",{endsWith:function(t){var n=i(this,t,"endsWith"),r=arguments.length>1?arguments[1]:void 0,e=o(n.length),c=void 0===r?e:Math.min(o(r),e),f=String(t);return u?u.call(n,f,c):n.slice(c-f.length,c)===f}});},function(t,n,r){var e=r(37),o=r(11);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))};},function(t,n,r){var e=r(1),o=r(5),i=r(6)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))};},function(t,n,r){var e=r(6)("match");t.exports=function(t){var n=/./;try{"/./"[t](n);}catch(r){try{return n[e]=!1,!"/./"[t](n)}catch(t){}}return !0};}]);
});

var accepts = unwrapExports(dist);

var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;

// Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted
function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || accepts(file, accept);
}

function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}

function allFilesAccepted(files, accept) {
  return files.every(function (file) {
    return fileAccepted(file, accept);
  });
}

// React's synthetic events has evt.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check evt.cancelBubble
function isPropagationStopped(evt) {
  if (typeof evt.isPropagationStopped === 'function') {
    return evt.isPropagationStopped();
  } else if (typeof evt.cancelBubble !== 'undefined') {
    return evt.cancelBubble;
  }
  return false;
}

// React's synthetic events has evt.isDefaultPrevented,
// but to remain compatibility with other libs (Preact) first
// check evt.defaultPrevented
function isDefaultPrevented(evt) {
  if (typeof evt.defaultPrevented !== 'undefined') {
    return evt.defaultPrevented;
  } else if (typeof evt.isDefaultPrevented === 'function') {
    return evt.isDefaultPrevented();
  }
  return false;
}

function isDragDataWithFiles(evt) {
  if (!evt.dataTransfer) {
    return true;
  }
  // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
  return Array.prototype.some.call(evt.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}

// allow the entire document to be a drag target
function onDocumentDragOver(evt) {
  evt.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;

  return isIe(userAgent) || isEdge(userAgent);
}

/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.preventDefault()`.
 * Not sure this is the best way to do this, but it seems legit.
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */
function composeEventHandlers() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      fn && fn.apply(undefined, [event].concat(args));
      return event.defaultPrevented;
    });
  };
}

var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties$1(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Dropzone = function (_React$Component) {
  _inherits(Dropzone, _React$Component);

  function Dropzone() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Dropzone);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      draggedFiles: [],
      acceptedFiles: [],
      rejectedFiles: []
    }, _this.isFileDialogActive = false, _this.onDocumentDrop = function (evt) {
      if (_this.node && _this.node.contains(evt.target)) {
        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
      }
      evt.preventDefault();
      _this.dragTargets = [];
    }, _this.onDragStart = function (evt) {
      evt.persist();
      if (_this.props.onDragStart && isDragDataWithFiles(evt)) {
        _this.props.onDragStart.call(_this, evt);
      }
    }, _this.onDragEnter = function (evt) {
      evt.preventDefault();

      // Count the dropzone and any children that are entered.
      if (_this.dragTargets.indexOf(evt.target) === -1) {
        _this.dragTargets.push(evt.target);
      }

      evt.persist();

      if (isDragDataWithFiles(evt)) {
        Promise.resolve(_this.props.getDataTransferItems(evt)).then(function (draggedFiles) {
          if (isPropagationStopped(evt)) {
            return;
          }

          _this.setState({
            draggedFiles: draggedFiles,
            // Do not rely on files for the drag state. It doesn't work in Safari.
            isDragActive: true
          });
        });

        if (_this.props.onDragEnter) {
          _this.props.onDragEnter.call(_this, evt);
        }
      }
    }, _this.onDragOver = function (evt) {
      // eslint-disable-line class-methods-use-this
      evt.preventDefault();
      evt.persist();

      if (evt.dataTransfer) {
        evt.dataTransfer.dropEffect = 'copy';
      }

      if (_this.props.onDragOver && isDragDataWithFiles(evt)) {
        _this.props.onDragOver.call(_this, evt);
      }

      return false;
    }, _this.onDragLeave = function (evt) {
      evt.preventDefault();
      evt.persist();

      // Only deactivate once the dropzone and all children have been left.
      _this.dragTargets = _this.dragTargets.filter(function (el) {
        return el !== evt.target && _this.node.contains(el);
      });
      if (_this.dragTargets.length > 0) {
        return;
      }

      // Clear dragging files state
      _this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      if (_this.props.onDragLeave && isDragDataWithFiles(evt)) {
        _this.props.onDragLeave.call(_this, evt);
      }
    }, _this.onDrop = function (evt) {
      var _this$props = _this.props,
          onDrop = _this$props.onDrop,
          onDropAccepted = _this$props.onDropAccepted,
          onDropRejected = _this$props.onDropRejected,
          multiple = _this$props.multiple,
          accept = _this$props.accept,
          getDataTransferItems = _this$props.getDataTransferItems;

      // Stop default browser behavior

      evt.preventDefault();

      // Persist event for later usage
      evt.persist();

      // Reset the counter along with the drag on a drop.
      _this.dragTargets = [];
      _this.isFileDialogActive = false;

      // Clear files value
      _this.draggedFiles = null;

      // Reset drag state
      _this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      if (isDragDataWithFiles(evt)) {
        Promise.resolve(getDataTransferItems(evt)).then(function (fileList) {
          var acceptedFiles = [];
          var rejectedFiles = [];

          if (isPropagationStopped(evt)) {
            return;
          }

          fileList.forEach(function (file) {
            if (fileAccepted(file, accept) && fileMatchSize(file, _this.props.maxSize, _this.props.minSize)) {
              acceptedFiles.push(file);
            } else {
              rejectedFiles.push(file);
            }
          });

          if (!multiple && acceptedFiles.length > 1) {
            // if not in multi mode add any extra accepted files to rejected.
            // This will allow end users to easily ignore a multi file drop in "single" mode.
            rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(0)));
          }

          // Update `acceptedFiles` and `rejectedFiles` state
          // This will make children render functions receive the appropriate
          // values
          _this.setState({ acceptedFiles: acceptedFiles, rejectedFiles: rejectedFiles }, function () {
            if (onDrop) {
              onDrop.call(_this, acceptedFiles, rejectedFiles, evt);
            }

            if (rejectedFiles.length > 0 && onDropRejected) {
              onDropRejected.call(_this, rejectedFiles, evt);
            }

            if (acceptedFiles.length > 0 && onDropAccepted) {
              onDropAccepted.call(_this, acceptedFiles, evt);
            }
          });
        });
      }
    }, _this.onClick = function (evt) {
      var onClick = _this.props.onClick;

      // if onClick prop is given, run it first

      if (onClick) {
        onClick.call(_this, evt);
      }

      // If the event hasn't been default prevented from within
      // the onClick listener, open the file dialog
      if (!isDefaultPrevented(evt)) {
        evt.stopPropagation();

        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
        // this is so react can handle state changes in the onClick prop above above
        // see: https://github.com/react-dropzone/react-dropzone/issues/450
        if (isIeOrEdge()) {
          setTimeout(_this.open, 0);
        } else {
          _this.open();
        }
      }
    }, _this.onInputElementClick = function (evt) {
      evt.stopPropagation();
    }, _this.onFileDialogCancel = function () {
      // timeout will not recognize context of this method
      var onFileDialogCancel = _this.props.onFileDialogCancel;
      // execute the timeout only if the FileDialog is opened in the browser

      if (_this.isFileDialogActive) {
        setTimeout(function () {
          if (_this.input != null) {
            // Returns an object as FileList
            var files = _this.input.files;


            if (!files.length) {
              _this.isFileDialogActive = false;

              if (typeof onFileDialogCancel === 'function') {
                onFileDialogCancel();
              }
            }
          }
        }, 300);
      }
    }, _this.onFocus = function (evt) {
      var onFocus = _this.props.onFocus;

      if (onFocus) {
        onFocus.call(_this, evt);
      }
      if (!isDefaultPrevented(evt)) {
        _this.setState({ isFocused: true });
      }
    }, _this.onBlur = function (evt) {
      var onBlur = _this.props.onBlur;

      if (onBlur) {
        onBlur.call(_this, evt);
      }
      if (!isDefaultPrevented(evt)) {
        _this.setState({ isFocused: false });
      }
    }, _this.onKeyDown = function (evt) {
      var onKeyDown = _this.props.onKeyDown;

      if (!_this.node.isEqualNode(evt.target)) {
        return;
      }

      if (onKeyDown) {
        onKeyDown.call(_this, evt);
      }

      if (!isDefaultPrevented(evt) && (evt.keyCode === 32 || evt.keyCode === 13)) {
        evt.preventDefault();
        _this.open();
      }
    }, _this.composeHandler = function (handler) {
      if (_this.props.disabled) {
        return null;
      }
      return handler;
    }, _this.getRootProps = function () {
      var _extends2;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === undefined ? 'ref' : _ref2$refKey,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragStart = _ref2.onDragStart,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties$1(_ref2, ['refKey', 'onKeyDown', 'onFocus', 'onBlur', 'onClick', 'onDragStart', 'onDragEnter', 'onDragOver', 'onDragLeave', 'onDrop']);

      return _extends$1((_extends2 = {
        onKeyDown: _this.composeHandler(onKeyDown ? composeEventHandlers(onKeyDown, _this.onKeyDown) : _this.onKeyDown),
        onFocus: _this.composeHandler(onFocus ? composeEventHandlers(onFocus, _this.onFocus) : _this.onFocus),
        onBlur: _this.composeHandler(onBlur ? composeEventHandlers(onBlur, _this.onBlur) : _this.onBlur),
        onClick: _this.composeHandler(onClick ? composeEventHandlers(onClick, _this.onClick) : _this.onClick),
        onDragStart: _this.composeHandler(onDragStart ? composeEventHandlers(onDragStart, _this.onDragStart) : _this.onDragStart),
        onDragEnter: _this.composeHandler(onDragEnter ? composeEventHandlers(onDragEnter, _this.onDragEnter) : _this.onDragEnter),
        onDragOver: _this.composeHandler(onDragOver ? composeEventHandlers(onDragOver, _this.onDragOver) : _this.onDragOver),
        onDragLeave: _this.composeHandler(onDragLeave ? composeEventHandlers(onDragLeave, _this.onDragLeave) : _this.onDragLeave),
        onDrop: _this.composeHandler(onDrop ? composeEventHandlers(onDrop, _this.onDrop) : _this.onDrop)
      }, _defineProperty$2(_extends2, refKey, _this.setNodeRef), _defineProperty$2(_extends2, 'tabIndex', _this.props.disabled ? -1 : 0), _extends2), rest);
    }, _this.getInputProps = function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === undefined ? 'ref' : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties$1(_ref3, ['refKey', 'onChange', 'onClick']);

      var _this$props2 = _this.props,
          accept = _this$props2.accept,
          multiple = _this$props2.multiple,
          name = _this$props2.name;

      var inputProps = _defineProperty$2({
        accept: accept,
        type: 'file',
        style: { display: 'none' },
        multiple: supportMultiple && multiple,
        onChange: composeEventHandlers(onChange, _this.onDrop),
        onClick: composeEventHandlers(onClick, _this.onInputElementClick),
        autoComplete: 'off',
        tabIndex: -1
      }, refKey, _this.setInputRef);
      if (name && name.length) {
        inputProps.name = name;
      }
      return _extends$1({}, inputProps, rest);
    }, _this.setNodeRef = function (node) {
      _this.node = node;
    }, _this.setInputRef = function (input) {
      _this.input = input;
    }, _this.open = function () {
      _this.isFileDialogActive = true;
      if (_this.input) {
        _this.input.value = null;
        _this.input.click();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dropzone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      this.dragTargets = [];

      if (preventDropOnDocument) {
        document.addEventListener('dragover', onDocumentDragOver, false);
        document.addEventListener('drop', this.onDocumentDrop, false);
      }

      window.addEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      if (preventDropOnDocument) {
        document.removeEventListener('dragover', onDocumentDragOver);
        document.removeEventListener('drop', this.onDocumentDrop);
      }

      window.removeEventListener('focus', this.onFileDialogCancel, false);
    }

    /**
     * Open system file upload dialog.
     *
     * @public
     */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          multiple = _props.multiple,
          disabled = _props.disabled;
      var _state = this.state,
          isDragActive = _state.isDragActive,
          isFocused = _state.isFocused,
          draggedFiles = _state.draggedFiles,
          acceptedFiles = _state.acceptedFiles,
          rejectedFiles = _state.rejectedFiles;


      var filesCount = draggedFiles.length;
      var isMultipleAllowed = multiple || filesCount <= 1;
      var isDragAccept = filesCount > 0 && allFilesAccepted(draggedFiles, this.props.accept);
      var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);

      return children({
        isDragActive: isDragActive,
        isDragAccept: isDragAccept,
        isDragReject: isDragReject,
        draggedFiles: draggedFiles,
        acceptedFiles: acceptedFiles,
        rejectedFiles: rejectedFiles,
        isFocused: isFocused && !disabled,
        getRootProps: this.getRootProps,
        getInputProps: this.getInputProps,
        open: this.open
      });
    }
  }]);

  return Dropzone;
}(React__default.Component);

Dropzone.propTypes = {
  /**
   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),

  /**
   * Render function that renders the actual component
   *
   * @param {Object} props
   * @param {Function} props.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} props.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} props.open Open the native file selection dialog
   * @param {Boolean} props.isFocused Dropzone area is in focus
   * @param {Boolean} props.isDragActive Active drag is in progress
   * @param {Boolean} props.isDragAccept Dragged files are accepted
   * @param {Boolean} props.isDragReject Some dragged files are rejected
   * @param {Array} props.draggedFiles Files in active drag
   * @param {Array} props.acceptedFiles Accepted files
   * @param {Array} props.rejectedFiles Rejected files
   */
  children: PropTypes.func,

  /**
   * Enable/disable the dropzone entirely
   */
  disabled: PropTypes.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes.bool,

  /**
   * Allow dropping multiple files
   */
  multiple: PropTypes.bool,

  /**
   * `name` attribute for the input tag
   */
  name: PropTypes.string,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,

  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes.number,

  /**
   * getDataTransferItems handler
   * @param {Event} event
   * @returns {Array} array of File objects
   */
  getDataTransferItems: PropTypes.func,

  /**
   * onClick callback
   * @param {Event} event
   */
  onClick: PropTypes.func,

  /**
   * onFocus callback
   */
  onFocus: PropTypes.func,

  /**
   * onBlur callback
   */
  onBlur: PropTypes.func,

  /**
   * onKeyDown callback
   */
  onKeyDown: PropTypes.func,

  /**
   * The `onDrop` method that accepts two arguments.
   * The first argument represents the accepted files and the second argument the rejected files.
   *
   * ```javascript
   * function onDrop(acceptedFiles, rejectedFiles) {
   *   // do stuff with files...
   * }
   * ```
   *
   * Files are accepted or rejected based on the `accept` prop.
   * This must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   *
   * Note that the `onDrop` callback will always be called regardless if the dropped files were accepted or rejected.
   * You can use the `onDropAccepted`/`onDropRejected` props if you'd like to react to a specific event instead of the `onDrop` prop.
   *
   * The `onDrop` callback will provide you with an array of [Files](https://developer.mozilla.org/en-US/docs/Web/API/File) which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```javascript
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   */
  onDrop: PropTypes.func,

  /**
   * onDropAccepted callback
   */
  onDropAccepted: PropTypes.func,

  /**
   * onDropRejected callback
   */
  onDropRejected: PropTypes.func,

  /**
   * onDragStart callback
   */
  onDragStart: PropTypes.func,

  /**
   * onDragEnter callback
   */
  onDragEnter: PropTypes.func,

  /**
   * onDragOver callback
   */
  onDragOver: PropTypes.func,

  /**
   * onDragLeave callback
   */
  onDragLeave: PropTypes.func,

  /**
   * Provide a callback on clicking the cancel button of the file dialog
   */
  onFileDialogCancel: PropTypes.func
};

Dropzone.defaultProps = {
  preventDropOnDocument: true,
  disabled: false,
  multiple: true,
  maxSize: Infinity,
  minSize: 0,
  getDataTransferItems: fromEvent
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var StyledFileDragAndDrop = styled('div', function (props) {
  var borderColor = props.$isDragActive ? props.$theme.colors.borderAccent : props.$theme.colors.fileUploaderBorderColorDefault;
  var borderStyle = props.$afterFileDrop ? 'none' : 'dashed';
  return {
    alignItems: 'center',
    backgroundColor: props.$isDragActive ? props.$theme.colors.backgroundLightAccent : props.$theme.colors.fileUploaderBackgroundColor,
    borderLeftColor: borderColor,
    borderRightColor: borderColor,
    borderTopColor: borderColor,
    borderBottomColor: borderColor,
    borderLeftStyle: borderStyle,
    borderRightStyle: borderStyle,
    borderTopStyle: borderStyle,
    borderBottomStyle: borderStyle,
    borderLeftWidth: props.$theme.sizing.scale0,
    borderRightWidth: props.$theme.sizing.scale0,
    borderTopWidth: props.$theme.sizing.scale0,
    borderBottomWidth: props.$theme.sizing.scale0,
    borderTopLeftRadius: props.$theme.borders.radius400,
    borderTopRightRadius: props.$theme.borders.radius400,
    borderBottomLeftRadius: props.$theme.borders.radius400,
    borderBottomRightRadius: props.$theme.borders.radius400,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    outline: 'none',
    paddingTop: props.$theme.sizing.scale900,
    paddingRight: props.$theme.sizing.scale800,
    paddingBottom: props.$afterFileDrop ? props.$theme.sizing.scale300 : props.$theme.sizing.scale900,
    paddingLeft: props.$theme.sizing.scale800,
    width: '100%'
  };
});
StyledFileDragAndDrop.displayName = "StyledFileDragAndDrop";
var StyledContentMessage = styled('div', function (_ref) {
  var $theme = _ref.$theme,
      $afterFileDrop = _ref.$afterFileDrop,
      $isDragActive = _ref.$isDragActive;
  return _objectSpread$1(_objectSpread$1({}, $afterFileDrop ? $theme.typography.LabelMedium : $theme.typography.LabelSmall), {}, {
    color: $afterFileDrop ? $theme.colors.contentPrimary : $isDragActive ? $theme.colors.contentAccent : null,
    marginTop: $afterFileDrop ? $theme.sizing.scale100 : null,
    marginBottom: $afterFileDrop ? $theme.sizing.scale100 : null
  });
});
StyledContentMessage.displayName = "StyledContentMessage";
var StyledContentSeparator = StyledContentMessage;
var StyledErrorMessage = styled('div', function (props) {
  return _objectSpread$1(_objectSpread$1({}, props.$theme.typography.LabelMedium), {}, {
    color: props.$theme.colors.negative,
    marginTop: props.$afterFileDrop ? props.$theme.sizing.scale100 : null,
    marginBottom: props.$afterFileDrop ? props.$theme.sizing.scale100 : null
  });
});
StyledErrorMessage.displayName = "StyledErrorMessage";
var StyledRoot = styled('div', function (props) {
  return _objectSpread$1(_objectSpread$1({}, props.$theme.typography.font300), {}, {
    color: props.$theme.colors.fileUploaderMessageColor
  });
});
StyledRoot.displayName = "StyledRoot";
var StyledHiddenInput = styled('input', {});
StyledHiddenInput.displayName = "StyledHiddenInput";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function prependStyleProps(styleProps) {
  return Object.keys(styleProps).reduce(function (nextStyleProps, currentKey) {
    nextStyleProps["$".concat(currentKey)] = styleProps[currentKey];
    return nextStyleProps;
  }, {});
}

function FileUploader(props) {
  var _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides;

  var _useStyletron = useStyletron(),
      _useStyletron2 = _slicedToArray(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _getOverrides = getOverrides(overrides.Root, StyledRoot),
      _getOverrides2 = _slicedToArray(_getOverrides, 2),
      Root = _getOverrides2[0],
      rootProps = _getOverrides2[1];

  var _getOverrides3 = getOverrides(overrides.FileDragAndDrop, StyledFileDragAndDrop),
      _getOverrides4 = _slicedToArray(_getOverrides3, 2),
      FileDragAndDrop = _getOverrides4[0],
      fileDragAndDropProps = _getOverrides4[1];

  var _getOverrides5 = getOverrides(overrides.ContentMessage, StyledContentMessage),
      _getOverrides6 = _slicedToArray(_getOverrides5, 2),
      ContentMessage = _getOverrides6[0],
      contentMessageProps = _getOverrides6[1];

  var _getOverrides7 = getOverrides(overrides.ContentSeparator, StyledContentSeparator),
      _getOverrides8 = _slicedToArray(_getOverrides7, 2),
      ContentSeparator = _getOverrides8[0],
      contentSeparatorProps = _getOverrides8[1];

  var _getOverrides9 = getOverrides(overrides.ErrorMessage, StyledErrorMessage),
      _getOverrides10 = _slicedToArray(_getOverrides9, 2),
      ErrorMessage = _getOverrides10[0],
      errorMessageProps = _getOverrides10[1];

  var _getOverrides11 = getOverrides(overrides.HiddenInput, StyledHiddenInput),
      _getOverrides12 = _slicedToArray(_getOverrides11, 2),
      HiddenInput = _getOverrides12[0],
      hiddenInputProps = _getOverrides12[1];

  var _getOverrides13 = getOverrides(overrides.ButtonComponent, Button$2),
      _getOverrides14 = _slicedToArray(_getOverrides13, 2),
      ButtonComponent = _getOverrides14[0],
      buttonProps = _getOverrides14[1];

  var _getOverrides15 = getOverrides(overrides.Spinner, StyledSpinnerNext$1),
      _getOverrides16 = _slicedToArray(_getOverrides15, 2),
      SpinnerComponent = _getOverrides16[0],
      spinnerProps = _getOverrides16[1];

  var afterFileDrop = !!(props.progressAmount || props.progressMessage || props.errorMessage);
  return /*#__PURE__*/React$2.createElement(Dropzone, _extends({}, props, {
    disabled: props.disabled || afterFileDrop
  }), function (renderProps) {
    var getRootProps = renderProps.getRootProps,
        getInputProps = renderProps.getInputProps,
        open = renderProps.open,
        styleProps = _objectWithoutProperties(renderProps, ["getRootProps", "getInputProps", "open"]);

    var prefixedStyledProps = prependStyleProps(_objectSpread(_objectSpread({}, styleProps), {}, {
      isDisabled: props.disabled,
      afterFileDrop: afterFileDrop
    }));

    var getRootPropsArgs = _objectSpread(_objectSpread({}, props.disableClick ? {
      onClick: function onClick(evt) {
        return evt.preventDefault();
      }
    } : {}), {}, {
      tabIndex: '-1'
    });

    return /*#__PURE__*/React$2.createElement(LocaleContext.Consumer, null, function (locale) {
      return /*#__PURE__*/React$2.createElement(Root, _extends({
        "data-baseweb": "file-uploader"
      }, prefixedStyledProps, rootProps), /*#__PURE__*/React$2.createElement(FileDragAndDrop, _extends({}, getRootProps(getRootPropsArgs), prefixedStyledProps, fileDragAndDropProps), !afterFileDrop && /*#__PURE__*/React$2.createElement(React$2.Fragment, null, /*#__PURE__*/React$2.createElement(ContentMessage, _extends({}, prefixedStyledProps, contentMessageProps), locale.fileuploader.dropFilesToUpload), /*#__PURE__*/React$2.createElement(ContentSeparator, _extends({}, prefixedStyledProps, contentSeparatorProps), locale.fileuploader.or), /*#__PURE__*/React$2.createElement(ButtonComponent, _extends({
        disabled: props.disabled,
        kind: KIND$1.secondary,
        shape: SHAPE$1.pill,
        size: SIZE$3.compact,
        onClick: open,
        role: "button",
        overrides: {
          BaseButton: {
            style: function style(_ref) {
              var $theme = _ref.$theme;
              return {
                marginTop: $theme.sizing.scale500
              };
            }
          }
        }
      }, prefixedStyledProps, buttonProps), locale.fileuploader.browseFiles)), afterFileDrop && /*#__PURE__*/React$2.createElement(React$2.Fragment, null, typeof props.progressAmount === 'number' ? /*#__PURE__*/React$2.createElement(ProgressBar$2, {
        value: props.progressAmount,
        overrides: {
          BarProgress: {
            style: function style(_ref2) {
              var $theme = _ref2.$theme;
              return {
                backgroundColor: props.errorMessage ? $theme.colors.negative : $theme.colors.accent
              };
            }
          }
        }
      }) : props.errorMessage ? null : /*#__PURE__*/React$2.createElement(SpinnerComponent, _extends({
        $size: SIZE$4.medium,
        $style: {
          marginBottom: theme.sizing.scale300
        }
      }, spinnerProps)), (props.errorMessage || props.progressMessage) && props.errorMessage ? /*#__PURE__*/React$2.createElement(ErrorMessage, _extends({}, prefixedStyledProps, errorMessageProps), props.errorMessage) : /*#__PURE__*/React$2.createElement(ContentMessage, _extends({}, prefixedStyledProps, contentMessageProps), props.progressMessage), props.errorMessage ? /*#__PURE__*/React$2.createElement(ButtonComponent, {
        kind: KIND$1.minimal,
        onClick: function onClick() {
          props.onRetry && props.onRetry();
        },
        "aria-invalid": Boolean(props.errorMessage),
        "aria-describedby": props['aria-describedby'],
        "aria-errormessage": props.errorMessage
      }, locale.fileuploader.retry) : /*#__PURE__*/React$2.createElement(ButtonComponent, {
        kind: KIND$1.minimal,
        onClick: function onClick() {
          props.onCancel && props.onCancel();
        },
        "aria-describedby": props['aria-describedby'],
        overrides: {
          BaseButton: {
            style: function style(_ref3) {
              var $theme = _ref3.$theme;
              return {
                color: $theme.colors.contentNegative
              };
            }
          }
        }
      }, locale.fileuploader.cancel))), /*#__PURE__*/React$2.createElement(HiddenInput, _extends({
        "aria-invalid": Boolean(props.errorMessage) || null,
        "aria-describedby": props['aria-describedby'],
        "aria-errormessage": props.errorMessage || null
      }, getInputProps(), prefixedStyledProps, hiddenInputProps)));
    });
  });
}

FileUploader.defaultProps = {
  disableClick: true,
  overrides: {}
};

export { ALIGN, AbtTaskPictogram, Accordion, AddAccountPictogram, AddCircleOutlineIcon, AddOutlineIcon, AdvertisingPictogram, AgriculturePictogram, AirplanePictogram, AirportPictogram, AlertOutlineIcon, AlertPictogram, ArrowDownOutlineIcon, arrowLeft as ArrowLeft, ArrowLeftOutlineIcon, arrowRight as ArrowRight, ArrowRightOutlineIcon, ArrowUpOutlineIcon, ArtPictogram, AscendingOutlineIcon, AudioOffOutlineIcon, AudioOnOutlineIcon, AudioPictogram, AutoValidateOutlineIcon, BADGE_KIND, BAR_SIZE, BEHAVIOR, KIND$1 as BUTTON_KIND, SIZE$3 as BUTTON_SIZE, Back10OutlineIcon, BadgeColors, BankOutlineIcon, Bar$1 as Bar, BaseProvider$1 as BaseProvider, BattlesPictogram, BeverageFreshnessPictogram, BgPauseIcon, BgPlayIcon, BigBoxStorePictogram, BillboardPictogram, BinocularsPictogram, Block, BoatPictogram, ParagraphLarge as Body, ParagraphSmall as BodySmall, BoundaryL0FillIcon, BoundaryL1FillIcon, BoundaryL2FillIcon, BoundaryPointsFillIcon, BoxPictogram, Breadcrumbs, BridgesPictogram, BrushPictogram, Button, ButtonGroup, STYLE_TYPE as CHECKBOX_TYPE, CalendarIcon, CalendarOutlineIcon, CameraOutlineIcon, Card, CardVariant, CaretDownOutlineIcon, CaretUpOutlineIcon, CautionFillIcon, CautionOutlineIcon, Cell, ChartPictogram, ChatOutlineIcon, Checkbox, CheckboxCheckedOutlineIcon, CheckboxDashOutlineIcon, CheckboxDefaultOutlineIcon, CheckboxSize, CheckmarkFillIcon, CheckmarkOutlineIcon, ChevronDown, ChevronLeft, ChevronLeftOutlineIcon, ChevronRight, ChevronRightOutlineIcon, ChevronUp, CircleCautionFillIcon, CircleCautionOutlineIcon, Close$1 as Close, CloseCircleFillIcon, CloseCircleOutlineIcon, CloseOutlineIcon, ClosedCaptionFillIcon, CollapseIcon, CollapseOutlineIcon, CommunityPictogram, CompliancePictogram, ConvenienceStorePictogram, CostOfLivingPictogram, CountOutlineIcon, CovidPictogram, ANCHOR as DRAWER_ANCHOR, SIZE$1 as DRAWER_SIZE, DarkOutlineIcon, DarkTheme, DatePicker, Delete, DeleteOutlineIcon, DescendingOutlineIcon, DiagonalUpArrowOutlineIcon, DigitalMediaPictogram, DiscoveryPictogram, Display4, DownloadOutlineIcon, DraftOutlineIcon, Drawer, EducationPictogram, ElectricityPictogram, EllipsesHorizontalOutlineIcon, EllipsesVerticalOutlineIcon, ExpandIcon, ExpandOutlineIcon, ExplosionPictogram, ExtremelySatisfiedOutlineIcon, ExtremelyUnsatisfiedOutlineIcon, FastforwardFillIcon, FileUploader, FilledAlertFillIcon, FilledDarkFillIcon, FilledDeleteFillIcon, FilledDragFillIcon, FilledExtremelySatisfiedFillIcon, FilledExtremelyUnsatisfiedFillIcon, FilledFolderFillIcon, FilledGroupFillIcon, FilledInviteFillIcon, FilledLightFillIcon, FilledMapLayerFillIcon, FilledNeutralFillIcon, FilledNotificationFillIcon, FilledOverviewFillIcon, FilledSatisfiedFillIcon, FilledSaveFillIcon, FilledShareFillIcon, FilledSplitScreenFillIcon, FilledSuggestedPlaceToValidateFillIcon, FilledUnsatisfiedFillIcon, Filter, FilterOffOutlineIcon, FilterOnOutlineIcon, FlexGrid, FlexGridItemComponent$1 as FlexGridItem, FluidGrid, FolderOutlineIcon, FontWeight, FoodPictogram, FormControl, FullScreenOutlineIcon, GeneralEconomyPictogram, GlobalPictogram, Globe, GovernmentPictogram, Grid, GridOutlineIcon, GroceriesPictogram, GroceryCartPictogram, GroupOutlineIcon, GuidelinesOutlineIcon, HeadingXXLarge as H1, HeadingXLarge as H2, HeadingLarge as H3, HeadingMedium as H4, Hamburger, HardhatPictogram, HardwarePictogram, HardwareStorePictogram, HeaderNavigation$1 as HeaderNavigation, HealthPictogram, HelpOutlineIcon, HideOutlineIcon, HomeFillIcon, HomeOutlineIcon, HouseholdPictogram, HyperLinkStyles, HyperLinkStylesSmall, SIZE$2 as INPUT_SIZE, INPUT_TYPE, Icon$2 as Icon, IconButton, ImageOutlineIcon, InfoOutlineIcon, InfrastructureRoadsPictogram, Input$1 as Input, InviteOutlineIcon, JobPictogram, LABEL_PLACEMENT, LIKERT_SIZE, LabelMedium as Label, LabelLarge, LabelSmall, LabelSmallTight, LanguageOutlineIcon, Lattice, Layer, LayerOutlineIcon, LightOutlineIcon, LightTheme, LightbulbOutlineIcon, Likert, LineHeightVariant, LinkOutlineIcon, List, ListItem, ListItemLabel, ListOutlineIcon, LocateOutlineIcon, LockIcon, LockOutlineIcon, LogoutOutlineIcon, SIZE as MODAL_SIZE, MapOutlineIcon, MapPinFillIcon, MapPinOutlineIcon, MarketFillIcon, MarketOutlineIcon, MeatPictogram, MinimizeFullScreenOutlineIcon, MinusOutlineIcon, Modal, ModalBody, ModalFooter, ModalHeader, MonumentPictogram, MuralPictogram, KIND as NOTIFICATION_KIND, NaturePictogram, NetworkPictogram, NeutralOutlineIcon, NewsPictogram, NoImageOutlineIcon, NoWifiOutlineIcon, Notification, NotificationOutlineIcon, OutlineCheckmarkIcon, Overflow, OverviewOutlineIcon, SIZE$2 as PHONE_INPUT_SIZE, PLACEMENT$2 as PLACEMENT, PLACEMENT$2 as POPOVER_PLACEMENT, SIZE$5 as PROGRESS_BAR_SIZE, Pagination, Panel, ParkPictogram, PauseOutlineIcon, PaymentsFillIcon, PaymentsOutlineIcon, PencilOutlineIcon, PercentageOutlineIcon, PetStorePictogram, PharmacyPictogram, PhoneInput, PhoneOutlineIcon, PlaceOfWorshipPictogram, PlayCircleOutlineIcon, PlayFillIcon, PlayOutlineIcon, Plus, PopoverMenu, PotholePictogram, PreferencesOutlineIcon, PremiseLogo, PremiseLogoGrayIcon, PremiseLogoWebIcon, PreviewOutlineIcon, PricePictogram, ProductPlaceholderIcon, ProfileFillIcon, ProfileIcon, ProfileOutlineIcon, ProgressBar, ProtestPictogram, ALIGN$1 as RADIO_ALIGN, Radio, RadioGroup, RefreshOutlineIcon, ReplayOutlineIcon, ResizeOutlineIcon, ResultOutlineIcon, RewardFillIcon, RewardOutlineIcon, RewindFillIcon, RiotPictogram, RoadConditionsPictogram, RoutePictogram, SIZE$2 as SELECT_SIZE, TYPE$1 as SELECT_TYPE, DURATION as SNACKBAR_DURATION, PLACEMENT as SNACKBAR_PLACEMENT, SORT_DIRECTION, SIZE$4 as SPINNER_SIZE, SalesPictogram, SatisfiedOutlineIcon, SaveOutlineIcon, ScanOutlineIcon, Search, SearchOutlineIcon, SecurityPictogram, Select, StyletronServer as Server, SettingsFillIcon, SettingsOutlineIcon, ShieldPictogram, ShoppingBasketPictogram, ShoppingPictogram, Show, ShowOutlineIcon, SideNavigation, SimilarOutlineIcon, SingleImageOutlineIcon, SirenPictogram, Skeleton, Skip10OutlineIcon, Slider, SnackPictogram, SnackbarProvider, SortOutlineIcon, sortableHeadCell as SortableHeadCell, SplitScreenOutlineIcon, StatefulInput, StatefulMenu, StatefulPanel, StatefulPhoneInput, StatefulPopover, StatefulRadioGroup, StatefulSelect, StatefulTextarea, Tooltip as StatefulTooltip, StatelessAccordion, StopFillIcon, StrategyPictogram, StyledBody, Action as StyledCardAction, Body$1 as StyledCardBody, StyledCell, StyledHead, StyledHeadCell, StyledLink, StyledLinkLabel, StyledLinkLabelSmall, StyledLinkSmall, StyledList, StyledListItem, NavigationItem as StyledNavigationItem, NavigationList as StyledNavigationList, StyledRow, Spinner as StyledSpinnerNext, StyledTable, StyletronClient as Styletron, Provider$1 as StyletronProvider, SubArrowOutlineIcon, MonoHeadingLarge as SubHeader1, MonoHeadingMedium as SubHeader2, MonoHeadingSmall as SubHeader3, MonoHeadingXSmall as SubHeader4, SuggestedPlaceToValidateOutlineIcon, Sun, VARIANT as TAG_VARIANT, TETHER_PLACEMENT, KIND as TOAST_KIND, TRIGGER_TYPE, Tab, TabSize, Table, Tabs, Tag, TakePicOutlineIcon, TalkPictogram, TaskFillIcon, TaskOutlineIcon, TasksPictogram, TetherBehavior, Textarea, ThreeColumns, TimeOutlineIcon, Toast, ToasterContainer, TooltipSize, TransportationPictogram, TrendOutlineIcon, TriangleDown$1 as TriangleDown, triangleLeft as TriangleLeft, triangleRight as TriangleRight, UnlockedOutlineIcon, UnsatisfiedOutlineIcon, UploadOutlineIcon, VideoOutlineIcon, ViolencePictogram, VolumeOffOutlineIcon, VolumeOnOutlineIcon, WaterPictogram, WifiOutlineIcon, lib_2 as arrayMove, lib_1 as arrayRemove, border, typography$4 as displayTypography, getBreakpoints, typography$3 as headerTypography, typography$6 as labelTypography, noBorder, numberPattern, typography$1 as paragraphTypography, themedStyled as styled, typography as subHeaderTypography, toaster$1 as toaster, tokens$1 as tokens, bodyStyles as tooltipBodyStyles, innerStyles as tooltipInnerStyles, useSnackbar, themedUseStyletron as useStyletron, themedWithStyle as withStyle };
//# sourceMappingURL=index.es.js.map
